// @ts-nocheck
export type Scalars = {
    String: string,
    Float: number,
    Boolean: boolean,
    ID: string,
    Int: number,
    AllowClassificationForVersion: any,
    BusinessEventRuleType: any,
    Date: string,
    EnrichmentRuleType: any,
    JSON: any,
    JSONObject: any,
}

export interface AcceptedInviteCompanyInfo {
    id: Scalars['String']
    __typename: 'AcceptedInviteCompanyInfo'
}

export interface AcceptInvitationResponse {
    userInvitation?: UserInvitation
    __typename: 'AcceptInvitationResponse'
}

export interface AccountBalance {
    accountRole: Scalars['String']
    balance: Scalars['Float']
    asOfDate: Scalars['Date']
    __typename: 'AccountBalance'
}

export interface AccountingInfo {
    isSalesAffecting: Scalars['Boolean']
    isCogsAffecting: Scalars['Boolean']
    __typename: 'AccountingInfo'
}

export type AccountingMethod = 'accrual' | 'cash'

export type AccountingServicesTypes = 'NOT_INTERESTED' | 'INTERESTED' | 'NO_STORE' | 'AUTOMATED' | 'FULLY_MANAGED'

export interface AccountRole {
    name: Scalars['String']
    groupId: Scalars['String']
    isClearingAccount?: Scalars['Boolean']
    reportsHierarchy?: ReportHierarchyNode[]
    __typename: 'AccountRole'
}

export type AccountState = 'ACTIVE' | 'MADE_PRIVATE' | 'CLOSED' | 'ASSUMED_MADE_PRIVATE' | 'ASSUMED_CLOSED'

export type AccountStatus = 'VALID' | 'ISSUE'

export interface AccountValidation {
    openingBalanceValue?: Scalars['Float']
    lastValidAt?: Scalars['Date']
    updatedAt?: Scalars['Date']
    accountState?: AccountState
    potentialOpeningValue?: Scalars['Float']
    status?: AccountStatus
    madePrivateAt?: Scalars['Date']
    accountBalanceDiffValue?: Scalars['Float']
    lastMetricCreatedAt?: Scalars['Date']
    lastMetricEventTime?: Scalars['Date']
    companyIntegrationLastSuccessfulUpdate?: Scalars['Date']
    reason?: Scalars['String']
    __typename: 'AccountValidation'
}

export interface Accrual {
    id: Scalars['ID']
    accrualsData: AccrualData[]
    bankTransactionId: Scalars['ID']
    companyId: Scalars['ID']
    createdAt: Scalars['Date']
    updatedAt: Scalars['Date']
    archivedAt?: Scalars['Date']
    createdBy?: ActorType
    createdById?: Scalars['String']
    latestActorType?: ActorType
    latestActorId?: Scalars['String']
    __typename: 'Accrual'
}

export interface AccrualData {
    classificationTagId?: Scalars['ID']
    businessEventType: Scalars['String']
    spreadType: SpreadType
    residualAmount?: Scalars['Float']
    specificDate?: SpecificDate
    spreadOverTime?: SpreadOverTime
    customSpread?: CustomSpread[]
    customSpreadOptions?: CustomSpreadOptions
    defaultFixedAssetsData?: DefaultFixedAssetsData
    customFixedAssetsData?: CustomFixedAssetsData
    canceledAt?: Scalars['Date']
    canceledBy?: Scalars['String']
    canceledAccrualsData?: CanceledAccrualData
    __typename: 'AccrualData'
}

export type AccrualEntity = (BankTransaction | Bill) & { __isUnion?: true }

export type AccrualEntityType = 'BANK_TRANSACTION' | 'BILL'

export interface AccrualRecordResponse {
    spreadItems: AccrualRecordSpreadItem[]
    totalAmount: Scalars['Float']
    amountAsOfDate: Scalars['Float']
    businessEventType: Scalars['String']
    entity: AccrualEntity
    source: AccrualRecordSource
    startDate: Scalars['Date']
    endDate: Scalars['Date']
    category?: Scalars['String']
    depreciationMethod: DepreciationMethod
    depreciationType: SpreadBasisType
    depreciationPeriod: Scalars['String']
    vendor?: Scalars['String']
    entityDate?: Scalars['Date']
    __typename: 'AccrualRecordResponse'
}

export type AccrualRecordSource = 'Transactions' | 'Bills' | 'Historical'

export interface AccrualRecordSpreadItem {
    date: Scalars['Date']
    amount: Scalars['Float']
    __typename: 'AccrualRecordSpreadItem'
}

export interface AccrualsSpread {
    id: Scalars['String']
    amount: Scalars['Float']
    postedAt: Scalars['Date']
    endDate?: Scalars['Date']
    classificationTag?: ClassificationTag
    businessEventType: Scalars['String']
    isRemainingExpenses: Scalars['Boolean']
    isResidualAmount: Scalars['Boolean']
    fixedAssetsOptions?: FixedAssetsOptions
    __typename: 'AccrualsSpread'
}

export interface AccrualsSpreadResponse {
    amount: Scalars['Float']
    postedAt: Scalars['Date']
    endDate?: Scalars['Date']
    classificationTag?: ClassificationTag
    bankTransaction?: BankTransaction
    businessEventType: Scalars['String']
    id: Scalars['String']
    companyId: Scalars['String']
    accrualId: Scalars['String']
    bankTransactionId: Scalars['ID']
    isRemainingExpenses: Scalars['Boolean']
    isResidualAmount: Scalars['Boolean']
    fixedAssetsOptions?: FixedAssetsOptions
    spreadBasisType: SpreadBasisType
    __typename: 'AccrualsSpreadResponse'
}

export type AccrualsStatus = 'FAILURE' | 'SUCCESS'

export type AccrualType = 'ALL' | 'FIXED_ASSETS' | 'PREPAID_EXPENSES' | 'ACCRUED_EXPENSES'

export interface AccrualV2 {
    id: Scalars['ID']
    accrualsData: AccrualData[]
    entity?: AccrualEntity
    entityType: AccrualEntityType
    entityId: Scalars['ID']
    companyId: Scalars['ID']
    createdAt: Scalars['Date']
    updatedAt: Scalars['Date']
    archivedAt?: Scalars['Date']
    createdBy?: ActorType
    createdById?: Scalars['String']
    latestActorType?: ActorType
    latestActorId?: Scalars['String']
    spreads?: AccrualsSpread[]
    __typename: 'AccrualV2'
}

export interface AcknowledgeLoansChanges {
    loans: Loan[]
    __typename: 'AcknowledgeLoansChanges'
}

export interface ActionChange {
    accountRole: Scalars['String']
    accountRoleV2: AccountRole
    moneyDirection: ActionChangeMoneyDirection
    __typename: 'ActionChange'
}

export type ActionChangeMoneyDirection = 'INCREASE' | 'DECREASE'

export type ActorType = 'INTEGRATION' | 'FINALOOP_TEAM' | 'FINALOOP_CUSTOMER' | 'LOCAL_RULE' | 'MACHINE' | 'MACHINE_FORCE' | 'NTROPY' | 'DATA_DELETER' | 'DATA_SCIENCE_CLEAR' | 'SYSTEM' | 'REALTIME_RULE_APPLIER' | 'MISSION' | 'INITIAL_MIGRATION' | 'DUPLICATE_DETECTOR' | 'DUPLICATE_MERGER' | 'ZERO_AMOUNT_DELETER'

export interface Ad {
    id: Scalars['ID']
    companyId: Scalars['ID']
    name: Scalars['String']
    status: Scalars['String']
    insights?: AdInsightsByDate[]
    __typename: 'Ad'
}

export interface AdAccount {
    id: Scalars['ID']
    companyId: Scalars['ID']
    externalId: Scalars['ID']
    adPlatform: Platform
    adBusinessId: Scalars['String']
    updatedAt: Scalars['Date']
    name: Scalars['String']
    status: Scalars['String']
    paymentMethod: Scalars['String']
    timezoneOffset?: Scalars['Int']
    rollingBalance?: Scalars['Float']
    currency: Scalars['String']
    minDailyBudget?: Scalars['Int']
    adCampaigns?: AdCampaign[]
    __typename: 'AdAccount'
}

export interface AdCampaign {
    id: Scalars['ID']
    name: Scalars['String']
    status: Scalars['String']
    endTime?: Scalars['Date']
    companyId: Scalars['ID']
    startTime?: Scalars['Date']
    adAccount: AdAccount
    dailyBudget?: Scalars['Float']
    lifetimeBudget?: Scalars['Float']
    remainingBudget?: Scalars['Float']
    clicks?: Scalars['Int']
    impressions?: Scalars['Int']
    reach?: Scalars['Int']
    spend?: Scalars['Float']
    adSets?: AdSet[]
    __typename: 'AdCampaign'
}

export interface AddDepreciationBonus {
    date: Scalars['Date']
    percent: Scalars['Float']
    amount: Scalars['Float']
    __typename: 'AddDepreciationBonus'
}

export interface AdditionalErrorInfo {
    expectedValue: Scalars['String']
    actualValue: Scalars['String']
    __typename: 'AdditionalErrorInfo'
}

export interface AddMissingBillsTask {
    id: BillsYearEndTaskId
    status: BillsYearEndTaskStatus
    stateKey: Scalars['String']
    state: AddMissingBillsTaskState
    history?: (AddMissingBillsTaskStateChangeLog | undefined)[]
    __typename: 'AddMissingBillsTask'
}

export interface AddMissingBillsTaskState {
    markedAsCompletedAt?: Scalars['Date']
    __typename: 'AddMissingBillsTaskState'
}

export interface AddMissingBillsTaskStateChangeLog {
    id: Scalars['ID']
    createdAt: Scalars['Date']
    updaterType: YearEndStateUpdaterType
    changedByUid?: Scalars['String']
    reason?: Scalars['String']
    oldValue?: AddMissingBillsTaskState
    newValue?: AddMissingBillsTaskState
    __typename: 'AddMissingBillsTaskStateChangeLog'
}

export interface AddMissingInvoicesTask {
    id: InvoicesYearEndTaskId
    status: InvoicesYearEndTaskStatus
    stateKey: Scalars['String']
    state: AddMissingInvoicesTaskState
    history?: (AddMissingInvoicesTaskStateChangeLog | undefined)[]
    __typename: 'AddMissingInvoicesTask'
}

export interface AddMissingInvoicesTaskState {
    markedAsCompletedAt?: Scalars['Date']
    __typename: 'AddMissingInvoicesTaskState'
}

export interface AddMissingInvoicesTaskStateChangeLog {
    id: Scalars['ID']
    createdAt: Scalars['Date']
    updaterType: YearEndStateUpdaterType
    changedByUid?: Scalars['String']
    reason?: Scalars['String']
    oldValue?: AddMissingInvoicesTaskState
    newValue?: AddMissingInvoicesTaskState
    __typename: 'AddMissingInvoicesTaskStateChangeLog'
}

export interface Address {
    country?: Scalars['String']
    state?: Scalars['String']
    city?: Scalars['String']
    postalCode?: Scalars['String']
    line1?: Scalars['String']
    line2?: Scalars['String']
    __typename: 'Address'
}

export interface AddRoleToAffiliatedEntityResult {
    createdEntityId: Scalars['ID']
    affiliatedEntity: AffiliatedEntity
    __typename: 'AddRoleToAffiliatedEntityResult'
}

export interface AdInsight {
    adId: Scalars['ID']
    companyId: Scalars['ID']
    date: Scalars['Date']
    country?: Scalars['String']
    region?: Scalars['String']
    impressions?: Scalars['Int']
    spend?: Scalars['Float']
    clicks?: Scalars['Int']
    cpm?: Scalars['Float']
    ctr?: Scalars['Float']
    cpc?: Scalars['Float']
    reach?: Scalars['Int']
    __typename: 'AdInsight'
}

export interface AdInsightsByDate {
    date: Scalars['Date']
    metrics: AdInsight[]
    __typename: 'AdInsightsByDate'
}

export interface AdjustmentRestockingAction {
    quantity: Scalars['Float']
    id: Scalars['String']
    date: Scalars['Date']
    type: Scalars['String']
    salesChannel: WarehouseActionSalesChannel
    sku?: Scalars['String']
    __typename: 'AdjustmentRestockingAction'
}

export interface AdjustmentsReason {
    code: Scalars['String']
    quantity: Scalars['Int']
    __typename: 'AdjustmentsReason'
}

export interface AdjustmentsValidation {
    adjustments: QuantityAndCost
    cogs: QuantityAndCost
    source: QuantityAndCost
    diff: QuantityAndCost
    isValid: Scalars['Boolean']
    __typename: 'AdjustmentsValidation'
}

export type AdjustmentType = 'PAID_HISTORICALLY' | 'UNCOLLECTIBLE' | 'COLLECTIBLE'

export interface AdSet {
    id: Scalars['ID']
    companyId: Scalars['ID']
    name: Scalars['String']
    status: Scalars['String']
    startTime?: Scalars['Date']
    endTime?: Scalars['Date']
    adAccount: AdAccount
    adCampaign: AdCampaign
    dailyBudget?: Scalars['Float']
    lifetimeBudget?: Scalars['Float']
    remainingBudget?: Scalars['Float']
    impressions?: Scalars['Int']
    spend?: Scalars['Float']
    clicks?: Scalars['Int']
    cpm?: Scalars['Float']
    ctr?: Scalars['Float']
    cpc?: Scalars['Float']
    frequency?: Scalars['Float']
    reach?: Scalars['Int']
    conversions?: Scalars['Int']
    ads?: Ad[]
    __typename: 'AdSet'
}

export interface AffectedTransactionsIds {
    transactionsIds: Scalars['ID'][]
    __typename: 'AffectedTransactionsIds'
}

export interface AffiliatedEntity {
    id: Scalars['ID']
    company?: Company
    institutions?: Institution[]
    name: Scalars['String']
    companyAffiliates?: CompanyAffiliate[]
    holders?: Holder[]
    safeHolders?: SafeHolder[]
    relatedParties?: RelatedParty[]
    unpaidInventoryAmount?: Scalars['Float']
    lenders?: NewLender[]
    employees?: Employee[]
    contractors?: Contractor[]
    vendors?: Vendor[]
    __typename: 'AffiliatedEntity'
}

export interface AgingAggregationItem {
    preset: OrdersAgingPreset
    balance: Scalars['Float']
    count: Scalars['Int']
    __typename: 'AgingAggregationItem'
}

export interface AllSkusResponse {
    title: Scalars['String']
    updatedAt?: Scalars['Date']
    data: SkuData[]
    sources?: (SourceTypes | undefined)[]
    __typename: 'AllSkusResponse'
}

export type AllSkusSortField = 'SALES' | 'SALES_TREND' | 'DISCOUNTS' | 'COGS' | 'PROFIT' | 'MARGIN' | 'REFUNDS' | 'RESTOCKS' | 'EFFECTIVE_PROFIT' | 'EFFECTIVE_PROFIT_MARGIN' | 'UNITS_SOLD' | 'UNITS_REFUNDED' | 'AVERAGE_UNITS_SOLD' | 'AVERAGE_SALE_PRICE' | 'AVERAGE_NET_SALES' | 'AVERAGE_COST_PER_UNIT' | 'AVERAGE_PROFIT_PER_UNIT'

export interface AlterBankTransactionsLifecycleStateResult {
    processedIds: Scalars['ID'][]
    unprocessed: AlterBankTransactionsLifecycleStateUnprocessedResult[]
    __typename: 'AlterBankTransactionsLifecycleStateResult'
}

export interface AlterBankTransactionsLifecycleStateUnprocessedResult {
    id: Scalars['ID']
    reason: Scalars['String']
    __typename: 'AlterBankTransactionsLifecycleStateUnprocessedResult'
}

export interface AmazonAvailableMarketplace {
    displayName: Scalars['String']
    integrationAccountId: Scalars['String']
    integrationAccountName: Scalars['String']
    marketplaceId: Scalars['String']
    __typename: 'AmazonAvailableMarketplace'
}

export interface AmazonAvailableValidationDataResponse {
    integrationAccountIdsData: AmazonIntegrationAccountIdAvailableData[]
    __typename: 'AmazonAvailableValidationDataResponse'
}

export interface AmazonIntegrationAccountIdAvailableData {
    availableMarketplaces: AmazonAvailableMarketplace[]
    shipmentsReportEndTime?: Scalars['Date']
    returnsReportEndTime?: Scalars['Date']
    integrationAccountId: Scalars['String']
    impactOnBooksSince: Scalars['Date']
    __typename: 'AmazonIntegrationAccountIdAvailableData'
}

export interface AmazonOrdersDiffResponse {
    data: Scalars['JSON']
    __typename: 'AmazonOrdersDiffResponse'
}

export interface AmazonProduct {
    id: Scalars['String']
    companyId: Scalars['String']
    finaloopId: Scalars['String']
    lineOfBusinessId?: Scalars['String']
    sku?: Scalars['String']
    price?: Scalars['Float']
    displayName?: Scalars['String']
    imageUrl?: Scalars['String']
    listedChannels: SalesChannel[]
    appliedCosts: ProductAppliedCost[]
    dailySalesData: SalesChannelDailySalesData[]
    totalSold: Scalars['Int']
    avgCostPerUnit?: Scalars['Float']
    asin: Scalars['String']
    canEditLatestAppliedCost?: Scalars['Boolean']
    isFractional: Scalars['Boolean']
    isHidden: Scalars['Boolean']
    salesData: SalesData
    rawRecipes: Recipe[]
    componentOfProducts: Product[]
    isAmbiguousSku?: Scalars['Boolean']
    analyticsOverview: ProductAnalyticsOverview
    warehousesAnalyticsOverview: ProductWarehousesAnalyticsOverview[]
    tags: Scalars['String'][]
    isCreatedManually: Scalars['Boolean']
    isDataSyncing: Scalars['Boolean']
    mergeHistory: ProductMergeHistoryItem[]
    isDropshipping?: Scalars['Boolean']
    __typename: 'AmazonProduct'
}

export interface AmazonProductsReconciliationResponse {
    validationId: Scalars['String']
    __typename: 'AmazonProductsReconciliationResponse'
}

export interface AmazonProductsValidationReadyResponse {
    checkStartTime?: Scalars['Date']
    checkEndTime?: Scalars['Date']
    data: AmazonSkuReconciliationData[]
    summary: AmazonReconciliationSummary
    isTrackstarConnected: Scalars['Boolean']
    __typename: 'AmazonProductsValidationReadyResponse'
}

export interface AmazonReconciliationAdjustmentsData {
    onlyAdjustments: Scalars['Boolean']
    adjustments: Scalars['Float']
    sourceAdjustments: Scalars['Float']
    adjustmentsDiff: Scalars['Float']
    __typename: 'AmazonReconciliationAdjustmentsData'
}

export interface AmazonReconciliationEntityData {
    restocked: Scalars['Int']
    mfn: Scalars['Int']
    afn: Scalars['Int']
    totalSold: Scalars['Int']
    __typename: 'AmazonReconciliationEntityData'
}

export interface AmazonReconciliationEntityEntityValidationStatus {
    restockedDiff: Scalars['Int']
    afnDiff: Scalars['Int']
    mfnDiff: Scalars['Int']
    mcfDiff: Scalars['Int']
    reportDiff: Scalars['Int']
    totalDiff: Scalars['Int']
    adjustmentsDiff: Scalars['Int']
    __typename: 'AmazonReconciliationEntityEntityValidationStatus'
}

export interface AmazonReconciliationProductData {
    unitsSold: Scalars['Int']
    unitsRestocked: Scalars['Int']
    unitsGiveaway: Scalars['Int']
    ambiguousSkuQuantity: Scalars['Int']
    __typename: 'AmazonReconciliationProductData'
}

export interface AmazonReconciliationProductValidationStatus {
    soldDiff: Scalars['Int']
    restockedDiff: Scalars['Int']
    totalDiff: Scalars['Int']
    __typename: 'AmazonReconciliationProductValidationStatus'
}

export interface AmazonReconciliationRestockedReportData {
    mcf: Scalars['Int']
    afn: Scalars['Int']
    __typename: 'AmazonReconciliationRestockedReportData'
}

export interface AmazonReconciliationSalesOrderIds {
    recentInvoices: Scalars['String'][]
    oldInvoices: Scalars['String'][]
    notInTimeRange: Scalars['String'][]
    mfn: Scalars['String'][]
    afn: Scalars['String'][]
    all: Scalars['String'][]
    restocked: Scalars['String'][]
    __typename: 'AmazonReconciliationSalesOrderIds'
}

export interface AmazonReconciliationSalesReportData {
    recentInvoices: Scalars['Int']
    oldInvoices: Scalars['Int']
    notInTimeRange: Scalars['Int']
    mcf: Scalars['Int']
    afn: Scalars['Int']
    total: Scalars['Int']
    __typename: 'AmazonReconciliationSalesReportData'
}

export interface AmazonReconciliationSummary {
    entityData: AmazonReconciliationEntityData
    entityValidationStatus: AmazonReconciliationEntityEntityValidationStatus
    salesReportData: AmazonReconciliationSalesReportData
    restocksReportData: AmazonReconciliationRestockedReportData
    productData: AmazonReconciliationProductData
    productValidationStatus: AmazonReconciliationProductValidationStatus
    adjustmentsData: AmazonReconciliationAdjustmentsData
    __typename: 'AmazonReconciliationSummary'
}

export interface AmazonSkuReconciliationData {
    comments?: Scalars['String']
    sku: Scalars['String']
    orderIds: AmazonReconciliationSalesOrderIds
    summary: AmazonReconciliationSummary
    __typename: 'AmazonSkuReconciliationData'
}

export interface Amounts {
    amount: Scalars['Float']
    amountInHomeCurrency: Scalars['Float']
    currency: CurrencyCode
    __typename: 'Amounts'
}

export interface AnyActiveProductWithoutQuantities {
    anyActiveProductWithoutQuantities: Scalars['Boolean']
    __typename: 'AnyActiveProductWithoutQuantities'
}

export interface APAccountBalance {
    accountRole: Scalars['String']
    balance: Scalars['Float']
    asOfDate: Scalars['Date']
    __typename: 'APAccountBalance'
}

export type ApplyPendingSalesDataAdjustmentsMode = 'ADD_ON_TOP' | 'REPLACE'

export interface ApplySalesChannelChangesResult {
    success: Scalars['Boolean']
    salesChannels: SalesChannelInfo[]
    __typename: 'ApplySalesChannelChangesResult'
}

export interface ArtificialTransactionsByMonth {
    type: ArtificialTransactionsType
    integrationType: Scalars['String']
    count: Scalars['Int']
    sum: Scalars['Float']
    month: Scalars['Int']
    __typename: 'ArtificialTransactionsByMonth'
}

export interface ArtificialTransactionsByMonthResponse {
    payments: ArtificialTransactionsByMonth[]
    refunds: ArtificialTransactionsByMonth[]
    __typename: 'ArtificialTransactionsByMonthResponse'
}

export type ArtificialTransactionsType = 'PAYMENT' | 'REFUND'

export type AskTheUserFlowType = 'FEDERAL_TAX_PAID_FLOW_TYPE' | 'STATE_AND_SALES_TAXES_PAID_FLOW_TYPE' | 'PAYROLL_FLOW_TYPE' | 'PENSION_FLOW_TYPE' | 'INTERNAL_TRANSFER' | 'REFUND' | 'DISTRIBUTION' | 'PAYOUTS_TOP_UPS'

export interface AskTheUserNotificationServiceResult {
    success: Scalars['Boolean']
    __typename: 'AskTheUserNotificationServiceResult'
}

export type AskTheUserNotificationType = 'PAYROLL_PROVIDER_IDENTIFIED_BY_USER' | 'PAYOUTS_TOPUPS_SHOPIFY_PAYMENT_GATEWAY_NO_CONFIG' | 'PAYOUTS_TOPUPS_CONNECTION_FAILURE' | 'PAYOUTS_TOPUPS_USER_SELECTED_INTEGRATION' | 'PAYOUTS_TOPUPS_USER_SELECTED_WALMART_CONNECTED_INTEGRATION' | 'INTERNAL_TRANSFER_PAYPAL_RECLASSIFICATION' | 'PAYOUTS_TOP_UPS_FROM_MISSION_LENDER_SELECTED' | 'PAYOUTS_TOP_UPS_FROM_MISSION_RELATED_PARTY_SELECTED' | 'PAYOUTS_TOP_UPS_FROM_MISSION_OTHER_THIRDPARTY_SELECTED' | 'PAYOUTS_TOP_UPS_FROM_MISSION_PAYPAL_SELECTED' | 'PAYOUTS_TOP_UPS_FROM_MISSION_TRANSACTION_MATCHED' | 'PAYOUTS_TOP_UPS_FROM_MISSION_CUSTOM_CLASSIFICATION' | 'PAYOUTS_TOP_UPS_USER_UPLOADED_INTEGRATION_FILE'

export interface AskTheUserResult {
    type: Scalars['String']
    data?: Scalars['JSONObject']
    __typename: 'AskTheUserResult'
}

export interface AssembledByMap {
    id: Scalars['String']
    assembled: Scalars['Float']
    __typename: 'AssembledByMap'
}

export interface Assembly {
    companyId: Scalars['ID']
    startDate: Scalars['Date']
    endDate: Scalars['Date']
    amount: Scalars['Float']
    assemblyItems: AssemblyItem[]
    inventoryPaymentGroupLinks: InventoryPaymentGroupLink[]
    unpaidAmounts: UnpaidAmountPerAffiliatedEntity[]
    __typename: 'Assembly'
}

export type AssemblyDeletedReason = 'MERGE' | 'USER_MANUAL'

export type AssemblyItem = (ManualAssembly | OnDemandAssemblyVendorCosts) & { __isUnion?: true }

export interface AssemblyListItem {
    type: AssemblyType
    date: Scalars['Date']
    amount: Scalars['Float']
    recipe: Recipe
    id: Scalars['ID']
    __typename: 'AssemblyListItem'
}

export type AssemblyType = 'ON_DEMAND' | 'MANUAL'

export interface AssignCompanyToUserResponse {
    success: Scalars['Boolean']
    __typename: 'AssignCompanyToUserResponse'
}

export interface AttachmentTargetURL {
    fileName: Scalars['String']
    url: Scalars['String']
    signedUrl: Scalars['String']
    __typename: 'AttachmentTargetURL'
}

export interface AttachmentTargetURLS {
    signedUrls: AttachmentTargetURL[]
    __typename: 'AttachmentTargetURLS'
}

export interface Auth0UserLookupResponse {
    exists: Scalars['Boolean']
    __typename: 'Auth0UserLookupResponse'
}

export interface AwaitedExportResponse {
    requestId: Scalars['String']
    status: ExportStatus
    signedUrl?: Scalars['String']
    message?: Scalars['String']
    __typename: 'AwaitedExportResponse'
}

export interface BackOfficeBankStatementRequestsFiltersResponse {
    years: Scalars['String'][]
    tiers: CompanyTier[]
    statuses: BankStatementRequestStatus[]
    types: BankStatementRequestType[]
    __typename: 'BackOfficeBankStatementRequestsFiltersResponse'
}

export type BackOfficeCreateBankReconciliationRequestType = 'BULK_PDF' | 'MISSING_TXNS' | 'ONE_TIME_RECONCILIATION' | 'RECURRING_CSV'

export interface BalanceAdjustment {
    value: Scalars['Float']
    forDate: Scalars['String']
    actorType: BankAccountBalanceAdjustmentActorType
    actorId?: Scalars['String']
    createdAt: Scalars['Date']
    __typename: 'BalanceAdjustment'
}

export interface BalanceByCurrency {
    currency: Scalars['String']
    balance?: Scalars['Float']
    __typename: 'BalanceByCurrency'
}

export interface BalanceLocation {
    balance: Scalars['Float']
    balanceAtIso: Scalars['String']
    __typename: 'BalanceLocation'
}

export interface BalanceSheetDependency {
    blocked: Scalars['Boolean']
    resolvedAt?: Scalars['Date']
    __typename: 'BalanceSheetDependency'
}

export interface BalanceSheetItem {
    state: BalanceSheetSetupItemStateResponse
    data?: Scalars['JSONObject']
    createdAt: Scalars['Date']
    updatedAt: Scalars['Date']
    __typename: 'BalanceSheetItem'
}

export type BalanceSheetItemType = 'BUSINESS_AND_TAX_INFORMATION' | 'BANKS' | 'LOANS' | 'TAX_RETURN_DOCUMENT' | 'BALANCE_SHEET_DOCUMENT' | 'ACQUISITION_AGREEMENT_DOCUMENT'

export interface BalanceSheetSetup {
    id: Scalars['ID']
    state: BalanceSheetSetupStateResponse
    userUnresponsive: UserUnresponsive
    isPreviewEnabled: Scalars['Boolean']
    email?: Scalars['String']
    intercomLink?: Scalars['String']
    items: BalanceSheetSetupItems
    __typename: 'BalanceSheetSetup'
}

export type BalanceSheetSetupItemErrorMessage = 'BALANCE_SHEET_IS_NOT_EDITABLE'

export interface BalanceSheetSetupItems {
    businessAndTaxInformation: BalanceSheetItem
    banks: BalanceSheetItem
    loans: BalanceSheetItem
    taxReturnDocument: BalanceSheetItem
    balanceSheetDocument: BalanceSheetItem
    acquisitionAgreementDocument: BalanceSheetItem
    __typename: 'BalanceSheetSetupItems'
}

export interface BalanceSheetSetupItemStateResponse {
    value: HubItemState
    history?: HubItemStateChangeLog[]
    __typename: 'BalanceSheetSetupItemStateResponse'
}

export interface BalanceSheetSetupStateResponse {
    value: HubState
    history?: HubStateChangeLog[]
    __typename: 'BalanceSheetSetupStateResponse'
}

export interface BalanceSheetStatus {
    status?: Scalars['String']
    updatedAt?: Scalars['Date']
    updatedBy?: Scalars['String']
    __typename: 'BalanceSheetStatus'
}

export interface BankAccount {
    id: Scalars['ID']
    companyId: Scalars['String']
    integrationAccountId: Scalars['ID']
    source: IntegrationType
    externalSourceId?: Scalars['String']
    externalInstitutionId?: Scalars['String']
    type: BankAccountType
    subtype: BankAccountSubtype
    currency?: Scalars['String']
    currentBalance?: Scalars['Float']
    institution?: Institution
    institutionId?: Scalars['String']
    institutionName?: Scalars['String']
    name: Scalars['String']
    fullName: Scalars['String']
    displayName: Scalars['String']
    mask?: Scalars['String']
    connectedAt?: Scalars['Date']
    isHistoricalUpdateCompleted?: Scalars['Boolean']
    isMissingHistoricalTransactions?: Scalars['Boolean']
    userSaidThereAreNoMissingTransactions?: Scalars['Boolean']
    locks?: BankAccountLock[]
    rawData: Scalars['JSONObject']
    closingBalanceLogs?: BankAccountClosingBalance[]
    balanceAdjustments?: BalanceAdjustment[]
    latestAccountingEventIds?: Scalars['String'][]
    transactionsImportStatus?: BankAccountTransactionsImportStatus
    deletedByUserAt?: Scalars['Date']
    deletedByUserId?: Scalars['String']
    createdAt?: Scalars['Date']
    createdBy?: Scalars['String']
    shouldUpdateAccountDetailsOnNextUpdate?: Scalars['Boolean']
    vendor?: Vendor
    duplicateOfBankAccountId?: Scalars['String']
    hasRecurringMission: Scalars['Boolean']
    lockStatus?: BankAccountLockStatus
    accountValidation?: AccountValidation
    markedAsClosedByCustomerAt?: Scalars['Date']
    forwardTransactionsToBankAccountId?: Scalars['String']
    isManagedByFinaloop?: Scalars['Boolean']
    hasNotifiedUponNoHistoricalUpdate?: Scalars['Boolean']
    accountRole: Scalars['String']
    connectionStatus?: BankAccountConnectionStatus
    accountStatus?: BankConnectionAccountStatus
    status: BankAccountStatus
    institutionLogo?: Scalars['String']
    integrationType?: IntegrationType
    deletedAt?: Scalars['Date']
    deletedBy?: Scalars['String']
    isManual?: Scalars['Boolean']
    isRefreshRequired?: Scalars['Boolean']
    isDisconnected?: Scalars['Boolean']
    convertedToManualAt?: Scalars['Date']
    convertedToManualBy?: Scalars['String']
    transactionsCount: Scalars['Int']
    minimumTransactionDate?: Scalars['Date']
    __typename: 'BankAccount'
}

export type BankAccountBalanceAdjustmentActorType = 'MANUAL_STREAMLIT' | 'AUTOMATIC_DATA_JOBS' | 'AUTOMATIC_DATA_JOBS_OPENING_BALANCE_STATEMENT'

export interface BankAccountClosingBalance {
    value: Scalars['Float']
    forDate: Scalars['String']
    actorType: BankAccountClosingBalanceActorType
    actorId?: Scalars['String']
    createdAt: Scalars['Date']
    __typename: 'BankAccountClosingBalance'
}

export type BankAccountClosingBalanceActorType = 'MANUAL_STREAMLIT' | 'AUTOMATIC_DATA_JOBS' | 'AUTOMATIC_DATA_JOBS_OPENING_BALANCE_STATEMENT'

export type BankAccountConnectionStatus = 'Connected' | 'Disconnected'

export interface BankAccountLock {
    type: Scalars['String']
    startTime: Scalars['Date']
    endTime: Scalars['Date']
    lockedAt: Scalars['Date']
    actorType: ActorType
    actorId: Scalars['String']
    reason?: Scalars['String']
    __typename: 'BankAccountLock'
}

export interface BankAccountLockStatus {
    lockedAt: Scalars['Date']
    minimumAllowedEventTime: Scalars['Date']
    year?: Scalars['Int']
    __typename: 'BankAccountLockStatus'
}

export type BankAccountNewOwnerType = 'THIRD_PARTY' | 'RELATED_PARTY' | 'OWNER'

export interface BankAccountReconciliation {
    id: Scalars['ID']
    bankAccount: BankAccount
    companyId: Scalars['String']
    status: BankAccountReconciliationStatus
    transactionsFileLocations?: FileLocation[]
    statementFileLocations?: FileLocation[]
    balanceLocation?: BalanceLocation
    reconciliationDate: Scalars['Date']
    __typename: 'BankAccountReconciliation'
}

export type BankAccountReconciliationStatus = 'PENDING_USER_ACTION' | 'COMPLETED'

export type BankAccountStatementFileType = 'CSV' | 'PDF' | 'XLSX' | 'XLS' | 'UNSUPPORTED'

export interface BankAccountStatementRequest {
    id: Scalars['ID']
    companyId: Scalars['ID']
    fromDate: Scalars['Date']
    toDate: Scalars['Date']
    bankAccount: BankStatementBankAccount
    type: BankAccountStatementRequestType
    subType?: BankAccountStatementRequestSubType
    customerData?: BankStatementCustomerData
    finaloopData?: BankStatementFinaloopData
    status: BankAccountStatementRequestStatus
    fileNames?: (Scalars['String'] | undefined)[]
    displayedBalance?: Scalars['Float']
    csvUploads?: (CSVUpload | undefined)[]
    balanceId?: Scalars['String']
    markedAsClosedByCustomerAt?: Scalars['Date']
    lockedStatus?: LockedStatus
    originalBankAccountId?: Scalars['String']
    __typename: 'BankAccountStatementRequest'
}

export type BankAccountStatementRequestStatus = 'NOT_REQUIRED' | 'IRRELEVANT' | 'PENDING_USER_INPUT' | 'USER_COMPLETED' | 'FINALOOP_APPROVED' | 'IRRELEVANT_APPROVED'

export type BankAccountStatementRequestSubType = 'MADE_PRIVATE_WHILE_INVALID' | 'ASSUMED_CLOSED' | 'STOP_IMPORT'

export type BankAccountStatementRequestType = 'END_OF_YEAR_BALANCE' | 'START_OF_YEAR_BALANCE' | 'TRANSACTIONS_BACKFILL' | 'INTERNAL_TRANSFER_TRANSACTION_MATCH'

export type BankAccountStatus = 'ACTIVE' | 'PENDING' | 'DUPLICATE' | 'SUSPECTED_AS_DUPLICATE' | 'DELETED' | 'MERGING' | 'MERGED' | 'MERGE_DESTINATION'

export interface BankAccountStopImportNewOwner {
    id?: Scalars['String']
    type: BankAccountNewOwnerType
    name: Scalars['String']
    __typename: 'BankAccountStopImportNewOwner'
}

export type BankAccountSubtype = 'Checking' | 'Savings' | 'CreditCard' | 'Loan' | 'CompanyAffiliateBalance' | 'DueToFromOwner' | 'ShortTermLoanTaken' | 'Unknown' | 'LineOfCredit'

export interface BankAccountTransactionsImportStatus {
    changedBy: Scalars['String']
    changedAt: Scalars['Date']
    stopImportFromDate: Scalars['Date']
    balanceAtStopImportFromDate?: Scalars['Float']
    newOwner?: BankAccountStopImportNewOwner
    __typename: 'BankAccountTransactionsImportStatus'
}

export type BankAccountType = 'Depository' | 'CreditCard' | 'Loan' | 'Investment' | 'Other'

export interface BankConnection {
    companyId: Scalars['ID']
    integrationType: IntegrationType
    integrationAccountId: Scalars['ID']
    institutionName: Scalars['String']
    institutionId?: Scalars['String']
    institutionLogo?: Scalars['String']
    isTest: Scalars['Boolean']
    accounts: BankAccount[]
    isRefreshRequired: Scalars['Boolean']
    isDisconnected: Scalars['Boolean']
    syncStatus?: BankConnectionSyncStatus
    impactOnBooksSince: Scalars['Date']
    deletedAt?: Scalars['Date']
    deletedBy?: Scalars['String']
    status: BankConnectionStatus
    __typename: 'BankConnection'
}

export interface BankConnectionAccount {
    id: Scalars['ID']
    minimumTransactionDate?: Scalars['Date']
    __typename: 'BankConnectionAccount'
}

export interface BankConnectionAccountLock {
    startTime: Scalars['Date']
    endTime: Scalars['Date']
    __typename: 'BankConnectionAccountLock'
}

export type BankConnectionAccountStatus = 'HEALTHY' | 'IMPORT_STOPPED' | 'ACCESS_REMOVED' | 'DISCONNECTED'

export interface BankConnectionAccountTransactionsImportStatus {
    changedBy: Scalars['String']
    changedAt: Scalars['Date']
    stopImportFromDate: Scalars['Date']
    __typename: 'BankConnectionAccountTransactionsImportStatus'
}

export type BankConnectionMetricsEventType = 'INTEGRATION_DISCONNECTED' | 'INTEGRATION_RECONNECTED' | 'INTEGRATION_REFRESH_REQUIRED'

export type BankConnectionSortType = 'DEFAULT' | 'BANKS_OVERVIEW_PAGE'

export type BankConnectionStatus = 'CONNECTED' | 'DISCONNECTED' | 'PENDING_REFRESH' | 'NO_ACTIVE_CONNECTION'

export interface BankConnectionSyncStatus {
    lastSuccessfulTransactionsUpdate?: Scalars['Date']
    lastFailedTransactionsUpdate?: Scalars['Date']
    updatedAt?: Scalars['Date']
    __typename: 'BankConnectionSyncStatus'
}

export interface BankDetails {
    name: Scalars['String']
    lastFourDigits?: Scalars['String']
    type?: Scalars['String']
    missingBank?: Scalars['Boolean']
    accountName: Scalars['String']
    __typename: 'BankDetails'
}

export interface BankingAudit {
    entityType: Scalars['String']
    entityId: Scalars['String']
    field: Scalars['String']
    beforeValue?: Scalars['String']
    afterValue?: Scalars['String']
    timestamp?: Scalars['Date']
    correlationId: Scalars['String']
    action: BankingAuditAction
    __typename: 'BankingAudit'
}

export type BankingAuditAction = 'CREATE' | 'UPDATE' | 'DELETE'

export interface BankingMetric {
    companyId: Scalars['ID']
    eventTime: Scalars['Date']
    eventType: Scalars['String']
    integrationType: Scalars['String']
    integrationAccountId?: Scalars['String']
    data?: Scalars['JSON']
    __typename: 'BankingMetric'
}

export type BankingMetricEventType = 'INTEGRATION_DISCONNECTED' | 'INTEGRATION_RECONNECTED' | 'INTEGRATION_REFRESH_REQUIRED'

export interface BankingMissionResult {
    hasMissions: Scalars['Boolean']
    hasBankConnectionMissions: Scalars['Boolean']
    __typename: 'BankingMissionResult'
}

export interface BankOverviewPageAccount {
    id: Scalars['ID']
    companyId: Scalars['String']
    bankAccount: BankAccount
    virtualCurrencies?: Scalars['String'][]
    balancesByCurrency?: (BalanceByCurrency | undefined)[]
    isTestAccount: Scalars['Boolean']
    syncStatus?: BankConnectionSyncStatus
    connectionStatus: OverviewConnectionStatus
    reconciliationStatus?: ReconciliationStatus
    accountCurrentBalance?: Scalars['Float']
    __typename: 'BankOverviewPageAccount'
}

export type BankReconciliationConfigurableRequestType = 'RECURRING_CSV'

export interface BankReconciliationGraphPoint {
    date: Scalars['Date']
    source: Scalars['String']
    actualBalance: Scalars['Float']
    finaloopBalance: Scalars['Float']
    __typename: 'BankReconciliationGraphPoint'
}

export interface BankReconciliationRequest {
    id: Scalars['ID']
    bankAccount: BankAccount
    companyId: Scalars['String']
    company: Company
    requestType: BankStatementRequestType
    requestCategory: BankStatementRequestCategory
    originalBankAccountId?: Scalars['String']
    resolutionComment?: Scalars['String']
    internalMessage?: Scalars['String']
    finaloopMessage?: Scalars['String']
    finaloopMessageSender?: Scalars['String']
    expectedStartDate?: Scalars['Date']
    expectedEndDate: Scalars['Date']
    customerSelectedDate?: Scalars['Date']
    booksBalanceAtDate?: Scalars['Float']
    customerBalanceByStatement?: Scalars['Float']
    customerConfirmedBooksBalanceAtDate?: Scalars['Boolean']
    resolutionType?: BankStatementReconciliationResolutionType
    customerForceSubmitted?: Scalars['Boolean']
    irrelevantReason?: BankStatementReconciliationIrrelevantReason
    transferredEntity?: BankStatementReconciliationTransferredEntity
    configurationId?: Scalars['String']
    defaultEndDate?: Scalars['Date']
    status: BankStatementRequestStatus
    isBankAccountValid: Scalars['Boolean']
    latestActorId: Scalars['String']
    latestActorType: ActorType
    statementFiles?: ReconciliationRequestStatementFile[]
    hasTransactionsBeforeBSD?: Scalars['Boolean']
    completedStandardOpeningBalance?: Scalars['Boolean']
    accountCurrentBalance?: Scalars['Float']
    lastAccountTransaction?: LastTransaction
    isAccountValidOnSubmission?: Scalars['Boolean']
    isOngoingReconciliation?: Scalars['Boolean']
    createdById?: Scalars['String']
    createdByActorType?: ActorType
    deletedAt?: Scalars['Date']
    createdAt: Scalars['Date']
    updatedAt: Scalars['Date']
    completedAt?: Scalars['Date']
    __typename: 'BankReconciliationRequest'
}

export type BankReconciliationRequestCategory = 'UPLOAD_FILES' | 'RECONCILIATION' | 'CONNECTION'

export interface BankReconciliationRequestConfiguration {
    id: Scalars['ID']
    company: Company
    bankAccount: BankAccount
    requestType: BankReconciliationConfigurableRequestType
    requestCategory?: BankReconciliationRequestCategory
    recurrence: BankReconciliationRequestRecurrence
    startDate: Scalars['Date']
    lastRunAt?: Scalars['Date']
    createdAt: Scalars['Date']
    createdById?: Scalars['String']
    createdByActorType?: ActorType
    updatedAt: Scalars['Date']
    latestActorId: Scalars['String']
    latestActorType: ActorType
    deletedAt?: Scalars['Date']
    __typename: 'BankReconciliationRequestConfiguration'
}

export type BankReconciliationRequestFilesStatus = 'APPROVED' | 'REJECTED' | 'NOT_RELEVANT'

export type BankReconciliationRequestMachineStatus = 'WAITING_FOR_AUTOMATIC_PROCESSING' | 'WAITING_FOR_MANUAL_PROCESSING' | 'DONE' | 'FAILURE' | 'NOT_RELEVANT'

export type BankReconciliationRequestRecurrence = 'DAILY' | 'WEEKLY' | 'MONTHLY'

export interface BankReconciliationRequestSettingsResponse {
    configurations?: BankReconciliationRequestConfiguration[]
    requests?: BankReconciliationRequest[]
    __typename: 'BankReconciliationRequestSettingsResponse'
}

export type BankReconciliationRequestStatusCategories = 'OPEN' | 'PROCESSING' | 'CLOSED'

export type BankReconciliationSettingsRequestTypes = 'BULK_PDF' | 'HISTORICAL_GAP' | 'MISSING_TXNS' | 'ONE_TIME_RECONCILIATION' | 'RECURRING_CSV'

export interface BankStatementAccountHolder {
    firstName?: Scalars['String']
    lastName?: Scalars['String']
    __typename: 'BankStatementAccountHolder'
}

export type BankStatementAutoProcessingStatus = 'SUCCESS' | 'PENDING' | 'FAILED'

export interface BankStatementBankAccount {
    id: Scalars['ID']
    integrationAccountId: Scalars['ID']
    name: Scalars['String']
    type: BankAccountType
    subtype: BankAccountSubtype
    institutionName?: Scalars['String']
    institutionId?: Scalars['String']
    currency?: Scalars['String']
    mask?: Scalars['String']
    source: IntegrationType
    transactionsImportStatus?: TransactionsImportStatus
    __typename: 'BankStatementBankAccount'
}

export interface BankStatementCustomerData {
    fileNames: Scalars['String'][]
    csvFileNames?: (Scalars['String'] | undefined)[]
    noCSVFiles?: Scalars['Boolean']
    noPDFFiles?: Scalars['Boolean']
    displayedBalance?: Scalars['Float']
    realBalance?: Scalars['Float']
    cycleStart?: Scalars['Date']
    cycleEnd?: Scalars['Date']
    isConfirmed?: Scalars['Boolean']
    irrelevantReason?: Scalars['String']
    irrelevantType?: IrrelevantType
    isMachineReconciled?: Scalars['Boolean']
    newOwner?: Scalars['String']
    newOwnerType?: BankAccountNewOwnerType
    newOwnerId?: Scalars['String']
    newOwnerName?: Scalars['String']
    bankDetails?: BankDetails
    transferDate?: Scalars['Date']
    closedDate?: Scalars['Date']
    relatedMissionId?: Scalars['String']
    isIntegrationTransfers?: Scalars['Boolean']
    isClosedThisYear?: Scalars['Boolean']
    __typename: 'BankStatementCustomerData'
}

export interface BankStatementFile {
    id: Scalars['ID']
    bankAccount: BankAccount
    bankStatementRequestId?: Scalars['String']
    companyId: Scalars['String']
    fileName?: Scalars['String']
    s3Bucket: Scalars['String']
    s3Key: Scalars['String']
    fileType?: BankAccountStatementFileType
    originalBankAccountId?: Scalars['String']
    originFileId?: Scalars['String']
    uploadOriginator?: BankStatementResolutionOriginator
    uploadedAt: Scalars['Date']
    uploadedByActor: ActorType
    uploadedById: Scalars['String']
    createdAt: Scalars['Date']
    updatedAt: Scalars['Date']
    status?: BankStatementFileStatus
    processingLogs?: BankStatementFileProcessingLog[]
    companyAffiliateType?: Scalars['String']
    companyAffiliateId?: Scalars['String']
    system?: BankStatementFileSystem
    subSystem?: BankStatementFileSubSystem
    __typename: 'BankStatementFile'
}

export interface BankStatementFileProcessingLog {
    processorType: BankStatementFileProcessorType
    state: BankStatementFileProcessingLogState
    processorId: Scalars['String']
    metadata?: Scalars['JSONObject']
    message?: Scalars['String']
    createdAt: Scalars['Date']
    __typename: 'BankStatementFileProcessingLog'
}

export type BankStatementFileProcessingLogState = 'IN_PROGRESS' | 'FINISHED' | 'ERROR' | 'MARKED_AS_DONE' | 'MARKED_AS_NOT_RELEVANT'

export type BankStatementFileProcessorType = 'MANUAL' | 'AUTOMATIC' | 'VIRTUAL_ASSISTANT' | 'TRANSACTIONS_UPLOADER'

export type BankStatementFileStatus = 'WAITING_FOR_AUTOMATIC_PROCESSING' | 'AUTOMATIC_PROCESS_RUNNING' | 'AUTOMATIC_PROCESS_FINISHED' | 'AUTOMATIC_PROCESS_FAILURE' | 'WAITING_FOR_MANUAL_PROCESSING' | 'MANUAL_PROCESS_RUNNING' | 'MANUAL_PROCESS_FINISHED' | 'MANUAL_PROCESS_FAILURE' | 'WAITING_FOR_TRANSACTIONS_UPLOADER' | 'TRANSACTIONS_UPLOADER_RUNNING' | 'TRANSACTIONS_UPLOADER_FINISHED' | 'DONE' | 'FAILURE' | 'NOT_RELEVANT'

export type BankStatementFileSubSystem = 'BULK_PDF' | 'CLOSING_BALANCE' | 'CUSTOMER_MANUAL_TRANSACTIONS_UPLOAD' | 'FILES_MANAGEMENT_BACKOFFICE' | 'HISTORICAL_GAP' | 'INTERNAL_TRANSFER' | 'MISSING_TXNS' | 'ONGOING_RECONCILIATION' | 'OPENING_BALANCE' | 'PAYOUTS_AND_TOPUPS' | 'RECURRING_CSV' | 'REPORTED_TRANSACTIONS' | 'STREAMLIT' | 'TRANSACTIONS_BACKFILL' | 'TRANSACTIONS_CSV_UPLOAD'

export type BankStatementFilesValidationProvider = 'OPEN_AI' | 'HERON' | 'NTROPY'

export type BankStatementFileSystem = 'ATU' | 'ATU_INTEGRATIONS' | 'BACKOFFICE' | 'STATEMENT_REQUESTS'

export interface BankStatementFinaloopData {
    comment?: Scalars['String']
    __typename: 'BankStatementFinaloopData'
}

export interface BankStatementParsedTransaction {
    date?: Scalars['String']
    description?: Scalars['String']
    amount?: Scalars['Float']
    runningBalance?: Scalars['Float']
    __typename: 'BankStatementParsedTransaction'
}

export interface BankStatementParsingRequest {
    id?: Scalars['ID']
    companyId: Scalars['ID']
    bankTransactionsUploadId?: Scalars['String']
    bankStatementFileId?: Scalars['String']
    provider?: BankStatementParsingRequestsProvider
    providerModel?: Scalars['String']
    queryVersion?: Scalars['Int']
    requestPayload?: Scalars['JSONObject']
    runStatus?: BankStatementParsingRequestsRunStatus
    rawResponse?: Scalars['JSONObject']
    startTime?: Scalars['Date']
    endTime?: Scalars['Date']
    responseTimeMs?: Scalars['Float']
    failureReason?: Scalars['String']
    __typename: 'BankStatementParsingRequest'
}

export type BankStatementParsingRequestsProvider = 'OPEN_AI' | 'HERON' | 'NTROPY'

export type BankStatementParsingRequestsRunStatus = 'SUCCESS' | 'FAILURE' | 'TIMEOUT'

export interface BankStatementParsingResult {
    id?: Scalars['ID']
    companyId: Scalars['ID']
    bankStatementParsingRequestId?: Scalars['String']
    bankTransactionsUploadId?: Scalars['String']
    bankStatementFileId?: Scalars['String']
    provider?: BankStatementParsingRequestsProvider
    providerModel?: Scalars['String']
    queryVersion?: Scalars['Int']
    status?: BankStatementParsingResultStatus
    institutionName?: Scalars['String']
    accountName?: Scalars['String']
    mask?: Scalars['String']
    openingBalance?: Scalars['Float']
    closingBalance?: Scalars['Float']
    startDate?: Scalars['Date']
    endDate?: Scalars['Date']
    isReconciled: Scalars['Boolean']
    isReconciledByProvider?: Scalars['Boolean']
    transactions?: BankStatementParsedTransaction[]
    accountHolders?: BankStatementAccountHolder[]
    transactionsCount?: Scalars['Int']
    totalTransactionsAmount?: Scalars['Float']
    balanceChange?: Scalars['Float']
    __typename: 'BankStatementParsingResult'
}

export type BankStatementParsingResultStatus = 'ACTIVE' | 'INACTIVE'

export type BankStatementReconciliationIrrelevantReason = 'ACCOUNT_CLOSED' | 'OWNERS_PERSONAL_ACCOUNT' | 'OWNED_BY_RELATED_BUSINESS' | 'TRANSFERRED_FROM_BUSINESS' | 'TRANSFERRED_TO_BUSINESS' | 'ACCOUNT_OPENED_AFTER_REQUESTED_DATE' | 'USER_SAID_NO_MISSING_TXNS' | 'USER_SAID_NO_RELEVANT_BANK_STATEMENTS'

export type BankStatementReconciliationResolutionType = 'IRRELEVANT' | 'STANDARD' | 'MADE_PRIVATE' | 'ASSUMED_CLOSED' | 'CONVERT_TO_MANUAL' | 'SEND_TO_OPS'

export type BankStatementReconciliationTransferredEntity = 'BUSINESS_OWNER' | 'RELATED_PARTY' | 'THIRD_PARTY'

export type BankStatementRequestCategory = 'UPLOAD_FILES' | 'RECONCILIATION' | 'CONNECTION' | 'UPLOAD_PDF'

export interface BankStatementRequestResolutionResponse {
    status: BankStatementRequestStatus
    submissionStatus: BankStatementRequestSubmissionStatus
    fileValidationStatus?: BankReconciliationRequestFilesStatus
    fileIds?: Scalars['String'][]
    errors?: Scalars['JSONObject']
    __typename: 'BankStatementRequestResolutionResponse'
}

export type BankStatementRequestStatus = 'CUSTOMER_ACTION_REQUIRED' | 'PENDING_FINALOOP_REVIEW' | 'FINALOOP_APPROVED' | 'CUSTOMER_CLOSED' | 'IRRELEVANT_ASSUMED_FINALOOP' | 'PENDING_AUTOMATIC_PROCESSING'

export type BankStatementRequestSubmissionStatus = 'APPROVED' | 'REJECTED' | 'FAILED'

export type BankStatementRequestType = 'OPENING' | 'CLOSING' | 'ONGOING' | 'RECURRING_CSV' | 'BULK_PDF' | 'MISSING_TXNS' | 'ONE_TIME_RECONCILIATION' | 'HISTORICAL_GAP' | 'ACCESS_REMOVED' | 'REPORT_TRANSACTIONS'

export type BankStatementResolutionOriginator = 'ATUBanking' | 'ATUIntegrations' | 'ATUWalmartHyperwallet' | 'BackOffice' | 'BankAccountReconciliation' | 'BankAccountStatementsReconciliation' | 'BankingPage' | 'ClosingBalanceRequest' | 'CustomerManualTransactionsUpload' | 'InternalTransferTransactionMatch' | 'OngoingReconciliationRequest' | 'OpeningBalanceRequest' | 'PayoutsAndTopUps' | 'ReportedTransactions' | 'TransactionsBackfill' | 'TransactionsBackOfficeStreamlit' | 'TransactionsCSVUpload'

export interface BankStatementValidationResults {
    fileId: Scalars['ID']
    runStatus: BankStatementValidationRunStatus
    failureReason?: Scalars['String']
    matchConfidence?: Scalars['Float']
    matchedComponents?: (BankStatementVerificationComponents | undefined)[]
    institution?: Scalars['String']
    startDate?: Scalars['Date']
    endDate?: Scalars['Date']
    openingBalance?: Scalars['Float']
    closingBalance?: Scalars['Float']
    accountNumber?: Scalars['String']
    __typename: 'BankStatementValidationResults'
}

export type BankStatementValidationRunStatus = 'PENDING' | 'VALID' | 'INVALID' | 'API_FAILED' | 'TIMEOUT' | 'NOT_APPLICABLE'

export type BankStatementVerificationComponents = 'MASK' | 'INSTITUTION'

export interface BankTransaction {
    id: Scalars['ID']
    accrual?: Accrual
    companyId: Scalars['ID']
    bankAccount: BankAccount
    postedAt: Scalars['Date']
    amount: Scalars['Float']
    currency: Scalars['String']
    amountInUsd: Scalars['Float']
    merchant?: Merchant
    businessEvent?: BankTransactionBusinessEvent
    classificationMetadata?: ClassificationMetadata
    description: Scalars['String']
    processedByMachineAt?: Scalars['Date']
    lastProcessedByMachineAt?: Scalars['Date']
    applyingClassificationJobId?: Scalars['String']
    source: Scalars['String']
    sourceSpecificData?: Scalars['JSONObject']
    userMemo?: BankTransactionMemo
    attachments: BankTransactionAttachment[]
    classificationVersion: Scalars['Int']
    deletedAt?: Scalars['Date']
    recommendations?: BankTransactionRecommendation[]
    loan?: CompanyLoan
    loanInfo?: TransactionLoan
    __typename: 'BankTransaction'
}

export interface BankTransactionAttachment {
    signedUrl: Scalars['String']
    url: Scalars['String']
    name: Scalars['String']
    addedBy: Scalars['String']
    createdAt?: Scalars['Date']
    __typename: 'BankTransactionAttachment'
}

export interface BankTransactionBusinessEvent {
    classifiedAt: Scalars['Date']
    classifierType: Scalars['String']
    classifiedBy: Scalars['String']
    classifications: BankTransactionBusinessEventClassification[]
    __typename: 'BankTransactionBusinessEvent'
}

export interface BankTransactionBusinessEventClassification {
    classificationId?: Scalars['ID']
    businessEvent: Scalars['String']
    amount: Scalars['Float']
    amountInPercentage?: Scalars['Float']
    amountInHomeCurrency?: Scalars['Float']
    affiliatedEntityId?: Scalars['String']
    affiliatedEntity?: AffiliatedEntity
    pairedEntityId?: Scalars['String']
    pairedEntityType?: PairedEntityType
    pairingType?: PairingType
    classificationTagId?: Scalars['String']
    classificationTagText?: Scalars['String']
    classificationText?: Scalars['String']
    description?: Scalars['String']
    extraData?: Scalars['JSONObject']
    askTheUserResult?: AskTheUserResult
    pairedEntity?: PairedEntity
    classificationTag?: ClassificationTag
    businessEventV2?: BusinessEventActionsConfiguration
    __typename: 'BankTransactionBusinessEventClassification'
}

export interface BankTransactionByMerchant {
    groupId: Scalars['ID']
    merchant?: Merchant
    transactions: BankTransaction[]
    __typename: 'BankTransactionByMerchant'
}

export interface BankTransactionByMerchantResult {
    groups: BankTransactionByMerchant[]
    total: Scalars['Int']
    nextToken?: Scalars['ID']
    __typename: 'BankTransactionByMerchantResult'
}

export interface BankTransactionCategorizationResult {
    bankTransaction: BankTransaction
    status: BankTransactionCategorizationResultStatus
    error?: Scalars['String']
    __typename: 'BankTransactionCategorizationResult'
}

export type BankTransactionCategorizationResultStatus = 'FAILURE' | 'SUCCESS'

export type BankTransactionClassifierType = 'LOCAL_RULE' | 'RULE' | 'USER' | 'INTEGRATION' | 'DATA_DELETER' | 'FINALOOP_TEAM' | 'FINALOOP_CUSTOMER' | 'NTROPY'

export interface BankTransactionMemo {
    content: Scalars['String']
    updatedAt?: Scalars['Date']
    updatedBy: Scalars['String']
    __typename: 'BankTransactionMemo'
}

export interface BankTransactionPairingResult {
    pairedEntityType: PairedEntityType
    pairedEntityId: Scalars['String']
    bankTransactions: BankTransaction[]
    __typename: 'BankTransactionPairingResult'
}

export interface BankTransactionRecommendation {
    classificationTag: ClassificationTag
    score: Scalars['Float']
    model: Scalars['String']
    recommendationsSource: RecommendationSource
    recommendedBy: RecommendedBy
    __typename: 'BankTransactionRecommendation'
}

export interface BankTransactionResponse {
    bankTransactions: BankTransaction[]
    nextOffset: Scalars['Int']
    __typename: 'BankTransactionResponse'
}

export interface BankTransactionsResponse {
    bankTransactions: BankTransaction[]
    __typename: 'BankTransactionsResponse'
}

export interface BankTransactionsSummary {
    amountInUsd: Scalars['Float']
    count: Scalars['Int']
    __typename: 'BankTransactionsSummary'
}

export interface BankTransactionsUpload {
    id: Scalars['ID']
    companyId: Scalars['String']
    bankAccount: BankAccount
    fileLocation: BankTransactionsUploadFileLocation
    uploadOriginator: Scalars['String']
    uploadedBy: ActorType
    uploadedById: Scalars['String']
    uploadedAt: Scalars['Date']
    processingLogs: BankTransactionsUploadProcessingLog[]
    status: BankTransactionsUploadStatus
    bankStatementRequestId?: Scalars['String']
    originFileId?: Scalars['String']
    __typename: 'BankTransactionsUpload'
}

export interface BankTransactionsUploadFileLocation {
    bucket: Scalars['String']
    key: Scalars['String']
    __typename: 'BankTransactionsUploadFileLocation'
}

export interface BankTransactionsUploadProcessingLog {
    processorType: BankTransactionsUploadProcessorType
    processorId: Scalars['String']
    createdAt: Scalars['Date']
    state: BankTransactionsUploadProcessingLogState
    metadata?: Scalars['JSONObject']
    __typename: 'BankTransactionsUploadProcessingLog'
}

export type BankTransactionsUploadProcessingLogState = 'IN_PROGRESS' | 'FINISHED' | 'ERROR' | 'MARKED_AS_DONE'

export type BankTransactionsUploadProcessorType = 'MANUAL' | 'AUTOMATIC' | 'VIRTUAL_ASSISTANT' | 'TRANSACTIONS_UPLOADER'

export type BankTransactionsUploadStatus = 'WAITING_FOR_AUTOMATIC_PROCESSING' | 'AUTOMATIC_PROCESS_RUNNING' | 'AUTOMATIC_PROCESS_FINISHED' | 'AUTOMATIC_PROCESS_FAILURE' | 'WAITING_FOR_MANUAL_PROCESSING' | 'MANUAL_PROCESS_RUNNING' | 'MANUAL_PROCESS_FINISHED' | 'MANUAL_PROCESS_FAILURE' | 'WAITING_FOR_TRANSACTIONS_UPLOADER' | 'TRANSACTIONS_UPLOADER_RUNNING' | 'TRANSACTIONS_UPLOADER_FINISHED' | 'DONE' | 'FAILURE'

export interface BankTxSaleTransaction {
    id: Scalars['ID']
    integrationInfo?: IntegrationInfo
    integrationAccountId?: Scalars['String']
    externalSourceId?: Scalars['String']
    amount: Scalars['Float']
    postedAt: Scalars['Date']
    currency: CurrencyCode
    amountInHomeCurrency: Scalars['Float']
    type: TransactionType
    finaloopPaymentGateway?: Scalars['String']
    originalPaymentGateway?: Scalars['String']
    paymentGatewayVariant?: Scalars['String']
    isIndication: Scalars['Boolean']
    __typename: 'BankTxSaleTransaction'
}

export interface BaseAffiliatedEntity {
    id: Scalars['ID']
    company?: Company
    name: Scalars['String']
    __typename: 'BaseAffiliatedEntity'
}

export interface BigValidationAccountRoleAmount {
    amount: Scalars['Float']
    accountRole: Scalars['String']
    __typename: 'BigValidationAccountRoleAmount'
}

export interface BigValidationAdjustment {
    date: Scalars['Date']
    amount: Scalars['Float']
    comment: Scalars['String']
    type: Scalars['String']
    setBy: Scalars['String']
    __typename: 'BigValidationAdjustment'
}

export interface BigValidationData {
    method: ManagementMethod
    startDate: Scalars['Date']
    endDate: Scalars['Date']
    entityData: BigValidationPeriodData
    booksData: BigValidationPeriodData
    status: BigValidationStatus
    isGreen: Scalars['Boolean']
    adjustment?: BigValidationAdjustment
    __typename: 'BigValidationData'
}

export interface BigValidationInventoryBalanceData {
    inventory: Scalars['Float']
    inventoryInProcess: Scalars['Float']
    inventoryInTransit: Scalars['Float']
    inventoryInTransitInternal: Scalars['Float']
    legacyInventory: Scalars['Float']
    __typename: 'BigValidationInventoryBalanceData'
}

export interface BigValidationPeriodData {
    cogs: BigValidationAccountRoleAmount[]
    purchases: BigValidationAccountRoleAmount[]
    endOfYearAdjustments: Scalars['Float']
    inventoryEndingBalance: BigValidationInventoryBalanceData
    inventoryOpeningBalance: Scalars['Float']
    physicalCount: Scalars['Float']
    __typename: 'BigValidationPeriodData'
}

export interface BigValidationResponse {
    data?: BigValidationData[]
    __typename: 'BigValidationResponse'
}

export interface BigValidationStatus {
    openingBalance: Scalars['Boolean']
    cogs: Scalars['Boolean']
    methodChangeAdjustments: Scalars['Boolean']
    endOfYearAdjustments: Scalars['Boolean']
    endingBalance: Scalars['Boolean']
    purchases: Scalars['Boolean']
    __typename: 'BigValidationStatus'
}


/**
 * This is an incomplete representation of a Bill in Finaloop's systems, for a full representation - please use
 * the REST API (bills-api) until this is complete.
 */
export interface Bill {
    id: Scalars['ID']
    accrual?: AccrualV2
    companyId: Scalars['ID']
    billNumber?: Scalars['String']
    currency: Scalars['String']
    amount: Scalars['Float']
    dueDate: Scalars['Date']
    createdDate: Scalars['Date']
    deletedAt?: Scalars['Date']
    vendor: Vendor
    categories: Category[]
    balance: Scalars['Float']
    payments: BillPayment[]
    indicativePayments: BillPayment[]
    credits: BillCredit[]
    adjustments: BillAdjustment[]
    refunds: BillRefund[]
    source: IntegrationType
    externalSourceData?: BillExternalSourceData
    latestAccountingEventIds?: Scalars['String'][]
    __typename: 'Bill'
}

export interface BillAdjustment {
    id?: Scalars['ID']
    type: BillAdjustmentType
    amount: Scalars['Float']
    currency: CurrencyCode
    actionTime: Scalars['Date']
    eventTime: Scalars['Date']
    __typename: 'BillAdjustment'
}

export type BillAdjustmentType = 'PRIOR_YEAR_ADJUSTMENT' | 'FULLY_REFUNDED'

export interface BillCredit {
    creditDate: Scalars['Date']
    amount: Scalars['Float']
    __typename: 'BillCredit'
}

export interface BillExternalSourceData {
    integrationAccountId: Scalars['String']
    integrationAccountName?: Scalars['String']
    balance?: Scalars['Float']
    link?: Scalars['String']
    __typename: 'BillExternalSourceData'
}

export interface Billing {
    id: Scalars['ID']
    __typename: 'Billing'
}

export type BillingPayment = (RecurringPayment | OneTimePayment) & { __isUnion?: true }

export interface BillPayment {
    id?: Scalars['ID']
    paymentDate: Scalars['Date']
    amount: Scalars['Float']
    feeAmount?: Scalars['Float']
    amountInUSD?: Scalars['Float']
    currency: CurrencyCode
    vendor?: Vendor
    settlementType: BillPaymentSettlementType
    voidedAt?: Scalars['Date']
    source: IntegrationType
    /**
     * These are the amounts being prorates for this payment over each category.
     * The order of the amounts in this array corresponds to the order of the categories in the bill.
     * 
     * This field is not available for indicative payments, as the proration acts only on the regular payments.
     */
    categoriesProration?: Scalars['Float'][]
    financing?: BillPaymentFinancing
    bulkPaymentData?: BulkPaymentData
    __typename: 'BillPayment'
}

export interface BillPaymentFinancing {
    type: BillPaymentFinancingType
    feeBillIds?: (Scalars['String'] | undefined)[]
    financedAmount?: Scalars['Float']
    totalDays?: Scalars['Int']
    periods?: Scalars['Int']
    periodDays?: Scalars['Int']
    installments: BillPaymentFinancingInstallment[]
    __typename: 'BillPaymentFinancing'
}

export interface BillPaymentFinancingInstallment {
    installmentTime: Scalars['Date']
    principalAmount: Scalars['Float']
    interestAmount: Scalars['Float']
    totalAmount: Scalars['Float']
    status: FinancedPaymentInstallmentStatus
    isRefund?: Scalars['Boolean']
    externalId?: Scalars['String']
    refundedExternalIds?: Scalars['String'][]
    __typename: 'BillPaymentFinancingInstallment'
}

export type BillPaymentFinancingType = 'EPT' | 'BEPT' | 'AMORTIZED'

export type BillPaymentSettlementType = 'PAID_EXTERNALLY' | 'PAID_VIA_INTEGRATION' | 'FINANCED_BY_INTEGRATION' | 'FINANCED_EXTERNALLY' | 'SCHEDULED' | 'INDICATIVE' | 'MANUAL_BY_FINALOOP_TEAM'

export interface BillRefund {
    id?: Scalars['ID']
    refundDate: Scalars['Date']
    amount: Scalars['Float']
    amountInUSD?: Scalars['Float']
    currency: CurrencyCode
    settlementType: BillRefundSettlementType
    isVoidedPayment?: Scalars['Boolean']
    source: IntegrationType
    __typename: 'BillRefund'
}

export type BillRefundSettlementType = 'REFUNDED_VIA_INTEGRATION' | 'SCHEDULED' | 'INDICATIVE' | 'MANUAL_BY_FINALOOP_TEAM'

export interface BillsDueDateSummary {
    total?: DueDateSummary
    totalBalanceDue?: DueDateSummary
    pastDue?: DueDateSummary
    dueNext7Days?: DueDateSummary
    dueAfterNext7Days?: DueDateSummary
    __typename: 'BillsDueDateSummary'
}

export interface BillsYearEnd {
    fiscalYearStartDate: Scalars['Date']
    fiscalYearEndDate: Scalars['Date']
    domainState: YearEndDomainState
    hubReportedDomainState?: YearEndDomainState
    tasks: BillsYearEndTask[]
    __typename: 'BillsYearEnd'
}

export type BillsYearEndTask = (AddMissingBillsTask | CategorizeUncategorizedBillsTask | CloseOpenBillsTask | ConfirmApBalanceTask) & { __isUnion?: true }

export type BillsYearEndTaskId = 'CATEGORIZE_UNCATEGORIZED_BILLS' | 'CLOSE_OPEN_BILLS' | 'ADD_MISSING_BILLS' | 'CONFIRM_AP_BALANCE'

export interface BillsYearEndTasksResponse {
    yearEnd: BillsYearEnd[]
    __typename: 'BillsYearEndTasksResponse'
}

export type BillsYearEndTaskStatus = 'INACTIVE' | 'OPEN' | 'REOPENED' | 'PROCESSING' | 'CLOSED'

export interface BooleanChangeLog {
    id: Scalars['ID']
    createdAt: Scalars['Date']
    updaterType: HubUpdaterType
    changedByUid?: Scalars['String']
    reason?: Scalars['String']
    oldValue: Scalars['Boolean']
    newValue: Scalars['Boolean']
    __typename: 'BooleanChangeLog'
}

export interface BooleanResult {
    success: Scalars['Boolean']
    __typename: 'BooleanResult'
}

export type BreakdownType = 'CATEGORY' | 'MERCHANT'

export interface BulkEditCsvTemplateResponse {
    url: Scalars['String']
    __typename: 'BulkEditCsvTemplateResponse'
}

export interface BulkPaymentData {
    id?: Scalars['String']
    amount?: Scalars['Float']
    amountInUsd?: Scalars['Float']
    paymentType?: Scalars['String']
    feeAmount?: Scalars['Float']
    __typename: 'BulkPaymentData'
}

export interface BulkRecoveryUnitsTrackingFailureResult {
    company: Company
    reason: Scalars['String']
    __typename: 'BulkRecoveryUnitsTrackingFailureResult'
}

export interface BulkRecoveryUnitsTrackingResult {
    failureResults: BulkRecoveryUnitsTrackingFailureResult[]
    successResults: Company[]
    __typename: 'BulkRecoveryUnitsTrackingResult'
}

export type BusinessCreationType = 'CREATED' | 'PURCHASED'

export interface BusinessEventActionsConfiguration {
    type: Scalars['String']
    variant?: Scalars['String']
    id: Scalars['ID']
    accrualConfig?: JournalEntryActions
    cashConfig?: JournalEntryActions
    presentationalAccountRole?: AccountRole
    businessEventDefinition?: BusinessEventDefinition
    __typename: 'BusinessEventActionsConfiguration'
}

export interface BusinessEventData {
    id: Scalars['ID']
    __typename: 'BusinessEventData'
}

export interface BusinessEventDefinition {
    id: Scalars['ID']
    name?: Scalars['String']
    customerDisplayName?: Scalars['String']
    groups: Scalars['String'][]
    vendorRequired?: Scalars['Boolean']
    requiredAffiliatedEntityType?: Scalars['String']
    irrelevantForVendor?: Scalars['Boolean']
    hideForManualClassification?: Scalars['Boolean']
    forceShowInEventsListings?: Scalars['Boolean']
    moneyDirection?: MoneyDirection
    customerDescriptionTemplate?: Scalars['String']
    isRelevantToAccruals?: Scalars['Boolean']
    isRelevantToAccrualsFixedAsset?: Scalars['Boolean']
    __typename: 'BusinessEventDefinition'
}

export interface BusinessEventsAccrualsConfig {
    id: Scalars['ID']
    isRelevantToAccruals?: Scalars['Boolean']
    isRelevantToAccrualsFixedAsset?: Scalars['Boolean']
    __typename: 'BusinessEventsAccrualsConfig'
}

export interface BusinessEventsAccrualsConfigV2 {
    companyId: Scalars['ID']
    event: BusinessEventDefinition
    isRelevantToAccruals?: Scalars['Boolean']
    isRelevantToAccrualsFixedAsset?: Scalars['Boolean']
    __typename: 'BusinessEventsAccrualsConfigV2'
}

export interface CalendlyEventResponse {
    email: Scalars['String']
    name: Scalars['String']
    phoneNumber?: Scalars['String']
    __typename: 'CalendlyEventResponse'
}

export interface CanceledAccrualData {
    classificationTagId?: Scalars['ID']
    businessEventType: Scalars['String']
    spreadType: SpreadType
    /** @deprecated use customSpreadOptions instead */
    residualAmount?: Scalars['Float']
    specificDate?: SpecificDate
    spreadOverTime?: SpreadOverTime
    customSpread?: CustomSpread[]
    customSpreadOptions?: CustomSpreadOptions
    defaultFixedAssetsData?: DefaultFixedAssetsData
    customFixedAssetsData?: CustomFixedAssetsData
    __typename: 'CanceledAccrualData'
}

export interface CancelInvalidInventoryPaymentGroupsResponse {
    canceledGroupIds: Scalars['String'][]
    __typename: 'CancelInvalidInventoryPaymentGroupsResponse'
}

export interface CategorizeUncategorizedBillsTask {
    id: BillsYearEndTaskId
    status: BillsYearEndTaskStatus
    stateKey: Scalars['String']
    amount: Scalars['Int']
    __typename: 'CategorizeUncategorizedBillsTask'
}

export interface Category {
    description?: Scalars['String']
    amount: Scalars['Float']
    classificationTag: ClassificationTag
    __typename: 'Category'
}

export interface CategoryBreakdown {
    category: CogsCategory
    amount: Scalars['Float']
    costType: CostType
    __typename: 'CategoryBreakdown'
}

export type ChangeLog = (AddMissingBillsTaskStateChangeLog | AddMissingInvoicesTaskStateChangeLog | CloseOpenBillsTaskStateChangeLog | CloseOpenInvoicesTaskStateChangeLog | ConfirmApBalanceTaskStateChangeLog | ConfirmArBalanceTaskStateChangeLog | LinkInvoicePaymentsTaskStateChangeLog | YearEndDomainStateChangeLog | YearEndDomainStateDataChangeLog | YearEndEmailChangeLog | YearEndIntercomLinkChangeLog | YearEndStateChangeLog | YearEndUserUnresponsiveChangeLog) & { __isUnion?: true }

export interface Chargeback {
    companyId: Scalars['ID']
    id: Scalars['ID']
    source: IntegrationType
    integrationAccountId: Scalars['ID']
    integrationAccountName?: Scalars['String']
    amount: Scalars['Float']
    currency: Scalars['String']
    postedAt: Scalars['Date']
    disputeId?: Scalars['ID']
    __typename: 'Chargeback'
}

export interface ChartDataResponse {
    title: Scalars['String']
    updatedAt?: Scalars['Date']
    category?: Scalars['String']
    data: DataSerie[]
    labels: (Scalars['String'] | undefined)[]
    __typename: 'ChartDataResponse'
}

export interface ClassificationMetadata {
    enrichmentRuleType?: Scalars['EnrichmentRuleType']
    enrichmentRuleId?: Scalars['String']
    businessEventRuleType?: Scalars['BusinessEventRuleType']
    businessEventRuleId?: Scalars['String']
    isAugmented?: Scalars['Boolean']
    actorType?: ActorType
    actorId?: Scalars['String']
    classifiedAt?: Scalars['Date']
    recommendations?: ClassificationMetadataRecommendation
    __typename: 'ClassificationMetadata'
}

export interface ClassificationMetadataRecommendation {
    chosenRecommendation?: ClassificationRecommendation
    mechanism: RecommendedBy
    value?: ClassificationMetadataRecommendationValue
    __typename: 'ClassificationMetadataRecommendation'
}

export interface ClassificationMetadataRecommendationOptionValue {
    seenOptions: ClassificationRecommendation[]
    __typename: 'ClassificationMetadataRecommendationOptionValue'
}

export interface ClassificationMetadataRecommendationPromptValue {
    prompt: Scalars['String']
    __typename: 'ClassificationMetadataRecommendationPromptValue'
}

export type ClassificationMetadataRecommendationValue = (ClassificationMetadataRecommendationOptionValue | ClassificationMetadataRecommendationPromptValue) & { __isUnion?: true }

export interface ClassificationRecommendation {
    tagId: Scalars['String']
    score: Scalars['Float']
    model: Scalars['String']
    recommendationsSource: RecommendationSource
    __typename: 'ClassificationRecommendation'
}

export interface ClassificationResult {
    current: BankTransaction
    previous: BankTransaction
    __typename: 'ClassificationResult'
}

export interface ClassificationTag {
    id: Scalars['ID']
    name: Scalars['String']
    moneyDirection: MoneyDirection
    isHidden: Scalars['Boolean']
    isRelevantToBills: Scalars['Boolean']
    isRelevantToApplyAlways: Scalars['Boolean']
    displayNameForReports?: Scalars['String']
    keywords: Scalars['String'][]
    classification: ClassificationTagClassification
    isApplicableForRefund: Scalars['Boolean']
    weight?: Scalars['Int']
    reportsDisplayNameForTagSelection?: Scalars['String']
    createdAt: Scalars['Date']
    updatedAt: Scalars['Date']
    lastUpdatedBy?: Scalars['String']
    classificationBusinessEventEffects?: ClassificationTagBusinessEventEffects
    triggeringClassificationFlowsConditions?: Scalars['JSONObject']
    __typename: 'ClassificationTag'
}

export interface ClassificationTagBusinessEventEffects {
    moneyInBusinessEvent?: BusinessEventActionsConfiguration
    moneyOutBusinessEvent?: BusinessEventActionsConfiguration
    __typename: 'ClassificationTagBusinessEventEffects'
}

export interface ClassificationTagClassification {
    in?: Scalars['String']
    out?: Scalars['String']
    __typename: 'ClassificationTagClassification'
}

export interface ClassificationTagSuggestionsResponse {
    suggestions: ClassificationTagWithSuggestionReason[]
    debuggingInfo?: Scalars['JSONObject']
    __typename: 'ClassificationTagSuggestionsResponse'
}

export interface ClassificationTagWithSuggestionReason {
    classificationTag: ClassificationTag
    confidenceScore?: Scalars['Float']
    reason?: Scalars['String']
    __typename: 'ClassificationTagWithSuggestionReason'
}

export interface CloseOpenBillsTask {
    id: BillsYearEndTaskId
    status: BillsYearEndTaskStatus
    stateKey: Scalars['String']
    currentBillsHash: Scalars['String']
    state: CloseOpenBillsTaskState
    history?: (CloseOpenBillsTaskStateChangeLog | undefined)[]
    __typename: 'CloseOpenBillsTask'
}

export interface CloseOpenBillsTaskState {
    confirmedBillsHash?: Scalars['String']
    __typename: 'CloseOpenBillsTaskState'
}

export interface CloseOpenBillsTaskStateChangeLog {
    id: Scalars['ID']
    createdAt: Scalars['Date']
    updaterType: YearEndStateUpdaterType
    changedByUid?: Scalars['String']
    reason?: Scalars['String']
    oldValue?: CloseOpenBillsTaskState
    newValue?: CloseOpenBillsTaskState
    __typename: 'CloseOpenBillsTaskStateChangeLog'
}

export interface CloseOpenInvoicesTask {
    id: InvoicesYearEndTaskId
    status: InvoicesYearEndTaskStatus
    stateKey: Scalars['String']
    currentInvoicesHash: Scalars['String']
    state: CloseOpenInvoicesTaskState
    history?: (CloseOpenInvoicesTaskStateChangeLog | undefined)[]
    __typename: 'CloseOpenInvoicesTask'
}

export interface CloseOpenInvoicesTaskState {
    confirmedInvoicesHash?: Scalars['String']
    __typename: 'CloseOpenInvoicesTaskState'
}

export interface CloseOpenInvoicesTaskStateChangeLog {
    id: Scalars['ID']
    createdAt: Scalars['Date']
    updaterType: YearEndStateUpdaterType
    changedByUid?: Scalars['String']
    reason?: Scalars['String']
    oldValue?: CloseOpenInvoicesTaskState
    newValue?: CloseOpenInvoicesTaskState
    __typename: 'CloseOpenInvoicesTaskStateChangeLog'
}

export interface ClosingBalance {
    companyId: Scalars['ID']
    id: Scalars['ID']
    source: IntegrationType
    integrationAccountId: Scalars['ID']
    integrationAccountName?: Scalars['String']
    amount: Scalars['Float']
    currency: Scalars['String']
    appliedAt: Scalars['Date']
    type: ClosingBalanceType
    __typename: 'ClosingBalance'
}

export type ClosingBalanceType = 'INTEGRATION_UDF'

export interface COGSBreakdownItem {
    product: Product
    quantity: Scalars['Int']
    avgCostPerUnit?: Scalars['Float']
    totalCogs: Scalars['Float']
    __typename: 'COGSBreakdownItem'
}

export type CogsCategory = 'ProductDirectCost' | 'ShippingAndFreightIn' | 'CustomFeesAndServices' | 'DutiesAndTax' | 'Insurance' | 'PalletCosts' | 'ShippingSurcharge' | 'VendorFees' | 'ProductionCosts' | 'Discount' | 'PackagingMaterials' | 'Dropshipping' | 'ProductionLaborCosts' | 'ManufacturingCosts' | 'ManufacturingLabor' | 'Printing' | 'InventoryMaintenance' | 'General' | 'OtherInventoryAdjustments' | 'WarrantyReimbursement'

export interface COGSEvent {
    id: Scalars['String']
    groupName: Scalars['String']
    period: COGSEventPeriod
    amount: Scalars['Float']
    salesChannel?: SalesChannel
    lineOfBusinessId?: Scalars['String']
    memo?: Scalars['String']
    type: CogsType
    source: COGSEventSource
    isFullyProcessed: Scalars['Boolean']
    costType: CostType
    categoryBreakdown?: CategoryBreakdown[]
    __typename: 'COGSEvent'
}

export interface COGSEventPeriod {
    fromDate: Scalars['Date']
    toDate: Scalars['Date']
    __typename: 'COGSEventPeriod'
}

export type COGSEventSource = 'system' | 'user' | 'incidentals'

export type CogsSource = 'Products' | 'Incidentals' | 'Manual'

export interface COGSSummaryV2 {
    groupName: Scalars['String']
    type: CogsType
    sum: Scalars['Float']
    salesChannel?: SalesChannel
    realtimeSum: Scalars['Float']
    manualSum: Scalars['Float']
    __typename: 'COGSSummaryV2'
}

export type CogsType = 'COGS' | 'DeadInventory' | 'ProductGiveaways' | 'Waste' | 'PhysicalAdjustments' | 'ProductDonations' | 'UnitLost' | 'UnitFound' | 'OtherFba' | 'SupplierReturn'

export interface CommonAction {
    quantity: Scalars['Float']
    id: Scalars['String']
    date: Scalars['Date']
    type: Scalars['String']
    __typename: 'CommonAction'
}

export interface Company {
    id: Scalars['ID']
    billing?: CompanyBilling
    name?: Scalars['String']
    userName?: Scalars['String']
    refferalCode?: Scalars['String']
    source?: Scalars['JSONObject']
    email: Scalars['String']
    isManufacturer?: Scalars['Boolean']
    phoneNumber?: Scalars['String']
    address?: Address
    accountingMethod?: AccountingMethod
    booksStartTime?: Scalars['JSONObject']
    dataRestrictionTime?: Scalars['Date']
    /** @deprecated use balanceSheetSetup instead */
    balanceSheetStatus?: BalanceSheetStatus
    customerSelectedAccountingMethod?: CustomerSelectedAccountingMethod
    inventorySettings?: InventorySettings
    ordersSettings?: OrdersSettings
    generalDetails?: Scalars['JSONObject']
    configuration?: CompanyConfiguration
    isTestCompany?: Scalars['Boolean']
    isArchived?: Scalars['Boolean']
    createdAtMs?: Scalars['Float']
    createdAtIso?: Scalars['String']
    canceledAtIso?: Scalars['String']
    preloadEmail?: Scalars['String']
    eventsLock?: Scalars['JSONObject']
    eventsLock2?: EventsLock
    legalEntityType?: Scalars['String']
    taxEntityType?: Scalars['String']
    trialStartTimeIso?: Scalars['String']
    trialStartTimeMs?: Scalars['Float']
    trialDurationInDays?: Scalars['Int']
    isPaying?: Scalars['Boolean']
    fullUiAccess?: Scalars['Boolean']
    paymentStatus?: Scalars['String']
    tier?: Scalars['String']
    tierAtConversion?: Scalars['String']
    taxPlan?: Scalars['String']
    stripeCustomerId?: Scalars['ID']
    isOnboardingCompleted?: Scalars['Boolean']
    onboardingCompletedAtIso?: Scalars['String']
    onboardingState?: OnBoardingState
    isParkerReferral?: Scalars['Boolean']
    estimatedProjectedRevenue?: EstimatedProjectedRevenue
    calculatedTier?: CompanyTier
    hasActiveTrial: Scalars['Boolean']
    lockStatus?: CompanyLockStatus
    isLiveTestCompany?: Scalars['Boolean']
    gtmSource?: GTMSource
    fiscalYearStart: CompanyFiscalYearStart
    lockHistory: CompanyLockHistory[]
    appsSelectedInPreOnboarding?: Scalars['String'][]
    referralCode?: Scalars['String']
    endOfYearDeadline?: Scalars['JSONObject']
    booksStatus?: Scalars['JSONObject']
    accountingServices?: AccountingServicesTypes
    demo?: Scalars['String']
    preOnboardingFunnelType?: Scalars['String']
    isPremiumService?: Scalars['Boolean']
    isPartner?: Scalars['Boolean']
    isTaxPlan?: Scalars['Boolean']
    firstPaymentDate?: Scalars['Date']
    balanceSheetSetup?: CompanyBalanceSheetSetup
    customerSuccessManager?: Scalars['String']
    healthScore?: Scalars['String']
    __typename: 'Company'
}

export interface CompanyAccountValidation {
    account?: Scalars['String']
    status: CompanyValidationStatus
    value?: Scalars['Float']
    isError: Scalars['Boolean']
    asOfDate?: Scalars['Date']
    updatedAt?: Scalars['Date']
    lastSuccessfulRunAt?: Scalars['Date']
    __typename: 'CompanyAccountValidation'
}

export interface CompanyAddress {
    id?: Scalars['ID']
    companyId: Scalars['ID']
    source: Scalars['String']
    integrationAccountId: Scalars['String']
    isDefault?: Scalars['Boolean']
    name?: Scalars['String']
    email?: Scalars['String']
    phone?: Scalars['String']
    line1?: Scalars['String']
    line2?: Scalars['String']
    city?: Scalars['String']
    country?: Scalars['String']
    province?: Scalars['String']
    state?: Scalars['String']
    zip?: Scalars['String']
    __typename: 'CompanyAddress'
}

export interface CompanyAffiliate {
    id: Scalars['ID']
    companyId?: Scalars['ID']
    type: CompanyAffiliateType
    name: Scalars['String']
    createdAt: Scalars['Date']
    updatedAt: Scalars['Date']
    logoUrl?: Scalars['String']
    holdingsInPercentage?: Scalars['Float']
    isForeignResident?: Scalars['Boolean']
    balance: Scalars['Float']
    transactions: CompanyAffiliateTransaction[]
    status?: HolderStatus
    affiliatedEntityId: Scalars['ID']
    latestAccountingEventIds?: Scalars['String'][]
    deletedAt?: Scalars['Date']
    __typename: 'CompanyAffiliate'
}

export interface CompanyAffiliateTransaction {
    entityId: Scalars['ID']
    entityType: Scalars['String']
    bankAccountId?: Scalars['String']
    postedAt: Scalars['Date']
    amount: Scalars['Float']
    currency: Scalars['String']
    amountInUsd: Scalars['Float']
    type: Scalars['String']
    source: IntegrationType
    __typename: 'CompanyAffiliateTransaction'
}

export type CompanyAffiliateType = 'holder' | 'safeHolder' | 'relatedParty' | 'employee' | 'contractor' | 'lender'

export interface CompanyArCashDiffsActionsResponse {
    accountRole: Scalars['String']
    amount: Scalars['Float']
    isAccrual: Scalars['Boolean']
    isCash: Scalars['Boolean']
    __typename: 'CompanyArCashDiffsActionsResponse'
}

export interface CompanyArCashDiffsFixbooksResponse {
    eventTime: Scalars['Date']
    createdAt: Scalars['Date']
    creatorEmail: Scalars['String']
    integrationAccountId: Scalars['String']
    memo: Scalars['String']
    actions: CompanyArCashDiffsActionsResponse[]
    __typename: 'CompanyArCashDiffsFixbooksResponse'
}

export interface CompanyArCashDiffsOrdersResponse {
    orderId: Scalars['ID']
    integrationAccountId: Scalars['String']
    externalSourceId: Scalars['String']
    displayName: Scalars['String']
    ordersVsBooks: Scalars['Float']
    ordersBalance?: Scalars['Float']
    booksBalance?: Scalars['Float']
    placedAt: Scalars['Date']
    __typename: 'CompanyArCashDiffsOrdersResponse'
}

export interface CompanyArCashDiffsResponse {
    companyId: Scalars['ID']
    reportDate: Scalars['Date']
    orders: CompanyArCashDiffsOrdersResponse[]
    fixbooks: CompanyArCashDiffsFixbooksResponse[]
    totals: CompanyArCashTotalsResponse[]
    lockTime?: Scalars['Date']
    __typename: 'CompanyArCashDiffsResponse'
}

export interface CompanyArCashTotalsResponse {
    arCashInBooks: Scalars['Float']
    unpaidOrders: Scalars['Float']
    __typename: 'CompanyArCashTotalsResponse'
}

export interface CompanyBalanceSheetSetup {
    state: HubState
    __typename: 'CompanyBalanceSheetSetup'
}

export interface CompanyBilling {
    features: Feature[]
    purchasedOffers: PurchasedOffer[]
    portalUrl?: Scalars['String']
    __typename: 'CompanyBilling'
}

export interface CompanyConfiguration {
    isPnlReportReady?: Scalars['Boolean']
    isBalanceSheetReportFinal?: Scalars['Boolean']
    includeCCAccountsInCashFlowBeforePayment?: Scalars['Boolean']
    includeUDFAccountsInCashFlowBeforeDeposit?: Scalars['Boolean']
    cashFlowStartTimeISO?: Scalars['String']
    __typename: 'CompanyConfiguration'
}

export interface CompanyEventsLockHistory {
    year: Scalars['Int']
    createdAt: Scalars['Date']
    userEmail: Scalars['String']
    type: LockType
    __typename: 'CompanyEventsLockHistory'
}

export interface CompanyFiscalYearStart {
    day: Scalars['Int']
    month: Scalars['Int']
    userEmail?: Scalars['String']
    __typename: 'CompanyFiscalYearStart'
}

export interface CompanyFundedStatus {
    hideBanner: Scalars['Boolean']
    __typename: 'CompanyFundedStatus'
}

export interface CompanyHealthStatus {
    company: Company
    domains: CompanyValidationDomain[]
    status: CompanyValidationStatus
    __typename: 'CompanyHealthStatus'
}

export type CompanyHealthStatusSortDirection = 'ASC' | 'DESC'

export interface CompanyIdAndStripeCustomerId {
    companyId: Scalars['String']
    stripeCustomerId: Scalars['String']
    __typename: 'CompanyIdAndStripeCustomerId'
}

export interface CompanyIntegration {
    companyId: Scalars['ID']
    integrationType: IntegrationType
    integrationAccountId: Scalars['ID']
    integrationTypeAndIntegrationAccountId: Scalars['String']
    data?: Scalars['JSON']
    enabled: Scalars['Boolean']
    impactOnBooksSince: Scalars['String']
    createdAtMs: Scalars['Float']
    deletedByUserAt?: Scalars['String']
    deletedByUserId?: Scalars['String']
    disconnectedAt?: Scalars['String']
    disconnectedBy?: Scalars['String']
    __typename: 'CompanyIntegration'
}

export interface CompanyLoan {
    id: Scalars['ID']
    company: Company
    source?: Scalars['String']
    integrationAccountId?: Scalars['String']
    externalSourceId?: Scalars['String']
    integrationAccountName?: Scalars['String']
    type?: LoanType
    lender?: NewLender
    currency?: CurrencyCode
    postedAt?: Scalars['Date']
    direction?: LoanDirection
    isShortTerm?: Scalars['Boolean']
    amount?: Scalars['Float']
    totalAmount?: Scalars['Float']
    outstandingAmount?: Scalars['Float']
    accruedInterest?: Scalars['Float']
    unrecognizedFees?: Scalars['Float']
    prepaymentLiabilityAmount?: Scalars['Float']
    status?: LoanStatus
    userActionStatus?: LoanUserActionStatus
    acknowledgedInternallyAt?: Scalars['Date']
    acknowledgedInternallyBy?: Scalars['String']
    paidOffAt?: Scalars['Date']
    attachments?: LoanAttachment[]
    workingPaperLink?: Scalars['String']
    updatedBy?: Scalars['String']
    lockedAt?: Scalars['Date']
    lastSeenByClientAt?: Scalars['Date']
    deletedAt?: Scalars['Date']
    createdAt: Scalars['Date']
    updatedAt: Scalars['Date']
    interestDays?: LoanInterestDays
    repaymentType?: LoanRepaymentType
    repaymentFrequency?: LoanRepaymentFrequency
    repaymentRate?: Scalars['Float']
    interestRateType?: LoanInterestRateType
    interestRate?: Scalars['Float']
    gracePeriod?: Scalars['Int']
    catchUpPeriod?: Scalars['Int']
    catchUpPercent?: Scalars['Float']
    originationFees?: Scalars['Float']
    prepaymentFees?: Scalars['Float']
    recurringDataFrequency?: LoanRecurringDataFrequency
    instantRepaymentMethod?: LoanInstantRepaymentMethod
    isIndexLinked?: Scalars['Boolean']
    interestType?: LoanInterestType
    variableInterestUpdatePeriod?: LoanVariableInterestUpdatePeriod
    variableInterestSpread?: Scalars['Float']
    variableInterestBase?: LoanVariableInterestBase
    compoundFrequency?: LoanCompoundFrequency
    indexType?: LoanIndexType
    isEarlyRepaymentDiscount?: Scalars['Boolean']
    earlyRepaymentDiscounts?: EarlyRepaymentDiscount[]
    transactions?: BankTransaction[]
    lastTransaction?: BankTransaction
    userFollowUp2?: UserFollowUp
    askIfRepaid?: Scalars['Boolean']
    hideOutdatedWarning?: Scalars['Boolean']
    deleteOptionMode?: CompanyLoanDeleteOptionMode
    pendingDelete?: Scalars['Boolean']
    pendingRestoreAcknowledgement?: Scalars['Boolean']
    lastUserMoveToProcessingAt?: Scalars['Date']
    dataRequestType?: LoanDataRequestType
    isHidden?: Scalars['Boolean']
    lastEventDate?: Scalars['Date']
    isBillPaymentEventAttached?: Scalars['Boolean']
    firstPaymentDate?: Scalars['Date']
    lastPaymentDate?: Scalars['Date']
    creationSource?: LoanSource
    hasRollOverEvent?: Scalars['Boolean']
    __typename: 'CompanyLoan'
}

export interface CompanyLoanAttachmentUpdateResult {
    success: Scalars['Boolean']
    errors?: LoanAttachmentError[]
    loan?: CompanyLoan
    processing?: Scalars['Boolean']
    __typename: 'CompanyLoanAttachmentUpdateResult'
}

export type CompanyLoanDeleteOptionMode = 'NOT_IN_BOOKS' | 'MANUAL_EVENTS_ONLY' | 'ONLY_TRANSACTIONS_EVENTS' | 'HAS_INTEGRATION_EVENTS'

export interface CompanyLoanResponse {
    loan: CompanyLoan
    __typename: 'CompanyLoanResponse'
}

export interface CompanyLoansResponse {
    loans: CompanyLoan[]
    __typename: 'CompanyLoansResponse'
}

export interface CompanyLockConditions {
    accountingMethod: Scalars['String']
    moneyIn: LockConditionStatus
    moneyOut: LockConditionStatus
    reclassificationMoneyIn: LockConditionStatus
    reclassificationMoneyOut: LockConditionStatus
    assetsEqualToLiabilitiesAndEquities: LockConditionStatus
    isPayrollOk?: Scalars['Boolean']
    __typename: 'CompanyLockConditions'
}

export interface CompanyLockHistory {
    type: LockAction
    userEmail: Scalars['String']
    startDate: Scalars['Date']
    endDate: Scalars['Date']
    createdAt: Scalars['Date']
    __typename: 'CompanyLockHistory'
}

export interface CompanyLockStatus {
    minimumAllowedEventTime: Scalars['Date']
    lockedAt: Scalars['Date']
    __typename: 'CompanyLockStatus'
}

export type CompanyTier = 'TIER_1_V3' | 'TIER_2_V3' | 'TIER_3_V3' | 'TIER_4_V3' | 'TIER_5_V3' | 'TIER_6_V3' | 'TIER_7_V3'

export type CompanyTierType = 'TIER_1' | 'TIER_2' | 'TIER_3' | 'TIER_4' | 'TIER_1_V3' | 'TIER_2_V3' | 'TIER_3_V3' | 'TIER_4_V3' | 'TIER_5_V3' | 'TIER_6_V3' | 'TIER_7_V3'

export interface CompanyUser {
    email: Scalars['String']
    roles: UserRole[]
    name?: Scalars['String']
    auth0Id?: Scalars['String']
    invitationStatus?: InvitationStatus
    __typename: 'CompanyUser'
}

export interface CompanyUsersResponse {
    users: CompanyUser[]
    __typename: 'CompanyUsersResponse'
}

export interface CompanyValidation {
    type: CompanyValidationType
    metricName?: CompanyValidationMetricName
    name: Scalars['String']
    status: CompanyValidationStatus
    accounts: CompanyAccountValidation[]
    asOfDate?: Scalars['Date']
    updatedAt?: Scalars['Date']
    lastSuccessfulRunAt?: Scalars['Date']
    __typename: 'CompanyValidation'
}

export interface CompanyValidationDomain {
    type: CompanyValidationDomainType
    name: Scalars['String']
    status: CompanyValidationStatus
    validations: CompanyValidation[]
    __typename: 'CompanyValidationDomain'
}

export type CompanyValidationDomainType = 'SHOPIFY' | 'AMAZON' | 'INVENTORY' | 'ACCRUALS' | 'STRIPE' | 'LOANS' | 'EQUITY' | 'PAYMENTS' | 'SALES' | 'COMPANY_AFFILIATES' | 'BANKS' | 'BANK_TRANSACTIONS' | 'BILLS' | 'AR' | 'MONEY_IN_TRANSIT' | 'GENERAL' | 'ORDERS' | 'PAYROLL' | 'TIK_TOK'

export type CompanyValidationMetricMode = 'DIFF' | 'INFO'

export type CompanyValidationMetricName = 'INTERNAL_DIFF' | 'USER_FACING_DIFF' | 'QUANTITY_DIFF' | 'COST_DIFF' | 'BUSINESS_EVENTS_DIFF' | 'BS_DIFF' | 'ACCRUALS_CLEARING_ACCOUNT' | 'GROSS_SALES_DIFF' | 'NET_SALES_DIFF' | 'TOTAL_SALES_DIFF' | 'ORDERS_RECONCILIATION_STATUS' | 'UDF_DIFF' | 'UDF_ON_HOLD_DIFF' | 'LOANS_OUTSTANDING_AMOUNT_NEG' | 'CLEARING_ACCOUNT' | 'HOLDINGS_DIFF' | 'ACCOUNT_RECEIVABLE_DIFF' | 'CLEARING_ACCOUNT_INVOICES_DIFF' | 'CLEARING_ACCOUNT_INVOICE_PAYMENTS_DIFF' | 'UNCLEARED_INVOICES_BALANCE_DIFF' | 'PAYPAL_INVOICES_DIFF' | 'PROFIT_AND_LOSS_DIFF' | 'RETAINED_EARNINGS_BALANCE_DIFF' | 'STRIPE_INVOICES_DIFF' | 'LOANS_ACTION_REQUIRED_COUNT' | 'LOANS_OUTSTANDING_AMOUNT_DIFF' | 'LOANS_OUTSTANDING_AMOUNT_VS_FEES' | 'LOANS_OUTSTANDING_AMOUNT_ZERO_BEFORE_NEW_LOAN' | 'GIFTCARDS_DIFF' | 'CLEARING_ACCOUNT_BILL_PAYMENTS_DIFF' | 'ACCOUNT_PAYABLE_DIFF' | 'PLATFORM_PAYABLE_DIFF' | 'ACCRUED_INTEREST_DIFF' | 'LOAN_PAYABLE_DIFF' | 'SETTLE_TOTAL_DIFF' | 'SETTLE_NUMBER_DIFF' | 'SETTLE_LOAN_PAYABLE_DIFF' | 'SETTLE_VENDOR_PAYABLE_DIFF' | 'BILL_COM_TOTAL_DIFF' | 'BILL_COM_NUMBER_DIFF' | 'BILL_COM_VENDOR_PAYABLE_DIFF' | 'AR_UNMATCHED_RATE' | 'AR_DIFF' | 'MONEY_IN_TRANSIT_DIFF' | 'AR_POTENTIAL_UNMATCHED_RATE' | 'GENERAL_CLEARING_ACCOUNT' | 'INVENTORY_CLEARING_ACCOUNT' | 'LOANS_CLEARING_ACCOUNT' | 'ORDERS_CLEARING_ACCOUNT' | 'PAYROLL_CLEARING_ACCOUNT' | 'PAYMENTS_CLEARING_ACCOUNT' | 'TOTAL_BANK_ACCOUNTS' | 'BANK_ACCOUNT_ISSUE' | 'AR_CASH_DIFF' | 'MONEY_IN_OUT_DIFF' | 'DEFERRED_REVENUE_DIFF' | 'INVENTORY_FULFILLMENTS_AFTER_LOCK'

export type CompanyValidationStatus = 'PASS' | 'FAIL' | 'NA'

export type CompanyValidationType = 'INVENTORY_BIG' | 'INVENTORY_VENDORS' | 'INVENTORY_FIFO' | 'INVENTORY_NO_UNIT' | 'AMAZON_PRODUCTS' | 'AMAZON_INVENTORY_LEDGER' | 'SHOPIFY_PRODUCTS' | 'ORDERS_RECONCILIATION' | 'DEFERRED_REVENUE' | 'ACCRUALS_ALL_ENTITIES' | 'INVENTORY_PURCHASES' | 'STRIPE_UDF' | 'LOANS_OUTSTANDING_AMOUNT' | 'EQUITY_ACCOUNTS' | 'EQUITY_ENTITIES' | 'EQUITY_CLEARING_ACCOUNT' | 'EQUITY_HOLDINGS' | 'EQUITY_HOLDERS' | 'KLARNA_UDF' | 'INVOICES' | 'CLEARING_ACCOUNT' | 'COMPANY_AFFILIATES_CLEARING_ACCOUNT' | 'LOANS_ACTION_REQUIRED' | 'LOANS_AUTOMATION' | 'SHOPIFY_GIFTCARDS' | 'BANKS_BALANCE' | 'BILLS' | 'SETTLE' | 'BILL_COM' | 'AR' | 'MONEY_IN_TRANSIT' | 'AR_CASH' | 'MONEY_IN_OUT' | 'PHYSICAL_COUNT' | 'TIK_TOK_UDF'

export interface CompanyWorksheet {
    worksheetRows: CompanyWorksheetRow[]
    company: Company
    __typename: 'CompanyWorksheet'
}

export interface CompanyWorksheetRow {
    companyId: Scalars['String']
    dateForLocking?: Scalars['Date']
    name: Scalars['String']
    amount?: Scalars['Float']
    comment?: Scalars['String']
    signedAt?: Scalars['Date']
    signedBy?: Scalars['String']
    signedByName?: Scalars['String']
    attachmentUrl?: Scalars['String']
    attachmentFileName?: Scalars['String']
    lockableEntity?: CompanyWorksheetRowLockableEntity
    periodStart: Scalars['Date']
    periodEnd: Scalars['Date']
    __typename: 'CompanyWorksheetRow'
}

export type CompanyWorksheetRowLockableEntity = (BankAccount) & { __isUnion?: true }

export interface ConfirmApBalanceTask {
    id: BillsYearEndTaskId
    status: BillsYearEndTaskStatus
    accountBalances: APAccountBalance[]
    stateKey: Scalars['String']
    state: ConfirmApBalanceTaskState
    history?: (ConfirmApBalanceTaskStateChangeLog | undefined)[]
    __typename: 'ConfirmApBalanceTask'
}

export interface ConfirmApBalanceTaskState {
    confirmedBalances?: APAccountBalance[]
    __typename: 'ConfirmApBalanceTaskState'
}

export interface ConfirmApBalanceTaskStateChangeLog {
    id: Scalars['ID']
    createdAt: Scalars['Date']
    updaterType: YearEndStateUpdaterType
    changedByUid?: Scalars['String']
    reason?: Scalars['String']
    oldValue?: ConfirmApBalanceTaskState
    newValue?: ConfirmApBalanceTaskState
    __typename: 'ConfirmApBalanceTaskStateChangeLog'
}

export interface ConfirmArBalanceTask {
    id: InvoicesYearEndTaskId
    status: InvoicesYearEndTaskStatus
    stateKey: Scalars['String']
    accountBalances: AccountBalance[]
    state: ConfirmArBalanceTaskState
    history?: (ConfirmArBalanceTaskStateChangeLog | undefined)[]
    __typename: 'ConfirmArBalanceTask'
}

export interface ConfirmArBalanceTaskState {
    confirmedBalances?: AccountBalance[]
    __typename: 'ConfirmArBalanceTaskState'
}

export interface ConfirmArBalanceTaskStateChangeLog {
    id: Scalars['ID']
    createdAt: Scalars['Date']
    updaterType: YearEndStateUpdaterType
    changedByUid?: Scalars['String']
    reason?: Scalars['String']
    oldValue?: ConfirmArBalanceTaskState
    newValue?: ConfirmArBalanceTaskState
    __typename: 'ConfirmArBalanceTaskStateChangeLog'
}

export interface Contractor {
    id: Scalars['ID']
    company: Company
    source: Scalars['String']
    department?: Department
    firstName: Scalars['String']
    lastName?: Scalars['String']
    middleName?: Scalars['String']
    name: Scalars['String']
    businessName?: Scalars['String']
    isActive: Scalars['Boolean']
    deletedAt?: Scalars['Date']
    __typename: 'Contractor'
}

export interface ContractorPayment {
    id: Scalars['String']
    company: Company
    source: Scalars['String']
    integrationAccountId?: Scalars['String']
    integrationAccountName?: Scalars['String']
    reimbursements: Reimbursement[]
    externalSourceId?: Scalars['String']
    department?: Department
    postedAt: Scalars['Date']
    currency: Scalars['String']
    wage: Scalars['Float']
    wageInHomeCurrency: Scalars['Float']
    bonus: Scalars['Float']
    bonusInHomeCurrency: Scalars['Float']
    categoryGroup: PayrollCategory
    paymentChecksAmount?: Scalars['Float']
    isPaymentChecksAmountImmaterial?: Scalars['Boolean']
    deletedAt?: Scalars['Date']
    __typename: 'ContractorPayment'
}

export interface ContractorPaymentIdsByCompanyItem {
    companyId: Scalars['String']
    contractorPaymentIds: Scalars['ID'][]
    __typename: 'ContractorPaymentIdsByCompanyItem'
}

export interface ContractorPaymentIdsByCompanyResponse {
    items: ContractorPaymentIdsByCompanyItem[]
    __typename: 'ContractorPaymentIdsByCompanyResponse'
}

export interface ContractorPaymentsInternalResponse {
    contractorPayments: ContractorPayment[]
    __typename: 'ContractorPaymentsInternalResponse'
}

export interface ConvertBetweenCurrenciesResult {
    convertedAmount: Scalars['Float']
    __typename: 'ConvertBetweenCurrenciesResult'
}

export type CostType = 'LandedCost' | 'Indirect' | 'Direct'

export interface CreateCheckoutSessionResponse {
    url: Scalars['String']
    __typename: 'CreateCheckoutSessionResponse'
}

export interface CreateCustomerCategorizationRuleResult {
    realTimeApplierJobId: Scalars['String']
    bankTransactionIdsAffectedByJobId: Scalars['ID'][]
    __typename: 'CreateCustomerCategorizationRuleResult'
}

export interface CreateGlobalRuleResult {
    id?: Scalars['ID']
    success: Scalars['Boolean']
    __typename: 'CreateGlobalRuleResult'
}

export interface CreateInventoryVendorValidationResponse {
    validationId: Scalars['String']
    __typename: 'CreateInventoryVendorValidationResponse'
}

export interface CreateOrUpdateAccrualResult {
    bankTransaction: BankTransaction
    status: AccrualsStatus
    error?: Scalars['String']
    __typename: 'CreateOrUpdateAccrualResult'
}

export interface CreateProductManuallyError {
    message: Scalars['String']
    __typename: 'CreateProductManuallyError'
}

export type CreateProductManuallyResponse = (CreateProductManuallyError | CreateProductManuallySuccess) & { __isUnion?: true }

export interface CreateProductManuallySuccess {
    product: Product
    __typename: 'CreateProductManuallySuccess'
}

export interface CreateTeamCategorizationRuleResult {
    realTimeApplierJobId: Scalars['String']
    bankTransactionIdsAffectedByJobId: Scalars['ID'][]
    __typename: 'CreateTeamCategorizationRuleResult'
}

export interface CreateUserResponse {
    user: User
    __typename: 'CreateUserResponse'
}

export interface CSVUpload {
    name: Scalars['String']
    uploadId: Scalars['String']
    __typename: 'CSVUpload'
}

export type CurrencyCode = 'AED' | 'AFN' | 'ALL' | 'AMD' | 'ANG' | 'AOA' | 'ARS' | 'AUD' | 'AWG' | 'AZN' | 'BAM' | 'BBD' | 'BDT' | 'BGN' | 'BHD' | 'BIF' | 'BMD' | 'BND' | 'BOB' | 'BRL' | 'BSD' | 'BTN' | 'BWP' | 'BYN' | 'BZD' | 'CAD' | 'CDF' | 'CHF' | 'CLP' | 'CNY' | 'COP' | 'CRC' | 'CUC' | 'CUP' | 'CVE' | 'CZK' | 'DJF' | 'DKK' | 'DOP' | 'DZD' | 'EGP' | 'ERN' | 'ETB' | 'EUR' | 'FJD' | 'FKP' | 'GBP' | 'GEL' | 'GHS' | 'GIP' | 'GMD' | 'GNF' | 'GTQ' | 'GYD' | 'HKD' | 'HNL' | 'HRK' | 'HTG' | 'HUF' | 'IDR' | 'ILS' | 'INR' | 'IQD' | 'IRR' | 'ISK' | 'JMD' | 'JOD' | 'JPY' | 'KES' | 'KGS' | 'KHR' | 'KMF' | 'KPW' | 'KRW' | 'KWD' | 'KYD' | 'KZT' | 'LAK' | 'LBP' | 'LKR' | 'LRD' | 'LSL' | 'LYD' | 'MAD' | 'MDL' | 'MGA' | 'MKD' | 'MMK' | 'MNT' | 'MOP' | 'MRU' | 'MUR' | 'MVR' | 'MWK' | 'MXN' | 'MYR' | 'MZN' | 'NAD' | 'NGN' | 'NIO' | 'NOK' | 'NPR' | 'NZD' | 'OMR' | 'PAB' | 'PEN' | 'PGK' | 'PHP' | 'PKR' | 'PLN' | 'PYG' | 'QAR' | 'RON' | 'RSD' | 'RUB' | 'RWF' | 'SAR' | 'SBD' | 'SCR' | 'SDG' | 'SEK' | 'SGD' | 'SHP' | 'SLL' | 'SOS' | 'SRD' | 'SSP' | 'STN' | 'SVC' | 'SYP' | 'SZL' | 'THB' | 'TJS' | 'TMT' | 'TND' | 'TOP' | 'TRY' | 'TTD' | 'TWD' | 'TZS' | 'UAH' | 'UGX' | 'USD' | 'UYU' | 'UZS' | 'VES' | 'VND' | 'VUV' | 'WST' | 'XAF' | 'XCD' | 'XOF' | 'XPF' | 'YER' | 'ZAR' | 'ZMW' | 'ZWL'

export interface CurrentlyRunningInventoryDataSyncResponse {
    totalItems: Scalars['Int']
    completedItems: Scalars['Int']
    updatingProducts: Product[]
    __typename: 'CurrentlyRunningInventoryDataSyncResponse'
}

export interface CurrentlyRunningInventoryDataSyncVendorsResponse {
    affiliatedEntities: AffiliatedEntity[]
    __typename: 'CurrentlyRunningInventoryDataSyncVendorsResponse'
}

export interface CurrentPreviousValue {
    current: Scalars['Float']
    previous: Scalars['Float']
    unitType: UnitType
    __typename: 'CurrentPreviousValue'
}

export interface Customer {
    id: Scalars['ID']
    name: Scalars['String']
    companyId: Scalars['ID']
    companyName?: Scalars['String']
    externalSourceId?: Scalars['String']
    source: CustomerSource
    email?: Scalars['String']
    phoneNumber?: Scalars['String']
    billingAddress?: CustomerAddressOld
    shippingAddress?: CustomerAddressOld
    __typename: 'Customer'
}

export interface CustomerAddress {
    id?: Scalars['ID']
    country?: Scalars['String']
    countryCode?: Scalars['String']
    state?: Scalars['String']
    stateCode?: Scalars['String']
    province?: Scalars['String']
    provinceCode?: Scalars['String']
    city?: Scalars['String']
    zip?: Scalars['String']
    line1?: Scalars['String']
    line2?: Scalars['String']
    isShipping?: Scalars['Boolean']
    isBilling?: Scalars['Boolean']
    __typename: 'CustomerAddress'
}

export interface CustomerAddressOld {
    country?: Scalars['String']
    state?: Scalars['String']
    city?: Scalars['String']
    postalCode?: Scalars['String']
    line1?: Scalars['String']
    line2?: Scalars['String']
    __typename: 'CustomerAddressOld'
}

export interface CustomerAddressV3 {
    id: Scalars['ID']
    phoneNumber?: Scalars['String']
    country?: Scalars['String']
    countryCode?: Scalars['String']
    state?: Scalars['String']
    stateCode?: Scalars['String']
    province?: Scalars['String']
    provinceCode?: Scalars['String']
    city?: Scalars['String']
    zip?: Scalars['String']
    line1?: Scalars['String']
    line2?: Scalars['String']
    isShipping?: Scalars['Boolean']
    isBilling?: Scalars['Boolean']
    deletedAt?: Scalars['Date']
    __typename: 'CustomerAddressV3'
}

export interface CustomerNotExistError {
    message: Scalars['String']
    id: Scalars['ID']
    __typename: 'CustomerNotExistError'
}

export type CustomerSelectedAccountingMethod = 'ACCRUAL' | 'CASH' | 'MODIFIED_CASH'

export type CustomerSource = 'BILL_COM' | 'PAYPAL' | 'STRIPE' | 'FINALOOP_INVOICES' | 'QUICKBOOKS' | 'SPS_COMMERCE' | 'QUICKBOOKS_INVOICES' | 'NU_ORDER_INVOICES'

export interface CustomerV2 {
    id: Scalars['ID']
    affiliatedEntityId?: Scalars['ID']
    companyId: Scalars['String']
    source: Scalars['String']
    name: Scalars['String']
    email?: Scalars['String']
    billingAddress?: CustomerAddress
    shippingAddress?: CustomerAddress
    addresses?: CustomerAddress[]
    __typename: 'CustomerV2'
}

export interface CustomerV3 {
    id: Scalars['ID']
    company?: Company
    name?: Scalars['String']
    email?: Scalars['String']
    integrationType?: Scalars['String']
    integrationAccountId?: Scalars['String']
    addresses?: (CustomerAddressV3 | undefined)[]
    __typename: 'CustomerV3'
}

export interface CustomFixedAssetsData {
    usefulLifeStartDate: Scalars['Date']
    depreciationMethod?: DepreciationMethod
    residualValue?: Scalars['Float']
    section179Deduction?: Section179Deduction
    addDepreciationBonus?: AddDepreciationBonus
    startDate: Scalars['Date']
    endDate: Scalars['Date']
    amount: Scalars['Float']
    spreadBasisType: SpreadBasisType
    canceledAmount?: Scalars['Float']
    __typename: 'CustomFixedAssetsData'
}

export interface CustomSpread {
    specificDate?: SpecificDate
    spreadOverTime?: CustomSpreadOverTime
    __typename: 'CustomSpread'
}

export interface CustomSpreadOptions {
    spreadBasisType: SpreadBasisType
    residualAmount: Scalars['Float']
    __typename: 'CustomSpreadOptions'
}

export interface CustomSpreadOverTime {
    fromDate: Scalars['Date']
    toDate: Scalars['Date']
    amount: Scalars['Float']
    __typename: 'CustomSpreadOverTime'
}

export interface DailyAggregatedOwnersDraw {
    employeeId: Scalars['ID']
    employeeName: Scalars['String']
    amount: Scalars['Float']
    __typename: 'DailyAggregatedOwnersDraw'
}

export interface DailyAggregatedPaymentCheck {
    id: Scalars['ID']
    amount: Scalars['Float']
    postedAt: Scalars['Date']
    employeeId?: Scalars['ID']
    employmentType: PayrollEmploymentType
    categoryGroup: PayrollCategory
    isImmaterial: Scalars['Boolean']
    __typename: 'DailyAggregatedPaymentCheck'
}

export interface DailyAggregatedPayrollData {
    date: Scalars['Date']
    salariesAndWages: Scalars['Float']
    bonus: Scalars['Float']
    commission: Scalars['Float']
    correctionPayment: Scalars['Float']
    tips: Scalars['Float']
    holidayPay: Scalars['Float']
    sickLeave: Scalars['Float']
    severance: Scalars['Float']
    ownersDraw: Scalars['Float']
    vacationPay: Scalars['Float']
    ficaEmployee: Scalars['Float']
    ficaEmployer: Scalars['Float']
    federalEmployee: Scalars['Float']
    federalEmployer: Scalars['Float']
    stateAndLocalEmployee: Scalars['Float']
    stateAndLocalEmployer: Scalars['Float']
    savingsAndRetirement401kEmployee: Scalars['Float']
    savingsAndRetirement401kEmployer: Scalars['Float']
    savingsAndRetirementOtherEmployee: Scalars['Float']
    savingsAndRetirementOtherEmployer: Scalars['Float']
    healthEmployee: Scalars['Float']
    healthEmployer: Scalars['Float']
    transportationEmployee: Scalars['Float']
    transportationEmployer: Scalars['Float']
    otherBenefitsEmployee: Scalars['Float']
    otherBenefitsEmployer: Scalars['Float']
    childSupport: Scalars['Float']
    otherGarnishments: Scalars['Float']
    otherDeductions: Scalars['Float']
    grossPay: Scalars['Float']
    netPay: Scalars['Float']
    employerCost: Scalars['Float']
    employmentType: PayrollEmploymentType
    categoryGroup: PayrollCategory
    __typename: 'DailyAggregatedPayrollData'
}

export interface DailyAggregatedReimbursement {
    id: Scalars['ID']
    amount: Scalars['Float']
    postedAt: Scalars['Date']
    employeeId?: Scalars['ID']
    isClearedByNetPayPayment?: Scalars['Boolean']
    paymentMethod: Scalars['String']
    employmentType: PayrollEmploymentType
    categoryGroup: PayrollCategory
    __typename: 'DailyAggregatedReimbursement'
}

export interface DailyPaymentsByContractor {
    contractor: Contractor
    payments: Scalars['Float']
    reimbursements: Scalars['Float']
    __typename: 'DailyPaymentsByContractor'
}

export interface DailyPaymentsByEmployee {
    employee: Employee
    netPay: Scalars['Float']
    grossPay: Scalars['Float']
    employeeTaxes: Scalars['Float']
    deductionsAndBenefits: Scalars['Float']
    reimbursements: Scalars['Float']
    __typename: 'DailyPaymentsByEmployee'
}

export interface DataSerie {
    label: Scalars['String']
    values: Scalars['Float'][]
    unitGroup: Scalars['String']
    valueType?: ValueType
    previous?: Scalars['Boolean']
    __typename: 'DataSerie'
}

export interface DateRange {
    startTime: Scalars['Date']
    endTime: Scalars['Date']
    __typename: 'DateRange'
}

export interface DatesToFix {
    date: Scalars['Date']
    quantity: Scalars['Float']
    __typename: 'DatesToFix'
}

export interface DeadInventoryAction {
    quantity: Scalars['Float']
    id: Scalars['String']
    date: Scalars['Date']
    type: Scalars['String']
    __typename: 'DeadInventoryAction'
}

export interface DeadInventoryCogs {
    amount: Scalars['Float']
    quantity: Scalars['Float']
    monthlyBreakdown: DeadInventoryMonthlyBreakdown[]
    __typename: 'DeadInventoryCogs'
}

export interface DeadInventoryDailyBreakdown {
    date: Scalars['Date']
    quantity: Scalars['Float']
    reason?: AdjustmentsReason[]
    __typename: 'DeadInventoryDailyBreakdown'
}

export interface DeadInventoryMonthlyBreakdown {
    date: Scalars['Date']
    quantity: Scalars['Float']
    dailyData: DeadInventoryDailyBreakdown[]
    __typename: 'DeadInventoryMonthlyBreakdown'
}

export interface DeadInventoryOriginalValue {
    quantity?: Scalars['Int']
    __typename: 'DeadInventoryOriginalValue'
}

export interface DefaultFixedAssetsData {
    usefulLifeStartDate: Scalars['Date']
    startDate: Scalars['Date']
    endDate: Scalars['Date']
    amount: Scalars['Float']
    canceledAmount?: Scalars['Float']
    __typename: 'DefaultFixedAssetsData'
}

export interface DeleteInventoryPaymentGroupResponse {
    success: Scalars['Boolean']
    __typename: 'DeleteInventoryPaymentGroupResponse'
}

export interface DeleteInvoicesResponse {
    deleted: Scalars['ID'][]
    errors: Scalars['String'][]
    __typename: 'DeleteInvoicesResponse'
}

export interface DeleteLoansEventsEffectConfigurationResult {
    success?: Scalars['Boolean']
    __typename: 'DeleteLoansEventsEffectConfigurationResult'
}

export interface DeleteLoansResults {
    loans: Loan[]
    __typename: 'DeleteLoansResults'
}

export interface DeleteOrderGroupResponse {
    success: Scalars['Boolean']
    __typename: 'DeleteOrderGroupResponse'
}

export interface DeleteOrderGroupUponTransactionChangeResponse {
    success: Scalars['Boolean']
    __typename: 'DeleteOrderGroupUponTransactionChangeResponse'
}

export interface DeletePaymentGroupResponse {
    success: Scalars['Boolean']
    __typename: 'DeletePaymentGroupResponse'
}

export interface DeletePaymentGroupUponTransactionChangeResponse {
    success: Scalars['Boolean']
    __typename: 'DeletePaymentGroupUponTransactionChangeResponse'
}

export interface Department {
    id: Scalars['ID']
    company: Company
    source: Scalars['String']
    name: Scalars['String']
    __typename: 'Department'
}

export type Dependency = (BalanceSheetDependency | YearEndDependency) & { __isUnion?: true }

export type DepreciationMethod = 'STRAIGHT_LINE' | 'DECLINING_BALANCE'

export interface DirectLineItem {
    id: Scalars['ID']
    product: Product
    quantity: Scalars['Float']
    vendor: Vendor
    indirectCostsAllocation: IndirectCostAllocation[]
    directCostPerUnit: Scalars['Float']
    indirectCostPerUnit: Scalars['Float']
    remainderIndirectCostPerUnit?: Scalars['Float']
    discountCostPerUnit: Scalars['Float']
    remainderDiscountCostPerUnit?: Scalars['Float']
    landedCostPerUnit: Scalars['Float']
    remainderLandedCostPerUnit?: Scalars['Float']
    directCostTotal: Scalars['Float']
    indirectCostTotal: Scalars['Float']
    landedCostTotal: Scalars['Float']
    discountCostTotal: Scalars['Float']
    note?: Scalars['String']
    __typename: 'DirectLineItem'
}

export interface Discount {
    id: Scalars['ID']
    type: DiscountType
    amount: Scalars['Float']
    description?: Scalars['String']
    totalAmount?: Scalars['Float']
    discountType: LineItemDiscountType
    __typename: 'Discount'
}

export interface DiscountLineItemV3 {
    id: Scalars['ID']
    /** The ID of the line item in the external system */
    externalLineItemId: Scalars['String']
    /** The name of the line item */
    name?: Scalars['String']
    /** The description of the line item */
    description: Scalars['String']
    /** The amount of the line item */
    amount: Amounts
    parentId?: Scalars['String']
    /** The type of the line item */
    parentLineItemType?: ParentLineItemType
    /** The earliest date and time the line item was posted */
    earliestPostedAt: Scalars['Date']
    /** The latest date and time the line item was posted */
    latestPostedAt: Scalars['Date']
    /** The type of the line item */
    type: OrderLineItemTypeV3
    /** The type of the discount */
    discountType: OrderLineItemDiscountType
    __typename: 'DiscountLineItemV3'
}

export type DiscountType = 'PERCENTAGE' | 'FIXED_AMOUNT'

export interface Dispute {
    companyId: Scalars['ID']
    id: Scalars['ID']
    source: IntegrationType
    integrationAccountId: Scalars['ID']
    integrationAccountName?: Scalars['String']
    disputedAmount: Scalars['Float']
    disputedCurrency: Scalars['String']
    openedAt: Scalars['Date']
    closedAt?: Scalars['Date']
    reviewStartedAt?: Scalars['Date']
    refundAmount?: Scalars['Float']
    refundCurrency?: Scalars['String']
    outcome?: DisputeOutcome
    __typename: 'Dispute'
}

export type DisputeOutcome = 'RESOLVED' | 'REFUNDED' | 'CHARGEBACK'

export interface DonationCogs {
    amount: Scalars['Float']
    quantity: Scalars['Int']
    monthlyBreakdown: DonationMonthlyBreakdown[]
    __typename: 'DonationCogs'
}

export interface DonationDailyBreakdown {
    date: Scalars['Date']
    quantity: Scalars['Int']
    reason?: AdjustmentsReason[]
    __typename: 'DonationDailyBreakdown'
}

export interface DonationMonthlyBreakdown {
    date: Scalars['Date']
    quantity: Scalars['Int']
    dailyData: DonationDailyBreakdown[]
    __typename: 'DonationMonthlyBreakdown'
}

export interface DonationOriginalValue {
    quantity?: Scalars['Int']
    __typename: 'DonationOriginalValue'
}

export interface DownloadAttachmentResult {
    fileName: Scalars['String']
    url: Scalars['String']
    __typename: 'DownloadAttachmentResult'
}

export type DropshippingModeType = 'INCIDENTAL' | 'NON_INCIDENTAL'

export interface DropshippingSettings {
    id: Scalars['String']
    companyId: Scalars['String']
    isEnabled: Scalars['Boolean']
    mode?: DropshippingModeType
    affiliatedEntities: AffiliatedEntity[]
    __typename: 'DropshippingSettings'
}

export interface DueDateSummary {
    count: Scalars['Int']
    sum: Scalars['Float']
    __typename: 'DueDateSummary'
}

export type DuplicateCheckResult = 'DUPLICATE' | 'NOT_DUPLICATE'

export interface EarlyRepaymentDiscount {
    period?: Scalars['Int']
    fee?: Scalars['Float']
    periodType?: EarlyRepaymentDiscountPeriodType
    __typename: 'EarlyRepaymentDiscount'
}

export type EarlyRepaymentDiscountPeriodType = 'MONTH' | 'DAY' | 'PAYMENT'

export interface Employee {
    id: Scalars['ID']
    company: Company
    source: Scalars['String']
    department?: Department
    firstName: Scalars['String']
    lastName?: Scalars['String']
    middleName?: Scalars['String']
    name: Scalars['String']
    isOfficer: Scalars['Boolean']
    isTerminated: Scalars['Boolean']
    jobs: Scalars['String'][]
    __typename: 'Employee'
}

export interface EntityLockedPeriodBypass {
    companyId: Scalars['ID']
    entityType: Scalars['String']
    entityId: Scalars['ID']
    isBypassed: Scalars['Boolean']
    __typename: 'EntityLockedPeriodBypass'
}

export interface EquityEventsEffectConfiguration {
    id: Scalars['ID']
    legalEntityType: Scalars['String']
    taxEntityType: Scalars['String']
    shareType?: EquityEventShareType
    memoTemplate?: Scalars['String']
    dateTemplate?: Scalars['String']
    businessEventActionsConfiguration: BusinessEventActionsConfiguration
    latestActorType: ActorType
    latestActorId: Scalars['String']
    createdAt: Scalars['Date']
    updatedAt: Scalars['Date']
    __typename: 'EquityEventsEffectConfiguration'
}

export type EquityEventShareType = 'COMMON_STOCK' | 'PREFERRED' | 'SAFE'

export type Error = (CustomerNotExistError | VendorNotExistError) & { __isUnion?: true }

export type EstimatedProjectedRevenue = 'ZERO_TO_TWO_HUNDRED_THOUSAND' | 'ZERO_TO_HALF_A_MILLION' | 'TWO_HUNDRED_THOUSAND_TO_FIVE_HUNDRED_THOUSAND' | 'TWO_HUNDRED_THOUSAND_TO_ONE_MILLION' | 'FIVE_HUNDRED_THOUSAND_TO_THREE_MILLION' | 'HALF_A_MILLION_TO_ONE_AND_A_HALF_MILLION' | 'ONE_MILLION_TO_FIVE_MILLION' | 'ONE_AND_A_HALF_TO_TEN_MILLION' | 'THREE_MILLION_TO_TEN_MILLION' | 'FIVE_MILLION_TO_TEN_MILLION' | 'TEN_TO_FIFTY_MILLION' | 'ABOVE_TEN_MILLION' | 'ABOVE_FIFTY_MILLION'

export interface EvaluateBankReconciliationRequestsResponse {
    explains: Scalars['String'][]
    __typename: 'EvaluateBankReconciliationRequestsResponse'
}

export interface EventsLock {
    minimumAllowedEventTime?: Scalars['Date']
    lockHistory?: CompanyEventsLockHistory[]
    __typename: 'EventsLock'
}

export interface ExcludedSalesChannelItemReconciliation {
    sku: Scalars['String']
    isBlacklisted: Scalars['Boolean']
    shopifySalesChannel: Scalars['String']
    summary: ReconciliationSummary
    __typename: 'ExcludedSalesChannelItemReconciliation'
}

export interface ExplainBankAccountMergeDuplicate {
    id: Scalars['ID']
    name: Scalars['String']
    status: BankAccountStatus
    createdAt?: Scalars['Date']
    transactionsImportStatus?: ExplainBankAccountMergeTransactionsImportStatus
    __typename: 'ExplainBankAccountMergeDuplicate'
}

export interface ExplainBankAccountMergeExplain {
    primary: Scalars['ID']
    companyId: Scalars['ID']
    duplicates: ExplainBankAccountMergeDuplicate[]
    notes: ExplainBankAccountMergeNote[]
    __typename: 'ExplainBankAccountMergeExplain'
}

export interface ExplainBankAccountMergeNote {
    error: Scalars['String']
    resolution: Scalars['String']
    __typename: 'ExplainBankAccountMergeNote'
}

export interface ExplainBankAccountMergeResponse {
    explains: ExplainBankAccountMergeExplain[]
    __typename: 'ExplainBankAccountMergeResponse'
}

export interface ExplainBankAccountMergeTransactionsImportStatus {
    stopImportFromDate?: Scalars['Date']
    changedBy?: Scalars['String']
    __typename: 'ExplainBankAccountMergeTransactionsImportStatus'
}

export interface ExplainFifoResult {
    warehouseMovements: WarehouseMovements[]
    __typename: 'ExplainFifoResult'
}

export interface ExportAccrualsListCsvResponse {
    url: Scalars['String']
    __typename: 'ExportAccrualsListCsvResponse'
}

export interface ExportCOGSBreakdownResponse {
    url: Scalars['String']
    __typename: 'ExportCOGSBreakdownResponse'
}

export interface ExportCOGSOverviewResponse {
    url: Scalars['String']
    __typename: 'ExportCOGSOverviewResponse'
}

export interface ExportCSVResponse {
    url: Scalars['String']
    __typename: 'ExportCSVResponse'
}

export type ExportedReportsLogsSortBy = 'createdAt' | 'email'

export interface ExportGeneralLedgerResponse {
    jobId: Scalars['ID']
    __typename: 'ExportGeneralLedgerResponse'
}

export interface ExportInvoicesResponse {
    url: Scalars['String']
    __typename: 'ExportInvoicesResponse'
}

export interface ExportLoansResult {
    url: Scalars['String']
    fileName: Scalars['String']
    __typename: 'ExportLoansResult'
}

export interface ExportProductsResponse {
    url: Scalars['String']
    __typename: 'ExportProductsResponse'
}

export interface ExportPurchaseOrdersResponse {
    url: Scalars['String']
    __typename: 'ExportPurchaseOrdersResponse'
}

export interface ExportResponse {
    signedUrl: Scalars['String']
    __typename: 'ExportResponse'
}

export interface ExportSkuAnalysisResponse {
    url: Scalars['String']
    __typename: 'ExportSkuAnalysisResponse'
}

export type ExportStatus = 'STARTING' | 'IN_PROGRESS' | 'FAILURE' | 'SUCCESS' | 'PARTIAL_SUCCESS' | 'ERROR'

export interface ExtensionFiled {
    value: Scalars['Boolean']
    updatedAt?: Scalars['Date']
    updatedBy?: Scalars['String']
    __typename: 'ExtensionFiled'
}

export interface FailingValidation {
    companyId: Scalars['String']
    validationId: Scalars['String']
    integrationAccountId?: Scalars['String']
    validationDataLocation?: Scalars['String']
    __typename: 'FailingValidation'
}

export type Feature = 'CATCHUP' | 'SUBSCRIPTION'

export interface FeeLineItemV3 {
    id: Scalars['ID']
    /** The ID of the line item in the external system */
    externalLineItemId: Scalars['String']
    /** The name of the line item */
    name?: Scalars['String']
    /** The description of the line item */
    description: Scalars['String']
    /** The amount of the line item */
    amount: Amounts
    parentId?: Scalars['String']
    /** The type of the line item */
    parentLineItemType?: ParentLineItemType
    /** The earliest date and time the line item was posted */
    earliestPostedAt: Scalars['Date']
    /** The latest date and time the line item was posted */
    latestPostedAt: Scalars['Date']
    /** The type of the line item */
    type: OrderLineItemTypeV3
    /** The type of the fee */
    feeType: Scalars['String']
    /** The ID of the fee in the external system */
    externalName: Scalars['String']
    __typename: 'FeeLineItemV3'
}

export interface FifoCogsBusinessEventsMetrics {
    type: Scalars['String']
    integrationAccountName?: Scalars['String']
    integrationType?: Scalars['String']
    metrics: FifoCogsBusinessEventsSingleMetric[]
    __typename: 'FifoCogsBusinessEventsMetrics'
}

export interface FifoCogsBusinessEventsSingleMetric {
    name: Scalars['String']
    fifo: Scalars['Float']
    isValid: Scalars['Boolean']
    be: Scalars['Float']
    __typename: 'FifoCogsBusinessEventsSingleMetric'
}

export interface FifoValidationCogsSummary {
    name: Scalars['String']
    fifoCogs?: Scalars['Float']
    isValidCost: Scalars['Boolean']
    __typename: 'FifoValidationCogsSummary'
}

export interface FifoValidationProductData {
    product: Product
    warehouse: Warehouse
    baseMetrics: FifoValidationSummary[]
    cogsMetrics: FifoValidationCogsSummary[]
    __typename: 'FifoValidationProductData'
}

export interface FifoValidationProductTotals {
    baseMetrics: FifoValidationSummary[]
    cogsMetrics: FifoValidationCogsSummary[]
    __typename: 'FifoValidationProductTotals'
}

export interface FifoValidationProductValidationData {
    data: FifoValidationProductData[]
    totals: FifoValidationProductTotals
    totalBalance: FifoValidationTotalsBalance
    fifoCogsBusinessEventsMetrics: FifoCogsBusinessEventsMetrics[]
    fifoCogsBusinessEventsMetricsTotal: FifoCogsBusinessEventsSingleMetric[]
    notPropagatedBEIds?: Scalars['String'][]
    redundantBEIds?: Scalars['String'][]
    secondaryProductRedundantOverviews?: Scalars['String'][]
    isUnitsValid: Scalars['Boolean']
    isCogsValid: Scalars['Boolean']
    isBusinessEventsValid: Scalars['Boolean']
    fulfillmentsAfterLock: Scalars['Float']
    __typename: 'FifoValidationProductValidationData'
}

export interface FifoValidationSummary {
    name: Scalars['String']
    source?: Scalars['Float']
    sourceCost?: Scalars['Float']
    fifo: Scalars['Float']
    fifoCost: Scalars['Float']
    fifoCogs: Scalars['Float']
    isValidQuantity: Scalars['Boolean']
    isValidCost: Scalars['Boolean']
    isValidCogs: Scalars['Boolean']
    __typename: 'FifoValidationSummary'
}

export interface FifoValidationTotalsBalance {
    totalIncomingFromSource: Scalars['Float']
    totalOnHandFromFifo: Scalars['Float']
    totalCogs: Scalars['Float']
    totalWaste: Scalars['Float']
    isValid: Scalars['Boolean']
    __typename: 'FifoValidationTotalsBalance'
}

export interface FileLocation {
    name: Scalars['String']
    key: Scalars['String']
    bankTransactionsUploadId?: Scalars['String']
    __typename: 'FileLocation'
}

export type FileType = 'EXCEL'

export type FileUploadSource = 'BANK_TRANSACTIONS_ATTACHMENT' | 'TAX_1099' | 'INVENTORY' | 'VALIDATION_DATA' | 'WORKSHEET' | 'LOANS' | 'ORDERS' | 'GIFT_CARDS' | 'YEAR_END' | 'REPORTS' | 'BALANCE_SHEET_HUB' | 'INVOICES'

export interface FileUploadUrlResult {
    uploadUrl: Scalars['String']
    url: Scalars['String']
    fileName: Scalars['String']
    key: Scalars['String']
    bucket: Scalars['String']
    __typename: 'FileUploadUrlResult'
}

export interface FilingDeadline {
    value: Scalars['Date']
    extensionFiled?: ExtensionFiled
    __typename: 'FilingDeadline'
}

export type FilterableBankStatementRequestTypes = 'OPENING' | 'CLOSING' | 'ONGOING' | 'RECURRING_CSV' | 'BULK_PDF' | 'MISSING_TXNS' | 'ONE_TIME_RECONCILIATION' | 'HISTORICAL_GAP' | 'ACCESS_REMOVED'

export interface FilteringBoundsOrderV3Result {
    maxNetOrderInHomeCurrency?: Scalars['Float']
    maxItemsCount?: Scalars['Int']
    stores: StoreV3[]
    /** @deprecated Use maxNetOrderInHomeCurrency instead */
    orderTotalP999?: Scalars['Float']
    /** @deprecated no longer used */
    integrations: Scalars['String'][]
    __typename: 'FilteringBoundsOrderV3Result'
}

export type FilterOperator = 'IN' | 'NOTIN'

export interface FinalizeAskTheUserFlowResult {
    success: Scalars['Boolean']
    __typename: 'FinalizeAskTheUserFlowResult'
}

export interface FinaloopProduct {
    id: Scalars['ID']
    __typename: 'FinaloopProduct'
}

export type FinancedPaymentInstallmentStatus = 'pending_approval' | 'scheduled' | 'initiated' | 'completed' | 'failed' | 'canceled' | 'refunded'

export type FinancialReportingStatus = 'COGS_ONLY' | 'SALES_ONLY' | 'COGS_AND_SALES' | 'EXCLUDED' | 'GIVEAWAY'

export type FinancialReportingStatusSource = 'SALES_CHANNEL_CONFIGURATION' | 'MARKED_BY_USER'

export interface FiscalYearEndStateResponse {
    year: Scalars['Int']
    state: YearEndState
    isUnderReview: Scalars['Boolean']
    isLegacy: Scalars['Boolean']
    updatedAt: Scalars['Date']
    updatedBy?: Scalars['String']
    filingDeadline: FilingDeadline
    userUnresponsive?: YearEndUserUnresponsive
    __typename: 'FiscalYearEndStateResponse'
}

export interface FixedAssetsOptions {
    startDate: Scalars['Date']
    __typename: 'FixedAssetsOptions'
}

export interface FulfillmentAction {
    quantity: Scalars['Float']
    id: Scalars['String']
    date: Scalars['Date']
    type: Scalars['String']
    salesChannel: WarehouseActionSalesChannel
    sku?: Scalars['String']
    __typename: 'FulfillmentAction'
}

export type FulfillmentChannel = 'SELLER' | 'PLATFORM'

export interface FulfillmentCost {
    id: Scalars['ID']
    companyId: Scalars['ID']
    source: Scalars['String']
    externalSourceId?: Scalars['String']
    integrationAccountId?: Scalars['String']
    integrationAccountName?: Scalars['String']
    sale?: Sale
    order?: OrderV2
    type: FulfillmentCostType
    externalId?: Scalars['String']
    externalName?: Scalars['String']
    amount: Scalars['Float']
    currency: CurrencyCode
    amountInHomeCurrency: Scalars['Float']
    __typename: 'FulfillmentCost'
}

export type FulfillmentCostType = 'PICK_AND_PACK'

export interface FulfillmentMethod {
    startDate: Scalars['Date']
    endDate: Scalars['Date']
    type: FulfillmentMethodType
    __typename: 'FulfillmentMethod'
}

export type FulfillmentMethodType = 'AUTOMATIC' | 'INTEGRATION'

export interface FulfillmentSetting {
    companyId: Scalars['ID']
    integrationAccountId: Scalars['ID']
    methods: FulfillmentMethod[]
    __typename: 'FulfillmentSetting'
}

export type FulfillmentStatus = 'UNFULFILLED' | 'PARTIALLY_FULFILLED' | 'FULFILLED'

export interface FulfillmentsValidation {
    integrationData: QuantityAndCost
    adjustments: QuantityAndCost
    cogs: QuantityAndCost
    source: QuantityAndCost
    diff: QuantityAndCost
    isValid: Scalars['Boolean']
    integrationType: Scalars['String']
    integrationAccountName: Scalars['String']
    __typename: 'FulfillmentsValidation'
}

export interface GenerateBigValidationResponse {
    validationId: Scalars['String']
    __typename: 'GenerateBigValidationResponse'
}

export interface GenerateFifoValidationResponse {
    validationId: Scalars['String']
    __typename: 'GenerateFifoValidationResponse'
}

export interface GenerateNoUnitsValidationError {
    message: Scalars['String']
    __typename: 'GenerateNoUnitsValidationError'
}

export interface GenerateNoUnitsValidationResponse {
    validationId: Scalars['String']
    __typename: 'GenerateNoUnitsValidationResponse'
}

export interface GenerateNoUnitsValidationResult {
    id: Scalars['String']
    __typename: 'GenerateNoUnitsValidationResult'
}

export interface GeneratePdfError {
    message: Scalars['String']
    __typename: 'GeneratePdfError'
}

export interface GeneratePdfResponse {
    url: Scalars['String']
    __typename: 'GeneratePdfResponse'
}

export type GeneratePdfResponseV2 = (GeneratePdfResponse | GeneratePdfError) & { __isUnion?: true }

export interface GenericResponse {
    success: Scalars['Boolean']
    errorMessage?: Scalars['String']
    __typename: 'GenericResponse'
}

export interface GetAllCompaniesForDomainResponse {
    companyId: Scalars['ID']
    year?: Scalars['Int']
    state?: YearEndState
    domainState?: YearEndDomainStateResponse
    domainData?: (YearEndDomainStateDataResponse | undefined)[]
    __typename: 'GetAllCompaniesForDomainResponse'
}

export interface GetAllocatableEventIdsResult {
    ids: Scalars['ID'][]
    __typename: 'GetAllocatableEventIdsResult'
}

export interface GetBackOfficeBankStatementRequestsResponse {
    statementRequests: BankReconciliationRequest[]
    totalCount: Scalars['Int']
    offset: Scalars['Int']
    limit: Scalars['Int']
    __typename: 'GetBackOfficeBankStatementRequestsResponse'
}

export interface GetBalanceSheetSetupItemDocumentUrlReponse {
    downloadUrl: Scalars['String']
    __typename: 'GetBalanceSheetSetupItemDocumentUrlReponse'
}

export type GetBankStatementRequestsDirection = 'ASC' | 'DESC'

export type GetBankStatementRequestsSortType = 'COMPANY_NAME' | 'TIER' | 'STATUS' | 'LAST_UPDATED_AT' | 'COMPLETED_AT'

export interface GetBillsResponse {
    bills: Bill[]
    totalCount: Scalars['Int']
    __typename: 'GetBillsResponse'
}

export interface GetCOGSBreakdownResponse {
    from: Scalars['Date']
    to: Scalars['Date']
    type: CogsType
    items: COGSBreakdownItem[]
    totalCount: Scalars['Int']
    hasNext: Scalars['Boolean']
    __typename: 'GetCOGSBreakdownResponse'
}

export type GetCogsBreakdownSortField = 'SKU' | 'DISPLAY_NAME' | 'UNITS' | 'TOTAL_LANDED' | 'TOTAL_DIRECT' | 'TOTAL_VENDOR_FEES' | 'TOTAL_DUTIES_AND_TAX' | 'TOTAL_CUSTOM_FEES_AND_SERVICES' | 'TOTAL_INSURANCE' | 'TOTAL_PRODUCTION_COST' | 'TOTAL_DISCOUNT' | 'TOTAL_SHIPPING' | 'TOTAL_PALLET_COSTS' | 'TOTAL_SHIPPING_SURCHARGE' | 'TOTAL_OTHER_INVENTORY_ADJUSTMENTS' | 'TOTAL_PRODUCTION_LABOR_COST' | 'AVG_COST_PER_UNIT_LANDED' | 'AVG_COST_PER_UNIT_DIRECT' | 'AVG_COST_PER_UNIT_VENDOR_FEES' | 'AVG_COST_PER_UNIT_DUTIES_AND_TAX' | 'AVG_COST_PER_UNIT_CUSTOM_FEES_AND_SERVICES' | 'AVG_COST_PER_UNIT_INSURANCE' | 'AVG_COST_PER_UNIT_PRODUCTION_COST' | 'AVG_COST_PER_UNIT_DISCOUNT' | 'AVG_COST_PER_UNIT_SHIPPING' | 'AVG_COST_PER_UNIT_PALLET_COSTS' | 'AVG_COST_PER_UNIT_SHIPPING_SURCHARGE' | 'AVG_COST_PER_UNIT_OTHER_INVENTORY_ADJUSTMENTS' | 'AVG_COST_PER_UNIT_PRODUCTION_LABOR_COST'

export interface GetCOGSOverviewResponse {
    from: Scalars['Date']
    to: Scalars['Date']
    summary: COGSSummaryV2[]
    summaryEvents: COGSEvent[]
    __typename: 'GetCOGSOverviewResponse'
}

export type GetCustomerResponse = (Customer | CustomerNotExistError) & { __isUnion?: true }

export interface GetExportedReportsResponse {
    id: Scalars['ID']
    createdAt: Scalars['Date']
    updatedAt: Scalars['Date']
    fromDate?: Scalars['Date']
    toDate?: Scalars['Date']
    reportType: Scalars['String']
    source: Scalars['String']
    email?: Scalars['String']
    period: Scalars['String']
    __typename: 'GetExportedReportsResponse'
}

export interface GetFromEmailAddressError {
    message: Scalars['String']
    __typename: 'GetFromEmailAddressError'
}

export interface GetFromEmailAddressResponse {
    fromAddress: Scalars['String']
    __typename: 'GetFromEmailAddressResponse'
}

export type GetFromEmailAddressResult = (GetFromEmailAddressResponse | GetFromEmailAddressError) & { __isUnion?: true }

export interface GetFulfillmentSettingsResponse {
    settings: IntegrationFulfillmentSetting[]
    __typename: 'GetFulfillmentSettingsResponse'
}

export interface GetInventoryAccountBalanceResponse {
    inventoryAccountBalance: Scalars['Float']
    __typename: 'GetInventoryAccountBalanceResponse'
}

export interface GetInvoicesAffectingPaymentGroupsResponse {
    invoicesToPaymentGroups: InvoiceToPaymentGroups[]
    __typename: 'GetInvoicesAffectingPaymentGroupsResponse'
}

export interface GetInvoicesResult {
    invoices: Invoice[]
    __typename: 'GetInvoicesResult'
}

export interface GetLatestValidationResult {
    validationId?: Scalars['String']
    __typename: 'GetLatestValidationResult'
}

export interface GetLoanEventsLengthResult {
    length: Scalars['Int']
    __typename: 'GetLoanEventsLengthResult'
}

export interface GetLoanEventsResult {
    events: LoanEvent[]
    page: Scalars['Int']
    size: Scalars['Int']
    __typename: 'GetLoanEventsResult'
}

export interface GetLoanRelationshipsResult {
    relationships: LoanRelationship[]
    page: Scalars['Int']
    size: Scalars['Int']
    __typename: 'GetLoanRelationshipsResult'
}

export interface GetLoansOutstandingAmountOnDateResult {
    loans: LoanOutstandingAmountOnDate[]
    __typename: 'GetLoansOutstandingAmountOnDateResult'
}

export interface GetMatchingEffectRuleResult {
    effect?: LoansEventsEffectConfiguration
    memo?: Scalars['String']
    dailyAccrual?: Scalars['Float']
    __typename: 'GetMatchingEffectRuleResult'
}

export type GetNoUnitsPhysicalCountProductQuantitiesSortField = 'SKU' | 'COST_PER_UNIT' | 'DISPLAY_NAME' | 'TOTAL_CLOSING_BALANCE' | 'QUANTITY'

export interface GetOffersResponse {
    status: OffersStatus
    offers?: Offer[]
    __typename: 'GetOffersResponse'
}

export interface GetOrderFilteringBoundsResult {
    finaloopPaymentGateways: Scalars['String'][]
    salesChannels: Scalars['String'][]
    orderTotalP999: Scalars['Float']
    maxItemsCount: Scalars['Int']
    availableStatuses: OrderFinaloopStatus[]
    __typename: 'GetOrderFilteringBoundsResult'
}

export interface GetOrdersResultV2 {
    orders: OrderV2[]
    __typename: 'GetOrdersResultV2'
}

export type GetOrdersSortDirection = 'ASC' | 'DESC'

export type GetOrdersSortType = 'PLACED_DATE' | 'FIRST_PAYMENT_DATE' | 'FIRST_REFUND_DATE' | 'FIRST_FULFILLMENT_DATE' | 'TOTAL' | 'NET_SALES' | 'UNPAID_BALANCE' | 'BALANCE'

export type GetPendingAdjustmentsSortField = 'SKU' | 'PRODUCT_DISPLAY_NAME' | 'SOURCE' | 'WAREHOUSE_NAME' | 'DATE' | 'UNITS_SOLD' | 'UNITS_RESTOCKED' | 'QUANTITY'

export type GetPendingSalesDataAdjustmentsSortField = 'SKU' | 'PRODUCT_DISPLAY_NAME' | 'SOURCE' | 'WAREHOUSE_NAME' | 'DATE' | 'UNITS_SOLD' | 'UNITS_RESTOCKED'

export interface GetProductAutomergeSettingsResponse {
    matchGroupSettings: ProductAutomergeMatchGroupSetting[]
    __typename: 'GetProductAutomergeSettingsResponse'
}

export interface GetProductBulkAdjustmentStatus {
    id: Scalars['ID']
    companyId: Scalars['ID']
    state: ProductBulkAdjustmentStatusState
    totalAmount: Scalars['Int']
    processedAmount: Scalars['Int']
    __typename: 'GetProductBulkAdjustmentStatus'
}

export interface GetProductMergeLogsOverviewResponse {
    total: Scalars['Int']
    mergedByOptions: Scalars['String'][]
    __typename: 'GetProductMergeLogsOverviewResponse'
}

export interface GetProductMergeLogsResponse {
    items: ProductMergeLogItem[]
    __typename: 'GetProductMergeLogsResponse'
}

export interface GetProductMergeRecommendationsMatchGroupResponse {
    productGroups: ProductMergeRecommendationsProductGroup[]
    __typename: 'GetProductMergeRecommendationsMatchGroupResponse'
}

export type GetProductsSortField = 'SKU' | 'DISPLAY_NAME' | 'TOTAL_SOLD' | 'CURRENT_COST' | 'NET_DEPLETED' | 'COST_PER_UNIT' | 'ON_HAND_COST' | 'ON_HAND' | 'PURCHASED' | 'IN_TRANSIT' | 'SOURCE' | 'OPENING_BALANCE_QUANTITY' | 'NEGATIVE_ON_HAND'

export interface GetReadyValidationResponse {
    url?: Scalars['String']
    from?: Scalars['Date']
    to: Scalars['Date']
    generatedAt: Scalars['Date']
    generatedBy?: Scalars['String']
    isGreen: Scalars['Boolean']
    isError: Scalars['Boolean']
    __typename: 'GetReadyValidationResponse'
}

export interface GetSalesResult {
    sales: Sale[]
    __typename: 'GetSalesResult'
}

export type GetSalesSortDirection = 'ASC' | 'DESC'

export type GetSalesSortType = 'PLACED_DATE' | 'DISPLAY_NAME' | 'CUSTOMER_NAME' | 'SOURCE' | 'TOTAL' | 'TOTAL_BEFORE_TAXES' | 'BALANCE' | 'DUE_DATE'

export interface GetSignedDatesResponse {
    dates: Scalars['Date'][]
    __typename: 'GetSignedDatesResponse'
}

export interface GetSignedUrlByExportedLogIdResponse {
    downloadUrl: Scalars['String']
    __typename: 'GetSignedUrlByExportedLogIdResponse'
}

export type GetUnitsTrackingPhysicalCountProductQuantitiesSortField = 'SKU' | 'AVG_COST' | 'DISPLAY_NAME' | 'UNITS_ON_HAND' | 'ADJUSTMENT' | 'TOTAL_ADJUSTMENT' | 'QUANTITY'

export interface GetUnpaidOrdersCsvResponse {
    url: Scalars['String']
    __typename: 'GetUnpaidOrdersCsvResponse'
}

export type GetVendorResponse = (Vendor | VendorNotExistError) & { __isUnion?: true }

export interface GiftCard {
    id: Scalars['ID']
    company: Company
    integrationAccountId: Scalars['String']
    source: Scalars['String']
    externalSourceId: Scalars['String']
    status: GiftCardStatus
    lastCharacters: Scalars['String']
    issueMethod: GiftCardIssueMethod
    customer?: CustomerV2
    issuingOrder?: OrderV2
    issuedAt: Scalars['Date']
    expiredAt?: Scalars['Date']
    deactivatedAt?: Scalars['Date']
    disabledAt?: Scalars['Date']
    currency: Scalars['String']
    initialBalance: Scalars['Float']
    initialBalanceInHomeCurrency: Scalars['Float']
    remainingBalance: Scalars['Float']
    remainingBalanceInHomeCurrency: Scalars['Float']
    note?: Scalars['String']
    transactions: GiftCardTransaction[]
    balance: Scalars['Float']
    balanceInHomeCurrency: Scalars['Float']
    deactivationDate?: Scalars['Date']
    balanceAsOf: Scalars['Date']
    deletedAt?: Scalars['Date']
    __typename: 'GiftCard'
}

export interface GiftCardAggregationsResult {
    giftCardsCount: Scalars['Int']
    totalBalance: Scalars['Float']
    purchasedGiftCardsBalance: Scalars['Float']
    maximumGiftCardBalance: Scalars['Float']
    totalBalanceInHomeCurrency: Scalars['Float']
    purchasedGiftCardsBalanceInHomeCurrency: Scalars['Float']
    maximumGiftCardBalanceInHomeCurrency: Scalars['Float']
    __typename: 'GiftCardAggregationsResult'
}

export type GiftCardIssueMethod = 'PURCHASED' | 'MANUALLY_ISSUED'

export interface GiftCardsByIdsResponse {
    giftCards: GiftCard[]
    __typename: 'GiftCardsByIdsResponse'
}

export interface GiftCardsCsvResponse {
    url: Scalars['String']
    __typename: 'GiftCardsCsvResponse'
}

export interface GiftCardsMaximumCompanyBalanceResult {
    maximumBalance: Scalars['Float']
    __typename: 'GiftCardsMaximumCompanyBalanceResult'
}

export type GiftCardSortKeys = 'STATUS' | 'INITIAL_BALANCE' | 'BALANCE_AS_OF' | 'CURRENT_BALANCE' | 'ISSUE_DATE' | 'DEACTIVATION_DATE' | 'EXPIRATION_DATE' | 'DISABLE_DATE'

export interface GiftCardsResult {
    giftCards: GiftCard[]
    __typename: 'GiftCardsResult'
}

export type GiftCardsSortDirection = 'ASCENDING' | 'DESCENDING'

export type GiftCardStatus = 'ACTIVE' | 'PARTIALLY_REDEEMED' | 'REDEEMED' | 'DEACTIVATED' | 'EXPIRED'

export interface GiftCardTransaction {
    id: Scalars['ID']
    externalSourceId: Scalars['ID']
    currency: Scalars['String']
    amount: Scalars['Float']
    amountInHomeCurrency: Scalars['Float']
    postedAt: Scalars['Date']
    __typename: 'GiftCardTransaction'
}

export interface GiveawayCogs {
    amount: Scalars['Float']
    quantity: Scalars['Int']
    monthlyBreakdown: GiveawayMonthlyBreakdown[]
    __typename: 'GiveawayCogs'
}

export interface GiveawayDailyBreakdown {
    date: Scalars['Date']
    quantity: Scalars['Int']
    __typename: 'GiveawayDailyBreakdown'
}

export interface GiveawayDropshippingOriginalValue {
    quantity?: Scalars['Int']
    __typename: 'GiveawayDropshippingOriginalValue'
}

export interface GiveawayMonthlyBreakdown {
    date: Scalars['Date']
    quantity: Scalars['Int']
    dailyData: GiveawayDailyBreakdown[]
    __typename: 'GiveawayMonthlyBreakdown'
}

export interface GiveawayOriginalValue {
    quantity?: Scalars['Int']
    __typename: 'GiveawayOriginalValue'
}

export interface GlobalVendorMappingRule {
    id: Scalars['ID']
    __typename: 'GlobalVendorMappingRule'
}

export interface GoogleConnectLinkResponse {
    link: Scalars['String']
    __typename: 'GoogleConnectLinkResponse'
}

export interface GoogleConnectStatusResponse {
    isConnected: Scalars['Boolean']
    email?: Scalars['String']
    sharedFolderUrl?: Scalars['String']
    sharedFolderName?: Scalars['String']
    accessToken?: Scalars['String']
    __typename: 'GoogleConnectStatusResponse'
}

export interface GoogleTokenCodeResponse {
    success: Scalars['Boolean']
    __typename: 'GoogleTokenCodeResponse'
}

export interface GTMSource {
    utms?: GTMSourceUtms
    identifiers?: Scalars['JSON']
    __typename: 'GTMSource'
}

export interface GTMSourceUtms {
    firstUtms?: GTMUtms
    lastUtms?: GTMUtms
    __typename: 'GTMSourceUtms'
}

export interface GTMUtms {
    utmTimestamp?: Scalars['String']
    uuid?: Scalars['String']
    utmSource?: Scalars['String']
    utmMedium?: Scalars['String']
    utmCampaign?: Scalars['String']
    firstPageSeen?: Scalars['String']
    utmTerm?: Scalars['String']
    utmContent?: Scalars['String']
    __typename: 'GTMUtms'
}

export interface HandleUserLoginResponse {
    acceptedInviteCompanyInfo?: AcceptedInviteCompanyInfo
    wasCompanyCreated: Scalars['Boolean']
    __typename: 'HandleUserLoginResponse'
}

export interface HasOrdersInOrderGroupsResponse {
    hasOrders: Scalars['Boolean']
    __typename: 'HasOrdersInOrderGroupsResponse'
}

export interface HasProductMergeRecommendationsResponse {
    hasProductMergeRecommendations: Scalars['Boolean']
    __typename: 'HasProductMergeRecommendationsResponse'
}

export interface Holder {
    id: Scalars['ID']
    __typename: 'Holder'
}

export interface HolderCapitalInvestment {
    id: Scalars['ID']
    company: Company
    holder?: CompanyAffiliate
    amount?: Scalars['Float']
    bankTransactionId?: Scalars['String']
    holderTransactionId?: Scalars['String']
    businessEventId?: Scalars['String']
    loanManualEventId?: Scalars['String']
    configuration?: EquityEventsEffectConfiguration
    businessEventData?: BusinessEventData
    memo?: Scalars['String']
    postedAt?: Scalars['Date']
    latestActorId?: Scalars['String']
    createdAt: Scalars['Date']
    updatedAt: Scalars['Date']
    deletedAt?: Scalars['Date']
    __typename: 'HolderCapitalInvestment'
}

export interface HolderSafeInvestment {
    id: Scalars['ID']
    company: Company
    safeHolder?: CompanyAffiliate
    amount?: Scalars['Float']
    bankTransactionId?: Scalars['String']
    holderTransactionId?: Scalars['String']
    businessEventId?: Scalars['String']
    loanManualEventId?: Scalars['String']
    configuration?: EquityEventsEffectConfiguration
    businessEventData?: BusinessEventData
    memo?: Scalars['String']
    postedAt?: Scalars['Date']
    latestActorId?: Scalars['String']
    createdAt: Scalars['Date']
    updatedAt: Scalars['Date']
    deletedAt?: Scalars['Date']
    __typename: 'HolderSafeInvestment'
}

export interface HolderShare {
    id: Scalars['ID']
    company: Company
    holder?: CompanyAffiliate
    type: ShareType
    series?: Scalars['String']
    amount?: Scalars['Float']
    parValue?: Scalars['Float']
    quantity?: Scalars['Int']
    bankTransactionId?: Scalars['String']
    holderTransactionId?: Scalars['String']
    businessEventId?: Scalars['String']
    loanManualEventId?: Scalars['String']
    configuration?: EquityEventsEffectConfiguration
    businessEventData?: BusinessEventData
    memo?: Scalars['String']
    postedAt?: Scalars['Date']
    latestActorId?: Scalars['String']
    createdAt: Scalars['Date']
    updatedAt: Scalars['Date']
    deletedAt?: Scalars['Date']
    __typename: 'HolderShare'
}

export type HolderStatus = 'ACTIVE' | 'INACTIVE'

export interface HolderTransaction {
    id: Scalars['ID']
    company: Company
    holder?: CompanyAffiliate
    bankTransaction?: BankTransaction
    type: HolderTransactionType
    businessEventId?: Scalars['String']
    loanManualEventId?: Scalars['String']
    configuration?: EquityEventsEffectConfiguration
    businessEventData?: BusinessEventData
    memo?: Scalars['String']
    amount?: Scalars['Float']
    postedAt?: Scalars['Date']
    latestActorId?: Scalars['String']
    createdAt: Scalars['Date']
    updatedAt: Scalars['Date']
    deletedAt?: Scalars['Date']
    __typename: 'HolderTransaction'
}

export type HolderTransactionType = 'CONTRIBUTION' | 'DISTRIBUTION' | 'REDEMPTION'

export type HubItemState = 'INACTIVE' | 'OPEN' | 'IN_PROGRESS' | 'CLOSED'

export interface HubItemStateChangeLog {
    id: Scalars['ID']
    createdAt: Scalars['Date']
    updaterType: HubUpdaterType
    changedByUid?: Scalars['String']
    reason?: Scalars['String']
    oldValue: HubItemState
    newValue: HubItemState
    __typename: 'HubItemStateChangeLog'
}

export type HubState = 'INACTIVE' | 'OPEN' | 'INITIAL_PROCESSING' | 'AWAITING_USER_FEEDBACK' | 'FOLLOW_UP_PROCESSING' | 'READY' | 'NA'

export interface HubStateChangeLog {
    id: Scalars['ID']
    createdAt: Scalars['Date']
    updaterType: HubUpdaterType
    changedByUid?: Scalars['String']
    reason?: Scalars['String']
    oldValue: HubState
    newValue: HubState
    __typename: 'HubStateChangeLog'
}

export type HubUpdaterType = 'USER' | 'SYSTEM' | 'OPS'

export type HubUpdaterTypeInput = 'USER' | 'OPS'

export interface IdResult {
    id: Scalars['String']
    __typename: 'IdResult'
}

export interface ImageUploadUrlResult {
    uploadUrl: Scalars['String']
    url: Scalars['String']
    iconUrl: Scalars['String']
    fileName: Scalars['String']
    __typename: 'ImageUploadUrlResult'
}

export interface ImpersonateResponse {
    success: Scalars['Boolean']
    __typename: 'ImpersonateResponse'
}

export interface IncludedFinaloopSalesChannelItemReconciliation {
    salesChannel: ItemReconciliationFinaloopSalesChannel
    data: IncludedShopifySalesChannelItemReconciliation[]
    summary: ReconciliationSummary
    productItemSoldData: ShopifySkuReconciliationProductItemSoldData
    productStatus: ShopifyReconciliationProductsStatus
    unknownSkuQuantity: Scalars['Int']
    unknownSkuZeroPriceQuantity: Scalars['Int']
    __typename: 'IncludedFinaloopSalesChannelItemReconciliation'
}

export interface IncludedShopifySalesChannelItemReconciliation {
    sku: Scalars['String']
    isBlacklisted: Scalars['Boolean']
    salesChannel: ItemReconciliationFinaloopSalesChannel
    shopifySalesChannel: Scalars['String']
    summary: ReconciliationSummary
    __typename: 'IncludedShopifySalesChannelItemReconciliation'
}

export interface IncomingBatchAnalytics {
    origin: IncomingBatchOrigin
    analytics: IncomingInventoryAnalytics
    __typename: 'IncomingBatchAnalytics'
}

export type IncomingBatchOrigin = (Shipment | WarehouseOpeningBalance | RecipeWithBreakdown | ManualAssemblyWithBreakdown | WarehouseTransferWithBreakdown | UnitsTrackingPhysicalCount | WarehouseNegativesAdjustmentBreakdown) & { __isUnion?: true }

export interface IncomingInventoryAnalytics {
    assembled: Scalars['Float']
    incoming: Scalars['Float']
    fulfilled: Scalars['Float']
    lost: Scalars['Float']
    found: Scalars['Float']
    warehouseTransfers: Scalars['Float']
    adjustments: Scalars['Float']
    deadInventory: Scalars['Float']
    otherAdjustments: Scalars['Float']
    restocked: Scalars['Float']
    onHand: Scalars['Float']
    landedCostPerUnit?: Scalars['Float']
    onHandCost: Scalars['Float']
    unavailable: Scalars['Float']
    unavailableByAssemblies: Scalars['Float']
    unavailableByWarehouseTransfersOut: Scalars['Float']
    unavailableByAdjustmentsDeadInventory: Scalars['Float']
    unavailableByDeadInventory: Scalars['Float']
    unavailableByUnitLost: Scalars['Float']
    unavailableByUnitFound: Scalars['Float']
    unavailableByOtherAdjustments: Scalars['Float']
    netDepleted: Scalars['Float']
    openingBalanceQuantity: Scalars['Float']
    openingBalanceCost: Scalars['Float']
    physicalCountAdjustmentOut: Scalars['Float']
    unavailableBreakdown: IncomingInventoryAnalyticsUnavailableBreakdown[]
    __typename: 'IncomingInventoryAnalytics'
}

export interface IncomingInventoryAnalyticsUnavailableBreakdown {
    date: Scalars['Date']
    total: Scalars['Float']
    action: WarehouseAction
    __typename: 'IncomingInventoryAnalyticsUnavailableBreakdown'
}

export interface IndirectCostAllocation {
    id: Scalars['ID']
    indirectLineItem: IndirectLineItem
    allocatedCostPerUnit: Scalars['Float']
    remainderAllocationCostPerUnit?: Scalars['Float']
    __typename: 'IndirectCostAllocation'
}

export interface IndirectLineItem {
    id: Scalars['ID']
    type: IndirectLineItemType
    cost: Scalars['Float']
    vendor: Vendor
    isDefaultVendor: Scalars['Boolean']
    hasAutomaticAllocation?: Scalars['Boolean']
    __typename: 'IndirectLineItem'
}

export type IndirectLineItemType = 'SHIPPING' | 'GENERAL' | 'VENDOR_FEES' | 'DUTIES_AND_TAX' | 'CUSTOM_FEES_AND_SERVICES' | 'INSURANCE' | 'PRODUCTION_COSTS' | 'DISCOUNT' | 'PALLET_COSTS' | 'SHIPPING_SURCHARGE' | 'OTHER_INVENTORY_ADJUSTMENTS' | 'PRODUCTION_LABOR_COSTS' | 'OTHER'

export interface IndividualSkusResponse {
    title: Scalars['String']
    updatedAt?: Scalars['Date']
    data: SkuDataByDate[]
    __typename: 'IndividualSkusResponse'
}

export type IndividualSkusSortField = 'DATE' | 'SALES' | 'DISCOUNTS' | 'COGS' | 'PROFIT' | 'MARGIN' | 'REFUNDS' | 'UNITS_SOLD' | 'UNITS_REFUNDED'

export interface Institution {
    id: Scalars['ID']
    name: Scalars['String']
    preferredProvider?: InstitutionProviders
    logoUrl?: Scalars['String']
    websiteUrl?: Scalars['String']
    affiliatedEntityId: Scalars['ID']
    csvInstructionsLink?: Scalars['String']
    pdfInstructionsLink?: Scalars['String']
    csvAvailable: Scalars['Boolean']
    pdfAvailable: Scalars['Boolean']
    dataConfig?: Scalars['JSONObject']
    __typename: 'Institution'
}

export interface InstitutionMapping {
    id: Scalars['ID']
    source?: Scalars['String']
    externalSourceId?: Scalars['String']
    externalSourceName?: Scalars['String']
    institutionId?: Scalars['String']
    __typename: 'InstitutionMapping'
}

export interface InstitutionMappingResponse {
    mappings: InstitutionMapping[]
    __typename: 'InstitutionMappingResponse'
}

export type InstitutionMappingSourceType = 'PLAID' | 'QUICKBOOKS' | 'QUICKBOOKS_BANKS'

export type InstitutionProviders = 'PLAID' | 'PAYPAL' | 'RAMP' | 'MANUAL'

export interface InstitutionsResponse {
    institutions: Institution[]
    __typename: 'InstitutionsResponse'
}

export interface InstitutionVendorID {
    vendorId: Scalars['ID']
    __typename: 'InstitutionVendorID'
}

export interface IntegrationConnectionAccount {
    integrationType: IntegrationType
    connectedAt: Scalars['Date']
    integrationAccountId: Scalars['ID']
    integrationAccountName?: Scalars['String']
    impactOnBooksSince: Scalars['Date']
    __typename: 'IntegrationConnectionAccount'
}

export type IntegrationConnectionType = 'PAYMENT_PROCESSOR' | 'MARKETPLACE'

export interface IntegrationFulfillmentSetting {
    companyId: Scalars['ID']
    integrationAccountId: Scalars['ID']
    source: IntegrationType
    methods: FulfillmentMethod[]
    __typename: 'IntegrationFulfillmentSetting'
}

export interface IntegrationInfo {
    accountId: Scalars['ID']
    accountName: Scalars['String']
    externalSourceId: Scalars['String']
    __typename: 'IntegrationInfo'
}

export interface IntegrationSaleTransaction {
    id: Scalars['ID']
    integrationInfo?: IntegrationInfo
    integrationAccountId?: Scalars['String']
    externalSourceId?: Scalars['String']
    amount: Scalars['Float']
    postedAt: Scalars['Date']
    currency: CurrencyCode
    amountInHomeCurrency: Scalars['Float']
    type: TransactionType
    finaloopPaymentGateway?: Scalars['String']
    originalPaymentGateway?: Scalars['String']
    paymentGatewayVariant?: Scalars['String']
    isIndication: Scalars['Boolean']
    source?: Scalars['String']
    __typename: 'IntegrationSaleTransaction'
}

export type IntegrationSource = 'PAYPAL' | 'STRIPE' | 'QUICKBOOKS' | 'SPS_COMMERCE' | 'QUICKBOOKS_INVOICES' | 'NU_ORDER_INVOICES' | 'FINALOOP_INVOICES'

export type IntegrationTransfer = (Payout | Topup) & { __isUnion?: true }

export interface IntegrationTransferClassification {
    businessEvent?: Scalars['String']
    askTheUserResult?: Scalars['JSONObject']
    description?: Scalars['String']
    pairedEntity?: IntegrationTransferPairedEntity
    __typename: 'IntegrationTransferClassification'
}

export interface IntegrationTransferGroup {
    groupId: Scalars['ID']
    integrationTransfers: IntegrationTransfer[]
    payer: IntegrationTransferParty
    payee: IntegrationTransferParty
    isProcessing: Scalars['Boolean']
    action: UnidentifiedTransfersGroupAction
    type: IntegrationTransferType
    tooltipText?: Scalars['String']
    __typename: 'IntegrationTransferGroup'
}

export interface IntegrationTransferPairedEntity {
    id: Scalars['ID']
    type: IntegrationTransferPairedEntityType
    __typename: 'IntegrationTransferPairedEntity'
}

export type IntegrationTransferPairedEntityType = 'COMPANY_AFFILIATE' | 'BANK_TRANSACTION' | 'RELATED_PARTY'

export type IntegrationTransferParty = (UnknownIntegrationTransferBank | UnknownIntegrationTransferAccount | Vendor | BankAccount) & { __isUnion?: true }

export interface IntegrationTransferRule {
    id: Scalars['ID']
    integrationType: IntegrationType
    companyAffiliate: CompanyAffiliate
    integrationAccountId?: Scalars['ID']
    __typename: 'IntegrationTransferRule'
}

export type IntegrationTransferType = 'PAYOUT' | 'TOPUP'

export type IntegrationTransferTypeV2 = 'FROM_INTEGRATION' | 'TO_INTEGRATION'

export interface IntegrationTransferV2 {
    companyId: Scalars['ID']
    id: Scalars['ID']
    source: IntegrationType
    integrationAccountId: Scalars['ID']
    integrationAccountName?: Scalars['String']
    amount: Scalars['Float']
    currency: Scalars['String']
    postedAt?: Scalars['Date']
    requestedAt?: Scalars['Date']
    failedAt?: Scalars['Date']
    type: IntegrationTransferTypeV2
    __typename: 'IntegrationTransferV2'
}

export type IntegrationType = 'AFTERPAY' | 'AMAZON' | 'AMAZON_PAY' | 'BILL_COM' | 'EBAY' | 'ETSY' | 'FACEBOOK_ADS' | 'GOOGLE_ADS' | 'PAYPAL' | 'PLAID' | 'QUICKBOOKS' | 'SHOPIFY' | 'SHOP_PAY' | 'STRIPE' | 'WALMART' | 'FINALOOP_BANK_TRANSACTIONS_UPLOAD' | 'FINALOOP_BALANCE_TRANSACTIONS' | 'FINALOOP_BILLS' | 'FINALOOP_INVOICES' | 'FINALOOP_INVENTORY' | 'FINALOOP_INTERNAL' | 'FINALOOP_PAYMENTS' | 'FINALOOP_TRANSACTIONS' | 'FINALOOP_TRANSACTIONS_MACHINE' | 'FINALOOP_BANK_ACCOUNT_VALIDATIONS' | 'FINALOOP_COMPANY_AFFILIATE_BALANCES' | 'QUICKBOOKS_BANKS' | 'REPORTED_BUSINESS_BANK_TRANSACTIONS' | 'SHADOW_QUICKBOOKS' | 'SHOPIFY_ORDERS' | 'SHOPIFY_PRODUCTS' | 'TEST' | 'USER' | 'USER_PASSWORD' | 'AFFIRM' | 'ALMA' | 'AUTHORIZE_NET' | 'BLACKCART' | 'BANKFUL' | 'BRAINTREE' | 'CLEARCO' | 'CLEARPAY' | 'FAIRE' | 'PARKER' | 'KLARNA' | 'KLICKLY' | 'SETTLE' | 'SEZZLE' | 'SPS_COMMERCE' | 'QUICKBOOKS_PAYMENTS' | 'SQUARE' | 'WOOCOMMERCE' | 'FACEBOOK' | 'ZIP_CO' | 'SPLITIT' | 'BREAD_PAY' | 'GLOBAL_E' | 'GUSTO' | 'SNACK_MAGIC' | 'POSTAL' | 'CORPORATE_GIFT' | 'CAROO' | 'CARRO' | 'RAMP' | 'RAMP_PUBLIC_API' | 'STRIPE_FINANCIAL_CONNECTIONS' | 'MX' | 'REVOLUT' | 'OPEN_PATH' | 'OPEN_NOD' | 'RETURNLY' | 'COINBASE' | 'TRUE_MED' | 'PAYONEER' | 'AIRWALLEX' | 'LEAP_RETAIL' | 'TWINT' | 'MIRAKL' | 'CATCH' | 'PARTIAL_LY' | 'TIK_TOK' | 'BLOOM' | 'TRACKSTAR' | 'QUICKBOOKS_INVOICES' | 'NU_ORDER_INVOICES'

export interface InventoryBatch {
    action: WarehouseAction
    quantity: Scalars['Int']
    directCost: Scalars['Float']
    indirectCosts: MovementIndirectCost[]
    __typename: 'InventoryBatch'
}

export interface InventoryInitStatus {
    areProductsLoaded: Scalars['Boolean']
    isSalesDataLoaded: Scalars['Boolean']
    isDataReconciled: Scalars['Boolean']
    hasPurchaseOrders: Scalars['Boolean']
    hasWarehouseOpeningBalances: Scalars['Boolean']
    __typename: 'InventoryInitStatus'
}

export interface InventoryPaymentGroup {
    id: Scalars['ID']
    companyId: Scalars['String']
    postedAt: Scalars['Date']
    createdAt: Scalars['Date']
    updatedAt: Scalars['Date']
    deletedAt?: Scalars['Date']
    affiliatedEntity: AffiliatedEntity
    serialNumber: Scalars['String']
    purchaseOrders: PaymentGroupLinkedPurchaseOrder[]
    warehouseTransfers: PaymentGroupLinkedWarehouseTransfer[]
    inventoryPurchases: PaymentGroupLinkedInventoryPurchases[]
    manualAssemblies: PaymentGroupLinkedManualAssembly[]
    onDemandAssemblyVendorCosts: PaymentGroupLinkedOnDemandAssemblyVendorCost[]
    __typename: 'InventoryPaymentGroup'
}

export interface InventoryPaymentGroupByIdResponse {
    inventoryPaymentGroup?: InventoryPaymentGroup
    __typename: 'InventoryPaymentGroupByIdResponse'
}

export interface InventoryPaymentGroupLink {
    inventoryPaymentGroup: InventoryPaymentGroup
    serialNumber: Scalars['String']
    amount: Scalars['Float']
    amountInHomeCurrency: Scalars['Float']
    currency: CurrencyCode
    postedAt: Scalars['Date']
    __typename: 'InventoryPaymentGroupLink'
}

export interface InventoryPaymentGroupsByIdsResponse {
    inventoryPaymentGroups: InventoryPaymentGroup[]
    __typename: 'InventoryPaymentGroupsByIdsResponse'
}

export interface InventoryPaymentGroupsResponse {
    inventoryPaymentGroups: InventoryPaymentGroup[]
    __typename: 'InventoryPaymentGroupsResponse'
}

export type InventoryPaymentGroupsSortDirection = 'ASC' | 'DESC'

export type InventoryPaymentGroupsSortType = 'POSTED_AT'

export interface InventoryPaymentGroupUnclearedBalance {
    paymentGroup: InventoryPaymentGroup
    unclearedBalance: Amounts
    __typename: 'InventoryPaymentGroupUnclearedBalance'
}

export interface InventoryPurchase {
    id: Scalars['ID']
    companyId: Scalars['ID']
    source: InventoryPurchaseSource
    sourceEntity?: InventoryPurchaseSourceEntity
    bankTransactionId?: Scalars['ID']
    billId?: Scalars['ID']
    amazonShippingInBusinessEventId?: Scalars['ID']
    payrollId?: Scalars['ID']
    sourceDescription: Scalars['String']
    direction: InventoryPurchaseDirection
    dates: DateRange
    affiliatedEntity?: AffiliatedEntity
    currency: Scalars['String']
    amount: Scalars['Float']
    amountInHomeCurrency: Scalars['Float']
    historicalPurchaseAffectingMethodId?: Scalars['ID']
    categories: InventoryPurchaseCategory[]
    items: InventoryPurchaseItem[]
    paymentStatus: InventoryPurchasePaymentStatus
    canceledAt?: Scalars['Date']
    lastUpdatedAt: Scalars['Date']
    attachments: InventoryPurchaseAttachment[]
    paidAt?: Scalars['Date']
    inventoryPaymentGroupLinks: InventoryPaymentGroupLink[]
    unpaidAmount: Scalars['Float']
    __typename: 'InventoryPurchase'
}

export interface InventoryPurchaseAttachment {
    filename: Scalars['String']
    url: Scalars['String']
    __typename: 'InventoryPurchaseAttachment'
}

export interface InventoryPurchaseCategory {
    serialNumber: Scalars['Int']
    categoryName: InventoryPurchaseCategoryName
    purchaseType: InventoryPurchaseType
    amount: Scalars['Float']
    amountInHomeCurrency: Scalars['Float']
    classificationTag?: ClassificationTag
    __typename: 'InventoryPurchaseCategory'
}

export type InventoryPurchaseCategoryName = 'CONSIGNMENT' | 'DROPSHIPPING' | 'DEAD_INVENTORY' | 'FINISHED_PRODUCTS' | 'OTHER_INVENTORY_INDIRECT_COSTS' | 'PACKAGING_MATERIALS' | 'PRODUCTION_COSTS' | 'PRODUCTION_LABOR_COSTS' | 'SHIPPING_AND_FREIGHT_IN' | 'SUPPLIES_AND_MATERIALS' | 'VENDOR_FEES' | 'DUTIES_AND_TAX' | 'CUSTOM_FEES_AND_SERVICES' | 'INVENTORY_INSURANCE' | 'SHIPPING_SURCHARGE' | 'PALLET_COSTS' | 'PRODUCT_DONATIONS' | 'PRODUCT_GIVEAWAYS' | 'WARRANTY_REIMBURSEMENT'

export interface InventoryPurchaseCategorySummary {
    categoryName: InventoryPurchaseCategoryName
    purchasedAmountInHomeCurrency: Scalars['Float']
    incidentalsAmountInHomeCurrency: Scalars['Float']
    receivedAmountInHomeCurrency: Scalars['Float']
    __typename: 'InventoryPurchaseCategorySummary'
}

export type InventoryPurchaseDirection = 'PURCHASE' | 'REFUND'

export interface InventoryPurchaseItem {
    amount: Scalars['Float']
    shipmentDate?: Scalars['Date']
    receivedDate?: Scalars['Date']
    purchaseDate?: Scalars['Date']
    note?: Scalars['String']
    __typename: 'InventoryPurchaseItem'
}

export type InventoryPurchasePaymentStatus = 'UNPAID' | 'PARTIALLY_PAID' | 'FULLY_PAID'

export interface InventoryPurchaseRule {
    id: Scalars['String']
    affiliatedEntity?: AffiliatedEntity
    categoryName: InventoryPurchaseCategoryName
    startDate: Scalars['Date']
    endDate?: Scalars['Date']
    condition?: InventoryPurchaseRuleCondition
    amount?: Scalars['Float']
    __typename: 'InventoryPurchaseRule'
}

export type InventoryPurchaseRuleApplyRuleOperation = 'CREATE' | 'UPDATE' | 'DELETE'

export type InventoryPurchaseRuleCondition = 'GREATER_THAN' | 'LESS_THAN'

export interface InventoryPurchaseRulesResponse {
    items: InventoryPurchaseRule[]
    __typename: 'InventoryPurchaseRulesResponse'
}

export interface InventoryPurchasesCountByVendorItem {
    affiliatedEntity: AffiliatedEntity
    count: Scalars['Int']
    __typename: 'InventoryPurchasesCountByVendorItem'
}

export interface InventoryPurchasesCountByVendorResponse {
    items: InventoryPurchasesCountByVendorItem[]
    __typename: 'InventoryPurchasesCountByVendorResponse'
}

export interface InventoryPurchasesExportResponse {
    url: Scalars['String']
    __typename: 'InventoryPurchasesExportResponse'
}

export type InventoryPurchaseSource = 'TRANSACTION' | 'BILL' | 'USER_INPUT' | 'PAYROLL' | 'AMAZON_SHIPPING_IN' | 'CONTRACTOR_PAYMENT'

export type InventoryPurchaseSourceCategory = 'BILL' | 'PURCHASE'

export type InventoryPurchaseSourceEntity = (BankTransaction | Bill) & { __isUnion?: true }

export interface InventoryPurchasesResponse {
    purchases: InventoryPurchase[]
    hasNext: Scalars['Boolean']
    totalCount: Scalars['Float']
    __typename: 'InventoryPurchasesResponse'
}

export type InventoryPurchasesSortByField = 'DATE' | 'PAID_STATUS'

export type InventoryPurchasesSortDirection = 'ASC' | 'DESC'

export interface InventoryPurchasesSummaryResponse {
    summary: InventoryPurchaseCategorySummary[]
    __typename: 'InventoryPurchasesSummaryResponse'
}

export type InventoryPurchaseStatus = 'PENDING' | 'IN_PROCESS' | 'IN_TRANSIT' | 'RECEIVED'

export interface InventoryPurchasesValidationResult {
    checkTime: Scalars['Date']
    expectedInProcessBalance: Scalars['Float']
    expectedInTransitBalance: Scalars['Float']
    actualInProcessBalance: Scalars['Float']
    actualInTransitBalance: Scalars['Float']
    clearingAccountBalance: Scalars['Float']
    missingExpectedPurchaseIds: Scalars['ID'][]
    unexpectedPurchaseIds: Scalars['ID'][]
    missingExpectedBusinessEventsForPurchaseIds: Scalars['ID'][]
    unexpectedBusinessEventIds: Scalars['ID'][]
    status: InventoryPurchasesValidationStatus
    __typename: 'InventoryPurchasesValidationResult'
}

export type InventoryPurchasesValidationStatus = 'PASS' | 'FAIL'

export type InventoryPurchaseType = 'PURCHASE' | 'INCIDENTAL' | 'ALLOCATED_RECIPES'

export interface InventoryPurchaseUpdateOutOfDateError {
    inventoryPurchase: InventoryPurchase
    __typename: 'InventoryPurchaseUpdateOutOfDateError'
}

export interface InventoryPurchaseVendorsResponse {
    items: AffiliatedEntity[]
    __typename: 'InventoryPurchaseVendorsResponse'
}

export interface InventorySettings {
    companyId: Scalars['ID']
    managementMethod?: Scalars['String']
    onboardingCompletionTime?: Scalars['Date']
    rangedManagementMethod?: RangedManagementMethod[]
    isEligibleForNoClosingBalancePurchaseBased?: Scalars['Boolean']
    openingBalance?: Scalars['Float']
    latestOpeningBalanceBusinessEventId?: Scalars['String']
    closingBalances?: Scalars['JSONObject']
    latestClosingBalanceBusinessEventIds?: Scalars['String'][]
    realtimeCogsStatus?: RealtimeCogsStatus
    hasUserReviewedProducts?: Scalars['Boolean']
    haveDropshippingPurchase?: Scalars['Boolean']
    isUsingPaymentGroupsFeature?: Scalars['Boolean']
    __typename: 'InventorySettings'
}

export type InventoryUsageType = 'WAREHOUSE_TRANSFERS' | 'INVOICE_COGS' | 'OTHER_INTEGRATION_SALES' | 'DROPSHIPPING'

export interface InventoryVendor {
    affiliatedEntity: AffiliatedEntity
    rollingBalance: Scalars['Float']
    unpaidBills: Scalars['Float']
    __typename: 'InventoryVendor'
}

export interface InventoryVendorAdjustment {
    date: Scalars['Date']
    amount: Scalars['Float']
    bill: Bill
    __typename: 'InventoryVendorAdjustment'
}

export interface InventoryVendorBillItem {
    amount: Scalars['Float']
    balance: Scalars['Float']
    paidAmount?: Scalars['Float']
    source: InventoryVendorBillItemSource
    __typename: 'InventoryVendorBillItem'
}

export type InventoryVendorBillItemSource = (InventoryPurchase | InventoryVendorPayment | InventoryVendorCredit | InventoryVendorAdjustment) & { __isUnion?: true }

export type InventoryVendorBillItemType = 'BILL' | 'INCIDENTAL' | 'PAYMENT' | 'CREDIT' | 'ADJUSTMENT'

export interface InventoryVendorBillsOverviewResponse {
    billsAmount: Scalars['Float']
    billPayments: Scalars['Float']
    billCredits: Scalars['Float']
    billAdjustments: Scalars['Float']
    billsPurchasesAmount: Scalars['Float']
    billsIncidentalPurchasesAmount: Scalars['Float']
    asOfDate: InventoryVendorOverviewItem
    beforeUnitsTracking: InventoryVendorOverviewItem
    count: Scalars['Int']
    minAmount: Scalars['Float']
    maxAmount: Scalars['Float']
    __typename: 'InventoryVendorBillsOverviewResponse'
}

export interface InventoryVendorBillsResponse {
    hasNext: Scalars['Boolean']
    count: Scalars['Int']
    items: InventoryVendorBillItem[]
    __typename: 'InventoryVendorBillsResponse'
}

export interface InventoryVendorCredit {
    date: Scalars['Date']
    amount: Scalars['Float']
    bill: Bill
    __typename: 'InventoryVendorCredit'
}

export interface InventoryVendorFilterValuesResponse {
    maxRollingBalance: Scalars['Float']
    minRollingBalance: Scalars['Float']
    maxUnpaidBills: Scalars['Float']
    minUnpaidBills: Scalars['Float']
    __typename: 'InventoryVendorFilterValuesResponse'
}

export interface InventoryVendorOverviewItem {
    amount: Scalars['Float']
    payments: Scalars['Float']
    credits: Scalars['Float']
    adjustments: Scalars['Float']
    purchasesAmount: Scalars['Float']
    incidentalPurchasesAmount: Scalars['Float']
    __typename: 'InventoryVendorOverviewItem'
}

export interface InventoryVendorParamsResponse {
    inventoryVendorBillsCount: Scalars['Int']
    __typename: 'InventoryVendorParamsResponse'
}

export interface InventoryVendorPayment {
    date: Scalars['Date']
    amount: Scalars['Float']
    bill: Bill
    __typename: 'InventoryVendorPayment'
}

export interface InventoryVendorRollingBalanceItem {
    amount: Scalars['Float']
    rollingBalance: Scalars['Float']
    source: InventoryVendorRollingBalanceItemSource
    __typename: 'InventoryVendorRollingBalanceItem'
}

export type InventoryVendorRollingBalanceItemSource = (PurchaseOrder | InventoryPurchase | WarehouseTransfer | Assembly) & { __isUnion?: true }

export type InventoryVendorRollingBalanceItemTypes = 'PURCHASE_ORDER' | 'BILL' | 'PAYMENT' | 'TRANSACTION' | 'USER_INPUT' | 'WAREHOUSE_TRANSFER' | 'ASSEMBLY'

export interface InventoryVendorRollingBalanceOverviewResponse {
    affiliatedEntity?: AffiliatedEntity
    purchaseOrdersBalance: Scalars['Float']
    warehouseTransfersBalance: Scalars['Float']
    paymentsBalance: Scalars['Float']
    billsBalance: Scalars['Float']
    assembliesBalance: Scalars['Float']
    count: Scalars['Int']
    minAmount: Scalars['Float']
    maxAmount: Scalars['Float']
    __typename: 'InventoryVendorRollingBalanceOverviewResponse'
}

export interface InventoryVendorRollingBalanceResponse {
    hasNext: Scalars['Boolean']
    items: InventoryVendorRollingBalanceItem[]
    __typename: 'InventoryVendorRollingBalanceResponse'
}

export interface InventoryVendorsOverviewResponse {
    count: Scalars['Int']
    negativeRollingBalanceCount: Scalars['Int']
    rollingBalance: Scalars['Float']
    unpaidBills: Scalars['Float']
    unpaidBillsOpeningBalance: Scalars['Float']
    __typename: 'InventoryVendorsOverviewResponse'
}

export interface InventoryVendorsResponse {
    vendors: InventoryVendor[]
    hasNext: Scalars['Boolean']
    __typename: 'InventoryVendorsResponse'
}

export type InventoryVendorsSortField = 'vendorName' | 'rollingBalance'

export interface InventoryVendorValidationResult {
    totalsResult: InventoryVendorValidationTotalsResult
    vendorsResults: InventoryVendorValidationResultItem[]
    nonMatchingUnpaidBills?: (NonMatchingUnpaidBill | undefined)[]
    emptyVendorInventoryPurchases?: (Scalars['String'] | undefined)[]
    __typename: 'InventoryVendorValidationResult'
}

export interface InventoryVendorValidationResultItem {
    affiliatedEntity: AffiliatedEntity
    rollingBalanceTotalAmount: Scalars['Float']
    rollingBalanceListAmount: Scalars['Float']
    rollingBalanceOverviewAmount: Scalars['Float']
    unpaidBillsTotalAmount: Scalars['Float']
    unpaidBillsListAmount: Scalars['Float']
    unpaidBillsOverviewAmount: Scalars['Float']
    rollingBalancePassed: Scalars['Boolean']
    unpaidBillsPassed: Scalars['Boolean']
    __typename: 'InventoryVendorValidationResultItem'
}

export interface InventoryVendorValidationTotalsResult {
    rollingBalanceOverviewAmount: Scalars['Float']
    rollingBalanceListAmount: Scalars['Float']
    rollingBalanceBooksAmount: Scalars['Float']
    rollingBalanceDbAmount: Scalars['Float']
    unpaidBillsOverviewAmount: Scalars['Float']
    unpaidBillsIncidentalsAmount: Scalars['Float']
    unpaidBillsBooksAmount: Scalars['Float']
    unpaidBillsListAmount: Scalars['Float']
    unpaidBillsDbAmount: Scalars['Float']
    rollingBalancePassed: Scalars['Boolean']
    unpaidBillsPassed: Scalars['Boolean']
    __typename: 'InventoryVendorValidationTotalsResult'
}

export interface InventoryYearEndHistoryLog {
    userEmail?: Scalars['String']
    updaterType: Scalars['String']
    date: Scalars['Date']
    status: InventoryYearEndMissionStatus
    __typename: 'InventoryYearEndHistoryLog'
}

export interface InventoryYearEndMissionsResponse {
    missions: YearEndInventoryMission[]
    __typename: 'InventoryYearEndMissionsResponse'
}

export type InventoryYearEndMissionStatus = 'OPEN' | 'REOPEN' | 'COMPLETED'

export type InventoryYearEndMissionsType = 'PurchaseBasedOpeningBalance' | 'PurchaseBasedPurchases' | 'PurchaseBasedClosingBalance' | 'SalesBasedOpeningBalance' | 'SalesBasedPurchases' | 'SalesBasedReportCogs' | 'SalesBasedMissingCostPerUnit' | 'SalesBasedClosingBalance' | 'UnitBasedVendorsNegativeBalance' | 'UnitBasedReportCogs' | 'UnitBasedNegativeOnHands' | 'UnitBasedClosingBalance'

export type InvitationStatus = 'PENDING' | 'ACCEPTED' | 'EXPIRED'

export interface InviteUserResponse {
    success: Scalars['Boolean']
    __typename: 'InviteUserResponse'
}

export interface Invoice {
    id: Scalars['ID']
    dueDate?: Scalars['Date']
    dueInDays?: Scalars['Int']
    companyAddress: CompanyAddress
    currentPdf?: InvoicePdf
    pdfs: InvoicePdf[]
    paymentMethod: PaymentMethod
    paymentMethods: PaymentMethod[]
    openPaymentLinks: InvoicePaymentLink[]
    paidPaymentLinks: InvoicePaymentLink[]
    saleType: Scalars['String']
    companyId: Scalars['ID']
    source: SaleSource
    externalSourceUrl?: Scalars['String']
    externalSourceId?: Scalars['String']
    integrationAccountId?: Scalars['ID']
    integrationAccountName?: Scalars['String']
    currency: CurrencyCode
    displayName: Scalars['String']
    statuses: SaleStatus[]
    postedAt: Scalars['Date']
    createdAt: Scalars['Date']
    updatedAt: Scalars['Date']
    deletedAt?: Scalars['Date']
    publishedAt?: Scalars['Date']
    lineItems: SaleLineItem[]
    shipping: ShippingLineItem[]
    discounts: Discount[]
    platformDiscounts: Discount[]
    taxes: Tax[]
    taxFixedAmount?: Scalars['Float']
    taxType: SaleTaxType
    adjustments: SaleAdjustment[]
    payments: SaleTransaction[]
    credits: SaleTransaction[]
    refunds: SaleTransaction[]
    paymentIndications: SaleTransaction[]
    refundIndications: SaleTransaction[]
    customer: CustomerV2
    customerId: Scalars['ID']
    shippingAddress?: CustomerAddress
    billingAddress?: CustomerAddress
    integrationTags: Scalars['String'][]
    integrationNote?: Scalars['String']
    finaloopNote?: Scalars['String']
    customerNote?: Scalars['String']
    isSalesAffecting: Scalars['Boolean']
    isCogsAffecting: Scalars['Boolean']
    accounting: AccountingInfo
    voidedAt?: Scalars['Date']
    voidedBy?: SaleActor
    approvedAt?: Scalars['Date']
    uploadId?: Scalars['String']
    uploadedAt?: Scalars['Date']
    purchaseOrderNumber?: Scalars['String']
    summary: SaleTotals
    __typename: 'Invoice'
}

export interface InvoicePay {
    id: Scalars['String']
    companyId: Scalars['String']
    source: Scalars['String']
    amount: Scalars['Float']
    currency: CurrencyCode
    invoiceTotal: Scalars['Float']
    invoiceUnpaidBalance: Scalars['Float']
    invoiceDisplayName: Scalars['String']
    pdfUrl: Scalars['String']
    companyLogoUrl?: Scalars['String']
    status: PaymentLinkStatus
    customerName: Scalars['String']
    invoicerName: Scalars['String']
    invoiceDate: Scalars['Date']
    dueDate?: Scalars['Date']
    paymentMethods: PaymentMethod[]
    integrationAccountId?: Scalars['String']
    publishableApiKey?: Scalars['String']
    clientSecret?: Scalars['String']
    previousPaymentErrorMessage?: Scalars['String']
    __typename: 'InvoicePay'
}

export interface InvoicePaymentGroup {
    id: Scalars['ID']
    companyId: Scalars['String']
    postedAt: Scalars['Date']
    createdAt: Scalars['Date']
    updatedAt: Scalars['Date']
    deletedAt?: Scalars['Date']
    invoices: PaymentGroupLinkedInvoice[]
    bankTransactions: PaymentGroupLinkedBankTransaction[]
    expenses: PaymentGroupExpense[]
    actorType?: ActorType
    __typename: 'InvoicePaymentGroup'
}

export interface InvoicePaymentGroupByIdResponse {
    paymentGroup?: InvoicePaymentGroup
    __typename: 'InvoicePaymentGroupByIdResponse'
}

export interface InvoicePaymentGroupsByIdsResponse {
    paymentGroups: InvoicePaymentGroup[]
    __typename: 'InvoicePaymentGroupsByIdsResponse'
}

export interface InvoicePaymentGroupsResponse {
    paymentGroups: InvoicePaymentGroup[]
    __typename: 'InvoicePaymentGroupsResponse'
}

export interface InvoicePaymentGroupsUnclearedBalanceResponse {
    asOfDate: Scalars['Date']
    unclearedBalances: InvoicePaymentGroupUnclearedBalance[]
    __typename: 'InvoicePaymentGroupsUnclearedBalanceResponse'
}

export interface InvoicePaymentGroupUnclearedBalance {
    paymentGroup: InvoicePaymentGroup
    unclearedBalance: Amounts
    __typename: 'InvoicePaymentGroupUnclearedBalance'
}

export interface InvoicePaymentLink {
    id: Scalars['String']
    source: Scalars['String']
    integrationAccountId: Scalars['String']
    amount: Scalars['Float']
    currency: CurrencyCode
    refundedAt?: Scalars['Date']
    amountInHomeCurrency?: Scalars['Float']
    externalSourceId?: Scalars['String']
    saleTransactionId?: Scalars['String']
    refundSaleTransactionId?: Scalars['String']
    __typename: 'InvoicePaymentLink'
}

export interface InvoicePdf {
    id: Scalars['ID']
    location: Scalars['String']
    createdAt: Scalars['Date']
    sentAt?: Scalars['Date']
    issuedAt: Scalars['Date']
    isDraft: Scalars['Boolean']
    isVoided: Scalars['Boolean']
    __typename: 'InvoicePdf'
}

export interface InvoicesAggregations {
    invoicesCount: Scalars['Int']
    invoicesAverageValue: Scalars['Float']
    invoicesNetSales: Scalars['Float']
    __typename: 'InvoicesAggregations'
}

export interface InvoicesBalance {
    balance: Scalars['Float']
    count: Scalars['Int']
    __typename: 'InvoicesBalance'
}

export interface InvoiceSettings {
    logoImageLocation?: Scalars['String']
    currentAutoInvoiceNumber?: Scalars['Int']
    __typename: 'InvoiceSettings'
}

export interface InvoicesYearEnd {
    fiscalYearStartDate: Scalars['Date']
    fiscalYearEndDate: Scalars['Date']
    domainState: YearEndDomainState
    hubReportedDomainState?: YearEndDomainState
    tasks: InvoicesYearEndTask[]
    __typename: 'InvoicesYearEnd'
}

export type InvoicesYearEndTask = (AddMissingInvoicesTask | CloseOpenInvoicesTask | ConfirmArBalanceTask | LinkInvoicePaymentsTask) & { __isUnion?: true }

export type InvoicesYearEndTaskId = 'CLOSE_OPEN_INVOICES' | 'LINK_INVOICE_PAYMENTS' | 'ADD_MISSING_INVOICES' | 'CONFIRM_AR_BALANCE'

export interface InvoicesYearEndTasksResponse {
    yearEnd: InvoicesYearEnd[]
    __typename: 'InvoicesYearEndTasksResponse'
}

export type InvoicesYearEndTaskStatus = 'INACTIVE' | 'OPEN' | 'REOPENED' | 'PROCESSING' | 'CLOSED'

export interface InvoiceToPaymentGroups {
    invoiceId: Scalars['String']
    paymentGroups: InvoicePaymentGroup[]
    __typename: 'InvoiceToPaymentGroups'
}

export type IPaymentGroup = (InvoicePaymentGroup | OrderPaymentGroup) & { __isUnion?: true }

export type IrrelevantType = 'OPEN_AFTER_SPECIFIED_DATE' | 'CLOSED_DURING_THE_YEAR' | 'PERSONAL_ACCOUNT' | 'BUSINESS_ACCOUNT' | 'TRANSFERRED_TO_BUSINESS_AFTER_SPECIFIED_DATE' | 'TRANSFERRED_FROM_BUSINESS_DURING_THE_YEAR'

export interface IsGlobalRuleExistResult {
    exists: Scalars['Boolean']
    id?: Scalars['ID']
    __typename: 'IsGlobalRuleExistResult'
}

export interface IsInvitationCodeForRegisteredUserResponse {
    isRegisteredUser: Scalars['Boolean']
    __typename: 'IsInvitationCodeForRegisteredUserResponse'
}

export interface ItemReconciliationFinaloopSalesChannel {
    displayName: Scalars['String']
    integrationAccountName: Scalars['String']
    __typename: 'ItemReconciliationFinaloopSalesChannel'
}

export interface JournalEntryActions {
    firstAccount: ActionChange
    secondAccount: ActionChange
    __typename: 'JournalEntryActions'
}

export interface LastAccountingReportSyncResponse {
    status?: ReportSyncStatus
    exportedAt?: Scalars['Date']
    fileUrl?: Scalars['String']
    fileName?: Scalars['String']
    __typename: 'LastAccountingReportSyncResponse'
}

export interface LastTransaction {
    id: Scalars['String']
    postedAt: Scalars['Date']
    bankAccountId: Scalars['String']
    __typename: 'LastTransaction'
}

export interface LatestActiveCompanyUserResponse {
    user?: User
    latestIpAddress?: Scalars['String']
    latestGtmSourceIdentifiers?: Scalars['String']
    latestUserAgent?: Scalars['String']
    latestXGtmServerPreview?: Scalars['String']
    latestUtms?: Scalars['JSON']
    __typename: 'LatestActiveCompanyUserResponse'
}

export type LineItemDiscountType = 'SELLER_DISCOUNT' | 'PLATFORM_DISCOUNT'

export interface LineItemStatuses {
    voidStatus?: VoidStatus
    fulfillmentStatus: FulfillmentStatus
    restockStatus?: RestockStatus
    __typename: 'LineItemStatuses'
}

export interface LineItemTimelineAccountStateV3 {
    /** The quantity of the item */
    quantity: Scalars['Int']
    /** The amount of the item */
    amount: Scalars['Float']
    /** The amount of the item in home currency */
    amountInHomeCurrency: Scalars['Float']
    /** The seller discount amount of the item */
    sellerDiscountAmount: Scalars['Float']
    /** The seller discount amount of the item in home currency */
    sellerDiscountAmountInHomeCurrency: Scalars['Float']
    /** The platform discount amount of the item */
    platformDiscountAmount: Scalars['Float']
    /** The platform discount amount of the item in home currency */
    platformDiscountAmountInHomeCurrency: Scalars['Float']
    __typename: 'LineItemTimelineAccountStateV3'
}

export type LineItemTimeLineActionTypeV3 = 'PLACEMENT' | 'FULFILLMENT' | 'REFUND_BEFORE_FULFILLMENT' | 'REFUND_AFTER_FULFILLMENT' | 'OPENING_BALANCE'

export interface LineItemTimelineActionV3 {
    /** The date and time the action was posted */
    postedAt: Scalars['Date']
    /** The type of the action */
    action: LineItemTimeLineActionTypeV3
    /** The amount of the action */
    amount: Scalars['Float']
    /** The amount of the action in home currency */
    amountInHomeCurrency: Scalars['Float']
    /** The amount of the seller discount */
    sellerDiscountAmount: Scalars['Float']
    /** The amount of the seller discount in home currency */
    sellerDiscountAmountInHomeCurrency: Scalars['Float']
    /** The amount of the platform discount */
    platformDiscountAmount: Scalars['Float']
    /** The amount of the platform discount in home currency */
    platformDiscountAmountInHomeCurrency: Scalars['Float']
    /** The quantity of the action */
    quantity: Scalars['Int']
    __typename: 'LineItemTimelineActionV3'
}

export interface LinkedBankTransaction {
    bankTransaction: BankTransaction
    amount: Amounts
    __typename: 'LinkedBankTransaction'
}

export interface LinkedOrder {
    order: OrderV2
    amountInHomeCurrency: Scalars['Float']
    __typename: 'LinkedOrder'
}

export interface LinkInventoryPaymentGroupResponse {
    inventoryPaymentGroup?: InventoryPaymentGroup
    __typename: 'LinkInventoryPaymentGroupResponse'
}

export interface LinkInvoicePaymentGroupResponse {
    paymentGroup?: InvoicePaymentGroup
    __typename: 'LinkInvoicePaymentGroupResponse'
}

export interface LinkInvoicePaymentsTask {
    id: InvoicesYearEndTaskId
    status: InvoicesYearEndTaskStatus
    stateKey: Scalars['String']
    currentInvoicesHash: Scalars['String']
    state: LinkInvoicePaymentsTaskState
    history?: (LinkInvoicePaymentsTaskStateChangeLog | undefined)[]
    __typename: 'LinkInvoicePaymentsTask'
}

export interface LinkInvoicePaymentsTaskState {
    confirmedInvoicesHash?: Scalars['String']
    __typename: 'LinkInvoicePaymentsTaskState'
}

export interface LinkInvoicePaymentsTaskStateChangeLog {
    id: Scalars['ID']
    createdAt: Scalars['Date']
    updaterType: YearEndStateUpdaterType
    changedByUid?: Scalars['String']
    reason?: Scalars['String']
    oldValue?: LinkInvoicePaymentsTaskState
    newValue?: LinkInvoicePaymentsTaskState
    __typename: 'LinkInvoicePaymentsTaskStateChangeLog'
}

export interface LinkOrderGroupResponse {
    orderGroup?: OrderGroup
    __typename: 'LinkOrderGroupResponse'
}

export interface LinkOrderPaymentGroupResponse {
    paymentGroup?: OrderPaymentGroup
    __typename: 'LinkOrderPaymentGroupResponse'
}

export interface ListAssembliesResult {
    assemblies: Assembly[]
    hasNext: Scalars['Boolean']
    __typename: 'ListAssembliesResult'
}

export interface ListAssemblyItemsResult {
    assemblyItems: AssemblyListItem[]
    __typename: 'ListAssemblyItemsResult'
}

export type ListAssemblyItemsSortDirection = 'ASC' | 'DESC'

export type ListAssemblyItemsSortField = 'PRODUCT_NAME' | 'RECIPE_NAME' | 'DATE' | 'AMOUNT' | 'ASSEMBLY_TYPE'

export interface ListFailingValidationCompaniesResponse {
    companies?: ValidationFailingCompany[]
    __typename: 'ListFailingValidationCompaniesResponse'
}

export interface ListManualAssembliesResult {
    manualAssemblies: ManualAssembly[]
    __typename: 'ListManualAssembliesResult'
}

export interface Loan {
    id: Scalars['ID']
    company: Company
    source?: Scalars['String']
    integrationAccountId?: Scalars['String']
    externalSourceId?: Scalars['String']
    integrationAccountName?: Scalars['String']
    latestActorType?: ActorType
    latestActorId?: Scalars['String']
    type?: LoanType
    lender?: NewLender
    currency?: CurrencyCode
    postedAt?: Scalars['Date']
    direction?: LoanDirection
    internalNote?: Scalars['String']
    isShortTerm?: Scalars['Boolean']
    amount?: Scalars['Float']
    totalAmount?: Scalars['Float']
    amountInHomeCurrency?: Scalars['Float']
    outstandingAmount?: Scalars['Float']
    accruedInterest?: Scalars['Float']
    unrecognizedFees?: Scalars['Float']
    prepaymentLiabilityAmount?: Scalars['Float']
    status?: LoanStatus
    userActionStatus?: LoanUserActionStatus
    treatmentStatus?: LoanTreatmentStatus
    acknowledgedInternallyAt?: Scalars['Date']
    acknowledgedInternallyBy?: Scalars['String']
    paidOffAt?: Scalars['Date']
    lastManuallyHandledAt?: Scalars['Date']
    lastManuallyHandledBy?: Scalars['String']
    attachments?: LoanAttachment[]
    createdBy?: Scalars['String']
    createdById?: Scalars['String']
    workingPaperLink?: Scalars['String']
    internalOwner?: Scalars['String']
    updatedBy?: Scalars['String']
    lockedAt?: Scalars['Date']
    lastSeenByClientAt?: Scalars['Date']
    deletedAt?: Scalars['Date']
    createdAt: Scalars['Date']
    updatedAt: Scalars['Date']
    restoredAt?: Scalars['Date']
    directionSource?: LoanPropertySource
    merchantSource?: LoanPropertySource
    postedAtSource?: LoanPropertySource
    amountSource?: LoanPropertySource
    interestDays?: LoanInterestDays
    repaymentType?: LoanRepaymentType
    repaymentFrequency?: LoanRepaymentFrequency
    repaymentRate?: Scalars['Float']
    interestRateType?: LoanInterestRateType
    interestRate?: Scalars['Float']
    gracePeriod?: Scalars['Int']
    catchUpPeriod?: Scalars['Int']
    catchUpPercent?: Scalars['Float']
    catchUpAmount?: Scalars['Float']
    originationFees?: Scalars['Float']
    prepaymentFees?: Scalars['Float']
    feeRate?: Scalars['Float']
    dataRequestType?: LoanDataRequestType
    recurringDataFrequency?: LoanRecurringDataFrequency
    instantRepaymentMethod?: LoanInstantRepaymentMethod
    isIndexLinked?: Scalars['Boolean']
    interestType?: LoanInterestType
    variableInterestUpdatePeriod?: LoanVariableInterestUpdatePeriod
    variableInterestSpread?: Scalars['Float']
    variableInterestBase?: LoanVariableInterestBase
    compoundFrequency?: LoanCompoundFrequency
    indexType?: LoanIndexType
    termDurationValue?: Scalars['Int']
    termDurationUnit?: LoanTermDuration
    modifiedFields?: Scalars['String'][]
    manualEventsGroup?: LoanManualEvent[]
    billPaymentEvents?: LoanBillPaymentEvent[]
    isEarlyRepaymentDiscount?: Scalars['Boolean']
    earlyRepaymentDiscounts?: EarlyRepaymentDiscount[]
    userFollowUp2?: UserFollowUp
    pendingDelete?: Scalars['Boolean']
    pendingRestoreAcknowledgement?: Scalars['Boolean']
    lastUserMoveToProcessingAt?: Scalars['Date']
    isHidden?: Scalars['Boolean']
    firstEventDate?: Scalars['Date']
    firstPaymentDate?: Scalars['Date']
    lastPaymentDate?: Scalars['Date']
    businessName?: Scalars['String']
    isBillPaymentEventAttached?: Scalars['Boolean']
    accountingEvents?: LoanAccountingEvent[]
    bankAccount?: BankAccount
    neededReconciliationAt?: Scalars['Date']
    lastOngoingTreatmentAt?: Scalars['Date']
    hasRollOverEvent?: Scalars['Boolean']
    __typename: 'Loan'
}

export interface LoanAccountingEvent {
    id: Scalars['ID']
    amount: Scalars['Float']
    postedAt: Scalars['Date']
    memo?: Scalars['String']
    businessEventActionsConfiguration: BusinessEventActionsConfiguration
    customTags?: Scalars['JSONObject']
    latestActorType: ActorType
    latestActorId: Scalars['String']
    updatedAt: Scalars['Date']
    createdAt: Scalars['Date']
    businessEventData?: LoanBusinessEventData
    __typename: 'LoanAccountingEvent'
}

export type LoanAccountRoleEffectDirection = 'INCREASE' | 'DECREASE'

export interface LoanAffiliatedTransactionEvent {
    id: Scalars['ID']
    bankTransaction: BankTransaction
    companyAffiliate: CompanyAffiliate
    amount: Scalars['Float']
    postedAt: Scalars['Date']
    __typename: 'LoanAffiliatedTransactionEvent'
}

export interface LoanAlreadyExistsResult {
    loan: Loan
    __typename: 'LoanAlreadyExistsResult'
}

export type LoanAmountEffect = 'DECREASE' | 'INCREASE'

export interface LoanAttachment {
    id: Scalars['ID']
    name: Scalars['String']
    createdAt: Scalars['Date']
    type?: LoanAttachmentType
    latestActorId?: Scalars['String']
    isHidden: Scalars['Boolean']
    __typename: 'LoanAttachment'
}

export interface LoanAttachmentError {
    message: Scalars['String']
    type: LoanAttachmentErrorType
    attachment?: Scalars['String']
    attachmentType?: LoanAttachmentType
    additionalInfo?: AdditionalErrorInfo
    attachmentUrl?: Scalars['String']
    __typename: 'LoanAttachmentError'
}

export type LoanAttachmentErrorType = 'LOAN_DATE_MISMATCH' | 'LOAN_AMOUNT_MISMATCH' | 'PARSING_FAILED' | 'VALIDATION_FAILED' | 'OTHER'

export type LoanAttachmentType = 'AGREEMENT' | 'AMORTIZATION_SCHEDULE' | 'STATEMENT' | 'REPAYMENT_SCHEDULE' | 'AMENDMENT' | 'RECONCILIATION'

export interface LoanBillEvent {
    id: Scalars['ID']
    __typename: 'LoanBillEvent'
}

export interface LoanBillPaymentEvent {
    id: Scalars['ID']
    bill: Bill
    paymentId?: Scalars['ID']
    postedAt: Scalars['Date']
    amount: Scalars['Float']
    __typename: 'LoanBillPaymentEvent'
}

export interface LoanBusinessEvent {
    id: Scalars['ID']
    postedAt: Scalars['Date']
    eventType?: Scalars['String']
    memo?: Scalars['String']
    actions?: Scalars['JSONObject'][]
    integrationAccountId?: Scalars['String']
    amount: Scalars['Float']
    isMigrationAdjustment?: Scalars['Boolean']
    __typename: 'LoanBusinessEvent'
}

export interface LoanBusinessEventData {
    id: Scalars['ID']
    __typename: 'LoanBusinessEventData'
}

export interface LoanComment {
    id: Scalars['ID']
    text: Scalars['String']
    createdAt: Scalars['Date']
    __typename: 'LoanComment'
}

export type LoanCompoundFrequency = 'CONTINUOUSLY' | 'DAILY' | 'WEEKLY' | 'MONTHLY' | 'QUARTERLY' | 'YEARLY'

export interface LoanCreationFailureResult {
    reason?: Scalars['String']
    __typename: 'LoanCreationFailureResult'
}

export type LoanCreationResult = (LoanUpdatedResult | LoanCreationFailureResult | LoanAlreadyExistsResult | LoanTransactionProcessedOnlineResult) & { __isUnion?: true }

export type LoanDataRequestType = 'ONE_TIME' | 'RECURRING'

export type LoanDirection = 'TAKEN' | 'GIVEN' | 'ROLLING'

export type LoanEvent = (LoanManualEvent | BankTransaction | LoanBillEvent | LoanBusinessEvent | LoanBillPaymentEvent | Payout | Topup | LoanAffiliatedTransactionEvent | LoanAccountingEvent) & { __isUnion?: true }

export interface LoanEventDefinition {
    id: Scalars['ID']
    name: Scalars['String']
    isSpreadable?: Scalars['Boolean']
    __typename: 'LoanEventDefinition'
}

export type LoanEventFilter = 'MANUAL' | 'AUTOMATED' | 'TRANSACTION' | 'BILL' | 'BILL_PAYMENT' | 'BUSINESS'

export type LoanEventRecurrence = 'ONCE' | 'WEEKLY' | 'MONTHLY'

export type LoanIndexType = 'CONSUMER_PRICE_INDEX'

export type LoanInstantRepaymentMethod = 'DIRECT' | 'INDIRECT'

export type LoanInterestDays = 'DAYS_365' | 'DAYS_360' | 'ACTUAL_DAYS'

export type LoanInterestRateType = 'FIXED' | 'VARIABLE'

export type LoanInterestType = 'SIMPLE' | 'COMPOUND'

export type LoanLenderType = 'CompanyAffiliate' | 'Vendor' | 'Institution'

export interface LoanManualEvent {
    id: Scalars['ID']
    eventDefinition: LoanEventDefinition
    amount: Scalars['Float']
    postedAt?: Scalars['Date']
    memo?: Scalars['String']
    recurrenceSettings: RecurrenceSettings
    spreadData?: LoanManualEventSpreadData
    latestActorType: ActorType
    latestActorId: Scalars['String']
    updatedAt: Scalars['Date']
    createdAt: Scalars['Date']
    effect?: LoansEventsEffectConfiguration
    accountingEvents?: LoanAccountingEvent[]
    __typename: 'LoanManualEvent'
}

export interface LoanManualEventSpreadData {
    startDate: Scalars['Date']
    endDate: Scalars['Date']
    __typename: 'LoanManualEventSpreadData'
}

export type LoanOutstandingAmountAffect = 'DECREASE' | 'INCREASE'

export interface LoanOutstandingAmountOnDate {
    loanId: Scalars['ID']
    outstandingAmount?: Scalars['Float']
    __typename: 'LoanOutstandingAmountOnDate'
}

export type LoanPropertySource = 'AUTOMATIC' | 'MANUAL'

export type LoanRecurringDataFrequency = 'MONTHLY' | 'QUARTERLY' | 'YEARLY'

export interface LoanRelationship {
    id: Scalars['ID']
    isManuallyAttached?: Scalars['Boolean']
    isLocked?: Scalars['Boolean']
    event: LoanEvent
    __typename: 'LoanRelationship'
}

export type LoanRepaymentFrequency = 'DAY' | 'WEEK' | 'MONTH' | 'QUARTER' | 'YEAR'

export type LoanRepaymentType = 'AMORTIZATION' | 'BALLOON' | 'INTEREST_ONLY' | 'FIXED_PRINCIPAL' | 'ACCRUED_INTEREST_FIRST'

export interface LoansByIdsResponse {
    loans: Loan[]
    __typename: 'LoansByIdsResponse'
}

export interface LoansEventsEffectConfiguration {
    id: Scalars['ID']
    event: LoanEventDefinition
    loanType: LoanType
    isShortTerm: Scalars['Boolean']
    direction: LoanDirection
    minGracePeriod?: Scalars['Int']
    repaymentType?: LoanRepaymentType
    lender?: NewLender
    memoTemplate?: Scalars['String']
    dateTemplate?: Scalars['String']
    businessEventActionsConfiguration: BusinessEventActionsConfiguration
    loanOutstandingAmountAffect?: LoanOutstandingAmountAffect
    loanAmountAffect?: LoanAmountEffect
    latestActorType: ActorType
    latestActorId: Scalars['String']
    createdAt: Scalars['Date']
    updatedAt: Scalars['Date']
    __typename: 'LoansEventsEffectConfiguration'
}

export type LoanSortDirection = 'asc' | 'desc'

export type LoanSource = 'INTEGRATION' | 'TRANSACTION' | 'BACKOFFICE' | 'APPLICATION' | 'BILLS' | 'BALANCE_TRANSACTION'

export interface LoansResponse {
    loans: Loan[]
    page: Scalars['Int']
    __typename: 'LoansResponse'
}

export type LoanStatus = 'PREACTIVE' | 'ACTIVE' | 'PAID_OFF' | 'FORGIVEN'

export type LoanTermDuration = 'DAY' | 'WEEK' | 'MONTH' | 'QUARTER' | 'YEAR'

export interface LoanTransactionLockStatus {
    transactionId: Scalars['ID']
    isLocked?: Scalars['Boolean']
    __typename: 'LoanTransactionLockStatus'
}

export interface LoanTransactionProcessedOnlineResult {
    reason?: Scalars['String']
    __typename: 'LoanTransactionProcessedOnlineResult'
}

export type LoanTreatmentStatus = 'OPEN' | 'RECURRING' | 'DONE' | 'MISSING_DATA' | 'DELETED' | 'AUTO'

export type LoanType = 'MERCHANT_CASH_ADVANCE' | 'TERM_LOAN' | 'REVENUE_BASED_CREDIT' | 'FACTORING' | 'AP_FINANCING' | 'LINE_OF_CREDIT' | 'INSTANT_ADVANCE' | 'SALE_OF_FUTURE_REVENUE' | 'CAR_LOAN' | 'INVENTORY_FINANCING' | 'CONVERTIBLE' | 'RELATED_PARTY_LOAN' | 'RELATED_PARTY_BALANCE' | 'DUE_TO_FROM_OWNER' | 'DUE_TO_FROM_CONTRACTOR' | 'DUE_TO_FROM_EMPLOYEE' | 'RELATED_PARTY_CONVERTIBLE'

export interface LoanUpdatedResult {
    loans: Loan[]
    __typename: 'LoanUpdatedResult'
}

export type LoanUserActionStatus = 'ACTION_REQUIRED' | 'PROCESSING' | 'APPROVED' | 'DELETED'

export type LoanUserFollowUpType = 'WRONG_AGREEMENT' | 'WRONG_AMORTIZATION_SCHEDULE' | 'INVITATION_NOT_RECEIVED' | 'INVITATION_STEP_2' | 'STEP_2_NOT_RECEIVED' | 'WRONG_REPEYMENT_SCHEDULE' | 'WRONG_PAYMENT_SCHEDULE' | 'BANK_NOT_CONNECTED' | 'REQUEST_FOR_STATEMENTS' | 'MISSING_AMENDMENT' | 'NOT_THE_STATEMENT' | 'NOT_THE_RECONCILIATION_REPORT' | 'MISSING_THE_TRANSACTION_STATEMENT' | 'WRONG_PAYMENT_HISTORY' | 'MISSING_STATEMENT' | 'RECONCILIATION_NEEDED'

export type LoanVariableInterestBase = 'PRIME' | 'SOFR'

export type LoanVariableInterestUpdatePeriod = 'MONTH' | 'QUARTER' | 'YEAR_2' | 'YEAR_5' | 'CUSTOM'

export type LockAction = 'LOCK' | 'UNLOCK'

export type LockConditionStatus = 'Ok' | 'NotOk'

export interface LockedStatus {
    year: Scalars['Int']
    lockedAt: Scalars['String']
    __typename: 'LockedStatus'
}

export interface LockLoanResult {
    success: Scalars['Boolean']
    message?: Scalars['String']
    __typename: 'LockLoanResult'
}

export type LockType = 'lock' | 'unlock'

export interface LostAndFoundCogs {
    amount: Scalars['Float']
    lost: Scalars['Int']
    found: Scalars['Int']
    monthlyBreakdown: LostAndFoundMonthlyBreakdown[]
    __typename: 'LostAndFoundCogs'
}

export interface LostAndFoundDailyBreakdown {
    date: Scalars['Date']
    lost: Scalars['Int']
    found: Scalars['Int']
    reason?: AdjustmentsReason[]
    __typename: 'LostAndFoundDailyBreakdown'
}

export interface LostAndFoundMonthlyBreakdown {
    date: Scalars['Date']
    lost: Scalars['Int']
    found: Scalars['Int']
    dailyData: LostAndFoundDailyBreakdown[]
    __typename: 'LostAndFoundMonthlyBreakdown'
}

export interface MachineClassificationJob {
    finishedAt: Scalars['Date']
    __typename: 'MachineClassificationJob'
}

export type ManageBalanceSheetSetupStatus = 'ERROR' | 'RESET_SUCCESSFULLY' | 'CREATED_SUCCESSFULLY' | 'OPEN_SUCCESSFULLY' | 'COMPANY_NOT_FOUND'

export interface ManageCompanyYearEndStateResponse {
    status: ManageYearEndOperationStatus
    message?: Scalars['String']
    __typename: 'ManageCompanyYearEndStateResponse'
}

export type ManagementMethod = 'PURCHASE_BASED' | 'SALES_BASED' | 'SALES_BASED_UNIT_TRACKING'

export interface ManagementMethodYearEndPeriod {
    method: ManagementMethod
    startDate: Scalars['Date']
    endDate: Scalars['Date']
    __typename: 'ManagementMethodYearEndPeriod'
}

export type ManageYearEndOperations = 'RESET' | 'INITIALISE' | 'SETUP' | 'OPEN' | 'CLOSE' | 'SET_NA' | 'SET_INACTIVE' | 'SET_USER_ACTIVE' | 'SET_USER_INACTIVE'

export type ManageYearEndOperationStatus = 'ERROR' | 'NOT_AFFECTED' | 'SUCCESSFULL' | 'NOT_FOUND'

export interface ManualAssembly {
    id: Scalars['String']
    companyId: Scalars['String']
    product: Product
    date: Scalars['Date']
    warehouse: Warehouse
    recipe: Recipe
    unitsToAssemble: Scalars['Int']
    displayName?: Scalars['String']
    serialNumber: Scalars['Int']
    deletedReason?: AssemblyDeletedReason
    deletedAt?: Scalars['Date']
    unpaidAmounts: UnpaidAmountPerAffiliatedEntity[]
    inventoryPaymentGroupLinks: InventoryPaymentGroupLink[]
    __typename: 'ManualAssembly'
}

export interface ManualAssemblyAction {
    quantity: Scalars['Float']
    id: Scalars['String']
    date: Scalars['Date']
    type: Scalars['String']
    manualAssembly: ManualAssembly
    __typename: 'ManualAssemblyAction'
}

export interface ManualAssemblyBreakdown {
    origin: ManualAssemblyWithBreakdown
    analytics: IncomingInventoryAnalytics
    __typename: 'ManualAssemblyBreakdown'
}

export interface ManualAssemblyDuplicateError {
    date: Scalars['Date']
    __typename: 'ManualAssemblyDuplicateError'
}

export interface ManualAssemblyWithBreakdown {
    assembly: ManualAssembly
    warehouse: Warehouse
    date: Scalars['Date']
    breakdown: RecipeBreakdown[][][]
    __typename: 'ManualAssemblyWithBreakdown'
}

export interface ManualCompanyLoanCreationResult {
    loan: CompanyLoan
    __typename: 'ManualCompanyLoanCreationResult'
}

export type ManualEquityEntity = (HolderTransaction | HolderShare | HolderCapitalInvestment | HolderSafeInvestment) & { __isUnion?: true }

export interface ManualLoanCreationResult {
    loan: Loan
    __typename: 'ManualLoanCreationResult'
}

export interface ManualTransactionsAttachToLoanResult {
    loan: CompanyLoan
    transactions: (BankTransaction | undefined)[]
    __typename: 'ManualTransactionsAttachToLoanResult'
}

export interface ManualTransactionsAttachToLoansResult {
    loans: CompanyLoan[]
    transactions: (BankTransaction | undefined)[]
    __typename: 'ManualTransactionsAttachToLoansResult'
}

export interface MarkOrderLineItemsAsVoidedResponse {
    success: Scalars['Boolean']
    failedOrderIds: (Scalars['ID'] | undefined)[]
    __typename: 'MarkOrderLineItemsAsVoidedResponse'
}

export interface MarkOrdersAsCOGSResponse {
    orders: OrderV2[]
    __typename: 'MarkOrdersAsCOGSResponse'
}

export interface MarkOrdersAsGiveawayResponse {
    orders: OrderV2[]
    __typename: 'MarkOrdersAsGiveawayResponse'
}

export interface MarkOrdersAsHistoricallyPaidResponse {
    orders: OrderV2[]
    __typename: 'MarkOrdersAsHistoricallyPaidResponse'
}

export interface MarkOrdersAsOvercollectedResponse {
    orders: OrderV2[]
    __typename: 'MarkOrdersAsOvercollectedResponse'
}

export interface MarkOrdersAsUncollectibleResponse {
    orders: OrderV2[]
    __typename: 'MarkOrdersAsUncollectibleResponse'
}

export type MarkOrderType = 'UN_COLLECTIBLE' | 'OVER_COLLECTIBLE' | 'VOIDED'

export type Merchant = (Vendor | CustomerV2 | CompanyAffiliate | Institution) & { __isUnion?: true }

export interface MerchantsBankTransactionStats {
    merchantsCount: Scalars['Int']
    transactionsCount: Scalars['Int']
    transactionsSum: Scalars['Float']
    uncategorizedTransactionsCount: Scalars['Int']
    uncategorizedTransactionsSum: Scalars['Float']
    transactionBusinessEvents: Scalars['String'][]
    uncategorizedTransactionBusinessEvents: Scalars['String'][]
    __typename: 'MerchantsBankTransactionStats'
}

export type MerchantType = 'VENDOR' | 'CUSTOMER' | 'COMPANY_AFFILIATE' | 'INSTITUTION'

export interface MeResponse {
    user: User
    __typename: 'MeResponse'
}

export interface MergedProduct {
    id: Scalars['String']
    companyId: Scalars['String']
    finaloopId: Scalars['String']
    displayName?: Scalars['String']
    imageUrl?: Scalars['String']
    sku?: Scalars['String']
    price?: Scalars['Float']
    lineOfBusinessId?: Scalars['String']
    string?: Scalars['String']
    listedChannels: SalesChannel[]
    appliedCosts: ProductAppliedCost[]
    dailySalesData: SalesChannelDailySalesData[]
    totalSold: Scalars['Int']
    avgCostPerUnit?: Scalars['Float']
    representativeFinaloopProductId: Scalars['String']
    mergedWithProducts: Product[]
    canEditLatestAppliedCost?: Scalars['Boolean']
    isFractional: Scalars['Boolean']
    isHidden: Scalars['Boolean']
    salesData: SalesData
    rawRecipes: Recipe[]
    componentOfProducts: Product[]
    analyticsOverview: ProductAnalyticsOverview
    warehousesAnalyticsOverview: ProductWarehousesAnalyticsOverview[]
    tags: Scalars['String'][]
    isDataSyncing: Scalars['Boolean']
    mergeHistory: ProductMergeHistoryItem[]
    isDropshipping?: Scalars['Boolean']
    __typename: 'MergedProduct'
}

export type MergeProductsV3Response = (MergeProductsV3Result | MergeProductsValidationError) & { __isUnion?: true }

export interface MergeProductsV3Result {
    splitResult?: Product[]
    mergeResult?: Product
    __typename: 'MergeProductsV3Result'
}

export interface MergeProductsValidationError {
    message: Scalars['String']
    __typename: 'MergeProductsValidationError'
}

export type MergeResult = 'SUCCESS' | 'FAILURE'

export interface MergeWarehousesError {
    error: Scalars['String']
    __typename: 'MergeWarehousesError'
}

export type MergeWarehousesResult = (MergeWarehousesSuccess | MergeWarehousesError) & { __isUnion?: true }

export interface MergeWarehousesSuccess {
    isMerged: Scalars['Boolean']
    __typename: 'MergeWarehousesSuccess'
}

export type MetricRangeGroupBy = 'year' | 'month' | 'week' | 'day'

export interface MissingCostsInPeriodResponse {
    hasMissingCosts: Scalars['Boolean']
    __typename: 'MissingCostsInPeriodResponse'
}

export type MoneyDirection = 'IN' | 'OUT' | 'ALL'

export interface Movement {
    stockSituation: InventoryBatch[]
    direction: MovementDirection
    batches: InventoryBatch[]
    unavailableQuantity?: Scalars['Int']
    action: WarehouseAction
    __typename: 'Movement'
}

export type MovementDirection = 'IN' | 'IN_FIRST' | 'OUT'

export interface MovementIndirectCost {
    type: MovementIndirectCostType
    amount: Scalars['Float']
    __typename: 'MovementIndirectCost'
}

export type MovementIndirectCostType = 'GENERAL' | 'VENDOR_FEES' | 'DUTIES_AND_TAX' | 'CUSTOM_FEES_AND_SERVICES' | 'INSURANCE' | 'PRODUCTION_COSTS' | 'DISCOUNT' | 'SHIPPING' | 'ASSEMBLY' | 'SHIPPING_SURCHARGE'

export interface Mutation {
    /** @deprecated Use upsertAccrual instead */
    createOrUpdateAccrual: (CreateOrUpdateAccrualResult | undefined)[]
    /** @deprecated Use deleteAccrualV2 instead */
    deleteAccrual?: Accrual
    upsertAccrual: AccrualV2
    deleteAccrualV2?: AccrualV2
    /** @deprecated Use cancelAccrualV2 instead */
    cancelAccrual?: Accrual
    cancelAccrualV2?: AccrualV2
    sendAnalyticsEvent: SendAnalyticsEventResult
    dispatchEshedTest: SendAnalyticsEventResult
    updateBalanceSheetSetup: UpdateBalanceSheetSetupResponse
    updateBalanceSheetSetupItem: UpdateBalanceSheetSetupItemResponse
    resetBalanceSheetSetup: ResetBalanceSheetSetupResponse
    openBalanceSheetSetup: OpenBalanceSheetSetupResponse
    updateBankAccountClosingBalance: BankAccount
    createBankAccountBalanceAdjustment: BankAccount
    deleteBankAccountBalanceAdjustment: BankAccount
    setBankAccountsLatestEventIds: BankAccount[]
    createBankAccount: BankAccount
    copyBankAccount: BankAccount
    updateBankAccount: BankAccount
    /** @deprecated This mutation is deprecated, use replaceBankAccountLocksByType instead. */
    replaceBankAccountLocks: BankAccount
    replaceBankAccountLocksByType: BankAccount
    updateBankAccountsMergeStatus: SuspectedBankAccountDuplication
    lockBankAccount: BankAccount
    createInstitution: Institution
    updateInstitution: Institution
    updateInstitutionDataConfig: Institution
    createInstitutionMapping: InstitutionMapping
    updateInstitutionMapping: InstitutionMapping
    uploadBankStatement: UploadBankStatementResponse
    updateBankReconciliationRequestMessage: BankReconciliationRequest
    updateBankReconciliationRequestStatus: BankReconciliationRequest
    upsertBankStatementParsingRequest: BankStatementParsingRequest
    upsertBankStatementParsingResults: BankStatementParsingResult
    updateBankStatementParsingResultStatus: BankStatementParsingResult
    writeBankingMetric: Scalars['Int']
    deleteBankReconciliationRequestConfiguration: GenericResponse
    createAdminBankReconciliationRequest: Scalars['ID']
    convertBankAccountToManual: BankAccount
    convertBankAccountBackFromManual?: GenericResponse
    markReconciliationRequestFileAsNotRelevant: GenericResponse
    uploadFileToBankReconciliationRequest: GenericResponse
    moveBankStatementFilesToAnotherBankAccount: BankStatementFile[]
    updateBankStatementFileProcessingLogs: BankStatementFile
    stopImportingDataForBankAccount: BankAccount
    stopImportingDataForBankAccountNew: BankAccount
    createBankAccountStatementForStopImport: BankAccountStatementRequest
    createManualBankAccount: BankAccount
    deleteBankAccounts: Scalars['Boolean']
    submitBankReconciliationRequestResolution: BankStatementRequestResolutionResponse
    markBankReconciliationRequestAsRelevant?: BankReconciliationRequest
    triggerBankReconciliationRequests?: BankReconciliationRequest[]
    updateBankReconciliationStatementAutoProcessingResults: Scalars['Boolean']
    uploadReportedTransactions: GenericResponse
    createBankStatementFileUpload: BankStatementFile
    categorizeBankTransactions: BankTransactionCategorizationResult[]
    createCustomerCategorizationRule: CreateCustomerCategorizationRuleResult
    updateBankTransactionMemo: BankTransaction
    addBankTransactionAttachment: BankTransaction
    deleteBankTransactionAttachment: BankTransaction
    finalizeAskTheUserFlow: FinalizeAskTheUserFlowResult
    askTheUserNotificationService: AskTheUserNotificationServiceResult
    scheduleAtuTransactionsResultProcessing: ScheduleAtuTransactionsResultProcessingResult
    createGlobalVendorMappingRule: GlobalVendorMappingRule[]
    createBankTransactionsUpload: BankTransactionsUpload
    toggleBankTransactionAccrual: ToggleBankTransactionAccrualResult
    upsertBankTransactionLocalRule: CreateTeamCategorizationRuleResult
    createGlobalRule?: CreateGlobalRuleResult
    attemptToClassifyTransactions: ClassificationResult[]
    attemptToClassifyTransactionsWithPairedEntities: ClassificationResult[]
    deleteBankTransactionsByBankAccountIds: Scalars['Boolean']
    deleteBankTransactionsInternal: AlterBankTransactionsLifecycleStateResult
    restoreBankTransactionsInternal: AlterBankTransactionsLifecycleStateResult
    moveBankAccountUploadsToAnotherBankAccount: BankTransactionsUpload[]
    appendProcessingLogToBankTransactionsUpload: BankTransactionsUpload
    submitTransactionsFileToBankTransactionsUpload: SubmitTransactionsFileToBankTransactionsUploadResponse
    clearExpiredDoItLaterResults: AffectedTransactionsIds
    addClassificationTag: ClassificationTag
    editClassificationTag: ClassificationTag
    updateAssociatedBankTransactionsFile: UpdateAssociatedBankTransactionsFileResponse
    processCheckoutWebhookEvents: Scalars['Boolean']
    syncStripeOffers?: Scalars['Boolean']
    syncStripeTier1Offer?: Scalars['Boolean']
    createCheckoutSession: CreateCheckoutSessionResponse
    pollCheckoutSessionStatus: Company
    toggleBillHasAccrual: Scalars['Boolean']
    createOrGetBusinessEventDefinition: BusinessEventActionsConfiguration
    createAccountRole: AccountRole
    updateBooksStartTime: SuccessResult
    createFileUploadUrl: FileUploadUrlResult
    updateCompanyAccountingMethod: Company
    updateEstimatedProjectedRevenue: Company
    toggleOrdersZeroNetBalance: SuccessResult
    toggleRecognizeZeroNetOrdersAsGiveaways?: Scalars['Boolean']
    createImageUploadUrl: ImageUploadUrlResult
    setSettings: SuccessResult
    upsertCompanyAddress: CompanyAddress
    deleteCompanyAddress?: Scalars['Boolean']
    updateOnboardingStatus: OnboardingStatus
    setFiscalYearData?: Scalars['Boolean']
    updateCompanyNamesAndNotifyHandler: Company
    updateCompany: Company
    setFiscalYearStart?: Scalars['Boolean']
    createCompany: Company
    updateCompanyPayingStatus: Company
    syncCompany: Scalars['Boolean']
    lockCompany: CompanyLockStatus
    unlockCompany?: CompanyLockStatus
    lockCompanyV2: Company
    unlockCompanyV2: Company
    removeDataRestriction: Company
    validationCycle: ValidationCycle
    completeValidationCycle: Scalars['Boolean']
    sendValidationNotification: Scalars['Boolean']
    storeValidation: Scalars['Boolean']
    grantEntitiesLockedPeriodBypasses: Scalars['Boolean']
    createCompanyAffiliate: CompanyAffiliate
    updateCompanyAffiliate: CompanyAffiliate
    deleteCompanyAffiliate: CompanyAffiliate
    upsertHolderShare: HolderShare
    deleteHolderShare: HolderShare
    upsertHolderCapitalInvestment: HolderCapitalInvestment
    deleteHolderCapitalInvestment: HolderCapitalInvestment
    addRoleToAffiliatedEntity: AddRoleToAffiliatedEntityResult
    upsertManualEquityEvent: ManualEquityEntity
    deleteManualEquityEvents: ManualEquityEntity[]
    companyIntegrationBulkUpdate: (CompanyIntegration | undefined)[]
    syncDataPlatformIntegration: SyncDataPlatformIntegrationResponse
    deleteBankConnection: Scalars['Boolean']
    disconnectPayrollConnection: Scalars['Boolean']
    disconnectConnection: Scalars['Boolean']
    confirmRoleForPaymentGateway: Scalars['Boolean']
    unclassifyIntegrationTransfers?: IntegrationTransfer[]
    markIntegrationTransfersAsDiscrepancy?: IntegrationTransfer[]
    classifyIntegrationTransfer: IntegrationTransfer[]
    createIntegrationTransferRule: IntegrationTransferRule
    scheduleAtuIntegrationTransfersResultProcessing: ScheduleAtuIntegrationTransfersResultProcessingResult
    refreshSkuAmbiguity: Scalars['Boolean']
    triggerCOGSFromScratch: Scalars['Boolean']
    deleteFifoGroups: Scalars['Boolean']
    bulkRecoveryUnitsTracking: BulkRecoveryUnitsTrackingResult
    syncInventoryIntegrationFulfillmentSetting: Scalars['Boolean']
    triggerBigValidationReconciliation: Scalars['Boolean']
    triggerInventoryPurchasesReconciliation: Scalars['Boolean']
    triggerFifoReconciliation: Scalars['Boolean']
    updateOnDemandAssemblyCosts: Scalars['Boolean']
    updateOnDemandAssemblyVendorCosts: Scalars['Boolean']
    validateInventoryPaymentGroupOnEntityChange: Scalars['Boolean']
    setWarehouseDropshippingSettings: Warehouse
    reconcileInventoryPurchasesFromTransactions: Scalars['Boolean']
    reconcileInventoryPurchasesFromBills: Scalars['Boolean']
    reconcileInventoryPurchasesFromBusinessEvents: Scalars['Boolean']
    reconcileAllPayrollInventoryPurchases: Scalars['Boolean']
    reconcileAllContractorPaymentInventoryPurchases: Scalars['Boolean']
    reconcileAllBillInventoryPurchases: Scalars['Boolean']
    reconcileAllTransactionInventoryPurchases: Scalars['Boolean']
    reReconcileInventoryPurchases: Scalars['Boolean']
    shopifyItemsValidationBlacklistSku: Scalars['Boolean']
    shopifyItemsValidationBlacklistSalesChannel: Scalars['Boolean']
    markOrderWithoutFinancialEvents: Scalars['Boolean']
    markOrdersWithoutFinancialEvents: Scalars['Int']
    generateFifoValidation: GenerateFifoValidationResponse
    generateNoUnitsValidation: GenerateNoUnitsValidationResponse
    ackInvalidNoUnitsValidation: Scalars['Boolean']
    deleteNoUnitsValidationInvalidAck: Scalars['Boolean']
    generateBigValidation: GenerateBigValidationResponse
    runNoUnitsChangesDetector: Scalars['Boolean']
    amazonValidationAdjustSkuQuantities: Scalars['Boolean']
    createInventoryVendorValidation?: CreateInventoryVendorValidationResponse
    remediateValidation: Scalars['Boolean']
    deleteValidationRemediations: Scalars['Boolean']
    findValidationBuggyDate: Scalars['Boolean']
    createShopifyProductsFromDiagnostics: Scalars['Int']
    createBigValidationAdjustment: Scalars['Boolean']
    generatePhysicalCountValidation: PhysicalCountValidationResponse
    changeProductsHiddenStatus: Scalars['Boolean']
    createProductManually: CreateProductManuallyResponse
    deleteManualAssembly: Scalars['Boolean']
    deleteRecipe: Scalars['Boolean']
    mergeProductsV3: MergeProductsV3Response
    setProductAdjustments: Product
    setWarehouseOpeningBalance: WarehouseOpeningBalance
    updateManualAssembly: UpdateManualAssemblyResult
    updateProduct: Product
    updateProductFractional: Product
    updateRecipe: UpdateRecipeResult
    generatePdf: GeneratePdfResponse
    generatePdfV2: GeneratePdfResponseV2
    sendPoEmail: SendPoEmailResult
    setInventoryUsages: Scalars['Boolean']
    detectAndNotifyCogsDrasticChanges: Scalars['Boolean']
    saveDropshippingSettings: DropshippingSettings
    removeDropshippingSettings: Scalars['Boolean']
    deletePurchaseOrder: Scalars['Boolean']
    updatePurchaseOrder?: PurchaseOrder
    updateInventoryPurchase: UpdateInventoryPurchaseResponse
    deleteInventoryPurchase?: InventoryPurchaseUpdateOutOfDateError
    schedulePurchasesValidation: SchedulePurchasesValidationResponse
    applyInventoryPurchaseRules: InventoryPurchaseRulesResponse
    setPendingWarehouseOpeningBalance?: PendingWarehouseOpeningBalancesResponse
    deleteWarehouseOpeningBalance: Scalars['Boolean']
    discardPendingWarehouseOpeningBalance: Scalars['Boolean']
    applyPendingWarehouseOpeningBalance: Scalars['Boolean']
    setPendingWarehouseOpeningBalanceWithCsv?: PendingWarehouseOpeningBalancesWithCsvResponse
    deletePendingWarehouseOpeningBalanceAttachment: Scalars['Boolean']
    updateWarehouseTransfer: WarehouseTransfer
    deleteWarehouseTransfer: Scalars['Boolean']
    setPendingSalesDataAdjustmentsV2: SetPendingSalesDataAdjustmentsResponseV2
    setPendingDeadInventoryAdjustments: SetPendingDedInventoryAdjustmentsResponse
    setPendingGiveawayAdjustments: SetPendingGiveawayAdjustmentsResponse
    setPendingGiveawayDropshippingAdjustments: SetPendingGiveawayDropshippingAdjustmentsResponse
    setPendingDonationAdjustments: SetPendingDonationAdjustmentsResponse
    setPendingSalesDataAdjustmentsWithCsv: ProductBulkEditCsvUploadResponse
    setPendingDeadInventoryAdjustmentsWithCsv: ProductBulkEditCsvUploadResponse
    setPendingGiveawayAdjustmentsWithCsv: ProductBulkEditCsvUploadResponse
    setPendingGiveawayDropshippingAdjustmentsWithCsv: ProductBulkEditCsvUploadResponse
    setPendingDonationAdjustmentsWithCsv: ProductBulkEditCsvUploadResponse
    discardPendingAdjustments: Scalars['Boolean']
    applyPendingSalesDataAdjustments: GetProductBulkAdjustmentStatus
    updateNoUnitsPhysicalCount: IdResult
    deleteNoUnitsPhysicalCount: Scalars['Boolean']
    updateNoUnitsPhysicalCountProductQuantityPendingAdjustments: Scalars['Boolean']
    applyNoUnitsPhysicalCountProductQuantitiesPendingAdjustments: Scalars['Boolean']
    discardNoUnitsPhysicalCountProductQuantityPendingAdjustments: Scalars['Boolean']
    setNoUnitsPhysicalCountPendingAdjustmentsWithCsv: ProductBulkEditCsvUploadResponse
    updateUnitsTrackingPhysicalCount: UnitsTrackingPhysicalCount
    deleteUnitsTrackingPhysicalCount: Scalars['Boolean']
    updateUnitsTrackingPhysicalCountProductQuantityPendingAdjustments: Scalars['Boolean']
    acknowledgeUnitsTrackingPhysicalCountProductQuantitiesAmounts: Scalars['Boolean']
    discardUnitsTrackingPhysicalCountProductQuantityPendingAdjustments: Scalars['Boolean']
    setUnitsTrackingPhysicalCountPendingAdjustmentsWithCsv: ProductBulkEditCsvUploadResponse
    createWarehouse: WarehouseCreateResult
    deleteWarehouse: Scalars['Boolean']
    updateWarehouse: Warehouse
    updateWarehousesDefaults: WarehousesDefaultsResult
    updateWarehousesDefaultsV2: WarehousesDefaultsResponse
    mergeWarehouses: MergeWarehousesResult
    splitWarehouses: Scalars['Boolean']
    setUserGivenWarehouseName: Warehouse
    linkInventoryPaymentGroup: LinkInventoryPaymentGroupResponse
    updateInventoryPaymentGroup: UpdateInventoryPaymentGroupResponse
    deleteInventoryPaymentGroup: DeleteInventoryPaymentGroupResponse
    cancelInvalidInventoryPaymentGroups: CancelInvalidInventoryPaymentGroupsResponse
    updateInventoryYearEndMission: InventoryYearEndMissionsResponse
    updateWarehouseNegativesAdjustment: Scalars['Boolean']
    manageProductMergeRecommendationsGroup: Scalars['Boolean']
    manageProductMergeRecommendationsProduct: Scalars['Boolean']
    setProductMergeRecommendationsPrimaryProduct: Scalars['Boolean']
    mergeProductMergeRecommendationsMatchGroup: Scalars['Boolean']
    updateProductAutomergeSettings: Scalars['Boolean']
    revertVanillaChipMerges: Scalars['Boolean']
    lockLoan: LockLoanResult
    unlockLoan: UnlockLoanResult
    updateLoan?: ManualLoanCreationResult
    updateLoanAttachments: ManualLoanCreationResult
    createLoan: ManualLoanCreationResult
    createLoanFromTransaction: LoanCreationResult
    createLoanFromBalanceTransaction: LoanCreationResult
    createLoanFromBillFinanced: Scalars['Boolean']
    acknowledgeLoansChanges: AcknowledgeLoansChanges
    simulateLoanFromTransaction2: SimulatedLoanSummary
    deleteLoans: DeleteLoansResults
    dangerousForceDeleteLoans: DeleteLoansResults
    dangerousTouchLoan?: Scalars['Boolean']
    deleteLoanRelationships: Scalars['Boolean']
    deleteManualLoanEvent: UpdateManualLoanEventResult
    deleteManualLoanEvents: UpdateManualLoanEventsResult
    createManualLoanEvent2: UpdateManualLoanEventResult
    updateManualLoanEvent2: UpdateManualLoanEventResult
    deleteLoanManualAccountingEvents: UpdateManualLoanEventsResult
    updateLoanManualAccountingEvent: UpdateManualLoanEventResult
    deleteLoansEventsEffectConfiguration: DeleteLoansEventsEffectConfigurationResult
    createLoansEventsEffectConfiguration?: LoansEventsEffectConfiguration
    createLoanEventDefinition: LoanEventDefinition
    attachRelationsToLoan: Scalars['Boolean']
    deleteCompanyLoanAttachment?: ManualCompanyLoanCreationResult
    updateCompanyLoanAttachments: CompanyLoanAttachmentUpdateResult
    createCompanyLoan: ManualCompanyLoanCreationResult
    updateCompanyLoan?: ManualCompanyLoanCreationResult
    updateCompanyLoans: UpdateCompanyLoansResponse
    deleteLoan: DeleteLoansResults
    userAttachTransactionsToExistingLoan: ManualTransactionsAttachToLoanResult
    userAttachTransactionsToNewLoan: ManualTransactionsAttachToLoanResult
    userAttachTransactionsToLoans: ManualTransactionsAttachToLoansResult
    lenderFromEntity: NewLender
    updateCompanyFundedStatus: CompanyFundedStatus
    updateOrderEntities: SuccessResponse
    deleteOrderGroupUponTransactionChange: DeleteOrderGroupUponTransactionChangeResponse
    initiateTotalArCashDiffsReport: SuccessResponse
    updateCompanyArCashDiffsInBucket: SuccessResponse
    /**
     * Override any existing fulfillment date for the given orders, to match their respective line item's earliest post date.
     * Line items that require no change are not updated. Orders that have no line items changed are not updated.
     */
    overrideOrderFulfillmentsToLineItemPostDate: OverrideOrderFulfillmentsResponse
    setOrderFinaloopNote: OrderV2Result
    setOrderFinaloopTags: OrderV2Result
    setFulfillmentSettings: SetFulfillmentSettingsResponse
    markOrders: Scalars['Boolean']
    linkOrderGroup: LinkOrderGroupResponse
    updateOrderGroup: UpdateOrderGroupResponse
    deleteOrderGroup: DeleteOrderGroupResponse
    voidOrders: VoidOrdersResponse
    unvoidOrders: UnvoidOrdersResponse
    markOrdersAsUncollectible: MarkOrdersAsUncollectibleResponse
    markOrdersAsOvercollected: MarkOrdersAsOvercollectedResponse
    markOrdersAsHistoricallyPaid: MarkOrdersAsHistoricallyPaidResponse
    unMarkOrdersAsUncollectible: UnMarkOrdersAsUncollectibleResponse
    unMarkOrdersAsOvercollected: UnMarkOrdersAsOvercollectedResponse
    markOrdersAsGiveaway: MarkOrdersAsGiveawayResponse
    unMarkOrdersAsGiveaway: UnMarkOrdersAsGiveawayResponse
    markOrdersAsCOGS: MarkOrdersAsCOGSResponse
    unMarkOrdersAsCOGS: UnMarkOrdersAsCOGSResponse
    markOrderLineItemsAsVoided: MarkOrderLineItemsAsVoidedResponse
    /**
     * Override order fulfillments for the given orders.
     * Note that the provided fulfillment override for each order will completely replace the existing fulfillments of that order.
     * Ensure it includes any existing fulfillments for the order if they should be preserved.
     * If more than one order is specified, each order may succeed or fail independently and its result is reflected in the response.
     */
    overrideOrderFulfillments: OverrideOrderFulfillmentsResponse
    deletePaymentGroupUponTransactionChange: DeletePaymentGroupUponTransactionChangeResponse
    linkOrderPaymentGroup: LinkOrderPaymentGroupResponse
    updateOrderPaymentGroup: UpdateOrderPaymentGroupResponse
    deleteOrderPaymentGroup: DeletePaymentGroupResponse
    linkInvoicePaymentGroup: LinkInvoicePaymentGroupResponse
    updateInvoicePaymentGroup: UpdateInvoicePaymentGroupResponse
    deleteInvoicePaymentGroup: DeletePaymentGroupResponse
    updateEmployeesOfficerStatus?: Scalars['Boolean']
    updatePayrollSettings?: Scalars['Boolean']
    createPeriodicPartnerReport: PeriodicPartnerReport
    scheduleAccountingReportExport: ScheduleAccountingReportExportResponse
    exportGeneralLedger: ExportGeneralLedgerResponse
    upsertIntegrationCustomer: CustomerV2
    upsertIntegrationInvoice?: Invoice
    sendSalesToReconcilerByTypeAndDate: Scalars['Boolean']
    forceDeleteInvoices: DeleteInvoicesResponse
    refreshInvoiceCalculatedFields?: Invoice
    refreshManyInvoicesCalculatedFields?: Invoice[]
    createCustomer: Customer
    updateCustomer: Customer
    upsertCustomerAddress: CustomerAddress
    upsertCustomerV2: CustomerV2
    upsertInvoice?: Invoice
    voidInvoice?: Invoice
    unvoidInvoice?: Invoice
    deleteInvoiceAdjustment?: Invoice
    markAsUncollectible?: Invoice
    addRefundToInvoice?: Invoice
    deleteInvoiceRefund?: Invoice
    addCreditToInvoice?: Invoice
    deleteInvoiceCredit?: Invoice
    upsertPaymentMethod: PaymentMethod
    deletePaymentMethod?: Scalars['Boolean']
    generateInvoicePDF: Scalars['ID']
    markInvoicePdfAsSent: Scalars['String']
    sendInvoiceEmail?: Invoice
    issueInvoice?: Invoice
    deleteInvoice?: Scalars['Boolean']
    updateSalesChannel: SalesChannelInfo
    applySalesChannelChanges: ApplySalesChannelChangesResult
    upsertInvoiceSettings?: InvoiceSettings
    startPaymentLinkCheckout?: InvoicePay
    markPaymentLinkAsProcessing?: Scalars['Date']
    createPaymentLinkForInvoice?: Scalars['String']
    deletePaymentLinkForInvoice?: Scalars['Boolean']
    refundPaymentLinkPayment?: Scalars['String']
    createPaymentFromPaymentLink?: Scalars['String']
    createRefundFromPaymentLink?: Scalars['String']
    uploadInvoicesFromCSV: UploadedInvoice[]
    dispatchInvoicesCSVBulkUploadTask: AwaitedExportResponse
    updateUserRolesForCompany: UpdateUserRolesForCompanyResponse
    inviteUser: InviteUserResponse
    referUser: referUserResponse
    removeUser: RemoveUserResponse
    acceptInvitation: AcceptInvitationResponse
    handleUserLogin: HandleUserLoginResponse
    updateUserDetails: UpdateUserDetailsResponse
    setGoogleToken: GoogleTokenCodeResponse
    disconnectGoogleAccount: GoogleTokenCodeResponse
    switchCompany: SwitchCompanyResponse
    updateSharedGoogleDriveFolder: SuccessResult
    assignCompanyToUser: AssignCompanyToUserResponse
    impersonate: ImpersonateResponse
    setUserName: SetUserNameResponse
    updateAuth0UserDetails: Scalars['Boolean']
    addCompanyToParkerUser: Scalars['Boolean']
    markAuth0CompanyUsersAsFinishedOnboarding: Scalars['Boolean']
    publishValidationStatusUpdate?: Scalars['Boolean']
    createVendor: Vendor
    recordTax1099AffiliatedEntityGroupInput?: Scalars['Boolean']
    mergeTax1099AffiliatedEntities?: Scalars['Boolean']
    splitTax1099AffiliatedEntityGroups?: Scalars['Boolean']
    createGlobalVendor: Vendor
    updateCompanyVendorExternalSourceId?: Vendor
    upsertCompanyVendor: Vendor
    updateGlobalVendorLogo: Vendor
    upsertGlobalVendor: Vendor
    unsignWorksheetRow: CompanyWorksheetRow
    signWorksheetRow: CompanyWorksheetRow
    storeDateForLocking: CompanyWorksheetRow
    updateComments: CompanyWorksheetRow
    signAndLockBankAccount?: CompanyWorksheetRow
    updateCompaniesDomainState: (UpdateCompanyDomainStateResponse | undefined)[]
    manageCompanyYearEndState: ManageCompanyYearEndStateResponse
    updateYearEndState: YearEndStateUpdateResponse
    updateYearEndDomainState: YearEndDomainStateUpdateResponse
    updateYearEndDomainStateData: YearEndDomainStateDataUpdateResponse
    deleteYearEndDomainStateData: YearEndDomainStateDataDeleteResponse
    /** @deprecated Use updateYearEndAdditionalFields instead */
    updateYearEndUserUnresponsive: YearEndUpdateUserUnresponsiveResponse
    updateYearEndAdditionalFields: YearEndUpdateAdditionalFieldsResponse
    __typename: 'Mutation'
}

export type NaturalSign = 'DEBIT' | 'CREDIT'

export interface NewLender {
    id: Scalars['ID']
    company?: Company
    affiliatedEntity: AffiliatedEntity
    name: Scalars['String']
    supportedLoanTypes?: LoanType[]
    defaultLoanType?: LoanType
    isShortTerm?: Scalars['Boolean']
    supportedFollowUpTypes?: LoanUserFollowUpType[]
    logoUrl?: Scalars['String']
    __typename: 'NewLender'
}

export interface NonMatchedSku {
    sku: Scalars['String']
    integrationAccountName: Scalars['String']
    quantity: Scalars['Int']
    zeroPriceQuantity: Scalars['Int']
    restocks?: Scalars['Int']
    giveaway?: Scalars['Int']
    __typename: 'NonMatchedSku'
}

export interface NonMatchingProductsResponse {
    ambiguousSkuCount: Scalars['Int']
    notFoundProductSkuCount: Scalars['Int']
    notFoundProductSkus: (NotFoundProductSkus | undefined)[]
    __typename: 'NonMatchingProductsResponse'
}

export interface NonMatchingUnpaidBill {
    billId: Scalars['String']
    booksAmount?: Scalars['Float']
    inventoryPurchaseAmount?: Scalars['Float']
    __typename: 'NonMatchingUnpaidBill'
}

export interface NotFoundProductSkus {
    shopName?: Scalars['String']
    integrationAccountId: Scalars['String']
    source?: Scalars['String']
    skus: Scalars['String'][]
    __typename: 'NotFoundProductSkus'
}

export interface NothingTypes {
    id: Scalars['String']
    __typename: 'NothingTypes'
}

export interface NoUnitsBusinessEventsValidationResult {
    isValid: Scalars['Boolean']
    isYoung: Scalars['Boolean']
    costDiff: Scalars['Float']
    ackedCostDiff?: Scalars['Float']
    integrationValidations: NoUnitsIntegrationValidation[]
    __typename: 'NoUnitsBusinessEventsValidationResult'
}

export interface NoUnitsDailyProductValidationResult {
    productValidations: NoUnitsProductValidation[]
    diff: QuantityAndCost
    isValid: Scalars['Boolean']
    ackedDiff?: QuantityAndCost
    __typename: 'NoUnitsDailyProductValidationResult'
}

export interface NoUnitsIntegrationValidation {
    isValid: Scalars['Boolean']
    integrationType?: Scalars['String']
    integrationAccountName?: Scalars['String']
    totalCogsAmount: Scalars['Float']
    totalBusinessEventsAmount: Scalars['Float']
    dailyCogsType: Scalars['String']
    businessEventType: Scalars['String']
    isYoung: Scalars['Boolean']
    businessEventId?: Scalars['String']
    dailyCogsId?: Scalars['String']
    __typename: 'NoUnitsIntegrationValidation'
}

export interface NoUnitsPhysicalCount {
    id: Scalars['ID']
    amount: Scalars['Float']
    date: Scalars['Date']
    companyId: Scalars['String']
    attachments?: NoUnitsPhysicalCountAttachment[]
    diff: Scalars['Float']
    lastAckDiff: Scalars['Float']
    closingBalance: Scalars['Float']
    lastAckClosingBalance: Scalars['Float']
    note?: Scalars['String']
    isDraft: Scalars['Boolean']
    __typename: 'NoUnitsPhysicalCount'
}

export interface NoUnitsPhysicalCountAttachment {
    name: Scalars['String']
    url: Scalars['String']
    __typename: 'NoUnitsPhysicalCountAttachment'
}

export interface NoUnitsPhysicalCountClosingBalanceResult {
    closingBalance: Scalars['Float']
    __typename: 'NoUnitsPhysicalCountClosingBalanceResult'
}

export interface NoUnitsPhysicalCountOverview {
    amount: Scalars['Float']
    amountWithoutPendingAdjustments: Scalars['Float']
    missingData: Scalars['Float']
    count: Scalars['Float']
    pendingChanges: Scalars['Float']
    productQuantities: Scalars['Float']
    __typename: 'NoUnitsPhysicalCountOverview'
}

export interface NoUnitsPhysicalCountProductQuantities {
    products?: NoUnitsPhysicalCountProductQuantity[]
    offset: Scalars['Float']
    count: Scalars['Float']
    __typename: 'NoUnitsPhysicalCountProductQuantities'
}

export interface NoUnitsPhysicalCountProductQuantity {
    product: Product
    quantity?: Scalars['Float']
    appliedCost?: Scalars['Float']
    isPendingChange: Scalars['Boolean']
    __typename: 'NoUnitsPhysicalCountProductQuantity'
}

export interface NoUnitsPhysicalCountProductQuantityPendingAdjustment {
    quantity: Scalars['Float']
    companyId: Scalars['String']
    physicalCountId: Scalars['String']
    productId: Scalars['String']
    __typename: 'NoUnitsPhysicalCountProductQuantityPendingAdjustment'
}

export interface NoUnitsPhysicalCountsList {
    physicalCounts: NoUnitsPhysicalCount[]
    offset: Scalars['Int']
    count: Scalars['Int']
    totalCount: Scalars['Int']
    minAmount?: Scalars['Float']
    maxAmount?: Scalars['Float']
    __typename: 'NoUnitsPhysicalCountsList'
}

export interface NoUnitsProductValidation {
    product: Product
    sales: FulfillmentsValidation[]
    restocks: FulfillmentsValidation[]
    deadInventory: AdjustmentsValidation
    donations: AdjustmentsValidation
    giveaways: AdjustmentsValidation
    isValid: Scalars['Boolean']
    diff: QuantityAndCost
    __typename: 'NoUnitsProductValidation'
}

export interface NoUnitsValidationError {
    message: Scalars['String']
    __typename: 'NoUnitsValidationError'
}

export type NoUnitsValidationResponse = (NoUnitsValidationResult | NoUnitsValidationError) & { __isUnion?: true }

export interface NoUnitsValidationResult {
    isValid: Scalars['Boolean']
    dailyProductValidationResult: NoUnitsDailyProductValidationResult
    businessEventsValidationResult: NoUnitsBusinessEventsValidationResult
    startDate: Scalars['Date']
    endDate: Scalars['Date']
    error?: Scalars['String']
    diff: QuantityAndCost
    fulfillmentsAfterLock: Scalars['Float']
    __typename: 'NoUnitsValidationResult'
}

export interface Offer {
    tier: OfferTier
    payment: BillingPayment
    features: Feature[]
    title: Scalars['String']
    description: Scalars['String']
    couponDiscount?: Scalars['Float']
    __typename: 'Offer'
}

export type OffersStatus = 'READY' | 'TIER_1' | 'TOO_EARLY_TO_OFFER'

export type OfferTier = 'TIER_1_V3' | 'TIER_2_V3' | 'TIER_3_V3' | 'TIER_4_V3' | 'TIER_5_V3' | 'TIER_6_V3' | 'TIER_7_V3'

export type OnboardingScope = 'INVENTORY' | 'DASHBOARD'

export interface OnBoardingState {
    signupCompleted?: Scalars['Boolean']
    currentPage?: Scalars['String']
    funnelVersion?: Scalars['String']
    isLastPageCompleted?: Scalars['Boolean']
    __typename: 'OnBoardingState'
}

export interface OnboardingStatus {
    companyId: Scalars['ID']
    scope: OnboardingScope
    step: Scalars['String']
    status: OnboardingStepStatus
    __typename: 'OnboardingStatus'
}

export interface OnboardingStatuses {
    hasReportedCOGSEvents: Scalars['Boolean']
    hasClassifiedPurchases: Scalars['Boolean']
    hasConfirmedOpeningBalance: Scalars['Boolean']
    dropshippingSettings?: DropshippingSettings
    inventoryInitStatus: InventoryInitStatus
    __typename: 'OnboardingStatuses'
}

export type OnboardingStepStatus = 'PENDING' | 'COMPLETED'

export interface OnDemandAssemblyAction {
    quantity: Scalars['Float']
    id: Scalars['String']
    date: Scalars['Date']
    type: Scalars['String']
    __typename: 'OnDemandAssemblyAction'
}

export interface OnDemandAssemblyBreakdown {
    origin: RecipeWithBreakdown
    analytics: IncomingInventoryAnalytics
    __typename: 'OnDemandAssemblyBreakdown'
}

export interface OnDemandAssemblyCosts {
    id: Scalars['ID']
    amount: Scalars['Float']
    date: Scalars['Date']
    __typename: 'OnDemandAssemblyCosts'
}

export interface OnDemandAssemblyCostsResult {
    assemblyCosts: OnDemandAssemblyCosts[]
    __typename: 'OnDemandAssemblyCostsResult'
}

export interface OnDemandAssemblyVendorCosts {
    id: Scalars['String']
    companyId: Scalars['String']
    amount: Scalars['Float']
    recipe: Recipe
    date: Scalars['Date']
    unpaidAmounts: UnpaidAmountPerAffiliatedEntity[]
    inventoryPaymentGroupLinks: InventoryPaymentGroupLink[]
    affiliatedEntity: AffiliatedEntity
    __typename: 'OnDemandAssemblyVendorCosts'
}

export interface OnDemandAssemblyVendorCostsResult {
    assemblyVendorCosts: OnDemandAssemblyVendorCosts[]
    __typename: 'OnDemandAssemblyVendorCostsResult'
}

export interface OneTimePayment {
    id: Scalars['ID']
    price: Scalars['Float']
    quantity: Scalars['Int']
    __typename: 'OneTimePayment'
}

export interface OpenBalanceSheetSetupResponse {
    message?: Scalars['String']
    status: ManageBalanceSheetSetupStatus
    __typename: 'OpenBalanceSheetSetupResponse'
}

export interface OpeningBalanceAction {
    quantity: Scalars['Float']
    id: Scalars['String']
    date: Scalars['Date']
    type: Scalars['String']
    averageCost: Scalars['Float']
    isFromUserInput: Scalars['Boolean']
    __typename: 'OpeningBalanceAction'
}

export interface OrderAccountingReconciliationAccount {
    entity: OrderAccountingReconciliationAmount
    account: OrderAccountingReconciliationAmount
    __typename: 'OrderAccountingReconciliationAccount'
}

export interface OrderAccountingReconciliationAmount {
    amount: Scalars['Float']
    accountRole: Scalars['String']
    accountName: Scalars['String']
    __typename: 'OrderAccountingReconciliationAmount'
}

export interface OrderAccountingReconciliationRow {
    accountName: Scalars['String']
    accounts: (OrderAccountingReconciliationAccount | undefined)[]
    __typename: 'OrderAccountingReconciliationRow'
}

export interface OrderAccountingReconciliationsResponse {
    rows: (OrderAccountingReconciliationRow | undefined)[]
    otherBalances?: (OrderOtherAccountingReconciliationRow | undefined)[]
    __typename: 'OrderAccountingReconciliationsResponse'
}

export type OrderActionType = 'PAYMENT' | 'REFUND' | 'ADJUSTMENT'

export interface OrderAdjustment {
    id: Scalars['ID']
    amountInHomeCurrency: Scalars['Float']
    type: OrderAdjustmentType
    postedAt: Scalars['Date']
    __typename: 'OrderAdjustment'
}

export type OrderAdjustmentType = 'UNCOLLECTIBLE' | 'OVERCOLLECTED' | 'HISTORICAL_PAYMENT_PRIOR_BOOKS' | 'HISTORICAL_PAYMENT_LOCKED_YEAR'

export type OrderAdjustmentTypeV3 = 'UNCOLLECTIBLE' | 'OVERCOLLECTED'


/** The adjustments of the order */
export interface OrderAdjustmentV3 {
    id: Scalars['String']
    /** The ID of the adjustment in the external system */
    externalId: Scalars['String']
    /** The date and time the adjustment was posted */
    postedAt: Scalars['Date']
    /** The amount of the adjustment */
    amount: Scalars['Float']
    /** The amount currency */
    amountCurrency: CurrencyCode
    /** The amount home currency */
    amountHomeCurrency: CurrencyCode
    /** The amount in home currency */
    amountInHomeCurrency: Scalars['Float']
    /** The type of the adjustment */
    type: OrderAdjustmentTypeV3
    __typename: 'OrderAdjustmentV3'
}

export type OrderAggregationEntry = (OrdersAggregation | OrdersAgingAggregation) & { __isUnion?: true }

export type OrderAggregationType = 'BALANCE_SUM' | 'COUNT' | 'ORDER_VALUE_AVG' | 'NET_SALES_SUM' | 'ORDERS_AGING'

export interface OrderBalance {
    /** The date of the balance */
    date: Scalars['Date']
    /** The balance of the order */
    balance: Scalars['Float']
    /** The balance of the order in home currency */
    balanceInHomeCurrency: Scalars['Float']
    __typename: 'OrderBalance'
}

export interface OrderEntity {
    id: Scalars['ID']
    __typename: 'OrderEntity'
}

export type OrderEntityType = 'Order' | 'OrderItem' | 'OrderTransaction' | 'OrderItemsFulfillment' | 'OrderTransactionsMatch'

export type OrderFinaloopStatus = 'UNCOLLECTIBLE' | 'OVERCOLLECTED' | 'VOIDED' | 'PARTIALLY_VOIDED' | 'SALES_AFFECTING' | 'EXCLUDED' | 'COGS_ONLY' | 'SALES_ONLY' | 'GIVEAWAY'

export interface OrderFinancialReportingStatus {
    status: FinancialReportingStatus
    source: FinancialReportingStatusSource
    __typename: 'OrderFinancialReportingStatus'
}

export interface OrderFulfillment {
    id: Scalars['ID']
    fulfilledAt: Scalars['Date']
    fulfillmentLineItems: OrderFulfillmentLineItem[]
    source: Scalars['String']
    warehouse?: Warehouse
    isOverriddenByFinaloop?: Scalars['Boolean']
    __typename: 'OrderFulfillment'
}

export interface OrderFulfillmentLineItem {
    id: Scalars['ID']
    lineItemId: Scalars['ID']
    quantity: Scalars['Int']
    sku?: Scalars['String']
    __typename: 'OrderFulfillmentLineItem'
}


/** The line items associated with the fulfillment */
export interface OrderFulfillmentLineItemV3 {
    id: Scalars['ID']
    /** The ID of the fulfillment in the external system */
    externalId?: Scalars['String']
    /** The ID of the line item that's being fulfilled */
    lineItemId: Scalars['String']
    /** The quantity of the line item */
    quantity: Scalars['Int']
    __typename: 'OrderFulfillmentLineItemV3'
}

export type OrderFulfillmentSource = 'INTEGRATION' | 'ARTIFICIAL' | 'CUSTOMER'

export type OrderFulfillmentStatus = 'FULFILLED' | 'PARTIALLY_FULFILLED' | 'UNFULFILLED'

export type OrderFulfillmentStatusInput = 'FULFILLED' | 'PARTIALLY_FULFILLED' | 'UNFULFILLED' | 'RESTOCKED'


/** The most up-to-date statuses of the order */
export type OrderFulfillmentStatusV3 = 'UNFULFILLED' | 'ATTEMPTED_DELIVERY' | 'CANCELED' | 'CONFIRMED' | 'DELIVERED' | 'DELAYED' | 'FAILURE' | 'FULFILLED' | 'IN_TRANSIT' | 'LABEL_PRINTED' | 'LABEL_PURCHASED' | 'LABEL_VOIDED' | 'MARKED_AS_FULFILLED' | 'NOT_DELIVERED' | 'OUT_FOR_DELIVERY' | 'PICKED_UP' | 'READY_FOR_PICKUP' | 'SUBMITTED'


/** The fulfillments associated with the order, representing the shipping of the order */
export interface OrderFulfillmentV3 {
    id: Scalars['ID']
    /** The ID of the fulfillment in the external system */
    externalId?: Scalars['String']
    /** The status of the fulfillment */
    status: OrderFulfillmentStatusV3
    /** The fulfilling party, for example FBT/FBA are PLATFORM, while FBM is SELLER */
    channel: FulfillmentChannel
    /** The warehouse that the fulfillment was shipped from */
    warehouse: Warehouse
    /** The date and time the fulfillment was shipped */
    shippedAt?: Scalars['Date']
    /** The date and time the fulfillment was delivered */
    deliveredAt?: Scalars['Date']
    /** The date and time the fulfillment was fulfilled */
    fulfilledAt: Scalars['Date']
    /** The line items associated with the fulfillment */
    lineItems: OrderFulfillmentLineItemV3[]
    __typename: 'OrderFulfillmentV3'
}

export interface OrderGroup {
    id: Scalars['ID']
    companyId: Scalars['String']
    amountInHomeCurrency: Scalars['Float']
    orders: LinkedOrder[]
    bankTransactions: LinkedBankTransaction[]
    expenses: OrderGroupExpense[]
    orderDistributions: OrderGroupOrderDistribution[]
    postedAt: Scalars['Date']
    createdAt: Scalars['Date']
    updatedAt: Scalars['Date']
    deletedAt?: Scalars['Date']
    __typename: 'OrderGroup'
}

export interface OrderGroupByIdResponse {
    orderGroup?: OrderGroup
    __typename: 'OrderGroupByIdResponse'
}

export interface OrderGroupDistributionBasic {
    orderGroupId: Scalars['ID']
    postedAt: Scalars['Date']
    amountInHomeCurrency: Scalars['Float']
    orderGroupHasCashPayments: Scalars['Boolean']
    __typename: 'OrderGroupDistributionBasic'
}

export interface OrderGroupExpense {
    id: Scalars['ID']
    expenseType: OrderGroupExpenseType
    amount: Amounts
    vendor?: Vendor
    __typename: 'OrderGroupExpense'
}

export type OrderGroupExpenseType = 'ADVERTISING' | 'BRICK_AND_MORTAR' | 'DEDUCTION' | 'DISCOUNT' | 'FEE' | 'MERCHANT_FEE' | 'SELLING_FEE' | 'FX_COMMISSION' | 'PLATFORM_ADJUSTMENT' | 'ORDERS_CREDIT' | 'OTHER_ADJUSTMENT'

export interface OrderGroupLink {
    orderGroupId: Scalars['ID']
    amountInHomeCurrency: Scalars['Float']
    postedAt: Scalars['Date']
    __typename: 'OrderGroupLink'
}

export interface OrderGroupOrderDistribution {
    order: OrderV2
    bankTransaction?: BankTransaction
    expense?: OrderGroupExpense
    postedAt: Scalars['Date']
    amountInHomeCurrency: Scalars['Float']
    orderGroupHasCashPayments: Scalars['Boolean']
    __typename: 'OrderGroupOrderDistribution'
}

export interface OrderGroupsByIdsResponse {
    orderGroups: OrderGroup[]
    __typename: 'OrderGroupsByIdsResponse'
}

export interface OrderGroupsResponse {
    orderGroups: OrderGroup[]
    __typename: 'OrderGroupsResponse'
}

export type OrderGroupsSortDirection = 'ASC' | 'DESC'

export type OrderGroupsSortType = 'POSTED_AT'

export interface OrderGroupsTotalUnclearedBalanceResponse {
    asOfDate: Scalars['Date']
    totalUnclearedBalance: Amounts
    __typename: 'OrderGroupsTotalUnclearedBalanceResponse'
}

export interface OrderGroupsUnclearedBalanceResponse {
    asOfDate: Scalars['Date']
    unclearedBalances: OrderGroupUnclearedBalance[]
    __typename: 'OrderGroupsUnclearedBalanceResponse'
}

export interface OrderGroupUnclearedBalance {
    orderGroup: OrderGroup
    unclearedBalance: Amounts
    __typename: 'OrderGroupUnclearedBalance'
}

export interface OrderItemsFulfillmentV2 {
    id: Scalars['ID']
    trackingInfoRecords?: Scalars['JSON']
    externalWarehouseId?: Scalars['String']
    voidedAt?: Scalars['Date']
    fulfilledAt: Scalars['Date']
    fulfilledQuantity: Scalars['Int']
    voidedBy?: ActorType
    source: OrderFulfillmentSource
    createdAt: Scalars['Date']
    updatedAt: Scalars['Date']
    __typename: 'OrderItemsFulfillmentV2'
}

export type OrderItemStatus = 'VOIDED' | 'PARTIALLY_VOIDED' | 'FULFILLED' | 'UNFULFILLED' | 'PARTIALLY_FULFILLED' | 'RESTOCKED' | 'PARTIALLY_RESTOCKED' | 'CANCELLED' | 'GIVEAWAY' | 'DROPSHIPPED' | 'PARTIALLY_DROPSHIPPED'

export interface OrderItemStatusWithOverride {
    status: OrderItemStatus
    isOverridden: Scalars['Boolean']
    __typename: 'OrderItemStatusWithOverride'
}

export type OrderItemType = 'SHIPPING' | 'PRODUCT' | 'ADDITIONAL_FEE' | 'GIFT_CARD' | 'TIP' | 'FX_ADJUSTMENT' | 'DUTY' | 'RESTOCKING_FEE' | 'RETURN_SHIPPING_FEE'

export interface OrderItemV2 {
    id: Scalars['ID']
    companyId: Scalars['String']
    actionType: OrderActionType
    type: OrderItemType
    amount: Amounts
    taxAmount: Scalars['Float']
    taxAmountInHomeCurrency: Scalars['Float']
    discountAmount: Scalars['Float']
    discountAmountInHomeCurrency: Scalars['Float']
    exchangeRateOverride?: Scalars['Float']
    taxExchangeRateOverride?: Scalars['Float']
    discountExchangeRateOverride?: Scalars['Float']
    taxes?: Scalars['JSON']
    externalSourceId?: Scalars['String']
    postedAt: Scalars['Date']
    externalProductId?: Scalars['String']
    product?: Product
    sku?: Scalars['String']
    quantity?: Scalars['Int']
    unitPrice?: Scalars['Float']
    isRestocked?: Scalars['Boolean']
    fulfillments: OrderItemsFulfillmentV2[]
    originalFulfillmentId?: Scalars['String']
    voided?: Scalars['JSON']
    voidedAt?: Scalars['Date']
    isFulfillmentOverridden?: Scalars['Boolean']
    createdAt: Scalars['Date']
    updatedAt: Scalars['Date']
    status: OrderItemStatusWithOverride[]
    lineItemId?: Scalars['ID']
    __typename: 'OrderItemV2'
}

export interface OrderLineItem {
    id: Scalars['ID']
    companyId: Scalars['String']
    integrationAccountId: Scalars['String']
    type: OrderLineItemType
    amount: Scalars['Float']
    amountInHomeCurrency: Scalars['Float']
    taxAmount: Scalars['Float']
    taxAmountInHomeCurrency: Scalars['Float']
    discountAmount: Scalars['Float']
    discountAmountInHomeCurrency: Scalars['Float']
    currency: CurrencyCode
    quantity: Scalars['Int']
    firstPostedAt: Scalars['Date']
    lastPostedAt: Scalars['Date']
    externalProductId?: Scalars['String']
    product?: Product
    sku?: Scalars['String']
    unitPrice?: Scalars['Float']
    voidedAt?: Scalars['Date']
    status: OrderItemStatusWithOverride[]
    fulfillments?: OrderLineItemFulfillment[]
    fulfillmentStats?: OrderLineItemFulfillmentStats
    __typename: 'OrderLineItem'
}

export type OrderLineItemDiscountType = 'PLATFORM_DISCOUNT' | 'SELLER_DISCOUNT' | 'COFUNDED_DISCOUNT'


/**
 * For a given order line item,
 * holds a consolidated list of fulfillment quantities and/or their overrides (if any)
 * as well as for the unfulfilled quantity
 */
export interface OrderLineItemFulfillment {
    warehouseId: Scalars['ID']
    /**
     * The start of the fulfillment UTC day (time is always 00:00:00).
     * If multiple fulfillments exist for this line item at different times in the same day,
     * they are aggregated into a single OrderLineItemFulfillment.
     */
    fulfilledAt: Scalars['Date']
    quantity: Scalars['Int']
    quantityOverride?: Scalars['Int']
    __typename: 'OrderLineItemFulfillment'
}

export interface OrderLineItemFulfillmentStats {
    /** Total quantity of the line item that is unfulfilled */
    unfulfilledQuantity: Scalars['Int']
    /** Total quantity of the line item that is unfulfilled by overrides */
    unfulfilledQuantityOverride?: Scalars['Int']
    /** Total quantity of the line item that is fulfilled. */
    fulfilledQuantity?: Scalars['Int']
    /** Total quantity of the line item that is fulfilled by overrides */
    fulfilledQuantityOverride?: Scalars['Int']
    /** Total quantity of the line item that is ordered. */
    orderedQuantity: Scalars['Int']
    __typename: 'OrderLineItemFulfillmentStats'
}

export interface OrderLineItemFulfillmentV3 {
    warehouse: Warehouse
    fulfilledAt: Scalars['Date']
    quantity: Scalars['Int']
    __typename: 'OrderLineItemFulfillmentV3'
}

export type OrderLineItemTaxType = 'DUTIES_AND_OTHER_TAXES' | 'GST' | 'SALES_TAX' | 'VAT'

export interface OrderLineItemTimelineV3 {
    lastEffectBy: Scalars['String']
    /** The date and time the action was posted */
    postedAt: Scalars['Date']
    /** The total quantity of the action */
    totalQuantity: Scalars['Int']
    /** The date and time the action was fully fulfilled */
    fullyFulfilledAt?: Scalars['Date']
    /** The date and time the action was first fulfilled */
    firstFulfillmentAt?: Scalars['Date']
    /** The account state of the item */
    totalPlaced: LineItemTimelineAccountStateV3
    /** The account state of the item */
    unfulfilled: LineItemTimelineAccountStateV3
    /** The account state of the item */
    fulfilled: LineItemTimelineAccountStateV3
    /** The account state of the item */
    unfulfilledRefunded: LineItemTimelineAccountStateV3
    /** The account state of the item */
    fulfilledRefunded: LineItemTimelineAccountStateV3
    actions: LineItemTimelineActionV3[]
    __typename: 'OrderLineItemTimelineV3'
}

export type OrderLineItemType = 'PRODUCT' | 'GIFT_CARD'

export type OrderLineItemTypeV3 = 'PRODUCT' | 'TAX' | 'FEE' | 'TIP' | 'SHIPPING' | 'DISCOUNT'

export type OrderLineItemV3 = (DiscountLineItemV3 | FeeLineItemV3 | ProductLineItemV3 | ShippingLineItemV3 | TaxLineItemV3 | TipLineItemV3) & { __isUnion?: true }

export interface OrderOtherAccountingReconciliationRow {
    accountName: Scalars['String']
    accounts: (OrderAccountingReconciliationAmount | undefined)[]
    __typename: 'OrderOtherAccountingReconciliationRow'
}

export interface OrderPaymentGroup {
    id: Scalars['ID']
    companyId: Scalars['String']
    postedAt: Scalars['Date']
    createdAt: Scalars['Date']
    updatedAt: Scalars['Date']
    deletedAt?: Scalars['Date']
    orders: PaymentGroupLinkedOrder[]
    bankTransactions: PaymentGroupLinkedBankTransaction[]
    expenses: PaymentGroupExpense[]
    __typename: 'OrderPaymentGroup'
}

export interface OrderPaymentGroupByIdResponse {
    paymentGroup?: OrderPaymentGroup
    __typename: 'OrderPaymentGroupByIdResponse'
}

export interface OrderPaymentGroupsByIdsResponse {
    paymentGroups: OrderPaymentGroup[]
    __typename: 'OrderPaymentGroupsByIdsResponse'
}

export interface OrderPaymentGroupsResponse {
    paymentGroups: OrderPaymentGroup[]
    __typename: 'OrderPaymentGroupsResponse'
}

export interface OrderPaymentGroupsUnclearedBalanceResponse {
    asOfDate: Scalars['Date']
    unclearedBalances: OrderPaymentGroupUnclearedBalance[]
    __typename: 'OrderPaymentGroupsUnclearedBalanceResponse'
}

export interface OrderPaymentGroupUnclearedBalance {
    paymentGroup: OrderPaymentGroup
    unclearedBalance: Amounts
    __typename: 'OrderPaymentGroupUnclearedBalance'
}

export type OrderPaymentStatus = 'PAID' | 'UNPAID' | 'PARTIALLY_PAID' | 'REFUNDED' | 'PARTIALLY_REFUNDED'

export interface OrderReconciliationRow {
    title: Scalars['String']
    saleAmount: Scalars['Float']
    taxAmount: Scalars['Float']
    discountAmount: Scalars['Float']
    shippingAmount: Scalars['Float']
    refundAmount: Scalars['Float']
    additionalTaxesAmount: Scalars['Float']
    totalAmount: Scalars['Float']
    netAmount: Scalars['Float']
    subRows?: (OrderReconciliationRow | undefined)[]
    __typename: 'OrderReconciliationRow'
}

export type OrderReconciliationRowType = 'ENTITY' | 'ACCOUNT'

export interface OrderReconciliationsResponse {
    booksRows: (OrderReconciliationRow | undefined)[]
    excludedRows: (OrderReconciliationRow | undefined)[]
    adjustedRows: (OrderReconciliationRow | undefined)[]
    shopifyRow: OrderReconciliationRow
    dateRange: DateRange
    currency: Scalars['String']
    failureReason?: Scalars['String']
    __typename: 'OrderReconciliationsResponse'
}

export interface OrderRestock {
    id: Scalars['ID']
    postedAt: Scalars['Date']
    restockLineItems: OrderRestockLineItem[]
    __typename: 'OrderRestock'
}

export interface OrderRestockLineItem {
    id: Scalars['ID']
    quantity: Scalars['Int']
    lineItemId?: Scalars['ID']
    sku?: Scalars['String']
    warehouse?: Warehouse
    __typename: 'OrderRestockLineItem'
}

export type OrderReturnLineItemTypeV3 = 'RETURN' | 'CANCEL'


/** The line items associated with the return */
export interface OrderReturnLineItemV3 {
    id: Scalars['ID']
    /** The ID of the fulfillment in the external system */
    externalId: Scalars['String']
    /** The ID of the warehouse that the return was returned to */
    warehouse?: Warehouse
    /** The ID of the line item that's being returned */
    lineItemId: Scalars['String']
    /** The ID of the line item in the external system */
    externalLineItemId?: Scalars['String']
    /** The type of the return line item */
    type: OrderReturnLineItemTypeV3
    /** Whether the return was restocked */
    isRestocked: Scalars['Boolean']
    /** The quantity that was returned */
    quantity: Scalars['Int']
    __typename: 'OrderReturnLineItemV3'
}


/** The returns associated with the order, representing the returns of the order */
export interface OrderReturnV3 {
    id: Scalars['ID']
    /** The ID of the return in the external system */
    externalId: Scalars['String']
    /** The date and time the return was posted */
    postedAt: Scalars['Date']
    /** The line items associated with the return */
    lineItems: OrderReturnLineItemV3[]
    /** The total refunded amount of the return */
    totalRefundedAmount?: Scalars['Float']
    /** totalRefundedAmount currency */
    totalRefundedAmountCurrency?: Scalars['String']
    /** totalRefundedAmount in home currency */
    totalRefundedAmountInHomeCurrency?: Scalars['Float']
    /** totalRefundedAmount home currency */
    totalRefundedAmountHomeCurrency?: Scalars['String']
    __typename: 'OrderReturnV3'
}

export interface OrdersAggregation {
    type: OrderAggregationType
    value: Scalars['Float']
    __typename: 'OrdersAggregation'
}

export interface OrdersAgingAggregation {
    type: OrderAggregationType
    values: AgingAggregationItem[]
    __typename: 'OrdersAgingAggregation'
}

export type OrdersAgingPreset = 'ZERO_TO_THIRTY' | 'THIRTY_ONE_TO_SIXTY' | 'SIXTY_ONE_TO_NINETY' | 'NINETY_ONE_PLUS'

export interface OrdersByIdsResponse {
    orders: OrderV2[]
    __typename: 'OrdersByIdsResponse'
}

export interface OrderSettings {
    void: VoidOrderSettings
    __typename: 'OrderSettings'
}

export interface OrderSettingsResponse {
    settings: OrderSettings
    __typename: 'OrderSettingsResponse'
}

export type OrderSettlementStatusInput = 'SETTLED' | 'PARTIALLY_SETTLED' | 'UNSETTLED'

export type OrderSourceTypeV3 = 'MARKETPLACE' | 'STORE'

export interface OrdersResult {
    orders: OrderV3[]
    __typename: 'OrdersResult'
}

export interface OrdersSettings {
    isZeroNetOrdersSupported?: Scalars['Boolean']
    shouldRecognizeZeroNetCogsAsGiveaways?: Scalars['Boolean']
    shopifyStoreV2StartDate?: Scalars['Date']
    __typename: 'OrdersSettings'
}

export type OrdersSortType = 'PLACED_DATE' | 'NET_SALES' | 'TOTAL' | 'UNPAID_BALANCE' | 'BALANCE'

export type OrderStatus = 'VOIDED' | 'COGS_ONLY' | 'SALES_ONLY' | 'GIVEAWAY' | 'EXCLUDED' | 'PAID' | 'UNPAID' | 'PARTIALLY_PAID' | 'REFUNDED' | 'PARTIALLY_REFUNDED' | 'DROPSHIPPED' | 'FULFILLED' | 'RESTOCKED' | 'PARTIALLY_DROPSHIPPED' | 'PARTIALLY_FULFILLED' | 'PARTIALLY_RESTOCKED' | 'PARTIALLY_VOIDED' | 'UNFULFILLED' | 'CANCELLED' | 'UNCOLLECTIBLE' | 'PARTIALLY_UNCOLLECTIBLE' | 'PARTIALLY_OVER_COLLECTED' | 'HISTORICALLY_PAID' | 'PARTIALLY_HISTORICALLY_PAID' | 'OVER_COLLECTED' | 'MATCHED_TRANSACTION' | 'UNMATCHED_TRANSACTION' | 'LINKED_TRANSACTIONS'

export type OrderStatusInput = 'GIVEAWAY' | 'VOIDED'

export type OrderStatusV3 = 'VOIDED' | 'COGS_ONLY' | 'SALES_ONLY' | 'GIVEAWAY' | 'EXCLUDED' | 'PAID' | 'UNPAID' | 'PARTIALLY_PAID' | 'REFUNDED' | 'PARTIALLY_REFUNDED' | 'FULFILLED' | 'PARTIALLY_FULFILLED' | 'UNFULFILLED' | 'RESTOCKED' | 'PARTIALLY_RESTOCKED' | 'OVER_COLLECTED' | 'PARTIALLY_OVER_COLLECTED' | 'UNCOLLECTIBLE' | 'PARTIALLY_UNCOLLECTIBLE' | 'COGS_AND_SALES' | 'DROPSHIPPED' | 'PARTIALLY_DROPSHIPPED' | 'UNSETTLED' | 'PARTIALLY_SETTLED' | 'SETTLED'

export interface OrderStatusWithOverride {
    status: OrderStatus
    isOverridden: Scalars['Boolean']
    __typename: 'OrderStatusWithOverride'
}

export interface OrderStatusWithOverrideV3 {
    status: OrderStatusV3
    isOverridden: Scalars['Boolean']
    __typename: 'OrderStatusWithOverrideV3'
}

export interface OrdersYearEndBalances {
    unpaidAmount: Scalars['Float']
    cashDepositAmount: Scalars['Float']
    netUnpaidBalance: Scalars['Float']
    __typename: 'OrdersYearEndBalances'
}

export interface OrdersYearEndResponse {
    balances: OrdersYearEndBalances
    waitingPermissionsIntegrations: Scalars['String'][]
    __typename: 'OrdersYearEndResponse'
}

export interface OrderTag {
    id: Scalars['ID']
    name: Scalars['String']
    __typename: 'OrderTag'
}


/** Timestamps for when the order was first paid, fully paid, etc. */
export interface OrderTimestamps {
    /** The date and time the order was fully paid */
    fullyPaidAt?: Scalars['Date']
    /** The date and time the order was first paid */
    firstPaymentAt?: Scalars['Date']
    /** The date and time the order was first refunded */
    firstRefundAt?: Scalars['Date']
    /** The date and time the order was fully fulfilled */
    fullyFulfilledAt: Scalars['Date']
    /** The date and time the order was first fulfilled */
    firstFulfilledAt?: Scalars['Date']
    /** The date and time the order was last updated */
    latestFinancialTimestamp: Scalars['Date']
    __typename: 'OrderTimestamps'
}


/** The most up-to-date totals of the order */
export interface OrderTotals {
    /** Total without taxes */
    netSales: Scalars['Float']
    /** Total without taxes in home currency */
    netSalesInHomeCurrency: Scalars['Float']
    /** Total before shipping, discounts and taxes */
    subTotal: Scalars['Float']
    /** Total before shipping, discounts and taxes in home currency */
    subTotalInHomeCurrency: Scalars['Float']
    /** Total tips */
    tipsSubtotal: Scalars['Float']
    /** Total tips in home currency */
    tipsSubtotalInHomeCurrency: Scalars['Float']
    /** Total shipping */
    shippingSubtotal: Scalars['Float']
    /** Total shipping in home currency */
    shippingSubtotalInHomeCurrency: Scalars['Float']
    /** Total without taxes and returns */
    orderValue: Scalars['Float']
    /** Total without taxes and returns in home currency */
    orderValueInHomeCurrency: Scalars['Float']
    /** Total, includes everything */
    netOrder: Scalars['Float']
    /** Total, includes everything in home currency */
    netOrderInHomeCurrency: Scalars['Float']
    itemSellerDiscounts: Scalars['Float']
    itemSellerDiscountsInHomeCurrency: Scalars['Float']
    itemPlatformDiscounts: Scalars['Float']
    itemPlatformDiscountsInHomeCurrency: Scalars['Float']
    itemCofundedDiscounts: Scalars['Float']
    itemCofundedDiscountsInHomeCurrency: Scalars['Float']
    itemOtherDiscounts: Scalars['Float']
    itemOtherDiscountsInHomeCurrency: Scalars['Float']
    shippingSellerDiscounts: Scalars['Float']
    shippingSellerDiscountsInHomeCurrency: Scalars['Float']
    shippingPlatformDiscounts: Scalars['Float']
    shippingPlatformDiscountsInHomeCurrency: Scalars['Float']
    shippingCofundedDiscounts: Scalars['Float']
    shippingCofundedDiscountsInHomeCurrency: Scalars['Float']
    shippingOtherDiscounts: Scalars['Float']
    shippingOtherDiscountsInHomeCurrency: Scalars['Float']
    feesSellerDiscounts: Scalars['Float']
    feesSellerDiscountsInHomeCurrency: Scalars['Float']
    feesPlatformDiscounts: Scalars['Float']
    feesPlatformDiscountsInHomeCurrency: Scalars['Float']
    feesCofundedDiscounts: Scalars['Float']
    feesCofundedDiscountsInHomeCurrency: Scalars['Float']
    feesOtherDiscounts: Scalars['Float']
    feesOtherDiscountsInHomeCurrency: Scalars['Float']
    globalSellerDiscounts: Scalars['Float']
    globalSellerDiscountsInHomeCurrency: Scalars['Float']
    globalPlatformDiscounts: Scalars['Float']
    globalPlatformDiscountsInHomeCurrency: Scalars['Float']
    globalCofundedDiscounts: Scalars['Float']
    globalCofundedDiscountsInHomeCurrency: Scalars['Float']
    globalOtherDiscounts: Scalars['Float']
    globalOtherDiscountsInHomeCurrency: Scalars['Float']
    totalDiscounts: Scalars['Float']
    totalDiscountsInHomeCurrency: Scalars['Float']
    /** Total payments */
    payments: Scalars['Float']
    /** Total payments in home currency */
    paymentsInHomeCurrency: Scalars['Float']
    /** Total payment refunds (money) */
    paymentRefunds: Scalars['Float']
    /** Total payment refunds (money) in home currency */
    paymentRefundsInHomeCurrency: Scalars['Float']
    /** Total value of item refunds */
    saleRefunds: Scalars['Float']
    /** Total value of item refunds in home currency */
    saleRefundsInHomeCurrency: Scalars['Float']
    /** Total adjustments */
    adjustments: Scalars['Float']
    /** Total adjustments in home currency */
    adjustmentsInHomeCurrency: Scalars['Float']
    totalTaxes: Scalars['Float']
    totalTaxesInHomeCurrency: Scalars['Float']
    taxesSubtotal: Scalars['Float']
    taxesSubtotalInHomeCurrency: Scalars['Float']
    taxRefunds: Scalars['Float']
    taxRefundsInHomeCurrency: Scalars['Float']
    salesTax: Scalars['Float']
    salesTaxInHomeCurrency: Scalars['Float']
    vat: Scalars['Float']
    vatInHomeCurrency: Scalars['Float']
    gst: Scalars['Float']
    gstInHomeCurrency: Scalars['Float']
    dutiesAndOtherTaxes: Scalars['Float']
    dutiesAndOtherTaxesInHomeCurrency: Scalars['Float']
    /** The number of items in the order */
    numberOfItems: Scalars['Float']
    /** The order net paid amount */
    netPaid: Scalars['Float']
    /** The order net paid amount in home currency */
    netPaidInHomeCurrency: Scalars['Float']
    __typename: 'OrderTotals'
}

export interface OrderTotalSummary {
    subtotal: Amounts
    shippingIncome: Amounts
    discounts: Amounts
    netSale: Amounts
    taxes: Amounts
    additionalTaxes: Amounts
    refunds: Amounts
    fxAdjustment: Amounts
    netOrder: Amounts
    voided?: Amounts
    paid: Scalars['Float']
    refunded: Scalars['Float']
    netPaid: Scalars['Float']
    uncollectible: Scalars['Float']
    overCollected: Scalars['Float']
    orderBalance: Scalars['Float']
    balanceAsOf: Scalars['Date']
    balanceAsOfAmount: Scalars['Float']
    __typename: 'OrderTotalSummary'
}

export interface OrderTransactionMatchV2 {
    id: Scalars['ID']
    amount: Amounts
    payment?: StorePaymentV2
    __typename: 'OrderTransactionMatchV2'
}

export type OrderTransactionType = 'PAYMENT' | 'REFUND'

export interface OrderTransactionV2 {
    id: Scalars['ID']
    amount: Amounts
    exchangeRateOverride?: Scalars['Float']
    type: OrderTransactionType
    postedAt: Scalars['Date']
    matches: OrderTransactionMatchV2[]
    finaloopPaymentGateway: Scalars['String']
    originalPaymentGateway: Scalars['String']
    paymentGatewayVariant?: Scalars['String']
    externalSourceId?: Scalars['String']
    createdAt: Scalars['Date']
    updatedAt: Scalars['Date']
    isManual: Scalars['Boolean']
    voided?: Scalars['JSON']
    authorizationCode?: Scalars['String']
    isArtificiallyMatched?: Scalars['Boolean']
    matchedAt?: Scalars['Date']
    __typename: 'OrderTransactionV2'
}


/** The transactions associated with the order, paying/refunding it */
export interface OrderTransactionV3 {
    id: Scalars['ID']
    /** The amount of the transaction */
    amount: Amounts
    /** The ID of the transaction in the external system */
    externalId?: Scalars['String']
    /** The type of the transaction (PAYMENT or REFUND) */
    type: OrderTransactionType
    /** The payment gateway of the transaction, as decided by Finaloop */
    paymentGateway: TransactionPaymentGatewayType
    /** The date and time the transaction was posted */
    postedAt: Scalars['Date']
    releasedAt?: Scalars['Date']
    /** The payment gateway of the transaction, as received from the external system */
    externalPaymentGateway?: Scalars['String']
    /** The authorization code of the transaction */
    authorizationCode?: Scalars['String']
    __typename: 'OrderTransactionV3'
}

export interface OrderV2 {
    id: Scalars['ID']
    companyId: Scalars['String']
    items: OrderItemV2[]
    lineItems: OrderLineItem[]
    transactions: OrderTransactionV2[]
    orderGroupLinks?: OrderGroupLink[]
    orderGroupDistributions: OrderGroupDistributionBasic[]
    orderAdjustments: OrderAdjustment[]
    totalSummary: OrderTotalSummary
    displayName?: Scalars['String']
    currency: Scalars['String']
    source: Scalars['String']
    placedAt: Scalars['Date']
    firstPaymentDate?: Scalars['Date']
    fullyPaidDate?: Scalars['Date']
    firstRefundDate?: Scalars['Date']
    firstFulfillmentDate?: Scalars['Date']
    latestFinancialDate: Scalars['Date']
    salesChannel?: Scalars['String']
    integrationAccountName: Scalars['String']
    integrationAccountId: Scalars['ID']
    customer?: CustomerV2
    isZeroNetOrder?: Scalars['Boolean']
    integrationTags: Scalars['String'][]
    finaloopTags: OrderTag[]
    finaloopNote: Scalars['String']
    integrationNote?: Scalars['String']
    isChannelProductSalesAffecting: Scalars['Boolean']
    isChannelAccountsAffecting: Scalars['Boolean']
    isProductSalesAffecting?: Scalars['Boolean']
    isAccountsAffecting?: Scalars['Boolean']
    paymentStatus?: OrderPaymentStatus
    fulfillmentStatus?: OrderFulfillmentStatus
    balanceInHomeCurrency?: Scalars['Float']
    voidedAt?: Scalars['Date']
    shippingAddress?: CustomerAddress
    billingAddress?: CustomerAddress
    store: Store
    status: OrderStatusWithOverride[]
    financialReportingStatus: OrderFinancialReportingStatus
    integrationExternalUrl: Scalars['String']
    fulfillments: OrderFulfillment[]
    restocks: OrderRestock[]
    paymentGroupLinks: PaymentGroupLink[]
    __typename: 'OrderV2'
}

export interface OrderV2NotFound {
    message: Scalars['String']
    __typename: 'OrderV2NotFound'
}

export type OrderV2Result = (OrderV2 | OrderV2NotFound) & { __isUnion?: true }

export interface OrderV3 {
    id: Scalars['ID']
    /** Company information */
    company: Company
    /** Integration type */
    integrationType: Scalars['String']
    /** Integration account ID */
    integrationAccountId: Scalars['String']
    totals: OrderTotals
    returns: OrderReturnV3[]
    store: StoreV3
    /** The balances timeline of the order */
    balances: OrderBalance[]
    /** The unfulfilled balances timeline of the order */
    unfulfilledBalances: OrderBalance[]
    balanceAsOfAmount?: Scalars['Float']
    currency: CurrencyCode
    /** The date and time the order was posted */
    postedAt: Scalars['Date']
    statuses: OrderStatusWithOverrideV3[]
    /** The date and time the order was voided */
    voidedAt?: Scalars['Date']
    /** The platform in which the order was voided */
    voidedBy?: OrderVoidedByType
    /** The date and time the order was voided in the integration */
    integrationVoidedAt?: Scalars['Date']
    /** The note left by the buyer */
    buyerNote?: Scalars['String']
    /** Whether the order is zero net */
    isZeroNet: Scalars['Boolean']
    lineItems: OrderLineItemV3[]
    customer: CustomerV3
    externalUrl?: Scalars['String']
    /** The ID of the order in the external system */
    externalId: Scalars['String']
    /** The date and time the order was updated in the external system */
    externalUpdatedAt?: Scalars['Date']
    /** The note left by the seller */
    sellerNote?: Scalars['String']
    timestamps: OrderTimestamps
    adjustments: OrderAdjustmentV3[]
    /** The display name of the order, i.e. "Order #1234567890" */
    displayName: Scalars['String']
    fulfillments: OrderFulfillmentV3[]
    transactions: OrderTransactionV3[]
    source: OrderSourceTypeV3
    /** The current balance of the order */
    currentBalance: Scalars['Float']
    /** The current balance of the order in home currency */
    currentBalanceInHomeCurrency: Scalars['Float']
    /** The current unfulfilled balance of the order */
    currentUnfulfilledBalance: Scalars['Float']
    /** The current unfulfilled balance of the order in home currency */
    currentUnfulfilledBalanceInHomeCurrency: Scalars['Float']
    /** The ID of the sales channel that the order belongs to */
    salesChannelId?: Scalars['String']
    billingAddressId?: Scalars['String']
    shippingAddressId?: Scalars['String']
    __typename: 'OrderV3'
}

export interface OrderV3NotFound {
    message: Scalars['String']
    __typename: 'OrderV3NotFound'
}

export type OrderVoidedByType = 'FINALOOP' | 'INTEGRATION'

export interface OtherFbaAction {
    quantity: Scalars['Float']
    id: Scalars['String']
    date: Scalars['Date']
    type: Scalars['String']
    __typename: 'OtherFbaAction'
}

export interface OtherFbaCogs {
    amount: Scalars['Float']
    otherFbaIncoming: Scalars['Int']
    otherFba: Scalars['Int']
    monthlyBreakdown: OtherFbaMonthlyBreakdown[]
    __typename: 'OtherFbaCogs'
}

export interface OtherFbaDailyBreakdown {
    date: Scalars['Date']
    otherFbaIncoming: Scalars['Int']
    otherFba: Scalars['Int']
    reason?: AdjustmentsReason[]
    __typename: 'OtherFbaDailyBreakdown'
}

export interface OtherFbaMonthlyBreakdown {
    date: Scalars['Date']
    otherFbaIncoming: Scalars['Int']
    otherFba: Scalars['Int']
    dailyData: OtherFbaDailyBreakdown[]
    __typename: 'OtherFbaMonthlyBreakdown'
}

export type OverrideOrderFulfillmentsError = (OverrideOrderFulfillmentsErrorInvalidLineItem | OverrideOrderFulfillmentsErrorInvalidOrder | OverrideOrderFulfillmentsErrorInvalidWarehouse | OverrideOrderFulfillmentsErrorInvalidQuantity | OverrideOrderFulfillmentsErrorQuantityDiscrepancy | OverrideOrderFulfillmentsErrorInvalidFulfillmentWarehouse | OverrideOrderFulfillmentsErrorInvalidFulfillmentDate | OverrideOrderFulfillmentsErrorLockedFulfillmentDate | OverrideOrderFulfillmentsErrorMissingOverride | OverrideOrderFulfillmentsErrorMisc) & { __isUnion?: true }

export interface OverrideOrderFulfillmentsErrorInvalidFulfillmentDate {
    /** The id of the line item in the order. */
    lineItemId: Scalars['ID']
    /** The date of the fulfillment */
    fulfilledAt?: Scalars['Date']
    /** The warehouse ID for which the invalid date was provided */
    warehouseId?: Scalars['String']
    /** An optional error message, describing the error in more detail */
    message?: Scalars['String']
    __typename: 'OverrideOrderFulfillmentsErrorInvalidFulfillmentDate'
}


/** Invalid warehouse ID was found in a fulfillment */
export interface OverrideOrderFulfillmentsErrorInvalidFulfillmentWarehouse {
    /** The fulfillment ID for which the invalid warehouse ID was provided */
    fulfillmentId: Scalars['ID']
    /** The invalid warehouse ID. Omitted if the warehouse ID was missing in the fulfillment. */
    warehouseId?: Scalars['String']
    /** The date of the fulfillment */
    fulfilledAt?: Scalars['Date']
    /** An optional error message, describing the error in more detail */
    message?: Scalars['String']
    __typename: 'OverrideOrderFulfillmentsErrorInvalidFulfillmentWarehouse'
}


/** An invalid line item ID was provided */
export interface OverrideOrderFulfillmentsErrorInvalidLineItem {
    /** The invalid line item ID */
    lineItemId: Scalars['ID']
    /** An optional error message, describing the error in more detail */
    message?: Scalars['String']
    __typename: 'OverrideOrderFulfillmentsErrorInvalidLineItem'
}


/** An invalid order ID was provided */
export interface OverrideOrderFulfillmentsErrorInvalidOrder {
    /** The invalid order ID */
    orderId?: Scalars['ID']
    /** An optional error message, describing the error in more detail */
    message?: Scalars['String']
    __typename: 'OverrideOrderFulfillmentsErrorInvalidOrder'
}


/** An invalid quantity was provided, e.g. a negative value */
export interface OverrideOrderFulfillmentsErrorInvalidQuantity {
    /** The line item ID for which the invalid quantity was provided */
    lineItemId: Scalars['ID']
    /** The warehouse ID for which the invalid quantity was provided */
    warehouseId?: Scalars['String']
    /** The date of the fulfillment for which the invalid quantity was provided */
    fulfilledAt?: Scalars['Date']
    /** The invalid quantity */
    quantity?: Scalars['Int']
    /** An optional error message, describing the error in more detail */
    message?: Scalars['String']
    __typename: 'OverrideOrderFulfillmentsErrorInvalidQuantity'
}


/** An invalid or inaccessible warehouse ID was provided */
export interface OverrideOrderFulfillmentsErrorInvalidWarehouse {
    /** The line item ID for which the invalid warehouse ID was provided */
    lineItemId: Scalars['ID']
    /** The invalid warehouse ID */
    warehouseId?: Scalars['String']
    /** The date of the fulfillment */
    fulfilledAt?: Scalars['Date']
    /** An optional error message, describing the error in more detail */
    message?: Scalars['String']
    __typename: 'OverrideOrderFulfillmentsErrorInvalidWarehouse'
}


/** A fulfillment date is within a locked time period */
export interface OverrideOrderFulfillmentsErrorLockedFulfillmentDate {
    /** The id of the line item in the order. */
    lineItemId: Scalars['ID']
    /** The locked date of the fulfillment */
    fulfilledAt?: Scalars['Date']
    /** The warehouse ID for which the locked date was provided */
    warehouseId?: Scalars['String']
    /** An optional error message, describing the error in more detail */
    message?: Scalars['String']
    __typename: 'OverrideOrderFulfillmentsErrorLockedFulfillmentDate'
}

export interface OverrideOrderFulfillmentsErrorMisc {
    /** An optional error message, describing the error in more detail */
    message?: Scalars['String']
    __typename: 'OverrideOrderFulfillmentsErrorMisc'
}


/**
 * An override is missing for an existing line item fulfillment warehouse-date combination.
 * Any line item that is provided with overrides must have overrides for all its fulfillments,
 * even if it means sending overrides with identical quantities.
 * This is required to confirm that quantities moving between warehouses/dates are all accounted for.
 */
export interface OverrideOrderFulfillmentsErrorMissingOverride {
    /** The id of the line item in the order. */
    lineItemId: Scalars['ID']
    /** The date of the missing fulfillment */
    fulfilledAt?: Scalars['Date']
    /** The warehouse ID of the missing fulfillment */
    warehouseId?: Scalars['String']
    /** An optional error message, describing the error in more detail */
    message?: Scalars['String']
    __typename: 'OverrideOrderFulfillmentsErrorMissingOverride'
}

export interface OverrideOrderFulfillmentsErrorQuantityDiscrepancy {
    /**
     * The calculated quantity that is in discrepancy with the quantity of the line item in the order.
     * Note this may be a result of multiple fulfillment entries for different warehouses and dates.
     */
    quantity?: Scalars['Int']
    /** The quantity of the line item in the order. */
    lineItemQuantity?: Scalars['Int']
    /** The id of the line item in the order. */
    lineItemId: Scalars['ID']
    /** An optional error message, describing the error in more detail */
    message?: Scalars['String']
    __typename: 'OverrideOrderFulfillmentsErrorQuantityDiscrepancy'
}

export interface OverrideOrderFulfillmentsOrderResponse {
    orderId: Scalars['ID']
    /**
     * Whether the operation was successful. If `false`, at least one input order updated has failed,
     * however, other orders may have been updated successfully.
     * For failed orders, the `errors` field will contain the errors that occurred.
     */
    success: Scalars['Boolean']
    errors?: OverrideOrderFulfillmentsError[]
    __typename: 'OverrideOrderFulfillmentsOrderResponse'
}

export interface OverrideOrderFulfillmentsResponse {
    orders: OverrideOrderFulfillmentsOrderResponse[]
    __typename: 'OverrideOrderFulfillmentsResponse'
}

export type OverviewConnectionStatus = 'CLOSED' | 'CONNECTED' | 'DISCONNECTED' | 'IMPORT_STOPPED' | 'MANUAL'

export interface OverviewCycle {
    fromDate: Scalars['Date']
    toDate: Scalars['Date']
    openingBalance: Scalars['Float']
    purchasesSum: Scalars['Float']
    assemblyCostsSum: Scalars['Float']
    cogsSum: Scalars['Float']
    cogsAdjustmentsSum: Scalars['Float']
    closingBalance: Scalars['Float']
    warehouseTransfersSum: Scalars['Float']
    physicalCountAdjustment: Scalars['Float']
    __typename: 'OverviewCycle'
}

export type PaidStatus = 'PAID' | 'PARTIALLY_PAID' | 'UNPAID'

export type PairedEntity = (Bill | Payout | Topup | BankTransaction | CompanyAffiliate) & { __isUnion?: true }

export type PairedEntityType = 'BANK_AFFECTING_INTEGRATION_EVENT' | 'BANK_TRANSACTION' | 'BILL' | 'INVOICE' | 'ORDER_GROUP' | 'COMPANY_AFFILIATE_BALANCE' | 'PAYMENT_CHECK' | 'PAYROLL' | 'PAYMENT_GROUP'

export type PairingType = 'INTERNAL_TRANSFER' | 'MATCH' | 'REFUND' | 'FAILED_TRANSFER'

export type ParentLineItemType = 'PRODUCT' | 'TAX' | 'SHIPPING' | 'DISCOUNT' | 'FEE' | 'TIP'

export interface Payment {
    companyId: Scalars['ID']
    id: Scalars['ID']
    source: IntegrationType
    integrationAccountId: Scalars['ID']
    integrationAccountName?: Scalars['String']
    amount: Scalars['Float']
    currency: Scalars['String']
    postedAt: Scalars['Date']
    externalAuthorizationCode?: Scalars['String']
    __typename: 'Payment'
}

export interface PaymentCheck {
    id: Scalars['ID']
    company: Company
    source: Scalars['String']
    postedAt: Scalars['Date']
    amount: Scalars['Float']
    currency: Scalars['String']
    amountInHomeCurrency: Scalars['Float']
    contractor?: Contractor
    employee?: Employee
    matchedBankTransaction?: BankTransaction
    isImmaterial: Scalars['Boolean']
    __typename: 'PaymentCheck'
}

export interface PaymentDetails {
    id: Scalars['ID']
    price: Scalars['Float']
    __typename: 'PaymentDetails'
}

export interface PaymentFee {
    companyId: Scalars['ID']
    id: Scalars['ID']
    source: IntegrationType
    integrationAccountId: Scalars['ID']
    integrationAccountName?: Scalars['String']
    amount: Scalars['Float']
    currency: Scalars['String']
    type: PaymentFeeType
    basis: PaymentFeeBasis
    postedAt: Scalars['Date']
    __typename: 'PaymentFee'
}

export type PaymentFeeBasis = 'PERCENTAGE' | 'FIXED'

export type PaymentFeeType = 'PROCESSING' | 'DISPUTE'

export type PaymentGateway = 'AFTERPAY' | 'AMAZON_PAY' | 'PAYPAL' | 'SHOP_PAY' | 'STRIPE' | 'GIFT_CARD' | 'EXCHANGE_CREDIT' | 'STORE_CREDIT' | 'MANUAL' | 'UNKNOWN' | 'NO_GATEWAY' | 'AFFIRM' | 'ALMA' | 'AUTHORIZE_NET' | 'BLACKCART' | 'BRAINTREE' | 'CLEARCO' | 'CLEARPAY' | 'FAIRE' | 'PARKER' | 'KLARNA' | 'KLICKLY' | 'SETTLE' | 'SEZZLE' | 'QUICKBOOKS_PAYMENTS' | 'SQUARE' | 'WOOCOMMERCE' | 'FACEBOOK' | 'ZIP_CO' | 'SPLITIT' | 'BREAD_PAY' | 'GLOBAL_E' | 'SNACK_MAGIC' | 'POSTAL' | 'CORPORATE_GIFT' | 'CAROO'

export type PaymentGatewayType = 'AFFIRM' | 'AMAZON_PAY' | 'BRAINTREE' | 'FAIRE' | 'KLARNA' | 'SEZZLE' | 'TRUE_MED'

export interface PaymentGroup {
    id: Scalars['ID']
    __typename: 'PaymentGroup'
}

export interface PaymentGroupExpense {
    id: Scalars['ID']
    expenseType: PaymentGroupExpenseType
    amount: Amounts
    vendor?: Vendor
    merchant?: VendorOrCustomer
    __typename: 'PaymentGroupExpense'
}

export type PaymentGroupExpenseType = 'ADVERTISING' | 'BRICK_AND_MORTAR' | 'DEDUCTION' | 'DISCOUNT' | 'FEE' | 'MERCHANT_FEE' | 'SELLING_FEE' | 'FX_COMMISSION' | 'PLATFORM_ADJUSTMENT' | 'ORDERS_CREDIT'

export interface PaymentGroupLink {
    paymentGroupId: Scalars['ID']
    amount: Scalars['Float']
    amountInHomeCurrency: Scalars['Float']
    currency: CurrencyCode
    postedAt: Scalars['Date']
    __typename: 'PaymentGroupLink'
}

export interface PaymentGroupLinkedBankTransaction {
    bankTransaction: BankTransaction
    bankTransactionPostedAt: Scalars['Date']
    amount: Amounts
    id: Scalars['ID']
    __typename: 'PaymentGroupLinkedBankTransaction'
}

export interface PaymentGroupLinkedInventoryPurchases {
    inventoryPurchase: InventoryPurchase
    inventoryPurchasePostedAt: Scalars['Date']
    amount: Amounts
    id: Scalars['ID']
    __typename: 'PaymentGroupLinkedInventoryPurchases'
}

export interface PaymentGroupLinkedInvoice {
    invoice: Invoice
    amountInHomeCurrency: Scalars['Float']
    currency: CurrencyCode
    amount: Scalars['Float']
    id: Scalars['ID']
    __typename: 'PaymentGroupLinkedInvoice'
}

export interface PaymentGroupLinkedManualAssembly {
    id: Scalars['ID']
    manualAssembly: ManualAssembly
    amountInHomeCurrency: Scalars['Float']
    __typename: 'PaymentGroupLinkedManualAssembly'
}

export interface PaymentGroupLinkedOnDemandAssemblyVendorCost {
    id: Scalars['ID']
    onDemandAssemblyVendorCost: OnDemandAssemblyVendorCosts
    amountInHomeCurrency: Scalars['Float']
    __typename: 'PaymentGroupLinkedOnDemandAssemblyVendorCost'
}

export interface PaymentGroupLinkedOrder {
    order: OrderV2
    amountInHomeCurrency: Scalars['Float']
    __typename: 'PaymentGroupLinkedOrder'
}

export interface PaymentGroupLinkedPurchaseOrder {
    id: Scalars['ID']
    purchaseOrder: PurchaseOrder
    amountInHomeCurrency: Scalars['Float']
    __typename: 'PaymentGroupLinkedPurchaseOrder'
}

export interface PaymentGroupLinkedWarehouseTransfer {
    id: Scalars['ID']
    warehouseTransfer: WarehouseTransfer
    amountInHomeCurrency: Scalars['Float']
    __typename: 'PaymentGroupLinkedWarehouseTransfer'
}

export interface PaymentGroupLinksForInvoiceResponse {
    paymentGroupLinks: PaymentGroupLink[]
    __typename: 'PaymentGroupLinksForInvoiceResponse'
}

export interface PaymentGroupLinksResponse {
    paymentGroupLinks: PaymentGroupLink[]
    __typename: 'PaymentGroupLinksResponse'
}

export interface PaymentGroupsByIdsResponse {
    paymentGroups: IPaymentGroup[]
    __typename: 'PaymentGroupsByIdsResponse'
}

export type PaymentGroupsSortDirection = 'ASC' | 'DESC'

export type PaymentGroupsSortType = 'POSTED_AT'

export interface PaymentGroupsTotalUnclearedBalanceResponse {
    asOfDate: Scalars['Date']
    totalUnclearedBalance: Amounts
    __typename: 'PaymentGroupsTotalUnclearedBalanceResponse'
}

export interface PaymentGroupTransaction {
    id: Scalars['ID']
    integrationInfo?: IntegrationInfo
    integrationAccountId?: Scalars['String']
    externalSourceId?: Scalars['String']
    amount: Scalars['Float']
    postedAt: Scalars['Date']
    currency: CurrencyCode
    amountInHomeCurrency: Scalars['Float']
    type: TransactionType
    finaloopPaymentGateway?: Scalars['String']
    originalPaymentGateway?: Scalars['String']
    paymentGatewayVariant?: Scalars['String']
    isIndication: Scalars['Boolean']
    paymentGroup: PaymentGroup
    __typename: 'PaymentGroupTransaction'
}

export type PaymentGroupType = 'INVOICE' | 'ORDER'

export type PaymentLinkStatus = 'LIVE' | 'PROCESSING' | 'PAID' | 'FAILED' | 'EXPIRED' | 'CANCELLED'

export interface PaymentMethod {
    id: Scalars['ID']
    source: Scalars['String']
    type: PaymentMethodType
    isDefault: Scalars['Boolean']
    integrationAccountId?: Scalars['String']
    instructions?: Scalars['String']
    bankName?: Scalars['String']
    accountNumber?: Scalars['String']
    routingNumber?: Scalars['String']
    swift?: Scalars['String']
    __typename: 'PaymentMethod'
}

export type PaymentMethodType = 'ACH' | 'CHECK' | 'CUSTOM' | 'INVOICE_PAY'

export interface PaymentProcessorByCompanyAndVendorResponse {
    processor?: Scalars['String']
    __typename: 'PaymentProcessorByCompanyAndVendorResponse'
}

export type PaymentRecurrence = 'MONTHLY' | 'YEARLY'

export interface Payout {
    id: Scalars['ID']
    companyId: Scalars['String']
    amount: Scalars['Float']
    amountInUsd: Scalars['Float']
    currency: Scalars['String']
    eventTime: Scalars['Date']
    deletedAt?: Scalars['Date']
    markedAsReconciliationDiscrepancyAt?: Scalars['Date']
    integrationType: IntegrationType
    pairedBankTransaction?: BankTransaction
    type: IntegrationTransferType
    classification?: IntegrationTransferClassification
    integrationAccountId?: Scalars['ID']
    integrationAccountName?: Scalars['String']
    pairedCompanyAffiliate?: CompanyAffiliate
    link?: Scalars['String']
    uploadedFileId?: Scalars['String']
    failedAmountInUsd?: Scalars['Float']
    failedAt?: Scalars['Date']
    markedAsUnidentifiedAt?: Scalars['Date']
    rawEvent?: Scalars['JSON']
    __typename: 'Payout'
}

export interface Payroll {
    id: Scalars['ID']
    company: Company
    source: Scalars['String']
    integrationAccountId?: Scalars['String']
    externalSourceId?: Scalars['String']
    integrationAccountName?: Scalars['String']
    currency: Scalars['String']
    postedAt: Scalars['Date']
    deletedAt?: Scalars['Date']
    createdAt: Scalars['Date']
    updatedAt: Scalars['Date']
    __typename: 'Payroll'
}

export type PayrollCategory = 'DEFAULT' | 'INVENTORY' | 'RESEARCH_AND_DEVELOPMENT' | 'SHIPPING_AND_FULFILLMENT' | 'MARKETING' | 'GENERAL_AND_ADMINISTRATIVE'

export type PayrollCategoryMapping = (PayrollDepartmentCategoryMapping | PayrollEmployeeCategoryMapping | PayrollContractorCategoryMapping) & { __isUnion?: true }

export type PayrollCategoryMappingMode = 'DEPARTMENT' | 'PERSONNEL'

export interface PayrollConnection {
    integrationAccountId: Scalars['ID']
    integrationType: IntegrationType
    integrationAccountName: Scalars['String']
    importStatus?: PayrollConnectionImportStatus
    disconnectedAt?: Scalars['Date']
    disconnectedBy?: Scalars['String']
    __typename: 'PayrollConnection'
}

export interface PayrollConnectionImportStatus {
    contractorPayments: PayrollConnectionImportStatusData
    contractors: PayrollConnectionImportStatusData
    departments: PayrollConnectionImportStatusData
    employees: PayrollConnectionImportStatusData
    payrolls: PayrollConnectionImportStatusData
    __typename: 'PayrollConnectionImportStatus'
}

export interface PayrollConnectionImportStatusData {
    lastUpdateTime: Scalars['Date']
    __typename: 'PayrollConnectionImportStatusData'
}

export interface PayrollContractorCategoryMapping {
    contractor: Contractor
    category?: PayrollCategory
    __typename: 'PayrollContractorCategoryMapping'
}

export interface PayrollDailyAggregate {
    id: Scalars['ID']
    currency: Scalars['String']
    postedAt: Scalars['Date']
    source: Scalars['String']
    integrationAccountName?: Scalars['String']
    integrationAccountId?: Scalars['String']
    startDate: Scalars['Date']
    endDate: Scalars['Date']
    unallocatedHealthBenefitsContribution: Scalars['Float']
    unallocatedCompanyTaxes: Scalars['Float']
    unallocatedDonationDeductions: Scalars['Float']
    pension401k?: Scalars['Float']
    deletedAt?: Scalars['Date']
    matchedBankTransaction?: BankTransaction
    paymentChecks: DailyAggregatedPaymentCheck[]
    reimbursements: DailyAggregatedReimbursement[]
    ownersDraw: DailyAggregatedOwnersDraw[]
    integrationTransfers: PayrollIntegrationTransfer[]
    taxDebitAmount: Scalars['Float']
    netPayDebitAmount: Scalars['Float']
    dailyAggregates: DailyAggregatedPayrollData[]
    unpaidAmountsViaProvider: UnpaidAmountsViaProvider[]
    __typename: 'PayrollDailyAggregate'
}

export interface PayrollData {
    knownVendors: Scalars['String'][]
    unknownVendors: Scalars['String'][]
    __typename: 'PayrollData'
}

export interface PayrollDepartmentCategoryMapping {
    department: Department
    category?: PayrollCategory
    __typename: 'PayrollDepartmentCategoryMapping'
}

export interface PayrollEmployeeCategoryMapping {
    employee: Employee
    category?: PayrollCategory
    __typename: 'PayrollEmployeeCategoryMapping'
}

export type PayrollEmploymentType = 'EMPLOYEE' | 'OFFICER' | 'PARTNER'

export interface PayrollIdsByCompanyItem {
    companyId: Scalars['String']
    payrollIds: Scalars['ID'][]
    __typename: 'PayrollIdsByCompanyItem'
}

export interface PayrollIdsByCompanyResponse {
    items: PayrollIdsByCompanyItem[]
    __typename: 'PayrollIdsByCompanyResponse'
}

export interface PayrollIntegrationTransfer {
    integrationTransferId: Scalars['String']
    type: PayrollIntegrationTransferType
    amount: Scalars['Float']
    amountInHomeCurrency: Scalars['Float']
    deletedAt?: Scalars['Date']
    __typename: 'PayrollIntegrationTransfer'
}

export type PayrollIntegrationTransferType = 'NET_PAY' | 'TAX' | 'REIMBURSEMENT' | 'GARNISHMENT' | 'RETIREMENT' | 'GENERAL'

export type PayrollMappableType = 'DEPARTMENT' | 'EMPLOYEE' | 'CONTRACTOR'

export interface PayrollSettings {
    withCategoryMapping: Scalars['Boolean']
    categoryMappingMode: PayrollCategoryMappingMode
    categoryMappings: PayrollCategoryMapping[]
    __typename: 'PayrollSettings'
}

export interface PendingAdjustmentsExcludeListItem {
    productId: Scalars['String']
    date?: Scalars['Date']
    warehouseId?: Scalars['String']
    __typename: 'PendingAdjustmentsExcludeListItem'
}

export interface PendingAdjustmentsOverviewResponse {
    count: Scalars['Int']
    pendingCount: Scalars['Int']
    missingDataCount: Scalars['Int']
    lastPendingChange?: Scalars['Date']
    __typename: 'PendingAdjustmentsOverviewResponse'
}

export interface PendingDeadInventoryAdjustments {
    id: Scalars['String']
    date?: Scalars['Date']
    quantity?: Scalars['Int']
    warehouseId?: Scalars['String']
    warehouse?: Warehouse
    productId: Scalars['String']
    companyId: Scalars['String']
    currentState?: DeadInventoryOriginalValue
    __typename: 'PendingDeadInventoryAdjustments'
}

export interface PendingDeadInventoryAdjustmentsByIdsResponse {
    items: PendingDeadInventoryAdjustments[]
    __typename: 'PendingDeadInventoryAdjustmentsByIdsResponse'
}

export interface PendingDeadInventoryAdjustmentsItem {
    productId: Scalars['String']
    product: Product
    pendingDeadInventoryAdjustments?: PendingDeadInventoryAdjustments
    __typename: 'PendingDeadInventoryAdjustmentsItem'
}

export interface PendingDeadInventoryAdjustmentsResponse {
    items?: PendingDeadInventoryAdjustmentsItem[]
    excludeList: PendingAdjustmentsExcludeListItem[]
    __typename: 'PendingDeadInventoryAdjustmentsResponse'
}

export interface PendingDonationAdjustments {
    id: Scalars['String']
    date?: Scalars['Date']
    quantity?: Scalars['Int']
    warehouseId?: Scalars['String']
    warehouse?: Warehouse
    productId: Scalars['String']
    companyId: Scalars['String']
    currentState?: DonationOriginalValue
    __typename: 'PendingDonationAdjustments'
}

export interface PendingDonationAdjustmentsByIdsResponse {
    items: PendingDonationAdjustments[]
    __typename: 'PendingDonationAdjustmentsByIdsResponse'
}

export interface PendingDonationAdjustmentsItem {
    productId: Scalars['String']
    product: Product
    pendingDonationAdjustments?: PendingDonationAdjustments
    __typename: 'PendingDonationAdjustmentsItem'
}

export interface PendingDonationAdjustmentsResponse {
    items?: PendingDonationAdjustmentsItem[]
    excludeList: PendingAdjustmentsExcludeListItem[]
    __typename: 'PendingDonationAdjustmentsResponse'
}

export interface PendingGiveawayAdjustments {
    id: Scalars['String']
    date?: Scalars['Date']
    quantity?: Scalars['Int']
    warehouseId?: Scalars['String']
    warehouse?: Warehouse
    productId: Scalars['String']
    companyId: Scalars['String']
    currentState?: GiveawayOriginalValue
    __typename: 'PendingGiveawayAdjustments'
}

export interface PendingGiveawayAdjustmentsByIdsResponse {
    items: PendingGiveawayAdjustments[]
    __typename: 'PendingGiveawayAdjustmentsByIdsResponse'
}

export interface PendingGiveawayAdjustmentsItem {
    productId: Scalars['String']
    product: Product
    pendingGiveawayAdjustments?: PendingGiveawayAdjustments
    __typename: 'PendingGiveawayAdjustmentsItem'
}

export interface PendingGiveawayAdjustmentsResponse {
    items?: PendingGiveawayAdjustmentsItem[]
    excludeList: PendingAdjustmentsExcludeListItem[]
    __typename: 'PendingGiveawayAdjustmentsResponse'
}

export interface PendingGiveawayDropshippingAdjustments {
    id: Scalars['String']
    date?: Scalars['Date']
    quantity?: Scalars['Int']
    warehouseId?: Scalars['String']
    warehouse?: Warehouse
    productId: Scalars['String']
    companyId: Scalars['String']
    currentState?: GiveawayDropshippingOriginalValue
    __typename: 'PendingGiveawayDropshippingAdjustments'
}

export interface PendingGiveawayDropshippingAdjustmentsByIdsResponse {
    items: PendingGiveawayDropshippingAdjustments[]
    __typename: 'PendingGiveawayDropshippingAdjustmentsByIdsResponse'
}

export interface PendingGiveawayDropshippingAdjustmentsItem {
    productId: Scalars['String']
    product: Product
    pendingGiveawayDropshippingAdjustments?: PendingGiveawayDropshippingAdjustments
    __typename: 'PendingGiveawayDropshippingAdjustmentsItem'
}

export interface PendingGiveawayDropshippingAdjustmentsResponse {
    items?: PendingGiveawayDropshippingAdjustmentsItem[]
    excludeList: PendingAdjustmentsExcludeListItem[]
    __typename: 'PendingGiveawayDropshippingAdjustmentsResponse'
}

export type PendingProductAdjustmentsDataType = 'MISSING' | 'PENDING'

export interface PendingSalesDataAdjustments {
    id: Scalars['String']
    salesChannel: SalesChannel
    date?: Scalars['Date']
    unitsSold?: Scalars['Int']
    unitsRestocked?: Scalars['Int']
    warehouseId?: Scalars['String']
    warehouse?: Warehouse
    productId: Scalars['String']
    companyId: Scalars['String']
    currentState?: SalesAdjustmentOriginalValue
    __typename: 'PendingSalesDataAdjustments'
}

export interface PendingSalesDataAdjustmentsByIdsResponse {
    items: PendingSalesDataAdjustments[]
    __typename: 'PendingSalesDataAdjustmentsByIdsResponse'
}

export interface PendingSalesDataAdjustmentsItem {
    productId: Scalars['String']
    product: Product
    pendingSalesDataAdjustments?: PendingSalesDataAdjustments
    __typename: 'PendingSalesDataAdjustmentsItem'
}

export interface PendingSalesDataAdjustmentsOverviewResponse {
    count: Scalars['Int']
    pendingCount: Scalars['Int']
    missingDataCount: Scalars['Int']
    lastPendingChange?: Scalars['Date']
    __typename: 'PendingSalesDataAdjustmentsOverviewResponse'
}

export interface PendingSalesDataAdjustmentsResponse {
    items?: PendingSalesDataAdjustmentsItem[]
    excludeList: PendingAdjustmentsExcludeListItem[]
    __typename: 'PendingSalesDataAdjustmentsResponse'
}

export interface PendingWarehouseOpeningBalance {
    id?: Scalars['ID']
    warehouse?: Warehouse
    quantity?: Scalars['Float']
    costPerUnit?: Scalars['Float']
    date?: Scalars['Date']
    attachmentId?: Scalars['String']
    __typename: 'PendingWarehouseOpeningBalance'
}

export interface PendingWarehouseOpeningBalanceAttachment {
    id: Scalars['ID']
    companyId: Scalars['String']
    date: Scalars['Date']
    filename: Scalars['String']
    url: Scalars['String']
    createdAt: Scalars['Date']
    deletedAt?: Scalars['Date']
    pendingChangesCount: Scalars['Int']
    summaryData?: PendingWarehouseOpeningBalancesAttachmentSummary
    __typename: 'PendingWarehouseOpeningBalanceAttachment'
}

export interface PendingWarehouseOpeningBalancesAttachmentSummary {
    totalCount: Scalars['Int']
    validCount: Scalars['Int']
    invalidCount: Scalars['Int']
    errorCount: Scalars['Int']
    errorItems?: WarehouseOpeningBalanceErrorItem[]
    __typename: 'PendingWarehouseOpeningBalancesAttachmentSummary'
}

export interface PendingWarehouseOpeningBalancesResponse {
    items: WarehouseOpeningBalanceItem[]
    __typename: 'PendingWarehouseOpeningBalancesResponse'
}

export interface PendingWarehouseOpeningBalancesWithCsvResponse {
    attachmentId: Scalars['ID']
    summaryData: PendingWarehouseOpeningBalancesAttachmentSummary
    __typename: 'PendingWarehouseOpeningBalancesWithCsvResponse'
}

export interface PeriodicPartnerReport {
    company: Company
    partner: ReportsPartner
    createdAt: Scalars['Date']
    latestActorId: Scalars['String']
    __typename: 'PeriodicPartnerReport'
}

export interface Permission {
    id: Scalars['ID']
    name: Scalars['String']
    __typename: 'Permission'
}

export interface PhysicalCountValidationData {
    items: PhysicalCountValidationItem[]
    __typename: 'PhysicalCountValidationData'
}

export interface PhysicalCountValidationItem {
    date: Scalars['Date']
    booksAmount: Scalars['Float']
    entityAmount: Scalars['Float']
    diff: Scalars['Float']
    __typename: 'PhysicalCountValidationItem'
}

export interface PhysicalCountValidationResponse {
    validationId: Scalars['String']
    __typename: 'PhysicalCountValidationResponse'
}

export type Platform = 'FACEBOOK_ADS' | 'GOOGLE_ADS'

export interface ProcessBillContentResult {
    isSuccessful: Scalars['Boolean']
    id?: Scalars['ID']
    vendor?: Vendor
    categories?: Category[]
    date?: Scalars['Date']
    dueDate?: Scalars['Date']
    __typename: 'ProcessBillContentResult'
}

export interface ProcessLoanAttachmentResult {
    success: Scalars['Boolean']
    errors?: LoanAttachmentError[]
    processing?: Scalars['Boolean']
    __typename: 'ProcessLoanAttachmentResult'
}

export type Product = (AmazonProduct | MergedProduct | ShopifyProduct | TikTokProduct | UserManualProduct | WalmartProduct) & { __isUnion?: true }

export interface ProductAnalyticsOverview {
    inTransit?: Scalars['Float']
    incoming?: Scalars['Float']
    netDepleted?: Scalars['Float']
    onHand?: Scalars['Float']
    costPerUnit?: Scalars['Float']
    onHandCost?: Scalars['Float']
    unavailable?: Scalars['Float']
    openingBalanceCost?: Scalars['Float']
    openingBalanceQuantity?: Scalars['Float']
    __typename: 'ProductAnalyticsOverview'
}

export interface ProductAppliedCost {
    asOfDate: Scalars['Date']
    appliedCost: Scalars['Float']
    source: ProductAppliedCostSource
    type: ProductAppliedCostType
    isLocked?: Scalars['Boolean']
    __typename: 'ProductAppliedCost'
}

export type ProductAppliedCostSource = 'USER' | 'SHOPIFY'

export type ProductAppliedCostType = 'GENERAL' | 'DROPSHIPPING'

export interface ProductAppliedCostWithDepletedCount {
    asOfDate: Scalars['Date']
    appliedCost: Scalars['Float']
    source: ProductAppliedCostSource
    depletedCount: Scalars['Int']
    type: ProductAppliedCostType
    isLocked?: Scalars['Boolean']
    __typename: 'ProductAppliedCostWithDepletedCount'
}

export interface ProductAssembliesBreakdownResult {
    manualAssemblies: ManualAssemblyBreakdown[]
    onDemandAssemblies: OnDemandAssemblyBreakdown[]
    __typename: 'ProductAssembliesBreakdownResult'
}

export type ProductAttributesTypes = 'ACTIVE' | 'INACTIVE' | 'MERGED' | 'NOT_MERGED' | 'HAS_RECIPE' | 'NO_RECIPE' | 'COMPONENT_OF' | 'NOT_COMPONENT_OF' | 'VISIBLE' | 'NOT_VISIBLE' | 'FRACTIONAL' | 'NOT_FRACTIONAL' | 'DROPSHIPPING' | 'NOT_DROPSHIPPING'

export interface ProductAutomergeMatchGroupSetting {
    matchGroupType: ProductMergeRecommendationsGroupType
    isEnabled: Scalars['Boolean']
    __typename: 'ProductAutomergeMatchGroupSetting'
}

export type ProductBulkAdjustmentStatusState = 'IN_PROGRESS' | 'DONE' | 'FAILED'

export type ProductBulkAdjustmentStatusType = 'SALES' | 'DEAD_INVENTORY' | 'GIVEAWAY' | 'GIVEAWAY_DROPSHIPPING' | 'DONATIONS'

export interface ProductBulkEditCsvAttachment {
    id: Scalars['ID']
    companyId: Scalars['String']
    filename: Scalars['String']
    url: Scalars['String']
    createdAt: Scalars['Date']
    deletedAt?: Scalars['Date']
    summaryData?: ProductBulkEditCsvSummary
    __typename: 'ProductBulkEditCsvAttachment'
}

export interface ProductBulkEditCsvAttachmentsResponse {
    attachments: ProductBulkEditCsvAttachment[]
    __typename: 'ProductBulkEditCsvAttachmentsResponse'
}

export type ProductBulkEditCsvAttachmentType = 'PHYSICAL_COUNT_UNIT_TRACKING' | 'PHYSICAL_COUNT_NO_UNIT_TRACKING' | 'WAREHOUSE_OPENING_BALANCE' | 'SALES_ADJUSTMENTS' | 'DEAD_INVENTORY_ADJUSTMENTS' | 'DONATIONS_ADJUSTMENTS' | 'GIVEN_AWAY_ADJUSTMENTS' | 'GIVEN_AWAY_DROPSHIPPING_ADJUSTMENTS'

export interface ProductBulkEditCsvErrorItem {
    rowNumber: Scalars['Int']
    cellNumber: Scalars['Int']
    errorType: ProductBulkEditCsvErrorItemType
    __typename: 'ProductBulkEditCsvErrorItem'
}

export type ProductBulkEditCsvErrorItemType = 'INVALID_HEADERS' | 'MISSING_PRODUCT' | 'MISSING_QUANTITY' | 'ROW_DUPLICATE' | 'PRODUCT_AMBIGUOUS' | 'PRODUCT_NOT_FOUND' | 'MISSING_WAREHOUSE' | 'MISSING_COST' | 'WAREHOUSE_AMBIGUOUS' | 'WAREHOUSE_NOT_FOUND' | 'INVALID_DATA' | 'MISSING_DATE' | 'UNKNOWN_ERROR' | 'MISSING_SOLD_AND_RESTOCKED' | 'DATE_OUT_OF_METHOD_RANGE'

export interface ProductBulkEditCsvSummary {
    totalCount: Scalars['Int']
    validCount: Scalars['Int']
    invalidCount: Scalars['Int']
    errorCount: Scalars['Int']
    errorItems: ProductBulkEditCsvErrorItem[]
    __typename: 'ProductBulkEditCsvSummary'
}

export interface ProductBulkEditCsvUploadResponse {
    attachmentId: Scalars['ID']
    summaryData: ProductBulkEditCsvSummary
    __typename: 'ProductBulkEditCsvUploadResponse'
}

export interface ProductDeadInventoryAdjustment {
    id?: Scalars['String']
    finaloopProductId: Scalars['String']
    date: Scalars['Date']
    unitsDeadInventory: Scalars['Float']
    warehouse?: Warehouse
    __typename: 'ProductDeadInventoryAdjustment'
}

export interface ProductDeadInventoryAdjustments {
    adjustments: ProductDeadInventoryAdjustment[]
    __typename: 'ProductDeadInventoryAdjustments'
}

export interface ProductDonationAdjustment {
    finaloopProductId: Scalars['String']
    date: Scalars['Date']
    unitsDonated: Scalars['Int']
    warehouse?: Warehouse
    __typename: 'ProductDonationAdjustment'
}

export interface ProductDonationAdjustments {
    adjustments: ProductDonationAdjustment[]
    __typename: 'ProductDonationAdjustments'
}

export interface ProductGiveawayAdjustment {
    finaloopProductId: Scalars['String']
    date: Scalars['Date']
    unitsGiveaway: Scalars['Int']
    warehouse?: Warehouse
    __typename: 'ProductGiveawayAdjustment'
}

export interface ProductGiveawayAdjustments {
    adjustments: ProductGiveawayAdjustment[]
    __typename: 'ProductGiveawayAdjustments'
}

export interface ProductLineItemV3 {
    id: Scalars['ID']
    /** The ID of the line item in the external system */
    externalLineItemId: Scalars['String']
    /** The name of the line item */
    name?: Scalars['String']
    /** The description of the line item */
    description?: Scalars['String']
    /** The amount of the line item */
    amount: Amounts
    parentId?: Scalars['String']
    /** The type of the line item */
    parentLineItemType?: ParentLineItemType
    /** The earliest date and time the line item was posted */
    earliestPostedAt: Scalars['Date']
    /** The latest date and time the line item was posted */
    latestPostedAt: Scalars['Date']
    /** The statuses of the line item */
    statuses: LineItemStatuses
    fulfillments: OrderLineItemFulfillmentV3[]
    /** The timeline of the line item */
    timeline: OrderLineItemTimelineV3[]
    product: Product
    /** The SKU of the product that the line item belongs to */
    sku: Scalars['String']
    /** The ID of the product that the line item belongs to in the external system */
    externalProductId: Scalars['String']
    /** The quantity of the line item */
    quantity: Scalars['Int']
    originalQuantity: Scalars['Int']
    /** The unit price of the line item */
    unitPrice: Scalars['Float']
    totalAmount: Scalars['Float']
    /** The type of the line item */
    type: OrderLineItemTypeV3
    __typename: 'ProductLineItemV3'
}

export interface ProductLostAndFoundAdjustment {
    finaloopProductId: Scalars['String']
    date: Scalars['Date']
    unitsLost: Scalars['Int']
    unitsFound: Scalars['Int']
    warehouse?: Warehouse
    __typename: 'ProductLostAndFoundAdjustment'
}

export interface ProductLostAndFoundAdjustments {
    adjustments: ProductLostAndFoundAdjustment[]
    __typename: 'ProductLostAndFoundAdjustments'
}

export interface ProductMergeHistoryItem {
    from?: Scalars['Date']
    to?: Scalars['Date']
    product: Product
    isPrimary: Scalars['Boolean']
    __typename: 'ProductMergeHistoryItem'
}

export interface ProductMergeLogItem {
    id: Scalars['String']
    products: ProductMergeLogItemProduct[]
    date?: Scalars['Date']
    trigger: ProductMergeLogTrigger
    actor?: Scalars['String']
    __typename: 'ProductMergeLogItem'
}

export interface ProductMergeLogItemProduct {
    product: Product
    isPrimary: Scalars['Boolean']
    date: Scalars['Date']
    trigger: ProductMergeLogTrigger
    actor?: Scalars['String']
    __typename: 'ProductMergeLogItemProduct'
}

export type ProductMergeLogSortDirection = 'ASC' | 'DESC'

export type ProductMergeLogSortField = 'DATE' | 'DISPLAY_NAME' | 'SKU' | 'SOURCE' | 'TYPE'

export type ProductMergeLogTrigger = 'MANUAL' | 'MANUAL_RECOMMENDATION' | 'AUTOMATIC' | 'MULTI'

export type ProductMergeLogTriggerType = 'MANUAL' | 'AUTOMATIC_SUGGESTION' | 'MANUAL_SUGGESTION' | 'MULTI'

export interface ProductMergeRecommendations {
    matchGroups: ProductMergeRecommendationsMatchGroup[]
    __typename: 'ProductMergeRecommendations'
}

export type ProductMergeRecommendationsGroupType = 'PERFECT' | 'FLEXIBLE' | 'SMART'

export interface ProductMergeRecommendationsMatchGroup {
    id: Scalars['String']
    type: ProductMergeRecommendationsGroupType
    mergeStartedAt?: Scalars['Date']
    mergeFinishedAt?: Scalars['Date']
    mergedCount: Scalars['Int']
    errorCount: Scalars['Int']
    totalCount: Scalars['Int']
    deletedCount: Scalars['Int']
    __typename: 'ProductMergeRecommendationsMatchGroup'
}

export interface ProductMergeRecommendationsProduct {
    product: Product
    isPrimary: Scalars['Boolean']
    deletedAt?: Scalars['Date']
    __typename: 'ProductMergeRecommendationsProduct'
}

export interface ProductMergeRecommendationsProductGroup {
    id: Scalars['String']
    deletedAt?: Scalars['Date']
    products: ProductMergeRecommendationsProduct[]
    __typename: 'ProductMergeRecommendationsProductGroup'
}

export interface ProductOtherFbaAdjustment {
    finaloopProductId: Scalars['String']
    date: Scalars['Date']
    otherFbaIncoming: Scalars['Int']
    otherFba: Scalars['Int']
    warehouse?: Warehouse
    __typename: 'ProductOtherFbaAdjustment'
}

export interface ProductOtherFbaAdjustments {
    adjustments: ProductOtherFbaAdjustment[]
    __typename: 'ProductOtherFbaAdjustments'
}

export interface ProductPendingAdjustmentsCountBreakdownResponse {
    salesAdjustmentsCount: Scalars['Int']
    deadInventoryAdjustmentsCount: Scalars['Int']
    giveawayAdjustmentsCount: Scalars['Int']
    giveawayDropshippingAdjustmentsCount: Scalars['Int']
    donationAdjustmentsCount: Scalars['Int']
    totalCount: Scalars['Int']
    salesAdjustmentsBreakdown: SalesAdjustmentsBreakdownItem[]
    __typename: 'ProductPendingAdjustmentsCountBreakdownResponse'
}

export interface ProductPurchases {
    purchaseOrder?: PurchaseOrder
    __typename: 'ProductPurchases'
}

export type ProductQuantityFilter = 'MISSING_DATA' | 'PENDING_CHANGES'

export interface Products2Result {
    products: Product[]
    hasNext: Scalars['Boolean']
    __typename: 'Products2Result'
}

export interface ProductSalesDataAdjustment {
    salesChannel: SalesChannel
    date: Scalars['Date']
    unitsSold: Scalars['Int']
    unitsRestocked: Scalars['Int']
    warehouse?: Warehouse
    __typename: 'ProductSalesDataAdjustment'
}

export interface ProductSalesDataAdjustments {
    adjustments: ProductSalesDataAdjustment[]
    __typename: 'ProductSalesDataAdjustments'
}

export type ProductSource = 'AMAZON' | 'WALMART' | 'USER_MANUAL' | 'SHOPIFY'

export type ProductSourceV3 = 'TRACKSTAR_FBA' | 'AMAZON' | 'WALMART' | 'USER_MANUAL' | 'SHOPIFY' | 'TIK_TOK'

export interface ProductsOverviewResponse {
    totalOnHandInventory: Scalars['Float']
    totalNegativeOnHand: Scalars['Float']
    productsWithoutCostCount: Scalars['Int']
    totalProducts: Scalars['Int']
    totalHidden: Scalars['Int']
    totalGeneral?: Scalars['Int']
    totalDropshipping?: Scalars['Int']
    __typename: 'ProductsOverviewResponse'
}

export interface ProductsResult {
    totalProducts: Scalars['Int']
    productsWithoutCostCount: Scalars['Int']
    totalOnHandInventory: Scalars['Float']
    totalNegativeOnHand: Scalars['Int']
    totalHidden: Scalars['Int']
    products: Product[]
    hasNext: Scalars['Boolean']
    __typename: 'ProductsResult'
}

export type ProductsSortDirection = 'ASC' | 'DESC'

export interface ProductsValidationData {
    skuData: SkuValidationData[]
    ambiguousSkus: NonMatchedSku[]
    unknownSkus: NonMatchedSku[]
    __typename: 'ProductsValidationData'
}

export interface ProductTopPerformersResponse {
    title: Scalars['String']
    updatedAt?: Scalars['Date']
    data: DataSerie[]
    labels: (Scalars['String'] | undefined)[]
    labelsIds?: Scalars['String'][]
    skus?: Scalars['String'][]
    __typename: 'ProductTopPerformersResponse'
}

export interface ProductUnitCogs {
    amount: Scalars['Float']
    quantity: Scalars['Int']
    monthlyBreakdown: ProductUnitCogsMonthlyBreakdown[]
    __typename: 'ProductUnitCogs'
}

export interface ProductUnitCogsDailyBreakdown {
    date: Scalars['Date']
    quantity: Scalars['Int']
    reason?: AdjustmentsReason[]
    __typename: 'ProductUnitCogsDailyBreakdown'
}

export interface ProductUnitCogsMonthlyBreakdown {
    date: Scalars['Date']
    quantity: Scalars['Int']
    dailyData: ProductUnitCogsDailyBreakdown[]
    __typename: 'ProductUnitCogsMonthlyBreakdown'
}

export interface ProductUnitsAdjustment {
    date: Scalars['Date']
    unitsIn: Scalars['Int']
    unitsOut: Scalars['Int']
    warehouse?: Warehouse
    __typename: 'ProductUnitsAdjustment'
}

export interface ProductUnitsAdjustments {
    adjustments: ProductUnitsAdjustment[]
    __typename: 'ProductUnitsAdjustments'
}

export interface ProductV3 {
    id: Scalars['String']
    integrationType: Scalars['String']
    integrationAccountId: Scalars['String']
    company: Company
    sku?: Scalars['String']
    price?: Scalars['Float']
    title?: Scalars['String']
    source: ProductSourceV3
    imageUrl?: Scalars['String']
    displayName?: Scalars['String']
    platformId: Scalars['String']
    parentPlatformId?: Scalars['String']
    amazonAsin?: Scalars['String']
    shopifyProductId?: Scalars['String']
    walmartItemId?: Scalars['String']
    isFractional: Scalars['Boolean']
    isBlacklisted: Scalars['Boolean']
    isMerged: Scalars['Boolean']
    isCreatedManually: Scalars['Boolean']
    isTrackingIntegrationCost: Scalars['Boolean']
    __typename: 'ProductV3'
}

export interface ProductWarehousesAnalyticsOverview {
    warehouse: Warehouse
    analytics: ProductAnalyticsOverview
    __typename: 'ProductWarehousesAnalyticsOverview'
}

export interface PurchaseBasedClosingBalance {
    missionType: InventoryYearEndMissionsType
    status: InventoryYearEndMissionStatus
    historyLog: InventoryYearEndHistoryLog[]
    managementMethodPeriod: ManagementMethodYearEndPeriod
    openingBalance: Scalars['Float']
    purchases: Scalars['Float']
    cogs: Scalars['Float']
    closingBalance: Scalars['Float']
    __typename: 'PurchaseBasedClosingBalance'
}

export interface PurchaseBasedOpeningBalance {
    missionType: InventoryYearEndMissionsType
    status: InventoryYearEndMissionStatus
    historyLog: InventoryYearEndHistoryLog[]
    managementMethodPeriod: ManagementMethodYearEndPeriod
    openingBalance: Scalars['Float']
    __typename: 'PurchaseBasedOpeningBalance'
}

export interface PurchaseBasedPurchases {
    missionType: InventoryYearEndMissionsType
    status: InventoryYearEndMissionStatus
    historyLog: InventoryYearEndHistoryLog[]
    managementMethodPeriod: ManagementMethodYearEndPeriod
    purchases: Scalars['Float']
    __typename: 'PurchaseBasedPurchases'
}

export interface PurchasedOffer {
    purchasedAt: Scalars['Date']
    tier: OfferTier
    features: Feature[]
    price: Scalars['Float']
    title: Scalars['String']
    description: Scalars['String']
    recurrence?: PaymentRecurrence
    __typename: 'PurchasedOffer'
}

export interface PurchaseOrder {
    id: Scalars['ID']
    companyId: Scalars['ID']
    displayName?: Scalars['String']
    placementDate?: Scalars['Date']
    inProgressDate?: Scalars['Date']
    vendor: Vendor
    directLineItems: DirectLineItem[]
    indirectLineItems: IndirectLineItem[]
    shipments: Shipment[]
    directCostTotal: Scalars['Float']
    indirectCostTotal: Scalars['Float']
    landedCostTotal: Scalars['Float']
    landedCostBreakdown: PurchaseOrderLandedCostBreakdown
    discountCostTotal: Scalars['Float']
    status: PurchaseOrderStatus
    publishedEventIds?: Scalars['String'][]
    deletedAt?: Scalars['Date']
    isDeleted?: Scalars['Boolean']
    serialNumber: Scalars['Int']
    notes?: Scalars['String']
    attachments: PurchaseOrderAttachment[]
    inventoryPaymentGroupLinks: InventoryPaymentGroupLink[]
    unpaidAmounts: UnpaidAmountPerAffiliatedEntity[]
    __typename: 'PurchaseOrder'
}

export interface PurchaseOrderAttachment {
    id: Scalars['ID']
    filename: Scalars['String']
    url: Scalars['String']
    __typename: 'PurchaseOrderAttachment'
}

export interface PurchaseOrderLandedCostBreakdown {
    inTransit: Scalars['Float']
    inProcess: Scalars['Float']
    received: Scalars['Float']
    __typename: 'PurchaseOrderLandedCostBreakdown'
}

export interface PurchaseOrderOverview {
    status: PurchaseOrderStatus
    landedCostTotal: Scalars['Float']
    totalPurchaseOrders: Scalars['Int']
    __typename: 'PurchaseOrderOverview'
}

export interface PurchaseOrderOverviewV2 {
    maxLandedCostTotal: Scalars['Float']
    purchaseOrderOverview: PurchaseOrderOverview[]
    __typename: 'PurchaseOrderOverviewV2'
}

export type PurchaseOrdersSortField = 'productionStartDate' | 'landedCostTotal' | 'createdAt' | 'paidStatus' | 'poName'

export type PurchaseOrderStatus = 'DRAFT' | 'PLACED' | 'IN_PROCESS' | 'PARTIALLY_SHIPPED' | 'SHIPPED' | 'PARTIALLY_RECEIVED' | 'RECEIVED'

export interface QuantityAndCost {
    quantity: Scalars['Int']
    cost: Scalars['Float']
    __typename: 'QuantityAndCost'
}

export interface Query {
    /** @deprecated Use accrualsSpreadByEntityIDs instead */
    accrualsSpreadByTransactionIDs: (AccrualsSpreadResponse | undefined)[]
    /** @deprecated Use getAccrualsByEntityIDs instead */
    getAccrualsByTransactionIDs: (Accrual | undefined)[]
    getAccrualsByEntityIDs: (AccrualV2 | undefined)[]
    getAccrualsList: (AccrualRecordResponse | undefined)[]
    exportAccrualsListCsv: ExportAccrualsListCsvResponse
    adAccounts?: AdAccount[]
    adCampaigns?: AdCampaign[]
    adSets?: AdSet[]
    balanceSheetSetup: BalanceSheetSetup
    getBalanceSheetSetupItemDocumentUrl: GetBalanceSheetSetupItemDocumentUrlReponse
    reportedBusinessBankTransactionsAccount?: BankAccount
    bankAccountInternal?: BankAccount
    bankAccountsInternal: BankAccount[]
    institutionVendorsIds: InstitutionVendorID[]
    institutionMappings: InstitutionMappingResponse
    institutionById?: Institution
    bankStatementParsingRequest?: BankStatementParsingRequest[]
    bankStatementParsingResults?: BankStatementParsingResult[]
    backOfficeBankStatementRequests: GetBackOfficeBankStatementRequestsResponse
    backOfficeBankStatementRequestsFilters: BackOfficeBankStatementRequestsFiltersResponse
    bankReconciliationStatementFiles?: ReconciliationRequestStatementFile[]
    bankReconciliationRequestsSettings: BankReconciliationRequestSettingsResponse
    companyHasBankingMission: BankingMissionResult
    isDomainBanksEnabledForBalanceSheetSetup: Scalars['Boolean']
    evaluateBankReconciliationRequestsDryRun: EvaluateBankReconciliationRequestsResponse
    explainBankAccountMerge: ExplainBankAccountMergeResponse
    bankingAudits: (BankingAudit | undefined)[]
    bankStatementFileById?: BankStatementFile
    bankStatementFilesByCompanyId?: BankStatementFile[]
    bankStatementFiles?: BankStatementFile[]
    bankAccount?: BankAccount
    bankAccounts: BankAccount[]
    bankAccountsByIds: BankAccount[]
    bankAccountReconciliations: BankAccountReconciliation[]
    bankAccountBalance: Scalars['Float']
    institutions: InstitutionsResponse
    bankReconciliationRequest?: BankReconciliationRequest
    bankReconciliationRequests?: (BankReconciliationRequest | undefined)[]
    bankConnections: BankConnection[]
    bankOverviewPageAccounts?: BankOverviewPageAccount[]
    bankConnectionMetrics?: BankingMetric[]
    bankReconciliationGraphPoints?: BankReconciliationGraphPoint[]
    bankTransaction?: BankTransaction
    bankTransactions: BankTransactionResponse
    bankTransactionsByMerchant: BankTransactionByMerchantResult
    searchMerchants: Merchant[]
    merchantBankTransactionRecommendations?: BankTransactionRecommendation[]
    searchVendorsTransactionsPriority: SearchVendorsTransactionsPriorityResult
    classificationTags: ClassificationTag[]
    classificationTagsByIds: ClassificationTag[]
    internalTransferCandidates: BankTransactionResponse
    internalTransferCandidatesV2: BankTransactionsResponse
    unidentifiedBankTransactionsGroups: UnidentifiedBankTransactionsGroup[]
    merchantsBankTransactionStats: MerchantsBankTransactionStats
    bankTransactionsSummary: BankTransactionsSummary
    merchantsByIds?: Merchant[]
    suggestBankTransactionClassification: ClassificationTagSuggestionsResponse
    lastMachineClassificationJob?: MachineClassificationJob
    convertBetweenCurrencies: ConvertBetweenCurrenciesResult
    merchantsByKeys: Merchant[]
    bankTransactionsByPairings: BankTransactionPairingResult[]
    isGlobalRuleExistByVendorAndMoneyDirection: IsGlobalRuleExistResult
    paypalTransactionCurrencies?: CurrencyCode[]
    bankTransactionUploadFileById: BankTransactionsUpload
    companyByStripeCustomerId?: Company
    stripeCustomerIdsByCompanyIds: StripeCustomerIdsResponse
    offers: GetOffersResponse
    billsByIds: Bill[]
    bill?: Bill
    billsDueDateSummary: BillsDueDateSummary
    processBillContent: ProcessBillContentResult
    bills: GetBillsResponse
    billsAgingReportCSV: AwaitedExportResponse
    billsYearEndTasks: BillsYearEndTasksResponse
    businessEventDefinitions: BusinessEventDefinition[]
    businessEventDefinitionsByIds: BusinessEventDefinition[]
    businessEventDefinitionsByGroups: BusinessEventDefinition[]
    businessEventActionsConfigurations: BusinessEventActionsConfiguration[]
    businessEventActionsConfigurationByType?: BusinessEventActionsConfiguration
    accountRoles: AccountRole[]
    classificationBusinessEventDefinitions: BusinessEventDefinition[]
    /** @deprecated Use getBusinessEventsAccrualsConfig instead */
    businessEventsAccrualsConfig: BusinessEventsAccrualsConfig[]
    getBusinessEventsAccrualsConfig: BusinessEventsAccrualsConfigV2[]
    accountRole: AccountRole
    businessEvents: BusinessEventActionsConfiguration[]
    company: Company
    getCompanyAddresses: CompanyAddress[]
    getCompanyDefaultAddress?: CompanyAddress
    signedDownloadUrl: Scalars['String']
    onboardingStatus: OnboardingStatus[]
    listCompanies: Company[]
    getCompanies: Company[]
    getCompaniesByIds: Company[]
    healthStatus: CompanyHealthStatus[]
    getLatestValidation: GetLatestValidationResult
    validationTemplates: ValidationTemplate[]
    failingValidationsByValidationCycle: FailingValidation[]
    failingValidationsByValidationTemplate: FailingValidation[]
    getEntitiesLockedPeriodBypasses: EntityLockedPeriodBypass[]
    listReadyValidations: ReadyValidation[]
    getReadyValidation?: GetReadyValidationResponse
    companyMainHolder: CompanyAffiliate
    companyAffiliatesByIds: CompanyAffiliate[]
    holderTransactionsByIds: HolderTransaction[]
    holderSharesByIds: HolderShare[]
    holderCapitalInvestmentsByIds: HolderCapitalInvestment[]
    holderSafeInvestmentsByIds: HolderSafeInvestment[]
    equityEventsEffectConfigurations: EquityEventsEffectConfiguration[]
    manualEquityEvents: ManualEquityEntity[]
    affiliatedEntityByIds: AffiliatedEntity[]
    companyAffiliates: CompanyAffiliate[]
    companyAffiliate: CompanyAffiliate
    holderShares: HolderShare[]
    holderCapitalInvestments: HolderCapitalInvestment[]
    holderTransactions: HolderTransaction[]
    affiliatedEntityById?: AffiliatedEntity
    companyIntegration?: CompanyIntegration
    companyIntegrations: CompanyIntegration[]
    closingBalancesByIds: ClosingBalance[]
    payrollConnections: PayrollConnection[]
    integrationConnectionAccounts: IntegrationConnectionAccount[]
    integrationTransfersByCompanyAffiliate: IntegrationTransfer[]
    integrationTransfersBackoffice: IntegrationTransfer[]
    integrationTransfer?: IntegrationTransfer
    integrationTransfers: IntegrationTransfer[]
    groupedIntegrationTransfers: IntegrationTransferGroup[]
    finaloopProductInternal?: FinaloopProduct
    inventoryPurchasesForCompany: InventoryPurchase[]
    inventoryPurchasesByIds: InventoryPurchase[]
    runAmazonProductsValidationDiagnostics: RunProductsValidationDiagnosticsResponse
    runShopifyProductsValidationDiagnostics: RunProductsValidationDiagnosticsResponse
    getCOGSBreakdown2: GetCOGSBreakdownResponse
    exportCOGSBreakdown: ExportCOGSBreakdownResponse
    getCOGSOverview2: GetCOGSOverviewResponse
    exportCOGSOverview: ExportCOGSOverviewResponse
    product?: Product
    productAssembliesInventoryBreakdown: ProductAssembliesBreakdownResult
    productsCsv: ExportProductsResponse
    products2: Products2Result
    productsOverview: ProductsOverviewResponse
    salesChannels: SalesChannel[]
    currentlyRunningInventoryDataSync?: CurrentlyRunningInventoryDataSyncResponse
    currentlyRunningInventoryDataSyncVendors?: CurrentlyRunningInventoryDataSyncVendorsResponse
    inventoryAccountBalance: GetInventoryAccountBalanceResponse
    getOnboardingStatuses: OnboardingStatuses
    nonMatchedProducts: NonMatchingProductsResponse
    getFromEmailAddress: GetFromEmailAddressResult
    productBulkEditCsvAttachments: ProductBulkEditCsvAttachmentsResponse
    listOnDemandAssemblyCosts: OnDemandAssemblyCostsResult
    listOnDemandAssemblyVendorCosts: OnDemandAssemblyVendorCostsResult
    listManualAssemblies: ListManualAssembliesResult
    listAssemblies: ListAssembliesResult
    listAssemblyItems: ListAssemblyItemsResult
    missingCostsInPeriod: MissingCostsInPeriodResponse
    dropshippingSettings?: DropshippingSettings
    purchaseOrder?: PurchaseOrder
    purchaseOrdersV2: PurchaseOrder[]
    purchaseOrdersV2Total: Scalars['Int']
    purchaseOrdersOverviewV2?: PurchaseOrderOverviewV2
    exportPurchaseOrders: ExportPurchaseOrdersResponse
    inventoryPurchases: InventoryPurchasesResponse
    inventoryPurchasesExport: InventoryPurchasesExportResponse
    inventoryPurchasesSummary: InventoryPurchasesSummaryResponse
    inventoryPurchaseRules: InventoryPurchaseRulesResponse
    isPaymentGroupLinkExist: Scalars['Boolean']
    inventoryPurchaseVendors: InventoryPurchaseVendorsResponse
    inventoryPurchasesCountByVendor: InventoryPurchasesCountByVendorResponse
    inventoryOverviewCycles: OverviewCycle[]
    shopifyProductsValidationConnections: ShopifyProductsValidationConnectionsResponse
    shopifyItemsReconciliation: ShopifyProductsValidationResponse
    shopifyItemsReconciliationOrders: ShopifyItemsReconciliationOrdersResponse
    shopifyItemsReconciliationOrdersDiff: ShopifyItemsReconciliationOrdersDiffResult
    amazonProductsReconciliation: AmazonProductsReconciliationResponse
    amazonAvailableValidationData: AmazonAvailableValidationDataResponse
    amazonOrdersDiff: AmazonOrdersDiffResponse
    amazonCustomerShipmentReportLink: Report
    amazonLedgerReportLink: Report
    amazonCustomerReturnsReportLink: Report
    listValidationRemediations: ValidationRemediationsResponse
    inventoryVendorsOverview: InventoryVendorsOverviewResponse
    inventoryVendors: InventoryVendorsResponse
    inventoryVendorRollingBalance?: InventoryVendorRollingBalanceResponse
    inventoryVendorRollingBalanceOverview?: InventoryVendorRollingBalanceOverviewResponse
    inventoryVendorBills?: InventoryVendorBillsResponse
    inventoryVendorBillsOverview?: InventoryVendorBillsOverviewResponse
    inventoryVendorFilterValues?: InventoryVendorFilterValuesResponse
    inventoryVendorParams: InventoryVendorParamsResponse
    warehouseOpeningBalanceOverview: WarehouseOpeningBalanceOverviewResponse
    warehouseOpeningBalances: WarehouseOpeningBalancesResponse
    pendingWarehouseOpeningBalancesAttachments: PendingWarehouseOpeningBalanceAttachment[]
    getWarehouseOpeningBalancesCsvTemplate: WarehouseOpeningBalancesCsvTemplateResponse
    exportWarehouseOpeningBalancesCsv: WarehouseOpeningBalancesCsvResponse
    warehouseTransfersOverview: WarehouseTransfersOverview
    warehouseTransfers: WarehouseTransfersResponse
    warehouseTransfer?: WarehouseTransfer
    pendingSalesDataAdjustmentsV2: PendingSalesDataAdjustmentsResponse
    pendingSalesDataAdjustmentsByIds: PendingSalesDataAdjustmentsByIdsResponse
    pendingDeadInventoryAdjustments: PendingDeadInventoryAdjustmentsResponse
    pendingDeadInventoryAdjustmentsByIds: PendingDeadInventoryAdjustmentsByIdsResponse
    pendingGiveawayAdjustments: PendingGiveawayAdjustmentsResponse
    pendingGiveawayAdjustmentsByIds: PendingGiveawayAdjustmentsByIdsResponse
    pendingGiveawayDropshippingAdjustments: PendingGiveawayDropshippingAdjustmentsResponse
    pendingGiveawayDropshippingAdjustmentsByIds: PendingGiveawayAdjustmentsByIdsResponse
    pendingDonationAdjustments: PendingDonationAdjustmentsResponse
    pendingDonationAdjustmentsByIds: PendingDonationAdjustmentsByIdsResponse
    pendingSalesDataAdjustmentsOverviewV2: PendingAdjustmentsOverviewResponse
    pendingDeadInventoryAdjustmentsOverview: PendingAdjustmentsOverviewResponse
    pendingGiveawayAdjustmentsOverview: PendingAdjustmentsOverviewResponse
    pendingGiveawayDropshippingAdjustmentsOverview: PendingAdjustmentsOverviewResponse
    pendingDonationAdjustmentsOverview: PendingAdjustmentsOverviewResponse
    productBulkAdjustmentStatus?: GetProductBulkAdjustmentStatus
    salesAdjustmentsCsvTemplate: BulkEditCsvTemplateResponse
    deadInventoryAdjustmentsCsvTemplate: BulkEditCsvTemplateResponse
    giveawayAdjustmentsCsvTemplate: BulkEditCsvTemplateResponse
    donationAdjustmentsCsvTemplate: BulkEditCsvTemplateResponse
    productPendingAdjustmentsCountBreakdown: ProductPendingAdjustmentsCountBreakdownResponse
    listNoUnitsPhysicalCounts: NoUnitsPhysicalCountsList
    noUnitsPhysicalCount?: NoUnitsPhysicalCount
    noUnitsPhysicalCountProductQuantities?: NoUnitsPhysicalCountProductQuantities
    exportNoUnitsTrackingPhysicalCountProductQuantities: ExportCSVResponse
    noUnitsPhysicalCountOverview?: NoUnitsPhysicalCountOverview
    getNoUnitsPhysicalCountClosingBalance: NoUnitsPhysicalCountClosingBalanceResult
    getNoUnitsPhysicalCountAnyActiveProductsWithoutQuantities: AnyActiveProductWithoutQuantities
    listUnitsTrackingPhysicalCounts: UnitsTrackingPhysicalCountsList
    unitsTrackingPhysicalCount?: UnitsTrackingPhysicalCount
    unitsTrackingPhysicalCountProductQuantities?: UnitsTrackingPhysicalCountProductQuantities
    exportUnitsTrackingPhysicalCountProductQuantities: ExportCSVResponse
    unitsTrackingPhysicalCountOverview?: UnitsTrackingPhysicalCountOverview
    physicalCountCsvTemplate: BulkEditCsvTemplateResponse
    hasUnacknowledgedChanges: Scalars['Boolean']
    warehouses: WarehouseResult
    warehouseDefaults: WarehousesDefaultsResult
    inventoryPaymentGroupById: InventoryPaymentGroupByIdResponse
    inventoryPaymentGroupsByIds: InventoryPaymentGroupsByIdsResponse
    validateInventoryPaymentGroupByEntity: ValidateInventoryPaymentGroupByEntityResponse
    inventoryYearEndMissions: InventoryYearEndMissionsResponse
    explainFifo: ExplainFifoResult
    warehouseIncomingInventoryOverview: WarehouseIncomingInventoryOverviewResult[]
    warehouseIncomingInventoryBreakdown: WarehouseIncomingInventoryBreakdownResult
    productMergeRecommendationsMatchGroup: GetProductMergeRecommendationsMatchGroupResponse
    productMergeLogs: GetProductMergeLogsResponse
    productMergeLogsOverview: GetProductMergeLogsOverviewResponse
    productAutomergeSettings: GetProductAutomergeSettingsResponse
    hasProductMergeRecommendations: HasProductMergeRecommendationsResponse
    productMergeRecommendations: ProductMergeRecommendations
    loans: LoansResponse
    getMatchingEffectRule: GetMatchingEffectRuleResult
    loansEventsEffectConfiguration: LoansEventsEffectConfiguration[]
    getLoansById: LoansByIdsResponse
    exportLoans: ExportLoansResult
    getLoanEvents: GetLoanEventsResult
    getLoanRelationships: GetLoanRelationshipsResult
    getAllocatableEventIds: GetAllocatableEventIdsResult
    getLoanEventsLength: GetLoanEventsLengthResult
    loanEventDefinitions: LoanEventDefinition[]
    getLoansUpdatedBy: Scalars['String'][]
    knownLenders: NewLender[]
    companyLoans: CompanyLoansResponse
    companyLoan: CompanyLoanResponse
    getAttachmentTargetURLS: AttachmentTargetURLS
    downloadAttachment: DownloadAttachmentResult
    getLoansOutstandingAmountOnDate: GetLoansOutstandingAmountOnDateResult
    getLoanTransactionStatuses: LoanTransactionLockStatus[]
    prevalidateCompanyLoan?: ProcessLoanAttachmentResult
    getCompanyFundedStatus: CompanyFundedStatus
    companyArCashDiffs: CompanyArCashDiffsResponse
    giftCardsByIds: GiftCardsByIdsResponse
    shopifyReportDateLimits: ShopifyReportDateLimitsResponse
    shopifyReconciliationData: OrderReconciliationsResponse
    paymentProcessorByCompanyAndVendor: PaymentProcessorByCompanyAndVendorResponse
    vendorByPaymentGateway: VendorByPaymentGatewayResponse
    salesChannelsByCompanyAndIntegration: SalesChannelsByCompanyAndIntegrationResponse[]
    paymentGatewaysByCompanyIntegrationAndSalesChannel: Scalars['String'][]
    getOrdersV2: GetOrdersResultV2
    getUnpaidOrdersCsv: GetUnpaidOrdersCsvResponse
    getUnpaidOrdersAgingCsv: GetUnpaidOrdersCsvResponse
    giftCardsCsv: GiftCardsCsvResponse
    getOrdersAggregations: OrderAggregationEntry[]
    getOrderById: OrderV2Result
    getFinaloopTags: OrderTag[]
    getIntegrationTags: OrderTag[]
    getFinaloopPaymentGateways: Scalars['String'][]
    getOrderSalesChannels: Scalars['String'][]
    getOrderFilteringBounds: GetOrderFilteringBoundsResult
    getFulfillmentSettings: GetFulfillmentSettingsResponse
    isCompanyFulfillmentSettingsApplied: Scalars['Boolean']
    ordersByIds: OrdersByIdsResponse
    orderGroupById: OrderGroupByIdResponse
    orderGroupsByIds: OrderGroupsByIdsResponse
    orderGroups: OrderGroupsResponse
    orderGroupsUnclearedBalance: OrderGroupsUnclearedBalanceResponse
    orderGroupsTotalUnclearedBalance: OrderGroupsTotalUnclearedBalanceResponse
    ordersYearEnd: OrdersYearEndResponse
    giftCards: GiftCardsResult
    giftCardAggregations: GiftCardAggregationsResult
    giftCardsMaximumCompanyBalance: GiftCardsMaximumCompanyBalanceResult
    hasOrdersInOrderGroups?: HasOrdersInOrderGroupsResponse
    orders: OrdersResult
    orderById: SingleOrderResult
    filteringBoundsOrderV3: FilteringBoundsOrderV3Result
    paymentGroupLinks: PaymentGroupLinksResponse
    getInvoicesAffectingPaymentGroups: GetInvoicesAffectingPaymentGroupsResponse
    getPaymentGroupsByIds: PaymentGroupsByIdsResponse
    orderPaymentGroupById: OrderPaymentGroupByIdResponse
    orderPaymentGroupsByIds: OrderPaymentGroupsByIdsResponse
    orderPaymentGroups: OrderPaymentGroupsResponse
    orderPaymentGroupsUnclearedBalance: OrderPaymentGroupsUnclearedBalanceResponse
    orderPaymentGroupsTotalUnclearedBalance: PaymentGroupsTotalUnclearedBalanceResponse
    invoicePaymentGroupById: InvoicePaymentGroupByIdResponse
    invoicePaymentGroupsByIds: InvoicePaymentGroupsByIdsResponse
    invoicePaymentGroups: InvoicePaymentGroupsResponse
    invoicePaymentGroupsUnclearedBalance: InvoicePaymentGroupsUnclearedBalanceResponse
    invoicePaymentGroupsTotalUnclearedBalance: PaymentGroupsTotalUnclearedBalanceResponse
    artificialTransactionsByMonth: ArtificialTransactionsByMonthResponse
    paymentsByIds: Payment[]
    refundsByIds: Refund[]
    integrationTransfersByIds: IntegrationTransferV2[]
    disputesByIds: Dispute[]
    paymentFeesByIds: PaymentFee[]
    chargebacksByIds: Chargeback[]
    paymentChecks: PaymentCheck[]
    payrollDailyAggregatesByEmploymentTypeAndCategory: (PayrollDailyAggregate | undefined)[]
    payrollIdsByCompany: PayrollIdsByCompanyResponse
    contractorPaymentsInternal: ContractorPaymentsInternalResponse
    contractorPaymentIdsByCompany: ContractorPaymentIdsByCompanyResponse
    paymentsByEmployee: DailyPaymentsByEmployee[]
    paymentsByContractor: DailyPaymentsByContractor[]
    payrollSettings: PayrollSettings
    validations: ValidationResult[]
    periodicPartnerReports: PeriodicPartnerReport[]
    periodicReportsPartners: ReportsPartner[]
    exportCashFlow: ExportResponse
    exportBalanceSheet: AwaitedExportResponse
    ledgerAccountTransactionsCSV: AwaitedExportResponse
    checkExportStatus: AwaitedExportResponse
    syncReportDefinition?: ScheduleAccountingReportExportResponse
    lastAccountingReportSync: LastAccountingReportSyncResponse
    chartData: ChartDataResponse
    getExportedReportsLogs: GetExportedReportsResponse[]
    getSignedUrlByExportedReportsLogId: GetSignedUrlByExportedLogIdResponse
    skuAnalysis: AllSkusResponse
    exportSkuAnalysis: ExportSkuAnalysisResponse
    skuAnalysisByDate: IndividualSkusResponse
    bestSellers: ProductTopPerformersResponse
    unitsSold: ProductTopPerformersResponse
    highestProfit: ProductTopPerformersResponse
    bestMargin: ProductTopPerformersResponse
    customerInternal?: Customer
    sellingFeesByIds: SellingFee[]
    fulfillmentCostsByIds: FulfillmentCost[]
    shippingCostsByIds: ShippingCost[]
    getCustomers: Customer[]
    getCustomerById: GetCustomerResponse
    searchCustomers: CustomerV2[]
    getCustomerV2ById: CustomerV2
    getCustomerV2ByIds: CustomerV2[]
    sale?: Sale
    getSales: GetSalesResult
    invoice?: Invoice
    getInvoices: GetInvoicesResult
    getInvoicePdfUrl: Scalars['String']
    getPaymentMethods: PaymentMethod[]
    calculateInvoice?: Invoice
    getInvoicesCsv: ExportInvoicesResponse
    getInvoiceAggregations: InvoicesAggregations
    getInvoicesBalance: InvoicesBalance
    invoicesAgingReportCSV: AwaitedExportResponse
    salesChannel?: SalesChannelInfo
    getSalesChannels: SalesChannelInfo[]
    getSalesChannelTemplates: SalesChannelTemplate[]
    invoiceSettings?: InvoiceSettings
    getInvoiceExamplePdfUrl: Scalars['String']
    invoicesYearEndTasks: InvoicesYearEndTasksResponse
    testSPSCommerceOrgConnection?: TestSPSCommerceOrgConnectionResponse
    me: MeResponse
    isInvitationCodeForRegisteredUser: IsInvitationCodeForRegisteredUserResponse
    companyUsers: CompanyUsersResponse
    userInvitationByCode: UserInvitationResponse
    userReferralLink: UserReferralLinkResponse
    userInvitationsByEmail: UserInvitationsByEmailResponse
    userRoles: UserRolesResponse
    auth0UserLookup: Auth0UserLookupResponse
    googleConnectStatus?: GoogleConnectStatusResponse
    googleConnectionLink?: GoogleConnectLinkResponse
    calendlyEventDetails?: CalendlyEventResponse
    userNameFromReferralCode?: UserNameFromReferralCodeResponse
    userByEmail: UserByEmailResponse
    usersByEmails: UsersByEmailsResponse
    latestActiveCompanyUser: LatestActiveCompanyUserResponse
    vendors: Vendor[]
    vendor: GetVendorResponse
    vendorsByIds: Vendor[]
    vendorsBySubtype: Vendor[]
    tax1099AffiliatedEntityGroups: Tax1099AffiliatedEntityGroupsByType[]
    institutionVendors: Vendor[]
    vendorById: Vendor
    vendorByAffiliatedEntityId?: Vendor
    vendorByName?: Vendor
    globalVendorsByIds: Vendor[]
    vendorsByIntegrationType: Vendor[]
    getCompanyWorksheets: CompanyWorksheet
    getCompanyLockConditions?: (CompanyLockConditions | undefined)[]
    getSignedDates: GetSignedDatesResponse
    getWorksheets: Worksheet
    getAllCompaniesForDomain?: (GetAllCompaniesForDomainResponse | undefined)[]
    yearEnd: YearEndStateResponse
    yearEndDomainStateDatum?: YearEndDomainStateDataResponse
    yearEndDomainStateData?: (YearEndDomainStateDataResponse | undefined)[]
    yearEndStates: FiscalYearEndStateResponse[]
    __typename: 'Query'
}

export interface RangedManagementMethod {
    managementMethod: ManagementMethod
    startDate?: Scalars['Date']
    endDate?: Scalars['Date']
    id: Scalars['ID']
    __typename: 'RangedManagementMethod'
}

export interface ReadyValidation {
    id: Scalars['ID']
    from?: Scalars['Date']
    to: Scalars['Date']
    generatedAt: Scalars['Date']
    generatedBy?: Scalars['String']
    isGreen: Scalars['Boolean']
    __typename: 'ReadyValidation'
}

export interface RealtimeCogsStatus {
    isAmazonEnabled?: Scalars['Boolean']
    isShopifyEnabled?: Scalars['Boolean']
    isWalmartEnabled?: Scalars['Boolean']
    isTikTokEnabled?: Scalars['Boolean']
    __typename: 'RealtimeCogsStatus'
}

export interface Recipe {
    id: Scalars['String']
    from?: Scalars['Date']
    to?: Scalars['Date']
    isAssembledOnDemand: Scalars['Boolean']
    product: Product
    warehouse?: Warehouse
    components: RecipeComponent[]
    managementMethod: RecipeManagementMethod
    displayName: Scalars['String']
    deletedReason?: AssemblyDeletedReason
    manualAssemblyId?: Scalars['String']
    totalAssembled?: Scalars['Float']
    allocatedCosts: RecipeAllocatedCost[]
    additionalAllocatedCostsPerUnit: Scalars['Float']
    __typename: 'Recipe'
}

export interface RecipeAllocatedCost {
    affiliatedEntity?: AffiliatedEntity
    type: RecipeAllocatedCostType
    costPerUnit: Scalars['Float']
    __typename: 'RecipeAllocatedCost'
}

export interface RecipeAllocatedCostsError {
    message: Scalars['String']
    __typename: 'RecipeAllocatedCostsError'
}

export type RecipeAllocatedCostType = 'PRODUCTION_COSTS' | 'PRODUCTION_LABOR_COSTS' | 'OTHER'

export interface RecipeBreakdown {
    quantity: Scalars['Float']
    wasteQuantity: Scalars['Float']
    costPerUnit: Scalars['Float']
    product: Product
    warehouse: Warehouse
    __typename: 'RecipeBreakdown'
}

export interface RecipeCirclesFoundError {
    data: (RecipeCirclesFoundErrorData[] | undefined)[]
    __typename: 'RecipeCirclesFoundError'
}

export interface RecipeCirclesFoundErrorData {
    recipe?: Recipe
    product: Product
    __typename: 'RecipeCirclesFoundErrorData'
}

export interface RecipeComponent {
    product: Product
    warehouse?: Warehouse
    quantity: Scalars['Float']
    wasteQuantity: Scalars['Float']
    __typename: 'RecipeComponent'
}

export type RecipeManagementMethod = 'UNITS_TRACKING' | 'NO_UNITS_TRACKING'

export interface RecipeOverlappingError {
    recipes: Recipe[]
    __typename: 'RecipeOverlappingError'
}

export interface RecipeWithBreakdown {
    recipe: Recipe
    startDate: Scalars['Date']
    endDate: Scalars['Date']
    warehouse: Warehouse
    breakdown: RecipeBreakdown[][][]
    affiliatedEntities: AffiliatedEntity[]
    __typename: 'RecipeWithBreakdown'
}

export type RecommendationSource = 'BANK_TRANSACTION' | 'LOCAL_MERCHANT' | 'GLOBAL_MERCHANT'

export type RecommendedBy = 'FINALOOP_SUGGESTIONS' | 'ASK_AI'

export interface ReconciliationRequestStatementFile {
    id: Scalars['String']
    requestId?: Scalars['String']
    s3Bucket: Scalars['String']
    s3Key: Scalars['String']
    fileName: Scalars['String']
    fileType: BankAccountStatementFileType
    status: BankReconciliationRequestFilesStatus
    machineStatus?: BankReconciliationRequestMachineStatus
    providerValidationResults: BankStatementValidationResults
    createdAt: Scalars['Date']
    uploadOriginator?: BankStatementResolutionOriginator
    companyAffiliate?: CompanyAffiliate
    __typename: 'ReconciliationRequestStatementFile'
}

export type ReconciliationStatus = 'RECONCILED' | 'RECONCILIATION_NEEDED' | 'PROCESSING' | 'UNKNOWN'

export interface ReconciliationSummary {
    totalInReport: Scalars['Int']
    isGreen: Scalars['Boolean']
    inBooks?: Scalars['Int']
    unfulfilledInBooks?: Scalars['Int']
    voided?: Scalars['Int']
    restocked?: Scalars['Int']
    excluded?: Scalars['Int']
    totalInDb: Scalars['Int']
    fulfilled?: Scalars['Int']
    fulfilledNotSold?: Scalars['Int']
    soldNotFulfilled?: Scalars['Int']
    zeroNet?: Scalars['Int']
    zeroNetFulfilled?: Scalars['Int']
    zeroNetNotSold?: Scalars['Int']
    zeroNetNotFulfilled?: Scalars['Int']
    __typename: 'ReconciliationSummary'
}

export interface RecurrenceSettings {
    recurrence: LoanEventRecurrence
    totalRecurrences?: Scalars['Int']
    cutOffDate?: Scalars['Date']
    __typename: 'RecurrenceSettings'
}

export interface RecurringPayment {
    yearly?: PaymentDetails
    monthly?: PaymentDetails
    yearlyDiscount?: Scalars['Float']
    __typename: 'RecurringPayment'
}

export interface referUserResponse {
    success: Scalars['Boolean']
    __typename: 'referUserResponse'
}

export interface Refund {
    companyId: Scalars['ID']
    id: Scalars['ID']
    source: IntegrationType
    integrationAccountId: Scalars['ID']
    integrationAccountName?: Scalars['String']
    amount: Scalars['Float']
    currency: Scalars['String']
    postedAt: Scalars['Date']
    __typename: 'Refund'
}

export interface Reimbursement {
    id: Scalars['String']
    source: Scalars['String']
    externalSourceId?: Scalars['String']
    integrationAccountId?: Scalars['String']
    integrationAccountName?: Scalars['String']
    postedAt: Scalars['Date']
    amount: Scalars['Float']
    isClearedByNetPayPayment?: Scalars['Boolean']
    employee?: Employee
    contractor?: Contractor
    contractorPayment?: ContractorPayment
    payroll?: Payroll
    deletedAt?: Scalars['Date']
    __typename: 'Reimbursement'
}

export interface RelatedParty {
    id: Scalars['ID']
    __typename: 'RelatedParty'
}

export interface RemoveUserResponse {
    success: Scalars['Boolean']
    __typename: 'RemoveUserResponse'
}

export interface Report {
    url: Scalars['String']
    __typename: 'Report'
}

export interface ReportHierarchyNode {
    name: Scalars['String']
    reportType: ReportType
    breakdownType?: BreakdownType
    accountRole?: AccountRole
    __typename: 'ReportHierarchyNode'
}

export interface ReportsPartner {
    id: Scalars['ID']
    name: Scalars['String']
    __typename: 'ReportsPartner'
}

export type ReportSyncStatus = 'PROCESSING' | 'SYNCED' | 'FAILED'

export type ReportType = 'PROFIT_AND_LOSS' | 'BALANCE_SHEET' | 'CASH_FLOW'

export interface ResetBalanceSheetSetupResponse {
    message?: Scalars['String']
    status: ManageBalanceSheetSetupStatus
    __typename: 'ResetBalanceSheetSetupResponse'
}

export interface RestockingAction {
    quantity: Scalars['Float']
    id: Scalars['String']
    date: Scalars['Date']
    type: Scalars['String']
    salesChannel: WarehouseActionSalesChannel
    fulfillmentDate: Scalars['Date']
    sku?: Scalars['String']
    __typename: 'RestockingAction'
}

export type RestockStatus = 'PARTIALLY_RESTOCKED' | 'RESTOCKED'

export type Role = 'ADMIN' | 'EMPLOYEE' | 'USER' | 'GUEST'

export type RootConditionOperator = 'OR' | 'AND'

export interface RunProductsValidationDiagnosticsResponse {
    issues: Scalars['String'][]
    __typename: 'RunProductsValidationDiagnosticsResponse'
}

export interface SafeHolder {
    id: Scalars['ID']
    __typename: 'SafeHolder'
}

export interface Sale {
    id: Scalars['ID']
    saleType: Scalars['String']
    companyId: Scalars['ID']
    source: SaleSource
    externalSourceUrl?: Scalars['String']
    externalSourceId?: Scalars['String']
    integrationAccountId?: Scalars['ID']
    integrationAccountName?: Scalars['String']
    currency: CurrencyCode
    displayName: Scalars['String']
    statuses: SaleStatus[]
    postedAt: Scalars['Date']
    createdAt: Scalars['Date']
    updatedAt: Scalars['Date']
    deletedAt?: Scalars['Date']
    publishedAt?: Scalars['Date']
    lineItems: SaleLineItem[]
    shipping: ShippingLineItem[]
    discounts: Discount[]
    platformDiscounts: Discount[]
    taxes: Tax[]
    taxFixedAmount?: Scalars['Float']
    taxType: SaleTaxType
    adjustments: SaleAdjustment[]
    payments: SaleTransaction[]
    credits: SaleTransaction[]
    refunds: SaleTransaction[]
    paymentIndications: SaleTransaction[]
    refundIndications: SaleTransaction[]
    customer: CustomerV2
    customerId: Scalars['ID']
    shippingAddress?: CustomerAddress
    billingAddress?: CustomerAddress
    integrationTags?: Scalars['String'][]
    integrationNote?: Scalars['String']
    finaloopNote?: Scalars['String']
    customerNote?: Scalars['String']
    isSalesAffecting: Scalars['Boolean']
    isCogsAffecting: Scalars['Boolean']
    voidedAt?: Scalars['Date']
    voidedBy?: SaleActor
    approvedAt?: Scalars['Date']
    uploadId?: Scalars['String']
    uploadedAt?: Scalars['Date']
    summary: SaleTotals
    __typename: 'Sale'
}

export type SaleActor = 'INTEGRATION' | 'CUSTOMER'

export interface SaleAdjustment {
    id: Scalars['ID']
    amount: Scalars['Float']
    currency: CurrencyCode
    amountInHomeCurrency: Scalars['Float']
    type: AdjustmentType
    postedAt: Scalars['Date']
    __typename: 'SaleAdjustment'
}

export interface SaleLineItem {
    id: Scalars['ID']
    quantity: Scalars['Float']
    unitPrice: Scalars['Float']
    currency: CurrencyCode
    type: SaleLineItemType
    integrationInfo?: IntegrationInfo
    product?: Product
    sku?: Scalars['String']
    description?: Scalars['String']
    discounts: Discount[]
    shipping: ShippingLineItem[]
    taxes: Tax[]
    subtotal: Scalars['Float']
    totalAmount: Scalars['Float']
    salesChannel?: SalesChannelInfo
    salesChannelId?: Scalars['ID']
    __typename: 'SaleLineItem'
}

export interface SaleLineItemTaxInfo {
    taxableAmount: Scalars['Float']
    taxRate: Scalars['Float']
    totalTaxAmount: Scalars['Float']
    isTaxInclusive: Scalars['Boolean']
    __typename: 'SaleLineItemTaxInfo'
}

export type SaleLineItemType = 'PRODUCT' | 'TAX' | 'SHIPPING' | 'SELLER_DISCOUNT' | 'PLATFORM_DISCOUNT' | 'FEE' | 'SERVICE' | 'TIP'

export interface SaleOrder {
    id: Scalars['ID']
    saleType: Scalars['String']
    companyId: Scalars['ID']
    source: SaleSource
    externalSourceUrl?: Scalars['String']
    externalSourceId?: Scalars['String']
    integrationAccountId?: Scalars['ID']
    integrationAccountName?: Scalars['String']
    currency: CurrencyCode
    displayName: Scalars['String']
    statuses: SaleStatus[]
    postedAt: Scalars['Date']
    createdAt: Scalars['Date']
    updatedAt: Scalars['Date']
    deletedAt?: Scalars['Date']
    publishedAt?: Scalars['Date']
    lineItems: SaleLineItem[]
    shipping: ShippingLineItem[]
    discounts: Discount[]
    platformDiscounts: Discount[]
    taxes: Tax[]
    taxFixedAmount?: Scalars['Float']
    taxType: SaleTaxType
    adjustments: SaleAdjustment[]
    payments: SaleTransaction[]
    credits: SaleTransaction[]
    refunds: SaleTransaction[]
    paymentIndications: SaleTransaction[]
    refundIndications: SaleTransaction[]
    customer: CustomerV2
    customerId: Scalars['ID']
    shippingAddress?: CustomerAddress
    billingAddress?: CustomerAddress
    integrationTags: Scalars['String'][]
    integrationNote?: Scalars['String']
    finaloopNote?: Scalars['String']
    customerNote?: Scalars['String']
    accounting: AccountingInfo
    isSalesAffecting: Scalars['Boolean']
    isCogsAffecting: Scalars['Boolean']
    voidedAt?: Scalars['Date']
    voidedBy?: SaleActor
    approvedAt?: Scalars['Date']
    uploadId?: Scalars['String']
    uploadedAt?: Scalars['Date']
    summary: SaleTotals
    __typename: 'SaleOrder'
}

export interface SalesAdjustmentOriginalValue {
    unitsSold?: Scalars['Int']
    unitsRestocked?: Scalars['Int']
    __typename: 'SalesAdjustmentOriginalValue'
}

export interface SalesAdjustmentsBreakdownItem {
    salesChannel: SalesChannel
    count: Scalars['Int']
    __typename: 'SalesAdjustmentsBreakdownItem'
}

export interface SalesBasedClosingBalance {
    missionType: InventoryYearEndMissionsType
    status: InventoryYearEndMissionStatus
    historyLog: InventoryYearEndHistoryLog[]
    managementMethodPeriod: ManagementMethodYearEndPeriod
    closingBalance: Scalars['Float']
    __typename: 'SalesBasedClosingBalance'
}

export interface SalesBasedMissingCostPerUnit {
    missionType: InventoryYearEndMissionsType
    status: InventoryYearEndMissionStatus
    historyLog: InventoryYearEndHistoryLog[]
    managementMethodPeriod: ManagementMethodYearEndPeriod
    missingCostPerUnitProducts: Scalars['Int']
    __typename: 'SalesBasedMissingCostPerUnit'
}

export interface SalesBasedOpeningBalance {
    missionType: InventoryYearEndMissionsType
    status: InventoryYearEndMissionStatus
    historyLog: InventoryYearEndHistoryLog[]
    managementMethodPeriod: ManagementMethodYearEndPeriod
    openingBalance: Scalars['Float']
    __typename: 'SalesBasedOpeningBalance'
}

export interface SalesBasedPurchases {
    missionType: InventoryYearEndMissionsType
    status: InventoryYearEndMissionStatus
    historyLog: InventoryYearEndHistoryLog[]
    managementMethodPeriod: ManagementMethodYearEndPeriod
    purchases: Scalars['Float']
    __typename: 'SalesBasedPurchases'
}

export interface SalesBasedReportCogs {
    missionType: InventoryYearEndMissionsType
    status: InventoryYearEndMissionStatus
    historyLog: InventoryYearEndHistoryLog[]
    managementMethodPeriod: ManagementMethodYearEndPeriod
    __typename: 'SalesBasedReportCogs'
}

export interface SalesChannel {
    accountRole?: Scalars['String']
    integrationType?: Scalars['String']
    integrationAccountName?: Scalars['String']
    currency?: Scalars['String']
    displayName: Scalars['String']
    isDropshipping?: Scalars['Boolean']
    __typename: 'SalesChannel'
}

export interface SalesChannelDailySalesData {
    salesChannel: SalesChannel
    salesData: SalesChannelSalesData[]
    soldSkusSummary: SalesChannelSkuSalesSummary[]
    __typename: 'SalesChannelDailySalesData'
}

export interface SalesChannelDailySummary {
    date: Scalars['Date']
    summary: SalesChannelSkuSummary[]
    __typename: 'SalesChannelDailySummary'
}

export interface SalesChannelInfo {
    id: Scalars['ID']
    name: Scalars['String']
    source: Scalars['String']
    integrationAccountId: Scalars['String']
    isCogsAffecting: Scalars['Boolean']
    isSalesAffecting: Scalars['Boolean']
    financialReportingStatus?: FinancialReportingStatus
    periods: SalesChannelPeriod[]
    deletedAt?: Scalars['Date']
    __typename: 'SalesChannelInfo'
}

export interface SalesChannelMonthlyBreakdown {
    date: Scalars['Date']
    summary: SalesChannelSkuSummary[]
    dailyData: SalesChannelDailySummary[]
    __typename: 'SalesChannelMonthlyBreakdown'
}

export interface SalesChannelPeriod {
    startDate?: Scalars['Date']
    endDate?: Scalars['Date']
    financialReportingStatus: FinancialReportingStatus
    __typename: 'SalesChannelPeriod'
}

export interface SalesChannelSalesCogs {
    hasAdjustments: Scalars['Boolean']
    salesChannel: SalesChannel
    summary: SalesChannelSkuSummary[]
    monthlyBreakdown: SalesChannelMonthlyBreakdown[]
    amount: Scalars['Float']
    __typename: 'SalesChannelSalesCogs'
}

export interface SalesChannelSalesData {
    date: Scalars['Date']
    unitsSold: Scalars['Int']
    unitsRestocked: Scalars['Int']
    unitsGiveaway?: Scalars['Int']
    __typename: 'SalesChannelSalesData'
}

export interface SalesChannelsByCompanyAndIntegrationResponse {
    id: Scalars['ID']
    name: Scalars['String']
    isSalesAffecting: Scalars['Boolean']
    __typename: 'SalesChannelsByCompanyAndIntegrationResponse'
}

export interface SalesChannelSkuSalesSummary {
    sku: Scalars['String']
    unitsSold: Scalars['Int']
    unitsRestocked: Scalars['Int']
    unitsGiveaway: Scalars['Int']
    __typename: 'SalesChannelSkuSalesSummary'
}

export interface SalesChannelSkuSummary {
    sku: Scalars['String']
    fulfilled: Scalars['Int']
    restocked: Scalars['Int']
    __typename: 'SalesChannelSkuSummary'
}

export interface SalesChannelTemplate {
    id: Scalars['ID']
    name: Scalars['String']
    source: Scalars['String']
    isCogsAffecting: Scalars['Boolean']
    isSalesAffecting: Scalars['Boolean']
    financialReportingStatus?: FinancialReportingStatus
    __typename: 'SalesChannelTemplate'
}

export interface SalesData {
    recipes: Recipe[]
    assembledByRecipeMap: AssembledByMap[]
    salesChannels: SalesChannelSalesCogs[]
    deadInventory: DeadInventoryCogs
    giveaway: GiveawayCogs
    giveawayDropshipping: GiveawayCogs
    donation: DonationCogs
    lostAndFound: LostAndFoundCogs
    otherFba: OtherFbaCogs
    waste: WasteCogs
    supplierReturn: ProductUnitCogs
    warehouseSalesData: WarehouseSalesData[]
    salesAdjustments: ProductSalesDataAdjustments
    deadInventoryAdjustments: ProductDeadInventoryAdjustments
    giveawayAdjustments: ProductGiveawayAdjustments
    giveawayDropshippingAdjustments: ProductGiveawayAdjustments
    donationAdjustments: ProductDonationAdjustments
    lostAndFoundAdjustments: ProductLostAndFoundAdjustments
    otherFbaAdjustments: ProductOtherFbaAdjustments
    supplierReturnAdjustments: ProductUnitsAdjustments
    appliedCosts: ProductAppliedCostWithDepletedCount[]
    __typename: 'SalesData'
}

export type SaleSource = 'FINALOOP_INVOICES' | 'STRIPE' | 'PAYPAL' | 'QUICKBOOKS' | 'QUICKBOOKS_INVOICES' | 'NU_ORDER_INVOICES' | 'SPS_COMMERCE' | 'FINALOOP_ORDERS' | 'TIK_TOK'

export type SaleStatus = 'DRAFT' | 'FOR_REVIEW' | 'VOIDED' | 'COGS_ONLY' | 'GIVEAWAY' | 'OPEN' | 'PAST_DUE' | 'PAID' | 'REFUNDED' | 'CLOSED' | 'UNCOLLECTIBLE' | 'OVER_COLLECTED' | 'ADJUSTED' | 'PARTIALLY_UNCOLLECTIBLE' | 'PARTIALLY_ADJUSTED' | 'PARTIALLY_REFUNDED' | 'PARTIALLY_PAID'

export type SaleTaxType = 'SALES_TAX' | 'VAT' | 'GST'

export interface SaleTotals {
    subtotal: Amounts
    subtotalAfterItemDiscounts: Amounts
    subtotalAfterDiscounts: Amounts
    totalBeforeTaxes: Amounts
    total: Amounts
    tipsSubtotal: Amounts
    shippingSubtotal: Amounts
    shippingDiscounts: Amounts
    shipping: Amounts
    payments: Amounts
    refunds: Amounts
    credits: Amounts
    adjustments: Amounts
    taxes: Amounts
    globalDiscounts: Amounts
    globalPlatformDiscounts: Amounts
    itemDiscounts: Amounts
    totalDiscounts: Amounts
    unpaidBalance: Amounts
    balanceAsOf?: Scalars['Date']
    balanceAsOfAmount?: Amounts
    latestFinancialTimestamp: Scalars['Date']
    __typename: 'SaleTotals'
}

export type SaleTransaction = (BankTxSaleTransaction | IntegrationSaleTransaction | PaymentGroupTransaction) & { __isUnion?: true }

export type SaleType = 'ORDER' | 'INVOICE'

export interface ScheduleAccountingReportExportResponse {
    reportType: ReportType
    isEnabled: Scalars['Boolean']
    byMonth: Scalars['Boolean']
    fractions: Scalars['Boolean']
    withMerchantsBreakdown: Scalars['Boolean']
    fromDate: Scalars['Date']
    toDate: Scalars['Date']
    syncMostUpdatedReport?: Scalars['Boolean']
    includeCCAccounts?: Scalars['Boolean']
    includeUDFAccounts?: Scalars['Boolean']
    __typename: 'ScheduleAccountingReportExportResponse'
}

export interface ScheduleAtuIntegrationTransfersResultProcessingResult {
    success: Scalars['Boolean']
    __typename: 'ScheduleAtuIntegrationTransfersResultProcessingResult'
}

export interface ScheduleAtuTransactionsResultProcessingResult {
    success: Scalars['Boolean']
    __typename: 'ScheduleAtuTransactionsResultProcessingResult'
}

export interface SchedulePurchasesValidationResponse {
    validationId: Scalars['String']
    __typename: 'SchedulePurchasesValidationResponse'
}

export interface SearchVendorsTransactionsPriorityResult {
    vendors: Vendor[]
    counts: VendorsTransactionsCount[]
    __typename: 'SearchVendorsTransactionsPriorityResult'
}

export interface Section179Deduction {
    date: Scalars['Date']
    amount: Scalars['Float']
    __typename: 'Section179Deduction'
}

export interface SellingFee {
    id: Scalars['ID']
    companyId: Scalars['ID']
    source: Scalars['String']
    externalSourceId?: Scalars['String']
    integrationAccountId?: Scalars['String']
    integrationAccountName?: Scalars['String']
    sale?: Sale
    order?: OrderV2
    type: SellingFeeType
    externalId?: Scalars['String']
    externalName?: Scalars['String']
    amount: Scalars['Float']
    currency: CurrencyCode
    amountInHomeCurrency: Scalars['Float']
    __typename: 'SellingFee'
}

export type SellingFeeType = 'SELLING_FEE' | 'AFFILIATE_COMMISSION'

export interface SendAnalyticsEventResult {
    success: Scalars['Boolean']
    __typename: 'SendAnalyticsEventResult'
}

export interface SendPoEmailError {
    message: Scalars['String']
    __typename: 'SendPoEmailError'
}

export interface SendPoEmailResponse {
    success: Scalars['Boolean']
    __typename: 'SendPoEmailResponse'
}

export type SendPoEmailResult = (SendPoEmailResponse | SendPoEmailError) & { __isUnion?: true }

export interface SetFulfillmentSettingsResponse {
    settings: IntegrationFulfillmentSetting[]
    __typename: 'SetFulfillmentSettingsResponse'
}

export interface SetPendingDedInventoryAdjustmentsResponse {
    items: PendingDeadInventoryAdjustments[]
    __typename: 'SetPendingDedInventoryAdjustmentsResponse'
}

export interface SetPendingDonationAdjustmentsResponse {
    items: PendingDonationAdjustments[]
    __typename: 'SetPendingDonationAdjustmentsResponse'
}

export interface SetPendingGiveawayAdjustmentsResponse {
    items: PendingGiveawayAdjustments[]
    __typename: 'SetPendingGiveawayAdjustmentsResponse'
}

export interface SetPendingGiveawayDropshippingAdjustmentsResponse {
    items: PendingGiveawayDropshippingAdjustments[]
    __typename: 'SetPendingGiveawayDropshippingAdjustmentsResponse'
}

export interface SetPendingSalesDataAdjustmentsResponseV2 {
    items: PendingSalesDataAdjustments[]
    __typename: 'SetPendingSalesDataAdjustmentsResponseV2'
}

export type SetProductAdjustmentOperation = 'CREATE' | 'UPDATE' | 'DELETE' | 'ADD_ON_TOP' | 'UPDATE_GOING_FORWARD' | 'REPLACE'

export interface SetUserNameResponse {
    success: Scalars['Boolean']
    __typename: 'SetUserNameResponse'
}

export type ShareType = 'COMMON_STOCK' | 'PREFERRED'

export interface Shipment {
    id: Scalars['ID']
    shipmentDate?: Scalars['Date']
    arrival?: ShipmentArrival
    contents: ShipmentContents[]
    displayName?: Scalars['String']
    vendor?: Vendor
    notes?: Scalars['String']
    attachments: ShipmentAttachment[]
    purchaseOrder: PurchaseOrder
    cost: Scalars['Float']
    __typename: 'Shipment'
}

export interface ShipmentAction {
    quantity: Scalars['Float']
    id: Scalars['String']
    date: Scalars['Date']
    type: Scalars['String']
    purchaseOrder: PurchaseOrder
    directCost: Scalars['Float']
    indirectCosts: MovementIndirectCost[]
    __typename: 'ShipmentAction'
}

export interface ShipmentArrival {
    arrivalDate?: Scalars['Date']
    warehouse: Warehouse
    __typename: 'ShipmentArrival'
}

export interface ShipmentAttachment {
    id: Scalars['ID']
    filename: Scalars['String']
    url: Scalars['String']
    __typename: 'ShipmentAttachment'
}

export interface ShipmentContents {
    id: Scalars['ID']
    lineItem: DirectLineItem
    quantity: Scalars['Float']
    __typename: 'ShipmentContents'
}

export interface ShippingCost {
    id: Scalars['ID']
    companyId: Scalars['ID']
    source: Scalars['String']
    externalSourceId?: Scalars['String']
    integrationAccountId?: Scalars['String']
    integrationAccountName?: Scalars['String']
    sale?: Sale
    order?: OrderV2
    type: ShippingCostType
    externalId?: Scalars['String']
    externalName?: Scalars['String']
    amount: Scalars['Float']
    currency: CurrencyCode
    amountInHomeCurrency: Scalars['Float']
    __typename: 'ShippingCost'
}

export type ShippingCostType = 'SHIPPING_OUT_TO_CUSTOMERS' | 'SHIPPING_BACK_FROM_CUSTOMERS'

export interface ShippingLineItem {
    id: Scalars['ID']
    quantity: Scalars['Float']
    unitPrice: Scalars['Float']
    currency: CurrencyCode
    type: SaleLineItemType
    description?: Scalars['String']
    discounts: Discount[]
    taxes: Tax[]
    subtotal: Scalars['Float']
    totalAmount: Scalars['Float']
    __typename: 'ShippingLineItem'
}

export interface ShippingLineItemV3 {
    id: Scalars['ID']
    /** The ID of the line item in the external system */
    externalLineItemId: Scalars['String']
    /** The name of the line item */
    name?: Scalars['String']
    /** The description of the line item */
    description: Scalars['String']
    /** The amount of the line item */
    amount: Amounts
    parentId?: Scalars['String']
    /** The type of the line item */
    parentLineItemType?: ParentLineItemType
    /** The earliest date and time the line item was posted */
    earliestPostedAt: Scalars['Date']
    /** The latest date and time the line item was posted */
    latestPostedAt: Scalars['Date']
    /** The timeline of the line item */
    timeline: OrderLineItemTimelineV3[]
    /** The type of the line item */
    type: OrderLineItemTypeV3
    __typename: 'ShippingLineItemV3'
}

export interface ShopifyCsvBalance {
    companyId: Scalars['String']
    integrationAccountId: Scalars['String']
    fromDate: Scalars['Date']
    toDate: Scalars['Date']
    balances: (ShopifyTimezoneBalance | undefined)[]
    __typename: 'ShopifyCsvBalance'
}

export interface ShopifyItemsReconciliationOrderData {
    orderId: Scalars['String']
    url: Scalars['String']
    shopifySalesChannel: Scalars['String']
    salesChannel: Scalars['String']
    quantity: Scalars['Int']
    __typename: 'ShopifyItemsReconciliationOrderData'
}

export interface ShopifyItemsReconciliationOrdersDiffResult {
    ordersData: ShopifyItemsReconciliationOrdersDiffResultData[]
    __typename: 'ShopifyItemsReconciliationOrdersDiffResult'
}

export interface ShopifyItemsReconciliationOrdersDiffResultData {
    orderId: Scalars['ID']
    reportQuantity: Scalars['Int']
    entitiesQuantity: Scalars['Int']
    __typename: 'ShopifyItemsReconciliationOrdersDiffResultData'
}

export interface ShopifyItemsReconciliationOrdersResponse {
    ordersData: ShopifyItemsReconciliationOrderData[]
    __typename: 'ShopifyItemsReconciliationOrdersResponse'
}

export interface ShopifyOrderSourceData {
    financialStatus: Scalars['String']
    fulfillmentStatus: Scalars['String']
    gqlId: Scalars['String']
    orderValidationData?: ShopifyOrderValidationData
    __typename: 'ShopifyOrderSourceData'
}

export interface ShopifyOrderValidationData {
    sales: (ShopifyOrderValidationSale | undefined)[]
    refunds: (ShopifyOrderValidationRefund | undefined)[]
    __typename: 'ShopifyOrderValidationData'
}

export interface ShopifyOrderValidationRefund {
    id: Scalars['String']
    refundAmount?: Scalars['Float']
    giftCardAmount?: Scalars['Float']
    giftCardDiscountAmount?: Scalars['Float']
    shippingAmount?: Scalars['Float']
    taxAmount?: Scalars['Float']
    __typename: 'ShopifyOrderValidationRefund'
}

export interface ShopifyOrderValidationSale {
    id: Scalars['String']
    saleAmount?: Scalars['Float']
    giftCardAmount?: Scalars['Float']
    giftCardDiscountAmount?: Scalars['Float']
    taxAmount?: Scalars['Float']
    dutyAmount?: Scalars['Float']
    discountAmount?: Scalars['Float']
    shippingAmount?: Scalars['Float']
    tipAmount?: Scalars['Float']
    __typename: 'ShopifyOrderValidationSale'
}

export interface ShopifyProduct {
    id: Scalars['String']
    companyId: Scalars['String']
    finaloopId: Scalars['String']
    lineOfBusinessId?: Scalars['String']
    sku?: Scalars['String']
    price?: Scalars['Float']
    displayName?: Scalars['String']
    imageUrl?: Scalars['String']
    listedChannels: SalesChannel[]
    appliedCosts: ProductAppliedCost[]
    dailySalesData: SalesChannelDailySalesData[]
    totalSold: Scalars['Int']
    avgCostPerUnit?: Scalars['Float']
    productUrl?: Scalars['String']
    productVariantId?: Scalars['String']
    canEditLatestAppliedCost?: Scalars['Boolean']
    isFractional: Scalars['Boolean']
    isHidden: Scalars['Boolean']
    salesData: SalesData
    rawRecipes: Recipe[]
    componentOfProducts: Product[]
    isAmbiguousSku?: Scalars['Boolean']
    analyticsOverview: ProductAnalyticsOverview
    warehousesAnalyticsOverview: ProductWarehousesAnalyticsOverview[]
    tags: Scalars['String'][]
    isCreatedManually: Scalars['Boolean']
    isDataSyncing: Scalars['Boolean']
    mergeHistory: ProductMergeHistoryItem[]
    isDropshipping?: Scalars['Boolean']
    __typename: 'ShopifyProduct'
}

export interface ShopifyProductsValidationConnection {
    integrationAccountId: Scalars['String']
    isAvailable: Scalars['Boolean']
    __typename: 'ShopifyProductsValidationConnection'
}

export interface ShopifyProductsValidationConnectionsResponse {
    connections: ShopifyProductsValidationConnection[]
    __typename: 'ShopifyProductsValidationConnectionsResponse'
}

export interface ShopifyProductsValidationData {
    integrationAccountId: Scalars['String']
    data: ShopifySkuReconciliationData[]
    reportEndTime?: Scalars['Date']
    reportPath?: Scalars['String']
    summary: ReconciliationSummary
    productItemSoldData: ShopifySkuReconciliationProductItemSoldData
    productStatus: ShopifyReconciliationProductsStatus
    unknownSkuQuantity: Scalars['Int']
    unknownSkuZeroPriceQuantity: Scalars['Int']
    isNotArtificiallyFulfilled: Scalars['Boolean']
    __typename: 'ShopifyProductsValidationData'
}

export interface ShopifyProductsValidationResponse {
    validationId: Scalars['String']
    __typename: 'ShopifyProductsValidationResponse'
}

export interface ShopifyReconciliationProductsStatus {
    unitsSoldDiff: Scalars['Int']
    unitsRestockedDiff: Scalars['Int']
    unitsGiveawayDiff: Scalars['Int']
    __typename: 'ShopifyReconciliationProductsStatus'
}

export interface ShopifyReportDateLimitsResponse {
    dateRange?: DateRange
    failureType?: Scalars['String']
    __typename: 'ShopifyReportDateLimitsResponse'
}

export interface ShopifySkuReconciliationData {
    sku: Scalars['String']
    isBlacklisted: Scalars['Boolean']
    excludedSalesChannelsData: ExcludedSalesChannelItemReconciliation[]
    includedSalesChannelsData: IncludedFinaloopSalesChannelItemReconciliation[]
    summary: ReconciliationSummary
    productItemSoldData: ShopifySkuReconciliationProductItemSoldData
    productStatus: ShopifyReconciliationProductsStatus
    unknownSkuQuantity: Scalars['Int']
    unknownSkuZeroPriceQuantity: Scalars['Int']
    __typename: 'ShopifySkuReconciliationData'
}

export interface ShopifySkuReconciliationProductItemSoldData {
    unitsSold: Scalars['Int']
    unitsSoldWithZeroPrice: Scalars['Int']
    unitsRestocked: Scalars['Int']
    unitsGiveaway: Scalars['Int']
    ambiguousSkuQuantity: Scalars['Int']
    __typename: 'ShopifySkuReconciliationProductItemSoldData'
}

export interface ShopifyTimezoneBalance {
    timezone: Scalars['String']
    grossAmount: Scalars['Float']
    netAmount: Scalars['Float']
    taxAmount: Scalars['Float']
    discountAmount: Scalars['Float']
    shippingAmount: Scalars['Float']
    refundAmount: Scalars['Float']
    totalAmount: Scalars['Float']
    __typename: 'ShopifyTimezoneBalance'
}

export type ShopifyValidationItemType = 'RESTOCKED' | 'VOIDED' | 'IN_BOOKS' | 'ZERO_NET' | 'EXCLUDED' | 'ZERO_PRICE'

export type SimpleMoneyDirection = 'IN' | 'OUT'

export interface SimulatedLoanFailure {
    reason?: Scalars['String']
    __typename: 'SimulatedLoanFailure'
}

export interface SimulatedLoanIrrelevantEvent {
    event?: Scalars['String']
    __typename: 'SimulatedLoanIrrelevantEvent'
}

export type SimulatedLoanSummary = (SimulatedLoanIrrelevantEvent | SimulatedLoanUpdate | SimulatedLoanFailure) & { __isUnion?: true }

export interface SimulatedLoanUpdate {
    createdLoan?: SimulatedLoanUpdateCreate
    deletedLoan?: SimulatedLoanUpdateDelete
    __typename: 'SimulatedLoanUpdate'
}

export interface SimulatedLoanUpdateCreate {
    type?: LoanType
    isShortTerm?: Scalars['Boolean']
    date?: Scalars['Date']
    amount?: Scalars['Float']
    lender?: NewLender
    __typename: 'SimulatedLoanUpdateCreate'
}

export interface SimulatedLoanUpdateDelete {
    loanId?: Scalars['String']
    type?: LoanType
    isShortTerm?: Scalars['Boolean']
    date?: Scalars['Date']
    amount?: Scalars['Float']
    lender?: NewLender
    __typename: 'SimulatedLoanUpdateDelete'
}

export type SingleOrderResult = (OrderV3 | OrderV3NotFound) & { __isUnion?: true }

export interface SkuData {
    product: Product
    /** @deprecated use product.id instead */
    productId: Scalars['String']
    /** @deprecated use product.displayName instead */
    productName: Scalars['String']
    /** @deprecated use product.sku instead */
    sku?: Scalars['String']
    sourcesAndStores: SourceAndStores[]
    sales: CurrentPreviousValue
    salesTrend: Scalars['Float']
    discounts: CurrentPreviousValue
    cogs: CurrentPreviousValue
    profit: CurrentPreviousValue
    margin: CurrentPreviousValue
    refunds: CurrentPreviousValue
    restocks: CurrentPreviousValue
    effectiveProfit: CurrentPreviousValue
    effectiveProfitMargin: CurrentPreviousValue
    unitsSold: CurrentPreviousValue
    unitsRefunded: CurrentPreviousValue
    averageUnitsSold: CurrentPreviousValue
    /** @deprecated use averageNetSales instead */
    averageSalePrice: CurrentPreviousValue
    averageNetSales: CurrentPreviousValue
    averageCostPerUnit: CurrentPreviousValue
    averageProfitPerUnit: CurrentPreviousValue
    __typename: 'SkuData'
}

export interface SkuDataByDate {
    date: Scalars['Date']
    sales: CurrentPreviousValue
    discounts: CurrentPreviousValue
    cogs: CurrentPreviousValue
    profit: CurrentPreviousValue
    margin: CurrentPreviousValue
    refunds: CurrentPreviousValue
    unitsSold: CurrentPreviousValue
    unitsRefunded: CurrentPreviousValue
    __typename: 'SkuDataByDate'
}

export interface SkuValidationData {
    sku?: Scalars['String']
    integrationAccountName: Scalars['String']
    unitsSold: Scalars['Int']
    unitsRestocked: Scalars['Int']
    unitsGiveaway: Scalars['Int']
    unitsSoldWithZeroPrice: Scalars['Int']
    __typename: 'SkuValidationData'
}

export type SortByMerchants = 'TRANSACTIONS_AMOUNT_DESC'

export type SortDirection = 'ASC' | 'DESC'

export interface SourceAndStores {
    source: SourceTypes
    stores: Scalars['String'][]
    __typename: 'SourceAndStores'
}

export type SourceTypes = 'INVOICE' | 'SHOPIFY' | 'TIK_TOK'

export interface SpecificDate {
    date: Scalars['Date']
    amount: Scalars['Float']
    __typename: 'SpecificDate'
}

export type SpreadBasisType = 'DAILY' | 'MONTHLY'

export interface SpreadOverTime {
    fromDate: Scalars['Date']
    toDate: Scalars['Date']
    amount: Scalars['Float']
    spreadBasisType?: SpreadBasisType
    __typename: 'SpreadOverTime'
}

export type SpreadType = 'SPECIFIC_DATE' | 'SPREAD_OVER_TIME' | 'CUSTOM_SPREAD' | 'FIXED_ASSETS_DEFAULT' | 'FIXED_ASSETS_CUSTOM'

export interface Store {
    id: Scalars['ID']
    name: Scalars['String']
    homeCurrency: CurrencyCode
    __typename: 'Store'
}

export type StoreOrderTransactionMatchType = 'PAYMENT' | 'BANK_TRANSACTION'

export interface StorePaymentV2 {
    id: Scalars['ID']
    source: IntegrationType
    externalSourceId: Scalars['String']
    __typename: 'StorePaymentV2'
}

export interface StoreV3 {
    id: Scalars['ID']
    name?: Scalars['String']
    homeCurrency?: CurrencyCode
    __typename: 'StoreV3'
}

export interface StripeCustomerIdsResponse {
    companyAndStripeIds: CompanyIdAndStripeCustomerId[]
    __typename: 'StripeCustomerIdsResponse'
}

export interface SubmitTransactionsFileToBankTransactionsUploadResponse {
    id: Scalars['ID']
    companyId: Scalars['String']
    bankAccountId: Scalars['String']
    s3Bucket: Scalars['String']
    s3Key: Scalars['String']
    status: BankTransactionsUploadStatus
    __typename: 'SubmitTransactionsFileToBankTransactionsUploadResponse'
}

export interface SuccessResponse {
    success: Scalars['Boolean']
    __typename: 'SuccessResponse'
}

export interface SuccessResult {
    success: Scalars['Boolean']
    __typename: 'SuccessResult'
}

export interface SuspectedBankAccountDuplication {
    id: Scalars['ID']
    companyId: Scalars['String']
    bankAccountId1: Scalars['String']
    bankAccountId2: Scalars['String']
    liveConnectionBankAccountId?: Scalars['String']
    readyForMergingAt?: Scalars['Date']
    hubspotNotificationSentAt?: Scalars['Date']
    duplicateCheckStartedAt?: Scalars['Date']
    duplicateCheckCompletedAt?: Scalars['Date']
    duplicateCheckResult?: DuplicateCheckResult
    mergeStartedAt?: Scalars['Date']
    mergeCompletedAt?: Scalars['Date']
    mergeResult?: MergeResult
    fileLocationBucket?: Scalars['String']
    fileLocationKey?: Scalars['String']
    mergedBy?: ActorType
    mergedById?: Scalars['String']
    totalMergedTransactionsChunks?: Scalars['Int']
    currentlyMergedTransactionsChunks?: Scalars['Int']
    createdAt: Scalars['Date']
    updatedAt: Scalars['Date']
    __typename: 'SuspectedBankAccountDuplication'
}

export interface SwitchCompanyResponse {
    success: Scalars['Boolean']
    __typename: 'SwitchCompanyResponse'
}

export type SyncCompanyEventName = 'INSERT' | 'MODIFY' | 'REMOVE'

export interface SyncDataPlatformIntegrationResponse {
    companyId: Scalars['ID']
    integrationType: IntegrationType
    integrationAccountId: Scalars['String']
    isNewIntegration: Scalars['Boolean']
    isUpdatedIntegration: Scalars['Boolean']
    __typename: 'SyncDataPlatformIntegrationResponse'
}

export interface Tax {
    id: Scalars['ID']
    amount: Scalars['Float']
    description?: Scalars['String']
    __typename: 'Tax'
}

export interface Tax1099AffiliatedEntity {
    affiliatedEntity: AffiliatedEntity
    type: Tax1099AffiliatedEntityType
    calendarYear: Scalars['Int']
    totalPayments: Scalars['Float']
    businessEvents: Scalars['String'][]
    sources: Scalars['String'][]
    __typename: 'Tax1099AffiliatedEntity'
}

export type Tax1099AffiliatedEntityDisqualifyReason = 'CORPORATION' | 'NON_US_TAXPAYER' | 'NOT_A_SERVICE_PROVIDER' | 'FREIGHT_OR_STORAGE_SERVICE_PROVIDER' | 'BANK' | 'NOT_A_DIVIDEND'

export interface Tax1099AffiliatedEntityGroup {
    id: Scalars['ID']
    groupName?: Scalars['String']
    isGroup: Scalars['Boolean']
    type: Tax1099AffiliatedEntityType
    calendarYear: Scalars['Int']
    affiliatedEntities: Tax1099AffiliatedEntity[]
    totalPayments: Scalars['Float']
    businessEvents: Scalars['String'][]
    sources: Scalars['String'][]
    disqualifyReason?: Tax1099AffiliatedEntityDisqualifyReason
    file?: Tax1099AffiliatedEntityGroupFile
    markedAsDoneAt?: Scalars['Date']
    finaloopComment?: Scalars['String']
    __typename: 'Tax1099AffiliatedEntityGroup'
}

export interface Tax1099AffiliatedEntityGroupFile {
    url: Scalars['String']
    name: Scalars['String']
    __typename: 'Tax1099AffiliatedEntityGroupFile'
}

export interface Tax1099AffiliatedEntityGroupsByType {
    type: Tax1099AffiliatedEntityType
    calendarYear: Scalars['Int']
    affiliatedEntityGroups: Tax1099AffiliatedEntityGroup[]
    __typename: 'Tax1099AffiliatedEntityGroupsByType'
}

export type Tax1099AffiliatedEntityType = 'NEC' | 'MISC' | 'DIV' | 'INT'

export interface TaxInfo {
    amount: Scalars['Float']
    description?: Scalars['String']
    isTaxInclusive: Scalars['Boolean']
    createdAt: Scalars['Date']
    updatedAt: Scalars['Date']
    __typename: 'TaxInfo'
}

export interface TaxLineItemV3 {
    id: Scalars['ID']
    /** The ID of the line item in the external system */
    externalLineItemId: Scalars['String']
    /** The name of the line item */
    name?: Scalars['String']
    /** The description of the line item */
    description: Scalars['String']
    /** The amount of the line item */
    amount: Amounts
    parentId?: Scalars['String']
    /** The type of the line item */
    parentLineItemType?: ParentLineItemType
    /** The earliest date and time the line item was posted */
    earliestPostedAt: Scalars['Date']
    /** The latest date and time the line item was posted */
    latestPostedAt: Scalars['Date']
    /** The type of the line item */
    type: OrderLineItemTypeV3
    /** The type of the tax */
    taxType: OrderLineItemTaxType
    /** The name of the tax as received from the external system */
    externalName: Scalars['String']
    /** The ISO code of the country of the tax */
    country?: Scalars['String']
    /** The region of the tax */
    region?: Scalars['String']
    /** The rate of the tax */
    ratePercentage?: Scalars['String']
    /** The liable party of the tax */
    liableParty: Scalars['String']
    __typename: 'TaxLineItemV3'
}

export interface TestSPSCommerceOrgConnectionResponse {
    success: Scalars['Boolean']
    message?: Scalars['String']
    __typename: 'TestSPSCommerceOrgConnectionResponse'
}

export interface TikTokProduct {
    id: Scalars['String']
    companyId: Scalars['String']
    finaloopId: Scalars['String']
    lineOfBusinessId?: Scalars['String']
    sku?: Scalars['String']
    price?: Scalars['Float']
    displayName?: Scalars['String']
    imageUrl?: Scalars['String']
    listedChannels: SalesChannel[]
    appliedCosts: ProductAppliedCost[]
    dailySalesData: SalesChannelDailySalesData[]
    totalSold: Scalars['Int']
    avgCostPerUnit?: Scalars['Float']
    asin: Scalars['String']
    canEditLatestAppliedCost?: Scalars['Boolean']
    isFractional: Scalars['Boolean']
    isHidden: Scalars['Boolean']
    salesData: SalesData
    rawRecipes: Recipe[]
    componentOfProducts: Product[]
    isAmbiguousSku?: Scalars['Boolean']
    analyticsOverview: ProductAnalyticsOverview
    warehousesAnalyticsOverview: ProductWarehousesAnalyticsOverview[]
    tags: Scalars['String'][]
    isCreatedManually: Scalars['Boolean']
    isDataSyncing: Scalars['Boolean']
    mergeHistory: ProductMergeHistoryItem[]
    isDropshipping?: Scalars['Boolean']
    __typename: 'TikTokProduct'
}

export type TimeBreakdownUnit = 'DAY' | 'WEEK' | 'MONTH' | 'QUARTER' | 'YEAR'

export interface TimeRange {
    fromUTC: Scalars['Date']
    toUTC: Scalars['Date']
    __typename: 'TimeRange'
}

export interface TipLineItemV3 {
    id: Scalars['ID']
    /** The ID of the line item in the external system */
    externalLineItemId?: Scalars['String']
    /** The name of the line item */
    name?: Scalars['String']
    /** The description of the line item */
    description?: Scalars['String']
    /** The amount of the line item */
    amount: Amounts
    parentId?: Scalars['String']
    /** The type of the line item */
    parentLineItemType?: ParentLineItemType
    /** The earliest date and time the line item was posted */
    earliestPostedAt: Scalars['Date']
    /** The latest date and time the line item was posted */
    latestPostedAt: Scalars['Date']
    /** The type of the line item */
    type: OrderLineItemTypeV3
    __typename: 'TipLineItemV3'
}

export interface ToggleBankTransactionAccrualResult {
    companyId: Scalars['ID']
    bankTransactionId: Scalars['ID']
    hasAccrual: Scalars['Boolean']
    __typename: 'ToggleBankTransactionAccrualResult'
}

export interface Topup {
    id: Scalars['ID']
    companyId: Scalars['String']
    amount: Scalars['Float']
    amountInUsd: Scalars['Float']
    currency: Scalars['String']
    eventTime: Scalars['Date']
    deletedAt?: Scalars['Date']
    markedAsReconciliationDiscrepancyAt?: Scalars['Date']
    integrationType: IntegrationType
    pairedBankTransaction?: BankTransaction
    type: IntegrationTransferType
    classification?: IntegrationTransferClassification
    integrationAccountId?: Scalars['ID']
    integrationAccountName?: Scalars['String']
    pairedCompanyAffiliate?: CompanyAffiliate
    link?: Scalars['String']
    uploadedFileId?: Scalars['String']
    failedAmountInUsd?: Scalars['Float']
    failedAt?: Scalars['Date']
    markedAsUnidentifiedAt?: Scalars['Date']
    rawEvent?: Scalars['JSON']
    __typename: 'Topup'
}

export interface TransactionDescription {
    description: Scalars['String']
    __typename: 'TransactionDescription'
}

export type TransactionKind = 'PAYMENT' | 'REFUND'

export interface TransactionLoan {
    transaction: BankTransaction
    loan?: CompanyLoan
    isLocked?: Scalars['Boolean']
    __typename: 'TransactionLoan'
}


/** The payment gateway of the transaction, as decided by Finaloop */
export type TransactionPaymentGatewayType = 'AAFES' | 'ADYEN' | 'AFFIRM' | 'AFTERPAY' | 'AIRWALLEX' | 'ALMA' | 'AMAZON' | 'AMAZON_PAY' | 'AUTHORIZE_NET' | 'BANKFUL' | 'BLACKCART' | 'BLOOM' | 'BN' | 'BRAINTREE' | 'BREAD_PAY' | 'CAROO' | 'CARRO' | 'CATCH' | 'CHANNEL_ADVISOR' | 'CHECKOUT_COM' | 'CLEARCO' | 'CLEARPAY' | 'COINBASE' | 'COMMENT_SOLD' | 'CORPORATE_GIFT' | 'CVS' | 'EBAY' | 'ETSY' | 'EXCHANGE_CREDIT' | 'FACEBOOK' | 'FAIRE' | 'FOUR_BNPL' | 'GIFT_CARD' | 'GLOBAL_E' | 'GLOPAL' | 'GUSTO' | 'KLARNA' | 'KLICKLY' | 'KROGER' | 'LEAP_RETAIL' | 'MANUAL' | 'MIRAKL' | 'NMI' | 'NO_GATEWAY' | 'OPEN_NODE' | 'OPEN_PATH' | 'PARKER' | 'PARTIALLY' | 'PAYONEER' | 'PAYPAL' | 'POSTAL' | 'QUICKBOOKS_PAYMENTS' | 'QVC' | 'REACH' | 'RECHARGE' | 'RETURNLY' | 'REVOLUT' | 'SETTLE' | 'SEZZLE' | 'SHOP_PAY' | 'SNACK_MAGIC' | 'SPLITIT' | 'SQUARE' | 'STORE_CREDIT' | 'STRIPE' | 'TARGET' | 'TIK_TOK' | 'TRUE_MED' | 'TWINT' | 'UNKNOWN' | 'WALGREENS' | 'WALMART' | 'WALMART_VIA_SHOPIFY' | 'WISE' | 'WOOCOMMERCE' | 'ZIP'

export type TransactionPaymentType = 'Internal' | 'External'

export interface TransactionsImportStatus {
    stopImportFromDate?: Scalars['String']
    changedBy?: Scalars['String']
    changedAt?: Scalars['String']
    __typename: 'TransactionsImportStatus'
}

export type TransactionType = 'PAYMENT' | 'REFUND'

export interface UnconnectedAccount {
    vendor?: Vendor
    __typename: 'UnconnectedAccount'
}

export type UnidentifiedBankTransactionParty = (BankAccount | UnknownTransactionBank | UnknownTransactionAccount | UnconnectedAccount | Vendor | TransactionDescription) & { __isUnion?: true }

export interface UnidentifiedBankTransactionsGroup {
    transactions: BankTransaction[]
    payer: UnidentifiedBankTransactionParty
    payee: UnidentifiedBankTransactionParty
    groupId: Scalars['ID']
    isProcessing: Scalars['Boolean']
    action?: UnidentifiedTransfersGroupAction
    tooltipText?: Scalars['String']
    type: UnidentifiedBankTransactionsGroupType
    __typename: 'UnidentifiedBankTransactionsGroup'
}

export type UnidentifiedBankTransactionsGroupType = 'TRANSFER' | 'BANK_TRANSFER' | 'CREDIT_CARD_PAYMENT'

export type UnidentifiedTransfersGroupAction = 'ASK_THE_USER_FLOW' | 'CONNECT_ACCOUNT' | 'UPLOAD_CSV' | 'UPLOAD_STATEMENT' | 'ROLE_GRANT'

export interface UnitBasedClosingBalance {
    missionType: InventoryYearEndMissionsType
    status: InventoryYearEndMissionStatus
    historyLog: InventoryYearEndHistoryLog[]
    managementMethodPeriod: ManagementMethodYearEndPeriod
    closingBalance: Scalars['Float']
    __typename: 'UnitBasedClosingBalance'
}

export interface UnitBasedNegativeOnHands {
    missionType: InventoryYearEndMissionsType
    status: InventoryYearEndMissionStatus
    historyLog: InventoryYearEndHistoryLog[]
    managementMethodPeriod: ManagementMethodYearEndPeriod
    productsWithNegativeOnHands: Scalars['Int']
    __typename: 'UnitBasedNegativeOnHands'
}

export interface UnitBasedReportCogs {
    missionType: InventoryYearEndMissionsType
    status: InventoryYearEndMissionStatus
    historyLog: InventoryYearEndHistoryLog[]
    managementMethodPeriod: ManagementMethodYearEndPeriod
    __typename: 'UnitBasedReportCogs'
}

export interface UnitBasedVendorsNegativeBalance {
    missionType: InventoryYearEndMissionsType
    status: InventoryYearEndMissionStatus
    historyLog: InventoryYearEndHistoryLog[]
    managementMethodPeriod: ManagementMethodYearEndPeriod
    vendorsWithNegativeBalance: Scalars['Int']
    __typename: 'UnitBasedVendorsNegativeBalance'
}

export interface UnitFoundAction {
    quantity: Scalars['Float']
    id: Scalars['String']
    date: Scalars['Date']
    type: Scalars['String']
    __typename: 'UnitFoundAction'
}

export interface UnitLostAction {
    quantity: Scalars['Float']
    id: Scalars['String']
    date: Scalars['Date']
    type: Scalars['String']
    __typename: 'UnitLostAction'
}

export interface UnitsTrackingPhysicalCount {
    id: Scalars['ID']
    companyId: Scalars['String']
    amountAdjustment?: Scalars['Float']
    lastAckAmountAdjustment?: Scalars['Float']
    amountAdjustmentWithPendingAdjustments?: Scalars['Float']
    date: Scalars['Date']
    warehouse: Warehouse
    attachments?: UnitsTrackingPhysicalCountAttachment[]
    closingBalance: Scalars['Float']
    amount?: Scalars['Float']
    note?: Scalars['String']
    isDraft: Scalars['Boolean']
    deletedAt?: Scalars['Date']
    hasUnacknowledgedChanges: Scalars['Boolean']
    __typename: 'UnitsTrackingPhysicalCount'
}

export interface UnitsTrackingPhysicalCountAttachment {
    name: Scalars['String']
    url: Scalars['String']
    __typename: 'UnitsTrackingPhysicalCountAttachment'
}

export interface UnitsTrackingPhysicalCountOverview {
    missingData: Scalars['Float']
    count: Scalars['Float']
    pendingChanges: Scalars['Float']
    productQuantities: Scalars['Float']
    __typename: 'UnitsTrackingPhysicalCountOverview'
}

export interface UnitsTrackingPhysicalCountProductQuantities {
    products?: UnitsTrackingPhysicalCountProductQuantity[]
    offset: Scalars['Float']
    count: Scalars['Float']
    hasUnacknowledgedChanges: Scalars['Boolean']
    __typename: 'UnitsTrackingPhysicalCountProductQuantities'
}

export interface UnitsTrackingPhysicalCountProductQuantity {
    product: Product
    quantity?: Scalars['Float']
    avgCost?: Scalars['Float']
    lastAckAvgCost?: Scalars['Float']
    quantityAdjustment?: Scalars['Float']
    lastAckQuantityAdjustment?: Scalars['Float']
    amountAdjustment?: Scalars['Float']
    lastAckAmountAdjustment?: Scalars['Float']
    unitsOnHand?: Scalars['Float']
    lastAckUnitsOnHand?: Scalars['Float']
    hasUnacknowledgedChanges: Scalars['Boolean']
    isPendingChange: Scalars['Boolean']
    __typename: 'UnitsTrackingPhysicalCountProductQuantity'
}

export interface UnitsTrackingPhysicalCountsList {
    physicalCounts: UnitsTrackingPhysicalCount[]
    offset: Scalars['Int']
    count: Scalars['Int']
    totalCount: Scalars['Int']
    minAdjustment?: Scalars['Float']
    maxAdjustment?: Scalars['Float']
    __typename: 'UnitsTrackingPhysicalCountsList'
}

export type UnitType = 'CURRENCY' | 'PERCENTAGE' | 'NUMBER'

export interface UnknownIntegrationTransferAccount {
    dummy?: Scalars['String']
    __typename: 'UnknownIntegrationTransferAccount'
}

export interface UnknownIntegrationTransferBank {
    dummy?: Scalars['String']
    __typename: 'UnknownIntegrationTransferBank'
}

export interface UnknownTransactionAccount {
    vendor?: Vendor
    __typename: 'UnknownTransactionAccount'
}

export interface UnknownTransactionBank {
    vendor?: Vendor
    __typename: 'UnknownTransactionBank'
}

export interface UnlockLoanResult {
    success: Scalars['Boolean']
    message?: Scalars['String']
    __typename: 'UnlockLoanResult'
}

export interface UnMarkOrdersAsCOGSResponse {
    orders: OrderV2[]
    __typename: 'UnMarkOrdersAsCOGSResponse'
}

export interface UnMarkOrdersAsGiveawayResponse {
    orders: OrderV2[]
    __typename: 'UnMarkOrdersAsGiveawayResponse'
}

export interface UnMarkOrdersAsOvercollectedResponse {
    orders: OrderV2[]
    __typename: 'UnMarkOrdersAsOvercollectedResponse'
}

export interface UnMarkOrdersAsUncollectibleResponse {
    orders: OrderV2[]
    __typename: 'UnMarkOrdersAsUncollectibleResponse'
}

export interface UnpaidAmountPerAffiliatedEntity {
    affiliatedEntity: AffiliatedEntity
    totalSum: Scalars['Float']
    unpaidAmount: Scalars['Float']
    __typename: 'UnpaidAmountPerAffiliatedEntity'
}

export interface UnpaidAmountsViaProvider {
    type: UnpaidAmountsViaProviderType
    categoryGroup?: PayrollCategory
    amount: Scalars['Float']
    __typename: 'UnpaidAmountsViaProvider'
}

export type UnpaidAmountsViaProviderType = 'TAXES' | 'HEALTH_EMPLOYEE' | 'TRANSPORTATION_EMPLOYEE' | 'OTHER_BENEFITS_EMPLOYEE' | 'OTHER_GARNISHMENTS' | 'OTHER_DEDUCTIONS' | 'SAVINGS_AND_RETIREMENT_OTHER_EMPLOYEE' | 'SAVINGS_AND_RETIREMENT_401K_EMPLOYEE' | 'VACATION_PAY' | 'CHILD_SUPPORT'

export interface UnvoidOrdersResponse {
    orders: OrderV2[]
    failedIds: Scalars['ID'][]
    __typename: 'UnvoidOrdersResponse'
}

export interface UpdateAssociatedBankTransactionsFileResponse {
    success: Scalars['Boolean']
    errorMessage?: Scalars['String']
    __typename: 'UpdateAssociatedBankTransactionsFileResponse'
}

export interface UpdateBalanceSheetSetupItemResponse {
    success: Scalars['Boolean']
    errorMessage?: BalanceSheetSetupItemErrorMessage
    __typename: 'UpdateBalanceSheetSetupItemResponse'
}

export interface UpdateBalanceSheetSetupResponse {
    success: Scalars['Boolean']
    __typename: 'UpdateBalanceSheetSetupResponse'
}

export type UpdateCheckDetails = 'RECORD_NOT_FOUND' | 'INVALID_STATE_CHANGE' | 'SAME_STATE' | 'YEAR_END_STATE_BLOCKED_FOR_CHANGES'

export type UpdateCheckTypes = 'VALID' | 'INVALID' | 'NOT_AFFECTED' | 'NOT_FOUND'

export interface UpdateCompanyDomainStateResponse {
    companyId?: Scalars['ID']
    yearEndDomainStateId?: Scalars['String']
    updateCheck: UpdateCheckTypes
    state?: YearEndDomainState
    details?: UpdateCheckDetails
    __typename: 'UpdateCompanyDomainStateResponse'
}

export interface UpdateCompanyLoansResponse {
    loans: Loan[]
    __typename: 'UpdateCompanyLoansResponse'
}

export interface UpdatedLoans {
    loans: Loan[]
    __typename: 'UpdatedLoans'
}

export interface UpdateInventoryPaymentGroupResponse {
    inventoryPaymentGroup?: InventoryPaymentGroup
    __typename: 'UpdateInventoryPaymentGroupResponse'
}

export type UpdateInventoryPurchaseResponse = (InventoryPurchase | InventoryPurchaseUpdateOutOfDateError) & { __isUnion?: true }

export interface UpdateInvoicePaymentGroupResponse {
    paymentGroup?: InvoicePaymentGroup
    __typename: 'UpdateInvoicePaymentGroupResponse'
}

export type UpdateManualAssemblyResult = (ManualAssembly | RecipeCirclesFoundError | RecipeAllocatedCostsError) & { __isUnion?: true }

export interface UpdateManualLoanEventResult {
    loan: Loan
    __typename: 'UpdateManualLoanEventResult'
}

export interface UpdateManualLoanEventsResult {
    loan: Loan
    __typename: 'UpdateManualLoanEventsResult'
}

export interface UpdateOrderGroupResponse {
    orderGroup?: OrderGroup
    __typename: 'UpdateOrderGroupResponse'
}

export interface UpdateOrderPaymentGroupResponse {
    paymentGroup?: OrderPaymentGroup
    __typename: 'UpdateOrderPaymentGroupResponse'
}

export type UpdateRecipeResult = (Recipe | RecipeCirclesFoundError | RecipeOverlappingError | RecipeAllocatedCostsError) & { __isUnion?: true }

export interface UpdateUserDetailsResponse {
    user: User
    __typename: 'UpdateUserDetailsResponse'
}

export interface UpdateUserRolesForCompanyResponse {
    success: Scalars['Boolean']
    __typename: 'UpdateUserRolesForCompanyResponse'
}

export type UploadableIntegrationType = 'FINALOOP_INVOICES' | 'QUICKBOOKS_INVOICES' | 'NU_ORDER_INVOICES' | 'SPS_COMMERCE'

export interface UploadBankStatementResponse {
    id: Scalars['ID']
    companyId: Scalars['ID']
    bankAccount: BankAccount
    providerValidationResults: BankStatementValidationResults
    __typename: 'UploadBankStatementResponse'
}

export interface UploadedInvoice {
    invoiceNumber: Scalars['String']
    externalSourceId: Scalars['String']
    invoiceId?: Scalars['String']
    error?: Scalars['String']
    __typename: 'UploadedInvoice'
}

export interface User {
    id: Scalars['ID']
    email: Scalars['String']
    auth0Id?: Scalars['String']
    name?: Scalars['String']
    companies?: UserCompanies[]
    permissions?: Permission[]
    globalRole?: Scalars['String']
    welcomeReportTransactionsMessageMarkedAsHiddenAt?: Scalars['Date']
    intercomJwt?: Scalars['String']
    __typename: 'User'
}

export interface UserByEmailResponse {
    user?: User
    __typename: 'UserByEmailResponse'
}

export interface UserCompanies {
    company: Company
    roles: Scalars['ID'][]
    __typename: 'UserCompanies'
}

export interface UserFollowUp {
    type: LoanUserFollowUpType
    data?: Scalars['JSONObject']
    __typename: 'UserFollowUp'
}

export interface UserInvitation {
    id: Scalars['ID']
    email: Scalars['String']
    companyId: Scalars['ID']
    roles: Scalars['String'][]
    invitedByUserId: Scalars['String']
    invitationCode: Scalars['String']
    acceptedAt?: Scalars['Date']
    cancelledBy?: Scalars['String']
    cancelledAt?: Scalars['Date']
    __typename: 'UserInvitation'
}

export interface UserInvitationResponse {
    userInvitation?: UserInvitationWithCompany
    __typename: 'UserInvitationResponse'
}

export interface UserInvitationsByEmailResponse {
    userInvitations?: (UserInvitationWithCompany | undefined)[]
    __typename: 'UserInvitationsByEmailResponse'
}

export interface UserInvitationWithCompany {
    id: Scalars['ID']
    email: Scalars['String']
    company: Company
    roles: Scalars['String'][]
    invitedByUserId: Scalars['String']
    invitationCode: Scalars['String']
    acceptedAt?: Scalars['Date']
    cancelledBy?: Scalars['String']
    cancelledAt?: Scalars['Date']
    __typename: 'UserInvitationWithCompany'
}

export interface UserManualProduct {
    id: Scalars['String']
    companyId: Scalars['String']
    finaloopId: Scalars['String']
    lineOfBusinessId?: Scalars['String']
    sku?: Scalars['String']
    price?: Scalars['Float']
    displayName?: Scalars['String']
    imageUrl?: Scalars['String']
    listedChannels: SalesChannel[]
    appliedCosts: ProductAppliedCost[]
    dailySalesData: SalesChannelDailySalesData[]
    totalSold: Scalars['Int']
    avgCostPerUnit?: Scalars['Float']
    canEditLatestAppliedCost?: Scalars['Boolean']
    isFractional: Scalars['Boolean']
    isHidden: Scalars['Boolean']
    salesData: SalesData
    rawRecipes: Recipe[]
    componentOfProducts: Product[]
    isAmbiguousSku?: Scalars['Boolean']
    analyticsOverview: ProductAnalyticsOverview
    warehousesAnalyticsOverview: ProductWarehousesAnalyticsOverview[]
    tags: Scalars['String'][]
    isDataSyncing: Scalars['Boolean']
    mergeHistory: ProductMergeHistoryItem[]
    isDropshipping?: Scalars['Boolean']
    __typename: 'UserManualProduct'
}

export interface UserNameFromReferralCodeResponse {
    userName: Scalars['String']
    __typename: 'UserNameFromReferralCodeResponse'
}

export interface UserReferralLinkResponse {
    referralLink: Scalars['String']
    __typename: 'UserReferralLinkResponse'
}

export interface UserRole {
    id: Scalars['String']
    name: Scalars['String']
    description: Scalars['String']
    __typename: 'UserRole'
}

export interface UserRolesResponse {
    userRoles: UserRole[]
    __typename: 'UserRolesResponse'
}

export interface UsersByEmailsResponse {
    users: User[]
    __typename: 'UsersByEmailsResponse'
}

export interface UserUnresponsive {
    value: Scalars['Boolean']
    history?: BooleanChangeLog[]
    __typename: 'UserUnresponsive'
}

export interface ValidateInventoryPaymentGroupByEntityResponse {
    canceledInventoryPaymentGroups: InventoryPaymentGroup[]
    __typename: 'ValidateInventoryPaymentGroupByEntityResponse'
}

export interface Validation {
    id: Scalars['ID']
    __typename: 'Validation'
}

export interface ValidationCycle {
    id: Scalars['String']
    status: ValidationCycleStatus
    executionId?: Scalars['String']
    finishedCount: Scalars['Int']
    __typename: 'ValidationCycle'
}

export type ValidationCycleStatus = 'IN_PROGRESS' | 'COMPLETED' | 'FAILED'

export interface ValidationFailingCompany {
    company: Company
    fiscalYear: Scalars['Int']
    createdAt: Scalars['Date']
    __typename: 'ValidationFailingCompany'
}

export interface ValidationRemediation {
    company: Company
    status: Scalars['String']
    validationFiscalYear: Scalars['Int']
    buggyDateStatus?: Scalars['String']
    buggyDate?: Scalars['Date']
    bugDescription?: Scalars['String']
    updatedAt?: Scalars['Date']
    __typename: 'ValidationRemediation'
}

export interface ValidationRemediationsResponse {
    validationRemediations?: ValidationRemediation[]
    __typename: 'ValidationRemediationsResponse'
}

export interface ValidationResult {
    companyId: Scalars['String']
    integrationType?: Scalars['String']
    integrationAccountId?: Scalars['String']
    integrationAccountName?: Scalars['String']
    currency?: Scalars['String']
    accountRoles: Scalars['String'][]
    accountingMethod: Scalars['String']
    resultSet: ValidationResultSet[]
    __typename: 'ValidationResult'
}

export interface ValidationResultSet {
    createdAt: Scalars['Date']
    sampleDate: Scalars['Date']
    sampleValue: Scalars['Float']
    currentValue: Scalars['Float']
    __typename: 'ValidationResultSet'
}

export interface ValidationTemplate {
    id: Scalars['String']
    domain: CompanyValidationDomainType
    type: CompanyValidationType
    endTime: ValidationTemplateEndTime
    isEnabled: Scalars['Boolean']
    __typename: 'ValidationTemplate'
}

export type ValidationTemplateEndTime = 'NOW' | 'PREVIOUS_YEAR' | 'LOCKED_DATE'

export type ValueType = 'BENCHMARK' | 'CURRENT' | 'MARGIN' | 'PREVIOUS' | 'MAIN'

export interface Vendor {
    id: Scalars['ID']
    integrationType?: IntegrationType
    name: Scalars['String']
    companyId?: Scalars['ID']
    externalSourceId?: Scalars['String']
    websiteUrl?: Scalars['String']
    logoUrl?: Scalars['String']
    source: VendorSource
    labels?: (Scalars['String'] | undefined)[]
    contactEmail?: Scalars['String']
    is1099Contractor?: Scalars['Boolean']
    type?: VendorType
    subType?: VendorSubType[]
    affiliatedEntityId: Scalars['ID']
    __typename: 'Vendor'
}

export interface VendorByPaymentGatewayResponse {
    vendor?: Vendor
    __typename: 'VendorByPaymentGatewayResponse'
}

export interface VendorNotExistError {
    message: Scalars['String']
    id: Scalars['ID']
    __typename: 'VendorNotExistError'
}

export type VendorOrCustomer = (Vendor | CustomerV2) & { __isUnion?: true }

export type VendorSource = 'NTROPY' | 'FINALOOP' | 'FINALOOP_BILLS' | 'FINALOOP_TRANSACTIONS' | 'FINALOOP_TRANSACTIONS_MACHINE' | 'FINALOOP_MACHINE' | 'QUICKBOOKS' | 'BILL_COM' | 'SETTLE' | 'CUSTOMER'

export interface VendorsTransactionsCount {
    id: Scalars['String']
    amount: Scalars['Int']
    __typename: 'VendorsTransactionsCount'
}

export type VendorSubType = 'AUTOMATED_PAYMENT_PROCESSOR' | 'AUTOMATED_MARKETPLACE' | 'NON_AUTOMATED_MARKETPLACE' | 'NON_AUTOMATED_BRANDED_STORE' | 'NON_AUTOMATED_PAYMENT_PROCESSOR' | 'NON_AUTOMATED_PAYMENT_GATEWAY' | 'NON_AUTOMATED_PAYMENT_PROCESSOR_AUTHORIZE_NET' | 'SHIPPING_CARRIER' | 'INVENTORY'

export type VendorType = 'LOCAL' | 'GLOBAL'

export type ViewTypes = 'DEFAULT' | 'BARS'

export interface VoidOrderSettings {
    restrictedPaymentGateways: Scalars['String'][]
    __typename: 'VoidOrderSettings'
}

export interface VoidOrdersResponse {
    orders: OrderV2[]
    failedIds: Scalars['ID'][]
    __typename: 'VoidOrdersResponse'
}

export type VoidStatus = 'VOIDED'

export interface WalmartProduct {
    id: Scalars['String']
    companyId: Scalars['String']
    finaloopId: Scalars['String']
    lineOfBusinessId?: Scalars['String']
    sku?: Scalars['String']
    price?: Scalars['Float']
    displayName?: Scalars['String']
    imageUrl?: Scalars['String']
    listedChannels: SalesChannel[]
    appliedCosts: ProductAppliedCost[]
    dailySalesData: SalesChannelDailySalesData[]
    totalSold: Scalars['Int']
    avgCostPerUnit?: Scalars['Float']
    canEditLatestAppliedCost?: Scalars['Boolean']
    walmartId?: Scalars['String']
    productUrl?: Scalars['String']
    isFractional: Scalars['Boolean']
    isHidden: Scalars['Boolean']
    salesData: SalesData
    rawRecipes: Recipe[]
    componentOfProducts: Product[]
    isAmbiguousSku?: Scalars['Boolean']
    analyticsOverview: ProductAnalyticsOverview
    warehousesAnalyticsOverview: ProductWarehousesAnalyticsOverview[]
    tags: Scalars['String'][]
    isCreatedManually: Scalars['Boolean']
    isDataSyncing: Scalars['Boolean']
    mergeHistory: ProductMergeHistoryItem[]
    isDropshipping?: Scalars['Boolean']
    __typename: 'WalmartProduct'
}

export interface Warehouse {
    id: Scalars['ID']
    companyId: Scalars['ID']
    name: Scalars['String']
    source: Scalars['String']
    phone?: Scalars['String']
    city?: Scalars['String']
    province?: Scalars['String']
    country?: Scalars['String']
    zip?: Scalars['String']
    address?: Scalars['String']
    isDeletable: Scalars['Boolean']
    isActive: Scalars['Boolean']
    primaryWarehouse?: Warehouse
    isDropshipping: Scalars['Boolean']
    isDropshippingFrom?: Scalars['Date']
    __typename: 'Warehouse'
}

export type WarehouseAction = (AdjustmentRestockingAction | CommonAction | DeadInventoryAction | FulfillmentAction | ManualAssemblyAction | OnDemandAssemblyAction | OpeningBalanceAction | OtherFbaAction | RestockingAction | ShipmentAction | UnitFoundAction | UnitLostAction | WarehouseNegativesAdjustmentAction | WarehouseTransferArrivalAction | WarehouseTransferShippingAction | WasteAction) & { __isUnion?: true }

export interface WarehouseActionSalesChannel {
    integrationType?: Scalars['String']
    integrationAccountName?: Scalars['String']
    __typename: 'WarehouseActionSalesChannel'
}

export interface WarehouseCreateError {
    message: Scalars['String']
    type: WarehouseCreateErrorTypeEnum
    __typename: 'WarehouseCreateError'
}

export type WarehouseCreateErrorTypeEnum = 'DUPLICATE'

export type WarehouseCreateResult = (Warehouse | WarehouseCreateError) & { __isUnion?: true }

export type WarehouseFilterType = 'ORIGIN' | 'DESTINATION' | 'ALL'

export interface WarehouseIncomingInventoryBreakdownResult {
    incomingBatches: IncomingBatchAnalytics[]
    totalBatches: Scalars['Int']
    __typename: 'WarehouseIncomingInventoryBreakdownResult'
}

export interface WarehouseIncomingInventoryOverviewResult {
    warehouse: Warehouse
    analytics: IncomingInventoryAnalytics
    inTransit: Scalars['Int']
    openingBalance: WarehouseOpeningBalance
    totalBatches: Scalars['Int']
    __typename: 'WarehouseIncomingInventoryOverviewResult'
}

export interface WarehouseMovements {
    warehouse: Warehouse
    movements: Movement[]
    __typename: 'WarehouseMovements'
}

export interface WarehouseNegativesAdjustment {
    id: Scalars['ID']
    productId: Scalars['String']
    warehouseId: Scalars['String']
    totalQuantity: Scalars['Float']
    costPerUnit: Scalars['Float']
    datesToFix: DatesToFix[]
    __typename: 'WarehouseNegativesAdjustment'
}

export interface WarehouseNegativesAdjustmentAction {
    quantity: Scalars['Float']
    id: Scalars['String']
    date: Scalars['Date']
    type: Scalars['String']
    warehouseNegativeAdjustment: WarehouseNegativesAdjustment
    __typename: 'WarehouseNegativesAdjustmentAction'
}

export interface WarehouseNegativesAdjustmentBreakdown {
    warehouseNegativesAdjustment: WarehouseNegativesAdjustment
    startDate: Scalars['Date']
    endDate: Scalars['Date']
    __typename: 'WarehouseNegativesAdjustmentBreakdown'
}

export interface WarehouseOpeningBalance {
    id: Scalars['ID']
    warehouse: Warehouse
    product: Product
    quantity: Scalars['Float']
    costPerUnit: Scalars['Float']
    date: Scalars['Date']
    isMissingUserInput: Scalars['Boolean']
    attachmentId?: Scalars['String']
    __typename: 'WarehouseOpeningBalance'
}

export interface WarehouseOpeningBalanceErrorItem {
    rowNumber: Scalars['Int']
    cellNumber: Scalars['Int']
    errorType: WarehouseOpeningBalanceErrorItemType
    __typename: 'WarehouseOpeningBalanceErrorItem'
}

export type WarehouseOpeningBalanceErrorItemType = 'INVALID_HEADERS' | 'MISSING_PRODUCT' | 'MISSING_WAREHOUSE' | 'MISSING_QUANTITY' | 'MISSING_COST' | 'INVALID_QUANTITY' | 'ROW_DUPLICATE' | 'PRODUCT_AMBIGUOUS' | 'WAREHOUSE_AMBIGUOUS' | 'PRODUCT_NOT_FOUND' | 'WAREHOUSE_NOT_FOUND' | 'INVALID_DATA' | 'UNKNOWN_ERROR'

export interface WarehouseOpeningBalanceItem {
    product: Product
    warehouseOpeningBalance?: WarehouseOpeningBalance
    pendingWarehouseOpeningBalance?: PendingWarehouseOpeningBalance
    __typename: 'WarehouseOpeningBalanceItem'
}

export interface WarehouseOpeningBalanceOverviewResponse {
    count: Scalars['Int']
    pendingCount: Scalars['Int']
    missingDataCount: Scalars['Int']
    totalCost?: Scalars['Float']
    minQuantity?: Scalars['Float']
    maxQuantity?: Scalars['Float']
    minCostPerUnit?: Scalars['Float']
    maxCostPerUnit?: Scalars['Float']
    lastPendingChange?: Scalars['Date']
    __typename: 'WarehouseOpeningBalanceOverviewResponse'
}

export interface WarehouseOpeningBalancesCsvResponse {
    url: Scalars['String']
    __typename: 'WarehouseOpeningBalancesCsvResponse'
}

export interface WarehouseOpeningBalancesCsvTemplateResponse {
    url: Scalars['String']
    __typename: 'WarehouseOpeningBalancesCsvTemplateResponse'
}

export type WarehouseOpeningBalanceSortField = 'PRODUCT_DISPLAY_NAME' | 'PRODUCT_SKU' | 'WAREHOUSE_NAME' | 'QUANTITY' | 'COST_PER_UNIT' | 'TOTAL_COST'

export interface WarehouseOpeningBalancesResponse {
    items: WarehouseOpeningBalanceItem[]
    __typename: 'WarehouseOpeningBalancesResponse'
}

export interface WarehouseResult {
    data: Warehouse[]
    __typename: 'WarehouseResult'
}

export interface WarehouseSalesData {
    warehouse: Warehouse
    salesChannels: SalesChannelSalesCogs[]
    deadInventory: DeadInventoryCogs
    giveaway: GiveawayCogs
    giveawayDropshipping: GiveawayCogs
    donation: DonationCogs
    lostAndFound: LostAndFoundCogs
    otherFba: OtherFbaCogs
    waste: WasteCogs
    supplierReturn: ProductUnitCogs
    salesAdjustments: ProductSalesDataAdjustments
    deadInventoryAdjustments: ProductDeadInventoryAdjustments
    giveawayAdjustments: ProductGiveawayAdjustments
    giveawayDropshippingAdjustments: ProductGiveawayAdjustments
    donationAdjustments: ProductDonationAdjustments
    lostAndFoundAdjustments: ProductLostAndFoundAdjustments
    otherFbaAdjustments: ProductOtherFbaAdjustments
    supplierReturnAdjustments: ProductUnitsAdjustments
    __typename: 'WarehouseSalesData'
}

export interface WarehousesDefaults {
    integrationType?: Scalars['String']
    integrationAccountName?: Scalars['String']
    integrationAccountId?: Scalars['String']
    warehouse: Warehouse
    startDate?: Scalars['Date']
    endDate?: Scalars['Date']
    __typename: 'WarehousesDefaults'
}

export interface WarehousesDefaultsError {
    errors?: Scalars['String'][]
    __typename: 'WarehousesDefaultsError'
}

export type WarehousesDefaultsResponse = (WarehousesDefaultsResult | WarehousesDefaultsError) & { __isUnion?: true }

export interface WarehousesDefaultsResult {
    companyId: Scalars['ID']
    defaults: WarehousesDefaults[]
    __typename: 'WarehousesDefaultsResult'
}

export type WarehouseSource = 'SHOPIFY' | 'USER_MANUAL' | 'AMAZON' | 'TRACKSTAR_FBA' | 'TIK_TOK'

export type WarehousesProductPurchasesBreakdownSortDirection = 'ASC' | 'DESC'

export type WarehousesProductPurchasesBreakdownSortField = 'DISPLAY_NAME' | 'RECEIVED_ON' | 'ASSEMBLED' | 'PURCHASED' | 'FULFILLED' | 'WAREHOUSE_TRANSFERS' | 'ADJUSTMENTS' | 'RESTOCKED' | 'ON_HAND' | 'LANDED_COST_PER_UNIT' | 'ON_HAND_COST' | 'UNAVAILABLE' | 'NET_DEPLETED'

export interface WarehouseTransfer {
    id: Scalars['ID']
    companyId: Scalars['ID']
    serialNumber: Scalars['Int']
    displayName: Scalars['String']
    transit?: WarehouseTransferTransit
    lineItems: WarehouseTransferLineItem[]
    costLineItems: WarehouseTransferCostLineItem[]
    attachments: WarehouseTransferAttachment[]
    status: WarehouseTransferStatus
    notes?: Scalars['String']
    deletedAt?: Scalars['Date']
    productsCost: Scalars['Float']
    transferCost: Scalars['Float']
    totalCost: Scalars['Float']
    isHistorical: Scalars['Boolean']
    inventoryPaymentGroupLinks: InventoryPaymentGroupLink[]
    unpaidAmounts: UnpaidAmountPerAffiliatedEntity[]
    __typename: 'WarehouseTransfer'
}

export interface WarehouseTransferArrival {
    date?: Scalars['Date']
    warehouse: Warehouse
    __typename: 'WarehouseTransferArrival'
}

export interface WarehouseTransferArrivalAction {
    quantity: Scalars['Float']
    id: Scalars['String']
    date: Scalars['Date']
    type: Scalars['String']
    warehouseTransfer: WarehouseTransfer
    __typename: 'WarehouseTransferArrivalAction'
}

export interface WarehouseTransferAttachment {
    filename: Scalars['String']
    url: Scalars['String']
    __typename: 'WarehouseTransferAttachment'
}

export interface WarehouseTransferBatchHistoryItem {
    action: WarehouseAction
    landedCost: Scalars['Float']
    __typename: 'WarehouseTransferBatchHistoryItem'
}

export interface WarehouseTransferBreakdownBatch {
    quantity: Scalars['Float']
    history: WarehouseTransferBatchHistoryItem[]
    __typename: 'WarehouseTransferBreakdownBatch'
}

export interface WarehouseTransferBreakdownItem {
    action: WarehouseAction
    quantity: Scalars['Float']
    landedCost: Scalars['Float']
    batches: WarehouseTransferBreakdownBatch[]
    __typename: 'WarehouseTransferBreakdownItem'
}

export interface WarehouseTransferCostAllocation {
    costLineItemId: Scalars['String']
    costPerUnit: Scalars['Float']
    lastUnitCost?: Scalars['Float']
    __typename: 'WarehouseTransferCostAllocation'
}

export interface WarehouseTransferCostLineItem {
    id: Scalars['String']
    type: WarehouseTransferCostLineItemType
    amount: Scalars['Float']
    vendor: Vendor
    isManuallyAllocated: Scalars['Boolean']
    __typename: 'WarehouseTransferCostLineItem'
}

export type WarehouseTransferCostLineItemType = 'SHIPPING' | 'GENERAL' | 'VENDOR_FEES' | 'SHIPPING_SURCHARGE'

export interface WarehouseTransferLineItem {
    id: Scalars['String']
    product: Product
    quantity: Scalars['Float']
    lineItemIdx: Scalars['Int']
    costAllocations: WarehouseTransferCostAllocation[]
    __typename: 'WarehouseTransferLineItem'
}

export interface WarehouseTransferLineItemFifoCost {
    directCost: Scalars['Float']
    indirectCosts: WarehouseTransferLineItemFifoIndirectCost[]
    __typename: 'WarehouseTransferLineItemFifoCost'
}

export interface WarehouseTransferLineItemFifoIndirectCost {
    type: IndirectLineItemType
    amount: Scalars['Float']
    __typename: 'WarehouseTransferLineItemFifoIndirectCost'
}

export interface WarehouseTransferOverviewItem {
    status: WarehouseTransferStatus
    count: Scalars['Int']
    totalCost: Scalars['Float']
    __typename: 'WarehouseTransferOverviewItem'
}

export interface WarehouseTransferShipping {
    date?: Scalars['Date']
    warehouse: Warehouse
    __typename: 'WarehouseTransferShipping'
}

export interface WarehouseTransferShippingAction {
    quantity: Scalars['Float']
    id: Scalars['String']
    date: Scalars['Date']
    type: Scalars['String']
    warehouseTransfer: WarehouseTransfer
    __typename: 'WarehouseTransferShippingAction'
}

export interface WarehouseTransfersOverview {
    items: WarehouseTransferOverviewItem[]
    __typename: 'WarehouseTransfersOverview'
}

export interface WarehouseTransfersResponse {
    warehouseTransfers: WarehouseTransfer[]
    hasNext: Scalars['Boolean']
    __typename: 'WarehouseTransfersResponse'
}

export type WarehouseTransfersSortDirection = 'ASC' | 'DESC'

export type WarehouseTransfersSortField = 'ARRIVAL_DATE' | 'SHIPPING_DATE' | 'ORIGIN_WAREHOUSE' | 'DESTINATION_WAREHOUSE' | 'STATUS' | 'ID' | 'COST' | 'PAID_STATUS'

export type WarehouseTransferStatus = 'DRAFT' | 'SCHEDULED' | 'IN_TRANSIT' | 'TRANSFERRED'

export interface WarehouseTransferTransit {
    shipping: WarehouseTransferShipping
    arrival?: WarehouseTransferArrival
    __typename: 'WarehouseTransferTransit'
}

export interface WarehouseTransferWithBreakdown {
    warehouseTransfer: WarehouseTransfer
    date: Scalars['Date']
    items: WarehouseTransferBreakdownItem[]
    __typename: 'WarehouseTransferWithBreakdown'
}

export interface WasteAction {
    quantity: Scalars['Float']
    id: Scalars['String']
    date: Scalars['Date']
    type: Scalars['String']
    __typename: 'WasteAction'
}

export interface WasteCogs {
    amount: Scalars['Float']
    quantity: Scalars['Float']
    monthlyBreakdown: WasteMonthlyBreakdown[]
    __typename: 'WasteCogs'
}

export interface WasteDailyBreakdown {
    date: Scalars['Date']
    quantity: Scalars['Float']
    __typename: 'WasteDailyBreakdown'
}

export interface WasteMonthlyBreakdown {
    date: Scalars['Date']
    quantity: Scalars['Float']
    dailyData: WasteDailyBreakdown[]
    __typename: 'WasteMonthlyBreakdown'
}

export interface Worksheet {
    worksheetRows: WorksheetRow[]
    __typename: 'Worksheet'
}

export interface WorksheetRow {
    companyId: Scalars['String']
    dateForLocking?: Scalars['Date']
    name: Scalars['String']
    amount: Scalars['Float']
    signedAmount?: Scalars['Float']
    comment?: Scalars['String']
    signedAt?: Scalars['Date']
    signedBy?: Scalars['String']
    signedByName?: Scalars['String']
    attachmentUrl?: Scalars['String']
    attachmentFileName?: Scalars['String']
    lockableEntity?: CompanyWorksheetRowLockableEntity
    periodStart: Scalars['Date']
    periodEnd: Scalars['Date']
    isPnl?: Scalars['Boolean']
    __typename: 'WorksheetRow'
}

export interface YearEndDependencies {
    companyId: Scalars['ID']
    balanceSheet?: BalanceSheetDependency
    yearEnd?: YearEndDependency[]
    __typename: 'YearEndDependencies'
}

export interface YearEndDependency {
    blocked: Scalars['Boolean']
    year: Scalars['Int']
    resolvedAt?: Scalars['Date']
    __typename: 'YearEndDependency'
}

export type YearEndDomainMode = 'ENABLED' | 'DISABLED'

export interface YearEndDomainsStates {
    banks?: YearEndDomainStateResponse
    transactions?: YearEndDomainStateResponse
    unclassified_transactions?: YearEndDomainStateResponse
    unmatched_payouts_and_transfers?: YearEndDomainStateResponse
    payments?: YearEndDomainStateResponse
    inventory?: YearEndDomainStateResponse
    loans?: YearEndDomainStateResponse
    equity?: YearEndDomainStateResponse
    payroll?: YearEndDomainStateResponse
    sales_tax?: YearEndDomainStateResponse
    investments?: YearEndDomainStateResponse
    security_deposits?: YearEndDomainStateResponse
    accounting_and_tax_information?: YearEndDomainStateResponse
    orders?: YearEndDomainStateResponse
    invoices?: YearEndDomainStateResponse
    bills?: YearEndDomainStateResponse
    __typename: 'YearEndDomainsStates'
}

export type YearEndDomainState = 'INACTIVE' | 'OPEN' | 'IN_PROGRESS' | 'CLOSED'

export interface YearEndDomainStateChangeLog {
    id: Scalars['ID']
    createdAt: Scalars['Date']
    updaterType: YearEndStateUpdaterType
    changedByUid?: Scalars['String']
    reason?: Scalars['String']
    oldValue: YearEndDomainState
    newValue: YearEndDomainState
    __typename: 'YearEndDomainStateChangeLog'
}

export interface YearEndDomainStateDataChangeLog {
    id: Scalars['ID']
    createdAt: Scalars['Date']
    updaterType: YearEndStateUpdaterType
    changedByUid?: Scalars['String']
    reason?: Scalars['String']
    oldValue: Scalars['JSONObject']
    newValue: Scalars['JSONObject']
    __typename: 'YearEndDomainStateDataChangeLog'
}

export interface YearEndDomainStateDataDeleteResponse {
    deletedAt: Scalars['Date']
    __typename: 'YearEndDomainStateDataDeleteResponse'
}

export interface YearEndDomainStateDataResponse {
    id: Scalars['ID']
    dataKey: Scalars['String']
    data: Scalars['JSONObject']
    history?: YearEndDomainStateDataChangeLog[]
    __typename: 'YearEndDomainStateDataResponse'
}

export interface YearEndDomainStateDataUpdateResponse {
    id: Scalars['ID']
    data: Scalars['JSONObject']
    dataKey: Scalars['String']
    historyLog?: YearEndDomainStateDataChangeLog
    __typename: 'YearEndDomainStateDataUpdateResponse'
}

export type YearEndDomainStateErrors = 'COMPANY_YEAR_END_DOMAIN_STATE_NOT_FOUND' | 'INVALID_YEAR_END_DOMAIN_STATE_CHANGE' | 'INVALID_YEAR_END_DOMAIN_DATA_CHANGE' | 'YEAR_END_STATE_BLOCKED_FOR_CHANGES'

export interface YearEndDomainStateResponse {
    state: YearEndDomainState
    canSubmit: Scalars['Boolean']
    history?: YearEndDomainStateChangeLog[]
    __typename: 'YearEndDomainStateResponse'
}

export interface YearEndDomainStateUpdateResponse {
    state: YearEndDomainState
    canSubmit?: Scalars['Boolean']
    historyLog?: YearEndDomainStateChangeLog
    __typename: 'YearEndDomainStateUpdateResponse'
}

export type YearEndDomainTypes = 'BANKS' | 'TRANSACTIONS' | 'UNCLASSIFIED_TRANSACTIONS' | 'UNMATCHED_PAYOUTS_AND_TRANSFERS' | 'PAYMENTS' | 'INVENTORY' | 'LOANS' | 'EQUITY' | 'PAYROLL' | 'SALES_TAX' | 'INVESTMENTS' | 'SECURITY_DEPOSITS' | 'ACCOUNTING_AND_TAX_INFORMATION' | 'ORDERS' | 'INVOICES' | 'BILLS'

export interface YearEndDomainUpToDateState {
    companyId: Scalars['ID']
    state: YearEndDomainState
    isEnabled: Scalars['Boolean']
    __typename: 'YearEndDomainUpToDateState'
}

export interface YearEndDomainUpToDateStates {
    companyId: Scalars['ID']
    banks?: YearEndDomainUpToDateState
    unclassifiedTransactions?: YearEndDomainUpToDateState
    unmatchedPayoutsAndTransfers?: YearEndDomainUpToDateState
    transactions?: YearEndDomainUpToDateState
    /** @deprecated It is going to be removed soon to keep consistency with mapped domain type name with camel case. Use unclassifiedTransactions instead  */
    unclassified_transactions?: YearEndDomainUpToDateState
    /** @deprecated It is going to be removed soon to keep consistency with mapped domain type name with camel case. Use unmatchedPayoutsAndTransfers instead  */
    unmatched_payouts_and_transfers?: YearEndDomainUpToDateState
    bills?: YearEndDomainUpToDateState
    inventory?: YearEndDomainUpToDateState
    loans?: YearEndDomainUpToDateState
    orders?: YearEndDomainUpToDateState
    paymentsMissions?: YearEndDomainUpToDateState
    invoices?: YearEndDomainUpToDateState
    accountingAndTaxInformation?: YearEndDomainUpToDateState
    payroll?: YearEndDomainUpToDateState
    salesTax?: YearEndDomainUpToDateState
    securityDeposits?: YearEndDomainUpToDateState
    investments?: YearEndDomainUpToDateState
    equity?: YearEndDomainUpToDateState
    __typename: 'YearEndDomainUpToDateStates'
}

export interface YearEndEmail {
    yearEndStateId: Scalars['String']
    value?: Scalars['String']
    history?: YearEndEmailChangeLog[]
    __typename: 'YearEndEmail'
}

export interface YearEndEmailChangeLog {
    id: Scalars['ID']
    createdAt: Scalars['Date']
    updaterType: YearEndStateUpdaterType
    changedByUid?: Scalars['String']
    reason?: Scalars['String']
    oldValue?: Scalars['String']
    newValue?: Scalars['String']
    __typename: 'YearEndEmailChangeLog'
}

export interface YearEndIntercomLink {
    yearEndStateId: Scalars['String']
    value?: Scalars['String']
    history?: YearEndIntercomLinkChangeLog[]
    __typename: 'YearEndIntercomLink'
}

export interface YearEndIntercomLinkChangeLog {
    id: Scalars['ID']
    createdAt: Scalars['Date']
    updaterType: YearEndStateUpdaterType
    changedByUid?: Scalars['String']
    reason?: Scalars['String']
    oldValue?: Scalars['String']
    newValue?: Scalars['String']
    __typename: 'YearEndIntercomLinkChangeLog'
}

export type YearEndInventoryMission = (PurchaseBasedClosingBalance | PurchaseBasedOpeningBalance | PurchaseBasedPurchases | SalesBasedClosingBalance | SalesBasedMissingCostPerUnit | SalesBasedOpeningBalance | SalesBasedPurchases | SalesBasedReportCogs | UnitBasedClosingBalance | UnitBasedNegativeOnHands | UnitBasedReportCogs | UnitBasedVendorsNegativeBalance) & { __isUnion?: true }

export type YearEndState = 'INACTIVE' | 'NA' | 'OPEN' | 'INITIAL_PROCESSING' | 'AWAITING_USER_FEEDBACK' | 'FOLLOW_UP_PROCESSING' | 'CLOSED'

export interface YearEndStateAdditionalData {
    companyId: Scalars['ID']
    accountingMethod?: Scalars['String']
    legalEntityType: Scalars['String']
    taxEntityType: Scalars['String']
    entityTypeDescription: Scalars['String']
    fiscalYearEndDate: Scalars['Date']
    fiscalYearStartDate: Scalars['Date']
    finaloopDeadline: Scalars['Date']
    finaloopLastCall: Scalars['Date']
    filingDeadline: Scalars['Date']
    extensionFiled: Scalars['Boolean']
    daysFromFiscalEndDateToFilingDeadline?: Scalars['Int']
    salesTaxLiabilityOpeningBalance?: Scalars['Float']
    salesTaxLiabilityClosingBalance?: Scalars['Float']
    netSalesTaxCollected?: Scalars['Float']
    salesTaxPaymentToAuthorities?: Scalars['Float']
    securityDepositsClosingBalance?: Scalars['Float']
    investmentsGeneralClosingBalance?: Scalars['Float']
    payroll?: PayrollData
    __typename: 'YearEndStateAdditionalData'
}

export interface YearEndStateChangeLog {
    id: Scalars['ID']
    createdAt: Scalars['Date']
    updaterType: YearEndStateUpdaterType
    changedByUid?: Scalars['String']
    reason?: Scalars['String']
    oldValue: YearEndState
    newValue: YearEndState
    __typename: 'YearEndStateChangeLog'
}

export type YearEndStateErrors = 'COMPANY_NOT_FOUND' | 'COMPANY_YEAR_END_STATE_NOT_FOUND' | 'INVALID_YEAR_END_STATE_CHANGE' | 'COMPANY_HAS_ANOTHER_YEAR_END_UNDER_REVIEW'

export interface YearEndStateResponse {
    id: Scalars['ID']
    companyId: Scalars['String']
    state: YearEndState
    year: Scalars['Int']
    domainsStates: YearEndDomainsStates
    domainsUpToDateStates: YearEndDomainUpToDateStates
    additionalData: YearEndStateAdditionalData
    history?: YearEndStateChangeLog[]
    isQualified?: Scalars['Boolean']
    /** @deprecated UserUnresponsive.value instead */
    isUserUnresponsive: Scalars['Boolean']
    email: YearEndEmail
    intercomLink: YearEndIntercomLink
    userUnresponsive: YearEndUserUnresponsive
    dependencies: YearEndDependencies
    isUnderReview: Scalars['Boolean']
    __typename: 'YearEndStateResponse'
}

export interface YearEndStateUpdateResponse {
    state: YearEndState
    __typename: 'YearEndStateUpdateResponse'
}

export type YearEndStateUpdaterType = 'USER' | 'SYSTEM' | 'OPS'

export interface YearEndUpdateAdditionalFieldsResponse {
    userUnresponsiveResponse?: YearEndUpdateUserUnresponsiveResponse
    emailResponse?: YearEndUpdateEmailResponse
    intercomLinkResponse?: YearEndUpdateIntercomLinkResponse
    __typename: 'YearEndUpdateAdditionalFieldsResponse'
}

export interface YearEndUpdateEmailResponse {
    email?: Scalars['String']
    historyLog: YearEndEmailChangeLog
    __typename: 'YearEndUpdateEmailResponse'
}

export interface YearEndUpdateIntercomLinkResponse {
    intercomLink?: Scalars['String']
    historyLog: YearEndEmailChangeLog
    __typename: 'YearEndUpdateIntercomLinkResponse'
}

export interface YearEndUpdateUserUnresponsiveResponse {
    isUserUnresponsive: Scalars['Boolean']
    historyLog: YearEndUserUnresponsiveChangeLog
    __typename: 'YearEndUpdateUserUnresponsiveResponse'
}

export interface YearEndUserUnresponsive {
    yearEndStateId: Scalars['String']
    value: Scalars['Boolean']
    history?: YearEndUserUnresponsiveChangeLog[]
    __typename: 'YearEndUserUnresponsive'
}

export interface YearEndUserUnresponsiveChangeLog {
    id: Scalars['ID']
    createdAt: Scalars['Date']
    updaterType: YearEndStateUpdaterType
    changedByUid?: Scalars['String']
    reason?: Scalars['String']
    oldValue: Scalars['Boolean']
    newValue: Scalars['Boolean']
    __typename: 'YearEndUserUnresponsiveChangeLog'
}

export interface AcceptedInviteCompanyInfoGenqlSelection{
    id?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AcceptInvitationArgs {invitationCode: Scalars['String']}

export interface AcceptInvitationResponseGenqlSelection{
    userInvitation?: UserInvitationGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AccountBalanceGenqlSelection{
    accountRole?: boolean | number
    balance?: boolean | number
    asOfDate?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AccountingInfoGenqlSelection{
    isSalesAffecting?: boolean | number
    isCogsAffecting?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AccountRoleGenqlSelection{
    name?: boolean | number
    groupId?: boolean | number
    isClearingAccount?: boolean | number
    reportsHierarchy?: ReportHierarchyNodeGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AccountValidationGenqlSelection{
    openingBalanceValue?: boolean | number
    lastValidAt?: boolean | number
    updatedAt?: boolean | number
    accountState?: boolean | number
    potentialOpeningValue?: boolean | number
    status?: boolean | number
    madePrivateAt?: boolean | number
    accountBalanceDiffValue?: boolean | number
    lastMetricCreatedAt?: boolean | number
    lastMetricEventTime?: boolean | number
    companyIntegrationLastSuccessfulUpdate?: boolean | number
    reason?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AccrualGenqlSelection{
    id?: boolean | number
    accrualsData?: AccrualDataGenqlSelection
    bankTransactionId?: boolean | number
    companyId?: boolean | number
    createdAt?: boolean | number
    updatedAt?: boolean | number
    archivedAt?: boolean | number
    createdBy?: boolean | number
    createdById?: boolean | number
    latestActorType?: boolean | number
    latestActorId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AccrualCategorizationInput {bankTransactionId: Scalars['ID'],merchant?: (MerchantInput | null),classifications?: (AccrualClassificationInput[] | null),recommendations?: (ClassificationRecommendationsInput | null)}

export interface AccrualClassificationInput {amount: Scalars['Float'],amountInPercentage?: (Scalars['Float'] | null),amountInHomeCurrency?: (Scalars['Float'] | null),affiliatedEntityId?: (Scalars['ID'] | null),classificationTagId?: (Scalars['ID'] | null),classificationText?: (Scalars['ID'] | null),businessEvent?: (Scalars['String'] | null),pairedEntityId?: (Scalars['String'] | null),pairedEntityType?: (PairedEntityType | null),pairingType?: (PairingType | null),askTheUserResult?: (Scalars['JSONObject'] | null),extraData?: (Scalars['JSONObject'] | null),description?: (Scalars['String'] | null)}

export interface AccrualDataGenqlSelection{
    classificationTagId?: boolean | number
    businessEventType?: boolean | number
    spreadType?: boolean | number
    residualAmount?: boolean | number
    specificDate?: SpecificDateGenqlSelection
    spreadOverTime?: SpreadOverTimeGenqlSelection
    customSpread?: CustomSpreadGenqlSelection
    customSpreadOptions?: CustomSpreadOptionsGenqlSelection
    defaultFixedAssetsData?: DefaultFixedAssetsDataGenqlSelection
    customFixedAssetsData?: CustomFixedAssetsDataGenqlSelection
    canceledAt?: boolean | number
    canceledBy?: boolean | number
    canceledAccrualsData?: CanceledAccrualDataGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AccrualDataInput {classificationTagId?: (Scalars['String'] | null),businessEventType: Scalars['String'],spreadType: SpreadType,specificDate?: (SpecificDateInput | null),spreadOverTime?: (SpreadOverTimeInput | null),customSpread?: (CustomSpreadInput[] | null),customSpreadOptions?: (CustomSpreadOptionsInput | null),defaultFixedAssetsData?: (DefaultFixedAssetsDataInput | null),customFixedAssetsData?: (CustomFixedAssetsDataInput | null)}

export interface AccrualEntityGenqlSelection{
    on_BankTransaction?:BankTransactionGenqlSelection,
    on_Bill?:BillGenqlSelection,
    __typename?: boolean | number
}

export interface AccrualRecordResponseGenqlSelection{
    spreadItems?: AccrualRecordSpreadItemGenqlSelection
    totalAmount?: boolean | number
    amountAsOfDate?: boolean | number
    businessEventType?: boolean | number
    entity?: AccrualEntityGenqlSelection
    source?: boolean | number
    startDate?: boolean | number
    endDate?: boolean | number
    category?: boolean | number
    depreciationMethod?: boolean | number
    depreciationType?: boolean | number
    depreciationPeriod?: boolean | number
    vendor?: boolean | number
    entityDate?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AccrualRecordSpreadItemGenqlSelection{
    date?: boolean | number
    amount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AccrualsSpreadGenqlSelection{
    id?: boolean | number
    amount?: boolean | number
    postedAt?: boolean | number
    endDate?: boolean | number
    classificationTag?: ClassificationTagGenqlSelection
    businessEventType?: boolean | number
    isRemainingExpenses?: boolean | number
    isResidualAmount?: boolean | number
    fixedAssetsOptions?: FixedAssetsOptionsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AccrualsSpreadResponseGenqlSelection{
    amount?: boolean | number
    postedAt?: boolean | number
    endDate?: boolean | number
    classificationTag?: ClassificationTagGenqlSelection
    bankTransaction?: BankTransactionGenqlSelection
    businessEventType?: boolean | number
    id?: boolean | number
    companyId?: boolean | number
    accrualId?: boolean | number
    bankTransactionId?: boolean | number
    isRemainingExpenses?: boolean | number
    isResidualAmount?: boolean | number
    fixedAssetsOptions?: FixedAssetsOptionsGenqlSelection
    spreadBasisType?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AccrualV2GenqlSelection{
    id?: boolean | number
    accrualsData?: AccrualDataGenqlSelection
    entity?: AccrualEntityGenqlSelection
    entityType?: boolean | number
    entityId?: boolean | number
    companyId?: boolean | number
    createdAt?: boolean | number
    updatedAt?: boolean | number
    archivedAt?: boolean | number
    createdBy?: boolean | number
    createdById?: boolean | number
    latestActorType?: boolean | number
    latestActorId?: boolean | number
    spreads?: AccrualsSpreadGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AckInvalidNoUnitsValidationInput {companyId: Scalars['ID'],startDate: Scalars['Date'],endDate: Scalars['Date'],quantityDiff: Scalars['Float'],costDiff: Scalars['Float'],businessEventsCostDiff: Scalars['Float']}

export interface AcknowledgeLoansChangesGenqlSelection{
    loans?: LoanGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AcknowledgeLoansChangesInput {loans: Scalars['ID'][]}

export interface AcknowledgeUnitsTrackingPhysicalCountProductQuantitiesAmountsInput {companyId: Scalars['String'],physicalCountId: Scalars['String']}

export interface ActionChangeGenqlSelection{
    accountRole?: boolean | number
    accountRoleV2?: AccountRoleGenqlSelection
    moneyDirection?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ActionChangeInput {accountRole: Scalars['String'],moneyDirection: ActionChangeMoneyDirection}

export interface ActorContextInput {actorType: ActorType,actorId: Scalars['String'],classifiedAt: Scalars['Date'],metadata?: (Scalars['JSONObject'] | null)}

export interface AdGenqlSelection{
    id?: boolean | number
    companyId?: boolean | number
    name?: boolean | number
    status?: boolean | number
    insights?: AdInsightsByDateGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AdAccountGenqlSelection{
    id?: boolean | number
    companyId?: boolean | number
    externalId?: boolean | number
    adPlatform?: boolean | number
    adBusinessId?: boolean | number
    updatedAt?: boolean | number
    name?: boolean | number
    status?: boolean | number
    paymentMethod?: boolean | number
    timezoneOffset?: boolean | number
    rollingBalance?: boolean | number
    currency?: boolean | number
    minDailyBudget?: boolean | number
    adCampaigns?: AdCampaignGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AdAccountInput {companyId: Scalars['ID'],page: Scalars['Int'],status?: (Scalars['String'] | null),platform?: (Platform | null)}

export interface AdCampaignGenqlSelection{
    id?: boolean | number
    name?: boolean | number
    status?: boolean | number
    endTime?: boolean | number
    companyId?: boolean | number
    startTime?: boolean | number
    adAccount?: AdAccountGenqlSelection
    dailyBudget?: boolean | number
    lifetimeBudget?: boolean | number
    remainingBudget?: boolean | number
    clicks?: boolean | number
    impressions?: boolean | number
    reach?: boolean | number
    spend?: boolean | number
    adSets?: AdSetGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AdCampaignInput {companyId: Scalars['ID'],page: Scalars['Int'],status?: (Scalars['String'] | null),platform?: (Platform | null),dateFrom?: (Scalars['Date'] | null),dateTo?: (Scalars['Date'] | null)}

export interface AddBankTransactionAttachmentInput {companyId: Scalars['ID'],bankTransactionId: Scalars['ID'],attachmentLink: Scalars['String'],attachmentName: Scalars['String']}

export interface AddClassificationTagInput {name: Scalars['String'],moneyDirection: MoneyDirection,isHidden: Scalars['Boolean'],isRelevantToBills: Scalars['Boolean'],isRelevantToApplyAlways: Scalars['Boolean'],displayNameForReports?: (Scalars['String'] | null),keywords?: (Scalars['String'][] | null),moneyInBusinessEvent?: (Scalars['ID'] | null),moneyOutBusinessEvent?: (Scalars['ID'] | null),isApplicableForRefund: Scalars['Boolean'],reportsDisplayNameForTagSelection?: (Scalars['String'] | null)}

export interface AddCompanyToParkerUserArgs {companyId: Scalars['String'],companyName?: (Scalars['String'] | null)}

export interface AddDepreciationBonusGenqlSelection{
    date?: boolean | number
    percent?: boolean | number
    amount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AddDepreciationBonusInput {date: Scalars['String'],percent: Scalars['Float'],amount: Scalars['Float']}

export interface AdditionalErrorInfoGenqlSelection{
    expectedValue?: boolean | number
    actualValue?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AddMissingBillsTaskGenqlSelection{
    id?: boolean | number
    status?: boolean | number
    stateKey?: boolean | number
    state?: AddMissingBillsTaskStateGenqlSelection
    history?: AddMissingBillsTaskStateChangeLogGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AddMissingBillsTaskStateGenqlSelection{
    markedAsCompletedAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AddMissingBillsTaskStateChangeLogGenqlSelection{
    id?: boolean | number
    createdAt?: boolean | number
    updaterType?: boolean | number
    changedByUid?: boolean | number
    reason?: boolean | number
    oldValue?: AddMissingBillsTaskStateGenqlSelection
    newValue?: AddMissingBillsTaskStateGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AddMissingInvoicesTaskGenqlSelection{
    id?: boolean | number
    status?: boolean | number
    stateKey?: boolean | number
    state?: AddMissingInvoicesTaskStateGenqlSelection
    history?: AddMissingInvoicesTaskStateChangeLogGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AddMissingInvoicesTaskStateGenqlSelection{
    markedAsCompletedAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AddMissingInvoicesTaskStateChangeLogGenqlSelection{
    id?: boolean | number
    createdAt?: boolean | number
    updaterType?: boolean | number
    changedByUid?: boolean | number
    reason?: boolean | number
    oldValue?: AddMissingInvoicesTaskStateGenqlSelection
    newValue?: AddMissingInvoicesTaskStateGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AddPriorYearAdjustmentInput {amount?: (Scalars['Float'] | null)}

export interface AddressGenqlSelection{
    country?: boolean | number
    state?: boolean | number
    city?: boolean | number
    postalCode?: boolean | number
    line1?: boolean | number
    line2?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AddressArgs {country?: (Scalars['String'] | null),state?: (Scalars['String'] | null),city?: (Scalars['String'] | null),postalCode?: (Scalars['String'] | null),line1?: (Scalars['String'] | null),line2?: (Scalars['String'] | null)}

export interface AddRoleToAffiliatedEntityInput {companyId: Scalars['ID'],sourceEntityOneOf: AffiliateSourceInput,role: CompanyAffiliateType,metadata: AddRoleToAffiliatedEntityMetadataInput}

export interface AddRoleToAffiliatedEntityMetadataInput {creatorEmail?: (Scalars['String'] | null),source: Scalars['String']}

export interface AddRoleToAffiliatedEntityResultGenqlSelection{
    createdEntityId?: boolean | number
    affiliatedEntity?: AffiliatedEntityGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AdInsightGenqlSelection{
    adId?: boolean | number
    companyId?: boolean | number
    date?: boolean | number
    country?: boolean | number
    region?: boolean | number
    impressions?: boolean | number
    spend?: boolean | number
    clicks?: boolean | number
    cpm?: boolean | number
    ctr?: boolean | number
    cpc?: boolean | number
    reach?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AdInsightsByDateGenqlSelection{
    date?: boolean | number
    metrics?: AdInsightGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AdjustmentRestockingActionGenqlSelection{
    quantity?: boolean | number
    id?: boolean | number
    date?: boolean | number
    type?: boolean | number
    salesChannel?: WarehouseActionSalesChannelGenqlSelection
    sku?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AdjustmentsReasonGenqlSelection{
    code?: boolean | number
    quantity?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AdjustmentsValidationGenqlSelection{
    adjustments?: QuantityAndCostGenqlSelection
    cogs?: QuantityAndCostGenqlSelection
    source?: QuantityAndCostGenqlSelection
    diff?: QuantityAndCostGenqlSelection
    isValid?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AdSetGenqlSelection{
    id?: boolean | number
    companyId?: boolean | number
    name?: boolean | number
    status?: boolean | number
    startTime?: boolean | number
    endTime?: boolean | number
    adAccount?: AdAccountGenqlSelection
    adCampaign?: AdCampaignGenqlSelection
    dailyBudget?: boolean | number
    lifetimeBudget?: boolean | number
    remainingBudget?: boolean | number
    impressions?: boolean | number
    spend?: boolean | number
    clicks?: boolean | number
    cpm?: boolean | number
    ctr?: boolean | number
    cpc?: boolean | number
    frequency?: boolean | number
    reach?: boolean | number
    conversions?: boolean | number
    ads?: AdGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AdSetInput {companyId: Scalars['ID'],page: Scalars['Int'],status?: (Scalars['String'] | null),platform?: (Platform | null),dateFrom?: (Scalars['Date'] | null),dateTo?: (Scalars['Date'] | null),country?: (Scalars['String'] | null),region?: (Scalars['String'] | null)}

export interface AffectedTransactionsIdsGenqlSelection{
    transactionsIds?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AffiliatedEntityGenqlSelection{
    id?: boolean | number
    company?: CompanyGenqlSelection
    institutions?: InstitutionGenqlSelection
    name?: boolean | number
    companyAffiliates?: CompanyAffiliateGenqlSelection
    holders?: HolderGenqlSelection
    safeHolders?: SafeHolderGenqlSelection
    relatedParties?: RelatedPartyGenqlSelection
    unpaidInventoryAmount?: boolean | number
    lenders?: NewLenderGenqlSelection
    employees?: EmployeeGenqlSelection
    contractors?: ContractorGenqlSelection
    vendors?: VendorGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AffiliatedEntityByIdInput {id: Scalars['ID'],companyId: Scalars['ID']}

export interface AffiliatedEntityByIdsInput {ids: Scalars['ID'][],companyId: Scalars['ID']}

export interface AffiliateSourceInput {affiliatedEntityId?: (Scalars['ID'] | null),companyAffiliateId?: (Scalars['ID'] | null),vendorId?: (Scalars['ID'] | null),institutionId?: (Scalars['ID'] | null)}

export interface AgingAggregationItemGenqlSelection{
    preset?: boolean | number
    balance?: boolean | number
    count?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AllSkusInput {companyId: Scalars['ID'],fromDate: Scalars['Date'],toDate: Scalars['Date'],breakdown: Scalars['String'],timezone: Scalars['String'],comparisonPeriod: Scalars['String'],stores?: ((Scalars['String'] | null)[] | null),sources?: (SourceTypes[] | null),salesChannels?: ((Scalars['String'] | null)[] | null),searchText?: (Scalars['String'] | null),limit?: (Scalars['Int'] | null),offset?: (Scalars['Int'] | null),sortBy?: (AllSkusSortBy | null)}

export interface AllSkusResponseGenqlSelection{
    title?: boolean | number
    updatedAt?: boolean | number
    data?: SkuDataGenqlSelection
    sources?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AllSkusSortBy {field: AllSkusSortField,direction: SortDirection}

export interface AlterBankTransactionsLifecycleStateInput {companyId: Scalars['ID'],bankTransactionIds: Scalars['ID'][],actorType: ActorType,actorId: Scalars['String']}

export interface AlterBankTransactionsLifecycleStateResultGenqlSelection{
    processedIds?: boolean | number
    unprocessed?: AlterBankTransactionsLifecycleStateUnprocessedResultGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AlterBankTransactionsLifecycleStateUnprocessedResultGenqlSelection{
    id?: boolean | number
    reason?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AmazonAvailableMarketplaceGenqlSelection{
    displayName?: boolean | number
    integrationAccountId?: boolean | number
    integrationAccountName?: boolean | number
    marketplaceId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AmazonAvailableValidationDataInput {companyId: Scalars['ID']}

export interface AmazonAvailableValidationDataResponseGenqlSelection{
    integrationAccountIdsData?: AmazonIntegrationAccountIdAvailableDataGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AmazonIntegrationAccountIdAvailableDataGenqlSelection{
    availableMarketplaces?: AmazonAvailableMarketplaceGenqlSelection
    shipmentsReportEndTime?: boolean | number
    returnsReportEndTime?: boolean | number
    integrationAccountId?: boolean | number
    impactOnBooksSince?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AmazonOrdersDiffResponseGenqlSelection{
    data?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AmazonProductGenqlSelection{
    id?: boolean | number
    companyId?: boolean | number
    finaloopId?: boolean | number
    lineOfBusinessId?: boolean | number
    sku?: boolean | number
    price?: boolean | number
    displayName?: boolean | number
    imageUrl?: boolean | number
    listedChannels?: SalesChannelGenqlSelection
    appliedCosts?: ProductAppliedCostGenqlSelection
    dailySalesData?: (SalesChannelDailySalesDataGenqlSelection & { __args: {timeRange: ProductDataTimeRangeInput} })
    totalSold?: boolean | number
    avgCostPerUnit?: boolean | number
    asin?: boolean | number
    canEditLatestAppliedCost?: boolean | number
    isFractional?: boolean | number
    isHidden?: boolean | number
    salesData?: (SalesDataGenqlSelection & { __args: {timeRange: ProductDataTimeRangeInput} })
    rawRecipes?: (RecipeGenqlSelection & { __args: {timeRange: ProductDataTimeRangeInput} })
    componentOfProducts?: ProductGenqlSelection
    isAmbiguousSku?: boolean | number
    analyticsOverview?: (ProductAnalyticsOverviewGenqlSelection & { __args?: {input?: (AnalyticsOverviewInput | null)} })
    warehousesAnalyticsOverview?: (ProductWarehousesAnalyticsOverviewGenqlSelection & { __args?: {input?: (AnalyticsOverviewInput | null)} })
    tags?: boolean | number
    isCreatedManually?: boolean | number
    isDataSyncing?: boolean | number
    mergeHistory?: ProductMergeHistoryItemGenqlSelection
    isDropshipping?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AmazonProductsReconciliationResponseGenqlSelection{
    validationId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AmazonProductsValidationReadyResponseGenqlSelection{
    checkStartTime?: boolean | number
    checkEndTime?: boolean | number
    data?: AmazonSkuReconciliationDataGenqlSelection
    summary?: AmazonReconciliationSummaryGenqlSelection
    isTrackstarConnected?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AmazonReconciliationAdjustmentsDataGenqlSelection{
    onlyAdjustments?: boolean | number
    adjustments?: boolean | number
    sourceAdjustments?: boolean | number
    adjustmentsDiff?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AmazonReconciliationEntityDataGenqlSelection{
    restocked?: boolean | number
    mfn?: boolean | number
    afn?: boolean | number
    totalSold?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AmazonReconciliationEntityEntityValidationStatusGenqlSelection{
    restockedDiff?: boolean | number
    afnDiff?: boolean | number
    mfnDiff?: boolean | number
    mcfDiff?: boolean | number
    reportDiff?: boolean | number
    totalDiff?: boolean | number
    adjustmentsDiff?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AmazonReconciliationProductDataGenqlSelection{
    unitsSold?: boolean | number
    unitsRestocked?: boolean | number
    unitsGiveaway?: boolean | number
    ambiguousSkuQuantity?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AmazonReconciliationProductValidationStatusGenqlSelection{
    soldDiff?: boolean | number
    restockedDiff?: boolean | number
    totalDiff?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AmazonReconciliationRestockedReportDataGenqlSelection{
    mcf?: boolean | number
    afn?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AmazonReconciliationSalesOrderIdsGenqlSelection{
    recentInvoices?: boolean | number
    oldInvoices?: boolean | number
    notInTimeRange?: boolean | number
    mfn?: boolean | number
    afn?: boolean | number
    all?: boolean | number
    restocked?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AmazonReconciliationSalesReportDataGenqlSelection{
    recentInvoices?: boolean | number
    oldInvoices?: boolean | number
    notInTimeRange?: boolean | number
    mcf?: boolean | number
    afn?: boolean | number
    total?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AmazonReconciliationSummaryGenqlSelection{
    entityData?: AmazonReconciliationEntityDataGenqlSelection
    entityValidationStatus?: AmazonReconciliationEntityEntityValidationStatusGenqlSelection
    salesReportData?: AmazonReconciliationSalesReportDataGenqlSelection
    restocksReportData?: AmazonReconciliationRestockedReportDataGenqlSelection
    productData?: AmazonReconciliationProductDataGenqlSelection
    productValidationStatus?: AmazonReconciliationProductValidationStatusGenqlSelection
    adjustmentsData?: AmazonReconciliationAdjustmentsDataGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AmazonSkuReconciliationDataGenqlSelection{
    comments?: boolean | number
    sku?: boolean | number
    orderIds?: AmazonReconciliationSalesOrderIdsGenqlSelection
    summary?: AmazonReconciliationSummaryGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AmazonValidationAdjustSkuQuantitiesInput {companyId: Scalars['String'],integrationAccountId: Scalars['String'],marketplaceId: Scalars['String'],sku: Scalars['String'],reportQuantity?: (Scalars['Int'] | null),finaloopQuantity?: (Scalars['Int'] | null),orderId: Scalars['String']}

export interface AmazonValidationInput {startTime: Scalars['Date'],endTime: Scalars['Date'],integrationAccountId: Scalars['String'],integrationAccountName: Scalars['String'],companyId: Scalars['ID'],marketplaceId: Scalars['String'],ignoreCached?: (Scalars['Boolean'] | null)}

export interface AmountRange {from: Scalars['Float'],to: Scalars['Float']}

export interface AmountRangeInput {from: Scalars['Float'],to: Scalars['Float']}

export interface AmountsGenqlSelection{
    amount?: boolean | number
    amountInHomeCurrency?: boolean | number
    currency?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AnalyticsEventDedupKey {key: Scalars['String'],ttlSeconds?: (Scalars['Int'] | null)}

export interface AnalyticsEventsData {name: Scalars['String'],data: Scalars['JSON'],dedupKey?: (AnalyticsEventDedupKey | null)}

export interface AnalyticsOverviewInput {asOfDate: Scalars['Date']}

export interface AnyActiveProductWithoutQuantitiesGenqlSelection{
    anyActiveProductWithoutQuantities?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface APAccountBalanceGenqlSelection{
    accountRole?: boolean | number
    balance?: boolean | number
    asOfDate?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AppendProcessingLogToBankTransactionsUploadInput {companyId: Scalars['ID'],bankTransactionsUploadId: Scalars['String'],originFileId?: (Scalars['String'] | null),processingLog: BankTransactionsUploadProcessingLogInput,status: BankTransactionsUploadStatus}

export interface ApplyInventoryPurchaseRulesInput {companyId: Scalars['ID'],operations: ApplyInventoryPurchaseRulesOperation[]}

export interface ApplyInventoryPurchaseRulesOperation {id?: (Scalars['String'] | null),affiliatedEntityId?: (Scalars['String'] | null),categoryName?: (InventoryPurchaseCategoryName | null),startDate?: (Scalars['Date'] | null),endDate?: (Scalars['Date'] | null),condition?: (InventoryPurchaseRuleCondition | null),amount?: (Scalars['Float'] | null),operation: InventoryPurchaseRuleApplyRuleOperation}

export interface ApplyNoUnitsPhysicalCountProductQuantitiesPendingAdjustmentsInput {physicalCountId: Scalars['String'],companyId: Scalars['String']}

export interface ApplyPendingSalesDataAdjustmentsInput {companyId: Scalars['ID'],managementMethodId: Scalars['String'],mode: ApplyPendingSalesDataAdjustmentsMode,type?: (ProductBulkAdjustmentStatusType[] | null),salesChannels?: (SalesChannelInput[] | null)}

export interface ApplyPendingWarehouseOpeningBalanceInput {companyId: Scalars['ID'],date: Scalars['Date']}

export interface ApplySalesChannelChangesInput {companyId: Scalars['ID'],add: SalesChannelAddChangeInput[],update: SalesChannelUpdateChangeInput[],delete: SalesChannelDeleteChangeInput[]}

export interface ApplySalesChannelChangesResultGenqlSelection{
    success?: boolean | number
    salesChannels?: SalesChannelInfoGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ArtificialTransactionsByMonthGenqlSelection{
    type?: boolean | number
    integrationType?: boolean | number
    count?: boolean | number
    sum?: boolean | number
    month?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ArtificialTransactionsByMonthResponseGenqlSelection{
    payments?: ArtificialTransactionsByMonthGenqlSelection
    refunds?: ArtificialTransactionsByMonthGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AskTheUserNotificationInput {companyId: Scalars['ID'],notificationType: AskTheUserNotificationType,notificationData: Scalars['JSONObject']}

export interface AskTheUserNotificationServiceResultGenqlSelection{
    success?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AskTheUserResultGenqlSelection{
    type?: boolean | number
    data?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AssembledByMapGenqlSelection{
    id?: boolean | number
    assembled?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AssemblyGenqlSelection{
    companyId?: boolean | number
    startDate?: boolean | number
    endDate?: boolean | number
    amount?: boolean | number
    assemblyItems?: AssemblyItemGenqlSelection
    inventoryPaymentGroupLinks?: InventoryPaymentGroupLinkGenqlSelection
    unpaidAmounts?: UnpaidAmountPerAffiliatedEntityGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AssemblyItemGenqlSelection{
    on_ManualAssembly?:ManualAssemblyGenqlSelection,
    on_OnDemandAssemblyVendorCosts?:OnDemandAssemblyVendorCostsGenqlSelection,
    __typename?: boolean | number
}

export interface AssemblyListItemGenqlSelection{
    type?: boolean | number
    date?: boolean | number
    amount?: boolean | number
    recipe?: RecipeGenqlSelection
    id?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AssignCompanyToUser {email: Scalars['String'],companyId: Scalars['String'],roles: Scalars['String'][]}

export interface AssignCompanyToUserResponseGenqlSelection{
    success?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AttachmentTargetURLGenqlSelection{
    fileName?: boolean | number
    url?: boolean | number
    signedUrl?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AttachmentTargetURLSGenqlSelection{
    signedUrls?: AttachmentTargetURLGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AttachRelationsToLoanInput {ids: (Scalars['ID'] | null)[],loanId: Scalars['ID'],companyId: Scalars['ID']}

export interface AttachTransactionToCompanyLoanTransactionInput {transactionId: Scalars['String'],classifications: CreateCompanyLoanFromTransactionClassificationInput[]}

export interface AttemptToClassifyTransactionsInput {classificationRequests: ClassificationRequestInput[],actorContext: ActorContextInput}

export interface Auth0UserLookupInput {email: Scalars['String'],accessKey: Scalars['String']}

export interface Auth0UserLookupResponseGenqlSelection{
    exists?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AwaitedExportResponseGenqlSelection{
    requestId?: boolean | number
    status?: boolean | number
    signedUrl?: boolean | number
    message?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BackOfficeBankStatementRequestsFiltersResponseGenqlSelection{
    years?: boolean | number
    tiers?: boolean | number
    statuses?: boolean | number
    types?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BalanceAdjustmentGenqlSelection{
    value?: boolean | number
    forDate?: boolean | number
    actorType?: boolean | number
    actorId?: boolean | number
    createdAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BalanceByCurrencyGenqlSelection{
    currency?: boolean | number
    balance?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BalanceLocationGenqlSelection{
    balance?: boolean | number
    balanceAtIso?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BalanceSheetDependencyGenqlSelection{
    blocked?: boolean | number
    resolvedAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BalanceSheetItemGenqlSelection{
    state?: BalanceSheetSetupItemStateResponseGenqlSelection
    data?: boolean | number
    createdAt?: boolean | number
    updatedAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BalanceSheetSetupGenqlSelection{
    id?: boolean | number
    state?: BalanceSheetSetupStateResponseGenqlSelection
    userUnresponsive?: UserUnresponsiveGenqlSelection
    isPreviewEnabled?: boolean | number
    email?: boolean | number
    intercomLink?: boolean | number
    items?: BalanceSheetSetupItemsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BalanceSheetSetupInput {companyId: Scalars['ID']}

export interface BalanceSheetSetupItemsGenqlSelection{
    businessAndTaxInformation?: BalanceSheetItemGenqlSelection
    banks?: BalanceSheetItemGenqlSelection
    loans?: BalanceSheetItemGenqlSelection
    taxReturnDocument?: BalanceSheetItemGenqlSelection
    balanceSheetDocument?: BalanceSheetItemGenqlSelection
    acquisitionAgreementDocument?: BalanceSheetItemGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BalanceSheetSetupItemStateResponseGenqlSelection{
    value?: boolean | number
    history?: HubItemStateChangeLogGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BalanceSheetSetupStateResponseGenqlSelection{
    value?: boolean | number
    history?: HubStateChangeLogGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BalanceSheetStatusGenqlSelection{
    status?: boolean | number
    updatedAt?: boolean | number
    updatedBy?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BankAccountGenqlSelection{
    id?: boolean | number
    companyId?: boolean | number
    integrationAccountId?: boolean | number
    source?: boolean | number
    externalSourceId?: boolean | number
    externalInstitutionId?: boolean | number
    type?: boolean | number
    subtype?: boolean | number
    currency?: boolean | number
    currentBalance?: boolean | number
    institution?: InstitutionGenqlSelection
    institutionId?: boolean | number
    institutionName?: boolean | number
    name?: boolean | number
    fullName?: boolean | number
    displayName?: boolean | number
    mask?: boolean | number
    connectedAt?: boolean | number
    isHistoricalUpdateCompleted?: boolean | number
    isMissingHistoricalTransactions?: boolean | number
    userSaidThereAreNoMissingTransactions?: boolean | number
    locks?: BankAccountLockGenqlSelection
    rawData?: boolean | number
    closingBalanceLogs?: BankAccountClosingBalanceGenqlSelection
    balanceAdjustments?: BalanceAdjustmentGenqlSelection
    latestAccountingEventIds?: boolean | number
    transactionsImportStatus?: BankAccountTransactionsImportStatusGenqlSelection
    deletedByUserAt?: boolean | number
    deletedByUserId?: boolean | number
    createdAt?: boolean | number
    createdBy?: boolean | number
    shouldUpdateAccountDetailsOnNextUpdate?: boolean | number
    vendor?: VendorGenqlSelection
    duplicateOfBankAccountId?: boolean | number
    hasRecurringMission?: boolean | number
    lockStatus?: (BankAccountLockStatusGenqlSelection & { __args?: {year?: (Scalars['Int'] | null)} })
    accountValidation?: AccountValidationGenqlSelection
    markedAsClosedByCustomerAt?: boolean | number
    forwardTransactionsToBankAccountId?: boolean | number
    isManagedByFinaloop?: boolean | number
    hasNotifiedUponNoHistoricalUpdate?: boolean | number
    accountRole?: boolean | number
    connectionStatus?: boolean | number
    accountStatus?: boolean | number
    status?: boolean | number
    institutionLogo?: boolean | number
    integrationType?: boolean | number
    deletedAt?: boolean | number
    deletedBy?: boolean | number
    isManual?: boolean | number
    isRefreshRequired?: boolean | number
    isDisconnected?: boolean | number
    convertedToManualAt?: boolean | number
    convertedToManualBy?: boolean | number
    transactionsCount?: { __args: {fromDate?: (Scalars['Date'] | null), untilDate?: (Scalars['Date'] | null)} } | boolean | number
    minimumTransactionDate?: { __args: {fromBooksStartTime?: (Scalars['Boolean'] | null)} } | boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BankAccountBalanceInput {companyId: Scalars['ID'],bankAccountId: Scalars['ID'],balanceDateInISO: Scalars['String']}

export interface BankAccountClosingBalanceGenqlSelection{
    value?: boolean | number
    forDate?: boolean | number
    actorType?: boolean | number
    actorId?: boolean | number
    createdAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BankAccountEventIdsInput {bankAccountId: Scalars['ID'],eventIds: Scalars['ID'][]}

export interface BankAccountInput {id: Scalars['ID'],companyId: Scalars['ID']}

export interface BankAccountInternalInput {id: Scalars['ID']}

export interface BankAccountLockGenqlSelection{
    type?: boolean | number
    startTime?: boolean | number
    endTime?: boolean | number
    lockedAt?: boolean | number
    actorType?: boolean | number
    actorId?: boolean | number
    reason?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BankAccountLockByTypeInput {startDate: Scalars['Date'],endDate: Scalars['Date'],lockedAt?: (Scalars['Date'] | null),actorType: ActorType,actorId: Scalars['String'],reason?: (Scalars['String'] | null)}

export interface BankAccountLockInput {startDate: Scalars['Date'],endDate: Scalars['Date'],lockedAt?: (Scalars['Date'] | null),actorType: ActorType,actorId: Scalars['String'],type: Scalars['String'],reason?: (Scalars['String'] | null)}

export interface BankAccountLockStatusGenqlSelection{
    lockedAt?: boolean | number
    minimumAllowedEventTime?: boolean | number
    year?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BankAccountNewOwner {type: BankAccountNewOwnerType,id?: (Scalars['ID'] | null),name: Scalars['String']}

export interface BankAccountReconciliationGenqlSelection{
    id?: boolean | number
    bankAccount?: BankAccountGenqlSelection
    companyId?: boolean | number
    status?: boolean | number
    transactionsFileLocations?: FileLocationGenqlSelection
    statementFileLocations?: FileLocationGenqlSelection
    balanceLocation?: BalanceLocationGenqlSelection
    reconciliationDate?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BankAccountReconciliationsInput {companyId: Scalars['ID']}

export interface BankAccountsByIdsInput {companyId: Scalars['ID'],bankAccountIds: Scalars['ID'][]}

export interface BankAccountsInput {companyId: Scalars['ID'],sources?: (IntegrationType[] | null),statuses?: (BankAccountStatus[] | null),types?: (BankAccountType[] | null),subtypes?: (BankAccountSubtype[] | null),withDisabled?: (Scalars['Boolean'] | null),withDeleted?: (Scalars['Boolean'] | null),withDuplicate?: (Scalars['Boolean'] | null)}

export interface BankAccountsInternalInput {bankAccountIds: Scalars['ID'][]}

export interface BankAccountStatementRequestGenqlSelection{
    id?: boolean | number
    companyId?: boolean | number
    fromDate?: boolean | number
    toDate?: boolean | number
    bankAccount?: BankStatementBankAccountGenqlSelection
    type?: boolean | number
    subType?: boolean | number
    customerData?: BankStatementCustomerDataGenqlSelection
    finaloopData?: BankStatementFinaloopDataGenqlSelection
    status?: boolean | number
    fileNames?: boolean | number
    displayedBalance?: boolean | number
    csvUploads?: CSVUploadGenqlSelection
    balanceId?: boolean | number
    markedAsClosedByCustomerAt?: boolean | number
    lockedStatus?: LockedStatusGenqlSelection
    originalBankAccountId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BankAccountStopImportNewOwnerGenqlSelection{
    id?: boolean | number
    type?: boolean | number
    name?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BankAccountTransactionsImportStatusGenqlSelection{
    changedBy?: boolean | number
    changedAt?: boolean | number
    stopImportFromDate?: boolean | number
    balanceAtStopImportFromDate?: boolean | number
    newOwner?: BankAccountStopImportNewOwnerGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BankConnectionGenqlSelection{
    companyId?: boolean | number
    integrationType?: boolean | number
    integrationAccountId?: boolean | number
    institutionName?: boolean | number
    institutionId?: boolean | number
    institutionLogo?: boolean | number
    isTest?: boolean | number
    accounts?: BankAccountGenqlSelection
    isRefreshRequired?: boolean | number
    isDisconnected?: boolean | number
    syncStatus?: BankConnectionSyncStatusGenqlSelection
    impactOnBooksSince?: boolean | number
    deletedAt?: boolean | number
    deletedBy?: boolean | number
    status?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BankConnectionAccountGenqlSelection{
    id?: boolean | number
    minimumTransactionDate?: { __args: {fromBooksStartTime?: (Scalars['Boolean'] | null)} } | boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BankConnectionAccountLockGenqlSelection{
    startTime?: boolean | number
    endTime?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BankConnectionAccountTransactionsImportStatusGenqlSelection{
    changedBy?: boolean | number
    changedAt?: boolean | number
    stopImportFromDate?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BankConnectionMetricsInput {companyId: Scalars['ID'],eventType?: (BankConnectionMetricsEventType[] | null),integrationAccountId?: (Scalars['String'] | null)}

export interface BankConnectionsInput {companyId: Scalars['ID'],withDeleted?: (Scalars['Boolean'] | null),withDuplicate?: (Scalars['Boolean'] | null),sources?: (IntegrationType[] | null),statuses?: (BankAccountStatus[] | null),accountTypes?: (BankAccountType[] | null),accountSubtypes?: (BankAccountSubtype[] | null)}

export interface BankConnectionSyncStatusGenqlSelection{
    lastSuccessfulTransactionsUpdate?: boolean | number
    lastFailedTransactionsUpdate?: boolean | number
    updatedAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BankDetailsGenqlSelection{
    name?: boolean | number
    lastFourDigits?: boolean | number
    type?: boolean | number
    missingBank?: boolean | number
    accountName?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BankingAuditGenqlSelection{
    entityType?: boolean | number
    entityId?: boolean | number
    field?: boolean | number
    beforeValue?: boolean | number
    afterValue?: boolean | number
    timestamp?: boolean | number
    correlationId?: boolean | number
    action?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BankingAuditsInput {entityType: Scalars['String'],entityId: Scalars['String'],field?: (Scalars['String'][] | null),action?: (BankingAuditAction[] | null)}

export interface BankingMetricGenqlSelection{
    companyId?: boolean | number
    eventTime?: boolean | number
    eventType?: boolean | number
    integrationType?: boolean | number
    integrationAccountId?: boolean | number
    data?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BankingMetricInput {companyId: Scalars['String'],eventTime: Scalars['Date'],eventType: BankingMetricEventType,integrationType: Scalars['String'],integrationAccountId?: (Scalars['String'] | null),data?: (Scalars['JSONObject'] | null)}

export interface BankingMissionResultGenqlSelection{
    hasMissions?: boolean | number
    hasBankConnectionMissions?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BankOverviewPageAccountGenqlSelection{
    id?: boolean | number
    companyId?: boolean | number
    bankAccount?: BankAccountGenqlSelection
    virtualCurrencies?: boolean | number
    balancesByCurrency?: BalanceByCurrencyGenqlSelection
    isTestAccount?: boolean | number
    syncStatus?: BankConnectionSyncStatusGenqlSelection
    connectionStatus?: boolean | number
    reconciliationStatus?: boolean | number
    accountCurrentBalance?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BankOverviewPageInput {companyId: Scalars['ID'],withDeleted?: (Scalars['Boolean'] | null),sources?: (IntegrationType[] | null),accountTypes?: (BankAccountType[] | null),accountSubtypes?: (BankAccountSubtype[] | null),accountIds?: (Scalars['ID'][] | null)}

export interface BankReconciliationGraphPointGenqlSelection{
    date?: boolean | number
    source?: boolean | number
    actualBalance?: boolean | number
    finaloopBalance?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BankReconciliationGraphPointsInput {companyId: Scalars['ID'],bankAccountId: Scalars['ID']}

export interface BankReconciliationRequestGenqlSelection{
    id?: boolean | number
    bankAccount?: BankAccountGenqlSelection
    companyId?: boolean | number
    company?: CompanyGenqlSelection
    requestType?: boolean | number
    requestCategory?: boolean | number
    originalBankAccountId?: boolean | number
    resolutionComment?: boolean | number
    internalMessage?: boolean | number
    finaloopMessage?: boolean | number
    finaloopMessageSender?: boolean | number
    expectedStartDate?: boolean | number
    expectedEndDate?: boolean | number
    customerSelectedDate?: boolean | number
    booksBalanceAtDate?: boolean | number
    customerBalanceByStatement?: boolean | number
    customerConfirmedBooksBalanceAtDate?: boolean | number
    resolutionType?: boolean | number
    customerForceSubmitted?: boolean | number
    irrelevantReason?: boolean | number
    transferredEntity?: boolean | number
    configurationId?: boolean | number
    defaultEndDate?: boolean | number
    status?: boolean | number
    isBankAccountValid?: boolean | number
    latestActorId?: boolean | number
    latestActorType?: boolean | number
    statementFiles?: ReconciliationRequestStatementFileGenqlSelection
    hasTransactionsBeforeBSD?: boolean | number
    completedStandardOpeningBalance?: boolean | number
    accountCurrentBalance?: boolean | number
    lastAccountTransaction?: LastTransactionGenqlSelection
    isAccountValidOnSubmission?: boolean | number
    isOngoingReconciliation?: boolean | number
    createdById?: boolean | number
    createdByActorType?: boolean | number
    deletedAt?: boolean | number
    createdAt?: boolean | number
    updatedAt?: boolean | number
    completedAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BankReconciliationRequestConfigurationGenqlSelection{
    id?: boolean | number
    company?: CompanyGenqlSelection
    bankAccount?: BankAccountGenqlSelection
    requestType?: boolean | number
    requestCategory?: boolean | number
    recurrence?: boolean | number
    startDate?: boolean | number
    lastRunAt?: boolean | number
    createdAt?: boolean | number
    createdById?: boolean | number
    createdByActorType?: boolean | number
    updatedAt?: boolean | number
    latestActorId?: boolean | number
    latestActorType?: boolean | number
    deletedAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BankReconciliationRequestFiltersInput {statusCategory?: ((BankReconciliationRequestStatusCategories | null)[] | null),requestTypes?: ((FilterableBankStatementRequestTypes | null)[] | null),requestCategories?: ((BankReconciliationRequestCategory | null)[] | null),withDeleted?: (Scalars['Boolean'] | null),limit?: (Scalars['Int'] | null),offset?: (Scalars['Int'] | null)}

export interface BankReconciliationRequestInput {id: Scalars['ID'],companyId: Scalars['String']}

export interface BankReconciliationRequestSettingsInput {companyId?: (Scalars['ID'] | null),bankAccountId?: (Scalars['ID'] | null),requestTypes?: (BankReconciliationSettingsRequestTypes[] | null),tiers?: (CompanyTier[] | null),withDeleted?: (Scalars['Boolean'] | null)}

export interface BankReconciliationRequestSettingsResponseGenqlSelection{
    configurations?: BankReconciliationRequestConfigurationGenqlSelection
    requests?: BankReconciliationRequestGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BankReconciliationRequestsInput {ids?: (Scalars['String'][] | null),companyId: Scalars['String'],bankAccountIds?: (Scalars['String'][] | null),filters?: (BankReconciliationRequestFiltersInput | null)}

export interface BankReconciliationStatementAutoProcessingResultsInput {companyId: Scalars['String'],requestId: Scalars['String'],status: BankStatementAutoProcessingStatus,message?: (Scalars['String'] | null)}

export interface BankStatementAccountHolderGenqlSelection{
    firstName?: boolean | number
    lastName?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BankStatementAccountHolderInput {firstName?: (Scalars['String'] | null),lastName?: (Scalars['String'] | null)}

export interface BankStatementBankAccountGenqlSelection{
    id?: boolean | number
    integrationAccountId?: boolean | number
    name?: boolean | number
    type?: boolean | number
    subtype?: boolean | number
    institutionName?: boolean | number
    institutionId?: boolean | number
    currency?: boolean | number
    mask?: boolean | number
    source?: boolean | number
    transactionsImportStatus?: TransactionsImportStatusGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BankStatementCustomerDataGenqlSelection{
    fileNames?: boolean | number
    csvFileNames?: boolean | number
    noCSVFiles?: boolean | number
    noPDFFiles?: boolean | number
    displayedBalance?: boolean | number
    realBalance?: boolean | number
    cycleStart?: boolean | number
    cycleEnd?: boolean | number
    isConfirmed?: boolean | number
    irrelevantReason?: boolean | number
    irrelevantType?: boolean | number
    isMachineReconciled?: boolean | number
    newOwner?: boolean | number
    newOwnerType?: boolean | number
    newOwnerId?: boolean | number
    newOwnerName?: boolean | number
    bankDetails?: BankDetailsGenqlSelection
    transferDate?: boolean | number
    closedDate?: boolean | number
    relatedMissionId?: boolean | number
    isIntegrationTransfers?: boolean | number
    isClosedThisYear?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BankStatementFileGenqlSelection{
    id?: boolean | number
    bankAccount?: BankAccountGenqlSelection
    bankStatementRequestId?: boolean | number
    companyId?: boolean | number
    fileName?: boolean | number
    s3Bucket?: boolean | number
    s3Key?: boolean | number
    fileType?: boolean | number
    originalBankAccountId?: boolean | number
    originFileId?: boolean | number
    uploadOriginator?: boolean | number
    uploadedAt?: boolean | number
    uploadedByActor?: boolean | number
    uploadedById?: boolean | number
    createdAt?: boolean | number
    updatedAt?: boolean | number
    status?: boolean | number
    processingLogs?: BankStatementFileProcessingLogGenqlSelection
    companyAffiliateType?: boolean | number
    companyAffiliateId?: boolean | number
    system?: boolean | number
    subSystem?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BankStatementFileByCompanyIdInput {companyId: Scalars['ID'],bankAccountIds?: (Scalars['ID'][] | null),withPayoutTopUpFilter?: (Scalars['Boolean'] | null)}

export interface BankStatementFileByIdInput {companyId: Scalars['ID'],fileId: Scalars['String']}

export interface BankStatementFileProcessingLogGenqlSelection{
    processorType?: boolean | number
    state?: boolean | number
    processorId?: boolean | number
    metadata?: boolean | number
    message?: boolean | number
    createdAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BankStatementFileProcessingLogInput {processorType: BankStatementFileProcessorType,processorId: Scalars['String'],state: BankStatementFileProcessingLogState,message?: (Scalars['String'] | null),metadata?: (Scalars['JSONObject'] | null)}

export interface BankStatementFilesInput {withPayoutTopUpFilter?: (Scalars['Boolean'] | null),limit: Scalars['Int'],offset: Scalars['Int']}

export interface BankStatementFinaloopDataGenqlSelection{
    comment?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BankStatementParsedTransactionGenqlSelection{
    date?: boolean | number
    description?: boolean | number
    amount?: boolean | number
    runningBalance?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BankStatementParsedTransactionInput {date?: (Scalars['String'] | null),description?: (Scalars['String'] | null),amount?: (Scalars['Float'] | null),runningBalance?: (Scalars['Float'] | null)}

export interface BankStatementParsingRequestGenqlSelection{
    id?: boolean | number
    companyId?: boolean | number
    bankTransactionsUploadId?: boolean | number
    bankStatementFileId?: boolean | number
    provider?: boolean | number
    providerModel?: boolean | number
    queryVersion?: boolean | number
    requestPayload?: boolean | number
    runStatus?: boolean | number
    rawResponse?: boolean | number
    startTime?: boolean | number
    endTime?: boolean | number
    responseTimeMs?: boolean | number
    failureReason?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BankStatementParsingRequestInput {id?: (Scalars['ID'] | null),companyId: Scalars['ID'],bankTransactionsUploadId?: (Scalars['String'] | null),bankStatementFileId?: (Scalars['String'] | null),provider: BankStatementParsingRequestsProvider,providerModel?: (Scalars['String'] | null),queryVersion: Scalars['Int'],requestPayload: Scalars['JSONObject'],runStatus: BankStatementParsingRequestsRunStatus,rawResponse: Scalars['JSONObject'],startTime: Scalars['Date'],endTime: Scalars['Date'],responseTimeMs?: (Scalars['Float'] | null),failureReason?: (Scalars['String'] | null)}

export interface BankStatementParsingResultGenqlSelection{
    id?: boolean | number
    companyId?: boolean | number
    bankStatementParsingRequestId?: boolean | number
    bankTransactionsUploadId?: boolean | number
    bankStatementFileId?: boolean | number
    provider?: boolean | number
    providerModel?: boolean | number
    queryVersion?: boolean | number
    status?: boolean | number
    institutionName?: boolean | number
    accountName?: boolean | number
    mask?: boolean | number
    openingBalance?: boolean | number
    closingBalance?: boolean | number
    startDate?: boolean | number
    endDate?: boolean | number
    isReconciled?: boolean | number
    isReconciledByProvider?: boolean | number
    transactions?: BankStatementParsedTransactionGenqlSelection
    accountHolders?: BankStatementAccountHolderGenqlSelection
    transactionsCount?: boolean | number
    totalTransactionsAmount?: boolean | number
    balanceChange?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BankStatementParsingResultsInput {id?: (Scalars['ID'] | null),companyId: Scalars['ID'],bankStatementParsingRequestId?: (Scalars['String'] | null),bankTransactionsUploadId?: (Scalars['String'] | null),bankStatementFileId?: (Scalars['String'] | null),provider: BankStatementParsingRequestsProvider,providerModel?: (Scalars['String'] | null),queryVersion: Scalars['Int'],institutionName?: (Scalars['String'] | null),accountName?: (Scalars['String'] | null),mask?: (Scalars['String'] | null),openingBalance?: (Scalars['Float'] | null),closingBalance?: (Scalars['Float'] | null),startDate?: (Scalars['Date'] | null),endDate?: (Scalars['Date'] | null),isReconciled: Scalars['Boolean'],isReconciledByProvider?: (Scalars['Boolean'] | null),transactions?: (BankStatementParsedTransactionInput[] | null),accountHolders?: (BankStatementAccountHolderInput[] | null),transactionsCount?: (Scalars['Int'] | null),totalTransactionsAmount?: (Scalars['Float'] | null),balanceChange?: (Scalars['Float'] | null)}

export interface BankStatementRequestResolutionInput {id: Scalars['ID'],companyId: Scalars['String'],resolutionType: BankStatementReconciliationResolutionType,irrelevantReason?: (BankStatementReconciliationIrrelevantReason | null),transferredEntity?: (BankStatementReconciliationTransferredEntity | null),customerConfirmedBooksBalanceAtDate?: (Scalars['Boolean'] | null),customerBalanceByStatement?: (Scalars['Float'] | null),customerSelectedDate?: (Scalars['Date'] | null),booksBalanceAtDate?: (Scalars['Float'] | null),statementFiles?: (StatementFile[] | null),forceSubmit?: (Scalars['Boolean'] | null),fileIds?: (Scalars['String'][] | null),originator: BankStatementResolutionOriginator}

export interface BankStatementRequestResolutionResponseGenqlSelection{
    status?: boolean | number
    submissionStatus?: boolean | number
    fileValidationStatus?: boolean | number
    fileIds?: boolean | number
    errors?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BankStatementValidationResultsGenqlSelection{
    fileId?: boolean | number
    runStatus?: boolean | number
    failureReason?: boolean | number
    matchConfidence?: boolean | number
    matchedComponents?: boolean | number
    institution?: boolean | number
    startDate?: boolean | number
    endDate?: boolean | number
    openingBalance?: boolean | number
    closingBalance?: boolean | number
    accountNumber?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BankTransactionGenqlSelection{
    id?: boolean | number
    accrual?: AccrualGenqlSelection
    companyId?: boolean | number
    bankAccount?: BankAccountGenqlSelection
    postedAt?: boolean | number
    amount?: boolean | number
    currency?: boolean | number
    amountInUsd?: boolean | number
    merchant?: MerchantGenqlSelection
    businessEvent?: BankTransactionBusinessEventGenqlSelection
    classificationMetadata?: ClassificationMetadataGenqlSelection
    description?: boolean | number
    processedByMachineAt?: boolean | number
    lastProcessedByMachineAt?: boolean | number
    applyingClassificationJobId?: boolean | number
    source?: boolean | number
    sourceSpecificData?: boolean | number
    userMemo?: BankTransactionMemoGenqlSelection
    attachments?: BankTransactionAttachmentGenqlSelection
    classificationVersion?: boolean | number
    deletedAt?: boolean | number
    recommendations?: BankTransactionRecommendationGenqlSelection
    loan?: CompanyLoanGenqlSelection
    loanInfo?: TransactionLoanGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BankTransactionAttachmentGenqlSelection{
    signedUrl?: boolean | number
    url?: boolean | number
    name?: boolean | number
    addedBy?: boolean | number
    createdAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BankTransactionBusinessEventGenqlSelection{
    classifiedAt?: boolean | number
    classifierType?: boolean | number
    classifiedBy?: boolean | number
    classifications?: BankTransactionBusinessEventClassificationGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BankTransactionBusinessEventClassificationGenqlSelection{
    classificationId?: boolean | number
    businessEvent?: boolean | number
    amount?: boolean | number
    amountInPercentage?: boolean | number
    amountInHomeCurrency?: boolean | number
    affiliatedEntityId?: boolean | number
    affiliatedEntity?: AffiliatedEntityGenqlSelection
    pairedEntityId?: boolean | number
    pairedEntityType?: boolean | number
    pairingType?: boolean | number
    classificationTagId?: boolean | number
    classificationTagText?: boolean | number
    classificationText?: boolean | number
    description?: boolean | number
    extraData?: boolean | number
    askTheUserResult?: AskTheUserResultGenqlSelection
    pairedEntity?: PairedEntityGenqlSelection
    classificationTag?: ClassificationTagGenqlSelection
    businessEventV2?: BusinessEventActionsConfigurationGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BankTransactionByMerchantGenqlSelection{
    groupId?: boolean | number
    merchant?: MerchantGenqlSelection
    transactions?: BankTransactionGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BankTransactionByMerchantResultGenqlSelection{
    groups?: BankTransactionByMerchantGenqlSelection
    total?: boolean | number
    nextToken?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BankTransactionCategorizationInput {bankTransactionId: Scalars['ID'],merchant?: (MerchantInput | null),classifications?: (BankTransactionClassificationInput[] | null),recommendations?: (ClassificationRecommendationsInput | null)}

export interface BankTransactionCategorizationResultGenqlSelection{
    bankTransaction?: BankTransactionGenqlSelection
    status?: boolean | number
    error?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BankTransactionClassificationInput {amount: Scalars['Float'],amountInPercentage?: (Scalars['Float'] | null),amountInHomeCurrency?: (Scalars['Float'] | null),affiliatedEntityId?: (Scalars['ID'] | null),classificationTagId?: (Scalars['ID'] | null),classificationText?: (Scalars['ID'] | null),businessEvent?: (Scalars['String'] | null),pairedEntityId?: (Scalars['String'] | null),pairedEntityType?: (PairedEntityType | null),pairingType?: (PairingType | null),askTheUserResult?: (Scalars['JSONObject'] | null),extraData?: (Scalars['JSONObject'] | null),description?: (Scalars['String'] | null)}

export interface BankTransactionCursorInput {offset?: (Scalars['Int'] | null),limit: Scalars['Int']}

export interface BankTransactionInput {companyId: Scalars['ID'],transactionId: Scalars['ID']}

export interface BankTransactionMemoGenqlSelection{
    content?: boolean | number
    updatedAt?: boolean | number
    updatedBy?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BankTransactionPairingInput {pairedEntityType: PairedEntityType,pairedEntityId: Scalars['String']}

export interface BankTransactionPairingResultGenqlSelection{
    pairedEntityType?: boolean | number
    pairedEntityId?: boolean | number
    bankTransactions?: BankTransactionGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BankTransactionRecommendationGenqlSelection{
    classificationTag?: ClassificationTagGenqlSelection
    score?: boolean | number
    model?: boolean | number
    recommendationsSource?: boolean | number
    recommendedBy?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BankTransactionResponseGenqlSelection{
    bankTransactions?: BankTransactionGenqlSelection
    nextOffset?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BankTransactionsByMerchantInput {companyId: Scalars['ID'],bankAccountId?: (Scalars['ID'] | null),dateRange?: (DateRangeInput | null),merchantIds?: (Scalars['ID'][] | null),merchantIdsOperator?: (FilterOperator | null),nextToken?: (Scalars['ID'] | null),limit: Scalars['Int'],searchTerm?: (Scalars['String'] | null),amountRange?: (AmountRangeInput | null),absoluteAmounts?: (Scalars['Boolean'] | null),moneyDirection?: (MoneyDirection | null),searchMerchantsByName?: (Scalars['Boolean'] | null),source?: (IntegrationType | null),excludeLocked?: (Scalars['Boolean'] | null)}

export interface BankTransactionsByPairingsInput {pairings: BankTransactionPairingInput[]}

export interface BankTransactionsInput {companyId: Scalars['ID'],bankTransactionIds?: (Scalars['ID'][] | null),bankAccountIds?: (Scalars['ID'][] | null),bankAccountIdsOperator?: (FilterOperator | null),businessEvents?: (Scalars['String'][] | null),businessEventsOperator?: (FilterOperator | null),searchTerm?: (Scalars['String'] | null),endDate?: (Scalars['Date'] | null),startDate?: (Scalars['Date'] | null),amountLte?: (Scalars['Float'] | null),amountGte?: (Scalars['Float'] | null),checkAgainstOriginalAmount?: (Scalars['Boolean'] | null),absoluteAmounts?: (Scalars['Boolean'] | null),source?: (IntegrationType | null),merchantIds?: (Scalars['ID'][] | null),searchMerchantsByName?: (Scalars['Boolean'] | null),merchantIdsOperator?: (FilterOperator | null),withMerchantIdsAsPairedEntities?: (Scalars['Boolean'] | null),onlyPendingUserInput?: (Scalars['Boolean'] | null),moneyDirection?: (MoneyDirection | null),cursor?: (BankTransactionCursorInput | null),excludePairedEntityTypes?: (PairedEntityType[] | null),showOnlySpreadTransactions?: (Scalars['Boolean'] | null),excludeLocked?: (Scalars['Boolean'] | null),showOnlySplitTransactions?: (Scalars['Boolean'] | null)}

export interface BankTransactionsResponseGenqlSelection{
    bankTransactions?: BankTransactionGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BankTransactionsSort {closeToAmount?: (Scalars['Float'] | null),closeToDate?: (Scalars['Date'] | null)}

export interface BankTransactionsSummaryGenqlSelection{
    amountInUsd?: boolean | number
    count?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BankTransactionsUploadGenqlSelection{
    id?: boolean | number
    companyId?: boolean | number
    bankAccount?: BankAccountGenqlSelection
    fileLocation?: BankTransactionsUploadFileLocationGenqlSelection
    uploadOriginator?: boolean | number
    uploadedBy?: boolean | number
    uploadedById?: boolean | number
    uploadedAt?: boolean | number
    processingLogs?: BankTransactionsUploadProcessingLogGenqlSelection
    status?: boolean | number
    bankStatementRequestId?: boolean | number
    originFileId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BankTransactionsUploadFileInput {companyId: Scalars['ID'],bankTransactionsUploadFileId: Scalars['String']}

export interface BankTransactionsUploadFileLocationGenqlSelection{
    bucket?: boolean | number
    key?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BankTransactionsUploadProcessingLogGenqlSelection{
    processorType?: boolean | number
    processorId?: boolean | number
    createdAt?: boolean | number
    state?: boolean | number
    metadata?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BankTransactionsUploadProcessingLogInput {processorType: BankTransactionsUploadProcessorType,processorId: Scalars['String'],state: BankTransactionsUploadProcessingLogState,message?: (Scalars['String'] | null),metadata?: (Scalars['JSONObject'] | null)}

export interface BankTransactionToLinkInput {transactionId: Scalars['ID'],amountInHomeCurrency?: (Scalars['Float'] | null),amount: Scalars['Float'],currency?: (CurrencyCode | null)}

export interface BankTxSaleTransactionGenqlSelection{
    id?: boolean | number
    integrationInfo?: IntegrationInfoGenqlSelection
    integrationAccountId?: boolean | number
    externalSourceId?: boolean | number
    amount?: boolean | number
    postedAt?: boolean | number
    currency?: boolean | number
    amountInHomeCurrency?: boolean | number
    type?: boolean | number
    finaloopPaymentGateway?: boolean | number
    originalPaymentGateway?: boolean | number
    paymentGatewayVariant?: boolean | number
    isIndication?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BaseAffiliatedEntityGenqlSelection{
    id?: boolean | number
    company?: CompanyGenqlSelection
    name?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BigValidationAccountRoleAmountGenqlSelection{
    amount?: boolean | number
    accountRole?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BigValidationAdjustmentGenqlSelection{
    date?: boolean | number
    amount?: boolean | number
    comment?: boolean | number
    type?: boolean | number
    setBy?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BigValidationDataGenqlSelection{
    method?: boolean | number
    startDate?: boolean | number
    endDate?: boolean | number
    entityData?: BigValidationPeriodDataGenqlSelection
    booksData?: BigValidationPeriodDataGenqlSelection
    status?: BigValidationStatusGenqlSelection
    isGreen?: boolean | number
    adjustment?: BigValidationAdjustmentGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BigValidationInventoryBalanceDataGenqlSelection{
    inventory?: boolean | number
    inventoryInProcess?: boolean | number
    inventoryInTransit?: boolean | number
    inventoryInTransitInternal?: boolean | number
    legacyInventory?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BigValidationPeriodDataGenqlSelection{
    cogs?: BigValidationAccountRoleAmountGenqlSelection
    purchases?: BigValidationAccountRoleAmountGenqlSelection
    endOfYearAdjustments?: boolean | number
    inventoryEndingBalance?: BigValidationInventoryBalanceDataGenqlSelection
    inventoryOpeningBalance?: boolean | number
    physicalCount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BigValidationResponseGenqlSelection{
    data?: BigValidationDataGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BigValidationStatusGenqlSelection{
    openingBalance?: boolean | number
    cogs?: boolean | number
    methodChangeAdjustments?: boolean | number
    endOfYearAdjustments?: boolean | number
    endingBalance?: boolean | number
    purchases?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}


/**
 * This is an incomplete representation of a Bill in Finaloop's systems, for a full representation - please use
 * the REST API (bills-api) until this is complete.
 */
export interface BillGenqlSelection{
    id?: boolean | number
    accrual?: AccrualV2GenqlSelection
    companyId?: boolean | number
    billNumber?: boolean | number
    currency?: boolean | number
    amount?: boolean | number
    dueDate?: boolean | number
    createdDate?: boolean | number
    deletedAt?: boolean | number
    vendor?: VendorGenqlSelection
    categories?: CategoryGenqlSelection
    balance?: { __args: {input?: (BillBalanceInput | null)} } | boolean | number
    payments?: BillPaymentGenqlSelection
    indicativePayments?: BillPaymentGenqlSelection
    credits?: BillCreditGenqlSelection
    adjustments?: BillAdjustmentGenqlSelection
    refunds?: BillRefundGenqlSelection
    source?: boolean | number
    externalSourceData?: BillExternalSourceDataGenqlSelection
    latestAccountingEventIds?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BillAdjustmentGenqlSelection{
    id?: boolean | number
    type?: boolean | number
    amount?: boolean | number
    currency?: boolean | number
    actionTime?: boolean | number
    eventTime?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BillBalanceInput {asOfDate: Scalars['Date']}

export interface BillCreditGenqlSelection{
    creditDate?: boolean | number
    amount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BillExternalSourceDataGenqlSelection{
    integrationAccountId?: boolean | number
    integrationAccountName?: boolean | number
    balance?: boolean | number
    link?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BillingGenqlSelection{
    id?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BillingPaymentGenqlSelection{
    on_RecurringPayment?:RecurringPaymentGenqlSelection,
    on_OneTimePayment?:OneTimePaymentGenqlSelection,
    __typename?: boolean | number
}

export interface BillInput {id: Scalars['ID'],companyId: Scalars['ID']}

export interface BillItemToReconcile {companyId: Scalars['ID'],billId: Scalars['ID']}

export interface BillPaymentGenqlSelection{
    id?: boolean | number
    paymentDate?: boolean | number
    amount?: boolean | number
    feeAmount?: boolean | number
    amountInUSD?: boolean | number
    currency?: boolean | number
    vendor?: VendorGenqlSelection
    settlementType?: boolean | number
    voidedAt?: boolean | number
    source?: boolean | number
    /**
     * These are the amounts being prorates for this payment over each category.
     * The order of the amounts in this array corresponds to the order of the categories in the bill.
     * 
     * This field is not available for indicative payments, as the proration acts only on the regular payments.
     */
    categoriesProration?: boolean | number
    financing?: BillPaymentFinancingGenqlSelection
    bulkPaymentData?: BulkPaymentDataGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BillPaymentFinancingGenqlSelection{
    type?: boolean | number
    feeBillIds?: boolean | number
    financedAmount?: boolean | number
    totalDays?: boolean | number
    periods?: boolean | number
    periodDays?: boolean | number
    installments?: BillPaymentFinancingInstallmentGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BillPaymentFinancingInstallmentGenqlSelection{
    installmentTime?: boolean | number
    principalAmount?: boolean | number
    interestAmount?: boolean | number
    totalAmount?: boolean | number
    status?: boolean | number
    isRefund?: boolean | number
    externalId?: boolean | number
    refundedExternalIds?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BillRefundGenqlSelection{
    id?: boolean | number
    refundDate?: boolean | number
    amount?: boolean | number
    amountInUSD?: boolean | number
    currency?: boolean | number
    settlementType?: boolean | number
    isVoidedPayment?: boolean | number
    source?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BillsAgingReportInput {companyId: Scalars['ID'],balanceAsOfDate: Scalars['Date']}

export interface BillsDueDateSummaryGenqlSelection{
    total?: DueDateSummaryGenqlSelection
    totalBalanceDue?: DueDateSummaryGenqlSelection
    pastDue?: DueDateSummaryGenqlSelection
    dueNext7Days?: DueDateSummaryGenqlSelection
    dueAfterNext7Days?: DueDateSummaryGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BillsDueDateSummaryInput {companyId: Scalars['ID']}

export interface BillsYearEndGenqlSelection{
    fiscalYearStartDate?: boolean | number
    fiscalYearEndDate?: boolean | number
    domainState?: boolean | number
    hubReportedDomainState?: boolean | number
    tasks?: BillsYearEndTaskGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BillsYearEndTaskGenqlSelection{
    id?: boolean | number
    stateKey?: boolean | number
    status?: boolean | number
    on_AddMissingBillsTask?: AddMissingBillsTaskGenqlSelection
    on_CategorizeUncategorizedBillsTask?: CategorizeUncategorizedBillsTaskGenqlSelection
    on_CloseOpenBillsTask?: CloseOpenBillsTaskGenqlSelection
    on_ConfirmApBalanceTask?: ConfirmApBalanceTaskGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BillsYearEndTasksInput {companyId: Scalars['ID']}

export interface BillsYearEndTasksResponseGenqlSelection{
    yearEnd?: BillsYearEndGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BooleanChangeLogGenqlSelection{
    id?: boolean | number
    createdAt?: boolean | number
    updaterType?: boolean | number
    changedByUid?: boolean | number
    reason?: boolean | number
    oldValue?: boolean | number
    newValue?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BooleanResultGenqlSelection{
    success?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BulkEditCsvTemplateInput {companyId: Scalars['ID'],isEmpty: Scalars['Boolean'],managementMethodId: Scalars['ID']}

export interface BulkEditCsvTemplateResponseGenqlSelection{
    url?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BulkPaymentDataGenqlSelection{
    id?: boolean | number
    amount?: boolean | number
    amountInUsd?: boolean | number
    paymentType?: boolean | number
    feeAmount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BulkRecoveryUnitsTrackingFailureResultGenqlSelection{
    company?: CompanyGenqlSelection
    reason?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BulkRecoveryUnitsTrackingInput {companyId?: (Scalars['ID'] | null)}

export interface BulkRecoveryUnitsTrackingResultGenqlSelection{
    failureResults?: BulkRecoveryUnitsTrackingFailureResultGenqlSelection
    successResults?: CompanyGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BusinessEventActionsConfigurationGenqlSelection{
    type?: boolean | number
    variant?: boolean | number
    id?: boolean | number
    accrualConfig?: JournalEntryActionsGenqlSelection
    cashConfig?: JournalEntryActionsGenqlSelection
    presentationalAccountRole?: AccountRoleGenqlSelection
    businessEventDefinition?: BusinessEventDefinitionGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BusinessEventActionsConfigurationByType {type: Scalars['String'],variant: Scalars['String']}

export interface BusinessEventCategorizationInput {classifications: ClassificationInput[],shouldApplyAlways: Scalars['Boolean']}

export interface BusinessEventClassificationInput {businessEvent: Scalars['String'],amount: Scalars['Float'],amountInPercentage?: (Scalars['Float'] | null),amountInHomeCurrency?: (Scalars['Float'] | null),affiliatedEntityId?: (Scalars['ID'] | null),pairedEntityId?: (Scalars['String'] | null),pairedEntityType?: (PairedEntityType | null),pairingType?: (PairingType | null),classificationTagId?: (Scalars['String'] | null),classificationTagText?: (Scalars['String'] | null),classificationText?: (Scalars['String'] | null),description?: (Scalars['String'] | null),extraData?: (Scalars['JSONObject'] | null),askTheUserResult?: (Scalars['JSONObject'] | null)}

export interface BusinessEventDataGenqlSelection{
    id?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BusinessEventDefinitionGenqlSelection{
    id?: boolean | number
    name?: boolean | number
    customerDisplayName?: boolean | number
    groups?: boolean | number
    vendorRequired?: boolean | number
    requiredAffiliatedEntityType?: boolean | number
    irrelevantForVendor?: boolean | number
    hideForManualClassification?: boolean | number
    forceShowInEventsListings?: boolean | number
    moneyDirection?: boolean | number
    customerDescriptionTemplate?: boolean | number
    isRelevantToAccruals?: boolean | number
    isRelevantToAccrualsFixedAsset?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BusinessEventDefinitionsByGroups {groups: Scalars['String'][]}

export interface BusinessEventDefinitionsByIds {ids: Scalars['String'][]}

export interface BusinessEventInput {classifications: BusinessEventClassificationInput[]}

export interface BusinessEventItemToReconcile {companyId: Scalars['ID'],businessEventId: Scalars['ID']}

export interface BusinessEventsAccrualsConfigGenqlSelection{
    id?: boolean | number
    isRelevantToAccruals?: boolean | number
    isRelevantToAccrualsFixedAsset?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BusinessEventsAccrualsConfigV2GenqlSelection{
    companyId?: boolean | number
    event?: BusinessEventDefinitionGenqlSelection
    isRelevantToAccruals?: boolean | number
    isRelevantToAccrualsFixedAsset?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CalculateInvoiceInput {id?: (Scalars['ID'] | null),companyId: Scalars['ID'],companyAddressId?: (Scalars['ID'] | null),customerId?: (Scalars['ID'] | null),shippingAddressId?: (Scalars['ID'] | null),billingAddressId?: (Scalars['ID'] | null),displayName?: (Scalars['String'] | null),postedAt?: (Scalars['Date'] | null),dueDate?: (Scalars['Date'] | null),taxFixedAmount: Scalars['Float'],taxType?: (SaleTaxType | null),lineItems: SaleLineItemInput[],discounts: DiscountInput[],paymentMethodIds: Scalars['ID'][],customerNote?: (Scalars['String'] | null),issueInvoice?: (Scalars['Boolean'] | null),currency: CurrencyCode}

export interface CalendlyEventInput {eventId: Scalars['String'],inviteeId: Scalars['String']}

export interface CalendlyEventResponseGenqlSelection{
    email?: boolean | number
    name?: boolean | number
    phoneNumber?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CancelAccrualInput {companyId: Scalars['ID'],bankTransactionId: Scalars['ID'],canceledAtData: CanceledAtDataItem[]}

export interface CancelAccrualV2Input {companyId: Scalars['ID'],entityType: AccrualEntityType,entityId: Scalars['ID'],canceledAtData: CanceledAtDataItem[]}

export interface CanceledAccrualDataGenqlSelection{
    classificationTagId?: boolean | number
    businessEventType?: boolean | number
    spreadType?: boolean | number
    /** @deprecated use customSpreadOptions instead */
    residualAmount?: boolean | number
    specificDate?: SpecificDateGenqlSelection
    spreadOverTime?: SpreadOverTimeGenqlSelection
    customSpread?: CustomSpreadGenqlSelection
    customSpreadOptions?: CustomSpreadOptionsGenqlSelection
    defaultFixedAssetsData?: DefaultFixedAssetsDataGenqlSelection
    customFixedAssetsData?: CustomFixedAssetsDataGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CanceledAtDataItem {canceledAt: Scalars['String'],classificationTagId?: (Scalars['String'] | null),businessEventType: Scalars['String']}

export interface CancelInvalidInventoryPaymentGroupsInput {companyId: Scalars['ID']}

export interface CancelInvalidInventoryPaymentGroupsResponseGenqlSelection{
    canceledGroupIds?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CategorizeBankTransactionsInput {companyId: Scalars['ID'],categorizations: BankTransactionCategorizationInput[]}

export interface CategorizeUncategorizedBillsTaskGenqlSelection{
    id?: boolean | number
    status?: boolean | number
    stateKey?: boolean | number
    amount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CategoryGenqlSelection{
    description?: boolean | number
    amount?: boolean | number
    classificationTag?: ClassificationTagGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CategoryBreakdownGenqlSelection{
    category?: boolean | number
    amount?: boolean | number
    costType?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ChangeLogGenqlSelection{
    id?: boolean | number
    createdAt?: boolean | number
    updaterType?: boolean | number
    changedByUid?: boolean | number
    reason?: boolean | number
    on_AddMissingBillsTaskStateChangeLog?: AddMissingBillsTaskStateChangeLogGenqlSelection
    on_AddMissingInvoicesTaskStateChangeLog?: AddMissingInvoicesTaskStateChangeLogGenqlSelection
    on_CloseOpenBillsTaskStateChangeLog?: CloseOpenBillsTaskStateChangeLogGenqlSelection
    on_CloseOpenInvoicesTaskStateChangeLog?: CloseOpenInvoicesTaskStateChangeLogGenqlSelection
    on_ConfirmApBalanceTaskStateChangeLog?: ConfirmApBalanceTaskStateChangeLogGenqlSelection
    on_ConfirmArBalanceTaskStateChangeLog?: ConfirmArBalanceTaskStateChangeLogGenqlSelection
    on_LinkInvoicePaymentsTaskStateChangeLog?: LinkInvoicePaymentsTaskStateChangeLogGenqlSelection
    on_YearEndDomainStateChangeLog?: YearEndDomainStateChangeLogGenqlSelection
    on_YearEndDomainStateDataChangeLog?: YearEndDomainStateDataChangeLogGenqlSelection
    on_YearEndEmailChangeLog?: YearEndEmailChangeLogGenqlSelection
    on_YearEndIntercomLinkChangeLog?: YearEndIntercomLinkChangeLogGenqlSelection
    on_YearEndStateChangeLog?: YearEndStateChangeLogGenqlSelection
    on_YearEndUserUnresponsiveChangeLog?: YearEndUserUnresponsiveChangeLogGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ChangeProductsHiddenStatusInput {companyId: Scalars['ID'],productStatusChange: ProductStatusChangeInput[]}

export interface ChargebackGenqlSelection{
    companyId?: boolean | number
    id?: boolean | number
    source?: boolean | number
    integrationAccountId?: boolean | number
    integrationAccountName?: boolean | number
    amount?: boolean | number
    currency?: boolean | number
    postedAt?: boolean | number
    disputeId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ChartDataInput {companyId: Scalars['ID'],chartName: Scalars['String'],fromDate: Scalars['Date'],toDate: Scalars['Date'],breakdown: Scalars['String'],timezone: Scalars['String'],comparisonPeriod: Scalars['String'],view?: (ViewTypes | null)}

export interface ChartDataResponseGenqlSelection{
    title?: boolean | number
    updatedAt?: boolean | number
    category?: boolean | number
    data?: DataSerieGenqlSelection
    labels?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CheckAwaitedExportStatusInput {companyId: Scalars['ID'],requestId: Scalars['String']}

export interface ClassificationInput {businessEvent: Scalars['String'],amount: Scalars['Float'],description?: (Scalars['String'] | null),pairedEntityId?: (Scalars['String'] | null),pairedEntityType?: (PairedEntityType | null),pairingType?: (PairingType | null)}

export interface ClassificationMetadataGenqlSelection{
    enrichmentRuleType?: boolean | number
    enrichmentRuleId?: boolean | number
    businessEventRuleType?: boolean | number
    businessEventRuleId?: boolean | number
    isAugmented?: boolean | number
    actorType?: boolean | number
    actorId?: boolean | number
    classifiedAt?: boolean | number
    recommendations?: ClassificationMetadataRecommendationGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ClassificationMetadataInput {enrichmentRuleType?: (Scalars['EnrichmentRuleType'] | null),enrichmentRuleId?: (Scalars['String'] | null),businessEventRuleType?: (Scalars['BusinessEventRuleType'] | null),businessEventRuleId?: (Scalars['String'] | null),isAugmented?: (Scalars['Boolean'] | null),metadata?: (Scalars['JSONObject'] | null)}

export interface ClassificationMetadataRecommendationGenqlSelection{
    chosenRecommendation?: ClassificationRecommendationGenqlSelection
    mechanism?: boolean | number
    value?: ClassificationMetadataRecommendationValueGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ClassificationMetadataRecommendationOptionValueGenqlSelection{
    seenOptions?: ClassificationRecommendationGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ClassificationMetadataRecommendationPromptValueGenqlSelection{
    prompt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ClassificationMetadataRecommendationValueGenqlSelection{
    on_ClassificationMetadataRecommendationOptionValue?:ClassificationMetadataRecommendationOptionValueGenqlSelection,
    on_ClassificationMetadataRecommendationPromptValue?:ClassificationMetadataRecommendationPromptValueGenqlSelection,
    __typename?: boolean | number
}

export interface ClassificationRecommendationGenqlSelection{
    tagId?: boolean | number
    score?: boolean | number
    model?: boolean | number
    recommendationsSource?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ClassificationRecommendationsInput {chosenRecommendation?: (ClassificationRecommendationTag | null),mechanism: RecommendedBy,optionValue?: (DecisionClassificationMetadataRecommendationOptionValue | null),promptValue?: (DecisionClassificationMetadataRecommendationPromptValue | null)}

export interface ClassificationRecommendationTag {tagId: Scalars['String'],score: Scalars['Float'],model?: (Scalars['String'] | null),recommendationsSource?: (RecommendationSource | null)}

export interface ClassificationRequestInput {id: Scalars['ID'],merchant?: (MerchantInput | null),businessEvent?: (BusinessEventInput | null),allowClassificationForVersion: Scalars['AllowClassificationForVersion'],classificationMetadata: ClassificationMetadataInput,recommendations?: (ClassificationRecommendationsInput | null)}

export interface ClassificationResultGenqlSelection{
    current?: BankTransactionGenqlSelection
    previous?: BankTransactionGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ClassificationTagGenqlSelection{
    id?: boolean | number
    name?: boolean | number
    moneyDirection?: boolean | number
    isHidden?: boolean | number
    isRelevantToBills?: boolean | number
    isRelevantToApplyAlways?: boolean | number
    displayNameForReports?: boolean | number
    keywords?: boolean | number
    classification?: ClassificationTagClassificationGenqlSelection
    isApplicableForRefund?: boolean | number
    weight?: boolean | number
    reportsDisplayNameForTagSelection?: boolean | number
    createdAt?: boolean | number
    updatedAt?: boolean | number
    lastUpdatedBy?: boolean | number
    classificationBusinessEventEffects?: ClassificationTagBusinessEventEffectsGenqlSelection
    triggeringClassificationFlowsConditions?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ClassificationTagBusinessEventEffectsGenqlSelection{
    moneyInBusinessEvent?: BusinessEventActionsConfigurationGenqlSelection
    moneyOutBusinessEvent?: BusinessEventActionsConfigurationGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ClassificationTagClassificationGenqlSelection{
    in?: boolean | number
    out?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ClassificationTagsByIdsInput {ids: Scalars['ID'][]}

export interface ClassificationTagsInput {forBillsOnly?: (Scalars['Boolean'] | null)}

export interface ClassificationTagSuggestionsResponseGenqlSelection{
    suggestions?: ClassificationTagWithSuggestionReasonGenqlSelection
    debuggingInfo?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ClassificationTagWithSuggestionReasonGenqlSelection{
    classificationTag?: ClassificationTagGenqlSelection
    confidenceScore?: boolean | number
    reason?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ClassifyIntegrationTransferInput {companyId: Scalars['ID'],classifications: IntegrationTransferClassificationInput[]}

export interface CloseOpenBillsTaskGenqlSelection{
    id?: boolean | number
    status?: boolean | number
    stateKey?: boolean | number
    currentBillsHash?: boolean | number
    state?: CloseOpenBillsTaskStateGenqlSelection
    history?: CloseOpenBillsTaskStateChangeLogGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CloseOpenBillsTaskStateGenqlSelection{
    confirmedBillsHash?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CloseOpenBillsTaskStateChangeLogGenqlSelection{
    id?: boolean | number
    createdAt?: boolean | number
    updaterType?: boolean | number
    changedByUid?: boolean | number
    reason?: boolean | number
    oldValue?: CloseOpenBillsTaskStateGenqlSelection
    newValue?: CloseOpenBillsTaskStateGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CloseOpenInvoicesTaskGenqlSelection{
    id?: boolean | number
    status?: boolean | number
    stateKey?: boolean | number
    currentInvoicesHash?: boolean | number
    state?: CloseOpenInvoicesTaskStateGenqlSelection
    history?: CloseOpenInvoicesTaskStateChangeLogGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CloseOpenInvoicesTaskStateGenqlSelection{
    confirmedInvoicesHash?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CloseOpenInvoicesTaskStateChangeLogGenqlSelection{
    id?: boolean | number
    createdAt?: boolean | number
    updaterType?: boolean | number
    changedByUid?: boolean | number
    reason?: boolean | number
    oldValue?: CloseOpenInvoicesTaskStateGenqlSelection
    newValue?: CloseOpenInvoicesTaskStateGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ClosingBalanceGenqlSelection{
    companyId?: boolean | number
    id?: boolean | number
    source?: boolean | number
    integrationAccountId?: boolean | number
    integrationAccountName?: boolean | number
    amount?: boolean | number
    currency?: boolean | number
    appliedAt?: boolean | number
    type?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface COGSBreakdownItemGenqlSelection{
    product?: ProductGenqlSelection
    quantity?: boolean | number
    avgCostPerUnit?: boolean | number
    totalCogs?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface COGSEventGenqlSelection{
    id?: boolean | number
    groupName?: boolean | number
    period?: COGSEventPeriodGenqlSelection
    amount?: boolean | number
    salesChannel?: SalesChannelGenqlSelection
    lineOfBusinessId?: boolean | number
    memo?: boolean | number
    type?: boolean | number
    source?: boolean | number
    isFullyProcessed?: boolean | number
    costType?: boolean | number
    categoryBreakdown?: CategoryBreakdownGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface COGSEventPeriodGenqlSelection{
    fromDate?: boolean | number
    toDate?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface COGSSummaryV2GenqlSelection{
    groupName?: boolean | number
    type?: boolean | number
    sum?: boolean | number
    salesChannel?: SalesChannelGenqlSelection
    realtimeSum?: boolean | number
    manualSum?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CommonActionGenqlSelection{
    quantity?: boolean | number
    id?: boolean | number
    date?: boolean | number
    type?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CommonWarehouseTransfersFilterInput {companyId: Scalars['String'],productIds?: (Scalars['String'][] | null),warehouseTransferIds?: (Scalars['String'][] | null),shippingDate?: (WarehouseTimeRangeInput | null),arrivalDate?: (WarehouseTimeRangeInput | null),warehouse?: (WarehouseFilter | null),textSearch?: (Scalars['String'] | null),withDeleted?: (Scalars['Boolean'] | null),vendorId?: (Scalars['String'] | null),paidStatus?: (PaidStatus[] | null)}

export interface CompanyGenqlSelection{
    id?: boolean | number
    billing?: CompanyBillingGenqlSelection
    name?: boolean | number
    userName?: boolean | number
    refferalCode?: boolean | number
    source?: boolean | number
    email?: boolean | number
    isManufacturer?: boolean | number
    phoneNumber?: boolean | number
    address?: AddressGenqlSelection
    accountingMethod?: boolean | number
    booksStartTime?: boolean | number
    dataRestrictionTime?: boolean | number
    /** @deprecated use balanceSheetSetup instead */
    balanceSheetStatus?: BalanceSheetStatusGenqlSelection
    customerSelectedAccountingMethod?: boolean | number
    inventorySettings?: InventorySettingsGenqlSelection
    ordersSettings?: OrdersSettingsGenqlSelection
    generalDetails?: boolean | number
    configuration?: CompanyConfigurationGenqlSelection
    isTestCompany?: boolean | number
    isArchived?: boolean | number
    createdAtMs?: boolean | number
    createdAtIso?: boolean | number
    canceledAtIso?: boolean | number
    preloadEmail?: boolean | number
    eventsLock?: boolean | number
    eventsLock2?: EventsLockGenqlSelection
    legalEntityType?: boolean | number
    taxEntityType?: boolean | number
    trialStartTimeIso?: boolean | number
    trialStartTimeMs?: boolean | number
    trialDurationInDays?: boolean | number
    isPaying?: boolean | number
    fullUiAccess?: boolean | number
    paymentStatus?: boolean | number
    tier?: boolean | number
    tierAtConversion?: boolean | number
    taxPlan?: boolean | number
    stripeCustomerId?: boolean | number
    isOnboardingCompleted?: boolean | number
    onboardingCompletedAtIso?: boolean | number
    onboardingState?: OnBoardingStateGenqlSelection
    isParkerReferral?: boolean | number
    estimatedProjectedRevenue?: boolean | number
    calculatedTier?: boolean | number
    hasActiveTrial?: boolean | number
    lockStatus?: CompanyLockStatusGenqlSelection
    isLiveTestCompany?: boolean | number
    gtmSource?: GTMSourceGenqlSelection
    fiscalYearStart?: CompanyFiscalYearStartGenqlSelection
    lockHistory?: CompanyLockHistoryGenqlSelection
    appsSelectedInPreOnboarding?: boolean | number
    referralCode?: boolean | number
    endOfYearDeadline?: boolean | number
    booksStatus?: boolean | number
    accountingServices?: boolean | number
    demo?: boolean | number
    preOnboardingFunnelType?: boolean | number
    isPremiumService?: boolean | number
    isPartner?: boolean | number
    isTaxPlan?: boolean | number
    firstPaymentDate?: boolean | number
    balanceSheetSetup?: CompanyBalanceSheetSetupGenqlSelection
    customerSuccessManager?: boolean | number
    healthScore?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CompanyAccountValidationGenqlSelection{
    account?: boolean | number
    status?: boolean | number
    value?: boolean | number
    isError?: boolean | number
    asOfDate?: boolean | number
    updatedAt?: boolean | number
    lastSuccessfulRunAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CompanyAddressGenqlSelection{
    id?: boolean | number
    companyId?: boolean | number
    source?: boolean | number
    integrationAccountId?: boolean | number
    isDefault?: boolean | number
    name?: boolean | number
    email?: boolean | number
    phone?: boolean | number
    line1?: boolean | number
    line2?: boolean | number
    city?: boolean | number
    country?: boolean | number
    province?: boolean | number
    state?: boolean | number
    zip?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CompanyAddressInput {companyId: Scalars['ID'],id: Scalars['ID']}

export interface CompanyAffiliateGenqlSelection{
    id?: boolean | number
    companyId?: boolean | number
    type?: boolean | number
    name?: boolean | number
    createdAt?: boolean | number
    updatedAt?: boolean | number
    logoUrl?: boolean | number
    holdingsInPercentage?: boolean | number
    isForeignResident?: boolean | number
    balance?: boolean | number
    transactions?: CompanyAffiliateTransactionGenqlSelection
    status?: boolean | number
    affiliatedEntityId?: boolean | number
    latestAccountingEventIds?: boolean | number
    deletedAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CompanyAffiliateInput {id: Scalars['ID'],companyId: Scalars['ID']}

export interface CompanyAffiliatesByIdsInput {companyId?: (Scalars['ID'] | null),ids: Scalars['ID'][]}

export interface CompanyAffiliatesInput {companyId: Scalars['ID'],type?: (CompanyAffiliateType | null),searchTerm?: (Scalars['String'] | null)}

export interface CompanyAffiliateTransactionGenqlSelection{
    entityId?: boolean | number
    entityType?: boolean | number
    bankAccountId?: boolean | number
    postedAt?: boolean | number
    amount?: boolean | number
    currency?: boolean | number
    amountInUsd?: boolean | number
    type?: boolean | number
    source?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CompanyArCashDiffsActionsResponseGenqlSelection{
    accountRole?: boolean | number
    amount?: boolean | number
    isAccrual?: boolean | number
    isCash?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CompanyArCashDiffsFixbooksResponseGenqlSelection{
    eventTime?: boolean | number
    createdAt?: boolean | number
    creatorEmail?: boolean | number
    integrationAccountId?: boolean | number
    memo?: boolean | number
    actions?: CompanyArCashDiffsActionsResponseGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CompanyArCashDiffsInput {companyId: Scalars['ID'],unpaidBalanceAsOf?: (Scalars['Date'] | null)}

export interface CompanyArCashDiffsOrdersResponseGenqlSelection{
    orderId?: boolean | number
    integrationAccountId?: boolean | number
    externalSourceId?: boolean | number
    displayName?: boolean | number
    ordersVsBooks?: boolean | number
    ordersBalance?: boolean | number
    booksBalance?: boolean | number
    placedAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CompanyArCashDiffsResponseGenqlSelection{
    companyId?: boolean | number
    reportDate?: boolean | number
    orders?: CompanyArCashDiffsOrdersResponseGenqlSelection
    fixbooks?: CompanyArCashDiffsFixbooksResponseGenqlSelection
    totals?: CompanyArCashTotalsResponseGenqlSelection
    lockTime?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CompanyArCashTotalsResponseGenqlSelection{
    arCashInBooks?: boolean | number
    unpaidOrders?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CompanyArtificialFulfillmentSettingsInput {companyId: Scalars['ID']}

export interface CompanyBalanceSheetSetupGenqlSelection{
    state?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CompanyBillingGenqlSelection{
    features?: boolean | number
    purchasedOffers?: PurchasedOfferGenqlSelection
    portalUrl?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CompanyByStripeCustomerIdInput {stripeCustomerId: Scalars['String']}

export interface CompanyConfigurationGenqlSelection{
    isPnlReportReady?: boolean | number
    isBalanceSheetReportFinal?: boolean | number
    includeCCAccountsInCashFlowBeforePayment?: boolean | number
    includeUDFAccountsInCashFlowBeforeDeposit?: boolean | number
    cashFlowStartTimeISO?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CompanyDomainState {companyId: Scalars['ID'],state: YearEndDomainState,reason?: (Scalars['String'] | null)}

export interface CompanyEventsLockHistoryGenqlSelection{
    year?: boolean | number
    createdAt?: boolean | number
    userEmail?: boolean | number
    type?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CompanyFiscalYearStartGenqlSelection{
    day?: boolean | number
    month?: boolean | number
    userEmail?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CompanyFundedStatusGenqlSelection{
    hideBanner?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CompanyHasBankingMissionInput {companyId: Scalars['ID'],triggerEvaluationIfRequired?: (Scalars['Boolean'] | null)}

export interface CompanyHealthStatusGenqlSelection{
    company?: CompanyGenqlSelection
    domains?: CompanyValidationDomainGenqlSelection
    status?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CompanyIdAndStripeCustomerIdGenqlSelection{
    companyId?: boolean | number
    stripeCustomerId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CompanyIdInput {companyId: Scalars['ID']}

export interface CompanyIntegrationGenqlSelection{
    companyId?: boolean | number
    integrationType?: boolean | number
    integrationAccountId?: boolean | number
    integrationTypeAndIntegrationAccountId?: boolean | number
    data?: boolean | number
    enabled?: boolean | number
    impactOnBooksSince?: boolean | number
    createdAtMs?: boolean | number
    deletedByUserAt?: boolean | number
    deletedByUserId?: boolean | number
    disconnectedAt?: boolean | number
    disconnectedBy?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CompanyIntegrationBulkUpdateInput {companyId: Scalars['ID'],updateExpression: UpdateExpression}

export interface CompanyIntegrationInput {companyId: Scalars['ID'],integrationType: IntegrationType,integrationAccountId: Scalars['String']}

export interface CompanyIntegrationsInput {companyId: Scalars['ID'],integrationType?: (IntegrationType | null)}

export interface CompanyInvoicePayInput {id: Scalars['ID'],companyId: Scalars['ID']}

export interface CompanyLoanGenqlSelection{
    id?: boolean | number
    company?: CompanyGenqlSelection
    source?: boolean | number
    integrationAccountId?: boolean | number
    externalSourceId?: boolean | number
    integrationAccountName?: boolean | number
    type?: boolean | number
    lender?: NewLenderGenqlSelection
    currency?: boolean | number
    postedAt?: boolean | number
    direction?: boolean | number
    isShortTerm?: boolean | number
    amount?: boolean | number
    totalAmount?: boolean | number
    outstandingAmount?: boolean | number
    accruedInterest?: boolean | number
    unrecognizedFees?: boolean | number
    prepaymentLiabilityAmount?: boolean | number
    status?: boolean | number
    userActionStatus?: boolean | number
    acknowledgedInternallyAt?: boolean | number
    acknowledgedInternallyBy?: boolean | number
    paidOffAt?: boolean | number
    attachments?: LoanAttachmentGenqlSelection
    workingPaperLink?: boolean | number
    updatedBy?: boolean | number
    lockedAt?: boolean | number
    lastSeenByClientAt?: boolean | number
    deletedAt?: boolean | number
    createdAt?: boolean | number
    updatedAt?: boolean | number
    interestDays?: boolean | number
    repaymentType?: boolean | number
    repaymentFrequency?: boolean | number
    repaymentRate?: boolean | number
    interestRateType?: boolean | number
    interestRate?: boolean | number
    gracePeriod?: boolean | number
    catchUpPeriod?: boolean | number
    catchUpPercent?: boolean | number
    originationFees?: boolean | number
    prepaymentFees?: boolean | number
    recurringDataFrequency?: boolean | number
    instantRepaymentMethod?: boolean | number
    isIndexLinked?: boolean | number
    interestType?: boolean | number
    variableInterestUpdatePeriod?: boolean | number
    variableInterestSpread?: boolean | number
    variableInterestBase?: boolean | number
    compoundFrequency?: boolean | number
    indexType?: boolean | number
    isEarlyRepaymentDiscount?: boolean | number
    earlyRepaymentDiscounts?: EarlyRepaymentDiscountGenqlSelection
    transactions?: BankTransactionGenqlSelection
    lastTransaction?: BankTransactionGenqlSelection
    userFollowUp2?: UserFollowUpGenqlSelection
    askIfRepaid?: boolean | number
    hideOutdatedWarning?: boolean | number
    deleteOptionMode?: boolean | number
    pendingDelete?: boolean | number
    pendingRestoreAcknowledgement?: boolean | number
    lastUserMoveToProcessingAt?: boolean | number
    dataRequestType?: boolean | number
    isHidden?: boolean | number
    lastEventDate?: boolean | number
    isBillPaymentEventAttached?: boolean | number
    firstPaymentDate?: boolean | number
    lastPaymentDate?: boolean | number
    creationSource?: boolean | number
    hasRollOverEvent?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CompanyLoanAttachmentUpdateResultGenqlSelection{
    success?: boolean | number
    errors?: LoanAttachmentErrorGenqlSelection
    loan?: CompanyLoanGenqlSelection
    processing?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CompanyLoanResponseGenqlSelection{
    loan?: CompanyLoanGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CompanyLoansResponseGenqlSelection{
    loans?: CompanyLoanGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CompanyLockConditionsGenqlSelection{
    accountingMethod?: boolean | number
    moneyIn?: boolean | number
    moneyOut?: boolean | number
    reclassificationMoneyIn?: boolean | number
    reclassificationMoneyOut?: boolean | number
    assetsEqualToLiabilitiesAndEquities?: boolean | number
    isPayrollOk?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CompanyLockHistoryGenqlSelection{
    type?: boolean | number
    userEmail?: boolean | number
    startDate?: boolean | number
    endDate?: boolean | number
    createdAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CompanyLockStatusGenqlSelection{
    minimumAllowedEventTime?: boolean | number
    lockedAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CompanyMainHolderInput {companyId: Scalars['ID']}

export interface CompanySyncBodyInput {id: Scalars['ID'],booksStartTime?: (Scalars['Date'] | null),deletedAt?: (Scalars['Date'] | null),name?: (Scalars['String'] | null),accountingMethod?: (Scalars['String'] | null),isTestCompany?: (Scalars['Boolean'] | null),booksStatus?: (Scalars['JSON'] | null),isArchived?: (Scalars['Boolean'] | null),archivedAtIso?: (Scalars['Date'] | null),createdAt?: (Scalars['Date'] | null),tier?: (CompanyTierType | null),trialStartTime?: (Scalars['Date'] | null),trialDurationInDays?: (Scalars['Int'] | null),isPaying?: (Scalars['Boolean'] | null),eventsLock?: (Scalars['JSON'] | null),isLiveTestCompany?: (Scalars['Boolean'] | null)}

export interface CompanyUserGenqlSelection{
    email?: boolean | number
    roles?: UserRoleGenqlSelection
    name?: boolean | number
    auth0Id?: boolean | number
    invitationStatus?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CompanyUsersArgs {companyId: Scalars['String']}

export interface CompanyUsersResponseGenqlSelection{
    users?: CompanyUserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CompanyValidationGenqlSelection{
    type?: boolean | number
    metricName?: boolean | number
    name?: boolean | number
    status?: boolean | number
    accounts?: CompanyAccountValidationGenqlSelection
    asOfDate?: boolean | number
    updatedAt?: boolean | number
    lastSuccessfulRunAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CompanyValidationDomainGenqlSelection{
    type?: boolean | number
    name?: boolean | number
    status?: boolean | number
    validations?: CompanyValidationGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CompanyValidationSortByValidationInput {validationType: CompanyValidationType,metricName?: (CompanyValidationMetricName | null)}

export interface CompanyWorksheetGenqlSelection{
    worksheetRows?: CompanyWorksheetRowGenqlSelection
    company?: CompanyGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CompanyWorksheetRowGenqlSelection{
    companyId?: boolean | number
    dateForLocking?: boolean | number
    name?: boolean | number
    amount?: boolean | number
    comment?: boolean | number
    signedAt?: boolean | number
    signedBy?: boolean | number
    signedByName?: boolean | number
    attachmentUrl?: boolean | number
    attachmentFileName?: boolean | number
    lockableEntity?: CompanyWorksheetRowLockableEntityGenqlSelection
    periodStart?: boolean | number
    periodEnd?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CompanyWorksheetRowLockableEntityGenqlSelection{
    on_BankAccount?:BankAccountGenqlSelection,
    __typename?: boolean | number
}

export interface CompleteValidationCycleInput {validationCycleId: Scalars['String']}

export interface ConfirmApBalanceTaskGenqlSelection{
    id?: boolean | number
    status?: boolean | number
    accountBalances?: APAccountBalanceGenqlSelection
    stateKey?: boolean | number
    state?: ConfirmApBalanceTaskStateGenqlSelection
    history?: ConfirmApBalanceTaskStateChangeLogGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ConfirmApBalanceTaskStateGenqlSelection{
    confirmedBalances?: APAccountBalanceGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ConfirmApBalanceTaskStateChangeLogGenqlSelection{
    id?: boolean | number
    createdAt?: boolean | number
    updaterType?: boolean | number
    changedByUid?: boolean | number
    reason?: boolean | number
    oldValue?: ConfirmApBalanceTaskStateGenqlSelection
    newValue?: ConfirmApBalanceTaskStateGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ConfirmArBalanceTaskGenqlSelection{
    id?: boolean | number
    status?: boolean | number
    stateKey?: boolean | number
    accountBalances?: AccountBalanceGenqlSelection
    state?: ConfirmArBalanceTaskStateGenqlSelection
    history?: ConfirmArBalanceTaskStateChangeLogGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ConfirmArBalanceTaskStateGenqlSelection{
    confirmedBalances?: AccountBalanceGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ConfirmArBalanceTaskStateChangeLogGenqlSelection{
    id?: boolean | number
    createdAt?: boolean | number
    updaterType?: boolean | number
    changedByUid?: boolean | number
    reason?: boolean | number
    oldValue?: ConfirmArBalanceTaskStateGenqlSelection
    newValue?: ConfirmArBalanceTaskStateGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ConfirmRoleForPaymentGatewayInput {companyId: Scalars['ID'],paymentGatewayType: PaymentGatewayType}

export interface ContractorGenqlSelection{
    id?: boolean | number
    company?: CompanyGenqlSelection
    source?: boolean | number
    department?: DepartmentGenqlSelection
    firstName?: boolean | number
    lastName?: boolean | number
    middleName?: boolean | number
    name?: boolean | number
    businessName?: boolean | number
    isActive?: boolean | number
    deletedAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ContractorPaymentGenqlSelection{
    id?: boolean | number
    company?: CompanyGenqlSelection
    source?: boolean | number
    integrationAccountId?: boolean | number
    integrationAccountName?: boolean | number
    reimbursements?: ReimbursementGenqlSelection
    externalSourceId?: boolean | number
    department?: DepartmentGenqlSelection
    postedAt?: boolean | number
    currency?: boolean | number
    wage?: boolean | number
    wageInHomeCurrency?: boolean | number
    bonus?: boolean | number
    bonusInHomeCurrency?: boolean | number
    categoryGroup?: boolean | number
    paymentChecksAmount?: boolean | number
    isPaymentChecksAmountImmaterial?: boolean | number
    deletedAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ContractorPaymentIdsByCompanyInput {companyIds: Scalars['ID'][],afterBooksStartTimeOnly?: (Scalars['Boolean'] | null)}

export interface ContractorPaymentIdsByCompanyItemGenqlSelection{
    companyId?: boolean | number
    contractorPaymentIds?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ContractorPaymentIdsByCompanyResponseGenqlSelection{
    items?: ContractorPaymentIdsByCompanyItemGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ContractorPaymentsInternalInput {companyId: Scalars['ID'],contractorPaymentIds: Scalars['ID'][]}

export interface ContractorPaymentsInternalResponseGenqlSelection{
    contractorPayments?: ContractorPaymentGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ConvertBankAccountBackFromManualInput {companyId: Scalars['ID'],bankAccountId: Scalars['ID']}

export interface ConvertBankAccountToManualInput {companyId: Scalars['ID'],bankAccountId: Scalars['ID'],startDate: Scalars['Date']}

export interface ConvertBetweenCurrenciesInput {amount: Scalars['Float'],asOfTime: Scalars['Date'],fromCurrency: Scalars['String'],toCurrency: Scalars['String']}

export interface ConvertBetweenCurrenciesResultGenqlSelection{
    convertedAmount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CopyBankAccountInput {sourceBankAccountId: Scalars['String'],newBankAccountId: Scalars['String'],companyId: Scalars['String'],integrationAccountId: Scalars['String'],status: BankAccountStatus}

export interface CreateAccountRoleInput {name: Scalars['String'],groupId: Scalars['ID'],sign: NaturalSign}

export interface CreateAdminBankReconciliationRequestInput {companyId: Scalars['ID'],bankAccountId: Scalars['ID'],requestType: BackOfficeCreateBankReconciliationRequestType,recurrence?: (BankReconciliationRequestRecurrence | null),startDate: Scalars['Date'],endDate?: (Scalars['Date'] | null)}

export interface CreateBankAccountInput {companyId: Scalars['ID'],id?: (Scalars['ID'] | null),integrationAccountId: Scalars['String'],source: IntegrationType,externalSourceId?: (Scalars['String'] | null),type: BankAccountType,subtype: BankAccountSubtype,connectionStatus?: (BankAccountConnectionStatus | null),lastUpdateTime?: (Scalars['Date'] | null),isHistoricalUpdateCompleted?: (Scalars['Boolean'] | null),currency?: (Scalars['String'] | null),externalInstitutionId?: (Scalars['String'] | null),institutionId?: (Scalars['String'] | null),institutionName: Scalars['String'],name: Scalars['String'],displayName: Scalars['String'],overrideFullName?: (Scalars['String'] | null),mask?: (Scalars['String'] | null),currentBalance?: (Scalars['Float'] | null),connectedAt?: (Scalars['Date'] | null),rawData?: (Scalars['JSONObject'] | null),shouldUpdateAccountDetailsOnNextUpdate?: (Scalars['Boolean'] | null),status: BankAccountStatus,createdByActor?: (ActorType | null),createdBy?: (Scalars['String'] | null),createdFromSource?: (Scalars['String'] | null)}

export interface CreateBankAccountStatementForStopImportInput {bankAccountId: Scalars['ID'],companyId: Scalars['ID'],stopImportFromDate: Scalars['String'],displayedBalance: Scalars['Float'],closedDate: Scalars['String'],isConfirmed: Scalars['Boolean'],fileNames: Scalars['String'][],csvFileNames?: (Scalars['String'][] | null),realBalance?: (Scalars['Float'] | null),newOwner?: (BankAccountNewOwner | null)}

export interface CreateBankStatementFileInput {companyId: Scalars['ID'],bankAccountId: Scalars['String'],s3Bucket: Scalars['String'],s3Key: Scalars['String'],uploadOriginator: Scalars['String'],skipMachineTrigger?: (Scalars['Boolean'] | null),originFileId?: (Scalars['ID'] | null),fileStatus?: (BankStatementFileStatus | null),uploadedOnBankTransactionId?: (Scalars['ID'] | null),bankStatementRequestId?: (Scalars['String'] | null),companyAffiliateType?: (CompanyAffiliateType | null),companyAffiliateId?: (Scalars['String'] | null),system?: (BankStatementFileSystem | null),subSystem?: (BankStatementFileSubSystem | null),uploadedBy: ActorType,uploadedById: Scalars['String']}

export interface CreateBankTransactionsUploadInput {companyId: Scalars['ID'],bankAccountId: Scalars['String'],bucket: Scalars['String'],key: Scalars['String'],uploadOriginator: Scalars['String'],uploadedBy: ActorType,uploadedById: Scalars['String'],uploadedAt: Scalars['Date'],skipMachineTrigger?: (Scalars['Boolean'] | null),originFileId?: (Scalars['ID'] | null),fileStatus?: (BankTransactionsUploadStatus | null),uploadedOnBankTransactionId?: (Scalars['ID'] | null),fileUrl?: (Scalars['String'] | null),bankStatementRequestId?: (Scalars['String'] | null),companyAffiliateType?: (CompanyAffiliateType | null),companyAffiliateId?: (Scalars['String'] | null)}

export interface CreateBigValidationAdjustmentInput {companyId: Scalars['ID'],date: Scalars['Date'],amount: Scalars['Float']}

export interface CreateCheckoutSessionInput {companyId: Scalars['ID'],paymentOptionIds: Scalars['ID'][],successUrl: Scalars['String'],cancelUrl: Scalars['String']}

export interface CreateCheckoutSessionResponseGenqlSelection{
    url?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CreateCompanyAffiliateInput {companyId: Scalars['ID'],name: Scalars['String'],type: CompanyAffiliateType,isForeignResident?: (Scalars['Boolean'] | null),holdingsInPercentage?: (Scalars['Float'] | null)}

export interface CreateCompanyInput {email: Scalars['String'],stripeCustomerId?: (Scalars['String'] | null),source?: (Scalars['JSON'] | null),referralCode?: (Scalars['String'] | null),isParkerReferral?: (Scalars['Boolean'] | null),withoutNotification?: (Scalars['Boolean'] | null),gtmSource?: (GTMSourceInput | null),appsSelectedInPreOnboarding?: (Scalars['String'][] | null)}

export interface CreateCompanyLoanFromTransactionClassificationInput {loanId?: (Scalars['ID'] | null),amount: Scalars['Float'],amountInPercentage?: (Scalars['Float'] | null),amountInHomeCurrency?: (Scalars['Float'] | null),classificationTagId?: (Scalars['ID'] | null),classificationText?: (Scalars['ID'] | null),businessEvent: Scalars['String'],affiliatedEntityId?: (Scalars['ID'] | null),pairedEntityId?: (Scalars['String'] | null),pairedEntityType?: (PairedEntityType | null),pairingType?: (PairingType | null),askTheUserResult?: (Scalars['JSONObject'] | null),extraData?: (Scalars['JSONObject'] | null),description?: (Scalars['String'] | null)}

export interface CreateCompanyLoanInput {companyId: Scalars['ID'],data: LoanUpdateBasicData}

export interface CreateCustomerArgs {name: Scalars['String'],companyName?: (Scalars['String'] | null),externalSourceId?: (Scalars['String'] | null),source: CustomerSource,email?: (Scalars['String'] | null),phoneNumber?: (Scalars['String'] | null),billingAddress?: (AddressArgs | null),shippingAddress?: (AddressArgs | null)}

export interface CreateCustomerCategorizationRuleInput {companyId: Scalars['ID'],applyForAlreadyCategorizedTransactions: Scalars['Boolean'],merchant: MerchantInput,moneyDirection: SimpleMoneyDirection,classification?: (CustomerCategorizationRuleClassificationInput | null),classifications?: (CustomerCategorizationRuleClassificationInput[] | null)}

export interface CreateCustomerCategorizationRuleResultGenqlSelection{
    realTimeApplierJobId?: boolean | number
    bankTransactionIdsAffectedByJobId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CreateFileUploadUrlInput {companyId: Scalars['String'],source: FileUploadSource,fileName: Scalars['String'],featureContext?: (Scalars['String'] | null)}

export interface CreateGlobalRuleResultGenqlSelection{
    id?: boolean | number
    success?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CreateGlobalVendorInput {id?: (Scalars['String'] | null),name: Scalars['String'],notificationInfo?: (VendorsNotificationInfoInput | null),subTypes?: (VendorSubType[] | null),is1099Contractor?: (Scalars['Boolean'] | null),websiteUrl?: (Scalars['String'] | null),source: VendorSource,labels?: (Scalars['String'][] | null)}

export interface CreateGlobalVendorRuleInput {vendorIds: Scalars['String'][]}

export interface CreateImageUploadUrlInput {companyId: Scalars['String'],fileName: Scalars['String']}

export interface CreateInstitutionInput {name: Scalars['String'],preferredProvider: InstitutionProviders,isMajor?: (Scalars['String'] | null),logoUrl?: (Scalars['String'] | null),websiteUrl?: (Scalars['String'] | null),csvInstructionsLink?: (Scalars['String'] | null),pdfInstructionsLink?: (Scalars['String'] | null),csvAvailable?: (Scalars['Boolean'] | null),pdfAvailable?: (Scalars['Boolean'] | null)}

export interface CreateInstitutionMappingsInput {source: InstitutionMappingSourceType,externalSourceId: Scalars['String'],externalSourceName: Scalars['String'],institutionId: Scalars['String']}

export interface CreateIntegrationTransferRuleInput {companyId: Scalars['ID'],integrationType: IntegrationType,companyAffiliateId: Scalars['ID'],integrationAccountId?: (Scalars['ID'] | null)}

export interface CreateInventoryVendorValidationInput {companyId: Scalars['ID'],fromDate?: (Scalars['Date'] | null),toDate?: (Scalars['Date'] | null),unpaidBillsUntil?: (Scalars['Date'] | null)}

export interface CreateInventoryVendorValidationResponseGenqlSelection{
    validationId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CreateLoanEventDefinitionInput {name: Scalars['String']}

export interface CreateLoanFromBalanceTransactionInput {companyId: Scalars['ID'],balanceTransactionId: Scalars['ID']}

export interface CreateLoanFromBillFinancedInput {companyId: Scalars['ID'],billId: Scalars['ID']}

export interface CreateLoanInput {companyId: Scalars['ID'],data: LoanUpdateData,merchantRole?: (CompanyAffiliateType | null)}

export interface CreateLoansEventsEffectConfigurationInput {eventDefinitionId: Scalars['ID'],loanType: LoanType,isShortTerm: Scalars['Boolean'],direction: LoanDirection,minGracePeriod?: (Scalars['Int'] | null),repaymentType?: (LoanRepaymentType | null),lenderId?: (Scalars['ID'] | null),memoTemplate?: (Scalars['String'] | null),dateTemplate?: (Scalars['String'] | null),accrualConfig?: (JournalEntryActionsInput | null),cashConfig?: (JournalEntryActionsInput | null),loanOutstandingAmountAffect?: (LoanOutstandingAmountAffect | null),loanAmountAffect?: (LoanAmountEffect | null)}

export interface CreateManualBankAccountInput {companyId: Scalars['ID'],nameOnBooks: Scalars['String'],institutionName: Scalars['String'],institutionId?: (Scalars['String'] | null),accountName: Scalars['String'],mask?: (Scalars['String'] | null),type: BankAccountType,subType: BankAccountSubtype,currency?: (Scalars['String'] | null),createdFromSource: Scalars['String']}

export interface CreateManualLoanEventInput {companyId: Scalars['ID'],loanId: Scalars['ID'],events: CreateManualLoanEventInputEvents[]}

export interface CreateManualLoanEventInput2 {companyId: Scalars['ID'],loanId: Scalars['ID'],eventDefinitionId: Scalars['ID'],amount: Scalars['Float'],memo?: (Scalars['String'] | null),postedAt?: (Scalars['Date'] | null),spreadInput?: (CreateManualLoanEventSpreadInput | null),recurrenceSettings: RecurrenceSettingsInput}

export interface CreateManualLoanEventInputEvents {eventDefinitionId: Scalars['ID'],amount: Scalars['Float'],memo?: (Scalars['String'] | null),postedAt: Scalars['Date']}

export interface CreateManualLoanEventSpreadInput {startDate: Scalars['Date'],endDate: Scalars['Date']}

export interface CreateOrGetBusinessEventDefinitionInput {type: Scalars['String'],variant: Scalars['String'],accrualConfig?: (JournalEntryActionsInput | null),cashConfig?: (JournalEntryActionsInput | null),originalActorId?: (Scalars['String'] | null),originalActorType?: (ActorType | null),integrationType: Scalars['String'],name?: (Scalars['String'] | null),customerDisplayName?: (Scalars['String'] | null),groups?: (Scalars['String'][] | null),vendorRequired?: (Scalars['Boolean'] | null),requiredAffiliatedEntityType?: (Scalars['String'] | null),irrelevantForVendor?: (Scalars['Boolean'] | null),hideForManualClassification?: (Scalars['Boolean'] | null),forceShowInEventsListings?: (Scalars['Boolean'] | null),isRelevantToAccruals?: (Scalars['Boolean'] | null),moneyDirection?: (MoneyDirection | null)}

export interface CreateOrUpdateAccrualInput {companyId: Scalars['ID'],bankTransactionId: Scalars['ID'],accrualsData: AccrualDataInput[],categorizations?: (AccrualCategorizationInput[] | null)}

export interface CreateOrUpdateAccrualResultGenqlSelection{
    bankTransaction?: BankTransactionGenqlSelection
    status?: boolean | number
    error?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CreateProductManuallyErrorGenqlSelection{
    message?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CreateProductManuallyInput {source?: (Scalars['String'] | null),integrationAccountId?: (Scalars['String'] | null),companyId: Scalars['String'],displayName: Scalars['String'],sku: Scalars['String'],imageUrl?: (Scalars['String'] | null),isFractional: Scalars['Boolean'],platformId?: (Scalars['String'] | null)}

export interface CreateProductManuallyResponseGenqlSelection{
    on_CreateProductManuallyError?:CreateProductManuallyErrorGenqlSelection,
    on_CreateProductManuallySuccess?:CreateProductManuallySuccessGenqlSelection,
    __typename?: boolean | number
}

export interface CreateProductManuallySuccessGenqlSelection{
    product?: ProductGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CreateShopifyProductsFromDiagnosticsInput {companyId: Scalars['ID'],fromDate: Scalars['Date'],toDate: Scalars['Date']}

export interface CreateTeamCategorizationRuleResultGenqlSelection{
    realTimeApplierJobId?: boolean | number
    bankTransactionIdsAffectedByJobId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CreateUserResponseGenqlSelection{
    user?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CreateVendorArgs {id?: (Scalars['ID'] | null),companyId: Scalars['ID'],name: Scalars['String'],notificationInfo?: (VendorsNotificationInfoInput | null),subTypes?: (VendorSubType[] | null),is1099Contractor?: (Scalars['Boolean'] | null),contactEmail?: (Scalars['String'] | null),source: VendorSource,externalSourceId?: (Scalars['String'] | null),isPaymentVendor?: (Scalars['Boolean'] | null),labels?: (Scalars['String'][] | null),logoUrl?: (Scalars['String'] | null),websiteUrl?: (Scalars['String'] | null)}

export interface CreateWarehouseInput {companyId: Scalars['String'],source: Scalars['String'],name: Scalars['String'],phone?: (Scalars['String'] | null),city?: (Scalars['String'] | null),province?: (Scalars['String'] | null),country?: (Scalars['String'] | null),zip?: (Scalars['String'] | null),address?: (Scalars['String'] | null),isDropshipping?: (Scalars['Boolean'] | null)}

export interface CSVUploadGenqlSelection{
    name?: boolean | number
    uploadId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CurrentlyRunningInventoryDataSyncInput {companyId: Scalars['ID']}

export interface CurrentlyRunningInventoryDataSyncResponseGenqlSelection{
    totalItems?: boolean | number
    completedItems?: boolean | number
    updatingProducts?: ProductGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CurrentlyRunningInventoryDataSyncVendorsResponseGenqlSelection{
    affiliatedEntities?: AffiliatedEntityGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CurrentPreviousValueGenqlSelection{
    current?: boolean | number
    previous?: boolean | number
    unitType?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CustomerGenqlSelection{
    id?: boolean | number
    name?: boolean | number
    companyId?: boolean | number
    companyName?: boolean | number
    externalSourceId?: boolean | number
    source?: boolean | number
    email?: boolean | number
    phoneNumber?: boolean | number
    billingAddress?: CustomerAddressOldGenqlSelection
    shippingAddress?: CustomerAddressOldGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CustomerAddressGenqlSelection{
    id?: boolean | number
    country?: boolean | number
    countryCode?: boolean | number
    state?: boolean | number
    stateCode?: boolean | number
    province?: boolean | number
    provinceCode?: boolean | number
    city?: boolean | number
    zip?: boolean | number
    line1?: boolean | number
    line2?: boolean | number
    isShipping?: boolean | number
    isBilling?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CustomerAddressArgs {line1: Scalars['String'],line2?: (Scalars['String'] | null),city: Scalars['String'],country: Scalars['String'],countryCode?: (Scalars['String'] | null),province?: (Scalars['String'] | null),provinceCode?: (Scalars['String'] | null),state?: (Scalars['String'] | null),stateCode?: (Scalars['String'] | null),zip?: (Scalars['String'] | null),source: CustomerSource}

export interface CustomerAddressOldGenqlSelection{
    country?: boolean | number
    state?: boolean | number
    city?: boolean | number
    postalCode?: boolean | number
    line1?: boolean | number
    line2?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CustomerAddressV3GenqlSelection{
    id?: boolean | number
    phoneNumber?: boolean | number
    country?: boolean | number
    countryCode?: boolean | number
    state?: boolean | number
    stateCode?: boolean | number
    province?: boolean | number
    provinceCode?: boolean | number
    city?: boolean | number
    zip?: boolean | number
    line1?: boolean | number
    line2?: boolean | number
    isShipping?: boolean | number
    isBilling?: boolean | number
    deletedAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CustomerCategorizationRuleClassificationInput {classificationTagId?: (Scalars['ID'] | null),businessEvent?: (Scalars['String'] | null),pairedEntityType?: (PairedEntityType | null),pairedEntityId?: (Scalars['String'] | null),pairingType?: (PairingType | null),amountInPercentage?: (Scalars['Float'] | null)}

export interface CustomerNotExistErrorGenqlSelection{
    message?: boolean | number
    id?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CustomerV2GenqlSelection{
    id?: boolean | number
    affiliatedEntityId?: boolean | number
    companyId?: boolean | number
    source?: boolean | number
    name?: boolean | number
    email?: boolean | number
    billingAddress?: CustomerAddressGenqlSelection
    shippingAddress?: CustomerAddressGenqlSelection
    addresses?: CustomerAddressGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CustomerV3GenqlSelection{
    id?: boolean | number
    company?: CompanyGenqlSelection
    name?: boolean | number
    email?: boolean | number
    integrationType?: boolean | number
    integrationAccountId?: boolean | number
    addresses?: CustomerAddressV3GenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CustomFixedAssetsDataGenqlSelection{
    usefulLifeStartDate?: boolean | number
    depreciationMethod?: boolean | number
    residualValue?: boolean | number
    section179Deduction?: Section179DeductionGenqlSelection
    addDepreciationBonus?: AddDepreciationBonusGenqlSelection
    startDate?: boolean | number
    endDate?: boolean | number
    amount?: boolean | number
    spreadBasisType?: boolean | number
    canceledAmount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CustomFixedAssetsDataInput {usefulLifeStartDate: Scalars['String'],depreciationMethod: DepreciationMethod,residualValue?: (Scalars['Float'] | null),section179Deduction?: (Section179DeductionInput | null),addDepreciationBonus?: (AddDepreciationBonusInput | null),startDate: Scalars['String'],endDate: Scalars['String'],amount: Scalars['Float'],spreadBasisType: SpreadBasisType}

export interface CustomSpreadGenqlSelection{
    specificDate?: SpecificDateGenqlSelection
    spreadOverTime?: CustomSpreadOverTimeGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CustomSpreadInput {specificDate?: (SpecificDateInput | null),spreadOverTime?: (CustomSpreadOverTimeInput | null)}

export interface CustomSpreadOptionsGenqlSelection{
    spreadBasisType?: boolean | number
    residualAmount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CustomSpreadOptionsInput {spreadBasisType: SpreadBasisType}

export interface CustomSpreadOverTimeGenqlSelection{
    fromDate?: boolean | number
    toDate?: boolean | number
    amount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CustomSpreadOverTimeInput {fromDate: Scalars['String'],toDate: Scalars['String'],amount: Scalars['Float']}

export interface DailyAggregatedOwnersDrawGenqlSelection{
    employeeId?: boolean | number
    employeeName?: boolean | number
    amount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DailyAggregatedPaymentCheckGenqlSelection{
    id?: boolean | number
    amount?: boolean | number
    postedAt?: boolean | number
    employeeId?: boolean | number
    employmentType?: boolean | number
    categoryGroup?: boolean | number
    isImmaterial?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DailyAggregatedPayrollDataGenqlSelection{
    date?: boolean | number
    salariesAndWages?: boolean | number
    bonus?: boolean | number
    commission?: boolean | number
    correctionPayment?: boolean | number
    tips?: boolean | number
    holidayPay?: boolean | number
    sickLeave?: boolean | number
    severance?: boolean | number
    ownersDraw?: boolean | number
    vacationPay?: boolean | number
    ficaEmployee?: boolean | number
    ficaEmployer?: boolean | number
    federalEmployee?: boolean | number
    federalEmployer?: boolean | number
    stateAndLocalEmployee?: boolean | number
    stateAndLocalEmployer?: boolean | number
    savingsAndRetirement401kEmployee?: boolean | number
    savingsAndRetirement401kEmployer?: boolean | number
    savingsAndRetirementOtherEmployee?: boolean | number
    savingsAndRetirementOtherEmployer?: boolean | number
    healthEmployee?: boolean | number
    healthEmployer?: boolean | number
    transportationEmployee?: boolean | number
    transportationEmployer?: boolean | number
    otherBenefitsEmployee?: boolean | number
    otherBenefitsEmployer?: boolean | number
    childSupport?: boolean | number
    otherGarnishments?: boolean | number
    otherDeductions?: boolean | number
    grossPay?: boolean | number
    netPay?: boolean | number
    employerCost?: boolean | number
    employmentType?: boolean | number
    categoryGroup?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DailyAggregatedReimbursementGenqlSelection{
    id?: boolean | number
    amount?: boolean | number
    postedAt?: boolean | number
    employeeId?: boolean | number
    isClearedByNetPayPayment?: boolean | number
    paymentMethod?: boolean | number
    employmentType?: boolean | number
    categoryGroup?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DailyPaymentsByContractorGenqlSelection{
    contractor?: ContractorGenqlSelection
    payments?: boolean | number
    reimbursements?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DailyPaymentsByEmployeeGenqlSelection{
    employee?: EmployeeGenqlSelection
    netPay?: boolean | number
    grossPay?: boolean | number
    employeeTaxes?: boolean | number
    deductionsAndBenefits?: boolean | number
    reimbursements?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DangerousTouchLoanInput {loanId: Scalars['ID'],companyId: Scalars['ID']}

export interface DataSerieGenqlSelection{
    label?: boolean | number
    values?: boolean | number
    unitGroup?: boolean | number
    valueType?: boolean | number
    previous?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DateRangeGenqlSelection{
    startTime?: boolean | number
    endTime?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DateRangeInput {from: Scalars['Date'],to: Scalars['Date']}

export interface DatesToFixGenqlSelection{
    date?: boolean | number
    quantity?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DatesToFixInput {date: Scalars['Date'],quantity: Scalars['Float']}

export interface DeadInventoryActionGenqlSelection{
    quantity?: boolean | number
    id?: boolean | number
    date?: boolean | number
    type?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DeadInventoryCogsGenqlSelection{
    amount?: boolean | number
    quantity?: boolean | number
    monthlyBreakdown?: DeadInventoryMonthlyBreakdownGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DeadInventoryDailyBreakdownGenqlSelection{
    date?: boolean | number
    quantity?: boolean | number
    reason?: AdjustmentsReasonGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DeadInventoryMonthlyBreakdownGenqlSelection{
    date?: boolean | number
    quantity?: boolean | number
    dailyData?: DeadInventoryDailyBreakdownGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DeadInventoryOriginalValueGenqlSelection{
    quantity?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DecisionClassificationMetadataRecommendationOptionValue {seenOptions: ClassificationRecommendationTag[]}

export interface DecisionClassificationMetadataRecommendationPromptValue {prompt: Scalars['String']}

export interface DefaultFixedAssetsDataGenqlSelection{
    usefulLifeStartDate?: boolean | number
    startDate?: boolean | number
    endDate?: boolean | number
    amount?: boolean | number
    canceledAmount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DefaultFixedAssetsDataInput {usefulLifeStartDate: Scalars['String'],startDate: Scalars['String'],endDate: Scalars['String'],amount: Scalars['Float']}

export interface DeleteAccrualInput {bankTransactionId: Scalars['ID'],companyId: Scalars['ID']}

export interface DeleteAccrualV2Input {entityType: AccrualEntityType,entityId: Scalars['ID'],companyId: Scalars['ID']}

export interface DeleteBankAccountsInput {companyId: Scalars['String'],bankAccountIds: Scalars['ID'][],userEmail?: (Scalars['String'] | null)}

export interface DeleteBankConnectionInput {companyId: Scalars['ID'],integrationType: IntegrationType,integrationAccountId: Scalars['String']}

export interface DeleteBankReconciliationRequestConfigInput {companyId: Scalars['ID'],requestId: Scalars['ID']}

export interface DeleteBankTransactionAttachmentInput {companyId: Scalars['ID'],bankTransactionId: Scalars['ID'],attachmentUrl: Scalars['String']}

export interface DeleteBankTransactionsByBankAccountIdsInput {companyId: Scalars['ID'],bankAccountIds: Scalars['ID'][],userEmail: Scalars['String']}

export interface DeleteCompanyAffiliateInput {id: Scalars['ID'],companyId: Scalars['ID']}

export interface DeleteFifoGroupsInput {companyId: Scalars['ID'],productIds: Scalars['String'][]}

export interface DeleteHolderCapitalInvestmentInput {id: Scalars['ID'],companyId: Scalars['ID']}

export interface DeleteHolderShareInput {id: Scalars['ID'],companyId: Scalars['ID']}

export interface DeleteInventoryPaymentGroupInput {companyId: Scalars['ID'],paymentGroupId: Scalars['ID']}

export interface DeleteInventoryPaymentGroupResponseGenqlSelection{
    success?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DeleteInventoryPurchaseInput {companyId: Scalars['ID'],id: Scalars['ID'],lastUpdatedAt: Scalars['Date']}

export interface DeleteInvoicesResponseGenqlSelection{
    deleted?: boolean | number
    errors?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DeleteLoanAttachmentInput {companyId: Scalars['ID'],loanId: Scalars['ID'],attachmentId: Scalars['ID']}

export interface DeleteLoanInput {loanId: Scalars['ID'],companyId: Scalars['ID']}

export interface DeleteLoanManualAccountingEventsInput {companyId: Scalars['ID'],loanId: Scalars['ID'],accountingEventIds: Scalars['ID'][]}

export interface DeleteLoanRelationshipsInput {relationshipIds: Scalars['ID'][]}

export interface DeleteLoansEventsEffectConfigurationInput {id: Scalars['ID']}

export interface DeleteLoansEventsEffectConfigurationResultGenqlSelection{
    success?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DeleteLoansInput {loans: DeleteLoanInput[]}

export interface DeleteLoansResultsGenqlSelection{
    loans?: LoanGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DeleteManualAssemblyInput {companyId: Scalars['ID'],id: Scalars['String']}

export interface DeleteManualEquityEventsInput {ids: Scalars['ID'][],configurationIds: Scalars['ID'][],companyId: Scalars['ID']}

export interface DeleteManualLoanEventInput {companyId: Scalars['ID'],loanId: Scalars['ID'],eventId: Scalars['ID']}

export interface DeleteManualLoanEventsInput {companyId: Scalars['ID'],loanId: Scalars['ID'],eventIds: Scalars['ID'][]}

export interface DeleteNoUnitsPhysicalCountInput {id: Scalars['ID'],companyId: Scalars['String']}

export interface DeleteNoUnitsValidationInvalidAckInput {companyId: Scalars['ID'],startDate: Scalars['Date'],endDate: Scalars['Date']}

export interface DeleteOrderGroupInput {companyId: Scalars['ID'],orderGroupId: Scalars['ID']}

export interface DeleteOrderGroupResponseGenqlSelection{
    success?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DeleteOrderGroupUponTransactionChangeInput {companyId: Scalars['String'],orderGroupId: Scalars['String'],changedBankTransactionId: Scalars['String']}

export interface DeleteOrderGroupUponTransactionChangeResponseGenqlSelection{
    success?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DeletePaymentGroupInput {companyId: Scalars['ID'],paymentGroupId: Scalars['ID']}

export interface DeletePaymentGroupResponseGenqlSelection{
    success?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DeletePaymentGroupUponTransactionChangeInput {companyId: Scalars['String'],paymentGroupId: Scalars['String']}

export interface DeletePaymentGroupUponTransactionChangeResponseGenqlSelection{
    success?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DeletePendingWarehouseOpeningAttachmentInput {companyId: Scalars['ID'],attachmentId: Scalars['ID']}

export interface DeleteProductsInput {companyId: Scalars['ID'],productIds: Scalars['String'][]}

export interface DeletePurchaseOrderInput {companyId: Scalars['String'],id: Scalars['String']}

export interface DeleteRecipeInput {companyId: Scalars['ID'],recipeId: Scalars['String']}

export interface DeleteUnitsTrackingPhysicalCountInput {id: Scalars['ID'],companyId: Scalars['String']}

export interface DeleteWarehouseInput {id: Scalars['String'],companyId: Scalars['String']}

export interface DeleteWarehouseOpeningBalancesInput {companyId: Scalars['ID'],date: Scalars['Date'],productId: Scalars['String'],warehouseId: Scalars['String']}

export interface DeleteWarehouseTransferInput {id: Scalars['String'],companyId: Scalars['String']}

export interface DepartmentGenqlSelection{
    id?: boolean | number
    company?: CompanyGenqlSelection
    source?: boolean | number
    name?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DependencyGenqlSelection{
    blocked?: boolean | number
    resolvedAt?: boolean | number
    on_BalanceSheetDependency?: BalanceSheetDependencyGenqlSelection
    on_YearEndDependency?: YearEndDependencyGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DetectAndNotifyCogsDrasticChangesInput {companyIds: Scalars['ID'][]}

export interface DirectLineItemGenqlSelection{
    id?: boolean | number
    product?: ProductGenqlSelection
    quantity?: boolean | number
    vendor?: VendorGenqlSelection
    indirectCostsAllocation?: IndirectCostAllocationGenqlSelection
    directCostPerUnit?: boolean | number
    indirectCostPerUnit?: boolean | number
    remainderIndirectCostPerUnit?: boolean | number
    discountCostPerUnit?: boolean | number
    remainderDiscountCostPerUnit?: boolean | number
    landedCostPerUnit?: boolean | number
    remainderLandedCostPerUnit?: boolean | number
    directCostTotal?: boolean | number
    indirectCostTotal?: boolean | number
    landedCostTotal?: boolean | number
    discountCostTotal?: boolean | number
    note?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DirectLineItemInput {id: Scalars['ID'],productId: Scalars['String'],quantity: Scalars['Float'],vendorId: Scalars['ID'],directCostPerUnit: Scalars['Float'],indirectCostsAllocation: IndirectCostAllocationInput[],indirectCostPerUnit: Scalars['Float'],remainderIndirectCostPerUnit?: (Scalars['Float'] | null),discountCostPerUnit: Scalars['Float'],remainderDiscountCostPerUnit?: (Scalars['Float'] | null),landedCostPerUnit: Scalars['Float'],remainderLandedCostPerUnit?: (Scalars['Float'] | null),directCostTotal: Scalars['Float'],indirectCostTotal: Scalars['Float'],landedCostTotal: Scalars['Float'],discountCostTotal: Scalars['Float'],note?: (Scalars['String'] | null)}

export interface DiscardNoUnitsPhysicalCountProductQuantityPendingAdjustmentInput {physicalCountId: Scalars['String'],companyId: Scalars['String']}

export interface DiscardPendingAdjustments {companyId: Scalars['ID'],managementMethodId: Scalars['String']}

export interface DiscardPendingWarehouseOpeningBalancesInput {companyId: Scalars['ID'],date: Scalars['Date'],warehouseId?: (Scalars['String'] | null),productId?: (Scalars['String'] | null)}

export interface DiscardUnitsTrackingPhysicalCountProductQuantityPendingAdjustmentInput {physicalCountId: Scalars['String'],companyId: Scalars['String']}

export interface DisconnectConnectionInput {companyId: Scalars['ID'],integrationType: IntegrationType,integrationAccountId: Scalars['String']}

export interface DiscountGenqlSelection{
    id?: boolean | number
    type?: boolean | number
    amount?: boolean | number
    description?: boolean | number
    totalAmount?: boolean | number
    discountType?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DiscountInput {id?: (Scalars['ID'] | null),amount: Scalars['Float'],type: DiscountType,description?: (Scalars['String'] | null),externalSourceId?: (Scalars['String'] | null)}

export interface DiscountLineItemV3GenqlSelection{
    id?: boolean | number
    /** The ID of the line item in the external system */
    externalLineItemId?: boolean | number
    /** The name of the line item */
    name?: boolean | number
    /** The description of the line item */
    description?: boolean | number
    /** The amount of the line item */
    amount?: AmountsGenqlSelection
    parentId?: boolean | number
    /** The type of the line item */
    parentLineItemType?: boolean | number
    /** The earliest date and time the line item was posted */
    earliestPostedAt?: boolean | number
    /** The latest date and time the line item was posted */
    latestPostedAt?: boolean | number
    /** The type of the line item */
    type?: boolean | number
    /** The type of the discount */
    discountType?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DispatchEshedTestInput {companyId: Scalars['String']}

export interface DisputeGenqlSelection{
    companyId?: boolean | number
    id?: boolean | number
    source?: boolean | number
    integrationAccountId?: boolean | number
    integrationAccountName?: boolean | number
    disputedAmount?: boolean | number
    disputedCurrency?: boolean | number
    openedAt?: boolean | number
    closedAt?: boolean | number
    reviewStartedAt?: boolean | number
    refundAmount?: boolean | number
    refundCurrency?: boolean | number
    outcome?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DonationCogsGenqlSelection{
    amount?: boolean | number
    quantity?: boolean | number
    monthlyBreakdown?: DonationMonthlyBreakdownGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DonationDailyBreakdownGenqlSelection{
    date?: boolean | number
    quantity?: boolean | number
    reason?: AdjustmentsReasonGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DonationMonthlyBreakdownGenqlSelection{
    date?: boolean | number
    quantity?: boolean | number
    dailyData?: DonationDailyBreakdownGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DonationOriginalValueGenqlSelection{
    quantity?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DownloadAttachmentInput {companyId: Scalars['ID'],loanId: Scalars['ID'],attachmentId: Scalars['ID']}

export interface DownloadAttachmentResultGenqlSelection{
    fileName?: boolean | number
    url?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DropshippingSettingsGenqlSelection{
    id?: boolean | number
    companyId?: boolean | number
    isEnabled?: boolean | number
    mode?: boolean | number
    affiliatedEntities?: AffiliatedEntityGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DropshippingSettingsInput {companyId: Scalars['String']}

export interface DueDateSummaryGenqlSelection{
    count?: boolean | number
    sum?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface EarlyRepaymentDiscountGenqlSelection{
    period?: boolean | number
    fee?: boolean | number
    periodType?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface EarlyRepaymentDiscountUpdate {period?: (Scalars['Int'] | null),fee?: (Scalars['Float'] | null),periodType?: (EarlyRepaymentDiscountPeriodType | null)}

export interface EditClassificationTagInput {id: Scalars['ID'],name: Scalars['String'],moneyDirection: MoneyDirection,isHidden: Scalars['Boolean'],isRelevantToBills: Scalars['Boolean'],isRelevantToApplyAlways: Scalars['Boolean'],displayNameForReports?: (Scalars['String'] | null),keywords?: (Scalars['String'][] | null),moneyInBusinessEvent?: (Scalars['ID'] | null),moneyOutBusinessEvent?: (Scalars['ID'] | null),isApplicableForRefund: Scalars['Boolean'],reportsDisplayNameForTagSelection?: (Scalars['String'] | null)}

export interface EmployeeGenqlSelection{
    id?: boolean | number
    company?: CompanyGenqlSelection
    source?: boolean | number
    department?: DepartmentGenqlSelection
    firstName?: boolean | number
    lastName?: boolean | number
    middleName?: boolean | number
    name?: boolean | number
    isOfficer?: boolean | number
    isTerminated?: boolean | number
    jobs?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface EntitiesByType {entityType: Scalars['String'],entityIds: Scalars['ID'][]}

export interface EntityLockedPeriodBypassGenqlSelection{
    companyId?: boolean | number
    entityType?: boolean | number
    entityId?: boolean | number
    isBypassed?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface EquityEventsEffectConfigurationGenqlSelection{
    id?: boolean | number
    legalEntityType?: boolean | number
    taxEntityType?: boolean | number
    shareType?: boolean | number
    memoTemplate?: boolean | number
    dateTemplate?: boolean | number
    businessEventActionsConfiguration?: BusinessEventActionsConfigurationGenqlSelection
    latestActorType?: boolean | number
    latestActorId?: boolean | number
    createdAt?: boolean | number
    updatedAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface EquityEventsEffectConfigurationsInput {companyId: Scalars['ID']}

export interface ErrorGenqlSelection{
    message?: boolean | number
    on_CustomerNotExistError?: CustomerNotExistErrorGenqlSelection
    on_VendorNotExistError?: VendorNotExistErrorGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface EvaluateBankReconciliationRequestsInput {companyId: Scalars['ID'],skipFeatureFlags: Scalars['Boolean']}

export interface EvaluateBankReconciliationRequestsResponseGenqlSelection{
    explains?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface EventsLockGenqlSelection{
    minimumAllowedEventTime?: boolean | number
    lockHistory?: CompanyEventsLockHistoryGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ExcludedSalesChannelItemReconciliationGenqlSelection{
    sku?: boolean | number
    isBlacklisted?: boolean | number
    shopifySalesChannel?: boolean | number
    summary?: ReconciliationSummaryGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ExistingCompanyIntegrationInput {integrationType: UploadableIntegrationType,integrationAccountId?: (Scalars['String'] | null)}

export interface ExplainBankAccountMergeDuplicateGenqlSelection{
    id?: boolean | number
    name?: boolean | number
    status?: boolean | number
    createdAt?: boolean | number
    transactionsImportStatus?: ExplainBankAccountMergeTransactionsImportStatusGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ExplainBankAccountMergeExplainGenqlSelection{
    primary?: boolean | number
    companyId?: boolean | number
    duplicates?: ExplainBankAccountMergeDuplicateGenqlSelection
    notes?: ExplainBankAccountMergeNoteGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ExplainBankAccountMergeInput {companyId: Scalars['ID']}

export interface ExplainBankAccountMergeNoteGenqlSelection{
    error?: boolean | number
    resolution?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ExplainBankAccountMergeResponseGenqlSelection{
    explains?: ExplainBankAccountMergeExplainGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ExplainBankAccountMergeTransactionsImportStatusGenqlSelection{
    stopImportFromDate?: boolean | number
    changedBy?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ExplainFifoInput {companyId: Scalars['ID'],productId: Scalars['String'],fromDate: Scalars['Date'],toDate: Scalars['Date']}

export interface ExplainFifoResultGenqlSelection{
    warehouseMovements?: WarehouseMovementsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ExportAccrualsListCsvInput {companyId: Scalars['ID'],asOfDate: Scalars['Date'],accrualType: AccrualType,scheduleWithoutAdjustments: Scalars['Boolean']}

export interface ExportAccrualsListCsvResponseGenqlSelection{
    url?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ExportBalanceSheetApiArgs {companyId: Scalars['ID'],isGoogleExport?: (Scalars['Boolean'] | null),fromTimeIso: Scalars['Date'],toTimeIso: Scalars['Date'],noDecimals?: (Scalars['Boolean'] | null)}

export interface ExportCashFlowApiArgs {companyId: Scalars['ID'],exportArgs: ExportCashFlowArgs}

export interface ExportCashFlowArgs {timeRange: TimeRangeInput,fileType: FileType,groupByTimeWindow?: (MetricRangeGroupBy | null),includeUDFAccounts: Scalars['Boolean'],includeCCAccounts: Scalars['Boolean'],breakdowns: Scalars['String']}

export interface ExportCOGSBreakdownRequest {companyId: Scalars['ID'],from: Scalars['Date'],to: Scalars['Date'],type: CogsType,salesChannel?: (SalesChannelInput | null),category?: (CogsCategory[] | null),sort?: (GetCogsBreakdownSort | null),searchText?: (Scalars['String'] | null),productIds?: (Scalars['String'][] | null),warehouseIds?: (Scalars['String'][] | null)}

export interface ExportCOGSBreakdownResponseGenqlSelection{
    url?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ExportCOGSOverviewRequest {companyId: Scalars['ID'],from: Scalars['Date'],to: Scalars['Date'],filters?: (GetCOGSOverviewFilters | null)}

export interface ExportCOGSOverviewResponseGenqlSelection{
    url?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ExportCSVResponseGenqlSelection{
    url?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ExportGeneralLedgerInput {companyId: Scalars['ID'],startDate: Scalars['Date'],endDate: Scalars['Date'],email?: (Scalars['String'] | null)}

export interface ExportGeneralLedgerResponseGenqlSelection{
    jobId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ExportInvoicesResponseGenqlSelection{
    url?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ExportLedgerAccountTransactionsInput {companyId: Scalars['ID'],exportArgs: FetchLedgerAccountTransactionsInput,withBalance?: (Scalars['Boolean'] | null)}

export interface ExportLoansCsvInput {companyIds?: (Scalars['String'][] | null),lenderIds?: (Scalars['String'][] | null),vendorIds?: (Scalars['String'][] | null),affiliatedEntityIds?: (Scalars['String'][] | null),updateBy?: (Scalars['String'][] | null),statuses?: (LoanTreatmentStatus[] | null),companyTiers?: (Scalars['String'][] | null),owners?: (Scalars['String'][] | null),showOnlyModified?: (Scalars['Boolean'] | null),userActionStatuses?: (LoanUserActionStatus[] | null),includeDeleted?: (Scalars['Boolean'] | null),loanType?: (LoanType | null),limit?: (Scalars['Int'] | null)}

export interface ExportLoansResultGenqlSelection{
    url?: boolean | number
    fileName?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ExportNoUnitsTrackingPhysicalCountProductQuantitiesInput {companyId: Scalars['String'],filters: GetNoUnitsPhysicalCountProductQuantitiesInput}

export interface ExportProductsResponseGenqlSelection{
    url?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ExportPurchaseOrdersInput {companyId: Scalars['ID'],filters: GetPurchaseOrdersInput}

export interface ExportPurchaseOrdersResponseGenqlSelection{
    url?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ExportResponseGenqlSelection{
    signedUrl?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ExportSkuAnalysisInput {companyId: Scalars['ID'],fromDate: Scalars['Date'],toDate: Scalars['Date'],breakdown: Scalars['String'],timezone: Scalars['String'],comparisonPeriod: Scalars['String'],stores?: ((Scalars['String'] | null)[] | null),sources?: (SourceTypes[] | null),salesChannels?: ((Scalars['String'] | null)[] | null),searchText?: (Scalars['String'] | null),sortBy?: (AllSkusSortBy | null),showPrevious?: (Scalars['Boolean'] | null),showReturn?: (Scalars['Boolean'] | null)}

export interface ExportSkuAnalysisResponseGenqlSelection{
    url?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ExportUnitsTrackingPhysicalCountProductQuantitiesInput {companyId: Scalars['String'],filters: GetUnitsTrackingPhysicalCountProductQuantitiesInput}

export interface ExportWarehouseOpeningBalancesCsvInput {companyId: Scalars['ID'],filters: GetWarehouseOpeningBalancesInput}

export interface ExtensionFiledGenqlSelection{
    value?: boolean | number
    updatedAt?: boolean | number
    updatedBy?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ExternalBalanceInput {integrationAccountId: Scalars['ID'],companyId: Scalars['ID']}

export interface FailingValidationGenqlSelection{
    companyId?: boolean | number
    validationId?: boolean | number
    integrationAccountId?: boolean | number
    validationDataLocation?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FeeLineItemV3GenqlSelection{
    id?: boolean | number
    /** The ID of the line item in the external system */
    externalLineItemId?: boolean | number
    /** The name of the line item */
    name?: boolean | number
    /** The description of the line item */
    description?: boolean | number
    /** The amount of the line item */
    amount?: AmountsGenqlSelection
    parentId?: boolean | number
    /** The type of the line item */
    parentLineItemType?: boolean | number
    /** The earliest date and time the line item was posted */
    earliestPostedAt?: boolean | number
    /** The latest date and time the line item was posted */
    latestPostedAt?: boolean | number
    /** The type of the line item */
    type?: boolean | number
    /** The type of the fee */
    feeType?: boolean | number
    /** The ID of the fee in the external system */
    externalName?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FetchLedgerAccountTransactionsInput {vendorId?: (Scalars['String'] | null),categoryId?: (Scalars['String'] | null),classificationTagId?: (Scalars['String'] | null),categoryName?: (Scalars['String'] | null),accountName?: (Scalars['String'] | null),filterByVendor?: (Scalars['Boolean'] | null),filterByCategory?: (Scalars['Boolean'] | null),timeRange?: (OptionalTimeRangeInput | null),accountingMethod: Scalars['String'],isCashFlow?: (Scalars['Boolean'] | null)}

export interface FifoCogsBusinessEventsMetricsGenqlSelection{
    type?: boolean | number
    integrationAccountName?: boolean | number
    integrationType?: boolean | number
    metrics?: FifoCogsBusinessEventsSingleMetricGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FifoCogsBusinessEventsSingleMetricGenqlSelection{
    name?: boolean | number
    fifo?: boolean | number
    isValid?: boolean | number
    be?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FifoValidationCogsSummaryGenqlSelection{
    name?: boolean | number
    fifoCogs?: boolean | number
    isValidCost?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FifoValidationInput {date: Scalars['Date'],companyId: Scalars['ID'],id?: (Scalars['String'] | null)}

export interface FifoValidationProductDataGenqlSelection{
    product?: ProductGenqlSelection
    warehouse?: WarehouseGenqlSelection
    baseMetrics?: FifoValidationSummaryGenqlSelection
    cogsMetrics?: FifoValidationCogsSummaryGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FifoValidationProductTotalsGenqlSelection{
    baseMetrics?: FifoValidationSummaryGenqlSelection
    cogsMetrics?: FifoValidationCogsSummaryGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FifoValidationProductValidationDataGenqlSelection{
    data?: FifoValidationProductDataGenqlSelection
    totals?: FifoValidationProductTotalsGenqlSelection
    totalBalance?: FifoValidationTotalsBalanceGenqlSelection
    fifoCogsBusinessEventsMetrics?: FifoCogsBusinessEventsMetricsGenqlSelection
    fifoCogsBusinessEventsMetricsTotal?: FifoCogsBusinessEventsSingleMetricGenqlSelection
    notPropagatedBEIds?: boolean | number
    redundantBEIds?: boolean | number
    secondaryProductRedundantOverviews?: boolean | number
    isUnitsValid?: boolean | number
    isCogsValid?: boolean | number
    isBusinessEventsValid?: boolean | number
    fulfillmentsAfterLock?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FifoValidationSummaryGenqlSelection{
    name?: boolean | number
    source?: boolean | number
    sourceCost?: boolean | number
    fifo?: boolean | number
    fifoCost?: boolean | number
    fifoCogs?: boolean | number
    isValidQuantity?: boolean | number
    isValidCost?: boolean | number
    isValidCogs?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FifoValidationTotalsBalanceGenqlSelection{
    totalIncomingFromSource?: boolean | number
    totalOnHandFromFifo?: boolean | number
    totalCogs?: boolean | number
    totalWaste?: boolean | number
    isValid?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FileLocationGenqlSelection{
    name?: boolean | number
    key?: boolean | number
    bankTransactionsUploadId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FileUploadUrlResultGenqlSelection{
    uploadUrl?: boolean | number
    url?: boolean | number
    fileName?: boolean | number
    key?: boolean | number
    bucket?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FilingDeadlineGenqlSelection{
    value?: boolean | number
    extensionFiled?: ExtensionFiledGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FilteringBoundsInput {companyId: Scalars['ID'],placedDate: OrdersDateRangeInput}

export interface FilteringBoundsOrderV3ResultGenqlSelection{
    maxNetOrderInHomeCurrency?: boolean | number
    maxItemsCount?: boolean | number
    stores?: StoreV3GenqlSelection
    /** @deprecated Use maxNetOrderInHomeCurrency instead */
    orderTotalP999?: boolean | number
    /** @deprecated no longer used */
    integrations?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FinalizeAskTheUserFlowInput {companyId: Scalars['ID'],bankTransactionId: Scalars['ID'],type: AskTheUserFlowType,snapshot: Scalars['JSONObject']}

export interface FinalizeAskTheUserFlowResultGenqlSelection{
    success?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FinaloopProductGenqlSelection{
    id?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FinaloopProductInternalInput {id: Scalars['ID'],companyId: Scalars['ID']}

export interface FinaloopTagsInput {id?: (Scalars['String'] | null),name?: (Scalars['String'] | null),isNew: Scalars['Boolean']}

export interface FindValidationBuggyDateInput {companyId: Scalars['ID'],validationDomain: Scalars['String'],validationType: Scalars['String']}

export interface FiscalYearEndStateResponseGenqlSelection{
    year?: boolean | number
    state?: boolean | number
    isUnderReview?: boolean | number
    isLegacy?: boolean | number
    updatedAt?: boolean | number
    updatedBy?: boolean | number
    filingDeadline?: FilingDeadlineGenqlSelection
    userUnresponsive?: YearEndUserUnresponsiveGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FixedAssetsOptionsGenqlSelection{
    startDate?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FloatRange {min?: (Scalars['Float'] | null),max?: (Scalars['Float'] | null)}

export interface FulfillLineItemInput {lineItemId: Scalars['ID'],fulfillmentDate: Scalars['Date'],quantity: Scalars['Float']}

export interface FulfillmentActionGenqlSelection{
    quantity?: boolean | number
    id?: boolean | number
    date?: boolean | number
    type?: boolean | number
    salesChannel?: WarehouseActionSalesChannelGenqlSelection
    sku?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FulfillmentCostGenqlSelection{
    id?: boolean | number
    companyId?: boolean | number
    source?: boolean | number
    externalSourceId?: boolean | number
    integrationAccountId?: boolean | number
    integrationAccountName?: boolean | number
    sale?: SaleGenqlSelection
    order?: OrderV2GenqlSelection
    type?: boolean | number
    externalId?: boolean | number
    externalName?: boolean | number
    amount?: boolean | number
    currency?: boolean | number
    amountInHomeCurrency?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FulfillmentMethodGenqlSelection{
    startDate?: boolean | number
    endDate?: boolean | number
    type?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FulfillmentMethodInput {startDate: Scalars['Date'],endDate: Scalars['Date'],type: FulfillmentMethodType}

export interface FulfillmentSettingGenqlSelection{
    companyId?: boolean | number
    integrationAccountId?: boolean | number
    methods?: FulfillmentMethodGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FulfillmentSettingInput {companyId: Scalars['ID'],integrationAccountIds?: (Scalars['ID'][] | null)}

export interface FulfillmentsValidationGenqlSelection{
    integrationData?: QuantityAndCostGenqlSelection
    adjustments?: QuantityAndCostGenqlSelection
    cogs?: QuantityAndCostGenqlSelection
    source?: QuantityAndCostGenqlSelection
    diff?: QuantityAndCostGenqlSelection
    isValid?: boolean | number
    integrationType?: boolean | number
    integrationAccountName?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GenerateBigValidationInput {companyId: Scalars['ID'],to: Scalars['Date']}

export interface GenerateBigValidationResponseGenqlSelection{
    validationId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GenerateFifoValidationResponseGenqlSelection{
    validationId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GenerateNoUnitsValidationErrorGenqlSelection{
    message?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GenerateNoUnitsValidationInput {startDate: Scalars['Date'],endDate: Scalars['Date'],companyId: Scalars['ID']}

export interface GenerateNoUnitsValidationResponseGenqlSelection{
    validationId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GenerateNoUnitsValidationResultGenqlSelection{
    id?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GeneratePdfErrorGenqlSelection{
    message?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GeneratePdfInput {companyId: Scalars['String'],html: Scalars['String'],id: Scalars['String']}

export interface GeneratePdfResponseGenqlSelection{
    url?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GeneratePdfResponseV2GenqlSelection{
    on_GeneratePdfResponse?:GeneratePdfResponseGenqlSelection,
    on_GeneratePdfError?:GeneratePdfErrorGenqlSelection,
    __typename?: boolean | number
}

export interface GenerateProductMergeRecommendationsInput {companyId: Scalars['ID']}

export interface GenericResponseGenqlSelection{
    success?: boolean | number
    errorMessage?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GetAccountRoleInput {name: Scalars['String']}

export interface GetAccrualsByEntityIDsInput {companyId: Scalars['ID'],entityType: AccrualEntityType,entityIds: Scalars['ID'][]}

export interface GetAccrualsByTransactionIDsInput {companyId: Scalars['ID'],bankTransactionIds: Scalars['ID'][]}

export interface GetAccrualsListInput {companyId: Scalars['ID'],accrualType: AccrualType,asOfDate: Scalars['Date'],limit?: (Scalars['Int'] | null),offset?: (Scalars['Int'] | null)}

export interface GetAccrualsSpreadInput {companyId: Scalars['ID'],bankTransactionIds: Scalars['ID'][]}

export interface GetAccrualsSpreadInputV2 {companyId: Scalars['ID'],entityType: AccrualEntityType,entityIds: Scalars['ID'][]}

export interface GetAllCompaniesForDomainInput {domain: YearEndDomainTypes,state: YearEndDomainState}

export interface GetAllCompaniesForDomainResponseGenqlSelection{
    companyId?: boolean | number
    year?: boolean | number
    state?: boolean | number
    domainState?: YearEndDomainStateResponseGenqlSelection
    domainData?: YearEndDomainStateDataResponseGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GetAllocatableEventIdsInput {companyId: Scalars['ID'],loanId: Scalars['ID'],filters?: (LoanEventFilter[] | null)}

export interface GetAllocatableEventIdsResultGenqlSelection{
    ids?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GetArtificialTransactionsInput {companyId: Scalars['ID']}

export interface GetAttachmentTargetURLSInput {companyId: Scalars['ID'],loanId?: (Scalars['ID'] | null),fileNames: Scalars['String'][]}

export interface GetBackOfficeBankStatementRequestsInput {filter?: (GetBankStatementRequestsFiltersInput | null),sort: GetBankStatementReconciliationRequestsSort,limit: Scalars['Int'],offset: Scalars['Int']}

export interface GetBackOfficeBankStatementRequestsResponseGenqlSelection{
    statementRequests?: BankReconciliationRequestGenqlSelection
    totalCount?: boolean | number
    offset?: boolean | number
    limit?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GetBalanceSheetSetupItemDocumentUrlInput {balanceSheetSetupItemId: Scalars['ID']}

export interface GetBalanceSheetSetupItemDocumentUrlReponseGenqlSelection{
    downloadUrl?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GetBankAccountStatementFilesInput {companyId: Scalars['String'],bankAccountId: Scalars['String']}

export interface GetBankStatementParsingRequestInput {id?: (Scalars['ID'] | null),companyId: Scalars['ID'],bankTransactionsUploadId?: (Scalars['String'] | null),bankStatementFileId?: (Scalars['String'] | null),provider?: (BankStatementParsingRequestsProvider | null),queryVersion?: (Scalars['Int'] | null)}

export interface GetBankStatementParsingResultsInput {id?: (Scalars['ID'] | null),companyId: Scalars['ID'],bankTransactionsUploadId?: (Scalars['String'] | null),bankStatementFileId?: (Scalars['String'] | null),status?: (BankStatementParsingResultStatus | null)}

export interface GetBankStatementReconciliationRequestsSort {type: GetBankStatementRequestsSortType,direction: GetBankStatementRequestsDirection}

export interface GetBankStatementRequestsFiltersInput {companyIds?: (Scalars['ID'][] | null),bankAccountIds?: (Scalars['ID'][] | null),years?: (Scalars['String'][] | null),tiers?: (CompanyTier[] | null),statuses?: (BankStatementRequestStatus[] | null),types?: (BankStatementRequestType[] | null),withDeleted?: (Scalars['Boolean'] | null),withTestCompanies?: (Scalars['Boolean'] | null),withLiveTestCompanies?: (Scalars['Boolean'] | null)}

export interface GetBillsInput {companyId: Scalars['ID'],dateTo?: (Scalars['Date'] | null),limit?: (Scalars['Int'] | null),offset?: (Scalars['Int'] | null)}

export interface GetBillsResponseGenqlSelection{
    bills?: BillGenqlSelection
    totalCount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GetBusinessEventInput {id?: (Scalars['ID'] | null),type?: (Scalars['String'] | null),variant?: (Scalars['String'] | null)}

export interface GetBusinessEventsAccrualsConfigInput {companyId: Scalars['ID']}

export interface GetChargebacksByIdsInput {ids: Scalars['ID'][],companyId: Scalars['ID']}

export interface GetClosingBalancesByIdsInput {ids: Scalars['ID'][],companyId: Scalars['ID']}

export interface GetCOGSBreakdownRequest {companyId: Scalars['ID'],from: Scalars['Date'],to: Scalars['Date'],type: CogsType,salesChannel?: (SalesChannelInput | null),category?: (CogsCategory[] | null),limit?: (Scalars['Int'] | null),offset?: (Scalars['Int'] | null),sort?: (GetCogsBreakdownSort | null),searchText?: (Scalars['String'] | null),productIds?: (Scalars['String'][] | null),warehouseIds?: (Scalars['String'][] | null)}

export interface GetCOGSBreakdownResponseGenqlSelection{
    from?: boolean | number
    to?: boolean | number
    type?: boolean | number
    items?: COGSBreakdownItemGenqlSelection
    totalCount?: boolean | number
    hasNext?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GetCogsBreakdownSort {field: GetCogsBreakdownSortField,direction: ProductsSortDirection}

export interface GetCOGSOverviewFilters {source?: (CogsSource | null),type?: (CogsType | null),costType?: (CostType | null),category?: (CogsCategory[] | null),productIds?: (Scalars['String'][] | null),warehouseIds?: (Scalars['String'][] | null),salesChannel?: (SalesChannelInput | null),groupNames?: (Scalars['String'][] | null)}

export interface GetCOGSOverviewRequest {companyId: Scalars['ID'],from: Scalars['Date'],to: Scalars['Date'],filters?: (GetCOGSOverviewFilters | null)}

export interface GetCOGSOverviewResponseGenqlSelection{
    from?: boolean | number
    to?: boolean | number
    summary?: COGSSummaryV2GenqlSelection
    summaryEvents?: COGSEventGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GetCompaniesByIdsInput {companyIds: Scalars['ID'][]}

export interface GetCompaniesInput {payingCompaniesOnly?: (Scalars['Boolean'] | null),tiers?: (CompanyTier[] | null)}

export interface GetCompanyFundedStatusInput {companyId: Scalars['ID']}

export interface GetCompanyInput {companyId: Scalars['ID']}

export interface GetCompanyLoanInput {companyId: Scalars['ID'],loanId: Scalars['ID']}

export interface GetCompanyLoansInput {companyId: Scalars['ID']}

export interface GetCompanyLockConditionsArgs {companyId: Scalars['String'],periodDates: PeriodDatesInput}

export interface GetCompanyWorksheetsArgs {companyId: Scalars['String'],periodDates: PeriodDatesInput}

export interface GetCustomerArgs {searchTerm?: (Scalars['String'] | null),limit?: (Scalars['Int'] | null)}

export interface GetCustomerByIdInput {companyId: Scalars['ID'],id: Scalars['ID']}

export interface GetCustomerByIdsInput {companyId: Scalars['ID'],ids: Scalars['ID'][]}

export interface GetCustomerInternal {id: Scalars['ID'],companyId: Scalars['ID']}

export interface GetCustomerResponseGenqlSelection{
    on_Customer?:CustomerGenqlSelection,
    on_CustomerNotExistError?:CustomerNotExistErrorGenqlSelection,
    on_Error?: ErrorGenqlSelection,
    __typename?: boolean | number
}

export interface GetDisputesByIdsInput {ids: Scalars['ID'][],companyId: Scalars['ID']}

export interface GetEntitiesLockedPeriodBypassesInput {companyId: Scalars['ID'],entitiesByType: EntitiesByType[]}

export interface GetExportedReportsInput {companyId: Scalars['ID'],reportType?: (ReportType | null),year?: (Scalars['Int'] | null),fromDate?: (Scalars['Date'] | null),toDate?: (Scalars['Date'] | null),createdAtFrom?: (Scalars['Date'] | null),createdAtTo?: (Scalars['Date'] | null),email?: (Scalars['String'] | null),sortBy?: (ExportedReportsLogsSortBy | null),sortDirection?: (SortDirection | null)}

export interface GetExportedReportsResponseGenqlSelection{
    id?: boolean | number
    createdAt?: boolean | number
    updatedAt?: boolean | number
    fromDate?: boolean | number
    toDate?: boolean | number
    reportType?: boolean | number
    source?: boolean | number
    email?: boolean | number
    period?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GetFailingValidationsByValidationCycleInput {validationCycleId: Scalars['String']}

export interface GetFailingValidationsByValidationTemplateInput {validationType: CompanyValidationType,endTime: ValidationTemplateEndTime}

export interface GetFiscalYerDataInput {companyId: Scalars['ID']}

export interface GetFromEmailAddressErrorGenqlSelection{
    message?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GetFromEmailAddressInput {companyId: Scalars['String'],entityType: Scalars['String']}

export interface GetFromEmailAddressResponseGenqlSelection{
    fromAddress?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GetFromEmailAddressResultGenqlSelection{
    on_GetFromEmailAddressResponse?:GetFromEmailAddressResponseGenqlSelection,
    on_GetFromEmailAddressError?:GetFromEmailAddressErrorGenqlSelection,
    __typename?: boolean | number
}

export interface GetFulfillmentCostsByIdsInput {companyId: Scalars['ID'],fulfillmentCostIds: Scalars['ID'][]}

export interface GetFulfillmentSettingInput {companyId: Scalars['ID']}

export interface GetFulfillmentSettingsResponseGenqlSelection{
    settings?: IntegrationFulfillmentSettingGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GetGlobalVendorsInput {ids: Scalars['ID'][]}

export interface GetHealthStatusInput {asOfDate: Scalars['Date'],updatedAt: Scalars['Date'],companiesIds?: (Scalars['String'][] | null),sort?: (HealthStatusSortType | null),limit: Scalars['Int'],offset: Scalars['Int'],isStrictAsOfDate?: (Scalars['Boolean'] | null),domains?: (CompanyValidationDomainType[] | null)}

export interface GetIntegrationTagsInput {companyId: Scalars['ID'],searchText: Scalars['String']}

export interface GetIntegrationTransferInput {id: Scalars['ID'],companyId: Scalars['ID']}

export interface GetIntegrationTransfersBackofficeInput {companyId: Scalars['ID'],ids?: (Scalars['ID'][] | null),timeRange?: (IntegrationTransferTimeRangeInput | null),sort?: (IntegrationTransfersSort | null),type?: (IntegrationTransferType | null),limit?: (Scalars['Int'] | null),integrationType?: (IntegrationType | null),amountRange?: (AmountRange | null),withDeleted?: (Scalars['Boolean'] | null)}

export interface GetIntegrationTransfersByIdsInput {ids: Scalars['ID'][],companyId: Scalars['ID']}

export interface GetIntegrationTransfersInput {companyId: Scalars['ID'],ids?: (Scalars['ID'][] | null),timeRange?: (IntegrationTransferTimeRangeInput | null),sort?: (IntegrationTransfersSort | null),type?: (IntegrationTransferType | null),limit?: (Scalars['Int'] | null),offset?: (Scalars['Int'] | null),integrationType?: (IntegrationType | null),checkAgainstOriginalAmount?: (Scalars['Boolean'] | null),onlyUnidentified?: (Scalars['Boolean'] | null),pairedCompanyAffiliateId?: (Scalars['ID'] | null),withDeleted?: (Scalars['Boolean'] | null)}

export interface GetInventoryAccountBalanceInput {companyId: Scalars['ID'],pointInTime: Scalars['Date']}

export interface GetInventoryAccountBalanceResponseGenqlSelection{
    inventoryAccountBalance?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GetInventoryPurchaseRulesInput {companyId: Scalars['ID']}

export interface GetInventoryPurchasesByIdsInput {companyId: Scalars['ID'],ids: Scalars['String'][]}

export interface GetInventoryPurchasesCountByVendorInput {companyId: Scalars['String'],source?: (InventoryPurchaseSource | null),affiliatedEntityIds?: (Scalars['String'][] | null)}

export interface GetInventoryPurchasesExportInput {filters: GetInventoryPurchasesFilters,sort: InventoryPurchasesSort,managementMethod: ManagementMethod}

export interface GetInventoryPurchasesFilters {companyId: Scalars['ID'],startDate: Scalars['Date'],endDate: Scalars['Date'],text?: (Scalars['String'] | null),status?: (InventoryPurchaseStatus[] | null),statusAsOfDate?: (Scalars['Date'] | null),ids?: (Scalars['String'][] | null),affiliatedEntityId?: (Scalars['String'] | null),source?: (InventoryPurchaseSourceCategory[] | null),categoryName?: (InventoryPurchaseCategoryName[] | null),purchaseType?: (InventoryPurchaseType[] | null),paidStatus?: (PaidStatus[] | null)}

export interface GetInventoryPurchasesForCompanyInput {companyId: Scalars['ID'],historicalPurchasesOnly?: (Scalars['Boolean'] | null)}

export interface GetInventoryPurchasesInput {filters: GetInventoryPurchasesFilters,offset: Scalars['Int'],limit: Scalars['Int'],sort: InventoryPurchasesSort}

export interface GetInventoryPurchaseSummaryInput {companyId: Scalars['ID'],startDate: Scalars['Date'],endDate: Scalars['Date'],text?: (Scalars['String'] | null),status?: (InventoryPurchaseStatus[] | null),purchaseType?: (InventoryPurchaseType[] | null),statusAsOfDate?: (Scalars['Date'] | null)}

export interface GetInventoryPurchaseVendorsInput {companyId: Scalars['String'],categoryName?: (InventoryPurchaseCategoryName | null),source?: (InventoryPurchaseSource | null)}

export interface GetInventoryVendorBillsInput {companyId: Scalars['ID'],affiliatedEntityId: Scalars['ID'],toDate: Scalars['Date'],unpaidBillsUntilDate?: (Scalars['Date'] | null),text?: (Scalars['String'] | null),fromAmount?: (Scalars['Float'] | null),toAmount?: (Scalars['Float'] | null),itemTypes?: (InventoryVendorBillItemType[] | null),limit: Scalars['Int'],offset: Scalars['Int']}

export interface GetInventoryVendorBillsOverviewInput {companyId: Scalars['ID'],affiliatedEntityId: Scalars['ID'],toDate: Scalars['Date'],unpaidBillsUntilDate?: (Scalars['Date'] | null),text?: (Scalars['String'] | null),fromAmount?: (Scalars['Float'] | null),toAmount?: (Scalars['Float'] | null)}

export interface GetInventoryVendorFilterValuesInput {companyId: Scalars['ID'],untilDate: Scalars['Date'],text?: (Scalars['String'] | null)}

export interface GetInventoryVendorParamsInput {companyId: Scalars['ID']}

export interface GetInventoryVendorRollingBalanceInput {companyId: Scalars['ID'],affiliatedEntityId: Scalars['ID'],fromDate: Scalars['Date'],toDate: Scalars['Date'],text?: (Scalars['String'] | null),fromAmount?: (Scalars['Float'] | null),toAmount?: (Scalars['Float'] | null),skipZeroAmount?: (Scalars['Boolean'] | null),itemTypes?: (InventoryVendorRollingBalanceItemTypes[] | null),limit: Scalars['Int'],offset: Scalars['Int']}

export interface GetInventoryVendorRollingBalanceOverviewInput {companyId: Scalars['ID'],affiliatedEntityId: Scalars['ID'],fromDate: Scalars['Date'],toDate: Scalars['Date'],text?: (Scalars['String'] | null),fromAmount?: (Scalars['Float'] | null),toAmount?: (Scalars['Float'] | null),skipZeroAmount?: (Scalars['Boolean'] | null),itemTypes?: (InventoryVendorRollingBalanceItemTypes[] | null)}

export interface GetInventoryVendorsInput {companyId: Scalars['ID'],text?: (Scalars['String'] | null),untilDate?: (Scalars['Date'] | null),unpaidBillsUntilDate?: (Scalars['Date'] | null),skipZeroRollingBalance?: (Scalars['Boolean'] | null),negativeRollingBalance?: (Scalars['Boolean'] | null),fromRollingBalance?: (Scalars['Float'] | null),toRollingBalance?: (Scalars['Float'] | null),sort?: (InventoryVendorsSort | null),offset: Scalars['Int'],limit: Scalars['Int']}

export interface GetInventoryVendorsOverviewInput {companyId: Scalars['ID'],text?: (Scalars['String'] | null),untilDate?: (Scalars['Date'] | null),unpaidBillsUntilDate?: (Scalars['Date'] | null),skipZeroRollingBalance?: (Scalars['Boolean'] | null),negativeRollingBalance?: (Scalars['Boolean'] | null),fromRollingBalance?: (Scalars['Float'] | null),toRollingBalance?: (Scalars['Float'] | null)}

export interface GetInvoicesAffectingPaymentGroupsInput {companyId: Scalars['String'],invoiceIds: Scalars['String'][]}

export interface GetInvoicesAffectingPaymentGroupsResponseGenqlSelection{
    invoicesToPaymentGroups?: InvoiceToPaymentGroupsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GetInvoiceSettingsInput {companyId: Scalars['ID']}

export interface GetInvoicesResultGenqlSelection{
    invoices?: InvoiceGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GetLatestValidationInput {companyId: Scalars['String'],type: CompanyValidationType,integrationAccountId?: (Scalars['String'] | null),validationCycleId?: (Scalars['String'] | null),account?: (Scalars['String'] | null),startTime?: (Scalars['Date'] | null),endTime: Scalars['Date']}

export interface GetLatestValidationResultGenqlSelection{
    validationId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GetLoanEventsInput {companyId: Scalars['ID'],loanId: Scalars['ID'],filters?: (LoanEventFilter[] | null),page: Scalars['Int'],size: Scalars['Int']}

export interface GetLoanEventsLengthInput {companyId: Scalars['ID'],loanId: Scalars['ID'],filters?: (LoanEventFilter[] | null)}

export interface GetLoanEventsLengthResultGenqlSelection{
    length?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GetLoanEventsResultGenqlSelection{
    events?: LoanEventGenqlSelection
    page?: boolean | number
    size?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GetLoanRelationshipsResultGenqlSelection{
    relationships?: LoanRelationshipGenqlSelection
    page?: boolean | number
    size?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GetLoansByIdInput {loanIds: Scalars['ID'][],includeDeleted?: (Scalars['Boolean'] | null)}

export interface GetLoansForAllocateInput {companyId: Scalars['ID'],lenderId: Scalars['ID']}

export interface GetLoansInput {page: Scalars['Int'],companyIds?: (Scalars['String'][] | null),lenderIds?: (Scalars['String'][] | null),vendorIds?: (Scalars['String'][] | null),affiliatedEntityIds?: (Scalars['String'][] | null),updateBy?: (Scalars['String'][] | null),statuses?: (LoanTreatmentStatus[] | null),companyTiers?: (Scalars['String'][] | null),owners?: (Scalars['String'][] | null),showOnlyModified?: (Scalars['Boolean'] | null),includeDeleted?: (Scalars['Boolean'] | null),userActionStatuses?: (LoanUserActionStatus[] | null),sort?: (LoansSort | null),loanType?: (LoanType | null),limit?: (Scalars['Int'] | null)}

export interface GetLoansOutstandingAmountOnDateInput {companyId: Scalars['ID'],loansIds: Scalars['ID'][],date: Scalars['Date']}

export interface GetLoansOutstandingAmountOnDateResultGenqlSelection{
    loans?: LoanOutstandingAmountOnDateGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GetMatchingEffectRuleInput {companyId: Scalars['ID'],loanId: Scalars['ID'],eventDefinitionId: Scalars['ID'],loanInput?: (GetMatchingEffectRuleLoanInput | null)}

export interface GetMatchingEffectRuleLoanInput {amount?: (Scalars['Float'] | null),postedAt?: (Scalars['Date'] | null),spreadInput?: (CreateManualLoanEventSpreadInput | null),memo?: (Scalars['String'] | null)}

export interface GetMatchingEffectRuleResultGenqlSelection{
    effect?: LoansEventsEffectConfigurationGenqlSelection
    memo?: boolean | number
    dailyAccrual?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GetNonMatchingProductsInput {companyId: Scalars['ID'],fromDate?: (Scalars['Date'] | null),toDate?: (Scalars['Date'] | null)}

export interface GetNoUnitsPhysicalCountAnyActiveProductsWithoutQuantitiesInput {companyId: Scalars['String'],physicalCountId: Scalars['String']}

export interface GetNoUnitsPhysicalCountClosingBalanceInput {companyId: Scalars['String'],date: Scalars['Date'],excludingDate?: (Scalars['Date'] | null)}

export interface GetNoUnitsPhysicalCountInput {id: Scalars['ID'],companyId: Scalars['String']}

export interface GetNoUnitsPhysicalCountOverviewInput {physicalCountId: Scalars['String'],companyId: Scalars['String'],filters?: (GetProductsFilter | null)}

export interface GetNoUnitsPhysicalCountProductQuantitiesInput {id: Scalars['ID'],companyId: Scalars['String'],productQuantityFilter?: (ProductQuantityFilter | null),page?: (PageInput | null),asOfDate: Scalars['Date'],filters?: (GetProductsFilter | null),sort?: (GetNoUnitsPhysicalCountProductQuantitiesSort | null)}

export interface GetNoUnitsPhysicalCountProductQuantitiesSort {field: GetNoUnitsPhysicalCountProductQuantitiesSortField,direction: ProductsSortDirection}

export interface GetOffersInput {companyId: Scalars['ID']}

export interface GetOffersResponseGenqlSelection{
    status?: boolean | number
    offers?: OfferGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GetOnboardingStatusesInput {companyId: Scalars['ID']}

export interface GetOnboardingStatusInput {companyId: Scalars['ID'],scope: OnboardingScope,step?: (Scalars['String'] | null)}

export interface GetOrderFilteringBoundsResultGenqlSelection{
    finaloopPaymentGateways?: boolean | number
    salesChannels?: boolean | number
    orderTotalP999?: boolean | number
    maxItemsCount?: boolean | number
    availableStatuses?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GetOrdersAggregationsInput {filter: GetOrdersFilter,companyId: Scalars['ID']}

export interface GetOrdersDateRangeInput {min: Scalars['Date'],max: Scalars['Date']}

export interface GetOrdersFilter {productIds?: (Scalars['ID'][] | null),tagIds?: (Scalars['ID'][] | null),customerIds?: (Scalars['ID'][] | null),paymentStatuses?: (OrderPaymentStatus[] | null),finaloopStatus?: (OrderFinaloopStatus[] | null),finaloopPaymentGateways?: (Scalars['String'][] | null),salesChannels?: (Scalars['String'][] | null),integrationAccountIds?: (Scalars['String'][] | null),itemsCount?: (FloatRange | null),totalAmountInHomeCurrency?: (FloatRange | null),balanceAsOfAmount?: (FloatRange | null),placedDate?: (GetOrdersDateRangeInput | null),firstPaymentDate?: (GetOrdersDateRangeInput | null),firstRefundDate?: (GetOrdersDateRangeInput | null),firstFulfillmentDate?: (GetOrdersDateRangeInput | null),unpaidAsOfDate?: (Scalars['Date'] | null),hasRestockedItem?: (Scalars['Boolean'] | null),allTransactionsMatched?: (Scalars['Boolean'] | null),fulfillmentStatuses?: (OrderFulfillmentStatus[] | null),fulfillmentWarehouseIds?: (Scalars['ID'][] | null),fulfillmentDate?: (GetOrdersDateRangeInput | null),searchText?: (Scalars['String'] | null),agingPreset?: (OrdersAgingPreset | null)}

export interface GetOrdersInput {companyId: Scalars['ID'],filter: GetOrdersFilter,sort: GetOrdersSort,limit: Scalars['Int'],offset: Scalars['Int']}

export interface GetOrdersResultV2GenqlSelection{
    orders?: OrderV2GenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GetOrdersSort {type: GetOrdersSortType,direction: GetOrdersSortDirection}

export interface GetPaymentFeesByIdsInput {ids: Scalars['ID'][],companyId: Scalars['ID']}

export interface GetPaymentsByIdsInput {ids: Scalars['ID'][],companyId: Scalars['ID']}

export interface GetPendingAdjustmentsByIdsInput {ids: Scalars['String'][]}

export interface GetPendingAdjustmentsFilter {attributes?: (ProductAttributesTypes[] | null),searchText?: (Scalars['String'] | null),source?: (Scalars['String'][] | null),warehouseId?: (Scalars['String'][] | null),dataType?: (PendingProductAdjustmentsDataType | null)}

export interface GetPendingAdjustmentsInput {companyId: Scalars['ID'],limit: Scalars['Int'],offset: Scalars['Int'],endDate?: (Scalars['Date'] | null),startDate?: (Scalars['Date'] | null),sort?: (GetPendingAdjustmentsSort | null),filter?: (GetPendingAdjustmentsFilter | null)}

export interface GetPendingAdjustmentsOverviewInput {companyId: Scalars['ID'],endDate?: (Scalars['Date'] | null),startDate?: (Scalars['Date'] | null),filter?: (GetPendingAdjustmentsFilter | null)}

export interface GetPendingAdjustmentsSort {field: GetPendingAdjustmentsSortField,direction: ProductsSortDirection}

export interface GetPendingSalesDataAdjustmentsInputV2 {salesChannel: SalesChannelInput,companyId: Scalars['ID'],limit: Scalars['Int'],offset: Scalars['Int'],endDate?: (Scalars['Date'] | null),startDate?: (Scalars['Date'] | null),sort?: (GetPendingAdjustmentsSort | null),filter?: (GetPendingAdjustmentsFilter | null)}

export interface GetPendingSalesDataAdjustmentsOverviewInputV2 {salesChannel: SalesChannelInput,companyId: Scalars['ID'],endDate?: (Scalars['Date'] | null),startDate?: (Scalars['Date'] | null),filter?: (GetPendingAdjustmentsFilter | null)}

export interface GetPendingSalesDataAdjustmentsSort {field: GetPendingSalesDataAdjustmentsSortField,direction: ProductsSortDirection}

export interface GetPendingWarehouseOpeningBalancesAttachmentsInput {companyId: Scalars['ID'],date: Scalars['Date'],displayDeleted?: (Scalars['Boolean'] | null),limit?: (Scalars['Int'] | null),offset?: (Scalars['Int'] | null)}

export interface GetProductAutomergeSettingsInput {companyId: Scalars['ID']}

export interface GetProductAutomergeSettingsResponseGenqlSelection{
    matchGroupSettings?: ProductAutomergeMatchGroupSettingGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GetProductBulkAdjustmentStatusGenqlSelection{
    id?: boolean | number
    companyId?: boolean | number
    state?: boolean | number
    totalAmount?: boolean | number
    processedAmount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GetProductBulkAdjustmentStatusInput {companyId: Scalars['ID']}

export interface GetProductInput {companyId: Scalars['ID'],productId: Scalars['String']}

export interface GetProductMergeLogsFiltersInput {searchText?: (Scalars['String'] | null),trigger?: (ProductMergeLogTriggerType[] | null),mergedBy?: (Scalars['String'][] | null),productIds?: (Scalars['String'][] | null),from?: (Scalars['Date'] | null),to?: (Scalars['Date'] | null),source?: (Scalars['String'][] | null),showLatestMergeState?: (Scalars['Boolean'] | null)}

export interface GetProductMergeLogsInput {companyId: Scalars['ID'],offset: Scalars['Int'],limit: Scalars['Int'],sort: GetProductMergeLogsSortInput,filters: GetProductMergeLogsFiltersInput}

export interface GetProductMergeLogsOverviewInput {companyId: Scalars['ID'],filters: GetProductMergeLogsFiltersInput}

export interface GetProductMergeLogsOverviewResponseGenqlSelection{
    total?: boolean | number
    mergedByOptions?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GetProductMergeLogsResponseGenqlSelection{
    items?: ProductMergeLogItemGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GetProductMergeLogsSortInput {field: ProductMergeLogSortField,direction: ProductMergeLogSortDirection}

export interface GetProductMergeRecommendationsMatchGroupInput {companyId: Scalars['ID'],matchGroupId: Scalars['String'],offset: Scalars['Int'],limit: Scalars['Int']}

export interface GetProductMergeRecommendationsMatchGroupResponseGenqlSelection{
    productGroups?: ProductMergeRecommendationsProductGroupGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GetProductsFilter {searchText?: (Scalars['String'] | null),sku?: (Scalars['String'] | null),ids?: (Scalars['String'][] | null),source?: (Scalars['String'][] | null),withoutCostOnly?: (Scalars['Boolean'] | null),withNegativeOnHandOnly?: (Scalars['Boolean'] | null),attributes?: (ProductAttributesTypes[] | null),canEditCurrentAppliedCost?: (Scalars['Boolean'] | null),onlyPrimaryProducts?: (Scalars['Boolean'] | null),warehouseId?: (Scalars['String'][] | null),asOfDate?: (Scalars['Date'] | null),startDate?: (Scalars['Date'] | null),notMatchingProducts?: (Scalars['Boolean'] | null)}

export interface GetProductsInput {companyId: Scalars['ID'],limit: Scalars['Int'],offset: Scalars['Int'],sort?: (GetProductsSort | null),filter?: (GetProductsFilter | null),extendedList?: (Scalars['Boolean'] | null),extendedWithWarehousesList?: (Scalars['Boolean'] | null),splitByIsDropshipping?: (Scalars['Boolean'] | null)}

export interface GetProductsSort {field: GetProductsSortField,direction: ProductsSortDirection}

export interface GetPurchaseOrderInput {companyId: Scalars['ID'],purchaseOrderId: Scalars['String']}

export interface GetPurchaseOrdersInput {companyId: Scalars['ID'],purchaseOrderIds?: (Scalars['String'][] | null),returnDeleted?: (Scalars['Boolean'] | null),searchField?: (Scalars['String'] | null),productIds?: (Scalars['String'][] | null),status?: (PurchaseOrderStatus[] | null),fromInProgressDate?: (Scalars['Date'] | null),toInProgressDate?: (Scalars['Date'] | null),fromLandedCostTotal?: (Scalars['Float'] | null),toLandedCostTotal?: (Scalars['Float'] | null),sortField?: (PurchaseOrdersSortField | null),sortDirection?: (SortDirection | null),showHistorical?: (Scalars['Boolean'] | null),vendorId?: (Scalars['String'] | null),paidStatus?: (PaidStatus[] | null),limit?: (Scalars['Int'] | null),offset?: (Scalars['Int'] | null)}

export interface GetPurchaseOrdersOverviewInput {companyId: Scalars['ID'],purchaseOrderIds?: (Scalars['String'][] | null),returnDeleted?: (Scalars['Boolean'] | null),searchField?: (Scalars['String'] | null),vendorId?: (Scalars['String'] | null),productIds?: (Scalars['String'][] | null),fromInProgressDate?: (Scalars['Date'] | null),toInProgressDate?: (Scalars['Date'] | null),fromLandedCostTotal?: (Scalars['Float'] | null),toLandedCostTotal?: (Scalars['Float'] | null),showHistorical?: (Scalars['Boolean'] | null),paidStatus?: (PaidStatus[] | null)}

export interface GetReadyValidationInput {companyId: Scalars['ID'],validationId: Scalars['ID']}

export interface GetReadyValidationResponseGenqlSelection{
    url?: boolean | number
    from?: boolean | number
    to?: boolean | number
    generatedAt?: boolean | number
    generatedBy?: boolean | number
    isGreen?: boolean | number
    isError?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GetRefundsByIdsInput {ids: Scalars['ID'][],companyId: Scalars['ID']}

export interface GetSaleAggregationsInput {companyId: Scalars['ID'],filter?: (GetSalesFilter | null)}

export interface GetSaleDateRangeInput {min?: (Scalars['Date'] | null),max?: (Scalars['Date'] | null)}

export interface GetSaleFloatRangeInput {min?: (Scalars['Float'] | null),max?: (Scalars['Float'] | null)}

export interface GetSaleIntRangeInput {min?: (Scalars['Int'] | null),max?: (Scalars['Int'] | null)}

export interface GetSalesChannelsFilter {ids?: (Scalars['ID'][] | null),source?: (Scalars['String'] | null),name?: (Scalars['String'] | null),withDeleted?: (Scalars['Boolean'] | null)}

export interface GetSalesChannelsInput {companyId: Scalars['ID'],filter?: (GetSalesChannelsFilter | null),sort?: (GetSalesSort | null),limit?: (Scalars['Int'] | null),offset?: (Scalars['Int'] | null)}

export interface GetSalesChannelTemplatesInput {filter?: (GetSalesChannelsFilter | null),sort?: (GetSalesSort | null),limit?: (Scalars['Int'] | null),offset?: (Scalars['Int'] | null)}

export interface GetSalesFilter {ids?: (Scalars['ID'][] | null),customerIds?: (Scalars['ID'][] | null),excludeCustomerIds?: (Scalars['ID'][] | null),withDeleted?: (Scalars['Boolean'] | null),withForReview?: (Scalars['Boolean'] | null),withoutVoided?: (Scalars['Boolean'] | null),withoutDrafts?: (Scalars['Boolean'] | null),includeAllPreBSD?: (Scalars['Boolean'] | null),salesChannelName?: (Scalars['String'] | null),search?: (Scalars['String'] | null),sources?: (SaleSource[] | null),dueInDays?: (GetSaleIntRangeInput | null),total?: (GetSaleFloatRangeInput | null),balance?: (GetSaleFloatRangeInput | null),netSales?: (GetSaleFloatRangeInput | null),postedAt?: (GetSaleDateRangeInput | null),firstPaymentDate?: (GetSaleDateRangeInput | null),uploadId?: (Scalars['String'] | null),uploadDate?: (Scalars['Date'] | null),currencies?: (CurrencyCode[] | null),excludeCurrencies?: (CurrencyCode[] | null),paymentMethodIds?: (Scalars['ID'][] | null),productIds?: (Scalars['ID'][] | null),unpaidAsOfDate?: (Scalars['Date'] | null),statuses?: (SaleStatus[] | null)}

export interface GetSalesInput {companyId: Scalars['ID'],filter?: (GetSalesFilter | null),sort?: (GetSalesSort | null),limit?: (Scalars['Int'] | null),offset?: (Scalars['Int'] | null),balanceAsOfDate?: (Scalars['Date'] | null)}

export interface GetSalesResultGenqlSelection{
    sales?: SaleGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GetSalesSort {type: GetSalesSortType,direction: GetSalesSortDirection}

export interface GetSellingFeesByIdsInput {companyId: Scalars['ID'],sellingFeeIds: Scalars['ID'][]}

export interface GetShippingCostsByIdsInput {companyId: Scalars['ID'],shippingCostIds: Scalars['ID'][]}

export interface GetSignedDatesInput {companyId: Scalars['String'],periodStart: Scalars['Date']}

export interface GetSignedDatesResponseGenqlSelection{
    dates?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GetSignedUrlByExportedLogIdResponseGenqlSelection{
    downloadUrl?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GetTax1099AffiliatedEntityGroupsInput {companyId: Scalars['ID'],calendarYear: Scalars['Int']}

export interface GetUnitsTrackingPhysicalCountInput {id: Scalars['ID'],companyId: Scalars['String'],asOfDate?: (Scalars['Date'] | null),warehouseId?: (Scalars['String'] | null)}

export interface GetUnitsTrackingPhysicalCountOverviewInput {physicalCountId: Scalars['String'],companyId: Scalars['String'],asOfDate?: (Scalars['Date'] | null),filters?: (GetProductsFilter | null)}

export interface GetUnitsTrackingPhysicalCountProductQuantitiesInput {id: Scalars['ID'],companyId: Scalars['String'],productQuantityFilter?: (ProductQuantityFilter | null),asOfDate?: (Scalars['Date'] | null),page?: (PageInput | null),filters?: (GetProductsFilter | null),sort?: (GetUnitsTrackingPhysicalCountProductQuantitiesSort | null)}

export interface GetUnitsTrackingPhysicalCountProductQuantitiesSort {field: GetUnitsTrackingPhysicalCountProductQuantitiesSortField,direction: ProductsSortDirection}

export interface GetUnpaidOrdersAgingCsvInput {companyId: Scalars['ID'],filter: GetOrdersFilter,sort: GetOrdersSort}

export interface GetUnpaidOrdersCsvInput {companyId: Scalars['ID'],filter: GetOrdersFilter,sort: GetOrdersSort}

export interface GetUnpaidOrdersCsvResponseGenqlSelection{
    url?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GetValidationCycleInput {executionId: Scalars['String']}

export interface GetValidationTemplatesInput {validationType: CompanyValidationType,endTime?: (ValidationTemplateEndTime | null)}

export interface GetVendorInput {companyId: Scalars['ID'],id: Scalars['ID']}

export interface GetVendorResponseGenqlSelection{
    on_Vendor?:VendorGenqlSelection,
    on_VendorNotExistError?:VendorNotExistErrorGenqlSelection,
    on_Error?: ErrorGenqlSelection,
    __typename?: boolean | number
}

export interface GetVendorsInput {companyId: Scalars['ID'],ids: Scalars['ID'][]}

export interface GetWarehouseOpeningBalanceOverviewInput {companyId: Scalars['ID'],date: Scalars['Date'],text?: (Scalars['String'] | null),warehouseIds?: (Scalars['ID'][] | null),missingData?: (Scalars['Boolean'] | null),pendingChanges?: (Scalars['Boolean'] | null),attachmentIds?: (Scalars['ID'][] | null),productSource?: (Scalars['String'][] | null),productAttributes?: (ProductAttributesTypes[] | null)}

export interface GetWarehouseOpeningBalancesInput {companyId: Scalars['ID'],date: Scalars['Date'],productSource?: (Scalars['String'][] | null),productAttributes?: (ProductAttributesTypes[] | null),text?: (Scalars['String'] | null),warehouseIds?: (Scalars['ID'][] | null),missingData?: (Scalars['Boolean'] | null),pendingChanges?: (Scalars['Boolean'] | null),attachmentIds?: (Scalars['ID'][] | null),sort?: (WarehouseOpeningBalanceSort | null),limit: Scalars['Int'],offset: Scalars['Int']}

export interface GetWarehousesDefaultsInput {companyId: Scalars['ID']}

export interface GetWarehousesInput {ids?: (Scalars['String'][] | null),companyId: Scalars['ID'],limit: Scalars['Int'],offset: Scalars['Int'],searchText?: (Scalars['String'] | null),includeMerged?: (Scalars['Boolean'] | null)}

export interface GetWarehouseTransferInput {companyId: Scalars['String'],id: Scalars['String']}

export interface GetWarehouseTransfersInput {filters: CommonWarehouseTransfersFilterInput,status?: (WarehouseTransferStatus[] | null),sort: WarehouseTransfersSortInput,offset: Scalars['Int'],limit: Scalars['Int']}

export interface GiftCardGenqlSelection{
    id?: boolean | number
    company?: CompanyGenqlSelection
    integrationAccountId?: boolean | number
    source?: boolean | number
    externalSourceId?: boolean | number
    status?: boolean | number
    lastCharacters?: boolean | number
    issueMethod?: boolean | number
    customer?: CustomerV2GenqlSelection
    issuingOrder?: OrderV2GenqlSelection
    issuedAt?: boolean | number
    expiredAt?: boolean | number
    deactivatedAt?: boolean | number
    disabledAt?: boolean | number
    currency?: boolean | number
    initialBalance?: boolean | number
    initialBalanceInHomeCurrency?: boolean | number
    remainingBalance?: boolean | number
    remainingBalanceInHomeCurrency?: boolean | number
    note?: boolean | number
    transactions?: GiftCardTransactionGenqlSelection
    balance?: boolean | number
    balanceInHomeCurrency?: boolean | number
    deactivationDate?: boolean | number
    balanceAsOf?: boolean | number
    deletedAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GiftCardAggregationsInput {companyId: Scalars['ID'],balanceAsOfDate?: (Scalars['Date'] | null),filter?: (GiftCardsFilter | null)}

export interface GiftCardAggregationsResultGenqlSelection{
    giftCardsCount?: boolean | number
    totalBalance?: boolean | number
    purchasedGiftCardsBalance?: boolean | number
    maximumGiftCardBalance?: boolean | number
    totalBalanceInHomeCurrency?: boolean | number
    purchasedGiftCardsBalanceInHomeCurrency?: boolean | number
    maximumGiftCardBalanceInHomeCurrency?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GiftCardsBalanceFilter {min: Scalars['Float'],max: Scalars['Float']}

export interface GiftCardsByIdsInput {companyId: Scalars['ID'],ids: Scalars['ID'][],includeDeleted?: (Scalars['Boolean'] | null)}

export interface GiftCardsByIdsResponseGenqlSelection{
    giftCards?: GiftCardGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GiftCardsCsvInput {companyId: Scalars['ID'],filter?: (GiftCardsFilter | null),balanceAsOfDate?: (Scalars['Date'] | null),sort?: (GiftCardsSort | null)}

export interface GiftCardsCsvResponseGenqlSelection{
    url?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GiftCardsFilter {integrationAccountIds?: (Scalars['String'][] | null),issueMethod?: (GiftCardIssueMethod[] | null),status?: (GiftCardStatus[] | null),currentBalance?: (GiftCardsBalanceFilter | null),lastCharacters?: (Scalars['String'] | null)}

export interface GiftCardsInput {companyId: Scalars['ID'],balanceAsOfDate?: (Scalars['Date'] | null),filter?: (GiftCardsFilter | null),sort?: (GiftCardsSort | null),limit: Scalars['Int'],offset: Scalars['Int']}

export interface GiftCardsMaximumCompanyBalanceInput {companyId: Scalars['ID']}

export interface GiftCardsMaximumCompanyBalanceResultGenqlSelection{
    maximumBalance?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GiftCardsResultGenqlSelection{
    giftCards?: GiftCardGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GiftCardsSort {sortMethod: GiftCardSortKeys,direction: GiftCardsSortDirection}

export interface GiftCardTransactionGenqlSelection{
    id?: boolean | number
    externalSourceId?: boolean | number
    currency?: boolean | number
    amount?: boolean | number
    amountInHomeCurrency?: boolean | number
    postedAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GiveawayCogsGenqlSelection{
    amount?: boolean | number
    quantity?: boolean | number
    monthlyBreakdown?: GiveawayMonthlyBreakdownGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GiveawayDailyBreakdownGenqlSelection{
    date?: boolean | number
    quantity?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GiveawayDropshippingOriginalValueGenqlSelection{
    quantity?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GiveawayMonthlyBreakdownGenqlSelection{
    date?: boolean | number
    quantity?: boolean | number
    dailyData?: GiveawayDailyBreakdownGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GiveawayOriginalValueGenqlSelection{
    quantity?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GlobalRuleExistByVendorAndMoneyDirectionInput {vendorId: Scalars['String'],moneyDirection: MoneyDirection}

export interface GlobalRuleInput {vendorId: Scalars['String'],metadata?: (Scalars['JSONObject'] | null),outcome: Scalars['JSONObject'],conditions: (Scalars['JSONObject'] | null)[],logicalOperator: RootConditionOperator,updatedAtMS?: (Scalars['Int'] | null)}

export interface GlobalVendorMappingRuleGenqlSelection{
    id?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GoogleConnectionLinkInput {state?: (Scalars['JSONObject'] | null)}

export interface GoogleConnectLinkResponseGenqlSelection{
    link?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GoogleConnectStatusResponseGenqlSelection{
    isConnected?: boolean | number
    email?: boolean | number
    sharedFolderUrl?: boolean | number
    sharedFolderName?: boolean | number
    accessToken?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GoogleTokenCodeArgs {companyId: Scalars['ID'],code: Scalars['String'],scope: Scalars['String']}

export interface GoogleTokenCodeResponseGenqlSelection{
    success?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GrantEntitiesLockedPeriodBypassesInput {companyId: Scalars['ID'],unlockDurationSeconds: Scalars['Int'],entitiesByType: EntitiesByType[]}

export interface GTMSourceGenqlSelection{
    utms?: GTMSourceUtmsGenqlSelection
    identifiers?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GTMSourceInput {utms?: (GTMSourceUtmsInput | null),identifiers?: (Scalars['JSON'] | null),userAgent?: (Scalars['String'] | null),xGtmServerPreview?: (Scalars['String'] | null)}

export interface GTMSourceUtmsGenqlSelection{
    firstUtms?: GTMUtmsGenqlSelection
    lastUtms?: GTMUtmsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GTMSourceUtmsInput {firstUtms?: (GTMUtmsInput | null),lastUtms?: (GTMUtmsInput | null)}

export interface GTMUtmsGenqlSelection{
    utmTimestamp?: boolean | number
    uuid?: boolean | number
    utmSource?: boolean | number
    utmMedium?: boolean | number
    utmCampaign?: boolean | number
    firstPageSeen?: boolean | number
    utmTerm?: boolean | number
    utmContent?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GTMUtmsInput {utmTimestamp?: (Scalars['String'] | null),uuid?: (Scalars['String'] | null),utmSource?: (Scalars['String'] | null),utmMedium?: (Scalars['String'] | null),utmCampaign?: (Scalars['String'] | null),firstPageSeen?: (Scalars['String'] | null),utmTerm?: (Scalars['String'] | null),utmContent?: (Scalars['String'] | null)}

export interface HandleUserLoginArgs {source?: (Scalars['JSON'] | null),invitationCode?: (Scalars['String'] | null),gtmSource?: (GTMSourceInput | null)}

export interface HandleUserLoginResponseGenqlSelection{
    acceptedInviteCompanyInfo?: AcceptedInviteCompanyInfoGenqlSelection
    wasCompanyCreated?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface HasOrdersInOrderGroupsInput {companyId: Scalars['String'],salesChannelId: Scalars['String'],dateRange: DateRangeInput}

export interface HasOrdersInOrderGroupsResponseGenqlSelection{
    hasOrders?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface HasProductMergeRecommendationsInput {companyId: Scalars['ID']}

export interface HasProductMergeRecommendationsResponseGenqlSelection{
    hasProductMergeRecommendations?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface HasUnacknowledgedChangesInput {companyId: Scalars['ID'],managementMethodId: Scalars['ID']}

export interface HealthStatusSortType {validation: CompanyValidationSortByValidationInput,direction: CompanyHealthStatusSortDirection}

export interface HistoricalPayment {orderId: Scalars['ID'],amountInHomeCurrency: Scalars['Float']}

export interface HolderGenqlSelection{
    id?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface HolderCapitalInvestmentGenqlSelection{
    id?: boolean | number
    company?: CompanyGenqlSelection
    holder?: CompanyAffiliateGenqlSelection
    amount?: boolean | number
    bankTransactionId?: boolean | number
    holderTransactionId?: boolean | number
    businessEventId?: boolean | number
    loanManualEventId?: boolean | number
    configuration?: EquityEventsEffectConfigurationGenqlSelection
    businessEventData?: BusinessEventDataGenqlSelection
    memo?: boolean | number
    postedAt?: boolean | number
    latestActorId?: boolean | number
    createdAt?: boolean | number
    updatedAt?: boolean | number
    deletedAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface HolderCapitalInvestmentsByIdsInput {ids: Scalars['ID'][],includeDeleted?: (Scalars['Boolean'] | null)}

export interface HolderCapitalInvestmentsInput {companyId: Scalars['ID']}

export interface HolderSafeInvestmentGenqlSelection{
    id?: boolean | number
    company?: CompanyGenqlSelection
    safeHolder?: CompanyAffiliateGenqlSelection
    amount?: boolean | number
    bankTransactionId?: boolean | number
    holderTransactionId?: boolean | number
    businessEventId?: boolean | number
    loanManualEventId?: boolean | number
    configuration?: EquityEventsEffectConfigurationGenqlSelection
    businessEventData?: BusinessEventDataGenqlSelection
    memo?: boolean | number
    postedAt?: boolean | number
    latestActorId?: boolean | number
    createdAt?: boolean | number
    updatedAt?: boolean | number
    deletedAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface HolderSafeInvestmentsByIdsInput {ids: Scalars['ID'][],includeDeleted?: (Scalars['Boolean'] | null)}

export interface HolderShareGenqlSelection{
    id?: boolean | number
    company?: CompanyGenqlSelection
    holder?: CompanyAffiliateGenqlSelection
    type?: boolean | number
    series?: boolean | number
    amount?: boolean | number
    parValue?: boolean | number
    quantity?: boolean | number
    bankTransactionId?: boolean | number
    holderTransactionId?: boolean | number
    businessEventId?: boolean | number
    loanManualEventId?: boolean | number
    configuration?: EquityEventsEffectConfigurationGenqlSelection
    businessEventData?: BusinessEventDataGenqlSelection
    memo?: boolean | number
    postedAt?: boolean | number
    latestActorId?: boolean | number
    createdAt?: boolean | number
    updatedAt?: boolean | number
    deletedAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface HolderSharesByIdsInput {ids: Scalars['ID'][],includeDeleted?: (Scalars['Boolean'] | null)}

export interface HolderSharesInput {companyId: Scalars['ID']}

export interface HolderTransactionGenqlSelection{
    id?: boolean | number
    company?: CompanyGenqlSelection
    holder?: CompanyAffiliateGenqlSelection
    bankTransaction?: BankTransactionGenqlSelection
    type?: boolean | number
    businessEventId?: boolean | number
    loanManualEventId?: boolean | number
    configuration?: EquityEventsEffectConfigurationGenqlSelection
    businessEventData?: BusinessEventDataGenqlSelection
    memo?: boolean | number
    amount?: boolean | number
    postedAt?: boolean | number
    latestActorId?: boolean | number
    createdAt?: boolean | number
    updatedAt?: boolean | number
    deletedAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface HolderTransactionsByIdsInput {ids: Scalars['ID'][],includeDeleted?: (Scalars['Boolean'] | null)}

export interface HolderTransactionsInput {companyId: Scalars['ID'],onlyManual?: (Scalars['Boolean'] | null),includeDeleted?: (Scalars['Boolean'] | null)}

export interface HubItemStateChangeLogGenqlSelection{
    id?: boolean | number
    createdAt?: boolean | number
    updaterType?: boolean | number
    changedByUid?: boolean | number
    reason?: boolean | number
    oldValue?: boolean | number
    newValue?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface HubStateChangeLogGenqlSelection{
    id?: boolean | number
    createdAt?: boolean | number
    updaterType?: boolean | number
    changedByUid?: boolean | number
    reason?: boolean | number
    oldValue?: boolean | number
    newValue?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface IdResultGenqlSelection{
    id?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ImageUploadUrlResultGenqlSelection{
    uploadUrl?: boolean | number
    url?: boolean | number
    iconUrl?: boolean | number
    fileName?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ImpersonateArgs {companyIdToSwitchTo: Scalars['String']}

export interface ImpersonateResponseGenqlSelection{
    success?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface IncludedFinaloopSalesChannelItemReconciliationGenqlSelection{
    salesChannel?: ItemReconciliationFinaloopSalesChannelGenqlSelection
    data?: IncludedShopifySalesChannelItemReconciliationGenqlSelection
    summary?: ReconciliationSummaryGenqlSelection
    productItemSoldData?: ShopifySkuReconciliationProductItemSoldDataGenqlSelection
    productStatus?: ShopifyReconciliationProductsStatusGenqlSelection
    unknownSkuQuantity?: boolean | number
    unknownSkuZeroPriceQuantity?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface IncludedShopifySalesChannelItemReconciliationGenqlSelection{
    sku?: boolean | number
    isBlacklisted?: boolean | number
    salesChannel?: ItemReconciliationFinaloopSalesChannelGenqlSelection
    shopifySalesChannel?: boolean | number
    summary?: ReconciliationSummaryGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface IncomingBatchAnalyticsGenqlSelection{
    origin?: IncomingBatchOriginGenqlSelection
    analytics?: IncomingInventoryAnalyticsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface IncomingBatchOriginGenqlSelection{
    on_Shipment?:ShipmentGenqlSelection,
    on_WarehouseOpeningBalance?:WarehouseOpeningBalanceGenqlSelection,
    on_RecipeWithBreakdown?:RecipeWithBreakdownGenqlSelection,
    on_ManualAssemblyWithBreakdown?:ManualAssemblyWithBreakdownGenqlSelection,
    on_WarehouseTransferWithBreakdown?:WarehouseTransferWithBreakdownGenqlSelection,
    on_UnitsTrackingPhysicalCount?:UnitsTrackingPhysicalCountGenqlSelection,
    on_WarehouseNegativesAdjustmentBreakdown?:WarehouseNegativesAdjustmentBreakdownGenqlSelection,
    __typename?: boolean | number
}

export interface IncomingInventoryAnalyticsGenqlSelection{
    assembled?: boolean | number
    incoming?: boolean | number
    fulfilled?: boolean | number
    lost?: boolean | number
    found?: boolean | number
    warehouseTransfers?: boolean | number
    adjustments?: boolean | number
    deadInventory?: boolean | number
    otherAdjustments?: boolean | number
    restocked?: boolean | number
    onHand?: boolean | number
    landedCostPerUnit?: boolean | number
    onHandCost?: boolean | number
    unavailable?: boolean | number
    unavailableByAssemblies?: boolean | number
    unavailableByWarehouseTransfersOut?: boolean | number
    unavailableByAdjustmentsDeadInventory?: boolean | number
    unavailableByDeadInventory?: boolean | number
    unavailableByUnitLost?: boolean | number
    unavailableByUnitFound?: boolean | number
    unavailableByOtherAdjustments?: boolean | number
    netDepleted?: boolean | number
    openingBalanceQuantity?: boolean | number
    openingBalanceCost?: boolean | number
    physicalCountAdjustmentOut?: boolean | number
    unavailableBreakdown?: IncomingInventoryAnalyticsUnavailableBreakdownGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface IncomingInventoryAnalyticsUnavailableBreakdownGenqlSelection{
    date?: boolean | number
    total?: boolean | number
    action?: WarehouseActionGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface IndirectCostAllocationGenqlSelection{
    id?: boolean | number
    indirectLineItem?: IndirectLineItemGenqlSelection
    allocatedCostPerUnit?: boolean | number
    remainderAllocationCostPerUnit?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface IndirectCostAllocationInput {indirectLineItemId: Scalars['ID'],allocatedCostPerUnit: Scalars['Float'],remainderAllocationCostPerUnit?: (Scalars['Float'] | null)}

export interface IndirectLineItemGenqlSelection{
    id?: boolean | number
    type?: boolean | number
    cost?: boolean | number
    vendor?: VendorGenqlSelection
    isDefaultVendor?: boolean | number
    hasAutomaticAllocation?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface IndirectLineItemInput {id: Scalars['ID'],type: IndirectLineItemType,cost: Scalars['Float'],vendorId: Scalars['ID'],isDefaultVendor: Scalars['Boolean'],hasAutomaticAllocation?: (Scalars['Boolean'] | null)}

export interface IndividualSkusInput {companyId: Scalars['ID'],fromDate: Scalars['Date'],toDate: Scalars['Date'],breakdown: Scalars['String'],timezone: Scalars['String'],comparisonPeriod: Scalars['String'],productIds: Scalars['String'][],source?: (SourceTypes | null),salesChannels?: ((Scalars['String'] | null)[] | null),limit?: (Scalars['Int'] | null),offset?: (Scalars['Int'] | null),sortBy?: (IndividualSkusSortBy | null)}

export interface IndividualSkusResponseGenqlSelection{
    title?: boolean | number
    updatedAt?: boolean | number
    data?: SkuDataByDateGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface IndividualSkusSortBy {field: IndividualSkusSortField,direction: SortDirection}

export interface InitiateTotalArCashDiffsReportInput {unpaidBalanceAsOf: Scalars['Date']}

export interface InstitutionGenqlSelection{
    id?: boolean | number
    name?: boolean | number
    preferredProvider?: boolean | number
    logoUrl?: boolean | number
    websiteUrl?: boolean | number
    affiliatedEntityId?: boolean | number
    csvInstructionsLink?: boolean | number
    pdfInstructionsLink?: boolean | number
    csvAvailable?: boolean | number
    pdfAvailable?: boolean | number
    dataConfig?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InstitutionMappingGenqlSelection{
    id?: boolean | number
    source?: boolean | number
    externalSourceId?: boolean | number
    externalSourceName?: boolean | number
    institutionId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InstitutionMappingResponseGenqlSelection{
    mappings?: InstitutionMappingGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InstitutionMappingsInput {source?: (InstitutionMappingSourceType | null),externalSourceId?: (Scalars['String'] | null),externalSourceName?: (Scalars['String'] | null),institutionId?: (Scalars['String'] | null)}

export interface InstitutionsInput {name?: (Scalars['String'] | null),searchTerm?: (Scalars['String'] | null),ids?: (Scalars['String'][] | null)}

export interface InstitutionsResponseGenqlSelection{
    institutions?: InstitutionGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InstitutionVendorIDGenqlSelection{
    vendorId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface IntegrationCompanyAddressInput {name: Scalars['String'],email: Scalars['String'],phone?: (Scalars['String'] | null),line1: Scalars['String'],line2?: (Scalars['String'] | null),city: Scalars['String'],country: Scalars['String'],province?: (Scalars['String'] | null),provinceCode?: (Scalars['String'] | null),state?: (Scalars['String'] | null),stateCode?: (Scalars['String'] | null),zip?: (Scalars['String'] | null)}

export interface IntegrationConnectionAccountGenqlSelection{
    integrationType?: boolean | number
    connectedAt?: boolean | number
    integrationAccountId?: boolean | number
    integrationAccountName?: boolean | number
    impactOnBooksSince?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface IntegrationConnectionsFilter {companyId: Scalars['ID'],connectionTypes?: (IntegrationConnectionType[] | null),integrationTypes?: (IntegrationType[] | null)}

export interface IntegrationCustomerAddressInput {line1: Scalars['String'],line2?: (Scalars['String'] | null),city: Scalars['String'],province?: (Scalars['String'] | null),provinceCode?: (Scalars['String'] | null),state?: (Scalars['String'] | null),stateCode?: (Scalars['String'] | null),country: Scalars['String'],countryCode?: (Scalars['String'] | null),zip?: (Scalars['String'] | null)}

export interface IntegrationCustomerInput {name?: (Scalars['String'] | null),email: Scalars['String'],externalSourceId?: (Scalars['ID'] | null)}

export interface IntegrationDiscountInput {id?: (Scalars['ID'] | null),amount: Scalars['Float'],type: DiscountType,description?: (Scalars['String'] | null),externalSourceId?: (Scalars['String'] | null)}

export interface IntegrationFulfillmentSettingGenqlSelection{
    companyId?: boolean | number
    integrationAccountId?: boolean | number
    source?: boolean | number
    methods?: FulfillmentMethodGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface IntegrationFulfillmentSettingsInput {integrationAccountId: Scalars['String'],methods: FulfillmentMethodInput[]}

export interface IntegrationIndicativeTransactionInput {postedAt: Scalars['Date'],amount: Scalars['Float'],currency: CurrencyCode,amountInHomeCurrency: Scalars['Float'],externalSourceId?: (Scalars['String'] | null)}

export interface IntegrationInfoGenqlSelection{
    accountId?: boolean | number
    accountName?: boolean | number
    externalSourceId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface IntegrationSaleLineItemInput {id?: (Scalars['ID'] | null),quantity: Scalars['Float'],unitPrice: Scalars['Float'],type: SaleLineItemType,currency: CurrencyCode,salesChannelName?: (Scalars['String'] | null),productId?: (Scalars['ID'] | null),sku?: (Scalars['String'] | null),description?: (Scalars['String'] | null),discounts?: (DiscountInput[] | null),taxRate?: (Scalars['Float'] | null),externalSourceId?: (Scalars['String'] | null)}

export interface IntegrationSaleTransactionGenqlSelection{
    id?: boolean | number
    integrationInfo?: IntegrationInfoGenqlSelection
    integrationAccountId?: boolean | number
    externalSourceId?: boolean | number
    amount?: boolean | number
    postedAt?: boolean | number
    currency?: boolean | number
    amountInHomeCurrency?: boolean | number
    type?: boolean | number
    finaloopPaymentGateway?: boolean | number
    originalPaymentGateway?: boolean | number
    paymentGatewayVariant?: boolean | number
    isIndication?: boolean | number
    source?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface IntegrationTransactionInput {postedAt: Scalars['Date'],amount: Scalars['Float'],currency: CurrencyCode,amountInHomeCurrency: Scalars['Float'],externalSourceId: Scalars['String']}

export interface IntegrationTransferGenqlSelection{
    id?: boolean | number
    companyId?: boolean | number
    amount?: boolean | number
    amountInUsd?: boolean | number
    currency?: boolean | number
    eventTime?: boolean | number
    deletedAt?: boolean | number
    markedAsReconciliationDiscrepancyAt?: boolean | number
    integrationType?: boolean | number
    pairedBankTransaction?: BankTransactionGenqlSelection
    pairedCompanyAffiliate?: CompanyAffiliateGenqlSelection
    type?: boolean | number
    classification?: IntegrationTransferClassificationGenqlSelection
    integrationAccountId?: boolean | number
    integrationAccountName?: boolean | number
    link?: boolean | number
    uploadedFileId?: boolean | number
    failedAt?: boolean | number
    failedAmountInUsd?: boolean | number
    markedAsUnidentifiedAt?: boolean | number
    rawEvent?: boolean | number
    on_Payout?: PayoutGenqlSelection
    on_Topup?: TopupGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface IntegrationTransferClassificationGenqlSelection{
    businessEvent?: boolean | number
    askTheUserResult?: boolean | number
    description?: boolean | number
    pairedEntity?: IntegrationTransferPairedEntityGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface IntegrationTransferClassificationInput {integrationTransferId: Scalars['ID'],businessEvent?: (Scalars['String'] | null),askTheUserResult?: (Scalars['JSONObject'] | null),description?: (Scalars['String'] | null),pairedEntity?: (IntegrationTransferPairedEntityInput | null)}

export interface IntegrationTransferGroupGenqlSelection{
    groupId?: boolean | number
    integrationTransfers?: IntegrationTransferGenqlSelection
    payer?: IntegrationTransferPartyGenqlSelection
    payee?: IntegrationTransferPartyGenqlSelection
    isProcessing?: boolean | number
    action?: boolean | number
    type?: boolean | number
    tooltipText?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface IntegrationTransferPairedEntityGenqlSelection{
    id?: boolean | number
    type?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface IntegrationTransferPairedEntityInput {id: Scalars['ID'],type: IntegrationTransferPairedEntityType}

export interface IntegrationTransferPartyGenqlSelection{
    on_UnknownIntegrationTransferBank?:UnknownIntegrationTransferBankGenqlSelection,
    on_UnknownIntegrationTransferAccount?:UnknownIntegrationTransferAccountGenqlSelection,
    on_Vendor?:VendorGenqlSelection,
    on_BankAccount?:BankAccountGenqlSelection,
    __typename?: boolean | number
}

export interface IntegrationTransferRuleGenqlSelection{
    id?: boolean | number
    integrationType?: boolean | number
    companyAffiliate?: CompanyAffiliateGenqlSelection
    integrationAccountId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface IntegrationTransfersByCompanyAffiliateInput {companyId: Scalars['ID'],companyAffiliateId: Scalars['ID']}

export interface IntegrationTransfersSort {closeToAmount?: (Scalars['Float'] | null),closeToDate?: (Scalars['Date'] | null),byDate?: (SortDirection | null)}

export interface IntegrationTransferTimeRangeInput {from?: (Scalars['Date'] | null),to?: (Scalars['Date'] | null)}

export interface IntegrationTransferV2GenqlSelection{
    companyId?: boolean | number
    id?: boolean | number
    source?: boolean | number
    integrationAccountId?: boolean | number
    integrationAccountName?: boolean | number
    amount?: boolean | number
    currency?: boolean | number
    postedAt?: boolean | number
    requestedAt?: boolean | number
    failedAt?: boolean | number
    type?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InternalTransferCandidatesInput {companyId: Scalars['ID'],bankTransactionId: Scalars['ID'],allowNotExactMatch?: (Scalars['Boolean'] | null)}

export interface internalTransferCandidatesV2Input {companyId: Scalars['ID'],bankTransactionId: Scalars['ID'],rangePercentageAmount?: (Scalars['Float'] | null),postedAt?: (DateRangeInput | null),allowNotExactDateMatch?: (Scalars['Boolean'] | null),sort?: (BankTransactionsSort | null),limit?: (Scalars['Int'] | null)}

export interface InventoryBatchGenqlSelection{
    action?: WarehouseActionGenqlSelection
    quantity?: boolean | number
    directCost?: boolean | number
    indirectCosts?: MovementIndirectCostGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryInitStatusGenqlSelection{
    areProductsLoaded?: boolean | number
    isSalesDataLoaded?: boolean | number
    isDataReconciled?: boolean | number
    hasPurchaseOrders?: boolean | number
    hasWarehouseOpeningBalances?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryPaymentGroupGenqlSelection{
    id?: boolean | number
    companyId?: boolean | number
    postedAt?: boolean | number
    createdAt?: boolean | number
    updatedAt?: boolean | number
    deletedAt?: boolean | number
    affiliatedEntity?: AffiliatedEntityGenqlSelection
    serialNumber?: boolean | number
    purchaseOrders?: PaymentGroupLinkedPurchaseOrderGenqlSelection
    warehouseTransfers?: PaymentGroupLinkedWarehouseTransferGenqlSelection
    inventoryPurchases?: PaymentGroupLinkedInventoryPurchasesGenqlSelection
    manualAssemblies?: PaymentGroupLinkedManualAssemblyGenqlSelection
    onDemandAssemblyVendorCosts?: PaymentGroupLinkedOnDemandAssemblyVendorCostGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryPaymentGroupByIdInput {inventoryPaymentGroupId: Scalars['ID'],companyId: Scalars['ID']}

export interface InventoryPaymentGroupByIdResponseGenqlSelection{
    inventoryPaymentGroup?: InventoryPaymentGroupGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryPaymentGroupLinkGenqlSelection{
    inventoryPaymentGroup?: InventoryPaymentGroupGenqlSelection
    serialNumber?: boolean | number
    amount?: boolean | number
    amountInHomeCurrency?: boolean | number
    currency?: boolean | number
    postedAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryPaymentGroupsByIdsInput {companyId: Scalars['ID'],inventoryPaymentGroupIds: Scalars['ID'][],withDeleted?: (Scalars['Boolean'] | null)}

export interface InventoryPaymentGroupsByIdsResponseGenqlSelection{
    inventoryPaymentGroups?: InventoryPaymentGroupGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryPaymentGroupsFilter {postedAt?: (DateRangeInput | null)}

export interface InventoryPaymentGroupsInput {companyId: Scalars['String'],filter: InventoryPaymentGroupsFilter,affiliatedEntityId: Scalars['String'],sort?: (InventoryPaymentGroupsSort | null),limit: Scalars['Int'],offset: Scalars['Int']}

export interface InventoryPaymentGroupsResponseGenqlSelection{
    inventoryPaymentGroups?: InventoryPaymentGroupGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryPaymentGroupsSort {type: InventoryPaymentGroupsSortType,direction: InventoryPaymentGroupsSortDirection}

export interface InventoryPaymentGroupUnclearedBalanceGenqlSelection{
    paymentGroup?: InventoryPaymentGroupGenqlSelection
    unclearedBalance?: AmountsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryPurchaseGenqlSelection{
    id?: boolean | number
    companyId?: boolean | number
    source?: boolean | number
    sourceEntity?: InventoryPurchaseSourceEntityGenqlSelection
    bankTransactionId?: boolean | number
    billId?: boolean | number
    amazonShippingInBusinessEventId?: boolean | number
    payrollId?: boolean | number
    sourceDescription?: boolean | number
    direction?: boolean | number
    dates?: DateRangeGenqlSelection
    affiliatedEntity?: AffiliatedEntityGenqlSelection
    currency?: boolean | number
    amount?: boolean | number
    amountInHomeCurrency?: boolean | number
    historicalPurchaseAffectingMethodId?: boolean | number
    categories?: InventoryPurchaseCategoryGenqlSelection
    items?: InventoryPurchaseItemGenqlSelection
    paymentStatus?: boolean | number
    canceledAt?: boolean | number
    lastUpdatedAt?: boolean | number
    attachments?: InventoryPurchaseAttachmentGenqlSelection
    paidAt?: boolean | number
    inventoryPaymentGroupLinks?: InventoryPaymentGroupLinkGenqlSelection
    unpaidAmount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryPurchaseAttachmentGenqlSelection{
    filename?: boolean | number
    url?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryPurchaseAttachmentInput {filename: Scalars['String'],url: Scalars['String']}

export interface InventoryPurchaseCategoryGenqlSelection{
    serialNumber?: boolean | number
    categoryName?: boolean | number
    purchaseType?: boolean | number
    amount?: boolean | number
    amountInHomeCurrency?: boolean | number
    classificationTag?: ClassificationTagGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryPurchaseCategoryInput {serialNumber: Scalars['Int'],categoryName: InventoryPurchaseCategoryName,purchaseType: InventoryPurchaseType,amount: Scalars['Float'],classificationTagId?: (Scalars['String'] | null)}

export interface InventoryPurchaseCategorySummaryGenqlSelection{
    categoryName?: boolean | number
    purchasedAmountInHomeCurrency?: boolean | number
    incidentalsAmountInHomeCurrency?: boolean | number
    receivedAmountInHomeCurrency?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryPurchaseInput {id?: (Scalars['ID'] | null),companyId: Scalars['ID'],sourceDescription: Scalars['String'],direction: InventoryPurchaseDirection,dates: DateRangeInput,vendorId?: (Scalars['ID'] | null),affiliatedEntityId?: (Scalars['ID'] | null),currency: Scalars['String'],amount: Scalars['Float'],categories: InventoryPurchaseCategoryInput[],items: InventoryPurchaseItemInput[],paymentStatus: InventoryPurchasePaymentStatus,lastUpdatedAt: Scalars['Date'],attachments: InventoryPurchaseAttachmentInput[]}

export interface InventoryPurchaseItemGenqlSelection{
    amount?: boolean | number
    shipmentDate?: boolean | number
    receivedDate?: boolean | number
    purchaseDate?: boolean | number
    note?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryPurchaseItemInput {amount: Scalars['Float'],shipmentDate?: (Scalars['Date'] | null),receivedDate?: (Scalars['Date'] | null),purchaseDate?: (Scalars['Date'] | null),note?: (Scalars['String'] | null)}

export interface InventoryPurchaseRuleGenqlSelection{
    id?: boolean | number
    affiliatedEntity?: AffiliatedEntityGenqlSelection
    categoryName?: boolean | number
    startDate?: boolean | number
    endDate?: boolean | number
    condition?: boolean | number
    amount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryPurchaseRulesResponseGenqlSelection{
    items?: InventoryPurchaseRuleGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryPurchasesCountByVendorItemGenqlSelection{
    affiliatedEntity?: AffiliatedEntityGenqlSelection
    count?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryPurchasesCountByVendorResponseGenqlSelection{
    items?: InventoryPurchasesCountByVendorItemGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryPurchasesExportResponseGenqlSelection{
    url?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryPurchaseSourceEntityGenqlSelection{
    on_BankTransaction?:BankTransactionGenqlSelection,
    on_Bill?:BillGenqlSelection,
    __typename?: boolean | number
}

export interface InventoryPurchasesResponseGenqlSelection{
    purchases?: InventoryPurchaseGenqlSelection
    hasNext?: boolean | number
    totalCount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryPurchasesSort {field: InventoryPurchasesSortByField,direction: InventoryPurchasesSortDirection}

export interface InventoryPurchasesSummaryResponseGenqlSelection{
    summary?: InventoryPurchaseCategorySummaryGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryPurchasesValidationResultGenqlSelection{
    checkTime?: boolean | number
    expectedInProcessBalance?: boolean | number
    expectedInTransitBalance?: boolean | number
    actualInProcessBalance?: boolean | number
    actualInTransitBalance?: boolean | number
    clearingAccountBalance?: boolean | number
    missingExpectedPurchaseIds?: boolean | number
    unexpectedPurchaseIds?: boolean | number
    missingExpectedBusinessEventsForPurchaseIds?: boolean | number
    unexpectedBusinessEventIds?: boolean | number
    status?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryPurchaseUpdateOutOfDateErrorGenqlSelection{
    inventoryPurchase?: InventoryPurchaseGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryPurchaseVendorsResponseGenqlSelection{
    items?: AffiliatedEntityGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventorySettingsGenqlSelection{
    companyId?: boolean | number
    managementMethod?: boolean | number
    onboardingCompletionTime?: boolean | number
    rangedManagementMethod?: RangedManagementMethodGenqlSelection
    isEligibleForNoClosingBalancePurchaseBased?: boolean | number
    openingBalance?: boolean | number
    latestOpeningBalanceBusinessEventId?: boolean | number
    closingBalances?: boolean | number
    latestClosingBalanceBusinessEventIds?: boolean | number
    realtimeCogsStatus?: RealtimeCogsStatusGenqlSelection
    hasUserReviewedProducts?: boolean | number
    haveDropshippingPurchase?: boolean | number
    isUsingPaymentGroupsFeature?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryVendorGenqlSelection{
    affiliatedEntity?: AffiliatedEntityGenqlSelection
    rollingBalance?: boolean | number
    unpaidBills?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryVendorAdjustmentGenqlSelection{
    date?: boolean | number
    amount?: boolean | number
    bill?: BillGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryVendorBillItemGenqlSelection{
    amount?: boolean | number
    balance?: boolean | number
    paidAmount?: boolean | number
    source?: InventoryVendorBillItemSourceGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryVendorBillItemSourceGenqlSelection{
    on_InventoryPurchase?:InventoryPurchaseGenqlSelection,
    on_InventoryVendorPayment?:InventoryVendorPaymentGenqlSelection,
    on_InventoryVendorCredit?:InventoryVendorCreditGenqlSelection,
    on_InventoryVendorAdjustment?:InventoryVendorAdjustmentGenqlSelection,
    __typename?: boolean | number
}

export interface InventoryVendorBillsOverviewResponseGenqlSelection{
    billsAmount?: boolean | number
    billPayments?: boolean | number
    billCredits?: boolean | number
    billAdjustments?: boolean | number
    billsPurchasesAmount?: boolean | number
    billsIncidentalPurchasesAmount?: boolean | number
    asOfDate?: InventoryVendorOverviewItemGenqlSelection
    beforeUnitsTracking?: InventoryVendorOverviewItemGenqlSelection
    count?: boolean | number
    minAmount?: boolean | number
    maxAmount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryVendorBillsResponseGenqlSelection{
    hasNext?: boolean | number
    count?: boolean | number
    items?: InventoryVendorBillItemGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryVendorCreditGenqlSelection{
    date?: boolean | number
    amount?: boolean | number
    bill?: BillGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryVendorFilterValuesResponseGenqlSelection{
    maxRollingBalance?: boolean | number
    minRollingBalance?: boolean | number
    maxUnpaidBills?: boolean | number
    minUnpaidBills?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryVendorOverviewItemGenqlSelection{
    amount?: boolean | number
    payments?: boolean | number
    credits?: boolean | number
    adjustments?: boolean | number
    purchasesAmount?: boolean | number
    incidentalPurchasesAmount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryVendorParamsResponseGenqlSelection{
    inventoryVendorBillsCount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryVendorPaymentGenqlSelection{
    date?: boolean | number
    amount?: boolean | number
    bill?: BillGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryVendorRollingBalanceItemGenqlSelection{
    amount?: boolean | number
    rollingBalance?: boolean | number
    source?: InventoryVendorRollingBalanceItemSourceGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryVendorRollingBalanceItemSourceGenqlSelection{
    on_PurchaseOrder?:PurchaseOrderGenqlSelection,
    on_InventoryPurchase?:InventoryPurchaseGenqlSelection,
    on_WarehouseTransfer?:WarehouseTransferGenqlSelection,
    on_Assembly?:AssemblyGenqlSelection,
    __typename?: boolean | number
}

export interface InventoryVendorRollingBalanceOverviewResponseGenqlSelection{
    affiliatedEntity?: AffiliatedEntityGenqlSelection
    purchaseOrdersBalance?: boolean | number
    warehouseTransfersBalance?: boolean | number
    paymentsBalance?: boolean | number
    billsBalance?: boolean | number
    assembliesBalance?: boolean | number
    count?: boolean | number
    minAmount?: boolean | number
    maxAmount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryVendorRollingBalanceResponseGenqlSelection{
    hasNext?: boolean | number
    items?: InventoryVendorRollingBalanceItemGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryVendorsOverviewResponseGenqlSelection{
    count?: boolean | number
    negativeRollingBalanceCount?: boolean | number
    rollingBalance?: boolean | number
    unpaidBills?: boolean | number
    unpaidBillsOpeningBalance?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryVendorsResponseGenqlSelection{
    vendors?: InventoryVendorGenqlSelection
    hasNext?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryVendorsSort {field: InventoryVendorsSortField,direction: SortDirection}

export interface InventoryVendorValidationResultGenqlSelection{
    totalsResult?: InventoryVendorValidationTotalsResultGenqlSelection
    vendorsResults?: InventoryVendorValidationResultItemGenqlSelection
    nonMatchingUnpaidBills?: NonMatchingUnpaidBillGenqlSelection
    emptyVendorInventoryPurchases?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryVendorValidationResultItemGenqlSelection{
    affiliatedEntity?: AffiliatedEntityGenqlSelection
    rollingBalanceTotalAmount?: boolean | number
    rollingBalanceListAmount?: boolean | number
    rollingBalanceOverviewAmount?: boolean | number
    unpaidBillsTotalAmount?: boolean | number
    unpaidBillsListAmount?: boolean | number
    unpaidBillsOverviewAmount?: boolean | number
    rollingBalancePassed?: boolean | number
    unpaidBillsPassed?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryVendorValidationTotalsResultGenqlSelection{
    rollingBalanceOverviewAmount?: boolean | number
    rollingBalanceListAmount?: boolean | number
    rollingBalanceBooksAmount?: boolean | number
    rollingBalanceDbAmount?: boolean | number
    unpaidBillsOverviewAmount?: boolean | number
    unpaidBillsIncidentalsAmount?: boolean | number
    unpaidBillsBooksAmount?: boolean | number
    unpaidBillsListAmount?: boolean | number
    unpaidBillsDbAmount?: boolean | number
    rollingBalancePassed?: boolean | number
    unpaidBillsPassed?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryYearEndHistoryLogGenqlSelection{
    userEmail?: boolean | number
    updaterType?: boolean | number
    date?: boolean | number
    status?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryYearEndMissionsInput {companyId: Scalars['ID']}

export interface InventoryYearEndMissionsResponseGenqlSelection{
    missions?: YearEndInventoryMissionGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InviteUserArgs {email: Scalars['String'],roles: Scalars['String'][],companyId: Scalars['String']}

export interface InviteUserResponseGenqlSelection{
    success?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InvoiceGenqlSelection{
    id?: boolean | number
    dueDate?: boolean | number
    dueInDays?: boolean | number
    companyAddress?: CompanyAddressGenqlSelection
    currentPdf?: InvoicePdfGenqlSelection
    pdfs?: InvoicePdfGenqlSelection
    paymentMethod?: PaymentMethodGenqlSelection
    paymentMethods?: PaymentMethodGenqlSelection
    openPaymentLinks?: InvoicePaymentLinkGenqlSelection
    paidPaymentLinks?: InvoicePaymentLinkGenqlSelection
    saleType?: boolean | number
    companyId?: boolean | number
    source?: boolean | number
    externalSourceUrl?: boolean | number
    externalSourceId?: boolean | number
    integrationAccountId?: boolean | number
    integrationAccountName?: boolean | number
    currency?: boolean | number
    displayName?: boolean | number
    statuses?: boolean | number
    postedAt?: boolean | number
    createdAt?: boolean | number
    updatedAt?: boolean | number
    deletedAt?: boolean | number
    publishedAt?: boolean | number
    lineItems?: SaleLineItemGenqlSelection
    shipping?: ShippingLineItemGenqlSelection
    discounts?: DiscountGenqlSelection
    platformDiscounts?: DiscountGenqlSelection
    taxes?: TaxGenqlSelection
    taxFixedAmount?: boolean | number
    taxType?: boolean | number
    adjustments?: SaleAdjustmentGenqlSelection
    payments?: SaleTransactionGenqlSelection
    credits?: SaleTransactionGenqlSelection
    refunds?: SaleTransactionGenqlSelection
    paymentIndications?: SaleTransactionGenqlSelection
    refundIndications?: SaleTransactionGenqlSelection
    customer?: CustomerV2GenqlSelection
    customerId?: boolean | number
    shippingAddress?: CustomerAddressGenqlSelection
    billingAddress?: CustomerAddressGenqlSelection
    integrationTags?: boolean | number
    integrationNote?: boolean | number
    finaloopNote?: boolean | number
    customerNote?: boolean | number
    isSalesAffecting?: boolean | number
    isCogsAffecting?: boolean | number
    accounting?: AccountingInfoGenqlSelection
    voidedAt?: boolean | number
    voidedBy?: boolean | number
    approvedAt?: boolean | number
    uploadId?: boolean | number
    uploadedAt?: boolean | number
    purchaseOrderNumber?: boolean | number
    summary?: SaleTotalsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InvoiceAdjustmentInput {invoiceId: Scalars['ID'],companyId: Scalars['ID'],adjustmentId: Scalars['ID'],createPaymentLink?: (Scalars['Boolean'] | null)}

export interface InvoiceCreditInput {invoiceId: Scalars['ID'],companyId: Scalars['ID'],creditId: Scalars['ID']}

export interface InvoiceEmailInput {id: Scalars['ID'],companyId: Scalars['ID'],note?: (Scalars['String'] | null),ccList?: (Scalars['String'][] | null)}

export interface InvoiceInput {id: Scalars['ID'],companyId: Scalars['ID'],balanceAsOfDate?: (Scalars['Date'] | null)}

export interface InvoicePayGenqlSelection{
    id?: boolean | number
    companyId?: boolean | number
    source?: boolean | number
    amount?: boolean | number
    currency?: boolean | number
    invoiceTotal?: boolean | number
    invoiceUnpaidBalance?: boolean | number
    invoiceDisplayName?: boolean | number
    pdfUrl?: boolean | number
    companyLogoUrl?: boolean | number
    status?: boolean | number
    customerName?: boolean | number
    invoicerName?: boolean | number
    invoiceDate?: boolean | number
    dueDate?: boolean | number
    paymentMethods?: PaymentMethodGenqlSelection
    integrationAccountId?: boolean | number
    publishableApiKey?: boolean | number
    clientSecret?: boolean | number
    previousPaymentErrorMessage?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InvoicePayInput {id: Scalars['ID']}

export interface InvoicePayLinkInput {id: Scalars['ID'],companyId: Scalars['ID'],amount?: (Scalars['Float'] | null)}

export interface InvoicePaymentGroupGenqlSelection{
    id?: boolean | number
    companyId?: boolean | number
    postedAt?: boolean | number
    createdAt?: boolean | number
    updatedAt?: boolean | number
    deletedAt?: boolean | number
    invoices?: PaymentGroupLinkedInvoiceGenqlSelection
    bankTransactions?: PaymentGroupLinkedBankTransactionGenqlSelection
    expenses?: PaymentGroupExpenseGenqlSelection
    actorType?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InvoicePaymentGroupByIdResponseGenqlSelection{
    paymentGroup?: InvoicePaymentGroupGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InvoicePaymentGroupsByIdsResponseGenqlSelection{
    paymentGroups?: InvoicePaymentGroupGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InvoicePaymentGroupsResponseGenqlSelection{
    paymentGroups?: InvoicePaymentGroupGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InvoicePaymentGroupsUnclearedBalanceResponseGenqlSelection{
    asOfDate?: boolean | number
    unclearedBalances?: InvoicePaymentGroupUnclearedBalanceGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InvoicePaymentGroupUnclearedBalanceGenqlSelection{
    paymentGroup?: InvoicePaymentGroupGenqlSelection
    unclearedBalance?: AmountsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InvoicePaymentLinkGenqlSelection{
    id?: boolean | number
    source?: boolean | number
    integrationAccountId?: boolean | number
    amount?: boolean | number
    currency?: boolean | number
    refundedAt?: boolean | number
    amountInHomeCurrency?: boolean | number
    externalSourceId?: boolean | number
    saleTransactionId?: boolean | number
    refundSaleTransactionId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InvoicePdfGenqlSelection{
    id?: boolean | number
    location?: boolean | number
    createdAt?: boolean | number
    sentAt?: boolean | number
    issuedAt?: boolean | number
    isDraft?: boolean | number
    isVoided?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InvoicePdfInput {companyId: Scalars['ID'],invoiceId: Scalars['ID'],invoicePdfId: Scalars['ID']}

export interface InvoicePdfSentInput {companyId: Scalars['ID'],invoicePdfId: Scalars['ID'],invoiceId: Scalars['ID'],sentAtStr: Scalars['String']}

export interface InvoiceRefundInput {invoiceId: Scalars['ID'],companyId: Scalars['ID'],refundId: Scalars['ID']}

export interface InvoiceRefundOrAdjustmentInput {invoiceId: Scalars['ID'],companyId: Scalars['ID'],refundId?: (Scalars['ID'] | null),adjustmentId?: (Scalars['ID'] | null)}

export interface InvoicesAggregationsGenqlSelection{
    invoicesCount?: boolean | number
    invoicesAverageValue?: boolean | number
    invoicesNetSales?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InvoicesBalanceGenqlSelection{
    balance?: boolean | number
    count?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InvoiceSettingsGenqlSelection{
    logoImageLocation?: boolean | number
    currentAutoInvoiceNumber?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InvoicesInput {companyId: Scalars['ID'],balanceAsOfDate?: (Scalars['Date'] | null)}

export interface InvoicesYearEndGenqlSelection{
    fiscalYearStartDate?: boolean | number
    fiscalYearEndDate?: boolean | number
    domainState?: boolean | number
    hubReportedDomainState?: boolean | number
    tasks?: InvoicesYearEndTaskGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InvoicesYearEndTaskGenqlSelection{
    id?: boolean | number
    stateKey?: boolean | number
    status?: boolean | number
    on_AddMissingInvoicesTask?: AddMissingInvoicesTaskGenqlSelection
    on_CloseOpenInvoicesTask?: CloseOpenInvoicesTaskGenqlSelection
    on_ConfirmArBalanceTask?: ConfirmArBalanceTaskGenqlSelection
    on_LinkInvoicePaymentsTask?: LinkInvoicePaymentsTaskGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InvoicesYearEndTasksInput {companyId: Scalars['ID']}

export interface InvoicesYearEndTasksResponseGenqlSelection{
    yearEnd?: InvoicesYearEndGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InvoiceToPaymentGroupsGenqlSelection{
    invoiceId?: boolean | number
    paymentGroups?: InvoicePaymentGroupGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InvoiceTransactionInput {invoiceId: Scalars['ID'],companyId: Scalars['ID'],refundId?: (Scalars['ID'] | null),adjustmentId?: (Scalars['ID'] | null),creditId?: (Scalars['ID'] | null)}

export interface InvoiceUnvoidInput {id: Scalars['ID'],companyId: Scalars['ID'],createPaymentLink?: (Scalars['Boolean'] | null)}

export interface IPaymentGroupGenqlSelection{
    id?: boolean | number
    companyId?: boolean | number
    postedAt?: boolean | number
    createdAt?: boolean | number
    updatedAt?: boolean | number
    deletedAt?: boolean | number
    on_InvoicePaymentGroup?: InvoicePaymentGroupGenqlSelection
    on_OrderPaymentGroup?: OrderPaymentGroupGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface IsCompanyFulfillmentSettingsAppliedInput {companyId: Scalars['ID']}

export interface IsGlobalRuleExistResultGenqlSelection{
    exists?: boolean | number
    id?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface IsInvitationCodeForRegisteredUserArgs {invitationCode: Scalars['String']}

export interface IsInvitationCodeForRegisteredUserResponseGenqlSelection{
    isRegisteredUser?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface IsPaymentGroupLinkExistInput {companyId: Scalars['String'],affiliatedEntityId?: (Scalars['String'] | null),categoryName: InventoryPurchaseCategoryName,startDate: Scalars['Date'],endDate?: (Scalars['Date'] | null),condition?: (InventoryPurchaseRuleCondition | null),amount?: (Scalars['Float'] | null)}

export interface ItemReconciliationFinaloopSalesChannelGenqlSelection{
    displayName?: boolean | number
    integrationAccountName?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface JournalEntryActionsGenqlSelection{
    firstAccount?: ActionChangeGenqlSelection
    secondAccount?: ActionChangeGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface JournalEntryActionsInput {firstAccount: ActionChangeInput,secondAccount: ActionChangeInput}

export interface LastAccountingReportSyncInput {companyId: Scalars['ID'],reportType: ReportType}

export interface LastAccountingReportSyncResponseGenqlSelection{
    status?: boolean | number
    exportedAt?: boolean | number
    fileUrl?: boolean | number
    fileName?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LastTransactionGenqlSelection{
    id?: boolean | number
    postedAt?: boolean | number
    bankAccountId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LatestActiveCompanyUserArgs {companyId: Scalars['ID']}

export interface LatestActiveCompanyUserResponseGenqlSelection{
    user?: UserGenqlSelection
    latestIpAddress?: boolean | number
    latestGtmSourceIdentifiers?: boolean | number
    latestUserAgent?: boolean | number
    latestXGtmServerPreview?: boolean | number
    latestUtms?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface lenderFromEntityInput {companyId: Scalars['ID'],entityId: Scalars['ID'],entityType: MerchantType}

export interface LinearIdentifiersInput {teamName: Scalars['String']}

export interface LineItemStatusesGenqlSelection{
    voidStatus?: boolean | number
    fulfillmentStatus?: boolean | number
    restockStatus?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LineItemTimelineAccountStateV3GenqlSelection{
    /** The quantity of the item */
    quantity?: boolean | number
    /** The amount of the item */
    amount?: boolean | number
    /** The amount of the item in home currency */
    amountInHomeCurrency?: boolean | number
    /** The seller discount amount of the item */
    sellerDiscountAmount?: boolean | number
    /** The seller discount amount of the item in home currency */
    sellerDiscountAmountInHomeCurrency?: boolean | number
    /** The platform discount amount of the item */
    platformDiscountAmount?: boolean | number
    /** The platform discount amount of the item in home currency */
    platformDiscountAmountInHomeCurrency?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LineItemTimelineActionV3GenqlSelection{
    /** The date and time the action was posted */
    postedAt?: boolean | number
    /** The type of the action */
    action?: boolean | number
    /** The amount of the action */
    amount?: boolean | number
    /** The amount of the action in home currency */
    amountInHomeCurrency?: boolean | number
    /** The amount of the seller discount */
    sellerDiscountAmount?: boolean | number
    /** The amount of the seller discount in home currency */
    sellerDiscountAmountInHomeCurrency?: boolean | number
    /** The amount of the platform discount */
    platformDiscountAmount?: boolean | number
    /** The amount of the platform discount in home currency */
    platformDiscountAmountInHomeCurrency?: boolean | number
    /** The quantity of the action */
    quantity?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LinkedBankTransactionGenqlSelection{
    bankTransaction?: BankTransactionGenqlSelection
    amount?: AmountsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LinkedOrderGenqlSelection{
    order?: OrderV2GenqlSelection
    amountInHomeCurrency?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LinkInventoryPaymentGroupInput {companyId: Scalars['ID'],postedAt: Scalars['Date'],affiliatedEntityId: Scalars['ID'],purchaseOrders: PaymentGroupPurchaseOrderToLinkInput[],warehouseTransfers: PaymentGroupWarehouseTransferToLinkInput[],inventoryPurchases: PaymentGroupInventoryPurchasesToLinkInput[],manualAssemblies: PaymentGroupManualAssemblyCostsToLinkInput[],onDemandAssemblyVendorCosts: PaymentGroupOnDemandAssemblyVendorCostsToLinkInput[]}

export interface LinkInventoryPaymentGroupResponseGenqlSelection{
    inventoryPaymentGroup?: InventoryPaymentGroupGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LinkInvoicePaymentGroupInput {companyId: Scalars['ID'],postedAt: Scalars['Date'],invoices: PaymentGroupInvoiceToLinkInput[],bankTransactions: PaymentGroupBankTransactionToLinkInput[],expenses: PaymentGroupExpenseInput[],actorType?: (ActorType | null),TEMPORARY_ACTOR_EMAIL?: (Scalars['String'] | null)}

export interface LinkInvoicePaymentGroupResponseGenqlSelection{
    paymentGroup?: InvoicePaymentGroupGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LinkInvoicePaymentsTaskGenqlSelection{
    id?: boolean | number
    status?: boolean | number
    stateKey?: boolean | number
    currentInvoicesHash?: boolean | number
    state?: LinkInvoicePaymentsTaskStateGenqlSelection
    history?: LinkInvoicePaymentsTaskStateChangeLogGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LinkInvoicePaymentsTaskStateGenqlSelection{
    confirmedInvoicesHash?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LinkInvoicePaymentsTaskStateChangeLogGenqlSelection{
    id?: boolean | number
    createdAt?: boolean | number
    updaterType?: boolean | number
    changedByUid?: boolean | number
    reason?: boolean | number
    oldValue?: LinkInvoicePaymentsTaskStateGenqlSelection
    newValue?: LinkInvoicePaymentsTaskStateGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LinkOrderGroupInput {companyId: Scalars['ID'],postedAt: Scalars['Date'],orders: OrderToLinkInput[],bankTransactions: BankTransactionToLinkInput[],expenses: OrderGroupExpenseInput[]}

export interface LinkOrderGroupResponseGenqlSelection{
    orderGroup?: OrderGroupGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LinkOrderPaymentGroupInput {companyId: Scalars['ID'],postedAt: Scalars['Date'],orders: PaymentGroupOrderToLinkInput[],bankTransactions: PaymentGroupBankTransactionToLinkInput[],expenses: PaymentGroupExpenseInput[]}

export interface LinkOrderPaymentGroupResponseGenqlSelection{
    paymentGroup?: OrderPaymentGroupGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ListAssembliesAmountRangeFilters {from?: (Scalars['Float'] | null),to?: (Scalars['Float'] | null)}

export interface ListAssembliesFilters {companyId: Scalars['ID'],affiliatedEntityId: Scalars['ID'],periods?: (ListAssembliesTimePeriod[] | null),textSearch?: (Scalars['String'] | null),warehouseIds?: (Scalars['ID'][] | null),productIds?: (Scalars['ID'][] | null),amountRange?: (ListAssembliesAmountRangeFilters | null),assemblyType?: (AssemblyType | null)}

export interface ListAssembliesInput {filters: ListAssembliesFilters,offset?: (Scalars['Float'] | null),limit?: (Scalars['Float'] | null)}

export interface ListAssembliesResultGenqlSelection{
    assemblies?: AssemblyGenqlSelection
    hasNext?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ListAssembliesTimePeriod {startDate?: (Scalars['Date'] | null),endDate?: (Scalars['Date'] | null)}

export interface ListAssemblyCostsInput {companyId: Scalars['ID'],ids?: (Scalars['ID'][] | null)}

export interface ListAssemblyItemsFilters {companyId: Scalars['ID'],affiliatedEntityId: Scalars['ID'],period: ListAssembliesTimePeriod}

export interface ListAssemblyItemsInput {filters: ListAssemblyItemsFilters,sort?: (ListAssemblyItemsSort | null)}

export interface ListAssemblyItemsResultGenqlSelection{
    assemblyItems?: AssemblyListItemGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ListAssemblyItemsSort {field: ListAssemblyItemsSortField,direction: ListAssemblyItemsSortDirection}

export interface ListCompaniesInput {withArchivedCompanies?: (Scalars['Boolean'] | null)}

export interface ListFailingValidationCompaniesResponseGenqlSelection{
    companies?: ValidationFailingCompanyGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ListManualAssembliesResultGenqlSelection{
    manualAssemblies?: ManualAssemblyGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ListNoUnitsPhysicalCountsInput {companyId: Scalars['String'],toDate: Scalars['Date'],adjustmentAmountMin?: (Scalars['Float'] | null),adjustmentAmountMax?: (Scalars['Float'] | null),productIds?: (Scalars['String'][] | null),page?: (PageInput | null),includeDrafts?: (Scalars['Boolean'] | null)}

export interface ListReadyValidationsInput {companyId: Scalars['ID'],type: CompanyValidationType,from?: (Scalars['Date'] | null),to?: (Scalars['Date'] | null)}

export interface ListUnitsTrackingPhysicalCountsInput {companyId: Scalars['String'],toDate: Scalars['Date'],warehouseId?: (Scalars['String'] | null),productIds?: (Scalars['String'][] | null),adjustmentAmountMin?: (Scalars['Float'] | null),adjustmentAmountMax?: (Scalars['Float'] | null),page?: (PageInput | null),includeDrafts?: (Scalars['Boolean'] | null)}

export interface ListValidationRemediationsInput {validationDomain: Scalars['String'],validationType: Scalars['String'],fiscalYears?: (Scalars['Int'][] | null)}

export interface LoanGenqlSelection{
    id?: boolean | number
    company?: CompanyGenqlSelection
    source?: boolean | number
    integrationAccountId?: boolean | number
    externalSourceId?: boolean | number
    integrationAccountName?: boolean | number
    latestActorType?: boolean | number
    latestActorId?: boolean | number
    type?: boolean | number
    lender?: NewLenderGenqlSelection
    currency?: boolean | number
    postedAt?: boolean | number
    direction?: boolean | number
    internalNote?: boolean | number
    isShortTerm?: boolean | number
    amount?: boolean | number
    totalAmount?: boolean | number
    amountInHomeCurrency?: boolean | number
    outstandingAmount?: boolean | number
    accruedInterest?: boolean | number
    unrecognizedFees?: boolean | number
    prepaymentLiabilityAmount?: boolean | number
    status?: boolean | number
    userActionStatus?: boolean | number
    treatmentStatus?: boolean | number
    acknowledgedInternallyAt?: boolean | number
    acknowledgedInternallyBy?: boolean | number
    paidOffAt?: boolean | number
    lastManuallyHandledAt?: boolean | number
    lastManuallyHandledBy?: boolean | number
    attachments?: LoanAttachmentGenqlSelection
    createdBy?: boolean | number
    createdById?: boolean | number
    workingPaperLink?: boolean | number
    internalOwner?: boolean | number
    updatedBy?: boolean | number
    lockedAt?: boolean | number
    lastSeenByClientAt?: boolean | number
    deletedAt?: boolean | number
    createdAt?: boolean | number
    updatedAt?: boolean | number
    restoredAt?: boolean | number
    directionSource?: boolean | number
    merchantSource?: boolean | number
    postedAtSource?: boolean | number
    amountSource?: boolean | number
    interestDays?: boolean | number
    repaymentType?: boolean | number
    repaymentFrequency?: boolean | number
    repaymentRate?: boolean | number
    interestRateType?: boolean | number
    interestRate?: boolean | number
    gracePeriod?: boolean | number
    catchUpPeriod?: boolean | number
    catchUpPercent?: boolean | number
    catchUpAmount?: boolean | number
    originationFees?: boolean | number
    prepaymentFees?: boolean | number
    feeRate?: boolean | number
    dataRequestType?: boolean | number
    recurringDataFrequency?: boolean | number
    instantRepaymentMethod?: boolean | number
    isIndexLinked?: boolean | number
    interestType?: boolean | number
    variableInterestUpdatePeriod?: boolean | number
    variableInterestSpread?: boolean | number
    variableInterestBase?: boolean | number
    compoundFrequency?: boolean | number
    indexType?: boolean | number
    termDurationValue?: boolean | number
    termDurationUnit?: boolean | number
    modifiedFields?: boolean | number
    manualEventsGroup?: LoanManualEventGenqlSelection
    billPaymentEvents?: LoanBillPaymentEventGenqlSelection
    isEarlyRepaymentDiscount?: boolean | number
    earlyRepaymentDiscounts?: EarlyRepaymentDiscountGenqlSelection
    userFollowUp2?: UserFollowUpGenqlSelection
    pendingDelete?: boolean | number
    pendingRestoreAcknowledgement?: boolean | number
    lastUserMoveToProcessingAt?: boolean | number
    isHidden?: boolean | number
    firstEventDate?: boolean | number
    firstPaymentDate?: boolean | number
    lastPaymentDate?: boolean | number
    businessName?: boolean | number
    isBillPaymentEventAttached?: boolean | number
    accountingEvents?: LoanAccountingEventGenqlSelection
    bankAccount?: BankAccountGenqlSelection
    neededReconciliationAt?: boolean | number
    lastOngoingTreatmentAt?: boolean | number
    hasRollOverEvent?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LoanAccountingEventGenqlSelection{
    id?: boolean | number
    amount?: boolean | number
    postedAt?: boolean | number
    memo?: boolean | number
    businessEventActionsConfiguration?: BusinessEventActionsConfigurationGenqlSelection
    customTags?: boolean | number
    latestActorType?: boolean | number
    latestActorId?: boolean | number
    updatedAt?: boolean | number
    createdAt?: boolean | number
    businessEventData?: LoanBusinessEventDataGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LoanAffiliatedTransactionEventGenqlSelection{
    id?: boolean | number
    bankTransaction?: BankTransactionGenqlSelection
    companyAffiliate?: CompanyAffiliateGenqlSelection
    amount?: boolean | number
    postedAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LoanAlreadyExistsResultGenqlSelection{
    loan?: LoanGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LoanAttachmentGenqlSelection{
    id?: boolean | number
    name?: boolean | number
    createdAt?: boolean | number
    type?: boolean | number
    latestActorId?: boolean | number
    isHidden?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LoanAttachmentErrorGenqlSelection{
    message?: boolean | number
    type?: boolean | number
    attachment?: boolean | number
    attachmentType?: boolean | number
    additionalInfo?: AdditionalErrorInfoGenqlSelection
    attachmentUrl?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LoanBillEventGenqlSelection{
    id?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LoanBillPaymentEventGenqlSelection{
    id?: boolean | number
    bill?: BillGenqlSelection
    paymentId?: boolean | number
    postedAt?: boolean | number
    amount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LoanBusinessEventGenqlSelection{
    id?: boolean | number
    postedAt?: boolean | number
    eventType?: boolean | number
    memo?: boolean | number
    actions?: boolean | number
    integrationAccountId?: boolean | number
    amount?: boolean | number
    isMigrationAdjustment?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LoanBusinessEventDataGenqlSelection{
    id?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LoanCommentGenqlSelection{
    id?: boolean | number
    text?: boolean | number
    createdAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LoanCommentInput {id?: (Scalars['ID'] | null),text: Scalars['String']}

export interface LoanCreationFailureResultGenqlSelection{
    reason?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LoanCreationResultGenqlSelection{
    on_LoanUpdatedResult?:LoanUpdatedResultGenqlSelection,
    on_LoanCreationFailureResult?:LoanCreationFailureResultGenqlSelection,
    on_LoanAlreadyExistsResult?:LoanAlreadyExistsResultGenqlSelection,
    on_LoanTransactionProcessedOnlineResult?:LoanTransactionProcessedOnlineResultGenqlSelection,
    __typename?: boolean | number
}

export interface LoanEventGenqlSelection{
    on_LoanManualEvent?:LoanManualEventGenqlSelection,
    on_BankTransaction?:BankTransactionGenqlSelection,
    on_LoanBillEvent?:LoanBillEventGenqlSelection,
    on_LoanBusinessEvent?:LoanBusinessEventGenqlSelection,
    on_LoanBillPaymentEvent?:LoanBillPaymentEventGenqlSelection,
    on_Payout?:PayoutGenqlSelection,
    on_Topup?:TopupGenqlSelection,
    on_LoanAffiliatedTransactionEvent?:LoanAffiliatedTransactionEventGenqlSelection,
    on_LoanAccountingEvent?:LoanAccountingEventGenqlSelection,
    on_IntegrationTransfer?: IntegrationTransferGenqlSelection,
    __typename?: boolean | number
}

export interface LoanEventDefinitionGenqlSelection{
    id?: boolean | number
    name?: boolean | number
    isSpreadable?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LoanManualEventGenqlSelection{
    id?: boolean | number
    eventDefinition?: LoanEventDefinitionGenqlSelection
    amount?: boolean | number
    postedAt?: boolean | number
    memo?: boolean | number
    recurrenceSettings?: RecurrenceSettingsGenqlSelection
    spreadData?: LoanManualEventSpreadDataGenqlSelection
    latestActorType?: boolean | number
    latestActorId?: boolean | number
    updatedAt?: boolean | number
    createdAt?: boolean | number
    effect?: LoansEventsEffectConfigurationGenqlSelection
    accountingEvents?: LoanAccountingEventGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LoanManualEventSpreadDataGenqlSelection{
    startDate?: boolean | number
    endDate?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LoanMerchantInput {id: Scalars['ID'],type: MerchantType}

export interface LoanOutstandingAmountOnDateGenqlSelection{
    loanId?: boolean | number
    outstandingAmount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LoanRelationshipGenqlSelection{
    id?: boolean | number
    isManuallyAttached?: boolean | number
    isLocked?: boolean | number
    event?: LoanEventGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LoansByIdsResponseGenqlSelection{
    loans?: LoanGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LoansEventsEffectConfigurationGenqlSelection{
    id?: boolean | number
    event?: LoanEventDefinitionGenqlSelection
    loanType?: boolean | number
    isShortTerm?: boolean | number
    direction?: boolean | number
    minGracePeriod?: boolean | number
    repaymentType?: boolean | number
    lender?: NewLenderGenqlSelection
    memoTemplate?: boolean | number
    dateTemplate?: boolean | number
    businessEventActionsConfiguration?: BusinessEventActionsConfigurationGenqlSelection
    loanOutstandingAmountAffect?: boolean | number
    loanAmountAffect?: boolean | number
    latestActorType?: boolean | number
    latestActorId?: boolean | number
    createdAt?: boolean | number
    updatedAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LoansResponseGenqlSelection{
    loans?: LoanGenqlSelection
    page?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LoansSort {field: Scalars['String'],direction: LoanSortDirection}

export interface LoanTransactionLockStatusGenqlSelection{
    transactionId?: boolean | number
    isLocked?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LoanTransactionProcessedOnlineResultGenqlSelection{
    reason?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LoanUpdateBasicData {lenderId?: (Scalars['String'] | null),userActionStatus?: (LoanUserActionStatus | null),postedAt?: (Scalars['Date'] | null),amount?: (Scalars['Float'] | null),status?: (LoanStatus | null),hideOutdatedWarning?: (Scalars['Boolean'] | null),type?: (LoanType | null),pendingDelete?: (Scalars['Boolean'] | null),userFollowUp2?: (UserFollowUpInput | null),direction?: (LoanDirection | null),dataRequestType?: (LoanDataRequestType | null),recurringDataFrequency?: (LoanRecurringDataFrequency | null),isShortTerm?: (Scalars['Boolean'] | null)}

export interface LoanUpdateData {status?: (LoanStatus | null),userActionStatus?: (LoanUserActionStatus | null),lastManuallyHandledAt?: (Scalars['Date'] | null),postedAt?: (Scalars['Date'] | null),amount?: (Scalars['Float'] | null),internalOwner?: (Scalars['String'] | null),postedAtSource?: (LoanPropertySource | null),amountSource?: (LoanPropertySource | null),isShortTerm?: (Scalars['Boolean'] | null),type?: (LoanType | null),direction?: (LoanDirection | null),directionSource?: (LoanPropertySource | null),interestRateType?: (LoanInterestRateType | null),interestRate?: (Scalars['Float'] | null),dataRequestType?: (LoanDataRequestType | null),interestType?: (LoanInterestType | null),isIndexLinked?: (Scalars['Boolean'] | null),gracePeriod?: (Scalars['Int'] | null),interestDays?: (LoanInterestDays | null),originationFees?: (Scalars['Float'] | null),prepaymentFees?: (Scalars['Float'] | null),repaymentFrequency?: (LoanRepaymentFrequency | null),repaymentType?: (LoanRepaymentType | null),lenderId?: (Scalars['String'] | null),lenderType?: (LoanLenderType | null),merchantSource?: (LoanPropertySource | null),variableInterestUpdatePeriod?: (LoanVariableInterestUpdatePeriod | null),variableInterestSpread?: (Scalars['Float'] | null),variableInterestBase?: (LoanVariableInterestBase | null),compoundFrequency?: (LoanCompoundFrequency | null),recurringDataFrequency?: (LoanRecurringDataFrequency | null),comment?: (LoanCommentInput | null),unrecognizedFees?: (Scalars['Float'] | null),repaymentRate?: (Scalars['Float'] | null),catchUpPeriod?: (Scalars['Int'] | null),catchUpPercent?: (Scalars['Float'] | null),catchUpAmount?: (Scalars['Float'] | null),instantRepaymentMethod?: (LoanInstantRepaymentMethod | null),indexType?: (LoanIndexType | null),currency?: (CurrencyCode | null),isEarlyRepaymentDiscount?: (Scalars['Boolean'] | null),earlyRepaymentDiscounts?: (EarlyRepaymentDiscountUpdate[] | null),userFollowUp2?: (UserFollowUpInput | null),internalNote?: (Scalars['String'] | null),lastUserMoveToProcessingAt?: (Scalars['Date'] | null),bankAccountId?: (Scalars['String'] | null),businessName?: (Scalars['String'] | null),termDurationValue?: (Scalars['Int'] | null),termDurationUnit?: (LoanTermDuration | null),lastOngoingTreatmentAt?: (Scalars['Date'] | null)}

export interface LoanUpdatedResultGenqlSelection{
    loans?: LoanGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LockBankAccountInput {companyId: Scalars['String'],name: Scalars['String'],startDate: Scalars['Date'],endDate: Scalars['Date']}

export interface LockCompanyBankInput {companyId: Scalars['String'],bankName: Scalars['String'],year: Scalars['Int']}

export interface LockCompanyInput {companyId: Scalars['String'],year: Scalars['Int']}

export interface LockCompanyV2Input {companyId: Scalars['String'],date: Scalars['Date']}

export interface LockedStatusGenqlSelection{
    year?: boolean | number
    lockedAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LockLoanInput {loanId: Scalars['ID'],lockDate: Scalars['Date']}

export interface LockLoanResultGenqlSelection{
    success?: boolean | number
    message?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LockStatusV2Input {from: Scalars['Date'],to: Scalars['Date']}

export interface LostAndFoundCogsGenqlSelection{
    amount?: boolean | number
    lost?: boolean | number
    found?: boolean | number
    monthlyBreakdown?: LostAndFoundMonthlyBreakdownGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LostAndFoundDailyBreakdownGenqlSelection{
    date?: boolean | number
    lost?: boolean | number
    found?: boolean | number
    reason?: AdjustmentsReasonGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LostAndFoundMonthlyBreakdownGenqlSelection{
    date?: boolean | number
    lost?: boolean | number
    found?: boolean | number
    dailyData?: LostAndFoundDailyBreakdownGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface MachineClassificationInput {companyId: Scalars['ID']}

export interface MachineClassificationJobGenqlSelection{
    finishedAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ManageCompanyYearEndStateInput {companyId: Scalars['ID'],year: Scalars['Int'],operation: ManageYearEndOperations,updatedBy?: (Scalars['String'] | null),reason?: (Scalars['String'] | null)}

export interface ManageCompanyYearEndStateResponseGenqlSelection{
    status?: boolean | number
    message?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ManagementMethodYearEndPeriodGenqlSelection{
    method?: boolean | number
    startDate?: boolean | number
    endDate?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ManagementMethodYearEndPeriodInput {method: ManagementMethod,startDate: Scalars['Date'],endDate: Scalars['Date']}

export interface ManageProductMergeRecommendationsGroupInput {companyId: Scalars['ID'],productGroupId: Scalars['String'],isDelete: Scalars['Boolean']}

export interface ManageProductMergeRecommendationsProductInput {companyId: Scalars['ID'],productGroupId: Scalars['String'],productId: Scalars['String'],isDelete?: (Scalars['Boolean'] | null)}

export interface ManualAssemblyGenqlSelection{
    id?: boolean | number
    companyId?: boolean | number
    product?: ProductGenqlSelection
    date?: boolean | number
    warehouse?: WarehouseGenqlSelection
    recipe?: RecipeGenqlSelection
    unitsToAssemble?: boolean | number
    displayName?: boolean | number
    serialNumber?: boolean | number
    deletedReason?: boolean | number
    deletedAt?: boolean | number
    unpaidAmounts?: UnpaidAmountPerAffiliatedEntityGenqlSelection
    inventoryPaymentGroupLinks?: InventoryPaymentGroupLinkGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ManualAssemblyActionGenqlSelection{
    quantity?: boolean | number
    id?: boolean | number
    date?: boolean | number
    type?: boolean | number
    manualAssembly?: ManualAssemblyGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ManualAssemblyBreakdownGenqlSelection{
    origin?: ManualAssemblyWithBreakdownGenqlSelection
    analytics?: IncomingInventoryAnalyticsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ManualAssemblyDuplicateErrorGenqlSelection{
    date?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ManualAssemblyWithBreakdownGenqlSelection{
    assembly?: ManualAssemblyGenqlSelection
    warehouse?: WarehouseGenqlSelection
    date?: boolean | number
    breakdown?: RecipeBreakdownGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ManualCompanyLoanCreationResultGenqlSelection{
    loan?: CompanyLoanGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ManualEquityEntityGenqlSelection{
    on_HolderTransaction?:HolderTransactionGenqlSelection,
    on_HolderShare?:HolderShareGenqlSelection,
    on_HolderCapitalInvestment?:HolderCapitalInvestmentGenqlSelection,
    on_HolderSafeInvestment?:HolderSafeInvestmentGenqlSelection,
    __typename?: boolean | number
}

export interface ManualEquityEventsInput {companyId: Scalars['ID'],includeDeleted?: (Scalars['Boolean'] | null)}

export interface ManualLoanCreationResultGenqlSelection{
    loan?: LoanGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ManualTransactionsAttachToLoanResultGenqlSelection{
    loan?: CompanyLoanGenqlSelection
    transactions?: BankTransactionGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ManualTransactionsAttachToLoansResultGenqlSelection{
    loans?: CompanyLoanGenqlSelection
    transactions?: BankTransactionGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ManualTxInput {companyId: Scalars['ID'],id: Scalars['ID'],amount: Scalars['Float'],currency: CurrencyCode,amountInHomeCurrency: Scalars['Float'],postedAt: Scalars['Date'],createPaymentLink?: (Scalars['Boolean'] | null)}

export interface MarkAuth0CompanyUsersAsFinishedOnboardingArgs {companyId: Scalars['ID']}

export interface MarkBankAccountReconciliationRelevantInput {id: Scalars['String'],companyId: Scalars['String'],finaloopMessage?: (Scalars['String'] | null),internalMessage?: (Scalars['String'] | null)}

export interface MarkIntegrationTransfersAsDiscrepancyInput {ids: Scalars['ID'][],companyId: Scalars['ID']}

export interface MarkOrderLineItemsAsVoidedInput {companyId: Scalars['ID'],orderVoidingStates: OrderVoidingStateInput[]}

export interface MarkOrderLineItemsAsVoidedResponseGenqlSelection{
    success?: boolean | number
    failedOrderIds?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface MarkOrdersAsCOGSInput {companyId: Scalars['ID'],orderIds: Scalars['ID'][]}

export interface MarkOrdersAsCOGSResponseGenqlSelection{
    orders?: OrderV2GenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface MarkOrdersAsGiveawayInput {companyId: Scalars['ID'],orderIds: Scalars['ID'][]}

export interface MarkOrdersAsGiveawayResponseGenqlSelection{
    orders?: OrderV2GenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface MarkOrdersAsHistoricallyPaidInput {companyId: Scalars['ID'],historicalPayments: HistoricalPayment[]}

export interface MarkOrdersAsHistoricallyPaidResponseGenqlSelection{
    orders?: OrderV2GenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface MarkOrdersAsOvercollectedInput {companyId: Scalars['ID'],orderIds: Scalars['ID'][]}

export interface MarkOrdersAsOvercollectedResponseGenqlSelection{
    orders?: OrderV2GenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface MarkOrdersAsUncollectibleInput {companyId: Scalars['ID'],orderIds: Scalars['ID'][],postedAt?: (Scalars['Date'] | null)}

export interface MarkOrdersAsUncollectibleResponseGenqlSelection{
    orders?: OrderV2GenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface MarkOrdersInput {companyId: Scalars['ID'],orderMarks: MarkSingleOrderInput[]}

export interface MarkOrderWithoutFinancialEventsInput {companyId: Scalars['ID'],orderId: Scalars['String'],integrationAccountId: Scalars['String']}

export interface MarkReconciliationRequestFileAsNotRelevantInput {companyId: Scalars['ID'],fileId: Scalars['ID'],requestId: Scalars['ID']}

export interface MarkSingleOrderInput {orderId: Scalars['ID'],markType: MarkOrderType}

export interface MerchantGenqlSelection{
    on_Vendor?:VendorGenqlSelection,
    on_CustomerV2?:CustomerV2GenqlSelection,
    on_CompanyAffiliate?:CompanyAffiliateGenqlSelection,
    on_Institution?:InstitutionGenqlSelection,
    __typename?: boolean | number
}

export interface MerchantBankTransactionRecommendationsInput {companyId: Scalars['ID'],affiliatedEntityId: Scalars['ID'],moneyDirection: SimpleMoneyDirection}

export interface MerchantBankTransactionStatsMerchantKeyInput {id: Scalars['ID'],type: MerchantType}

export interface MerchantCategorizationInput {merchant?: (MerchantInput | null),shouldApplyAlways: Scalars['Boolean']}

export interface MerchantInput {id: Scalars['ID'],type: MerchantType}

export interface MerchantKey {id: Scalars['ID'],type: MerchantType}

export interface MerchantsBankTransactionStatsGenqlSelection{
    merchantsCount?: boolean | number
    transactionsCount?: boolean | number
    transactionsSum?: boolean | number
    uncategorizedTransactionsCount?: boolean | number
    uncategorizedTransactionsSum?: boolean | number
    transactionBusinessEvents?: boolean | number
    uncategorizedTransactionBusinessEvents?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface MerchantsBankTransactionStatsInput {companyId: Scalars['ID'],merchants: MerchantBankTransactionStatsMerchantKeyInput[],moneyDirection: SimpleMoneyDirection,excludeBusinessEventClassifications?: (Scalars['String'][] | null)}

export interface MerchantsByIdsInput {companyId: Scalars['ID'],merchantIds: Scalars['ID'][]}

export interface MerchantsByKeysInput {keys: MerchantKey[]}

export interface MeResponseGenqlSelection{
    user?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface MergedProductGenqlSelection{
    id?: boolean | number
    companyId?: boolean | number
    finaloopId?: boolean | number
    displayName?: boolean | number
    imageUrl?: boolean | number
    sku?: boolean | number
    price?: boolean | number
    lineOfBusinessId?: boolean | number
    string?: boolean | number
    listedChannels?: SalesChannelGenqlSelection
    appliedCosts?: ProductAppliedCostGenqlSelection
    dailySalesData?: (SalesChannelDailySalesDataGenqlSelection & { __args: {timeRange: ProductDataTimeRangeInput} })
    totalSold?: boolean | number
    avgCostPerUnit?: boolean | number
    representativeFinaloopProductId?: boolean | number
    mergedWithProducts?: ProductGenqlSelection
    canEditLatestAppliedCost?: boolean | number
    isFractional?: boolean | number
    isHidden?: boolean | number
    salesData?: (SalesDataGenqlSelection & { __args: {timeRange: ProductDataTimeRangeInput} })
    rawRecipes?: (RecipeGenqlSelection & { __args: {timeRange: ProductDataTimeRangeInput} })
    componentOfProducts?: ProductGenqlSelection
    analyticsOverview?: (ProductAnalyticsOverviewGenqlSelection & { __args?: {input?: (AnalyticsOverviewInput | null)} })
    warehousesAnalyticsOverview?: (ProductWarehousesAnalyticsOverviewGenqlSelection & { __args?: {input?: (AnalyticsOverviewInput | null)} })
    tags?: boolean | number
    isDataSyncing?: boolean | number
    mergeHistory?: ProductMergeHistoryItemGenqlSelection
    isDropshipping?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface MergeProductMergeRecommendationsMatchGroupInput {companyId: Scalars['ID'],matchGroupId: Scalars['String'],from?: (Scalars['Date'] | null)}

export interface MergeProductsInput {companyId: Scalars['String'],representativeFinaloopProductId: Scalars['String'],mergedFinaloopProductIds: Scalars['String'][]}

export interface MergeProductsV3 {representativeId: Scalars['String'],productIds: Scalars['String'][],from?: (Scalars['Date'] | null)}

export interface MergeProductsV3Input {companyId: Scalars['String'],mergeInput?: (MergeProductsV3 | null),splitInput?: (SplitProductsV3 | null)}

export interface MergeProductsV3ResponseGenqlSelection{
    on_MergeProductsV3Result?:MergeProductsV3ResultGenqlSelection,
    on_MergeProductsValidationError?:MergeProductsValidationErrorGenqlSelection,
    __typename?: boolean | number
}

export interface MergeProductsV3ResultGenqlSelection{
    splitResult?: ProductGenqlSelection
    mergeResult?: ProductGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface MergeProductsValidationErrorGenqlSelection{
    message?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface MergeTax1099AffiliatedEntitiesInput {companyId: Scalars['ID'],affiliatedEntityIds: Scalars['ID'][],type: Tax1099AffiliatedEntityType,calendarYear: Scalars['Int']}

export interface MergeWarehousesErrorGenqlSelection{
    error?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface MergeWarehousesInput {companyId: Scalars['ID'],representativeId: Scalars['String'],warehouseIds: Scalars['String'][]}

export interface MergeWarehousesResultGenqlSelection{
    on_MergeWarehousesSuccess?:MergeWarehousesSuccessGenqlSelection,
    on_MergeWarehousesError?:MergeWarehousesErrorGenqlSelection,
    __typename?: boolean | number
}

export interface MergeWarehousesSuccessGenqlSelection{
    isMerged?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface MissingCostsInPeriodInput {companyId: Scalars['ID'],from: Scalars['Date'],to: Scalars['Date']}

export interface MissingCostsInPeriodResponseGenqlSelection{
    hasMissingCosts?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface MissionSpecificInfoInput {purchaseBasedOpeningBalance?: (PurchaseBasedOpeningBalanceInput | null),purchaseBasedClosingBalanceInput?: (PurchaseBasedClosingBalanceInput | null),purchaseBasedPurchases?: (PurchaseBasedPurchasesInput | null),salesBasedOpeningBalance?: (SalesBasedOpeningBalanceInput | null),salesBasedMissingCostPerUnit?: (SalesBasedMissingCostPerUnitInput | null),salesBasedClosingBalance?: (SalesBasedClosingBalanceInput | null),salesBasedPurchases?: (SalesBasedPurchasesInput | null),unitBasedVendorsNegativeBalance?: (UnitBasedVendorsNegativeBalanceInput | null),unitBasedNegativeOnHands?: (UnitBasedNegativeOnHandsInput | null),unitBasedClosingBalance?: (UnitBasedClosingBalanceInput | null)}

export interface MissionStateInput {missionType: InventoryYearEndMissionsType,status: InventoryYearEndMissionStatus,missionSpecificData: MissionSpecificInfoInput,managementMethodPeriod: ManagementMethodYearEndPeriodInput}

export interface MoveBankAccountUploadsToAnotherBankAccountInput {companyId: Scalars['ID'],sourceBankAccountId: Scalars['ID'],targetBankAccountId: Scalars['ID']}

export interface MoveBankStatementFilesToAnotherBankAccount {companyId: Scalars['ID'],sourceBankAccountId: Scalars['ID'],targetBankAccountId: Scalars['ID']}

export interface MovementGenqlSelection{
    stockSituation?: InventoryBatchGenqlSelection
    direction?: boolean | number
    batches?: InventoryBatchGenqlSelection
    unavailableQuantity?: boolean | number
    action?: WarehouseActionGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface MovementIndirectCostGenqlSelection{
    type?: boolean | number
    amount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface MutationGenqlSelection{
    /** @deprecated Use upsertAccrual instead */
    createOrUpdateAccrual?: (CreateOrUpdateAccrualResultGenqlSelection & { __args: {input: CreateOrUpdateAccrualInput} })
    /** @deprecated Use deleteAccrualV2 instead */
    deleteAccrual?: (AccrualGenqlSelection & { __args: {input: DeleteAccrualInput} })
    upsertAccrual?: (AccrualV2GenqlSelection & { __args: {input: UpsertAccrualInput} })
    deleteAccrualV2?: (AccrualV2GenqlSelection & { __args: {input: DeleteAccrualV2Input} })
    /** @deprecated Use cancelAccrualV2 instead */
    cancelAccrual?: (AccrualGenqlSelection & { __args: {input: CancelAccrualInput} })
    cancelAccrualV2?: (AccrualV2GenqlSelection & { __args: {input: CancelAccrualV2Input} })
    sendAnalyticsEvent?: (SendAnalyticsEventResultGenqlSelection & { __args: {input: SendAnalyticsEventInput} })
    dispatchEshedTest?: (SendAnalyticsEventResultGenqlSelection & { __args: {input: DispatchEshedTestInput} })
    updateBalanceSheetSetup?: (UpdateBalanceSheetSetupResponseGenqlSelection & { __args: {args: UpdateBalanceSheetSetupInput} })
    updateBalanceSheetSetupItem?: (UpdateBalanceSheetSetupItemResponseGenqlSelection & { __args: {args: UpdateBalanceSheetSetupItemInput} })
    resetBalanceSheetSetup?: (ResetBalanceSheetSetupResponseGenqlSelection & { __args: {input: ResetBalanceSheetSetupInput} })
    openBalanceSheetSetup?: (OpenBalanceSheetSetupResponseGenqlSelection & { __args: {input: OpenBalanceSheetSetupInput} })
    updateBankAccountClosingBalance?: (BankAccountGenqlSelection & { __args: {input: UpdateBankAccountClosingBalanceInput} })
    createBankAccountBalanceAdjustment?: (BankAccountGenqlSelection & { __args: {input: UpdateBankAccountBalanceAdjustmentInput} })
    deleteBankAccountBalanceAdjustment?: (BankAccountGenqlSelection & { __args: {input: UpdateBankAccountBalanceAdjustmentInput} })
    setBankAccountsLatestEventIds?: (BankAccountGenqlSelection & { __args: {input: SetBankAccountsLatestEventIdsInput} })
    createBankAccount?: (BankAccountGenqlSelection & { __args: {input: CreateBankAccountInput} })
    copyBankAccount?: (BankAccountGenqlSelection & { __args: {input: CopyBankAccountInput} })
    updateBankAccount?: (BankAccountGenqlSelection & { __args: {input: UpdateBankAccountInput} })
    /** @deprecated This mutation is deprecated, use replaceBankAccountLocksByType instead. */
    replaceBankAccountLocks?: (BankAccountGenqlSelection & { __args: {input: ReplaceBankAccountLocksInput} })
    replaceBankAccountLocksByType?: (BankAccountGenqlSelection & { __args: {input: ReplaceBankAccountLocksByTypeInput} })
    updateBankAccountsMergeStatus?: (SuspectedBankAccountDuplicationGenqlSelection & { __args: {input: UpdateBankAccountsMergeStatusInput} })
    lockBankAccount?: (BankAccountGenqlSelection & { __args: {input: LockBankAccountInput} })
    createInstitution?: (InstitutionGenqlSelection & { __args: {input: CreateInstitutionInput} })
    updateInstitution?: (InstitutionGenqlSelection & { __args: {input: UpdateInstitutionInput} })
    updateInstitutionDataConfig?: (InstitutionGenqlSelection & { __args: {input: UpdateInstitutionDataConfigInput} })
    createInstitutionMapping?: (InstitutionMappingGenqlSelection & { __args: {input: CreateInstitutionMappingsInput} })
    updateInstitutionMapping?: (InstitutionMappingGenqlSelection & { __args: {input: UpdateInstitutionMappingInput} })
    uploadBankStatement?: (UploadBankStatementResponseGenqlSelection & { __args: {input: UploadBankStatementInput} })
    updateBankReconciliationRequestMessage?: (BankReconciliationRequestGenqlSelection & { __args: {input: UpdateBankReconciliationRequestMessageInput} })
    updateBankReconciliationRequestStatus?: (BankReconciliationRequestGenqlSelection & { __args: {input: UpdateBankReconciliationRequestStatusInput} })
    upsertBankStatementParsingRequest?: (BankStatementParsingRequestGenqlSelection & { __args: {input: BankStatementParsingRequestInput} })
    upsertBankStatementParsingResults?: (BankStatementParsingResultGenqlSelection & { __args: {input: BankStatementParsingResultsInput} })
    updateBankStatementParsingResultStatus?: (BankStatementParsingResultGenqlSelection & { __args: {input: UpdateBankStatementParsingResultStatus} })
    writeBankingMetric?: { __args: {input: BankingMetricInput[]} }
    deleteBankReconciliationRequestConfiguration?: (GenericResponseGenqlSelection & { __args: {input: DeleteBankReconciliationRequestConfigInput} })
    createAdminBankReconciliationRequest?: { __args: {input: CreateAdminBankReconciliationRequestInput} }
    convertBankAccountToManual?: (BankAccountGenqlSelection & { __args: {input: ConvertBankAccountToManualInput} })
    convertBankAccountBackFromManual?: (GenericResponseGenqlSelection & { __args: {input: ConvertBankAccountBackFromManualInput} })
    markReconciliationRequestFileAsNotRelevant?: (GenericResponseGenqlSelection & { __args: {input: MarkReconciliationRequestFileAsNotRelevantInput} })
    uploadFileToBankReconciliationRequest?: (GenericResponseGenqlSelection & { __args: {input: UploadFileToBankReconciliationRequestInput} })
    moveBankStatementFilesToAnotherBankAccount?: (BankStatementFileGenqlSelection & { __args: {input: MoveBankStatementFilesToAnotherBankAccount} })
    updateBankStatementFileProcessingLogs?: (BankStatementFileGenqlSelection & { __args: {input: UpdateBankStatementFileProcessingLogsInput} })
    stopImportingDataForBankAccount?: (BankAccountGenqlSelection & { __args: {input: StopImportingDataForBankAccountInput} })
    stopImportingDataForBankAccountNew?: (BankAccountGenqlSelection & { __args: {input: StopImportingDataForBankAccountNewInput} })
    createBankAccountStatementForStopImport?: (BankAccountStatementRequestGenqlSelection & { __args: {input: CreateBankAccountStatementForStopImportInput} })
    createManualBankAccount?: (BankAccountGenqlSelection & { __args: {input: CreateManualBankAccountInput} })
    deleteBankAccounts?: { __args: {input: DeleteBankAccountsInput} }
    submitBankReconciliationRequestResolution?: (BankStatementRequestResolutionResponseGenqlSelection & { __args: {input: BankStatementRequestResolutionInput} })
    markBankReconciliationRequestAsRelevant?: (BankReconciliationRequestGenqlSelection & { __args: {input: MarkBankAccountReconciliationRelevantInput} })
    triggerBankReconciliationRequests?: (BankReconciliationRequestGenqlSelection & { __args: {input: BankAccountReconciliationsInput} })
    updateBankReconciliationStatementAutoProcessingResults?: { __args: {input: BankReconciliationStatementAutoProcessingResultsInput} }
    uploadReportedTransactions?: (GenericResponseGenqlSelection & { __args: {input: UploadReportedTransactionsInput} })
    createBankStatementFileUpload?: (BankStatementFileGenqlSelection & { __args: {input: CreateBankStatementFileInput} })
    categorizeBankTransactions?: (BankTransactionCategorizationResultGenqlSelection & { __args: {input: CategorizeBankTransactionsInput} })
    createCustomerCategorizationRule?: (CreateCustomerCategorizationRuleResultGenqlSelection & { __args: {input: CreateCustomerCategorizationRuleInput} })
    updateBankTransactionMemo?: (BankTransactionGenqlSelection & { __args: {input: UpdateBankTransactionMemoInput} })
    addBankTransactionAttachment?: (BankTransactionGenqlSelection & { __args: {input: AddBankTransactionAttachmentInput} })
    deleteBankTransactionAttachment?: (BankTransactionGenqlSelection & { __args: {input: DeleteBankTransactionAttachmentInput} })
    finalizeAskTheUserFlow?: (FinalizeAskTheUserFlowResultGenqlSelection & { __args: {input: FinalizeAskTheUserFlowInput} })
    askTheUserNotificationService?: (AskTheUserNotificationServiceResultGenqlSelection & { __args: {input: AskTheUserNotificationInput} })
    scheduleAtuTransactionsResultProcessing?: (ScheduleAtuTransactionsResultProcessingResultGenqlSelection & { __args: {input: ScheduleAtuTransactionsResultProcessingInput} })
    createGlobalVendorMappingRule?: (GlobalVendorMappingRuleGenqlSelection & { __args: {input: CreateGlobalVendorRuleInput} })
    createBankTransactionsUpload?: (BankTransactionsUploadGenqlSelection & { __args: {input: CreateBankTransactionsUploadInput} })
    toggleBankTransactionAccrual?: (ToggleBankTransactionAccrualResultGenqlSelection & { __args: {input: ToggleBankTransactionAccrualInput} })
    upsertBankTransactionLocalRule?: (CreateTeamCategorizationRuleResultGenqlSelection & { __args: {input: UpsertBankTransactionLocalRuleInput} })
    createGlobalRule?: (CreateGlobalRuleResultGenqlSelection & { __args: {input: GlobalRuleInput} })
    attemptToClassifyTransactions?: (ClassificationResultGenqlSelection & { __args: {input: AttemptToClassifyTransactionsInput} })
    attemptToClassifyTransactionsWithPairedEntities?: (ClassificationResultGenqlSelection & { __args: {input: AttemptToClassifyTransactionsInput} })
    deleteBankTransactionsByBankAccountIds?: { __args: {input: DeleteBankTransactionsByBankAccountIdsInput} }
    deleteBankTransactionsInternal?: (AlterBankTransactionsLifecycleStateResultGenqlSelection & { __args: {input: AlterBankTransactionsLifecycleStateInput} })
    restoreBankTransactionsInternal?: (AlterBankTransactionsLifecycleStateResultGenqlSelection & { __args: {input: AlterBankTransactionsLifecycleStateInput} })
    moveBankAccountUploadsToAnotherBankAccount?: (BankTransactionsUploadGenqlSelection & { __args: {input: MoveBankAccountUploadsToAnotherBankAccountInput} })
    appendProcessingLogToBankTransactionsUpload?: (BankTransactionsUploadGenqlSelection & { __args: {input: AppendProcessingLogToBankTransactionsUploadInput} })
    submitTransactionsFileToBankTransactionsUpload?: (SubmitTransactionsFileToBankTransactionsUploadResponseGenqlSelection & { __args: {input: SubmitTransactionsFileToBankTransactionsUploadInput} })
    clearExpiredDoItLaterResults?: AffectedTransactionsIdsGenqlSelection
    addClassificationTag?: (ClassificationTagGenqlSelection & { __args: {input: AddClassificationTagInput} })
    editClassificationTag?: (ClassificationTagGenqlSelection & { __args: {input: EditClassificationTagInput} })
    updateAssociatedBankTransactionsFile?: (UpdateAssociatedBankTransactionsFileResponseGenqlSelection & { __args: {input: UpdateAssociatedBankTransactionsFileInput} })
    processCheckoutWebhookEvents?: { __args: {args: ProcessCheckoutWebhookEventsInput} }
    syncStripeOffers?: { __args: {args: SyncStripeOffersInput} }
    syncStripeTier1Offer?: { __args: {args: SyncStripeTier1Offer} }
    createCheckoutSession?: (CreateCheckoutSessionResponseGenqlSelection & { __args: {args: CreateCheckoutSessionInput} })
    pollCheckoutSessionStatus?: (CompanyGenqlSelection & { __args: {args: PollCheckoutSessionStatusInput} })
    toggleBillHasAccrual?: { __args: {input: ToggleBillHasAccrualInput} }
    createOrGetBusinessEventDefinition?: (BusinessEventActionsConfigurationGenqlSelection & { __args: {input: CreateOrGetBusinessEventDefinitionInput} })
    createAccountRole?: (AccountRoleGenqlSelection & { __args: {input: CreateAccountRoleInput} })
    updateBooksStartTime?: (SuccessResultGenqlSelection & { __args: {args: UpdateBooksStartTimeArgs} })
    createFileUploadUrl?: (FileUploadUrlResultGenqlSelection & { __args: {input: CreateFileUploadUrlInput} })
    updateCompanyAccountingMethod?: (CompanyGenqlSelection & { __args: {args: UpdateCompanyAccountingMethodArgs} })
    updateEstimatedProjectedRevenue?: (CompanyGenqlSelection & { __args: {args: UpdateEstimatedProjectedRevenueInput} })
    toggleOrdersZeroNetBalance?: (SuccessResultGenqlSelection & { __args: {args: ToggleOrdersZeroNetBalanceInput} })
    toggleRecognizeZeroNetOrdersAsGiveaways?: { __args: {args: ToggleRecognizeZeroNetOrdersAsGiveawaysInput} }
    createImageUploadUrl?: (ImageUploadUrlResultGenqlSelection & { __args: {input: CreateImageUploadUrlInput} })
    setSettings?: (SuccessResultGenqlSelection & { __args: {args: SetSettingsArgs} })
    upsertCompanyAddress?: (CompanyAddressGenqlSelection & { __args?: {input?: (UpsertCompanyAddressInput | null)} })
    deleteCompanyAddress?: { __args: {input: CompanyAddressInput} }
    updateOnboardingStatus?: (OnboardingStatusGenqlSelection & { __args: {input: UpdateOnboardingStatusInput} })
    setFiscalYearData?: { __args: {input: SetFiscalYearDataInput} }
    updateCompanyNamesAndNotifyHandler?: (CompanyGenqlSelection & { __args: {input: UpdateCompanyNamesAndNotifyHandlerInput} })
    updateCompany?: (CompanyGenqlSelection & { __args: {input: UpdateCompanyInput} })
    setFiscalYearStart?: { __args: {input: SetFiscalYearStartInput} }
    createCompany?: (CompanyGenqlSelection & { __args: {args: CreateCompanyInput} })
    updateCompanyPayingStatus?: (CompanyGenqlSelection & { __args: {args: UpdateCompanyPayingStatusInput} })
    syncCompany?: { __args: {args: SyncCompanyInput} }
    lockCompany?: (CompanyLockStatusGenqlSelection & { __args: {args: LockCompanyInput} })
    unlockCompany?: (CompanyLockStatusGenqlSelection & { __args: {args: LockCompanyInput} })
    lockCompanyV2?: (CompanyGenqlSelection & { __args: {args: LockCompanyV2Input} })
    unlockCompanyV2?: (CompanyGenqlSelection & { __args: {args: UnlockCompanyV2Input} })
    removeDataRestriction?: (CompanyGenqlSelection & { __args: {args: RemoveDataRestrictionInput} })
    validationCycle?: (ValidationCycleGenqlSelection & { __args: {input: GetValidationCycleInput} })
    completeValidationCycle?: { __args: {input: CompleteValidationCycleInput} }
    sendValidationNotification?: { __args: {input: SendValidationNotificationInput} }
    storeValidation?: { __args: {input: StoreValidationInput} }
    grantEntitiesLockedPeriodBypasses?: { __args: {args: GrantEntitiesLockedPeriodBypassesInput} }
    createCompanyAffiliate?: (CompanyAffiliateGenqlSelection & { __args: {input: CreateCompanyAffiliateInput} })
    updateCompanyAffiliate?: (CompanyAffiliateGenqlSelection & { __args: {input: UpdateCompanyAffiliateInput} })
    deleteCompanyAffiliate?: (CompanyAffiliateGenqlSelection & { __args: {input: DeleteCompanyAffiliateInput} })
    upsertHolderShare?: (HolderShareGenqlSelection & { __args: {input: UpsertHolderShareInput} })
    deleteHolderShare?: (HolderShareGenqlSelection & { __args: {input: DeleteHolderShareInput} })
    upsertHolderCapitalInvestment?: (HolderCapitalInvestmentGenqlSelection & { __args: {input: UpsertHolderCapitalInvestmentInput} })
    deleteHolderCapitalInvestment?: (HolderCapitalInvestmentGenqlSelection & { __args: {input: DeleteHolderCapitalInvestmentInput} })
    addRoleToAffiliatedEntity?: (AddRoleToAffiliatedEntityResultGenqlSelection & { __args: {input: AddRoleToAffiliatedEntityInput} })
    upsertManualEquityEvent?: (ManualEquityEntityGenqlSelection & { __args: {input: UpsertManualEquityEventInput} })
    deleteManualEquityEvents?: (ManualEquityEntityGenqlSelection & { __args: {input: DeleteManualEquityEventsInput} })
    companyIntegrationBulkUpdate?: (CompanyIntegrationGenqlSelection & { __args: {input: CompanyIntegrationBulkUpdateInput} })
    syncDataPlatformIntegration?: (SyncDataPlatformIntegrationResponseGenqlSelection & { __args: {input: SyncDataPlatformIntegrationInput} })
    deleteBankConnection?: { __args: {input: DeleteBankConnectionInput} }
    disconnectPayrollConnection?: { __args: {input: DisconnectConnectionInput} }
    disconnectConnection?: { __args: {input: DisconnectConnectionInput} }
    confirmRoleForPaymentGateway?: { __args: {input: ConfirmRoleForPaymentGatewayInput} }
    unclassifyIntegrationTransfers?: (IntegrationTransferGenqlSelection & { __args: {input: UnclassifyIntegrationTransferInput} })
    markIntegrationTransfersAsDiscrepancy?: (IntegrationTransferGenqlSelection & { __args: {input: MarkIntegrationTransfersAsDiscrepancyInput} })
    classifyIntegrationTransfer?: (IntegrationTransferGenqlSelection & { __args: {input: ClassifyIntegrationTransferInput} })
    createIntegrationTransferRule?: (IntegrationTransferRuleGenqlSelection & { __args: {input: CreateIntegrationTransferRuleInput} })
    scheduleAtuIntegrationTransfersResultProcessing?: (ScheduleAtuIntegrationTransfersResultProcessingResultGenqlSelection & { __args: {input: ScheduleAtuIntegrationTransfersResultProcessingInput} })
    refreshSkuAmbiguity?: { __args: {input: RefreshSkuAmbiguityInput} }
    triggerCOGSFromScratch?: { __args: {input: TriggerCOGSFromScratchInput} }
    deleteFifoGroups?: { __args: {input: DeleteFifoGroupsInput} }
    bulkRecoveryUnitsTracking?: (BulkRecoveryUnitsTrackingResultGenqlSelection & { __args?: {input?: (BulkRecoveryUnitsTrackingInput | null)} })
    syncInventoryIntegrationFulfillmentSetting?: { __args: {input: SyncInventoryIntegrationFulfillmentSettingInput} }
    triggerBigValidationReconciliation?: { __args: {input: TriggerReconciliationInput} }
    triggerInventoryPurchasesReconciliation?: { __args: {input: TriggerReconciliationInput} }
    triggerFifoReconciliation?: { __args: {input: TriggerFifoReconciliationInput} }
    updateOnDemandAssemblyCosts?: { __args: {input: UpdateOnDemandAssemblyCostsInput} }
    updateOnDemandAssemblyVendorCosts?: { __args: {input: UpdateOnDemandAssemblyCostsInput} }
    validateInventoryPaymentGroupOnEntityChange?: { __args: {input: ValidateInventoryPaymentGroupOnEntityChangeInput} }
    setWarehouseDropshippingSettings?: (WarehouseGenqlSelection & { __args: {input: SetWarehouseDropshippingSettingsInput} })
    reconcileInventoryPurchasesFromTransactions?: { __args: {input: ReconcileInventoryPurchasesFromTransactionsInput} }
    reconcileInventoryPurchasesFromBills?: { __args: {input: ReconcileInventoryPurchasesFromBillsInput} }
    reconcileInventoryPurchasesFromBusinessEvents?: { __args: {input: ReconcileInventoryPurchasesFromBusinessEventsInput} }
    reconcileAllPayrollInventoryPurchases?: { __args: {input: ReconcileAllInventoryPurchasesInput} }
    reconcileAllContractorPaymentInventoryPurchases?: { __args: {input: ReconcileAllInventoryPurchasesInput} }
    reconcileAllBillInventoryPurchases?: { __args: {input: ReconcileAllInventoryPurchasesInput} }
    reconcileAllTransactionInventoryPurchases?: { __args: {input: ReconcileAllInventoryPurchasesInput} }
    reReconcileInventoryPurchases?: { __args: {input: ReReconcileInventoryPurchasesInput} }
    shopifyItemsValidationBlacklistSku?: { __args: {input: ShopifyItemsValidationBlacklistSkuInput} }
    shopifyItemsValidationBlacklistSalesChannel?: { __args: {input: ShopifyItemsValidationBlacklistSalesChannelInput} }
    markOrderWithoutFinancialEvents?: { __args: {input: MarkOrderWithoutFinancialEventsInput} }
    markOrdersWithoutFinancialEvents?: { __args: {input: AmazonValidationInput} }
    generateFifoValidation?: (GenerateFifoValidationResponseGenqlSelection & { __args: {input: FifoValidationInput} })
    generateNoUnitsValidation?: (GenerateNoUnitsValidationResponseGenqlSelection & { __args: {input: GenerateNoUnitsValidationInput} })
    ackInvalidNoUnitsValidation?: { __args: {input: AckInvalidNoUnitsValidationInput} }
    deleteNoUnitsValidationInvalidAck?: { __args: {input: DeleteNoUnitsValidationInvalidAckInput} }
    generateBigValidation?: (GenerateBigValidationResponseGenqlSelection & { __args: {input: GenerateBigValidationInput} })
    runNoUnitsChangesDetector?: boolean | number
    amazonValidationAdjustSkuQuantities?: { __args: {input: AmazonValidationAdjustSkuQuantitiesInput} }
    createInventoryVendorValidation?: (CreateInventoryVendorValidationResponseGenqlSelection & { __args: {input: CreateInventoryVendorValidationInput} })
    remediateValidation?: { __args: {input: RemediateValidationInput} }
    deleteValidationRemediations?: { __args: {input: RemediateValidationInput} }
    findValidationBuggyDate?: { __args: {input: FindValidationBuggyDateInput} }
    createShopifyProductsFromDiagnostics?: { __args: {input: CreateShopifyProductsFromDiagnosticsInput} }
    createBigValidationAdjustment?: { __args: {input: CreateBigValidationAdjustmentInput} }
    generatePhysicalCountValidation?: (PhysicalCountValidationResponseGenqlSelection & { __args: {input: PhysicalCountValidationInput} })
    changeProductsHiddenStatus?: { __args: {input: ChangeProductsHiddenStatusInput} }
    createProductManually?: (CreateProductManuallyResponseGenqlSelection & { __args: {input: CreateProductManuallyInput} })
    deleteManualAssembly?: { __args: {input: DeleteManualAssemblyInput} }
    deleteRecipe?: { __args: {input: DeleteRecipeInput} }
    mergeProductsV3?: (MergeProductsV3ResponseGenqlSelection & { __args: {input: MergeProductsV3Input} })
    setProductAdjustments?: (ProductGenqlSelection & { __args: {input: SetProductAdjustmentsInput} })
    setWarehouseOpeningBalance?: (WarehouseOpeningBalanceGenqlSelection & { __args: {input: SetWarehouseOpeningBalanceInput} })
    updateManualAssembly?: (UpdateManualAssemblyResultGenqlSelection & { __args: {input: UpdateManualAssemblyInput} })
    updateProduct?: (ProductGenqlSelection & { __args: {input: UpdateProductInput} })
    updateProductFractional?: (ProductGenqlSelection & { __args: {input: UpdateProductFractionalInput} })
    updateRecipe?: (UpdateRecipeResultGenqlSelection & { __args: {input: UpdateRecipeInput} })
    generatePdf?: (GeneratePdfResponseGenqlSelection & { __args: {input: GeneratePdfInput} })
    generatePdfV2?: (GeneratePdfResponseV2GenqlSelection & { __args: {input: GeneratePdfInput} })
    sendPoEmail?: (SendPoEmailResultGenqlSelection & { __args: {input: SendPoEmailInput} })
    setInventoryUsages?: { __args: {input: SetInventoryUsagesInput} }
    detectAndNotifyCogsDrasticChanges?: { __args: {input: DetectAndNotifyCogsDrasticChangesInput} }
    saveDropshippingSettings?: (DropshippingSettingsGenqlSelection & { __args: {input: SaveDropshippingSettingsInput} })
    removeDropshippingSettings?: { __args: {input: RemoveDropshippingSettingsInput} }
    deletePurchaseOrder?: { __args: {input: DeletePurchaseOrderInput} }
    updatePurchaseOrder?: (PurchaseOrderGenqlSelection & { __args: {input: PurchaseOrderInput} })
    updateInventoryPurchase?: (UpdateInventoryPurchaseResponseGenqlSelection & { __args: {input: InventoryPurchaseInput} })
    deleteInventoryPurchase?: (InventoryPurchaseUpdateOutOfDateErrorGenqlSelection & { __args: {input: DeleteInventoryPurchaseInput} })
    schedulePurchasesValidation?: (SchedulePurchasesValidationResponseGenqlSelection & { __args: {input: SchedulePurchasesValidationInput} })
    applyInventoryPurchaseRules?: (InventoryPurchaseRulesResponseGenqlSelection & { __args: {input: ApplyInventoryPurchaseRulesInput} })
    setPendingWarehouseOpeningBalance?: (PendingWarehouseOpeningBalancesResponseGenqlSelection & { __args: {input: SetPendingWarehouseOpeningBalancesInput} })
    deleteWarehouseOpeningBalance?: { __args: {input: DeleteWarehouseOpeningBalancesInput} }
    discardPendingWarehouseOpeningBalance?: { __args: {input: DiscardPendingWarehouseOpeningBalancesInput} }
    applyPendingWarehouseOpeningBalance?: { __args: {input: ApplyPendingWarehouseOpeningBalanceInput} }
    setPendingWarehouseOpeningBalanceWithCsv?: (PendingWarehouseOpeningBalancesWithCsvResponseGenqlSelection & { __args: {input: SetPendingWarehouseOpeningBalancesWithCsvInput} })
    deletePendingWarehouseOpeningBalanceAttachment?: { __args: {input: DeletePendingWarehouseOpeningAttachmentInput} }
    updateWarehouseTransfer?: (WarehouseTransferGenqlSelection & { __args: {input: UpdateWarehouseTransferInput} })
    deleteWarehouseTransfer?: { __args: {input: DeleteWarehouseTransferInput} }
    setPendingSalesDataAdjustmentsV2?: (SetPendingSalesDataAdjustmentsResponseV2GenqlSelection & { __args: {input: SetPendingSalesDataAdjustmentsInput} })
    setPendingDeadInventoryAdjustments?: (SetPendingDedInventoryAdjustmentsResponseGenqlSelection & { __args: {input: SetPendingDeadInventoryAdjustmentsInput} })
    setPendingGiveawayAdjustments?: (SetPendingGiveawayAdjustmentsResponseGenqlSelection & { __args: {input: SetPendingGiveawayAdjustmentsInput} })
    setPendingGiveawayDropshippingAdjustments?: (SetPendingGiveawayDropshippingAdjustmentsResponseGenqlSelection & { __args: {input: SetPendingGiveawayAdjustmentsInput} })
    setPendingDonationAdjustments?: (SetPendingDonationAdjustmentsResponseGenqlSelection & { __args: {input: SetPendingDonationAdjustmentsInput} })
    setPendingSalesDataAdjustmentsWithCsv?: (ProductBulkEditCsvUploadResponseGenqlSelection & { __args: {input: SetPendingSalesDataAdjustmentsWithCsvInput} })
    setPendingDeadInventoryAdjustmentsWithCsv?: (ProductBulkEditCsvUploadResponseGenqlSelection & { __args: {input: SetPendingAdjustmentsWithCsvInput} })
    setPendingGiveawayAdjustmentsWithCsv?: (ProductBulkEditCsvUploadResponseGenqlSelection & { __args: {input: SetPendingAdjustmentsWithCsvInput} })
    setPendingGiveawayDropshippingAdjustmentsWithCsv?: (ProductBulkEditCsvUploadResponseGenqlSelection & { __args: {input: SetPendingAdjustmentsWithCsvInput} })
    setPendingDonationAdjustmentsWithCsv?: (ProductBulkEditCsvUploadResponseGenqlSelection & { __args: {input: SetPendingAdjustmentsWithCsvInput} })
    discardPendingAdjustments?: { __args: {input: DiscardPendingAdjustments} }
    applyPendingSalesDataAdjustments?: (GetProductBulkAdjustmentStatusGenqlSelection & { __args: {input: ApplyPendingSalesDataAdjustmentsInput} })
    updateNoUnitsPhysicalCount?: (IdResultGenqlSelection & { __args: {input: UpdateNoUnitsPhysicalCountInput} })
    deleteNoUnitsPhysicalCount?: { __args: {input: DeleteNoUnitsPhysicalCountInput} }
    updateNoUnitsPhysicalCountProductQuantityPendingAdjustments?: { __args: {input: UpdateNoUnitsPhysicalCountProductQuantityPendingAdjustmentsInput} }
    applyNoUnitsPhysicalCountProductQuantitiesPendingAdjustments?: { __args: {input: ApplyNoUnitsPhysicalCountProductQuantitiesPendingAdjustmentsInput} }
    discardNoUnitsPhysicalCountProductQuantityPendingAdjustments?: { __args: {input: DiscardNoUnitsPhysicalCountProductQuantityPendingAdjustmentInput} }
    setNoUnitsPhysicalCountPendingAdjustmentsWithCsv?: (ProductBulkEditCsvUploadResponseGenqlSelection & { __args: {input: SetPhysicalCountPendingAdjustmentsWithCsvInput} })
    updateUnitsTrackingPhysicalCount?: (UnitsTrackingPhysicalCountGenqlSelection & { __args: {input: UpdateUnitsTrackingPhysicalCountInput} })
    deleteUnitsTrackingPhysicalCount?: { __args: {input: DeleteUnitsTrackingPhysicalCountInput} }
    updateUnitsTrackingPhysicalCountProductQuantityPendingAdjustments?: { __args: {input: UpdateUnitsTrackingPhysicalCountProductQuantityPendingAdjustmentsInput} }
    acknowledgeUnitsTrackingPhysicalCountProductQuantitiesAmounts?: { __args: {input: AcknowledgeUnitsTrackingPhysicalCountProductQuantitiesAmountsInput} }
    discardUnitsTrackingPhysicalCountProductQuantityPendingAdjustments?: { __args: {input: DiscardUnitsTrackingPhysicalCountProductQuantityPendingAdjustmentInput} }
    setUnitsTrackingPhysicalCountPendingAdjustmentsWithCsv?: (ProductBulkEditCsvUploadResponseGenqlSelection & { __args: {input: SetPhysicalCountPendingAdjustmentsWithCsvInput} })
    createWarehouse?: (WarehouseCreateResultGenqlSelection & { __args: {input: CreateWarehouseInput} })
    deleteWarehouse?: { __args: {input: DeleteWarehouseInput} }
    updateWarehouse?: (WarehouseGenqlSelection & { __args: {input: UpdateWarehouseInput} })
    updateWarehousesDefaults?: (WarehousesDefaultsResultGenqlSelection & { __args: {input: UpdateWarehousesDefaultsInput} })
    updateWarehousesDefaultsV2?: (WarehousesDefaultsResponseGenqlSelection & { __args: {input: UpdateWarehousesDefaultsInput} })
    mergeWarehouses?: (MergeWarehousesResultGenqlSelection & { __args: {input: MergeWarehousesInput} })
    splitWarehouses?: { __args: {input: SplitWarehouseInput} }
    setUserGivenWarehouseName?: (WarehouseGenqlSelection & { __args: {input: SetUserGivenWarehouseNameInput} })
    linkInventoryPaymentGroup?: (LinkInventoryPaymentGroupResponseGenqlSelection & { __args: {input: LinkInventoryPaymentGroupInput} })
    updateInventoryPaymentGroup?: (UpdateInventoryPaymentGroupResponseGenqlSelection & { __args: {input: UpdateInventoryPaymentGroupInput} })
    deleteInventoryPaymentGroup?: (DeleteInventoryPaymentGroupResponseGenqlSelection & { __args: {input: DeleteInventoryPaymentGroupInput} })
    cancelInvalidInventoryPaymentGroups?: (CancelInvalidInventoryPaymentGroupsResponseGenqlSelection & { __args: {input: CancelInvalidInventoryPaymentGroupsInput} })
    updateInventoryYearEndMission?: (InventoryYearEndMissionsResponseGenqlSelection & { __args: {input: UpdateInventoryYearEndMissionInput} })
    updateWarehouseNegativesAdjustment?: { __args: {input: UpdateWarehouseNegativesAdjustmentInput} }
    manageProductMergeRecommendationsGroup?: { __args: {input: ManageProductMergeRecommendationsGroupInput} }
    manageProductMergeRecommendationsProduct?: { __args: {input: ManageProductMergeRecommendationsProductInput} }
    setProductMergeRecommendationsPrimaryProduct?: { __args: {input: SetProductMergeRecommendationsPrimaryProductInput} }
    mergeProductMergeRecommendationsMatchGroup?: { __args: {input: MergeProductMergeRecommendationsMatchGroupInput} }
    updateProductAutomergeSettings?: { __args: {input: UpdateAutomergeSettingsInput} }
    revertVanillaChipMerges?: boolean | number
    lockLoan?: (LockLoanResultGenqlSelection & { __args: {input: LockLoanInput} })
    unlockLoan?: (UnlockLoanResultGenqlSelection & { __args: {id: Scalars['ID']} })
    updateLoan?: (ManualLoanCreationResultGenqlSelection & { __args: {input: UpdateInternalLoanInput} })
    updateLoanAttachments?: (ManualLoanCreationResultGenqlSelection & { __args: {input: UpdateLoanAttachmentsInput} })
    createLoan?: (ManualLoanCreationResultGenqlSelection & { __args: {input: CreateLoanInput} })
    createLoanFromTransaction?: (LoanCreationResultGenqlSelection & { __args: {input: TransactionUpdatedInput} })
    createLoanFromBalanceTransaction?: (LoanCreationResultGenqlSelection & { __args: {input: CreateLoanFromBalanceTransactionInput} })
    createLoanFromBillFinanced?: { __args: {input: CreateLoanFromBillFinancedInput} }
    acknowledgeLoansChanges?: (AcknowledgeLoansChangesGenqlSelection & { __args: {input: AcknowledgeLoansChangesInput} })
    simulateLoanFromTransaction2?: (SimulatedLoanSummaryGenqlSelection & { __args: {input: SimulateTransactionUpdatedInput2} })
    deleteLoans?: (DeleteLoansResultsGenqlSelection & { __args: {input: DeleteLoansInput} })
    dangerousForceDeleteLoans?: (DeleteLoansResultsGenqlSelection & { __args: {input: DeleteLoansInput} })
    dangerousTouchLoan?: { __args: {input: DangerousTouchLoanInput} }
    deleteLoanRelationships?: { __args: {input: DeleteLoanRelationshipsInput} }
    deleteManualLoanEvent?: (UpdateManualLoanEventResultGenqlSelection & { __args: {input: DeleteManualLoanEventInput} })
    deleteManualLoanEvents?: (UpdateManualLoanEventsResultGenqlSelection & { __args: {input: DeleteManualLoanEventsInput} })
    createManualLoanEvent2?: (UpdateManualLoanEventResultGenqlSelection & { __args: {input: CreateManualLoanEventInput2} })
    updateManualLoanEvent2?: (UpdateManualLoanEventResultGenqlSelection & { __args: {input: UpdateManualLoanEventInput2} })
    deleteLoanManualAccountingEvents?: (UpdateManualLoanEventsResultGenqlSelection & { __args: {input: DeleteLoanManualAccountingEventsInput} })
    updateLoanManualAccountingEvent?: (UpdateManualLoanEventResultGenqlSelection & { __args: {input: UpdateLoanManualAccountingEventInput} })
    deleteLoansEventsEffectConfiguration?: (DeleteLoansEventsEffectConfigurationResultGenqlSelection & { __args: {input: DeleteLoansEventsEffectConfigurationInput} })
    createLoansEventsEffectConfiguration?: (LoansEventsEffectConfigurationGenqlSelection & { __args: {input: CreateLoansEventsEffectConfigurationInput} })
    createLoanEventDefinition?: (LoanEventDefinitionGenqlSelection & { __args: {input: CreateLoanEventDefinitionInput} })
    attachRelationsToLoan?: { __args: {input: AttachRelationsToLoanInput} }
    deleteCompanyLoanAttachment?: (ManualCompanyLoanCreationResultGenqlSelection & { __args: {input: DeleteLoanAttachmentInput} })
    updateCompanyLoanAttachments?: (CompanyLoanAttachmentUpdateResultGenqlSelection & { __args: {input: UpdateLoanAttachmentsInput} })
    createCompanyLoan?: (ManualCompanyLoanCreationResultGenqlSelection & { __args: {input: CreateCompanyLoanInput} })
    updateCompanyLoan?: (ManualCompanyLoanCreationResultGenqlSelection & { __args: {input: UpdateLoanInput} })
    updateCompanyLoans?: (UpdateCompanyLoansResponseGenqlSelection & { __args: {input: UpdateCompanyLoansInput} })
    deleteLoan?: (DeleteLoansResultsGenqlSelection & { __args: {input: DeleteLoanInput} })
    userAttachTransactionsToExistingLoan?: (ManualTransactionsAttachToLoanResultGenqlSelection & { __args: {input: UserAttachTransactionsToExistingLoanInput} })
    userAttachTransactionsToNewLoan?: (ManualTransactionsAttachToLoanResultGenqlSelection & { __args: {input: UserAttachTransactionsToNewLoanInput} })
    userAttachTransactionsToLoans?: (ManualTransactionsAttachToLoansResultGenqlSelection & { __args: {input: UserAttachTransactionsToLoansInput} })
    lenderFromEntity?: (NewLenderGenqlSelection & { __args: {input: lenderFromEntityInput} })
    updateCompanyFundedStatus?: (CompanyFundedStatusGenqlSelection & { __args: {input: UpdateCompanyFundedStatusInput} })
    updateOrderEntities?: (SuccessResponseGenqlSelection & { __args: {input: UpdateOrderEntitiesInput} })
    deleteOrderGroupUponTransactionChange?: (DeleteOrderGroupUponTransactionChangeResponseGenqlSelection & { __args: {input: DeleteOrderGroupUponTransactionChangeInput} })
    initiateTotalArCashDiffsReport?: (SuccessResponseGenqlSelection & { __args: {input: InitiateTotalArCashDiffsReportInput} })
    updateCompanyArCashDiffsInBucket?: (SuccessResponseGenqlSelection & { __args: {input: CompanyArCashDiffsInput} })
    /**
     * Override any existing fulfillment date for the given orders, to match their respective line item's earliest post date.
     * Line items that require no change are not updated. Orders that have no line items changed are not updated.
     */
    overrideOrderFulfillmentsToLineItemPostDate?: (OverrideOrderFulfillmentsResponseGenqlSelection & { __args: {input: OverrideOrderFulfillmentsToLineItemPostDateInput} })
    setOrderFinaloopNote?: (OrderV2ResultGenqlSelection & { __args: {input: SetOrderFinaloopNoteInput} })
    setOrderFinaloopTags?: (OrderV2ResultGenqlSelection & { __args: {input: SetOrderFinaloopTagsInput} })
    setFulfillmentSettings?: (SetFulfillmentSettingsResponseGenqlSelection & { __args: {input: SetFulfillmentSettingsInput} })
    markOrders?: { __args: {input?: (MarkOrdersInput | null)} } | boolean | number
    linkOrderGroup?: (LinkOrderGroupResponseGenqlSelection & { __args: {input: LinkOrderGroupInput} })
    updateOrderGroup?: (UpdateOrderGroupResponseGenqlSelection & { __args: {input: UpdateOrderGroupInput} })
    deleteOrderGroup?: (DeleteOrderGroupResponseGenqlSelection & { __args: {input: DeleteOrderGroupInput} })
    voidOrders?: (VoidOrdersResponseGenqlSelection & { __args: {input: VoidOrdersInput} })
    unvoidOrders?: (UnvoidOrdersResponseGenqlSelection & { __args: {input: UnvoidOrdersInput} })
    markOrdersAsUncollectible?: (MarkOrdersAsUncollectibleResponseGenqlSelection & { __args: {input: MarkOrdersAsUncollectibleInput} })
    markOrdersAsOvercollected?: (MarkOrdersAsOvercollectedResponseGenqlSelection & { __args: {input: MarkOrdersAsOvercollectedInput} })
    markOrdersAsHistoricallyPaid?: (MarkOrdersAsHistoricallyPaidResponseGenqlSelection & { __args: {input: MarkOrdersAsHistoricallyPaidInput} })
    unMarkOrdersAsUncollectible?: (UnMarkOrdersAsUncollectibleResponseGenqlSelection & { __args: {input: UnMarkOrdersAsUncollectibleInput} })
    unMarkOrdersAsOvercollected?: (UnMarkOrdersAsOvercollectedResponseGenqlSelection & { __args: {input: UnMarkOrdersAsOvercollectedInput} })
    markOrdersAsGiveaway?: (MarkOrdersAsGiveawayResponseGenqlSelection & { __args: {input: MarkOrdersAsGiveawayInput} })
    unMarkOrdersAsGiveaway?: (UnMarkOrdersAsGiveawayResponseGenqlSelection & { __args: {input: UnMarkOrdersAsGiveawayInput} })
    markOrdersAsCOGS?: (MarkOrdersAsCOGSResponseGenqlSelection & { __args: {input: MarkOrdersAsCOGSInput} })
    unMarkOrdersAsCOGS?: (UnMarkOrdersAsCOGSResponseGenqlSelection & { __args: {input: UnMarkOrdersAsCOGSInput} })
    markOrderLineItemsAsVoided?: (MarkOrderLineItemsAsVoidedResponseGenqlSelection & { __args: {input: MarkOrderLineItemsAsVoidedInput} })
    /**
     * Override order fulfillments for the given orders.
     * Note that the provided fulfillment override for each order will completely replace the existing fulfillments of that order.
     * Ensure it includes any existing fulfillments for the order if they should be preserved.
     * If more than one order is specified, each order may succeed or fail independently and its result is reflected in the response.
     */
    overrideOrderFulfillments?: (OverrideOrderFulfillmentsResponseGenqlSelection & { __args: {input: OverrideOrderFulfillmentsInput} })
    deletePaymentGroupUponTransactionChange?: (DeletePaymentGroupUponTransactionChangeResponseGenqlSelection & { __args: {input: DeletePaymentGroupUponTransactionChangeInput} })
    linkOrderPaymentGroup?: (LinkOrderPaymentGroupResponseGenqlSelection & { __args: {input: LinkOrderPaymentGroupInput} })
    updateOrderPaymentGroup?: (UpdateOrderPaymentGroupResponseGenqlSelection & { __args: {input: UpdateOrderPaymentGroupInput} })
    deleteOrderPaymentGroup?: (DeletePaymentGroupResponseGenqlSelection & { __args: {input: DeletePaymentGroupInput} })
    linkInvoicePaymentGroup?: (LinkInvoicePaymentGroupResponseGenqlSelection & { __args: {input: LinkInvoicePaymentGroupInput} })
    updateInvoicePaymentGroup?: (UpdateInvoicePaymentGroupResponseGenqlSelection & { __args: {input: UpdateInvoicePaymentGroupInput} })
    deleteInvoicePaymentGroup?: (DeletePaymentGroupResponseGenqlSelection & { __args: {input: DeletePaymentGroupInput} })
    updateEmployeesOfficerStatus?: { __args: {input: UpdateEmployeesOfficerStatusInput} }
    updatePayrollSettings?: { __args: {input: UpdatePayrollSettingsInput} }
    createPeriodicPartnerReport?: (PeriodicPartnerReportGenqlSelection & { __args: {input: PeriodicPartnerReportInput} })
    scheduleAccountingReportExport?: (ScheduleAccountingReportExportResponseGenqlSelection & { __args: {args: ScheduleAccountingReportExportInput} })
    exportGeneralLedger?: (ExportGeneralLedgerResponseGenqlSelection & { __args: {input: ExportGeneralLedgerInput} })
    upsertIntegrationCustomer?: (CustomerV2GenqlSelection & { __args: {input: UpsertIntegrationCustomerArgs} })
    upsertIntegrationInvoice?: (InvoiceGenqlSelection & { __args: {input: UpsertIntegrationInvoiceInput} })
    sendSalesToReconcilerByTypeAndDate?: { __args: {input: SalesByTypeAndDateInput} }
    forceDeleteInvoices?: (DeleteInvoicesResponseGenqlSelection & { __args: {input: SalesInternalInput} })
    refreshInvoiceCalculatedFields?: (InvoiceGenqlSelection & { __args: {input: SaleInternalInput} })
    refreshManyInvoicesCalculatedFields?: (InvoiceGenqlSelection & { __args: {input: SalesInternalInput} })
    createCustomer?: (CustomerGenqlSelection & { __args: {createCustomerArgs: CreateCustomerArgs} })
    updateCustomer?: (CustomerGenqlSelection & { __args: {updateCustomerArgs: UpdateCustomerArgs} })
    upsertCustomerAddress?: (CustomerAddressGenqlSelection & { __args: {input: UpsertCustomerAddressArgs} })
    upsertCustomerV2?: (CustomerV2GenqlSelection & { __args: {input: UpsertCustomerV2Args} })
    upsertInvoice?: (InvoiceGenqlSelection & { __args: {input: UpsertInvoiceInput} })
    voidInvoice?: (InvoiceGenqlSelection & { __args: {input: InvoiceInput} })
    unvoidInvoice?: (InvoiceGenqlSelection & { __args: {input: InvoiceUnvoidInput} })
    deleteInvoiceAdjustment?: (InvoiceGenqlSelection & { __args: {input: InvoiceAdjustmentInput} })
    markAsUncollectible?: (InvoiceGenqlSelection & { __args: {input: ManualTxInput} })
    addRefundToInvoice?: (InvoiceGenqlSelection & { __args: {input: ManualTxInput} })
    deleteInvoiceRefund?: (InvoiceGenqlSelection & { __args: {input: InvoiceRefundInput} })
    addCreditToInvoice?: (InvoiceGenqlSelection & { __args: {input: ManualTxInput} })
    deleteInvoiceCredit?: (InvoiceGenqlSelection & { __args: {input: InvoiceCreditInput} })
    upsertPaymentMethod?: (PaymentMethodGenqlSelection & { __args?: {input?: (UpsertPaymentMethodInput | null)} })
    deletePaymentMethod?: { __args: {input: PaymentMethodInput} }
    generateInvoicePDF?: { __args: {input: InvoiceInput} }
    markInvoicePdfAsSent?: { __args: {input: InvoicePdfSentInput} }
    sendInvoiceEmail?: (InvoiceGenqlSelection & { __args: {input: InvoiceEmailInput} })
    issueInvoice?: (InvoiceGenqlSelection & { __args: {input: InvoiceInput} })
    deleteInvoice?: { __args: {input: InvoiceInput} }
    updateSalesChannel?: (SalesChannelInfoGenqlSelection & { __args: {input: UpdateSalesChannelInput} })
    applySalesChannelChanges?: (ApplySalesChannelChangesResultGenqlSelection & { __args: {input: ApplySalesChannelChangesInput} })
    upsertInvoiceSettings?: (InvoiceSettingsGenqlSelection & { __args: {input: UpsertInvoiceSettingsInput} })
    startPaymentLinkCheckout?: (InvoicePayGenqlSelection & { __args?: {input?: (InvoicePayInput | null)} })
    markPaymentLinkAsProcessing?: { __args: {input?: (InvoicePayInput | null)} } | boolean | number
    createPaymentLinkForInvoice?: { __args: {input?: (InvoicePayLinkInput | null)} } | boolean | number
    deletePaymentLinkForInvoice?: { __args: {input?: (CompanyInvoicePayInput | null)} } | boolean | number
    refundPaymentLinkPayment?: { __args: {input?: (CompanyInvoicePayInput | null)} } | boolean | number
    createPaymentFromPaymentLink?: { __args: {input?: (CompanyInvoicePayInput | null)} } | boolean | number
    createRefundFromPaymentLink?: { __args: {input?: (CompanyInvoicePayInput | null)} } | boolean | number
    uploadInvoicesFromCSV?: (UploadedInvoiceGenqlSelection & { __args: {input: UploadInvoicesFromCSVInput} })
    dispatchInvoicesCSVBulkUploadTask?: (AwaitedExportResponseGenqlSelection & { __args: {input: UploadInvoicesFromCSVInput} })
    updateUserRolesForCompany?: (UpdateUserRolesForCompanyResponseGenqlSelection & { __args: {args: UpdateUserRolesForCompanyArgs} })
    inviteUser?: (InviteUserResponseGenqlSelection & { __args: {args: InviteUserArgs} })
    referUser?: (referUserResponseGenqlSelection & { __args: {args: ReferUserArgs} })
    removeUser?: (RemoveUserResponseGenqlSelection & { __args: {args: RemoveUserArgs} })
    acceptInvitation?: (AcceptInvitationResponseGenqlSelection & { __args: {args: AcceptInvitationArgs} })
    handleUserLogin?: (HandleUserLoginResponseGenqlSelection & { __args: {args: HandleUserLoginArgs} })
    updateUserDetails?: (UpdateUserDetailsResponseGenqlSelection & { __args: {args: UpdateUserDetailsArgs} })
    setGoogleToken?: (GoogleTokenCodeResponseGenqlSelection & { __args: {args: GoogleTokenCodeArgs} })
    disconnectGoogleAccount?: GoogleTokenCodeResponseGenqlSelection
    switchCompany?: (SwitchCompanyResponseGenqlSelection & { __args: {args: SwitchCompanyArgs} })
    updateSharedGoogleDriveFolder?: (SuccessResultGenqlSelection & { __args: {args: UpdateSharedGoogleDriveFolder} })
    assignCompanyToUser?: (AssignCompanyToUserResponseGenqlSelection & { __args: {args: AssignCompanyToUser} })
    impersonate?: (ImpersonateResponseGenqlSelection & { __args: {args: ImpersonateArgs} })
    setUserName?: (SetUserNameResponseGenqlSelection & { __args: {args: SetUserName} })
    updateAuth0UserDetails?: { __args: {args: UpdateAuth0UserDetailsArgs} }
    addCompanyToParkerUser?: { __args: {args: AddCompanyToParkerUserArgs} }
    markAuth0CompanyUsersAsFinishedOnboarding?: { __args: {args: MarkAuth0CompanyUsersAsFinishedOnboardingArgs} }
    publishValidationStatusUpdate?: { __args: {input: PublishValidationStatusUpdateInput} }
    createVendor?: (VendorGenqlSelection & { __args: {createVendorArgs: CreateVendorArgs} })
    recordTax1099AffiliatedEntityGroupInput?: { __args: {input: RecordTax1099AffiliatedEntityGroupInput} }
    mergeTax1099AffiliatedEntities?: { __args: {input: MergeTax1099AffiliatedEntitiesInput} }
    splitTax1099AffiliatedEntityGroups?: { __args: {input: SplitTax1099AffiliatedEntityGroupsInput} }
    createGlobalVendor?: (VendorGenqlSelection & { __args: {input: CreateGlobalVendorInput} })
    updateCompanyVendorExternalSourceId?: (VendorGenqlSelection & { __args: {args: UpdateCompanyVendorExternalSourceIdVendorInput} })
    upsertCompanyVendor?: (VendorGenqlSelection & { __args: {args: UpdateVendorInput} })
    updateGlobalVendorLogo?: (VendorGenqlSelection & { __args: {input: UpdateGlobalVendorLogoInput} })
    upsertGlobalVendor?: (VendorGenqlSelection & { __args: {args: UpsertGlobalVendorInput} })
    unsignWorksheetRow?: (CompanyWorksheetRowGenqlSelection & { __args: {args: UnsignWorksheetRowInput} })
    signWorksheetRow?: (CompanyWorksheetRowGenqlSelection & { __args: {args: SignWorksheetRowInput} })
    storeDateForLocking?: (CompanyWorksheetRowGenqlSelection & { __args: {args: StoreDateForLockingInput} })
    updateComments?: (CompanyWorksheetRowGenqlSelection & { __args: {args: UpdateCommentsInput} })
    signAndLockBankAccount?: (CompanyWorksheetRowGenqlSelection & { __args: {args: SignAndLockBankAccountInput} })
    updateCompaniesDomainState?: (UpdateCompanyDomainStateResponseGenqlSelection & { __args: {args: UpdateCompaniesDomainStateInput} })
    manageCompanyYearEndState?: (ManageCompanyYearEndStateResponseGenqlSelection & { __args: {args: ManageCompanyYearEndStateInput} })
    updateYearEndState?: (YearEndStateUpdateResponseGenqlSelection & { __args: {args: YearEndStateUpdateInput} })
    updateYearEndDomainState?: (YearEndDomainStateUpdateResponseGenqlSelection & { __args: {args: YearEndDomainStateUpdateInput} })
    updateYearEndDomainStateData?: (YearEndDomainStateDataUpdateResponseGenqlSelection & { __args: {args: YearEndDomainStateDataUpdateInput} })
    deleteYearEndDomainStateData?: (YearEndDomainStateDataDeleteResponseGenqlSelection & { __args: {args: YearEndDomainStateDataDeleteInput} })
    /** @deprecated Use updateYearEndAdditionalFields instead */
    updateYearEndUserUnresponsive?: (YearEndUpdateUserUnresponsiveResponseGenqlSelection & { __args: {args: YearEndUpdateUserUnresponsiveInput} })
    updateYearEndAdditionalFields?: (YearEndUpdateAdditionalFieldsResponseGenqlSelection & { __args: {args: YearEndUpdateAdditionalFieldsInput} })
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface NewCompanyIntegrationInput {integrationType: UploadableIntegrationType,accountName: Scalars['String'],businessCreationType: BusinessCreationType,businessPurchaseDate?: (Scalars['String'] | null)}

export interface NewLenderGenqlSelection{
    id?: boolean | number
    company?: CompanyGenqlSelection
    affiliatedEntity?: AffiliatedEntityGenqlSelection
    name?: boolean | number
    supportedLoanTypes?: boolean | number
    defaultLoanType?: boolean | number
    isShortTerm?: boolean | number
    supportedFollowUpTypes?: boolean | number
    logoUrl?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface NewSourceInput {sourceName: Scalars['String'],accountName: Scalars['String'],businessCreationType: BusinessCreationType,businessPurchaseDate?: (Scalars['String'] | null)}

export interface NonMatchedSkuGenqlSelection{
    sku?: boolean | number
    integrationAccountName?: boolean | number
    quantity?: boolean | number
    zeroPriceQuantity?: boolean | number
    restocks?: boolean | number
    giveaway?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface NonMatchingProductsResponseGenqlSelection{
    ambiguousSkuCount?: boolean | number
    notFoundProductSkuCount?: boolean | number
    notFoundProductSkus?: NotFoundProductSkusGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface NonMatchingUnpaidBillGenqlSelection{
    billId?: boolean | number
    booksAmount?: boolean | number
    inventoryPurchaseAmount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface NotFoundProductSkusGenqlSelection{
    shopName?: boolean | number
    integrationAccountId?: boolean | number
    source?: boolean | number
    skus?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface NothingTypesGenqlSelection{
    id?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface NoUnitsBusinessEventsValidationResultGenqlSelection{
    isValid?: boolean | number
    isYoung?: boolean | number
    costDiff?: boolean | number
    ackedCostDiff?: boolean | number
    integrationValidations?: NoUnitsIntegrationValidationGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface NoUnitsDailyProductValidationResultGenqlSelection{
    productValidations?: NoUnitsProductValidationGenqlSelection
    diff?: QuantityAndCostGenqlSelection
    isValid?: boolean | number
    ackedDiff?: QuantityAndCostGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface NoUnitsIntegrationValidationGenqlSelection{
    isValid?: boolean | number
    integrationType?: boolean | number
    integrationAccountName?: boolean | number
    totalCogsAmount?: boolean | number
    totalBusinessEventsAmount?: boolean | number
    dailyCogsType?: boolean | number
    businessEventType?: boolean | number
    isYoung?: boolean | number
    businessEventId?: boolean | number
    dailyCogsId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface NoUnitsPhysicalCountGenqlSelection{
    id?: boolean | number
    amount?: boolean | number
    date?: boolean | number
    companyId?: boolean | number
    attachments?: NoUnitsPhysicalCountAttachmentGenqlSelection
    diff?: boolean | number
    lastAckDiff?: boolean | number
    closingBalance?: boolean | number
    lastAckClosingBalance?: boolean | number
    note?: boolean | number
    isDraft?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface NoUnitsPhysicalCountAttachmentGenqlSelection{
    name?: boolean | number
    url?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface NoUnitsPhysicalCountClosingBalanceResultGenqlSelection{
    closingBalance?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface NoUnitsPhysicalCountOverviewGenqlSelection{
    amount?: boolean | number
    amountWithoutPendingAdjustments?: boolean | number
    missingData?: boolean | number
    count?: boolean | number
    pendingChanges?: boolean | number
    productQuantities?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface NoUnitsPhysicalCountProductQuantitiesGenqlSelection{
    products?: NoUnitsPhysicalCountProductQuantityGenqlSelection
    offset?: boolean | number
    count?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface NoUnitsPhysicalCountProductQuantityGenqlSelection{
    product?: ProductGenqlSelection
    quantity?: boolean | number
    appliedCost?: boolean | number
    isPendingChange?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface NoUnitsPhysicalCountProductQuantityPendingAdjustmentGenqlSelection{
    quantity?: boolean | number
    companyId?: boolean | number
    physicalCountId?: boolean | number
    productId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface NoUnitsPhysicalCountsListGenqlSelection{
    physicalCounts?: NoUnitsPhysicalCountGenqlSelection
    offset?: boolean | number
    count?: boolean | number
    totalCount?: boolean | number
    minAmount?: boolean | number
    maxAmount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface NoUnitsProductValidationGenqlSelection{
    product?: ProductGenqlSelection
    sales?: FulfillmentsValidationGenqlSelection
    restocks?: FulfillmentsValidationGenqlSelection
    deadInventory?: AdjustmentsValidationGenqlSelection
    donations?: AdjustmentsValidationGenqlSelection
    giveaways?: AdjustmentsValidationGenqlSelection
    isValid?: boolean | number
    diff?: QuantityAndCostGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface NoUnitsValidationErrorGenqlSelection{
    message?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface NoUnitsValidationResponseGenqlSelection{
    on_NoUnitsValidationResult?:NoUnitsValidationResultGenqlSelection,
    on_NoUnitsValidationError?:NoUnitsValidationErrorGenqlSelection,
    __typename?: boolean | number
}

export interface NoUnitsValidationResultGenqlSelection{
    isValid?: boolean | number
    dailyProductValidationResult?: NoUnitsDailyProductValidationResultGenqlSelection
    businessEventsValidationResult?: NoUnitsBusinessEventsValidationResultGenqlSelection
    startDate?: boolean | number
    endDate?: boolean | number
    error?: boolean | number
    diff?: QuantityAndCostGenqlSelection
    fulfillmentsAfterLock?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OfferGenqlSelection{
    tier?: boolean | number
    payment?: BillingPaymentGenqlSelection
    features?: boolean | number
    title?: boolean | number
    description?: boolean | number
    couponDiscount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OnBoardingStateGenqlSelection{
    signupCompleted?: boolean | number
    currentPage?: boolean | number
    funnelVersion?: boolean | number
    isLastPageCompleted?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OnboardingStateInput {signupCompleted: Scalars['Boolean'],currentPage?: (Scalars['String'] | null),funnelVersion?: (Scalars['String'] | null),isLastPageCompleted?: (Scalars['Boolean'] | null)}

export interface OnboardingStatusGenqlSelection{
    companyId?: boolean | number
    scope?: boolean | number
    step?: boolean | number
    status?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OnboardingStatusesGenqlSelection{
    hasReportedCOGSEvents?: boolean | number
    hasClassifiedPurchases?: boolean | number
    hasConfirmedOpeningBalance?: boolean | number
    dropshippingSettings?: DropshippingSettingsGenqlSelection
    inventoryInitStatus?: InventoryInitStatusGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OnDemandAssemblyActionGenqlSelection{
    quantity?: boolean | number
    id?: boolean | number
    date?: boolean | number
    type?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OnDemandAssemblyBreakdownGenqlSelection{
    origin?: RecipeWithBreakdownGenqlSelection
    analytics?: IncomingInventoryAnalyticsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OnDemandAssemblyCostsGenqlSelection{
    id?: boolean | number
    amount?: boolean | number
    date?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OnDemandAssemblyCostsResultGenqlSelection{
    assemblyCosts?: OnDemandAssemblyCostsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OnDemandAssemblyVendorCostsGenqlSelection{
    id?: boolean | number
    companyId?: boolean | number
    amount?: boolean | number
    recipe?: RecipeGenqlSelection
    date?: boolean | number
    unpaidAmounts?: UnpaidAmountPerAffiliatedEntityGenqlSelection
    inventoryPaymentGroupLinks?: InventoryPaymentGroupLinkGenqlSelection
    affiliatedEntity?: AffiliatedEntityGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OnDemandAssemblyVendorCostsResultGenqlSelection{
    assemblyVendorCosts?: OnDemandAssemblyVendorCostsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OneTimePaymentGenqlSelection{
    id?: boolean | number
    price?: boolean | number
    quantity?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OpenBalanceSheetSetupInput {companyId: Scalars['String'],updatedBy?: (Scalars['String'] | null),reason?: (Scalars['String'] | null)}

export interface OpenBalanceSheetSetupResponseGenqlSelection{
    message?: boolean | number
    status?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OpeningBalanceActionGenqlSelection{
    quantity?: boolean | number
    id?: boolean | number
    date?: boolean | number
    type?: boolean | number
    averageCost?: boolean | number
    isFromUserInput?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OptionalTimeRangeInput {fromUTC?: (Scalars['Date'] | null),toUTC?: (Scalars['Date'] | null)}

export interface OrderAccountingReconciliationAccountGenqlSelection{
    entity?: OrderAccountingReconciliationAmountGenqlSelection
    account?: OrderAccountingReconciliationAmountGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderAccountingReconciliationAmountGenqlSelection{
    amount?: boolean | number
    accountRole?: boolean | number
    accountName?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderAccountingReconciliationRowGenqlSelection{
    accountName?: boolean | number
    accounts?: OrderAccountingReconciliationAccountGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderAccountingReconciliationsResponseGenqlSelection{
    rows?: OrderAccountingReconciliationRowGenqlSelection
    otherBalances?: OrderOtherAccountingReconciliationRowGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderAdjustmentGenqlSelection{
    id?: boolean | number
    amountInHomeCurrency?: boolean | number
    type?: boolean | number
    postedAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}


/** The adjustments of the order */
export interface OrderAdjustmentV3GenqlSelection{
    id?: boolean | number
    /** The ID of the adjustment in the external system */
    externalId?: boolean | number
    /** The date and time the adjustment was posted */
    postedAt?: boolean | number
    /** The amount of the adjustment */
    amount?: boolean | number
    /** The amount currency */
    amountCurrency?: boolean | number
    /** The amount home currency */
    amountHomeCurrency?: boolean | number
    /** The amount in home currency */
    amountInHomeCurrency?: boolean | number
    /** The type of the adjustment */
    type?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderAggregationEntryGenqlSelection{
    on_OrdersAggregation?:OrdersAggregationGenqlSelection,
    on_OrdersAgingAggregation?:OrdersAgingAggregationGenqlSelection,
    __typename?: boolean | number
}

export interface OrderBalanceGenqlSelection{
    /** The date of the balance */
    date?: boolean | number
    /** The balance of the order */
    balance?: boolean | number
    /** The balance of the order in home currency */
    balanceInHomeCurrency?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderEntityGenqlSelection{
    id?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderFinancialReportingStatusGenqlSelection{
    status?: boolean | number
    source?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderFulfillmentGenqlSelection{
    id?: boolean | number
    fulfilledAt?: boolean | number
    fulfillmentLineItems?: OrderFulfillmentLineItemGenqlSelection
    source?: boolean | number
    warehouse?: WarehouseGenqlSelection
    isOverriddenByFinaloop?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderFulfillmentLineItemGenqlSelection{
    id?: boolean | number
    lineItemId?: boolean | number
    quantity?: boolean | number
    sku?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}


/** The line items associated with the fulfillment */
export interface OrderFulfillmentLineItemV3GenqlSelection{
    id?: boolean | number
    /** The ID of the fulfillment in the external system */
    externalId?: boolean | number
    /** The ID of the line item that's being fulfilled */
    lineItemId?: boolean | number
    /** The quantity of the line item */
    quantity?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}


/** The fulfillments associated with the order, representing the shipping of the order */
export interface OrderFulfillmentV3GenqlSelection{
    id?: boolean | number
    /** The ID of the fulfillment in the external system */
    externalId?: boolean | number
    /** The status of the fulfillment */
    status?: boolean | number
    /** The fulfilling party, for example FBT/FBA are PLATFORM, while FBM is SELLER */
    channel?: boolean | number
    /** The warehouse that the fulfillment was shipped from */
    warehouse?: WarehouseGenqlSelection
    /** The date and time the fulfillment was shipped */
    shippedAt?: boolean | number
    /** The date and time the fulfillment was delivered */
    deliveredAt?: boolean | number
    /** The date and time the fulfillment was fulfilled */
    fulfilledAt?: boolean | number
    /** The line items associated with the fulfillment */
    lineItems?: OrderFulfillmentLineItemV3GenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderGroupGenqlSelection{
    id?: boolean | number
    companyId?: boolean | number
    amountInHomeCurrency?: boolean | number
    orders?: LinkedOrderGenqlSelection
    bankTransactions?: LinkedBankTransactionGenqlSelection
    expenses?: OrderGroupExpenseGenqlSelection
    orderDistributions?: OrderGroupOrderDistributionGenqlSelection
    postedAt?: boolean | number
    createdAt?: boolean | number
    updatedAt?: boolean | number
    deletedAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderGroupByIdInput {orderGroupId: Scalars['ID'],companyId: Scalars['ID']}

export interface OrderGroupByIdResponseGenqlSelection{
    orderGroup?: OrderGroupGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderGroupDistributionBasicGenqlSelection{
    orderGroupId?: boolean | number
    postedAt?: boolean | number
    amountInHomeCurrency?: boolean | number
    orderGroupHasCashPayments?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderGroupExpenseGenqlSelection{
    id?: boolean | number
    expenseType?: boolean | number
    amount?: AmountsGenqlSelection
    vendor?: VendorGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderGroupExpenseInput {expenseType: OrderGroupExpenseType,amount: Scalars['Float'],vendorId?: (Scalars['ID'] | null)}

export interface OrderGroupLinkGenqlSelection{
    orderGroupId?: boolean | number
    amountInHomeCurrency?: boolean | number
    postedAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderGroupOrderDistributionGenqlSelection{
    order?: OrderV2GenqlSelection
    bankTransaction?: BankTransactionGenqlSelection
    expense?: OrderGroupExpenseGenqlSelection
    postedAt?: boolean | number
    amountInHomeCurrency?: boolean | number
    orderGroupHasCashPayments?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderGroupsByIdsInput {companyId: Scalars['ID'],orderGroupIds: Scalars['ID'][],withDeleted?: (Scalars['Boolean'] | null)}

export interface OrderGroupsByIdsResponseGenqlSelection{
    orderGroups?: OrderGroupGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderGroupsFilter {postedAt?: (DateRangeInput | null)}

export interface OrderGroupsInput {companyId: Scalars['String'],filter: OrderGroupsFilter,sort?: (OrderGroupsSort | null),limit: Scalars['Int'],offset: Scalars['Int']}

export interface OrderGroupsResponseGenqlSelection{
    orderGroups?: OrderGroupGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderGroupsSort {type: OrderGroupsSortType,direction: OrderGroupsSortDirection}

export interface OrderGroupsTotalUnclearedBalanceInput {companyId: Scalars['ID'],asOfDate: Scalars['Date']}

export interface OrderGroupsTotalUnclearedBalanceResponseGenqlSelection{
    asOfDate?: boolean | number
    totalUnclearedBalance?: AmountsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderGroupsUnclearedBalanceInput {companyId: Scalars['ID'],orderGroupIds: Scalars['ID'][],asOfDate: Scalars['Date']}

export interface OrderGroupsUnclearedBalanceResponseGenqlSelection{
    asOfDate?: boolean | number
    unclearedBalances?: OrderGroupUnclearedBalanceGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderGroupUnclearedBalanceGenqlSelection{
    orderGroup?: OrderGroupGenqlSelection
    unclearedBalance?: AmountsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderIdInput {companyId: Scalars['ID'],orderId: Scalars['ID']}

export interface OrderInternalInput {id: Scalars['ID'],companyId: Scalars['ID']}

export interface OrderItemsFulfillmentV2GenqlSelection{
    id?: boolean | number
    trackingInfoRecords?: boolean | number
    externalWarehouseId?: boolean | number
    voidedAt?: boolean | number
    fulfilledAt?: boolean | number
    fulfilledQuantity?: boolean | number
    voidedBy?: boolean | number
    source?: boolean | number
    createdAt?: boolean | number
    updatedAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderItemStatusWithOverrideGenqlSelection{
    status?: boolean | number
    isOverridden?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderItemV2GenqlSelection{
    id?: boolean | number
    companyId?: boolean | number
    actionType?: boolean | number
    type?: boolean | number
    amount?: AmountsGenqlSelection
    taxAmount?: boolean | number
    taxAmountInHomeCurrency?: boolean | number
    discountAmount?: boolean | number
    discountAmountInHomeCurrency?: boolean | number
    exchangeRateOverride?: boolean | number
    taxExchangeRateOverride?: boolean | number
    discountExchangeRateOverride?: boolean | number
    taxes?: boolean | number
    externalSourceId?: boolean | number
    postedAt?: boolean | number
    externalProductId?: boolean | number
    product?: ProductGenqlSelection
    sku?: boolean | number
    quantity?: boolean | number
    unitPrice?: boolean | number
    isRestocked?: boolean | number
    fulfillments?: OrderItemsFulfillmentV2GenqlSelection
    originalFulfillmentId?: boolean | number
    voided?: boolean | number
    voidedAt?: boolean | number
    isFulfillmentOverridden?: boolean | number
    createdAt?: boolean | number
    updatedAt?: boolean | number
    status?: OrderItemStatusWithOverrideGenqlSelection
    lineItemId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderLineItemGenqlSelection{
    id?: boolean | number
    companyId?: boolean | number
    integrationAccountId?: boolean | number
    type?: boolean | number
    amount?: boolean | number
    amountInHomeCurrency?: boolean | number
    taxAmount?: boolean | number
    taxAmountInHomeCurrency?: boolean | number
    discountAmount?: boolean | number
    discountAmountInHomeCurrency?: boolean | number
    currency?: boolean | number
    quantity?: boolean | number
    firstPostedAt?: boolean | number
    lastPostedAt?: boolean | number
    externalProductId?: boolean | number
    product?: ProductGenqlSelection
    sku?: boolean | number
    unitPrice?: boolean | number
    voidedAt?: boolean | number
    status?: OrderItemStatusWithOverrideGenqlSelection
    fulfillments?: OrderLineItemFulfillmentGenqlSelection
    fulfillmentStats?: OrderLineItemFulfillmentStatsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}


/**
 * For a given order line item,
 * holds a consolidated list of fulfillment quantities and/or their overrides (if any)
 * as well as for the unfulfilled quantity
 */
export interface OrderLineItemFulfillmentGenqlSelection{
    warehouseId?: boolean | number
    /**
     * The start of the fulfillment UTC day (time is always 00:00:00).
     * If multiple fulfillments exist for this line item at different times in the same day,
     * they are aggregated into a single OrderLineItemFulfillment.
     */
    fulfilledAt?: boolean | number
    quantity?: boolean | number
    quantityOverride?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderLineItemFulfillmentStatsGenqlSelection{
    /** Total quantity of the line item that is unfulfilled */
    unfulfilledQuantity?: boolean | number
    /** Total quantity of the line item that is unfulfilled by overrides */
    unfulfilledQuantityOverride?: boolean | number
    /** Total quantity of the line item that is fulfilled. */
    fulfilledQuantity?: boolean | number
    /** Total quantity of the line item that is fulfilled by overrides */
    fulfilledQuantityOverride?: boolean | number
    /** Total quantity of the line item that is ordered. */
    orderedQuantity?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderLineItemFulfillmentV3GenqlSelection{
    warehouse?: WarehouseGenqlSelection
    fulfilledAt?: boolean | number
    quantity?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderLineItemTimelineV3GenqlSelection{
    lastEffectBy?: boolean | number
    /** The date and time the action was posted */
    postedAt?: boolean | number
    /** The total quantity of the action */
    totalQuantity?: boolean | number
    /** The date and time the action was fully fulfilled */
    fullyFulfilledAt?: boolean | number
    /** The date and time the action was first fulfilled */
    firstFulfillmentAt?: boolean | number
    /** The account state of the item */
    totalPlaced?: LineItemTimelineAccountStateV3GenqlSelection
    /** The account state of the item */
    unfulfilled?: LineItemTimelineAccountStateV3GenqlSelection
    /** The account state of the item */
    fulfilled?: LineItemTimelineAccountStateV3GenqlSelection
    /** The account state of the item */
    unfulfilledRefunded?: LineItemTimelineAccountStateV3GenqlSelection
    /** The account state of the item */
    fulfilledRefunded?: LineItemTimelineAccountStateV3GenqlSelection
    actions?: LineItemTimelineActionV3GenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderLineItemV3GenqlSelection{
    id?: boolean | number
    /** The ID of the line item in the external system */
    externalLineItemId?: boolean | number
    /** The name of the line item */
    name?: boolean | number
    /** The description of the line item */
    description?: boolean | number
    /** The amount of the line item */
    amount?: AmountsGenqlSelection
    parentId?: boolean | number
    /** The type of the line item */
    parentLineItemType?: boolean | number
    /** The earliest date and time the line item was posted */
    earliestPostedAt?: boolean | number
    /** The latest date and time the line item was posted */
    latestPostedAt?: boolean | number
    /** The type of the line item */
    type?: boolean | number
    on_DiscountLineItemV3?: DiscountLineItemV3GenqlSelection
    on_FeeLineItemV3?: FeeLineItemV3GenqlSelection
    on_ProductLineItemV3?: ProductLineItemV3GenqlSelection
    on_ShippingLineItemV3?: ShippingLineItemV3GenqlSelection
    on_TaxLineItemV3?: TaxLineItemV3GenqlSelection
    on_TipLineItemV3?: TipLineItemV3GenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderOtherAccountingReconciliationRowGenqlSelection{
    accountName?: boolean | number
    accounts?: OrderAccountingReconciliationAmountGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderPaymentGroupGenqlSelection{
    id?: boolean | number
    companyId?: boolean | number
    postedAt?: boolean | number
    createdAt?: boolean | number
    updatedAt?: boolean | number
    deletedAt?: boolean | number
    orders?: PaymentGroupLinkedOrderGenqlSelection
    bankTransactions?: PaymentGroupLinkedBankTransactionGenqlSelection
    expenses?: PaymentGroupExpenseGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderPaymentGroupByIdResponseGenqlSelection{
    paymentGroup?: OrderPaymentGroupGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderPaymentGroupsByIdsResponseGenqlSelection{
    paymentGroups?: OrderPaymentGroupGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderPaymentGroupsResponseGenqlSelection{
    paymentGroups?: OrderPaymentGroupGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderPaymentGroupsUnclearedBalanceResponseGenqlSelection{
    asOfDate?: boolean | number
    unclearedBalances?: OrderPaymentGroupUnclearedBalanceGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderPaymentGroupUnclearedBalanceGenqlSelection{
    paymentGroup?: OrderPaymentGroupGenqlSelection
    unclearedBalance?: AmountsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderReconciliationRowGenqlSelection{
    title?: boolean | number
    saleAmount?: boolean | number
    taxAmount?: boolean | number
    discountAmount?: boolean | number
    shippingAmount?: boolean | number
    refundAmount?: boolean | number
    additionalTaxesAmount?: boolean | number
    totalAmount?: boolean | number
    netAmount?: boolean | number
    subRows?: OrderReconciliationRowGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderReconciliationsInput {startTime: Scalars['Date'],endTime: Scalars['Date'],integrationAccountId: Scalars['ID'],companyId: Scalars['ID']}

export interface OrderReconciliationsResponseGenqlSelection{
    booksRows?: OrderReconciliationRowGenqlSelection
    excludedRows?: OrderReconciliationRowGenqlSelection
    adjustedRows?: OrderReconciliationRowGenqlSelection
    shopifyRow?: OrderReconciliationRowGenqlSelection
    dateRange?: DateRangeGenqlSelection
    currency?: boolean | number
    failureReason?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderRestockGenqlSelection{
    id?: boolean | number
    postedAt?: boolean | number
    restockLineItems?: OrderRestockLineItemGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderRestockLineItemGenqlSelection{
    id?: boolean | number
    quantity?: boolean | number
    lineItemId?: boolean | number
    sku?: boolean | number
    warehouse?: WarehouseGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}


/** The line items associated with the return */
export interface OrderReturnLineItemV3GenqlSelection{
    id?: boolean | number
    /** The ID of the fulfillment in the external system */
    externalId?: boolean | number
    /** The ID of the warehouse that the return was returned to */
    warehouse?: WarehouseGenqlSelection
    /** The ID of the line item that's being returned */
    lineItemId?: boolean | number
    /** The ID of the line item in the external system */
    externalLineItemId?: boolean | number
    /** The type of the return line item */
    type?: boolean | number
    /** Whether the return was restocked */
    isRestocked?: boolean | number
    /** The quantity that was returned */
    quantity?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}


/** The returns associated with the order, representing the returns of the order */
export interface OrderReturnV3GenqlSelection{
    id?: boolean | number
    /** The ID of the return in the external system */
    externalId?: boolean | number
    /** The date and time the return was posted */
    postedAt?: boolean | number
    /** The line items associated with the return */
    lineItems?: OrderReturnLineItemV3GenqlSelection
    /** The total refunded amount of the return */
    totalRefundedAmount?: boolean | number
    /** totalRefundedAmount currency */
    totalRefundedAmountCurrency?: boolean | number
    /** totalRefundedAmount in home currency */
    totalRefundedAmountInHomeCurrency?: boolean | number
    /** totalRefundedAmount home currency */
    totalRefundedAmountHomeCurrency?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrdersAggregationGenqlSelection{
    type?: boolean | number
    value?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrdersAgingAggregationGenqlSelection{
    type?: boolean | number
    values?: AgingAggregationItemGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrdersByIdsInput {companyId: Scalars['ID'],orderIds: Scalars['ID'][]}

export interface OrdersByIdsResponseGenqlSelection{
    orders?: OrderV2GenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrdersDateRangeInput {min: Scalars['Date'],max: Scalars['Date']}

export interface OrderSettingsGenqlSelection{
    void?: VoidOrderSettingsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderSettingsInput {companyId: Scalars['ID']}

export interface OrderSettingsResponseGenqlSelection{
    settings?: OrderSettingsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrdersFilter {searchText?: (Scalars['String'] | null),orderIds?: (Scalars['String'][] | null),unpaidAsOfDate?: (Scalars['Date'] | null),placedDate?: (OrdersDateRangeInput | null),productIds?: (Scalars['ID'][] | null),itemsCount?: (FloatRange | null),totalAmountInHomeCurrency?: (FloatRange | null),integrationAccountIds?: (Scalars['String'][] | null),storeIds?: (Scalars['String'][] | null),integrationAccountId?: (Scalars['String'] | null),paymentStatuses?: (OrderPaymentStatus[] | null),fulfillmentStatuses?: (OrderFulfillmentStatusInput[] | null),settlementStatuses?: (OrderSettlementStatusInput[] | null),orderStatuses?: (OrderStatusInput[] | null),tagIds?: (Scalars['ID'][] | null)}

export interface OrdersInput {companyId: Scalars['ID'],filter: OrdersFilter,sort: OrdersSort,limit: Scalars['Int'],offset: Scalars['Int']}

export interface OrdersResultGenqlSelection{
    orders?: OrderV3GenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrdersSettingsGenqlSelection{
    isZeroNetOrdersSupported?: boolean | number
    shouldRecognizeZeroNetCogsAsGiveaways?: boolean | number
    shopifyStoreV2StartDate?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrdersSort {type: OrdersSortType,direction: SortDirection}

export interface OrderStatusWithOverrideGenqlSelection{
    status?: boolean | number
    isOverridden?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderStatusWithOverrideV3GenqlSelection{
    status?: boolean | number
    isOverridden?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrdersYearEndBalancesGenqlSelection{
    unpaidAmount?: boolean | number
    cashDepositAmount?: boolean | number
    netUnpaidBalance?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrdersYearEndInput {companyId: Scalars['ID']}

export interface OrdersYearEndResponseGenqlSelection{
    balances?: OrdersYearEndBalancesGenqlSelection
    waitingPermissionsIntegrations?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderTagGenqlSelection{
    id?: boolean | number
    name?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}


/** Timestamps for when the order was first paid, fully paid, etc. */
export interface OrderTimestampsGenqlSelection{
    /** The date and time the order was fully paid */
    fullyPaidAt?: boolean | number
    /** The date and time the order was first paid */
    firstPaymentAt?: boolean | number
    /** The date and time the order was first refunded */
    firstRefundAt?: boolean | number
    /** The date and time the order was fully fulfilled */
    fullyFulfilledAt?: boolean | number
    /** The date and time the order was first fulfilled */
    firstFulfilledAt?: boolean | number
    /** The date and time the order was last updated */
    latestFinancialTimestamp?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderToLinkInput {orderId: Scalars['ID'],amountInHomeCurrency: Scalars['Float']}


/** The most up-to-date totals of the order */
export interface OrderTotalsGenqlSelection{
    /** Total without taxes */
    netSales?: boolean | number
    /** Total without taxes in home currency */
    netSalesInHomeCurrency?: boolean | number
    /** Total before shipping, discounts and taxes */
    subTotal?: boolean | number
    /** Total before shipping, discounts and taxes in home currency */
    subTotalInHomeCurrency?: boolean | number
    /** Total tips */
    tipsSubtotal?: boolean | number
    /** Total tips in home currency */
    tipsSubtotalInHomeCurrency?: boolean | number
    /** Total shipping */
    shippingSubtotal?: boolean | number
    /** Total shipping in home currency */
    shippingSubtotalInHomeCurrency?: boolean | number
    /** Total without taxes and returns */
    orderValue?: boolean | number
    /** Total without taxes and returns in home currency */
    orderValueInHomeCurrency?: boolean | number
    /** Total, includes everything */
    netOrder?: boolean | number
    /** Total, includes everything in home currency */
    netOrderInHomeCurrency?: boolean | number
    itemSellerDiscounts?: boolean | number
    itemSellerDiscountsInHomeCurrency?: boolean | number
    itemPlatformDiscounts?: boolean | number
    itemPlatformDiscountsInHomeCurrency?: boolean | number
    itemCofundedDiscounts?: boolean | number
    itemCofundedDiscountsInHomeCurrency?: boolean | number
    itemOtherDiscounts?: boolean | number
    itemOtherDiscountsInHomeCurrency?: boolean | number
    shippingSellerDiscounts?: boolean | number
    shippingSellerDiscountsInHomeCurrency?: boolean | number
    shippingPlatformDiscounts?: boolean | number
    shippingPlatformDiscountsInHomeCurrency?: boolean | number
    shippingCofundedDiscounts?: boolean | number
    shippingCofundedDiscountsInHomeCurrency?: boolean | number
    shippingOtherDiscounts?: boolean | number
    shippingOtherDiscountsInHomeCurrency?: boolean | number
    feesSellerDiscounts?: boolean | number
    feesSellerDiscountsInHomeCurrency?: boolean | number
    feesPlatformDiscounts?: boolean | number
    feesPlatformDiscountsInHomeCurrency?: boolean | number
    feesCofundedDiscounts?: boolean | number
    feesCofundedDiscountsInHomeCurrency?: boolean | number
    feesOtherDiscounts?: boolean | number
    feesOtherDiscountsInHomeCurrency?: boolean | number
    globalSellerDiscounts?: boolean | number
    globalSellerDiscountsInHomeCurrency?: boolean | number
    globalPlatformDiscounts?: boolean | number
    globalPlatformDiscountsInHomeCurrency?: boolean | number
    globalCofundedDiscounts?: boolean | number
    globalCofundedDiscountsInHomeCurrency?: boolean | number
    globalOtherDiscounts?: boolean | number
    globalOtherDiscountsInHomeCurrency?: boolean | number
    totalDiscounts?: boolean | number
    totalDiscountsInHomeCurrency?: boolean | number
    /** Total payments */
    payments?: boolean | number
    /** Total payments in home currency */
    paymentsInHomeCurrency?: boolean | number
    /** Total payment refunds (money) */
    paymentRefunds?: boolean | number
    /** Total payment refunds (money) in home currency */
    paymentRefundsInHomeCurrency?: boolean | number
    /** Total value of item refunds */
    saleRefunds?: boolean | number
    /** Total value of item refunds in home currency */
    saleRefundsInHomeCurrency?: boolean | number
    /** Total adjustments */
    adjustments?: boolean | number
    /** Total adjustments in home currency */
    adjustmentsInHomeCurrency?: boolean | number
    totalTaxes?: boolean | number
    totalTaxesInHomeCurrency?: boolean | number
    taxesSubtotal?: boolean | number
    taxesSubtotalInHomeCurrency?: boolean | number
    taxRefunds?: boolean | number
    taxRefundsInHomeCurrency?: boolean | number
    salesTax?: boolean | number
    salesTaxInHomeCurrency?: boolean | number
    vat?: boolean | number
    vatInHomeCurrency?: boolean | number
    gst?: boolean | number
    gstInHomeCurrency?: boolean | number
    dutiesAndOtherTaxes?: boolean | number
    dutiesAndOtherTaxesInHomeCurrency?: boolean | number
    /** The number of items in the order */
    numberOfItems?: boolean | number
    /** The order net paid amount */
    netPaid?: boolean | number
    /** The order net paid amount in home currency */
    netPaidInHomeCurrency?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderTotalSummaryGenqlSelection{
    subtotal?: AmountsGenqlSelection
    shippingIncome?: AmountsGenqlSelection
    discounts?: AmountsGenqlSelection
    netSale?: AmountsGenqlSelection
    taxes?: AmountsGenqlSelection
    additionalTaxes?: AmountsGenqlSelection
    refunds?: AmountsGenqlSelection
    fxAdjustment?: AmountsGenqlSelection
    netOrder?: AmountsGenqlSelection
    voided?: AmountsGenqlSelection
    paid?: boolean | number
    refunded?: boolean | number
    netPaid?: boolean | number
    uncollectible?: boolean | number
    overCollected?: boolean | number
    orderBalance?: boolean | number
    balanceAsOf?: boolean | number
    balanceAsOfAmount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderTransactionMatchV2GenqlSelection{
    id?: boolean | number
    amount?: AmountsGenqlSelection
    payment?: StorePaymentV2GenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderTransactionV2GenqlSelection{
    id?: boolean | number
    amount?: AmountsGenqlSelection
    exchangeRateOverride?: boolean | number
    type?: boolean | number
    postedAt?: boolean | number
    matches?: OrderTransactionMatchV2GenqlSelection
    finaloopPaymentGateway?: boolean | number
    originalPaymentGateway?: boolean | number
    paymentGatewayVariant?: boolean | number
    externalSourceId?: boolean | number
    createdAt?: boolean | number
    updatedAt?: boolean | number
    isManual?: boolean | number
    voided?: boolean | number
    authorizationCode?: boolean | number
    isArtificiallyMatched?: boolean | number
    matchedAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}


/** The transactions associated with the order, paying/refunding it */
export interface OrderTransactionV3GenqlSelection{
    id?: boolean | number
    /** The amount of the transaction */
    amount?: AmountsGenqlSelection
    /** The ID of the transaction in the external system */
    externalId?: boolean | number
    /** The type of the transaction (PAYMENT or REFUND) */
    type?: boolean | number
    /** The payment gateway of the transaction, as decided by Finaloop */
    paymentGateway?: boolean | number
    /** The date and time the transaction was posted */
    postedAt?: boolean | number
    releasedAt?: boolean | number
    /** The payment gateway of the transaction, as received from the external system */
    externalPaymentGateway?: boolean | number
    /** The authorization code of the transaction */
    authorizationCode?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderV2GenqlSelection{
    id?: boolean | number
    companyId?: boolean | number
    items?: OrderItemV2GenqlSelection
    lineItems?: OrderLineItemGenqlSelection
    transactions?: OrderTransactionV2GenqlSelection
    orderGroupLinks?: OrderGroupLinkGenqlSelection
    orderGroupDistributions?: OrderGroupDistributionBasicGenqlSelection
    orderAdjustments?: OrderAdjustmentGenqlSelection
    totalSummary?: OrderTotalSummaryGenqlSelection
    displayName?: boolean | number
    currency?: boolean | number
    source?: boolean | number
    placedAt?: boolean | number
    firstPaymentDate?: boolean | number
    fullyPaidDate?: boolean | number
    firstRefundDate?: boolean | number
    firstFulfillmentDate?: boolean | number
    latestFinancialDate?: boolean | number
    salesChannel?: boolean | number
    integrationAccountName?: boolean | number
    integrationAccountId?: boolean | number
    customer?: CustomerV2GenqlSelection
    isZeroNetOrder?: boolean | number
    integrationTags?: boolean | number
    finaloopTags?: OrderTagGenqlSelection
    finaloopNote?: boolean | number
    integrationNote?: boolean | number
    isChannelProductSalesAffecting?: boolean | number
    isChannelAccountsAffecting?: boolean | number
    isProductSalesAffecting?: boolean | number
    isAccountsAffecting?: boolean | number
    paymentStatus?: boolean | number
    fulfillmentStatus?: boolean | number
    balanceInHomeCurrency?: boolean | number
    voidedAt?: boolean | number
    shippingAddress?: CustomerAddressGenqlSelection
    billingAddress?: CustomerAddressGenqlSelection
    store?: StoreGenqlSelection
    status?: OrderStatusWithOverrideGenqlSelection
    financialReportingStatus?: OrderFinancialReportingStatusGenqlSelection
    integrationExternalUrl?: boolean | number
    fulfillments?: OrderFulfillmentGenqlSelection
    restocks?: OrderRestockGenqlSelection
    paymentGroupLinks?: PaymentGroupLinkGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderV2NotFoundGenqlSelection{
    message?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderV2ResultGenqlSelection{
    on_OrderV2?:OrderV2GenqlSelection,
    on_OrderV2NotFound?:OrderV2NotFoundGenqlSelection,
    __typename?: boolean | number
}

export interface OrderV3GenqlSelection{
    id?: boolean | number
    /** Company information */
    company?: CompanyGenqlSelection
    /** Integration type */
    integrationType?: boolean | number
    /** Integration account ID */
    integrationAccountId?: boolean | number
    totals?: OrderTotalsGenqlSelection
    returns?: OrderReturnV3GenqlSelection
    store?: StoreV3GenqlSelection
    /** The balances timeline of the order */
    balances?: OrderBalanceGenqlSelection
    /** The unfulfilled balances timeline of the order */
    unfulfilledBalances?: OrderBalanceGenqlSelection
    balanceAsOfAmount?: boolean | number
    currency?: boolean | number
    /** The date and time the order was posted */
    postedAt?: boolean | number
    statuses?: OrderStatusWithOverrideV3GenqlSelection
    /** The date and time the order was voided */
    voidedAt?: boolean | number
    /** The platform in which the order was voided */
    voidedBy?: boolean | number
    /** The date and time the order was voided in the integration */
    integrationVoidedAt?: boolean | number
    /** The note left by the buyer */
    buyerNote?: boolean | number
    /** Whether the order is zero net */
    isZeroNet?: boolean | number
    lineItems?: OrderLineItemV3GenqlSelection
    customer?: CustomerV3GenqlSelection
    externalUrl?: boolean | number
    /** The ID of the order in the external system */
    externalId?: boolean | number
    /** The date and time the order was updated in the external system */
    externalUpdatedAt?: boolean | number
    /** The note left by the seller */
    sellerNote?: boolean | number
    timestamps?: OrderTimestampsGenqlSelection
    adjustments?: OrderAdjustmentV3GenqlSelection
    /** The display name of the order, i.e. "Order #1234567890" */
    displayName?: boolean | number
    fulfillments?: OrderFulfillmentV3GenqlSelection
    transactions?: OrderTransactionV3GenqlSelection
    source?: boolean | number
    /** The current balance of the order */
    currentBalance?: boolean | number
    /** The current balance of the order in home currency */
    currentBalanceInHomeCurrency?: boolean | number
    /** The current unfulfilled balance of the order */
    currentUnfulfilledBalance?: boolean | number
    /** The current unfulfilled balance of the order in home currency */
    currentUnfulfilledBalanceInHomeCurrency?: boolean | number
    /** The ID of the sales channel that the order belongs to */
    salesChannelId?: boolean | number
    billingAddressId?: boolean | number
    shippingAddressId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderV3NotFoundGenqlSelection{
    message?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderVoidingStateInput {orderId: Scalars['ID'],voidedLineItemIds: Scalars['ID'][],nonVoidedLineItemIds: Scalars['ID'][]}

export interface OtherFbaActionGenqlSelection{
    quantity?: boolean | number
    id?: boolean | number
    date?: boolean | number
    type?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OtherFbaCogsGenqlSelection{
    amount?: boolean | number
    otherFbaIncoming?: boolean | number
    otherFba?: boolean | number
    monthlyBreakdown?: OtherFbaMonthlyBreakdownGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OtherFbaDailyBreakdownGenqlSelection{
    date?: boolean | number
    otherFbaIncoming?: boolean | number
    otherFba?: boolean | number
    reason?: AdjustmentsReasonGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OtherFbaMonthlyBreakdownGenqlSelection{
    date?: boolean | number
    otherFbaIncoming?: boolean | number
    otherFba?: boolean | number
    dailyData?: OtherFbaDailyBreakdownGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}


/**
 * Fulfillment overrides for a specific order line item.
 * Under `overrides`, quantity of multiple overrides with the same warehouse and date
 * is considered to be the sum of those quantities.
 */
export interface OverrideOrderFulfillmentLineItemInput {lineItemId: Scalars['ID'],overrides: OverrideOrderFulfillmentsItemInput[]}

export interface OverrideOrderFulfillmentsErrorGenqlSelection{
    on_OverrideOrderFulfillmentsErrorInvalidLineItem?:OverrideOrderFulfillmentsErrorInvalidLineItemGenqlSelection,
    on_OverrideOrderFulfillmentsErrorInvalidOrder?:OverrideOrderFulfillmentsErrorInvalidOrderGenqlSelection,
    on_OverrideOrderFulfillmentsErrorInvalidWarehouse?:OverrideOrderFulfillmentsErrorInvalidWarehouseGenqlSelection,
    on_OverrideOrderFulfillmentsErrorInvalidQuantity?:OverrideOrderFulfillmentsErrorInvalidQuantityGenqlSelection,
    on_OverrideOrderFulfillmentsErrorQuantityDiscrepancy?:OverrideOrderFulfillmentsErrorQuantityDiscrepancyGenqlSelection,
    on_OverrideOrderFulfillmentsErrorInvalidFulfillmentWarehouse?:OverrideOrderFulfillmentsErrorInvalidFulfillmentWarehouseGenqlSelection,
    on_OverrideOrderFulfillmentsErrorInvalidFulfillmentDate?:OverrideOrderFulfillmentsErrorInvalidFulfillmentDateGenqlSelection,
    on_OverrideOrderFulfillmentsErrorLockedFulfillmentDate?:OverrideOrderFulfillmentsErrorLockedFulfillmentDateGenqlSelection,
    on_OverrideOrderFulfillmentsErrorMissingOverride?:OverrideOrderFulfillmentsErrorMissingOverrideGenqlSelection,
    on_OverrideOrderFulfillmentsErrorMisc?:OverrideOrderFulfillmentsErrorMiscGenqlSelection,
    __typename?: boolean | number
}

export interface OverrideOrderFulfillmentsErrorInvalidFulfillmentDateGenqlSelection{
    /** The id of the line item in the order. */
    lineItemId?: boolean | number
    /** The date of the fulfillment */
    fulfilledAt?: boolean | number
    /** The warehouse ID for which the invalid date was provided */
    warehouseId?: boolean | number
    /** An optional error message, describing the error in more detail */
    message?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}


/** Invalid warehouse ID was found in a fulfillment */
export interface OverrideOrderFulfillmentsErrorInvalidFulfillmentWarehouseGenqlSelection{
    /** The fulfillment ID for which the invalid warehouse ID was provided */
    fulfillmentId?: boolean | number
    /** The invalid warehouse ID. Omitted if the warehouse ID was missing in the fulfillment. */
    warehouseId?: boolean | number
    /** The date of the fulfillment */
    fulfilledAt?: boolean | number
    /** An optional error message, describing the error in more detail */
    message?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}


/** An invalid line item ID was provided */
export interface OverrideOrderFulfillmentsErrorInvalidLineItemGenqlSelection{
    /** The invalid line item ID */
    lineItemId?: boolean | number
    /** An optional error message, describing the error in more detail */
    message?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}


/** An invalid order ID was provided */
export interface OverrideOrderFulfillmentsErrorInvalidOrderGenqlSelection{
    /** The invalid order ID */
    orderId?: boolean | number
    /** An optional error message, describing the error in more detail */
    message?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}


/** An invalid quantity was provided, e.g. a negative value */
export interface OverrideOrderFulfillmentsErrorInvalidQuantityGenqlSelection{
    /** The line item ID for which the invalid quantity was provided */
    lineItemId?: boolean | number
    /** The warehouse ID for which the invalid quantity was provided */
    warehouseId?: boolean | number
    /** The date of the fulfillment for which the invalid quantity was provided */
    fulfilledAt?: boolean | number
    /** The invalid quantity */
    quantity?: boolean | number
    /** An optional error message, describing the error in more detail */
    message?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}


/** An invalid or inaccessible warehouse ID was provided */
export interface OverrideOrderFulfillmentsErrorInvalidWarehouseGenqlSelection{
    /** The line item ID for which the invalid warehouse ID was provided */
    lineItemId?: boolean | number
    /** The invalid warehouse ID */
    warehouseId?: boolean | number
    /** The date of the fulfillment */
    fulfilledAt?: boolean | number
    /** An optional error message, describing the error in more detail */
    message?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}


/** A fulfillment date is within a locked time period */
export interface OverrideOrderFulfillmentsErrorLockedFulfillmentDateGenqlSelection{
    /** The id of the line item in the order. */
    lineItemId?: boolean | number
    /** The locked date of the fulfillment */
    fulfilledAt?: boolean | number
    /** The warehouse ID for which the locked date was provided */
    warehouseId?: boolean | number
    /** An optional error message, describing the error in more detail */
    message?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OverrideOrderFulfillmentsErrorMiscGenqlSelection{
    /** An optional error message, describing the error in more detail */
    message?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}


/**
 * An override is missing for an existing line item fulfillment warehouse-date combination.
 * Any line item that is provided with overrides must have overrides for all its fulfillments,
 * even if it means sending overrides with identical quantities.
 * This is required to confirm that quantities moving between warehouses/dates are all accounted for.
 */
export interface OverrideOrderFulfillmentsErrorMissingOverrideGenqlSelection{
    /** The id of the line item in the order. */
    lineItemId?: boolean | number
    /** The date of the missing fulfillment */
    fulfilledAt?: boolean | number
    /** The warehouse ID of the missing fulfillment */
    warehouseId?: boolean | number
    /** An optional error message, describing the error in more detail */
    message?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OverrideOrderFulfillmentsErrorQuantityDiscrepancyGenqlSelection{
    /**
     * The calculated quantity that is in discrepancy with the quantity of the line item in the order.
     * Note this may be a result of multiple fulfillment entries for different warehouses and dates.
     */
    quantity?: boolean | number
    /** The quantity of the line item in the order. */
    lineItemQuantity?: boolean | number
    /** The id of the line item in the order. */
    lineItemId?: boolean | number
    /** An optional error message, describing the error in more detail */
    message?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OverrideOrderFulfillmentsInput {companyId: Scalars['ID'],fulfillmentOverrides: OverrideOrderFulfillmentsOrderInput[]}


/** Fulfillment override for a specific warehouse and date */
export interface OverrideOrderFulfillmentsItemInput {warehouseId: Scalars['String'],fulfilledAt: Scalars['Date'],quantity: Scalars['Int']}


/**
 * Override order fulfillments for the given order.
 * Note that the provided fulfillment overrides will completely replace the existing fulfillments of the order.
 * Ensure it includes any existing fulfillments for the order if they should be preserved.
 */
export interface OverrideOrderFulfillmentsOrderInput {orderId: Scalars['ID'],lineItemOverrides: OverrideOrderFulfillmentLineItemInput[]}

export interface OverrideOrderFulfillmentsOrderResponseGenqlSelection{
    orderId?: boolean | number
    /**
     * Whether the operation was successful. If `false`, at least one input order updated has failed,
     * however, other orders may have been updated successfully.
     * For failed orders, the `errors` field will contain the errors that occurred.
     */
    success?: boolean | number
    errors?: OverrideOrderFulfillmentsErrorGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OverrideOrderFulfillmentsResponseGenqlSelection{
    orders?: OverrideOrderFulfillmentsOrderResponseGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OverrideOrderFulfillmentsToLineItemPostDateInput {companyId: Scalars['ID'],orderIds: Scalars['ID'][]}

export interface OverviewCycleGenqlSelection{
    fromDate?: boolean | number
    toDate?: boolean | number
    openingBalance?: boolean | number
    purchasesSum?: boolean | number
    assemblyCostsSum?: boolean | number
    cogsSum?: boolean | number
    cogsAdjustmentsSum?: boolean | number
    closingBalance?: boolean | number
    warehouseTransfersSum?: boolean | number
    physicalCountAdjustment?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OverviewCyclesInput {companyId: Scalars['ID'],fromDate: Scalars['Date'],toDate: Scalars['Date']}

export interface PageInput {offset: Scalars['Int'],limit: Scalars['Int']}

export interface PairedEntityGenqlSelection{
    on_Bill?:BillGenqlSelection,
    on_Payout?:PayoutGenqlSelection,
    on_Topup?:TopupGenqlSelection,
    on_BankTransaction?:BankTransactionGenqlSelection,
    on_CompanyAffiliate?:CompanyAffiliateGenqlSelection,
    on_IntegrationTransfer?: IntegrationTransferGenqlSelection,
    __typename?: boolean | number
}

export interface PaymentGenqlSelection{
    companyId?: boolean | number
    id?: boolean | number
    source?: boolean | number
    integrationAccountId?: boolean | number
    integrationAccountName?: boolean | number
    amount?: boolean | number
    currency?: boolean | number
    postedAt?: boolean | number
    externalAuthorizationCode?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PaymentCheckGenqlSelection{
    id?: boolean | number
    company?: CompanyGenqlSelection
    source?: boolean | number
    postedAt?: boolean | number
    amount?: boolean | number
    currency?: boolean | number
    amountInHomeCurrency?: boolean | number
    contractor?: ContractorGenqlSelection
    employee?: EmployeeGenqlSelection
    matchedBankTransaction?: BankTransactionGenqlSelection
    isImmaterial?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PaymentChecksInput {companyId: Scalars['ID'],amount: Scalars['Float'],currency: Scalars['String']}

export interface PaymentDetailsGenqlSelection{
    id?: boolean | number
    price?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PaymentFeeGenqlSelection{
    companyId?: boolean | number
    id?: boolean | number
    source?: boolean | number
    integrationAccountId?: boolean | number
    integrationAccountName?: boolean | number
    amount?: boolean | number
    currency?: boolean | number
    type?: boolean | number
    basis?: boolean | number
    postedAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PaymentGatewaysByCompanyIntegrationAndSalesChannelInput {companyId: Scalars['ID'],integrationAccountId: Scalars['ID'],salesChannel: Scalars['String']}

export interface PaymentGroupGenqlSelection{
    id?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PaymentGroupBankTransactionToLinkInput {transactionId: Scalars['ID'],amount: Scalars['Float'],amountInHomeCurrency?: (Scalars['Float'] | null),currency?: (CurrencyCode | null)}

export interface PaymentGroupByIdInput {paymentGroupId: Scalars['ID'],companyId: Scalars['ID']}

export interface PaymentGroupExpenseGenqlSelection{
    id?: boolean | number
    expenseType?: boolean | number
    amount?: AmountsGenqlSelection
    vendor?: VendorGenqlSelection
    merchant?: VendorOrCustomerGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PaymentGroupExpenseInput {expenseType: PaymentGroupExpenseType,amount: Scalars['Float'],vendorId?: (Scalars['ID'] | null)}

export interface PaymentGroupInventoryPurchasesToLinkInput {id?: (Scalars['ID'] | null),inventoryPurchaseId: Scalars['ID'],amount: Scalars['Float'],amountInHomeCurrency?: (Scalars['Float'] | null),currency?: (CurrencyCode | null)}

export interface PaymentGroupInvoiceToLinkInput {invoiceId: Scalars['ID'],amount: Scalars['Float'],amountInHomeCurrency: Scalars['Float'],currency: CurrencyCode}

export interface PaymentGroupLinkGenqlSelection{
    paymentGroupId?: boolean | number
    amount?: boolean | number
    amountInHomeCurrency?: boolean | number
    currency?: boolean | number
    postedAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PaymentGroupLinkedBankTransactionGenqlSelection{
    bankTransaction?: BankTransactionGenqlSelection
    bankTransactionPostedAt?: boolean | number
    amount?: AmountsGenqlSelection
    id?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PaymentGroupLinkedInventoryPurchasesGenqlSelection{
    inventoryPurchase?: InventoryPurchaseGenqlSelection
    inventoryPurchasePostedAt?: boolean | number
    amount?: AmountsGenqlSelection
    id?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PaymentGroupLinkedInvoiceGenqlSelection{
    invoice?: InvoiceGenqlSelection
    amountInHomeCurrency?: boolean | number
    currency?: boolean | number
    amount?: boolean | number
    id?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PaymentGroupLinkedManualAssemblyGenqlSelection{
    id?: boolean | number
    manualAssembly?: ManualAssemblyGenqlSelection
    amountInHomeCurrency?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PaymentGroupLinkedOnDemandAssemblyVendorCostGenqlSelection{
    id?: boolean | number
    onDemandAssemblyVendorCost?: OnDemandAssemblyVendorCostsGenqlSelection
    amountInHomeCurrency?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PaymentGroupLinkedOrderGenqlSelection{
    order?: OrderV2GenqlSelection
    amountInHomeCurrency?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PaymentGroupLinkedPurchaseOrderGenqlSelection{
    id?: boolean | number
    purchaseOrder?: PurchaseOrderGenqlSelection
    amountInHomeCurrency?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PaymentGroupLinkedWarehouseTransferGenqlSelection{
    id?: boolean | number
    warehouseTransfer?: WarehouseTransferGenqlSelection
    amountInHomeCurrency?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PaymentGroupLinksForInvoiceInput {companyId: Scalars['String'],invoiceId: Scalars['String']}

export interface PaymentGroupLinksForInvoiceResponseGenqlSelection{
    paymentGroupLinks?: PaymentGroupLinkGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PaymentGroupLinksInput {companyId: Scalars['String'],saleId: Scalars['String'],paymentGroupType: PaymentGroupType}

export interface PaymentGroupLinksResponseGenqlSelection{
    paymentGroupLinks?: PaymentGroupLinkGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PaymentGroupManualAssemblyCostsToLinkInput {id?: (Scalars['ID'] | null),manualAssemblyId: Scalars['ID'],amountInHomeCurrency: Scalars['Float']}

export interface PaymentGroupOnDemandAssemblyVendorCostsToLinkInput {id?: (Scalars['ID'] | null),onDemandAssemblyVendorCostId: Scalars['ID'],amountInHomeCurrency: Scalars['Float']}

export interface PaymentGroupOrderToLinkInput {orderId: Scalars['ID'],amountInHomeCurrency: Scalars['Float']}

export interface PaymentGroupPurchaseOrderToLinkInput {id?: (Scalars['ID'] | null),purchaseOrderId: Scalars['ID'],amountInHomeCurrency: Scalars['Float']}

export interface PaymentGroupsByIdsInput {companyId: Scalars['ID'],paymentGroupIds: Scalars['ID'][],withDeleted?: (Scalars['Boolean'] | null)}

export interface PaymentGroupsByIdsResponseGenqlSelection{
    paymentGroups?: IPaymentGroupGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PaymentGroupsFilter {postedAt?: (DateRangeInput | null)}

export interface PaymentGroupsInput {companyId: Scalars['String'],filter: PaymentGroupsFilter,sort?: (PaymentGroupsSort | null),limit: Scalars['Int'],offset: Scalars['Int']}

export interface PaymentGroupsSort {type: PaymentGroupsSortType,direction: PaymentGroupsSortDirection}

export interface PaymentGroupsTotalUnclearedBalanceInput {companyId: Scalars['ID'],asOfDate: Scalars['Date']}

export interface PaymentGroupsTotalUnclearedBalanceResponseGenqlSelection{
    asOfDate?: boolean | number
    totalUnclearedBalance?: AmountsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PaymentGroupsUnclearedBalanceInput {companyId: Scalars['ID'],paymentGroupIds: Scalars['ID'][],asOfDate: Scalars['Date']}

export interface PaymentGroupTransactionGenqlSelection{
    id?: boolean | number
    integrationInfo?: IntegrationInfoGenqlSelection
    integrationAccountId?: boolean | number
    externalSourceId?: boolean | number
    amount?: boolean | number
    postedAt?: boolean | number
    currency?: boolean | number
    amountInHomeCurrency?: boolean | number
    type?: boolean | number
    finaloopPaymentGateway?: boolean | number
    originalPaymentGateway?: boolean | number
    paymentGatewayVariant?: boolean | number
    isIndication?: boolean | number
    paymentGroup?: PaymentGroupGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PaymentGroupWarehouseTransferToLinkInput {id?: (Scalars['ID'] | null),warehouseTransferId: Scalars['ID'],amountInHomeCurrency: Scalars['Float']}

export interface PaymentMethodGenqlSelection{
    id?: boolean | number
    source?: boolean | number
    type?: boolean | number
    isDefault?: boolean | number
    integrationAccountId?: boolean | number
    instructions?: boolean | number
    bankName?: boolean | number
    accountNumber?: boolean | number
    routingNumber?: boolean | number
    swift?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PaymentMethodInput {companyId: Scalars['ID'],id: Scalars['ID']}

export interface PaymentOptionInput {stripeId: Scalars['String'],price: Scalars['Float'],recurrence?: (PaymentRecurrence | null)}

export interface PaymentProcessorByCompanyAndVendorInput {companyId: Scalars['ID'],vendorId: Scalars['ID']}

export interface PaymentProcessorByCompanyAndVendorResponseGenqlSelection{
    processor?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PaymentsByEntityInput {companyId: Scalars['ID'],startDate: Scalars['Date'],endDate: Scalars['Date']}

export interface PayoutGenqlSelection{
    id?: boolean | number
    companyId?: boolean | number
    amount?: boolean | number
    amountInUsd?: boolean | number
    currency?: boolean | number
    eventTime?: boolean | number
    deletedAt?: boolean | number
    markedAsReconciliationDiscrepancyAt?: boolean | number
    integrationType?: boolean | number
    pairedBankTransaction?: BankTransactionGenqlSelection
    type?: boolean | number
    classification?: IntegrationTransferClassificationGenqlSelection
    integrationAccountId?: boolean | number
    integrationAccountName?: boolean | number
    pairedCompanyAffiliate?: CompanyAffiliateGenqlSelection
    link?: boolean | number
    uploadedFileId?: boolean | number
    failedAmountInUsd?: boolean | number
    failedAt?: boolean | number
    markedAsUnidentifiedAt?: boolean | number
    rawEvent?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PaypalTransactionCurrenciesInput {companyId: Scalars['ID'],bankAccountId: Scalars['ID'],integrationAccountId: Scalars['String']}

export interface PayrollGenqlSelection{
    id?: boolean | number
    company?: CompanyGenqlSelection
    source?: boolean | number
    integrationAccountId?: boolean | number
    externalSourceId?: boolean | number
    integrationAccountName?: boolean | number
    currency?: boolean | number
    postedAt?: boolean | number
    deletedAt?: boolean | number
    createdAt?: boolean | number
    updatedAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PayrollCategoryMappingGenqlSelection{
    on_PayrollDepartmentCategoryMapping?:PayrollDepartmentCategoryMappingGenqlSelection,
    on_PayrollEmployeeCategoryMapping?:PayrollEmployeeCategoryMappingGenqlSelection,
    on_PayrollContractorCategoryMapping?:PayrollContractorCategoryMappingGenqlSelection,
    __typename?: boolean | number
}

export interface PayrollCategoryMappingInput {id: Scalars['ID'],type: PayrollMappableType,category?: (PayrollCategory | null)}

export interface PayrollConnectionGenqlSelection{
    integrationAccountId?: boolean | number
    integrationType?: boolean | number
    integrationAccountName?: boolean | number
    importStatus?: PayrollConnectionImportStatusGenqlSelection
    disconnectedAt?: boolean | number
    disconnectedBy?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PayrollConnectionImportStatusGenqlSelection{
    contractorPayments?: PayrollConnectionImportStatusDataGenqlSelection
    contractors?: PayrollConnectionImportStatusDataGenqlSelection
    departments?: PayrollConnectionImportStatusDataGenqlSelection
    employees?: PayrollConnectionImportStatusDataGenqlSelection
    payrolls?: PayrollConnectionImportStatusDataGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PayrollConnectionImportStatusDataGenqlSelection{
    lastUpdateTime?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PayrollConnectionsInput {companyId: Scalars['ID']}

export interface PayrollContractorCategoryMappingGenqlSelection{
    contractor?: ContractorGenqlSelection
    category?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PayrollDailyAggregateGenqlSelection{
    id?: boolean | number
    currency?: boolean | number
    postedAt?: boolean | number
    source?: boolean | number
    integrationAccountName?: boolean | number
    integrationAccountId?: boolean | number
    startDate?: boolean | number
    endDate?: boolean | number
    unallocatedHealthBenefitsContribution?: boolean | number
    unallocatedCompanyTaxes?: boolean | number
    unallocatedDonationDeductions?: boolean | number
    pension401k?: boolean | number
    deletedAt?: boolean | number
    matchedBankTransaction?: BankTransactionGenqlSelection
    paymentChecks?: DailyAggregatedPaymentCheckGenqlSelection
    reimbursements?: DailyAggregatedReimbursementGenqlSelection
    ownersDraw?: DailyAggregatedOwnersDrawGenqlSelection
    integrationTransfers?: PayrollIntegrationTransferGenqlSelection
    taxDebitAmount?: boolean | number
    netPayDebitAmount?: boolean | number
    dailyAggregates?: DailyAggregatedPayrollDataGenqlSelection
    unpaidAmountsViaProvider?: UnpaidAmountsViaProviderGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PayrollDailyDataInput {companyId: Scalars['ID'],payrollIds: Scalars['ID'][]}

export interface PayrollDataGenqlSelection{
    knownVendors?: boolean | number
    unknownVendors?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PayrollDepartmentCategoryMappingGenqlSelection{
    department?: DepartmentGenqlSelection
    category?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PayrollEmployeeCategoryMappingGenqlSelection{
    employee?: EmployeeGenqlSelection
    category?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PayrollIdsByCompanyInput {companyIds: Scalars['ID'][],afterBooksStartTimeOnly?: (Scalars['Boolean'] | null)}

export interface PayrollIdsByCompanyItemGenqlSelection{
    companyId?: boolean | number
    payrollIds?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PayrollIdsByCompanyResponseGenqlSelection{
    items?: PayrollIdsByCompanyItemGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PayrollIntegrationTransferGenqlSelection{
    integrationTransferId?: boolean | number
    type?: boolean | number
    amount?: boolean | number
    amountInHomeCurrency?: boolean | number
    deletedAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PayrollItemToReconcile {companyId: Scalars['ID'],payrollId: Scalars['ID']}

export interface PayrollSettingsGenqlSelection{
    withCategoryMapping?: boolean | number
    categoryMappingMode?: boolean | number
    categoryMappings?: PayrollCategoryMappingGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PayrollSettingsInput {companyId: Scalars['ID']}

export interface PendingAdjustmentsExcludeListItemGenqlSelection{
    productId?: boolean | number
    date?: boolean | number
    warehouseId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PendingAdjustmentsOverviewResponseGenqlSelection{
    count?: boolean | number
    pendingCount?: boolean | number
    missingDataCount?: boolean | number
    lastPendingChange?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PendingDeadInventoryAdjustmentsGenqlSelection{
    id?: boolean | number
    date?: boolean | number
    quantity?: boolean | number
    warehouseId?: boolean | number
    warehouse?: WarehouseGenqlSelection
    productId?: boolean | number
    companyId?: boolean | number
    currentState?: DeadInventoryOriginalValueGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PendingDeadInventoryAdjustmentsByIdsResponseGenqlSelection{
    items?: PendingDeadInventoryAdjustmentsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PendingDeadInventoryAdjustmentsItemGenqlSelection{
    productId?: boolean | number
    product?: ProductGenqlSelection
    pendingDeadInventoryAdjustments?: PendingDeadInventoryAdjustmentsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PendingDeadInventoryAdjustmentsResponseGenqlSelection{
    items?: PendingDeadInventoryAdjustmentsItemGenqlSelection
    excludeList?: PendingAdjustmentsExcludeListItemGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PendingDonationAdjustmentsGenqlSelection{
    id?: boolean | number
    date?: boolean | number
    quantity?: boolean | number
    warehouseId?: boolean | number
    warehouse?: WarehouseGenqlSelection
    productId?: boolean | number
    companyId?: boolean | number
    currentState?: DonationOriginalValueGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PendingDonationAdjustmentsByIdsResponseGenqlSelection{
    items?: PendingDonationAdjustmentsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PendingDonationAdjustmentsItemGenqlSelection{
    productId?: boolean | number
    product?: ProductGenqlSelection
    pendingDonationAdjustments?: PendingDonationAdjustmentsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PendingDonationAdjustmentsResponseGenqlSelection{
    items?: PendingDonationAdjustmentsItemGenqlSelection
    excludeList?: PendingAdjustmentsExcludeListItemGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PendingGiveawayAdjustmentsGenqlSelection{
    id?: boolean | number
    date?: boolean | number
    quantity?: boolean | number
    warehouseId?: boolean | number
    warehouse?: WarehouseGenqlSelection
    productId?: boolean | number
    companyId?: boolean | number
    currentState?: GiveawayOriginalValueGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PendingGiveawayAdjustmentsByIdsResponseGenqlSelection{
    items?: PendingGiveawayAdjustmentsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PendingGiveawayAdjustmentsItemGenqlSelection{
    productId?: boolean | number
    product?: ProductGenqlSelection
    pendingGiveawayAdjustments?: PendingGiveawayAdjustmentsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PendingGiveawayAdjustmentsResponseGenqlSelection{
    items?: PendingGiveawayAdjustmentsItemGenqlSelection
    excludeList?: PendingAdjustmentsExcludeListItemGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PendingGiveawayDropshippingAdjustmentsGenqlSelection{
    id?: boolean | number
    date?: boolean | number
    quantity?: boolean | number
    warehouseId?: boolean | number
    warehouse?: WarehouseGenqlSelection
    productId?: boolean | number
    companyId?: boolean | number
    currentState?: GiveawayDropshippingOriginalValueGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PendingGiveawayDropshippingAdjustmentsByIdsResponseGenqlSelection{
    items?: PendingGiveawayDropshippingAdjustmentsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PendingGiveawayDropshippingAdjustmentsItemGenqlSelection{
    productId?: boolean | number
    product?: ProductGenqlSelection
    pendingGiveawayDropshippingAdjustments?: PendingGiveawayDropshippingAdjustmentsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PendingGiveawayDropshippingAdjustmentsResponseGenqlSelection{
    items?: PendingGiveawayDropshippingAdjustmentsItemGenqlSelection
    excludeList?: PendingAdjustmentsExcludeListItemGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PendingSalesDataAdjustmentsGenqlSelection{
    id?: boolean | number
    salesChannel?: SalesChannelGenqlSelection
    date?: boolean | number
    unitsSold?: boolean | number
    unitsRestocked?: boolean | number
    warehouseId?: boolean | number
    warehouse?: WarehouseGenqlSelection
    productId?: boolean | number
    companyId?: boolean | number
    currentState?: SalesAdjustmentOriginalValueGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PendingSalesDataAdjustmentsByIdsResponseGenqlSelection{
    items?: PendingSalesDataAdjustmentsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PendingSalesDataAdjustmentsItemGenqlSelection{
    productId?: boolean | number
    product?: ProductGenqlSelection
    pendingSalesDataAdjustments?: PendingSalesDataAdjustmentsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PendingSalesDataAdjustmentsOverviewResponseGenqlSelection{
    count?: boolean | number
    pendingCount?: boolean | number
    missingDataCount?: boolean | number
    lastPendingChange?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PendingSalesDataAdjustmentsResponseGenqlSelection{
    items?: PendingSalesDataAdjustmentsItemGenqlSelection
    excludeList?: PendingAdjustmentsExcludeListItemGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PendingWarehouseOpeningBalanceGenqlSelection{
    id?: boolean | number
    warehouse?: WarehouseGenqlSelection
    quantity?: boolean | number
    costPerUnit?: boolean | number
    date?: boolean | number
    attachmentId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PendingWarehouseOpeningBalanceAttachmentGenqlSelection{
    id?: boolean | number
    companyId?: boolean | number
    date?: boolean | number
    filename?: boolean | number
    url?: boolean | number
    createdAt?: boolean | number
    deletedAt?: boolean | number
    pendingChangesCount?: boolean | number
    summaryData?: PendingWarehouseOpeningBalancesAttachmentSummaryGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PendingWarehouseOpeningBalancesAttachmentSummaryGenqlSelection{
    totalCount?: boolean | number
    validCount?: boolean | number
    invalidCount?: boolean | number
    errorCount?: boolean | number
    errorItems?: WarehouseOpeningBalanceErrorItemGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PendingWarehouseOpeningBalancesResponseGenqlSelection{
    items?: WarehouseOpeningBalanceItemGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PendingWarehouseOpeningBalancesWithCsvResponseGenqlSelection{
    attachmentId?: boolean | number
    summaryData?: PendingWarehouseOpeningBalancesAttachmentSummaryGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PeriodDatesInput {periodStart: Scalars['Date'],periodEnd: Scalars['Date']}

export interface PeriodicPartnerReportGenqlSelection{
    company?: CompanyGenqlSelection
    partner?: ReportsPartnerGenqlSelection
    createdAt?: boolean | number
    latestActorId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PeriodicPartnerReportInput {companyId: Scalars['ID'],partnerId: Scalars['ID']}

export interface PermissionGenqlSelection{
    id?: boolean | number
    name?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PerVendorBreakdownInput {affiliatedEntityId: Scalars['String'],newTotal: Scalars['Float']}

export interface PhysicalCountValidationDataGenqlSelection{
    items?: PhysicalCountValidationItemGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PhysicalCountValidationInput {companyId: Scalars['ID']}

export interface PhysicalCountValidationItemGenqlSelection{
    date?: boolean | number
    booksAmount?: boolean | number
    entityAmount?: boolean | number
    diff?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PhysicalCountValidationResponseGenqlSelection{
    validationId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PollCheckoutSessionStatusInput {checkoutSessionId: Scalars['String'],companyId: Scalars['ID']}

export interface PrevalidateCompanyLoanInput {companyId: Scalars['ID'],loanId?: (Scalars['ID'] | null),data: LoanUpdateBasicData,attachments: UpdateLoanAttachmentInput[]}

export interface ProcessBillContentInput {companyId: Scalars['ID'],filePathInBucket: Scalars['String']}

export interface ProcessBillContentResultGenqlSelection{
    isSuccessful?: boolean | number
    id?: boolean | number
    vendor?: VendorGenqlSelection
    categories?: CategoryGenqlSelection
    date?: boolean | number
    dueDate?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProcessCheckoutWebhookEventsInput {webhookEvent: Scalars['JSON']}

export interface ProcessLoanAttachmentResultGenqlSelection{
    success?: boolean | number
    errors?: LoanAttachmentErrorGenqlSelection
    processing?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProductGenqlSelection{
    id?: boolean | number
    companyId?: boolean | number
    finaloopId?: boolean | number
    displayName?: boolean | number
    imageUrl?: boolean | number
    sku?: boolean | number
    lineOfBusinessId?: boolean | number
    listedChannels?: SalesChannelGenqlSelection
    appliedCosts?: ProductAppliedCostGenqlSelection
    dailySalesData?: (SalesChannelDailySalesDataGenqlSelection & { __args: {timeRange: ProductDataTimeRangeInput} })
    totalSold?: boolean | number
    avgCostPerUnit?: boolean | number
    price?: boolean | number
    canEditLatestAppliedCost?: boolean | number
    isFractional?: boolean | number
    isHidden?: boolean | number
    salesData?: (SalesDataGenqlSelection & { __args: {timeRange: ProductDataTimeRangeInput} })
    rawRecipes?: (RecipeGenqlSelection & { __args: {timeRange: ProductDataTimeRangeInput} })
    componentOfProducts?: ProductGenqlSelection
    analyticsOverview?: (ProductAnalyticsOverviewGenqlSelection & { __args?: {input?: (AnalyticsOverviewInput | null)} })
    warehousesAnalyticsOverview?: (ProductWarehousesAnalyticsOverviewGenqlSelection & { __args?: {input?: (AnalyticsOverviewInput | null)} })
    tags?: boolean | number
    isDataSyncing?: boolean | number
    mergeHistory?: ProductMergeHistoryItemGenqlSelection
    isDropshipping?: boolean | number
    on_AmazonProduct?: AmazonProductGenqlSelection
    on_MergedProduct?: MergedProductGenqlSelection
    on_ShopifyProduct?: ShopifyProductGenqlSelection
    on_TikTokProduct?: TikTokProductGenqlSelection
    on_UserManualProduct?: UserManualProductGenqlSelection
    on_WalmartProduct?: WalmartProductGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProductAnalyticsOverviewGenqlSelection{
    inTransit?: boolean | number
    incoming?: boolean | number
    netDepleted?: boolean | number
    onHand?: boolean | number
    costPerUnit?: boolean | number
    onHandCost?: boolean | number
    unavailable?: boolean | number
    openingBalanceCost?: boolean | number
    openingBalanceQuantity?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProductAppliedCostGenqlSelection{
    asOfDate?: boolean | number
    appliedCost?: boolean | number
    source?: boolean | number
    type?: boolean | number
    isLocked?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProductAppliedCostWithDepletedCountGenqlSelection{
    asOfDate?: boolean | number
    appliedCost?: boolean | number
    source?: boolean | number
    depletedCount?: boolean | number
    type?: boolean | number
    isLocked?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProductAssembliesBreakdownInput {companyId: Scalars['ID'],productId: Scalars['String'],date?: (Scalars['Date'] | null)}

export interface ProductAssembliesBreakdownResultGenqlSelection{
    manualAssemblies?: ManualAssemblyBreakdownGenqlSelection
    onDemandAssemblies?: OnDemandAssemblyBreakdownGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProductAutomergeMatchGroupSettingGenqlSelection{
    matchGroupType?: boolean | number
    isEnabled?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProductBulkEditCsvAttachmentGenqlSelection{
    id?: boolean | number
    companyId?: boolean | number
    filename?: boolean | number
    url?: boolean | number
    createdAt?: boolean | number
    deletedAt?: boolean | number
    summaryData?: ProductBulkEditCsvSummaryGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProductBulkEditCsvAttachmentsInput {companyId: Scalars['ID'],type: ProductBulkEditCsvAttachmentType,displayDeleted?: (Scalars['Boolean'] | null),managementMethodId: Scalars['ID']}

export interface ProductBulkEditCsvAttachmentsResponseGenqlSelection{
    attachments?: ProductBulkEditCsvAttachmentGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProductBulkEditCsvErrorItemGenqlSelection{
    rowNumber?: boolean | number
    cellNumber?: boolean | number
    errorType?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProductBulkEditCsvSummaryGenqlSelection{
    totalCount?: boolean | number
    validCount?: boolean | number
    invalidCount?: boolean | number
    errorCount?: boolean | number
    errorItems?: ProductBulkEditCsvErrorItemGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProductBulkEditCsvUploadResponseGenqlSelection{
    attachmentId?: boolean | number
    summaryData?: ProductBulkEditCsvSummaryGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProductDataTimeRangeInput {fromDate: Scalars['Date'],toDate: Scalars['Date']}

export interface ProductDeadInventoryAdjustmentGenqlSelection{
    id?: boolean | number
    finaloopProductId?: boolean | number
    date?: boolean | number
    unitsDeadInventory?: boolean | number
    warehouse?: WarehouseGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProductDeadInventoryAdjustmentsGenqlSelection{
    adjustments?: ProductDeadInventoryAdjustmentGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProductDonationAdjustmentGenqlSelection{
    finaloopProductId?: boolean | number
    date?: boolean | number
    unitsDonated?: boolean | number
    warehouse?: WarehouseGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProductDonationAdjustmentsGenqlSelection{
    adjustments?: ProductDonationAdjustmentGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProductGiveawayAdjustmentGenqlSelection{
    finaloopProductId?: boolean | number
    date?: boolean | number
    unitsGiveaway?: boolean | number
    warehouse?: WarehouseGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProductGiveawayAdjustmentsGenqlSelection{
    adjustments?: ProductGiveawayAdjustmentGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProductLineItemV3GenqlSelection{
    id?: boolean | number
    /** The ID of the line item in the external system */
    externalLineItemId?: boolean | number
    /** The name of the line item */
    name?: boolean | number
    /** The description of the line item */
    description?: boolean | number
    /** The amount of the line item */
    amount?: AmountsGenqlSelection
    parentId?: boolean | number
    /** The type of the line item */
    parentLineItemType?: boolean | number
    /** The earliest date and time the line item was posted */
    earliestPostedAt?: boolean | number
    /** The latest date and time the line item was posted */
    latestPostedAt?: boolean | number
    /** The statuses of the line item */
    statuses?: LineItemStatusesGenqlSelection
    fulfillments?: OrderLineItemFulfillmentV3GenqlSelection
    /** The timeline of the line item */
    timeline?: OrderLineItemTimelineV3GenqlSelection
    product?: ProductGenqlSelection
    /** The SKU of the product that the line item belongs to */
    sku?: boolean | number
    /** The ID of the product that the line item belongs to in the external system */
    externalProductId?: boolean | number
    /** The quantity of the line item */
    quantity?: boolean | number
    originalQuantity?: boolean | number
    /** The unit price of the line item */
    unitPrice?: boolean | number
    totalAmount?: boolean | number
    /** The type of the line item */
    type?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProductLostAndFoundAdjustmentGenqlSelection{
    finaloopProductId?: boolean | number
    date?: boolean | number
    unitsLost?: boolean | number
    unitsFound?: boolean | number
    warehouse?: WarehouseGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProductLostAndFoundAdjustmentsGenqlSelection{
    adjustments?: ProductLostAndFoundAdjustmentGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProductMergeHistoryItemGenqlSelection{
    from?: boolean | number
    to?: boolean | number
    product?: ProductGenqlSelection
    isPrimary?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProductMergeLogItemGenqlSelection{
    id?: boolean | number
    products?: ProductMergeLogItemProductGenqlSelection
    date?: boolean | number
    trigger?: boolean | number
    actor?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProductMergeLogItemProductGenqlSelection{
    product?: ProductGenqlSelection
    isPrimary?: boolean | number
    date?: boolean | number
    trigger?: boolean | number
    actor?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProductMergeRecommendationsGenqlSelection{
    matchGroups?: ProductMergeRecommendationsMatchGroupGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProductMergeRecommendationsMatchGroupGenqlSelection{
    id?: boolean | number
    type?: boolean | number
    mergeStartedAt?: boolean | number
    mergeFinishedAt?: boolean | number
    mergedCount?: boolean | number
    errorCount?: boolean | number
    totalCount?: boolean | number
    deletedCount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProductMergeRecommendationsProductGenqlSelection{
    product?: ProductGenqlSelection
    isPrimary?: boolean | number
    deletedAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProductMergeRecommendationsProductGroupGenqlSelection{
    id?: boolean | number
    deletedAt?: boolean | number
    products?: ProductMergeRecommendationsProductGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProductOtherFbaAdjustmentGenqlSelection{
    finaloopProductId?: boolean | number
    date?: boolean | number
    otherFbaIncoming?: boolean | number
    otherFba?: boolean | number
    warehouse?: WarehouseGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProductOtherFbaAdjustmentsGenqlSelection{
    adjustments?: ProductOtherFbaAdjustmentGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProductPendingAdjustmentsCountBreakdownInput {companyId: Scalars['ID'],managementMethodId: Scalars['String']}

export interface ProductPendingAdjustmentsCountBreakdownResponseGenqlSelection{
    salesAdjustmentsCount?: boolean | number
    deadInventoryAdjustmentsCount?: boolean | number
    giveawayAdjustmentsCount?: boolean | number
    giveawayDropshippingAdjustmentsCount?: boolean | number
    donationAdjustmentsCount?: boolean | number
    totalCount?: boolean | number
    salesAdjustmentsBreakdown?: SalesAdjustmentsBreakdownItemGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProductPurchasesGenqlSelection{
    purchaseOrder?: PurchaseOrderGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface Products2ResultGenqlSelection{
    products?: ProductGenqlSelection
    hasNext?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProductSalesDataAdjustmentGenqlSelection{
    salesChannel?: SalesChannelGenqlSelection
    date?: boolean | number
    unitsSold?: boolean | number
    unitsRestocked?: boolean | number
    warehouse?: WarehouseGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProductSalesDataAdjustmentsGenqlSelection{
    adjustments?: ProductSalesDataAdjustmentGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProductsOverviewInput {companyId: Scalars['ID'],splitByIsDropshipping?: (Scalars['Boolean'] | null),filter?: (GetProductsFilter | null)}

export interface ProductsOverviewResponseGenqlSelection{
    totalOnHandInventory?: boolean | number
    totalNegativeOnHand?: boolean | number
    productsWithoutCostCount?: boolean | number
    totalProducts?: boolean | number
    totalHidden?: boolean | number
    totalGeneral?: boolean | number
    totalDropshipping?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProductsResultGenqlSelection{
    totalProducts?: boolean | number
    productsWithoutCostCount?: boolean | number
    totalOnHandInventory?: boolean | number
    totalNegativeOnHand?: boolean | number
    totalHidden?: boolean | number
    products?: ProductGenqlSelection
    hasNext?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProductStatusChangeInput {productId: Scalars['String'],isHidden: Scalars['Boolean']}

export interface ProductsValidationDataGenqlSelection{
    skuData?: SkuValidationDataGenqlSelection
    ambiguousSkus?: NonMatchedSkuGenqlSelection
    unknownSkus?: NonMatchedSkuGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProductsValidationDataInput {companyId: Scalars['ID'],integrationType: Scalars['String'],integrationAccountId: Scalars['String'],isUIOperation: Scalars['Boolean'],timeRange: ProductDataTimeRangeInput}

export interface ProductTopPerformersFilter {companyId: Scalars['ID'],fromDate: Scalars['Date'],toDate: Scalars['Date'],breakdown: Scalars['String'],timezone: Scalars['String'],comparisonPeriod: Scalars['String'],stores?: ((Scalars['String'] | null)[] | null),source?: (SourceTypes | null),salesChannels?: ((Scalars['String'] | null)[] | null),limit?: (Scalars['Int'] | null),offset?: (Scalars['Int'] | null)}

export interface ProductTopPerformersResponseGenqlSelection{
    title?: boolean | number
    updatedAt?: boolean | number
    data?: DataSerieGenqlSelection
    labels?: boolean | number
    labelsIds?: boolean | number
    skus?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProductUnitCogsGenqlSelection{
    amount?: boolean | number
    quantity?: boolean | number
    monthlyBreakdown?: ProductUnitCogsMonthlyBreakdownGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProductUnitCogsDailyBreakdownGenqlSelection{
    date?: boolean | number
    quantity?: boolean | number
    reason?: AdjustmentsReasonGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProductUnitCogsMonthlyBreakdownGenqlSelection{
    date?: boolean | number
    quantity?: boolean | number
    dailyData?: ProductUnitCogsDailyBreakdownGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProductUnitsAdjustmentGenqlSelection{
    date?: boolean | number
    unitsIn?: boolean | number
    unitsOut?: boolean | number
    warehouse?: WarehouseGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProductUnitsAdjustmentsGenqlSelection{
    adjustments?: ProductUnitsAdjustmentGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProductV3GenqlSelection{
    id?: boolean | number
    integrationType?: boolean | number
    integrationAccountId?: boolean | number
    company?: CompanyGenqlSelection
    sku?: boolean | number
    price?: boolean | number
    title?: boolean | number
    source?: boolean | number
    imageUrl?: boolean | number
    displayName?: boolean | number
    platformId?: boolean | number
    parentPlatformId?: boolean | number
    amazonAsin?: boolean | number
    shopifyProductId?: boolean | number
    walmartItemId?: boolean | number
    isFractional?: boolean | number
    isBlacklisted?: boolean | number
    isMerged?: boolean | number
    isCreatedManually?: boolean | number
    isTrackingIntegrationCost?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProductWarehousesAnalyticsOverviewGenqlSelection{
    warehouse?: WarehouseGenqlSelection
    analytics?: ProductAnalyticsOverviewGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PublishValidationStatusUpdateInput {status: Scalars['String'],timestamp: Scalars['String'],companyId: Scalars['String'],companyName: Scalars['String'],validationType: Scalars['String'],yearEndValidationOf?: (Scalars['Float'] | null),integrationAccountId?: (Scalars['String'] | null),content?: (Scalars['String'] | null),linearIdentifiers: LinearIdentifiersInput}

export interface PurchaseBasedClosingBalanceGenqlSelection{
    missionType?: boolean | number
    status?: boolean | number
    historyLog?: InventoryYearEndHistoryLogGenqlSelection
    managementMethodPeriod?: ManagementMethodYearEndPeriodGenqlSelection
    openingBalance?: boolean | number
    purchases?: boolean | number
    cogs?: boolean | number
    closingBalance?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PurchaseBasedClosingBalanceInput {openingBalance: Scalars['Float'],purchases: Scalars['Float'],cogs: Scalars['Float'],closingBalance: Scalars['Float']}

export interface PurchaseBasedOpeningBalanceGenqlSelection{
    missionType?: boolean | number
    status?: boolean | number
    historyLog?: InventoryYearEndHistoryLogGenqlSelection
    managementMethodPeriod?: ManagementMethodYearEndPeriodGenqlSelection
    openingBalance?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PurchaseBasedOpeningBalanceInput {openingBalance: Scalars['Float']}

export interface PurchaseBasedPurchasesGenqlSelection{
    missionType?: boolean | number
    status?: boolean | number
    historyLog?: InventoryYearEndHistoryLogGenqlSelection
    managementMethodPeriod?: ManagementMethodYearEndPeriodGenqlSelection
    purchases?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PurchaseBasedPurchasesInput {purchases: Scalars['Float']}

export interface PurchasedOfferGenqlSelection{
    purchasedAt?: boolean | number
    tier?: boolean | number
    features?: boolean | number
    price?: boolean | number
    title?: boolean | number
    description?: boolean | number
    recurrence?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PurchaseOrderGenqlSelection{
    id?: boolean | number
    companyId?: boolean | number
    displayName?: boolean | number
    placementDate?: boolean | number
    inProgressDate?: boolean | number
    vendor?: VendorGenqlSelection
    directLineItems?: DirectLineItemGenqlSelection
    indirectLineItems?: IndirectLineItemGenqlSelection
    shipments?: ShipmentGenqlSelection
    directCostTotal?: boolean | number
    indirectCostTotal?: boolean | number
    landedCostTotal?: boolean | number
    landedCostBreakdown?: PurchaseOrderLandedCostBreakdownGenqlSelection
    discountCostTotal?: boolean | number
    status?: boolean | number
    publishedEventIds?: boolean | number
    deletedAt?: boolean | number
    isDeleted?: boolean | number
    serialNumber?: boolean | number
    notes?: boolean | number
    attachments?: PurchaseOrderAttachmentGenqlSelection
    inventoryPaymentGroupLinks?: InventoryPaymentGroupLinkGenqlSelection
    unpaidAmounts?: UnpaidAmountPerAffiliatedEntityGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PurchaseOrderAttachmentGenqlSelection{
    id?: boolean | number
    filename?: boolean | number
    url?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PurchaseOrderAttachmentInput {id?: (Scalars['String'] | null),filename: Scalars['String'],url: Scalars['String']}

export interface PurchaseOrderInput {id: Scalars['ID'],companyId: Scalars['ID'],displayName?: (Scalars['String'] | null),placementDate?: (Scalars['Date'] | null),vendorId: Scalars['ID'],directLineItems: DirectLineItemInput[],indirectLineItems: IndirectLineItemInput[],shipments: ShipmentInput[],directCostTotal: Scalars['Float'],indirectCostTotal: Scalars['Float'],landedCostTotal: Scalars['Float'],discountCostTotal: Scalars['Float'],inProgressDate?: (Scalars['Date'] | null),notes?: (Scalars['String'] | null),attachments: PurchaseOrderAttachmentInput[]}

export interface PurchaseOrderLandedCostBreakdownGenqlSelection{
    inTransit?: boolean | number
    inProcess?: boolean | number
    received?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PurchaseOrderOverviewGenqlSelection{
    status?: boolean | number
    landedCostTotal?: boolean | number
    totalPurchaseOrders?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PurchaseOrderOverviewV2GenqlSelection{
    maxLandedCostTotal?: boolean | number
    purchaseOrderOverview?: PurchaseOrderOverviewGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface QuantityAndCostGenqlSelection{
    quantity?: boolean | number
    cost?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface QueryGenqlSelection{
    /** @deprecated Use accrualsSpreadByEntityIDs instead */
    accrualsSpreadByTransactionIDs?: (AccrualsSpreadResponseGenqlSelection & { __args: {input: GetAccrualsSpreadInput} })
    /** @deprecated Use getAccrualsByEntityIDs instead */
    getAccrualsByTransactionIDs?: (AccrualGenqlSelection & { __args: {input: GetAccrualsByTransactionIDsInput} })
    getAccrualsByEntityIDs?: (AccrualV2GenqlSelection & { __args: {input: GetAccrualsByEntityIDsInput} })
    getAccrualsList?: (AccrualRecordResponseGenqlSelection & { __args: {input: GetAccrualsListInput} })
    exportAccrualsListCsv?: (ExportAccrualsListCsvResponseGenqlSelection & { __args: {input: ExportAccrualsListCsvInput} })
    adAccounts?: (AdAccountGenqlSelection & { __args: {input: AdAccountInput} })
    adCampaigns?: (AdCampaignGenqlSelection & { __args: {input: AdCampaignInput} })
    adSets?: (AdSetGenqlSelection & { __args: {input: AdSetInput} })
    balanceSheetSetup?: (BalanceSheetSetupGenqlSelection & { __args: {input: BalanceSheetSetupInput} })
    getBalanceSheetSetupItemDocumentUrl?: (GetBalanceSheetSetupItemDocumentUrlReponseGenqlSelection & { __args: {input: GetBalanceSheetSetupItemDocumentUrlInput} })
    reportedBusinessBankTransactionsAccount?: (BankAccountGenqlSelection & { __args: {input: ReportedBusinessBankTransactionsAccountInput} })
    bankAccountInternal?: (BankAccountGenqlSelection & { __args: {input: BankAccountInternalInput} })
    bankAccountsInternal?: (BankAccountGenqlSelection & { __args: {input: BankAccountsInternalInput} })
    institutionVendorsIds?: (InstitutionVendorIDGenqlSelection & { __args?: {vendorId?: (Scalars['ID'] | null)} })
    institutionMappings?: (InstitutionMappingResponseGenqlSelection & { __args?: {input?: (InstitutionMappingsInput | null)} })
    institutionById?: (InstitutionGenqlSelection & { __args: {id: Scalars['ID']} })
    bankStatementParsingRequest?: (BankStatementParsingRequestGenqlSelection & { __args: {input: GetBankStatementParsingRequestInput} })
    bankStatementParsingResults?: (BankStatementParsingResultGenqlSelection & { __args: {input: GetBankStatementParsingResultsInput} })
    backOfficeBankStatementRequests?: (GetBackOfficeBankStatementRequestsResponseGenqlSelection & { __args: {input: GetBackOfficeBankStatementRequestsInput} })
    backOfficeBankStatementRequestsFilters?: BackOfficeBankStatementRequestsFiltersResponseGenqlSelection
    bankReconciliationStatementFiles?: (ReconciliationRequestStatementFileGenqlSelection & { __args: {input: GetBankAccountStatementFilesInput} })
    bankReconciliationRequestsSettings?: (BankReconciliationRequestSettingsResponseGenqlSelection & { __args: {input: BankReconciliationRequestSettingsInput} })
    companyHasBankingMission?: (BankingMissionResultGenqlSelection & { __args: {input: CompanyHasBankingMissionInput} })
    isDomainBanksEnabledForBalanceSheetSetup?: { __args: {input: BalanceSheetSetupInput} }
    evaluateBankReconciliationRequestsDryRun?: (EvaluateBankReconciliationRequestsResponseGenqlSelection & { __args: {input: EvaluateBankReconciliationRequestsInput} })
    explainBankAccountMerge?: (ExplainBankAccountMergeResponseGenqlSelection & { __args: {input: ExplainBankAccountMergeInput} })
    bankingAudits?: (BankingAuditGenqlSelection & { __args: {input: BankingAuditsInput} })
    bankStatementFileById?: (BankStatementFileGenqlSelection & { __args: {input: BankStatementFileByIdInput} })
    bankStatementFilesByCompanyId?: (BankStatementFileGenqlSelection & { __args: {input: BankStatementFileByCompanyIdInput} })
    bankStatementFiles?: (BankStatementFileGenqlSelection & { __args: {input: BankStatementFilesInput} })
    bankAccount?: (BankAccountGenqlSelection & { __args: {input: BankAccountInput} })
    bankAccounts?: (BankAccountGenqlSelection & { __args: {input: BankAccountsInput} })
    bankAccountsByIds?: (BankAccountGenqlSelection & { __args: {input: BankAccountsByIdsInput} })
    bankAccountReconciliations?: (BankAccountReconciliationGenqlSelection & { __args: {input: BankAccountReconciliationsInput} })
    bankAccountBalance?: { __args: {input: BankAccountBalanceInput} }
    institutions?: (InstitutionsResponseGenqlSelection & { __args?: {input?: (InstitutionsInput | null)} })
    bankReconciliationRequest?: (BankReconciliationRequestGenqlSelection & { __args: {input: BankReconciliationRequestInput} })
    bankReconciliationRequests?: (BankReconciliationRequestGenqlSelection & { __args: {input: BankReconciliationRequestsInput} })
    bankConnections?: (BankConnectionGenqlSelection & { __args: {input: BankConnectionsInput} })
    bankOverviewPageAccounts?: (BankOverviewPageAccountGenqlSelection & { __args: {input: BankOverviewPageInput} })
    bankConnectionMetrics?: (BankingMetricGenqlSelection & { __args: {input: BankConnectionMetricsInput} })
    bankReconciliationGraphPoints?: (BankReconciliationGraphPointGenqlSelection & { __args: {input: BankReconciliationGraphPointsInput} })
    bankTransaction?: (BankTransactionGenqlSelection & { __args: {getBankTransactionInput: BankTransactionInput} })
    bankTransactions?: (BankTransactionResponseGenqlSelection & { __args: {input: BankTransactionsInput} })
    bankTransactionsByMerchant?: (BankTransactionByMerchantResultGenqlSelection & { __args: {bankTransactionsByMerchantInput: BankTransactionsByMerchantInput} })
    searchMerchants?: (MerchantGenqlSelection & { __args: {input: SearchMerchantsInput} })
    merchantBankTransactionRecommendations?: (BankTransactionRecommendationGenqlSelection & { __args: {input: MerchantBankTransactionRecommendationsInput} })
    searchVendorsTransactionsPriority?: (SearchVendorsTransactionsPriorityResultGenqlSelection & { __args: {input: SearchVendorsTransactionPriorityInput} })
    classificationTags?: (ClassificationTagGenqlSelection & { __args?: {input?: (ClassificationTagsInput | null)} })
    classificationTagsByIds?: (ClassificationTagGenqlSelection & { __args: {input: ClassificationTagsByIdsInput} })
    internalTransferCandidates?: (BankTransactionResponseGenqlSelection & { __args: {input: InternalTransferCandidatesInput} })
    internalTransferCandidatesV2?: (BankTransactionsResponseGenqlSelection & { __args: {input: internalTransferCandidatesV2Input} })
    unidentifiedBankTransactionsGroups?: (UnidentifiedBankTransactionsGroupGenqlSelection & { __args: {input: UnidentifiedBankTransactionsGroupsInput} })
    merchantsBankTransactionStats?: (MerchantsBankTransactionStatsGenqlSelection & { __args: {input: MerchantsBankTransactionStatsInput} })
    bankTransactionsSummary?: (BankTransactionsSummaryGenqlSelection & { __args: {input: BankTransactionsInput} })
    merchantsByIds?: (MerchantGenqlSelection & { __args: {input: MerchantsByIdsInput} })
    suggestBankTransactionClassification?: (ClassificationTagSuggestionsResponseGenqlSelection & { __args: {input: SuggestBankTransactionClassificationInput} })
    lastMachineClassificationJob?: (MachineClassificationJobGenqlSelection & { __args: {input: MachineClassificationInput} })
    convertBetweenCurrencies?: (ConvertBetweenCurrenciesResultGenqlSelection & { __args: {input: ConvertBetweenCurrenciesInput} })
    merchantsByKeys?: (MerchantGenqlSelection & { __args: {input: MerchantsByKeysInput} })
    bankTransactionsByPairings?: (BankTransactionPairingResultGenqlSelection & { __args: {input: BankTransactionsByPairingsInput} })
    isGlobalRuleExistByVendorAndMoneyDirection?: (IsGlobalRuleExistResultGenqlSelection & { __args: {input: GlobalRuleExistByVendorAndMoneyDirectionInput} })
    paypalTransactionCurrencies?: { __args: {input: PaypalTransactionCurrenciesInput} }
    bankTransactionUploadFileById?: (BankTransactionsUploadGenqlSelection & { __args: {input: BankTransactionsUploadFileInput} })
    companyByStripeCustomerId?: (CompanyGenqlSelection & { __args: {args: CompanyByStripeCustomerIdInput} })
    stripeCustomerIdsByCompanyIds?: (StripeCustomerIdsResponseGenqlSelection & { __args: {args: StripeCustomerIdsByCompanyIdsInput} })
    offers?: (GetOffersResponseGenqlSelection & { __args: {args: GetOffersInput} })
    billsByIds?: (BillGenqlSelection & { __args: {input: Scalars['ID'][]} })
    bill?: (BillGenqlSelection & { __args: {input: BillInput} })
    billsDueDateSummary?: (BillsDueDateSummaryGenqlSelection & { __args: {input: BillsDueDateSummaryInput} })
    processBillContent?: (ProcessBillContentResultGenqlSelection & { __args: {input: ProcessBillContentInput} })
    bills?: (GetBillsResponseGenqlSelection & { __args: {input: GetBillsInput} })
    billsAgingReportCSV?: (AwaitedExportResponseGenqlSelection & { __args: {args: BillsAgingReportInput} })
    billsYearEndTasks?: (BillsYearEndTasksResponseGenqlSelection & { __args: {input: BillsYearEndTasksInput} })
    businessEventDefinitions?: BusinessEventDefinitionGenqlSelection
    businessEventDefinitionsByIds?: (BusinessEventDefinitionGenqlSelection & { __args: {input: BusinessEventDefinitionsByIds} })
    businessEventDefinitionsByGroups?: (BusinessEventDefinitionGenqlSelection & { __args: {input: BusinessEventDefinitionsByGroups} })
    businessEventActionsConfigurations?: BusinessEventActionsConfigurationGenqlSelection
    businessEventActionsConfigurationByType?: (BusinessEventActionsConfigurationGenqlSelection & { __args: {input: BusinessEventActionsConfigurationByType} })
    accountRoles?: AccountRoleGenqlSelection
    classificationBusinessEventDefinitions?: BusinessEventDefinitionGenqlSelection
    /** @deprecated Use getBusinessEventsAccrualsConfig instead */
    businessEventsAccrualsConfig?: BusinessEventsAccrualsConfigGenqlSelection
    getBusinessEventsAccrualsConfig?: (BusinessEventsAccrualsConfigV2GenqlSelection & { __args: {input: GetBusinessEventsAccrualsConfigInput} })
    accountRole?: (AccountRoleGenqlSelection & { __args: {input: GetAccountRoleInput} })
    businessEvents?: (BusinessEventActionsConfigurationGenqlSelection & { __args: {input: GetBusinessEventInput[]} })
    company?: (CompanyGenqlSelection & { __args: {args: GetCompanyInput} })
    getCompanyAddresses?: (CompanyAddressGenqlSelection & { __args: {input: CompanyIdInput} })
    getCompanyDefaultAddress?: (CompanyAddressGenqlSelection & { __args: {input: CompanyIdInput} })
    signedDownloadUrl?: { __args: {args: SignedDownloadUrlInput} }
    onboardingStatus?: (OnboardingStatusGenqlSelection & { __args: {input: GetOnboardingStatusInput} })
    listCompanies?: (CompanyGenqlSelection & { __args?: {args?: (ListCompaniesInput | null)} })
    getCompanies?: (CompanyGenqlSelection & { __args?: {args?: (GetCompaniesInput | null)} })
    getCompaniesByIds?: (CompanyGenqlSelection & { __args: {args: GetCompaniesByIdsInput} })
    healthStatus?: (CompanyHealthStatusGenqlSelection & { __args: {input: GetHealthStatusInput} })
    getLatestValidation?: (GetLatestValidationResultGenqlSelection & { __args: {input: GetLatestValidationInput} })
    validationTemplates?: (ValidationTemplateGenqlSelection & { __args: {input: GetValidationTemplatesInput} })
    failingValidationsByValidationCycle?: (FailingValidationGenqlSelection & { __args: {input: GetFailingValidationsByValidationCycleInput} })
    failingValidationsByValidationTemplate?: (FailingValidationGenqlSelection & { __args: {input: GetFailingValidationsByValidationTemplateInput} })
    getEntitiesLockedPeriodBypasses?: (EntityLockedPeriodBypassGenqlSelection & { __args: {args: GetEntitiesLockedPeriodBypassesInput} })
    listReadyValidations?: (ReadyValidationGenqlSelection & { __args: {input: ListReadyValidationsInput} })
    getReadyValidation?: (GetReadyValidationResponseGenqlSelection & { __args: {input: GetReadyValidationInput} })
    companyMainHolder?: (CompanyAffiliateGenqlSelection & { __args: {input: CompanyMainHolderInput} })
    companyAffiliatesByIds?: (CompanyAffiliateGenqlSelection & { __args: {input: CompanyAffiliatesByIdsInput} })
    holderTransactionsByIds?: (HolderTransactionGenqlSelection & { __args: {input: HolderTransactionsByIdsInput} })
    holderSharesByIds?: (HolderShareGenqlSelection & { __args: {input: HolderSharesByIdsInput} })
    holderCapitalInvestmentsByIds?: (HolderCapitalInvestmentGenqlSelection & { __args: {input: HolderCapitalInvestmentsByIdsInput} })
    holderSafeInvestmentsByIds?: (HolderSafeInvestmentGenqlSelection & { __args: {input: HolderSafeInvestmentsByIdsInput} })
    equityEventsEffectConfigurations?: (EquityEventsEffectConfigurationGenqlSelection & { __args: {input: EquityEventsEffectConfigurationsInput} })
    manualEquityEvents?: (ManualEquityEntityGenqlSelection & { __args: {input: ManualEquityEventsInput} })
    affiliatedEntityByIds?: (AffiliatedEntityGenqlSelection & { __args: {input: AffiliatedEntityByIdsInput} })
    companyAffiliates?: (CompanyAffiliateGenqlSelection & { __args: {input: CompanyAffiliatesInput} })
    companyAffiliate?: (CompanyAffiliateGenqlSelection & { __args: {input: CompanyAffiliateInput} })
    holderShares?: (HolderShareGenqlSelection & { __args: {input: HolderSharesInput} })
    holderCapitalInvestments?: (HolderCapitalInvestmentGenqlSelection & { __args: {input: HolderCapitalInvestmentsInput} })
    holderTransactions?: (HolderTransactionGenqlSelection & { __args: {input: HolderTransactionsInput} })
    affiliatedEntityById?: (AffiliatedEntityGenqlSelection & { __args: {input: AffiliatedEntityByIdInput} })
    companyIntegration?: (CompanyIntegrationGenqlSelection & { __args: {input: CompanyIntegrationInput} })
    companyIntegrations?: (CompanyIntegrationGenqlSelection & { __args: {input: CompanyIntegrationsInput} })
    closingBalancesByIds?: (ClosingBalanceGenqlSelection & { __args: {input: GetClosingBalancesByIdsInput} })
    payrollConnections?: (PayrollConnectionGenqlSelection & { __args: {input: PayrollConnectionsInput} })
    integrationConnectionAccounts?: (IntegrationConnectionAccountGenqlSelection & { __args: {input: IntegrationConnectionsFilter} })
    integrationTransfersByCompanyAffiliate?: (IntegrationTransferGenqlSelection & { __args: {input: IntegrationTransfersByCompanyAffiliateInput} })
    integrationTransfersBackoffice?: (IntegrationTransferGenqlSelection & { __args: {input: GetIntegrationTransfersBackofficeInput} })
    integrationTransfer?: (IntegrationTransferGenqlSelection & { __args: {input: GetIntegrationTransferInput} })
    integrationTransfers?: (IntegrationTransferGenqlSelection & { __args: {input: GetIntegrationTransfersInput} })
    groupedIntegrationTransfers?: (IntegrationTransferGroupGenqlSelection & { __args: {input: GetIntegrationTransfersInput} })
    finaloopProductInternal?: (FinaloopProductGenqlSelection & { __args: {input: FinaloopProductInternalInput} })
    inventoryPurchasesForCompany?: (InventoryPurchaseGenqlSelection & { __args: {input: GetInventoryPurchasesForCompanyInput} })
    inventoryPurchasesByIds?: (InventoryPurchaseGenqlSelection & { __args: {input: GetInventoryPurchasesByIdsInput} })
    runAmazonProductsValidationDiagnostics?: (RunProductsValidationDiagnosticsResponseGenqlSelection & { __args: {input: RunProductsValidationDiagnosticsInput} })
    runShopifyProductsValidationDiagnostics?: (RunProductsValidationDiagnosticsResponseGenqlSelection & { __args: {input: RunProductsValidationDiagnosticsInput} })
    getCOGSBreakdown2?: (GetCOGSBreakdownResponseGenqlSelection & { __args: {input: GetCOGSBreakdownRequest} })
    exportCOGSBreakdown?: (ExportCOGSBreakdownResponseGenqlSelection & { __args: {input: ExportCOGSBreakdownRequest} })
    getCOGSOverview2?: (GetCOGSOverviewResponseGenqlSelection & { __args: {input: GetCOGSOverviewRequest} })
    exportCOGSOverview?: (ExportCOGSOverviewResponseGenqlSelection & { __args: {input: ExportCOGSOverviewRequest} })
    product?: (ProductGenqlSelection & { __args: {input: GetProductInput} })
    productAssembliesInventoryBreakdown?: (ProductAssembliesBreakdownResultGenqlSelection & { __args: {input: ProductAssembliesBreakdownInput} })
    productsCsv?: (ExportProductsResponseGenqlSelection & { __args: {input: GetProductsInput} })
    products2?: (Products2ResultGenqlSelection & { __args: {input: GetProductsInput} })
    productsOverview?: (ProductsOverviewResponseGenqlSelection & { __args: {input: ProductsOverviewInput} })
    salesChannels?: (SalesChannelGenqlSelection & { __args: {input: SalesChannelsInput} })
    currentlyRunningInventoryDataSync?: (CurrentlyRunningInventoryDataSyncResponseGenqlSelection & { __args: {input: CurrentlyRunningInventoryDataSyncInput} })
    currentlyRunningInventoryDataSyncVendors?: (CurrentlyRunningInventoryDataSyncVendorsResponseGenqlSelection & { __args: {input: CurrentlyRunningInventoryDataSyncInput} })
    inventoryAccountBalance?: (GetInventoryAccountBalanceResponseGenqlSelection & { __args: {input: GetInventoryAccountBalanceInput} })
    getOnboardingStatuses?: (OnboardingStatusesGenqlSelection & { __args: {input: GetOnboardingStatusesInput} })
    nonMatchedProducts?: (NonMatchingProductsResponseGenqlSelection & { __args: {input: GetNonMatchingProductsInput} })
    getFromEmailAddress?: (GetFromEmailAddressResultGenqlSelection & { __args: {input: GetFromEmailAddressInput} })
    productBulkEditCsvAttachments?: (ProductBulkEditCsvAttachmentsResponseGenqlSelection & { __args: {input: ProductBulkEditCsvAttachmentsInput} })
    listOnDemandAssemblyCosts?: (OnDemandAssemblyCostsResultGenqlSelection & { __args: {input: ListAssemblyCostsInput} })
    listOnDemandAssemblyVendorCosts?: (OnDemandAssemblyVendorCostsResultGenqlSelection & { __args: {input: ListAssemblyCostsInput} })
    listManualAssemblies?: (ListManualAssembliesResultGenqlSelection & { __args: {input: ListAssemblyCostsInput} })
    listAssemblies?: (ListAssembliesResultGenqlSelection & { __args: {input: ListAssembliesInput} })
    listAssemblyItems?: (ListAssemblyItemsResultGenqlSelection & { __args: {input: ListAssemblyItemsInput} })
    missingCostsInPeriod?: (MissingCostsInPeriodResponseGenqlSelection & { __args: {input: MissingCostsInPeriodInput} })
    dropshippingSettings?: (DropshippingSettingsGenqlSelection & { __args: {input: DropshippingSettingsInput} })
    purchaseOrder?: (PurchaseOrderGenqlSelection & { __args: {input: GetPurchaseOrderInput} })
    purchaseOrdersV2?: (PurchaseOrderGenqlSelection & { __args: {input: GetPurchaseOrdersInput} })
    purchaseOrdersV2Total?: { __args: {input: GetPurchaseOrdersInput} }
    purchaseOrdersOverviewV2?: (PurchaseOrderOverviewV2GenqlSelection & { __args: {input: GetPurchaseOrdersOverviewInput} })
    exportPurchaseOrders?: (ExportPurchaseOrdersResponseGenqlSelection & { __args: {input: ExportPurchaseOrdersInput} })
    inventoryPurchases?: (InventoryPurchasesResponseGenqlSelection & { __args: {input: GetInventoryPurchasesInput} })
    inventoryPurchasesExport?: (InventoryPurchasesExportResponseGenqlSelection & { __args: {input: GetInventoryPurchasesExportInput} })
    inventoryPurchasesSummary?: (InventoryPurchasesSummaryResponseGenqlSelection & { __args: {input: GetInventoryPurchaseSummaryInput} })
    inventoryPurchaseRules?: (InventoryPurchaseRulesResponseGenqlSelection & { __args: {input: GetInventoryPurchaseRulesInput} })
    isPaymentGroupLinkExist?: { __args: {input: IsPaymentGroupLinkExistInput} }
    inventoryPurchaseVendors?: (InventoryPurchaseVendorsResponseGenqlSelection & { __args: {input: GetInventoryPurchaseVendorsInput} })
    inventoryPurchasesCountByVendor?: (InventoryPurchasesCountByVendorResponseGenqlSelection & { __args: {input: GetInventoryPurchasesCountByVendorInput} })
    inventoryOverviewCycles?: (OverviewCycleGenqlSelection & { __args: {input: OverviewCyclesInput} })
    shopifyProductsValidationConnections?: (ShopifyProductsValidationConnectionsResponseGenqlSelection & { __args: {input: ShopifyProductsValidationConnectionsInput} })
    shopifyItemsReconciliation?: (ShopifyProductsValidationResponseGenqlSelection & { __args: {input: ShopifyItemsReconciliationInput} })
    shopifyItemsReconciliationOrders?: (ShopifyItemsReconciliationOrdersResponseGenqlSelection & { __args: {input: ShopifyItemsReconciliationOrdersInput} })
    shopifyItemsReconciliationOrdersDiff?: (ShopifyItemsReconciliationOrdersDiffResultGenqlSelection & { __args: {input: ShopifyItemsReconciliationOrdersDiffInput} })
    amazonProductsReconciliation?: (AmazonProductsReconciliationResponseGenqlSelection & { __args: {input: AmazonValidationInput} })
    amazonAvailableValidationData?: (AmazonAvailableValidationDataResponseGenqlSelection & { __args: {input: AmazonAvailableValidationDataInput} })
    amazonOrdersDiff?: (AmazonOrdersDiffResponseGenqlSelection & { __args: {input: AmazonValidationInput} })
    amazonCustomerShipmentReportLink?: (ReportGenqlSelection & { __args: {input: AmazonValidationInput} })
    amazonLedgerReportLink?: (ReportGenqlSelection & { __args: {input: AmazonValidationInput} })
    amazonCustomerReturnsReportLink?: (ReportGenqlSelection & { __args: {input: AmazonValidationInput} })
    listValidationRemediations?: (ValidationRemediationsResponseGenqlSelection & { __args: {input: ListValidationRemediationsInput} })
    inventoryVendorsOverview?: (InventoryVendorsOverviewResponseGenqlSelection & { __args: {input: GetInventoryVendorsOverviewInput} })
    inventoryVendors?: (InventoryVendorsResponseGenqlSelection & { __args: {input: GetInventoryVendorsInput} })
    inventoryVendorRollingBalance?: (InventoryVendorRollingBalanceResponseGenqlSelection & { __args: {input: GetInventoryVendorRollingBalanceInput} })
    inventoryVendorRollingBalanceOverview?: (InventoryVendorRollingBalanceOverviewResponseGenqlSelection & { __args: {input: GetInventoryVendorRollingBalanceOverviewInput} })
    inventoryVendorBills?: (InventoryVendorBillsResponseGenqlSelection & { __args: {input: GetInventoryVendorBillsInput} })
    inventoryVendorBillsOverview?: (InventoryVendorBillsOverviewResponseGenqlSelection & { __args: {input: GetInventoryVendorBillsOverviewInput} })
    inventoryVendorFilterValues?: (InventoryVendorFilterValuesResponseGenqlSelection & { __args: {input: GetInventoryVendorFilterValuesInput} })
    inventoryVendorParams?: (InventoryVendorParamsResponseGenqlSelection & { __args: {input: GetInventoryVendorParamsInput} })
    warehouseOpeningBalanceOverview?: (WarehouseOpeningBalanceOverviewResponseGenqlSelection & { __args: {input: GetWarehouseOpeningBalanceOverviewInput} })
    warehouseOpeningBalances?: (WarehouseOpeningBalancesResponseGenqlSelection & { __args: {input: GetWarehouseOpeningBalancesInput} })
    pendingWarehouseOpeningBalancesAttachments?: (PendingWarehouseOpeningBalanceAttachmentGenqlSelection & { __args: {input: GetPendingWarehouseOpeningBalancesAttachmentsInput} })
    getWarehouseOpeningBalancesCsvTemplate?: (WarehouseOpeningBalancesCsvTemplateResponseGenqlSelection & { __args: {input: GetWarehouseOpeningBalanceOverviewInput} })
    exportWarehouseOpeningBalancesCsv?: (WarehouseOpeningBalancesCsvResponseGenqlSelection & { __args: {input: ExportWarehouseOpeningBalancesCsvInput} })
    warehouseTransfersOverview?: (WarehouseTransfersOverviewGenqlSelection & { __args: {input: CommonWarehouseTransfersFilterInput} })
    warehouseTransfers?: (WarehouseTransfersResponseGenqlSelection & { __args: {input: GetWarehouseTransfersInput} })
    warehouseTransfer?: (WarehouseTransferGenqlSelection & { __args: {input: GetWarehouseTransferInput} })
    pendingSalesDataAdjustmentsV2?: (PendingSalesDataAdjustmentsResponseGenqlSelection & { __args: {input: GetPendingSalesDataAdjustmentsInputV2} })
    pendingSalesDataAdjustmentsByIds?: (PendingSalesDataAdjustmentsByIdsResponseGenqlSelection & { __args: {input: GetPendingAdjustmentsByIdsInput} })
    pendingDeadInventoryAdjustments?: (PendingDeadInventoryAdjustmentsResponseGenqlSelection & { __args: {input: GetPendingAdjustmentsInput} })
    pendingDeadInventoryAdjustmentsByIds?: (PendingDeadInventoryAdjustmentsByIdsResponseGenqlSelection & { __args: {input: GetPendingAdjustmentsByIdsInput} })
    pendingGiveawayAdjustments?: (PendingGiveawayAdjustmentsResponseGenqlSelection & { __args: {input: GetPendingAdjustmentsInput} })
    pendingGiveawayAdjustmentsByIds?: (PendingGiveawayAdjustmentsByIdsResponseGenqlSelection & { __args: {input: GetPendingAdjustmentsByIdsInput} })
    pendingGiveawayDropshippingAdjustments?: (PendingGiveawayDropshippingAdjustmentsResponseGenqlSelection & { __args: {input: GetPendingAdjustmentsInput} })
    pendingGiveawayDropshippingAdjustmentsByIds?: (PendingGiveawayAdjustmentsByIdsResponseGenqlSelection & { __args: {input: GetPendingAdjustmentsByIdsInput} })
    pendingDonationAdjustments?: (PendingDonationAdjustmentsResponseGenqlSelection & { __args: {input: GetPendingAdjustmentsInput} })
    pendingDonationAdjustmentsByIds?: (PendingDonationAdjustmentsByIdsResponseGenqlSelection & { __args: {input: GetPendingAdjustmentsByIdsInput} })
    pendingSalesDataAdjustmentsOverviewV2?: (PendingAdjustmentsOverviewResponseGenqlSelection & { __args: {input: GetPendingSalesDataAdjustmentsOverviewInputV2} })
    pendingDeadInventoryAdjustmentsOverview?: (PendingAdjustmentsOverviewResponseGenqlSelection & { __args: {input: GetPendingAdjustmentsOverviewInput} })
    pendingGiveawayAdjustmentsOverview?: (PendingAdjustmentsOverviewResponseGenqlSelection & { __args: {input: GetPendingAdjustmentsOverviewInput} })
    pendingGiveawayDropshippingAdjustmentsOverview?: (PendingAdjustmentsOverviewResponseGenqlSelection & { __args: {input: GetPendingAdjustmentsOverviewInput} })
    pendingDonationAdjustmentsOverview?: (PendingAdjustmentsOverviewResponseGenqlSelection & { __args: {input: GetPendingAdjustmentsOverviewInput} })
    productBulkAdjustmentStatus?: (GetProductBulkAdjustmentStatusGenqlSelection & { __args: {input: GetProductBulkAdjustmentStatusInput} })
    salesAdjustmentsCsvTemplate?: (BulkEditCsvTemplateResponseGenqlSelection & { __args: {input: BulkEditCsvTemplateInput} })
    deadInventoryAdjustmentsCsvTemplate?: (BulkEditCsvTemplateResponseGenqlSelection & { __args: {input: BulkEditCsvTemplateInput} })
    giveawayAdjustmentsCsvTemplate?: (BulkEditCsvTemplateResponseGenqlSelection & { __args: {input: BulkEditCsvTemplateInput} })
    donationAdjustmentsCsvTemplate?: (BulkEditCsvTemplateResponseGenqlSelection & { __args: {input: BulkEditCsvTemplateInput} })
    productPendingAdjustmentsCountBreakdown?: (ProductPendingAdjustmentsCountBreakdownResponseGenqlSelection & { __args: {input: ProductPendingAdjustmentsCountBreakdownInput} })
    listNoUnitsPhysicalCounts?: (NoUnitsPhysicalCountsListGenqlSelection & { __args: {input: ListNoUnitsPhysicalCountsInput} })
    noUnitsPhysicalCount?: (NoUnitsPhysicalCountGenqlSelection & { __args: {input: GetNoUnitsPhysicalCountInput} })
    noUnitsPhysicalCountProductQuantities?: (NoUnitsPhysicalCountProductQuantitiesGenqlSelection & { __args: {input: GetNoUnitsPhysicalCountProductQuantitiesInput} })
    exportNoUnitsTrackingPhysicalCountProductQuantities?: (ExportCSVResponseGenqlSelection & { __args: {input: ExportNoUnitsTrackingPhysicalCountProductQuantitiesInput} })
    noUnitsPhysicalCountOverview?: (NoUnitsPhysicalCountOverviewGenqlSelection & { __args: {input: GetNoUnitsPhysicalCountOverviewInput} })
    getNoUnitsPhysicalCountClosingBalance?: (NoUnitsPhysicalCountClosingBalanceResultGenqlSelection & { __args: {input: GetNoUnitsPhysicalCountClosingBalanceInput} })
    getNoUnitsPhysicalCountAnyActiveProductsWithoutQuantities?: (AnyActiveProductWithoutQuantitiesGenqlSelection & { __args: {input: GetNoUnitsPhysicalCountAnyActiveProductsWithoutQuantitiesInput} })
    listUnitsTrackingPhysicalCounts?: (UnitsTrackingPhysicalCountsListGenqlSelection & { __args: {input: ListUnitsTrackingPhysicalCountsInput} })
    unitsTrackingPhysicalCount?: (UnitsTrackingPhysicalCountGenqlSelection & { __args: {input: GetUnitsTrackingPhysicalCountInput} })
    unitsTrackingPhysicalCountProductQuantities?: (UnitsTrackingPhysicalCountProductQuantitiesGenqlSelection & { __args: {input: GetUnitsTrackingPhysicalCountProductQuantitiesInput} })
    exportUnitsTrackingPhysicalCountProductQuantities?: (ExportCSVResponseGenqlSelection & { __args: {input: ExportUnitsTrackingPhysicalCountProductQuantitiesInput} })
    unitsTrackingPhysicalCountOverview?: (UnitsTrackingPhysicalCountOverviewGenqlSelection & { __args: {input: GetUnitsTrackingPhysicalCountOverviewInput} })
    physicalCountCsvTemplate?: (BulkEditCsvTemplateResponseGenqlSelection & { __args: {input: BulkEditCsvTemplateInput} })
    hasUnacknowledgedChanges?: { __args: {input: HasUnacknowledgedChangesInput} }
    warehouses?: (WarehouseResultGenqlSelection & { __args: {input: GetWarehousesInput} })
    warehouseDefaults?: (WarehousesDefaultsResultGenqlSelection & { __args: {input: GetWarehousesDefaultsInput} })
    inventoryPaymentGroupById?: (InventoryPaymentGroupByIdResponseGenqlSelection & { __args: {input: InventoryPaymentGroupByIdInput} })
    inventoryPaymentGroupsByIds?: (InventoryPaymentGroupsByIdsResponseGenqlSelection & { __args: {input: InventoryPaymentGroupsByIdsInput} })
    validateInventoryPaymentGroupByEntity?: (ValidateInventoryPaymentGroupByEntityResponseGenqlSelection & { __args: {input: ValidateInventoryPaymentGroupByEntityInput} })
    inventoryYearEndMissions?: (InventoryYearEndMissionsResponseGenqlSelection & { __args: {input: InventoryYearEndMissionsInput} })
    explainFifo?: (ExplainFifoResultGenqlSelection & { __args: {input: ExplainFifoInput} })
    warehouseIncomingInventoryOverview?: (WarehouseIncomingInventoryOverviewResultGenqlSelection & { __args: {input: WarehouseIncomingInventoryOverviewInput} })
    warehouseIncomingInventoryBreakdown?: (WarehouseIncomingInventoryBreakdownResultGenqlSelection & { __args: {input: WarehouseIncomingInventoryBreakdownInput} })
    productMergeRecommendationsMatchGroup?: (GetProductMergeRecommendationsMatchGroupResponseGenqlSelection & { __args: {input: GetProductMergeRecommendationsMatchGroupInput} })
    productMergeLogs?: (GetProductMergeLogsResponseGenqlSelection & { __args: {input: GetProductMergeLogsInput} })
    productMergeLogsOverview?: (GetProductMergeLogsOverviewResponseGenqlSelection & { __args: {input: GetProductMergeLogsOverviewInput} })
    productAutomergeSettings?: (GetProductAutomergeSettingsResponseGenqlSelection & { __args: {input: GetProductAutomergeSettingsInput} })
    hasProductMergeRecommendations?: (HasProductMergeRecommendationsResponseGenqlSelection & { __args: {input: HasProductMergeRecommendationsInput} })
    productMergeRecommendations?: (ProductMergeRecommendationsGenqlSelection & { __args: {input: GenerateProductMergeRecommendationsInput} })
    loans?: (LoansResponseGenqlSelection & { __args: {input: GetLoansInput} })
    getMatchingEffectRule?: (GetMatchingEffectRuleResultGenqlSelection & { __args: {input: GetMatchingEffectRuleInput} })
    loansEventsEffectConfiguration?: LoansEventsEffectConfigurationGenqlSelection
    getLoansById?: (LoansByIdsResponseGenqlSelection & { __args: {input: GetLoansByIdInput} })
    exportLoans?: (ExportLoansResultGenqlSelection & { __args: {input: ExportLoansCsvInput} })
    getLoanEvents?: (GetLoanEventsResultGenqlSelection & { __args: {input: GetLoanEventsInput} })
    getLoanRelationships?: (GetLoanRelationshipsResultGenqlSelection & { __args: {input: GetLoanEventsInput} })
    getAllocatableEventIds?: (GetAllocatableEventIdsResultGenqlSelection & { __args: {input: GetAllocatableEventIdsInput} })
    getLoanEventsLength?: (GetLoanEventsLengthResultGenqlSelection & { __args: {input: GetLoanEventsLengthInput} })
    loanEventDefinitions?: LoanEventDefinitionGenqlSelection
    getLoansUpdatedBy?: boolean | number
    knownLenders?: NewLenderGenqlSelection
    companyLoans?: (CompanyLoansResponseGenqlSelection & { __args: {input: GetCompanyLoansInput} })
    companyLoan?: (CompanyLoanResponseGenqlSelection & { __args: {input: GetCompanyLoanInput} })
    getAttachmentTargetURLS?: (AttachmentTargetURLSGenqlSelection & { __args: {input: GetAttachmentTargetURLSInput} })
    downloadAttachment?: (DownloadAttachmentResultGenqlSelection & { __args: {input: DownloadAttachmentInput} })
    getLoansOutstandingAmountOnDate?: (GetLoansOutstandingAmountOnDateResultGenqlSelection & { __args: {input: GetLoansOutstandingAmountOnDateInput} })
    getLoanTransactionStatuses?: (LoanTransactionLockStatusGenqlSelection & { __args: {transactionIds: Scalars['ID'][]} })
    prevalidateCompanyLoan?: (ProcessLoanAttachmentResultGenqlSelection & { __args: {input: PrevalidateCompanyLoanInput} })
    getCompanyFundedStatus?: (CompanyFundedStatusGenqlSelection & { __args: {input: GetCompanyFundedStatusInput} })
    companyArCashDiffs?: (CompanyArCashDiffsResponseGenqlSelection & { __args: {input: CompanyArCashDiffsInput} })
    giftCardsByIds?: (GiftCardsByIdsResponseGenqlSelection & { __args: {input: GiftCardsByIdsInput} })
    shopifyReportDateLimits?: (ShopifyReportDateLimitsResponseGenqlSelection & { __args: {input: ShopifyReportDateLimitsInput} })
    shopifyReconciliationData?: (OrderReconciliationsResponseGenqlSelection & { __args: {input: OrderReconciliationsInput} })
    paymentProcessorByCompanyAndVendor?: (PaymentProcessorByCompanyAndVendorResponseGenqlSelection & { __args: {input: PaymentProcessorByCompanyAndVendorInput} })
    vendorByPaymentGateway?: (VendorByPaymentGatewayResponseGenqlSelection & { __args: {input: VendorByPaymentGatewayInput} })
    salesChannelsByCompanyAndIntegration?: (SalesChannelsByCompanyAndIntegrationResponseGenqlSelection & { __args: {input: SalesChannelsByCompanyAndIntegrationInput} })
    paymentGatewaysByCompanyIntegrationAndSalesChannel?: { __args: {input: PaymentGatewaysByCompanyIntegrationAndSalesChannelInput} }
    getOrdersV2?: (GetOrdersResultV2GenqlSelection & { __args: {input: GetOrdersInput} })
    getUnpaidOrdersCsv?: (GetUnpaidOrdersCsvResponseGenqlSelection & { __args: {input: GetUnpaidOrdersCsvInput} })
    getUnpaidOrdersAgingCsv?: (GetUnpaidOrdersCsvResponseGenqlSelection & { __args: {input: GetUnpaidOrdersAgingCsvInput} })
    giftCardsCsv?: (GiftCardsCsvResponseGenqlSelection & { __args: {input: GiftCardsCsvInput} })
    getOrdersAggregations?: (OrderAggregationEntryGenqlSelection & { __args: {input: GetOrdersAggregationsInput} })
    getOrderById?: (OrderV2ResultGenqlSelection & { __args: {input: OrderIdInput} })
    getFinaloopTags?: (OrderTagGenqlSelection & { __args: {input: CompanyIdInput} })
    getIntegrationTags?: (OrderTagGenqlSelection & { __args: {input: GetIntegrationTagsInput} })
    getFinaloopPaymentGateways?: { __args: {input: CompanyIdInput} }
    getOrderSalesChannels?: { __args: {input: CompanyIdInput} }
    getOrderFilteringBounds?: (GetOrderFilteringBoundsResultGenqlSelection & { __args: {input: CompanyIdInput} })
    getFulfillmentSettings?: (GetFulfillmentSettingsResponseGenqlSelection & { __args: {input: GetFulfillmentSettingInput} })
    isCompanyFulfillmentSettingsApplied?: { __args: {input: IsCompanyFulfillmentSettingsAppliedInput} }
    ordersByIds?: (OrdersByIdsResponseGenqlSelection & { __args: {input: OrdersByIdsInput} })
    orderGroupById?: (OrderGroupByIdResponseGenqlSelection & { __args: {input: OrderGroupByIdInput} })
    orderGroupsByIds?: (OrderGroupsByIdsResponseGenqlSelection & { __args: {input: OrderGroupsByIdsInput} })
    orderGroups?: (OrderGroupsResponseGenqlSelection & { __args: {input: OrderGroupsInput} })
    orderGroupsUnclearedBalance?: (OrderGroupsUnclearedBalanceResponseGenqlSelection & { __args: {input: OrderGroupsUnclearedBalanceInput} })
    orderGroupsTotalUnclearedBalance?: (OrderGroupsTotalUnclearedBalanceResponseGenqlSelection & { __args: {input: OrderGroupsTotalUnclearedBalanceInput} })
    ordersYearEnd?: (OrdersYearEndResponseGenqlSelection & { __args: {input: OrdersYearEndInput} })
    giftCards?: (GiftCardsResultGenqlSelection & { __args: {input: GiftCardsInput} })
    giftCardAggregations?: (GiftCardAggregationsResultGenqlSelection & { __args: {input: GiftCardAggregationsInput} })
    giftCardsMaximumCompanyBalance?: (GiftCardsMaximumCompanyBalanceResultGenqlSelection & { __args: {input: GiftCardsMaximumCompanyBalanceInput} })
    hasOrdersInOrderGroups?: (HasOrdersInOrderGroupsResponseGenqlSelection & { __args: {input: HasOrdersInOrderGroupsInput} })
    orders?: (OrdersResultGenqlSelection & { __args: {input: OrdersInput} })
    orderById?: (SingleOrderResultGenqlSelection & { __args: {input: OrderIdInput} })
    filteringBoundsOrderV3?: (FilteringBoundsOrderV3ResultGenqlSelection & { __args: {input: FilteringBoundsInput} })
    paymentGroupLinks?: (PaymentGroupLinksResponseGenqlSelection & { __args: {input: PaymentGroupLinksInput} })
    getInvoicesAffectingPaymentGroups?: (GetInvoicesAffectingPaymentGroupsResponseGenqlSelection & { __args: {input: GetInvoicesAffectingPaymentGroupsInput} })
    getPaymentGroupsByIds?: (PaymentGroupsByIdsResponseGenqlSelection & { __args: {input: PaymentGroupsByIdsInput} })
    orderPaymentGroupById?: (OrderPaymentGroupByIdResponseGenqlSelection & { __args: {input: PaymentGroupByIdInput} })
    orderPaymentGroupsByIds?: (OrderPaymentGroupsByIdsResponseGenqlSelection & { __args: {input: PaymentGroupsByIdsInput} })
    orderPaymentGroups?: (OrderPaymentGroupsResponseGenqlSelection & { __args: {input: PaymentGroupsInput} })
    orderPaymentGroupsUnclearedBalance?: (OrderPaymentGroupsUnclearedBalanceResponseGenqlSelection & { __args: {input: PaymentGroupsUnclearedBalanceInput} })
    orderPaymentGroupsTotalUnclearedBalance?: (PaymentGroupsTotalUnclearedBalanceResponseGenqlSelection & { __args: {input: PaymentGroupsTotalUnclearedBalanceInput} })
    invoicePaymentGroupById?: (InvoicePaymentGroupByIdResponseGenqlSelection & { __args: {input: PaymentGroupByIdInput} })
    invoicePaymentGroupsByIds?: (InvoicePaymentGroupsByIdsResponseGenqlSelection & { __args: {input: PaymentGroupsByIdsInput} })
    invoicePaymentGroups?: (InvoicePaymentGroupsResponseGenqlSelection & { __args: {input: PaymentGroupsInput} })
    invoicePaymentGroupsUnclearedBalance?: (InvoicePaymentGroupsUnclearedBalanceResponseGenqlSelection & { __args: {input: PaymentGroupsUnclearedBalanceInput} })
    invoicePaymentGroupsTotalUnclearedBalance?: (PaymentGroupsTotalUnclearedBalanceResponseGenqlSelection & { __args: {input: PaymentGroupsTotalUnclearedBalanceInput} })
    artificialTransactionsByMonth?: (ArtificialTransactionsByMonthResponseGenqlSelection & { __args: {input: GetArtificialTransactionsInput} })
    paymentsByIds?: (PaymentGenqlSelection & { __args: {input: GetPaymentsByIdsInput} })
    refundsByIds?: (RefundGenqlSelection & { __args: {input: GetRefundsByIdsInput} })
    integrationTransfersByIds?: (IntegrationTransferV2GenqlSelection & { __args: {input: GetIntegrationTransfersByIdsInput} })
    disputesByIds?: (DisputeGenqlSelection & { __args: {input: GetDisputesByIdsInput} })
    paymentFeesByIds?: (PaymentFeeGenqlSelection & { __args: {input: GetPaymentsByIdsInput} })
    chargebacksByIds?: (ChargebackGenqlSelection & { __args: {input: GetChargebacksByIdsInput} })
    paymentChecks?: (PaymentCheckGenqlSelection & { __args: {input: PaymentChecksInput} })
    payrollDailyAggregatesByEmploymentTypeAndCategory?: (PayrollDailyAggregateGenqlSelection & { __args: {input: PayrollDailyDataInput} })
    payrollIdsByCompany?: (PayrollIdsByCompanyResponseGenqlSelection & { __args: {input: PayrollIdsByCompanyInput} })
    contractorPaymentsInternal?: (ContractorPaymentsInternalResponseGenqlSelection & { __args: {input: ContractorPaymentsInternalInput} })
    contractorPaymentIdsByCompany?: (ContractorPaymentIdsByCompanyResponseGenqlSelection & { __args: {input: ContractorPaymentIdsByCompanyInput} })
    paymentsByEmployee?: (DailyPaymentsByEmployeeGenqlSelection & { __args: {input: PaymentsByEntityInput} })
    paymentsByContractor?: (DailyPaymentsByContractorGenqlSelection & { __args: {input: PaymentsByEntityInput} })
    payrollSettings?: (PayrollSettingsGenqlSelection & { __args: {input: PayrollSettingsInput} })
    validations?: (ValidationResultGenqlSelection & { __args: {args: ValidationsArgs} })
    periodicPartnerReports?: PeriodicPartnerReportGenqlSelection
    periodicReportsPartners?: ReportsPartnerGenqlSelection
    exportCashFlow?: (ExportResponseGenqlSelection & { __args: {args: ExportCashFlowApiArgs} })
    exportBalanceSheet?: (AwaitedExportResponseGenqlSelection & { __args: {args: ExportBalanceSheetApiArgs} })
    ledgerAccountTransactionsCSV?: (AwaitedExportResponseGenqlSelection & { __args: {args: ExportLedgerAccountTransactionsInput} })
    checkExportStatus?: (AwaitedExportResponseGenqlSelection & { __args: {args: CheckAwaitedExportStatusInput} })
    syncReportDefinition?: (ScheduleAccountingReportExportResponseGenqlSelection & { __args: {args: SyncReportInput} })
    lastAccountingReportSync?: (LastAccountingReportSyncResponseGenqlSelection & { __args: {args: LastAccountingReportSyncInput} })
    chartData?: (ChartDataResponseGenqlSelection & { __args: {args: ChartDataInput} })
    getExportedReportsLogs?: (GetExportedReportsResponseGenqlSelection & { __args: {args: GetExportedReportsInput} })
    getSignedUrlByExportedReportsLogId?: (GetSignedUrlByExportedLogIdResponseGenqlSelection & { __args: {id: Scalars['String']} })
    skuAnalysis?: (AllSkusResponseGenqlSelection & { __args: {args: AllSkusInput} })
    exportSkuAnalysis?: (ExportSkuAnalysisResponseGenqlSelection & { __args: {args: ExportSkuAnalysisInput} })
    skuAnalysisByDate?: (IndividualSkusResponseGenqlSelection & { __args: {args: IndividualSkusInput} })
    bestSellers?: (ProductTopPerformersResponseGenqlSelection & { __args: {args: ProductTopPerformersFilter} })
    unitsSold?: (ProductTopPerformersResponseGenqlSelection & { __args: {args: ProductTopPerformersFilter} })
    highestProfit?: (ProductTopPerformersResponseGenqlSelection & { __args: {args: ProductTopPerformersFilter} })
    bestMargin?: (ProductTopPerformersResponseGenqlSelection & { __args: {args: ProductTopPerformersFilter} })
    customerInternal?: (CustomerGenqlSelection & { __args: {args: GetCustomerInternal} })
    sellingFeesByIds?: (SellingFeeGenqlSelection & { __args: {input: GetSellingFeesByIdsInput} })
    fulfillmentCostsByIds?: (FulfillmentCostGenqlSelection & { __args: {input: GetFulfillmentCostsByIdsInput} })
    shippingCostsByIds?: (ShippingCostGenqlSelection & { __args: {input: GetShippingCostsByIdsInput} })
    getCustomers?: (CustomerGenqlSelection & { __args: {getCustomerArgs: GetCustomerArgs} })
    getCustomerById?: (GetCustomerResponseGenqlSelection & { __args: {id: Scalars['ID']} })
    searchCustomers?: (CustomerV2GenqlSelection & { __args: {input: SearchCustomersInput} })
    getCustomerV2ById?: (CustomerV2GenqlSelection & { __args: {input: GetCustomerByIdInput} })
    getCustomerV2ByIds?: (CustomerV2GenqlSelection & { __args: {input: GetCustomerByIdsInput} })
    sale?: (SaleGenqlSelection & { __args: {input: SaleInput} })
    getSales?: (GetSalesResultGenqlSelection & { __args: {input: GetSalesInput} })
    invoice?: (InvoiceGenqlSelection & { __args: {input: InvoiceInput} })
    getInvoices?: (GetInvoicesResultGenqlSelection & { __args: {input: GetSalesInput} })
    getInvoicePdfUrl?: { __args: {input: InvoicePdfInput} }
    getPaymentMethods?: (PaymentMethodGenqlSelection & { __args: {input: CompanyIdInput} })
    calculateInvoice?: (InvoiceGenqlSelection & { __args: {input: CalculateInvoiceInput} })
    getInvoicesCsv?: (ExportInvoicesResponseGenqlSelection & { __args: {input: GetSalesInput} })
    getInvoiceAggregations?: (InvoicesAggregationsGenqlSelection & { __args: {input: GetSaleAggregationsInput} })
    getInvoicesBalance?: (InvoicesBalanceGenqlSelection & { __args: {input: GetSaleAggregationsInput} })
    invoicesAgingReportCSV?: (AwaitedExportResponseGenqlSelection & { __args: {args: GetSalesInput} })
    salesChannel?: (SalesChannelInfoGenqlSelection & { __args: {input: SaleInput} })
    getSalesChannels?: (SalesChannelInfoGenqlSelection & { __args: {input: GetSalesChannelsInput} })
    getSalesChannelTemplates?: (SalesChannelTemplateGenqlSelection & { __args: {input: GetSalesChannelTemplatesInput} })
    invoiceSettings?: (InvoiceSettingsGenqlSelection & { __args: {input: GetInvoiceSettingsInput} })
    getInvoiceExamplePdfUrl?: { __args: {input: InvoicesInput} }
    invoicesYearEndTasks?: (InvoicesYearEndTasksResponseGenqlSelection & { __args: {input: InvoicesYearEndTasksInput} })
    testSPSCommerceOrgConnection?: (TestSPSCommerceOrgConnectionResponseGenqlSelection & { __args: {input: TestSPSCommerceOrgConnectionInput} })
    me?: MeResponseGenqlSelection
    isInvitationCodeForRegisteredUser?: (IsInvitationCodeForRegisteredUserResponseGenqlSelection & { __args: {args: IsInvitationCodeForRegisteredUserArgs} })
    companyUsers?: (CompanyUsersResponseGenqlSelection & { __args?: {args?: (CompanyUsersArgs | null)} })
    userInvitationByCode?: (UserInvitationResponseGenqlSelection & { __args: {args: UserInvitationArgs} })
    userReferralLink?: (UserReferralLinkResponseGenqlSelection & { __args?: {args?: (UserReferralLinkArgs | null)} })
    userInvitationsByEmail?: (UserInvitationsByEmailResponseGenqlSelection & { __args: {args: UserInvitationsByEmailArgs} })
    userRoles?: UserRolesResponseGenqlSelection
    auth0UserLookup?: (Auth0UserLookupResponseGenqlSelection & { __args: {args: Auth0UserLookupInput} })
    googleConnectStatus?: GoogleConnectStatusResponseGenqlSelection
    googleConnectionLink?: (GoogleConnectLinkResponseGenqlSelection & { __args?: {input?: (GoogleConnectionLinkInput | null)} })
    calendlyEventDetails?: (CalendlyEventResponseGenqlSelection & { __args: {args: CalendlyEventInput} })
    userNameFromReferralCode?: (UserNameFromReferralCodeResponseGenqlSelection & { __args: {args: UserNameFromReferralCodeInput} })
    userByEmail?: (UserByEmailResponseGenqlSelection & { __args: {args: UserByEmailArgs} })
    usersByEmails?: (UsersByEmailsResponseGenqlSelection & { __args: {args: UsersByEmailsArgs} })
    latestActiveCompanyUser?: (LatestActiveCompanyUserResponseGenqlSelection & { __args: {args: LatestActiveCompanyUserArgs} })
    vendors?: (VendorGenqlSelection & { __args: {input: VendorsInput} })
    vendor?: (GetVendorResponseGenqlSelection & { __args: {input: GetVendorInput} })
    vendorsByIds?: (VendorGenqlSelection & { __args: {input: GetVendorsInput} })
    vendorsBySubtype?: (VendorGenqlSelection & { __args: {companyId: Scalars['ID'], subTypes: VendorSubType[]} })
    tax1099AffiliatedEntityGroups?: (Tax1099AffiliatedEntityGroupsByTypeGenqlSelection & { __args: {input: GetTax1099AffiliatedEntityGroupsInput} })
    institutionVendors?: VendorGenqlSelection
    vendorById?: (VendorGenqlSelection & { __args: {input: VendorByIdInput} })
    vendorByAffiliatedEntityId?: (VendorGenqlSelection & { __args: {input: VendorByAffiliatedEntityIdInput} })
    vendorByName?: (VendorGenqlSelection & { __args: {input: VendorByNameInput} })
    globalVendorsByIds?: (VendorGenqlSelection & { __args: {input: GetGlobalVendorsInput} })
    vendorsByIntegrationType?: (VendorGenqlSelection & { __args: {input: VendorsByIntegrationTypeInput} })
    getCompanyWorksheets?: (CompanyWorksheetGenqlSelection & { __args: {args: GetCompanyWorksheetsArgs} })
    getCompanyLockConditions?: (CompanyLockConditionsGenqlSelection & { __args: {args: GetCompanyLockConditionsArgs} })
    getSignedDates?: (GetSignedDatesResponseGenqlSelection & { __args: {args: GetSignedDatesInput} })
    getWorksheets?: (WorksheetGenqlSelection & { __args: {input: GetCompanyWorksheetsArgs} })
    getAllCompaniesForDomain?: (GetAllCompaniesForDomainResponseGenqlSelection & { __args: {args: GetAllCompaniesForDomainInput} })
    yearEnd?: (YearEndStateResponseGenqlSelection & { __args: {args: YearEndStateInput} })
    yearEndDomainStateDatum?: (YearEndDomainStateDataResponseGenqlSelection & { __args: {args: YearEndDomainStateDatumInput} })
    yearEndDomainStateData?: (YearEndDomainStateDataResponseGenqlSelection & { __args: {args: YearEndDomainStateDataInput} })
    yearEndStates?: (FiscalYearEndStateResponseGenqlSelection & { __args: {args: YearEndStatesInput} })
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface RangedManagementMethodGenqlSelection{
    managementMethod?: boolean | number
    startDate?: boolean | number
    endDate?: boolean | number
    id?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface RangedManagementMethodInput {managementMethod: ManagementMethod,startDate?: (Scalars['Date'] | null),endDate?: (Scalars['Date'] | null)}

export interface ReadyValidationGenqlSelection{
    id?: boolean | number
    from?: boolean | number
    to?: boolean | number
    generatedAt?: boolean | number
    generatedBy?: boolean | number
    isGreen?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface RealtimeCogsStatusGenqlSelection{
    isAmazonEnabled?: boolean | number
    isShopifyEnabled?: boolean | number
    isWalmartEnabled?: boolean | number
    isTikTokEnabled?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface RecipeGenqlSelection{
    id?: boolean | number
    from?: boolean | number
    to?: boolean | number
    isAssembledOnDemand?: boolean | number
    product?: ProductGenqlSelection
    warehouse?: WarehouseGenqlSelection
    components?: RecipeComponentGenqlSelection
    managementMethod?: boolean | number
    displayName?: boolean | number
    deletedReason?: boolean | number
    manualAssemblyId?: boolean | number
    totalAssembled?: boolean | number
    allocatedCosts?: RecipeAllocatedCostGenqlSelection
    additionalAllocatedCostsPerUnit?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface RecipeAllocatedCostGenqlSelection{
    affiliatedEntity?: AffiliatedEntityGenqlSelection
    type?: boolean | number
    costPerUnit?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface RecipeAllocatedCostInput {costPerUnit: Scalars['Float'],type: RecipeAllocatedCostType,affiliatedEntityId?: (Scalars['ID'] | null)}

export interface RecipeAllocatedCostsErrorGenqlSelection{
    message?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface RecipeBreakdownGenqlSelection{
    quantity?: boolean | number
    wasteQuantity?: boolean | number
    costPerUnit?: boolean | number
    product?: ProductGenqlSelection
    warehouse?: WarehouseGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface RecipeCirclesFoundErrorGenqlSelection{
    data?: RecipeCirclesFoundErrorDataGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface RecipeCirclesFoundErrorDataGenqlSelection{
    recipe?: RecipeGenqlSelection
    product?: ProductGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface RecipeComponentGenqlSelection{
    product?: ProductGenqlSelection
    warehouse?: WarehouseGenqlSelection
    quantity?: boolean | number
    wasteQuantity?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface RecipeComponentInput {productId: Scalars['String'],warehouseId?: (Scalars['String'] | null),quantity: Scalars['Float'],wasteQuantity: Scalars['Float']}

export interface RecipeOverlappingErrorGenqlSelection{
    recipes?: RecipeGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface RecipeWithBreakdownGenqlSelection{
    recipe?: RecipeGenqlSelection
    startDate?: boolean | number
    endDate?: boolean | number
    warehouse?: WarehouseGenqlSelection
    breakdown?: RecipeBreakdownGenqlSelection
    affiliatedEntities?: AffiliatedEntityGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ReconcileAllInventoryPurchasesInput {companyId: Scalars['ID']}

export interface ReconcileInventoryPurchasesFromBillsInput {billItemsToReconcile: BillItemToReconcile[]}

export interface ReconcileInventoryPurchasesFromBusinessEventsInput {businessEventItemsToReconcile: BusinessEventItemToReconcile[]}

export interface ReconcileInventoryPurchasesFromPayrollsInput {payrollItemsToReconcile: PayrollItemToReconcile[]}

export interface ReconcileInventoryPurchasesFromTransactionsInput {transactionItemsToReconcile: TransactionItemToReconcile[]}

export interface ReconciliationRequestStatementFileGenqlSelection{
    id?: boolean | number
    requestId?: boolean | number
    s3Bucket?: boolean | number
    s3Key?: boolean | number
    fileName?: boolean | number
    fileType?: boolean | number
    status?: boolean | number
    machineStatus?: boolean | number
    providerValidationResults?: BankStatementValidationResultsGenqlSelection
    createdAt?: boolean | number
    uploadOriginator?: boolean | number
    companyAffiliate?: CompanyAffiliateGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ReconciliationSummaryGenqlSelection{
    totalInReport?: boolean | number
    isGreen?: boolean | number
    inBooks?: boolean | number
    unfulfilledInBooks?: boolean | number
    voided?: boolean | number
    restocked?: boolean | number
    excluded?: boolean | number
    totalInDb?: boolean | number
    fulfilled?: boolean | number
    fulfilledNotSold?: boolean | number
    soldNotFulfilled?: boolean | number
    zeroNet?: boolean | number
    zeroNetFulfilled?: boolean | number
    zeroNetNotSold?: boolean | number
    zeroNetNotFulfilled?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface RecordTax1099AffiliatedEntityGroupIdentifierInput {id: Scalars['ID'],type: Tax1099AffiliatedEntityType,isGroup: Scalars['Boolean']}

export interface RecordTax1099AffiliatedEntityGroupInput {companyId: Scalars['ID'],identifiers: RecordTax1099AffiliatedEntityGroupIdentifierInput[],calendarYear: Scalars['Int'],isDone?: (Scalars['Boolean'] | null),disqualifyReason?: (Tax1099AffiliatedEntityDisqualifyReason | null),resetDisqualifyReason?: (Scalars['Boolean'] | null),file?: (Tax1099AffiliatedEntityGroupFileInput | null),resetFile?: (Scalars['Boolean'] | null),finaloopComment?: (Scalars['String'] | null)}

export interface RecurrenceSettingsGenqlSelection{
    recurrence?: boolean | number
    totalRecurrences?: boolean | number
    cutOffDate?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface RecurrenceSettingsInput {recurrence: LoanEventRecurrence,totalRecurrences?: (Scalars['Int'] | null),cutOffDate?: (Scalars['Date'] | null)}

export interface RecurringPaymentGenqlSelection{
    yearly?: PaymentDetailsGenqlSelection
    monthly?: PaymentDetailsGenqlSelection
    yearlyDiscount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ReferUserArgs {email: Scalars['String'],companyId: Scalars['String']}

export interface referUserResponseGenqlSelection{
    success?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface RefreshSkuAmbiguityInput {companyId: Scalars['ID'],productId: Scalars['String'],skus: Scalars['String'][]}

export interface RefundGenqlSelection{
    companyId?: boolean | number
    id?: boolean | number
    source?: boolean | number
    integrationAccountId?: boolean | number
    integrationAccountName?: boolean | number
    amount?: boolean | number
    currency?: boolean | number
    postedAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ReimbursementGenqlSelection{
    id?: boolean | number
    source?: boolean | number
    externalSourceId?: boolean | number
    integrationAccountId?: boolean | number
    integrationAccountName?: boolean | number
    postedAt?: boolean | number
    amount?: boolean | number
    isClearedByNetPayPayment?: boolean | number
    employee?: EmployeeGenqlSelection
    contractor?: ContractorGenqlSelection
    contractorPayment?: ContractorPaymentGenqlSelection
    payroll?: PayrollGenqlSelection
    deletedAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface RelatedPartyGenqlSelection{
    id?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface RemediateValidationInput {companyIds?: (Scalars['ID'][] | null),validationDomain: Scalars['String'],validationType: Scalars['String'],fiscalYears?: (Scalars['Int'][] | null)}

export interface RemoveDataRestrictionInput {companyId: Scalars['ID']}

export interface RemoveDropshippingSettingsInput {companyId: Scalars['String']}

export interface RemoveUserArgs {email: Scalars['String'],companyId: Scalars['String']}

export interface RemoveUserResponseGenqlSelection{
    success?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ReplaceBankAccountLocksByTypeInput {companyId: Scalars['ID'],bankAccountId: Scalars['ID'],locks: BankAccountLockByTypeInput[],lockType: Scalars['String']}

export interface ReplaceBankAccountLocksInput {companyId: Scalars['ID'],bankAccountId: Scalars['ID'],locks: BankAccountLockInput[]}

export interface ReportGenqlSelection{
    url?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ReportedBusinessBankTransactionsAccountInput {companyId: Scalars['ID']}

export interface ReportHierarchyNodeGenqlSelection{
    name?: boolean | number
    reportType?: boolean | number
    breakdownType?: boolean | number
    accountRole?: AccountRoleGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ReportsPartnerGenqlSelection{
    id?: boolean | number
    name?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ReReconcileInventoryPurchasesInput {purchasesIds: Scalars['String'][],businessEventIds: Scalars['String'][],companyId: Scalars['ID']}

export interface ResetBalanceSheetSetupInput {companyId: Scalars['String']}

export interface ResetBalanceSheetSetupResponseGenqlSelection{
    message?: boolean | number
    status?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface RestockingActionGenqlSelection{
    quantity?: boolean | number
    id?: boolean | number
    date?: boolean | number
    type?: boolean | number
    salesChannel?: WarehouseActionSalesChannelGenqlSelection
    fulfillmentDate?: boolean | number
    sku?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface RunProductsValidationDiagnosticsInput {companyId: Scalars['ID'],fromDate: Scalars['Date'],toDate: Scalars['Date']}

export interface RunProductsValidationDiagnosticsResponseGenqlSelection{
    issues?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SafeHolderGenqlSelection{
    id?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SaleGenqlSelection{
    id?: boolean | number
    saleType?: boolean | number
    companyId?: boolean | number
    source?: boolean | number
    externalSourceUrl?: boolean | number
    externalSourceId?: boolean | number
    integrationAccountId?: boolean | number
    integrationAccountName?: boolean | number
    currency?: boolean | number
    displayName?: boolean | number
    statuses?: boolean | number
    postedAt?: boolean | number
    createdAt?: boolean | number
    updatedAt?: boolean | number
    deletedAt?: boolean | number
    publishedAt?: boolean | number
    lineItems?: SaleLineItemGenqlSelection
    shipping?: ShippingLineItemGenqlSelection
    discounts?: DiscountGenqlSelection
    platformDiscounts?: DiscountGenqlSelection
    taxes?: TaxGenqlSelection
    taxFixedAmount?: boolean | number
    taxType?: boolean | number
    adjustments?: SaleAdjustmentGenqlSelection
    payments?: SaleTransactionGenqlSelection
    credits?: SaleTransactionGenqlSelection
    refunds?: SaleTransactionGenqlSelection
    paymentIndications?: SaleTransactionGenqlSelection
    refundIndications?: SaleTransactionGenqlSelection
    customer?: CustomerV2GenqlSelection
    customerId?: boolean | number
    shippingAddress?: CustomerAddressGenqlSelection
    billingAddress?: CustomerAddressGenqlSelection
    integrationTags?: boolean | number
    integrationNote?: boolean | number
    finaloopNote?: boolean | number
    customerNote?: boolean | number
    isSalesAffecting?: boolean | number
    isCogsAffecting?: boolean | number
    voidedAt?: boolean | number
    voidedBy?: boolean | number
    approvedAt?: boolean | number
    uploadId?: boolean | number
    uploadedAt?: boolean | number
    summary?: SaleTotalsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SaleAdjustmentGenqlSelection{
    id?: boolean | number
    amount?: boolean | number
    currency?: boolean | number
    amountInHomeCurrency?: boolean | number
    type?: boolean | number
    postedAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SaleInput {id: Scalars['ID'],companyId: Scalars['ID'],balanceAsOfDate?: (Scalars['Date'] | null)}

export interface SaleInternalInput {id: Scalars['ID'],companyId: Scalars['ID']}

export interface SaleLineItemGenqlSelection{
    id?: boolean | number
    quantity?: boolean | number
    unitPrice?: boolean | number
    currency?: boolean | number
    type?: boolean | number
    integrationInfo?: IntegrationInfoGenqlSelection
    product?: ProductGenqlSelection
    sku?: boolean | number
    description?: boolean | number
    discounts?: DiscountGenqlSelection
    shipping?: ShippingLineItemGenqlSelection
    taxes?: TaxGenqlSelection
    subtotal?: boolean | number
    totalAmount?: boolean | number
    salesChannel?: SalesChannelInfoGenqlSelection
    salesChannelId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SaleLineItemInput {id?: (Scalars['ID'] | null),quantity: Scalars['Float'],unitPrice: Scalars['Float'],type: SaleLineItemType,currency: CurrencyCode,salesChannelName?: (Scalars['String'] | null),productId?: (Scalars['ID'] | null),sku?: (Scalars['String'] | null),description?: (Scalars['String'] | null),discounts?: (DiscountInput[] | null),taxRate?: (Scalars['Float'] | null),externalSourceId?: (Scalars['String'] | null)}

export interface SaleLineItemTaxInfoGenqlSelection{
    taxableAmount?: boolean | number
    taxRate?: boolean | number
    totalTaxAmount?: boolean | number
    isTaxInclusive?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SaleOrderGenqlSelection{
    id?: boolean | number
    saleType?: boolean | number
    companyId?: boolean | number
    source?: boolean | number
    externalSourceUrl?: boolean | number
    externalSourceId?: boolean | number
    integrationAccountId?: boolean | number
    integrationAccountName?: boolean | number
    currency?: boolean | number
    displayName?: boolean | number
    statuses?: boolean | number
    postedAt?: boolean | number
    createdAt?: boolean | number
    updatedAt?: boolean | number
    deletedAt?: boolean | number
    publishedAt?: boolean | number
    lineItems?: SaleLineItemGenqlSelection
    shipping?: ShippingLineItemGenqlSelection
    discounts?: DiscountGenqlSelection
    platformDiscounts?: DiscountGenqlSelection
    taxes?: TaxGenqlSelection
    taxFixedAmount?: boolean | number
    taxType?: boolean | number
    adjustments?: SaleAdjustmentGenqlSelection
    payments?: SaleTransactionGenqlSelection
    credits?: SaleTransactionGenqlSelection
    refunds?: SaleTransactionGenqlSelection
    paymentIndications?: SaleTransactionGenqlSelection
    refundIndications?: SaleTransactionGenqlSelection
    customer?: CustomerV2GenqlSelection
    customerId?: boolean | number
    shippingAddress?: CustomerAddressGenqlSelection
    billingAddress?: CustomerAddressGenqlSelection
    integrationTags?: boolean | number
    integrationNote?: boolean | number
    finaloopNote?: boolean | number
    customerNote?: boolean | number
    accounting?: AccountingInfoGenqlSelection
    isSalesAffecting?: boolean | number
    isCogsAffecting?: boolean | number
    voidedAt?: boolean | number
    voidedBy?: boolean | number
    approvedAt?: boolean | number
    uploadId?: boolean | number
    uploadedAt?: boolean | number
    summary?: SaleTotalsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SalesAdjustmentOriginalValueGenqlSelection{
    unitsSold?: boolean | number
    unitsRestocked?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SalesAdjustmentsBreakdownItemGenqlSelection{
    salesChannel?: SalesChannelGenqlSelection
    count?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SalesBasedClosingBalanceGenqlSelection{
    missionType?: boolean | number
    status?: boolean | number
    historyLog?: InventoryYearEndHistoryLogGenqlSelection
    managementMethodPeriod?: ManagementMethodYearEndPeriodGenqlSelection
    closingBalance?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SalesBasedClosingBalanceInput {closingBalance: Scalars['Float']}

export interface SalesBasedMissingCostPerUnitGenqlSelection{
    missionType?: boolean | number
    status?: boolean | number
    historyLog?: InventoryYearEndHistoryLogGenqlSelection
    managementMethodPeriod?: ManagementMethodYearEndPeriodGenqlSelection
    missingCostPerUnitProducts?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SalesBasedMissingCostPerUnitInput {missingCostPerUnitProducts: Scalars['Int']}

export interface SalesBasedOpeningBalanceGenqlSelection{
    missionType?: boolean | number
    status?: boolean | number
    historyLog?: InventoryYearEndHistoryLogGenqlSelection
    managementMethodPeriod?: ManagementMethodYearEndPeriodGenqlSelection
    openingBalance?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SalesBasedOpeningBalanceInput {openingBalance: Scalars['Float']}

export interface SalesBasedPurchasesGenqlSelection{
    missionType?: boolean | number
    status?: boolean | number
    historyLog?: InventoryYearEndHistoryLogGenqlSelection
    managementMethodPeriod?: ManagementMethodYearEndPeriodGenqlSelection
    purchases?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SalesBasedPurchasesInput {purchases: Scalars['Float']}

export interface SalesBasedReportCogsGenqlSelection{
    missionType?: boolean | number
    status?: boolean | number
    historyLog?: InventoryYearEndHistoryLogGenqlSelection
    managementMethodPeriod?: ManagementMethodYearEndPeriodGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SalesByTypeAndDateInput {saleType: SaleType,companyId: Scalars['ID'],from: Scalars['Date'],to: Scalars['Date']}

export interface SalesChannelGenqlSelection{
    accountRole?: boolean | number
    integrationType?: boolean | number
    integrationAccountName?: boolean | number
    currency?: boolean | number
    displayName?: boolean | number
    isDropshipping?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SalesChannelAddChangeInput {salesChannelName: Scalars['String']}

export interface SalesChannelDailySalesDataGenqlSelection{
    salesChannel?: SalesChannelGenqlSelection
    salesData?: SalesChannelSalesDataGenqlSelection
    soldSkusSummary?: SalesChannelSkuSalesSummaryGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SalesChannelDailySummaryGenqlSelection{
    date?: boolean | number
    summary?: SalesChannelSkuSummaryGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SalesChannelDeleteChangeInput {salesChannelName: Scalars['String']}

export interface SalesChannelInfoGenqlSelection{
    id?: boolean | number
    name?: boolean | number
    source?: boolean | number
    integrationAccountId?: boolean | number
    isCogsAffecting?: boolean | number
    isSalesAffecting?: boolean | number
    financialReportingStatus?: boolean | number
    periods?: SalesChannelPeriodGenqlSelection
    deletedAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SalesChannelInput {accountRole?: (Scalars['String'] | null),integrationType?: (Scalars['String'] | null),integrationAccountName?: (Scalars['String'] | null),currency?: (Scalars['String'] | null),isDropshipping?: (Scalars['Boolean'] | null)}

export interface SalesChannelMonthlyBreakdownGenqlSelection{
    date?: boolean | number
    summary?: SalesChannelSkuSummaryGenqlSelection
    dailyData?: SalesChannelDailySummaryGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SalesChannelPeriodGenqlSelection{
    startDate?: boolean | number
    endDate?: boolean | number
    financialReportingStatus?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SalesChannelPeriodInput {startDate?: (Scalars['Date'] | null),endDate?: (Scalars['Date'] | null),financialReportingStatus: FinancialReportingStatus}

export interface SalesChannelSalesCogsGenqlSelection{
    hasAdjustments?: boolean | number
    salesChannel?: SalesChannelGenqlSelection
    summary?: SalesChannelSkuSummaryGenqlSelection
    monthlyBreakdown?: SalesChannelMonthlyBreakdownGenqlSelection
    amount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SalesChannelSalesDataGenqlSelection{
    date?: boolean | number
    unitsSold?: boolean | number
    unitsRestocked?: boolean | number
    unitsGiveaway?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SalesChannelsByCompanyAndIntegrationInput {companyId: Scalars['ID'],integrationAccountId: Scalars['ID']}

export interface SalesChannelsByCompanyAndIntegrationResponseGenqlSelection{
    id?: boolean | number
    name?: boolean | number
    isSalesAffecting?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SalesChannelsInput {companyId: Scalars['ID']}

export interface SalesChannelSkuSalesSummaryGenqlSelection{
    sku?: boolean | number
    unitsSold?: boolean | number
    unitsRestocked?: boolean | number
    unitsGiveaway?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SalesChannelSkuSummaryGenqlSelection{
    sku?: boolean | number
    fulfilled?: boolean | number
    restocked?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SalesChannelTemplateGenqlSelection{
    id?: boolean | number
    name?: boolean | number
    source?: boolean | number
    isCogsAffecting?: boolean | number
    isSalesAffecting?: boolean | number
    financialReportingStatus?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SalesChannelUpdateChangeInput {newSalesChannelName: Scalars['String'],oldSalesChannelName: Scalars['String']}

export interface SalesDataGenqlSelection{
    recipes?: RecipeGenqlSelection
    assembledByRecipeMap?: AssembledByMapGenqlSelection
    salesChannels?: SalesChannelSalesCogsGenqlSelection
    deadInventory?: DeadInventoryCogsGenqlSelection
    giveaway?: GiveawayCogsGenqlSelection
    giveawayDropshipping?: GiveawayCogsGenqlSelection
    donation?: DonationCogsGenqlSelection
    lostAndFound?: LostAndFoundCogsGenqlSelection
    otherFba?: OtherFbaCogsGenqlSelection
    waste?: WasteCogsGenqlSelection
    supplierReturn?: ProductUnitCogsGenqlSelection
    warehouseSalesData?: WarehouseSalesDataGenqlSelection
    salesAdjustments?: ProductSalesDataAdjustmentsGenqlSelection
    deadInventoryAdjustments?: ProductDeadInventoryAdjustmentsGenqlSelection
    giveawayAdjustments?: ProductGiveawayAdjustmentsGenqlSelection
    giveawayDropshippingAdjustments?: ProductGiveawayAdjustmentsGenqlSelection
    donationAdjustments?: ProductDonationAdjustmentsGenqlSelection
    lostAndFoundAdjustments?: ProductLostAndFoundAdjustmentsGenqlSelection
    otherFbaAdjustments?: ProductOtherFbaAdjustmentsGenqlSelection
    supplierReturnAdjustments?: ProductUnitsAdjustmentsGenqlSelection
    appliedCosts?: ProductAppliedCostWithDepletedCountGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SalesInternalInput {ids: Scalars['ID'][],companyId: Scalars['ID']}

export interface SaleTotalsGenqlSelection{
    subtotal?: AmountsGenqlSelection
    subtotalAfterItemDiscounts?: AmountsGenqlSelection
    subtotalAfterDiscounts?: AmountsGenqlSelection
    totalBeforeTaxes?: AmountsGenqlSelection
    total?: AmountsGenqlSelection
    tipsSubtotal?: AmountsGenqlSelection
    shippingSubtotal?: AmountsGenqlSelection
    shippingDiscounts?: AmountsGenqlSelection
    shipping?: AmountsGenqlSelection
    payments?: AmountsGenqlSelection
    refunds?: AmountsGenqlSelection
    credits?: AmountsGenqlSelection
    adjustments?: AmountsGenqlSelection
    taxes?: AmountsGenqlSelection
    globalDiscounts?: AmountsGenqlSelection
    globalPlatformDiscounts?: AmountsGenqlSelection
    itemDiscounts?: AmountsGenqlSelection
    totalDiscounts?: AmountsGenqlSelection
    unpaidBalance?: AmountsGenqlSelection
    balanceAsOf?: boolean | number
    balanceAsOfAmount?: AmountsGenqlSelection
    latestFinancialTimestamp?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SaleTransactionGenqlSelection{
    id?: boolean | number
    integrationInfo?: IntegrationInfoGenqlSelection
    integrationAccountId?: boolean | number
    externalSourceId?: boolean | number
    amount?: boolean | number
    postedAt?: boolean | number
    currency?: boolean | number
    amountInHomeCurrency?: boolean | number
    type?: boolean | number
    finaloopPaymentGateway?: boolean | number
    originalPaymentGateway?: boolean | number
    paymentGatewayVariant?: boolean | number
    isIndication?: boolean | number
    on_BankTxSaleTransaction?: BankTxSaleTransactionGenqlSelection
    on_IntegrationSaleTransaction?: IntegrationSaleTransactionGenqlSelection
    on_PaymentGroupTransaction?: PaymentGroupTransactionGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SaveDropshippingSettingsInput {companyId: Scalars['String'],isEnabled: Scalars['Boolean'],mode?: (DropshippingModeType | null),warehouseIds?: (Scalars['String'][] | null),affiliatedEntityIds?: (Scalars['String'][] | null),applyVendorsSettingsForExistingTransactions?: (Scalars['Boolean'] | null),isIncludePaymentTerms?: (Scalars['Boolean'] | null),paymentsPerMonth?: (Scalars['Int'] | null)}

export interface ScheduleAccountingReportExportInput {companyId: Scalars['ID'],reportType: ReportType,isEnabled: Scalars['Boolean'],byMonth: Scalars['Boolean'],fractions: Scalars['Boolean'],withMerchantsBreakdown: Scalars['Boolean'],fromDate: Scalars['Date'],toDate: Scalars['Date'],includeCCAccounts?: (Scalars['Boolean'] | null),includeUDFAccounts?: (Scalars['Boolean'] | null)}

export interface ScheduleAccountingReportExportResponseGenqlSelection{
    reportType?: boolean | number
    isEnabled?: boolean | number
    byMonth?: boolean | number
    fractions?: boolean | number
    withMerchantsBreakdown?: boolean | number
    fromDate?: boolean | number
    toDate?: boolean | number
    syncMostUpdatedReport?: boolean | number
    includeCCAccounts?: boolean | number
    includeUDFAccounts?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ScheduleAtuIntegrationTransfersResultProcessingInput {companyId: Scalars['ID'],integrationTransferIds: Scalars['ID'][],askTheUserResult?: (Scalars['JSONObject'] | null)}

export interface ScheduleAtuIntegrationTransfersResultProcessingResultGenqlSelection{
    success?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ScheduleAtuTransactionsResultProcessingInput {companyId: Scalars['ID'],transactionIds: Scalars['ID'][],askTheUserResult?: (Scalars['JSONObject'] | null)}

export interface ScheduleAtuTransactionsResultProcessingResultGenqlSelection{
    success?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SchedulePurchasesValidationInput {companyId: Scalars['ID']}

export interface SchedulePurchasesValidationResponseGenqlSelection{
    validationId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SearchCustomersInput {companyId: Scalars['ID'],searchTerm: Scalars['String'],source?: (CustomerSource | null),limit?: (Scalars['Int'] | null)}

export interface SearchMerchantsInput {companyId: Scalars['ID'],searchTerm: Scalars['String']}

export interface SearchVendorsTransactionPriorityInput {companyId: Scalars['ID'],searchTerm: Scalars['String'],merchantType: MerchantType[],subType: VendorSubType[]}

export interface SearchVendorsTransactionsPriorityResultGenqlSelection{
    vendors?: VendorGenqlSelection
    counts?: VendorsTransactionsCountGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface Section179DeductionGenqlSelection{
    date?: boolean | number
    amount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface Section179DeductionInput {date: Scalars['String'],amount: Scalars['Float']}

export interface SellingFeeGenqlSelection{
    id?: boolean | number
    companyId?: boolean | number
    source?: boolean | number
    externalSourceId?: boolean | number
    integrationAccountId?: boolean | number
    integrationAccountName?: boolean | number
    sale?: SaleGenqlSelection
    order?: OrderV2GenqlSelection
    type?: boolean | number
    externalId?: boolean | number
    externalName?: boolean | number
    amount?: boolean | number
    currency?: boolean | number
    amountInHomeCurrency?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SendAnalyticsEventInput {companyId: Scalars['ID'],events: AnalyticsEventsData[]}

export interface SendAnalyticsEventResultGenqlSelection{
    success?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SendPoEmailErrorGenqlSelection{
    message?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SendPoEmailInput {companyId: Scalars['String'],id: Scalars['String'],to: Scalars['String'][],from: Scalars['String'],cc?: (Scalars['String'][] | null),bcc?: (Scalars['String'][] | null),subject: Scalars['String'],message?: (Scalars['String'] | null)}

export interface SendPoEmailResponseGenqlSelection{
    success?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SendPoEmailResultGenqlSelection{
    on_SendPoEmailResponse?:SendPoEmailResponseGenqlSelection,
    on_SendPoEmailError?:SendPoEmailErrorGenqlSelection,
    __typename?: boolean | number
}

export interface SendValidationNotificationInput {caption: Scalars['String'],validationCycleId: Scalars['String'],validationTemplateId: Scalars['String'],slackChannel?: (Scalars['String'] | null),type: CompanyValidationDomainType}

export interface SetBankAccountsLatestEventIdsInput {bankAccountEventIds: BankAccountEventIdsInput[]}

export interface SetFiscalYearDataInput {companyId: Scalars['ID'],month: Scalars['Int'],day: Scalars['Int']}

export interface SetFiscalYearStartInput {companyId: Scalars['ID'],month: Scalars['Int'],day: Scalars['Int'],userEmail: Scalars['String']}

export interface SetFulfillmentSettingsInput {companyId: Scalars['ID'],settings: IntegrationFulfillmentSettingsInput[]}

export interface SetFulfillmentSettingsResponseGenqlSelection{
    settings?: IntegrationFulfillmentSettingGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SetInventoryUsagesInput {companyId: Scalars['ID'],usageTypes: InventoryUsageType[]}

export interface SetOrderFinaloopNoteInput {companyId: Scalars['ID'],orderId: Scalars['ID'],finaloopNote: Scalars['String']}

export interface SetOrderFinaloopTagsInput {companyId: Scalars['ID'],orderId: Scalars['ID'],finaloopTags: FinaloopTagsInput[]}

export interface SetPendingAdjustmentsWithCsvInput {companyId: Scalars['ID'],url: Scalars['String'],filename: Scalars['String'],managementMethodId: Scalars['ID']}

export interface SetPendingDeadInventoryAdjustmentsInput {companyId: Scalars['ID'],managementMethodId: Scalars['ID'],items: SetPendingDeadInventoryAdjustmentsItemInput[]}

export interface SetPendingDeadInventoryAdjustmentsItemInput {productId: Scalars['String'],pendingId?: (Scalars['String'] | null),date?: (Scalars['Date'] | null),quantity?: (Scalars['Int'] | null),warehouseId?: (Scalars['String'] | null)}

export interface SetPendingDedInventoryAdjustmentsResponseGenqlSelection{
    items?: PendingDeadInventoryAdjustmentsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SetPendingDonationAdjustmentsInput {companyId: Scalars['ID'],managementMethodId: Scalars['ID'],items: SetPendingDonationAdjustmentsItemInput[]}

export interface SetPendingDonationAdjustmentsItemInput {productId: Scalars['String'],pendingId?: (Scalars['String'] | null),date?: (Scalars['Date'] | null),quantity?: (Scalars['Int'] | null),warehouseId?: (Scalars['String'] | null)}

export interface SetPendingDonationAdjustmentsResponseGenqlSelection{
    items?: PendingDonationAdjustmentsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SetPendingGiveawayAdjustmentsInput {companyId: Scalars['ID'],managementMethodId: Scalars['ID'],items: SetPendingGiveawayAdjustmentsItemInput[]}

export interface SetPendingGiveawayAdjustmentsItemInput {productId: Scalars['String'],pendingId?: (Scalars['String'] | null),date?: (Scalars['Date'] | null),quantity?: (Scalars['Int'] | null),warehouseId?: (Scalars['String'] | null)}

export interface SetPendingGiveawayAdjustmentsResponseGenqlSelection{
    items?: PendingGiveawayAdjustmentsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SetPendingGiveawayDropshippingAdjustmentsResponseGenqlSelection{
    items?: PendingGiveawayDropshippingAdjustmentsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SetPendingSalesDataAdjustmentsInput {companyId: Scalars['ID'],salesChannel: SalesChannelInput,managementMethodId: Scalars['ID'],items: SetPendingSalesDataAdjustmentsItemInput[]}

export interface SetPendingSalesDataAdjustmentsItemInput {productId: Scalars['String'],pendingId?: (Scalars['String'] | null),date?: (Scalars['Date'] | null),unitsSold?: (Scalars['Int'] | null),unitsRestocked?: (Scalars['Int'] | null),warehouseId?: (Scalars['String'] | null)}

export interface SetPendingSalesDataAdjustmentsResponseV2GenqlSelection{
    items?: PendingSalesDataAdjustmentsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SetPendingSalesDataAdjustmentsWithCsvInput {companyId: Scalars['ID'],url: Scalars['String'],filename: Scalars['String'],managementMethodId: Scalars['ID'],salesChannel: SalesChannelInput}

export interface SetPendingWarehouseOpeningBalancesInput {companyId: Scalars['ID'],date: Scalars['Date'],items: SetPendingWarehouseOpeningBalancesItemInput[]}

export interface SetPendingWarehouseOpeningBalancesItemInput {productId: Scalars['String'],warehouseId?: (Scalars['String'] | null),sourceId?: (Scalars['String'] | null),pendingId?: (Scalars['String'] | null),quantity?: (Scalars['Float'] | null),costPerUnit?: (Scalars['Float'] | null)}

export interface SetPendingWarehouseOpeningBalancesWithCsvInput {companyId: Scalars['ID'],date: Scalars['Date'],url: Scalars['String'],filename: Scalars['String']}

export interface SetPhysicalCountPendingAdjustmentsWithCsvInput {companyId: Scalars['ID'],physicalCountId: Scalars['ID'],url: Scalars['String'],filename: Scalars['String'],managementMethodId: Scalars['ID']}

export interface SetProductAdjustmentsInput {companyId: Scalars['ID'],finaloopProductId: Scalars['String'],salesDataAdjustments?: (SetProductSalesDataAdjustmentInput[] | null),deadInventoryAdjustments?: (SetProductDeadInventoryAdjustmentInput[] | null),giveawayAdjustments?: (SetProductGiveawayAdjustmentInput[] | null),donationAdjustments?: (SetProductDonationAdjustmentInput[] | null),unitLostAdjustments?: (SetProductUnitLostAdjustmentInput[] | null),otherFbaAdjustments?: (SetProductOtherFbaAdjustmentInput[] | null),supplierReturnAdjustments?: (SetProductSupplierReturnAdjustmentInput[] | null),appliedCosts?: (SetProductAppliedCostInput[] | null)}

export interface SetProductAppliedCostInput {operation: SetProductAdjustmentOperation,asOfDate: Scalars['Date'],appliedCost: Scalars['Float'],type?: (ProductAppliedCostType | null)}

export interface SetProductDeadInventoryAdjustmentInput {id?: (Scalars['String'] | null),operation: SetProductAdjustmentOperation,finaloopProductId: Scalars['String'],date: Scalars['Date'],unitsDeadInventory: Scalars['Float'],warehouseId?: (Scalars['String'] | null)}

export interface SetProductDonationAdjustmentInput {operation: SetProductAdjustmentOperation,finaloopProductId: Scalars['String'],date: Scalars['Date'],unitsDonated: Scalars['Int'],warehouseId?: (Scalars['String'] | null)}

export interface SetProductGiveawayAdjustmentInput {operation: SetProductAdjustmentOperation,finaloopProductId: Scalars['String'],date: Scalars['Date'],unitsGiveaway: Scalars['Int'],warehouseId?: (Scalars['String'] | null),isDropshipping?: (Scalars['Boolean'] | null)}

export interface SetProductMergeRecommendationsPrimaryProductInput {companyId: Scalars['ID'],productGroupId: Scalars['String'],productId: Scalars['String']}

export interface SetProductOtherFbaAdjustmentInput {operation: SetProductAdjustmentOperation,date: Scalars['Date'],otherFbaIncoming: Scalars['Int'],otherFba: Scalars['Int'],warehouseId?: (Scalars['String'] | null)}

export interface SetProductSalesDataAdjustmentInput {operation: SetProductAdjustmentOperation,salesChannel: SalesChannelInput,date: Scalars['Date'],unitsSold?: (Scalars['Int'] | null),unitsRestocked?: (Scalars['Int'] | null),warehouseId?: (Scalars['String'] | null)}

export interface SetProductSupplierReturnAdjustmentInput {operation: SetProductAdjustmentOperation,date: Scalars['Date'],units: Scalars['Int'],warehouseId?: (Scalars['String'] | null)}

export interface SetProductUnitLostAdjustmentInput {operation: SetProductAdjustmentOperation,date: Scalars['Date'],unitsLost: Scalars['Int'],unitsFound: Scalars['Int'],warehouseId?: (Scalars['String'] | null)}

export interface SetSettingsArgs {companyId: Scalars['String'],rangedManagementMethod?: (RangedManagementMethodInput[] | null)}

export interface SetUserGivenWarehouseNameInput {companyId: Scalars['ID'],warehouseId: Scalars['ID'],name: Scalars['String']}

export interface SetUserName {email: Scalars['String'],name: Scalars['String']}

export interface SetUserNameResponseGenqlSelection{
    success?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SetWarehouseDropshippingSettingsInput {id: Scalars['String'],companyId: Scalars['String'],isDropshipping: Scalars['Boolean'],isDropshippingFrom?: (Scalars['Date'] | null)}

export interface SetWarehouseOpeningBalanceInput {warehouseId: Scalars['String'],companyId: Scalars['ID'],productId: Scalars['String'],quantity: Scalars['Float'],costPerUnit: Scalars['Float'],date: Scalars['Date']}

export interface ShipmentGenqlSelection{
    id?: boolean | number
    shipmentDate?: boolean | number
    arrival?: ShipmentArrivalGenqlSelection
    contents?: ShipmentContentsGenqlSelection
    displayName?: boolean | number
    vendor?: VendorGenqlSelection
    notes?: boolean | number
    attachments?: ShipmentAttachmentGenqlSelection
    purchaseOrder?: PurchaseOrderGenqlSelection
    cost?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ShipmentActionGenqlSelection{
    quantity?: boolean | number
    id?: boolean | number
    date?: boolean | number
    type?: boolean | number
    purchaseOrder?: PurchaseOrderGenqlSelection
    directCost?: boolean | number
    indirectCosts?: MovementIndirectCostGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ShipmentArrivalGenqlSelection{
    arrivalDate?: boolean | number
    warehouse?: WarehouseGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ShipmentArrivalInput {arrivalDate?: (Scalars['Date'] | null),warehouseId: Scalars['ID']}

export interface ShipmentAttachmentGenqlSelection{
    id?: boolean | number
    filename?: boolean | number
    url?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ShipmentAttachmentInput {filename: Scalars['String'],url: Scalars['String']}

export interface ShipmentContentsGenqlSelection{
    id?: boolean | number
    lineItem?: DirectLineItemGenqlSelection
    quantity?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ShipmentContentsInput {lineItemId: Scalars['ID'],quantity: Scalars['Float']}

export interface ShipmentInput {id: Scalars['ID'],shipmentDate?: (Scalars['Date'] | null),arrival?: (ShipmentArrivalInput | null),contents: ShipmentContentsInput[],displayName?: (Scalars['String'] | null),vendorId?: (Scalars['ID'] | null),notes?: (Scalars['String'] | null),attachments: ShipmentAttachmentInput[]}

export interface ShippingCostGenqlSelection{
    id?: boolean | number
    companyId?: boolean | number
    source?: boolean | number
    externalSourceId?: boolean | number
    integrationAccountId?: boolean | number
    integrationAccountName?: boolean | number
    sale?: SaleGenqlSelection
    order?: OrderV2GenqlSelection
    type?: boolean | number
    externalId?: boolean | number
    externalName?: boolean | number
    amount?: boolean | number
    currency?: boolean | number
    amountInHomeCurrency?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ShippingLineItemGenqlSelection{
    id?: boolean | number
    quantity?: boolean | number
    unitPrice?: boolean | number
    currency?: boolean | number
    type?: boolean | number
    description?: boolean | number
    discounts?: DiscountGenqlSelection
    taxes?: TaxGenqlSelection
    subtotal?: boolean | number
    totalAmount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ShippingLineItemV3GenqlSelection{
    id?: boolean | number
    /** The ID of the line item in the external system */
    externalLineItemId?: boolean | number
    /** The name of the line item */
    name?: boolean | number
    /** The description of the line item */
    description?: boolean | number
    /** The amount of the line item */
    amount?: AmountsGenqlSelection
    parentId?: boolean | number
    /** The type of the line item */
    parentLineItemType?: boolean | number
    /** The earliest date and time the line item was posted */
    earliestPostedAt?: boolean | number
    /** The latest date and time the line item was posted */
    latestPostedAt?: boolean | number
    /** The timeline of the line item */
    timeline?: OrderLineItemTimelineV3GenqlSelection
    /** The type of the line item */
    type?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ShopifyCsvBalanceGenqlSelection{
    companyId?: boolean | number
    integrationAccountId?: boolean | number
    fromDate?: boolean | number
    toDate?: boolean | number
    balances?: ShopifyTimezoneBalanceGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ShopifyItemsReconciliationInput {startTime: Scalars['Date'],endTime: Scalars['Date'],integrationAccountId: Scalars['String'],companyId: Scalars['ID'],isRegenerateFromScratch?: (Scalars['Boolean'] | null)}

export interface ShopifyItemsReconciliationOrderDataGenqlSelection{
    orderId?: boolean | number
    url?: boolean | number
    shopifySalesChannel?: boolean | number
    salesChannel?: boolean | number
    quantity?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ShopifyItemsReconciliationOrdersDiffInput {companyId: Scalars['ID'],startTime: Scalars['Date'],endTime: Scalars['Date']}

export interface ShopifyItemsReconciliationOrdersDiffResultGenqlSelection{
    ordersData?: ShopifyItemsReconciliationOrdersDiffResultDataGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ShopifyItemsReconciliationOrdersDiffResultDataGenqlSelection{
    orderId?: boolean | number
    reportQuantity?: boolean | number
    entitiesQuantity?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ShopifyItemsReconciliationOrdersInput {startTime: Scalars['Date'],endTime: Scalars['Date'],integrationAccountId: Scalars['String'],integrationAccountName?: (Scalars['String'] | null),companyId: Scalars['ID'],sku: Scalars['String'],itemType?: (ShopifyValidationItemType | null),salesChannel?: (Scalars['String'] | null)}

export interface ShopifyItemsReconciliationOrdersResponseGenqlSelection{
    ordersData?: ShopifyItemsReconciliationOrderDataGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ShopifyItemsValidationBlacklistSalesChannelInput {companyId: Scalars['ID'],integrationAccountId: Scalars['String'],salesChannel: Scalars['String']}

export interface ShopifyItemsValidationBlacklistSkuInput {companyId: Scalars['ID'],integrationAccountId: Scalars['String'],sku: Scalars['String']}

export interface ShopifyOrderSourceDataGenqlSelection{
    financialStatus?: boolean | number
    fulfillmentStatus?: boolean | number
    gqlId?: boolean | number
    orderValidationData?: ShopifyOrderValidationDataGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ShopifyOrderValidationDataGenqlSelection{
    sales?: ShopifyOrderValidationSaleGenqlSelection
    refunds?: ShopifyOrderValidationRefundGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ShopifyOrderValidationRefundGenqlSelection{
    id?: boolean | number
    refundAmount?: boolean | number
    giftCardAmount?: boolean | number
    giftCardDiscountAmount?: boolean | number
    shippingAmount?: boolean | number
    taxAmount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ShopifyOrderValidationSaleGenqlSelection{
    id?: boolean | number
    saleAmount?: boolean | number
    giftCardAmount?: boolean | number
    giftCardDiscountAmount?: boolean | number
    taxAmount?: boolean | number
    dutyAmount?: boolean | number
    discountAmount?: boolean | number
    shippingAmount?: boolean | number
    tipAmount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ShopifyProductGenqlSelection{
    id?: boolean | number
    companyId?: boolean | number
    finaloopId?: boolean | number
    lineOfBusinessId?: boolean | number
    sku?: boolean | number
    price?: boolean | number
    displayName?: boolean | number
    imageUrl?: boolean | number
    listedChannels?: SalesChannelGenqlSelection
    appliedCosts?: ProductAppliedCostGenqlSelection
    dailySalesData?: (SalesChannelDailySalesDataGenqlSelection & { __args: {timeRange: ProductDataTimeRangeInput} })
    totalSold?: boolean | number
    avgCostPerUnit?: boolean | number
    productUrl?: boolean | number
    productVariantId?: boolean | number
    canEditLatestAppliedCost?: boolean | number
    isFractional?: boolean | number
    isHidden?: boolean | number
    salesData?: (SalesDataGenqlSelection & { __args: {timeRange: ProductDataTimeRangeInput} })
    rawRecipes?: (RecipeGenqlSelection & { __args: {timeRange: ProductDataTimeRangeInput} })
    componentOfProducts?: ProductGenqlSelection
    isAmbiguousSku?: boolean | number
    analyticsOverview?: (ProductAnalyticsOverviewGenqlSelection & { __args?: {input?: (AnalyticsOverviewInput | null)} })
    warehousesAnalyticsOverview?: (ProductWarehousesAnalyticsOverviewGenqlSelection & { __args?: {input?: (AnalyticsOverviewInput | null)} })
    tags?: boolean | number
    isCreatedManually?: boolean | number
    isDataSyncing?: boolean | number
    mergeHistory?: ProductMergeHistoryItemGenqlSelection
    isDropshipping?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ShopifyProductsValidationConnectionGenqlSelection{
    integrationAccountId?: boolean | number
    isAvailable?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ShopifyProductsValidationConnectionsInput {companyId: Scalars['ID']}

export interface ShopifyProductsValidationConnectionsResponseGenqlSelection{
    connections?: ShopifyProductsValidationConnectionGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ShopifyProductsValidationDataGenqlSelection{
    integrationAccountId?: boolean | number
    data?: ShopifySkuReconciliationDataGenqlSelection
    reportEndTime?: boolean | number
    reportPath?: boolean | number
    summary?: ReconciliationSummaryGenqlSelection
    productItemSoldData?: ShopifySkuReconciliationProductItemSoldDataGenqlSelection
    productStatus?: ShopifyReconciliationProductsStatusGenqlSelection
    unknownSkuQuantity?: boolean | number
    unknownSkuZeroPriceQuantity?: boolean | number
    isNotArtificiallyFulfilled?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ShopifyProductsValidationResponseGenqlSelection{
    validationId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ShopifyReconciliationProductsStatusGenqlSelection{
    unitsSoldDiff?: boolean | number
    unitsRestockedDiff?: boolean | number
    unitsGiveawayDiff?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ShopifyReportDateLimitsInput {integrationAccountId: Scalars['ID'],companyId: Scalars['ID']}

export interface ShopifyReportDateLimitsResponseGenqlSelection{
    dateRange?: DateRangeGenqlSelection
    failureType?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ShopifySkuReconciliationDataGenqlSelection{
    sku?: boolean | number
    isBlacklisted?: boolean | number
    excludedSalesChannelsData?: ExcludedSalesChannelItemReconciliationGenqlSelection
    includedSalesChannelsData?: IncludedFinaloopSalesChannelItemReconciliationGenqlSelection
    summary?: ReconciliationSummaryGenqlSelection
    productItemSoldData?: ShopifySkuReconciliationProductItemSoldDataGenqlSelection
    productStatus?: ShopifyReconciliationProductsStatusGenqlSelection
    unknownSkuQuantity?: boolean | number
    unknownSkuZeroPriceQuantity?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ShopifySkuReconciliationProductItemSoldDataGenqlSelection{
    unitsSold?: boolean | number
    unitsSoldWithZeroPrice?: boolean | number
    unitsRestocked?: boolean | number
    unitsGiveaway?: boolean | number
    ambiguousSkuQuantity?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ShopifyTimezoneBalanceGenqlSelection{
    timezone?: boolean | number
    grossAmount?: boolean | number
    netAmount?: boolean | number
    taxAmount?: boolean | number
    discountAmount?: boolean | number
    shippingAmount?: boolean | number
    refundAmount?: boolean | number
    totalAmount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SignAndLockBankAccountInput {companyId: Scalars['String'],bankAccountId: Scalars['String'],signedBy?: (Scalars['String'] | null)}

export interface SignedDownloadUrlInput {companyId: Scalars['String'],s3Url: Scalars['String']}

export interface SignWorksheetRowInput {companyId: Scalars['String'],name: Scalars['String'],amount: Scalars['Float'],comment?: (Scalars['String'] | null),periodDates: PeriodDatesInput}

export interface SimulatedLoanFailureGenqlSelection{
    reason?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SimulatedLoanIrrelevantEventGenqlSelection{
    event?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SimulatedLoanSummaryGenqlSelection{
    on_SimulatedLoanIrrelevantEvent?:SimulatedLoanIrrelevantEventGenqlSelection,
    on_SimulatedLoanUpdate?:SimulatedLoanUpdateGenqlSelection,
    on_SimulatedLoanFailure?:SimulatedLoanFailureGenqlSelection,
    __typename?: boolean | number
}

export interface SimulatedLoanUpdateGenqlSelection{
    createdLoan?: SimulatedLoanUpdateCreateGenqlSelection
    deletedLoan?: SimulatedLoanUpdateDeleteGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SimulatedLoanUpdateCreateGenqlSelection{
    type?: boolean | number
    isShortTerm?: boolean | number
    date?: boolean | number
    amount?: boolean | number
    lender?: NewLenderGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SimulatedLoanUpdateDeleteGenqlSelection{
    loanId?: boolean | number
    type?: boolean | number
    isShortTerm?: boolean | number
    date?: boolean | number
    amount?: boolean | number
    lender?: NewLenderGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SimulateTransactionUpdatedClassification {businessEvent: Scalars['String'],amount: Scalars['Float'],pairedEntityId?: (Scalars['String'] | null),pairedEntityType?: (Scalars['String'] | null)}

export interface SimulateTransactionUpdatedInput {companyId: Scalars['ID'],transactionId: Scalars['String'],businessEvent: Scalars['String'],merchantId: Scalars['String']}

export interface SimulateTransactionUpdatedInput2 {companyId: Scalars['ID'],transactionId: Scalars['String'],classifications: SimulateTransactionUpdatedClassification[],merchantId: Scalars['String'],merchantType?: (LoanLenderType | null)}

export interface SingleOrderResultGenqlSelection{
    on_OrderV3?:OrderV3GenqlSelection,
    on_OrderV3NotFound?:OrderV3NotFoundGenqlSelection,
    __typename?: boolean | number
}

export interface SkuDataGenqlSelection{
    product?: ProductGenqlSelection
    /** @deprecated use product.id instead */
    productId?: boolean | number
    /** @deprecated use product.displayName instead */
    productName?: boolean | number
    /** @deprecated use product.sku instead */
    sku?: boolean | number
    sourcesAndStores?: SourceAndStoresGenqlSelection
    sales?: CurrentPreviousValueGenqlSelection
    salesTrend?: boolean | number
    discounts?: CurrentPreviousValueGenqlSelection
    cogs?: CurrentPreviousValueGenqlSelection
    profit?: CurrentPreviousValueGenqlSelection
    margin?: CurrentPreviousValueGenqlSelection
    refunds?: CurrentPreviousValueGenqlSelection
    restocks?: CurrentPreviousValueGenqlSelection
    effectiveProfit?: CurrentPreviousValueGenqlSelection
    effectiveProfitMargin?: CurrentPreviousValueGenqlSelection
    unitsSold?: CurrentPreviousValueGenqlSelection
    unitsRefunded?: CurrentPreviousValueGenqlSelection
    averageUnitsSold?: CurrentPreviousValueGenqlSelection
    /** @deprecated use averageNetSales instead */
    averageSalePrice?: CurrentPreviousValueGenqlSelection
    averageNetSales?: CurrentPreviousValueGenqlSelection
    averageCostPerUnit?: CurrentPreviousValueGenqlSelection
    averageProfitPerUnit?: CurrentPreviousValueGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SkuDataByDateGenqlSelection{
    date?: boolean | number
    sales?: CurrentPreviousValueGenqlSelection
    discounts?: CurrentPreviousValueGenqlSelection
    cogs?: CurrentPreviousValueGenqlSelection
    profit?: CurrentPreviousValueGenqlSelection
    margin?: CurrentPreviousValueGenqlSelection
    refunds?: CurrentPreviousValueGenqlSelection
    unitsSold?: CurrentPreviousValueGenqlSelection
    unitsRefunded?: CurrentPreviousValueGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SkuValidationDataGenqlSelection{
    sku?: boolean | number
    integrationAccountName?: boolean | number
    unitsSold?: boolean | number
    unitsRestocked?: boolean | number
    unitsGiveaway?: boolean | number
    unitsSoldWithZeroPrice?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SourceAndStoresGenqlSelection{
    source?: boolean | number
    stores?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SpecificDateGenqlSelection{
    date?: boolean | number
    amount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SpecificDateInput {date: Scalars['String'],amount: Scalars['Float']}

export interface SplitProductsInput {companyId: Scalars['String'],finaloopProductIds: Scalars['String'][]}

export interface SplitProductsV3 {productIds: Scalars['String'][],from?: (Scalars['Date'] | null)}

export interface SplitTax1099AffiliatedEntityGroupsInput {companyId: Scalars['ID'],groupIds: Scalars['ID'][]}

export interface SplitWarehouseInput {companyId: Scalars['ID'],representativeId: Scalars['String']}

export interface SpreadOverTimeGenqlSelection{
    fromDate?: boolean | number
    toDate?: boolean | number
    amount?: boolean | number
    spreadBasisType?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SpreadOverTimeInput {fromDate: Scalars['String'],toDate: Scalars['String'],amount: Scalars['Float'],spreadBasisType?: (SpreadBasisType | null)}

export interface StatementFile {s3Bucket: Scalars['String'],s3Key: Scalars['String'],fileName: Scalars['String'],fileType: BankAccountStatementFileType}

export interface StopImportingDataForBankAccountInput {bankAccountId: Scalars['ID'],companyId: Scalars['ID'],stopImportFromDate: Scalars['String']}

export interface StopImportingDataForBankAccountNewInput {bankAccountId: Scalars['ID'],companyId: Scalars['ID'],stopImportFromDate: Scalars['String'],newOwner?: (BankAccountNewOwner | null)}

export interface StoreGenqlSelection{
    id?: boolean | number
    name?: boolean | number
    homeCurrency?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface StoreDateForLockingInput {companyId: Scalars['String'],name: Scalars['String'],dateForLocking: Scalars['Date'],periodDates: PeriodDatesInput}

export interface StorePaymentV2GenqlSelection{
    id?: boolean | number
    source?: boolean | number
    externalSourceId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface StoreV3GenqlSelection{
    id?: boolean | number
    name?: boolean | number
    homeCurrency?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface StoreValidationInput {validationTemplateId?: (Scalars['String'] | null),validationId: Scalars['String'],validationCycleId?: (Scalars['String'] | null),result: StoreValidationResultDataInput}

export interface StoreValidationResultDataInput {companyId: Scalars['String'],domain: CompanyValidationDomainType,type: CompanyValidationType,integrationAccountId?: (Scalars['String'] | null),account?: (Scalars['String'] | null),accountDisplayName?: (Scalars['String'] | null),isError?: (Scalars['Boolean'] | null),metrics: StoreValidationResultDataMeticItemInput[],dataUrl?: (Scalars['String'] | null),from?: (Scalars['Date'] | null),to: Scalars['Date'],generatedBy?: (Scalars['String'] | null)}

export interface StoreValidationResultDataMeticItemInput {metricName?: (CompanyValidationMetricName | null),value: Scalars['Float'],mode?: (CompanyValidationMetricMode | null)}

export interface StripeCustomerIdsByCompanyIdsInput {companyIds: Scalars['String'][]}

export interface StripeCustomerIdsResponseGenqlSelection{
    companyAndStripeIds?: CompanyIdAndStripeCustomerIdGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SubmitTransactionsFileToBankTransactionsUploadInput {companyId: Scalars['ID'],bankTransactionsUploadId: Scalars['String'],bucket: Scalars['String'],key: Scalars['String'],processorId: Scalars['String']}

export interface SubmitTransactionsFileToBankTransactionsUploadResponseGenqlSelection{
    id?: boolean | number
    companyId?: boolean | number
    bankAccountId?: boolean | number
    s3Bucket?: boolean | number
    s3Key?: boolean | number
    status?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SuccessResponseGenqlSelection{
    success?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SuccessResultGenqlSelection{
    success?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SuggestBankTransactionClassificationInput {companyId: Scalars['ID'],bankTransactionIds: Scalars['ID'][],userPrompt?: (Scalars['String'] | null),merchantId?: (Scalars['ID'] | null),merchantType?: (MerchantType | null)}

export interface SuspectedBankAccountDuplicationGenqlSelection{
    id?: boolean | number
    companyId?: boolean | number
    bankAccountId1?: boolean | number
    bankAccountId2?: boolean | number
    liveConnectionBankAccountId?: boolean | number
    readyForMergingAt?: boolean | number
    hubspotNotificationSentAt?: boolean | number
    duplicateCheckStartedAt?: boolean | number
    duplicateCheckCompletedAt?: boolean | number
    duplicateCheckResult?: boolean | number
    mergeStartedAt?: boolean | number
    mergeCompletedAt?: boolean | number
    mergeResult?: boolean | number
    fileLocationBucket?: boolean | number
    fileLocationKey?: boolean | number
    mergedBy?: boolean | number
    mergedById?: boolean | number
    totalMergedTransactionsChunks?: boolean | number
    currentlyMergedTransactionsChunks?: boolean | number
    createdAt?: boolean | number
    updatedAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SwitchCompanyArgs {companyId: Scalars['String'],companyIdToSwitchTo: Scalars['String']}

export interface SwitchCompanyResponseGenqlSelection{
    success?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SyncCompanyInput {eventName: SyncCompanyEventName,body: CompanySyncBodyInput}

export interface SyncDataPlatformIntegrationInput {companyId: Scalars['ID'],integrationType: IntegrationType,integrationAccountId: Scalars['String'],clientConfig: Scalars['JSONObject']}

export interface SyncDataPlatformIntegrationResponseGenqlSelection{
    companyId?: boolean | number
    integrationType?: boolean | number
    integrationAccountId?: boolean | number
    isNewIntegration?: boolean | number
    isUpdatedIntegration?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SyncGtmSourceInput {companyId: Scalars['ID'],gtmSource?: (GTMSourceInput | null)}

export interface SyncInventoryIntegrationFulfillmentSettingInput {companyId: Scalars['ID'],source: Scalars['String'],isEnabled: Scalars['Boolean']}

export interface SyncReportInput {companyId: Scalars['ID'],reportType: ReportType}

export interface SyncStripeOffersInput {subscriptionProductId: Scalars['String'],transitionFeeProductId?: (Scalars['String'] | null),catchupProductId?: (Scalars['String'] | null),couponCode?: (Scalars['String'] | null),isStripeTest: Scalars['Boolean'],description: Scalars['String'],title: Scalars['String'],tier: OfferTier}

export interface SyncStripeTier1Offer {yearlySubscriptionPriceId?: (Scalars['String'] | null),monthlySubscriptionPriceId?: (Scalars['String'] | null),transitionFeePriceId?: (Scalars['String'] | null),catchupPriceId?: (Scalars['String'] | null),isStripeTest?: (Scalars['Boolean'] | null),description: Scalars['String'],title: Scalars['String'],couponCode?: (Scalars['String'] | null),companyId: Scalars['String']}

export interface TaxGenqlSelection{
    id?: boolean | number
    amount?: boolean | number
    description?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface Tax1099AffiliatedEntityGenqlSelection{
    affiliatedEntity?: AffiliatedEntityGenqlSelection
    type?: boolean | number
    calendarYear?: boolean | number
    totalPayments?: boolean | number
    businessEvents?: boolean | number
    sources?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface Tax1099AffiliatedEntityGroupGenqlSelection{
    id?: boolean | number
    groupName?: boolean | number
    isGroup?: boolean | number
    type?: boolean | number
    calendarYear?: boolean | number
    affiliatedEntities?: Tax1099AffiliatedEntityGenqlSelection
    totalPayments?: boolean | number
    businessEvents?: boolean | number
    sources?: boolean | number
    disqualifyReason?: boolean | number
    file?: Tax1099AffiliatedEntityGroupFileGenqlSelection
    markedAsDoneAt?: boolean | number
    finaloopComment?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface Tax1099AffiliatedEntityGroupFileGenqlSelection{
    url?: boolean | number
    name?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface Tax1099AffiliatedEntityGroupFileInput {url: Scalars['String'],name: Scalars['String']}

export interface Tax1099AffiliatedEntityGroupsByTypeGenqlSelection{
    type?: boolean | number
    calendarYear?: boolean | number
    affiliatedEntityGroups?: Tax1099AffiliatedEntityGroupGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TaxInfoGenqlSelection{
    amount?: boolean | number
    description?: boolean | number
    isTaxInclusive?: boolean | number
    createdAt?: boolean | number
    updatedAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TaxLineItemV3GenqlSelection{
    id?: boolean | number
    /** The ID of the line item in the external system */
    externalLineItemId?: boolean | number
    /** The name of the line item */
    name?: boolean | number
    /** The description of the line item */
    description?: boolean | number
    /** The amount of the line item */
    amount?: AmountsGenqlSelection
    parentId?: boolean | number
    /** The type of the line item */
    parentLineItemType?: boolean | number
    /** The earliest date and time the line item was posted */
    earliestPostedAt?: boolean | number
    /** The latest date and time the line item was posted */
    latestPostedAt?: boolean | number
    /** The type of the line item */
    type?: boolean | number
    /** The type of the tax */
    taxType?: boolean | number
    /** The name of the tax as received from the external system */
    externalName?: boolean | number
    /** The ISO code of the country of the tax */
    country?: boolean | number
    /** The region of the tax */
    region?: boolean | number
    /** The rate of the tax */
    ratePercentage?: boolean | number
    /** The liable party of the tax */
    liableParty?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TestSPSCommerceOrgConnectionInput {companyId: Scalars['String'],organizationName: Scalars['String']}

export interface TestSPSCommerceOrgConnectionResponseGenqlSelection{
    success?: boolean | number
    message?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TikTokProductGenqlSelection{
    id?: boolean | number
    companyId?: boolean | number
    finaloopId?: boolean | number
    lineOfBusinessId?: boolean | number
    sku?: boolean | number
    price?: boolean | number
    displayName?: boolean | number
    imageUrl?: boolean | number
    listedChannels?: SalesChannelGenqlSelection
    appliedCosts?: ProductAppliedCostGenqlSelection
    dailySalesData?: (SalesChannelDailySalesDataGenqlSelection & { __args: {timeRange: ProductDataTimeRangeInput} })
    totalSold?: boolean | number
    avgCostPerUnit?: boolean | number
    asin?: boolean | number
    canEditLatestAppliedCost?: boolean | number
    isFractional?: boolean | number
    isHidden?: boolean | number
    salesData?: (SalesDataGenqlSelection & { __args: {timeRange: ProductDataTimeRangeInput} })
    rawRecipes?: (RecipeGenqlSelection & { __args: {timeRange: ProductDataTimeRangeInput} })
    componentOfProducts?: ProductGenqlSelection
    isAmbiguousSku?: boolean | number
    analyticsOverview?: (ProductAnalyticsOverviewGenqlSelection & { __args?: {input?: (AnalyticsOverviewInput | null)} })
    warehousesAnalyticsOverview?: (ProductWarehousesAnalyticsOverviewGenqlSelection & { __args?: {input?: (AnalyticsOverviewInput | null)} })
    tags?: boolean | number
    isCreatedManually?: boolean | number
    isDataSyncing?: boolean | number
    mergeHistory?: ProductMergeHistoryItemGenqlSelection
    isDropshipping?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TimeRangeGenqlSelection{
    fromUTC?: boolean | number
    toUTC?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TimeRangeInput {fromUTC: Scalars['Date'],toUTC: Scalars['Date']}

export interface TipLineItemV3GenqlSelection{
    id?: boolean | number
    /** The ID of the line item in the external system */
    externalLineItemId?: boolean | number
    /** The name of the line item */
    name?: boolean | number
    /** The description of the line item */
    description?: boolean | number
    /** The amount of the line item */
    amount?: AmountsGenqlSelection
    parentId?: boolean | number
    /** The type of the line item */
    parentLineItemType?: boolean | number
    /** The earliest date and time the line item was posted */
    earliestPostedAt?: boolean | number
    /** The latest date and time the line item was posted */
    latestPostedAt?: boolean | number
    /** The type of the line item */
    type?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ToggleBankTransactionAccrualInput {companyId: Scalars['ID'],bankTransactionId: Scalars['ID'],hasAccrual: Scalars['Boolean']}

export interface ToggleBankTransactionAccrualResultGenqlSelection{
    companyId?: boolean | number
    bankTransactionId?: boolean | number
    hasAccrual?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ToggleBillHasAccrualInput {companyId: Scalars['ID'],billId: Scalars['ID'],hasAccrual: Scalars['Boolean']}

export interface ToggleOrdersZeroNetBalanceInput {companyId: Scalars['String'],isZeroNetOrdersSupported: Scalars['Boolean']}

export interface ToggleRecognizeZeroNetOrdersAsGiveawaysInput {companyId: Scalars['ID'],shouldRecognizeZeroNetCogsAsGiveaways: Scalars['Boolean']}

export interface TopupGenqlSelection{
    id?: boolean | number
    companyId?: boolean | number
    amount?: boolean | number
    amountInUsd?: boolean | number
    currency?: boolean | number
    eventTime?: boolean | number
    deletedAt?: boolean | number
    markedAsReconciliationDiscrepancyAt?: boolean | number
    integrationType?: boolean | number
    pairedBankTransaction?: BankTransactionGenqlSelection
    type?: boolean | number
    classification?: IntegrationTransferClassificationGenqlSelection
    integrationAccountId?: boolean | number
    integrationAccountName?: boolean | number
    pairedCompanyAffiliate?: CompanyAffiliateGenqlSelection
    link?: boolean | number
    uploadedFileId?: boolean | number
    failedAmountInUsd?: boolean | number
    failedAt?: boolean | number
    markedAsUnidentifiedAt?: boolean | number
    rawEvent?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TransactionDescriptionGenqlSelection{
    description?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TransactionItemToReconcile {companyId: Scalars['ID'],transactionId: Scalars['ID']}

export interface TransactionLoanGenqlSelection{
    transaction?: BankTransactionGenqlSelection
    loan?: CompanyLoanGenqlSelection
    isLocked?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TransactionsImportStatusGenqlSelection{
    stopImportFromDate?: boolean | number
    changedBy?: boolean | number
    changedAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TransactionUpdatedInput {companyId: Scalars['ID'],transactionId: Scalars['String'],actorType?: (ActorType | null)}

export interface TransactionWithMultipleClassificationsInput {transactionId: Scalars['String'],merchant: LoanMerchantInput,classifications: CreateCompanyLoanFromTransactionClassificationInput[]}

export interface TransitionFeeInput {stripeId: Scalars['String'],price: Scalars['Float']}

export interface TriggerCOGSFromScratchInput {companyId: Scalars['ID'],managementMethod: ManagementMethod,productIds?: (Scalars['String'][] | null)}

export interface TriggerFifoReconciliationInput {companyId: Scalars['ID'],startDate: Scalars['Date'],endDate: Scalars['Date'],eventIds: Scalars['ID'][]}

export interface TriggerReconciliationInput {companyId: Scalars['ID']}

export interface UnclassifyIntegrationTransferInput {ids: Scalars['ID'][],companyId: Scalars['ID']}

export interface UnconnectedAccountGenqlSelection{
    vendor?: VendorGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UnidentifiedBankTransactionPartyGenqlSelection{
    on_BankAccount?:BankAccountGenqlSelection,
    on_UnknownTransactionBank?:UnknownTransactionBankGenqlSelection,
    on_UnknownTransactionAccount?:UnknownTransactionAccountGenqlSelection,
    on_UnconnectedAccount?:UnconnectedAccountGenqlSelection,
    on_Vendor?:VendorGenqlSelection,
    on_TransactionDescription?:TransactionDescriptionGenqlSelection,
    __typename?: boolean | number
}

export interface UnidentifiedBankTransactionsGroupGenqlSelection{
    transactions?: BankTransactionGenqlSelection
    payer?: UnidentifiedBankTransactionPartyGenqlSelection
    payee?: UnidentifiedBankTransactionPartyGenqlSelection
    groupId?: boolean | number
    isProcessing?: boolean | number
    action?: boolean | number
    tooltipText?: boolean | number
    type?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UnidentifiedBankTransactionsGroupsInput {companyId: Scalars['ID'],fromDate?: (Scalars['Date'] | null),toDate?: (Scalars['Date'] | null)}

export interface UnitBasedClosingBalanceGenqlSelection{
    missionType?: boolean | number
    status?: boolean | number
    historyLog?: InventoryYearEndHistoryLogGenqlSelection
    managementMethodPeriod?: ManagementMethodYearEndPeriodGenqlSelection
    closingBalance?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UnitBasedClosingBalanceInput {closingBalance: Scalars['Float']}

export interface UnitBasedNegativeOnHandsGenqlSelection{
    missionType?: boolean | number
    status?: boolean | number
    historyLog?: InventoryYearEndHistoryLogGenqlSelection
    managementMethodPeriod?: ManagementMethodYearEndPeriodGenqlSelection
    productsWithNegativeOnHands?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UnitBasedNegativeOnHandsInput {productsWithNegativeOnHands: Scalars['Int']}

export interface UnitBasedReportCogsGenqlSelection{
    missionType?: boolean | number
    status?: boolean | number
    historyLog?: InventoryYearEndHistoryLogGenqlSelection
    managementMethodPeriod?: ManagementMethodYearEndPeriodGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UnitBasedVendorsNegativeBalanceGenqlSelection{
    missionType?: boolean | number
    status?: boolean | number
    historyLog?: InventoryYearEndHistoryLogGenqlSelection
    managementMethodPeriod?: ManagementMethodYearEndPeriodGenqlSelection
    vendorsWithNegativeBalance?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UnitBasedVendorsNegativeBalanceInput {vendorsWithNegativeBalance: Scalars['Int']}

export interface UnitFoundActionGenqlSelection{
    quantity?: boolean | number
    id?: boolean | number
    date?: boolean | number
    type?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UnitLostActionGenqlSelection{
    quantity?: boolean | number
    id?: boolean | number
    date?: boolean | number
    type?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UnitsTrackingPhysicalCountGenqlSelection{
    id?: boolean | number
    companyId?: boolean | number
    amountAdjustment?: boolean | number
    lastAckAmountAdjustment?: boolean | number
    amountAdjustmentWithPendingAdjustments?: boolean | number
    date?: boolean | number
    warehouse?: WarehouseGenqlSelection
    attachments?: UnitsTrackingPhysicalCountAttachmentGenqlSelection
    closingBalance?: boolean | number
    amount?: boolean | number
    note?: boolean | number
    isDraft?: boolean | number
    deletedAt?: boolean | number
    hasUnacknowledgedChanges?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UnitsTrackingPhysicalCountAttachmentGenqlSelection{
    name?: boolean | number
    url?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UnitsTrackingPhysicalCountOverviewGenqlSelection{
    missingData?: boolean | number
    count?: boolean | number
    pendingChanges?: boolean | number
    productQuantities?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UnitsTrackingPhysicalCountProductQuantitiesGenqlSelection{
    products?: UnitsTrackingPhysicalCountProductQuantityGenqlSelection
    offset?: boolean | number
    count?: boolean | number
    hasUnacknowledgedChanges?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UnitsTrackingPhysicalCountProductQuantityGenqlSelection{
    product?: ProductGenqlSelection
    quantity?: boolean | number
    avgCost?: boolean | number
    lastAckAvgCost?: boolean | number
    quantityAdjustment?: boolean | number
    lastAckQuantityAdjustment?: boolean | number
    amountAdjustment?: boolean | number
    lastAckAmountAdjustment?: boolean | number
    unitsOnHand?: boolean | number
    lastAckUnitsOnHand?: boolean | number
    hasUnacknowledgedChanges?: boolean | number
    isPendingChange?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UnitsTrackingPhysicalCountsListGenqlSelection{
    physicalCounts?: UnitsTrackingPhysicalCountGenqlSelection
    offset?: boolean | number
    count?: boolean | number
    totalCount?: boolean | number
    minAdjustment?: boolean | number
    maxAdjustment?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UnknownIntegrationTransferAccountGenqlSelection{
    dummy?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UnknownIntegrationTransferBankGenqlSelection{
    dummy?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UnknownTransactionAccountGenqlSelection{
    vendor?: VendorGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UnknownTransactionBankGenqlSelection{
    vendor?: VendorGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UnlockCompanyV2Input {companyId: Scalars['String'],startDate: Scalars['Date'],endDate: Scalars['Date']}

export interface UnlockLoanResultGenqlSelection{
    success?: boolean | number
    message?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UnMarkOrdersAsCOGSInput {companyId: Scalars['ID'],orderIds: Scalars['ID'][]}

export interface UnMarkOrdersAsCOGSResponseGenqlSelection{
    orders?: OrderV2GenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UnMarkOrdersAsGiveawayInput {companyId: Scalars['ID'],orderIds: Scalars['ID'][]}

export interface UnMarkOrdersAsGiveawayResponseGenqlSelection{
    orders?: OrderV2GenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UnMarkOrdersAsOvercollectedInput {companyId: Scalars['ID'],orderIds: Scalars['ID'][]}

export interface UnMarkOrdersAsOvercollectedResponseGenqlSelection{
    orders?: OrderV2GenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UnMarkOrdersAsUncollectibleInput {companyId: Scalars['ID'],orderIds: Scalars['ID'][]}

export interface UnMarkOrdersAsUncollectibleResponseGenqlSelection{
    orders?: OrderV2GenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UnpaidAmountPerAffiliatedEntityGenqlSelection{
    affiliatedEntity?: AffiliatedEntityGenqlSelection
    totalSum?: boolean | number
    unpaidAmount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UnpaidAmountsViaProviderGenqlSelection{
    type?: boolean | number
    categoryGroup?: boolean | number
    amount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UnsignWorksheetRowInput {companyId: Scalars['String'],name: Scalars['String'],periodDates: PeriodDatesInput}

export interface UnvoidOrdersInput {companyId: Scalars['ID'],orderIds: Scalars['ID'][]}

export interface UnvoidOrdersResponseGenqlSelection{
    orders?: OrderV2GenqlSelection
    failedIds?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UpdateAssociatedBankTransactionsFileInput {bankTransactionId: Scalars['ID'],fileId: Scalars['ID']}

export interface UpdateAssociatedBankTransactionsFileResponseGenqlSelection{
    success?: boolean | number
    errorMessage?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UpdateAuth0UserDetailsArgs {userEmail: Scalars['String'],companyName?: (Scalars['String'] | null),userName?: (Scalars['String'] | null)}

export interface UpdateAutomergeSettingsInput {companyId: Scalars['ID'],matchGroupType: ProductMergeRecommendationsGroupType,isEnabled: Scalars['Boolean']}

export interface UpdateBalanceSheetSetupInput {companyId: Scalars['ID'],state?: (HubState | null),isUserUnresponsive?: (Scalars['Boolean'] | null),isPreviewEnabled?: (Scalars['Boolean'] | null),reason?: (Scalars['String'] | null),intercomLink?: (Scalars['String'] | null),email?: (Scalars['String'] | null),updaterType?: (HubUpdaterTypeInput | null)}

export interface UpdateBalanceSheetSetupItemInput {companyId: Scalars['ID'],itemType: BalanceSheetItemType,state?: (HubItemState | null),data?: (Scalars['JSON'] | null),reason?: (Scalars['String'] | null),updaterType?: (HubUpdaterTypeInput | null)}

export interface UpdateBalanceSheetSetupItemResponseGenqlSelection{
    success?: boolean | number
    errorMessage?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UpdateBalanceSheetSetupResponseGenqlSelection{
    success?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UpdateBankAccountBalanceAdjustmentInput {companyId: Scalars['ID'],bankAccountId: Scalars['ID'],balanceAdjustment: Scalars['Float'],balanceAdjustmentDate: Scalars['String'],actorType: BankAccountBalanceAdjustmentActorType,actorId?: (Scalars['String'] | null)}

export interface UpdateBankAccountClosingBalanceInput {companyId: Scalars['ID'],bankAccountId: Scalars['ID'],closingBalance: Scalars['Float'],closingBalanceDate: Scalars['String'],actorType: BankAccountClosingBalanceActorType,actorId?: (Scalars['String'] | null)}

export interface UpdateBankAccountInput {companyId: Scalars['ID'],id: Scalars['ID'],integrationAccountId?: (Scalars['String'] | null),currentBalance?: (Scalars['Float'] | null),lastUpdateTime?: (Scalars['Date'] | null),isHistoricalUpdateCompleted?: (Scalars['Boolean'] | null),rawData?: (Scalars['JSONObject'] | null),shouldUpdateAccountDetailsOnNextUpdate?: (Scalars['Boolean'] | null),status?: (BankAccountStatus | null),forwardTransactionsToBankAccountId?: (Scalars['String'] | null),hasNotifiedUponNoHistoricalUpdate?: (Scalars['Boolean'] | null)}

export interface UpdateBankAccountsMergeStatusInput {companyId: Scalars['ID'],suspectedDuplicationId: Scalars['ID'],fileLocationBucket: Scalars['String'],fileLocationKey: Scalars['String']}

export interface UpdateBankReconciliationRequestMessageInput {id: Scalars['ID'],companyId: Scalars['ID'],message?: (Scalars['String'] | null)}

export interface UpdateBankReconciliationRequestStatusInput {id: Scalars['ID'],companyId: Scalars['ID'],status: BankStatementRequestStatus}

export interface UpdateBankStatementFileProcessingLogsInput {companyId: Scalars['ID'],fileId: Scalars['String'],originFileId?: (Scalars['String'] | null),processingLog: BankStatementFileProcessingLogInput,status: BankStatementFileStatus}

export interface UpdateBankStatementParsingResultStatus {id?: (Scalars['ID'] | null),companyId: Scalars['ID'],bankTransactionsUploadId?: (Scalars['String'] | null),bankStatementFileId?: (Scalars['String'] | null),status: BankStatementParsingResultStatus}

export interface UpdateBankTransactionMemoInput {companyId: Scalars['ID'],bankTransactionId: Scalars['ID'],text: Scalars['String']}

export interface UpdateBooksStartTimeArgs {companyId: Scalars['String'],booksStartTime: Scalars['Date']}

export interface UpdateCommentsInput {companyId: Scalars['String'],name: Scalars['String'],comment?: (Scalars['String'] | null),attachmentUrl?: (Scalars['String'] | null),attachmentFileName?: (Scalars['String'] | null),periodDates: PeriodDatesInput}

export interface UpdateCompaniesDomainStateInput {domain: YearEndDomainTypes,year: Scalars['Int'],companiesState: CompanyDomainState[]}

export interface UpdateCompanyAccountingMethodArgs {companyId: Scalars['String'],accountingMethod: CustomerSelectedAccountingMethod,flow?: (Scalars['String'] | null)}

export interface UpdateCompanyAffiliateInput {id: Scalars['ID'],companyId: Scalars['ID'],name: Scalars['String'],isForeignResident?: (Scalars['Boolean'] | null),holdingsInPercentage?: (Scalars['Float'] | null),status?: (HolderStatus | null)}

export interface UpdateCompanyDomainStateResponseGenqlSelection{
    companyId?: boolean | number
    yearEndDomainStateId?: boolean | number
    updateCheck?: boolean | number
    state?: boolean | number
    details?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UpdateCompanyFundedStatusInput {companyId: Scalars['ID'],hideBanner: Scalars['Boolean']}

export interface UpdateCompanyInput {companyId: Scalars['ID'],onboardingState?: (OnboardingStateInput | null),estimatedProjectedRevenue?: (EstimatedProjectedRevenue | null),phoneNumber?: (Scalars['String'] | null),isOnboardingCompleted?: (Scalars['Boolean'] | null),appsSelectedInPreOnboarding?: (Scalars['String'][] | null),referralCode?: (Scalars['String'] | null)}

export interface UpdateCompanyLoansInput {companyId: Scalars['ID'],loanIds: Scalars['ID'][],data: LoanUpdateBasicData}

export interface UpdateCompanyLoansResponseGenqlSelection{
    loans?: LoanGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UpdateCompanyNamesAndNotifyHandlerInput {companyId: Scalars['ID'],userName: Scalars['String'],companyName: Scalars['String'],estimatedProjectedRevenue?: (EstimatedProjectedRevenue | null),phoneNumber?: (Scalars['String'] | null),appsSelectedInPreOnboarding?: (Scalars['String'][] | null),referralCode?: (Scalars['String'] | null),accountingServices?: (AccountingServicesTypes | null),demo?: (Scalars['String'] | null),preOnboardingFunnelType?: (Scalars['String'] | null)}

export interface UpdateCompanyPayingStatusInput {companyId: Scalars['String'],isPaying: Scalars['Boolean']}

export interface UpdateCompanyTierInput {companyId: Scalars['String'],tier: CompanyTier}

export interface UpdateCompanyVendorExternalSourceIdVendorInput {id: Scalars['ID'],companyId: Scalars['ID'],externalSourceId: Scalars['String']}

export interface UpdateCustomerArgs {id: Scalars['String'],name: Scalars['String'],companyName?: (Scalars['String'] | null),externalSourceId?: (Scalars['String'] | null),source: CustomerSource,email?: (Scalars['String'] | null),phoneNumber?: (Scalars['String'] | null),billingAddress?: (AddressArgs | null),shippingAddress?: (AddressArgs | null)}

export interface UpdatedLoansGenqlSelection{
    loans?: LoanGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UpdateEmployeesOfficerStatusChange {employeeId: Scalars['ID'],isOfficer: Scalars['Boolean']}

export interface UpdateEmployeesOfficerStatusInput {companyId: Scalars['ID'],changes: UpdateEmployeesOfficerStatusChange[]}

export interface UpdateEstimatedProjectedRevenueInput {companyId: Scalars['String'],estimatedProjectedRevenue: EstimatedProjectedRevenue}

export interface UpdateExpression {impactOnBooksSince: Scalars['String']}

export interface UpdateGlobalVendorLogo {id: Scalars['ID'],logoUrl?: (Scalars['String'] | null)}

export interface UpdateGlobalVendorLogoInput {id: Scalars['ID'],logoUrl: Scalars['String']}

export interface UpdateInstitutionDataConfigInput {institutionId: Scalars['ID'],dataConfig: Scalars['JSONObject']}

export interface UpdateInstitutionInput {id: Scalars['ID'],name?: (Scalars['String'] | null),preferredProvider?: (InstitutionProviders | null),isMajor?: (Scalars['String'] | null),logoUrl?: (Scalars['String'] | null),websiteUrl?: (Scalars['String'] | null),csvInstructionsLink?: (Scalars['String'] | null),pdfInstructionsLink?: (Scalars['String'] | null),csvAvailable?: (Scalars['Boolean'] | null),pdfAvailable?: (Scalars['Boolean'] | null)}

export interface UpdateInstitutionMappingInput {id: Scalars['ID'],source?: (InstitutionMappingSourceType | null),externalSourceId?: (Scalars['String'] | null),externalSourceName?: (Scalars['String'] | null),institutionId?: (Scalars['String'] | null)}

export interface UpdateInternalLoanInput {companyId: Scalars['ID'],loanId: Scalars['ID'],data: LoanUpdateData,merchantRole?: (CompanyAffiliateType | null)}

export interface UpdateInventoryPaymentGroupInput {id?: (Scalars['ID'] | null),companyId: Scalars['ID'],postedAt: Scalars['Date'],affiliatedEntityId: Scalars['ID'],purchaseOrders: PaymentGroupPurchaseOrderToLinkInput[],warehouseTransfers: PaymentGroupWarehouseTransferToLinkInput[],inventoryPurchases: PaymentGroupInventoryPurchasesToLinkInput[],manualAssemblies: PaymentGroupManualAssemblyCostsToLinkInput[],onDemandAssemblyVendorCosts: PaymentGroupOnDemandAssemblyVendorCostsToLinkInput[]}

export interface UpdateInventoryPaymentGroupResponseGenqlSelection{
    inventoryPaymentGroup?: InventoryPaymentGroupGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UpdateInventoryPurchaseResponseGenqlSelection{
    on_InventoryPurchase?:InventoryPurchaseGenqlSelection,
    on_InventoryPurchaseUpdateOutOfDateError?:InventoryPurchaseUpdateOutOfDateErrorGenqlSelection,
    __typename?: boolean | number
}

export interface UpdateInventoryYearEndMissionInput {companyId: Scalars['ID'],missions: MissionStateInput[]}

export interface UpdateInvoicePaymentGroupInput {id: Scalars['ID'],companyId: Scalars['ID'],postedAt: Scalars['Date'],invoices: PaymentGroupInvoiceToLinkInput[],bankTransactions: PaymentGroupBankTransactionToLinkInput[],expenses: PaymentGroupExpenseInput[],actorType?: (ActorType | null)}

export interface UpdateInvoicePaymentGroupResponseGenqlSelection{
    paymentGroup?: InvoicePaymentGroupGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UpdateLoanAttachmentInput {id?: (Scalars['ID'] | null),fileName?: (Scalars['String'] | null),url?: (Scalars['String'] | null),type?: (LoanAttachmentType | null)}

export interface UpdateLoanAttachmentsInput {companyId: Scalars['ID'],loanId: Scalars['ID'],attachments: UpdateLoanAttachmentInput[]}

export interface UpdateLoanInput {companyId: Scalars['ID'],loanId: Scalars['ID'],data: LoanUpdateBasicData}

export interface UpdateLoanManualAccountingEventInput {companyId: Scalars['ID'],loanId: Scalars['ID'],accountingEventId: Scalars['ID'],amount: Scalars['Float'],memo: Scalars['String']}

export interface UpdateLoansInput {loans: UpdateLoansInputLoan[],data: LoanUpdateData}

export interface UpdateLoansInputLoan {companyId: Scalars['ID'],loanId: Scalars['ID']}

export interface UpdateManualAssemblyInput {companyId: Scalars['ID'],id?: (Scalars['String'] | null),productId: Scalars['String'],displayName?: (Scalars['String'] | null),date: Scalars['Date'],warehouseId: Scalars['String'],unitsToAssemble: Scalars['Int'],recipe: UpdateRecipeInput}

export interface UpdateManualAssemblyResultGenqlSelection{
    on_ManualAssembly?:ManualAssemblyGenqlSelection,
    on_RecipeCirclesFoundError?:RecipeCirclesFoundErrorGenqlSelection,
    on_RecipeAllocatedCostsError?:RecipeAllocatedCostsErrorGenqlSelection,
    __typename?: boolean | number
}

export interface UpdateManualLoanEventInput {companyId: Scalars['ID'],loanId: Scalars['ID'],loanEventId: Scalars['ID'],eventDefinitionId: Scalars['ID'],amount: Scalars['Float'],memo?: (Scalars['String'] | null),postedAt: Scalars['Date']}

export interface UpdateManualLoanEventInput2 {companyId: Scalars['ID'],loanId: Scalars['ID'],loanEventId: Scalars['ID'],eventDefinitionId: Scalars['ID'],amount: Scalars['Float'],memo?: (Scalars['String'] | null),postedAt?: (Scalars['Date'] | null),recurrenceSettings: RecurrenceSettingsInput,spreadInput?: (CreateManualLoanEventSpreadInput | null)}

export interface UpdateManualLoanEventResultGenqlSelection{
    loan?: LoanGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UpdateManualLoanEventsResultGenqlSelection{
    loan?: LoanGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UpdateNoUnitsPhysicalCountAttachmentInput {name: Scalars['String'],url: Scalars['String']}

export interface UpdateNoUnitsPhysicalCountInput {id?: (Scalars['String'] | null),amount: Scalars['Float'],date: Scalars['Date'],companyId: Scalars['String'],lastAckDiff: Scalars['Float'],lastAckClosingBalance: Scalars['Float'],attachments?: (UpdateNoUnitsPhysicalCountAttachmentInput[] | null),note?: (Scalars['String'] | null),isDraft: Scalars['Boolean']}

export interface UpdateNoUnitsPhysicalCountProductQuantityPendingAdjustmentInput {productId: Scalars['String'],quantity: Scalars['Float']}

export interface UpdateNoUnitsPhysicalCountProductQuantityPendingAdjustmentsInput {physicalCountId: Scalars['String'],companyId: Scalars['String'],adjustments: UpdateNoUnitsPhysicalCountProductQuantityPendingAdjustmentInput[]}

export interface UpdateOnboardingStatusInput {companyId: Scalars['ID'],scope: OnboardingScope,step: Scalars['String'],status: OnboardingStepStatus}

export interface UpdateOnDemandAssemblyCostsInput {companyId: Scalars['ID']}

export interface UpdateOrderEntitiesInput {entityType: OrderEntityType,companyId: Scalars['String'],entityIds: Scalars['ID'][]}

export interface UpdateOrderGroupInput {id: Scalars['ID'],companyId: Scalars['ID'],postedAt: Scalars['Date'],orders: OrderToLinkInput[],bankTransactions: BankTransactionToLinkInput[],expenses: OrderGroupExpenseInput[]}

export interface UpdateOrderGroupResponseGenqlSelection{
    orderGroup?: OrderGroupGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UpdateOrderPaymentGroupInput {id: Scalars['ID'],companyId: Scalars['ID'],postedAt: Scalars['Date'],orders: PaymentGroupOrderToLinkInput[],bankTransactions: PaymentGroupBankTransactionToLinkInput[],expenses: PaymentGroupExpenseInput[]}

export interface UpdateOrderPaymentGroupResponseGenqlSelection{
    paymentGroup?: OrderPaymentGroupGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UpdatePayrollSettingsInput {companyId: Scalars['ID'],withCategoryMapping: Scalars['Boolean'],categoryMappingMode: PayrollCategoryMappingMode,categoryMappings: PayrollCategoryMappingInput[]}

export interface UpdateProductFractionalInput {companyId: Scalars['String'],productId: Scalars['String'],isFractional: Scalars['Boolean']}

export interface UpdateProductInput {companyId: Scalars['String'],productId: Scalars['String'],displayName: Scalars['String'],imageUrl?: (Scalars['String'] | null)}

export interface UpdateRecipeInput {companyId: Scalars['ID'],id?: (Scalars['String'] | null),from?: (Scalars['Date'] | null),to?: (Scalars['Date'] | null),isAssembledOnDemand: Scalars['Boolean'],productId: Scalars['String'],warehouseId?: (Scalars['String'] | null),components: RecipeComponentInput[],allocatedCosts: RecipeAllocatedCostInput[],managementMethod: RecipeManagementMethod,displayName?: (Scalars['String'] | null)}

export interface UpdateRecipeResultGenqlSelection{
    on_Recipe?:RecipeGenqlSelection,
    on_RecipeCirclesFoundError?:RecipeCirclesFoundErrorGenqlSelection,
    on_RecipeOverlappingError?:RecipeOverlappingErrorGenqlSelection,
    on_RecipeAllocatedCostsError?:RecipeAllocatedCostsErrorGenqlSelection,
    __typename?: boolean | number
}

export interface UpdateSalesChannelInput {id: Scalars['ID'],companyId: Scalars['ID'],financialReportingStatus?: (FinancialReportingStatus | null),periods?: (SalesChannelPeriodInput[] | null)}

export interface UpdateSharedGoogleDriveFolder {companyId: Scalars['ID'],folderId: Scalars['ID'],folderName: Scalars['String'],folderUrl: Scalars['String']}

export interface UpdateUnitsTrackingPhysicalCountAttachmentInput {name: Scalars['String'],url: Scalars['String']}

export interface UpdateUnitsTrackingPhysicalCountInput {id?: (Scalars['ID'] | null),date: Scalars['Date'],warehouseId: Scalars['String'],companyId: Scalars['String'],attachments?: (UpdateUnitsTrackingPhysicalCountAttachmentInput[] | null),note?: (Scalars['String'] | null),isDraft: Scalars['Boolean'],lastAckClosingBalance?: (Scalars['Float'] | null)}

export interface UpdateUnitsTrackingPhysicalCountProductQuantityPendingAdjustmentInput {productId: Scalars['String'],quantity: Scalars['Float']}

export interface UpdateUnitsTrackingPhysicalCountProductQuantityPendingAdjustmentsInput {companyId: Scalars['String'],physicalCountId: Scalars['String'],adjustments: UpdateUnitsTrackingPhysicalCountProductQuantityPendingAdjustmentInput[]}

export interface UpdateUserDetailsArgs {id: Scalars['ID'],email?: (Scalars['String'] | null),name?: (Scalars['String'] | null),auth0Id?: (Scalars['String'] | null),welcomeReportTransactionsMessageMarkedAsHiddenAt?: (Scalars['Date'] | null)}

export interface UpdateUserDetailsResponseGenqlSelection{
    user?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UpdateUserRolesForCompanyArgs {email: Scalars['String'],roles: Scalars['String'][],companyId: Scalars['String']}

export interface UpdateUserRolesForCompanyResponseGenqlSelection{
    success?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UpdateVendorInput {id: Scalars['ID'],companyId: Scalars['ID'],source: VendorSource,name?: (Scalars['String'] | null),logoUrl?: (Scalars['String'] | null),labels?: (Scalars['String'][] | null),subTypes?: (VendorSubType[] | null),is1099Contractor?: (Scalars['Boolean'] | null),externalSourceId?: (Scalars['String'] | null),contactEmail?: (Scalars['String'] | null)}

export interface UpdateWarehouseFieldsInput {name?: (Scalars['String'] | null),phone?: (Scalars['String'] | null),city?: (Scalars['String'] | null),province?: (Scalars['String'] | null),country?: (Scalars['String'] | null),zip?: (Scalars['String'] | null),address?: (Scalars['String'] | null),isDefault?: (Scalars['Boolean'] | null),isActive?: (Scalars['Boolean'] | null),userGivenName?: (Scalars['String'] | null),isDropshipping?: (Scalars['Boolean'] | null)}

export interface UpdateWarehouseInput {id: Scalars['String'],companyId: Scalars['String'],updateFields: UpdateWarehouseFieldsInput}

export interface UpdateWarehouseNegativesAdjustmentInput {id?: (Scalars['ID'] | null),companyId: Scalars['ID'],productId: Scalars['String'],warehouseId: Scalars['String'],totalQuantity: Scalars['Float'],costPerUnit: Scalars['Float'],startDate: Scalars['Date'],endDate: Scalars['Date'],datesToFix: DatesToFixInput[]}

export interface UpdateWarehousesDefaultsInput {companyId: Scalars['ID'],defaults: WarehousesDefaultsInput[]}

export interface UpdateWarehouseTransferInput {id: Scalars['String'],companyId: Scalars['String'],serialNumber?: (Scalars['Int'] | null),displayName?: (Scalars['String'] | null),transit?: (WarehouseTransferTransitInput | null),lineItems: WarehouseTransferLineItemInput[],costLineItems: WarehouseTransferCostLineItemInput[],attachments: WarehouseTransferAttachmentInput[],notes?: (Scalars['String'] | null)}

export interface UploadBankStatementInput {companyId: Scalars['ID'],bankAccountId: Scalars['ID'],s3Bucket: Scalars['String'],s3Key: Scalars['String'],fileName: Scalars['String'],fileType: BankAccountStatementFileType,system: BankStatementFileSystem,subSystem: BankStatementFileSubSystem,validationProvider: BankStatementFilesValidationProvider,uploadedBy?: (Scalars['String'] | null)}

export interface UploadBankStatementResponseGenqlSelection{
    id?: boolean | number
    companyId?: boolean | number
    bankAccount?: BankAccountGenqlSelection
    providerValidationResults?: BankStatementValidationResultsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UploadedInvoiceGenqlSelection{
    invoiceNumber?: boolean | number
    externalSourceId?: boolean | number
    invoiceId?: boolean | number
    error?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UploadFileToBankReconciliationRequestInput {companyId: Scalars['ID'],requestId: Scalars['ID'],statementFile: StatementFile,originalFileId?: (Scalars['String'] | null),isAutomaticProcessing?: (Scalars['Boolean'] | null)}

export interface UploadInvoicesFromCSVInput {companyId: Scalars['String'],csvLink: Scalars['String'],shouldCreateInvoices: Scalars['Boolean'],newSource?: (NewSourceInput | null),newCompanyIntegration?: (NewCompanyIntegrationInput | null),existingCompanyIntegration?: (ExistingCompanyIntegrationInput | null),fileExportDate: Scalars['String']}

export interface UploadReportedTransactionsInput {companyId: Scalars['ID'],bankAccountId: Scalars['String'],statementFiles: StatementFile[],companyAffiliateType: CompanyAffiliateType,companyAffiliateId: Scalars['String']}

export interface UpsertAccrualInput {companyId: Scalars['ID'],entityType: AccrualEntityType,entityId: Scalars['ID'],accrualsData: AccrualDataInput[],categorizations?: (AccrualCategorizationInput[] | null)}

export interface UpsertBankTransactionLocalRuleInput {companyId: Scalars['ID'],bankTransactionId: Scalars['ID'],classification?: (BankTransactionClassificationInput | null),classifications?: (BankTransactionClassificationInput[] | null),moneyDirection: SimpleMoneyDirection,merchant: MerchantInput,shouldAlwaysApplyMerchant: Scalars['Boolean'],shouldAlwaysApplyClassification: Scalars['Boolean']}

export interface UpsertCompanyAddressInput {id?: (Scalars['ID'] | null),companyId: Scalars['ID'],isDefault: Scalars['Boolean'],deactivatedAt?: (Scalars['Date'] | null),name: Scalars['String'],source: Scalars['String'],email: Scalars['String'],phone?: (Scalars['String'] | null),line1: Scalars['String'],line2?: (Scalars['String'] | null),city: Scalars['String'],province?: (Scalars['String'] | null),provinceCode?: (Scalars['String'] | null),state?: (Scalars['String'] | null),stateCode?: (Scalars['String'] | null),country: Scalars['String'],zip?: (Scalars['String'] | null),finaloopSubjectId?: (Scalars['String'] | null)}

export interface UpsertCustomerAddressArgs {id?: (Scalars['String'] | null),customerId: Scalars['String'],companyId: Scalars['String'],line1: Scalars['String'],line2?: (Scalars['String'] | null),city: Scalars['String'],country: Scalars['String'],countryCode?: (Scalars['String'] | null),province?: (Scalars['String'] | null),provinceCode?: (Scalars['String'] | null),zip?: (Scalars['String'] | null),state?: (Scalars['String'] | null),stateCode?: (Scalars['String'] | null),source: CustomerSource,integrationAccountId?: (Scalars['String'] | null),isBilling?: (Scalars['Boolean'] | null),isShipping?: (Scalars['Boolean'] | null),deletedAt?: (Scalars['Date'] | null)}

export interface UpsertCustomerV2Args {id?: (Scalars['String'] | null),affiliatedEntityId?: (Scalars['String'] | null),companyId: Scalars['String'],name: Scalars['String'],email: Scalars['String'],source: CustomerSource,integrationAccountId: Scalars['String'],billingAddress?: (CustomerAddressArgs | null),shippingAddress?: (CustomerAddressArgs | null),billingIsSameAsShipping?: (Scalars['Boolean'] | null)}

export interface UpsertGlobalVendorInput {id: Scalars['ID'],name?: (Scalars['String'] | null),source?: (VendorSource | null),websiteUrl?: (Scalars['String'] | null),labels?: (Scalars['String'][] | null)}

export interface UpsertHolderCapitalInvestmentInput {id?: (Scalars['ID'] | null),holderId?: (Scalars['ID'] | null),companyId: Scalars['ID'],amount?: (Scalars['Float'] | null)}

export interface UpsertHolderShareInput {id?: (Scalars['ID'] | null),companyId: Scalars['ID'],holderId?: (Scalars['ID'] | null),type: ShareType,series?: (Scalars['String'] | null),amount?: (Scalars['Float'] | null),parValue?: (Scalars['Float'] | null),quantity?: (Scalars['Int'] | null)}

export interface UpsertIntegrationCustomerArgs {id?: (Scalars['String'] | null),companyId: Scalars['String'],name: Scalars['String'],email: Scalars['String'],source: CustomerSource,integrationAccountId: Scalars['String'],finaloopSubjectId?: (Scalars['String'] | null)}

export interface UpsertIntegrationInvoiceInput {companyId: Scalars['ID'],companyAddress: IntegrationCompanyAddressInput,shippingAddress?: (IntegrationCustomerAddressInput | null),billingAddress?: (IntegrationCustomerAddressInput | null),customer: IntegrationCustomerInput,payments: IntegrationTransactionInput[],refunds: IntegrationTransactionInput[],paymentIndications: IntegrationIndicativeTransactionInput[],refundIndications: IntegrationIndicativeTransactionInput[],credits: IntegrationTransactionInput[],externalSourceId: Scalars['ID'],externalSourceUrl: Scalars['String'],source: IntegrationSource,integrationAccountId: Scalars['String'],integrationAccountName: Scalars['String'],displayName: Scalars['String'],postedAt: Scalars['Date'],dueDate?: (Scalars['Date'] | null),taxFixedAmount: Scalars['Float'],lineItems: IntegrationSaleLineItemInput[],discounts: IntegrationDiscountInput[],customerNote?: (Scalars['String'] | null),issueInvoice?: (Scalars['Boolean'] | null),voidedAt?: (Scalars['Date'] | null),uncollectibleAt?: (Scalars['Date'] | null),deletedAt?: (Scalars['Date'] | null),currency: CurrencyCode}

export interface UpsertInvoiceInput {id?: (Scalars['ID'] | null),companyId: Scalars['ID'],companyAddressId: Scalars['ID'],customerId: Scalars['ID'],shippingAddressId?: (Scalars['ID'] | null),billingAddressId?: (Scalars['ID'] | null),displayName?: (Scalars['String'] | null),postedAt: Scalars['Date'],dueDate?: (Scalars['Date'] | null),taxFixedAmount: Scalars['Float'],taxType?: (SaleTaxType | null),lineItems: SaleLineItemInput[],discounts: DiscountInput[],paymentMethodIds: Scalars['ID'][],customerNote?: (Scalars['String'] | null),issueInvoice?: (Scalars['Boolean'] | null),sendInvoice?: (Scalars['Boolean'] | null),createPaymentLink?: (Scalars['Boolean'] | null),source?: (SaleSource | null),currency: CurrencyCode,uploadId?: (Scalars['String'] | null),uploadDate?: (Scalars['Date'] | null),emailNote?: (Scalars['String'] | null),ccList?: (Scalars['String'][] | null),purchaseOrderNumber?: (Scalars['String'] | null)}

export interface UpsertInvoiceSettingsInput {companyId: Scalars['ID'],logoImageLocation?: (Scalars['String'] | null),currentAutoInvoiceNumber?: (Scalars['Int'] | null)}

export interface UpsertManualEquityEventInput {id?: (Scalars['ID'] | null),holderId?: (Scalars['ID'] | null),companyId: Scalars['ID'],amount: Scalars['Float'],businessEvent: Scalars['String'],configurationId: Scalars['ID'],memo?: (Scalars['String'] | null),postedAt: Scalars['Date']}

export interface UpsertPaymentMethodInput {id?: (Scalars['ID'] | null),companyId: Scalars['ID'],type: PaymentMethodType,isDefault: Scalars['Boolean'],deletedAt?: (Scalars['Date'] | null),instructions?: (Scalars['String'] | null),bankName?: (Scalars['String'] | null),accountNumber?: (Scalars['String'] | null),routingNumber?: (Scalars['String'] | null),swift?: (Scalars['String'] | null),source?: (Scalars['String'] | null),integrationAccountId?: (Scalars['String'] | null)}

export interface UserGenqlSelection{
    id?: boolean | number
    email?: boolean | number
    auth0Id?: boolean | number
    name?: boolean | number
    companies?: UserCompaniesGenqlSelection
    permissions?: PermissionGenqlSelection
    globalRole?: boolean | number
    welcomeReportTransactionsMessageMarkedAsHiddenAt?: boolean | number
    intercomJwt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UserAttachTransactionsToExistingLoanInput {companyId: Scalars['ID'],loanId: Scalars['ID'],transactions: AttachTransactionToCompanyLoanTransactionInput[]}

export interface UserAttachTransactionsToLoansInput {companyId: Scalars['ID'],transactions: TransactionWithMultipleClassificationsInput[],newLoans: UserAttachTransactionsToNewLoanData[]}

export interface UserAttachTransactionsToNewLoanData {loanId?: (Scalars['ID'] | null),lenderId: Scalars['String'],amount: Scalars['Float'],postedAt: Scalars['Date'],direction: LoanDirection,isShortTerm: Scalars['Boolean'],type: LoanType,userActionStatus: LoanUserActionStatus}

export interface UserAttachTransactionsToNewLoanInput {companyId: Scalars['ID'],transactions: AttachTransactionToCompanyLoanTransactionInput[],merchant: LoanMerchantInput,newLoanData: UserAttachTransactionsToNewLoanData}

export interface UserByEmailArgs {email: Scalars['String']}

export interface UserByEmailResponseGenqlSelection{
    user?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UserCompaniesGenqlSelection{
    company?: CompanyGenqlSelection
    roles?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UserFollowUpGenqlSelection{
    type?: boolean | number
    data?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UserFollowUpInput {type: LoanUserFollowUpType,data?: (Scalars['JSONObject'] | null)}

export interface userIdInput {email: Scalars['String']}

export interface UserInvitationGenqlSelection{
    id?: boolean | number
    email?: boolean | number
    companyId?: boolean | number
    roles?: boolean | number
    invitedByUserId?: boolean | number
    invitationCode?: boolean | number
    acceptedAt?: boolean | number
    cancelledBy?: boolean | number
    cancelledAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UserInvitationArgs {invitationCode: Scalars['String']}

export interface UserInvitationResponseGenqlSelection{
    userInvitation?: UserInvitationWithCompanyGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UserInvitationsByEmailArgs {email: Scalars['String']}

export interface UserInvitationsByEmailResponseGenqlSelection{
    userInvitations?: UserInvitationWithCompanyGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UserInvitationWithCompanyGenqlSelection{
    id?: boolean | number
    email?: boolean | number
    company?: CompanyGenqlSelection
    roles?: boolean | number
    invitedByUserId?: boolean | number
    invitationCode?: boolean | number
    acceptedAt?: boolean | number
    cancelledBy?: boolean | number
    cancelledAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UserManualProductGenqlSelection{
    id?: boolean | number
    companyId?: boolean | number
    finaloopId?: boolean | number
    lineOfBusinessId?: boolean | number
    sku?: boolean | number
    price?: boolean | number
    displayName?: boolean | number
    imageUrl?: boolean | number
    listedChannels?: SalesChannelGenqlSelection
    appliedCosts?: ProductAppliedCostGenqlSelection
    dailySalesData?: (SalesChannelDailySalesDataGenqlSelection & { __args: {timeRange: ProductDataTimeRangeInput} })
    totalSold?: boolean | number
    avgCostPerUnit?: boolean | number
    canEditLatestAppliedCost?: boolean | number
    isFractional?: boolean | number
    isHidden?: boolean | number
    salesData?: (SalesDataGenqlSelection & { __args: {timeRange: ProductDataTimeRangeInput} })
    rawRecipes?: (RecipeGenqlSelection & { __args: {timeRange: ProductDataTimeRangeInput} })
    componentOfProducts?: ProductGenqlSelection
    isAmbiguousSku?: boolean | number
    analyticsOverview?: (ProductAnalyticsOverviewGenqlSelection & { __args?: {input?: (AnalyticsOverviewInput | null)} })
    warehousesAnalyticsOverview?: (ProductWarehousesAnalyticsOverviewGenqlSelection & { __args?: {input?: (AnalyticsOverviewInput | null)} })
    tags?: boolean | number
    isDataSyncing?: boolean | number
    mergeHistory?: ProductMergeHistoryItemGenqlSelection
    isDropshipping?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UserNameFromReferralCodeInput {referralCode: Scalars['String']}

export interface UserNameFromReferralCodeResponseGenqlSelection{
    userName?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UserReferralLinkArgs {companyId: Scalars['String']}

export interface UserReferralLinkResponseGenqlSelection{
    referralLink?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UserRoleGenqlSelection{
    id?: boolean | number
    name?: boolean | number
    description?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UserRolesResponseGenqlSelection{
    userRoles?: UserRoleGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UsersByEmailsArgs {emails: Scalars['String'][]}

export interface UsersByEmailsResponseGenqlSelection{
    users?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UserUnresponsiveGenqlSelection{
    value?: boolean | number
    history?: BooleanChangeLogGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ValidateInventoryPaymentGroupByEntityInput {companyId: Scalars['ID'],purchaseOrderId?: (Scalars['String'] | null),warehouseTransferId?: (Scalars['String'] | null),inventoryPurchaseId?: (Scalars['String'] | null),bankTransactionId?: (Scalars['String'] | null),billId?: (Scalars['String'] | null),payrollId?: (Scalars['String'] | null),perVendorBreakdown: PerVendorBreakdownInput[]}

export interface ValidateInventoryPaymentGroupByEntityResponseGenqlSelection{
    canceledInventoryPaymentGroups?: InventoryPaymentGroupGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ValidateInventoryPaymentGroupOnEntityChangeInput {companyId: Scalars['ID'],purchaseOrderId?: (Scalars['ID'] | null),warehouseTransferId?: (Scalars['ID'] | null),inventoryPurchaseId?: (Scalars['ID'] | null),manualAssemblyId?: (Scalars['ID'] | null),onDemandAssemblyVendorCostId?: (Scalars['ID'] | null)}

export interface ValidationGenqlSelection{
    id?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ValidationCycleGenqlSelection{
    id?: boolean | number
    status?: boolean | number
    executionId?: boolean | number
    finishedCount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ValidationFailingCompanyGenqlSelection{
    company?: CompanyGenqlSelection
    fiscalYear?: boolean | number
    createdAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ValidationRemediationGenqlSelection{
    company?: CompanyGenqlSelection
    status?: boolean | number
    validationFiscalYear?: boolean | number
    buggyDateStatus?: boolean | number
    buggyDate?: boolean | number
    bugDescription?: boolean | number
    updatedAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ValidationRemediationsResponseGenqlSelection{
    validationRemediations?: ValidationRemediationGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ValidationResultGenqlSelection{
    companyId?: boolean | number
    integrationType?: boolean | number
    integrationAccountId?: boolean | number
    integrationAccountName?: boolean | number
    currency?: boolean | number
    accountRoles?: boolean | number
    accountingMethod?: boolean | number
    resultSet?: ValidationResultSetGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ValidationResultSetGenqlSelection{
    createdAt?: boolean | number
    sampleDate?: boolean | number
    sampleValue?: boolean | number
    currentValue?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ValidationsArgs {integrationType?: (Scalars['String'] | null),accountRole?: (Scalars['String'] | null),resultsLimit?: (Scalars['Int'] | null),payingCompaniesOnly?: (Scalars['Boolean'] | null)}

export interface ValidationTemplateGenqlSelection{
    id?: boolean | number
    domain?: boolean | number
    type?: boolean | number
    endTime?: boolean | number
    isEnabled?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface VendorGenqlSelection{
    id?: boolean | number
    integrationType?: boolean | number
    name?: boolean | number
    companyId?: boolean | number
    externalSourceId?: boolean | number
    websiteUrl?: boolean | number
    logoUrl?: boolean | number
    source?: boolean | number
    labels?: boolean | number
    contactEmail?: boolean | number
    is1099Contractor?: boolean | number
    type?: boolean | number
    subType?: boolean | number
    affiliatedEntityId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface VendorByAffiliatedEntityIdInput {affiliatedEntityId: Scalars['ID']}

export interface VendorByIdInput {id: Scalars['ID']}

export interface VendorByNameInput {name: Scalars['String'],companyId?: (Scalars['ID'] | null)}

export interface VendorByPaymentGatewayInput {paymentGateway: Scalars['String']}

export interface VendorByPaymentGatewayResponseGenqlSelection{
    vendor?: VendorGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface VendorNotExistErrorGenqlSelection{
    message?: boolean | number
    id?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface VendorOrCustomerGenqlSelection{
    on_Vendor?:VendorGenqlSelection,
    on_CustomerV2?:CustomerV2GenqlSelection,
    __typename?: boolean | number
}

export interface VendorsByIntegrationTypeInput {integrationType: Scalars['String'][]}

export interface VendorsInput {searchTerm?: (Scalars['String'] | null),limit?: (Scalars['Int'] | null),companyId: Scalars['ID'],subTypes?: (VendorSubType[] | null)}

export interface VendorsNotificationInfoInput {subTypes?: (VendorSubType[] | null),purchaseOrderId?: (Scalars['String'] | null),purchaseOrderGroup?: (Scalars['String'] | null),logrocketSessionUrl?: (Scalars['String'] | null)}

export interface VendorsTransactionsCountGenqlSelection{
    id?: boolean | number
    amount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface VoidOrderSettingsGenqlSelection{
    restrictedPaymentGateways?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface VoidOrdersInput {companyId: Scalars['ID'],orderIds: Scalars['ID'][]}

export interface VoidOrdersResponseGenqlSelection{
    orders?: OrderV2GenqlSelection
    failedIds?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WalmartProductGenqlSelection{
    id?: boolean | number
    companyId?: boolean | number
    finaloopId?: boolean | number
    lineOfBusinessId?: boolean | number
    sku?: boolean | number
    price?: boolean | number
    displayName?: boolean | number
    imageUrl?: boolean | number
    listedChannels?: SalesChannelGenqlSelection
    appliedCosts?: ProductAppliedCostGenqlSelection
    dailySalesData?: (SalesChannelDailySalesDataGenqlSelection & { __args: {timeRange: ProductDataTimeRangeInput} })
    totalSold?: boolean | number
    avgCostPerUnit?: boolean | number
    canEditLatestAppliedCost?: boolean | number
    walmartId?: boolean | number
    productUrl?: boolean | number
    isFractional?: boolean | number
    isHidden?: boolean | number
    salesData?: (SalesDataGenqlSelection & { __args: {timeRange: ProductDataTimeRangeInput} })
    rawRecipes?: (RecipeGenqlSelection & { __args: {timeRange: ProductDataTimeRangeInput} })
    componentOfProducts?: ProductGenqlSelection
    isAmbiguousSku?: boolean | number
    analyticsOverview?: (ProductAnalyticsOverviewGenqlSelection & { __args?: {input?: (AnalyticsOverviewInput | null)} })
    warehousesAnalyticsOverview?: (ProductWarehousesAnalyticsOverviewGenqlSelection & { __args?: {input?: (AnalyticsOverviewInput | null)} })
    tags?: boolean | number
    isCreatedManually?: boolean | number
    isDataSyncing?: boolean | number
    mergeHistory?: ProductMergeHistoryItemGenqlSelection
    isDropshipping?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WarehouseGenqlSelection{
    id?: boolean | number
    companyId?: boolean | number
    name?: boolean | number
    source?: boolean | number
    phone?: boolean | number
    city?: boolean | number
    province?: boolean | number
    country?: boolean | number
    zip?: boolean | number
    address?: boolean | number
    isDeletable?: boolean | number
    isActive?: boolean | number
    primaryWarehouse?: WarehouseGenqlSelection
    isDropshipping?: boolean | number
    isDropshippingFrom?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WarehouseActionGenqlSelection{
    quantity?: boolean | number
    id?: boolean | number
    date?: boolean | number
    type?: boolean | number
    on_AdjustmentRestockingAction?: AdjustmentRestockingActionGenqlSelection
    on_CommonAction?: CommonActionGenqlSelection
    on_DeadInventoryAction?: DeadInventoryActionGenqlSelection
    on_FulfillmentAction?: FulfillmentActionGenqlSelection
    on_ManualAssemblyAction?: ManualAssemblyActionGenqlSelection
    on_OnDemandAssemblyAction?: OnDemandAssemblyActionGenqlSelection
    on_OpeningBalanceAction?: OpeningBalanceActionGenqlSelection
    on_OtherFbaAction?: OtherFbaActionGenqlSelection
    on_RestockingAction?: RestockingActionGenqlSelection
    on_ShipmentAction?: ShipmentActionGenqlSelection
    on_UnitFoundAction?: UnitFoundActionGenqlSelection
    on_UnitLostAction?: UnitLostActionGenqlSelection
    on_WarehouseNegativesAdjustmentAction?: WarehouseNegativesAdjustmentActionGenqlSelection
    on_WarehouseTransferArrivalAction?: WarehouseTransferArrivalActionGenqlSelection
    on_WarehouseTransferShippingAction?: WarehouseTransferShippingActionGenqlSelection
    on_WasteAction?: WasteActionGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WarehouseActionSalesChannelGenqlSelection{
    integrationType?: boolean | number
    integrationAccountName?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WarehouseCreateErrorGenqlSelection{
    message?: boolean | number
    type?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WarehouseCreateResultGenqlSelection{
    on_Warehouse?:WarehouseGenqlSelection,
    on_WarehouseCreateError?:WarehouseCreateErrorGenqlSelection,
    __typename?: boolean | number
}

export interface WarehouseFilter {type: WarehouseFilterType,warehouseId: Scalars['String'][]}

export interface WarehouseIncomingInventoryBreakdownFiltersInput {hasUnavailable?: (Scalars['Boolean'] | null),searchText?: (Scalars['String'] | null)}

export interface WarehouseIncomingInventoryBreakdownInput {companyId: Scalars['ID'],productId: Scalars['String'],warehouseId: Scalars['String'],sort: WarehousesProductPurchasesBreakdownSortInput,limit: Scalars['Int'],offset: Scalars['Int'],filters: WarehouseIncomingInventoryBreakdownFiltersInput,date?: (Scalars['Date'] | null)}

export interface WarehouseIncomingInventoryBreakdownResultGenqlSelection{
    incomingBatches?: IncomingBatchAnalyticsGenqlSelection
    totalBatches?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WarehouseIncomingInventoryOverviewInput {companyId: Scalars['ID'],productId: Scalars['String'],date?: (Scalars['Date'] | null),fromDate?: (Scalars['Date'] | null)}

export interface WarehouseIncomingInventoryOverviewResultGenqlSelection{
    warehouse?: WarehouseGenqlSelection
    analytics?: IncomingInventoryAnalyticsGenqlSelection
    inTransit?: boolean | number
    openingBalance?: WarehouseOpeningBalanceGenqlSelection
    totalBatches?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WarehouseMovementsGenqlSelection{
    warehouse?: WarehouseGenqlSelection
    movements?: MovementGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WarehouseNegativesAdjustmentGenqlSelection{
    id?: boolean | number
    productId?: boolean | number
    warehouseId?: boolean | number
    totalQuantity?: boolean | number
    costPerUnit?: boolean | number
    datesToFix?: DatesToFixGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WarehouseNegativesAdjustmentActionGenqlSelection{
    quantity?: boolean | number
    id?: boolean | number
    date?: boolean | number
    type?: boolean | number
    warehouseNegativeAdjustment?: WarehouseNegativesAdjustmentGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WarehouseNegativesAdjustmentBreakdownGenqlSelection{
    warehouseNegativesAdjustment?: WarehouseNegativesAdjustmentGenqlSelection
    startDate?: boolean | number
    endDate?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WarehouseOpeningBalanceGenqlSelection{
    id?: boolean | number
    warehouse?: WarehouseGenqlSelection
    product?: ProductGenqlSelection
    quantity?: boolean | number
    costPerUnit?: boolean | number
    date?: boolean | number
    isMissingUserInput?: boolean | number
    attachmentId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WarehouseOpeningBalanceErrorItemGenqlSelection{
    rowNumber?: boolean | number
    cellNumber?: boolean | number
    errorType?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WarehouseOpeningBalanceItemGenqlSelection{
    product?: ProductGenqlSelection
    warehouseOpeningBalance?: WarehouseOpeningBalanceGenqlSelection
    pendingWarehouseOpeningBalance?: PendingWarehouseOpeningBalanceGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WarehouseOpeningBalanceOverviewResponseGenqlSelection{
    count?: boolean | number
    pendingCount?: boolean | number
    missingDataCount?: boolean | number
    totalCost?: boolean | number
    minQuantity?: boolean | number
    maxQuantity?: boolean | number
    minCostPerUnit?: boolean | number
    maxCostPerUnit?: boolean | number
    lastPendingChange?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WarehouseOpeningBalancesCsvResponseGenqlSelection{
    url?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WarehouseOpeningBalancesCsvTemplateResponseGenqlSelection{
    url?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WarehouseOpeningBalanceSort {field: WarehouseOpeningBalanceSortField,direction: SortDirection}

export interface WarehouseOpeningBalancesResponseGenqlSelection{
    items?: WarehouseOpeningBalanceItemGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WarehouseResultGenqlSelection{
    data?: WarehouseGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WarehouseSalesDataGenqlSelection{
    warehouse?: WarehouseGenqlSelection
    salesChannels?: SalesChannelSalesCogsGenqlSelection
    deadInventory?: DeadInventoryCogsGenqlSelection
    giveaway?: GiveawayCogsGenqlSelection
    giveawayDropshipping?: GiveawayCogsGenqlSelection
    donation?: DonationCogsGenqlSelection
    lostAndFound?: LostAndFoundCogsGenqlSelection
    otherFba?: OtherFbaCogsGenqlSelection
    waste?: WasteCogsGenqlSelection
    supplierReturn?: ProductUnitCogsGenqlSelection
    salesAdjustments?: ProductSalesDataAdjustmentsGenqlSelection
    deadInventoryAdjustments?: ProductDeadInventoryAdjustmentsGenqlSelection
    giveawayAdjustments?: ProductGiveawayAdjustmentsGenqlSelection
    giveawayDropshippingAdjustments?: ProductGiveawayAdjustmentsGenqlSelection
    donationAdjustments?: ProductDonationAdjustmentsGenqlSelection
    lostAndFoundAdjustments?: ProductLostAndFoundAdjustmentsGenqlSelection
    otherFbaAdjustments?: ProductOtherFbaAdjustmentsGenqlSelection
    supplierReturnAdjustments?: ProductUnitsAdjustmentsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WarehousesDefaultsGenqlSelection{
    integrationType?: boolean | number
    integrationAccountName?: boolean | number
    integrationAccountId?: boolean | number
    warehouse?: WarehouseGenqlSelection
    startDate?: boolean | number
    endDate?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WarehousesDefaultsErrorGenqlSelection{
    errors?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WarehousesDefaultsInput {integrationType?: (Scalars['String'] | null),integrationAccountName?: (Scalars['String'] | null),integrationAccountId?: (Scalars['String'] | null),warehouseId: Scalars['String'],startDate?: (Scalars['Date'] | null),endDate?: (Scalars['Date'] | null)}

export interface WarehousesDefaultsResponseGenqlSelection{
    on_WarehousesDefaultsResult?:WarehousesDefaultsResultGenqlSelection,
    on_WarehousesDefaultsError?:WarehousesDefaultsErrorGenqlSelection,
    __typename?: boolean | number
}

export interface WarehousesDefaultsResultGenqlSelection{
    companyId?: boolean | number
    defaults?: WarehousesDefaultsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WarehousesProductPurchasesBreakdownSortInput {field: WarehousesProductPurchasesBreakdownSortField,direction: WarehousesProductPurchasesBreakdownSortDirection}

export interface WarehouseTimeRangeInput {startDate?: (Scalars['Date'] | null),endDate?: (Scalars['Date'] | null)}

export interface WarehouseTransferGenqlSelection{
    id?: boolean | number
    companyId?: boolean | number
    serialNumber?: boolean | number
    displayName?: boolean | number
    transit?: WarehouseTransferTransitGenqlSelection
    lineItems?: WarehouseTransferLineItemGenqlSelection
    costLineItems?: WarehouseTransferCostLineItemGenqlSelection
    attachments?: WarehouseTransferAttachmentGenqlSelection
    status?: boolean | number
    notes?: boolean | number
    deletedAt?: boolean | number
    productsCost?: boolean | number
    transferCost?: boolean | number
    totalCost?: boolean | number
    isHistorical?: boolean | number
    inventoryPaymentGroupLinks?: InventoryPaymentGroupLinkGenqlSelection
    unpaidAmounts?: UnpaidAmountPerAffiliatedEntityGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WarehouseTransferArrivalGenqlSelection{
    date?: boolean | number
    warehouse?: WarehouseGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WarehouseTransferArrivalActionGenqlSelection{
    quantity?: boolean | number
    id?: boolean | number
    date?: boolean | number
    type?: boolean | number
    warehouseTransfer?: WarehouseTransferGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WarehouseTransferArrivalInput {date?: (Scalars['Date'] | null),warehouseId: Scalars['String']}

export interface WarehouseTransferAttachmentGenqlSelection{
    filename?: boolean | number
    url?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WarehouseTransferAttachmentInput {filename: Scalars['String'],url: Scalars['String']}

export interface WarehouseTransferBatchHistoryItemGenqlSelection{
    action?: WarehouseActionGenqlSelection
    landedCost?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WarehouseTransferBreakdownBatchGenqlSelection{
    quantity?: boolean | number
    history?: WarehouseTransferBatchHistoryItemGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WarehouseTransferBreakdownItemGenqlSelection{
    action?: WarehouseActionGenqlSelection
    quantity?: boolean | number
    landedCost?: boolean | number
    batches?: WarehouseTransferBreakdownBatchGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WarehouseTransferCostAllocationGenqlSelection{
    costLineItemId?: boolean | number
    costPerUnit?: boolean | number
    lastUnitCost?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WarehouseTransferCostAllocationInput {costLineItemId: Scalars['String'],costPerUnit: Scalars['Float'],lastUnitCost?: (Scalars['Float'] | null)}

export interface WarehouseTransferCostLineItemGenqlSelection{
    id?: boolean | number
    type?: boolean | number
    amount?: boolean | number
    vendor?: VendorGenqlSelection
    isManuallyAllocated?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WarehouseTransferCostLineItemInput {id: Scalars['String'],type: WarehouseTransferCostLineItemType,amount: Scalars['Float'],vendorId: Scalars['String'],isManuallyAllocated: Scalars['Boolean']}

export interface WarehouseTransferLineItemGenqlSelection{
    id?: boolean | number
    product?: ProductGenqlSelection
    quantity?: boolean | number
    lineItemIdx?: boolean | number
    costAllocations?: WarehouseTransferCostAllocationGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WarehouseTransferLineItemFifoCostGenqlSelection{
    directCost?: boolean | number
    indirectCosts?: WarehouseTransferLineItemFifoIndirectCostGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WarehouseTransferLineItemFifoIndirectCostGenqlSelection{
    type?: boolean | number
    amount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WarehouseTransferLineItemInput {id: Scalars['String'],productId: Scalars['String'],quantity: Scalars['Float'],lineItemIdx: Scalars['Int'],costAllocations: WarehouseTransferCostAllocationInput[]}

export interface WarehouseTransferOverviewItemGenqlSelection{
    status?: boolean | number
    count?: boolean | number
    totalCost?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WarehouseTransferShippingGenqlSelection{
    date?: boolean | number
    warehouse?: WarehouseGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WarehouseTransferShippingActionGenqlSelection{
    quantity?: boolean | number
    id?: boolean | number
    date?: boolean | number
    type?: boolean | number
    warehouseTransfer?: WarehouseTransferGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WarehouseTransferShippingInput {date?: (Scalars['Date'] | null),warehouseId: Scalars['String']}

export interface WarehouseTransfersOverviewGenqlSelection{
    items?: WarehouseTransferOverviewItemGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WarehouseTransfersResponseGenqlSelection{
    warehouseTransfers?: WarehouseTransferGenqlSelection
    hasNext?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WarehouseTransfersSortInput {field: WarehouseTransfersSortField,direction: WarehouseTransfersSortDirection}

export interface WarehouseTransferTransitGenqlSelection{
    shipping?: WarehouseTransferShippingGenqlSelection
    arrival?: WarehouseTransferArrivalGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WarehouseTransferTransitInput {shipping: WarehouseTransferShippingInput,arrival?: (WarehouseTransferArrivalInput | null)}

export interface WarehouseTransferWithBreakdownGenqlSelection{
    warehouseTransfer?: WarehouseTransferGenqlSelection
    date?: boolean | number
    items?: WarehouseTransferBreakdownItemGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WasteActionGenqlSelection{
    quantity?: boolean | number
    id?: boolean | number
    date?: boolean | number
    type?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WasteCogsGenqlSelection{
    amount?: boolean | number
    quantity?: boolean | number
    monthlyBreakdown?: WasteMonthlyBreakdownGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WasteDailyBreakdownGenqlSelection{
    date?: boolean | number
    quantity?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WasteMonthlyBreakdownGenqlSelection{
    date?: boolean | number
    quantity?: boolean | number
    dailyData?: WasteDailyBreakdownGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WorksheetGenqlSelection{
    worksheetRows?: WorksheetRowGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WorksheetRowGenqlSelection{
    companyId?: boolean | number
    dateForLocking?: boolean | number
    name?: boolean | number
    amount?: boolean | number
    signedAmount?: boolean | number
    comment?: boolean | number
    signedAt?: boolean | number
    signedBy?: boolean | number
    signedByName?: boolean | number
    attachmentUrl?: boolean | number
    attachmentFileName?: boolean | number
    lockableEntity?: CompanyWorksheetRowLockableEntityGenqlSelection
    periodStart?: boolean | number
    periodEnd?: boolean | number
    isPnl?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface YearEndDependenciesGenqlSelection{
    companyId?: boolean | number
    balanceSheet?: BalanceSheetDependencyGenqlSelection
    yearEnd?: YearEndDependencyGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface YearEndDependencyGenqlSelection{
    blocked?: boolean | number
    year?: boolean | number
    resolvedAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface YearEndDomainsStatesGenqlSelection{
    banks?: YearEndDomainStateResponseGenqlSelection
    transactions?: YearEndDomainStateResponseGenqlSelection
    unclassified_transactions?: YearEndDomainStateResponseGenqlSelection
    unmatched_payouts_and_transfers?: YearEndDomainStateResponseGenqlSelection
    payments?: YearEndDomainStateResponseGenqlSelection
    inventory?: YearEndDomainStateResponseGenqlSelection
    loans?: YearEndDomainStateResponseGenqlSelection
    equity?: YearEndDomainStateResponseGenqlSelection
    payroll?: YearEndDomainStateResponseGenqlSelection
    sales_tax?: YearEndDomainStateResponseGenqlSelection
    investments?: YearEndDomainStateResponseGenqlSelection
    security_deposits?: YearEndDomainStateResponseGenqlSelection
    accounting_and_tax_information?: YearEndDomainStateResponseGenqlSelection
    orders?: YearEndDomainStateResponseGenqlSelection
    invoices?: YearEndDomainStateResponseGenqlSelection
    bills?: YearEndDomainStateResponseGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface YearEndDomainStateChangeLogGenqlSelection{
    id?: boolean | number
    createdAt?: boolean | number
    updaterType?: boolean | number
    changedByUid?: boolean | number
    reason?: boolean | number
    oldValue?: boolean | number
    newValue?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface YearEndDomainStateDataChangeLogGenqlSelection{
    id?: boolean | number
    createdAt?: boolean | number
    updaterType?: boolean | number
    changedByUid?: boolean | number
    reason?: boolean | number
    oldValue?: boolean | number
    newValue?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface YearEndDomainStateDataDeleteInput {companyId: Scalars['ID'],domain: YearEndDomainTypes,dataKey?: (Scalars['String'] | null),updaterType?: (YearEndStateUpdaterType | null),updatedBy?: (Scalars['String'] | null),reason?: (Scalars['String'] | null)}

export interface YearEndDomainStateDataDeleteResponseGenqlSelection{
    deletedAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface YearEndDomainStateDataInput {companyId: Scalars['ID'],domain: YearEndDomainTypes}

export interface YearEndDomainStateDataResponseGenqlSelection{
    id?: boolean | number
    dataKey?: boolean | number
    data?: boolean | number
    history?: YearEndDomainStateDataChangeLogGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface YearEndDomainStateDataUpdateInput {companyId: Scalars['ID'],domain: YearEndDomainTypes,dataKey?: (Scalars['String'] | null),data: Scalars['JSONObject'],updaterType?: (YearEndStateUpdaterType | null),updatedBy?: (Scalars['String'] | null),reason?: (Scalars['String'] | null)}

export interface YearEndDomainStateDataUpdateResponseGenqlSelection{
    id?: boolean | number
    data?: boolean | number
    dataKey?: boolean | number
    historyLog?: YearEndDomainStateDataChangeLogGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface YearEndDomainStateDatumInput {companyId: Scalars['ID'],domain: YearEndDomainTypes,dataKey?: (Scalars['String'] | null)}

export interface YearEndDomainStateResponseGenqlSelection{
    state?: boolean | number
    canSubmit?: boolean | number
    history?: YearEndDomainStateChangeLogGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface YearEndDomainStateUpdateInput {companyId: Scalars['ID'],domain: YearEndDomainTypes,state: YearEndDomainState,updatedBy?: (Scalars['String'] | null),updaterType: YearEndStateUpdaterType,reason?: (Scalars['String'] | null)}

export interface YearEndDomainStateUpdateResponseGenqlSelection{
    state?: boolean | number
    canSubmit?: boolean | number
    historyLog?: YearEndDomainStateChangeLogGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface YearEndDomainUpToDateStateGenqlSelection{
    companyId?: boolean | number
    state?: boolean | number
    isEnabled?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface YearEndDomainUpToDateStatesGenqlSelection{
    companyId?: boolean | number
    banks?: YearEndDomainUpToDateStateGenqlSelection
    unclassifiedTransactions?: YearEndDomainUpToDateStateGenqlSelection
    unmatchedPayoutsAndTransfers?: YearEndDomainUpToDateStateGenqlSelection
    transactions?: YearEndDomainUpToDateStateGenqlSelection
    /** @deprecated It is going to be removed soon to keep consistency with mapped domain type name with camel case. Use unclassifiedTransactions instead  */
    unclassified_transactions?: YearEndDomainUpToDateStateGenqlSelection
    /** @deprecated It is going to be removed soon to keep consistency with mapped domain type name with camel case. Use unmatchedPayoutsAndTransfers instead  */
    unmatched_payouts_and_transfers?: YearEndDomainUpToDateStateGenqlSelection
    bills?: YearEndDomainUpToDateStateGenqlSelection
    inventory?: YearEndDomainUpToDateStateGenqlSelection
    loans?: YearEndDomainUpToDateStateGenqlSelection
    orders?: YearEndDomainUpToDateStateGenqlSelection
    paymentsMissions?: YearEndDomainUpToDateStateGenqlSelection
    invoices?: YearEndDomainUpToDateStateGenqlSelection
    accountingAndTaxInformation?: YearEndDomainUpToDateStateGenqlSelection
    payroll?: YearEndDomainUpToDateStateGenqlSelection
    salesTax?: YearEndDomainUpToDateStateGenqlSelection
    securityDeposits?: YearEndDomainUpToDateStateGenqlSelection
    investments?: YearEndDomainUpToDateStateGenqlSelection
    equity?: YearEndDomainUpToDateStateGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface YearEndEmailGenqlSelection{
    yearEndStateId?: boolean | number
    value?: boolean | number
    history?: YearEndEmailChangeLogGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface YearEndEmailChangeLogGenqlSelection{
    id?: boolean | number
    createdAt?: boolean | number
    updaterType?: boolean | number
    changedByUid?: boolean | number
    reason?: boolean | number
    oldValue?: boolean | number
    newValue?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface YearEndIntercomLinkGenqlSelection{
    yearEndStateId?: boolean | number
    value?: boolean | number
    history?: YearEndIntercomLinkChangeLogGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface YearEndIntercomLinkChangeLogGenqlSelection{
    id?: boolean | number
    createdAt?: boolean | number
    updaterType?: boolean | number
    changedByUid?: boolean | number
    reason?: boolean | number
    oldValue?: boolean | number
    newValue?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface YearEndInventoryMissionGenqlSelection{
    missionType?: boolean | number
    status?: boolean | number
    historyLog?: InventoryYearEndHistoryLogGenqlSelection
    managementMethodPeriod?: ManagementMethodYearEndPeriodGenqlSelection
    on_PurchaseBasedClosingBalance?: PurchaseBasedClosingBalanceGenqlSelection
    on_PurchaseBasedOpeningBalance?: PurchaseBasedOpeningBalanceGenqlSelection
    on_PurchaseBasedPurchases?: PurchaseBasedPurchasesGenqlSelection
    on_SalesBasedClosingBalance?: SalesBasedClosingBalanceGenqlSelection
    on_SalesBasedMissingCostPerUnit?: SalesBasedMissingCostPerUnitGenqlSelection
    on_SalesBasedOpeningBalance?: SalesBasedOpeningBalanceGenqlSelection
    on_SalesBasedPurchases?: SalesBasedPurchasesGenqlSelection
    on_SalesBasedReportCogs?: SalesBasedReportCogsGenqlSelection
    on_UnitBasedClosingBalance?: UnitBasedClosingBalanceGenqlSelection
    on_UnitBasedNegativeOnHands?: UnitBasedNegativeOnHandsGenqlSelection
    on_UnitBasedReportCogs?: UnitBasedReportCogsGenqlSelection
    on_UnitBasedVendorsNegativeBalance?: UnitBasedVendorsNegativeBalanceGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface YearEndStateAdditionalDataGenqlSelection{
    companyId?: boolean | number
    accountingMethod?: boolean | number
    legalEntityType?: boolean | number
    taxEntityType?: boolean | number
    entityTypeDescription?: boolean | number
    fiscalYearEndDate?: boolean | number
    fiscalYearStartDate?: boolean | number
    finaloopDeadline?: boolean | number
    finaloopLastCall?: boolean | number
    filingDeadline?: boolean | number
    extensionFiled?: boolean | number
    daysFromFiscalEndDateToFilingDeadline?: boolean | number
    salesTaxLiabilityOpeningBalance?: boolean | number
    salesTaxLiabilityClosingBalance?: boolean | number
    netSalesTaxCollected?: boolean | number
    salesTaxPaymentToAuthorities?: boolean | number
    securityDepositsClosingBalance?: boolean | number
    investmentsGeneralClosingBalance?: boolean | number
    payroll?: PayrollDataGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface YearEndStateChangeLogGenqlSelection{
    id?: boolean | number
    createdAt?: boolean | number
    updaterType?: boolean | number
    changedByUid?: boolean | number
    reason?: boolean | number
    oldValue?: boolean | number
    newValue?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface YearEndStateInput {companyId: Scalars['ID'],year?: (Scalars['Int'] | null),isCurrentFiscalYear?: (Scalars['Boolean'] | null)}

export interface YearEndStateResponseGenqlSelection{
    id?: boolean | number
    companyId?: boolean | number
    state?: boolean | number
    year?: boolean | number
    domainsStates?: YearEndDomainsStatesGenqlSelection
    domainsUpToDateStates?: YearEndDomainUpToDateStatesGenqlSelection
    additionalData?: YearEndStateAdditionalDataGenqlSelection
    history?: YearEndStateChangeLogGenqlSelection
    isQualified?: boolean | number
    /** @deprecated UserUnresponsive.value instead */
    isUserUnresponsive?: boolean | number
    email?: YearEndEmailGenqlSelection
    intercomLink?: YearEndIntercomLinkGenqlSelection
    userUnresponsive?: YearEndUserUnresponsiveGenqlSelection
    dependencies?: YearEndDependenciesGenqlSelection
    isUnderReview?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface YearEndStatesInput {companyId: Scalars['ID'],includeLegacy?: (Scalars['Boolean'] | null)}

export interface YearEndStateUpdateInput {companyId: Scalars['ID'],year?: (Scalars['Int'] | null),state: YearEndState,updatedBy?: (Scalars['String'] | null),updaterType: YearEndStateUpdaterType,reason?: (Scalars['String'] | null)}

export interface YearEndStateUpdateResponseGenqlSelection{
    state?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface YearEndUpdateAdditionalFieldsInput {companyId: Scalars['ID'],isUserUnresponsive?: (Scalars['Boolean'] | null),email?: (Scalars['String'] | null),intercomLink?: (Scalars['String'] | null),updatedBy?: (Scalars['String'] | null),updaterType: YearEndStateUpdaterType,reason?: (Scalars['String'] | null),year?: (Scalars['Int'] | null)}

export interface YearEndUpdateAdditionalFieldsResponseGenqlSelection{
    userUnresponsiveResponse?: YearEndUpdateUserUnresponsiveResponseGenqlSelection
    emailResponse?: YearEndUpdateEmailResponseGenqlSelection
    intercomLinkResponse?: YearEndUpdateIntercomLinkResponseGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface YearEndUpdateEmailResponseGenqlSelection{
    email?: boolean | number
    historyLog?: YearEndEmailChangeLogGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface YearEndUpdateIntercomLinkResponseGenqlSelection{
    intercomLink?: boolean | number
    historyLog?: YearEndEmailChangeLogGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface YearEndUpdateUserUnresponsiveInput {companyId: Scalars['ID'],isUserUnresponsive: Scalars['Boolean'],updatedBy?: (Scalars['String'] | null),updaterType: YearEndStateUpdaterType,reason?: (Scalars['String'] | null)}

export interface YearEndUpdateUserUnresponsiveResponseGenqlSelection{
    isUserUnresponsive?: boolean | number
    historyLog?: YearEndUserUnresponsiveChangeLogGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface YearEndUserUnresponsiveGenqlSelection{
    yearEndStateId?: boolean | number
    value?: boolean | number
    history?: YearEndUserUnresponsiveChangeLogGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface YearEndUserUnresponsiveChangeLogGenqlSelection{
    id?: boolean | number
    createdAt?: boolean | number
    updaterType?: boolean | number
    changedByUid?: boolean | number
    reason?: boolean | number
    oldValue?: boolean | number
    newValue?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}


    const AcceptedInviteCompanyInfo_possibleTypes: string[] = ['AcceptedInviteCompanyInfo']
    export const isAcceptedInviteCompanyInfo = (obj?: { __typename?: any } | null): obj is AcceptedInviteCompanyInfo => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAcceptedInviteCompanyInfo"')
      return AcceptedInviteCompanyInfo_possibleTypes.includes(obj.__typename)
    }
    


    const AcceptInvitationResponse_possibleTypes: string[] = ['AcceptInvitationResponse']
    export const isAcceptInvitationResponse = (obj?: { __typename?: any } | null): obj is AcceptInvitationResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAcceptInvitationResponse"')
      return AcceptInvitationResponse_possibleTypes.includes(obj.__typename)
    }
    


    const AccountBalance_possibleTypes: string[] = ['AccountBalance']
    export const isAccountBalance = (obj?: { __typename?: any } | null): obj is AccountBalance => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAccountBalance"')
      return AccountBalance_possibleTypes.includes(obj.__typename)
    }
    


    const AccountingInfo_possibleTypes: string[] = ['AccountingInfo']
    export const isAccountingInfo = (obj?: { __typename?: any } | null): obj is AccountingInfo => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAccountingInfo"')
      return AccountingInfo_possibleTypes.includes(obj.__typename)
    }
    


    const AccountRole_possibleTypes: string[] = ['AccountRole']
    export const isAccountRole = (obj?: { __typename?: any } | null): obj is AccountRole => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAccountRole"')
      return AccountRole_possibleTypes.includes(obj.__typename)
    }
    


    const AccountValidation_possibleTypes: string[] = ['AccountValidation']
    export const isAccountValidation = (obj?: { __typename?: any } | null): obj is AccountValidation => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAccountValidation"')
      return AccountValidation_possibleTypes.includes(obj.__typename)
    }
    


    const Accrual_possibleTypes: string[] = ['Accrual']
    export const isAccrual = (obj?: { __typename?: any } | null): obj is Accrual => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAccrual"')
      return Accrual_possibleTypes.includes(obj.__typename)
    }
    


    const AccrualData_possibleTypes: string[] = ['AccrualData']
    export const isAccrualData = (obj?: { __typename?: any } | null): obj is AccrualData => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAccrualData"')
      return AccrualData_possibleTypes.includes(obj.__typename)
    }
    


    const AccrualEntity_possibleTypes: string[] = ['BankTransaction','Bill']
    export const isAccrualEntity = (obj?: { __typename?: any } | null): obj is AccrualEntity => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAccrualEntity"')
      return AccrualEntity_possibleTypes.includes(obj.__typename)
    }
    


    const AccrualRecordResponse_possibleTypes: string[] = ['AccrualRecordResponse']
    export const isAccrualRecordResponse = (obj?: { __typename?: any } | null): obj is AccrualRecordResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAccrualRecordResponse"')
      return AccrualRecordResponse_possibleTypes.includes(obj.__typename)
    }
    


    const AccrualRecordSpreadItem_possibleTypes: string[] = ['AccrualRecordSpreadItem']
    export const isAccrualRecordSpreadItem = (obj?: { __typename?: any } | null): obj is AccrualRecordSpreadItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAccrualRecordSpreadItem"')
      return AccrualRecordSpreadItem_possibleTypes.includes(obj.__typename)
    }
    


    const AccrualsSpread_possibleTypes: string[] = ['AccrualsSpread']
    export const isAccrualsSpread = (obj?: { __typename?: any } | null): obj is AccrualsSpread => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAccrualsSpread"')
      return AccrualsSpread_possibleTypes.includes(obj.__typename)
    }
    


    const AccrualsSpreadResponse_possibleTypes: string[] = ['AccrualsSpreadResponse']
    export const isAccrualsSpreadResponse = (obj?: { __typename?: any } | null): obj is AccrualsSpreadResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAccrualsSpreadResponse"')
      return AccrualsSpreadResponse_possibleTypes.includes(obj.__typename)
    }
    


    const AccrualV2_possibleTypes: string[] = ['AccrualV2']
    export const isAccrualV2 = (obj?: { __typename?: any } | null): obj is AccrualV2 => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAccrualV2"')
      return AccrualV2_possibleTypes.includes(obj.__typename)
    }
    


    const AcknowledgeLoansChanges_possibleTypes: string[] = ['AcknowledgeLoansChanges']
    export const isAcknowledgeLoansChanges = (obj?: { __typename?: any } | null): obj is AcknowledgeLoansChanges => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAcknowledgeLoansChanges"')
      return AcknowledgeLoansChanges_possibleTypes.includes(obj.__typename)
    }
    


    const ActionChange_possibleTypes: string[] = ['ActionChange']
    export const isActionChange = (obj?: { __typename?: any } | null): obj is ActionChange => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isActionChange"')
      return ActionChange_possibleTypes.includes(obj.__typename)
    }
    


    const Ad_possibleTypes: string[] = ['Ad']
    export const isAd = (obj?: { __typename?: any } | null): obj is Ad => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAd"')
      return Ad_possibleTypes.includes(obj.__typename)
    }
    


    const AdAccount_possibleTypes: string[] = ['AdAccount']
    export const isAdAccount = (obj?: { __typename?: any } | null): obj is AdAccount => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAdAccount"')
      return AdAccount_possibleTypes.includes(obj.__typename)
    }
    


    const AdCampaign_possibleTypes: string[] = ['AdCampaign']
    export const isAdCampaign = (obj?: { __typename?: any } | null): obj is AdCampaign => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAdCampaign"')
      return AdCampaign_possibleTypes.includes(obj.__typename)
    }
    


    const AddDepreciationBonus_possibleTypes: string[] = ['AddDepreciationBonus']
    export const isAddDepreciationBonus = (obj?: { __typename?: any } | null): obj is AddDepreciationBonus => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAddDepreciationBonus"')
      return AddDepreciationBonus_possibleTypes.includes(obj.__typename)
    }
    


    const AdditionalErrorInfo_possibleTypes: string[] = ['AdditionalErrorInfo']
    export const isAdditionalErrorInfo = (obj?: { __typename?: any } | null): obj is AdditionalErrorInfo => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAdditionalErrorInfo"')
      return AdditionalErrorInfo_possibleTypes.includes(obj.__typename)
    }
    


    const AddMissingBillsTask_possibleTypes: string[] = ['AddMissingBillsTask']
    export const isAddMissingBillsTask = (obj?: { __typename?: any } | null): obj is AddMissingBillsTask => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAddMissingBillsTask"')
      return AddMissingBillsTask_possibleTypes.includes(obj.__typename)
    }
    


    const AddMissingBillsTaskState_possibleTypes: string[] = ['AddMissingBillsTaskState']
    export const isAddMissingBillsTaskState = (obj?: { __typename?: any } | null): obj is AddMissingBillsTaskState => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAddMissingBillsTaskState"')
      return AddMissingBillsTaskState_possibleTypes.includes(obj.__typename)
    }
    


    const AddMissingBillsTaskStateChangeLog_possibleTypes: string[] = ['AddMissingBillsTaskStateChangeLog']
    export const isAddMissingBillsTaskStateChangeLog = (obj?: { __typename?: any } | null): obj is AddMissingBillsTaskStateChangeLog => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAddMissingBillsTaskStateChangeLog"')
      return AddMissingBillsTaskStateChangeLog_possibleTypes.includes(obj.__typename)
    }
    


    const AddMissingInvoicesTask_possibleTypes: string[] = ['AddMissingInvoicesTask']
    export const isAddMissingInvoicesTask = (obj?: { __typename?: any } | null): obj is AddMissingInvoicesTask => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAddMissingInvoicesTask"')
      return AddMissingInvoicesTask_possibleTypes.includes(obj.__typename)
    }
    


    const AddMissingInvoicesTaskState_possibleTypes: string[] = ['AddMissingInvoicesTaskState']
    export const isAddMissingInvoicesTaskState = (obj?: { __typename?: any } | null): obj is AddMissingInvoicesTaskState => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAddMissingInvoicesTaskState"')
      return AddMissingInvoicesTaskState_possibleTypes.includes(obj.__typename)
    }
    


    const AddMissingInvoicesTaskStateChangeLog_possibleTypes: string[] = ['AddMissingInvoicesTaskStateChangeLog']
    export const isAddMissingInvoicesTaskStateChangeLog = (obj?: { __typename?: any } | null): obj is AddMissingInvoicesTaskStateChangeLog => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAddMissingInvoicesTaskStateChangeLog"')
      return AddMissingInvoicesTaskStateChangeLog_possibleTypes.includes(obj.__typename)
    }
    


    const Address_possibleTypes: string[] = ['Address']
    export const isAddress = (obj?: { __typename?: any } | null): obj is Address => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAddress"')
      return Address_possibleTypes.includes(obj.__typename)
    }
    


    const AddRoleToAffiliatedEntityResult_possibleTypes: string[] = ['AddRoleToAffiliatedEntityResult']
    export const isAddRoleToAffiliatedEntityResult = (obj?: { __typename?: any } | null): obj is AddRoleToAffiliatedEntityResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAddRoleToAffiliatedEntityResult"')
      return AddRoleToAffiliatedEntityResult_possibleTypes.includes(obj.__typename)
    }
    


    const AdInsight_possibleTypes: string[] = ['AdInsight']
    export const isAdInsight = (obj?: { __typename?: any } | null): obj is AdInsight => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAdInsight"')
      return AdInsight_possibleTypes.includes(obj.__typename)
    }
    


    const AdInsightsByDate_possibleTypes: string[] = ['AdInsightsByDate']
    export const isAdInsightsByDate = (obj?: { __typename?: any } | null): obj is AdInsightsByDate => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAdInsightsByDate"')
      return AdInsightsByDate_possibleTypes.includes(obj.__typename)
    }
    


    const AdjustmentRestockingAction_possibleTypes: string[] = ['AdjustmentRestockingAction']
    export const isAdjustmentRestockingAction = (obj?: { __typename?: any } | null): obj is AdjustmentRestockingAction => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAdjustmentRestockingAction"')
      return AdjustmentRestockingAction_possibleTypes.includes(obj.__typename)
    }
    


    const AdjustmentsReason_possibleTypes: string[] = ['AdjustmentsReason']
    export const isAdjustmentsReason = (obj?: { __typename?: any } | null): obj is AdjustmentsReason => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAdjustmentsReason"')
      return AdjustmentsReason_possibleTypes.includes(obj.__typename)
    }
    


    const AdjustmentsValidation_possibleTypes: string[] = ['AdjustmentsValidation']
    export const isAdjustmentsValidation = (obj?: { __typename?: any } | null): obj is AdjustmentsValidation => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAdjustmentsValidation"')
      return AdjustmentsValidation_possibleTypes.includes(obj.__typename)
    }
    


    const AdSet_possibleTypes: string[] = ['AdSet']
    export const isAdSet = (obj?: { __typename?: any } | null): obj is AdSet => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAdSet"')
      return AdSet_possibleTypes.includes(obj.__typename)
    }
    


    const AffectedTransactionsIds_possibleTypes: string[] = ['AffectedTransactionsIds']
    export const isAffectedTransactionsIds = (obj?: { __typename?: any } | null): obj is AffectedTransactionsIds => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAffectedTransactionsIds"')
      return AffectedTransactionsIds_possibleTypes.includes(obj.__typename)
    }
    


    const AffiliatedEntity_possibleTypes: string[] = ['AffiliatedEntity']
    export const isAffiliatedEntity = (obj?: { __typename?: any } | null): obj is AffiliatedEntity => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAffiliatedEntity"')
      return AffiliatedEntity_possibleTypes.includes(obj.__typename)
    }
    


    const AgingAggregationItem_possibleTypes: string[] = ['AgingAggregationItem']
    export const isAgingAggregationItem = (obj?: { __typename?: any } | null): obj is AgingAggregationItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAgingAggregationItem"')
      return AgingAggregationItem_possibleTypes.includes(obj.__typename)
    }
    


    const AllSkusResponse_possibleTypes: string[] = ['AllSkusResponse']
    export const isAllSkusResponse = (obj?: { __typename?: any } | null): obj is AllSkusResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAllSkusResponse"')
      return AllSkusResponse_possibleTypes.includes(obj.__typename)
    }
    


    const AlterBankTransactionsLifecycleStateResult_possibleTypes: string[] = ['AlterBankTransactionsLifecycleStateResult']
    export const isAlterBankTransactionsLifecycleStateResult = (obj?: { __typename?: any } | null): obj is AlterBankTransactionsLifecycleStateResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAlterBankTransactionsLifecycleStateResult"')
      return AlterBankTransactionsLifecycleStateResult_possibleTypes.includes(obj.__typename)
    }
    


    const AlterBankTransactionsLifecycleStateUnprocessedResult_possibleTypes: string[] = ['AlterBankTransactionsLifecycleStateUnprocessedResult']
    export const isAlterBankTransactionsLifecycleStateUnprocessedResult = (obj?: { __typename?: any } | null): obj is AlterBankTransactionsLifecycleStateUnprocessedResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAlterBankTransactionsLifecycleStateUnprocessedResult"')
      return AlterBankTransactionsLifecycleStateUnprocessedResult_possibleTypes.includes(obj.__typename)
    }
    


    const AmazonAvailableMarketplace_possibleTypes: string[] = ['AmazonAvailableMarketplace']
    export const isAmazonAvailableMarketplace = (obj?: { __typename?: any } | null): obj is AmazonAvailableMarketplace => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAmazonAvailableMarketplace"')
      return AmazonAvailableMarketplace_possibleTypes.includes(obj.__typename)
    }
    


    const AmazonAvailableValidationDataResponse_possibleTypes: string[] = ['AmazonAvailableValidationDataResponse']
    export const isAmazonAvailableValidationDataResponse = (obj?: { __typename?: any } | null): obj is AmazonAvailableValidationDataResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAmazonAvailableValidationDataResponse"')
      return AmazonAvailableValidationDataResponse_possibleTypes.includes(obj.__typename)
    }
    


    const AmazonIntegrationAccountIdAvailableData_possibleTypes: string[] = ['AmazonIntegrationAccountIdAvailableData']
    export const isAmazonIntegrationAccountIdAvailableData = (obj?: { __typename?: any } | null): obj is AmazonIntegrationAccountIdAvailableData => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAmazonIntegrationAccountIdAvailableData"')
      return AmazonIntegrationAccountIdAvailableData_possibleTypes.includes(obj.__typename)
    }
    


    const AmazonOrdersDiffResponse_possibleTypes: string[] = ['AmazonOrdersDiffResponse']
    export const isAmazonOrdersDiffResponse = (obj?: { __typename?: any } | null): obj is AmazonOrdersDiffResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAmazonOrdersDiffResponse"')
      return AmazonOrdersDiffResponse_possibleTypes.includes(obj.__typename)
    }
    


    const AmazonProduct_possibleTypes: string[] = ['AmazonProduct']
    export const isAmazonProduct = (obj?: { __typename?: any } | null): obj is AmazonProduct => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAmazonProduct"')
      return AmazonProduct_possibleTypes.includes(obj.__typename)
    }
    


    const AmazonProductsReconciliationResponse_possibleTypes: string[] = ['AmazonProductsReconciliationResponse']
    export const isAmazonProductsReconciliationResponse = (obj?: { __typename?: any } | null): obj is AmazonProductsReconciliationResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAmazonProductsReconciliationResponse"')
      return AmazonProductsReconciliationResponse_possibleTypes.includes(obj.__typename)
    }
    


    const AmazonProductsValidationReadyResponse_possibleTypes: string[] = ['AmazonProductsValidationReadyResponse']
    export const isAmazonProductsValidationReadyResponse = (obj?: { __typename?: any } | null): obj is AmazonProductsValidationReadyResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAmazonProductsValidationReadyResponse"')
      return AmazonProductsValidationReadyResponse_possibleTypes.includes(obj.__typename)
    }
    


    const AmazonReconciliationAdjustmentsData_possibleTypes: string[] = ['AmazonReconciliationAdjustmentsData']
    export const isAmazonReconciliationAdjustmentsData = (obj?: { __typename?: any } | null): obj is AmazonReconciliationAdjustmentsData => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAmazonReconciliationAdjustmentsData"')
      return AmazonReconciliationAdjustmentsData_possibleTypes.includes(obj.__typename)
    }
    


    const AmazonReconciliationEntityData_possibleTypes: string[] = ['AmazonReconciliationEntityData']
    export const isAmazonReconciliationEntityData = (obj?: { __typename?: any } | null): obj is AmazonReconciliationEntityData => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAmazonReconciliationEntityData"')
      return AmazonReconciliationEntityData_possibleTypes.includes(obj.__typename)
    }
    


    const AmazonReconciliationEntityEntityValidationStatus_possibleTypes: string[] = ['AmazonReconciliationEntityEntityValidationStatus']
    export const isAmazonReconciliationEntityEntityValidationStatus = (obj?: { __typename?: any } | null): obj is AmazonReconciliationEntityEntityValidationStatus => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAmazonReconciliationEntityEntityValidationStatus"')
      return AmazonReconciliationEntityEntityValidationStatus_possibleTypes.includes(obj.__typename)
    }
    


    const AmazonReconciliationProductData_possibleTypes: string[] = ['AmazonReconciliationProductData']
    export const isAmazonReconciliationProductData = (obj?: { __typename?: any } | null): obj is AmazonReconciliationProductData => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAmazonReconciliationProductData"')
      return AmazonReconciliationProductData_possibleTypes.includes(obj.__typename)
    }
    


    const AmazonReconciliationProductValidationStatus_possibleTypes: string[] = ['AmazonReconciliationProductValidationStatus']
    export const isAmazonReconciliationProductValidationStatus = (obj?: { __typename?: any } | null): obj is AmazonReconciliationProductValidationStatus => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAmazonReconciliationProductValidationStatus"')
      return AmazonReconciliationProductValidationStatus_possibleTypes.includes(obj.__typename)
    }
    


    const AmazonReconciliationRestockedReportData_possibleTypes: string[] = ['AmazonReconciliationRestockedReportData']
    export const isAmazonReconciliationRestockedReportData = (obj?: { __typename?: any } | null): obj is AmazonReconciliationRestockedReportData => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAmazonReconciliationRestockedReportData"')
      return AmazonReconciliationRestockedReportData_possibleTypes.includes(obj.__typename)
    }
    


    const AmazonReconciliationSalesOrderIds_possibleTypes: string[] = ['AmazonReconciliationSalesOrderIds']
    export const isAmazonReconciliationSalesOrderIds = (obj?: { __typename?: any } | null): obj is AmazonReconciliationSalesOrderIds => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAmazonReconciliationSalesOrderIds"')
      return AmazonReconciliationSalesOrderIds_possibleTypes.includes(obj.__typename)
    }
    


    const AmazonReconciliationSalesReportData_possibleTypes: string[] = ['AmazonReconciliationSalesReportData']
    export const isAmazonReconciliationSalesReportData = (obj?: { __typename?: any } | null): obj is AmazonReconciliationSalesReportData => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAmazonReconciliationSalesReportData"')
      return AmazonReconciliationSalesReportData_possibleTypes.includes(obj.__typename)
    }
    


    const AmazonReconciliationSummary_possibleTypes: string[] = ['AmazonReconciliationSummary']
    export const isAmazonReconciliationSummary = (obj?: { __typename?: any } | null): obj is AmazonReconciliationSummary => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAmazonReconciliationSummary"')
      return AmazonReconciliationSummary_possibleTypes.includes(obj.__typename)
    }
    


    const AmazonSkuReconciliationData_possibleTypes: string[] = ['AmazonSkuReconciliationData']
    export const isAmazonSkuReconciliationData = (obj?: { __typename?: any } | null): obj is AmazonSkuReconciliationData => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAmazonSkuReconciliationData"')
      return AmazonSkuReconciliationData_possibleTypes.includes(obj.__typename)
    }
    


    const Amounts_possibleTypes: string[] = ['Amounts']
    export const isAmounts = (obj?: { __typename?: any } | null): obj is Amounts => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAmounts"')
      return Amounts_possibleTypes.includes(obj.__typename)
    }
    


    const AnyActiveProductWithoutQuantities_possibleTypes: string[] = ['AnyActiveProductWithoutQuantities']
    export const isAnyActiveProductWithoutQuantities = (obj?: { __typename?: any } | null): obj is AnyActiveProductWithoutQuantities => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAnyActiveProductWithoutQuantities"')
      return AnyActiveProductWithoutQuantities_possibleTypes.includes(obj.__typename)
    }
    


    const APAccountBalance_possibleTypes: string[] = ['APAccountBalance']
    export const isAPAccountBalance = (obj?: { __typename?: any } | null): obj is APAccountBalance => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAPAccountBalance"')
      return APAccountBalance_possibleTypes.includes(obj.__typename)
    }
    


    const ApplySalesChannelChangesResult_possibleTypes: string[] = ['ApplySalesChannelChangesResult']
    export const isApplySalesChannelChangesResult = (obj?: { __typename?: any } | null): obj is ApplySalesChannelChangesResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isApplySalesChannelChangesResult"')
      return ApplySalesChannelChangesResult_possibleTypes.includes(obj.__typename)
    }
    


    const ArtificialTransactionsByMonth_possibleTypes: string[] = ['ArtificialTransactionsByMonth']
    export const isArtificialTransactionsByMonth = (obj?: { __typename?: any } | null): obj is ArtificialTransactionsByMonth => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isArtificialTransactionsByMonth"')
      return ArtificialTransactionsByMonth_possibleTypes.includes(obj.__typename)
    }
    


    const ArtificialTransactionsByMonthResponse_possibleTypes: string[] = ['ArtificialTransactionsByMonthResponse']
    export const isArtificialTransactionsByMonthResponse = (obj?: { __typename?: any } | null): obj is ArtificialTransactionsByMonthResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isArtificialTransactionsByMonthResponse"')
      return ArtificialTransactionsByMonthResponse_possibleTypes.includes(obj.__typename)
    }
    


    const AskTheUserNotificationServiceResult_possibleTypes: string[] = ['AskTheUserNotificationServiceResult']
    export const isAskTheUserNotificationServiceResult = (obj?: { __typename?: any } | null): obj is AskTheUserNotificationServiceResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAskTheUserNotificationServiceResult"')
      return AskTheUserNotificationServiceResult_possibleTypes.includes(obj.__typename)
    }
    


    const AskTheUserResult_possibleTypes: string[] = ['AskTheUserResult']
    export const isAskTheUserResult = (obj?: { __typename?: any } | null): obj is AskTheUserResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAskTheUserResult"')
      return AskTheUserResult_possibleTypes.includes(obj.__typename)
    }
    


    const AssembledByMap_possibleTypes: string[] = ['AssembledByMap']
    export const isAssembledByMap = (obj?: { __typename?: any } | null): obj is AssembledByMap => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAssembledByMap"')
      return AssembledByMap_possibleTypes.includes(obj.__typename)
    }
    


    const Assembly_possibleTypes: string[] = ['Assembly']
    export const isAssembly = (obj?: { __typename?: any } | null): obj is Assembly => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAssembly"')
      return Assembly_possibleTypes.includes(obj.__typename)
    }
    


    const AssemblyItem_possibleTypes: string[] = ['ManualAssembly','OnDemandAssemblyVendorCosts']
    export const isAssemblyItem = (obj?: { __typename?: any } | null): obj is AssemblyItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAssemblyItem"')
      return AssemblyItem_possibleTypes.includes(obj.__typename)
    }
    


    const AssemblyListItem_possibleTypes: string[] = ['AssemblyListItem']
    export const isAssemblyListItem = (obj?: { __typename?: any } | null): obj is AssemblyListItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAssemblyListItem"')
      return AssemblyListItem_possibleTypes.includes(obj.__typename)
    }
    


    const AssignCompanyToUserResponse_possibleTypes: string[] = ['AssignCompanyToUserResponse']
    export const isAssignCompanyToUserResponse = (obj?: { __typename?: any } | null): obj is AssignCompanyToUserResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAssignCompanyToUserResponse"')
      return AssignCompanyToUserResponse_possibleTypes.includes(obj.__typename)
    }
    


    const AttachmentTargetURL_possibleTypes: string[] = ['AttachmentTargetURL']
    export const isAttachmentTargetURL = (obj?: { __typename?: any } | null): obj is AttachmentTargetURL => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAttachmentTargetURL"')
      return AttachmentTargetURL_possibleTypes.includes(obj.__typename)
    }
    


    const AttachmentTargetURLS_possibleTypes: string[] = ['AttachmentTargetURLS']
    export const isAttachmentTargetURLS = (obj?: { __typename?: any } | null): obj is AttachmentTargetURLS => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAttachmentTargetURLS"')
      return AttachmentTargetURLS_possibleTypes.includes(obj.__typename)
    }
    


    const Auth0UserLookupResponse_possibleTypes: string[] = ['Auth0UserLookupResponse']
    export const isAuth0UserLookupResponse = (obj?: { __typename?: any } | null): obj is Auth0UserLookupResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAuth0UserLookupResponse"')
      return Auth0UserLookupResponse_possibleTypes.includes(obj.__typename)
    }
    


    const AwaitedExportResponse_possibleTypes: string[] = ['AwaitedExportResponse']
    export const isAwaitedExportResponse = (obj?: { __typename?: any } | null): obj is AwaitedExportResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAwaitedExportResponse"')
      return AwaitedExportResponse_possibleTypes.includes(obj.__typename)
    }
    


    const BackOfficeBankStatementRequestsFiltersResponse_possibleTypes: string[] = ['BackOfficeBankStatementRequestsFiltersResponse']
    export const isBackOfficeBankStatementRequestsFiltersResponse = (obj?: { __typename?: any } | null): obj is BackOfficeBankStatementRequestsFiltersResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBackOfficeBankStatementRequestsFiltersResponse"')
      return BackOfficeBankStatementRequestsFiltersResponse_possibleTypes.includes(obj.__typename)
    }
    


    const BalanceAdjustment_possibleTypes: string[] = ['BalanceAdjustment']
    export const isBalanceAdjustment = (obj?: { __typename?: any } | null): obj is BalanceAdjustment => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBalanceAdjustment"')
      return BalanceAdjustment_possibleTypes.includes(obj.__typename)
    }
    


    const BalanceByCurrency_possibleTypes: string[] = ['BalanceByCurrency']
    export const isBalanceByCurrency = (obj?: { __typename?: any } | null): obj is BalanceByCurrency => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBalanceByCurrency"')
      return BalanceByCurrency_possibleTypes.includes(obj.__typename)
    }
    


    const BalanceLocation_possibleTypes: string[] = ['BalanceLocation']
    export const isBalanceLocation = (obj?: { __typename?: any } | null): obj is BalanceLocation => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBalanceLocation"')
      return BalanceLocation_possibleTypes.includes(obj.__typename)
    }
    


    const BalanceSheetDependency_possibleTypes: string[] = ['BalanceSheetDependency']
    export const isBalanceSheetDependency = (obj?: { __typename?: any } | null): obj is BalanceSheetDependency => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBalanceSheetDependency"')
      return BalanceSheetDependency_possibleTypes.includes(obj.__typename)
    }
    


    const BalanceSheetItem_possibleTypes: string[] = ['BalanceSheetItem']
    export const isBalanceSheetItem = (obj?: { __typename?: any } | null): obj is BalanceSheetItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBalanceSheetItem"')
      return BalanceSheetItem_possibleTypes.includes(obj.__typename)
    }
    


    const BalanceSheetSetup_possibleTypes: string[] = ['BalanceSheetSetup']
    export const isBalanceSheetSetup = (obj?: { __typename?: any } | null): obj is BalanceSheetSetup => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBalanceSheetSetup"')
      return BalanceSheetSetup_possibleTypes.includes(obj.__typename)
    }
    


    const BalanceSheetSetupItems_possibleTypes: string[] = ['BalanceSheetSetupItems']
    export const isBalanceSheetSetupItems = (obj?: { __typename?: any } | null): obj is BalanceSheetSetupItems => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBalanceSheetSetupItems"')
      return BalanceSheetSetupItems_possibleTypes.includes(obj.__typename)
    }
    


    const BalanceSheetSetupItemStateResponse_possibleTypes: string[] = ['BalanceSheetSetupItemStateResponse']
    export const isBalanceSheetSetupItemStateResponse = (obj?: { __typename?: any } | null): obj is BalanceSheetSetupItemStateResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBalanceSheetSetupItemStateResponse"')
      return BalanceSheetSetupItemStateResponse_possibleTypes.includes(obj.__typename)
    }
    


    const BalanceSheetSetupStateResponse_possibleTypes: string[] = ['BalanceSheetSetupStateResponse']
    export const isBalanceSheetSetupStateResponse = (obj?: { __typename?: any } | null): obj is BalanceSheetSetupStateResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBalanceSheetSetupStateResponse"')
      return BalanceSheetSetupStateResponse_possibleTypes.includes(obj.__typename)
    }
    


    const BalanceSheetStatus_possibleTypes: string[] = ['BalanceSheetStatus']
    export const isBalanceSheetStatus = (obj?: { __typename?: any } | null): obj is BalanceSheetStatus => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBalanceSheetStatus"')
      return BalanceSheetStatus_possibleTypes.includes(obj.__typename)
    }
    


    const BankAccount_possibleTypes: string[] = ['BankAccount']
    export const isBankAccount = (obj?: { __typename?: any } | null): obj is BankAccount => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBankAccount"')
      return BankAccount_possibleTypes.includes(obj.__typename)
    }
    


    const BankAccountClosingBalance_possibleTypes: string[] = ['BankAccountClosingBalance']
    export const isBankAccountClosingBalance = (obj?: { __typename?: any } | null): obj is BankAccountClosingBalance => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBankAccountClosingBalance"')
      return BankAccountClosingBalance_possibleTypes.includes(obj.__typename)
    }
    


    const BankAccountLock_possibleTypes: string[] = ['BankAccountLock']
    export const isBankAccountLock = (obj?: { __typename?: any } | null): obj is BankAccountLock => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBankAccountLock"')
      return BankAccountLock_possibleTypes.includes(obj.__typename)
    }
    


    const BankAccountLockStatus_possibleTypes: string[] = ['BankAccountLockStatus']
    export const isBankAccountLockStatus = (obj?: { __typename?: any } | null): obj is BankAccountLockStatus => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBankAccountLockStatus"')
      return BankAccountLockStatus_possibleTypes.includes(obj.__typename)
    }
    


    const BankAccountReconciliation_possibleTypes: string[] = ['BankAccountReconciliation']
    export const isBankAccountReconciliation = (obj?: { __typename?: any } | null): obj is BankAccountReconciliation => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBankAccountReconciliation"')
      return BankAccountReconciliation_possibleTypes.includes(obj.__typename)
    }
    


    const BankAccountStatementRequest_possibleTypes: string[] = ['BankAccountStatementRequest']
    export const isBankAccountStatementRequest = (obj?: { __typename?: any } | null): obj is BankAccountStatementRequest => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBankAccountStatementRequest"')
      return BankAccountStatementRequest_possibleTypes.includes(obj.__typename)
    }
    


    const BankAccountStopImportNewOwner_possibleTypes: string[] = ['BankAccountStopImportNewOwner']
    export const isBankAccountStopImportNewOwner = (obj?: { __typename?: any } | null): obj is BankAccountStopImportNewOwner => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBankAccountStopImportNewOwner"')
      return BankAccountStopImportNewOwner_possibleTypes.includes(obj.__typename)
    }
    


    const BankAccountTransactionsImportStatus_possibleTypes: string[] = ['BankAccountTransactionsImportStatus']
    export const isBankAccountTransactionsImportStatus = (obj?: { __typename?: any } | null): obj is BankAccountTransactionsImportStatus => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBankAccountTransactionsImportStatus"')
      return BankAccountTransactionsImportStatus_possibleTypes.includes(obj.__typename)
    }
    


    const BankConnection_possibleTypes: string[] = ['BankConnection']
    export const isBankConnection = (obj?: { __typename?: any } | null): obj is BankConnection => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBankConnection"')
      return BankConnection_possibleTypes.includes(obj.__typename)
    }
    


    const BankConnectionAccount_possibleTypes: string[] = ['BankConnectionAccount']
    export const isBankConnectionAccount = (obj?: { __typename?: any } | null): obj is BankConnectionAccount => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBankConnectionAccount"')
      return BankConnectionAccount_possibleTypes.includes(obj.__typename)
    }
    


    const BankConnectionAccountLock_possibleTypes: string[] = ['BankConnectionAccountLock']
    export const isBankConnectionAccountLock = (obj?: { __typename?: any } | null): obj is BankConnectionAccountLock => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBankConnectionAccountLock"')
      return BankConnectionAccountLock_possibleTypes.includes(obj.__typename)
    }
    


    const BankConnectionAccountTransactionsImportStatus_possibleTypes: string[] = ['BankConnectionAccountTransactionsImportStatus']
    export const isBankConnectionAccountTransactionsImportStatus = (obj?: { __typename?: any } | null): obj is BankConnectionAccountTransactionsImportStatus => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBankConnectionAccountTransactionsImportStatus"')
      return BankConnectionAccountTransactionsImportStatus_possibleTypes.includes(obj.__typename)
    }
    


    const BankConnectionSyncStatus_possibleTypes: string[] = ['BankConnectionSyncStatus']
    export const isBankConnectionSyncStatus = (obj?: { __typename?: any } | null): obj is BankConnectionSyncStatus => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBankConnectionSyncStatus"')
      return BankConnectionSyncStatus_possibleTypes.includes(obj.__typename)
    }
    


    const BankDetails_possibleTypes: string[] = ['BankDetails']
    export const isBankDetails = (obj?: { __typename?: any } | null): obj is BankDetails => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBankDetails"')
      return BankDetails_possibleTypes.includes(obj.__typename)
    }
    


    const BankingAudit_possibleTypes: string[] = ['BankingAudit']
    export const isBankingAudit = (obj?: { __typename?: any } | null): obj is BankingAudit => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBankingAudit"')
      return BankingAudit_possibleTypes.includes(obj.__typename)
    }
    


    const BankingMetric_possibleTypes: string[] = ['BankingMetric']
    export const isBankingMetric = (obj?: { __typename?: any } | null): obj is BankingMetric => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBankingMetric"')
      return BankingMetric_possibleTypes.includes(obj.__typename)
    }
    


    const BankingMissionResult_possibleTypes: string[] = ['BankingMissionResult']
    export const isBankingMissionResult = (obj?: { __typename?: any } | null): obj is BankingMissionResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBankingMissionResult"')
      return BankingMissionResult_possibleTypes.includes(obj.__typename)
    }
    


    const BankOverviewPageAccount_possibleTypes: string[] = ['BankOverviewPageAccount']
    export const isBankOverviewPageAccount = (obj?: { __typename?: any } | null): obj is BankOverviewPageAccount => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBankOverviewPageAccount"')
      return BankOverviewPageAccount_possibleTypes.includes(obj.__typename)
    }
    


    const BankReconciliationGraphPoint_possibleTypes: string[] = ['BankReconciliationGraphPoint']
    export const isBankReconciliationGraphPoint = (obj?: { __typename?: any } | null): obj is BankReconciliationGraphPoint => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBankReconciliationGraphPoint"')
      return BankReconciliationGraphPoint_possibleTypes.includes(obj.__typename)
    }
    


    const BankReconciliationRequest_possibleTypes: string[] = ['BankReconciliationRequest']
    export const isBankReconciliationRequest = (obj?: { __typename?: any } | null): obj is BankReconciliationRequest => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBankReconciliationRequest"')
      return BankReconciliationRequest_possibleTypes.includes(obj.__typename)
    }
    


    const BankReconciliationRequestConfiguration_possibleTypes: string[] = ['BankReconciliationRequestConfiguration']
    export const isBankReconciliationRequestConfiguration = (obj?: { __typename?: any } | null): obj is BankReconciliationRequestConfiguration => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBankReconciliationRequestConfiguration"')
      return BankReconciliationRequestConfiguration_possibleTypes.includes(obj.__typename)
    }
    


    const BankReconciliationRequestSettingsResponse_possibleTypes: string[] = ['BankReconciliationRequestSettingsResponse']
    export const isBankReconciliationRequestSettingsResponse = (obj?: { __typename?: any } | null): obj is BankReconciliationRequestSettingsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBankReconciliationRequestSettingsResponse"')
      return BankReconciliationRequestSettingsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const BankStatementAccountHolder_possibleTypes: string[] = ['BankStatementAccountHolder']
    export const isBankStatementAccountHolder = (obj?: { __typename?: any } | null): obj is BankStatementAccountHolder => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBankStatementAccountHolder"')
      return BankStatementAccountHolder_possibleTypes.includes(obj.__typename)
    }
    


    const BankStatementBankAccount_possibleTypes: string[] = ['BankStatementBankAccount']
    export const isBankStatementBankAccount = (obj?: { __typename?: any } | null): obj is BankStatementBankAccount => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBankStatementBankAccount"')
      return BankStatementBankAccount_possibleTypes.includes(obj.__typename)
    }
    


    const BankStatementCustomerData_possibleTypes: string[] = ['BankStatementCustomerData']
    export const isBankStatementCustomerData = (obj?: { __typename?: any } | null): obj is BankStatementCustomerData => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBankStatementCustomerData"')
      return BankStatementCustomerData_possibleTypes.includes(obj.__typename)
    }
    


    const BankStatementFile_possibleTypes: string[] = ['BankStatementFile']
    export const isBankStatementFile = (obj?: { __typename?: any } | null): obj is BankStatementFile => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBankStatementFile"')
      return BankStatementFile_possibleTypes.includes(obj.__typename)
    }
    


    const BankStatementFileProcessingLog_possibleTypes: string[] = ['BankStatementFileProcessingLog']
    export const isBankStatementFileProcessingLog = (obj?: { __typename?: any } | null): obj is BankStatementFileProcessingLog => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBankStatementFileProcessingLog"')
      return BankStatementFileProcessingLog_possibleTypes.includes(obj.__typename)
    }
    


    const BankStatementFinaloopData_possibleTypes: string[] = ['BankStatementFinaloopData']
    export const isBankStatementFinaloopData = (obj?: { __typename?: any } | null): obj is BankStatementFinaloopData => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBankStatementFinaloopData"')
      return BankStatementFinaloopData_possibleTypes.includes(obj.__typename)
    }
    


    const BankStatementParsedTransaction_possibleTypes: string[] = ['BankStatementParsedTransaction']
    export const isBankStatementParsedTransaction = (obj?: { __typename?: any } | null): obj is BankStatementParsedTransaction => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBankStatementParsedTransaction"')
      return BankStatementParsedTransaction_possibleTypes.includes(obj.__typename)
    }
    


    const BankStatementParsingRequest_possibleTypes: string[] = ['BankStatementParsingRequest']
    export const isBankStatementParsingRequest = (obj?: { __typename?: any } | null): obj is BankStatementParsingRequest => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBankStatementParsingRequest"')
      return BankStatementParsingRequest_possibleTypes.includes(obj.__typename)
    }
    


    const BankStatementParsingResult_possibleTypes: string[] = ['BankStatementParsingResult']
    export const isBankStatementParsingResult = (obj?: { __typename?: any } | null): obj is BankStatementParsingResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBankStatementParsingResult"')
      return BankStatementParsingResult_possibleTypes.includes(obj.__typename)
    }
    


    const BankStatementRequestResolutionResponse_possibleTypes: string[] = ['BankStatementRequestResolutionResponse']
    export const isBankStatementRequestResolutionResponse = (obj?: { __typename?: any } | null): obj is BankStatementRequestResolutionResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBankStatementRequestResolutionResponse"')
      return BankStatementRequestResolutionResponse_possibleTypes.includes(obj.__typename)
    }
    


    const BankStatementValidationResults_possibleTypes: string[] = ['BankStatementValidationResults']
    export const isBankStatementValidationResults = (obj?: { __typename?: any } | null): obj is BankStatementValidationResults => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBankStatementValidationResults"')
      return BankStatementValidationResults_possibleTypes.includes(obj.__typename)
    }
    


    const BankTransaction_possibleTypes: string[] = ['BankTransaction']
    export const isBankTransaction = (obj?: { __typename?: any } | null): obj is BankTransaction => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBankTransaction"')
      return BankTransaction_possibleTypes.includes(obj.__typename)
    }
    


    const BankTransactionAttachment_possibleTypes: string[] = ['BankTransactionAttachment']
    export const isBankTransactionAttachment = (obj?: { __typename?: any } | null): obj is BankTransactionAttachment => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBankTransactionAttachment"')
      return BankTransactionAttachment_possibleTypes.includes(obj.__typename)
    }
    


    const BankTransactionBusinessEvent_possibleTypes: string[] = ['BankTransactionBusinessEvent']
    export const isBankTransactionBusinessEvent = (obj?: { __typename?: any } | null): obj is BankTransactionBusinessEvent => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBankTransactionBusinessEvent"')
      return BankTransactionBusinessEvent_possibleTypes.includes(obj.__typename)
    }
    


    const BankTransactionBusinessEventClassification_possibleTypes: string[] = ['BankTransactionBusinessEventClassification']
    export const isBankTransactionBusinessEventClassification = (obj?: { __typename?: any } | null): obj is BankTransactionBusinessEventClassification => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBankTransactionBusinessEventClassification"')
      return BankTransactionBusinessEventClassification_possibleTypes.includes(obj.__typename)
    }
    


    const BankTransactionByMerchant_possibleTypes: string[] = ['BankTransactionByMerchant']
    export const isBankTransactionByMerchant = (obj?: { __typename?: any } | null): obj is BankTransactionByMerchant => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBankTransactionByMerchant"')
      return BankTransactionByMerchant_possibleTypes.includes(obj.__typename)
    }
    


    const BankTransactionByMerchantResult_possibleTypes: string[] = ['BankTransactionByMerchantResult']
    export const isBankTransactionByMerchantResult = (obj?: { __typename?: any } | null): obj is BankTransactionByMerchantResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBankTransactionByMerchantResult"')
      return BankTransactionByMerchantResult_possibleTypes.includes(obj.__typename)
    }
    


    const BankTransactionCategorizationResult_possibleTypes: string[] = ['BankTransactionCategorizationResult']
    export const isBankTransactionCategorizationResult = (obj?: { __typename?: any } | null): obj is BankTransactionCategorizationResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBankTransactionCategorizationResult"')
      return BankTransactionCategorizationResult_possibleTypes.includes(obj.__typename)
    }
    


    const BankTransactionMemo_possibleTypes: string[] = ['BankTransactionMemo']
    export const isBankTransactionMemo = (obj?: { __typename?: any } | null): obj is BankTransactionMemo => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBankTransactionMemo"')
      return BankTransactionMemo_possibleTypes.includes(obj.__typename)
    }
    


    const BankTransactionPairingResult_possibleTypes: string[] = ['BankTransactionPairingResult']
    export const isBankTransactionPairingResult = (obj?: { __typename?: any } | null): obj is BankTransactionPairingResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBankTransactionPairingResult"')
      return BankTransactionPairingResult_possibleTypes.includes(obj.__typename)
    }
    


    const BankTransactionRecommendation_possibleTypes: string[] = ['BankTransactionRecommendation']
    export const isBankTransactionRecommendation = (obj?: { __typename?: any } | null): obj is BankTransactionRecommendation => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBankTransactionRecommendation"')
      return BankTransactionRecommendation_possibleTypes.includes(obj.__typename)
    }
    


    const BankTransactionResponse_possibleTypes: string[] = ['BankTransactionResponse']
    export const isBankTransactionResponse = (obj?: { __typename?: any } | null): obj is BankTransactionResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBankTransactionResponse"')
      return BankTransactionResponse_possibleTypes.includes(obj.__typename)
    }
    


    const BankTransactionsResponse_possibleTypes: string[] = ['BankTransactionsResponse']
    export const isBankTransactionsResponse = (obj?: { __typename?: any } | null): obj is BankTransactionsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBankTransactionsResponse"')
      return BankTransactionsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const BankTransactionsSummary_possibleTypes: string[] = ['BankTransactionsSummary']
    export const isBankTransactionsSummary = (obj?: { __typename?: any } | null): obj is BankTransactionsSummary => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBankTransactionsSummary"')
      return BankTransactionsSummary_possibleTypes.includes(obj.__typename)
    }
    


    const BankTransactionsUpload_possibleTypes: string[] = ['BankTransactionsUpload']
    export const isBankTransactionsUpload = (obj?: { __typename?: any } | null): obj is BankTransactionsUpload => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBankTransactionsUpload"')
      return BankTransactionsUpload_possibleTypes.includes(obj.__typename)
    }
    


    const BankTransactionsUploadFileLocation_possibleTypes: string[] = ['BankTransactionsUploadFileLocation']
    export const isBankTransactionsUploadFileLocation = (obj?: { __typename?: any } | null): obj is BankTransactionsUploadFileLocation => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBankTransactionsUploadFileLocation"')
      return BankTransactionsUploadFileLocation_possibleTypes.includes(obj.__typename)
    }
    


    const BankTransactionsUploadProcessingLog_possibleTypes: string[] = ['BankTransactionsUploadProcessingLog']
    export const isBankTransactionsUploadProcessingLog = (obj?: { __typename?: any } | null): obj is BankTransactionsUploadProcessingLog => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBankTransactionsUploadProcessingLog"')
      return BankTransactionsUploadProcessingLog_possibleTypes.includes(obj.__typename)
    }
    


    const BankTxSaleTransaction_possibleTypes: string[] = ['BankTxSaleTransaction']
    export const isBankTxSaleTransaction = (obj?: { __typename?: any } | null): obj is BankTxSaleTransaction => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBankTxSaleTransaction"')
      return BankTxSaleTransaction_possibleTypes.includes(obj.__typename)
    }
    


    const BaseAffiliatedEntity_possibleTypes: string[] = ['BaseAffiliatedEntity']
    export const isBaseAffiliatedEntity = (obj?: { __typename?: any } | null): obj is BaseAffiliatedEntity => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBaseAffiliatedEntity"')
      return BaseAffiliatedEntity_possibleTypes.includes(obj.__typename)
    }
    


    const BigValidationAccountRoleAmount_possibleTypes: string[] = ['BigValidationAccountRoleAmount']
    export const isBigValidationAccountRoleAmount = (obj?: { __typename?: any } | null): obj is BigValidationAccountRoleAmount => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBigValidationAccountRoleAmount"')
      return BigValidationAccountRoleAmount_possibleTypes.includes(obj.__typename)
    }
    


    const BigValidationAdjustment_possibleTypes: string[] = ['BigValidationAdjustment']
    export const isBigValidationAdjustment = (obj?: { __typename?: any } | null): obj is BigValidationAdjustment => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBigValidationAdjustment"')
      return BigValidationAdjustment_possibleTypes.includes(obj.__typename)
    }
    


    const BigValidationData_possibleTypes: string[] = ['BigValidationData']
    export const isBigValidationData = (obj?: { __typename?: any } | null): obj is BigValidationData => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBigValidationData"')
      return BigValidationData_possibleTypes.includes(obj.__typename)
    }
    


    const BigValidationInventoryBalanceData_possibleTypes: string[] = ['BigValidationInventoryBalanceData']
    export const isBigValidationInventoryBalanceData = (obj?: { __typename?: any } | null): obj is BigValidationInventoryBalanceData => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBigValidationInventoryBalanceData"')
      return BigValidationInventoryBalanceData_possibleTypes.includes(obj.__typename)
    }
    


    const BigValidationPeriodData_possibleTypes: string[] = ['BigValidationPeriodData']
    export const isBigValidationPeriodData = (obj?: { __typename?: any } | null): obj is BigValidationPeriodData => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBigValidationPeriodData"')
      return BigValidationPeriodData_possibleTypes.includes(obj.__typename)
    }
    


    const BigValidationResponse_possibleTypes: string[] = ['BigValidationResponse']
    export const isBigValidationResponse = (obj?: { __typename?: any } | null): obj is BigValidationResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBigValidationResponse"')
      return BigValidationResponse_possibleTypes.includes(obj.__typename)
    }
    


    const BigValidationStatus_possibleTypes: string[] = ['BigValidationStatus']
    export const isBigValidationStatus = (obj?: { __typename?: any } | null): obj is BigValidationStatus => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBigValidationStatus"')
      return BigValidationStatus_possibleTypes.includes(obj.__typename)
    }
    


    const Bill_possibleTypes: string[] = ['Bill']
    export const isBill = (obj?: { __typename?: any } | null): obj is Bill => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBill"')
      return Bill_possibleTypes.includes(obj.__typename)
    }
    


    const BillAdjustment_possibleTypes: string[] = ['BillAdjustment']
    export const isBillAdjustment = (obj?: { __typename?: any } | null): obj is BillAdjustment => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBillAdjustment"')
      return BillAdjustment_possibleTypes.includes(obj.__typename)
    }
    


    const BillCredit_possibleTypes: string[] = ['BillCredit']
    export const isBillCredit = (obj?: { __typename?: any } | null): obj is BillCredit => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBillCredit"')
      return BillCredit_possibleTypes.includes(obj.__typename)
    }
    


    const BillExternalSourceData_possibleTypes: string[] = ['BillExternalSourceData']
    export const isBillExternalSourceData = (obj?: { __typename?: any } | null): obj is BillExternalSourceData => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBillExternalSourceData"')
      return BillExternalSourceData_possibleTypes.includes(obj.__typename)
    }
    


    const Billing_possibleTypes: string[] = ['Billing']
    export const isBilling = (obj?: { __typename?: any } | null): obj is Billing => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBilling"')
      return Billing_possibleTypes.includes(obj.__typename)
    }
    


    const BillingPayment_possibleTypes: string[] = ['RecurringPayment','OneTimePayment']
    export const isBillingPayment = (obj?: { __typename?: any } | null): obj is BillingPayment => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBillingPayment"')
      return BillingPayment_possibleTypes.includes(obj.__typename)
    }
    


    const BillPayment_possibleTypes: string[] = ['BillPayment']
    export const isBillPayment = (obj?: { __typename?: any } | null): obj is BillPayment => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBillPayment"')
      return BillPayment_possibleTypes.includes(obj.__typename)
    }
    


    const BillPaymentFinancing_possibleTypes: string[] = ['BillPaymentFinancing']
    export const isBillPaymentFinancing = (obj?: { __typename?: any } | null): obj is BillPaymentFinancing => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBillPaymentFinancing"')
      return BillPaymentFinancing_possibleTypes.includes(obj.__typename)
    }
    


    const BillPaymentFinancingInstallment_possibleTypes: string[] = ['BillPaymentFinancingInstallment']
    export const isBillPaymentFinancingInstallment = (obj?: { __typename?: any } | null): obj is BillPaymentFinancingInstallment => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBillPaymentFinancingInstallment"')
      return BillPaymentFinancingInstallment_possibleTypes.includes(obj.__typename)
    }
    


    const BillRefund_possibleTypes: string[] = ['BillRefund']
    export const isBillRefund = (obj?: { __typename?: any } | null): obj is BillRefund => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBillRefund"')
      return BillRefund_possibleTypes.includes(obj.__typename)
    }
    


    const BillsDueDateSummary_possibleTypes: string[] = ['BillsDueDateSummary']
    export const isBillsDueDateSummary = (obj?: { __typename?: any } | null): obj is BillsDueDateSummary => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBillsDueDateSummary"')
      return BillsDueDateSummary_possibleTypes.includes(obj.__typename)
    }
    


    const BillsYearEnd_possibleTypes: string[] = ['BillsYearEnd']
    export const isBillsYearEnd = (obj?: { __typename?: any } | null): obj is BillsYearEnd => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBillsYearEnd"')
      return BillsYearEnd_possibleTypes.includes(obj.__typename)
    }
    


    const BillsYearEndTask_possibleTypes: string[] = ['AddMissingBillsTask','CategorizeUncategorizedBillsTask','CloseOpenBillsTask','ConfirmApBalanceTask']
    export const isBillsYearEndTask = (obj?: { __typename?: any } | null): obj is BillsYearEndTask => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBillsYearEndTask"')
      return BillsYearEndTask_possibleTypes.includes(obj.__typename)
    }
    


    const BillsYearEndTasksResponse_possibleTypes: string[] = ['BillsYearEndTasksResponse']
    export const isBillsYearEndTasksResponse = (obj?: { __typename?: any } | null): obj is BillsYearEndTasksResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBillsYearEndTasksResponse"')
      return BillsYearEndTasksResponse_possibleTypes.includes(obj.__typename)
    }
    


    const BooleanChangeLog_possibleTypes: string[] = ['BooleanChangeLog']
    export const isBooleanChangeLog = (obj?: { __typename?: any } | null): obj is BooleanChangeLog => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBooleanChangeLog"')
      return BooleanChangeLog_possibleTypes.includes(obj.__typename)
    }
    


    const BooleanResult_possibleTypes: string[] = ['BooleanResult']
    export const isBooleanResult = (obj?: { __typename?: any } | null): obj is BooleanResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBooleanResult"')
      return BooleanResult_possibleTypes.includes(obj.__typename)
    }
    


    const BulkEditCsvTemplateResponse_possibleTypes: string[] = ['BulkEditCsvTemplateResponse']
    export const isBulkEditCsvTemplateResponse = (obj?: { __typename?: any } | null): obj is BulkEditCsvTemplateResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBulkEditCsvTemplateResponse"')
      return BulkEditCsvTemplateResponse_possibleTypes.includes(obj.__typename)
    }
    


    const BulkPaymentData_possibleTypes: string[] = ['BulkPaymentData']
    export const isBulkPaymentData = (obj?: { __typename?: any } | null): obj is BulkPaymentData => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBulkPaymentData"')
      return BulkPaymentData_possibleTypes.includes(obj.__typename)
    }
    


    const BulkRecoveryUnitsTrackingFailureResult_possibleTypes: string[] = ['BulkRecoveryUnitsTrackingFailureResult']
    export const isBulkRecoveryUnitsTrackingFailureResult = (obj?: { __typename?: any } | null): obj is BulkRecoveryUnitsTrackingFailureResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBulkRecoveryUnitsTrackingFailureResult"')
      return BulkRecoveryUnitsTrackingFailureResult_possibleTypes.includes(obj.__typename)
    }
    


    const BulkRecoveryUnitsTrackingResult_possibleTypes: string[] = ['BulkRecoveryUnitsTrackingResult']
    export const isBulkRecoveryUnitsTrackingResult = (obj?: { __typename?: any } | null): obj is BulkRecoveryUnitsTrackingResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBulkRecoveryUnitsTrackingResult"')
      return BulkRecoveryUnitsTrackingResult_possibleTypes.includes(obj.__typename)
    }
    


    const BusinessEventActionsConfiguration_possibleTypes: string[] = ['BusinessEventActionsConfiguration']
    export const isBusinessEventActionsConfiguration = (obj?: { __typename?: any } | null): obj is BusinessEventActionsConfiguration => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBusinessEventActionsConfiguration"')
      return BusinessEventActionsConfiguration_possibleTypes.includes(obj.__typename)
    }
    


    const BusinessEventData_possibleTypes: string[] = ['BusinessEventData']
    export const isBusinessEventData = (obj?: { __typename?: any } | null): obj is BusinessEventData => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBusinessEventData"')
      return BusinessEventData_possibleTypes.includes(obj.__typename)
    }
    


    const BusinessEventDefinition_possibleTypes: string[] = ['BusinessEventDefinition']
    export const isBusinessEventDefinition = (obj?: { __typename?: any } | null): obj is BusinessEventDefinition => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBusinessEventDefinition"')
      return BusinessEventDefinition_possibleTypes.includes(obj.__typename)
    }
    


    const BusinessEventsAccrualsConfig_possibleTypes: string[] = ['BusinessEventsAccrualsConfig']
    export const isBusinessEventsAccrualsConfig = (obj?: { __typename?: any } | null): obj is BusinessEventsAccrualsConfig => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBusinessEventsAccrualsConfig"')
      return BusinessEventsAccrualsConfig_possibleTypes.includes(obj.__typename)
    }
    


    const BusinessEventsAccrualsConfigV2_possibleTypes: string[] = ['BusinessEventsAccrualsConfigV2']
    export const isBusinessEventsAccrualsConfigV2 = (obj?: { __typename?: any } | null): obj is BusinessEventsAccrualsConfigV2 => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBusinessEventsAccrualsConfigV2"')
      return BusinessEventsAccrualsConfigV2_possibleTypes.includes(obj.__typename)
    }
    


    const CalendlyEventResponse_possibleTypes: string[] = ['CalendlyEventResponse']
    export const isCalendlyEventResponse = (obj?: { __typename?: any } | null): obj is CalendlyEventResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCalendlyEventResponse"')
      return CalendlyEventResponse_possibleTypes.includes(obj.__typename)
    }
    


    const CanceledAccrualData_possibleTypes: string[] = ['CanceledAccrualData']
    export const isCanceledAccrualData = (obj?: { __typename?: any } | null): obj is CanceledAccrualData => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCanceledAccrualData"')
      return CanceledAccrualData_possibleTypes.includes(obj.__typename)
    }
    


    const CancelInvalidInventoryPaymentGroupsResponse_possibleTypes: string[] = ['CancelInvalidInventoryPaymentGroupsResponse']
    export const isCancelInvalidInventoryPaymentGroupsResponse = (obj?: { __typename?: any } | null): obj is CancelInvalidInventoryPaymentGroupsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCancelInvalidInventoryPaymentGroupsResponse"')
      return CancelInvalidInventoryPaymentGroupsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const CategorizeUncategorizedBillsTask_possibleTypes: string[] = ['CategorizeUncategorizedBillsTask']
    export const isCategorizeUncategorizedBillsTask = (obj?: { __typename?: any } | null): obj is CategorizeUncategorizedBillsTask => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCategorizeUncategorizedBillsTask"')
      return CategorizeUncategorizedBillsTask_possibleTypes.includes(obj.__typename)
    }
    


    const Category_possibleTypes: string[] = ['Category']
    export const isCategory = (obj?: { __typename?: any } | null): obj is Category => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCategory"')
      return Category_possibleTypes.includes(obj.__typename)
    }
    


    const CategoryBreakdown_possibleTypes: string[] = ['CategoryBreakdown']
    export const isCategoryBreakdown = (obj?: { __typename?: any } | null): obj is CategoryBreakdown => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCategoryBreakdown"')
      return CategoryBreakdown_possibleTypes.includes(obj.__typename)
    }
    


    const ChangeLog_possibleTypes: string[] = ['AddMissingBillsTaskStateChangeLog','AddMissingInvoicesTaskStateChangeLog','CloseOpenBillsTaskStateChangeLog','CloseOpenInvoicesTaskStateChangeLog','ConfirmApBalanceTaskStateChangeLog','ConfirmArBalanceTaskStateChangeLog','LinkInvoicePaymentsTaskStateChangeLog','YearEndDomainStateChangeLog','YearEndDomainStateDataChangeLog','YearEndEmailChangeLog','YearEndIntercomLinkChangeLog','YearEndStateChangeLog','YearEndUserUnresponsiveChangeLog']
    export const isChangeLog = (obj?: { __typename?: any } | null): obj is ChangeLog => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isChangeLog"')
      return ChangeLog_possibleTypes.includes(obj.__typename)
    }
    


    const Chargeback_possibleTypes: string[] = ['Chargeback']
    export const isChargeback = (obj?: { __typename?: any } | null): obj is Chargeback => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isChargeback"')
      return Chargeback_possibleTypes.includes(obj.__typename)
    }
    


    const ChartDataResponse_possibleTypes: string[] = ['ChartDataResponse']
    export const isChartDataResponse = (obj?: { __typename?: any } | null): obj is ChartDataResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isChartDataResponse"')
      return ChartDataResponse_possibleTypes.includes(obj.__typename)
    }
    


    const ClassificationMetadata_possibleTypes: string[] = ['ClassificationMetadata']
    export const isClassificationMetadata = (obj?: { __typename?: any } | null): obj is ClassificationMetadata => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isClassificationMetadata"')
      return ClassificationMetadata_possibleTypes.includes(obj.__typename)
    }
    


    const ClassificationMetadataRecommendation_possibleTypes: string[] = ['ClassificationMetadataRecommendation']
    export const isClassificationMetadataRecommendation = (obj?: { __typename?: any } | null): obj is ClassificationMetadataRecommendation => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isClassificationMetadataRecommendation"')
      return ClassificationMetadataRecommendation_possibleTypes.includes(obj.__typename)
    }
    


    const ClassificationMetadataRecommendationOptionValue_possibleTypes: string[] = ['ClassificationMetadataRecommendationOptionValue']
    export const isClassificationMetadataRecommendationOptionValue = (obj?: { __typename?: any } | null): obj is ClassificationMetadataRecommendationOptionValue => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isClassificationMetadataRecommendationOptionValue"')
      return ClassificationMetadataRecommendationOptionValue_possibleTypes.includes(obj.__typename)
    }
    


    const ClassificationMetadataRecommendationPromptValue_possibleTypes: string[] = ['ClassificationMetadataRecommendationPromptValue']
    export const isClassificationMetadataRecommendationPromptValue = (obj?: { __typename?: any } | null): obj is ClassificationMetadataRecommendationPromptValue => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isClassificationMetadataRecommendationPromptValue"')
      return ClassificationMetadataRecommendationPromptValue_possibleTypes.includes(obj.__typename)
    }
    


    const ClassificationMetadataRecommendationValue_possibleTypes: string[] = ['ClassificationMetadataRecommendationOptionValue','ClassificationMetadataRecommendationPromptValue']
    export const isClassificationMetadataRecommendationValue = (obj?: { __typename?: any } | null): obj is ClassificationMetadataRecommendationValue => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isClassificationMetadataRecommendationValue"')
      return ClassificationMetadataRecommendationValue_possibleTypes.includes(obj.__typename)
    }
    


    const ClassificationRecommendation_possibleTypes: string[] = ['ClassificationRecommendation']
    export const isClassificationRecommendation = (obj?: { __typename?: any } | null): obj is ClassificationRecommendation => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isClassificationRecommendation"')
      return ClassificationRecommendation_possibleTypes.includes(obj.__typename)
    }
    


    const ClassificationResult_possibleTypes: string[] = ['ClassificationResult']
    export const isClassificationResult = (obj?: { __typename?: any } | null): obj is ClassificationResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isClassificationResult"')
      return ClassificationResult_possibleTypes.includes(obj.__typename)
    }
    


    const ClassificationTag_possibleTypes: string[] = ['ClassificationTag']
    export const isClassificationTag = (obj?: { __typename?: any } | null): obj is ClassificationTag => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isClassificationTag"')
      return ClassificationTag_possibleTypes.includes(obj.__typename)
    }
    


    const ClassificationTagBusinessEventEffects_possibleTypes: string[] = ['ClassificationTagBusinessEventEffects']
    export const isClassificationTagBusinessEventEffects = (obj?: { __typename?: any } | null): obj is ClassificationTagBusinessEventEffects => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isClassificationTagBusinessEventEffects"')
      return ClassificationTagBusinessEventEffects_possibleTypes.includes(obj.__typename)
    }
    


    const ClassificationTagClassification_possibleTypes: string[] = ['ClassificationTagClassification']
    export const isClassificationTagClassification = (obj?: { __typename?: any } | null): obj is ClassificationTagClassification => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isClassificationTagClassification"')
      return ClassificationTagClassification_possibleTypes.includes(obj.__typename)
    }
    


    const ClassificationTagSuggestionsResponse_possibleTypes: string[] = ['ClassificationTagSuggestionsResponse']
    export const isClassificationTagSuggestionsResponse = (obj?: { __typename?: any } | null): obj is ClassificationTagSuggestionsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isClassificationTagSuggestionsResponse"')
      return ClassificationTagSuggestionsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const ClassificationTagWithSuggestionReason_possibleTypes: string[] = ['ClassificationTagWithSuggestionReason']
    export const isClassificationTagWithSuggestionReason = (obj?: { __typename?: any } | null): obj is ClassificationTagWithSuggestionReason => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isClassificationTagWithSuggestionReason"')
      return ClassificationTagWithSuggestionReason_possibleTypes.includes(obj.__typename)
    }
    


    const CloseOpenBillsTask_possibleTypes: string[] = ['CloseOpenBillsTask']
    export const isCloseOpenBillsTask = (obj?: { __typename?: any } | null): obj is CloseOpenBillsTask => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCloseOpenBillsTask"')
      return CloseOpenBillsTask_possibleTypes.includes(obj.__typename)
    }
    


    const CloseOpenBillsTaskState_possibleTypes: string[] = ['CloseOpenBillsTaskState']
    export const isCloseOpenBillsTaskState = (obj?: { __typename?: any } | null): obj is CloseOpenBillsTaskState => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCloseOpenBillsTaskState"')
      return CloseOpenBillsTaskState_possibleTypes.includes(obj.__typename)
    }
    


    const CloseOpenBillsTaskStateChangeLog_possibleTypes: string[] = ['CloseOpenBillsTaskStateChangeLog']
    export const isCloseOpenBillsTaskStateChangeLog = (obj?: { __typename?: any } | null): obj is CloseOpenBillsTaskStateChangeLog => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCloseOpenBillsTaskStateChangeLog"')
      return CloseOpenBillsTaskStateChangeLog_possibleTypes.includes(obj.__typename)
    }
    


    const CloseOpenInvoicesTask_possibleTypes: string[] = ['CloseOpenInvoicesTask']
    export const isCloseOpenInvoicesTask = (obj?: { __typename?: any } | null): obj is CloseOpenInvoicesTask => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCloseOpenInvoicesTask"')
      return CloseOpenInvoicesTask_possibleTypes.includes(obj.__typename)
    }
    


    const CloseOpenInvoicesTaskState_possibleTypes: string[] = ['CloseOpenInvoicesTaskState']
    export const isCloseOpenInvoicesTaskState = (obj?: { __typename?: any } | null): obj is CloseOpenInvoicesTaskState => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCloseOpenInvoicesTaskState"')
      return CloseOpenInvoicesTaskState_possibleTypes.includes(obj.__typename)
    }
    


    const CloseOpenInvoicesTaskStateChangeLog_possibleTypes: string[] = ['CloseOpenInvoicesTaskStateChangeLog']
    export const isCloseOpenInvoicesTaskStateChangeLog = (obj?: { __typename?: any } | null): obj is CloseOpenInvoicesTaskStateChangeLog => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCloseOpenInvoicesTaskStateChangeLog"')
      return CloseOpenInvoicesTaskStateChangeLog_possibleTypes.includes(obj.__typename)
    }
    


    const ClosingBalance_possibleTypes: string[] = ['ClosingBalance']
    export const isClosingBalance = (obj?: { __typename?: any } | null): obj is ClosingBalance => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isClosingBalance"')
      return ClosingBalance_possibleTypes.includes(obj.__typename)
    }
    


    const COGSBreakdownItem_possibleTypes: string[] = ['COGSBreakdownItem']
    export const isCOGSBreakdownItem = (obj?: { __typename?: any } | null): obj is COGSBreakdownItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCOGSBreakdownItem"')
      return COGSBreakdownItem_possibleTypes.includes(obj.__typename)
    }
    


    const COGSEvent_possibleTypes: string[] = ['COGSEvent']
    export const isCOGSEvent = (obj?: { __typename?: any } | null): obj is COGSEvent => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCOGSEvent"')
      return COGSEvent_possibleTypes.includes(obj.__typename)
    }
    


    const COGSEventPeriod_possibleTypes: string[] = ['COGSEventPeriod']
    export const isCOGSEventPeriod = (obj?: { __typename?: any } | null): obj is COGSEventPeriod => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCOGSEventPeriod"')
      return COGSEventPeriod_possibleTypes.includes(obj.__typename)
    }
    


    const COGSSummaryV2_possibleTypes: string[] = ['COGSSummaryV2']
    export const isCOGSSummaryV2 = (obj?: { __typename?: any } | null): obj is COGSSummaryV2 => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCOGSSummaryV2"')
      return COGSSummaryV2_possibleTypes.includes(obj.__typename)
    }
    


    const CommonAction_possibleTypes: string[] = ['CommonAction']
    export const isCommonAction = (obj?: { __typename?: any } | null): obj is CommonAction => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCommonAction"')
      return CommonAction_possibleTypes.includes(obj.__typename)
    }
    


    const Company_possibleTypes: string[] = ['Company']
    export const isCompany = (obj?: { __typename?: any } | null): obj is Company => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCompany"')
      return Company_possibleTypes.includes(obj.__typename)
    }
    


    const CompanyAccountValidation_possibleTypes: string[] = ['CompanyAccountValidation']
    export const isCompanyAccountValidation = (obj?: { __typename?: any } | null): obj is CompanyAccountValidation => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCompanyAccountValidation"')
      return CompanyAccountValidation_possibleTypes.includes(obj.__typename)
    }
    


    const CompanyAddress_possibleTypes: string[] = ['CompanyAddress']
    export const isCompanyAddress = (obj?: { __typename?: any } | null): obj is CompanyAddress => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCompanyAddress"')
      return CompanyAddress_possibleTypes.includes(obj.__typename)
    }
    


    const CompanyAffiliate_possibleTypes: string[] = ['CompanyAffiliate']
    export const isCompanyAffiliate = (obj?: { __typename?: any } | null): obj is CompanyAffiliate => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCompanyAffiliate"')
      return CompanyAffiliate_possibleTypes.includes(obj.__typename)
    }
    


    const CompanyAffiliateTransaction_possibleTypes: string[] = ['CompanyAffiliateTransaction']
    export const isCompanyAffiliateTransaction = (obj?: { __typename?: any } | null): obj is CompanyAffiliateTransaction => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCompanyAffiliateTransaction"')
      return CompanyAffiliateTransaction_possibleTypes.includes(obj.__typename)
    }
    


    const CompanyArCashDiffsActionsResponse_possibleTypes: string[] = ['CompanyArCashDiffsActionsResponse']
    export const isCompanyArCashDiffsActionsResponse = (obj?: { __typename?: any } | null): obj is CompanyArCashDiffsActionsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCompanyArCashDiffsActionsResponse"')
      return CompanyArCashDiffsActionsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const CompanyArCashDiffsFixbooksResponse_possibleTypes: string[] = ['CompanyArCashDiffsFixbooksResponse']
    export const isCompanyArCashDiffsFixbooksResponse = (obj?: { __typename?: any } | null): obj is CompanyArCashDiffsFixbooksResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCompanyArCashDiffsFixbooksResponse"')
      return CompanyArCashDiffsFixbooksResponse_possibleTypes.includes(obj.__typename)
    }
    


    const CompanyArCashDiffsOrdersResponse_possibleTypes: string[] = ['CompanyArCashDiffsOrdersResponse']
    export const isCompanyArCashDiffsOrdersResponse = (obj?: { __typename?: any } | null): obj is CompanyArCashDiffsOrdersResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCompanyArCashDiffsOrdersResponse"')
      return CompanyArCashDiffsOrdersResponse_possibleTypes.includes(obj.__typename)
    }
    


    const CompanyArCashDiffsResponse_possibleTypes: string[] = ['CompanyArCashDiffsResponse']
    export const isCompanyArCashDiffsResponse = (obj?: { __typename?: any } | null): obj is CompanyArCashDiffsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCompanyArCashDiffsResponse"')
      return CompanyArCashDiffsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const CompanyArCashTotalsResponse_possibleTypes: string[] = ['CompanyArCashTotalsResponse']
    export const isCompanyArCashTotalsResponse = (obj?: { __typename?: any } | null): obj is CompanyArCashTotalsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCompanyArCashTotalsResponse"')
      return CompanyArCashTotalsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const CompanyBalanceSheetSetup_possibleTypes: string[] = ['CompanyBalanceSheetSetup']
    export const isCompanyBalanceSheetSetup = (obj?: { __typename?: any } | null): obj is CompanyBalanceSheetSetup => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCompanyBalanceSheetSetup"')
      return CompanyBalanceSheetSetup_possibleTypes.includes(obj.__typename)
    }
    


    const CompanyBilling_possibleTypes: string[] = ['CompanyBilling']
    export const isCompanyBilling = (obj?: { __typename?: any } | null): obj is CompanyBilling => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCompanyBilling"')
      return CompanyBilling_possibleTypes.includes(obj.__typename)
    }
    


    const CompanyConfiguration_possibleTypes: string[] = ['CompanyConfiguration']
    export const isCompanyConfiguration = (obj?: { __typename?: any } | null): obj is CompanyConfiguration => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCompanyConfiguration"')
      return CompanyConfiguration_possibleTypes.includes(obj.__typename)
    }
    


    const CompanyEventsLockHistory_possibleTypes: string[] = ['CompanyEventsLockHistory']
    export const isCompanyEventsLockHistory = (obj?: { __typename?: any } | null): obj is CompanyEventsLockHistory => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCompanyEventsLockHistory"')
      return CompanyEventsLockHistory_possibleTypes.includes(obj.__typename)
    }
    


    const CompanyFiscalYearStart_possibleTypes: string[] = ['CompanyFiscalYearStart']
    export const isCompanyFiscalYearStart = (obj?: { __typename?: any } | null): obj is CompanyFiscalYearStart => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCompanyFiscalYearStart"')
      return CompanyFiscalYearStart_possibleTypes.includes(obj.__typename)
    }
    


    const CompanyFundedStatus_possibleTypes: string[] = ['CompanyFundedStatus']
    export const isCompanyFundedStatus = (obj?: { __typename?: any } | null): obj is CompanyFundedStatus => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCompanyFundedStatus"')
      return CompanyFundedStatus_possibleTypes.includes(obj.__typename)
    }
    


    const CompanyHealthStatus_possibleTypes: string[] = ['CompanyHealthStatus']
    export const isCompanyHealthStatus = (obj?: { __typename?: any } | null): obj is CompanyHealthStatus => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCompanyHealthStatus"')
      return CompanyHealthStatus_possibleTypes.includes(obj.__typename)
    }
    


    const CompanyIdAndStripeCustomerId_possibleTypes: string[] = ['CompanyIdAndStripeCustomerId']
    export const isCompanyIdAndStripeCustomerId = (obj?: { __typename?: any } | null): obj is CompanyIdAndStripeCustomerId => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCompanyIdAndStripeCustomerId"')
      return CompanyIdAndStripeCustomerId_possibleTypes.includes(obj.__typename)
    }
    


    const CompanyIntegration_possibleTypes: string[] = ['CompanyIntegration']
    export const isCompanyIntegration = (obj?: { __typename?: any } | null): obj is CompanyIntegration => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCompanyIntegration"')
      return CompanyIntegration_possibleTypes.includes(obj.__typename)
    }
    


    const CompanyLoan_possibleTypes: string[] = ['CompanyLoan']
    export const isCompanyLoan = (obj?: { __typename?: any } | null): obj is CompanyLoan => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCompanyLoan"')
      return CompanyLoan_possibleTypes.includes(obj.__typename)
    }
    


    const CompanyLoanAttachmentUpdateResult_possibleTypes: string[] = ['CompanyLoanAttachmentUpdateResult']
    export const isCompanyLoanAttachmentUpdateResult = (obj?: { __typename?: any } | null): obj is CompanyLoanAttachmentUpdateResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCompanyLoanAttachmentUpdateResult"')
      return CompanyLoanAttachmentUpdateResult_possibleTypes.includes(obj.__typename)
    }
    


    const CompanyLoanResponse_possibleTypes: string[] = ['CompanyLoanResponse']
    export const isCompanyLoanResponse = (obj?: { __typename?: any } | null): obj is CompanyLoanResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCompanyLoanResponse"')
      return CompanyLoanResponse_possibleTypes.includes(obj.__typename)
    }
    


    const CompanyLoansResponse_possibleTypes: string[] = ['CompanyLoansResponse']
    export const isCompanyLoansResponse = (obj?: { __typename?: any } | null): obj is CompanyLoansResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCompanyLoansResponse"')
      return CompanyLoansResponse_possibleTypes.includes(obj.__typename)
    }
    


    const CompanyLockConditions_possibleTypes: string[] = ['CompanyLockConditions']
    export const isCompanyLockConditions = (obj?: { __typename?: any } | null): obj is CompanyLockConditions => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCompanyLockConditions"')
      return CompanyLockConditions_possibleTypes.includes(obj.__typename)
    }
    


    const CompanyLockHistory_possibleTypes: string[] = ['CompanyLockHistory']
    export const isCompanyLockHistory = (obj?: { __typename?: any } | null): obj is CompanyLockHistory => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCompanyLockHistory"')
      return CompanyLockHistory_possibleTypes.includes(obj.__typename)
    }
    


    const CompanyLockStatus_possibleTypes: string[] = ['CompanyLockStatus']
    export const isCompanyLockStatus = (obj?: { __typename?: any } | null): obj is CompanyLockStatus => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCompanyLockStatus"')
      return CompanyLockStatus_possibleTypes.includes(obj.__typename)
    }
    


    const CompanyUser_possibleTypes: string[] = ['CompanyUser']
    export const isCompanyUser = (obj?: { __typename?: any } | null): obj is CompanyUser => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCompanyUser"')
      return CompanyUser_possibleTypes.includes(obj.__typename)
    }
    


    const CompanyUsersResponse_possibleTypes: string[] = ['CompanyUsersResponse']
    export const isCompanyUsersResponse = (obj?: { __typename?: any } | null): obj is CompanyUsersResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCompanyUsersResponse"')
      return CompanyUsersResponse_possibleTypes.includes(obj.__typename)
    }
    


    const CompanyValidation_possibleTypes: string[] = ['CompanyValidation']
    export const isCompanyValidation = (obj?: { __typename?: any } | null): obj is CompanyValidation => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCompanyValidation"')
      return CompanyValidation_possibleTypes.includes(obj.__typename)
    }
    


    const CompanyValidationDomain_possibleTypes: string[] = ['CompanyValidationDomain']
    export const isCompanyValidationDomain = (obj?: { __typename?: any } | null): obj is CompanyValidationDomain => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCompanyValidationDomain"')
      return CompanyValidationDomain_possibleTypes.includes(obj.__typename)
    }
    


    const CompanyWorksheet_possibleTypes: string[] = ['CompanyWorksheet']
    export const isCompanyWorksheet = (obj?: { __typename?: any } | null): obj is CompanyWorksheet => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCompanyWorksheet"')
      return CompanyWorksheet_possibleTypes.includes(obj.__typename)
    }
    


    const CompanyWorksheetRow_possibleTypes: string[] = ['CompanyWorksheetRow']
    export const isCompanyWorksheetRow = (obj?: { __typename?: any } | null): obj is CompanyWorksheetRow => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCompanyWorksheetRow"')
      return CompanyWorksheetRow_possibleTypes.includes(obj.__typename)
    }
    


    const CompanyWorksheetRowLockableEntity_possibleTypes: string[] = ['BankAccount']
    export const isCompanyWorksheetRowLockableEntity = (obj?: { __typename?: any } | null): obj is CompanyWorksheetRowLockableEntity => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCompanyWorksheetRowLockableEntity"')
      return CompanyWorksheetRowLockableEntity_possibleTypes.includes(obj.__typename)
    }
    


    const ConfirmApBalanceTask_possibleTypes: string[] = ['ConfirmApBalanceTask']
    export const isConfirmApBalanceTask = (obj?: { __typename?: any } | null): obj is ConfirmApBalanceTask => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isConfirmApBalanceTask"')
      return ConfirmApBalanceTask_possibleTypes.includes(obj.__typename)
    }
    


    const ConfirmApBalanceTaskState_possibleTypes: string[] = ['ConfirmApBalanceTaskState']
    export const isConfirmApBalanceTaskState = (obj?: { __typename?: any } | null): obj is ConfirmApBalanceTaskState => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isConfirmApBalanceTaskState"')
      return ConfirmApBalanceTaskState_possibleTypes.includes(obj.__typename)
    }
    


    const ConfirmApBalanceTaskStateChangeLog_possibleTypes: string[] = ['ConfirmApBalanceTaskStateChangeLog']
    export const isConfirmApBalanceTaskStateChangeLog = (obj?: { __typename?: any } | null): obj is ConfirmApBalanceTaskStateChangeLog => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isConfirmApBalanceTaskStateChangeLog"')
      return ConfirmApBalanceTaskStateChangeLog_possibleTypes.includes(obj.__typename)
    }
    


    const ConfirmArBalanceTask_possibleTypes: string[] = ['ConfirmArBalanceTask']
    export const isConfirmArBalanceTask = (obj?: { __typename?: any } | null): obj is ConfirmArBalanceTask => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isConfirmArBalanceTask"')
      return ConfirmArBalanceTask_possibleTypes.includes(obj.__typename)
    }
    


    const ConfirmArBalanceTaskState_possibleTypes: string[] = ['ConfirmArBalanceTaskState']
    export const isConfirmArBalanceTaskState = (obj?: { __typename?: any } | null): obj is ConfirmArBalanceTaskState => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isConfirmArBalanceTaskState"')
      return ConfirmArBalanceTaskState_possibleTypes.includes(obj.__typename)
    }
    


    const ConfirmArBalanceTaskStateChangeLog_possibleTypes: string[] = ['ConfirmArBalanceTaskStateChangeLog']
    export const isConfirmArBalanceTaskStateChangeLog = (obj?: { __typename?: any } | null): obj is ConfirmArBalanceTaskStateChangeLog => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isConfirmArBalanceTaskStateChangeLog"')
      return ConfirmArBalanceTaskStateChangeLog_possibleTypes.includes(obj.__typename)
    }
    


    const Contractor_possibleTypes: string[] = ['Contractor']
    export const isContractor = (obj?: { __typename?: any } | null): obj is Contractor => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isContractor"')
      return Contractor_possibleTypes.includes(obj.__typename)
    }
    


    const ContractorPayment_possibleTypes: string[] = ['ContractorPayment']
    export const isContractorPayment = (obj?: { __typename?: any } | null): obj is ContractorPayment => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isContractorPayment"')
      return ContractorPayment_possibleTypes.includes(obj.__typename)
    }
    


    const ContractorPaymentIdsByCompanyItem_possibleTypes: string[] = ['ContractorPaymentIdsByCompanyItem']
    export const isContractorPaymentIdsByCompanyItem = (obj?: { __typename?: any } | null): obj is ContractorPaymentIdsByCompanyItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isContractorPaymentIdsByCompanyItem"')
      return ContractorPaymentIdsByCompanyItem_possibleTypes.includes(obj.__typename)
    }
    


    const ContractorPaymentIdsByCompanyResponse_possibleTypes: string[] = ['ContractorPaymentIdsByCompanyResponse']
    export const isContractorPaymentIdsByCompanyResponse = (obj?: { __typename?: any } | null): obj is ContractorPaymentIdsByCompanyResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isContractorPaymentIdsByCompanyResponse"')
      return ContractorPaymentIdsByCompanyResponse_possibleTypes.includes(obj.__typename)
    }
    


    const ContractorPaymentsInternalResponse_possibleTypes: string[] = ['ContractorPaymentsInternalResponse']
    export const isContractorPaymentsInternalResponse = (obj?: { __typename?: any } | null): obj is ContractorPaymentsInternalResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isContractorPaymentsInternalResponse"')
      return ContractorPaymentsInternalResponse_possibleTypes.includes(obj.__typename)
    }
    


    const ConvertBetweenCurrenciesResult_possibleTypes: string[] = ['ConvertBetweenCurrenciesResult']
    export const isConvertBetweenCurrenciesResult = (obj?: { __typename?: any } | null): obj is ConvertBetweenCurrenciesResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isConvertBetweenCurrenciesResult"')
      return ConvertBetweenCurrenciesResult_possibleTypes.includes(obj.__typename)
    }
    


    const CreateCheckoutSessionResponse_possibleTypes: string[] = ['CreateCheckoutSessionResponse']
    export const isCreateCheckoutSessionResponse = (obj?: { __typename?: any } | null): obj is CreateCheckoutSessionResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCreateCheckoutSessionResponse"')
      return CreateCheckoutSessionResponse_possibleTypes.includes(obj.__typename)
    }
    


    const CreateCustomerCategorizationRuleResult_possibleTypes: string[] = ['CreateCustomerCategorizationRuleResult']
    export const isCreateCustomerCategorizationRuleResult = (obj?: { __typename?: any } | null): obj is CreateCustomerCategorizationRuleResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCreateCustomerCategorizationRuleResult"')
      return CreateCustomerCategorizationRuleResult_possibleTypes.includes(obj.__typename)
    }
    


    const CreateGlobalRuleResult_possibleTypes: string[] = ['CreateGlobalRuleResult']
    export const isCreateGlobalRuleResult = (obj?: { __typename?: any } | null): obj is CreateGlobalRuleResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCreateGlobalRuleResult"')
      return CreateGlobalRuleResult_possibleTypes.includes(obj.__typename)
    }
    


    const CreateInventoryVendorValidationResponse_possibleTypes: string[] = ['CreateInventoryVendorValidationResponse']
    export const isCreateInventoryVendorValidationResponse = (obj?: { __typename?: any } | null): obj is CreateInventoryVendorValidationResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCreateInventoryVendorValidationResponse"')
      return CreateInventoryVendorValidationResponse_possibleTypes.includes(obj.__typename)
    }
    


    const CreateOrUpdateAccrualResult_possibleTypes: string[] = ['CreateOrUpdateAccrualResult']
    export const isCreateOrUpdateAccrualResult = (obj?: { __typename?: any } | null): obj is CreateOrUpdateAccrualResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCreateOrUpdateAccrualResult"')
      return CreateOrUpdateAccrualResult_possibleTypes.includes(obj.__typename)
    }
    


    const CreateProductManuallyError_possibleTypes: string[] = ['CreateProductManuallyError']
    export const isCreateProductManuallyError = (obj?: { __typename?: any } | null): obj is CreateProductManuallyError => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCreateProductManuallyError"')
      return CreateProductManuallyError_possibleTypes.includes(obj.__typename)
    }
    


    const CreateProductManuallyResponse_possibleTypes: string[] = ['CreateProductManuallyError','CreateProductManuallySuccess']
    export const isCreateProductManuallyResponse = (obj?: { __typename?: any } | null): obj is CreateProductManuallyResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCreateProductManuallyResponse"')
      return CreateProductManuallyResponse_possibleTypes.includes(obj.__typename)
    }
    


    const CreateProductManuallySuccess_possibleTypes: string[] = ['CreateProductManuallySuccess']
    export const isCreateProductManuallySuccess = (obj?: { __typename?: any } | null): obj is CreateProductManuallySuccess => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCreateProductManuallySuccess"')
      return CreateProductManuallySuccess_possibleTypes.includes(obj.__typename)
    }
    


    const CreateTeamCategorizationRuleResult_possibleTypes: string[] = ['CreateTeamCategorizationRuleResult']
    export const isCreateTeamCategorizationRuleResult = (obj?: { __typename?: any } | null): obj is CreateTeamCategorizationRuleResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCreateTeamCategorizationRuleResult"')
      return CreateTeamCategorizationRuleResult_possibleTypes.includes(obj.__typename)
    }
    


    const CreateUserResponse_possibleTypes: string[] = ['CreateUserResponse']
    export const isCreateUserResponse = (obj?: { __typename?: any } | null): obj is CreateUserResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCreateUserResponse"')
      return CreateUserResponse_possibleTypes.includes(obj.__typename)
    }
    


    const CSVUpload_possibleTypes: string[] = ['CSVUpload']
    export const isCSVUpload = (obj?: { __typename?: any } | null): obj is CSVUpload => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCSVUpload"')
      return CSVUpload_possibleTypes.includes(obj.__typename)
    }
    


    const CurrentlyRunningInventoryDataSyncResponse_possibleTypes: string[] = ['CurrentlyRunningInventoryDataSyncResponse']
    export const isCurrentlyRunningInventoryDataSyncResponse = (obj?: { __typename?: any } | null): obj is CurrentlyRunningInventoryDataSyncResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCurrentlyRunningInventoryDataSyncResponse"')
      return CurrentlyRunningInventoryDataSyncResponse_possibleTypes.includes(obj.__typename)
    }
    


    const CurrentlyRunningInventoryDataSyncVendorsResponse_possibleTypes: string[] = ['CurrentlyRunningInventoryDataSyncVendorsResponse']
    export const isCurrentlyRunningInventoryDataSyncVendorsResponse = (obj?: { __typename?: any } | null): obj is CurrentlyRunningInventoryDataSyncVendorsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCurrentlyRunningInventoryDataSyncVendorsResponse"')
      return CurrentlyRunningInventoryDataSyncVendorsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const CurrentPreviousValue_possibleTypes: string[] = ['CurrentPreviousValue']
    export const isCurrentPreviousValue = (obj?: { __typename?: any } | null): obj is CurrentPreviousValue => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCurrentPreviousValue"')
      return CurrentPreviousValue_possibleTypes.includes(obj.__typename)
    }
    


    const Customer_possibleTypes: string[] = ['Customer']
    export const isCustomer = (obj?: { __typename?: any } | null): obj is Customer => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCustomer"')
      return Customer_possibleTypes.includes(obj.__typename)
    }
    


    const CustomerAddress_possibleTypes: string[] = ['CustomerAddress']
    export const isCustomerAddress = (obj?: { __typename?: any } | null): obj is CustomerAddress => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCustomerAddress"')
      return CustomerAddress_possibleTypes.includes(obj.__typename)
    }
    


    const CustomerAddressOld_possibleTypes: string[] = ['CustomerAddressOld']
    export const isCustomerAddressOld = (obj?: { __typename?: any } | null): obj is CustomerAddressOld => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCustomerAddressOld"')
      return CustomerAddressOld_possibleTypes.includes(obj.__typename)
    }
    


    const CustomerAddressV3_possibleTypes: string[] = ['CustomerAddressV3']
    export const isCustomerAddressV3 = (obj?: { __typename?: any } | null): obj is CustomerAddressV3 => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCustomerAddressV3"')
      return CustomerAddressV3_possibleTypes.includes(obj.__typename)
    }
    


    const CustomerNotExistError_possibleTypes: string[] = ['CustomerNotExistError']
    export const isCustomerNotExistError = (obj?: { __typename?: any } | null): obj is CustomerNotExistError => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCustomerNotExistError"')
      return CustomerNotExistError_possibleTypes.includes(obj.__typename)
    }
    


    const CustomerV2_possibleTypes: string[] = ['CustomerV2']
    export const isCustomerV2 = (obj?: { __typename?: any } | null): obj is CustomerV2 => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCustomerV2"')
      return CustomerV2_possibleTypes.includes(obj.__typename)
    }
    


    const CustomerV3_possibleTypes: string[] = ['CustomerV3']
    export const isCustomerV3 = (obj?: { __typename?: any } | null): obj is CustomerV3 => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCustomerV3"')
      return CustomerV3_possibleTypes.includes(obj.__typename)
    }
    


    const CustomFixedAssetsData_possibleTypes: string[] = ['CustomFixedAssetsData']
    export const isCustomFixedAssetsData = (obj?: { __typename?: any } | null): obj is CustomFixedAssetsData => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCustomFixedAssetsData"')
      return CustomFixedAssetsData_possibleTypes.includes(obj.__typename)
    }
    


    const CustomSpread_possibleTypes: string[] = ['CustomSpread']
    export const isCustomSpread = (obj?: { __typename?: any } | null): obj is CustomSpread => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCustomSpread"')
      return CustomSpread_possibleTypes.includes(obj.__typename)
    }
    


    const CustomSpreadOptions_possibleTypes: string[] = ['CustomSpreadOptions']
    export const isCustomSpreadOptions = (obj?: { __typename?: any } | null): obj is CustomSpreadOptions => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCustomSpreadOptions"')
      return CustomSpreadOptions_possibleTypes.includes(obj.__typename)
    }
    


    const CustomSpreadOverTime_possibleTypes: string[] = ['CustomSpreadOverTime']
    export const isCustomSpreadOverTime = (obj?: { __typename?: any } | null): obj is CustomSpreadOverTime => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCustomSpreadOverTime"')
      return CustomSpreadOverTime_possibleTypes.includes(obj.__typename)
    }
    


    const DailyAggregatedOwnersDraw_possibleTypes: string[] = ['DailyAggregatedOwnersDraw']
    export const isDailyAggregatedOwnersDraw = (obj?: { __typename?: any } | null): obj is DailyAggregatedOwnersDraw => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDailyAggregatedOwnersDraw"')
      return DailyAggregatedOwnersDraw_possibleTypes.includes(obj.__typename)
    }
    


    const DailyAggregatedPaymentCheck_possibleTypes: string[] = ['DailyAggregatedPaymentCheck']
    export const isDailyAggregatedPaymentCheck = (obj?: { __typename?: any } | null): obj is DailyAggregatedPaymentCheck => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDailyAggregatedPaymentCheck"')
      return DailyAggregatedPaymentCheck_possibleTypes.includes(obj.__typename)
    }
    


    const DailyAggregatedPayrollData_possibleTypes: string[] = ['DailyAggregatedPayrollData']
    export const isDailyAggregatedPayrollData = (obj?: { __typename?: any } | null): obj is DailyAggregatedPayrollData => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDailyAggregatedPayrollData"')
      return DailyAggregatedPayrollData_possibleTypes.includes(obj.__typename)
    }
    


    const DailyAggregatedReimbursement_possibleTypes: string[] = ['DailyAggregatedReimbursement']
    export const isDailyAggregatedReimbursement = (obj?: { __typename?: any } | null): obj is DailyAggregatedReimbursement => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDailyAggregatedReimbursement"')
      return DailyAggregatedReimbursement_possibleTypes.includes(obj.__typename)
    }
    


    const DailyPaymentsByContractor_possibleTypes: string[] = ['DailyPaymentsByContractor']
    export const isDailyPaymentsByContractor = (obj?: { __typename?: any } | null): obj is DailyPaymentsByContractor => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDailyPaymentsByContractor"')
      return DailyPaymentsByContractor_possibleTypes.includes(obj.__typename)
    }
    


    const DailyPaymentsByEmployee_possibleTypes: string[] = ['DailyPaymentsByEmployee']
    export const isDailyPaymentsByEmployee = (obj?: { __typename?: any } | null): obj is DailyPaymentsByEmployee => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDailyPaymentsByEmployee"')
      return DailyPaymentsByEmployee_possibleTypes.includes(obj.__typename)
    }
    


    const DataSerie_possibleTypes: string[] = ['DataSerie']
    export const isDataSerie = (obj?: { __typename?: any } | null): obj is DataSerie => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDataSerie"')
      return DataSerie_possibleTypes.includes(obj.__typename)
    }
    


    const DateRange_possibleTypes: string[] = ['DateRange']
    export const isDateRange = (obj?: { __typename?: any } | null): obj is DateRange => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDateRange"')
      return DateRange_possibleTypes.includes(obj.__typename)
    }
    


    const DatesToFix_possibleTypes: string[] = ['DatesToFix']
    export const isDatesToFix = (obj?: { __typename?: any } | null): obj is DatesToFix => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDatesToFix"')
      return DatesToFix_possibleTypes.includes(obj.__typename)
    }
    


    const DeadInventoryAction_possibleTypes: string[] = ['DeadInventoryAction']
    export const isDeadInventoryAction = (obj?: { __typename?: any } | null): obj is DeadInventoryAction => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDeadInventoryAction"')
      return DeadInventoryAction_possibleTypes.includes(obj.__typename)
    }
    


    const DeadInventoryCogs_possibleTypes: string[] = ['DeadInventoryCogs']
    export const isDeadInventoryCogs = (obj?: { __typename?: any } | null): obj is DeadInventoryCogs => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDeadInventoryCogs"')
      return DeadInventoryCogs_possibleTypes.includes(obj.__typename)
    }
    


    const DeadInventoryDailyBreakdown_possibleTypes: string[] = ['DeadInventoryDailyBreakdown']
    export const isDeadInventoryDailyBreakdown = (obj?: { __typename?: any } | null): obj is DeadInventoryDailyBreakdown => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDeadInventoryDailyBreakdown"')
      return DeadInventoryDailyBreakdown_possibleTypes.includes(obj.__typename)
    }
    


    const DeadInventoryMonthlyBreakdown_possibleTypes: string[] = ['DeadInventoryMonthlyBreakdown']
    export const isDeadInventoryMonthlyBreakdown = (obj?: { __typename?: any } | null): obj is DeadInventoryMonthlyBreakdown => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDeadInventoryMonthlyBreakdown"')
      return DeadInventoryMonthlyBreakdown_possibleTypes.includes(obj.__typename)
    }
    


    const DeadInventoryOriginalValue_possibleTypes: string[] = ['DeadInventoryOriginalValue']
    export const isDeadInventoryOriginalValue = (obj?: { __typename?: any } | null): obj is DeadInventoryOriginalValue => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDeadInventoryOriginalValue"')
      return DeadInventoryOriginalValue_possibleTypes.includes(obj.__typename)
    }
    


    const DefaultFixedAssetsData_possibleTypes: string[] = ['DefaultFixedAssetsData']
    export const isDefaultFixedAssetsData = (obj?: { __typename?: any } | null): obj is DefaultFixedAssetsData => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDefaultFixedAssetsData"')
      return DefaultFixedAssetsData_possibleTypes.includes(obj.__typename)
    }
    


    const DeleteInventoryPaymentGroupResponse_possibleTypes: string[] = ['DeleteInventoryPaymentGroupResponse']
    export const isDeleteInventoryPaymentGroupResponse = (obj?: { __typename?: any } | null): obj is DeleteInventoryPaymentGroupResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDeleteInventoryPaymentGroupResponse"')
      return DeleteInventoryPaymentGroupResponse_possibleTypes.includes(obj.__typename)
    }
    


    const DeleteInvoicesResponse_possibleTypes: string[] = ['DeleteInvoicesResponse']
    export const isDeleteInvoicesResponse = (obj?: { __typename?: any } | null): obj is DeleteInvoicesResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDeleteInvoicesResponse"')
      return DeleteInvoicesResponse_possibleTypes.includes(obj.__typename)
    }
    


    const DeleteLoansEventsEffectConfigurationResult_possibleTypes: string[] = ['DeleteLoansEventsEffectConfigurationResult']
    export const isDeleteLoansEventsEffectConfigurationResult = (obj?: { __typename?: any } | null): obj is DeleteLoansEventsEffectConfigurationResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDeleteLoansEventsEffectConfigurationResult"')
      return DeleteLoansEventsEffectConfigurationResult_possibleTypes.includes(obj.__typename)
    }
    


    const DeleteLoansResults_possibleTypes: string[] = ['DeleteLoansResults']
    export const isDeleteLoansResults = (obj?: { __typename?: any } | null): obj is DeleteLoansResults => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDeleteLoansResults"')
      return DeleteLoansResults_possibleTypes.includes(obj.__typename)
    }
    


    const DeleteOrderGroupResponse_possibleTypes: string[] = ['DeleteOrderGroupResponse']
    export const isDeleteOrderGroupResponse = (obj?: { __typename?: any } | null): obj is DeleteOrderGroupResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDeleteOrderGroupResponse"')
      return DeleteOrderGroupResponse_possibleTypes.includes(obj.__typename)
    }
    


    const DeleteOrderGroupUponTransactionChangeResponse_possibleTypes: string[] = ['DeleteOrderGroupUponTransactionChangeResponse']
    export const isDeleteOrderGroupUponTransactionChangeResponse = (obj?: { __typename?: any } | null): obj is DeleteOrderGroupUponTransactionChangeResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDeleteOrderGroupUponTransactionChangeResponse"')
      return DeleteOrderGroupUponTransactionChangeResponse_possibleTypes.includes(obj.__typename)
    }
    


    const DeletePaymentGroupResponse_possibleTypes: string[] = ['DeletePaymentGroupResponse']
    export const isDeletePaymentGroupResponse = (obj?: { __typename?: any } | null): obj is DeletePaymentGroupResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDeletePaymentGroupResponse"')
      return DeletePaymentGroupResponse_possibleTypes.includes(obj.__typename)
    }
    


    const DeletePaymentGroupUponTransactionChangeResponse_possibleTypes: string[] = ['DeletePaymentGroupUponTransactionChangeResponse']
    export const isDeletePaymentGroupUponTransactionChangeResponse = (obj?: { __typename?: any } | null): obj is DeletePaymentGroupUponTransactionChangeResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDeletePaymentGroupUponTransactionChangeResponse"')
      return DeletePaymentGroupUponTransactionChangeResponse_possibleTypes.includes(obj.__typename)
    }
    


    const Department_possibleTypes: string[] = ['Department']
    export const isDepartment = (obj?: { __typename?: any } | null): obj is Department => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDepartment"')
      return Department_possibleTypes.includes(obj.__typename)
    }
    


    const Dependency_possibleTypes: string[] = ['BalanceSheetDependency','YearEndDependency']
    export const isDependency = (obj?: { __typename?: any } | null): obj is Dependency => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDependency"')
      return Dependency_possibleTypes.includes(obj.__typename)
    }
    


    const DirectLineItem_possibleTypes: string[] = ['DirectLineItem']
    export const isDirectLineItem = (obj?: { __typename?: any } | null): obj is DirectLineItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDirectLineItem"')
      return DirectLineItem_possibleTypes.includes(obj.__typename)
    }
    


    const Discount_possibleTypes: string[] = ['Discount']
    export const isDiscount = (obj?: { __typename?: any } | null): obj is Discount => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDiscount"')
      return Discount_possibleTypes.includes(obj.__typename)
    }
    


    const DiscountLineItemV3_possibleTypes: string[] = ['DiscountLineItemV3']
    export const isDiscountLineItemV3 = (obj?: { __typename?: any } | null): obj is DiscountLineItemV3 => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDiscountLineItemV3"')
      return DiscountLineItemV3_possibleTypes.includes(obj.__typename)
    }
    


    const Dispute_possibleTypes: string[] = ['Dispute']
    export const isDispute = (obj?: { __typename?: any } | null): obj is Dispute => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDispute"')
      return Dispute_possibleTypes.includes(obj.__typename)
    }
    


    const DonationCogs_possibleTypes: string[] = ['DonationCogs']
    export const isDonationCogs = (obj?: { __typename?: any } | null): obj is DonationCogs => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDonationCogs"')
      return DonationCogs_possibleTypes.includes(obj.__typename)
    }
    


    const DonationDailyBreakdown_possibleTypes: string[] = ['DonationDailyBreakdown']
    export const isDonationDailyBreakdown = (obj?: { __typename?: any } | null): obj is DonationDailyBreakdown => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDonationDailyBreakdown"')
      return DonationDailyBreakdown_possibleTypes.includes(obj.__typename)
    }
    


    const DonationMonthlyBreakdown_possibleTypes: string[] = ['DonationMonthlyBreakdown']
    export const isDonationMonthlyBreakdown = (obj?: { __typename?: any } | null): obj is DonationMonthlyBreakdown => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDonationMonthlyBreakdown"')
      return DonationMonthlyBreakdown_possibleTypes.includes(obj.__typename)
    }
    


    const DonationOriginalValue_possibleTypes: string[] = ['DonationOriginalValue']
    export const isDonationOriginalValue = (obj?: { __typename?: any } | null): obj is DonationOriginalValue => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDonationOriginalValue"')
      return DonationOriginalValue_possibleTypes.includes(obj.__typename)
    }
    


    const DownloadAttachmentResult_possibleTypes: string[] = ['DownloadAttachmentResult']
    export const isDownloadAttachmentResult = (obj?: { __typename?: any } | null): obj is DownloadAttachmentResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDownloadAttachmentResult"')
      return DownloadAttachmentResult_possibleTypes.includes(obj.__typename)
    }
    


    const DropshippingSettings_possibleTypes: string[] = ['DropshippingSettings']
    export const isDropshippingSettings = (obj?: { __typename?: any } | null): obj is DropshippingSettings => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDropshippingSettings"')
      return DropshippingSettings_possibleTypes.includes(obj.__typename)
    }
    


    const DueDateSummary_possibleTypes: string[] = ['DueDateSummary']
    export const isDueDateSummary = (obj?: { __typename?: any } | null): obj is DueDateSummary => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDueDateSummary"')
      return DueDateSummary_possibleTypes.includes(obj.__typename)
    }
    


    const EarlyRepaymentDiscount_possibleTypes: string[] = ['EarlyRepaymentDiscount']
    export const isEarlyRepaymentDiscount = (obj?: { __typename?: any } | null): obj is EarlyRepaymentDiscount => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isEarlyRepaymentDiscount"')
      return EarlyRepaymentDiscount_possibleTypes.includes(obj.__typename)
    }
    


    const Employee_possibleTypes: string[] = ['Employee']
    export const isEmployee = (obj?: { __typename?: any } | null): obj is Employee => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isEmployee"')
      return Employee_possibleTypes.includes(obj.__typename)
    }
    


    const EntityLockedPeriodBypass_possibleTypes: string[] = ['EntityLockedPeriodBypass']
    export const isEntityLockedPeriodBypass = (obj?: { __typename?: any } | null): obj is EntityLockedPeriodBypass => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isEntityLockedPeriodBypass"')
      return EntityLockedPeriodBypass_possibleTypes.includes(obj.__typename)
    }
    


    const EquityEventsEffectConfiguration_possibleTypes: string[] = ['EquityEventsEffectConfiguration']
    export const isEquityEventsEffectConfiguration = (obj?: { __typename?: any } | null): obj is EquityEventsEffectConfiguration => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isEquityEventsEffectConfiguration"')
      return EquityEventsEffectConfiguration_possibleTypes.includes(obj.__typename)
    }
    


    const Error_possibleTypes: string[] = ['CustomerNotExistError','VendorNotExistError']
    export const isError = (obj?: { __typename?: any } | null): obj is Error => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isError"')
      return Error_possibleTypes.includes(obj.__typename)
    }
    


    const EvaluateBankReconciliationRequestsResponse_possibleTypes: string[] = ['EvaluateBankReconciliationRequestsResponse']
    export const isEvaluateBankReconciliationRequestsResponse = (obj?: { __typename?: any } | null): obj is EvaluateBankReconciliationRequestsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isEvaluateBankReconciliationRequestsResponse"')
      return EvaluateBankReconciliationRequestsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const EventsLock_possibleTypes: string[] = ['EventsLock']
    export const isEventsLock = (obj?: { __typename?: any } | null): obj is EventsLock => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isEventsLock"')
      return EventsLock_possibleTypes.includes(obj.__typename)
    }
    


    const ExcludedSalesChannelItemReconciliation_possibleTypes: string[] = ['ExcludedSalesChannelItemReconciliation']
    export const isExcludedSalesChannelItemReconciliation = (obj?: { __typename?: any } | null): obj is ExcludedSalesChannelItemReconciliation => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isExcludedSalesChannelItemReconciliation"')
      return ExcludedSalesChannelItemReconciliation_possibleTypes.includes(obj.__typename)
    }
    


    const ExplainBankAccountMergeDuplicate_possibleTypes: string[] = ['ExplainBankAccountMergeDuplicate']
    export const isExplainBankAccountMergeDuplicate = (obj?: { __typename?: any } | null): obj is ExplainBankAccountMergeDuplicate => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isExplainBankAccountMergeDuplicate"')
      return ExplainBankAccountMergeDuplicate_possibleTypes.includes(obj.__typename)
    }
    


    const ExplainBankAccountMergeExplain_possibleTypes: string[] = ['ExplainBankAccountMergeExplain']
    export const isExplainBankAccountMergeExplain = (obj?: { __typename?: any } | null): obj is ExplainBankAccountMergeExplain => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isExplainBankAccountMergeExplain"')
      return ExplainBankAccountMergeExplain_possibleTypes.includes(obj.__typename)
    }
    


    const ExplainBankAccountMergeNote_possibleTypes: string[] = ['ExplainBankAccountMergeNote']
    export const isExplainBankAccountMergeNote = (obj?: { __typename?: any } | null): obj is ExplainBankAccountMergeNote => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isExplainBankAccountMergeNote"')
      return ExplainBankAccountMergeNote_possibleTypes.includes(obj.__typename)
    }
    


    const ExplainBankAccountMergeResponse_possibleTypes: string[] = ['ExplainBankAccountMergeResponse']
    export const isExplainBankAccountMergeResponse = (obj?: { __typename?: any } | null): obj is ExplainBankAccountMergeResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isExplainBankAccountMergeResponse"')
      return ExplainBankAccountMergeResponse_possibleTypes.includes(obj.__typename)
    }
    


    const ExplainBankAccountMergeTransactionsImportStatus_possibleTypes: string[] = ['ExplainBankAccountMergeTransactionsImportStatus']
    export const isExplainBankAccountMergeTransactionsImportStatus = (obj?: { __typename?: any } | null): obj is ExplainBankAccountMergeTransactionsImportStatus => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isExplainBankAccountMergeTransactionsImportStatus"')
      return ExplainBankAccountMergeTransactionsImportStatus_possibleTypes.includes(obj.__typename)
    }
    


    const ExplainFifoResult_possibleTypes: string[] = ['ExplainFifoResult']
    export const isExplainFifoResult = (obj?: { __typename?: any } | null): obj is ExplainFifoResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isExplainFifoResult"')
      return ExplainFifoResult_possibleTypes.includes(obj.__typename)
    }
    


    const ExportAccrualsListCsvResponse_possibleTypes: string[] = ['ExportAccrualsListCsvResponse']
    export const isExportAccrualsListCsvResponse = (obj?: { __typename?: any } | null): obj is ExportAccrualsListCsvResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isExportAccrualsListCsvResponse"')
      return ExportAccrualsListCsvResponse_possibleTypes.includes(obj.__typename)
    }
    


    const ExportCOGSBreakdownResponse_possibleTypes: string[] = ['ExportCOGSBreakdownResponse']
    export const isExportCOGSBreakdownResponse = (obj?: { __typename?: any } | null): obj is ExportCOGSBreakdownResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isExportCOGSBreakdownResponse"')
      return ExportCOGSBreakdownResponse_possibleTypes.includes(obj.__typename)
    }
    


    const ExportCOGSOverviewResponse_possibleTypes: string[] = ['ExportCOGSOverviewResponse']
    export const isExportCOGSOverviewResponse = (obj?: { __typename?: any } | null): obj is ExportCOGSOverviewResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isExportCOGSOverviewResponse"')
      return ExportCOGSOverviewResponse_possibleTypes.includes(obj.__typename)
    }
    


    const ExportCSVResponse_possibleTypes: string[] = ['ExportCSVResponse']
    export const isExportCSVResponse = (obj?: { __typename?: any } | null): obj is ExportCSVResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isExportCSVResponse"')
      return ExportCSVResponse_possibleTypes.includes(obj.__typename)
    }
    


    const ExportGeneralLedgerResponse_possibleTypes: string[] = ['ExportGeneralLedgerResponse']
    export const isExportGeneralLedgerResponse = (obj?: { __typename?: any } | null): obj is ExportGeneralLedgerResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isExportGeneralLedgerResponse"')
      return ExportGeneralLedgerResponse_possibleTypes.includes(obj.__typename)
    }
    


    const ExportInvoicesResponse_possibleTypes: string[] = ['ExportInvoicesResponse']
    export const isExportInvoicesResponse = (obj?: { __typename?: any } | null): obj is ExportInvoicesResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isExportInvoicesResponse"')
      return ExportInvoicesResponse_possibleTypes.includes(obj.__typename)
    }
    


    const ExportLoansResult_possibleTypes: string[] = ['ExportLoansResult']
    export const isExportLoansResult = (obj?: { __typename?: any } | null): obj is ExportLoansResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isExportLoansResult"')
      return ExportLoansResult_possibleTypes.includes(obj.__typename)
    }
    


    const ExportProductsResponse_possibleTypes: string[] = ['ExportProductsResponse']
    export const isExportProductsResponse = (obj?: { __typename?: any } | null): obj is ExportProductsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isExportProductsResponse"')
      return ExportProductsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const ExportPurchaseOrdersResponse_possibleTypes: string[] = ['ExportPurchaseOrdersResponse']
    export const isExportPurchaseOrdersResponse = (obj?: { __typename?: any } | null): obj is ExportPurchaseOrdersResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isExportPurchaseOrdersResponse"')
      return ExportPurchaseOrdersResponse_possibleTypes.includes(obj.__typename)
    }
    


    const ExportResponse_possibleTypes: string[] = ['ExportResponse']
    export const isExportResponse = (obj?: { __typename?: any } | null): obj is ExportResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isExportResponse"')
      return ExportResponse_possibleTypes.includes(obj.__typename)
    }
    


    const ExportSkuAnalysisResponse_possibleTypes: string[] = ['ExportSkuAnalysisResponse']
    export const isExportSkuAnalysisResponse = (obj?: { __typename?: any } | null): obj is ExportSkuAnalysisResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isExportSkuAnalysisResponse"')
      return ExportSkuAnalysisResponse_possibleTypes.includes(obj.__typename)
    }
    


    const ExtensionFiled_possibleTypes: string[] = ['ExtensionFiled']
    export const isExtensionFiled = (obj?: { __typename?: any } | null): obj is ExtensionFiled => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isExtensionFiled"')
      return ExtensionFiled_possibleTypes.includes(obj.__typename)
    }
    


    const FailingValidation_possibleTypes: string[] = ['FailingValidation']
    export const isFailingValidation = (obj?: { __typename?: any } | null): obj is FailingValidation => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFailingValidation"')
      return FailingValidation_possibleTypes.includes(obj.__typename)
    }
    


    const FeeLineItemV3_possibleTypes: string[] = ['FeeLineItemV3']
    export const isFeeLineItemV3 = (obj?: { __typename?: any } | null): obj is FeeLineItemV3 => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFeeLineItemV3"')
      return FeeLineItemV3_possibleTypes.includes(obj.__typename)
    }
    


    const FifoCogsBusinessEventsMetrics_possibleTypes: string[] = ['FifoCogsBusinessEventsMetrics']
    export const isFifoCogsBusinessEventsMetrics = (obj?: { __typename?: any } | null): obj is FifoCogsBusinessEventsMetrics => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFifoCogsBusinessEventsMetrics"')
      return FifoCogsBusinessEventsMetrics_possibleTypes.includes(obj.__typename)
    }
    


    const FifoCogsBusinessEventsSingleMetric_possibleTypes: string[] = ['FifoCogsBusinessEventsSingleMetric']
    export const isFifoCogsBusinessEventsSingleMetric = (obj?: { __typename?: any } | null): obj is FifoCogsBusinessEventsSingleMetric => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFifoCogsBusinessEventsSingleMetric"')
      return FifoCogsBusinessEventsSingleMetric_possibleTypes.includes(obj.__typename)
    }
    


    const FifoValidationCogsSummary_possibleTypes: string[] = ['FifoValidationCogsSummary']
    export const isFifoValidationCogsSummary = (obj?: { __typename?: any } | null): obj is FifoValidationCogsSummary => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFifoValidationCogsSummary"')
      return FifoValidationCogsSummary_possibleTypes.includes(obj.__typename)
    }
    


    const FifoValidationProductData_possibleTypes: string[] = ['FifoValidationProductData']
    export const isFifoValidationProductData = (obj?: { __typename?: any } | null): obj is FifoValidationProductData => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFifoValidationProductData"')
      return FifoValidationProductData_possibleTypes.includes(obj.__typename)
    }
    


    const FifoValidationProductTotals_possibleTypes: string[] = ['FifoValidationProductTotals']
    export const isFifoValidationProductTotals = (obj?: { __typename?: any } | null): obj is FifoValidationProductTotals => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFifoValidationProductTotals"')
      return FifoValidationProductTotals_possibleTypes.includes(obj.__typename)
    }
    


    const FifoValidationProductValidationData_possibleTypes: string[] = ['FifoValidationProductValidationData']
    export const isFifoValidationProductValidationData = (obj?: { __typename?: any } | null): obj is FifoValidationProductValidationData => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFifoValidationProductValidationData"')
      return FifoValidationProductValidationData_possibleTypes.includes(obj.__typename)
    }
    


    const FifoValidationSummary_possibleTypes: string[] = ['FifoValidationSummary']
    export const isFifoValidationSummary = (obj?: { __typename?: any } | null): obj is FifoValidationSummary => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFifoValidationSummary"')
      return FifoValidationSummary_possibleTypes.includes(obj.__typename)
    }
    


    const FifoValidationTotalsBalance_possibleTypes: string[] = ['FifoValidationTotalsBalance']
    export const isFifoValidationTotalsBalance = (obj?: { __typename?: any } | null): obj is FifoValidationTotalsBalance => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFifoValidationTotalsBalance"')
      return FifoValidationTotalsBalance_possibleTypes.includes(obj.__typename)
    }
    


    const FileLocation_possibleTypes: string[] = ['FileLocation']
    export const isFileLocation = (obj?: { __typename?: any } | null): obj is FileLocation => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFileLocation"')
      return FileLocation_possibleTypes.includes(obj.__typename)
    }
    


    const FileUploadUrlResult_possibleTypes: string[] = ['FileUploadUrlResult']
    export const isFileUploadUrlResult = (obj?: { __typename?: any } | null): obj is FileUploadUrlResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFileUploadUrlResult"')
      return FileUploadUrlResult_possibleTypes.includes(obj.__typename)
    }
    


    const FilingDeadline_possibleTypes: string[] = ['FilingDeadline']
    export const isFilingDeadline = (obj?: { __typename?: any } | null): obj is FilingDeadline => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFilingDeadline"')
      return FilingDeadline_possibleTypes.includes(obj.__typename)
    }
    


    const FilteringBoundsOrderV3Result_possibleTypes: string[] = ['FilteringBoundsOrderV3Result']
    export const isFilteringBoundsOrderV3Result = (obj?: { __typename?: any } | null): obj is FilteringBoundsOrderV3Result => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFilteringBoundsOrderV3Result"')
      return FilteringBoundsOrderV3Result_possibleTypes.includes(obj.__typename)
    }
    


    const FinalizeAskTheUserFlowResult_possibleTypes: string[] = ['FinalizeAskTheUserFlowResult']
    export const isFinalizeAskTheUserFlowResult = (obj?: { __typename?: any } | null): obj is FinalizeAskTheUserFlowResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFinalizeAskTheUserFlowResult"')
      return FinalizeAskTheUserFlowResult_possibleTypes.includes(obj.__typename)
    }
    


    const FinaloopProduct_possibleTypes: string[] = ['FinaloopProduct']
    export const isFinaloopProduct = (obj?: { __typename?: any } | null): obj is FinaloopProduct => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFinaloopProduct"')
      return FinaloopProduct_possibleTypes.includes(obj.__typename)
    }
    


    const FiscalYearEndStateResponse_possibleTypes: string[] = ['FiscalYearEndStateResponse']
    export const isFiscalYearEndStateResponse = (obj?: { __typename?: any } | null): obj is FiscalYearEndStateResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFiscalYearEndStateResponse"')
      return FiscalYearEndStateResponse_possibleTypes.includes(obj.__typename)
    }
    


    const FixedAssetsOptions_possibleTypes: string[] = ['FixedAssetsOptions']
    export const isFixedAssetsOptions = (obj?: { __typename?: any } | null): obj is FixedAssetsOptions => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFixedAssetsOptions"')
      return FixedAssetsOptions_possibleTypes.includes(obj.__typename)
    }
    


    const FulfillmentAction_possibleTypes: string[] = ['FulfillmentAction']
    export const isFulfillmentAction = (obj?: { __typename?: any } | null): obj is FulfillmentAction => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFulfillmentAction"')
      return FulfillmentAction_possibleTypes.includes(obj.__typename)
    }
    


    const FulfillmentCost_possibleTypes: string[] = ['FulfillmentCost']
    export const isFulfillmentCost = (obj?: { __typename?: any } | null): obj is FulfillmentCost => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFulfillmentCost"')
      return FulfillmentCost_possibleTypes.includes(obj.__typename)
    }
    


    const FulfillmentMethod_possibleTypes: string[] = ['FulfillmentMethod']
    export const isFulfillmentMethod = (obj?: { __typename?: any } | null): obj is FulfillmentMethod => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFulfillmentMethod"')
      return FulfillmentMethod_possibleTypes.includes(obj.__typename)
    }
    


    const FulfillmentSetting_possibleTypes: string[] = ['FulfillmentSetting']
    export const isFulfillmentSetting = (obj?: { __typename?: any } | null): obj is FulfillmentSetting => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFulfillmentSetting"')
      return FulfillmentSetting_possibleTypes.includes(obj.__typename)
    }
    


    const FulfillmentsValidation_possibleTypes: string[] = ['FulfillmentsValidation']
    export const isFulfillmentsValidation = (obj?: { __typename?: any } | null): obj is FulfillmentsValidation => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFulfillmentsValidation"')
      return FulfillmentsValidation_possibleTypes.includes(obj.__typename)
    }
    


    const GenerateBigValidationResponse_possibleTypes: string[] = ['GenerateBigValidationResponse']
    export const isGenerateBigValidationResponse = (obj?: { __typename?: any } | null): obj is GenerateBigValidationResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGenerateBigValidationResponse"')
      return GenerateBigValidationResponse_possibleTypes.includes(obj.__typename)
    }
    


    const GenerateFifoValidationResponse_possibleTypes: string[] = ['GenerateFifoValidationResponse']
    export const isGenerateFifoValidationResponse = (obj?: { __typename?: any } | null): obj is GenerateFifoValidationResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGenerateFifoValidationResponse"')
      return GenerateFifoValidationResponse_possibleTypes.includes(obj.__typename)
    }
    


    const GenerateNoUnitsValidationError_possibleTypes: string[] = ['GenerateNoUnitsValidationError']
    export const isGenerateNoUnitsValidationError = (obj?: { __typename?: any } | null): obj is GenerateNoUnitsValidationError => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGenerateNoUnitsValidationError"')
      return GenerateNoUnitsValidationError_possibleTypes.includes(obj.__typename)
    }
    


    const GenerateNoUnitsValidationResponse_possibleTypes: string[] = ['GenerateNoUnitsValidationResponse']
    export const isGenerateNoUnitsValidationResponse = (obj?: { __typename?: any } | null): obj is GenerateNoUnitsValidationResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGenerateNoUnitsValidationResponse"')
      return GenerateNoUnitsValidationResponse_possibleTypes.includes(obj.__typename)
    }
    


    const GenerateNoUnitsValidationResult_possibleTypes: string[] = ['GenerateNoUnitsValidationResult']
    export const isGenerateNoUnitsValidationResult = (obj?: { __typename?: any } | null): obj is GenerateNoUnitsValidationResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGenerateNoUnitsValidationResult"')
      return GenerateNoUnitsValidationResult_possibleTypes.includes(obj.__typename)
    }
    


    const GeneratePdfError_possibleTypes: string[] = ['GeneratePdfError']
    export const isGeneratePdfError = (obj?: { __typename?: any } | null): obj is GeneratePdfError => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGeneratePdfError"')
      return GeneratePdfError_possibleTypes.includes(obj.__typename)
    }
    


    const GeneratePdfResponse_possibleTypes: string[] = ['GeneratePdfResponse']
    export const isGeneratePdfResponse = (obj?: { __typename?: any } | null): obj is GeneratePdfResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGeneratePdfResponse"')
      return GeneratePdfResponse_possibleTypes.includes(obj.__typename)
    }
    


    const GeneratePdfResponseV2_possibleTypes: string[] = ['GeneratePdfResponse','GeneratePdfError']
    export const isGeneratePdfResponseV2 = (obj?: { __typename?: any } | null): obj is GeneratePdfResponseV2 => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGeneratePdfResponseV2"')
      return GeneratePdfResponseV2_possibleTypes.includes(obj.__typename)
    }
    


    const GenericResponse_possibleTypes: string[] = ['GenericResponse']
    export const isGenericResponse = (obj?: { __typename?: any } | null): obj is GenericResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGenericResponse"')
      return GenericResponse_possibleTypes.includes(obj.__typename)
    }
    


    const GetAllCompaniesForDomainResponse_possibleTypes: string[] = ['GetAllCompaniesForDomainResponse']
    export const isGetAllCompaniesForDomainResponse = (obj?: { __typename?: any } | null): obj is GetAllCompaniesForDomainResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGetAllCompaniesForDomainResponse"')
      return GetAllCompaniesForDomainResponse_possibleTypes.includes(obj.__typename)
    }
    


    const GetAllocatableEventIdsResult_possibleTypes: string[] = ['GetAllocatableEventIdsResult']
    export const isGetAllocatableEventIdsResult = (obj?: { __typename?: any } | null): obj is GetAllocatableEventIdsResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGetAllocatableEventIdsResult"')
      return GetAllocatableEventIdsResult_possibleTypes.includes(obj.__typename)
    }
    


    const GetBackOfficeBankStatementRequestsResponse_possibleTypes: string[] = ['GetBackOfficeBankStatementRequestsResponse']
    export const isGetBackOfficeBankStatementRequestsResponse = (obj?: { __typename?: any } | null): obj is GetBackOfficeBankStatementRequestsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGetBackOfficeBankStatementRequestsResponse"')
      return GetBackOfficeBankStatementRequestsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const GetBalanceSheetSetupItemDocumentUrlReponse_possibleTypes: string[] = ['GetBalanceSheetSetupItemDocumentUrlReponse']
    export const isGetBalanceSheetSetupItemDocumentUrlReponse = (obj?: { __typename?: any } | null): obj is GetBalanceSheetSetupItemDocumentUrlReponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGetBalanceSheetSetupItemDocumentUrlReponse"')
      return GetBalanceSheetSetupItemDocumentUrlReponse_possibleTypes.includes(obj.__typename)
    }
    


    const GetBillsResponse_possibleTypes: string[] = ['GetBillsResponse']
    export const isGetBillsResponse = (obj?: { __typename?: any } | null): obj is GetBillsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGetBillsResponse"')
      return GetBillsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const GetCOGSBreakdownResponse_possibleTypes: string[] = ['GetCOGSBreakdownResponse']
    export const isGetCOGSBreakdownResponse = (obj?: { __typename?: any } | null): obj is GetCOGSBreakdownResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGetCOGSBreakdownResponse"')
      return GetCOGSBreakdownResponse_possibleTypes.includes(obj.__typename)
    }
    


    const GetCOGSOverviewResponse_possibleTypes: string[] = ['GetCOGSOverviewResponse']
    export const isGetCOGSOverviewResponse = (obj?: { __typename?: any } | null): obj is GetCOGSOverviewResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGetCOGSOverviewResponse"')
      return GetCOGSOverviewResponse_possibleTypes.includes(obj.__typename)
    }
    


    const GetCustomerResponse_possibleTypes: string[] = ['Customer','CustomerNotExistError']
    export const isGetCustomerResponse = (obj?: { __typename?: any } | null): obj is GetCustomerResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGetCustomerResponse"')
      return GetCustomerResponse_possibleTypes.includes(obj.__typename)
    }
    


    const GetExportedReportsResponse_possibleTypes: string[] = ['GetExportedReportsResponse']
    export const isGetExportedReportsResponse = (obj?: { __typename?: any } | null): obj is GetExportedReportsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGetExportedReportsResponse"')
      return GetExportedReportsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const GetFromEmailAddressError_possibleTypes: string[] = ['GetFromEmailAddressError']
    export const isGetFromEmailAddressError = (obj?: { __typename?: any } | null): obj is GetFromEmailAddressError => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGetFromEmailAddressError"')
      return GetFromEmailAddressError_possibleTypes.includes(obj.__typename)
    }
    


    const GetFromEmailAddressResponse_possibleTypes: string[] = ['GetFromEmailAddressResponse']
    export const isGetFromEmailAddressResponse = (obj?: { __typename?: any } | null): obj is GetFromEmailAddressResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGetFromEmailAddressResponse"')
      return GetFromEmailAddressResponse_possibleTypes.includes(obj.__typename)
    }
    


    const GetFromEmailAddressResult_possibleTypes: string[] = ['GetFromEmailAddressResponse','GetFromEmailAddressError']
    export const isGetFromEmailAddressResult = (obj?: { __typename?: any } | null): obj is GetFromEmailAddressResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGetFromEmailAddressResult"')
      return GetFromEmailAddressResult_possibleTypes.includes(obj.__typename)
    }
    


    const GetFulfillmentSettingsResponse_possibleTypes: string[] = ['GetFulfillmentSettingsResponse']
    export const isGetFulfillmentSettingsResponse = (obj?: { __typename?: any } | null): obj is GetFulfillmentSettingsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGetFulfillmentSettingsResponse"')
      return GetFulfillmentSettingsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const GetInventoryAccountBalanceResponse_possibleTypes: string[] = ['GetInventoryAccountBalanceResponse']
    export const isGetInventoryAccountBalanceResponse = (obj?: { __typename?: any } | null): obj is GetInventoryAccountBalanceResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGetInventoryAccountBalanceResponse"')
      return GetInventoryAccountBalanceResponse_possibleTypes.includes(obj.__typename)
    }
    


    const GetInvoicesAffectingPaymentGroupsResponse_possibleTypes: string[] = ['GetInvoicesAffectingPaymentGroupsResponse']
    export const isGetInvoicesAffectingPaymentGroupsResponse = (obj?: { __typename?: any } | null): obj is GetInvoicesAffectingPaymentGroupsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGetInvoicesAffectingPaymentGroupsResponse"')
      return GetInvoicesAffectingPaymentGroupsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const GetInvoicesResult_possibleTypes: string[] = ['GetInvoicesResult']
    export const isGetInvoicesResult = (obj?: { __typename?: any } | null): obj is GetInvoicesResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGetInvoicesResult"')
      return GetInvoicesResult_possibleTypes.includes(obj.__typename)
    }
    


    const GetLatestValidationResult_possibleTypes: string[] = ['GetLatestValidationResult']
    export const isGetLatestValidationResult = (obj?: { __typename?: any } | null): obj is GetLatestValidationResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGetLatestValidationResult"')
      return GetLatestValidationResult_possibleTypes.includes(obj.__typename)
    }
    


    const GetLoanEventsLengthResult_possibleTypes: string[] = ['GetLoanEventsLengthResult']
    export const isGetLoanEventsLengthResult = (obj?: { __typename?: any } | null): obj is GetLoanEventsLengthResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGetLoanEventsLengthResult"')
      return GetLoanEventsLengthResult_possibleTypes.includes(obj.__typename)
    }
    


    const GetLoanEventsResult_possibleTypes: string[] = ['GetLoanEventsResult']
    export const isGetLoanEventsResult = (obj?: { __typename?: any } | null): obj is GetLoanEventsResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGetLoanEventsResult"')
      return GetLoanEventsResult_possibleTypes.includes(obj.__typename)
    }
    


    const GetLoanRelationshipsResult_possibleTypes: string[] = ['GetLoanRelationshipsResult']
    export const isGetLoanRelationshipsResult = (obj?: { __typename?: any } | null): obj is GetLoanRelationshipsResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGetLoanRelationshipsResult"')
      return GetLoanRelationshipsResult_possibleTypes.includes(obj.__typename)
    }
    


    const GetLoansOutstandingAmountOnDateResult_possibleTypes: string[] = ['GetLoansOutstandingAmountOnDateResult']
    export const isGetLoansOutstandingAmountOnDateResult = (obj?: { __typename?: any } | null): obj is GetLoansOutstandingAmountOnDateResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGetLoansOutstandingAmountOnDateResult"')
      return GetLoansOutstandingAmountOnDateResult_possibleTypes.includes(obj.__typename)
    }
    


    const GetMatchingEffectRuleResult_possibleTypes: string[] = ['GetMatchingEffectRuleResult']
    export const isGetMatchingEffectRuleResult = (obj?: { __typename?: any } | null): obj is GetMatchingEffectRuleResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGetMatchingEffectRuleResult"')
      return GetMatchingEffectRuleResult_possibleTypes.includes(obj.__typename)
    }
    


    const GetOffersResponse_possibleTypes: string[] = ['GetOffersResponse']
    export const isGetOffersResponse = (obj?: { __typename?: any } | null): obj is GetOffersResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGetOffersResponse"')
      return GetOffersResponse_possibleTypes.includes(obj.__typename)
    }
    


    const GetOrderFilteringBoundsResult_possibleTypes: string[] = ['GetOrderFilteringBoundsResult']
    export const isGetOrderFilteringBoundsResult = (obj?: { __typename?: any } | null): obj is GetOrderFilteringBoundsResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGetOrderFilteringBoundsResult"')
      return GetOrderFilteringBoundsResult_possibleTypes.includes(obj.__typename)
    }
    


    const GetOrdersResultV2_possibleTypes: string[] = ['GetOrdersResultV2']
    export const isGetOrdersResultV2 = (obj?: { __typename?: any } | null): obj is GetOrdersResultV2 => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGetOrdersResultV2"')
      return GetOrdersResultV2_possibleTypes.includes(obj.__typename)
    }
    


    const GetProductAutomergeSettingsResponse_possibleTypes: string[] = ['GetProductAutomergeSettingsResponse']
    export const isGetProductAutomergeSettingsResponse = (obj?: { __typename?: any } | null): obj is GetProductAutomergeSettingsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGetProductAutomergeSettingsResponse"')
      return GetProductAutomergeSettingsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const GetProductBulkAdjustmentStatus_possibleTypes: string[] = ['GetProductBulkAdjustmentStatus']
    export const isGetProductBulkAdjustmentStatus = (obj?: { __typename?: any } | null): obj is GetProductBulkAdjustmentStatus => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGetProductBulkAdjustmentStatus"')
      return GetProductBulkAdjustmentStatus_possibleTypes.includes(obj.__typename)
    }
    


    const GetProductMergeLogsOverviewResponse_possibleTypes: string[] = ['GetProductMergeLogsOverviewResponse']
    export const isGetProductMergeLogsOverviewResponse = (obj?: { __typename?: any } | null): obj is GetProductMergeLogsOverviewResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGetProductMergeLogsOverviewResponse"')
      return GetProductMergeLogsOverviewResponse_possibleTypes.includes(obj.__typename)
    }
    


    const GetProductMergeLogsResponse_possibleTypes: string[] = ['GetProductMergeLogsResponse']
    export const isGetProductMergeLogsResponse = (obj?: { __typename?: any } | null): obj is GetProductMergeLogsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGetProductMergeLogsResponse"')
      return GetProductMergeLogsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const GetProductMergeRecommendationsMatchGroupResponse_possibleTypes: string[] = ['GetProductMergeRecommendationsMatchGroupResponse']
    export const isGetProductMergeRecommendationsMatchGroupResponse = (obj?: { __typename?: any } | null): obj is GetProductMergeRecommendationsMatchGroupResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGetProductMergeRecommendationsMatchGroupResponse"')
      return GetProductMergeRecommendationsMatchGroupResponse_possibleTypes.includes(obj.__typename)
    }
    


    const GetReadyValidationResponse_possibleTypes: string[] = ['GetReadyValidationResponse']
    export const isGetReadyValidationResponse = (obj?: { __typename?: any } | null): obj is GetReadyValidationResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGetReadyValidationResponse"')
      return GetReadyValidationResponse_possibleTypes.includes(obj.__typename)
    }
    


    const GetSalesResult_possibleTypes: string[] = ['GetSalesResult']
    export const isGetSalesResult = (obj?: { __typename?: any } | null): obj is GetSalesResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGetSalesResult"')
      return GetSalesResult_possibleTypes.includes(obj.__typename)
    }
    


    const GetSignedDatesResponse_possibleTypes: string[] = ['GetSignedDatesResponse']
    export const isGetSignedDatesResponse = (obj?: { __typename?: any } | null): obj is GetSignedDatesResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGetSignedDatesResponse"')
      return GetSignedDatesResponse_possibleTypes.includes(obj.__typename)
    }
    


    const GetSignedUrlByExportedLogIdResponse_possibleTypes: string[] = ['GetSignedUrlByExportedLogIdResponse']
    export const isGetSignedUrlByExportedLogIdResponse = (obj?: { __typename?: any } | null): obj is GetSignedUrlByExportedLogIdResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGetSignedUrlByExportedLogIdResponse"')
      return GetSignedUrlByExportedLogIdResponse_possibleTypes.includes(obj.__typename)
    }
    


    const GetUnpaidOrdersCsvResponse_possibleTypes: string[] = ['GetUnpaidOrdersCsvResponse']
    export const isGetUnpaidOrdersCsvResponse = (obj?: { __typename?: any } | null): obj is GetUnpaidOrdersCsvResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGetUnpaidOrdersCsvResponse"')
      return GetUnpaidOrdersCsvResponse_possibleTypes.includes(obj.__typename)
    }
    


    const GetVendorResponse_possibleTypes: string[] = ['Vendor','VendorNotExistError']
    export const isGetVendorResponse = (obj?: { __typename?: any } | null): obj is GetVendorResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGetVendorResponse"')
      return GetVendorResponse_possibleTypes.includes(obj.__typename)
    }
    


    const GiftCard_possibleTypes: string[] = ['GiftCard']
    export const isGiftCard = (obj?: { __typename?: any } | null): obj is GiftCard => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGiftCard"')
      return GiftCard_possibleTypes.includes(obj.__typename)
    }
    


    const GiftCardAggregationsResult_possibleTypes: string[] = ['GiftCardAggregationsResult']
    export const isGiftCardAggregationsResult = (obj?: { __typename?: any } | null): obj is GiftCardAggregationsResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGiftCardAggregationsResult"')
      return GiftCardAggregationsResult_possibleTypes.includes(obj.__typename)
    }
    


    const GiftCardsByIdsResponse_possibleTypes: string[] = ['GiftCardsByIdsResponse']
    export const isGiftCardsByIdsResponse = (obj?: { __typename?: any } | null): obj is GiftCardsByIdsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGiftCardsByIdsResponse"')
      return GiftCardsByIdsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const GiftCardsCsvResponse_possibleTypes: string[] = ['GiftCardsCsvResponse']
    export const isGiftCardsCsvResponse = (obj?: { __typename?: any } | null): obj is GiftCardsCsvResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGiftCardsCsvResponse"')
      return GiftCardsCsvResponse_possibleTypes.includes(obj.__typename)
    }
    


    const GiftCardsMaximumCompanyBalanceResult_possibleTypes: string[] = ['GiftCardsMaximumCompanyBalanceResult']
    export const isGiftCardsMaximumCompanyBalanceResult = (obj?: { __typename?: any } | null): obj is GiftCardsMaximumCompanyBalanceResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGiftCardsMaximumCompanyBalanceResult"')
      return GiftCardsMaximumCompanyBalanceResult_possibleTypes.includes(obj.__typename)
    }
    


    const GiftCardsResult_possibleTypes: string[] = ['GiftCardsResult']
    export const isGiftCardsResult = (obj?: { __typename?: any } | null): obj is GiftCardsResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGiftCardsResult"')
      return GiftCardsResult_possibleTypes.includes(obj.__typename)
    }
    


    const GiftCardTransaction_possibleTypes: string[] = ['GiftCardTransaction']
    export const isGiftCardTransaction = (obj?: { __typename?: any } | null): obj is GiftCardTransaction => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGiftCardTransaction"')
      return GiftCardTransaction_possibleTypes.includes(obj.__typename)
    }
    


    const GiveawayCogs_possibleTypes: string[] = ['GiveawayCogs']
    export const isGiveawayCogs = (obj?: { __typename?: any } | null): obj is GiveawayCogs => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGiveawayCogs"')
      return GiveawayCogs_possibleTypes.includes(obj.__typename)
    }
    


    const GiveawayDailyBreakdown_possibleTypes: string[] = ['GiveawayDailyBreakdown']
    export const isGiveawayDailyBreakdown = (obj?: { __typename?: any } | null): obj is GiveawayDailyBreakdown => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGiveawayDailyBreakdown"')
      return GiveawayDailyBreakdown_possibleTypes.includes(obj.__typename)
    }
    


    const GiveawayDropshippingOriginalValue_possibleTypes: string[] = ['GiveawayDropshippingOriginalValue']
    export const isGiveawayDropshippingOriginalValue = (obj?: { __typename?: any } | null): obj is GiveawayDropshippingOriginalValue => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGiveawayDropshippingOriginalValue"')
      return GiveawayDropshippingOriginalValue_possibleTypes.includes(obj.__typename)
    }
    


    const GiveawayMonthlyBreakdown_possibleTypes: string[] = ['GiveawayMonthlyBreakdown']
    export const isGiveawayMonthlyBreakdown = (obj?: { __typename?: any } | null): obj is GiveawayMonthlyBreakdown => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGiveawayMonthlyBreakdown"')
      return GiveawayMonthlyBreakdown_possibleTypes.includes(obj.__typename)
    }
    


    const GiveawayOriginalValue_possibleTypes: string[] = ['GiveawayOriginalValue']
    export const isGiveawayOriginalValue = (obj?: { __typename?: any } | null): obj is GiveawayOriginalValue => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGiveawayOriginalValue"')
      return GiveawayOriginalValue_possibleTypes.includes(obj.__typename)
    }
    


    const GlobalVendorMappingRule_possibleTypes: string[] = ['GlobalVendorMappingRule']
    export const isGlobalVendorMappingRule = (obj?: { __typename?: any } | null): obj is GlobalVendorMappingRule => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGlobalVendorMappingRule"')
      return GlobalVendorMappingRule_possibleTypes.includes(obj.__typename)
    }
    


    const GoogleConnectLinkResponse_possibleTypes: string[] = ['GoogleConnectLinkResponse']
    export const isGoogleConnectLinkResponse = (obj?: { __typename?: any } | null): obj is GoogleConnectLinkResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGoogleConnectLinkResponse"')
      return GoogleConnectLinkResponse_possibleTypes.includes(obj.__typename)
    }
    


    const GoogleConnectStatusResponse_possibleTypes: string[] = ['GoogleConnectStatusResponse']
    export const isGoogleConnectStatusResponse = (obj?: { __typename?: any } | null): obj is GoogleConnectStatusResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGoogleConnectStatusResponse"')
      return GoogleConnectStatusResponse_possibleTypes.includes(obj.__typename)
    }
    


    const GoogleTokenCodeResponse_possibleTypes: string[] = ['GoogleTokenCodeResponse']
    export const isGoogleTokenCodeResponse = (obj?: { __typename?: any } | null): obj is GoogleTokenCodeResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGoogleTokenCodeResponse"')
      return GoogleTokenCodeResponse_possibleTypes.includes(obj.__typename)
    }
    


    const GTMSource_possibleTypes: string[] = ['GTMSource']
    export const isGTMSource = (obj?: { __typename?: any } | null): obj is GTMSource => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGTMSource"')
      return GTMSource_possibleTypes.includes(obj.__typename)
    }
    


    const GTMSourceUtms_possibleTypes: string[] = ['GTMSourceUtms']
    export const isGTMSourceUtms = (obj?: { __typename?: any } | null): obj is GTMSourceUtms => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGTMSourceUtms"')
      return GTMSourceUtms_possibleTypes.includes(obj.__typename)
    }
    


    const GTMUtms_possibleTypes: string[] = ['GTMUtms']
    export const isGTMUtms = (obj?: { __typename?: any } | null): obj is GTMUtms => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGTMUtms"')
      return GTMUtms_possibleTypes.includes(obj.__typename)
    }
    


    const HandleUserLoginResponse_possibleTypes: string[] = ['HandleUserLoginResponse']
    export const isHandleUserLoginResponse = (obj?: { __typename?: any } | null): obj is HandleUserLoginResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isHandleUserLoginResponse"')
      return HandleUserLoginResponse_possibleTypes.includes(obj.__typename)
    }
    


    const HasOrdersInOrderGroupsResponse_possibleTypes: string[] = ['HasOrdersInOrderGroupsResponse']
    export const isHasOrdersInOrderGroupsResponse = (obj?: { __typename?: any } | null): obj is HasOrdersInOrderGroupsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isHasOrdersInOrderGroupsResponse"')
      return HasOrdersInOrderGroupsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const HasProductMergeRecommendationsResponse_possibleTypes: string[] = ['HasProductMergeRecommendationsResponse']
    export const isHasProductMergeRecommendationsResponse = (obj?: { __typename?: any } | null): obj is HasProductMergeRecommendationsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isHasProductMergeRecommendationsResponse"')
      return HasProductMergeRecommendationsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const Holder_possibleTypes: string[] = ['Holder']
    export const isHolder = (obj?: { __typename?: any } | null): obj is Holder => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isHolder"')
      return Holder_possibleTypes.includes(obj.__typename)
    }
    


    const HolderCapitalInvestment_possibleTypes: string[] = ['HolderCapitalInvestment']
    export const isHolderCapitalInvestment = (obj?: { __typename?: any } | null): obj is HolderCapitalInvestment => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isHolderCapitalInvestment"')
      return HolderCapitalInvestment_possibleTypes.includes(obj.__typename)
    }
    


    const HolderSafeInvestment_possibleTypes: string[] = ['HolderSafeInvestment']
    export const isHolderSafeInvestment = (obj?: { __typename?: any } | null): obj is HolderSafeInvestment => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isHolderSafeInvestment"')
      return HolderSafeInvestment_possibleTypes.includes(obj.__typename)
    }
    


    const HolderShare_possibleTypes: string[] = ['HolderShare']
    export const isHolderShare = (obj?: { __typename?: any } | null): obj is HolderShare => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isHolderShare"')
      return HolderShare_possibleTypes.includes(obj.__typename)
    }
    


    const HolderTransaction_possibleTypes: string[] = ['HolderTransaction']
    export const isHolderTransaction = (obj?: { __typename?: any } | null): obj is HolderTransaction => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isHolderTransaction"')
      return HolderTransaction_possibleTypes.includes(obj.__typename)
    }
    


    const HubItemStateChangeLog_possibleTypes: string[] = ['HubItemStateChangeLog']
    export const isHubItemStateChangeLog = (obj?: { __typename?: any } | null): obj is HubItemStateChangeLog => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isHubItemStateChangeLog"')
      return HubItemStateChangeLog_possibleTypes.includes(obj.__typename)
    }
    


    const HubStateChangeLog_possibleTypes: string[] = ['HubStateChangeLog']
    export const isHubStateChangeLog = (obj?: { __typename?: any } | null): obj is HubStateChangeLog => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isHubStateChangeLog"')
      return HubStateChangeLog_possibleTypes.includes(obj.__typename)
    }
    


    const IdResult_possibleTypes: string[] = ['IdResult']
    export const isIdResult = (obj?: { __typename?: any } | null): obj is IdResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isIdResult"')
      return IdResult_possibleTypes.includes(obj.__typename)
    }
    


    const ImageUploadUrlResult_possibleTypes: string[] = ['ImageUploadUrlResult']
    export const isImageUploadUrlResult = (obj?: { __typename?: any } | null): obj is ImageUploadUrlResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isImageUploadUrlResult"')
      return ImageUploadUrlResult_possibleTypes.includes(obj.__typename)
    }
    


    const ImpersonateResponse_possibleTypes: string[] = ['ImpersonateResponse']
    export const isImpersonateResponse = (obj?: { __typename?: any } | null): obj is ImpersonateResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isImpersonateResponse"')
      return ImpersonateResponse_possibleTypes.includes(obj.__typename)
    }
    


    const IncludedFinaloopSalesChannelItemReconciliation_possibleTypes: string[] = ['IncludedFinaloopSalesChannelItemReconciliation']
    export const isIncludedFinaloopSalesChannelItemReconciliation = (obj?: { __typename?: any } | null): obj is IncludedFinaloopSalesChannelItemReconciliation => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isIncludedFinaloopSalesChannelItemReconciliation"')
      return IncludedFinaloopSalesChannelItemReconciliation_possibleTypes.includes(obj.__typename)
    }
    


    const IncludedShopifySalesChannelItemReconciliation_possibleTypes: string[] = ['IncludedShopifySalesChannelItemReconciliation']
    export const isIncludedShopifySalesChannelItemReconciliation = (obj?: { __typename?: any } | null): obj is IncludedShopifySalesChannelItemReconciliation => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isIncludedShopifySalesChannelItemReconciliation"')
      return IncludedShopifySalesChannelItemReconciliation_possibleTypes.includes(obj.__typename)
    }
    


    const IncomingBatchAnalytics_possibleTypes: string[] = ['IncomingBatchAnalytics']
    export const isIncomingBatchAnalytics = (obj?: { __typename?: any } | null): obj is IncomingBatchAnalytics => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isIncomingBatchAnalytics"')
      return IncomingBatchAnalytics_possibleTypes.includes(obj.__typename)
    }
    


    const IncomingBatchOrigin_possibleTypes: string[] = ['Shipment','WarehouseOpeningBalance','RecipeWithBreakdown','ManualAssemblyWithBreakdown','WarehouseTransferWithBreakdown','UnitsTrackingPhysicalCount','WarehouseNegativesAdjustmentBreakdown']
    export const isIncomingBatchOrigin = (obj?: { __typename?: any } | null): obj is IncomingBatchOrigin => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isIncomingBatchOrigin"')
      return IncomingBatchOrigin_possibleTypes.includes(obj.__typename)
    }
    


    const IncomingInventoryAnalytics_possibleTypes: string[] = ['IncomingInventoryAnalytics']
    export const isIncomingInventoryAnalytics = (obj?: { __typename?: any } | null): obj is IncomingInventoryAnalytics => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isIncomingInventoryAnalytics"')
      return IncomingInventoryAnalytics_possibleTypes.includes(obj.__typename)
    }
    


    const IncomingInventoryAnalyticsUnavailableBreakdown_possibleTypes: string[] = ['IncomingInventoryAnalyticsUnavailableBreakdown']
    export const isIncomingInventoryAnalyticsUnavailableBreakdown = (obj?: { __typename?: any } | null): obj is IncomingInventoryAnalyticsUnavailableBreakdown => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isIncomingInventoryAnalyticsUnavailableBreakdown"')
      return IncomingInventoryAnalyticsUnavailableBreakdown_possibleTypes.includes(obj.__typename)
    }
    


    const IndirectCostAllocation_possibleTypes: string[] = ['IndirectCostAllocation']
    export const isIndirectCostAllocation = (obj?: { __typename?: any } | null): obj is IndirectCostAllocation => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isIndirectCostAllocation"')
      return IndirectCostAllocation_possibleTypes.includes(obj.__typename)
    }
    


    const IndirectLineItem_possibleTypes: string[] = ['IndirectLineItem']
    export const isIndirectLineItem = (obj?: { __typename?: any } | null): obj is IndirectLineItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isIndirectLineItem"')
      return IndirectLineItem_possibleTypes.includes(obj.__typename)
    }
    


    const IndividualSkusResponse_possibleTypes: string[] = ['IndividualSkusResponse']
    export const isIndividualSkusResponse = (obj?: { __typename?: any } | null): obj is IndividualSkusResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isIndividualSkusResponse"')
      return IndividualSkusResponse_possibleTypes.includes(obj.__typename)
    }
    


    const Institution_possibleTypes: string[] = ['Institution']
    export const isInstitution = (obj?: { __typename?: any } | null): obj is Institution => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInstitution"')
      return Institution_possibleTypes.includes(obj.__typename)
    }
    


    const InstitutionMapping_possibleTypes: string[] = ['InstitutionMapping']
    export const isInstitutionMapping = (obj?: { __typename?: any } | null): obj is InstitutionMapping => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInstitutionMapping"')
      return InstitutionMapping_possibleTypes.includes(obj.__typename)
    }
    


    const InstitutionMappingResponse_possibleTypes: string[] = ['InstitutionMappingResponse']
    export const isInstitutionMappingResponse = (obj?: { __typename?: any } | null): obj is InstitutionMappingResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInstitutionMappingResponse"')
      return InstitutionMappingResponse_possibleTypes.includes(obj.__typename)
    }
    


    const InstitutionsResponse_possibleTypes: string[] = ['InstitutionsResponse']
    export const isInstitutionsResponse = (obj?: { __typename?: any } | null): obj is InstitutionsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInstitutionsResponse"')
      return InstitutionsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const InstitutionVendorID_possibleTypes: string[] = ['InstitutionVendorID']
    export const isInstitutionVendorID = (obj?: { __typename?: any } | null): obj is InstitutionVendorID => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInstitutionVendorID"')
      return InstitutionVendorID_possibleTypes.includes(obj.__typename)
    }
    


    const IntegrationConnectionAccount_possibleTypes: string[] = ['IntegrationConnectionAccount']
    export const isIntegrationConnectionAccount = (obj?: { __typename?: any } | null): obj is IntegrationConnectionAccount => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isIntegrationConnectionAccount"')
      return IntegrationConnectionAccount_possibleTypes.includes(obj.__typename)
    }
    


    const IntegrationFulfillmentSetting_possibleTypes: string[] = ['IntegrationFulfillmentSetting']
    export const isIntegrationFulfillmentSetting = (obj?: { __typename?: any } | null): obj is IntegrationFulfillmentSetting => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isIntegrationFulfillmentSetting"')
      return IntegrationFulfillmentSetting_possibleTypes.includes(obj.__typename)
    }
    


    const IntegrationInfo_possibleTypes: string[] = ['IntegrationInfo']
    export const isIntegrationInfo = (obj?: { __typename?: any } | null): obj is IntegrationInfo => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isIntegrationInfo"')
      return IntegrationInfo_possibleTypes.includes(obj.__typename)
    }
    


    const IntegrationSaleTransaction_possibleTypes: string[] = ['IntegrationSaleTransaction']
    export const isIntegrationSaleTransaction = (obj?: { __typename?: any } | null): obj is IntegrationSaleTransaction => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isIntegrationSaleTransaction"')
      return IntegrationSaleTransaction_possibleTypes.includes(obj.__typename)
    }
    


    const IntegrationTransfer_possibleTypes: string[] = ['Payout','Topup']
    export const isIntegrationTransfer = (obj?: { __typename?: any } | null): obj is IntegrationTransfer => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isIntegrationTransfer"')
      return IntegrationTransfer_possibleTypes.includes(obj.__typename)
    }
    


    const IntegrationTransferClassification_possibleTypes: string[] = ['IntegrationTransferClassification']
    export const isIntegrationTransferClassification = (obj?: { __typename?: any } | null): obj is IntegrationTransferClassification => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isIntegrationTransferClassification"')
      return IntegrationTransferClassification_possibleTypes.includes(obj.__typename)
    }
    


    const IntegrationTransferGroup_possibleTypes: string[] = ['IntegrationTransferGroup']
    export const isIntegrationTransferGroup = (obj?: { __typename?: any } | null): obj is IntegrationTransferGroup => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isIntegrationTransferGroup"')
      return IntegrationTransferGroup_possibleTypes.includes(obj.__typename)
    }
    


    const IntegrationTransferPairedEntity_possibleTypes: string[] = ['IntegrationTransferPairedEntity']
    export const isIntegrationTransferPairedEntity = (obj?: { __typename?: any } | null): obj is IntegrationTransferPairedEntity => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isIntegrationTransferPairedEntity"')
      return IntegrationTransferPairedEntity_possibleTypes.includes(obj.__typename)
    }
    


    const IntegrationTransferParty_possibleTypes: string[] = ['UnknownIntegrationTransferBank','UnknownIntegrationTransferAccount','Vendor','BankAccount']
    export const isIntegrationTransferParty = (obj?: { __typename?: any } | null): obj is IntegrationTransferParty => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isIntegrationTransferParty"')
      return IntegrationTransferParty_possibleTypes.includes(obj.__typename)
    }
    


    const IntegrationTransferRule_possibleTypes: string[] = ['IntegrationTransferRule']
    export const isIntegrationTransferRule = (obj?: { __typename?: any } | null): obj is IntegrationTransferRule => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isIntegrationTransferRule"')
      return IntegrationTransferRule_possibleTypes.includes(obj.__typename)
    }
    


    const IntegrationTransferV2_possibleTypes: string[] = ['IntegrationTransferV2']
    export const isIntegrationTransferV2 = (obj?: { __typename?: any } | null): obj is IntegrationTransferV2 => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isIntegrationTransferV2"')
      return IntegrationTransferV2_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryBatch_possibleTypes: string[] = ['InventoryBatch']
    export const isInventoryBatch = (obj?: { __typename?: any } | null): obj is InventoryBatch => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryBatch"')
      return InventoryBatch_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryInitStatus_possibleTypes: string[] = ['InventoryInitStatus']
    export const isInventoryInitStatus = (obj?: { __typename?: any } | null): obj is InventoryInitStatus => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryInitStatus"')
      return InventoryInitStatus_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryPaymentGroup_possibleTypes: string[] = ['InventoryPaymentGroup']
    export const isInventoryPaymentGroup = (obj?: { __typename?: any } | null): obj is InventoryPaymentGroup => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryPaymentGroup"')
      return InventoryPaymentGroup_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryPaymentGroupByIdResponse_possibleTypes: string[] = ['InventoryPaymentGroupByIdResponse']
    export const isInventoryPaymentGroupByIdResponse = (obj?: { __typename?: any } | null): obj is InventoryPaymentGroupByIdResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryPaymentGroupByIdResponse"')
      return InventoryPaymentGroupByIdResponse_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryPaymentGroupLink_possibleTypes: string[] = ['InventoryPaymentGroupLink']
    export const isInventoryPaymentGroupLink = (obj?: { __typename?: any } | null): obj is InventoryPaymentGroupLink => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryPaymentGroupLink"')
      return InventoryPaymentGroupLink_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryPaymentGroupsByIdsResponse_possibleTypes: string[] = ['InventoryPaymentGroupsByIdsResponse']
    export const isInventoryPaymentGroupsByIdsResponse = (obj?: { __typename?: any } | null): obj is InventoryPaymentGroupsByIdsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryPaymentGroupsByIdsResponse"')
      return InventoryPaymentGroupsByIdsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryPaymentGroupsResponse_possibleTypes: string[] = ['InventoryPaymentGroupsResponse']
    export const isInventoryPaymentGroupsResponse = (obj?: { __typename?: any } | null): obj is InventoryPaymentGroupsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryPaymentGroupsResponse"')
      return InventoryPaymentGroupsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryPaymentGroupUnclearedBalance_possibleTypes: string[] = ['InventoryPaymentGroupUnclearedBalance']
    export const isInventoryPaymentGroupUnclearedBalance = (obj?: { __typename?: any } | null): obj is InventoryPaymentGroupUnclearedBalance => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryPaymentGroupUnclearedBalance"')
      return InventoryPaymentGroupUnclearedBalance_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryPurchase_possibleTypes: string[] = ['InventoryPurchase']
    export const isInventoryPurchase = (obj?: { __typename?: any } | null): obj is InventoryPurchase => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryPurchase"')
      return InventoryPurchase_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryPurchaseAttachment_possibleTypes: string[] = ['InventoryPurchaseAttachment']
    export const isInventoryPurchaseAttachment = (obj?: { __typename?: any } | null): obj is InventoryPurchaseAttachment => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryPurchaseAttachment"')
      return InventoryPurchaseAttachment_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryPurchaseCategory_possibleTypes: string[] = ['InventoryPurchaseCategory']
    export const isInventoryPurchaseCategory = (obj?: { __typename?: any } | null): obj is InventoryPurchaseCategory => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryPurchaseCategory"')
      return InventoryPurchaseCategory_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryPurchaseCategorySummary_possibleTypes: string[] = ['InventoryPurchaseCategorySummary']
    export const isInventoryPurchaseCategorySummary = (obj?: { __typename?: any } | null): obj is InventoryPurchaseCategorySummary => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryPurchaseCategorySummary"')
      return InventoryPurchaseCategorySummary_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryPurchaseItem_possibleTypes: string[] = ['InventoryPurchaseItem']
    export const isInventoryPurchaseItem = (obj?: { __typename?: any } | null): obj is InventoryPurchaseItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryPurchaseItem"')
      return InventoryPurchaseItem_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryPurchaseRule_possibleTypes: string[] = ['InventoryPurchaseRule']
    export const isInventoryPurchaseRule = (obj?: { __typename?: any } | null): obj is InventoryPurchaseRule => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryPurchaseRule"')
      return InventoryPurchaseRule_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryPurchaseRulesResponse_possibleTypes: string[] = ['InventoryPurchaseRulesResponse']
    export const isInventoryPurchaseRulesResponse = (obj?: { __typename?: any } | null): obj is InventoryPurchaseRulesResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryPurchaseRulesResponse"')
      return InventoryPurchaseRulesResponse_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryPurchasesCountByVendorItem_possibleTypes: string[] = ['InventoryPurchasesCountByVendorItem']
    export const isInventoryPurchasesCountByVendorItem = (obj?: { __typename?: any } | null): obj is InventoryPurchasesCountByVendorItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryPurchasesCountByVendorItem"')
      return InventoryPurchasesCountByVendorItem_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryPurchasesCountByVendorResponse_possibleTypes: string[] = ['InventoryPurchasesCountByVendorResponse']
    export const isInventoryPurchasesCountByVendorResponse = (obj?: { __typename?: any } | null): obj is InventoryPurchasesCountByVendorResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryPurchasesCountByVendorResponse"')
      return InventoryPurchasesCountByVendorResponse_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryPurchasesExportResponse_possibleTypes: string[] = ['InventoryPurchasesExportResponse']
    export const isInventoryPurchasesExportResponse = (obj?: { __typename?: any } | null): obj is InventoryPurchasesExportResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryPurchasesExportResponse"')
      return InventoryPurchasesExportResponse_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryPurchaseSourceEntity_possibleTypes: string[] = ['BankTransaction','Bill']
    export const isInventoryPurchaseSourceEntity = (obj?: { __typename?: any } | null): obj is InventoryPurchaseSourceEntity => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryPurchaseSourceEntity"')
      return InventoryPurchaseSourceEntity_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryPurchasesResponse_possibleTypes: string[] = ['InventoryPurchasesResponse']
    export const isInventoryPurchasesResponse = (obj?: { __typename?: any } | null): obj is InventoryPurchasesResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryPurchasesResponse"')
      return InventoryPurchasesResponse_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryPurchasesSummaryResponse_possibleTypes: string[] = ['InventoryPurchasesSummaryResponse']
    export const isInventoryPurchasesSummaryResponse = (obj?: { __typename?: any } | null): obj is InventoryPurchasesSummaryResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryPurchasesSummaryResponse"')
      return InventoryPurchasesSummaryResponse_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryPurchasesValidationResult_possibleTypes: string[] = ['InventoryPurchasesValidationResult']
    export const isInventoryPurchasesValidationResult = (obj?: { __typename?: any } | null): obj is InventoryPurchasesValidationResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryPurchasesValidationResult"')
      return InventoryPurchasesValidationResult_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryPurchaseUpdateOutOfDateError_possibleTypes: string[] = ['InventoryPurchaseUpdateOutOfDateError']
    export const isInventoryPurchaseUpdateOutOfDateError = (obj?: { __typename?: any } | null): obj is InventoryPurchaseUpdateOutOfDateError => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryPurchaseUpdateOutOfDateError"')
      return InventoryPurchaseUpdateOutOfDateError_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryPurchaseVendorsResponse_possibleTypes: string[] = ['InventoryPurchaseVendorsResponse']
    export const isInventoryPurchaseVendorsResponse = (obj?: { __typename?: any } | null): obj is InventoryPurchaseVendorsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryPurchaseVendorsResponse"')
      return InventoryPurchaseVendorsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const InventorySettings_possibleTypes: string[] = ['InventorySettings']
    export const isInventorySettings = (obj?: { __typename?: any } | null): obj is InventorySettings => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventorySettings"')
      return InventorySettings_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryVendor_possibleTypes: string[] = ['InventoryVendor']
    export const isInventoryVendor = (obj?: { __typename?: any } | null): obj is InventoryVendor => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryVendor"')
      return InventoryVendor_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryVendorAdjustment_possibleTypes: string[] = ['InventoryVendorAdjustment']
    export const isInventoryVendorAdjustment = (obj?: { __typename?: any } | null): obj is InventoryVendorAdjustment => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryVendorAdjustment"')
      return InventoryVendorAdjustment_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryVendorBillItem_possibleTypes: string[] = ['InventoryVendorBillItem']
    export const isInventoryVendorBillItem = (obj?: { __typename?: any } | null): obj is InventoryVendorBillItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryVendorBillItem"')
      return InventoryVendorBillItem_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryVendorBillItemSource_possibleTypes: string[] = ['InventoryPurchase','InventoryVendorPayment','InventoryVendorCredit','InventoryVendorAdjustment']
    export const isInventoryVendorBillItemSource = (obj?: { __typename?: any } | null): obj is InventoryVendorBillItemSource => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryVendorBillItemSource"')
      return InventoryVendorBillItemSource_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryVendorBillsOverviewResponse_possibleTypes: string[] = ['InventoryVendorBillsOverviewResponse']
    export const isInventoryVendorBillsOverviewResponse = (obj?: { __typename?: any } | null): obj is InventoryVendorBillsOverviewResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryVendorBillsOverviewResponse"')
      return InventoryVendorBillsOverviewResponse_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryVendorBillsResponse_possibleTypes: string[] = ['InventoryVendorBillsResponse']
    export const isInventoryVendorBillsResponse = (obj?: { __typename?: any } | null): obj is InventoryVendorBillsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryVendorBillsResponse"')
      return InventoryVendorBillsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryVendorCredit_possibleTypes: string[] = ['InventoryVendorCredit']
    export const isInventoryVendorCredit = (obj?: { __typename?: any } | null): obj is InventoryVendorCredit => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryVendorCredit"')
      return InventoryVendorCredit_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryVendorFilterValuesResponse_possibleTypes: string[] = ['InventoryVendorFilterValuesResponse']
    export const isInventoryVendorFilterValuesResponse = (obj?: { __typename?: any } | null): obj is InventoryVendorFilterValuesResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryVendorFilterValuesResponse"')
      return InventoryVendorFilterValuesResponse_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryVendorOverviewItem_possibleTypes: string[] = ['InventoryVendorOverviewItem']
    export const isInventoryVendorOverviewItem = (obj?: { __typename?: any } | null): obj is InventoryVendorOverviewItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryVendorOverviewItem"')
      return InventoryVendorOverviewItem_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryVendorParamsResponse_possibleTypes: string[] = ['InventoryVendorParamsResponse']
    export const isInventoryVendorParamsResponse = (obj?: { __typename?: any } | null): obj is InventoryVendorParamsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryVendorParamsResponse"')
      return InventoryVendorParamsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryVendorPayment_possibleTypes: string[] = ['InventoryVendorPayment']
    export const isInventoryVendorPayment = (obj?: { __typename?: any } | null): obj is InventoryVendorPayment => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryVendorPayment"')
      return InventoryVendorPayment_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryVendorRollingBalanceItem_possibleTypes: string[] = ['InventoryVendorRollingBalanceItem']
    export const isInventoryVendorRollingBalanceItem = (obj?: { __typename?: any } | null): obj is InventoryVendorRollingBalanceItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryVendorRollingBalanceItem"')
      return InventoryVendorRollingBalanceItem_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryVendorRollingBalanceItemSource_possibleTypes: string[] = ['PurchaseOrder','InventoryPurchase','WarehouseTransfer','Assembly']
    export const isInventoryVendorRollingBalanceItemSource = (obj?: { __typename?: any } | null): obj is InventoryVendorRollingBalanceItemSource => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryVendorRollingBalanceItemSource"')
      return InventoryVendorRollingBalanceItemSource_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryVendorRollingBalanceOverviewResponse_possibleTypes: string[] = ['InventoryVendorRollingBalanceOverviewResponse']
    export const isInventoryVendorRollingBalanceOverviewResponse = (obj?: { __typename?: any } | null): obj is InventoryVendorRollingBalanceOverviewResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryVendorRollingBalanceOverviewResponse"')
      return InventoryVendorRollingBalanceOverviewResponse_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryVendorRollingBalanceResponse_possibleTypes: string[] = ['InventoryVendorRollingBalanceResponse']
    export const isInventoryVendorRollingBalanceResponse = (obj?: { __typename?: any } | null): obj is InventoryVendorRollingBalanceResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryVendorRollingBalanceResponse"')
      return InventoryVendorRollingBalanceResponse_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryVendorsOverviewResponse_possibleTypes: string[] = ['InventoryVendorsOverviewResponse']
    export const isInventoryVendorsOverviewResponse = (obj?: { __typename?: any } | null): obj is InventoryVendorsOverviewResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryVendorsOverviewResponse"')
      return InventoryVendorsOverviewResponse_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryVendorsResponse_possibleTypes: string[] = ['InventoryVendorsResponse']
    export const isInventoryVendorsResponse = (obj?: { __typename?: any } | null): obj is InventoryVendorsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryVendorsResponse"')
      return InventoryVendorsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryVendorValidationResult_possibleTypes: string[] = ['InventoryVendorValidationResult']
    export const isInventoryVendorValidationResult = (obj?: { __typename?: any } | null): obj is InventoryVendorValidationResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryVendorValidationResult"')
      return InventoryVendorValidationResult_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryVendorValidationResultItem_possibleTypes: string[] = ['InventoryVendorValidationResultItem']
    export const isInventoryVendorValidationResultItem = (obj?: { __typename?: any } | null): obj is InventoryVendorValidationResultItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryVendorValidationResultItem"')
      return InventoryVendorValidationResultItem_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryVendorValidationTotalsResult_possibleTypes: string[] = ['InventoryVendorValidationTotalsResult']
    export const isInventoryVendorValidationTotalsResult = (obj?: { __typename?: any } | null): obj is InventoryVendorValidationTotalsResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryVendorValidationTotalsResult"')
      return InventoryVendorValidationTotalsResult_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryYearEndHistoryLog_possibleTypes: string[] = ['InventoryYearEndHistoryLog']
    export const isInventoryYearEndHistoryLog = (obj?: { __typename?: any } | null): obj is InventoryYearEndHistoryLog => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryYearEndHistoryLog"')
      return InventoryYearEndHistoryLog_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryYearEndMissionsResponse_possibleTypes: string[] = ['InventoryYearEndMissionsResponse']
    export const isInventoryYearEndMissionsResponse = (obj?: { __typename?: any } | null): obj is InventoryYearEndMissionsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryYearEndMissionsResponse"')
      return InventoryYearEndMissionsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const InviteUserResponse_possibleTypes: string[] = ['InviteUserResponse']
    export const isInviteUserResponse = (obj?: { __typename?: any } | null): obj is InviteUserResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInviteUserResponse"')
      return InviteUserResponse_possibleTypes.includes(obj.__typename)
    }
    


    const Invoice_possibleTypes: string[] = ['Invoice']
    export const isInvoice = (obj?: { __typename?: any } | null): obj is Invoice => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInvoice"')
      return Invoice_possibleTypes.includes(obj.__typename)
    }
    


    const InvoicePay_possibleTypes: string[] = ['InvoicePay']
    export const isInvoicePay = (obj?: { __typename?: any } | null): obj is InvoicePay => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInvoicePay"')
      return InvoicePay_possibleTypes.includes(obj.__typename)
    }
    


    const InvoicePaymentGroup_possibleTypes: string[] = ['InvoicePaymentGroup']
    export const isInvoicePaymentGroup = (obj?: { __typename?: any } | null): obj is InvoicePaymentGroup => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInvoicePaymentGroup"')
      return InvoicePaymentGroup_possibleTypes.includes(obj.__typename)
    }
    


    const InvoicePaymentGroupByIdResponse_possibleTypes: string[] = ['InvoicePaymentGroupByIdResponse']
    export const isInvoicePaymentGroupByIdResponse = (obj?: { __typename?: any } | null): obj is InvoicePaymentGroupByIdResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInvoicePaymentGroupByIdResponse"')
      return InvoicePaymentGroupByIdResponse_possibleTypes.includes(obj.__typename)
    }
    


    const InvoicePaymentGroupsByIdsResponse_possibleTypes: string[] = ['InvoicePaymentGroupsByIdsResponse']
    export const isInvoicePaymentGroupsByIdsResponse = (obj?: { __typename?: any } | null): obj is InvoicePaymentGroupsByIdsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInvoicePaymentGroupsByIdsResponse"')
      return InvoicePaymentGroupsByIdsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const InvoicePaymentGroupsResponse_possibleTypes: string[] = ['InvoicePaymentGroupsResponse']
    export const isInvoicePaymentGroupsResponse = (obj?: { __typename?: any } | null): obj is InvoicePaymentGroupsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInvoicePaymentGroupsResponse"')
      return InvoicePaymentGroupsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const InvoicePaymentGroupsUnclearedBalanceResponse_possibleTypes: string[] = ['InvoicePaymentGroupsUnclearedBalanceResponse']
    export const isInvoicePaymentGroupsUnclearedBalanceResponse = (obj?: { __typename?: any } | null): obj is InvoicePaymentGroupsUnclearedBalanceResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInvoicePaymentGroupsUnclearedBalanceResponse"')
      return InvoicePaymentGroupsUnclearedBalanceResponse_possibleTypes.includes(obj.__typename)
    }
    


    const InvoicePaymentGroupUnclearedBalance_possibleTypes: string[] = ['InvoicePaymentGroupUnclearedBalance']
    export const isInvoicePaymentGroupUnclearedBalance = (obj?: { __typename?: any } | null): obj is InvoicePaymentGroupUnclearedBalance => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInvoicePaymentGroupUnclearedBalance"')
      return InvoicePaymentGroupUnclearedBalance_possibleTypes.includes(obj.__typename)
    }
    


    const InvoicePaymentLink_possibleTypes: string[] = ['InvoicePaymentLink']
    export const isInvoicePaymentLink = (obj?: { __typename?: any } | null): obj is InvoicePaymentLink => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInvoicePaymentLink"')
      return InvoicePaymentLink_possibleTypes.includes(obj.__typename)
    }
    


    const InvoicePdf_possibleTypes: string[] = ['InvoicePdf']
    export const isInvoicePdf = (obj?: { __typename?: any } | null): obj is InvoicePdf => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInvoicePdf"')
      return InvoicePdf_possibleTypes.includes(obj.__typename)
    }
    


    const InvoicesAggregations_possibleTypes: string[] = ['InvoicesAggregations']
    export const isInvoicesAggregations = (obj?: { __typename?: any } | null): obj is InvoicesAggregations => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInvoicesAggregations"')
      return InvoicesAggregations_possibleTypes.includes(obj.__typename)
    }
    


    const InvoicesBalance_possibleTypes: string[] = ['InvoicesBalance']
    export const isInvoicesBalance = (obj?: { __typename?: any } | null): obj is InvoicesBalance => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInvoicesBalance"')
      return InvoicesBalance_possibleTypes.includes(obj.__typename)
    }
    


    const InvoiceSettings_possibleTypes: string[] = ['InvoiceSettings']
    export const isInvoiceSettings = (obj?: { __typename?: any } | null): obj is InvoiceSettings => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInvoiceSettings"')
      return InvoiceSettings_possibleTypes.includes(obj.__typename)
    }
    


    const InvoicesYearEnd_possibleTypes: string[] = ['InvoicesYearEnd']
    export const isInvoicesYearEnd = (obj?: { __typename?: any } | null): obj is InvoicesYearEnd => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInvoicesYearEnd"')
      return InvoicesYearEnd_possibleTypes.includes(obj.__typename)
    }
    


    const InvoicesYearEndTask_possibleTypes: string[] = ['AddMissingInvoicesTask','CloseOpenInvoicesTask','ConfirmArBalanceTask','LinkInvoicePaymentsTask']
    export const isInvoicesYearEndTask = (obj?: { __typename?: any } | null): obj is InvoicesYearEndTask => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInvoicesYearEndTask"')
      return InvoicesYearEndTask_possibleTypes.includes(obj.__typename)
    }
    


    const InvoicesYearEndTasksResponse_possibleTypes: string[] = ['InvoicesYearEndTasksResponse']
    export const isInvoicesYearEndTasksResponse = (obj?: { __typename?: any } | null): obj is InvoicesYearEndTasksResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInvoicesYearEndTasksResponse"')
      return InvoicesYearEndTasksResponse_possibleTypes.includes(obj.__typename)
    }
    


    const InvoiceToPaymentGroups_possibleTypes: string[] = ['InvoiceToPaymentGroups']
    export const isInvoiceToPaymentGroups = (obj?: { __typename?: any } | null): obj is InvoiceToPaymentGroups => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInvoiceToPaymentGroups"')
      return InvoiceToPaymentGroups_possibleTypes.includes(obj.__typename)
    }
    


    const IPaymentGroup_possibleTypes: string[] = ['InvoicePaymentGroup','OrderPaymentGroup']
    export const isIPaymentGroup = (obj?: { __typename?: any } | null): obj is IPaymentGroup => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isIPaymentGroup"')
      return IPaymentGroup_possibleTypes.includes(obj.__typename)
    }
    


    const IsGlobalRuleExistResult_possibleTypes: string[] = ['IsGlobalRuleExistResult']
    export const isIsGlobalRuleExistResult = (obj?: { __typename?: any } | null): obj is IsGlobalRuleExistResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isIsGlobalRuleExistResult"')
      return IsGlobalRuleExistResult_possibleTypes.includes(obj.__typename)
    }
    


    const IsInvitationCodeForRegisteredUserResponse_possibleTypes: string[] = ['IsInvitationCodeForRegisteredUserResponse']
    export const isIsInvitationCodeForRegisteredUserResponse = (obj?: { __typename?: any } | null): obj is IsInvitationCodeForRegisteredUserResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isIsInvitationCodeForRegisteredUserResponse"')
      return IsInvitationCodeForRegisteredUserResponse_possibleTypes.includes(obj.__typename)
    }
    


    const ItemReconciliationFinaloopSalesChannel_possibleTypes: string[] = ['ItemReconciliationFinaloopSalesChannel']
    export const isItemReconciliationFinaloopSalesChannel = (obj?: { __typename?: any } | null): obj is ItemReconciliationFinaloopSalesChannel => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isItemReconciliationFinaloopSalesChannel"')
      return ItemReconciliationFinaloopSalesChannel_possibleTypes.includes(obj.__typename)
    }
    


    const JournalEntryActions_possibleTypes: string[] = ['JournalEntryActions']
    export const isJournalEntryActions = (obj?: { __typename?: any } | null): obj is JournalEntryActions => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isJournalEntryActions"')
      return JournalEntryActions_possibleTypes.includes(obj.__typename)
    }
    


    const LastAccountingReportSyncResponse_possibleTypes: string[] = ['LastAccountingReportSyncResponse']
    export const isLastAccountingReportSyncResponse = (obj?: { __typename?: any } | null): obj is LastAccountingReportSyncResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLastAccountingReportSyncResponse"')
      return LastAccountingReportSyncResponse_possibleTypes.includes(obj.__typename)
    }
    


    const LastTransaction_possibleTypes: string[] = ['LastTransaction']
    export const isLastTransaction = (obj?: { __typename?: any } | null): obj is LastTransaction => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLastTransaction"')
      return LastTransaction_possibleTypes.includes(obj.__typename)
    }
    


    const LatestActiveCompanyUserResponse_possibleTypes: string[] = ['LatestActiveCompanyUserResponse']
    export const isLatestActiveCompanyUserResponse = (obj?: { __typename?: any } | null): obj is LatestActiveCompanyUserResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLatestActiveCompanyUserResponse"')
      return LatestActiveCompanyUserResponse_possibleTypes.includes(obj.__typename)
    }
    


    const LineItemStatuses_possibleTypes: string[] = ['LineItemStatuses']
    export const isLineItemStatuses = (obj?: { __typename?: any } | null): obj is LineItemStatuses => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLineItemStatuses"')
      return LineItemStatuses_possibleTypes.includes(obj.__typename)
    }
    


    const LineItemTimelineAccountStateV3_possibleTypes: string[] = ['LineItemTimelineAccountStateV3']
    export const isLineItemTimelineAccountStateV3 = (obj?: { __typename?: any } | null): obj is LineItemTimelineAccountStateV3 => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLineItemTimelineAccountStateV3"')
      return LineItemTimelineAccountStateV3_possibleTypes.includes(obj.__typename)
    }
    


    const LineItemTimelineActionV3_possibleTypes: string[] = ['LineItemTimelineActionV3']
    export const isLineItemTimelineActionV3 = (obj?: { __typename?: any } | null): obj is LineItemTimelineActionV3 => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLineItemTimelineActionV3"')
      return LineItemTimelineActionV3_possibleTypes.includes(obj.__typename)
    }
    


    const LinkedBankTransaction_possibleTypes: string[] = ['LinkedBankTransaction']
    export const isLinkedBankTransaction = (obj?: { __typename?: any } | null): obj is LinkedBankTransaction => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLinkedBankTransaction"')
      return LinkedBankTransaction_possibleTypes.includes(obj.__typename)
    }
    


    const LinkedOrder_possibleTypes: string[] = ['LinkedOrder']
    export const isLinkedOrder = (obj?: { __typename?: any } | null): obj is LinkedOrder => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLinkedOrder"')
      return LinkedOrder_possibleTypes.includes(obj.__typename)
    }
    


    const LinkInventoryPaymentGroupResponse_possibleTypes: string[] = ['LinkInventoryPaymentGroupResponse']
    export const isLinkInventoryPaymentGroupResponse = (obj?: { __typename?: any } | null): obj is LinkInventoryPaymentGroupResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLinkInventoryPaymentGroupResponse"')
      return LinkInventoryPaymentGroupResponse_possibleTypes.includes(obj.__typename)
    }
    


    const LinkInvoicePaymentGroupResponse_possibleTypes: string[] = ['LinkInvoicePaymentGroupResponse']
    export const isLinkInvoicePaymentGroupResponse = (obj?: { __typename?: any } | null): obj is LinkInvoicePaymentGroupResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLinkInvoicePaymentGroupResponse"')
      return LinkInvoicePaymentGroupResponse_possibleTypes.includes(obj.__typename)
    }
    


    const LinkInvoicePaymentsTask_possibleTypes: string[] = ['LinkInvoicePaymentsTask']
    export const isLinkInvoicePaymentsTask = (obj?: { __typename?: any } | null): obj is LinkInvoicePaymentsTask => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLinkInvoicePaymentsTask"')
      return LinkInvoicePaymentsTask_possibleTypes.includes(obj.__typename)
    }
    


    const LinkInvoicePaymentsTaskState_possibleTypes: string[] = ['LinkInvoicePaymentsTaskState']
    export const isLinkInvoicePaymentsTaskState = (obj?: { __typename?: any } | null): obj is LinkInvoicePaymentsTaskState => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLinkInvoicePaymentsTaskState"')
      return LinkInvoicePaymentsTaskState_possibleTypes.includes(obj.__typename)
    }
    


    const LinkInvoicePaymentsTaskStateChangeLog_possibleTypes: string[] = ['LinkInvoicePaymentsTaskStateChangeLog']
    export const isLinkInvoicePaymentsTaskStateChangeLog = (obj?: { __typename?: any } | null): obj is LinkInvoicePaymentsTaskStateChangeLog => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLinkInvoicePaymentsTaskStateChangeLog"')
      return LinkInvoicePaymentsTaskStateChangeLog_possibleTypes.includes(obj.__typename)
    }
    


    const LinkOrderGroupResponse_possibleTypes: string[] = ['LinkOrderGroupResponse']
    export const isLinkOrderGroupResponse = (obj?: { __typename?: any } | null): obj is LinkOrderGroupResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLinkOrderGroupResponse"')
      return LinkOrderGroupResponse_possibleTypes.includes(obj.__typename)
    }
    


    const LinkOrderPaymentGroupResponse_possibleTypes: string[] = ['LinkOrderPaymentGroupResponse']
    export const isLinkOrderPaymentGroupResponse = (obj?: { __typename?: any } | null): obj is LinkOrderPaymentGroupResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLinkOrderPaymentGroupResponse"')
      return LinkOrderPaymentGroupResponse_possibleTypes.includes(obj.__typename)
    }
    


    const ListAssembliesResult_possibleTypes: string[] = ['ListAssembliesResult']
    export const isListAssembliesResult = (obj?: { __typename?: any } | null): obj is ListAssembliesResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isListAssembliesResult"')
      return ListAssembliesResult_possibleTypes.includes(obj.__typename)
    }
    


    const ListAssemblyItemsResult_possibleTypes: string[] = ['ListAssemblyItemsResult']
    export const isListAssemblyItemsResult = (obj?: { __typename?: any } | null): obj is ListAssemblyItemsResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isListAssemblyItemsResult"')
      return ListAssemblyItemsResult_possibleTypes.includes(obj.__typename)
    }
    


    const ListFailingValidationCompaniesResponse_possibleTypes: string[] = ['ListFailingValidationCompaniesResponse']
    export const isListFailingValidationCompaniesResponse = (obj?: { __typename?: any } | null): obj is ListFailingValidationCompaniesResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isListFailingValidationCompaniesResponse"')
      return ListFailingValidationCompaniesResponse_possibleTypes.includes(obj.__typename)
    }
    


    const ListManualAssembliesResult_possibleTypes: string[] = ['ListManualAssembliesResult']
    export const isListManualAssembliesResult = (obj?: { __typename?: any } | null): obj is ListManualAssembliesResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isListManualAssembliesResult"')
      return ListManualAssembliesResult_possibleTypes.includes(obj.__typename)
    }
    


    const Loan_possibleTypes: string[] = ['Loan']
    export const isLoan = (obj?: { __typename?: any } | null): obj is Loan => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLoan"')
      return Loan_possibleTypes.includes(obj.__typename)
    }
    


    const LoanAccountingEvent_possibleTypes: string[] = ['LoanAccountingEvent']
    export const isLoanAccountingEvent = (obj?: { __typename?: any } | null): obj is LoanAccountingEvent => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLoanAccountingEvent"')
      return LoanAccountingEvent_possibleTypes.includes(obj.__typename)
    }
    


    const LoanAffiliatedTransactionEvent_possibleTypes: string[] = ['LoanAffiliatedTransactionEvent']
    export const isLoanAffiliatedTransactionEvent = (obj?: { __typename?: any } | null): obj is LoanAffiliatedTransactionEvent => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLoanAffiliatedTransactionEvent"')
      return LoanAffiliatedTransactionEvent_possibleTypes.includes(obj.__typename)
    }
    


    const LoanAlreadyExistsResult_possibleTypes: string[] = ['LoanAlreadyExistsResult']
    export const isLoanAlreadyExistsResult = (obj?: { __typename?: any } | null): obj is LoanAlreadyExistsResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLoanAlreadyExistsResult"')
      return LoanAlreadyExistsResult_possibleTypes.includes(obj.__typename)
    }
    


    const LoanAttachment_possibleTypes: string[] = ['LoanAttachment']
    export const isLoanAttachment = (obj?: { __typename?: any } | null): obj is LoanAttachment => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLoanAttachment"')
      return LoanAttachment_possibleTypes.includes(obj.__typename)
    }
    


    const LoanAttachmentError_possibleTypes: string[] = ['LoanAttachmentError']
    export const isLoanAttachmentError = (obj?: { __typename?: any } | null): obj is LoanAttachmentError => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLoanAttachmentError"')
      return LoanAttachmentError_possibleTypes.includes(obj.__typename)
    }
    


    const LoanBillEvent_possibleTypes: string[] = ['LoanBillEvent']
    export const isLoanBillEvent = (obj?: { __typename?: any } | null): obj is LoanBillEvent => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLoanBillEvent"')
      return LoanBillEvent_possibleTypes.includes(obj.__typename)
    }
    


    const LoanBillPaymentEvent_possibleTypes: string[] = ['LoanBillPaymentEvent']
    export const isLoanBillPaymentEvent = (obj?: { __typename?: any } | null): obj is LoanBillPaymentEvent => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLoanBillPaymentEvent"')
      return LoanBillPaymentEvent_possibleTypes.includes(obj.__typename)
    }
    


    const LoanBusinessEvent_possibleTypes: string[] = ['LoanBusinessEvent']
    export const isLoanBusinessEvent = (obj?: { __typename?: any } | null): obj is LoanBusinessEvent => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLoanBusinessEvent"')
      return LoanBusinessEvent_possibleTypes.includes(obj.__typename)
    }
    


    const LoanBusinessEventData_possibleTypes: string[] = ['LoanBusinessEventData']
    export const isLoanBusinessEventData = (obj?: { __typename?: any } | null): obj is LoanBusinessEventData => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLoanBusinessEventData"')
      return LoanBusinessEventData_possibleTypes.includes(obj.__typename)
    }
    


    const LoanComment_possibleTypes: string[] = ['LoanComment']
    export const isLoanComment = (obj?: { __typename?: any } | null): obj is LoanComment => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLoanComment"')
      return LoanComment_possibleTypes.includes(obj.__typename)
    }
    


    const LoanCreationFailureResult_possibleTypes: string[] = ['LoanCreationFailureResult']
    export const isLoanCreationFailureResult = (obj?: { __typename?: any } | null): obj is LoanCreationFailureResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLoanCreationFailureResult"')
      return LoanCreationFailureResult_possibleTypes.includes(obj.__typename)
    }
    


    const LoanCreationResult_possibleTypes: string[] = ['LoanUpdatedResult','LoanCreationFailureResult','LoanAlreadyExistsResult','LoanTransactionProcessedOnlineResult']
    export const isLoanCreationResult = (obj?: { __typename?: any } | null): obj is LoanCreationResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLoanCreationResult"')
      return LoanCreationResult_possibleTypes.includes(obj.__typename)
    }
    


    const LoanEvent_possibleTypes: string[] = ['LoanManualEvent','BankTransaction','LoanBillEvent','LoanBusinessEvent','LoanBillPaymentEvent','Payout','Topup','LoanAffiliatedTransactionEvent','LoanAccountingEvent']
    export const isLoanEvent = (obj?: { __typename?: any } | null): obj is LoanEvent => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLoanEvent"')
      return LoanEvent_possibleTypes.includes(obj.__typename)
    }
    


    const LoanEventDefinition_possibleTypes: string[] = ['LoanEventDefinition']
    export const isLoanEventDefinition = (obj?: { __typename?: any } | null): obj is LoanEventDefinition => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLoanEventDefinition"')
      return LoanEventDefinition_possibleTypes.includes(obj.__typename)
    }
    


    const LoanManualEvent_possibleTypes: string[] = ['LoanManualEvent']
    export const isLoanManualEvent = (obj?: { __typename?: any } | null): obj is LoanManualEvent => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLoanManualEvent"')
      return LoanManualEvent_possibleTypes.includes(obj.__typename)
    }
    


    const LoanManualEventSpreadData_possibleTypes: string[] = ['LoanManualEventSpreadData']
    export const isLoanManualEventSpreadData = (obj?: { __typename?: any } | null): obj is LoanManualEventSpreadData => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLoanManualEventSpreadData"')
      return LoanManualEventSpreadData_possibleTypes.includes(obj.__typename)
    }
    


    const LoanOutstandingAmountOnDate_possibleTypes: string[] = ['LoanOutstandingAmountOnDate']
    export const isLoanOutstandingAmountOnDate = (obj?: { __typename?: any } | null): obj is LoanOutstandingAmountOnDate => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLoanOutstandingAmountOnDate"')
      return LoanOutstandingAmountOnDate_possibleTypes.includes(obj.__typename)
    }
    


    const LoanRelationship_possibleTypes: string[] = ['LoanRelationship']
    export const isLoanRelationship = (obj?: { __typename?: any } | null): obj is LoanRelationship => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLoanRelationship"')
      return LoanRelationship_possibleTypes.includes(obj.__typename)
    }
    


    const LoansByIdsResponse_possibleTypes: string[] = ['LoansByIdsResponse']
    export const isLoansByIdsResponse = (obj?: { __typename?: any } | null): obj is LoansByIdsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLoansByIdsResponse"')
      return LoansByIdsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const LoansEventsEffectConfiguration_possibleTypes: string[] = ['LoansEventsEffectConfiguration']
    export const isLoansEventsEffectConfiguration = (obj?: { __typename?: any } | null): obj is LoansEventsEffectConfiguration => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLoansEventsEffectConfiguration"')
      return LoansEventsEffectConfiguration_possibleTypes.includes(obj.__typename)
    }
    


    const LoansResponse_possibleTypes: string[] = ['LoansResponse']
    export const isLoansResponse = (obj?: { __typename?: any } | null): obj is LoansResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLoansResponse"')
      return LoansResponse_possibleTypes.includes(obj.__typename)
    }
    


    const LoanTransactionLockStatus_possibleTypes: string[] = ['LoanTransactionLockStatus']
    export const isLoanTransactionLockStatus = (obj?: { __typename?: any } | null): obj is LoanTransactionLockStatus => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLoanTransactionLockStatus"')
      return LoanTransactionLockStatus_possibleTypes.includes(obj.__typename)
    }
    


    const LoanTransactionProcessedOnlineResult_possibleTypes: string[] = ['LoanTransactionProcessedOnlineResult']
    export const isLoanTransactionProcessedOnlineResult = (obj?: { __typename?: any } | null): obj is LoanTransactionProcessedOnlineResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLoanTransactionProcessedOnlineResult"')
      return LoanTransactionProcessedOnlineResult_possibleTypes.includes(obj.__typename)
    }
    


    const LoanUpdatedResult_possibleTypes: string[] = ['LoanUpdatedResult']
    export const isLoanUpdatedResult = (obj?: { __typename?: any } | null): obj is LoanUpdatedResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLoanUpdatedResult"')
      return LoanUpdatedResult_possibleTypes.includes(obj.__typename)
    }
    


    const LockedStatus_possibleTypes: string[] = ['LockedStatus']
    export const isLockedStatus = (obj?: { __typename?: any } | null): obj is LockedStatus => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLockedStatus"')
      return LockedStatus_possibleTypes.includes(obj.__typename)
    }
    


    const LockLoanResult_possibleTypes: string[] = ['LockLoanResult']
    export const isLockLoanResult = (obj?: { __typename?: any } | null): obj is LockLoanResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLockLoanResult"')
      return LockLoanResult_possibleTypes.includes(obj.__typename)
    }
    


    const LostAndFoundCogs_possibleTypes: string[] = ['LostAndFoundCogs']
    export const isLostAndFoundCogs = (obj?: { __typename?: any } | null): obj is LostAndFoundCogs => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLostAndFoundCogs"')
      return LostAndFoundCogs_possibleTypes.includes(obj.__typename)
    }
    


    const LostAndFoundDailyBreakdown_possibleTypes: string[] = ['LostAndFoundDailyBreakdown']
    export const isLostAndFoundDailyBreakdown = (obj?: { __typename?: any } | null): obj is LostAndFoundDailyBreakdown => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLostAndFoundDailyBreakdown"')
      return LostAndFoundDailyBreakdown_possibleTypes.includes(obj.__typename)
    }
    


    const LostAndFoundMonthlyBreakdown_possibleTypes: string[] = ['LostAndFoundMonthlyBreakdown']
    export const isLostAndFoundMonthlyBreakdown = (obj?: { __typename?: any } | null): obj is LostAndFoundMonthlyBreakdown => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLostAndFoundMonthlyBreakdown"')
      return LostAndFoundMonthlyBreakdown_possibleTypes.includes(obj.__typename)
    }
    


    const MachineClassificationJob_possibleTypes: string[] = ['MachineClassificationJob']
    export const isMachineClassificationJob = (obj?: { __typename?: any } | null): obj is MachineClassificationJob => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isMachineClassificationJob"')
      return MachineClassificationJob_possibleTypes.includes(obj.__typename)
    }
    


    const ManageCompanyYearEndStateResponse_possibleTypes: string[] = ['ManageCompanyYearEndStateResponse']
    export const isManageCompanyYearEndStateResponse = (obj?: { __typename?: any } | null): obj is ManageCompanyYearEndStateResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isManageCompanyYearEndStateResponse"')
      return ManageCompanyYearEndStateResponse_possibleTypes.includes(obj.__typename)
    }
    


    const ManagementMethodYearEndPeriod_possibleTypes: string[] = ['ManagementMethodYearEndPeriod']
    export const isManagementMethodYearEndPeriod = (obj?: { __typename?: any } | null): obj is ManagementMethodYearEndPeriod => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isManagementMethodYearEndPeriod"')
      return ManagementMethodYearEndPeriod_possibleTypes.includes(obj.__typename)
    }
    


    const ManualAssembly_possibleTypes: string[] = ['ManualAssembly']
    export const isManualAssembly = (obj?: { __typename?: any } | null): obj is ManualAssembly => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isManualAssembly"')
      return ManualAssembly_possibleTypes.includes(obj.__typename)
    }
    


    const ManualAssemblyAction_possibleTypes: string[] = ['ManualAssemblyAction']
    export const isManualAssemblyAction = (obj?: { __typename?: any } | null): obj is ManualAssemblyAction => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isManualAssemblyAction"')
      return ManualAssemblyAction_possibleTypes.includes(obj.__typename)
    }
    


    const ManualAssemblyBreakdown_possibleTypes: string[] = ['ManualAssemblyBreakdown']
    export const isManualAssemblyBreakdown = (obj?: { __typename?: any } | null): obj is ManualAssemblyBreakdown => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isManualAssemblyBreakdown"')
      return ManualAssemblyBreakdown_possibleTypes.includes(obj.__typename)
    }
    


    const ManualAssemblyDuplicateError_possibleTypes: string[] = ['ManualAssemblyDuplicateError']
    export const isManualAssemblyDuplicateError = (obj?: { __typename?: any } | null): obj is ManualAssemblyDuplicateError => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isManualAssemblyDuplicateError"')
      return ManualAssemblyDuplicateError_possibleTypes.includes(obj.__typename)
    }
    


    const ManualAssemblyWithBreakdown_possibleTypes: string[] = ['ManualAssemblyWithBreakdown']
    export const isManualAssemblyWithBreakdown = (obj?: { __typename?: any } | null): obj is ManualAssemblyWithBreakdown => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isManualAssemblyWithBreakdown"')
      return ManualAssemblyWithBreakdown_possibleTypes.includes(obj.__typename)
    }
    


    const ManualCompanyLoanCreationResult_possibleTypes: string[] = ['ManualCompanyLoanCreationResult']
    export const isManualCompanyLoanCreationResult = (obj?: { __typename?: any } | null): obj is ManualCompanyLoanCreationResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isManualCompanyLoanCreationResult"')
      return ManualCompanyLoanCreationResult_possibleTypes.includes(obj.__typename)
    }
    


    const ManualEquityEntity_possibleTypes: string[] = ['HolderTransaction','HolderShare','HolderCapitalInvestment','HolderSafeInvestment']
    export const isManualEquityEntity = (obj?: { __typename?: any } | null): obj is ManualEquityEntity => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isManualEquityEntity"')
      return ManualEquityEntity_possibleTypes.includes(obj.__typename)
    }
    


    const ManualLoanCreationResult_possibleTypes: string[] = ['ManualLoanCreationResult']
    export const isManualLoanCreationResult = (obj?: { __typename?: any } | null): obj is ManualLoanCreationResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isManualLoanCreationResult"')
      return ManualLoanCreationResult_possibleTypes.includes(obj.__typename)
    }
    


    const ManualTransactionsAttachToLoanResult_possibleTypes: string[] = ['ManualTransactionsAttachToLoanResult']
    export const isManualTransactionsAttachToLoanResult = (obj?: { __typename?: any } | null): obj is ManualTransactionsAttachToLoanResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isManualTransactionsAttachToLoanResult"')
      return ManualTransactionsAttachToLoanResult_possibleTypes.includes(obj.__typename)
    }
    


    const ManualTransactionsAttachToLoansResult_possibleTypes: string[] = ['ManualTransactionsAttachToLoansResult']
    export const isManualTransactionsAttachToLoansResult = (obj?: { __typename?: any } | null): obj is ManualTransactionsAttachToLoansResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isManualTransactionsAttachToLoansResult"')
      return ManualTransactionsAttachToLoansResult_possibleTypes.includes(obj.__typename)
    }
    


    const MarkOrderLineItemsAsVoidedResponse_possibleTypes: string[] = ['MarkOrderLineItemsAsVoidedResponse']
    export const isMarkOrderLineItemsAsVoidedResponse = (obj?: { __typename?: any } | null): obj is MarkOrderLineItemsAsVoidedResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isMarkOrderLineItemsAsVoidedResponse"')
      return MarkOrderLineItemsAsVoidedResponse_possibleTypes.includes(obj.__typename)
    }
    


    const MarkOrdersAsCOGSResponse_possibleTypes: string[] = ['MarkOrdersAsCOGSResponse']
    export const isMarkOrdersAsCOGSResponse = (obj?: { __typename?: any } | null): obj is MarkOrdersAsCOGSResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isMarkOrdersAsCOGSResponse"')
      return MarkOrdersAsCOGSResponse_possibleTypes.includes(obj.__typename)
    }
    


    const MarkOrdersAsGiveawayResponse_possibleTypes: string[] = ['MarkOrdersAsGiveawayResponse']
    export const isMarkOrdersAsGiveawayResponse = (obj?: { __typename?: any } | null): obj is MarkOrdersAsGiveawayResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isMarkOrdersAsGiveawayResponse"')
      return MarkOrdersAsGiveawayResponse_possibleTypes.includes(obj.__typename)
    }
    


    const MarkOrdersAsHistoricallyPaidResponse_possibleTypes: string[] = ['MarkOrdersAsHistoricallyPaidResponse']
    export const isMarkOrdersAsHistoricallyPaidResponse = (obj?: { __typename?: any } | null): obj is MarkOrdersAsHistoricallyPaidResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isMarkOrdersAsHistoricallyPaidResponse"')
      return MarkOrdersAsHistoricallyPaidResponse_possibleTypes.includes(obj.__typename)
    }
    


    const MarkOrdersAsOvercollectedResponse_possibleTypes: string[] = ['MarkOrdersAsOvercollectedResponse']
    export const isMarkOrdersAsOvercollectedResponse = (obj?: { __typename?: any } | null): obj is MarkOrdersAsOvercollectedResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isMarkOrdersAsOvercollectedResponse"')
      return MarkOrdersAsOvercollectedResponse_possibleTypes.includes(obj.__typename)
    }
    


    const MarkOrdersAsUncollectibleResponse_possibleTypes: string[] = ['MarkOrdersAsUncollectibleResponse']
    export const isMarkOrdersAsUncollectibleResponse = (obj?: { __typename?: any } | null): obj is MarkOrdersAsUncollectibleResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isMarkOrdersAsUncollectibleResponse"')
      return MarkOrdersAsUncollectibleResponse_possibleTypes.includes(obj.__typename)
    }
    


    const Merchant_possibleTypes: string[] = ['Vendor','CustomerV2','CompanyAffiliate','Institution']
    export const isMerchant = (obj?: { __typename?: any } | null): obj is Merchant => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isMerchant"')
      return Merchant_possibleTypes.includes(obj.__typename)
    }
    


    const MerchantsBankTransactionStats_possibleTypes: string[] = ['MerchantsBankTransactionStats']
    export const isMerchantsBankTransactionStats = (obj?: { __typename?: any } | null): obj is MerchantsBankTransactionStats => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isMerchantsBankTransactionStats"')
      return MerchantsBankTransactionStats_possibleTypes.includes(obj.__typename)
    }
    


    const MeResponse_possibleTypes: string[] = ['MeResponse']
    export const isMeResponse = (obj?: { __typename?: any } | null): obj is MeResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isMeResponse"')
      return MeResponse_possibleTypes.includes(obj.__typename)
    }
    


    const MergedProduct_possibleTypes: string[] = ['MergedProduct']
    export const isMergedProduct = (obj?: { __typename?: any } | null): obj is MergedProduct => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isMergedProduct"')
      return MergedProduct_possibleTypes.includes(obj.__typename)
    }
    


    const MergeProductsV3Response_possibleTypes: string[] = ['MergeProductsV3Result','MergeProductsValidationError']
    export const isMergeProductsV3Response = (obj?: { __typename?: any } | null): obj is MergeProductsV3Response => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isMergeProductsV3Response"')
      return MergeProductsV3Response_possibleTypes.includes(obj.__typename)
    }
    


    const MergeProductsV3Result_possibleTypes: string[] = ['MergeProductsV3Result']
    export const isMergeProductsV3Result = (obj?: { __typename?: any } | null): obj is MergeProductsV3Result => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isMergeProductsV3Result"')
      return MergeProductsV3Result_possibleTypes.includes(obj.__typename)
    }
    


    const MergeProductsValidationError_possibleTypes: string[] = ['MergeProductsValidationError']
    export const isMergeProductsValidationError = (obj?: { __typename?: any } | null): obj is MergeProductsValidationError => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isMergeProductsValidationError"')
      return MergeProductsValidationError_possibleTypes.includes(obj.__typename)
    }
    


    const MergeWarehousesError_possibleTypes: string[] = ['MergeWarehousesError']
    export const isMergeWarehousesError = (obj?: { __typename?: any } | null): obj is MergeWarehousesError => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isMergeWarehousesError"')
      return MergeWarehousesError_possibleTypes.includes(obj.__typename)
    }
    


    const MergeWarehousesResult_possibleTypes: string[] = ['MergeWarehousesSuccess','MergeWarehousesError']
    export const isMergeWarehousesResult = (obj?: { __typename?: any } | null): obj is MergeWarehousesResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isMergeWarehousesResult"')
      return MergeWarehousesResult_possibleTypes.includes(obj.__typename)
    }
    


    const MergeWarehousesSuccess_possibleTypes: string[] = ['MergeWarehousesSuccess']
    export const isMergeWarehousesSuccess = (obj?: { __typename?: any } | null): obj is MergeWarehousesSuccess => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isMergeWarehousesSuccess"')
      return MergeWarehousesSuccess_possibleTypes.includes(obj.__typename)
    }
    


    const MissingCostsInPeriodResponse_possibleTypes: string[] = ['MissingCostsInPeriodResponse']
    export const isMissingCostsInPeriodResponse = (obj?: { __typename?: any } | null): obj is MissingCostsInPeriodResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isMissingCostsInPeriodResponse"')
      return MissingCostsInPeriodResponse_possibleTypes.includes(obj.__typename)
    }
    


    const Movement_possibleTypes: string[] = ['Movement']
    export const isMovement = (obj?: { __typename?: any } | null): obj is Movement => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isMovement"')
      return Movement_possibleTypes.includes(obj.__typename)
    }
    


    const MovementIndirectCost_possibleTypes: string[] = ['MovementIndirectCost']
    export const isMovementIndirectCost = (obj?: { __typename?: any } | null): obj is MovementIndirectCost => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isMovementIndirectCost"')
      return MovementIndirectCost_possibleTypes.includes(obj.__typename)
    }
    


    const Mutation_possibleTypes: string[] = ['Mutation']
    export const isMutation = (obj?: { __typename?: any } | null): obj is Mutation => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isMutation"')
      return Mutation_possibleTypes.includes(obj.__typename)
    }
    


    const NewLender_possibleTypes: string[] = ['NewLender']
    export const isNewLender = (obj?: { __typename?: any } | null): obj is NewLender => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isNewLender"')
      return NewLender_possibleTypes.includes(obj.__typename)
    }
    


    const NonMatchedSku_possibleTypes: string[] = ['NonMatchedSku']
    export const isNonMatchedSku = (obj?: { __typename?: any } | null): obj is NonMatchedSku => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isNonMatchedSku"')
      return NonMatchedSku_possibleTypes.includes(obj.__typename)
    }
    


    const NonMatchingProductsResponse_possibleTypes: string[] = ['NonMatchingProductsResponse']
    export const isNonMatchingProductsResponse = (obj?: { __typename?: any } | null): obj is NonMatchingProductsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isNonMatchingProductsResponse"')
      return NonMatchingProductsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const NonMatchingUnpaidBill_possibleTypes: string[] = ['NonMatchingUnpaidBill']
    export const isNonMatchingUnpaidBill = (obj?: { __typename?: any } | null): obj is NonMatchingUnpaidBill => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isNonMatchingUnpaidBill"')
      return NonMatchingUnpaidBill_possibleTypes.includes(obj.__typename)
    }
    


    const NotFoundProductSkus_possibleTypes: string[] = ['NotFoundProductSkus']
    export const isNotFoundProductSkus = (obj?: { __typename?: any } | null): obj is NotFoundProductSkus => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isNotFoundProductSkus"')
      return NotFoundProductSkus_possibleTypes.includes(obj.__typename)
    }
    


    const NothingTypes_possibleTypes: string[] = ['NothingTypes']
    export const isNothingTypes = (obj?: { __typename?: any } | null): obj is NothingTypes => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isNothingTypes"')
      return NothingTypes_possibleTypes.includes(obj.__typename)
    }
    


    const NoUnitsBusinessEventsValidationResult_possibleTypes: string[] = ['NoUnitsBusinessEventsValidationResult']
    export const isNoUnitsBusinessEventsValidationResult = (obj?: { __typename?: any } | null): obj is NoUnitsBusinessEventsValidationResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isNoUnitsBusinessEventsValidationResult"')
      return NoUnitsBusinessEventsValidationResult_possibleTypes.includes(obj.__typename)
    }
    


    const NoUnitsDailyProductValidationResult_possibleTypes: string[] = ['NoUnitsDailyProductValidationResult']
    export const isNoUnitsDailyProductValidationResult = (obj?: { __typename?: any } | null): obj is NoUnitsDailyProductValidationResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isNoUnitsDailyProductValidationResult"')
      return NoUnitsDailyProductValidationResult_possibleTypes.includes(obj.__typename)
    }
    


    const NoUnitsIntegrationValidation_possibleTypes: string[] = ['NoUnitsIntegrationValidation']
    export const isNoUnitsIntegrationValidation = (obj?: { __typename?: any } | null): obj is NoUnitsIntegrationValidation => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isNoUnitsIntegrationValidation"')
      return NoUnitsIntegrationValidation_possibleTypes.includes(obj.__typename)
    }
    


    const NoUnitsPhysicalCount_possibleTypes: string[] = ['NoUnitsPhysicalCount']
    export const isNoUnitsPhysicalCount = (obj?: { __typename?: any } | null): obj is NoUnitsPhysicalCount => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isNoUnitsPhysicalCount"')
      return NoUnitsPhysicalCount_possibleTypes.includes(obj.__typename)
    }
    


    const NoUnitsPhysicalCountAttachment_possibleTypes: string[] = ['NoUnitsPhysicalCountAttachment']
    export const isNoUnitsPhysicalCountAttachment = (obj?: { __typename?: any } | null): obj is NoUnitsPhysicalCountAttachment => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isNoUnitsPhysicalCountAttachment"')
      return NoUnitsPhysicalCountAttachment_possibleTypes.includes(obj.__typename)
    }
    


    const NoUnitsPhysicalCountClosingBalanceResult_possibleTypes: string[] = ['NoUnitsPhysicalCountClosingBalanceResult']
    export const isNoUnitsPhysicalCountClosingBalanceResult = (obj?: { __typename?: any } | null): obj is NoUnitsPhysicalCountClosingBalanceResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isNoUnitsPhysicalCountClosingBalanceResult"')
      return NoUnitsPhysicalCountClosingBalanceResult_possibleTypes.includes(obj.__typename)
    }
    


    const NoUnitsPhysicalCountOverview_possibleTypes: string[] = ['NoUnitsPhysicalCountOverview']
    export const isNoUnitsPhysicalCountOverview = (obj?: { __typename?: any } | null): obj is NoUnitsPhysicalCountOverview => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isNoUnitsPhysicalCountOverview"')
      return NoUnitsPhysicalCountOverview_possibleTypes.includes(obj.__typename)
    }
    


    const NoUnitsPhysicalCountProductQuantities_possibleTypes: string[] = ['NoUnitsPhysicalCountProductQuantities']
    export const isNoUnitsPhysicalCountProductQuantities = (obj?: { __typename?: any } | null): obj is NoUnitsPhysicalCountProductQuantities => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isNoUnitsPhysicalCountProductQuantities"')
      return NoUnitsPhysicalCountProductQuantities_possibleTypes.includes(obj.__typename)
    }
    


    const NoUnitsPhysicalCountProductQuantity_possibleTypes: string[] = ['NoUnitsPhysicalCountProductQuantity']
    export const isNoUnitsPhysicalCountProductQuantity = (obj?: { __typename?: any } | null): obj is NoUnitsPhysicalCountProductQuantity => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isNoUnitsPhysicalCountProductQuantity"')
      return NoUnitsPhysicalCountProductQuantity_possibleTypes.includes(obj.__typename)
    }
    


    const NoUnitsPhysicalCountProductQuantityPendingAdjustment_possibleTypes: string[] = ['NoUnitsPhysicalCountProductQuantityPendingAdjustment']
    export const isNoUnitsPhysicalCountProductQuantityPendingAdjustment = (obj?: { __typename?: any } | null): obj is NoUnitsPhysicalCountProductQuantityPendingAdjustment => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isNoUnitsPhysicalCountProductQuantityPendingAdjustment"')
      return NoUnitsPhysicalCountProductQuantityPendingAdjustment_possibleTypes.includes(obj.__typename)
    }
    


    const NoUnitsPhysicalCountsList_possibleTypes: string[] = ['NoUnitsPhysicalCountsList']
    export const isNoUnitsPhysicalCountsList = (obj?: { __typename?: any } | null): obj is NoUnitsPhysicalCountsList => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isNoUnitsPhysicalCountsList"')
      return NoUnitsPhysicalCountsList_possibleTypes.includes(obj.__typename)
    }
    


    const NoUnitsProductValidation_possibleTypes: string[] = ['NoUnitsProductValidation']
    export const isNoUnitsProductValidation = (obj?: { __typename?: any } | null): obj is NoUnitsProductValidation => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isNoUnitsProductValidation"')
      return NoUnitsProductValidation_possibleTypes.includes(obj.__typename)
    }
    


    const NoUnitsValidationError_possibleTypes: string[] = ['NoUnitsValidationError']
    export const isNoUnitsValidationError = (obj?: { __typename?: any } | null): obj is NoUnitsValidationError => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isNoUnitsValidationError"')
      return NoUnitsValidationError_possibleTypes.includes(obj.__typename)
    }
    


    const NoUnitsValidationResponse_possibleTypes: string[] = ['NoUnitsValidationResult','NoUnitsValidationError']
    export const isNoUnitsValidationResponse = (obj?: { __typename?: any } | null): obj is NoUnitsValidationResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isNoUnitsValidationResponse"')
      return NoUnitsValidationResponse_possibleTypes.includes(obj.__typename)
    }
    


    const NoUnitsValidationResult_possibleTypes: string[] = ['NoUnitsValidationResult']
    export const isNoUnitsValidationResult = (obj?: { __typename?: any } | null): obj is NoUnitsValidationResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isNoUnitsValidationResult"')
      return NoUnitsValidationResult_possibleTypes.includes(obj.__typename)
    }
    


    const Offer_possibleTypes: string[] = ['Offer']
    export const isOffer = (obj?: { __typename?: any } | null): obj is Offer => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOffer"')
      return Offer_possibleTypes.includes(obj.__typename)
    }
    


    const OnBoardingState_possibleTypes: string[] = ['OnBoardingState']
    export const isOnBoardingState = (obj?: { __typename?: any } | null): obj is OnBoardingState => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOnBoardingState"')
      return OnBoardingState_possibleTypes.includes(obj.__typename)
    }
    


    const OnboardingStatus_possibleTypes: string[] = ['OnboardingStatus']
    export const isOnboardingStatus = (obj?: { __typename?: any } | null): obj is OnboardingStatus => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOnboardingStatus"')
      return OnboardingStatus_possibleTypes.includes(obj.__typename)
    }
    


    const OnboardingStatuses_possibleTypes: string[] = ['OnboardingStatuses']
    export const isOnboardingStatuses = (obj?: { __typename?: any } | null): obj is OnboardingStatuses => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOnboardingStatuses"')
      return OnboardingStatuses_possibleTypes.includes(obj.__typename)
    }
    


    const OnDemandAssemblyAction_possibleTypes: string[] = ['OnDemandAssemblyAction']
    export const isOnDemandAssemblyAction = (obj?: { __typename?: any } | null): obj is OnDemandAssemblyAction => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOnDemandAssemblyAction"')
      return OnDemandAssemblyAction_possibleTypes.includes(obj.__typename)
    }
    


    const OnDemandAssemblyBreakdown_possibleTypes: string[] = ['OnDemandAssemblyBreakdown']
    export const isOnDemandAssemblyBreakdown = (obj?: { __typename?: any } | null): obj is OnDemandAssemblyBreakdown => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOnDemandAssemblyBreakdown"')
      return OnDemandAssemblyBreakdown_possibleTypes.includes(obj.__typename)
    }
    


    const OnDemandAssemblyCosts_possibleTypes: string[] = ['OnDemandAssemblyCosts']
    export const isOnDemandAssemblyCosts = (obj?: { __typename?: any } | null): obj is OnDemandAssemblyCosts => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOnDemandAssemblyCosts"')
      return OnDemandAssemblyCosts_possibleTypes.includes(obj.__typename)
    }
    


    const OnDemandAssemblyCostsResult_possibleTypes: string[] = ['OnDemandAssemblyCostsResult']
    export const isOnDemandAssemblyCostsResult = (obj?: { __typename?: any } | null): obj is OnDemandAssemblyCostsResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOnDemandAssemblyCostsResult"')
      return OnDemandAssemblyCostsResult_possibleTypes.includes(obj.__typename)
    }
    


    const OnDemandAssemblyVendorCosts_possibleTypes: string[] = ['OnDemandAssemblyVendorCosts']
    export const isOnDemandAssemblyVendorCosts = (obj?: { __typename?: any } | null): obj is OnDemandAssemblyVendorCosts => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOnDemandAssemblyVendorCosts"')
      return OnDemandAssemblyVendorCosts_possibleTypes.includes(obj.__typename)
    }
    


    const OnDemandAssemblyVendorCostsResult_possibleTypes: string[] = ['OnDemandAssemblyVendorCostsResult']
    export const isOnDemandAssemblyVendorCostsResult = (obj?: { __typename?: any } | null): obj is OnDemandAssemblyVendorCostsResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOnDemandAssemblyVendorCostsResult"')
      return OnDemandAssemblyVendorCostsResult_possibleTypes.includes(obj.__typename)
    }
    


    const OneTimePayment_possibleTypes: string[] = ['OneTimePayment']
    export const isOneTimePayment = (obj?: { __typename?: any } | null): obj is OneTimePayment => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOneTimePayment"')
      return OneTimePayment_possibleTypes.includes(obj.__typename)
    }
    


    const OpenBalanceSheetSetupResponse_possibleTypes: string[] = ['OpenBalanceSheetSetupResponse']
    export const isOpenBalanceSheetSetupResponse = (obj?: { __typename?: any } | null): obj is OpenBalanceSheetSetupResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOpenBalanceSheetSetupResponse"')
      return OpenBalanceSheetSetupResponse_possibleTypes.includes(obj.__typename)
    }
    


    const OpeningBalanceAction_possibleTypes: string[] = ['OpeningBalanceAction']
    export const isOpeningBalanceAction = (obj?: { __typename?: any } | null): obj is OpeningBalanceAction => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOpeningBalanceAction"')
      return OpeningBalanceAction_possibleTypes.includes(obj.__typename)
    }
    


    const OrderAccountingReconciliationAccount_possibleTypes: string[] = ['OrderAccountingReconciliationAccount']
    export const isOrderAccountingReconciliationAccount = (obj?: { __typename?: any } | null): obj is OrderAccountingReconciliationAccount => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderAccountingReconciliationAccount"')
      return OrderAccountingReconciliationAccount_possibleTypes.includes(obj.__typename)
    }
    


    const OrderAccountingReconciliationAmount_possibleTypes: string[] = ['OrderAccountingReconciliationAmount']
    export const isOrderAccountingReconciliationAmount = (obj?: { __typename?: any } | null): obj is OrderAccountingReconciliationAmount => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderAccountingReconciliationAmount"')
      return OrderAccountingReconciliationAmount_possibleTypes.includes(obj.__typename)
    }
    


    const OrderAccountingReconciliationRow_possibleTypes: string[] = ['OrderAccountingReconciliationRow']
    export const isOrderAccountingReconciliationRow = (obj?: { __typename?: any } | null): obj is OrderAccountingReconciliationRow => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderAccountingReconciliationRow"')
      return OrderAccountingReconciliationRow_possibleTypes.includes(obj.__typename)
    }
    


    const OrderAccountingReconciliationsResponse_possibleTypes: string[] = ['OrderAccountingReconciliationsResponse']
    export const isOrderAccountingReconciliationsResponse = (obj?: { __typename?: any } | null): obj is OrderAccountingReconciliationsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderAccountingReconciliationsResponse"')
      return OrderAccountingReconciliationsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const OrderAdjustment_possibleTypes: string[] = ['OrderAdjustment']
    export const isOrderAdjustment = (obj?: { __typename?: any } | null): obj is OrderAdjustment => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderAdjustment"')
      return OrderAdjustment_possibleTypes.includes(obj.__typename)
    }
    


    const OrderAdjustmentV3_possibleTypes: string[] = ['OrderAdjustmentV3']
    export const isOrderAdjustmentV3 = (obj?: { __typename?: any } | null): obj is OrderAdjustmentV3 => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderAdjustmentV3"')
      return OrderAdjustmentV3_possibleTypes.includes(obj.__typename)
    }
    


    const OrderAggregationEntry_possibleTypes: string[] = ['OrdersAggregation','OrdersAgingAggregation']
    export const isOrderAggregationEntry = (obj?: { __typename?: any } | null): obj is OrderAggregationEntry => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderAggregationEntry"')
      return OrderAggregationEntry_possibleTypes.includes(obj.__typename)
    }
    


    const OrderBalance_possibleTypes: string[] = ['OrderBalance']
    export const isOrderBalance = (obj?: { __typename?: any } | null): obj is OrderBalance => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderBalance"')
      return OrderBalance_possibleTypes.includes(obj.__typename)
    }
    


    const OrderEntity_possibleTypes: string[] = ['OrderEntity']
    export const isOrderEntity = (obj?: { __typename?: any } | null): obj is OrderEntity => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderEntity"')
      return OrderEntity_possibleTypes.includes(obj.__typename)
    }
    


    const OrderFinancialReportingStatus_possibleTypes: string[] = ['OrderFinancialReportingStatus']
    export const isOrderFinancialReportingStatus = (obj?: { __typename?: any } | null): obj is OrderFinancialReportingStatus => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderFinancialReportingStatus"')
      return OrderFinancialReportingStatus_possibleTypes.includes(obj.__typename)
    }
    


    const OrderFulfillment_possibleTypes: string[] = ['OrderFulfillment']
    export const isOrderFulfillment = (obj?: { __typename?: any } | null): obj is OrderFulfillment => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderFulfillment"')
      return OrderFulfillment_possibleTypes.includes(obj.__typename)
    }
    


    const OrderFulfillmentLineItem_possibleTypes: string[] = ['OrderFulfillmentLineItem']
    export const isOrderFulfillmentLineItem = (obj?: { __typename?: any } | null): obj is OrderFulfillmentLineItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderFulfillmentLineItem"')
      return OrderFulfillmentLineItem_possibleTypes.includes(obj.__typename)
    }
    


    const OrderFulfillmentLineItemV3_possibleTypes: string[] = ['OrderFulfillmentLineItemV3']
    export const isOrderFulfillmentLineItemV3 = (obj?: { __typename?: any } | null): obj is OrderFulfillmentLineItemV3 => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderFulfillmentLineItemV3"')
      return OrderFulfillmentLineItemV3_possibleTypes.includes(obj.__typename)
    }
    


    const OrderFulfillmentV3_possibleTypes: string[] = ['OrderFulfillmentV3']
    export const isOrderFulfillmentV3 = (obj?: { __typename?: any } | null): obj is OrderFulfillmentV3 => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderFulfillmentV3"')
      return OrderFulfillmentV3_possibleTypes.includes(obj.__typename)
    }
    


    const OrderGroup_possibleTypes: string[] = ['OrderGroup']
    export const isOrderGroup = (obj?: { __typename?: any } | null): obj is OrderGroup => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderGroup"')
      return OrderGroup_possibleTypes.includes(obj.__typename)
    }
    


    const OrderGroupByIdResponse_possibleTypes: string[] = ['OrderGroupByIdResponse']
    export const isOrderGroupByIdResponse = (obj?: { __typename?: any } | null): obj is OrderGroupByIdResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderGroupByIdResponse"')
      return OrderGroupByIdResponse_possibleTypes.includes(obj.__typename)
    }
    


    const OrderGroupDistributionBasic_possibleTypes: string[] = ['OrderGroupDistributionBasic']
    export const isOrderGroupDistributionBasic = (obj?: { __typename?: any } | null): obj is OrderGroupDistributionBasic => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderGroupDistributionBasic"')
      return OrderGroupDistributionBasic_possibleTypes.includes(obj.__typename)
    }
    


    const OrderGroupExpense_possibleTypes: string[] = ['OrderGroupExpense']
    export const isOrderGroupExpense = (obj?: { __typename?: any } | null): obj is OrderGroupExpense => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderGroupExpense"')
      return OrderGroupExpense_possibleTypes.includes(obj.__typename)
    }
    


    const OrderGroupLink_possibleTypes: string[] = ['OrderGroupLink']
    export const isOrderGroupLink = (obj?: { __typename?: any } | null): obj is OrderGroupLink => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderGroupLink"')
      return OrderGroupLink_possibleTypes.includes(obj.__typename)
    }
    


    const OrderGroupOrderDistribution_possibleTypes: string[] = ['OrderGroupOrderDistribution']
    export const isOrderGroupOrderDistribution = (obj?: { __typename?: any } | null): obj is OrderGroupOrderDistribution => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderGroupOrderDistribution"')
      return OrderGroupOrderDistribution_possibleTypes.includes(obj.__typename)
    }
    


    const OrderGroupsByIdsResponse_possibleTypes: string[] = ['OrderGroupsByIdsResponse']
    export const isOrderGroupsByIdsResponse = (obj?: { __typename?: any } | null): obj is OrderGroupsByIdsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderGroupsByIdsResponse"')
      return OrderGroupsByIdsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const OrderGroupsResponse_possibleTypes: string[] = ['OrderGroupsResponse']
    export const isOrderGroupsResponse = (obj?: { __typename?: any } | null): obj is OrderGroupsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderGroupsResponse"')
      return OrderGroupsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const OrderGroupsTotalUnclearedBalanceResponse_possibleTypes: string[] = ['OrderGroupsTotalUnclearedBalanceResponse']
    export const isOrderGroupsTotalUnclearedBalanceResponse = (obj?: { __typename?: any } | null): obj is OrderGroupsTotalUnclearedBalanceResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderGroupsTotalUnclearedBalanceResponse"')
      return OrderGroupsTotalUnclearedBalanceResponse_possibleTypes.includes(obj.__typename)
    }
    


    const OrderGroupsUnclearedBalanceResponse_possibleTypes: string[] = ['OrderGroupsUnclearedBalanceResponse']
    export const isOrderGroupsUnclearedBalanceResponse = (obj?: { __typename?: any } | null): obj is OrderGroupsUnclearedBalanceResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderGroupsUnclearedBalanceResponse"')
      return OrderGroupsUnclearedBalanceResponse_possibleTypes.includes(obj.__typename)
    }
    


    const OrderGroupUnclearedBalance_possibleTypes: string[] = ['OrderGroupUnclearedBalance']
    export const isOrderGroupUnclearedBalance = (obj?: { __typename?: any } | null): obj is OrderGroupUnclearedBalance => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderGroupUnclearedBalance"')
      return OrderGroupUnclearedBalance_possibleTypes.includes(obj.__typename)
    }
    


    const OrderItemsFulfillmentV2_possibleTypes: string[] = ['OrderItemsFulfillmentV2']
    export const isOrderItemsFulfillmentV2 = (obj?: { __typename?: any } | null): obj is OrderItemsFulfillmentV2 => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderItemsFulfillmentV2"')
      return OrderItemsFulfillmentV2_possibleTypes.includes(obj.__typename)
    }
    


    const OrderItemStatusWithOverride_possibleTypes: string[] = ['OrderItemStatusWithOverride']
    export const isOrderItemStatusWithOverride = (obj?: { __typename?: any } | null): obj is OrderItemStatusWithOverride => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderItemStatusWithOverride"')
      return OrderItemStatusWithOverride_possibleTypes.includes(obj.__typename)
    }
    


    const OrderItemV2_possibleTypes: string[] = ['OrderItemV2']
    export const isOrderItemV2 = (obj?: { __typename?: any } | null): obj is OrderItemV2 => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderItemV2"')
      return OrderItemV2_possibleTypes.includes(obj.__typename)
    }
    


    const OrderLineItem_possibleTypes: string[] = ['OrderLineItem']
    export const isOrderLineItem = (obj?: { __typename?: any } | null): obj is OrderLineItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderLineItem"')
      return OrderLineItem_possibleTypes.includes(obj.__typename)
    }
    


    const OrderLineItemFulfillment_possibleTypes: string[] = ['OrderLineItemFulfillment']
    export const isOrderLineItemFulfillment = (obj?: { __typename?: any } | null): obj is OrderLineItemFulfillment => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderLineItemFulfillment"')
      return OrderLineItemFulfillment_possibleTypes.includes(obj.__typename)
    }
    


    const OrderLineItemFulfillmentStats_possibleTypes: string[] = ['OrderLineItemFulfillmentStats']
    export const isOrderLineItemFulfillmentStats = (obj?: { __typename?: any } | null): obj is OrderLineItemFulfillmentStats => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderLineItemFulfillmentStats"')
      return OrderLineItemFulfillmentStats_possibleTypes.includes(obj.__typename)
    }
    


    const OrderLineItemFulfillmentV3_possibleTypes: string[] = ['OrderLineItemFulfillmentV3']
    export const isOrderLineItemFulfillmentV3 = (obj?: { __typename?: any } | null): obj is OrderLineItemFulfillmentV3 => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderLineItemFulfillmentV3"')
      return OrderLineItemFulfillmentV3_possibleTypes.includes(obj.__typename)
    }
    


    const OrderLineItemTimelineV3_possibleTypes: string[] = ['OrderLineItemTimelineV3']
    export const isOrderLineItemTimelineV3 = (obj?: { __typename?: any } | null): obj is OrderLineItemTimelineV3 => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderLineItemTimelineV3"')
      return OrderLineItemTimelineV3_possibleTypes.includes(obj.__typename)
    }
    


    const OrderLineItemV3_possibleTypes: string[] = ['DiscountLineItemV3','FeeLineItemV3','ProductLineItemV3','ShippingLineItemV3','TaxLineItemV3','TipLineItemV3']
    export const isOrderLineItemV3 = (obj?: { __typename?: any } | null): obj is OrderLineItemV3 => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderLineItemV3"')
      return OrderLineItemV3_possibleTypes.includes(obj.__typename)
    }
    


    const OrderOtherAccountingReconciliationRow_possibleTypes: string[] = ['OrderOtherAccountingReconciliationRow']
    export const isOrderOtherAccountingReconciliationRow = (obj?: { __typename?: any } | null): obj is OrderOtherAccountingReconciliationRow => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderOtherAccountingReconciliationRow"')
      return OrderOtherAccountingReconciliationRow_possibleTypes.includes(obj.__typename)
    }
    


    const OrderPaymentGroup_possibleTypes: string[] = ['OrderPaymentGroup']
    export const isOrderPaymentGroup = (obj?: { __typename?: any } | null): obj is OrderPaymentGroup => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderPaymentGroup"')
      return OrderPaymentGroup_possibleTypes.includes(obj.__typename)
    }
    


    const OrderPaymentGroupByIdResponse_possibleTypes: string[] = ['OrderPaymentGroupByIdResponse']
    export const isOrderPaymentGroupByIdResponse = (obj?: { __typename?: any } | null): obj is OrderPaymentGroupByIdResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderPaymentGroupByIdResponse"')
      return OrderPaymentGroupByIdResponse_possibleTypes.includes(obj.__typename)
    }
    


    const OrderPaymentGroupsByIdsResponse_possibleTypes: string[] = ['OrderPaymentGroupsByIdsResponse']
    export const isOrderPaymentGroupsByIdsResponse = (obj?: { __typename?: any } | null): obj is OrderPaymentGroupsByIdsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderPaymentGroupsByIdsResponse"')
      return OrderPaymentGroupsByIdsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const OrderPaymentGroupsResponse_possibleTypes: string[] = ['OrderPaymentGroupsResponse']
    export const isOrderPaymentGroupsResponse = (obj?: { __typename?: any } | null): obj is OrderPaymentGroupsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderPaymentGroupsResponse"')
      return OrderPaymentGroupsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const OrderPaymentGroupsUnclearedBalanceResponse_possibleTypes: string[] = ['OrderPaymentGroupsUnclearedBalanceResponse']
    export const isOrderPaymentGroupsUnclearedBalanceResponse = (obj?: { __typename?: any } | null): obj is OrderPaymentGroupsUnclearedBalanceResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderPaymentGroupsUnclearedBalanceResponse"')
      return OrderPaymentGroupsUnclearedBalanceResponse_possibleTypes.includes(obj.__typename)
    }
    


    const OrderPaymentGroupUnclearedBalance_possibleTypes: string[] = ['OrderPaymentGroupUnclearedBalance']
    export const isOrderPaymentGroupUnclearedBalance = (obj?: { __typename?: any } | null): obj is OrderPaymentGroupUnclearedBalance => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderPaymentGroupUnclearedBalance"')
      return OrderPaymentGroupUnclearedBalance_possibleTypes.includes(obj.__typename)
    }
    


    const OrderReconciliationRow_possibleTypes: string[] = ['OrderReconciliationRow']
    export const isOrderReconciliationRow = (obj?: { __typename?: any } | null): obj is OrderReconciliationRow => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderReconciliationRow"')
      return OrderReconciliationRow_possibleTypes.includes(obj.__typename)
    }
    


    const OrderReconciliationsResponse_possibleTypes: string[] = ['OrderReconciliationsResponse']
    export const isOrderReconciliationsResponse = (obj?: { __typename?: any } | null): obj is OrderReconciliationsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderReconciliationsResponse"')
      return OrderReconciliationsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const OrderRestock_possibleTypes: string[] = ['OrderRestock']
    export const isOrderRestock = (obj?: { __typename?: any } | null): obj is OrderRestock => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderRestock"')
      return OrderRestock_possibleTypes.includes(obj.__typename)
    }
    


    const OrderRestockLineItem_possibleTypes: string[] = ['OrderRestockLineItem']
    export const isOrderRestockLineItem = (obj?: { __typename?: any } | null): obj is OrderRestockLineItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderRestockLineItem"')
      return OrderRestockLineItem_possibleTypes.includes(obj.__typename)
    }
    


    const OrderReturnLineItemV3_possibleTypes: string[] = ['OrderReturnLineItemV3']
    export const isOrderReturnLineItemV3 = (obj?: { __typename?: any } | null): obj is OrderReturnLineItemV3 => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderReturnLineItemV3"')
      return OrderReturnLineItemV3_possibleTypes.includes(obj.__typename)
    }
    


    const OrderReturnV3_possibleTypes: string[] = ['OrderReturnV3']
    export const isOrderReturnV3 = (obj?: { __typename?: any } | null): obj is OrderReturnV3 => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderReturnV3"')
      return OrderReturnV3_possibleTypes.includes(obj.__typename)
    }
    


    const OrdersAggregation_possibleTypes: string[] = ['OrdersAggregation']
    export const isOrdersAggregation = (obj?: { __typename?: any } | null): obj is OrdersAggregation => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrdersAggregation"')
      return OrdersAggregation_possibleTypes.includes(obj.__typename)
    }
    


    const OrdersAgingAggregation_possibleTypes: string[] = ['OrdersAgingAggregation']
    export const isOrdersAgingAggregation = (obj?: { __typename?: any } | null): obj is OrdersAgingAggregation => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrdersAgingAggregation"')
      return OrdersAgingAggregation_possibleTypes.includes(obj.__typename)
    }
    


    const OrdersByIdsResponse_possibleTypes: string[] = ['OrdersByIdsResponse']
    export const isOrdersByIdsResponse = (obj?: { __typename?: any } | null): obj is OrdersByIdsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrdersByIdsResponse"')
      return OrdersByIdsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const OrderSettings_possibleTypes: string[] = ['OrderSettings']
    export const isOrderSettings = (obj?: { __typename?: any } | null): obj is OrderSettings => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderSettings"')
      return OrderSettings_possibleTypes.includes(obj.__typename)
    }
    


    const OrderSettingsResponse_possibleTypes: string[] = ['OrderSettingsResponse']
    export const isOrderSettingsResponse = (obj?: { __typename?: any } | null): obj is OrderSettingsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderSettingsResponse"')
      return OrderSettingsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const OrdersResult_possibleTypes: string[] = ['OrdersResult']
    export const isOrdersResult = (obj?: { __typename?: any } | null): obj is OrdersResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrdersResult"')
      return OrdersResult_possibleTypes.includes(obj.__typename)
    }
    


    const OrdersSettings_possibleTypes: string[] = ['OrdersSettings']
    export const isOrdersSettings = (obj?: { __typename?: any } | null): obj is OrdersSettings => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrdersSettings"')
      return OrdersSettings_possibleTypes.includes(obj.__typename)
    }
    


    const OrderStatusWithOverride_possibleTypes: string[] = ['OrderStatusWithOverride']
    export const isOrderStatusWithOverride = (obj?: { __typename?: any } | null): obj is OrderStatusWithOverride => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderStatusWithOverride"')
      return OrderStatusWithOverride_possibleTypes.includes(obj.__typename)
    }
    


    const OrderStatusWithOverrideV3_possibleTypes: string[] = ['OrderStatusWithOverrideV3']
    export const isOrderStatusWithOverrideV3 = (obj?: { __typename?: any } | null): obj is OrderStatusWithOverrideV3 => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderStatusWithOverrideV3"')
      return OrderStatusWithOverrideV3_possibleTypes.includes(obj.__typename)
    }
    


    const OrdersYearEndBalances_possibleTypes: string[] = ['OrdersYearEndBalances']
    export const isOrdersYearEndBalances = (obj?: { __typename?: any } | null): obj is OrdersYearEndBalances => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrdersYearEndBalances"')
      return OrdersYearEndBalances_possibleTypes.includes(obj.__typename)
    }
    


    const OrdersYearEndResponse_possibleTypes: string[] = ['OrdersYearEndResponse']
    export const isOrdersYearEndResponse = (obj?: { __typename?: any } | null): obj is OrdersYearEndResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrdersYearEndResponse"')
      return OrdersYearEndResponse_possibleTypes.includes(obj.__typename)
    }
    


    const OrderTag_possibleTypes: string[] = ['OrderTag']
    export const isOrderTag = (obj?: { __typename?: any } | null): obj is OrderTag => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderTag"')
      return OrderTag_possibleTypes.includes(obj.__typename)
    }
    


    const OrderTimestamps_possibleTypes: string[] = ['OrderTimestamps']
    export const isOrderTimestamps = (obj?: { __typename?: any } | null): obj is OrderTimestamps => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderTimestamps"')
      return OrderTimestamps_possibleTypes.includes(obj.__typename)
    }
    


    const OrderTotals_possibleTypes: string[] = ['OrderTotals']
    export const isOrderTotals = (obj?: { __typename?: any } | null): obj is OrderTotals => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderTotals"')
      return OrderTotals_possibleTypes.includes(obj.__typename)
    }
    


    const OrderTotalSummary_possibleTypes: string[] = ['OrderTotalSummary']
    export const isOrderTotalSummary = (obj?: { __typename?: any } | null): obj is OrderTotalSummary => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderTotalSummary"')
      return OrderTotalSummary_possibleTypes.includes(obj.__typename)
    }
    


    const OrderTransactionMatchV2_possibleTypes: string[] = ['OrderTransactionMatchV2']
    export const isOrderTransactionMatchV2 = (obj?: { __typename?: any } | null): obj is OrderTransactionMatchV2 => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderTransactionMatchV2"')
      return OrderTransactionMatchV2_possibleTypes.includes(obj.__typename)
    }
    


    const OrderTransactionV2_possibleTypes: string[] = ['OrderTransactionV2']
    export const isOrderTransactionV2 = (obj?: { __typename?: any } | null): obj is OrderTransactionV2 => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderTransactionV2"')
      return OrderTransactionV2_possibleTypes.includes(obj.__typename)
    }
    


    const OrderTransactionV3_possibleTypes: string[] = ['OrderTransactionV3']
    export const isOrderTransactionV3 = (obj?: { __typename?: any } | null): obj is OrderTransactionV3 => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderTransactionV3"')
      return OrderTransactionV3_possibleTypes.includes(obj.__typename)
    }
    


    const OrderV2_possibleTypes: string[] = ['OrderV2']
    export const isOrderV2 = (obj?: { __typename?: any } | null): obj is OrderV2 => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderV2"')
      return OrderV2_possibleTypes.includes(obj.__typename)
    }
    


    const OrderV2NotFound_possibleTypes: string[] = ['OrderV2NotFound']
    export const isOrderV2NotFound = (obj?: { __typename?: any } | null): obj is OrderV2NotFound => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderV2NotFound"')
      return OrderV2NotFound_possibleTypes.includes(obj.__typename)
    }
    


    const OrderV2Result_possibleTypes: string[] = ['OrderV2','OrderV2NotFound']
    export const isOrderV2Result = (obj?: { __typename?: any } | null): obj is OrderV2Result => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderV2Result"')
      return OrderV2Result_possibleTypes.includes(obj.__typename)
    }
    


    const OrderV3_possibleTypes: string[] = ['OrderV3']
    export const isOrderV3 = (obj?: { __typename?: any } | null): obj is OrderV3 => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderV3"')
      return OrderV3_possibleTypes.includes(obj.__typename)
    }
    


    const OrderV3NotFound_possibleTypes: string[] = ['OrderV3NotFound']
    export const isOrderV3NotFound = (obj?: { __typename?: any } | null): obj is OrderV3NotFound => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderV3NotFound"')
      return OrderV3NotFound_possibleTypes.includes(obj.__typename)
    }
    


    const OtherFbaAction_possibleTypes: string[] = ['OtherFbaAction']
    export const isOtherFbaAction = (obj?: { __typename?: any } | null): obj is OtherFbaAction => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOtherFbaAction"')
      return OtherFbaAction_possibleTypes.includes(obj.__typename)
    }
    


    const OtherFbaCogs_possibleTypes: string[] = ['OtherFbaCogs']
    export const isOtherFbaCogs = (obj?: { __typename?: any } | null): obj is OtherFbaCogs => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOtherFbaCogs"')
      return OtherFbaCogs_possibleTypes.includes(obj.__typename)
    }
    


    const OtherFbaDailyBreakdown_possibleTypes: string[] = ['OtherFbaDailyBreakdown']
    export const isOtherFbaDailyBreakdown = (obj?: { __typename?: any } | null): obj is OtherFbaDailyBreakdown => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOtherFbaDailyBreakdown"')
      return OtherFbaDailyBreakdown_possibleTypes.includes(obj.__typename)
    }
    


    const OtherFbaMonthlyBreakdown_possibleTypes: string[] = ['OtherFbaMonthlyBreakdown']
    export const isOtherFbaMonthlyBreakdown = (obj?: { __typename?: any } | null): obj is OtherFbaMonthlyBreakdown => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOtherFbaMonthlyBreakdown"')
      return OtherFbaMonthlyBreakdown_possibleTypes.includes(obj.__typename)
    }
    


    const OverrideOrderFulfillmentsError_possibleTypes: string[] = ['OverrideOrderFulfillmentsErrorInvalidLineItem','OverrideOrderFulfillmentsErrorInvalidOrder','OverrideOrderFulfillmentsErrorInvalidWarehouse','OverrideOrderFulfillmentsErrorInvalidQuantity','OverrideOrderFulfillmentsErrorQuantityDiscrepancy','OverrideOrderFulfillmentsErrorInvalidFulfillmentWarehouse','OverrideOrderFulfillmentsErrorInvalidFulfillmentDate','OverrideOrderFulfillmentsErrorLockedFulfillmentDate','OverrideOrderFulfillmentsErrorMissingOverride','OverrideOrderFulfillmentsErrorMisc']
    export const isOverrideOrderFulfillmentsError = (obj?: { __typename?: any } | null): obj is OverrideOrderFulfillmentsError => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOverrideOrderFulfillmentsError"')
      return OverrideOrderFulfillmentsError_possibleTypes.includes(obj.__typename)
    }
    


    const OverrideOrderFulfillmentsErrorInvalidFulfillmentDate_possibleTypes: string[] = ['OverrideOrderFulfillmentsErrorInvalidFulfillmentDate']
    export const isOverrideOrderFulfillmentsErrorInvalidFulfillmentDate = (obj?: { __typename?: any } | null): obj is OverrideOrderFulfillmentsErrorInvalidFulfillmentDate => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOverrideOrderFulfillmentsErrorInvalidFulfillmentDate"')
      return OverrideOrderFulfillmentsErrorInvalidFulfillmentDate_possibleTypes.includes(obj.__typename)
    }
    


    const OverrideOrderFulfillmentsErrorInvalidFulfillmentWarehouse_possibleTypes: string[] = ['OverrideOrderFulfillmentsErrorInvalidFulfillmentWarehouse']
    export const isOverrideOrderFulfillmentsErrorInvalidFulfillmentWarehouse = (obj?: { __typename?: any } | null): obj is OverrideOrderFulfillmentsErrorInvalidFulfillmentWarehouse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOverrideOrderFulfillmentsErrorInvalidFulfillmentWarehouse"')
      return OverrideOrderFulfillmentsErrorInvalidFulfillmentWarehouse_possibleTypes.includes(obj.__typename)
    }
    


    const OverrideOrderFulfillmentsErrorInvalidLineItem_possibleTypes: string[] = ['OverrideOrderFulfillmentsErrorInvalidLineItem']
    export const isOverrideOrderFulfillmentsErrorInvalidLineItem = (obj?: { __typename?: any } | null): obj is OverrideOrderFulfillmentsErrorInvalidLineItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOverrideOrderFulfillmentsErrorInvalidLineItem"')
      return OverrideOrderFulfillmentsErrorInvalidLineItem_possibleTypes.includes(obj.__typename)
    }
    


    const OverrideOrderFulfillmentsErrorInvalidOrder_possibleTypes: string[] = ['OverrideOrderFulfillmentsErrorInvalidOrder']
    export const isOverrideOrderFulfillmentsErrorInvalidOrder = (obj?: { __typename?: any } | null): obj is OverrideOrderFulfillmentsErrorInvalidOrder => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOverrideOrderFulfillmentsErrorInvalidOrder"')
      return OverrideOrderFulfillmentsErrorInvalidOrder_possibleTypes.includes(obj.__typename)
    }
    


    const OverrideOrderFulfillmentsErrorInvalidQuantity_possibleTypes: string[] = ['OverrideOrderFulfillmentsErrorInvalidQuantity']
    export const isOverrideOrderFulfillmentsErrorInvalidQuantity = (obj?: { __typename?: any } | null): obj is OverrideOrderFulfillmentsErrorInvalidQuantity => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOverrideOrderFulfillmentsErrorInvalidQuantity"')
      return OverrideOrderFulfillmentsErrorInvalidQuantity_possibleTypes.includes(obj.__typename)
    }
    


    const OverrideOrderFulfillmentsErrorInvalidWarehouse_possibleTypes: string[] = ['OverrideOrderFulfillmentsErrorInvalidWarehouse']
    export const isOverrideOrderFulfillmentsErrorInvalidWarehouse = (obj?: { __typename?: any } | null): obj is OverrideOrderFulfillmentsErrorInvalidWarehouse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOverrideOrderFulfillmentsErrorInvalidWarehouse"')
      return OverrideOrderFulfillmentsErrorInvalidWarehouse_possibleTypes.includes(obj.__typename)
    }
    


    const OverrideOrderFulfillmentsErrorLockedFulfillmentDate_possibleTypes: string[] = ['OverrideOrderFulfillmentsErrorLockedFulfillmentDate']
    export const isOverrideOrderFulfillmentsErrorLockedFulfillmentDate = (obj?: { __typename?: any } | null): obj is OverrideOrderFulfillmentsErrorLockedFulfillmentDate => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOverrideOrderFulfillmentsErrorLockedFulfillmentDate"')
      return OverrideOrderFulfillmentsErrorLockedFulfillmentDate_possibleTypes.includes(obj.__typename)
    }
    


    const OverrideOrderFulfillmentsErrorMisc_possibleTypes: string[] = ['OverrideOrderFulfillmentsErrorMisc']
    export const isOverrideOrderFulfillmentsErrorMisc = (obj?: { __typename?: any } | null): obj is OverrideOrderFulfillmentsErrorMisc => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOverrideOrderFulfillmentsErrorMisc"')
      return OverrideOrderFulfillmentsErrorMisc_possibleTypes.includes(obj.__typename)
    }
    


    const OverrideOrderFulfillmentsErrorMissingOverride_possibleTypes: string[] = ['OverrideOrderFulfillmentsErrorMissingOverride']
    export const isOverrideOrderFulfillmentsErrorMissingOverride = (obj?: { __typename?: any } | null): obj is OverrideOrderFulfillmentsErrorMissingOverride => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOverrideOrderFulfillmentsErrorMissingOverride"')
      return OverrideOrderFulfillmentsErrorMissingOverride_possibleTypes.includes(obj.__typename)
    }
    


    const OverrideOrderFulfillmentsErrorQuantityDiscrepancy_possibleTypes: string[] = ['OverrideOrderFulfillmentsErrorQuantityDiscrepancy']
    export const isOverrideOrderFulfillmentsErrorQuantityDiscrepancy = (obj?: { __typename?: any } | null): obj is OverrideOrderFulfillmentsErrorQuantityDiscrepancy => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOverrideOrderFulfillmentsErrorQuantityDiscrepancy"')
      return OverrideOrderFulfillmentsErrorQuantityDiscrepancy_possibleTypes.includes(obj.__typename)
    }
    


    const OverrideOrderFulfillmentsOrderResponse_possibleTypes: string[] = ['OverrideOrderFulfillmentsOrderResponse']
    export const isOverrideOrderFulfillmentsOrderResponse = (obj?: { __typename?: any } | null): obj is OverrideOrderFulfillmentsOrderResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOverrideOrderFulfillmentsOrderResponse"')
      return OverrideOrderFulfillmentsOrderResponse_possibleTypes.includes(obj.__typename)
    }
    


    const OverrideOrderFulfillmentsResponse_possibleTypes: string[] = ['OverrideOrderFulfillmentsResponse']
    export const isOverrideOrderFulfillmentsResponse = (obj?: { __typename?: any } | null): obj is OverrideOrderFulfillmentsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOverrideOrderFulfillmentsResponse"')
      return OverrideOrderFulfillmentsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const OverviewCycle_possibleTypes: string[] = ['OverviewCycle']
    export const isOverviewCycle = (obj?: { __typename?: any } | null): obj is OverviewCycle => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOverviewCycle"')
      return OverviewCycle_possibleTypes.includes(obj.__typename)
    }
    


    const PairedEntity_possibleTypes: string[] = ['Bill','Payout','Topup','BankTransaction','CompanyAffiliate']
    export const isPairedEntity = (obj?: { __typename?: any } | null): obj is PairedEntity => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPairedEntity"')
      return PairedEntity_possibleTypes.includes(obj.__typename)
    }
    


    const Payment_possibleTypes: string[] = ['Payment']
    export const isPayment = (obj?: { __typename?: any } | null): obj is Payment => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPayment"')
      return Payment_possibleTypes.includes(obj.__typename)
    }
    


    const PaymentCheck_possibleTypes: string[] = ['PaymentCheck']
    export const isPaymentCheck = (obj?: { __typename?: any } | null): obj is PaymentCheck => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPaymentCheck"')
      return PaymentCheck_possibleTypes.includes(obj.__typename)
    }
    


    const PaymentDetails_possibleTypes: string[] = ['PaymentDetails']
    export const isPaymentDetails = (obj?: { __typename?: any } | null): obj is PaymentDetails => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPaymentDetails"')
      return PaymentDetails_possibleTypes.includes(obj.__typename)
    }
    


    const PaymentFee_possibleTypes: string[] = ['PaymentFee']
    export const isPaymentFee = (obj?: { __typename?: any } | null): obj is PaymentFee => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPaymentFee"')
      return PaymentFee_possibleTypes.includes(obj.__typename)
    }
    


    const PaymentGroup_possibleTypes: string[] = ['PaymentGroup']
    export const isPaymentGroup = (obj?: { __typename?: any } | null): obj is PaymentGroup => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPaymentGroup"')
      return PaymentGroup_possibleTypes.includes(obj.__typename)
    }
    


    const PaymentGroupExpense_possibleTypes: string[] = ['PaymentGroupExpense']
    export const isPaymentGroupExpense = (obj?: { __typename?: any } | null): obj is PaymentGroupExpense => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPaymentGroupExpense"')
      return PaymentGroupExpense_possibleTypes.includes(obj.__typename)
    }
    


    const PaymentGroupLink_possibleTypes: string[] = ['PaymentGroupLink']
    export const isPaymentGroupLink = (obj?: { __typename?: any } | null): obj is PaymentGroupLink => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPaymentGroupLink"')
      return PaymentGroupLink_possibleTypes.includes(obj.__typename)
    }
    


    const PaymentGroupLinkedBankTransaction_possibleTypes: string[] = ['PaymentGroupLinkedBankTransaction']
    export const isPaymentGroupLinkedBankTransaction = (obj?: { __typename?: any } | null): obj is PaymentGroupLinkedBankTransaction => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPaymentGroupLinkedBankTransaction"')
      return PaymentGroupLinkedBankTransaction_possibleTypes.includes(obj.__typename)
    }
    


    const PaymentGroupLinkedInventoryPurchases_possibleTypes: string[] = ['PaymentGroupLinkedInventoryPurchases']
    export const isPaymentGroupLinkedInventoryPurchases = (obj?: { __typename?: any } | null): obj is PaymentGroupLinkedInventoryPurchases => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPaymentGroupLinkedInventoryPurchases"')
      return PaymentGroupLinkedInventoryPurchases_possibleTypes.includes(obj.__typename)
    }
    


    const PaymentGroupLinkedInvoice_possibleTypes: string[] = ['PaymentGroupLinkedInvoice']
    export const isPaymentGroupLinkedInvoice = (obj?: { __typename?: any } | null): obj is PaymentGroupLinkedInvoice => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPaymentGroupLinkedInvoice"')
      return PaymentGroupLinkedInvoice_possibleTypes.includes(obj.__typename)
    }
    


    const PaymentGroupLinkedManualAssembly_possibleTypes: string[] = ['PaymentGroupLinkedManualAssembly']
    export const isPaymentGroupLinkedManualAssembly = (obj?: { __typename?: any } | null): obj is PaymentGroupLinkedManualAssembly => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPaymentGroupLinkedManualAssembly"')
      return PaymentGroupLinkedManualAssembly_possibleTypes.includes(obj.__typename)
    }
    


    const PaymentGroupLinkedOnDemandAssemblyVendorCost_possibleTypes: string[] = ['PaymentGroupLinkedOnDemandAssemblyVendorCost']
    export const isPaymentGroupLinkedOnDemandAssemblyVendorCost = (obj?: { __typename?: any } | null): obj is PaymentGroupLinkedOnDemandAssemblyVendorCost => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPaymentGroupLinkedOnDemandAssemblyVendorCost"')
      return PaymentGroupLinkedOnDemandAssemblyVendorCost_possibleTypes.includes(obj.__typename)
    }
    


    const PaymentGroupLinkedOrder_possibleTypes: string[] = ['PaymentGroupLinkedOrder']
    export const isPaymentGroupLinkedOrder = (obj?: { __typename?: any } | null): obj is PaymentGroupLinkedOrder => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPaymentGroupLinkedOrder"')
      return PaymentGroupLinkedOrder_possibleTypes.includes(obj.__typename)
    }
    


    const PaymentGroupLinkedPurchaseOrder_possibleTypes: string[] = ['PaymentGroupLinkedPurchaseOrder']
    export const isPaymentGroupLinkedPurchaseOrder = (obj?: { __typename?: any } | null): obj is PaymentGroupLinkedPurchaseOrder => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPaymentGroupLinkedPurchaseOrder"')
      return PaymentGroupLinkedPurchaseOrder_possibleTypes.includes(obj.__typename)
    }
    


    const PaymentGroupLinkedWarehouseTransfer_possibleTypes: string[] = ['PaymentGroupLinkedWarehouseTransfer']
    export const isPaymentGroupLinkedWarehouseTransfer = (obj?: { __typename?: any } | null): obj is PaymentGroupLinkedWarehouseTransfer => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPaymentGroupLinkedWarehouseTransfer"')
      return PaymentGroupLinkedWarehouseTransfer_possibleTypes.includes(obj.__typename)
    }
    


    const PaymentGroupLinksForInvoiceResponse_possibleTypes: string[] = ['PaymentGroupLinksForInvoiceResponse']
    export const isPaymentGroupLinksForInvoiceResponse = (obj?: { __typename?: any } | null): obj is PaymentGroupLinksForInvoiceResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPaymentGroupLinksForInvoiceResponse"')
      return PaymentGroupLinksForInvoiceResponse_possibleTypes.includes(obj.__typename)
    }
    


    const PaymentGroupLinksResponse_possibleTypes: string[] = ['PaymentGroupLinksResponse']
    export const isPaymentGroupLinksResponse = (obj?: { __typename?: any } | null): obj is PaymentGroupLinksResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPaymentGroupLinksResponse"')
      return PaymentGroupLinksResponse_possibleTypes.includes(obj.__typename)
    }
    


    const PaymentGroupsByIdsResponse_possibleTypes: string[] = ['PaymentGroupsByIdsResponse']
    export const isPaymentGroupsByIdsResponse = (obj?: { __typename?: any } | null): obj is PaymentGroupsByIdsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPaymentGroupsByIdsResponse"')
      return PaymentGroupsByIdsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const PaymentGroupsTotalUnclearedBalanceResponse_possibleTypes: string[] = ['PaymentGroupsTotalUnclearedBalanceResponse']
    export const isPaymentGroupsTotalUnclearedBalanceResponse = (obj?: { __typename?: any } | null): obj is PaymentGroupsTotalUnclearedBalanceResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPaymentGroupsTotalUnclearedBalanceResponse"')
      return PaymentGroupsTotalUnclearedBalanceResponse_possibleTypes.includes(obj.__typename)
    }
    


    const PaymentGroupTransaction_possibleTypes: string[] = ['PaymentGroupTransaction']
    export const isPaymentGroupTransaction = (obj?: { __typename?: any } | null): obj is PaymentGroupTransaction => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPaymentGroupTransaction"')
      return PaymentGroupTransaction_possibleTypes.includes(obj.__typename)
    }
    


    const PaymentMethod_possibleTypes: string[] = ['PaymentMethod']
    export const isPaymentMethod = (obj?: { __typename?: any } | null): obj is PaymentMethod => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPaymentMethod"')
      return PaymentMethod_possibleTypes.includes(obj.__typename)
    }
    


    const PaymentProcessorByCompanyAndVendorResponse_possibleTypes: string[] = ['PaymentProcessorByCompanyAndVendorResponse']
    export const isPaymentProcessorByCompanyAndVendorResponse = (obj?: { __typename?: any } | null): obj is PaymentProcessorByCompanyAndVendorResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPaymentProcessorByCompanyAndVendorResponse"')
      return PaymentProcessorByCompanyAndVendorResponse_possibleTypes.includes(obj.__typename)
    }
    


    const Payout_possibleTypes: string[] = ['Payout']
    export const isPayout = (obj?: { __typename?: any } | null): obj is Payout => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPayout"')
      return Payout_possibleTypes.includes(obj.__typename)
    }
    


    const Payroll_possibleTypes: string[] = ['Payroll']
    export const isPayroll = (obj?: { __typename?: any } | null): obj is Payroll => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPayroll"')
      return Payroll_possibleTypes.includes(obj.__typename)
    }
    


    const PayrollCategoryMapping_possibleTypes: string[] = ['PayrollDepartmentCategoryMapping','PayrollEmployeeCategoryMapping','PayrollContractorCategoryMapping']
    export const isPayrollCategoryMapping = (obj?: { __typename?: any } | null): obj is PayrollCategoryMapping => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPayrollCategoryMapping"')
      return PayrollCategoryMapping_possibleTypes.includes(obj.__typename)
    }
    


    const PayrollConnection_possibleTypes: string[] = ['PayrollConnection']
    export const isPayrollConnection = (obj?: { __typename?: any } | null): obj is PayrollConnection => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPayrollConnection"')
      return PayrollConnection_possibleTypes.includes(obj.__typename)
    }
    


    const PayrollConnectionImportStatus_possibleTypes: string[] = ['PayrollConnectionImportStatus']
    export const isPayrollConnectionImportStatus = (obj?: { __typename?: any } | null): obj is PayrollConnectionImportStatus => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPayrollConnectionImportStatus"')
      return PayrollConnectionImportStatus_possibleTypes.includes(obj.__typename)
    }
    


    const PayrollConnectionImportStatusData_possibleTypes: string[] = ['PayrollConnectionImportStatusData']
    export const isPayrollConnectionImportStatusData = (obj?: { __typename?: any } | null): obj is PayrollConnectionImportStatusData => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPayrollConnectionImportStatusData"')
      return PayrollConnectionImportStatusData_possibleTypes.includes(obj.__typename)
    }
    


    const PayrollContractorCategoryMapping_possibleTypes: string[] = ['PayrollContractorCategoryMapping']
    export const isPayrollContractorCategoryMapping = (obj?: { __typename?: any } | null): obj is PayrollContractorCategoryMapping => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPayrollContractorCategoryMapping"')
      return PayrollContractorCategoryMapping_possibleTypes.includes(obj.__typename)
    }
    


    const PayrollDailyAggregate_possibleTypes: string[] = ['PayrollDailyAggregate']
    export const isPayrollDailyAggregate = (obj?: { __typename?: any } | null): obj is PayrollDailyAggregate => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPayrollDailyAggregate"')
      return PayrollDailyAggregate_possibleTypes.includes(obj.__typename)
    }
    


    const PayrollData_possibleTypes: string[] = ['PayrollData']
    export const isPayrollData = (obj?: { __typename?: any } | null): obj is PayrollData => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPayrollData"')
      return PayrollData_possibleTypes.includes(obj.__typename)
    }
    


    const PayrollDepartmentCategoryMapping_possibleTypes: string[] = ['PayrollDepartmentCategoryMapping']
    export const isPayrollDepartmentCategoryMapping = (obj?: { __typename?: any } | null): obj is PayrollDepartmentCategoryMapping => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPayrollDepartmentCategoryMapping"')
      return PayrollDepartmentCategoryMapping_possibleTypes.includes(obj.__typename)
    }
    


    const PayrollEmployeeCategoryMapping_possibleTypes: string[] = ['PayrollEmployeeCategoryMapping']
    export const isPayrollEmployeeCategoryMapping = (obj?: { __typename?: any } | null): obj is PayrollEmployeeCategoryMapping => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPayrollEmployeeCategoryMapping"')
      return PayrollEmployeeCategoryMapping_possibleTypes.includes(obj.__typename)
    }
    


    const PayrollIdsByCompanyItem_possibleTypes: string[] = ['PayrollIdsByCompanyItem']
    export const isPayrollIdsByCompanyItem = (obj?: { __typename?: any } | null): obj is PayrollIdsByCompanyItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPayrollIdsByCompanyItem"')
      return PayrollIdsByCompanyItem_possibleTypes.includes(obj.__typename)
    }
    


    const PayrollIdsByCompanyResponse_possibleTypes: string[] = ['PayrollIdsByCompanyResponse']
    export const isPayrollIdsByCompanyResponse = (obj?: { __typename?: any } | null): obj is PayrollIdsByCompanyResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPayrollIdsByCompanyResponse"')
      return PayrollIdsByCompanyResponse_possibleTypes.includes(obj.__typename)
    }
    


    const PayrollIntegrationTransfer_possibleTypes: string[] = ['PayrollIntegrationTransfer']
    export const isPayrollIntegrationTransfer = (obj?: { __typename?: any } | null): obj is PayrollIntegrationTransfer => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPayrollIntegrationTransfer"')
      return PayrollIntegrationTransfer_possibleTypes.includes(obj.__typename)
    }
    


    const PayrollSettings_possibleTypes: string[] = ['PayrollSettings']
    export const isPayrollSettings = (obj?: { __typename?: any } | null): obj is PayrollSettings => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPayrollSettings"')
      return PayrollSettings_possibleTypes.includes(obj.__typename)
    }
    


    const PendingAdjustmentsExcludeListItem_possibleTypes: string[] = ['PendingAdjustmentsExcludeListItem']
    export const isPendingAdjustmentsExcludeListItem = (obj?: { __typename?: any } | null): obj is PendingAdjustmentsExcludeListItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPendingAdjustmentsExcludeListItem"')
      return PendingAdjustmentsExcludeListItem_possibleTypes.includes(obj.__typename)
    }
    


    const PendingAdjustmentsOverviewResponse_possibleTypes: string[] = ['PendingAdjustmentsOverviewResponse']
    export const isPendingAdjustmentsOverviewResponse = (obj?: { __typename?: any } | null): obj is PendingAdjustmentsOverviewResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPendingAdjustmentsOverviewResponse"')
      return PendingAdjustmentsOverviewResponse_possibleTypes.includes(obj.__typename)
    }
    


    const PendingDeadInventoryAdjustments_possibleTypes: string[] = ['PendingDeadInventoryAdjustments']
    export const isPendingDeadInventoryAdjustments = (obj?: { __typename?: any } | null): obj is PendingDeadInventoryAdjustments => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPendingDeadInventoryAdjustments"')
      return PendingDeadInventoryAdjustments_possibleTypes.includes(obj.__typename)
    }
    


    const PendingDeadInventoryAdjustmentsByIdsResponse_possibleTypes: string[] = ['PendingDeadInventoryAdjustmentsByIdsResponse']
    export const isPendingDeadInventoryAdjustmentsByIdsResponse = (obj?: { __typename?: any } | null): obj is PendingDeadInventoryAdjustmentsByIdsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPendingDeadInventoryAdjustmentsByIdsResponse"')
      return PendingDeadInventoryAdjustmentsByIdsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const PendingDeadInventoryAdjustmentsItem_possibleTypes: string[] = ['PendingDeadInventoryAdjustmentsItem']
    export const isPendingDeadInventoryAdjustmentsItem = (obj?: { __typename?: any } | null): obj is PendingDeadInventoryAdjustmentsItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPendingDeadInventoryAdjustmentsItem"')
      return PendingDeadInventoryAdjustmentsItem_possibleTypes.includes(obj.__typename)
    }
    


    const PendingDeadInventoryAdjustmentsResponse_possibleTypes: string[] = ['PendingDeadInventoryAdjustmentsResponse']
    export const isPendingDeadInventoryAdjustmentsResponse = (obj?: { __typename?: any } | null): obj is PendingDeadInventoryAdjustmentsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPendingDeadInventoryAdjustmentsResponse"')
      return PendingDeadInventoryAdjustmentsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const PendingDonationAdjustments_possibleTypes: string[] = ['PendingDonationAdjustments']
    export const isPendingDonationAdjustments = (obj?: { __typename?: any } | null): obj is PendingDonationAdjustments => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPendingDonationAdjustments"')
      return PendingDonationAdjustments_possibleTypes.includes(obj.__typename)
    }
    


    const PendingDonationAdjustmentsByIdsResponse_possibleTypes: string[] = ['PendingDonationAdjustmentsByIdsResponse']
    export const isPendingDonationAdjustmentsByIdsResponse = (obj?: { __typename?: any } | null): obj is PendingDonationAdjustmentsByIdsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPendingDonationAdjustmentsByIdsResponse"')
      return PendingDonationAdjustmentsByIdsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const PendingDonationAdjustmentsItem_possibleTypes: string[] = ['PendingDonationAdjustmentsItem']
    export const isPendingDonationAdjustmentsItem = (obj?: { __typename?: any } | null): obj is PendingDonationAdjustmentsItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPendingDonationAdjustmentsItem"')
      return PendingDonationAdjustmentsItem_possibleTypes.includes(obj.__typename)
    }
    


    const PendingDonationAdjustmentsResponse_possibleTypes: string[] = ['PendingDonationAdjustmentsResponse']
    export const isPendingDonationAdjustmentsResponse = (obj?: { __typename?: any } | null): obj is PendingDonationAdjustmentsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPendingDonationAdjustmentsResponse"')
      return PendingDonationAdjustmentsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const PendingGiveawayAdjustments_possibleTypes: string[] = ['PendingGiveawayAdjustments']
    export const isPendingGiveawayAdjustments = (obj?: { __typename?: any } | null): obj is PendingGiveawayAdjustments => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPendingGiveawayAdjustments"')
      return PendingGiveawayAdjustments_possibleTypes.includes(obj.__typename)
    }
    


    const PendingGiveawayAdjustmentsByIdsResponse_possibleTypes: string[] = ['PendingGiveawayAdjustmentsByIdsResponse']
    export const isPendingGiveawayAdjustmentsByIdsResponse = (obj?: { __typename?: any } | null): obj is PendingGiveawayAdjustmentsByIdsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPendingGiveawayAdjustmentsByIdsResponse"')
      return PendingGiveawayAdjustmentsByIdsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const PendingGiveawayAdjustmentsItem_possibleTypes: string[] = ['PendingGiveawayAdjustmentsItem']
    export const isPendingGiveawayAdjustmentsItem = (obj?: { __typename?: any } | null): obj is PendingGiveawayAdjustmentsItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPendingGiveawayAdjustmentsItem"')
      return PendingGiveawayAdjustmentsItem_possibleTypes.includes(obj.__typename)
    }
    


    const PendingGiveawayAdjustmentsResponse_possibleTypes: string[] = ['PendingGiveawayAdjustmentsResponse']
    export const isPendingGiveawayAdjustmentsResponse = (obj?: { __typename?: any } | null): obj is PendingGiveawayAdjustmentsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPendingGiveawayAdjustmentsResponse"')
      return PendingGiveawayAdjustmentsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const PendingGiveawayDropshippingAdjustments_possibleTypes: string[] = ['PendingGiveawayDropshippingAdjustments']
    export const isPendingGiveawayDropshippingAdjustments = (obj?: { __typename?: any } | null): obj is PendingGiveawayDropshippingAdjustments => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPendingGiveawayDropshippingAdjustments"')
      return PendingGiveawayDropshippingAdjustments_possibleTypes.includes(obj.__typename)
    }
    


    const PendingGiveawayDropshippingAdjustmentsByIdsResponse_possibleTypes: string[] = ['PendingGiveawayDropshippingAdjustmentsByIdsResponse']
    export const isPendingGiveawayDropshippingAdjustmentsByIdsResponse = (obj?: { __typename?: any } | null): obj is PendingGiveawayDropshippingAdjustmentsByIdsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPendingGiveawayDropshippingAdjustmentsByIdsResponse"')
      return PendingGiveawayDropshippingAdjustmentsByIdsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const PendingGiveawayDropshippingAdjustmentsItem_possibleTypes: string[] = ['PendingGiveawayDropshippingAdjustmentsItem']
    export const isPendingGiveawayDropshippingAdjustmentsItem = (obj?: { __typename?: any } | null): obj is PendingGiveawayDropshippingAdjustmentsItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPendingGiveawayDropshippingAdjustmentsItem"')
      return PendingGiveawayDropshippingAdjustmentsItem_possibleTypes.includes(obj.__typename)
    }
    


    const PendingGiveawayDropshippingAdjustmentsResponse_possibleTypes: string[] = ['PendingGiveawayDropshippingAdjustmentsResponse']
    export const isPendingGiveawayDropshippingAdjustmentsResponse = (obj?: { __typename?: any } | null): obj is PendingGiveawayDropshippingAdjustmentsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPendingGiveawayDropshippingAdjustmentsResponse"')
      return PendingGiveawayDropshippingAdjustmentsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const PendingSalesDataAdjustments_possibleTypes: string[] = ['PendingSalesDataAdjustments']
    export const isPendingSalesDataAdjustments = (obj?: { __typename?: any } | null): obj is PendingSalesDataAdjustments => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPendingSalesDataAdjustments"')
      return PendingSalesDataAdjustments_possibleTypes.includes(obj.__typename)
    }
    


    const PendingSalesDataAdjustmentsByIdsResponse_possibleTypes: string[] = ['PendingSalesDataAdjustmentsByIdsResponse']
    export const isPendingSalesDataAdjustmentsByIdsResponse = (obj?: { __typename?: any } | null): obj is PendingSalesDataAdjustmentsByIdsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPendingSalesDataAdjustmentsByIdsResponse"')
      return PendingSalesDataAdjustmentsByIdsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const PendingSalesDataAdjustmentsItem_possibleTypes: string[] = ['PendingSalesDataAdjustmentsItem']
    export const isPendingSalesDataAdjustmentsItem = (obj?: { __typename?: any } | null): obj is PendingSalesDataAdjustmentsItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPendingSalesDataAdjustmentsItem"')
      return PendingSalesDataAdjustmentsItem_possibleTypes.includes(obj.__typename)
    }
    


    const PendingSalesDataAdjustmentsOverviewResponse_possibleTypes: string[] = ['PendingSalesDataAdjustmentsOverviewResponse']
    export const isPendingSalesDataAdjustmentsOverviewResponse = (obj?: { __typename?: any } | null): obj is PendingSalesDataAdjustmentsOverviewResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPendingSalesDataAdjustmentsOverviewResponse"')
      return PendingSalesDataAdjustmentsOverviewResponse_possibleTypes.includes(obj.__typename)
    }
    


    const PendingSalesDataAdjustmentsResponse_possibleTypes: string[] = ['PendingSalesDataAdjustmentsResponse']
    export const isPendingSalesDataAdjustmentsResponse = (obj?: { __typename?: any } | null): obj is PendingSalesDataAdjustmentsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPendingSalesDataAdjustmentsResponse"')
      return PendingSalesDataAdjustmentsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const PendingWarehouseOpeningBalance_possibleTypes: string[] = ['PendingWarehouseOpeningBalance']
    export const isPendingWarehouseOpeningBalance = (obj?: { __typename?: any } | null): obj is PendingWarehouseOpeningBalance => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPendingWarehouseOpeningBalance"')
      return PendingWarehouseOpeningBalance_possibleTypes.includes(obj.__typename)
    }
    


    const PendingWarehouseOpeningBalanceAttachment_possibleTypes: string[] = ['PendingWarehouseOpeningBalanceAttachment']
    export const isPendingWarehouseOpeningBalanceAttachment = (obj?: { __typename?: any } | null): obj is PendingWarehouseOpeningBalanceAttachment => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPendingWarehouseOpeningBalanceAttachment"')
      return PendingWarehouseOpeningBalanceAttachment_possibleTypes.includes(obj.__typename)
    }
    


    const PendingWarehouseOpeningBalancesAttachmentSummary_possibleTypes: string[] = ['PendingWarehouseOpeningBalancesAttachmentSummary']
    export const isPendingWarehouseOpeningBalancesAttachmentSummary = (obj?: { __typename?: any } | null): obj is PendingWarehouseOpeningBalancesAttachmentSummary => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPendingWarehouseOpeningBalancesAttachmentSummary"')
      return PendingWarehouseOpeningBalancesAttachmentSummary_possibleTypes.includes(obj.__typename)
    }
    


    const PendingWarehouseOpeningBalancesResponse_possibleTypes: string[] = ['PendingWarehouseOpeningBalancesResponse']
    export const isPendingWarehouseOpeningBalancesResponse = (obj?: { __typename?: any } | null): obj is PendingWarehouseOpeningBalancesResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPendingWarehouseOpeningBalancesResponse"')
      return PendingWarehouseOpeningBalancesResponse_possibleTypes.includes(obj.__typename)
    }
    


    const PendingWarehouseOpeningBalancesWithCsvResponse_possibleTypes: string[] = ['PendingWarehouseOpeningBalancesWithCsvResponse']
    export const isPendingWarehouseOpeningBalancesWithCsvResponse = (obj?: { __typename?: any } | null): obj is PendingWarehouseOpeningBalancesWithCsvResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPendingWarehouseOpeningBalancesWithCsvResponse"')
      return PendingWarehouseOpeningBalancesWithCsvResponse_possibleTypes.includes(obj.__typename)
    }
    


    const PeriodicPartnerReport_possibleTypes: string[] = ['PeriodicPartnerReport']
    export const isPeriodicPartnerReport = (obj?: { __typename?: any } | null): obj is PeriodicPartnerReport => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPeriodicPartnerReport"')
      return PeriodicPartnerReport_possibleTypes.includes(obj.__typename)
    }
    


    const Permission_possibleTypes: string[] = ['Permission']
    export const isPermission = (obj?: { __typename?: any } | null): obj is Permission => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPermission"')
      return Permission_possibleTypes.includes(obj.__typename)
    }
    


    const PhysicalCountValidationData_possibleTypes: string[] = ['PhysicalCountValidationData']
    export const isPhysicalCountValidationData = (obj?: { __typename?: any } | null): obj is PhysicalCountValidationData => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPhysicalCountValidationData"')
      return PhysicalCountValidationData_possibleTypes.includes(obj.__typename)
    }
    


    const PhysicalCountValidationItem_possibleTypes: string[] = ['PhysicalCountValidationItem']
    export const isPhysicalCountValidationItem = (obj?: { __typename?: any } | null): obj is PhysicalCountValidationItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPhysicalCountValidationItem"')
      return PhysicalCountValidationItem_possibleTypes.includes(obj.__typename)
    }
    


    const PhysicalCountValidationResponse_possibleTypes: string[] = ['PhysicalCountValidationResponse']
    export const isPhysicalCountValidationResponse = (obj?: { __typename?: any } | null): obj is PhysicalCountValidationResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPhysicalCountValidationResponse"')
      return PhysicalCountValidationResponse_possibleTypes.includes(obj.__typename)
    }
    


    const ProcessBillContentResult_possibleTypes: string[] = ['ProcessBillContentResult']
    export const isProcessBillContentResult = (obj?: { __typename?: any } | null): obj is ProcessBillContentResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProcessBillContentResult"')
      return ProcessBillContentResult_possibleTypes.includes(obj.__typename)
    }
    


    const ProcessLoanAttachmentResult_possibleTypes: string[] = ['ProcessLoanAttachmentResult']
    export const isProcessLoanAttachmentResult = (obj?: { __typename?: any } | null): obj is ProcessLoanAttachmentResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProcessLoanAttachmentResult"')
      return ProcessLoanAttachmentResult_possibleTypes.includes(obj.__typename)
    }
    


    const Product_possibleTypes: string[] = ['AmazonProduct','MergedProduct','ShopifyProduct','TikTokProduct','UserManualProduct','WalmartProduct']
    export const isProduct = (obj?: { __typename?: any } | null): obj is Product => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProduct"')
      return Product_possibleTypes.includes(obj.__typename)
    }
    


    const ProductAnalyticsOverview_possibleTypes: string[] = ['ProductAnalyticsOverview']
    export const isProductAnalyticsOverview = (obj?: { __typename?: any } | null): obj is ProductAnalyticsOverview => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductAnalyticsOverview"')
      return ProductAnalyticsOverview_possibleTypes.includes(obj.__typename)
    }
    


    const ProductAppliedCost_possibleTypes: string[] = ['ProductAppliedCost']
    export const isProductAppliedCost = (obj?: { __typename?: any } | null): obj is ProductAppliedCost => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductAppliedCost"')
      return ProductAppliedCost_possibleTypes.includes(obj.__typename)
    }
    


    const ProductAppliedCostWithDepletedCount_possibleTypes: string[] = ['ProductAppliedCostWithDepletedCount']
    export const isProductAppliedCostWithDepletedCount = (obj?: { __typename?: any } | null): obj is ProductAppliedCostWithDepletedCount => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductAppliedCostWithDepletedCount"')
      return ProductAppliedCostWithDepletedCount_possibleTypes.includes(obj.__typename)
    }
    


    const ProductAssembliesBreakdownResult_possibleTypes: string[] = ['ProductAssembliesBreakdownResult']
    export const isProductAssembliesBreakdownResult = (obj?: { __typename?: any } | null): obj is ProductAssembliesBreakdownResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductAssembliesBreakdownResult"')
      return ProductAssembliesBreakdownResult_possibleTypes.includes(obj.__typename)
    }
    


    const ProductAutomergeMatchGroupSetting_possibleTypes: string[] = ['ProductAutomergeMatchGroupSetting']
    export const isProductAutomergeMatchGroupSetting = (obj?: { __typename?: any } | null): obj is ProductAutomergeMatchGroupSetting => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductAutomergeMatchGroupSetting"')
      return ProductAutomergeMatchGroupSetting_possibleTypes.includes(obj.__typename)
    }
    


    const ProductBulkEditCsvAttachment_possibleTypes: string[] = ['ProductBulkEditCsvAttachment']
    export const isProductBulkEditCsvAttachment = (obj?: { __typename?: any } | null): obj is ProductBulkEditCsvAttachment => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductBulkEditCsvAttachment"')
      return ProductBulkEditCsvAttachment_possibleTypes.includes(obj.__typename)
    }
    


    const ProductBulkEditCsvAttachmentsResponse_possibleTypes: string[] = ['ProductBulkEditCsvAttachmentsResponse']
    export const isProductBulkEditCsvAttachmentsResponse = (obj?: { __typename?: any } | null): obj is ProductBulkEditCsvAttachmentsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductBulkEditCsvAttachmentsResponse"')
      return ProductBulkEditCsvAttachmentsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const ProductBulkEditCsvErrorItem_possibleTypes: string[] = ['ProductBulkEditCsvErrorItem']
    export const isProductBulkEditCsvErrorItem = (obj?: { __typename?: any } | null): obj is ProductBulkEditCsvErrorItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductBulkEditCsvErrorItem"')
      return ProductBulkEditCsvErrorItem_possibleTypes.includes(obj.__typename)
    }
    


    const ProductBulkEditCsvSummary_possibleTypes: string[] = ['ProductBulkEditCsvSummary']
    export const isProductBulkEditCsvSummary = (obj?: { __typename?: any } | null): obj is ProductBulkEditCsvSummary => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductBulkEditCsvSummary"')
      return ProductBulkEditCsvSummary_possibleTypes.includes(obj.__typename)
    }
    


    const ProductBulkEditCsvUploadResponse_possibleTypes: string[] = ['ProductBulkEditCsvUploadResponse']
    export const isProductBulkEditCsvUploadResponse = (obj?: { __typename?: any } | null): obj is ProductBulkEditCsvUploadResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductBulkEditCsvUploadResponse"')
      return ProductBulkEditCsvUploadResponse_possibleTypes.includes(obj.__typename)
    }
    


    const ProductDeadInventoryAdjustment_possibleTypes: string[] = ['ProductDeadInventoryAdjustment']
    export const isProductDeadInventoryAdjustment = (obj?: { __typename?: any } | null): obj is ProductDeadInventoryAdjustment => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductDeadInventoryAdjustment"')
      return ProductDeadInventoryAdjustment_possibleTypes.includes(obj.__typename)
    }
    


    const ProductDeadInventoryAdjustments_possibleTypes: string[] = ['ProductDeadInventoryAdjustments']
    export const isProductDeadInventoryAdjustments = (obj?: { __typename?: any } | null): obj is ProductDeadInventoryAdjustments => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductDeadInventoryAdjustments"')
      return ProductDeadInventoryAdjustments_possibleTypes.includes(obj.__typename)
    }
    


    const ProductDonationAdjustment_possibleTypes: string[] = ['ProductDonationAdjustment']
    export const isProductDonationAdjustment = (obj?: { __typename?: any } | null): obj is ProductDonationAdjustment => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductDonationAdjustment"')
      return ProductDonationAdjustment_possibleTypes.includes(obj.__typename)
    }
    


    const ProductDonationAdjustments_possibleTypes: string[] = ['ProductDonationAdjustments']
    export const isProductDonationAdjustments = (obj?: { __typename?: any } | null): obj is ProductDonationAdjustments => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductDonationAdjustments"')
      return ProductDonationAdjustments_possibleTypes.includes(obj.__typename)
    }
    


    const ProductGiveawayAdjustment_possibleTypes: string[] = ['ProductGiveawayAdjustment']
    export const isProductGiveawayAdjustment = (obj?: { __typename?: any } | null): obj is ProductGiveawayAdjustment => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductGiveawayAdjustment"')
      return ProductGiveawayAdjustment_possibleTypes.includes(obj.__typename)
    }
    


    const ProductGiveawayAdjustments_possibleTypes: string[] = ['ProductGiveawayAdjustments']
    export const isProductGiveawayAdjustments = (obj?: { __typename?: any } | null): obj is ProductGiveawayAdjustments => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductGiveawayAdjustments"')
      return ProductGiveawayAdjustments_possibleTypes.includes(obj.__typename)
    }
    


    const ProductLineItemV3_possibleTypes: string[] = ['ProductLineItemV3']
    export const isProductLineItemV3 = (obj?: { __typename?: any } | null): obj is ProductLineItemV3 => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductLineItemV3"')
      return ProductLineItemV3_possibleTypes.includes(obj.__typename)
    }
    


    const ProductLostAndFoundAdjustment_possibleTypes: string[] = ['ProductLostAndFoundAdjustment']
    export const isProductLostAndFoundAdjustment = (obj?: { __typename?: any } | null): obj is ProductLostAndFoundAdjustment => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductLostAndFoundAdjustment"')
      return ProductLostAndFoundAdjustment_possibleTypes.includes(obj.__typename)
    }
    


    const ProductLostAndFoundAdjustments_possibleTypes: string[] = ['ProductLostAndFoundAdjustments']
    export const isProductLostAndFoundAdjustments = (obj?: { __typename?: any } | null): obj is ProductLostAndFoundAdjustments => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductLostAndFoundAdjustments"')
      return ProductLostAndFoundAdjustments_possibleTypes.includes(obj.__typename)
    }
    


    const ProductMergeHistoryItem_possibleTypes: string[] = ['ProductMergeHistoryItem']
    export const isProductMergeHistoryItem = (obj?: { __typename?: any } | null): obj is ProductMergeHistoryItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductMergeHistoryItem"')
      return ProductMergeHistoryItem_possibleTypes.includes(obj.__typename)
    }
    


    const ProductMergeLogItem_possibleTypes: string[] = ['ProductMergeLogItem']
    export const isProductMergeLogItem = (obj?: { __typename?: any } | null): obj is ProductMergeLogItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductMergeLogItem"')
      return ProductMergeLogItem_possibleTypes.includes(obj.__typename)
    }
    


    const ProductMergeLogItemProduct_possibleTypes: string[] = ['ProductMergeLogItemProduct']
    export const isProductMergeLogItemProduct = (obj?: { __typename?: any } | null): obj is ProductMergeLogItemProduct => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductMergeLogItemProduct"')
      return ProductMergeLogItemProduct_possibleTypes.includes(obj.__typename)
    }
    


    const ProductMergeRecommendations_possibleTypes: string[] = ['ProductMergeRecommendations']
    export const isProductMergeRecommendations = (obj?: { __typename?: any } | null): obj is ProductMergeRecommendations => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductMergeRecommendations"')
      return ProductMergeRecommendations_possibleTypes.includes(obj.__typename)
    }
    


    const ProductMergeRecommendationsMatchGroup_possibleTypes: string[] = ['ProductMergeRecommendationsMatchGroup']
    export const isProductMergeRecommendationsMatchGroup = (obj?: { __typename?: any } | null): obj is ProductMergeRecommendationsMatchGroup => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductMergeRecommendationsMatchGroup"')
      return ProductMergeRecommendationsMatchGroup_possibleTypes.includes(obj.__typename)
    }
    


    const ProductMergeRecommendationsProduct_possibleTypes: string[] = ['ProductMergeRecommendationsProduct']
    export const isProductMergeRecommendationsProduct = (obj?: { __typename?: any } | null): obj is ProductMergeRecommendationsProduct => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductMergeRecommendationsProduct"')
      return ProductMergeRecommendationsProduct_possibleTypes.includes(obj.__typename)
    }
    


    const ProductMergeRecommendationsProductGroup_possibleTypes: string[] = ['ProductMergeRecommendationsProductGroup']
    export const isProductMergeRecommendationsProductGroup = (obj?: { __typename?: any } | null): obj is ProductMergeRecommendationsProductGroup => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductMergeRecommendationsProductGroup"')
      return ProductMergeRecommendationsProductGroup_possibleTypes.includes(obj.__typename)
    }
    


    const ProductOtherFbaAdjustment_possibleTypes: string[] = ['ProductOtherFbaAdjustment']
    export const isProductOtherFbaAdjustment = (obj?: { __typename?: any } | null): obj is ProductOtherFbaAdjustment => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductOtherFbaAdjustment"')
      return ProductOtherFbaAdjustment_possibleTypes.includes(obj.__typename)
    }
    


    const ProductOtherFbaAdjustments_possibleTypes: string[] = ['ProductOtherFbaAdjustments']
    export const isProductOtherFbaAdjustments = (obj?: { __typename?: any } | null): obj is ProductOtherFbaAdjustments => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductOtherFbaAdjustments"')
      return ProductOtherFbaAdjustments_possibleTypes.includes(obj.__typename)
    }
    


    const ProductPendingAdjustmentsCountBreakdownResponse_possibleTypes: string[] = ['ProductPendingAdjustmentsCountBreakdownResponse']
    export const isProductPendingAdjustmentsCountBreakdownResponse = (obj?: { __typename?: any } | null): obj is ProductPendingAdjustmentsCountBreakdownResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductPendingAdjustmentsCountBreakdownResponse"')
      return ProductPendingAdjustmentsCountBreakdownResponse_possibleTypes.includes(obj.__typename)
    }
    


    const ProductPurchases_possibleTypes: string[] = ['ProductPurchases']
    export const isProductPurchases = (obj?: { __typename?: any } | null): obj is ProductPurchases => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductPurchases"')
      return ProductPurchases_possibleTypes.includes(obj.__typename)
    }
    


    const Products2Result_possibleTypes: string[] = ['Products2Result']
    export const isProducts2Result = (obj?: { __typename?: any } | null): obj is Products2Result => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProducts2Result"')
      return Products2Result_possibleTypes.includes(obj.__typename)
    }
    


    const ProductSalesDataAdjustment_possibleTypes: string[] = ['ProductSalesDataAdjustment']
    export const isProductSalesDataAdjustment = (obj?: { __typename?: any } | null): obj is ProductSalesDataAdjustment => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductSalesDataAdjustment"')
      return ProductSalesDataAdjustment_possibleTypes.includes(obj.__typename)
    }
    


    const ProductSalesDataAdjustments_possibleTypes: string[] = ['ProductSalesDataAdjustments']
    export const isProductSalesDataAdjustments = (obj?: { __typename?: any } | null): obj is ProductSalesDataAdjustments => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductSalesDataAdjustments"')
      return ProductSalesDataAdjustments_possibleTypes.includes(obj.__typename)
    }
    


    const ProductsOverviewResponse_possibleTypes: string[] = ['ProductsOverviewResponse']
    export const isProductsOverviewResponse = (obj?: { __typename?: any } | null): obj is ProductsOverviewResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductsOverviewResponse"')
      return ProductsOverviewResponse_possibleTypes.includes(obj.__typename)
    }
    


    const ProductsResult_possibleTypes: string[] = ['ProductsResult']
    export const isProductsResult = (obj?: { __typename?: any } | null): obj is ProductsResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductsResult"')
      return ProductsResult_possibleTypes.includes(obj.__typename)
    }
    


    const ProductsValidationData_possibleTypes: string[] = ['ProductsValidationData']
    export const isProductsValidationData = (obj?: { __typename?: any } | null): obj is ProductsValidationData => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductsValidationData"')
      return ProductsValidationData_possibleTypes.includes(obj.__typename)
    }
    


    const ProductTopPerformersResponse_possibleTypes: string[] = ['ProductTopPerformersResponse']
    export const isProductTopPerformersResponse = (obj?: { __typename?: any } | null): obj is ProductTopPerformersResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductTopPerformersResponse"')
      return ProductTopPerformersResponse_possibleTypes.includes(obj.__typename)
    }
    


    const ProductUnitCogs_possibleTypes: string[] = ['ProductUnitCogs']
    export const isProductUnitCogs = (obj?: { __typename?: any } | null): obj is ProductUnitCogs => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductUnitCogs"')
      return ProductUnitCogs_possibleTypes.includes(obj.__typename)
    }
    


    const ProductUnitCogsDailyBreakdown_possibleTypes: string[] = ['ProductUnitCogsDailyBreakdown']
    export const isProductUnitCogsDailyBreakdown = (obj?: { __typename?: any } | null): obj is ProductUnitCogsDailyBreakdown => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductUnitCogsDailyBreakdown"')
      return ProductUnitCogsDailyBreakdown_possibleTypes.includes(obj.__typename)
    }
    


    const ProductUnitCogsMonthlyBreakdown_possibleTypes: string[] = ['ProductUnitCogsMonthlyBreakdown']
    export const isProductUnitCogsMonthlyBreakdown = (obj?: { __typename?: any } | null): obj is ProductUnitCogsMonthlyBreakdown => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductUnitCogsMonthlyBreakdown"')
      return ProductUnitCogsMonthlyBreakdown_possibleTypes.includes(obj.__typename)
    }
    


    const ProductUnitsAdjustment_possibleTypes: string[] = ['ProductUnitsAdjustment']
    export const isProductUnitsAdjustment = (obj?: { __typename?: any } | null): obj is ProductUnitsAdjustment => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductUnitsAdjustment"')
      return ProductUnitsAdjustment_possibleTypes.includes(obj.__typename)
    }
    


    const ProductUnitsAdjustments_possibleTypes: string[] = ['ProductUnitsAdjustments']
    export const isProductUnitsAdjustments = (obj?: { __typename?: any } | null): obj is ProductUnitsAdjustments => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductUnitsAdjustments"')
      return ProductUnitsAdjustments_possibleTypes.includes(obj.__typename)
    }
    


    const ProductV3_possibleTypes: string[] = ['ProductV3']
    export const isProductV3 = (obj?: { __typename?: any } | null): obj is ProductV3 => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductV3"')
      return ProductV3_possibleTypes.includes(obj.__typename)
    }
    


    const ProductWarehousesAnalyticsOverview_possibleTypes: string[] = ['ProductWarehousesAnalyticsOverview']
    export const isProductWarehousesAnalyticsOverview = (obj?: { __typename?: any } | null): obj is ProductWarehousesAnalyticsOverview => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductWarehousesAnalyticsOverview"')
      return ProductWarehousesAnalyticsOverview_possibleTypes.includes(obj.__typename)
    }
    


    const PurchaseBasedClosingBalance_possibleTypes: string[] = ['PurchaseBasedClosingBalance']
    export const isPurchaseBasedClosingBalance = (obj?: { __typename?: any } | null): obj is PurchaseBasedClosingBalance => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPurchaseBasedClosingBalance"')
      return PurchaseBasedClosingBalance_possibleTypes.includes(obj.__typename)
    }
    


    const PurchaseBasedOpeningBalance_possibleTypes: string[] = ['PurchaseBasedOpeningBalance']
    export const isPurchaseBasedOpeningBalance = (obj?: { __typename?: any } | null): obj is PurchaseBasedOpeningBalance => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPurchaseBasedOpeningBalance"')
      return PurchaseBasedOpeningBalance_possibleTypes.includes(obj.__typename)
    }
    


    const PurchaseBasedPurchases_possibleTypes: string[] = ['PurchaseBasedPurchases']
    export const isPurchaseBasedPurchases = (obj?: { __typename?: any } | null): obj is PurchaseBasedPurchases => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPurchaseBasedPurchases"')
      return PurchaseBasedPurchases_possibleTypes.includes(obj.__typename)
    }
    


    const PurchasedOffer_possibleTypes: string[] = ['PurchasedOffer']
    export const isPurchasedOffer = (obj?: { __typename?: any } | null): obj is PurchasedOffer => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPurchasedOffer"')
      return PurchasedOffer_possibleTypes.includes(obj.__typename)
    }
    


    const PurchaseOrder_possibleTypes: string[] = ['PurchaseOrder']
    export const isPurchaseOrder = (obj?: { __typename?: any } | null): obj is PurchaseOrder => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPurchaseOrder"')
      return PurchaseOrder_possibleTypes.includes(obj.__typename)
    }
    


    const PurchaseOrderAttachment_possibleTypes: string[] = ['PurchaseOrderAttachment']
    export const isPurchaseOrderAttachment = (obj?: { __typename?: any } | null): obj is PurchaseOrderAttachment => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPurchaseOrderAttachment"')
      return PurchaseOrderAttachment_possibleTypes.includes(obj.__typename)
    }
    


    const PurchaseOrderLandedCostBreakdown_possibleTypes: string[] = ['PurchaseOrderLandedCostBreakdown']
    export const isPurchaseOrderLandedCostBreakdown = (obj?: { __typename?: any } | null): obj is PurchaseOrderLandedCostBreakdown => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPurchaseOrderLandedCostBreakdown"')
      return PurchaseOrderLandedCostBreakdown_possibleTypes.includes(obj.__typename)
    }
    


    const PurchaseOrderOverview_possibleTypes: string[] = ['PurchaseOrderOverview']
    export const isPurchaseOrderOverview = (obj?: { __typename?: any } | null): obj is PurchaseOrderOverview => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPurchaseOrderOverview"')
      return PurchaseOrderOverview_possibleTypes.includes(obj.__typename)
    }
    


    const PurchaseOrderOverviewV2_possibleTypes: string[] = ['PurchaseOrderOverviewV2']
    export const isPurchaseOrderOverviewV2 = (obj?: { __typename?: any } | null): obj is PurchaseOrderOverviewV2 => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPurchaseOrderOverviewV2"')
      return PurchaseOrderOverviewV2_possibleTypes.includes(obj.__typename)
    }
    


    const QuantityAndCost_possibleTypes: string[] = ['QuantityAndCost']
    export const isQuantityAndCost = (obj?: { __typename?: any } | null): obj is QuantityAndCost => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isQuantityAndCost"')
      return QuantityAndCost_possibleTypes.includes(obj.__typename)
    }
    


    const Query_possibleTypes: string[] = ['Query']
    export const isQuery = (obj?: { __typename?: any } | null): obj is Query => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isQuery"')
      return Query_possibleTypes.includes(obj.__typename)
    }
    


    const RangedManagementMethod_possibleTypes: string[] = ['RangedManagementMethod']
    export const isRangedManagementMethod = (obj?: { __typename?: any } | null): obj is RangedManagementMethod => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isRangedManagementMethod"')
      return RangedManagementMethod_possibleTypes.includes(obj.__typename)
    }
    


    const ReadyValidation_possibleTypes: string[] = ['ReadyValidation']
    export const isReadyValidation = (obj?: { __typename?: any } | null): obj is ReadyValidation => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isReadyValidation"')
      return ReadyValidation_possibleTypes.includes(obj.__typename)
    }
    


    const RealtimeCogsStatus_possibleTypes: string[] = ['RealtimeCogsStatus']
    export const isRealtimeCogsStatus = (obj?: { __typename?: any } | null): obj is RealtimeCogsStatus => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isRealtimeCogsStatus"')
      return RealtimeCogsStatus_possibleTypes.includes(obj.__typename)
    }
    


    const Recipe_possibleTypes: string[] = ['Recipe']
    export const isRecipe = (obj?: { __typename?: any } | null): obj is Recipe => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isRecipe"')
      return Recipe_possibleTypes.includes(obj.__typename)
    }
    


    const RecipeAllocatedCost_possibleTypes: string[] = ['RecipeAllocatedCost']
    export const isRecipeAllocatedCost = (obj?: { __typename?: any } | null): obj is RecipeAllocatedCost => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isRecipeAllocatedCost"')
      return RecipeAllocatedCost_possibleTypes.includes(obj.__typename)
    }
    


    const RecipeAllocatedCostsError_possibleTypes: string[] = ['RecipeAllocatedCostsError']
    export const isRecipeAllocatedCostsError = (obj?: { __typename?: any } | null): obj is RecipeAllocatedCostsError => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isRecipeAllocatedCostsError"')
      return RecipeAllocatedCostsError_possibleTypes.includes(obj.__typename)
    }
    


    const RecipeBreakdown_possibleTypes: string[] = ['RecipeBreakdown']
    export const isRecipeBreakdown = (obj?: { __typename?: any } | null): obj is RecipeBreakdown => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isRecipeBreakdown"')
      return RecipeBreakdown_possibleTypes.includes(obj.__typename)
    }
    


    const RecipeCirclesFoundError_possibleTypes: string[] = ['RecipeCirclesFoundError']
    export const isRecipeCirclesFoundError = (obj?: { __typename?: any } | null): obj is RecipeCirclesFoundError => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isRecipeCirclesFoundError"')
      return RecipeCirclesFoundError_possibleTypes.includes(obj.__typename)
    }
    


    const RecipeCirclesFoundErrorData_possibleTypes: string[] = ['RecipeCirclesFoundErrorData']
    export const isRecipeCirclesFoundErrorData = (obj?: { __typename?: any } | null): obj is RecipeCirclesFoundErrorData => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isRecipeCirclesFoundErrorData"')
      return RecipeCirclesFoundErrorData_possibleTypes.includes(obj.__typename)
    }
    


    const RecipeComponent_possibleTypes: string[] = ['RecipeComponent']
    export const isRecipeComponent = (obj?: { __typename?: any } | null): obj is RecipeComponent => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isRecipeComponent"')
      return RecipeComponent_possibleTypes.includes(obj.__typename)
    }
    


    const RecipeOverlappingError_possibleTypes: string[] = ['RecipeOverlappingError']
    export const isRecipeOverlappingError = (obj?: { __typename?: any } | null): obj is RecipeOverlappingError => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isRecipeOverlappingError"')
      return RecipeOverlappingError_possibleTypes.includes(obj.__typename)
    }
    


    const RecipeWithBreakdown_possibleTypes: string[] = ['RecipeWithBreakdown']
    export const isRecipeWithBreakdown = (obj?: { __typename?: any } | null): obj is RecipeWithBreakdown => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isRecipeWithBreakdown"')
      return RecipeWithBreakdown_possibleTypes.includes(obj.__typename)
    }
    


    const ReconciliationRequestStatementFile_possibleTypes: string[] = ['ReconciliationRequestStatementFile']
    export const isReconciliationRequestStatementFile = (obj?: { __typename?: any } | null): obj is ReconciliationRequestStatementFile => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isReconciliationRequestStatementFile"')
      return ReconciliationRequestStatementFile_possibleTypes.includes(obj.__typename)
    }
    


    const ReconciliationSummary_possibleTypes: string[] = ['ReconciliationSummary']
    export const isReconciliationSummary = (obj?: { __typename?: any } | null): obj is ReconciliationSummary => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isReconciliationSummary"')
      return ReconciliationSummary_possibleTypes.includes(obj.__typename)
    }
    


    const RecurrenceSettings_possibleTypes: string[] = ['RecurrenceSettings']
    export const isRecurrenceSettings = (obj?: { __typename?: any } | null): obj is RecurrenceSettings => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isRecurrenceSettings"')
      return RecurrenceSettings_possibleTypes.includes(obj.__typename)
    }
    


    const RecurringPayment_possibleTypes: string[] = ['RecurringPayment']
    export const isRecurringPayment = (obj?: { __typename?: any } | null): obj is RecurringPayment => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isRecurringPayment"')
      return RecurringPayment_possibleTypes.includes(obj.__typename)
    }
    


    const referUserResponse_possibleTypes: string[] = ['referUserResponse']
    export const isreferUserResponse = (obj?: { __typename?: any } | null): obj is referUserResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isreferUserResponse"')
      return referUserResponse_possibleTypes.includes(obj.__typename)
    }
    


    const Refund_possibleTypes: string[] = ['Refund']
    export const isRefund = (obj?: { __typename?: any } | null): obj is Refund => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isRefund"')
      return Refund_possibleTypes.includes(obj.__typename)
    }
    


    const Reimbursement_possibleTypes: string[] = ['Reimbursement']
    export const isReimbursement = (obj?: { __typename?: any } | null): obj is Reimbursement => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isReimbursement"')
      return Reimbursement_possibleTypes.includes(obj.__typename)
    }
    


    const RelatedParty_possibleTypes: string[] = ['RelatedParty']
    export const isRelatedParty = (obj?: { __typename?: any } | null): obj is RelatedParty => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isRelatedParty"')
      return RelatedParty_possibleTypes.includes(obj.__typename)
    }
    


    const RemoveUserResponse_possibleTypes: string[] = ['RemoveUserResponse']
    export const isRemoveUserResponse = (obj?: { __typename?: any } | null): obj is RemoveUserResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isRemoveUserResponse"')
      return RemoveUserResponse_possibleTypes.includes(obj.__typename)
    }
    


    const Report_possibleTypes: string[] = ['Report']
    export const isReport = (obj?: { __typename?: any } | null): obj is Report => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isReport"')
      return Report_possibleTypes.includes(obj.__typename)
    }
    


    const ReportHierarchyNode_possibleTypes: string[] = ['ReportHierarchyNode']
    export const isReportHierarchyNode = (obj?: { __typename?: any } | null): obj is ReportHierarchyNode => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isReportHierarchyNode"')
      return ReportHierarchyNode_possibleTypes.includes(obj.__typename)
    }
    


    const ReportsPartner_possibleTypes: string[] = ['ReportsPartner']
    export const isReportsPartner = (obj?: { __typename?: any } | null): obj is ReportsPartner => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isReportsPartner"')
      return ReportsPartner_possibleTypes.includes(obj.__typename)
    }
    


    const ResetBalanceSheetSetupResponse_possibleTypes: string[] = ['ResetBalanceSheetSetupResponse']
    export const isResetBalanceSheetSetupResponse = (obj?: { __typename?: any } | null): obj is ResetBalanceSheetSetupResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isResetBalanceSheetSetupResponse"')
      return ResetBalanceSheetSetupResponse_possibleTypes.includes(obj.__typename)
    }
    


    const RestockingAction_possibleTypes: string[] = ['RestockingAction']
    export const isRestockingAction = (obj?: { __typename?: any } | null): obj is RestockingAction => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isRestockingAction"')
      return RestockingAction_possibleTypes.includes(obj.__typename)
    }
    


    const RunProductsValidationDiagnosticsResponse_possibleTypes: string[] = ['RunProductsValidationDiagnosticsResponse']
    export const isRunProductsValidationDiagnosticsResponse = (obj?: { __typename?: any } | null): obj is RunProductsValidationDiagnosticsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isRunProductsValidationDiagnosticsResponse"')
      return RunProductsValidationDiagnosticsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const SafeHolder_possibleTypes: string[] = ['SafeHolder']
    export const isSafeHolder = (obj?: { __typename?: any } | null): obj is SafeHolder => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSafeHolder"')
      return SafeHolder_possibleTypes.includes(obj.__typename)
    }
    


    const Sale_possibleTypes: string[] = ['Sale']
    export const isSale = (obj?: { __typename?: any } | null): obj is Sale => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSale"')
      return Sale_possibleTypes.includes(obj.__typename)
    }
    


    const SaleAdjustment_possibleTypes: string[] = ['SaleAdjustment']
    export const isSaleAdjustment = (obj?: { __typename?: any } | null): obj is SaleAdjustment => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSaleAdjustment"')
      return SaleAdjustment_possibleTypes.includes(obj.__typename)
    }
    


    const SaleLineItem_possibleTypes: string[] = ['SaleLineItem']
    export const isSaleLineItem = (obj?: { __typename?: any } | null): obj is SaleLineItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSaleLineItem"')
      return SaleLineItem_possibleTypes.includes(obj.__typename)
    }
    


    const SaleLineItemTaxInfo_possibleTypes: string[] = ['SaleLineItemTaxInfo']
    export const isSaleLineItemTaxInfo = (obj?: { __typename?: any } | null): obj is SaleLineItemTaxInfo => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSaleLineItemTaxInfo"')
      return SaleLineItemTaxInfo_possibleTypes.includes(obj.__typename)
    }
    


    const SaleOrder_possibleTypes: string[] = ['SaleOrder']
    export const isSaleOrder = (obj?: { __typename?: any } | null): obj is SaleOrder => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSaleOrder"')
      return SaleOrder_possibleTypes.includes(obj.__typename)
    }
    


    const SalesAdjustmentOriginalValue_possibleTypes: string[] = ['SalesAdjustmentOriginalValue']
    export const isSalesAdjustmentOriginalValue = (obj?: { __typename?: any } | null): obj is SalesAdjustmentOriginalValue => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSalesAdjustmentOriginalValue"')
      return SalesAdjustmentOriginalValue_possibleTypes.includes(obj.__typename)
    }
    


    const SalesAdjustmentsBreakdownItem_possibleTypes: string[] = ['SalesAdjustmentsBreakdownItem']
    export const isSalesAdjustmentsBreakdownItem = (obj?: { __typename?: any } | null): obj is SalesAdjustmentsBreakdownItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSalesAdjustmentsBreakdownItem"')
      return SalesAdjustmentsBreakdownItem_possibleTypes.includes(obj.__typename)
    }
    


    const SalesBasedClosingBalance_possibleTypes: string[] = ['SalesBasedClosingBalance']
    export const isSalesBasedClosingBalance = (obj?: { __typename?: any } | null): obj is SalesBasedClosingBalance => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSalesBasedClosingBalance"')
      return SalesBasedClosingBalance_possibleTypes.includes(obj.__typename)
    }
    


    const SalesBasedMissingCostPerUnit_possibleTypes: string[] = ['SalesBasedMissingCostPerUnit']
    export const isSalesBasedMissingCostPerUnit = (obj?: { __typename?: any } | null): obj is SalesBasedMissingCostPerUnit => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSalesBasedMissingCostPerUnit"')
      return SalesBasedMissingCostPerUnit_possibleTypes.includes(obj.__typename)
    }
    


    const SalesBasedOpeningBalance_possibleTypes: string[] = ['SalesBasedOpeningBalance']
    export const isSalesBasedOpeningBalance = (obj?: { __typename?: any } | null): obj is SalesBasedOpeningBalance => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSalesBasedOpeningBalance"')
      return SalesBasedOpeningBalance_possibleTypes.includes(obj.__typename)
    }
    


    const SalesBasedPurchases_possibleTypes: string[] = ['SalesBasedPurchases']
    export const isSalesBasedPurchases = (obj?: { __typename?: any } | null): obj is SalesBasedPurchases => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSalesBasedPurchases"')
      return SalesBasedPurchases_possibleTypes.includes(obj.__typename)
    }
    


    const SalesBasedReportCogs_possibleTypes: string[] = ['SalesBasedReportCogs']
    export const isSalesBasedReportCogs = (obj?: { __typename?: any } | null): obj is SalesBasedReportCogs => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSalesBasedReportCogs"')
      return SalesBasedReportCogs_possibleTypes.includes(obj.__typename)
    }
    


    const SalesChannel_possibleTypes: string[] = ['SalesChannel']
    export const isSalesChannel = (obj?: { __typename?: any } | null): obj is SalesChannel => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSalesChannel"')
      return SalesChannel_possibleTypes.includes(obj.__typename)
    }
    


    const SalesChannelDailySalesData_possibleTypes: string[] = ['SalesChannelDailySalesData']
    export const isSalesChannelDailySalesData = (obj?: { __typename?: any } | null): obj is SalesChannelDailySalesData => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSalesChannelDailySalesData"')
      return SalesChannelDailySalesData_possibleTypes.includes(obj.__typename)
    }
    


    const SalesChannelDailySummary_possibleTypes: string[] = ['SalesChannelDailySummary']
    export const isSalesChannelDailySummary = (obj?: { __typename?: any } | null): obj is SalesChannelDailySummary => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSalesChannelDailySummary"')
      return SalesChannelDailySummary_possibleTypes.includes(obj.__typename)
    }
    


    const SalesChannelInfo_possibleTypes: string[] = ['SalesChannelInfo']
    export const isSalesChannelInfo = (obj?: { __typename?: any } | null): obj is SalesChannelInfo => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSalesChannelInfo"')
      return SalesChannelInfo_possibleTypes.includes(obj.__typename)
    }
    


    const SalesChannelMonthlyBreakdown_possibleTypes: string[] = ['SalesChannelMonthlyBreakdown']
    export const isSalesChannelMonthlyBreakdown = (obj?: { __typename?: any } | null): obj is SalesChannelMonthlyBreakdown => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSalesChannelMonthlyBreakdown"')
      return SalesChannelMonthlyBreakdown_possibleTypes.includes(obj.__typename)
    }
    


    const SalesChannelPeriod_possibleTypes: string[] = ['SalesChannelPeriod']
    export const isSalesChannelPeriod = (obj?: { __typename?: any } | null): obj is SalesChannelPeriod => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSalesChannelPeriod"')
      return SalesChannelPeriod_possibleTypes.includes(obj.__typename)
    }
    


    const SalesChannelSalesCogs_possibleTypes: string[] = ['SalesChannelSalesCogs']
    export const isSalesChannelSalesCogs = (obj?: { __typename?: any } | null): obj is SalesChannelSalesCogs => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSalesChannelSalesCogs"')
      return SalesChannelSalesCogs_possibleTypes.includes(obj.__typename)
    }
    


    const SalesChannelSalesData_possibleTypes: string[] = ['SalesChannelSalesData']
    export const isSalesChannelSalesData = (obj?: { __typename?: any } | null): obj is SalesChannelSalesData => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSalesChannelSalesData"')
      return SalesChannelSalesData_possibleTypes.includes(obj.__typename)
    }
    


    const SalesChannelsByCompanyAndIntegrationResponse_possibleTypes: string[] = ['SalesChannelsByCompanyAndIntegrationResponse']
    export const isSalesChannelsByCompanyAndIntegrationResponse = (obj?: { __typename?: any } | null): obj is SalesChannelsByCompanyAndIntegrationResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSalesChannelsByCompanyAndIntegrationResponse"')
      return SalesChannelsByCompanyAndIntegrationResponse_possibleTypes.includes(obj.__typename)
    }
    


    const SalesChannelSkuSalesSummary_possibleTypes: string[] = ['SalesChannelSkuSalesSummary']
    export const isSalesChannelSkuSalesSummary = (obj?: { __typename?: any } | null): obj is SalesChannelSkuSalesSummary => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSalesChannelSkuSalesSummary"')
      return SalesChannelSkuSalesSummary_possibleTypes.includes(obj.__typename)
    }
    


    const SalesChannelSkuSummary_possibleTypes: string[] = ['SalesChannelSkuSummary']
    export const isSalesChannelSkuSummary = (obj?: { __typename?: any } | null): obj is SalesChannelSkuSummary => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSalesChannelSkuSummary"')
      return SalesChannelSkuSummary_possibleTypes.includes(obj.__typename)
    }
    


    const SalesChannelTemplate_possibleTypes: string[] = ['SalesChannelTemplate']
    export const isSalesChannelTemplate = (obj?: { __typename?: any } | null): obj is SalesChannelTemplate => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSalesChannelTemplate"')
      return SalesChannelTemplate_possibleTypes.includes(obj.__typename)
    }
    


    const SalesData_possibleTypes: string[] = ['SalesData']
    export const isSalesData = (obj?: { __typename?: any } | null): obj is SalesData => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSalesData"')
      return SalesData_possibleTypes.includes(obj.__typename)
    }
    


    const SaleTotals_possibleTypes: string[] = ['SaleTotals']
    export const isSaleTotals = (obj?: { __typename?: any } | null): obj is SaleTotals => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSaleTotals"')
      return SaleTotals_possibleTypes.includes(obj.__typename)
    }
    


    const SaleTransaction_possibleTypes: string[] = ['BankTxSaleTransaction','IntegrationSaleTransaction','PaymentGroupTransaction']
    export const isSaleTransaction = (obj?: { __typename?: any } | null): obj is SaleTransaction => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSaleTransaction"')
      return SaleTransaction_possibleTypes.includes(obj.__typename)
    }
    


    const ScheduleAccountingReportExportResponse_possibleTypes: string[] = ['ScheduleAccountingReportExportResponse']
    export const isScheduleAccountingReportExportResponse = (obj?: { __typename?: any } | null): obj is ScheduleAccountingReportExportResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isScheduleAccountingReportExportResponse"')
      return ScheduleAccountingReportExportResponse_possibleTypes.includes(obj.__typename)
    }
    


    const ScheduleAtuIntegrationTransfersResultProcessingResult_possibleTypes: string[] = ['ScheduleAtuIntegrationTransfersResultProcessingResult']
    export const isScheduleAtuIntegrationTransfersResultProcessingResult = (obj?: { __typename?: any } | null): obj is ScheduleAtuIntegrationTransfersResultProcessingResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isScheduleAtuIntegrationTransfersResultProcessingResult"')
      return ScheduleAtuIntegrationTransfersResultProcessingResult_possibleTypes.includes(obj.__typename)
    }
    


    const ScheduleAtuTransactionsResultProcessingResult_possibleTypes: string[] = ['ScheduleAtuTransactionsResultProcessingResult']
    export const isScheduleAtuTransactionsResultProcessingResult = (obj?: { __typename?: any } | null): obj is ScheduleAtuTransactionsResultProcessingResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isScheduleAtuTransactionsResultProcessingResult"')
      return ScheduleAtuTransactionsResultProcessingResult_possibleTypes.includes(obj.__typename)
    }
    


    const SchedulePurchasesValidationResponse_possibleTypes: string[] = ['SchedulePurchasesValidationResponse']
    export const isSchedulePurchasesValidationResponse = (obj?: { __typename?: any } | null): obj is SchedulePurchasesValidationResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSchedulePurchasesValidationResponse"')
      return SchedulePurchasesValidationResponse_possibleTypes.includes(obj.__typename)
    }
    


    const SearchVendorsTransactionsPriorityResult_possibleTypes: string[] = ['SearchVendorsTransactionsPriorityResult']
    export const isSearchVendorsTransactionsPriorityResult = (obj?: { __typename?: any } | null): obj is SearchVendorsTransactionsPriorityResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSearchVendorsTransactionsPriorityResult"')
      return SearchVendorsTransactionsPriorityResult_possibleTypes.includes(obj.__typename)
    }
    


    const Section179Deduction_possibleTypes: string[] = ['Section179Deduction']
    export const isSection179Deduction = (obj?: { __typename?: any } | null): obj is Section179Deduction => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSection179Deduction"')
      return Section179Deduction_possibleTypes.includes(obj.__typename)
    }
    


    const SellingFee_possibleTypes: string[] = ['SellingFee']
    export const isSellingFee = (obj?: { __typename?: any } | null): obj is SellingFee => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSellingFee"')
      return SellingFee_possibleTypes.includes(obj.__typename)
    }
    


    const SendAnalyticsEventResult_possibleTypes: string[] = ['SendAnalyticsEventResult']
    export const isSendAnalyticsEventResult = (obj?: { __typename?: any } | null): obj is SendAnalyticsEventResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSendAnalyticsEventResult"')
      return SendAnalyticsEventResult_possibleTypes.includes(obj.__typename)
    }
    


    const SendPoEmailError_possibleTypes: string[] = ['SendPoEmailError']
    export const isSendPoEmailError = (obj?: { __typename?: any } | null): obj is SendPoEmailError => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSendPoEmailError"')
      return SendPoEmailError_possibleTypes.includes(obj.__typename)
    }
    


    const SendPoEmailResponse_possibleTypes: string[] = ['SendPoEmailResponse']
    export const isSendPoEmailResponse = (obj?: { __typename?: any } | null): obj is SendPoEmailResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSendPoEmailResponse"')
      return SendPoEmailResponse_possibleTypes.includes(obj.__typename)
    }
    


    const SendPoEmailResult_possibleTypes: string[] = ['SendPoEmailResponse','SendPoEmailError']
    export const isSendPoEmailResult = (obj?: { __typename?: any } | null): obj is SendPoEmailResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSendPoEmailResult"')
      return SendPoEmailResult_possibleTypes.includes(obj.__typename)
    }
    


    const SetFulfillmentSettingsResponse_possibleTypes: string[] = ['SetFulfillmentSettingsResponse']
    export const isSetFulfillmentSettingsResponse = (obj?: { __typename?: any } | null): obj is SetFulfillmentSettingsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSetFulfillmentSettingsResponse"')
      return SetFulfillmentSettingsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const SetPendingDedInventoryAdjustmentsResponse_possibleTypes: string[] = ['SetPendingDedInventoryAdjustmentsResponse']
    export const isSetPendingDedInventoryAdjustmentsResponse = (obj?: { __typename?: any } | null): obj is SetPendingDedInventoryAdjustmentsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSetPendingDedInventoryAdjustmentsResponse"')
      return SetPendingDedInventoryAdjustmentsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const SetPendingDonationAdjustmentsResponse_possibleTypes: string[] = ['SetPendingDonationAdjustmentsResponse']
    export const isSetPendingDonationAdjustmentsResponse = (obj?: { __typename?: any } | null): obj is SetPendingDonationAdjustmentsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSetPendingDonationAdjustmentsResponse"')
      return SetPendingDonationAdjustmentsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const SetPendingGiveawayAdjustmentsResponse_possibleTypes: string[] = ['SetPendingGiveawayAdjustmentsResponse']
    export const isSetPendingGiveawayAdjustmentsResponse = (obj?: { __typename?: any } | null): obj is SetPendingGiveawayAdjustmentsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSetPendingGiveawayAdjustmentsResponse"')
      return SetPendingGiveawayAdjustmentsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const SetPendingGiveawayDropshippingAdjustmentsResponse_possibleTypes: string[] = ['SetPendingGiveawayDropshippingAdjustmentsResponse']
    export const isSetPendingGiveawayDropshippingAdjustmentsResponse = (obj?: { __typename?: any } | null): obj is SetPendingGiveawayDropshippingAdjustmentsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSetPendingGiveawayDropshippingAdjustmentsResponse"')
      return SetPendingGiveawayDropshippingAdjustmentsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const SetPendingSalesDataAdjustmentsResponseV2_possibleTypes: string[] = ['SetPendingSalesDataAdjustmentsResponseV2']
    export const isSetPendingSalesDataAdjustmentsResponseV2 = (obj?: { __typename?: any } | null): obj is SetPendingSalesDataAdjustmentsResponseV2 => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSetPendingSalesDataAdjustmentsResponseV2"')
      return SetPendingSalesDataAdjustmentsResponseV2_possibleTypes.includes(obj.__typename)
    }
    


    const SetUserNameResponse_possibleTypes: string[] = ['SetUserNameResponse']
    export const isSetUserNameResponse = (obj?: { __typename?: any } | null): obj is SetUserNameResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSetUserNameResponse"')
      return SetUserNameResponse_possibleTypes.includes(obj.__typename)
    }
    


    const Shipment_possibleTypes: string[] = ['Shipment']
    export const isShipment = (obj?: { __typename?: any } | null): obj is Shipment => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isShipment"')
      return Shipment_possibleTypes.includes(obj.__typename)
    }
    


    const ShipmentAction_possibleTypes: string[] = ['ShipmentAction']
    export const isShipmentAction = (obj?: { __typename?: any } | null): obj is ShipmentAction => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isShipmentAction"')
      return ShipmentAction_possibleTypes.includes(obj.__typename)
    }
    


    const ShipmentArrival_possibleTypes: string[] = ['ShipmentArrival']
    export const isShipmentArrival = (obj?: { __typename?: any } | null): obj is ShipmentArrival => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isShipmentArrival"')
      return ShipmentArrival_possibleTypes.includes(obj.__typename)
    }
    


    const ShipmentAttachment_possibleTypes: string[] = ['ShipmentAttachment']
    export const isShipmentAttachment = (obj?: { __typename?: any } | null): obj is ShipmentAttachment => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isShipmentAttachment"')
      return ShipmentAttachment_possibleTypes.includes(obj.__typename)
    }
    


    const ShipmentContents_possibleTypes: string[] = ['ShipmentContents']
    export const isShipmentContents = (obj?: { __typename?: any } | null): obj is ShipmentContents => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isShipmentContents"')
      return ShipmentContents_possibleTypes.includes(obj.__typename)
    }
    


    const ShippingCost_possibleTypes: string[] = ['ShippingCost']
    export const isShippingCost = (obj?: { __typename?: any } | null): obj is ShippingCost => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isShippingCost"')
      return ShippingCost_possibleTypes.includes(obj.__typename)
    }
    


    const ShippingLineItem_possibleTypes: string[] = ['ShippingLineItem']
    export const isShippingLineItem = (obj?: { __typename?: any } | null): obj is ShippingLineItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isShippingLineItem"')
      return ShippingLineItem_possibleTypes.includes(obj.__typename)
    }
    


    const ShippingLineItemV3_possibleTypes: string[] = ['ShippingLineItemV3']
    export const isShippingLineItemV3 = (obj?: { __typename?: any } | null): obj is ShippingLineItemV3 => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isShippingLineItemV3"')
      return ShippingLineItemV3_possibleTypes.includes(obj.__typename)
    }
    


    const ShopifyCsvBalance_possibleTypes: string[] = ['ShopifyCsvBalance']
    export const isShopifyCsvBalance = (obj?: { __typename?: any } | null): obj is ShopifyCsvBalance => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isShopifyCsvBalance"')
      return ShopifyCsvBalance_possibleTypes.includes(obj.__typename)
    }
    


    const ShopifyItemsReconciliationOrderData_possibleTypes: string[] = ['ShopifyItemsReconciliationOrderData']
    export const isShopifyItemsReconciliationOrderData = (obj?: { __typename?: any } | null): obj is ShopifyItemsReconciliationOrderData => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isShopifyItemsReconciliationOrderData"')
      return ShopifyItemsReconciliationOrderData_possibleTypes.includes(obj.__typename)
    }
    


    const ShopifyItemsReconciliationOrdersDiffResult_possibleTypes: string[] = ['ShopifyItemsReconciliationOrdersDiffResult']
    export const isShopifyItemsReconciliationOrdersDiffResult = (obj?: { __typename?: any } | null): obj is ShopifyItemsReconciliationOrdersDiffResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isShopifyItemsReconciliationOrdersDiffResult"')
      return ShopifyItemsReconciliationOrdersDiffResult_possibleTypes.includes(obj.__typename)
    }
    


    const ShopifyItemsReconciliationOrdersDiffResultData_possibleTypes: string[] = ['ShopifyItemsReconciliationOrdersDiffResultData']
    export const isShopifyItemsReconciliationOrdersDiffResultData = (obj?: { __typename?: any } | null): obj is ShopifyItemsReconciliationOrdersDiffResultData => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isShopifyItemsReconciliationOrdersDiffResultData"')
      return ShopifyItemsReconciliationOrdersDiffResultData_possibleTypes.includes(obj.__typename)
    }
    


    const ShopifyItemsReconciliationOrdersResponse_possibleTypes: string[] = ['ShopifyItemsReconciliationOrdersResponse']
    export const isShopifyItemsReconciliationOrdersResponse = (obj?: { __typename?: any } | null): obj is ShopifyItemsReconciliationOrdersResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isShopifyItemsReconciliationOrdersResponse"')
      return ShopifyItemsReconciliationOrdersResponse_possibleTypes.includes(obj.__typename)
    }
    


    const ShopifyOrderSourceData_possibleTypes: string[] = ['ShopifyOrderSourceData']
    export const isShopifyOrderSourceData = (obj?: { __typename?: any } | null): obj is ShopifyOrderSourceData => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isShopifyOrderSourceData"')
      return ShopifyOrderSourceData_possibleTypes.includes(obj.__typename)
    }
    


    const ShopifyOrderValidationData_possibleTypes: string[] = ['ShopifyOrderValidationData']
    export const isShopifyOrderValidationData = (obj?: { __typename?: any } | null): obj is ShopifyOrderValidationData => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isShopifyOrderValidationData"')
      return ShopifyOrderValidationData_possibleTypes.includes(obj.__typename)
    }
    


    const ShopifyOrderValidationRefund_possibleTypes: string[] = ['ShopifyOrderValidationRefund']
    export const isShopifyOrderValidationRefund = (obj?: { __typename?: any } | null): obj is ShopifyOrderValidationRefund => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isShopifyOrderValidationRefund"')
      return ShopifyOrderValidationRefund_possibleTypes.includes(obj.__typename)
    }
    


    const ShopifyOrderValidationSale_possibleTypes: string[] = ['ShopifyOrderValidationSale']
    export const isShopifyOrderValidationSale = (obj?: { __typename?: any } | null): obj is ShopifyOrderValidationSale => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isShopifyOrderValidationSale"')
      return ShopifyOrderValidationSale_possibleTypes.includes(obj.__typename)
    }
    


    const ShopifyProduct_possibleTypes: string[] = ['ShopifyProduct']
    export const isShopifyProduct = (obj?: { __typename?: any } | null): obj is ShopifyProduct => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isShopifyProduct"')
      return ShopifyProduct_possibleTypes.includes(obj.__typename)
    }
    


    const ShopifyProductsValidationConnection_possibleTypes: string[] = ['ShopifyProductsValidationConnection']
    export const isShopifyProductsValidationConnection = (obj?: { __typename?: any } | null): obj is ShopifyProductsValidationConnection => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isShopifyProductsValidationConnection"')
      return ShopifyProductsValidationConnection_possibleTypes.includes(obj.__typename)
    }
    


    const ShopifyProductsValidationConnectionsResponse_possibleTypes: string[] = ['ShopifyProductsValidationConnectionsResponse']
    export const isShopifyProductsValidationConnectionsResponse = (obj?: { __typename?: any } | null): obj is ShopifyProductsValidationConnectionsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isShopifyProductsValidationConnectionsResponse"')
      return ShopifyProductsValidationConnectionsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const ShopifyProductsValidationData_possibleTypes: string[] = ['ShopifyProductsValidationData']
    export const isShopifyProductsValidationData = (obj?: { __typename?: any } | null): obj is ShopifyProductsValidationData => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isShopifyProductsValidationData"')
      return ShopifyProductsValidationData_possibleTypes.includes(obj.__typename)
    }
    


    const ShopifyProductsValidationResponse_possibleTypes: string[] = ['ShopifyProductsValidationResponse']
    export const isShopifyProductsValidationResponse = (obj?: { __typename?: any } | null): obj is ShopifyProductsValidationResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isShopifyProductsValidationResponse"')
      return ShopifyProductsValidationResponse_possibleTypes.includes(obj.__typename)
    }
    


    const ShopifyReconciliationProductsStatus_possibleTypes: string[] = ['ShopifyReconciliationProductsStatus']
    export const isShopifyReconciliationProductsStatus = (obj?: { __typename?: any } | null): obj is ShopifyReconciliationProductsStatus => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isShopifyReconciliationProductsStatus"')
      return ShopifyReconciliationProductsStatus_possibleTypes.includes(obj.__typename)
    }
    


    const ShopifyReportDateLimitsResponse_possibleTypes: string[] = ['ShopifyReportDateLimitsResponse']
    export const isShopifyReportDateLimitsResponse = (obj?: { __typename?: any } | null): obj is ShopifyReportDateLimitsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isShopifyReportDateLimitsResponse"')
      return ShopifyReportDateLimitsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const ShopifySkuReconciliationData_possibleTypes: string[] = ['ShopifySkuReconciliationData']
    export const isShopifySkuReconciliationData = (obj?: { __typename?: any } | null): obj is ShopifySkuReconciliationData => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isShopifySkuReconciliationData"')
      return ShopifySkuReconciliationData_possibleTypes.includes(obj.__typename)
    }
    


    const ShopifySkuReconciliationProductItemSoldData_possibleTypes: string[] = ['ShopifySkuReconciliationProductItemSoldData']
    export const isShopifySkuReconciliationProductItemSoldData = (obj?: { __typename?: any } | null): obj is ShopifySkuReconciliationProductItemSoldData => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isShopifySkuReconciliationProductItemSoldData"')
      return ShopifySkuReconciliationProductItemSoldData_possibleTypes.includes(obj.__typename)
    }
    


    const ShopifyTimezoneBalance_possibleTypes: string[] = ['ShopifyTimezoneBalance']
    export const isShopifyTimezoneBalance = (obj?: { __typename?: any } | null): obj is ShopifyTimezoneBalance => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isShopifyTimezoneBalance"')
      return ShopifyTimezoneBalance_possibleTypes.includes(obj.__typename)
    }
    


    const SimulatedLoanFailure_possibleTypes: string[] = ['SimulatedLoanFailure']
    export const isSimulatedLoanFailure = (obj?: { __typename?: any } | null): obj is SimulatedLoanFailure => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSimulatedLoanFailure"')
      return SimulatedLoanFailure_possibleTypes.includes(obj.__typename)
    }
    


    const SimulatedLoanIrrelevantEvent_possibleTypes: string[] = ['SimulatedLoanIrrelevantEvent']
    export const isSimulatedLoanIrrelevantEvent = (obj?: { __typename?: any } | null): obj is SimulatedLoanIrrelevantEvent => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSimulatedLoanIrrelevantEvent"')
      return SimulatedLoanIrrelevantEvent_possibleTypes.includes(obj.__typename)
    }
    


    const SimulatedLoanSummary_possibleTypes: string[] = ['SimulatedLoanIrrelevantEvent','SimulatedLoanUpdate','SimulatedLoanFailure']
    export const isSimulatedLoanSummary = (obj?: { __typename?: any } | null): obj is SimulatedLoanSummary => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSimulatedLoanSummary"')
      return SimulatedLoanSummary_possibleTypes.includes(obj.__typename)
    }
    


    const SimulatedLoanUpdate_possibleTypes: string[] = ['SimulatedLoanUpdate']
    export const isSimulatedLoanUpdate = (obj?: { __typename?: any } | null): obj is SimulatedLoanUpdate => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSimulatedLoanUpdate"')
      return SimulatedLoanUpdate_possibleTypes.includes(obj.__typename)
    }
    


    const SimulatedLoanUpdateCreate_possibleTypes: string[] = ['SimulatedLoanUpdateCreate']
    export const isSimulatedLoanUpdateCreate = (obj?: { __typename?: any } | null): obj is SimulatedLoanUpdateCreate => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSimulatedLoanUpdateCreate"')
      return SimulatedLoanUpdateCreate_possibleTypes.includes(obj.__typename)
    }
    


    const SimulatedLoanUpdateDelete_possibleTypes: string[] = ['SimulatedLoanUpdateDelete']
    export const isSimulatedLoanUpdateDelete = (obj?: { __typename?: any } | null): obj is SimulatedLoanUpdateDelete => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSimulatedLoanUpdateDelete"')
      return SimulatedLoanUpdateDelete_possibleTypes.includes(obj.__typename)
    }
    


    const SingleOrderResult_possibleTypes: string[] = ['OrderV3','OrderV3NotFound']
    export const isSingleOrderResult = (obj?: { __typename?: any } | null): obj is SingleOrderResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSingleOrderResult"')
      return SingleOrderResult_possibleTypes.includes(obj.__typename)
    }
    


    const SkuData_possibleTypes: string[] = ['SkuData']
    export const isSkuData = (obj?: { __typename?: any } | null): obj is SkuData => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSkuData"')
      return SkuData_possibleTypes.includes(obj.__typename)
    }
    


    const SkuDataByDate_possibleTypes: string[] = ['SkuDataByDate']
    export const isSkuDataByDate = (obj?: { __typename?: any } | null): obj is SkuDataByDate => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSkuDataByDate"')
      return SkuDataByDate_possibleTypes.includes(obj.__typename)
    }
    


    const SkuValidationData_possibleTypes: string[] = ['SkuValidationData']
    export const isSkuValidationData = (obj?: { __typename?: any } | null): obj is SkuValidationData => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSkuValidationData"')
      return SkuValidationData_possibleTypes.includes(obj.__typename)
    }
    


    const SourceAndStores_possibleTypes: string[] = ['SourceAndStores']
    export const isSourceAndStores = (obj?: { __typename?: any } | null): obj is SourceAndStores => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSourceAndStores"')
      return SourceAndStores_possibleTypes.includes(obj.__typename)
    }
    


    const SpecificDate_possibleTypes: string[] = ['SpecificDate']
    export const isSpecificDate = (obj?: { __typename?: any } | null): obj is SpecificDate => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSpecificDate"')
      return SpecificDate_possibleTypes.includes(obj.__typename)
    }
    


    const SpreadOverTime_possibleTypes: string[] = ['SpreadOverTime']
    export const isSpreadOverTime = (obj?: { __typename?: any } | null): obj is SpreadOverTime => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSpreadOverTime"')
      return SpreadOverTime_possibleTypes.includes(obj.__typename)
    }
    


    const Store_possibleTypes: string[] = ['Store']
    export const isStore = (obj?: { __typename?: any } | null): obj is Store => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isStore"')
      return Store_possibleTypes.includes(obj.__typename)
    }
    


    const StorePaymentV2_possibleTypes: string[] = ['StorePaymentV2']
    export const isStorePaymentV2 = (obj?: { __typename?: any } | null): obj is StorePaymentV2 => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isStorePaymentV2"')
      return StorePaymentV2_possibleTypes.includes(obj.__typename)
    }
    


    const StoreV3_possibleTypes: string[] = ['StoreV3']
    export const isStoreV3 = (obj?: { __typename?: any } | null): obj is StoreV3 => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isStoreV3"')
      return StoreV3_possibleTypes.includes(obj.__typename)
    }
    


    const StripeCustomerIdsResponse_possibleTypes: string[] = ['StripeCustomerIdsResponse']
    export const isStripeCustomerIdsResponse = (obj?: { __typename?: any } | null): obj is StripeCustomerIdsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isStripeCustomerIdsResponse"')
      return StripeCustomerIdsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const SubmitTransactionsFileToBankTransactionsUploadResponse_possibleTypes: string[] = ['SubmitTransactionsFileToBankTransactionsUploadResponse']
    export const isSubmitTransactionsFileToBankTransactionsUploadResponse = (obj?: { __typename?: any } | null): obj is SubmitTransactionsFileToBankTransactionsUploadResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSubmitTransactionsFileToBankTransactionsUploadResponse"')
      return SubmitTransactionsFileToBankTransactionsUploadResponse_possibleTypes.includes(obj.__typename)
    }
    


    const SuccessResponse_possibleTypes: string[] = ['SuccessResponse']
    export const isSuccessResponse = (obj?: { __typename?: any } | null): obj is SuccessResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSuccessResponse"')
      return SuccessResponse_possibleTypes.includes(obj.__typename)
    }
    


    const SuccessResult_possibleTypes: string[] = ['SuccessResult']
    export const isSuccessResult = (obj?: { __typename?: any } | null): obj is SuccessResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSuccessResult"')
      return SuccessResult_possibleTypes.includes(obj.__typename)
    }
    


    const SuspectedBankAccountDuplication_possibleTypes: string[] = ['SuspectedBankAccountDuplication']
    export const isSuspectedBankAccountDuplication = (obj?: { __typename?: any } | null): obj is SuspectedBankAccountDuplication => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSuspectedBankAccountDuplication"')
      return SuspectedBankAccountDuplication_possibleTypes.includes(obj.__typename)
    }
    


    const SwitchCompanyResponse_possibleTypes: string[] = ['SwitchCompanyResponse']
    export const isSwitchCompanyResponse = (obj?: { __typename?: any } | null): obj is SwitchCompanyResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSwitchCompanyResponse"')
      return SwitchCompanyResponse_possibleTypes.includes(obj.__typename)
    }
    


    const SyncDataPlatformIntegrationResponse_possibleTypes: string[] = ['SyncDataPlatformIntegrationResponse']
    export const isSyncDataPlatformIntegrationResponse = (obj?: { __typename?: any } | null): obj is SyncDataPlatformIntegrationResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSyncDataPlatformIntegrationResponse"')
      return SyncDataPlatformIntegrationResponse_possibleTypes.includes(obj.__typename)
    }
    


    const Tax_possibleTypes: string[] = ['Tax']
    export const isTax = (obj?: { __typename?: any } | null): obj is Tax => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTax"')
      return Tax_possibleTypes.includes(obj.__typename)
    }
    


    const Tax1099AffiliatedEntity_possibleTypes: string[] = ['Tax1099AffiliatedEntity']
    export const isTax1099AffiliatedEntity = (obj?: { __typename?: any } | null): obj is Tax1099AffiliatedEntity => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTax1099AffiliatedEntity"')
      return Tax1099AffiliatedEntity_possibleTypes.includes(obj.__typename)
    }
    


    const Tax1099AffiliatedEntityGroup_possibleTypes: string[] = ['Tax1099AffiliatedEntityGroup']
    export const isTax1099AffiliatedEntityGroup = (obj?: { __typename?: any } | null): obj is Tax1099AffiliatedEntityGroup => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTax1099AffiliatedEntityGroup"')
      return Tax1099AffiliatedEntityGroup_possibleTypes.includes(obj.__typename)
    }
    


    const Tax1099AffiliatedEntityGroupFile_possibleTypes: string[] = ['Tax1099AffiliatedEntityGroupFile']
    export const isTax1099AffiliatedEntityGroupFile = (obj?: { __typename?: any } | null): obj is Tax1099AffiliatedEntityGroupFile => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTax1099AffiliatedEntityGroupFile"')
      return Tax1099AffiliatedEntityGroupFile_possibleTypes.includes(obj.__typename)
    }
    


    const Tax1099AffiliatedEntityGroupsByType_possibleTypes: string[] = ['Tax1099AffiliatedEntityGroupsByType']
    export const isTax1099AffiliatedEntityGroupsByType = (obj?: { __typename?: any } | null): obj is Tax1099AffiliatedEntityGroupsByType => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTax1099AffiliatedEntityGroupsByType"')
      return Tax1099AffiliatedEntityGroupsByType_possibleTypes.includes(obj.__typename)
    }
    


    const TaxInfo_possibleTypes: string[] = ['TaxInfo']
    export const isTaxInfo = (obj?: { __typename?: any } | null): obj is TaxInfo => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTaxInfo"')
      return TaxInfo_possibleTypes.includes(obj.__typename)
    }
    


    const TaxLineItemV3_possibleTypes: string[] = ['TaxLineItemV3']
    export const isTaxLineItemV3 = (obj?: { __typename?: any } | null): obj is TaxLineItemV3 => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTaxLineItemV3"')
      return TaxLineItemV3_possibleTypes.includes(obj.__typename)
    }
    


    const TestSPSCommerceOrgConnectionResponse_possibleTypes: string[] = ['TestSPSCommerceOrgConnectionResponse']
    export const isTestSPSCommerceOrgConnectionResponse = (obj?: { __typename?: any } | null): obj is TestSPSCommerceOrgConnectionResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTestSPSCommerceOrgConnectionResponse"')
      return TestSPSCommerceOrgConnectionResponse_possibleTypes.includes(obj.__typename)
    }
    


    const TikTokProduct_possibleTypes: string[] = ['TikTokProduct']
    export const isTikTokProduct = (obj?: { __typename?: any } | null): obj is TikTokProduct => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTikTokProduct"')
      return TikTokProduct_possibleTypes.includes(obj.__typename)
    }
    


    const TimeRange_possibleTypes: string[] = ['TimeRange']
    export const isTimeRange = (obj?: { __typename?: any } | null): obj is TimeRange => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTimeRange"')
      return TimeRange_possibleTypes.includes(obj.__typename)
    }
    


    const TipLineItemV3_possibleTypes: string[] = ['TipLineItemV3']
    export const isTipLineItemV3 = (obj?: { __typename?: any } | null): obj is TipLineItemV3 => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTipLineItemV3"')
      return TipLineItemV3_possibleTypes.includes(obj.__typename)
    }
    


    const ToggleBankTransactionAccrualResult_possibleTypes: string[] = ['ToggleBankTransactionAccrualResult']
    export const isToggleBankTransactionAccrualResult = (obj?: { __typename?: any } | null): obj is ToggleBankTransactionAccrualResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isToggleBankTransactionAccrualResult"')
      return ToggleBankTransactionAccrualResult_possibleTypes.includes(obj.__typename)
    }
    


    const Topup_possibleTypes: string[] = ['Topup']
    export const isTopup = (obj?: { __typename?: any } | null): obj is Topup => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTopup"')
      return Topup_possibleTypes.includes(obj.__typename)
    }
    


    const TransactionDescription_possibleTypes: string[] = ['TransactionDescription']
    export const isTransactionDescription = (obj?: { __typename?: any } | null): obj is TransactionDescription => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTransactionDescription"')
      return TransactionDescription_possibleTypes.includes(obj.__typename)
    }
    


    const TransactionLoan_possibleTypes: string[] = ['TransactionLoan']
    export const isTransactionLoan = (obj?: { __typename?: any } | null): obj is TransactionLoan => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTransactionLoan"')
      return TransactionLoan_possibleTypes.includes(obj.__typename)
    }
    


    const TransactionsImportStatus_possibleTypes: string[] = ['TransactionsImportStatus']
    export const isTransactionsImportStatus = (obj?: { __typename?: any } | null): obj is TransactionsImportStatus => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTransactionsImportStatus"')
      return TransactionsImportStatus_possibleTypes.includes(obj.__typename)
    }
    


    const UnconnectedAccount_possibleTypes: string[] = ['UnconnectedAccount']
    export const isUnconnectedAccount = (obj?: { __typename?: any } | null): obj is UnconnectedAccount => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUnconnectedAccount"')
      return UnconnectedAccount_possibleTypes.includes(obj.__typename)
    }
    


    const UnidentifiedBankTransactionParty_possibleTypes: string[] = ['BankAccount','UnknownTransactionBank','UnknownTransactionAccount','UnconnectedAccount','Vendor','TransactionDescription']
    export const isUnidentifiedBankTransactionParty = (obj?: { __typename?: any } | null): obj is UnidentifiedBankTransactionParty => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUnidentifiedBankTransactionParty"')
      return UnidentifiedBankTransactionParty_possibleTypes.includes(obj.__typename)
    }
    


    const UnidentifiedBankTransactionsGroup_possibleTypes: string[] = ['UnidentifiedBankTransactionsGroup']
    export const isUnidentifiedBankTransactionsGroup = (obj?: { __typename?: any } | null): obj is UnidentifiedBankTransactionsGroup => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUnidentifiedBankTransactionsGroup"')
      return UnidentifiedBankTransactionsGroup_possibleTypes.includes(obj.__typename)
    }
    


    const UnitBasedClosingBalance_possibleTypes: string[] = ['UnitBasedClosingBalance']
    export const isUnitBasedClosingBalance = (obj?: { __typename?: any } | null): obj is UnitBasedClosingBalance => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUnitBasedClosingBalance"')
      return UnitBasedClosingBalance_possibleTypes.includes(obj.__typename)
    }
    


    const UnitBasedNegativeOnHands_possibleTypes: string[] = ['UnitBasedNegativeOnHands']
    export const isUnitBasedNegativeOnHands = (obj?: { __typename?: any } | null): obj is UnitBasedNegativeOnHands => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUnitBasedNegativeOnHands"')
      return UnitBasedNegativeOnHands_possibleTypes.includes(obj.__typename)
    }
    


    const UnitBasedReportCogs_possibleTypes: string[] = ['UnitBasedReportCogs']
    export const isUnitBasedReportCogs = (obj?: { __typename?: any } | null): obj is UnitBasedReportCogs => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUnitBasedReportCogs"')
      return UnitBasedReportCogs_possibleTypes.includes(obj.__typename)
    }
    


    const UnitBasedVendorsNegativeBalance_possibleTypes: string[] = ['UnitBasedVendorsNegativeBalance']
    export const isUnitBasedVendorsNegativeBalance = (obj?: { __typename?: any } | null): obj is UnitBasedVendorsNegativeBalance => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUnitBasedVendorsNegativeBalance"')
      return UnitBasedVendorsNegativeBalance_possibleTypes.includes(obj.__typename)
    }
    


    const UnitFoundAction_possibleTypes: string[] = ['UnitFoundAction']
    export const isUnitFoundAction = (obj?: { __typename?: any } | null): obj is UnitFoundAction => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUnitFoundAction"')
      return UnitFoundAction_possibleTypes.includes(obj.__typename)
    }
    


    const UnitLostAction_possibleTypes: string[] = ['UnitLostAction']
    export const isUnitLostAction = (obj?: { __typename?: any } | null): obj is UnitLostAction => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUnitLostAction"')
      return UnitLostAction_possibleTypes.includes(obj.__typename)
    }
    


    const UnitsTrackingPhysicalCount_possibleTypes: string[] = ['UnitsTrackingPhysicalCount']
    export const isUnitsTrackingPhysicalCount = (obj?: { __typename?: any } | null): obj is UnitsTrackingPhysicalCount => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUnitsTrackingPhysicalCount"')
      return UnitsTrackingPhysicalCount_possibleTypes.includes(obj.__typename)
    }
    


    const UnitsTrackingPhysicalCountAttachment_possibleTypes: string[] = ['UnitsTrackingPhysicalCountAttachment']
    export const isUnitsTrackingPhysicalCountAttachment = (obj?: { __typename?: any } | null): obj is UnitsTrackingPhysicalCountAttachment => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUnitsTrackingPhysicalCountAttachment"')
      return UnitsTrackingPhysicalCountAttachment_possibleTypes.includes(obj.__typename)
    }
    


    const UnitsTrackingPhysicalCountOverview_possibleTypes: string[] = ['UnitsTrackingPhysicalCountOverview']
    export const isUnitsTrackingPhysicalCountOverview = (obj?: { __typename?: any } | null): obj is UnitsTrackingPhysicalCountOverview => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUnitsTrackingPhysicalCountOverview"')
      return UnitsTrackingPhysicalCountOverview_possibleTypes.includes(obj.__typename)
    }
    


    const UnitsTrackingPhysicalCountProductQuantities_possibleTypes: string[] = ['UnitsTrackingPhysicalCountProductQuantities']
    export const isUnitsTrackingPhysicalCountProductQuantities = (obj?: { __typename?: any } | null): obj is UnitsTrackingPhysicalCountProductQuantities => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUnitsTrackingPhysicalCountProductQuantities"')
      return UnitsTrackingPhysicalCountProductQuantities_possibleTypes.includes(obj.__typename)
    }
    


    const UnitsTrackingPhysicalCountProductQuantity_possibleTypes: string[] = ['UnitsTrackingPhysicalCountProductQuantity']
    export const isUnitsTrackingPhysicalCountProductQuantity = (obj?: { __typename?: any } | null): obj is UnitsTrackingPhysicalCountProductQuantity => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUnitsTrackingPhysicalCountProductQuantity"')
      return UnitsTrackingPhysicalCountProductQuantity_possibleTypes.includes(obj.__typename)
    }
    


    const UnitsTrackingPhysicalCountsList_possibleTypes: string[] = ['UnitsTrackingPhysicalCountsList']
    export const isUnitsTrackingPhysicalCountsList = (obj?: { __typename?: any } | null): obj is UnitsTrackingPhysicalCountsList => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUnitsTrackingPhysicalCountsList"')
      return UnitsTrackingPhysicalCountsList_possibleTypes.includes(obj.__typename)
    }
    


    const UnknownIntegrationTransferAccount_possibleTypes: string[] = ['UnknownIntegrationTransferAccount']
    export const isUnknownIntegrationTransferAccount = (obj?: { __typename?: any } | null): obj is UnknownIntegrationTransferAccount => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUnknownIntegrationTransferAccount"')
      return UnknownIntegrationTransferAccount_possibleTypes.includes(obj.__typename)
    }
    


    const UnknownIntegrationTransferBank_possibleTypes: string[] = ['UnknownIntegrationTransferBank']
    export const isUnknownIntegrationTransferBank = (obj?: { __typename?: any } | null): obj is UnknownIntegrationTransferBank => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUnknownIntegrationTransferBank"')
      return UnknownIntegrationTransferBank_possibleTypes.includes(obj.__typename)
    }
    


    const UnknownTransactionAccount_possibleTypes: string[] = ['UnknownTransactionAccount']
    export const isUnknownTransactionAccount = (obj?: { __typename?: any } | null): obj is UnknownTransactionAccount => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUnknownTransactionAccount"')
      return UnknownTransactionAccount_possibleTypes.includes(obj.__typename)
    }
    


    const UnknownTransactionBank_possibleTypes: string[] = ['UnknownTransactionBank']
    export const isUnknownTransactionBank = (obj?: { __typename?: any } | null): obj is UnknownTransactionBank => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUnknownTransactionBank"')
      return UnknownTransactionBank_possibleTypes.includes(obj.__typename)
    }
    


    const UnlockLoanResult_possibleTypes: string[] = ['UnlockLoanResult']
    export const isUnlockLoanResult = (obj?: { __typename?: any } | null): obj is UnlockLoanResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUnlockLoanResult"')
      return UnlockLoanResult_possibleTypes.includes(obj.__typename)
    }
    


    const UnMarkOrdersAsCOGSResponse_possibleTypes: string[] = ['UnMarkOrdersAsCOGSResponse']
    export const isUnMarkOrdersAsCOGSResponse = (obj?: { __typename?: any } | null): obj is UnMarkOrdersAsCOGSResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUnMarkOrdersAsCOGSResponse"')
      return UnMarkOrdersAsCOGSResponse_possibleTypes.includes(obj.__typename)
    }
    


    const UnMarkOrdersAsGiveawayResponse_possibleTypes: string[] = ['UnMarkOrdersAsGiveawayResponse']
    export const isUnMarkOrdersAsGiveawayResponse = (obj?: { __typename?: any } | null): obj is UnMarkOrdersAsGiveawayResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUnMarkOrdersAsGiveawayResponse"')
      return UnMarkOrdersAsGiveawayResponse_possibleTypes.includes(obj.__typename)
    }
    


    const UnMarkOrdersAsOvercollectedResponse_possibleTypes: string[] = ['UnMarkOrdersAsOvercollectedResponse']
    export const isUnMarkOrdersAsOvercollectedResponse = (obj?: { __typename?: any } | null): obj is UnMarkOrdersAsOvercollectedResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUnMarkOrdersAsOvercollectedResponse"')
      return UnMarkOrdersAsOvercollectedResponse_possibleTypes.includes(obj.__typename)
    }
    


    const UnMarkOrdersAsUncollectibleResponse_possibleTypes: string[] = ['UnMarkOrdersAsUncollectibleResponse']
    export const isUnMarkOrdersAsUncollectibleResponse = (obj?: { __typename?: any } | null): obj is UnMarkOrdersAsUncollectibleResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUnMarkOrdersAsUncollectibleResponse"')
      return UnMarkOrdersAsUncollectibleResponse_possibleTypes.includes(obj.__typename)
    }
    


    const UnpaidAmountPerAffiliatedEntity_possibleTypes: string[] = ['UnpaidAmountPerAffiliatedEntity']
    export const isUnpaidAmountPerAffiliatedEntity = (obj?: { __typename?: any } | null): obj is UnpaidAmountPerAffiliatedEntity => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUnpaidAmountPerAffiliatedEntity"')
      return UnpaidAmountPerAffiliatedEntity_possibleTypes.includes(obj.__typename)
    }
    


    const UnpaidAmountsViaProvider_possibleTypes: string[] = ['UnpaidAmountsViaProvider']
    export const isUnpaidAmountsViaProvider = (obj?: { __typename?: any } | null): obj is UnpaidAmountsViaProvider => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUnpaidAmountsViaProvider"')
      return UnpaidAmountsViaProvider_possibleTypes.includes(obj.__typename)
    }
    


    const UnvoidOrdersResponse_possibleTypes: string[] = ['UnvoidOrdersResponse']
    export const isUnvoidOrdersResponse = (obj?: { __typename?: any } | null): obj is UnvoidOrdersResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUnvoidOrdersResponse"')
      return UnvoidOrdersResponse_possibleTypes.includes(obj.__typename)
    }
    


    const UpdateAssociatedBankTransactionsFileResponse_possibleTypes: string[] = ['UpdateAssociatedBankTransactionsFileResponse']
    export const isUpdateAssociatedBankTransactionsFileResponse = (obj?: { __typename?: any } | null): obj is UpdateAssociatedBankTransactionsFileResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUpdateAssociatedBankTransactionsFileResponse"')
      return UpdateAssociatedBankTransactionsFileResponse_possibleTypes.includes(obj.__typename)
    }
    


    const UpdateBalanceSheetSetupItemResponse_possibleTypes: string[] = ['UpdateBalanceSheetSetupItemResponse']
    export const isUpdateBalanceSheetSetupItemResponse = (obj?: { __typename?: any } | null): obj is UpdateBalanceSheetSetupItemResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUpdateBalanceSheetSetupItemResponse"')
      return UpdateBalanceSheetSetupItemResponse_possibleTypes.includes(obj.__typename)
    }
    


    const UpdateBalanceSheetSetupResponse_possibleTypes: string[] = ['UpdateBalanceSheetSetupResponse']
    export const isUpdateBalanceSheetSetupResponse = (obj?: { __typename?: any } | null): obj is UpdateBalanceSheetSetupResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUpdateBalanceSheetSetupResponse"')
      return UpdateBalanceSheetSetupResponse_possibleTypes.includes(obj.__typename)
    }
    


    const UpdateCompanyDomainStateResponse_possibleTypes: string[] = ['UpdateCompanyDomainStateResponse']
    export const isUpdateCompanyDomainStateResponse = (obj?: { __typename?: any } | null): obj is UpdateCompanyDomainStateResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUpdateCompanyDomainStateResponse"')
      return UpdateCompanyDomainStateResponse_possibleTypes.includes(obj.__typename)
    }
    


    const UpdateCompanyLoansResponse_possibleTypes: string[] = ['UpdateCompanyLoansResponse']
    export const isUpdateCompanyLoansResponse = (obj?: { __typename?: any } | null): obj is UpdateCompanyLoansResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUpdateCompanyLoansResponse"')
      return UpdateCompanyLoansResponse_possibleTypes.includes(obj.__typename)
    }
    


    const UpdatedLoans_possibleTypes: string[] = ['UpdatedLoans']
    export const isUpdatedLoans = (obj?: { __typename?: any } | null): obj is UpdatedLoans => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUpdatedLoans"')
      return UpdatedLoans_possibleTypes.includes(obj.__typename)
    }
    


    const UpdateInventoryPaymentGroupResponse_possibleTypes: string[] = ['UpdateInventoryPaymentGroupResponse']
    export const isUpdateInventoryPaymentGroupResponse = (obj?: { __typename?: any } | null): obj is UpdateInventoryPaymentGroupResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUpdateInventoryPaymentGroupResponse"')
      return UpdateInventoryPaymentGroupResponse_possibleTypes.includes(obj.__typename)
    }
    


    const UpdateInventoryPurchaseResponse_possibleTypes: string[] = ['InventoryPurchase','InventoryPurchaseUpdateOutOfDateError']
    export const isUpdateInventoryPurchaseResponse = (obj?: { __typename?: any } | null): obj is UpdateInventoryPurchaseResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUpdateInventoryPurchaseResponse"')
      return UpdateInventoryPurchaseResponse_possibleTypes.includes(obj.__typename)
    }
    


    const UpdateInvoicePaymentGroupResponse_possibleTypes: string[] = ['UpdateInvoicePaymentGroupResponse']
    export const isUpdateInvoicePaymentGroupResponse = (obj?: { __typename?: any } | null): obj is UpdateInvoicePaymentGroupResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUpdateInvoicePaymentGroupResponse"')
      return UpdateInvoicePaymentGroupResponse_possibleTypes.includes(obj.__typename)
    }
    


    const UpdateManualAssemblyResult_possibleTypes: string[] = ['ManualAssembly','RecipeCirclesFoundError','RecipeAllocatedCostsError']
    export const isUpdateManualAssemblyResult = (obj?: { __typename?: any } | null): obj is UpdateManualAssemblyResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUpdateManualAssemblyResult"')
      return UpdateManualAssemblyResult_possibleTypes.includes(obj.__typename)
    }
    


    const UpdateManualLoanEventResult_possibleTypes: string[] = ['UpdateManualLoanEventResult']
    export const isUpdateManualLoanEventResult = (obj?: { __typename?: any } | null): obj is UpdateManualLoanEventResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUpdateManualLoanEventResult"')
      return UpdateManualLoanEventResult_possibleTypes.includes(obj.__typename)
    }
    


    const UpdateManualLoanEventsResult_possibleTypes: string[] = ['UpdateManualLoanEventsResult']
    export const isUpdateManualLoanEventsResult = (obj?: { __typename?: any } | null): obj is UpdateManualLoanEventsResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUpdateManualLoanEventsResult"')
      return UpdateManualLoanEventsResult_possibleTypes.includes(obj.__typename)
    }
    


    const UpdateOrderGroupResponse_possibleTypes: string[] = ['UpdateOrderGroupResponse']
    export const isUpdateOrderGroupResponse = (obj?: { __typename?: any } | null): obj is UpdateOrderGroupResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUpdateOrderGroupResponse"')
      return UpdateOrderGroupResponse_possibleTypes.includes(obj.__typename)
    }
    


    const UpdateOrderPaymentGroupResponse_possibleTypes: string[] = ['UpdateOrderPaymentGroupResponse']
    export const isUpdateOrderPaymentGroupResponse = (obj?: { __typename?: any } | null): obj is UpdateOrderPaymentGroupResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUpdateOrderPaymentGroupResponse"')
      return UpdateOrderPaymentGroupResponse_possibleTypes.includes(obj.__typename)
    }
    


    const UpdateRecipeResult_possibleTypes: string[] = ['Recipe','RecipeCirclesFoundError','RecipeOverlappingError','RecipeAllocatedCostsError']
    export const isUpdateRecipeResult = (obj?: { __typename?: any } | null): obj is UpdateRecipeResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUpdateRecipeResult"')
      return UpdateRecipeResult_possibleTypes.includes(obj.__typename)
    }
    


    const UpdateUserDetailsResponse_possibleTypes: string[] = ['UpdateUserDetailsResponse']
    export const isUpdateUserDetailsResponse = (obj?: { __typename?: any } | null): obj is UpdateUserDetailsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUpdateUserDetailsResponse"')
      return UpdateUserDetailsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const UpdateUserRolesForCompanyResponse_possibleTypes: string[] = ['UpdateUserRolesForCompanyResponse']
    export const isUpdateUserRolesForCompanyResponse = (obj?: { __typename?: any } | null): obj is UpdateUserRolesForCompanyResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUpdateUserRolesForCompanyResponse"')
      return UpdateUserRolesForCompanyResponse_possibleTypes.includes(obj.__typename)
    }
    


    const UploadBankStatementResponse_possibleTypes: string[] = ['UploadBankStatementResponse']
    export const isUploadBankStatementResponse = (obj?: { __typename?: any } | null): obj is UploadBankStatementResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUploadBankStatementResponse"')
      return UploadBankStatementResponse_possibleTypes.includes(obj.__typename)
    }
    


    const UploadedInvoice_possibleTypes: string[] = ['UploadedInvoice']
    export const isUploadedInvoice = (obj?: { __typename?: any } | null): obj is UploadedInvoice => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUploadedInvoice"')
      return UploadedInvoice_possibleTypes.includes(obj.__typename)
    }
    


    const User_possibleTypes: string[] = ['User']
    export const isUser = (obj?: { __typename?: any } | null): obj is User => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUser"')
      return User_possibleTypes.includes(obj.__typename)
    }
    


    const UserByEmailResponse_possibleTypes: string[] = ['UserByEmailResponse']
    export const isUserByEmailResponse = (obj?: { __typename?: any } | null): obj is UserByEmailResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUserByEmailResponse"')
      return UserByEmailResponse_possibleTypes.includes(obj.__typename)
    }
    


    const UserCompanies_possibleTypes: string[] = ['UserCompanies']
    export const isUserCompanies = (obj?: { __typename?: any } | null): obj is UserCompanies => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUserCompanies"')
      return UserCompanies_possibleTypes.includes(obj.__typename)
    }
    


    const UserFollowUp_possibleTypes: string[] = ['UserFollowUp']
    export const isUserFollowUp = (obj?: { __typename?: any } | null): obj is UserFollowUp => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUserFollowUp"')
      return UserFollowUp_possibleTypes.includes(obj.__typename)
    }
    


    const UserInvitation_possibleTypes: string[] = ['UserInvitation']
    export const isUserInvitation = (obj?: { __typename?: any } | null): obj is UserInvitation => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUserInvitation"')
      return UserInvitation_possibleTypes.includes(obj.__typename)
    }
    


    const UserInvitationResponse_possibleTypes: string[] = ['UserInvitationResponse']
    export const isUserInvitationResponse = (obj?: { __typename?: any } | null): obj is UserInvitationResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUserInvitationResponse"')
      return UserInvitationResponse_possibleTypes.includes(obj.__typename)
    }
    


    const UserInvitationsByEmailResponse_possibleTypes: string[] = ['UserInvitationsByEmailResponse']
    export const isUserInvitationsByEmailResponse = (obj?: { __typename?: any } | null): obj is UserInvitationsByEmailResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUserInvitationsByEmailResponse"')
      return UserInvitationsByEmailResponse_possibleTypes.includes(obj.__typename)
    }
    


    const UserInvitationWithCompany_possibleTypes: string[] = ['UserInvitationWithCompany']
    export const isUserInvitationWithCompany = (obj?: { __typename?: any } | null): obj is UserInvitationWithCompany => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUserInvitationWithCompany"')
      return UserInvitationWithCompany_possibleTypes.includes(obj.__typename)
    }
    


    const UserManualProduct_possibleTypes: string[] = ['UserManualProduct']
    export const isUserManualProduct = (obj?: { __typename?: any } | null): obj is UserManualProduct => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUserManualProduct"')
      return UserManualProduct_possibleTypes.includes(obj.__typename)
    }
    


    const UserNameFromReferralCodeResponse_possibleTypes: string[] = ['UserNameFromReferralCodeResponse']
    export const isUserNameFromReferralCodeResponse = (obj?: { __typename?: any } | null): obj is UserNameFromReferralCodeResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUserNameFromReferralCodeResponse"')
      return UserNameFromReferralCodeResponse_possibleTypes.includes(obj.__typename)
    }
    


    const UserReferralLinkResponse_possibleTypes: string[] = ['UserReferralLinkResponse']
    export const isUserReferralLinkResponse = (obj?: { __typename?: any } | null): obj is UserReferralLinkResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUserReferralLinkResponse"')
      return UserReferralLinkResponse_possibleTypes.includes(obj.__typename)
    }
    


    const UserRole_possibleTypes: string[] = ['UserRole']
    export const isUserRole = (obj?: { __typename?: any } | null): obj is UserRole => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUserRole"')
      return UserRole_possibleTypes.includes(obj.__typename)
    }
    


    const UserRolesResponse_possibleTypes: string[] = ['UserRolesResponse']
    export const isUserRolesResponse = (obj?: { __typename?: any } | null): obj is UserRolesResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUserRolesResponse"')
      return UserRolesResponse_possibleTypes.includes(obj.__typename)
    }
    


    const UsersByEmailsResponse_possibleTypes: string[] = ['UsersByEmailsResponse']
    export const isUsersByEmailsResponse = (obj?: { __typename?: any } | null): obj is UsersByEmailsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUsersByEmailsResponse"')
      return UsersByEmailsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const UserUnresponsive_possibleTypes: string[] = ['UserUnresponsive']
    export const isUserUnresponsive = (obj?: { __typename?: any } | null): obj is UserUnresponsive => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUserUnresponsive"')
      return UserUnresponsive_possibleTypes.includes(obj.__typename)
    }
    


    const ValidateInventoryPaymentGroupByEntityResponse_possibleTypes: string[] = ['ValidateInventoryPaymentGroupByEntityResponse']
    export const isValidateInventoryPaymentGroupByEntityResponse = (obj?: { __typename?: any } | null): obj is ValidateInventoryPaymentGroupByEntityResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isValidateInventoryPaymentGroupByEntityResponse"')
      return ValidateInventoryPaymentGroupByEntityResponse_possibleTypes.includes(obj.__typename)
    }
    


    const Validation_possibleTypes: string[] = ['Validation']
    export const isValidation = (obj?: { __typename?: any } | null): obj is Validation => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isValidation"')
      return Validation_possibleTypes.includes(obj.__typename)
    }
    


    const ValidationCycle_possibleTypes: string[] = ['ValidationCycle']
    export const isValidationCycle = (obj?: { __typename?: any } | null): obj is ValidationCycle => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isValidationCycle"')
      return ValidationCycle_possibleTypes.includes(obj.__typename)
    }
    


    const ValidationFailingCompany_possibleTypes: string[] = ['ValidationFailingCompany']
    export const isValidationFailingCompany = (obj?: { __typename?: any } | null): obj is ValidationFailingCompany => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isValidationFailingCompany"')
      return ValidationFailingCompany_possibleTypes.includes(obj.__typename)
    }
    


    const ValidationRemediation_possibleTypes: string[] = ['ValidationRemediation']
    export const isValidationRemediation = (obj?: { __typename?: any } | null): obj is ValidationRemediation => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isValidationRemediation"')
      return ValidationRemediation_possibleTypes.includes(obj.__typename)
    }
    


    const ValidationRemediationsResponse_possibleTypes: string[] = ['ValidationRemediationsResponse']
    export const isValidationRemediationsResponse = (obj?: { __typename?: any } | null): obj is ValidationRemediationsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isValidationRemediationsResponse"')
      return ValidationRemediationsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const ValidationResult_possibleTypes: string[] = ['ValidationResult']
    export const isValidationResult = (obj?: { __typename?: any } | null): obj is ValidationResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isValidationResult"')
      return ValidationResult_possibleTypes.includes(obj.__typename)
    }
    


    const ValidationResultSet_possibleTypes: string[] = ['ValidationResultSet']
    export const isValidationResultSet = (obj?: { __typename?: any } | null): obj is ValidationResultSet => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isValidationResultSet"')
      return ValidationResultSet_possibleTypes.includes(obj.__typename)
    }
    


    const ValidationTemplate_possibleTypes: string[] = ['ValidationTemplate']
    export const isValidationTemplate = (obj?: { __typename?: any } | null): obj is ValidationTemplate => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isValidationTemplate"')
      return ValidationTemplate_possibleTypes.includes(obj.__typename)
    }
    


    const Vendor_possibleTypes: string[] = ['Vendor']
    export const isVendor = (obj?: { __typename?: any } | null): obj is Vendor => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isVendor"')
      return Vendor_possibleTypes.includes(obj.__typename)
    }
    


    const VendorByPaymentGatewayResponse_possibleTypes: string[] = ['VendorByPaymentGatewayResponse']
    export const isVendorByPaymentGatewayResponse = (obj?: { __typename?: any } | null): obj is VendorByPaymentGatewayResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isVendorByPaymentGatewayResponse"')
      return VendorByPaymentGatewayResponse_possibleTypes.includes(obj.__typename)
    }
    


    const VendorNotExistError_possibleTypes: string[] = ['VendorNotExistError']
    export const isVendorNotExistError = (obj?: { __typename?: any } | null): obj is VendorNotExistError => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isVendorNotExistError"')
      return VendorNotExistError_possibleTypes.includes(obj.__typename)
    }
    


    const VendorOrCustomer_possibleTypes: string[] = ['Vendor','CustomerV2']
    export const isVendorOrCustomer = (obj?: { __typename?: any } | null): obj is VendorOrCustomer => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isVendorOrCustomer"')
      return VendorOrCustomer_possibleTypes.includes(obj.__typename)
    }
    


    const VendorsTransactionsCount_possibleTypes: string[] = ['VendorsTransactionsCount']
    export const isVendorsTransactionsCount = (obj?: { __typename?: any } | null): obj is VendorsTransactionsCount => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isVendorsTransactionsCount"')
      return VendorsTransactionsCount_possibleTypes.includes(obj.__typename)
    }
    


    const VoidOrderSettings_possibleTypes: string[] = ['VoidOrderSettings']
    export const isVoidOrderSettings = (obj?: { __typename?: any } | null): obj is VoidOrderSettings => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isVoidOrderSettings"')
      return VoidOrderSettings_possibleTypes.includes(obj.__typename)
    }
    


    const VoidOrdersResponse_possibleTypes: string[] = ['VoidOrdersResponse']
    export const isVoidOrdersResponse = (obj?: { __typename?: any } | null): obj is VoidOrdersResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isVoidOrdersResponse"')
      return VoidOrdersResponse_possibleTypes.includes(obj.__typename)
    }
    


    const WalmartProduct_possibleTypes: string[] = ['WalmartProduct']
    export const isWalmartProduct = (obj?: { __typename?: any } | null): obj is WalmartProduct => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWalmartProduct"')
      return WalmartProduct_possibleTypes.includes(obj.__typename)
    }
    


    const Warehouse_possibleTypes: string[] = ['Warehouse']
    export const isWarehouse = (obj?: { __typename?: any } | null): obj is Warehouse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWarehouse"')
      return Warehouse_possibleTypes.includes(obj.__typename)
    }
    


    const WarehouseAction_possibleTypes: string[] = ['AdjustmentRestockingAction','CommonAction','DeadInventoryAction','FulfillmentAction','ManualAssemblyAction','OnDemandAssemblyAction','OpeningBalanceAction','OtherFbaAction','RestockingAction','ShipmentAction','UnitFoundAction','UnitLostAction','WarehouseNegativesAdjustmentAction','WarehouseTransferArrivalAction','WarehouseTransferShippingAction','WasteAction']
    export const isWarehouseAction = (obj?: { __typename?: any } | null): obj is WarehouseAction => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWarehouseAction"')
      return WarehouseAction_possibleTypes.includes(obj.__typename)
    }
    


    const WarehouseActionSalesChannel_possibleTypes: string[] = ['WarehouseActionSalesChannel']
    export const isWarehouseActionSalesChannel = (obj?: { __typename?: any } | null): obj is WarehouseActionSalesChannel => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWarehouseActionSalesChannel"')
      return WarehouseActionSalesChannel_possibleTypes.includes(obj.__typename)
    }
    


    const WarehouseCreateError_possibleTypes: string[] = ['WarehouseCreateError']
    export const isWarehouseCreateError = (obj?: { __typename?: any } | null): obj is WarehouseCreateError => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWarehouseCreateError"')
      return WarehouseCreateError_possibleTypes.includes(obj.__typename)
    }
    


    const WarehouseCreateResult_possibleTypes: string[] = ['Warehouse','WarehouseCreateError']
    export const isWarehouseCreateResult = (obj?: { __typename?: any } | null): obj is WarehouseCreateResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWarehouseCreateResult"')
      return WarehouseCreateResult_possibleTypes.includes(obj.__typename)
    }
    


    const WarehouseIncomingInventoryBreakdownResult_possibleTypes: string[] = ['WarehouseIncomingInventoryBreakdownResult']
    export const isWarehouseIncomingInventoryBreakdownResult = (obj?: { __typename?: any } | null): obj is WarehouseIncomingInventoryBreakdownResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWarehouseIncomingInventoryBreakdownResult"')
      return WarehouseIncomingInventoryBreakdownResult_possibleTypes.includes(obj.__typename)
    }
    


    const WarehouseIncomingInventoryOverviewResult_possibleTypes: string[] = ['WarehouseIncomingInventoryOverviewResult']
    export const isWarehouseIncomingInventoryOverviewResult = (obj?: { __typename?: any } | null): obj is WarehouseIncomingInventoryOverviewResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWarehouseIncomingInventoryOverviewResult"')
      return WarehouseIncomingInventoryOverviewResult_possibleTypes.includes(obj.__typename)
    }
    


    const WarehouseMovements_possibleTypes: string[] = ['WarehouseMovements']
    export const isWarehouseMovements = (obj?: { __typename?: any } | null): obj is WarehouseMovements => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWarehouseMovements"')
      return WarehouseMovements_possibleTypes.includes(obj.__typename)
    }
    


    const WarehouseNegativesAdjustment_possibleTypes: string[] = ['WarehouseNegativesAdjustment']
    export const isWarehouseNegativesAdjustment = (obj?: { __typename?: any } | null): obj is WarehouseNegativesAdjustment => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWarehouseNegativesAdjustment"')
      return WarehouseNegativesAdjustment_possibleTypes.includes(obj.__typename)
    }
    


    const WarehouseNegativesAdjustmentAction_possibleTypes: string[] = ['WarehouseNegativesAdjustmentAction']
    export const isWarehouseNegativesAdjustmentAction = (obj?: { __typename?: any } | null): obj is WarehouseNegativesAdjustmentAction => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWarehouseNegativesAdjustmentAction"')
      return WarehouseNegativesAdjustmentAction_possibleTypes.includes(obj.__typename)
    }
    


    const WarehouseNegativesAdjustmentBreakdown_possibleTypes: string[] = ['WarehouseNegativesAdjustmentBreakdown']
    export const isWarehouseNegativesAdjustmentBreakdown = (obj?: { __typename?: any } | null): obj is WarehouseNegativesAdjustmentBreakdown => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWarehouseNegativesAdjustmentBreakdown"')
      return WarehouseNegativesAdjustmentBreakdown_possibleTypes.includes(obj.__typename)
    }
    


    const WarehouseOpeningBalance_possibleTypes: string[] = ['WarehouseOpeningBalance']
    export const isWarehouseOpeningBalance = (obj?: { __typename?: any } | null): obj is WarehouseOpeningBalance => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWarehouseOpeningBalance"')
      return WarehouseOpeningBalance_possibleTypes.includes(obj.__typename)
    }
    


    const WarehouseOpeningBalanceErrorItem_possibleTypes: string[] = ['WarehouseOpeningBalanceErrorItem']
    export const isWarehouseOpeningBalanceErrorItem = (obj?: { __typename?: any } | null): obj is WarehouseOpeningBalanceErrorItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWarehouseOpeningBalanceErrorItem"')
      return WarehouseOpeningBalanceErrorItem_possibleTypes.includes(obj.__typename)
    }
    


    const WarehouseOpeningBalanceItem_possibleTypes: string[] = ['WarehouseOpeningBalanceItem']
    export const isWarehouseOpeningBalanceItem = (obj?: { __typename?: any } | null): obj is WarehouseOpeningBalanceItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWarehouseOpeningBalanceItem"')
      return WarehouseOpeningBalanceItem_possibleTypes.includes(obj.__typename)
    }
    


    const WarehouseOpeningBalanceOverviewResponse_possibleTypes: string[] = ['WarehouseOpeningBalanceOverviewResponse']
    export const isWarehouseOpeningBalanceOverviewResponse = (obj?: { __typename?: any } | null): obj is WarehouseOpeningBalanceOverviewResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWarehouseOpeningBalanceOverviewResponse"')
      return WarehouseOpeningBalanceOverviewResponse_possibleTypes.includes(obj.__typename)
    }
    


    const WarehouseOpeningBalancesCsvResponse_possibleTypes: string[] = ['WarehouseOpeningBalancesCsvResponse']
    export const isWarehouseOpeningBalancesCsvResponse = (obj?: { __typename?: any } | null): obj is WarehouseOpeningBalancesCsvResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWarehouseOpeningBalancesCsvResponse"')
      return WarehouseOpeningBalancesCsvResponse_possibleTypes.includes(obj.__typename)
    }
    


    const WarehouseOpeningBalancesCsvTemplateResponse_possibleTypes: string[] = ['WarehouseOpeningBalancesCsvTemplateResponse']
    export const isWarehouseOpeningBalancesCsvTemplateResponse = (obj?: { __typename?: any } | null): obj is WarehouseOpeningBalancesCsvTemplateResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWarehouseOpeningBalancesCsvTemplateResponse"')
      return WarehouseOpeningBalancesCsvTemplateResponse_possibleTypes.includes(obj.__typename)
    }
    


    const WarehouseOpeningBalancesResponse_possibleTypes: string[] = ['WarehouseOpeningBalancesResponse']
    export const isWarehouseOpeningBalancesResponse = (obj?: { __typename?: any } | null): obj is WarehouseOpeningBalancesResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWarehouseOpeningBalancesResponse"')
      return WarehouseOpeningBalancesResponse_possibleTypes.includes(obj.__typename)
    }
    


    const WarehouseResult_possibleTypes: string[] = ['WarehouseResult']
    export const isWarehouseResult = (obj?: { __typename?: any } | null): obj is WarehouseResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWarehouseResult"')
      return WarehouseResult_possibleTypes.includes(obj.__typename)
    }
    


    const WarehouseSalesData_possibleTypes: string[] = ['WarehouseSalesData']
    export const isWarehouseSalesData = (obj?: { __typename?: any } | null): obj is WarehouseSalesData => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWarehouseSalesData"')
      return WarehouseSalesData_possibleTypes.includes(obj.__typename)
    }
    


    const WarehousesDefaults_possibleTypes: string[] = ['WarehousesDefaults']
    export const isWarehousesDefaults = (obj?: { __typename?: any } | null): obj is WarehousesDefaults => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWarehousesDefaults"')
      return WarehousesDefaults_possibleTypes.includes(obj.__typename)
    }
    


    const WarehousesDefaultsError_possibleTypes: string[] = ['WarehousesDefaultsError']
    export const isWarehousesDefaultsError = (obj?: { __typename?: any } | null): obj is WarehousesDefaultsError => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWarehousesDefaultsError"')
      return WarehousesDefaultsError_possibleTypes.includes(obj.__typename)
    }
    


    const WarehousesDefaultsResponse_possibleTypes: string[] = ['WarehousesDefaultsResult','WarehousesDefaultsError']
    export const isWarehousesDefaultsResponse = (obj?: { __typename?: any } | null): obj is WarehousesDefaultsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWarehousesDefaultsResponse"')
      return WarehousesDefaultsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const WarehousesDefaultsResult_possibleTypes: string[] = ['WarehousesDefaultsResult']
    export const isWarehousesDefaultsResult = (obj?: { __typename?: any } | null): obj is WarehousesDefaultsResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWarehousesDefaultsResult"')
      return WarehousesDefaultsResult_possibleTypes.includes(obj.__typename)
    }
    


    const WarehouseTransfer_possibleTypes: string[] = ['WarehouseTransfer']
    export const isWarehouseTransfer = (obj?: { __typename?: any } | null): obj is WarehouseTransfer => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWarehouseTransfer"')
      return WarehouseTransfer_possibleTypes.includes(obj.__typename)
    }
    


    const WarehouseTransferArrival_possibleTypes: string[] = ['WarehouseTransferArrival']
    export const isWarehouseTransferArrival = (obj?: { __typename?: any } | null): obj is WarehouseTransferArrival => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWarehouseTransferArrival"')
      return WarehouseTransferArrival_possibleTypes.includes(obj.__typename)
    }
    


    const WarehouseTransferArrivalAction_possibleTypes: string[] = ['WarehouseTransferArrivalAction']
    export const isWarehouseTransferArrivalAction = (obj?: { __typename?: any } | null): obj is WarehouseTransferArrivalAction => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWarehouseTransferArrivalAction"')
      return WarehouseTransferArrivalAction_possibleTypes.includes(obj.__typename)
    }
    


    const WarehouseTransferAttachment_possibleTypes: string[] = ['WarehouseTransferAttachment']
    export const isWarehouseTransferAttachment = (obj?: { __typename?: any } | null): obj is WarehouseTransferAttachment => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWarehouseTransferAttachment"')
      return WarehouseTransferAttachment_possibleTypes.includes(obj.__typename)
    }
    


    const WarehouseTransferBatchHistoryItem_possibleTypes: string[] = ['WarehouseTransferBatchHistoryItem']
    export const isWarehouseTransferBatchHistoryItem = (obj?: { __typename?: any } | null): obj is WarehouseTransferBatchHistoryItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWarehouseTransferBatchHistoryItem"')
      return WarehouseTransferBatchHistoryItem_possibleTypes.includes(obj.__typename)
    }
    


    const WarehouseTransferBreakdownBatch_possibleTypes: string[] = ['WarehouseTransferBreakdownBatch']
    export const isWarehouseTransferBreakdownBatch = (obj?: { __typename?: any } | null): obj is WarehouseTransferBreakdownBatch => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWarehouseTransferBreakdownBatch"')
      return WarehouseTransferBreakdownBatch_possibleTypes.includes(obj.__typename)
    }
    


    const WarehouseTransferBreakdownItem_possibleTypes: string[] = ['WarehouseTransferBreakdownItem']
    export const isWarehouseTransferBreakdownItem = (obj?: { __typename?: any } | null): obj is WarehouseTransferBreakdownItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWarehouseTransferBreakdownItem"')
      return WarehouseTransferBreakdownItem_possibleTypes.includes(obj.__typename)
    }
    


    const WarehouseTransferCostAllocation_possibleTypes: string[] = ['WarehouseTransferCostAllocation']
    export const isWarehouseTransferCostAllocation = (obj?: { __typename?: any } | null): obj is WarehouseTransferCostAllocation => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWarehouseTransferCostAllocation"')
      return WarehouseTransferCostAllocation_possibleTypes.includes(obj.__typename)
    }
    


    const WarehouseTransferCostLineItem_possibleTypes: string[] = ['WarehouseTransferCostLineItem']
    export const isWarehouseTransferCostLineItem = (obj?: { __typename?: any } | null): obj is WarehouseTransferCostLineItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWarehouseTransferCostLineItem"')
      return WarehouseTransferCostLineItem_possibleTypes.includes(obj.__typename)
    }
    


    const WarehouseTransferLineItem_possibleTypes: string[] = ['WarehouseTransferLineItem']
    export const isWarehouseTransferLineItem = (obj?: { __typename?: any } | null): obj is WarehouseTransferLineItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWarehouseTransferLineItem"')
      return WarehouseTransferLineItem_possibleTypes.includes(obj.__typename)
    }
    


    const WarehouseTransferLineItemFifoCost_possibleTypes: string[] = ['WarehouseTransferLineItemFifoCost']
    export const isWarehouseTransferLineItemFifoCost = (obj?: { __typename?: any } | null): obj is WarehouseTransferLineItemFifoCost => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWarehouseTransferLineItemFifoCost"')
      return WarehouseTransferLineItemFifoCost_possibleTypes.includes(obj.__typename)
    }
    


    const WarehouseTransferLineItemFifoIndirectCost_possibleTypes: string[] = ['WarehouseTransferLineItemFifoIndirectCost']
    export const isWarehouseTransferLineItemFifoIndirectCost = (obj?: { __typename?: any } | null): obj is WarehouseTransferLineItemFifoIndirectCost => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWarehouseTransferLineItemFifoIndirectCost"')
      return WarehouseTransferLineItemFifoIndirectCost_possibleTypes.includes(obj.__typename)
    }
    


    const WarehouseTransferOverviewItem_possibleTypes: string[] = ['WarehouseTransferOverviewItem']
    export const isWarehouseTransferOverviewItem = (obj?: { __typename?: any } | null): obj is WarehouseTransferOverviewItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWarehouseTransferOverviewItem"')
      return WarehouseTransferOverviewItem_possibleTypes.includes(obj.__typename)
    }
    


    const WarehouseTransferShipping_possibleTypes: string[] = ['WarehouseTransferShipping']
    export const isWarehouseTransferShipping = (obj?: { __typename?: any } | null): obj is WarehouseTransferShipping => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWarehouseTransferShipping"')
      return WarehouseTransferShipping_possibleTypes.includes(obj.__typename)
    }
    


    const WarehouseTransferShippingAction_possibleTypes: string[] = ['WarehouseTransferShippingAction']
    export const isWarehouseTransferShippingAction = (obj?: { __typename?: any } | null): obj is WarehouseTransferShippingAction => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWarehouseTransferShippingAction"')
      return WarehouseTransferShippingAction_possibleTypes.includes(obj.__typename)
    }
    


    const WarehouseTransfersOverview_possibleTypes: string[] = ['WarehouseTransfersOverview']
    export const isWarehouseTransfersOverview = (obj?: { __typename?: any } | null): obj is WarehouseTransfersOverview => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWarehouseTransfersOverview"')
      return WarehouseTransfersOverview_possibleTypes.includes(obj.__typename)
    }
    


    const WarehouseTransfersResponse_possibleTypes: string[] = ['WarehouseTransfersResponse']
    export const isWarehouseTransfersResponse = (obj?: { __typename?: any } | null): obj is WarehouseTransfersResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWarehouseTransfersResponse"')
      return WarehouseTransfersResponse_possibleTypes.includes(obj.__typename)
    }
    


    const WarehouseTransferTransit_possibleTypes: string[] = ['WarehouseTransferTransit']
    export const isWarehouseTransferTransit = (obj?: { __typename?: any } | null): obj is WarehouseTransferTransit => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWarehouseTransferTransit"')
      return WarehouseTransferTransit_possibleTypes.includes(obj.__typename)
    }
    


    const WarehouseTransferWithBreakdown_possibleTypes: string[] = ['WarehouseTransferWithBreakdown']
    export const isWarehouseTransferWithBreakdown = (obj?: { __typename?: any } | null): obj is WarehouseTransferWithBreakdown => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWarehouseTransferWithBreakdown"')
      return WarehouseTransferWithBreakdown_possibleTypes.includes(obj.__typename)
    }
    


    const WasteAction_possibleTypes: string[] = ['WasteAction']
    export const isWasteAction = (obj?: { __typename?: any } | null): obj is WasteAction => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWasteAction"')
      return WasteAction_possibleTypes.includes(obj.__typename)
    }
    


    const WasteCogs_possibleTypes: string[] = ['WasteCogs']
    export const isWasteCogs = (obj?: { __typename?: any } | null): obj is WasteCogs => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWasteCogs"')
      return WasteCogs_possibleTypes.includes(obj.__typename)
    }
    


    const WasteDailyBreakdown_possibleTypes: string[] = ['WasteDailyBreakdown']
    export const isWasteDailyBreakdown = (obj?: { __typename?: any } | null): obj is WasteDailyBreakdown => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWasteDailyBreakdown"')
      return WasteDailyBreakdown_possibleTypes.includes(obj.__typename)
    }
    


    const WasteMonthlyBreakdown_possibleTypes: string[] = ['WasteMonthlyBreakdown']
    export const isWasteMonthlyBreakdown = (obj?: { __typename?: any } | null): obj is WasteMonthlyBreakdown => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWasteMonthlyBreakdown"')
      return WasteMonthlyBreakdown_possibleTypes.includes(obj.__typename)
    }
    


    const Worksheet_possibleTypes: string[] = ['Worksheet']
    export const isWorksheet = (obj?: { __typename?: any } | null): obj is Worksheet => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWorksheet"')
      return Worksheet_possibleTypes.includes(obj.__typename)
    }
    


    const WorksheetRow_possibleTypes: string[] = ['WorksheetRow']
    export const isWorksheetRow = (obj?: { __typename?: any } | null): obj is WorksheetRow => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWorksheetRow"')
      return WorksheetRow_possibleTypes.includes(obj.__typename)
    }
    


    const YearEndDependencies_possibleTypes: string[] = ['YearEndDependencies']
    export const isYearEndDependencies = (obj?: { __typename?: any } | null): obj is YearEndDependencies => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isYearEndDependencies"')
      return YearEndDependencies_possibleTypes.includes(obj.__typename)
    }
    


    const YearEndDependency_possibleTypes: string[] = ['YearEndDependency']
    export const isYearEndDependency = (obj?: { __typename?: any } | null): obj is YearEndDependency => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isYearEndDependency"')
      return YearEndDependency_possibleTypes.includes(obj.__typename)
    }
    


    const YearEndDomainsStates_possibleTypes: string[] = ['YearEndDomainsStates']
    export const isYearEndDomainsStates = (obj?: { __typename?: any } | null): obj is YearEndDomainsStates => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isYearEndDomainsStates"')
      return YearEndDomainsStates_possibleTypes.includes(obj.__typename)
    }
    


    const YearEndDomainStateChangeLog_possibleTypes: string[] = ['YearEndDomainStateChangeLog']
    export const isYearEndDomainStateChangeLog = (obj?: { __typename?: any } | null): obj is YearEndDomainStateChangeLog => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isYearEndDomainStateChangeLog"')
      return YearEndDomainStateChangeLog_possibleTypes.includes(obj.__typename)
    }
    


    const YearEndDomainStateDataChangeLog_possibleTypes: string[] = ['YearEndDomainStateDataChangeLog']
    export const isYearEndDomainStateDataChangeLog = (obj?: { __typename?: any } | null): obj is YearEndDomainStateDataChangeLog => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isYearEndDomainStateDataChangeLog"')
      return YearEndDomainStateDataChangeLog_possibleTypes.includes(obj.__typename)
    }
    


    const YearEndDomainStateDataDeleteResponse_possibleTypes: string[] = ['YearEndDomainStateDataDeleteResponse']
    export const isYearEndDomainStateDataDeleteResponse = (obj?: { __typename?: any } | null): obj is YearEndDomainStateDataDeleteResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isYearEndDomainStateDataDeleteResponse"')
      return YearEndDomainStateDataDeleteResponse_possibleTypes.includes(obj.__typename)
    }
    


    const YearEndDomainStateDataResponse_possibleTypes: string[] = ['YearEndDomainStateDataResponse']
    export const isYearEndDomainStateDataResponse = (obj?: { __typename?: any } | null): obj is YearEndDomainStateDataResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isYearEndDomainStateDataResponse"')
      return YearEndDomainStateDataResponse_possibleTypes.includes(obj.__typename)
    }
    


    const YearEndDomainStateDataUpdateResponse_possibleTypes: string[] = ['YearEndDomainStateDataUpdateResponse']
    export const isYearEndDomainStateDataUpdateResponse = (obj?: { __typename?: any } | null): obj is YearEndDomainStateDataUpdateResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isYearEndDomainStateDataUpdateResponse"')
      return YearEndDomainStateDataUpdateResponse_possibleTypes.includes(obj.__typename)
    }
    


    const YearEndDomainStateResponse_possibleTypes: string[] = ['YearEndDomainStateResponse']
    export const isYearEndDomainStateResponse = (obj?: { __typename?: any } | null): obj is YearEndDomainStateResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isYearEndDomainStateResponse"')
      return YearEndDomainStateResponse_possibleTypes.includes(obj.__typename)
    }
    


    const YearEndDomainStateUpdateResponse_possibleTypes: string[] = ['YearEndDomainStateUpdateResponse']
    export const isYearEndDomainStateUpdateResponse = (obj?: { __typename?: any } | null): obj is YearEndDomainStateUpdateResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isYearEndDomainStateUpdateResponse"')
      return YearEndDomainStateUpdateResponse_possibleTypes.includes(obj.__typename)
    }
    


    const YearEndDomainUpToDateState_possibleTypes: string[] = ['YearEndDomainUpToDateState']
    export const isYearEndDomainUpToDateState = (obj?: { __typename?: any } | null): obj is YearEndDomainUpToDateState => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isYearEndDomainUpToDateState"')
      return YearEndDomainUpToDateState_possibleTypes.includes(obj.__typename)
    }
    


    const YearEndDomainUpToDateStates_possibleTypes: string[] = ['YearEndDomainUpToDateStates']
    export const isYearEndDomainUpToDateStates = (obj?: { __typename?: any } | null): obj is YearEndDomainUpToDateStates => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isYearEndDomainUpToDateStates"')
      return YearEndDomainUpToDateStates_possibleTypes.includes(obj.__typename)
    }
    


    const YearEndEmail_possibleTypes: string[] = ['YearEndEmail']
    export const isYearEndEmail = (obj?: { __typename?: any } | null): obj is YearEndEmail => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isYearEndEmail"')
      return YearEndEmail_possibleTypes.includes(obj.__typename)
    }
    


    const YearEndEmailChangeLog_possibleTypes: string[] = ['YearEndEmailChangeLog']
    export const isYearEndEmailChangeLog = (obj?: { __typename?: any } | null): obj is YearEndEmailChangeLog => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isYearEndEmailChangeLog"')
      return YearEndEmailChangeLog_possibleTypes.includes(obj.__typename)
    }
    


    const YearEndIntercomLink_possibleTypes: string[] = ['YearEndIntercomLink']
    export const isYearEndIntercomLink = (obj?: { __typename?: any } | null): obj is YearEndIntercomLink => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isYearEndIntercomLink"')
      return YearEndIntercomLink_possibleTypes.includes(obj.__typename)
    }
    


    const YearEndIntercomLinkChangeLog_possibleTypes: string[] = ['YearEndIntercomLinkChangeLog']
    export const isYearEndIntercomLinkChangeLog = (obj?: { __typename?: any } | null): obj is YearEndIntercomLinkChangeLog => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isYearEndIntercomLinkChangeLog"')
      return YearEndIntercomLinkChangeLog_possibleTypes.includes(obj.__typename)
    }
    


    const YearEndInventoryMission_possibleTypes: string[] = ['PurchaseBasedClosingBalance','PurchaseBasedOpeningBalance','PurchaseBasedPurchases','SalesBasedClosingBalance','SalesBasedMissingCostPerUnit','SalesBasedOpeningBalance','SalesBasedPurchases','SalesBasedReportCogs','UnitBasedClosingBalance','UnitBasedNegativeOnHands','UnitBasedReportCogs','UnitBasedVendorsNegativeBalance']
    export const isYearEndInventoryMission = (obj?: { __typename?: any } | null): obj is YearEndInventoryMission => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isYearEndInventoryMission"')
      return YearEndInventoryMission_possibleTypes.includes(obj.__typename)
    }
    


    const YearEndStateAdditionalData_possibleTypes: string[] = ['YearEndStateAdditionalData']
    export const isYearEndStateAdditionalData = (obj?: { __typename?: any } | null): obj is YearEndStateAdditionalData => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isYearEndStateAdditionalData"')
      return YearEndStateAdditionalData_possibleTypes.includes(obj.__typename)
    }
    


    const YearEndStateChangeLog_possibleTypes: string[] = ['YearEndStateChangeLog']
    export const isYearEndStateChangeLog = (obj?: { __typename?: any } | null): obj is YearEndStateChangeLog => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isYearEndStateChangeLog"')
      return YearEndStateChangeLog_possibleTypes.includes(obj.__typename)
    }
    


    const YearEndStateResponse_possibleTypes: string[] = ['YearEndStateResponse']
    export const isYearEndStateResponse = (obj?: { __typename?: any } | null): obj is YearEndStateResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isYearEndStateResponse"')
      return YearEndStateResponse_possibleTypes.includes(obj.__typename)
    }
    


    const YearEndStateUpdateResponse_possibleTypes: string[] = ['YearEndStateUpdateResponse']
    export const isYearEndStateUpdateResponse = (obj?: { __typename?: any } | null): obj is YearEndStateUpdateResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isYearEndStateUpdateResponse"')
      return YearEndStateUpdateResponse_possibleTypes.includes(obj.__typename)
    }
    


    const YearEndUpdateAdditionalFieldsResponse_possibleTypes: string[] = ['YearEndUpdateAdditionalFieldsResponse']
    export const isYearEndUpdateAdditionalFieldsResponse = (obj?: { __typename?: any } | null): obj is YearEndUpdateAdditionalFieldsResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isYearEndUpdateAdditionalFieldsResponse"')
      return YearEndUpdateAdditionalFieldsResponse_possibleTypes.includes(obj.__typename)
    }
    


    const YearEndUpdateEmailResponse_possibleTypes: string[] = ['YearEndUpdateEmailResponse']
    export const isYearEndUpdateEmailResponse = (obj?: { __typename?: any } | null): obj is YearEndUpdateEmailResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isYearEndUpdateEmailResponse"')
      return YearEndUpdateEmailResponse_possibleTypes.includes(obj.__typename)
    }
    


    const YearEndUpdateIntercomLinkResponse_possibleTypes: string[] = ['YearEndUpdateIntercomLinkResponse']
    export const isYearEndUpdateIntercomLinkResponse = (obj?: { __typename?: any } | null): obj is YearEndUpdateIntercomLinkResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isYearEndUpdateIntercomLinkResponse"')
      return YearEndUpdateIntercomLinkResponse_possibleTypes.includes(obj.__typename)
    }
    


    const YearEndUpdateUserUnresponsiveResponse_possibleTypes: string[] = ['YearEndUpdateUserUnresponsiveResponse']
    export const isYearEndUpdateUserUnresponsiveResponse = (obj?: { __typename?: any } | null): obj is YearEndUpdateUserUnresponsiveResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isYearEndUpdateUserUnresponsiveResponse"')
      return YearEndUpdateUserUnresponsiveResponse_possibleTypes.includes(obj.__typename)
    }
    


    const YearEndUserUnresponsive_possibleTypes: string[] = ['YearEndUserUnresponsive']
    export const isYearEndUserUnresponsive = (obj?: { __typename?: any } | null): obj is YearEndUserUnresponsive => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isYearEndUserUnresponsive"')
      return YearEndUserUnresponsive_possibleTypes.includes(obj.__typename)
    }
    


    const YearEndUserUnresponsiveChangeLog_possibleTypes: string[] = ['YearEndUserUnresponsiveChangeLog']
    export const isYearEndUserUnresponsiveChangeLog = (obj?: { __typename?: any } | null): obj is YearEndUserUnresponsiveChangeLog => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isYearEndUserUnresponsiveChangeLog"')
      return YearEndUserUnresponsiveChangeLog_possibleTypes.includes(obj.__typename)
    }
    

export const enumAccountingMethod = {
   accrual: 'accrual' as const,
   cash: 'cash' as const
}

export const enumAccountingServicesTypes = {
   NOT_INTERESTED: 'NOT_INTERESTED' as const,
   INTERESTED: 'INTERESTED' as const,
   NO_STORE: 'NO_STORE' as const,
   AUTOMATED: 'AUTOMATED' as const,
   FULLY_MANAGED: 'FULLY_MANAGED' as const
}

export const enumAccountState = {
   ACTIVE: 'ACTIVE' as const,
   MADE_PRIVATE: 'MADE_PRIVATE' as const,
   CLOSED: 'CLOSED' as const,
   ASSUMED_MADE_PRIVATE: 'ASSUMED_MADE_PRIVATE' as const,
   ASSUMED_CLOSED: 'ASSUMED_CLOSED' as const
}

export const enumAccountStatus = {
   VALID: 'VALID' as const,
   ISSUE: 'ISSUE' as const
}

export const enumAccrualEntityType = {
   BANK_TRANSACTION: 'BANK_TRANSACTION' as const,
   BILL: 'BILL' as const
}

export const enumAccrualRecordSource = {
   Transactions: 'Transactions' as const,
   Bills: 'Bills' as const,
   Historical: 'Historical' as const
}

export const enumAccrualsStatus = {
   FAILURE: 'FAILURE' as const,
   SUCCESS: 'SUCCESS' as const
}

export const enumAccrualType = {
   ALL: 'ALL' as const,
   FIXED_ASSETS: 'FIXED_ASSETS' as const,
   PREPAID_EXPENSES: 'PREPAID_EXPENSES' as const,
   ACCRUED_EXPENSES: 'ACCRUED_EXPENSES' as const
}

export const enumActionChangeMoneyDirection = {
   INCREASE: 'INCREASE' as const,
   DECREASE: 'DECREASE' as const
}

export const enumActorType = {
   INTEGRATION: 'INTEGRATION' as const,
   FINALOOP_TEAM: 'FINALOOP_TEAM' as const,
   FINALOOP_CUSTOMER: 'FINALOOP_CUSTOMER' as const,
   LOCAL_RULE: 'LOCAL_RULE' as const,
   MACHINE: 'MACHINE' as const,
   MACHINE_FORCE: 'MACHINE_FORCE' as const,
   NTROPY: 'NTROPY' as const,
   DATA_DELETER: 'DATA_DELETER' as const,
   DATA_SCIENCE_CLEAR: 'DATA_SCIENCE_CLEAR' as const,
   SYSTEM: 'SYSTEM' as const,
   REALTIME_RULE_APPLIER: 'REALTIME_RULE_APPLIER' as const,
   MISSION: 'MISSION' as const,
   INITIAL_MIGRATION: 'INITIAL_MIGRATION' as const,
   DUPLICATE_DETECTOR: 'DUPLICATE_DETECTOR' as const,
   DUPLICATE_MERGER: 'DUPLICATE_MERGER' as const,
   ZERO_AMOUNT_DELETER: 'ZERO_AMOUNT_DELETER' as const
}

export const enumAdjustmentType = {
   PAID_HISTORICALLY: 'PAID_HISTORICALLY' as const,
   UNCOLLECTIBLE: 'UNCOLLECTIBLE' as const,
   COLLECTIBLE: 'COLLECTIBLE' as const
}

export const enumAllSkusSortField = {
   SALES: 'SALES' as const,
   SALES_TREND: 'SALES_TREND' as const,
   DISCOUNTS: 'DISCOUNTS' as const,
   COGS: 'COGS' as const,
   PROFIT: 'PROFIT' as const,
   MARGIN: 'MARGIN' as const,
   REFUNDS: 'REFUNDS' as const,
   RESTOCKS: 'RESTOCKS' as const,
   EFFECTIVE_PROFIT: 'EFFECTIVE_PROFIT' as const,
   EFFECTIVE_PROFIT_MARGIN: 'EFFECTIVE_PROFIT_MARGIN' as const,
   UNITS_SOLD: 'UNITS_SOLD' as const,
   UNITS_REFUNDED: 'UNITS_REFUNDED' as const,
   AVERAGE_UNITS_SOLD: 'AVERAGE_UNITS_SOLD' as const,
   AVERAGE_SALE_PRICE: 'AVERAGE_SALE_PRICE' as const,
   AVERAGE_NET_SALES: 'AVERAGE_NET_SALES' as const,
   AVERAGE_COST_PER_UNIT: 'AVERAGE_COST_PER_UNIT' as const,
   AVERAGE_PROFIT_PER_UNIT: 'AVERAGE_PROFIT_PER_UNIT' as const
}

export const enumApplyPendingSalesDataAdjustmentsMode = {
   ADD_ON_TOP: 'ADD_ON_TOP' as const,
   REPLACE: 'REPLACE' as const
}

export const enumArtificialTransactionsType = {
   PAYMENT: 'PAYMENT' as const,
   REFUND: 'REFUND' as const
}

export const enumAskTheUserFlowType = {
   FEDERAL_TAX_PAID_FLOW_TYPE: 'FEDERAL_TAX_PAID_FLOW_TYPE' as const,
   STATE_AND_SALES_TAXES_PAID_FLOW_TYPE: 'STATE_AND_SALES_TAXES_PAID_FLOW_TYPE' as const,
   PAYROLL_FLOW_TYPE: 'PAYROLL_FLOW_TYPE' as const,
   PENSION_FLOW_TYPE: 'PENSION_FLOW_TYPE' as const,
   INTERNAL_TRANSFER: 'INTERNAL_TRANSFER' as const,
   REFUND: 'REFUND' as const,
   DISTRIBUTION: 'DISTRIBUTION' as const,
   PAYOUTS_TOP_UPS: 'PAYOUTS_TOP_UPS' as const
}

export const enumAskTheUserNotificationType = {
   PAYROLL_PROVIDER_IDENTIFIED_BY_USER: 'PAYROLL_PROVIDER_IDENTIFIED_BY_USER' as const,
   PAYOUTS_TOPUPS_SHOPIFY_PAYMENT_GATEWAY_NO_CONFIG: 'PAYOUTS_TOPUPS_SHOPIFY_PAYMENT_GATEWAY_NO_CONFIG' as const,
   PAYOUTS_TOPUPS_CONNECTION_FAILURE: 'PAYOUTS_TOPUPS_CONNECTION_FAILURE' as const,
   PAYOUTS_TOPUPS_USER_SELECTED_INTEGRATION: 'PAYOUTS_TOPUPS_USER_SELECTED_INTEGRATION' as const,
   PAYOUTS_TOPUPS_USER_SELECTED_WALMART_CONNECTED_INTEGRATION: 'PAYOUTS_TOPUPS_USER_SELECTED_WALMART_CONNECTED_INTEGRATION' as const,
   INTERNAL_TRANSFER_PAYPAL_RECLASSIFICATION: 'INTERNAL_TRANSFER_PAYPAL_RECLASSIFICATION' as const,
   PAYOUTS_TOP_UPS_FROM_MISSION_LENDER_SELECTED: 'PAYOUTS_TOP_UPS_FROM_MISSION_LENDER_SELECTED' as const,
   PAYOUTS_TOP_UPS_FROM_MISSION_RELATED_PARTY_SELECTED: 'PAYOUTS_TOP_UPS_FROM_MISSION_RELATED_PARTY_SELECTED' as const,
   PAYOUTS_TOP_UPS_FROM_MISSION_OTHER_THIRDPARTY_SELECTED: 'PAYOUTS_TOP_UPS_FROM_MISSION_OTHER_THIRDPARTY_SELECTED' as const,
   PAYOUTS_TOP_UPS_FROM_MISSION_PAYPAL_SELECTED: 'PAYOUTS_TOP_UPS_FROM_MISSION_PAYPAL_SELECTED' as const,
   PAYOUTS_TOP_UPS_FROM_MISSION_TRANSACTION_MATCHED: 'PAYOUTS_TOP_UPS_FROM_MISSION_TRANSACTION_MATCHED' as const,
   PAYOUTS_TOP_UPS_FROM_MISSION_CUSTOM_CLASSIFICATION: 'PAYOUTS_TOP_UPS_FROM_MISSION_CUSTOM_CLASSIFICATION' as const,
   PAYOUTS_TOP_UPS_USER_UPLOADED_INTEGRATION_FILE: 'PAYOUTS_TOP_UPS_USER_UPLOADED_INTEGRATION_FILE' as const
}

export const enumAssemblyDeletedReason = {
   MERGE: 'MERGE' as const,
   USER_MANUAL: 'USER_MANUAL' as const
}

export const enumAssemblyType = {
   ON_DEMAND: 'ON_DEMAND' as const,
   MANUAL: 'MANUAL' as const
}

export const enumBackOfficeCreateBankReconciliationRequestType = {
   BULK_PDF: 'BULK_PDF' as const,
   MISSING_TXNS: 'MISSING_TXNS' as const,
   ONE_TIME_RECONCILIATION: 'ONE_TIME_RECONCILIATION' as const,
   RECURRING_CSV: 'RECURRING_CSV' as const
}

export const enumBalanceSheetItemType = {
   BUSINESS_AND_TAX_INFORMATION: 'BUSINESS_AND_TAX_INFORMATION' as const,
   BANKS: 'BANKS' as const,
   LOANS: 'LOANS' as const,
   TAX_RETURN_DOCUMENT: 'TAX_RETURN_DOCUMENT' as const,
   BALANCE_SHEET_DOCUMENT: 'BALANCE_SHEET_DOCUMENT' as const,
   ACQUISITION_AGREEMENT_DOCUMENT: 'ACQUISITION_AGREEMENT_DOCUMENT' as const
}

export const enumBalanceSheetSetupItemErrorMessage = {
   BALANCE_SHEET_IS_NOT_EDITABLE: 'BALANCE_SHEET_IS_NOT_EDITABLE' as const
}

export const enumBankAccountBalanceAdjustmentActorType = {
   MANUAL_STREAMLIT: 'MANUAL_STREAMLIT' as const,
   AUTOMATIC_DATA_JOBS: 'AUTOMATIC_DATA_JOBS' as const,
   AUTOMATIC_DATA_JOBS_OPENING_BALANCE_STATEMENT: 'AUTOMATIC_DATA_JOBS_OPENING_BALANCE_STATEMENT' as const
}

export const enumBankAccountClosingBalanceActorType = {
   MANUAL_STREAMLIT: 'MANUAL_STREAMLIT' as const,
   AUTOMATIC_DATA_JOBS: 'AUTOMATIC_DATA_JOBS' as const,
   AUTOMATIC_DATA_JOBS_OPENING_BALANCE_STATEMENT: 'AUTOMATIC_DATA_JOBS_OPENING_BALANCE_STATEMENT' as const
}

export const enumBankAccountConnectionStatus = {
   Connected: 'Connected' as const,
   Disconnected: 'Disconnected' as const
}

export const enumBankAccountNewOwnerType = {
   THIRD_PARTY: 'THIRD_PARTY' as const,
   RELATED_PARTY: 'RELATED_PARTY' as const,
   OWNER: 'OWNER' as const
}

export const enumBankAccountReconciliationStatus = {
   PENDING_USER_ACTION: 'PENDING_USER_ACTION' as const,
   COMPLETED: 'COMPLETED' as const
}

export const enumBankAccountStatementFileType = {
   CSV: 'CSV' as const,
   PDF: 'PDF' as const,
   XLSX: 'XLSX' as const,
   XLS: 'XLS' as const,
   UNSUPPORTED: 'UNSUPPORTED' as const
}

export const enumBankAccountStatementRequestStatus = {
   NOT_REQUIRED: 'NOT_REQUIRED' as const,
   IRRELEVANT: 'IRRELEVANT' as const,
   PENDING_USER_INPUT: 'PENDING_USER_INPUT' as const,
   USER_COMPLETED: 'USER_COMPLETED' as const,
   FINALOOP_APPROVED: 'FINALOOP_APPROVED' as const,
   IRRELEVANT_APPROVED: 'IRRELEVANT_APPROVED' as const
}

export const enumBankAccountStatementRequestSubType = {
   MADE_PRIVATE_WHILE_INVALID: 'MADE_PRIVATE_WHILE_INVALID' as const,
   ASSUMED_CLOSED: 'ASSUMED_CLOSED' as const,
   STOP_IMPORT: 'STOP_IMPORT' as const
}

export const enumBankAccountStatementRequestType = {
   END_OF_YEAR_BALANCE: 'END_OF_YEAR_BALANCE' as const,
   START_OF_YEAR_BALANCE: 'START_OF_YEAR_BALANCE' as const,
   TRANSACTIONS_BACKFILL: 'TRANSACTIONS_BACKFILL' as const,
   INTERNAL_TRANSFER_TRANSACTION_MATCH: 'INTERNAL_TRANSFER_TRANSACTION_MATCH' as const
}

export const enumBankAccountStatus = {
   ACTIVE: 'ACTIVE' as const,
   PENDING: 'PENDING' as const,
   DUPLICATE: 'DUPLICATE' as const,
   SUSPECTED_AS_DUPLICATE: 'SUSPECTED_AS_DUPLICATE' as const,
   DELETED: 'DELETED' as const,
   MERGING: 'MERGING' as const,
   MERGED: 'MERGED' as const,
   MERGE_DESTINATION: 'MERGE_DESTINATION' as const
}

export const enumBankAccountSubtype = {
   Checking: 'Checking' as const,
   Savings: 'Savings' as const,
   CreditCard: 'CreditCard' as const,
   Loan: 'Loan' as const,
   CompanyAffiliateBalance: 'CompanyAffiliateBalance' as const,
   DueToFromOwner: 'DueToFromOwner' as const,
   ShortTermLoanTaken: 'ShortTermLoanTaken' as const,
   Unknown: 'Unknown' as const,
   LineOfCredit: 'LineOfCredit' as const
}

export const enumBankAccountType = {
   Depository: 'Depository' as const,
   CreditCard: 'CreditCard' as const,
   Loan: 'Loan' as const,
   Investment: 'Investment' as const,
   Other: 'Other' as const
}

export const enumBankConnectionAccountStatus = {
   HEALTHY: 'HEALTHY' as const,
   IMPORT_STOPPED: 'IMPORT_STOPPED' as const,
   ACCESS_REMOVED: 'ACCESS_REMOVED' as const,
   DISCONNECTED: 'DISCONNECTED' as const
}

export const enumBankConnectionMetricsEventType = {
   INTEGRATION_DISCONNECTED: 'INTEGRATION_DISCONNECTED' as const,
   INTEGRATION_RECONNECTED: 'INTEGRATION_RECONNECTED' as const,
   INTEGRATION_REFRESH_REQUIRED: 'INTEGRATION_REFRESH_REQUIRED' as const
}

export const enumBankConnectionSortType = {
   DEFAULT: 'DEFAULT' as const,
   BANKS_OVERVIEW_PAGE: 'BANKS_OVERVIEW_PAGE' as const
}

export const enumBankConnectionStatus = {
   CONNECTED: 'CONNECTED' as const,
   DISCONNECTED: 'DISCONNECTED' as const,
   PENDING_REFRESH: 'PENDING_REFRESH' as const,
   NO_ACTIVE_CONNECTION: 'NO_ACTIVE_CONNECTION' as const
}

export const enumBankingAuditAction = {
   CREATE: 'CREATE' as const,
   UPDATE: 'UPDATE' as const,
   DELETE: 'DELETE' as const
}

export const enumBankingMetricEventType = {
   INTEGRATION_DISCONNECTED: 'INTEGRATION_DISCONNECTED' as const,
   INTEGRATION_RECONNECTED: 'INTEGRATION_RECONNECTED' as const,
   INTEGRATION_REFRESH_REQUIRED: 'INTEGRATION_REFRESH_REQUIRED' as const
}

export const enumBankReconciliationConfigurableRequestType = {
   RECURRING_CSV: 'RECURRING_CSV' as const
}

export const enumBankReconciliationRequestCategory = {
   UPLOAD_FILES: 'UPLOAD_FILES' as const,
   RECONCILIATION: 'RECONCILIATION' as const,
   CONNECTION: 'CONNECTION' as const
}

export const enumBankReconciliationRequestFilesStatus = {
   APPROVED: 'APPROVED' as const,
   REJECTED: 'REJECTED' as const,
   NOT_RELEVANT: 'NOT_RELEVANT' as const
}

export const enumBankReconciliationRequestMachineStatus = {
   WAITING_FOR_AUTOMATIC_PROCESSING: 'WAITING_FOR_AUTOMATIC_PROCESSING' as const,
   WAITING_FOR_MANUAL_PROCESSING: 'WAITING_FOR_MANUAL_PROCESSING' as const,
   DONE: 'DONE' as const,
   FAILURE: 'FAILURE' as const,
   NOT_RELEVANT: 'NOT_RELEVANT' as const
}

export const enumBankReconciliationRequestRecurrence = {
   DAILY: 'DAILY' as const,
   WEEKLY: 'WEEKLY' as const,
   MONTHLY: 'MONTHLY' as const
}

export const enumBankReconciliationRequestStatusCategories = {
   OPEN: 'OPEN' as const,
   PROCESSING: 'PROCESSING' as const,
   CLOSED: 'CLOSED' as const
}

export const enumBankReconciliationSettingsRequestTypes = {
   BULK_PDF: 'BULK_PDF' as const,
   HISTORICAL_GAP: 'HISTORICAL_GAP' as const,
   MISSING_TXNS: 'MISSING_TXNS' as const,
   ONE_TIME_RECONCILIATION: 'ONE_TIME_RECONCILIATION' as const,
   RECURRING_CSV: 'RECURRING_CSV' as const
}

export const enumBankStatementAutoProcessingStatus = {
   SUCCESS: 'SUCCESS' as const,
   PENDING: 'PENDING' as const,
   FAILED: 'FAILED' as const
}

export const enumBankStatementFileProcessingLogState = {
   IN_PROGRESS: 'IN_PROGRESS' as const,
   FINISHED: 'FINISHED' as const,
   ERROR: 'ERROR' as const,
   MARKED_AS_DONE: 'MARKED_AS_DONE' as const,
   MARKED_AS_NOT_RELEVANT: 'MARKED_AS_NOT_RELEVANT' as const
}

export const enumBankStatementFileProcessorType = {
   MANUAL: 'MANUAL' as const,
   AUTOMATIC: 'AUTOMATIC' as const,
   VIRTUAL_ASSISTANT: 'VIRTUAL_ASSISTANT' as const,
   TRANSACTIONS_UPLOADER: 'TRANSACTIONS_UPLOADER' as const
}

export const enumBankStatementFileStatus = {
   WAITING_FOR_AUTOMATIC_PROCESSING: 'WAITING_FOR_AUTOMATIC_PROCESSING' as const,
   AUTOMATIC_PROCESS_RUNNING: 'AUTOMATIC_PROCESS_RUNNING' as const,
   AUTOMATIC_PROCESS_FINISHED: 'AUTOMATIC_PROCESS_FINISHED' as const,
   AUTOMATIC_PROCESS_FAILURE: 'AUTOMATIC_PROCESS_FAILURE' as const,
   WAITING_FOR_MANUAL_PROCESSING: 'WAITING_FOR_MANUAL_PROCESSING' as const,
   MANUAL_PROCESS_RUNNING: 'MANUAL_PROCESS_RUNNING' as const,
   MANUAL_PROCESS_FINISHED: 'MANUAL_PROCESS_FINISHED' as const,
   MANUAL_PROCESS_FAILURE: 'MANUAL_PROCESS_FAILURE' as const,
   WAITING_FOR_TRANSACTIONS_UPLOADER: 'WAITING_FOR_TRANSACTIONS_UPLOADER' as const,
   TRANSACTIONS_UPLOADER_RUNNING: 'TRANSACTIONS_UPLOADER_RUNNING' as const,
   TRANSACTIONS_UPLOADER_FINISHED: 'TRANSACTIONS_UPLOADER_FINISHED' as const,
   DONE: 'DONE' as const,
   FAILURE: 'FAILURE' as const,
   NOT_RELEVANT: 'NOT_RELEVANT' as const
}

export const enumBankStatementFileSubSystem = {
   BULK_PDF: 'BULK_PDF' as const,
   CLOSING_BALANCE: 'CLOSING_BALANCE' as const,
   CUSTOMER_MANUAL_TRANSACTIONS_UPLOAD: 'CUSTOMER_MANUAL_TRANSACTIONS_UPLOAD' as const,
   FILES_MANAGEMENT_BACKOFFICE: 'FILES_MANAGEMENT_BACKOFFICE' as const,
   HISTORICAL_GAP: 'HISTORICAL_GAP' as const,
   INTERNAL_TRANSFER: 'INTERNAL_TRANSFER' as const,
   MISSING_TXNS: 'MISSING_TXNS' as const,
   ONGOING_RECONCILIATION: 'ONGOING_RECONCILIATION' as const,
   OPENING_BALANCE: 'OPENING_BALANCE' as const,
   PAYOUTS_AND_TOPUPS: 'PAYOUTS_AND_TOPUPS' as const,
   RECURRING_CSV: 'RECURRING_CSV' as const,
   REPORTED_TRANSACTIONS: 'REPORTED_TRANSACTIONS' as const,
   STREAMLIT: 'STREAMLIT' as const,
   TRANSACTIONS_BACKFILL: 'TRANSACTIONS_BACKFILL' as const,
   TRANSACTIONS_CSV_UPLOAD: 'TRANSACTIONS_CSV_UPLOAD' as const
}

export const enumBankStatementFilesValidationProvider = {
   OPEN_AI: 'OPEN_AI' as const,
   HERON: 'HERON' as const,
   NTROPY: 'NTROPY' as const
}

export const enumBankStatementFileSystem = {
   ATU: 'ATU' as const,
   ATU_INTEGRATIONS: 'ATU_INTEGRATIONS' as const,
   BACKOFFICE: 'BACKOFFICE' as const,
   STATEMENT_REQUESTS: 'STATEMENT_REQUESTS' as const
}

export const enumBankStatementParsingRequestsProvider = {
   OPEN_AI: 'OPEN_AI' as const,
   HERON: 'HERON' as const,
   NTROPY: 'NTROPY' as const
}

export const enumBankStatementParsingRequestsRunStatus = {
   SUCCESS: 'SUCCESS' as const,
   FAILURE: 'FAILURE' as const,
   TIMEOUT: 'TIMEOUT' as const
}

export const enumBankStatementParsingResultStatus = {
   ACTIVE: 'ACTIVE' as const,
   INACTIVE: 'INACTIVE' as const
}

export const enumBankStatementReconciliationIrrelevantReason = {
   ACCOUNT_CLOSED: 'ACCOUNT_CLOSED' as const,
   OWNERS_PERSONAL_ACCOUNT: 'OWNERS_PERSONAL_ACCOUNT' as const,
   OWNED_BY_RELATED_BUSINESS: 'OWNED_BY_RELATED_BUSINESS' as const,
   TRANSFERRED_FROM_BUSINESS: 'TRANSFERRED_FROM_BUSINESS' as const,
   TRANSFERRED_TO_BUSINESS: 'TRANSFERRED_TO_BUSINESS' as const,
   ACCOUNT_OPENED_AFTER_REQUESTED_DATE: 'ACCOUNT_OPENED_AFTER_REQUESTED_DATE' as const,
   USER_SAID_NO_MISSING_TXNS: 'USER_SAID_NO_MISSING_TXNS' as const,
   USER_SAID_NO_RELEVANT_BANK_STATEMENTS: 'USER_SAID_NO_RELEVANT_BANK_STATEMENTS' as const
}

export const enumBankStatementReconciliationResolutionType = {
   IRRELEVANT: 'IRRELEVANT' as const,
   STANDARD: 'STANDARD' as const,
   MADE_PRIVATE: 'MADE_PRIVATE' as const,
   ASSUMED_CLOSED: 'ASSUMED_CLOSED' as const,
   CONVERT_TO_MANUAL: 'CONVERT_TO_MANUAL' as const,
   SEND_TO_OPS: 'SEND_TO_OPS' as const
}

export const enumBankStatementReconciliationTransferredEntity = {
   BUSINESS_OWNER: 'BUSINESS_OWNER' as const,
   RELATED_PARTY: 'RELATED_PARTY' as const,
   THIRD_PARTY: 'THIRD_PARTY' as const
}

export const enumBankStatementRequestCategory = {
   UPLOAD_FILES: 'UPLOAD_FILES' as const,
   RECONCILIATION: 'RECONCILIATION' as const,
   CONNECTION: 'CONNECTION' as const,
   UPLOAD_PDF: 'UPLOAD_PDF' as const
}

export const enumBankStatementRequestStatus = {
   CUSTOMER_ACTION_REQUIRED: 'CUSTOMER_ACTION_REQUIRED' as const,
   PENDING_FINALOOP_REVIEW: 'PENDING_FINALOOP_REVIEW' as const,
   FINALOOP_APPROVED: 'FINALOOP_APPROVED' as const,
   CUSTOMER_CLOSED: 'CUSTOMER_CLOSED' as const,
   IRRELEVANT_ASSUMED_FINALOOP: 'IRRELEVANT_ASSUMED_FINALOOP' as const,
   PENDING_AUTOMATIC_PROCESSING: 'PENDING_AUTOMATIC_PROCESSING' as const
}

export const enumBankStatementRequestSubmissionStatus = {
   APPROVED: 'APPROVED' as const,
   REJECTED: 'REJECTED' as const,
   FAILED: 'FAILED' as const
}

export const enumBankStatementRequestType = {
   OPENING: 'OPENING' as const,
   CLOSING: 'CLOSING' as const,
   ONGOING: 'ONGOING' as const,
   RECURRING_CSV: 'RECURRING_CSV' as const,
   BULK_PDF: 'BULK_PDF' as const,
   MISSING_TXNS: 'MISSING_TXNS' as const,
   ONE_TIME_RECONCILIATION: 'ONE_TIME_RECONCILIATION' as const,
   HISTORICAL_GAP: 'HISTORICAL_GAP' as const,
   ACCESS_REMOVED: 'ACCESS_REMOVED' as const,
   REPORT_TRANSACTIONS: 'REPORT_TRANSACTIONS' as const
}

export const enumBankStatementResolutionOriginator = {
   ATUBanking: 'ATUBanking' as const,
   ATUIntegrations: 'ATUIntegrations' as const,
   ATUWalmartHyperwallet: 'ATUWalmartHyperwallet' as const,
   BackOffice: 'BackOffice' as const,
   BankAccountReconciliation: 'BankAccountReconciliation' as const,
   BankAccountStatementsReconciliation: 'BankAccountStatementsReconciliation' as const,
   BankingPage: 'BankingPage' as const,
   ClosingBalanceRequest: 'ClosingBalanceRequest' as const,
   CustomerManualTransactionsUpload: 'CustomerManualTransactionsUpload' as const,
   InternalTransferTransactionMatch: 'InternalTransferTransactionMatch' as const,
   OngoingReconciliationRequest: 'OngoingReconciliationRequest' as const,
   OpeningBalanceRequest: 'OpeningBalanceRequest' as const,
   PayoutsAndTopUps: 'PayoutsAndTopUps' as const,
   ReportedTransactions: 'ReportedTransactions' as const,
   TransactionsBackfill: 'TransactionsBackfill' as const,
   TransactionsBackOfficeStreamlit: 'TransactionsBackOfficeStreamlit' as const,
   TransactionsCSVUpload: 'TransactionsCSVUpload' as const
}

export const enumBankStatementValidationRunStatus = {
   PENDING: 'PENDING' as const,
   VALID: 'VALID' as const,
   INVALID: 'INVALID' as const,
   API_FAILED: 'API_FAILED' as const,
   TIMEOUT: 'TIMEOUT' as const,
   NOT_APPLICABLE: 'NOT_APPLICABLE' as const
}

export const enumBankStatementVerificationComponents = {
   MASK: 'MASK' as const,
   INSTITUTION: 'INSTITUTION' as const
}

export const enumBankTransactionCategorizationResultStatus = {
   FAILURE: 'FAILURE' as const,
   SUCCESS: 'SUCCESS' as const
}

export const enumBankTransactionClassifierType = {
   LOCAL_RULE: 'LOCAL_RULE' as const,
   RULE: 'RULE' as const,
   USER: 'USER' as const,
   INTEGRATION: 'INTEGRATION' as const,
   DATA_DELETER: 'DATA_DELETER' as const,
   FINALOOP_TEAM: 'FINALOOP_TEAM' as const,
   FINALOOP_CUSTOMER: 'FINALOOP_CUSTOMER' as const,
   NTROPY: 'NTROPY' as const
}

export const enumBankTransactionsUploadProcessingLogState = {
   IN_PROGRESS: 'IN_PROGRESS' as const,
   FINISHED: 'FINISHED' as const,
   ERROR: 'ERROR' as const,
   MARKED_AS_DONE: 'MARKED_AS_DONE' as const
}

export const enumBankTransactionsUploadProcessorType = {
   MANUAL: 'MANUAL' as const,
   AUTOMATIC: 'AUTOMATIC' as const,
   VIRTUAL_ASSISTANT: 'VIRTUAL_ASSISTANT' as const,
   TRANSACTIONS_UPLOADER: 'TRANSACTIONS_UPLOADER' as const
}

export const enumBankTransactionsUploadStatus = {
   WAITING_FOR_AUTOMATIC_PROCESSING: 'WAITING_FOR_AUTOMATIC_PROCESSING' as const,
   AUTOMATIC_PROCESS_RUNNING: 'AUTOMATIC_PROCESS_RUNNING' as const,
   AUTOMATIC_PROCESS_FINISHED: 'AUTOMATIC_PROCESS_FINISHED' as const,
   AUTOMATIC_PROCESS_FAILURE: 'AUTOMATIC_PROCESS_FAILURE' as const,
   WAITING_FOR_MANUAL_PROCESSING: 'WAITING_FOR_MANUAL_PROCESSING' as const,
   MANUAL_PROCESS_RUNNING: 'MANUAL_PROCESS_RUNNING' as const,
   MANUAL_PROCESS_FINISHED: 'MANUAL_PROCESS_FINISHED' as const,
   MANUAL_PROCESS_FAILURE: 'MANUAL_PROCESS_FAILURE' as const,
   WAITING_FOR_TRANSACTIONS_UPLOADER: 'WAITING_FOR_TRANSACTIONS_UPLOADER' as const,
   TRANSACTIONS_UPLOADER_RUNNING: 'TRANSACTIONS_UPLOADER_RUNNING' as const,
   TRANSACTIONS_UPLOADER_FINISHED: 'TRANSACTIONS_UPLOADER_FINISHED' as const,
   DONE: 'DONE' as const,
   FAILURE: 'FAILURE' as const
}

export const enumBillAdjustmentType = {
   PRIOR_YEAR_ADJUSTMENT: 'PRIOR_YEAR_ADJUSTMENT' as const,
   FULLY_REFUNDED: 'FULLY_REFUNDED' as const
}

export const enumBillPaymentFinancingType = {
   EPT: 'EPT' as const,
   BEPT: 'BEPT' as const,
   AMORTIZED: 'AMORTIZED' as const
}

export const enumBillPaymentSettlementType = {
   PAID_EXTERNALLY: 'PAID_EXTERNALLY' as const,
   PAID_VIA_INTEGRATION: 'PAID_VIA_INTEGRATION' as const,
   FINANCED_BY_INTEGRATION: 'FINANCED_BY_INTEGRATION' as const,
   FINANCED_EXTERNALLY: 'FINANCED_EXTERNALLY' as const,
   SCHEDULED: 'SCHEDULED' as const,
   INDICATIVE: 'INDICATIVE' as const,
   MANUAL_BY_FINALOOP_TEAM: 'MANUAL_BY_FINALOOP_TEAM' as const
}

export const enumBillRefundSettlementType = {
   REFUNDED_VIA_INTEGRATION: 'REFUNDED_VIA_INTEGRATION' as const,
   SCHEDULED: 'SCHEDULED' as const,
   INDICATIVE: 'INDICATIVE' as const,
   MANUAL_BY_FINALOOP_TEAM: 'MANUAL_BY_FINALOOP_TEAM' as const
}

export const enumBillsYearEndTaskId = {
   CATEGORIZE_UNCATEGORIZED_BILLS: 'CATEGORIZE_UNCATEGORIZED_BILLS' as const,
   CLOSE_OPEN_BILLS: 'CLOSE_OPEN_BILLS' as const,
   ADD_MISSING_BILLS: 'ADD_MISSING_BILLS' as const,
   CONFIRM_AP_BALANCE: 'CONFIRM_AP_BALANCE' as const
}

export const enumBillsYearEndTaskStatus = {
   INACTIVE: 'INACTIVE' as const,
   OPEN: 'OPEN' as const,
   REOPENED: 'REOPENED' as const,
   PROCESSING: 'PROCESSING' as const,
   CLOSED: 'CLOSED' as const
}

export const enumBreakdownType = {
   CATEGORY: 'CATEGORY' as const,
   MERCHANT: 'MERCHANT' as const
}

export const enumBusinessCreationType = {
   CREATED: 'CREATED' as const,
   PURCHASED: 'PURCHASED' as const
}

export const enumClosingBalanceType = {
   INTEGRATION_UDF: 'INTEGRATION_UDF' as const
}

export const enumCogsCategory = {
   ProductDirectCost: 'ProductDirectCost' as const,
   ShippingAndFreightIn: 'ShippingAndFreightIn' as const,
   CustomFeesAndServices: 'CustomFeesAndServices' as const,
   DutiesAndTax: 'DutiesAndTax' as const,
   Insurance: 'Insurance' as const,
   PalletCosts: 'PalletCosts' as const,
   ShippingSurcharge: 'ShippingSurcharge' as const,
   VendorFees: 'VendorFees' as const,
   ProductionCosts: 'ProductionCosts' as const,
   Discount: 'Discount' as const,
   PackagingMaterials: 'PackagingMaterials' as const,
   Dropshipping: 'Dropshipping' as const,
   ProductionLaborCosts: 'ProductionLaborCosts' as const,
   ManufacturingCosts: 'ManufacturingCosts' as const,
   ManufacturingLabor: 'ManufacturingLabor' as const,
   Printing: 'Printing' as const,
   InventoryMaintenance: 'InventoryMaintenance' as const,
   General: 'General' as const,
   OtherInventoryAdjustments: 'OtherInventoryAdjustments' as const,
   WarrantyReimbursement: 'WarrantyReimbursement' as const
}

export const enumCogsEventSource = {
   system: 'system' as const,
   user: 'user' as const,
   incidentals: 'incidentals' as const
}

export const enumCogsSource = {
   Products: 'Products' as const,
   Incidentals: 'Incidentals' as const,
   Manual: 'Manual' as const
}

export const enumCogsType = {
   COGS: 'COGS' as const,
   DeadInventory: 'DeadInventory' as const,
   ProductGiveaways: 'ProductGiveaways' as const,
   Waste: 'Waste' as const,
   PhysicalAdjustments: 'PhysicalAdjustments' as const,
   ProductDonations: 'ProductDonations' as const,
   UnitLost: 'UnitLost' as const,
   UnitFound: 'UnitFound' as const,
   OtherFba: 'OtherFba' as const,
   SupplierReturn: 'SupplierReturn' as const
}

export const enumCompanyAffiliateType = {
   holder: 'holder' as const,
   safeHolder: 'safeHolder' as const,
   relatedParty: 'relatedParty' as const,
   employee: 'employee' as const,
   contractor: 'contractor' as const,
   lender: 'lender' as const
}

export const enumCompanyHealthStatusSortDirection = {
   ASC: 'ASC' as const,
   DESC: 'DESC' as const
}

export const enumCompanyLoanDeleteOptionMode = {
   NOT_IN_BOOKS: 'NOT_IN_BOOKS' as const,
   MANUAL_EVENTS_ONLY: 'MANUAL_EVENTS_ONLY' as const,
   ONLY_TRANSACTIONS_EVENTS: 'ONLY_TRANSACTIONS_EVENTS' as const,
   HAS_INTEGRATION_EVENTS: 'HAS_INTEGRATION_EVENTS' as const
}

export const enumCompanyTier = {
   TIER_1_V3: 'TIER_1_V3' as const,
   TIER_2_V3: 'TIER_2_V3' as const,
   TIER_3_V3: 'TIER_3_V3' as const,
   TIER_4_V3: 'TIER_4_V3' as const,
   TIER_5_V3: 'TIER_5_V3' as const,
   TIER_6_V3: 'TIER_6_V3' as const,
   TIER_7_V3: 'TIER_7_V3' as const
}

export const enumCompanyTierType = {
   TIER_1: 'TIER_1' as const,
   TIER_2: 'TIER_2' as const,
   TIER_3: 'TIER_3' as const,
   TIER_4: 'TIER_4' as const,
   TIER_1_V3: 'TIER_1_V3' as const,
   TIER_2_V3: 'TIER_2_V3' as const,
   TIER_3_V3: 'TIER_3_V3' as const,
   TIER_4_V3: 'TIER_4_V3' as const,
   TIER_5_V3: 'TIER_5_V3' as const,
   TIER_6_V3: 'TIER_6_V3' as const,
   TIER_7_V3: 'TIER_7_V3' as const
}

export const enumCompanyValidationDomainType = {
   SHOPIFY: 'SHOPIFY' as const,
   AMAZON: 'AMAZON' as const,
   INVENTORY: 'INVENTORY' as const,
   ACCRUALS: 'ACCRUALS' as const,
   STRIPE: 'STRIPE' as const,
   LOANS: 'LOANS' as const,
   EQUITY: 'EQUITY' as const,
   PAYMENTS: 'PAYMENTS' as const,
   SALES: 'SALES' as const,
   COMPANY_AFFILIATES: 'COMPANY_AFFILIATES' as const,
   BANKS: 'BANKS' as const,
   BANK_TRANSACTIONS: 'BANK_TRANSACTIONS' as const,
   BILLS: 'BILLS' as const,
   AR: 'AR' as const,
   MONEY_IN_TRANSIT: 'MONEY_IN_TRANSIT' as const,
   GENERAL: 'GENERAL' as const,
   ORDERS: 'ORDERS' as const,
   PAYROLL: 'PAYROLL' as const,
   TIK_TOK: 'TIK_TOK' as const
}

export const enumCompanyValidationMetricMode = {
   DIFF: 'DIFF' as const,
   INFO: 'INFO' as const
}

export const enumCompanyValidationMetricName = {
   INTERNAL_DIFF: 'INTERNAL_DIFF' as const,
   USER_FACING_DIFF: 'USER_FACING_DIFF' as const,
   QUANTITY_DIFF: 'QUANTITY_DIFF' as const,
   COST_DIFF: 'COST_DIFF' as const,
   BUSINESS_EVENTS_DIFF: 'BUSINESS_EVENTS_DIFF' as const,
   BS_DIFF: 'BS_DIFF' as const,
   ACCRUALS_CLEARING_ACCOUNT: 'ACCRUALS_CLEARING_ACCOUNT' as const,
   GROSS_SALES_DIFF: 'GROSS_SALES_DIFF' as const,
   NET_SALES_DIFF: 'NET_SALES_DIFF' as const,
   TOTAL_SALES_DIFF: 'TOTAL_SALES_DIFF' as const,
   ORDERS_RECONCILIATION_STATUS: 'ORDERS_RECONCILIATION_STATUS' as const,
   UDF_DIFF: 'UDF_DIFF' as const,
   UDF_ON_HOLD_DIFF: 'UDF_ON_HOLD_DIFF' as const,
   LOANS_OUTSTANDING_AMOUNT_NEG: 'LOANS_OUTSTANDING_AMOUNT_NEG' as const,
   CLEARING_ACCOUNT: 'CLEARING_ACCOUNT' as const,
   HOLDINGS_DIFF: 'HOLDINGS_DIFF' as const,
   ACCOUNT_RECEIVABLE_DIFF: 'ACCOUNT_RECEIVABLE_DIFF' as const,
   CLEARING_ACCOUNT_INVOICES_DIFF: 'CLEARING_ACCOUNT_INVOICES_DIFF' as const,
   CLEARING_ACCOUNT_INVOICE_PAYMENTS_DIFF: 'CLEARING_ACCOUNT_INVOICE_PAYMENTS_DIFF' as const,
   UNCLEARED_INVOICES_BALANCE_DIFF: 'UNCLEARED_INVOICES_BALANCE_DIFF' as const,
   PAYPAL_INVOICES_DIFF: 'PAYPAL_INVOICES_DIFF' as const,
   PROFIT_AND_LOSS_DIFF: 'PROFIT_AND_LOSS_DIFF' as const,
   RETAINED_EARNINGS_BALANCE_DIFF: 'RETAINED_EARNINGS_BALANCE_DIFF' as const,
   STRIPE_INVOICES_DIFF: 'STRIPE_INVOICES_DIFF' as const,
   LOANS_ACTION_REQUIRED_COUNT: 'LOANS_ACTION_REQUIRED_COUNT' as const,
   LOANS_OUTSTANDING_AMOUNT_DIFF: 'LOANS_OUTSTANDING_AMOUNT_DIFF' as const,
   LOANS_OUTSTANDING_AMOUNT_VS_FEES: 'LOANS_OUTSTANDING_AMOUNT_VS_FEES' as const,
   LOANS_OUTSTANDING_AMOUNT_ZERO_BEFORE_NEW_LOAN: 'LOANS_OUTSTANDING_AMOUNT_ZERO_BEFORE_NEW_LOAN' as const,
   GIFTCARDS_DIFF: 'GIFTCARDS_DIFF' as const,
   CLEARING_ACCOUNT_BILL_PAYMENTS_DIFF: 'CLEARING_ACCOUNT_BILL_PAYMENTS_DIFF' as const,
   ACCOUNT_PAYABLE_DIFF: 'ACCOUNT_PAYABLE_DIFF' as const,
   PLATFORM_PAYABLE_DIFF: 'PLATFORM_PAYABLE_DIFF' as const,
   ACCRUED_INTEREST_DIFF: 'ACCRUED_INTEREST_DIFF' as const,
   LOAN_PAYABLE_DIFF: 'LOAN_PAYABLE_DIFF' as const,
   SETTLE_TOTAL_DIFF: 'SETTLE_TOTAL_DIFF' as const,
   SETTLE_NUMBER_DIFF: 'SETTLE_NUMBER_DIFF' as const,
   SETTLE_LOAN_PAYABLE_DIFF: 'SETTLE_LOAN_PAYABLE_DIFF' as const,
   SETTLE_VENDOR_PAYABLE_DIFF: 'SETTLE_VENDOR_PAYABLE_DIFF' as const,
   BILL_COM_TOTAL_DIFF: 'BILL_COM_TOTAL_DIFF' as const,
   BILL_COM_NUMBER_DIFF: 'BILL_COM_NUMBER_DIFF' as const,
   BILL_COM_VENDOR_PAYABLE_DIFF: 'BILL_COM_VENDOR_PAYABLE_DIFF' as const,
   AR_UNMATCHED_RATE: 'AR_UNMATCHED_RATE' as const,
   AR_DIFF: 'AR_DIFF' as const,
   MONEY_IN_TRANSIT_DIFF: 'MONEY_IN_TRANSIT_DIFF' as const,
   AR_POTENTIAL_UNMATCHED_RATE: 'AR_POTENTIAL_UNMATCHED_RATE' as const,
   GENERAL_CLEARING_ACCOUNT: 'GENERAL_CLEARING_ACCOUNT' as const,
   INVENTORY_CLEARING_ACCOUNT: 'INVENTORY_CLEARING_ACCOUNT' as const,
   LOANS_CLEARING_ACCOUNT: 'LOANS_CLEARING_ACCOUNT' as const,
   ORDERS_CLEARING_ACCOUNT: 'ORDERS_CLEARING_ACCOUNT' as const,
   PAYROLL_CLEARING_ACCOUNT: 'PAYROLL_CLEARING_ACCOUNT' as const,
   PAYMENTS_CLEARING_ACCOUNT: 'PAYMENTS_CLEARING_ACCOUNT' as const,
   TOTAL_BANK_ACCOUNTS: 'TOTAL_BANK_ACCOUNTS' as const,
   BANK_ACCOUNT_ISSUE: 'BANK_ACCOUNT_ISSUE' as const,
   AR_CASH_DIFF: 'AR_CASH_DIFF' as const,
   MONEY_IN_OUT_DIFF: 'MONEY_IN_OUT_DIFF' as const,
   DEFERRED_REVENUE_DIFF: 'DEFERRED_REVENUE_DIFF' as const,
   INVENTORY_FULFILLMENTS_AFTER_LOCK: 'INVENTORY_FULFILLMENTS_AFTER_LOCK' as const
}

export const enumCompanyValidationStatus = {
   PASS: 'PASS' as const,
   FAIL: 'FAIL' as const,
   NA: 'NA' as const
}

export const enumCompanyValidationType = {
   INVENTORY_BIG: 'INVENTORY_BIG' as const,
   INVENTORY_VENDORS: 'INVENTORY_VENDORS' as const,
   INVENTORY_FIFO: 'INVENTORY_FIFO' as const,
   INVENTORY_NO_UNIT: 'INVENTORY_NO_UNIT' as const,
   AMAZON_PRODUCTS: 'AMAZON_PRODUCTS' as const,
   AMAZON_INVENTORY_LEDGER: 'AMAZON_INVENTORY_LEDGER' as const,
   SHOPIFY_PRODUCTS: 'SHOPIFY_PRODUCTS' as const,
   ORDERS_RECONCILIATION: 'ORDERS_RECONCILIATION' as const,
   DEFERRED_REVENUE: 'DEFERRED_REVENUE' as const,
   ACCRUALS_ALL_ENTITIES: 'ACCRUALS_ALL_ENTITIES' as const,
   INVENTORY_PURCHASES: 'INVENTORY_PURCHASES' as const,
   STRIPE_UDF: 'STRIPE_UDF' as const,
   LOANS_OUTSTANDING_AMOUNT: 'LOANS_OUTSTANDING_AMOUNT' as const,
   EQUITY_ACCOUNTS: 'EQUITY_ACCOUNTS' as const,
   EQUITY_ENTITIES: 'EQUITY_ENTITIES' as const,
   EQUITY_CLEARING_ACCOUNT: 'EQUITY_CLEARING_ACCOUNT' as const,
   EQUITY_HOLDINGS: 'EQUITY_HOLDINGS' as const,
   EQUITY_HOLDERS: 'EQUITY_HOLDERS' as const,
   KLARNA_UDF: 'KLARNA_UDF' as const,
   INVOICES: 'INVOICES' as const,
   CLEARING_ACCOUNT: 'CLEARING_ACCOUNT' as const,
   COMPANY_AFFILIATES_CLEARING_ACCOUNT: 'COMPANY_AFFILIATES_CLEARING_ACCOUNT' as const,
   LOANS_ACTION_REQUIRED: 'LOANS_ACTION_REQUIRED' as const,
   LOANS_AUTOMATION: 'LOANS_AUTOMATION' as const,
   SHOPIFY_GIFTCARDS: 'SHOPIFY_GIFTCARDS' as const,
   BANKS_BALANCE: 'BANKS_BALANCE' as const,
   BILLS: 'BILLS' as const,
   SETTLE: 'SETTLE' as const,
   BILL_COM: 'BILL_COM' as const,
   AR: 'AR' as const,
   MONEY_IN_TRANSIT: 'MONEY_IN_TRANSIT' as const,
   AR_CASH: 'AR_CASH' as const,
   MONEY_IN_OUT: 'MONEY_IN_OUT' as const,
   PHYSICAL_COUNT: 'PHYSICAL_COUNT' as const,
   TIK_TOK_UDF: 'TIK_TOK_UDF' as const
}

export const enumCostType = {
   LandedCost: 'LandedCost' as const,
   Indirect: 'Indirect' as const,
   Direct: 'Direct' as const
}

export const enumCurrencyCode = {
   AED: 'AED' as const,
   AFN: 'AFN' as const,
   ALL: 'ALL' as const,
   AMD: 'AMD' as const,
   ANG: 'ANG' as const,
   AOA: 'AOA' as const,
   ARS: 'ARS' as const,
   AUD: 'AUD' as const,
   AWG: 'AWG' as const,
   AZN: 'AZN' as const,
   BAM: 'BAM' as const,
   BBD: 'BBD' as const,
   BDT: 'BDT' as const,
   BGN: 'BGN' as const,
   BHD: 'BHD' as const,
   BIF: 'BIF' as const,
   BMD: 'BMD' as const,
   BND: 'BND' as const,
   BOB: 'BOB' as const,
   BRL: 'BRL' as const,
   BSD: 'BSD' as const,
   BTN: 'BTN' as const,
   BWP: 'BWP' as const,
   BYN: 'BYN' as const,
   BZD: 'BZD' as const,
   CAD: 'CAD' as const,
   CDF: 'CDF' as const,
   CHF: 'CHF' as const,
   CLP: 'CLP' as const,
   CNY: 'CNY' as const,
   COP: 'COP' as const,
   CRC: 'CRC' as const,
   CUC: 'CUC' as const,
   CUP: 'CUP' as const,
   CVE: 'CVE' as const,
   CZK: 'CZK' as const,
   DJF: 'DJF' as const,
   DKK: 'DKK' as const,
   DOP: 'DOP' as const,
   DZD: 'DZD' as const,
   EGP: 'EGP' as const,
   ERN: 'ERN' as const,
   ETB: 'ETB' as const,
   EUR: 'EUR' as const,
   FJD: 'FJD' as const,
   FKP: 'FKP' as const,
   GBP: 'GBP' as const,
   GEL: 'GEL' as const,
   GHS: 'GHS' as const,
   GIP: 'GIP' as const,
   GMD: 'GMD' as const,
   GNF: 'GNF' as const,
   GTQ: 'GTQ' as const,
   GYD: 'GYD' as const,
   HKD: 'HKD' as const,
   HNL: 'HNL' as const,
   HRK: 'HRK' as const,
   HTG: 'HTG' as const,
   HUF: 'HUF' as const,
   IDR: 'IDR' as const,
   ILS: 'ILS' as const,
   INR: 'INR' as const,
   IQD: 'IQD' as const,
   IRR: 'IRR' as const,
   ISK: 'ISK' as const,
   JMD: 'JMD' as const,
   JOD: 'JOD' as const,
   JPY: 'JPY' as const,
   KES: 'KES' as const,
   KGS: 'KGS' as const,
   KHR: 'KHR' as const,
   KMF: 'KMF' as const,
   KPW: 'KPW' as const,
   KRW: 'KRW' as const,
   KWD: 'KWD' as const,
   KYD: 'KYD' as const,
   KZT: 'KZT' as const,
   LAK: 'LAK' as const,
   LBP: 'LBP' as const,
   LKR: 'LKR' as const,
   LRD: 'LRD' as const,
   LSL: 'LSL' as const,
   LYD: 'LYD' as const,
   MAD: 'MAD' as const,
   MDL: 'MDL' as const,
   MGA: 'MGA' as const,
   MKD: 'MKD' as const,
   MMK: 'MMK' as const,
   MNT: 'MNT' as const,
   MOP: 'MOP' as const,
   MRU: 'MRU' as const,
   MUR: 'MUR' as const,
   MVR: 'MVR' as const,
   MWK: 'MWK' as const,
   MXN: 'MXN' as const,
   MYR: 'MYR' as const,
   MZN: 'MZN' as const,
   NAD: 'NAD' as const,
   NGN: 'NGN' as const,
   NIO: 'NIO' as const,
   NOK: 'NOK' as const,
   NPR: 'NPR' as const,
   NZD: 'NZD' as const,
   OMR: 'OMR' as const,
   PAB: 'PAB' as const,
   PEN: 'PEN' as const,
   PGK: 'PGK' as const,
   PHP: 'PHP' as const,
   PKR: 'PKR' as const,
   PLN: 'PLN' as const,
   PYG: 'PYG' as const,
   QAR: 'QAR' as const,
   RON: 'RON' as const,
   RSD: 'RSD' as const,
   RUB: 'RUB' as const,
   RWF: 'RWF' as const,
   SAR: 'SAR' as const,
   SBD: 'SBD' as const,
   SCR: 'SCR' as const,
   SDG: 'SDG' as const,
   SEK: 'SEK' as const,
   SGD: 'SGD' as const,
   SHP: 'SHP' as const,
   SLL: 'SLL' as const,
   SOS: 'SOS' as const,
   SRD: 'SRD' as const,
   SSP: 'SSP' as const,
   STN: 'STN' as const,
   SVC: 'SVC' as const,
   SYP: 'SYP' as const,
   SZL: 'SZL' as const,
   THB: 'THB' as const,
   TJS: 'TJS' as const,
   TMT: 'TMT' as const,
   TND: 'TND' as const,
   TOP: 'TOP' as const,
   TRY: 'TRY' as const,
   TTD: 'TTD' as const,
   TWD: 'TWD' as const,
   TZS: 'TZS' as const,
   UAH: 'UAH' as const,
   UGX: 'UGX' as const,
   USD: 'USD' as const,
   UYU: 'UYU' as const,
   UZS: 'UZS' as const,
   VES: 'VES' as const,
   VND: 'VND' as const,
   VUV: 'VUV' as const,
   WST: 'WST' as const,
   XAF: 'XAF' as const,
   XCD: 'XCD' as const,
   XOF: 'XOF' as const,
   XPF: 'XPF' as const,
   YER: 'YER' as const,
   ZAR: 'ZAR' as const,
   ZMW: 'ZMW' as const,
   ZWL: 'ZWL' as const
}

export const enumCustomerSelectedAccountingMethod = {
   ACCRUAL: 'ACCRUAL' as const,
   CASH: 'CASH' as const,
   MODIFIED_CASH: 'MODIFIED_CASH' as const
}

export const enumCustomerSource = {
   BILL_COM: 'BILL_COM' as const,
   PAYPAL: 'PAYPAL' as const,
   STRIPE: 'STRIPE' as const,
   FINALOOP_INVOICES: 'FINALOOP_INVOICES' as const,
   QUICKBOOKS: 'QUICKBOOKS' as const,
   SPS_COMMERCE: 'SPS_COMMERCE' as const,
   QUICKBOOKS_INVOICES: 'QUICKBOOKS_INVOICES' as const,
   NU_ORDER_INVOICES: 'NU_ORDER_INVOICES' as const
}

export const enumDepreciationMethod = {
   STRAIGHT_LINE: 'STRAIGHT_LINE' as const,
   DECLINING_BALANCE: 'DECLINING_BALANCE' as const
}

export const enumDiscountType = {
   PERCENTAGE: 'PERCENTAGE' as const,
   FIXED_AMOUNT: 'FIXED_AMOUNT' as const
}

export const enumDisputeOutcome = {
   RESOLVED: 'RESOLVED' as const,
   REFUNDED: 'REFUNDED' as const,
   CHARGEBACK: 'CHARGEBACK' as const
}

export const enumDropshippingModeType = {
   INCIDENTAL: 'INCIDENTAL' as const,
   NON_INCIDENTAL: 'NON_INCIDENTAL' as const
}

export const enumDuplicateCheckResult = {
   DUPLICATE: 'DUPLICATE' as const,
   NOT_DUPLICATE: 'NOT_DUPLICATE' as const
}

export const enumEarlyRepaymentDiscountPeriodType = {
   MONTH: 'MONTH' as const,
   DAY: 'DAY' as const,
   PAYMENT: 'PAYMENT' as const
}

export const enumEquityEventShareType = {
   COMMON_STOCK: 'COMMON_STOCK' as const,
   PREFERRED: 'PREFERRED' as const,
   SAFE: 'SAFE' as const
}

export const enumEstimatedProjectedRevenue = {
   ZERO_TO_TWO_HUNDRED_THOUSAND: 'ZERO_TO_TWO_HUNDRED_THOUSAND' as const,
   ZERO_TO_HALF_A_MILLION: 'ZERO_TO_HALF_A_MILLION' as const,
   TWO_HUNDRED_THOUSAND_TO_FIVE_HUNDRED_THOUSAND: 'TWO_HUNDRED_THOUSAND_TO_FIVE_HUNDRED_THOUSAND' as const,
   TWO_HUNDRED_THOUSAND_TO_ONE_MILLION: 'TWO_HUNDRED_THOUSAND_TO_ONE_MILLION' as const,
   FIVE_HUNDRED_THOUSAND_TO_THREE_MILLION: 'FIVE_HUNDRED_THOUSAND_TO_THREE_MILLION' as const,
   HALF_A_MILLION_TO_ONE_AND_A_HALF_MILLION: 'HALF_A_MILLION_TO_ONE_AND_A_HALF_MILLION' as const,
   ONE_MILLION_TO_FIVE_MILLION: 'ONE_MILLION_TO_FIVE_MILLION' as const,
   ONE_AND_A_HALF_TO_TEN_MILLION: 'ONE_AND_A_HALF_TO_TEN_MILLION' as const,
   THREE_MILLION_TO_TEN_MILLION: 'THREE_MILLION_TO_TEN_MILLION' as const,
   FIVE_MILLION_TO_TEN_MILLION: 'FIVE_MILLION_TO_TEN_MILLION' as const,
   TEN_TO_FIFTY_MILLION: 'TEN_TO_FIFTY_MILLION' as const,
   ABOVE_TEN_MILLION: 'ABOVE_TEN_MILLION' as const,
   ABOVE_FIFTY_MILLION: 'ABOVE_FIFTY_MILLION' as const
}

export const enumExportedReportsLogsSortBy = {
   createdAt: 'createdAt' as const,
   email: 'email' as const
}

export const enumExportStatus = {
   STARTING: 'STARTING' as const,
   IN_PROGRESS: 'IN_PROGRESS' as const,
   FAILURE: 'FAILURE' as const,
   SUCCESS: 'SUCCESS' as const,
   PARTIAL_SUCCESS: 'PARTIAL_SUCCESS' as const,
   ERROR: 'ERROR' as const
}

export const enumFeature = {
   CATCHUP: 'CATCHUP' as const,
   SUBSCRIPTION: 'SUBSCRIPTION' as const
}

export const enumFileType = {
   EXCEL: 'EXCEL' as const
}

export const enumFileUploadSource = {
   BANK_TRANSACTIONS_ATTACHMENT: 'BANK_TRANSACTIONS_ATTACHMENT' as const,
   TAX_1099: 'TAX_1099' as const,
   INVENTORY: 'INVENTORY' as const,
   VALIDATION_DATA: 'VALIDATION_DATA' as const,
   WORKSHEET: 'WORKSHEET' as const,
   LOANS: 'LOANS' as const,
   ORDERS: 'ORDERS' as const,
   GIFT_CARDS: 'GIFT_CARDS' as const,
   YEAR_END: 'YEAR_END' as const,
   REPORTS: 'REPORTS' as const,
   BALANCE_SHEET_HUB: 'BALANCE_SHEET_HUB' as const,
   INVOICES: 'INVOICES' as const
}

export const enumFilterableBankStatementRequestTypes = {
   OPENING: 'OPENING' as const,
   CLOSING: 'CLOSING' as const,
   ONGOING: 'ONGOING' as const,
   RECURRING_CSV: 'RECURRING_CSV' as const,
   BULK_PDF: 'BULK_PDF' as const,
   MISSING_TXNS: 'MISSING_TXNS' as const,
   ONE_TIME_RECONCILIATION: 'ONE_TIME_RECONCILIATION' as const,
   HISTORICAL_GAP: 'HISTORICAL_GAP' as const,
   ACCESS_REMOVED: 'ACCESS_REMOVED' as const
}

export const enumFilterOperator = {
   IN: 'IN' as const,
   NOTIN: 'NOTIN' as const
}

export const enumFinancedPaymentInstallmentStatus = {
   pending_approval: 'pending_approval' as const,
   scheduled: 'scheduled' as const,
   initiated: 'initiated' as const,
   completed: 'completed' as const,
   failed: 'failed' as const,
   canceled: 'canceled' as const,
   refunded: 'refunded' as const
}

export const enumFinancialReportingStatus = {
   COGS_ONLY: 'COGS_ONLY' as const,
   SALES_ONLY: 'SALES_ONLY' as const,
   COGS_AND_SALES: 'COGS_AND_SALES' as const,
   EXCLUDED: 'EXCLUDED' as const,
   GIVEAWAY: 'GIVEAWAY' as const
}

export const enumFinancialReportingStatusSource = {
   SALES_CHANNEL_CONFIGURATION: 'SALES_CHANNEL_CONFIGURATION' as const,
   MARKED_BY_USER: 'MARKED_BY_USER' as const
}

export const enumFulfillmentChannel = {
   SELLER: 'SELLER' as const,
   PLATFORM: 'PLATFORM' as const
}

export const enumFulfillmentCostType = {
   PICK_AND_PACK: 'PICK_AND_PACK' as const
}

export const enumFulfillmentMethodType = {
   AUTOMATIC: 'AUTOMATIC' as const,
   INTEGRATION: 'INTEGRATION' as const
}

export const enumFulfillmentStatus = {
   UNFULFILLED: 'UNFULFILLED' as const,
   PARTIALLY_FULFILLED: 'PARTIALLY_FULFILLED' as const,
   FULFILLED: 'FULFILLED' as const
}

export const enumGetBankStatementRequestsDirection = {
   ASC: 'ASC' as const,
   DESC: 'DESC' as const
}

export const enumGetBankStatementRequestsSortType = {
   COMPANY_NAME: 'COMPANY_NAME' as const,
   TIER: 'TIER' as const,
   STATUS: 'STATUS' as const,
   LAST_UPDATED_AT: 'LAST_UPDATED_AT' as const,
   COMPLETED_AT: 'COMPLETED_AT' as const
}

export const enumGetCogsBreakdownSortField = {
   SKU: 'SKU' as const,
   DISPLAY_NAME: 'DISPLAY_NAME' as const,
   UNITS: 'UNITS' as const,
   TOTAL_LANDED: 'TOTAL_LANDED' as const,
   TOTAL_DIRECT: 'TOTAL_DIRECT' as const,
   TOTAL_VENDOR_FEES: 'TOTAL_VENDOR_FEES' as const,
   TOTAL_DUTIES_AND_TAX: 'TOTAL_DUTIES_AND_TAX' as const,
   TOTAL_CUSTOM_FEES_AND_SERVICES: 'TOTAL_CUSTOM_FEES_AND_SERVICES' as const,
   TOTAL_INSURANCE: 'TOTAL_INSURANCE' as const,
   TOTAL_PRODUCTION_COST: 'TOTAL_PRODUCTION_COST' as const,
   TOTAL_DISCOUNT: 'TOTAL_DISCOUNT' as const,
   TOTAL_SHIPPING: 'TOTAL_SHIPPING' as const,
   TOTAL_PALLET_COSTS: 'TOTAL_PALLET_COSTS' as const,
   TOTAL_SHIPPING_SURCHARGE: 'TOTAL_SHIPPING_SURCHARGE' as const,
   TOTAL_OTHER_INVENTORY_ADJUSTMENTS: 'TOTAL_OTHER_INVENTORY_ADJUSTMENTS' as const,
   TOTAL_PRODUCTION_LABOR_COST: 'TOTAL_PRODUCTION_LABOR_COST' as const,
   AVG_COST_PER_UNIT_LANDED: 'AVG_COST_PER_UNIT_LANDED' as const,
   AVG_COST_PER_UNIT_DIRECT: 'AVG_COST_PER_UNIT_DIRECT' as const,
   AVG_COST_PER_UNIT_VENDOR_FEES: 'AVG_COST_PER_UNIT_VENDOR_FEES' as const,
   AVG_COST_PER_UNIT_DUTIES_AND_TAX: 'AVG_COST_PER_UNIT_DUTIES_AND_TAX' as const,
   AVG_COST_PER_UNIT_CUSTOM_FEES_AND_SERVICES: 'AVG_COST_PER_UNIT_CUSTOM_FEES_AND_SERVICES' as const,
   AVG_COST_PER_UNIT_INSURANCE: 'AVG_COST_PER_UNIT_INSURANCE' as const,
   AVG_COST_PER_UNIT_PRODUCTION_COST: 'AVG_COST_PER_UNIT_PRODUCTION_COST' as const,
   AVG_COST_PER_UNIT_DISCOUNT: 'AVG_COST_PER_UNIT_DISCOUNT' as const,
   AVG_COST_PER_UNIT_SHIPPING: 'AVG_COST_PER_UNIT_SHIPPING' as const,
   AVG_COST_PER_UNIT_PALLET_COSTS: 'AVG_COST_PER_UNIT_PALLET_COSTS' as const,
   AVG_COST_PER_UNIT_SHIPPING_SURCHARGE: 'AVG_COST_PER_UNIT_SHIPPING_SURCHARGE' as const,
   AVG_COST_PER_UNIT_OTHER_INVENTORY_ADJUSTMENTS: 'AVG_COST_PER_UNIT_OTHER_INVENTORY_ADJUSTMENTS' as const,
   AVG_COST_PER_UNIT_PRODUCTION_LABOR_COST: 'AVG_COST_PER_UNIT_PRODUCTION_LABOR_COST' as const
}

export const enumGetNoUnitsPhysicalCountProductQuantitiesSortField = {
   SKU: 'SKU' as const,
   COST_PER_UNIT: 'COST_PER_UNIT' as const,
   DISPLAY_NAME: 'DISPLAY_NAME' as const,
   TOTAL_CLOSING_BALANCE: 'TOTAL_CLOSING_BALANCE' as const,
   QUANTITY: 'QUANTITY' as const
}

export const enumGetOrdersSortDirection = {
   ASC: 'ASC' as const,
   DESC: 'DESC' as const
}

export const enumGetOrdersSortType = {
   PLACED_DATE: 'PLACED_DATE' as const,
   FIRST_PAYMENT_DATE: 'FIRST_PAYMENT_DATE' as const,
   FIRST_REFUND_DATE: 'FIRST_REFUND_DATE' as const,
   FIRST_FULFILLMENT_DATE: 'FIRST_FULFILLMENT_DATE' as const,
   TOTAL: 'TOTAL' as const,
   NET_SALES: 'NET_SALES' as const,
   UNPAID_BALANCE: 'UNPAID_BALANCE' as const,
   BALANCE: 'BALANCE' as const
}

export const enumGetPendingAdjustmentsSortField = {
   SKU: 'SKU' as const,
   PRODUCT_DISPLAY_NAME: 'PRODUCT_DISPLAY_NAME' as const,
   SOURCE: 'SOURCE' as const,
   WAREHOUSE_NAME: 'WAREHOUSE_NAME' as const,
   DATE: 'DATE' as const,
   UNITS_SOLD: 'UNITS_SOLD' as const,
   UNITS_RESTOCKED: 'UNITS_RESTOCKED' as const,
   QUANTITY: 'QUANTITY' as const
}

export const enumGetPendingSalesDataAdjustmentsSortField = {
   SKU: 'SKU' as const,
   PRODUCT_DISPLAY_NAME: 'PRODUCT_DISPLAY_NAME' as const,
   SOURCE: 'SOURCE' as const,
   WAREHOUSE_NAME: 'WAREHOUSE_NAME' as const,
   DATE: 'DATE' as const,
   UNITS_SOLD: 'UNITS_SOLD' as const,
   UNITS_RESTOCKED: 'UNITS_RESTOCKED' as const
}

export const enumGetProductsSortField = {
   SKU: 'SKU' as const,
   DISPLAY_NAME: 'DISPLAY_NAME' as const,
   TOTAL_SOLD: 'TOTAL_SOLD' as const,
   CURRENT_COST: 'CURRENT_COST' as const,
   NET_DEPLETED: 'NET_DEPLETED' as const,
   COST_PER_UNIT: 'COST_PER_UNIT' as const,
   ON_HAND_COST: 'ON_HAND_COST' as const,
   ON_HAND: 'ON_HAND' as const,
   PURCHASED: 'PURCHASED' as const,
   IN_TRANSIT: 'IN_TRANSIT' as const,
   SOURCE: 'SOURCE' as const,
   OPENING_BALANCE_QUANTITY: 'OPENING_BALANCE_QUANTITY' as const,
   NEGATIVE_ON_HAND: 'NEGATIVE_ON_HAND' as const
}

export const enumGetSalesSortDirection = {
   ASC: 'ASC' as const,
   DESC: 'DESC' as const
}

export const enumGetSalesSortType = {
   PLACED_DATE: 'PLACED_DATE' as const,
   DISPLAY_NAME: 'DISPLAY_NAME' as const,
   CUSTOMER_NAME: 'CUSTOMER_NAME' as const,
   SOURCE: 'SOURCE' as const,
   TOTAL: 'TOTAL' as const,
   TOTAL_BEFORE_TAXES: 'TOTAL_BEFORE_TAXES' as const,
   BALANCE: 'BALANCE' as const,
   DUE_DATE: 'DUE_DATE' as const
}

export const enumGetUnitsTrackingPhysicalCountProductQuantitiesSortField = {
   SKU: 'SKU' as const,
   AVG_COST: 'AVG_COST' as const,
   DISPLAY_NAME: 'DISPLAY_NAME' as const,
   UNITS_ON_HAND: 'UNITS_ON_HAND' as const,
   ADJUSTMENT: 'ADJUSTMENT' as const,
   TOTAL_ADJUSTMENT: 'TOTAL_ADJUSTMENT' as const,
   QUANTITY: 'QUANTITY' as const
}

export const enumGiftCardIssueMethod = {
   PURCHASED: 'PURCHASED' as const,
   MANUALLY_ISSUED: 'MANUALLY_ISSUED' as const
}

export const enumGiftCardSortKeys = {
   STATUS: 'STATUS' as const,
   INITIAL_BALANCE: 'INITIAL_BALANCE' as const,
   BALANCE_AS_OF: 'BALANCE_AS_OF' as const,
   CURRENT_BALANCE: 'CURRENT_BALANCE' as const,
   ISSUE_DATE: 'ISSUE_DATE' as const,
   DEACTIVATION_DATE: 'DEACTIVATION_DATE' as const,
   EXPIRATION_DATE: 'EXPIRATION_DATE' as const,
   DISABLE_DATE: 'DISABLE_DATE' as const
}

export const enumGiftCardsSortDirection = {
   ASCENDING: 'ASCENDING' as const,
   DESCENDING: 'DESCENDING' as const
}

export const enumGiftCardStatus = {
   ACTIVE: 'ACTIVE' as const,
   PARTIALLY_REDEEMED: 'PARTIALLY_REDEEMED' as const,
   REDEEMED: 'REDEEMED' as const,
   DEACTIVATED: 'DEACTIVATED' as const,
   EXPIRED: 'EXPIRED' as const
}

export const enumHolderStatus = {
   ACTIVE: 'ACTIVE' as const,
   INACTIVE: 'INACTIVE' as const
}

export const enumHolderTransactionType = {
   CONTRIBUTION: 'CONTRIBUTION' as const,
   DISTRIBUTION: 'DISTRIBUTION' as const,
   REDEMPTION: 'REDEMPTION' as const
}

export const enumHubItemState = {
   INACTIVE: 'INACTIVE' as const,
   OPEN: 'OPEN' as const,
   IN_PROGRESS: 'IN_PROGRESS' as const,
   CLOSED: 'CLOSED' as const
}

export const enumHubState = {
   INACTIVE: 'INACTIVE' as const,
   OPEN: 'OPEN' as const,
   INITIAL_PROCESSING: 'INITIAL_PROCESSING' as const,
   AWAITING_USER_FEEDBACK: 'AWAITING_USER_FEEDBACK' as const,
   FOLLOW_UP_PROCESSING: 'FOLLOW_UP_PROCESSING' as const,
   READY: 'READY' as const,
   NA: 'NA' as const
}

export const enumHubUpdaterType = {
   USER: 'USER' as const,
   SYSTEM: 'SYSTEM' as const,
   OPS: 'OPS' as const
}

export const enumHubUpdaterTypeInput = {
   USER: 'USER' as const,
   OPS: 'OPS' as const
}

export const enumIndirectLineItemType = {
   SHIPPING: 'SHIPPING' as const,
   GENERAL: 'GENERAL' as const,
   VENDOR_FEES: 'VENDOR_FEES' as const,
   DUTIES_AND_TAX: 'DUTIES_AND_TAX' as const,
   CUSTOM_FEES_AND_SERVICES: 'CUSTOM_FEES_AND_SERVICES' as const,
   INSURANCE: 'INSURANCE' as const,
   PRODUCTION_COSTS: 'PRODUCTION_COSTS' as const,
   DISCOUNT: 'DISCOUNT' as const,
   PALLET_COSTS: 'PALLET_COSTS' as const,
   SHIPPING_SURCHARGE: 'SHIPPING_SURCHARGE' as const,
   OTHER_INVENTORY_ADJUSTMENTS: 'OTHER_INVENTORY_ADJUSTMENTS' as const,
   PRODUCTION_LABOR_COSTS: 'PRODUCTION_LABOR_COSTS' as const,
   OTHER: 'OTHER' as const
}

export const enumIndividualSkusSortField = {
   DATE: 'DATE' as const,
   SALES: 'SALES' as const,
   DISCOUNTS: 'DISCOUNTS' as const,
   COGS: 'COGS' as const,
   PROFIT: 'PROFIT' as const,
   MARGIN: 'MARGIN' as const,
   REFUNDS: 'REFUNDS' as const,
   UNITS_SOLD: 'UNITS_SOLD' as const,
   UNITS_REFUNDED: 'UNITS_REFUNDED' as const
}

export const enumInstitutionMappingSourceType = {
   PLAID: 'PLAID' as const,
   QUICKBOOKS: 'QUICKBOOKS' as const,
   QUICKBOOKS_BANKS: 'QUICKBOOKS_BANKS' as const
}

export const enumInstitutionProviders = {
   PLAID: 'PLAID' as const,
   PAYPAL: 'PAYPAL' as const,
   RAMP: 'RAMP' as const,
   MANUAL: 'MANUAL' as const
}

export const enumIntegrationConnectionType = {
   PAYMENT_PROCESSOR: 'PAYMENT_PROCESSOR' as const,
   MARKETPLACE: 'MARKETPLACE' as const
}

export const enumIntegrationSource = {
   PAYPAL: 'PAYPAL' as const,
   STRIPE: 'STRIPE' as const,
   QUICKBOOKS: 'QUICKBOOKS' as const,
   SPS_COMMERCE: 'SPS_COMMERCE' as const,
   QUICKBOOKS_INVOICES: 'QUICKBOOKS_INVOICES' as const,
   NU_ORDER_INVOICES: 'NU_ORDER_INVOICES' as const,
   FINALOOP_INVOICES: 'FINALOOP_INVOICES' as const
}

export const enumIntegrationTransferPairedEntityType = {
   COMPANY_AFFILIATE: 'COMPANY_AFFILIATE' as const,
   BANK_TRANSACTION: 'BANK_TRANSACTION' as const,
   RELATED_PARTY: 'RELATED_PARTY' as const
}

export const enumIntegrationTransferType = {
   PAYOUT: 'PAYOUT' as const,
   TOPUP: 'TOPUP' as const
}

export const enumIntegrationTransferTypeV2 = {
   FROM_INTEGRATION: 'FROM_INTEGRATION' as const,
   TO_INTEGRATION: 'TO_INTEGRATION' as const
}

export const enumIntegrationType = {
   AFTERPAY: 'AFTERPAY' as const,
   AMAZON: 'AMAZON' as const,
   AMAZON_PAY: 'AMAZON_PAY' as const,
   BILL_COM: 'BILL_COM' as const,
   EBAY: 'EBAY' as const,
   ETSY: 'ETSY' as const,
   FACEBOOK_ADS: 'FACEBOOK_ADS' as const,
   GOOGLE_ADS: 'GOOGLE_ADS' as const,
   PAYPAL: 'PAYPAL' as const,
   PLAID: 'PLAID' as const,
   QUICKBOOKS: 'QUICKBOOKS' as const,
   SHOPIFY: 'SHOPIFY' as const,
   SHOP_PAY: 'SHOP_PAY' as const,
   STRIPE: 'STRIPE' as const,
   WALMART: 'WALMART' as const,
   FINALOOP_BANK_TRANSACTIONS_UPLOAD: 'FINALOOP_BANK_TRANSACTIONS_UPLOAD' as const,
   FINALOOP_BALANCE_TRANSACTIONS: 'FINALOOP_BALANCE_TRANSACTIONS' as const,
   FINALOOP_BILLS: 'FINALOOP_BILLS' as const,
   FINALOOP_INVOICES: 'FINALOOP_INVOICES' as const,
   FINALOOP_INVENTORY: 'FINALOOP_INVENTORY' as const,
   FINALOOP_INTERNAL: 'FINALOOP_INTERNAL' as const,
   FINALOOP_PAYMENTS: 'FINALOOP_PAYMENTS' as const,
   FINALOOP_TRANSACTIONS: 'FINALOOP_TRANSACTIONS' as const,
   FINALOOP_TRANSACTIONS_MACHINE: 'FINALOOP_TRANSACTIONS_MACHINE' as const,
   FINALOOP_BANK_ACCOUNT_VALIDATIONS: 'FINALOOP_BANK_ACCOUNT_VALIDATIONS' as const,
   FINALOOP_COMPANY_AFFILIATE_BALANCES: 'FINALOOP_COMPANY_AFFILIATE_BALANCES' as const,
   QUICKBOOKS_BANKS: 'QUICKBOOKS_BANKS' as const,
   REPORTED_BUSINESS_BANK_TRANSACTIONS: 'REPORTED_BUSINESS_BANK_TRANSACTIONS' as const,
   SHADOW_QUICKBOOKS: 'SHADOW_QUICKBOOKS' as const,
   SHOPIFY_ORDERS: 'SHOPIFY_ORDERS' as const,
   SHOPIFY_PRODUCTS: 'SHOPIFY_PRODUCTS' as const,
   TEST: 'TEST' as const,
   USER: 'USER' as const,
   USER_PASSWORD: 'USER_PASSWORD' as const,
   AFFIRM: 'AFFIRM' as const,
   ALMA: 'ALMA' as const,
   AUTHORIZE_NET: 'AUTHORIZE_NET' as const,
   BLACKCART: 'BLACKCART' as const,
   BANKFUL: 'BANKFUL' as const,
   BRAINTREE: 'BRAINTREE' as const,
   CLEARCO: 'CLEARCO' as const,
   CLEARPAY: 'CLEARPAY' as const,
   FAIRE: 'FAIRE' as const,
   PARKER: 'PARKER' as const,
   KLARNA: 'KLARNA' as const,
   KLICKLY: 'KLICKLY' as const,
   SETTLE: 'SETTLE' as const,
   SEZZLE: 'SEZZLE' as const,
   SPS_COMMERCE: 'SPS_COMMERCE' as const,
   QUICKBOOKS_PAYMENTS: 'QUICKBOOKS_PAYMENTS' as const,
   SQUARE: 'SQUARE' as const,
   WOOCOMMERCE: 'WOOCOMMERCE' as const,
   FACEBOOK: 'FACEBOOK' as const,
   ZIP_CO: 'ZIP_CO' as const,
   SPLITIT: 'SPLITIT' as const,
   BREAD_PAY: 'BREAD_PAY' as const,
   GLOBAL_E: 'GLOBAL_E' as const,
   GUSTO: 'GUSTO' as const,
   SNACK_MAGIC: 'SNACK_MAGIC' as const,
   POSTAL: 'POSTAL' as const,
   CORPORATE_GIFT: 'CORPORATE_GIFT' as const,
   CAROO: 'CAROO' as const,
   CARRO: 'CARRO' as const,
   RAMP: 'RAMP' as const,
   RAMP_PUBLIC_API: 'RAMP_PUBLIC_API' as const,
   STRIPE_FINANCIAL_CONNECTIONS: 'STRIPE_FINANCIAL_CONNECTIONS' as const,
   MX: 'MX' as const,
   REVOLUT: 'REVOLUT' as const,
   OPEN_PATH: 'OPEN_PATH' as const,
   OPEN_NOD: 'OPEN_NOD' as const,
   RETURNLY: 'RETURNLY' as const,
   COINBASE: 'COINBASE' as const,
   TRUE_MED: 'TRUE_MED' as const,
   PAYONEER: 'PAYONEER' as const,
   AIRWALLEX: 'AIRWALLEX' as const,
   LEAP_RETAIL: 'LEAP_RETAIL' as const,
   TWINT: 'TWINT' as const,
   MIRAKL: 'MIRAKL' as const,
   CATCH: 'CATCH' as const,
   PARTIAL_LY: 'PARTIAL_LY' as const,
   TIK_TOK: 'TIK_TOK' as const,
   BLOOM: 'BLOOM' as const,
   TRACKSTAR: 'TRACKSTAR' as const,
   QUICKBOOKS_INVOICES: 'QUICKBOOKS_INVOICES' as const,
   NU_ORDER_INVOICES: 'NU_ORDER_INVOICES' as const
}

export const enumInventoryPaymentGroupsSortDirection = {
   ASC: 'ASC' as const,
   DESC: 'DESC' as const
}

export const enumInventoryPaymentGroupsSortType = {
   POSTED_AT: 'POSTED_AT' as const
}

export const enumInventoryPurchaseCategoryName = {
   CONSIGNMENT: 'CONSIGNMENT' as const,
   DROPSHIPPING: 'DROPSHIPPING' as const,
   DEAD_INVENTORY: 'DEAD_INVENTORY' as const,
   FINISHED_PRODUCTS: 'FINISHED_PRODUCTS' as const,
   OTHER_INVENTORY_INDIRECT_COSTS: 'OTHER_INVENTORY_INDIRECT_COSTS' as const,
   PACKAGING_MATERIALS: 'PACKAGING_MATERIALS' as const,
   PRODUCTION_COSTS: 'PRODUCTION_COSTS' as const,
   PRODUCTION_LABOR_COSTS: 'PRODUCTION_LABOR_COSTS' as const,
   SHIPPING_AND_FREIGHT_IN: 'SHIPPING_AND_FREIGHT_IN' as const,
   SUPPLIES_AND_MATERIALS: 'SUPPLIES_AND_MATERIALS' as const,
   VENDOR_FEES: 'VENDOR_FEES' as const,
   DUTIES_AND_TAX: 'DUTIES_AND_TAX' as const,
   CUSTOM_FEES_AND_SERVICES: 'CUSTOM_FEES_AND_SERVICES' as const,
   INVENTORY_INSURANCE: 'INVENTORY_INSURANCE' as const,
   SHIPPING_SURCHARGE: 'SHIPPING_SURCHARGE' as const,
   PALLET_COSTS: 'PALLET_COSTS' as const,
   PRODUCT_DONATIONS: 'PRODUCT_DONATIONS' as const,
   PRODUCT_GIVEAWAYS: 'PRODUCT_GIVEAWAYS' as const,
   WARRANTY_REIMBURSEMENT: 'WARRANTY_REIMBURSEMENT' as const
}

export const enumInventoryPurchaseDirection = {
   PURCHASE: 'PURCHASE' as const,
   REFUND: 'REFUND' as const
}

export const enumInventoryPurchasePaymentStatus = {
   UNPAID: 'UNPAID' as const,
   PARTIALLY_PAID: 'PARTIALLY_PAID' as const,
   FULLY_PAID: 'FULLY_PAID' as const
}

export const enumInventoryPurchaseRuleApplyRuleOperation = {
   CREATE: 'CREATE' as const,
   UPDATE: 'UPDATE' as const,
   DELETE: 'DELETE' as const
}

export const enumInventoryPurchaseRuleCondition = {
   GREATER_THAN: 'GREATER_THAN' as const,
   LESS_THAN: 'LESS_THAN' as const
}

export const enumInventoryPurchaseSource = {
   TRANSACTION: 'TRANSACTION' as const,
   BILL: 'BILL' as const,
   USER_INPUT: 'USER_INPUT' as const,
   PAYROLL: 'PAYROLL' as const,
   AMAZON_SHIPPING_IN: 'AMAZON_SHIPPING_IN' as const,
   CONTRACTOR_PAYMENT: 'CONTRACTOR_PAYMENT' as const
}

export const enumInventoryPurchaseSourceCategory = {
   BILL: 'BILL' as const,
   PURCHASE: 'PURCHASE' as const
}

export const enumInventoryPurchasesSortByField = {
   DATE: 'DATE' as const,
   PAID_STATUS: 'PAID_STATUS' as const
}

export const enumInventoryPurchasesSortDirection = {
   ASC: 'ASC' as const,
   DESC: 'DESC' as const
}

export const enumInventoryPurchaseStatus = {
   PENDING: 'PENDING' as const,
   IN_PROCESS: 'IN_PROCESS' as const,
   IN_TRANSIT: 'IN_TRANSIT' as const,
   RECEIVED: 'RECEIVED' as const
}

export const enumInventoryPurchasesValidationStatus = {
   PASS: 'PASS' as const,
   FAIL: 'FAIL' as const
}

export const enumInventoryPurchaseType = {
   PURCHASE: 'PURCHASE' as const,
   INCIDENTAL: 'INCIDENTAL' as const,
   ALLOCATED_RECIPES: 'ALLOCATED_RECIPES' as const
}

export const enumInventoryUsageType = {
   WAREHOUSE_TRANSFERS: 'WAREHOUSE_TRANSFERS' as const,
   INVOICE_COGS: 'INVOICE_COGS' as const,
   OTHER_INTEGRATION_SALES: 'OTHER_INTEGRATION_SALES' as const,
   DROPSHIPPING: 'DROPSHIPPING' as const
}

export const enumInventoryVendorBillItemType = {
   BILL: 'BILL' as const,
   INCIDENTAL: 'INCIDENTAL' as const,
   PAYMENT: 'PAYMENT' as const,
   CREDIT: 'CREDIT' as const,
   ADJUSTMENT: 'ADJUSTMENT' as const
}

export const enumInventoryVendorRollingBalanceItemTypes = {
   PURCHASE_ORDER: 'PURCHASE_ORDER' as const,
   BILL: 'BILL' as const,
   PAYMENT: 'PAYMENT' as const,
   TRANSACTION: 'TRANSACTION' as const,
   USER_INPUT: 'USER_INPUT' as const,
   WAREHOUSE_TRANSFER: 'WAREHOUSE_TRANSFER' as const,
   ASSEMBLY: 'ASSEMBLY' as const
}

export const enumInventoryVendorsSortField = {
   vendorName: 'vendorName' as const,
   rollingBalance: 'rollingBalance' as const
}

export const enumInventoryYearEndMissionStatus = {
   OPEN: 'OPEN' as const,
   REOPEN: 'REOPEN' as const,
   COMPLETED: 'COMPLETED' as const
}

export const enumInventoryYearEndMissionsType = {
   PurchaseBasedOpeningBalance: 'PurchaseBasedOpeningBalance' as const,
   PurchaseBasedPurchases: 'PurchaseBasedPurchases' as const,
   PurchaseBasedClosingBalance: 'PurchaseBasedClosingBalance' as const,
   SalesBasedOpeningBalance: 'SalesBasedOpeningBalance' as const,
   SalesBasedPurchases: 'SalesBasedPurchases' as const,
   SalesBasedReportCogs: 'SalesBasedReportCogs' as const,
   SalesBasedMissingCostPerUnit: 'SalesBasedMissingCostPerUnit' as const,
   SalesBasedClosingBalance: 'SalesBasedClosingBalance' as const,
   UnitBasedVendorsNegativeBalance: 'UnitBasedVendorsNegativeBalance' as const,
   UnitBasedReportCogs: 'UnitBasedReportCogs' as const,
   UnitBasedNegativeOnHands: 'UnitBasedNegativeOnHands' as const,
   UnitBasedClosingBalance: 'UnitBasedClosingBalance' as const
}

export const enumInvitationStatus = {
   PENDING: 'PENDING' as const,
   ACCEPTED: 'ACCEPTED' as const,
   EXPIRED: 'EXPIRED' as const
}

export const enumInvoicesYearEndTaskId = {
   CLOSE_OPEN_INVOICES: 'CLOSE_OPEN_INVOICES' as const,
   LINK_INVOICE_PAYMENTS: 'LINK_INVOICE_PAYMENTS' as const,
   ADD_MISSING_INVOICES: 'ADD_MISSING_INVOICES' as const,
   CONFIRM_AR_BALANCE: 'CONFIRM_AR_BALANCE' as const
}

export const enumInvoicesYearEndTaskStatus = {
   INACTIVE: 'INACTIVE' as const,
   OPEN: 'OPEN' as const,
   REOPENED: 'REOPENED' as const,
   PROCESSING: 'PROCESSING' as const,
   CLOSED: 'CLOSED' as const
}

export const enumIrrelevantType = {
   OPEN_AFTER_SPECIFIED_DATE: 'OPEN_AFTER_SPECIFIED_DATE' as const,
   CLOSED_DURING_THE_YEAR: 'CLOSED_DURING_THE_YEAR' as const,
   PERSONAL_ACCOUNT: 'PERSONAL_ACCOUNT' as const,
   BUSINESS_ACCOUNT: 'BUSINESS_ACCOUNT' as const,
   TRANSFERRED_TO_BUSINESS_AFTER_SPECIFIED_DATE: 'TRANSFERRED_TO_BUSINESS_AFTER_SPECIFIED_DATE' as const,
   TRANSFERRED_FROM_BUSINESS_DURING_THE_YEAR: 'TRANSFERRED_FROM_BUSINESS_DURING_THE_YEAR' as const
}

export const enumLineItemDiscountType = {
   SELLER_DISCOUNT: 'SELLER_DISCOUNT' as const,
   PLATFORM_DISCOUNT: 'PLATFORM_DISCOUNT' as const
}

export const enumLineItemTimeLineActionTypeV3 = {
   PLACEMENT: 'PLACEMENT' as const,
   FULFILLMENT: 'FULFILLMENT' as const,
   REFUND_BEFORE_FULFILLMENT: 'REFUND_BEFORE_FULFILLMENT' as const,
   REFUND_AFTER_FULFILLMENT: 'REFUND_AFTER_FULFILLMENT' as const,
   OPENING_BALANCE: 'OPENING_BALANCE' as const
}

export const enumListAssemblyItemsSortDirection = {
   ASC: 'ASC' as const,
   DESC: 'DESC' as const
}

export const enumListAssemblyItemsSortField = {
   PRODUCT_NAME: 'PRODUCT_NAME' as const,
   RECIPE_NAME: 'RECIPE_NAME' as const,
   DATE: 'DATE' as const,
   AMOUNT: 'AMOUNT' as const,
   ASSEMBLY_TYPE: 'ASSEMBLY_TYPE' as const
}

export const enumLoanAccountRoleEffectDirection = {
   INCREASE: 'INCREASE' as const,
   DECREASE: 'DECREASE' as const
}

export const enumLoanAmountEffect = {
   DECREASE: 'DECREASE' as const,
   INCREASE: 'INCREASE' as const
}

export const enumLoanAttachmentErrorType = {
   LOAN_DATE_MISMATCH: 'LOAN_DATE_MISMATCH' as const,
   LOAN_AMOUNT_MISMATCH: 'LOAN_AMOUNT_MISMATCH' as const,
   PARSING_FAILED: 'PARSING_FAILED' as const,
   VALIDATION_FAILED: 'VALIDATION_FAILED' as const,
   OTHER: 'OTHER' as const
}

export const enumLoanAttachmentType = {
   AGREEMENT: 'AGREEMENT' as const,
   AMORTIZATION_SCHEDULE: 'AMORTIZATION_SCHEDULE' as const,
   STATEMENT: 'STATEMENT' as const,
   REPAYMENT_SCHEDULE: 'REPAYMENT_SCHEDULE' as const,
   AMENDMENT: 'AMENDMENT' as const,
   RECONCILIATION: 'RECONCILIATION' as const
}

export const enumLoanCompoundFrequency = {
   CONTINUOUSLY: 'CONTINUOUSLY' as const,
   DAILY: 'DAILY' as const,
   WEEKLY: 'WEEKLY' as const,
   MONTHLY: 'MONTHLY' as const,
   QUARTERLY: 'QUARTERLY' as const,
   YEARLY: 'YEARLY' as const
}

export const enumLoanDataRequestType = {
   ONE_TIME: 'ONE_TIME' as const,
   RECURRING: 'RECURRING' as const
}

export const enumLoanDirection = {
   TAKEN: 'TAKEN' as const,
   GIVEN: 'GIVEN' as const,
   ROLLING: 'ROLLING' as const
}

export const enumLoanEventFilter = {
   MANUAL: 'MANUAL' as const,
   AUTOMATED: 'AUTOMATED' as const,
   TRANSACTION: 'TRANSACTION' as const,
   BILL: 'BILL' as const,
   BILL_PAYMENT: 'BILL_PAYMENT' as const,
   BUSINESS: 'BUSINESS' as const
}

export const enumLoanEventRecurrence = {
   ONCE: 'ONCE' as const,
   WEEKLY: 'WEEKLY' as const,
   MONTHLY: 'MONTHLY' as const
}

export const enumLoanIndexType = {
   CONSUMER_PRICE_INDEX: 'CONSUMER_PRICE_INDEX' as const
}

export const enumLoanInstantRepaymentMethod = {
   DIRECT: 'DIRECT' as const,
   INDIRECT: 'INDIRECT' as const
}

export const enumLoanInterestDays = {
   DAYS_365: 'DAYS_365' as const,
   DAYS_360: 'DAYS_360' as const,
   ACTUAL_DAYS: 'ACTUAL_DAYS' as const
}

export const enumLoanInterestRateType = {
   FIXED: 'FIXED' as const,
   VARIABLE: 'VARIABLE' as const
}

export const enumLoanInterestType = {
   SIMPLE: 'SIMPLE' as const,
   COMPOUND: 'COMPOUND' as const
}

export const enumLoanLenderType = {
   CompanyAffiliate: 'CompanyAffiliate' as const,
   Vendor: 'Vendor' as const,
   Institution: 'Institution' as const
}

export const enumLoanOutstandingAmountAffect = {
   DECREASE: 'DECREASE' as const,
   INCREASE: 'INCREASE' as const
}

export const enumLoanPropertySource = {
   AUTOMATIC: 'AUTOMATIC' as const,
   MANUAL: 'MANUAL' as const
}

export const enumLoanRecurringDataFrequency = {
   MONTHLY: 'MONTHLY' as const,
   QUARTERLY: 'QUARTERLY' as const,
   YEARLY: 'YEARLY' as const
}

export const enumLoanRepaymentFrequency = {
   DAY: 'DAY' as const,
   WEEK: 'WEEK' as const,
   MONTH: 'MONTH' as const,
   QUARTER: 'QUARTER' as const,
   YEAR: 'YEAR' as const
}

export const enumLoanRepaymentType = {
   AMORTIZATION: 'AMORTIZATION' as const,
   BALLOON: 'BALLOON' as const,
   INTEREST_ONLY: 'INTEREST_ONLY' as const,
   FIXED_PRINCIPAL: 'FIXED_PRINCIPAL' as const,
   ACCRUED_INTEREST_FIRST: 'ACCRUED_INTEREST_FIRST' as const
}

export const enumLoanSortDirection = {
   asc: 'asc' as const,
   desc: 'desc' as const
}

export const enumLoanSource = {
   INTEGRATION: 'INTEGRATION' as const,
   TRANSACTION: 'TRANSACTION' as const,
   BACKOFFICE: 'BACKOFFICE' as const,
   APPLICATION: 'APPLICATION' as const,
   BILLS: 'BILLS' as const,
   BALANCE_TRANSACTION: 'BALANCE_TRANSACTION' as const
}

export const enumLoanStatus = {
   PREACTIVE: 'PREACTIVE' as const,
   ACTIVE: 'ACTIVE' as const,
   PAID_OFF: 'PAID_OFF' as const,
   FORGIVEN: 'FORGIVEN' as const
}

export const enumLoanTermDuration = {
   DAY: 'DAY' as const,
   WEEK: 'WEEK' as const,
   MONTH: 'MONTH' as const,
   QUARTER: 'QUARTER' as const,
   YEAR: 'YEAR' as const
}

export const enumLoanTreatmentStatus = {
   OPEN: 'OPEN' as const,
   RECURRING: 'RECURRING' as const,
   DONE: 'DONE' as const,
   MISSING_DATA: 'MISSING_DATA' as const,
   DELETED: 'DELETED' as const,
   AUTO: 'AUTO' as const
}

export const enumLoanType = {
   MERCHANT_CASH_ADVANCE: 'MERCHANT_CASH_ADVANCE' as const,
   TERM_LOAN: 'TERM_LOAN' as const,
   REVENUE_BASED_CREDIT: 'REVENUE_BASED_CREDIT' as const,
   FACTORING: 'FACTORING' as const,
   AP_FINANCING: 'AP_FINANCING' as const,
   LINE_OF_CREDIT: 'LINE_OF_CREDIT' as const,
   INSTANT_ADVANCE: 'INSTANT_ADVANCE' as const,
   SALE_OF_FUTURE_REVENUE: 'SALE_OF_FUTURE_REVENUE' as const,
   CAR_LOAN: 'CAR_LOAN' as const,
   INVENTORY_FINANCING: 'INVENTORY_FINANCING' as const,
   CONVERTIBLE: 'CONVERTIBLE' as const,
   RELATED_PARTY_LOAN: 'RELATED_PARTY_LOAN' as const,
   RELATED_PARTY_BALANCE: 'RELATED_PARTY_BALANCE' as const,
   DUE_TO_FROM_OWNER: 'DUE_TO_FROM_OWNER' as const,
   DUE_TO_FROM_CONTRACTOR: 'DUE_TO_FROM_CONTRACTOR' as const,
   DUE_TO_FROM_EMPLOYEE: 'DUE_TO_FROM_EMPLOYEE' as const,
   RELATED_PARTY_CONVERTIBLE: 'RELATED_PARTY_CONVERTIBLE' as const
}

export const enumLoanUserActionStatus = {
   ACTION_REQUIRED: 'ACTION_REQUIRED' as const,
   PROCESSING: 'PROCESSING' as const,
   APPROVED: 'APPROVED' as const,
   DELETED: 'DELETED' as const
}

export const enumLoanUserFollowUpType = {
   WRONG_AGREEMENT: 'WRONG_AGREEMENT' as const,
   WRONG_AMORTIZATION_SCHEDULE: 'WRONG_AMORTIZATION_SCHEDULE' as const,
   INVITATION_NOT_RECEIVED: 'INVITATION_NOT_RECEIVED' as const,
   INVITATION_STEP_2: 'INVITATION_STEP_2' as const,
   STEP_2_NOT_RECEIVED: 'STEP_2_NOT_RECEIVED' as const,
   WRONG_REPEYMENT_SCHEDULE: 'WRONG_REPEYMENT_SCHEDULE' as const,
   WRONG_PAYMENT_SCHEDULE: 'WRONG_PAYMENT_SCHEDULE' as const,
   BANK_NOT_CONNECTED: 'BANK_NOT_CONNECTED' as const,
   REQUEST_FOR_STATEMENTS: 'REQUEST_FOR_STATEMENTS' as const,
   MISSING_AMENDMENT: 'MISSING_AMENDMENT' as const,
   NOT_THE_STATEMENT: 'NOT_THE_STATEMENT' as const,
   NOT_THE_RECONCILIATION_REPORT: 'NOT_THE_RECONCILIATION_REPORT' as const,
   MISSING_THE_TRANSACTION_STATEMENT: 'MISSING_THE_TRANSACTION_STATEMENT' as const,
   WRONG_PAYMENT_HISTORY: 'WRONG_PAYMENT_HISTORY' as const,
   MISSING_STATEMENT: 'MISSING_STATEMENT' as const,
   RECONCILIATION_NEEDED: 'RECONCILIATION_NEEDED' as const
}

export const enumLoanVariableInterestBase = {
   PRIME: 'PRIME' as const,
   SOFR: 'SOFR' as const
}

export const enumLoanVariableInterestUpdatePeriod = {
   MONTH: 'MONTH' as const,
   QUARTER: 'QUARTER' as const,
   YEAR_2: 'YEAR_2' as const,
   YEAR_5: 'YEAR_5' as const,
   CUSTOM: 'CUSTOM' as const
}

export const enumLockAction = {
   LOCK: 'LOCK' as const,
   UNLOCK: 'UNLOCK' as const
}

export const enumLockConditionStatus = {
   Ok: 'Ok' as const,
   NotOk: 'NotOk' as const
}

export const enumLockType = {
   lock: 'lock' as const,
   unlock: 'unlock' as const
}

export const enumManageBalanceSheetSetupStatus = {
   ERROR: 'ERROR' as const,
   RESET_SUCCESSFULLY: 'RESET_SUCCESSFULLY' as const,
   CREATED_SUCCESSFULLY: 'CREATED_SUCCESSFULLY' as const,
   OPEN_SUCCESSFULLY: 'OPEN_SUCCESSFULLY' as const,
   COMPANY_NOT_FOUND: 'COMPANY_NOT_FOUND' as const
}

export const enumManagementMethod = {
   PURCHASE_BASED: 'PURCHASE_BASED' as const,
   SALES_BASED: 'SALES_BASED' as const,
   SALES_BASED_UNIT_TRACKING: 'SALES_BASED_UNIT_TRACKING' as const
}

export const enumManageYearEndOperations = {
   RESET: 'RESET' as const,
   INITIALISE: 'INITIALISE' as const,
   SETUP: 'SETUP' as const,
   OPEN: 'OPEN' as const,
   CLOSE: 'CLOSE' as const,
   SET_NA: 'SET_NA' as const,
   SET_INACTIVE: 'SET_INACTIVE' as const,
   SET_USER_ACTIVE: 'SET_USER_ACTIVE' as const,
   SET_USER_INACTIVE: 'SET_USER_INACTIVE' as const
}

export const enumManageYearEndOperationStatus = {
   ERROR: 'ERROR' as const,
   NOT_AFFECTED: 'NOT_AFFECTED' as const,
   SUCCESSFULL: 'SUCCESSFULL' as const,
   NOT_FOUND: 'NOT_FOUND' as const
}

export const enumMarkOrderType = {
   UN_COLLECTIBLE: 'UN_COLLECTIBLE' as const,
   OVER_COLLECTIBLE: 'OVER_COLLECTIBLE' as const,
   VOIDED: 'VOIDED' as const
}

export const enumMerchantType = {
   VENDOR: 'VENDOR' as const,
   CUSTOMER: 'CUSTOMER' as const,
   COMPANY_AFFILIATE: 'COMPANY_AFFILIATE' as const,
   INSTITUTION: 'INSTITUTION' as const
}

export const enumMergeResult = {
   SUCCESS: 'SUCCESS' as const,
   FAILURE: 'FAILURE' as const
}

export const enumMetricRangeGroupBy = {
   year: 'year' as const,
   month: 'month' as const,
   week: 'week' as const,
   day: 'day' as const
}

export const enumMoneyDirection = {
   IN: 'IN' as const,
   OUT: 'OUT' as const,
   ALL: 'ALL' as const
}

export const enumMovementDirection = {
   IN: 'IN' as const,
   IN_FIRST: 'IN_FIRST' as const,
   OUT: 'OUT' as const
}

export const enumMovementIndirectCostType = {
   GENERAL: 'GENERAL' as const,
   VENDOR_FEES: 'VENDOR_FEES' as const,
   DUTIES_AND_TAX: 'DUTIES_AND_TAX' as const,
   CUSTOM_FEES_AND_SERVICES: 'CUSTOM_FEES_AND_SERVICES' as const,
   INSURANCE: 'INSURANCE' as const,
   PRODUCTION_COSTS: 'PRODUCTION_COSTS' as const,
   DISCOUNT: 'DISCOUNT' as const,
   SHIPPING: 'SHIPPING' as const,
   ASSEMBLY: 'ASSEMBLY' as const,
   SHIPPING_SURCHARGE: 'SHIPPING_SURCHARGE' as const
}

export const enumNaturalSign = {
   DEBIT: 'DEBIT' as const,
   CREDIT: 'CREDIT' as const
}

export const enumOffersStatus = {
   READY: 'READY' as const,
   TIER_1: 'TIER_1' as const,
   TOO_EARLY_TO_OFFER: 'TOO_EARLY_TO_OFFER' as const
}

export const enumOfferTier = {
   TIER_1_V3: 'TIER_1_V3' as const,
   TIER_2_V3: 'TIER_2_V3' as const,
   TIER_3_V3: 'TIER_3_V3' as const,
   TIER_4_V3: 'TIER_4_V3' as const,
   TIER_5_V3: 'TIER_5_V3' as const,
   TIER_6_V3: 'TIER_6_V3' as const,
   TIER_7_V3: 'TIER_7_V3' as const
}

export const enumOnboardingScope = {
   INVENTORY: 'INVENTORY' as const,
   DASHBOARD: 'DASHBOARD' as const
}

export const enumOnboardingStepStatus = {
   PENDING: 'PENDING' as const,
   COMPLETED: 'COMPLETED' as const
}

export const enumOrderActionType = {
   PAYMENT: 'PAYMENT' as const,
   REFUND: 'REFUND' as const,
   ADJUSTMENT: 'ADJUSTMENT' as const
}

export const enumOrderAdjustmentType = {
   UNCOLLECTIBLE: 'UNCOLLECTIBLE' as const,
   OVERCOLLECTED: 'OVERCOLLECTED' as const,
   HISTORICAL_PAYMENT_PRIOR_BOOKS: 'HISTORICAL_PAYMENT_PRIOR_BOOKS' as const,
   HISTORICAL_PAYMENT_LOCKED_YEAR: 'HISTORICAL_PAYMENT_LOCKED_YEAR' as const
}

export const enumOrderAdjustmentTypeV3 = {
   UNCOLLECTIBLE: 'UNCOLLECTIBLE' as const,
   OVERCOLLECTED: 'OVERCOLLECTED' as const
}

export const enumOrderAggregationType = {
   BALANCE_SUM: 'BALANCE_SUM' as const,
   COUNT: 'COUNT' as const,
   ORDER_VALUE_AVG: 'ORDER_VALUE_AVG' as const,
   NET_SALES_SUM: 'NET_SALES_SUM' as const,
   ORDERS_AGING: 'ORDERS_AGING' as const
}

export const enumOrderEntityType = {
   Order: 'Order' as const,
   OrderItem: 'OrderItem' as const,
   OrderTransaction: 'OrderTransaction' as const,
   OrderItemsFulfillment: 'OrderItemsFulfillment' as const,
   OrderTransactionsMatch: 'OrderTransactionsMatch' as const
}

export const enumOrderFinaloopStatus = {
   UNCOLLECTIBLE: 'UNCOLLECTIBLE' as const,
   OVERCOLLECTED: 'OVERCOLLECTED' as const,
   VOIDED: 'VOIDED' as const,
   PARTIALLY_VOIDED: 'PARTIALLY_VOIDED' as const,
   SALES_AFFECTING: 'SALES_AFFECTING' as const,
   EXCLUDED: 'EXCLUDED' as const,
   COGS_ONLY: 'COGS_ONLY' as const,
   SALES_ONLY: 'SALES_ONLY' as const,
   GIVEAWAY: 'GIVEAWAY' as const
}

export const enumOrderFulfillmentSource = {
   INTEGRATION: 'INTEGRATION' as const,
   ARTIFICIAL: 'ARTIFICIAL' as const,
   CUSTOMER: 'CUSTOMER' as const
}

export const enumOrderFulfillmentStatus = {
   FULFILLED: 'FULFILLED' as const,
   PARTIALLY_FULFILLED: 'PARTIALLY_FULFILLED' as const,
   UNFULFILLED: 'UNFULFILLED' as const
}

export const enumOrderFulfillmentStatusInput = {
   FULFILLED: 'FULFILLED' as const,
   PARTIALLY_FULFILLED: 'PARTIALLY_FULFILLED' as const,
   UNFULFILLED: 'UNFULFILLED' as const,
   RESTOCKED: 'RESTOCKED' as const
}

export const enumOrderFulfillmentStatusV3 = {
   UNFULFILLED: 'UNFULFILLED' as const,
   ATTEMPTED_DELIVERY: 'ATTEMPTED_DELIVERY' as const,
   CANCELED: 'CANCELED' as const,
   CONFIRMED: 'CONFIRMED' as const,
   DELIVERED: 'DELIVERED' as const,
   DELAYED: 'DELAYED' as const,
   FAILURE: 'FAILURE' as const,
   FULFILLED: 'FULFILLED' as const,
   IN_TRANSIT: 'IN_TRANSIT' as const,
   LABEL_PRINTED: 'LABEL_PRINTED' as const,
   LABEL_PURCHASED: 'LABEL_PURCHASED' as const,
   LABEL_VOIDED: 'LABEL_VOIDED' as const,
   MARKED_AS_FULFILLED: 'MARKED_AS_FULFILLED' as const,
   NOT_DELIVERED: 'NOT_DELIVERED' as const,
   OUT_FOR_DELIVERY: 'OUT_FOR_DELIVERY' as const,
   PICKED_UP: 'PICKED_UP' as const,
   READY_FOR_PICKUP: 'READY_FOR_PICKUP' as const,
   SUBMITTED: 'SUBMITTED' as const
}

export const enumOrderGroupExpenseType = {
   ADVERTISING: 'ADVERTISING' as const,
   BRICK_AND_MORTAR: 'BRICK_AND_MORTAR' as const,
   DEDUCTION: 'DEDUCTION' as const,
   DISCOUNT: 'DISCOUNT' as const,
   FEE: 'FEE' as const,
   MERCHANT_FEE: 'MERCHANT_FEE' as const,
   SELLING_FEE: 'SELLING_FEE' as const,
   FX_COMMISSION: 'FX_COMMISSION' as const,
   PLATFORM_ADJUSTMENT: 'PLATFORM_ADJUSTMENT' as const,
   ORDERS_CREDIT: 'ORDERS_CREDIT' as const,
   OTHER_ADJUSTMENT: 'OTHER_ADJUSTMENT' as const
}

export const enumOrderGroupsSortDirection = {
   ASC: 'ASC' as const,
   DESC: 'DESC' as const
}

export const enumOrderGroupsSortType = {
   POSTED_AT: 'POSTED_AT' as const
}

export const enumOrderItemStatus = {
   VOIDED: 'VOIDED' as const,
   PARTIALLY_VOIDED: 'PARTIALLY_VOIDED' as const,
   FULFILLED: 'FULFILLED' as const,
   UNFULFILLED: 'UNFULFILLED' as const,
   PARTIALLY_FULFILLED: 'PARTIALLY_FULFILLED' as const,
   RESTOCKED: 'RESTOCKED' as const,
   PARTIALLY_RESTOCKED: 'PARTIALLY_RESTOCKED' as const,
   CANCELLED: 'CANCELLED' as const,
   GIVEAWAY: 'GIVEAWAY' as const,
   DROPSHIPPED: 'DROPSHIPPED' as const,
   PARTIALLY_DROPSHIPPED: 'PARTIALLY_DROPSHIPPED' as const
}

export const enumOrderItemType = {
   SHIPPING: 'SHIPPING' as const,
   PRODUCT: 'PRODUCT' as const,
   ADDITIONAL_FEE: 'ADDITIONAL_FEE' as const,
   GIFT_CARD: 'GIFT_CARD' as const,
   TIP: 'TIP' as const,
   FX_ADJUSTMENT: 'FX_ADJUSTMENT' as const,
   DUTY: 'DUTY' as const,
   RESTOCKING_FEE: 'RESTOCKING_FEE' as const,
   RETURN_SHIPPING_FEE: 'RETURN_SHIPPING_FEE' as const
}

export const enumOrderLineItemDiscountType = {
   PLATFORM_DISCOUNT: 'PLATFORM_DISCOUNT' as const,
   SELLER_DISCOUNT: 'SELLER_DISCOUNT' as const,
   COFUNDED_DISCOUNT: 'COFUNDED_DISCOUNT' as const
}

export const enumOrderLineItemTaxType = {
   DUTIES_AND_OTHER_TAXES: 'DUTIES_AND_OTHER_TAXES' as const,
   GST: 'GST' as const,
   SALES_TAX: 'SALES_TAX' as const,
   VAT: 'VAT' as const
}

export const enumOrderLineItemType = {
   PRODUCT: 'PRODUCT' as const,
   GIFT_CARD: 'GIFT_CARD' as const
}

export const enumOrderLineItemTypeV3 = {
   PRODUCT: 'PRODUCT' as const,
   TAX: 'TAX' as const,
   FEE: 'FEE' as const,
   TIP: 'TIP' as const,
   SHIPPING: 'SHIPPING' as const,
   DISCOUNT: 'DISCOUNT' as const
}

export const enumOrderPaymentStatus = {
   PAID: 'PAID' as const,
   UNPAID: 'UNPAID' as const,
   PARTIALLY_PAID: 'PARTIALLY_PAID' as const,
   REFUNDED: 'REFUNDED' as const,
   PARTIALLY_REFUNDED: 'PARTIALLY_REFUNDED' as const
}

export const enumOrderReconciliationRowType = {
   ENTITY: 'ENTITY' as const,
   ACCOUNT: 'ACCOUNT' as const
}

export const enumOrderReturnLineItemTypeV3 = {
   RETURN: 'RETURN' as const,
   CANCEL: 'CANCEL' as const
}

export const enumOrdersAgingPreset = {
   ZERO_TO_THIRTY: 'ZERO_TO_THIRTY' as const,
   THIRTY_ONE_TO_SIXTY: 'THIRTY_ONE_TO_SIXTY' as const,
   SIXTY_ONE_TO_NINETY: 'SIXTY_ONE_TO_NINETY' as const,
   NINETY_ONE_PLUS: 'NINETY_ONE_PLUS' as const
}

export const enumOrderSettlementStatusInput = {
   SETTLED: 'SETTLED' as const,
   PARTIALLY_SETTLED: 'PARTIALLY_SETTLED' as const,
   UNSETTLED: 'UNSETTLED' as const
}

export const enumOrderSourceTypeV3 = {
   MARKETPLACE: 'MARKETPLACE' as const,
   STORE: 'STORE' as const
}

export const enumOrdersSortType = {
   PLACED_DATE: 'PLACED_DATE' as const,
   NET_SALES: 'NET_SALES' as const,
   TOTAL: 'TOTAL' as const,
   UNPAID_BALANCE: 'UNPAID_BALANCE' as const,
   BALANCE: 'BALANCE' as const
}

export const enumOrderStatus = {
   VOIDED: 'VOIDED' as const,
   COGS_ONLY: 'COGS_ONLY' as const,
   SALES_ONLY: 'SALES_ONLY' as const,
   GIVEAWAY: 'GIVEAWAY' as const,
   EXCLUDED: 'EXCLUDED' as const,
   PAID: 'PAID' as const,
   UNPAID: 'UNPAID' as const,
   PARTIALLY_PAID: 'PARTIALLY_PAID' as const,
   REFUNDED: 'REFUNDED' as const,
   PARTIALLY_REFUNDED: 'PARTIALLY_REFUNDED' as const,
   DROPSHIPPED: 'DROPSHIPPED' as const,
   FULFILLED: 'FULFILLED' as const,
   RESTOCKED: 'RESTOCKED' as const,
   PARTIALLY_DROPSHIPPED: 'PARTIALLY_DROPSHIPPED' as const,
   PARTIALLY_FULFILLED: 'PARTIALLY_FULFILLED' as const,
   PARTIALLY_RESTOCKED: 'PARTIALLY_RESTOCKED' as const,
   PARTIALLY_VOIDED: 'PARTIALLY_VOIDED' as const,
   UNFULFILLED: 'UNFULFILLED' as const,
   CANCELLED: 'CANCELLED' as const,
   UNCOLLECTIBLE: 'UNCOLLECTIBLE' as const,
   PARTIALLY_UNCOLLECTIBLE: 'PARTIALLY_UNCOLLECTIBLE' as const,
   PARTIALLY_OVER_COLLECTED: 'PARTIALLY_OVER_COLLECTED' as const,
   HISTORICALLY_PAID: 'HISTORICALLY_PAID' as const,
   PARTIALLY_HISTORICALLY_PAID: 'PARTIALLY_HISTORICALLY_PAID' as const,
   OVER_COLLECTED: 'OVER_COLLECTED' as const,
   MATCHED_TRANSACTION: 'MATCHED_TRANSACTION' as const,
   UNMATCHED_TRANSACTION: 'UNMATCHED_TRANSACTION' as const,
   LINKED_TRANSACTIONS: 'LINKED_TRANSACTIONS' as const
}

export const enumOrderStatusInput = {
   GIVEAWAY: 'GIVEAWAY' as const,
   VOIDED: 'VOIDED' as const
}

export const enumOrderStatusV3 = {
   VOIDED: 'VOIDED' as const,
   COGS_ONLY: 'COGS_ONLY' as const,
   SALES_ONLY: 'SALES_ONLY' as const,
   GIVEAWAY: 'GIVEAWAY' as const,
   EXCLUDED: 'EXCLUDED' as const,
   PAID: 'PAID' as const,
   UNPAID: 'UNPAID' as const,
   PARTIALLY_PAID: 'PARTIALLY_PAID' as const,
   REFUNDED: 'REFUNDED' as const,
   PARTIALLY_REFUNDED: 'PARTIALLY_REFUNDED' as const,
   FULFILLED: 'FULFILLED' as const,
   PARTIALLY_FULFILLED: 'PARTIALLY_FULFILLED' as const,
   UNFULFILLED: 'UNFULFILLED' as const,
   RESTOCKED: 'RESTOCKED' as const,
   PARTIALLY_RESTOCKED: 'PARTIALLY_RESTOCKED' as const,
   OVER_COLLECTED: 'OVER_COLLECTED' as const,
   PARTIALLY_OVER_COLLECTED: 'PARTIALLY_OVER_COLLECTED' as const,
   UNCOLLECTIBLE: 'UNCOLLECTIBLE' as const,
   PARTIALLY_UNCOLLECTIBLE: 'PARTIALLY_UNCOLLECTIBLE' as const,
   COGS_AND_SALES: 'COGS_AND_SALES' as const,
   DROPSHIPPED: 'DROPSHIPPED' as const,
   PARTIALLY_DROPSHIPPED: 'PARTIALLY_DROPSHIPPED' as const,
   UNSETTLED: 'UNSETTLED' as const,
   PARTIALLY_SETTLED: 'PARTIALLY_SETTLED' as const,
   SETTLED: 'SETTLED' as const
}

export const enumOrderTransactionType = {
   PAYMENT: 'PAYMENT' as const,
   REFUND: 'REFUND' as const
}

export const enumOrderVoidedByType = {
   FINALOOP: 'FINALOOP' as const,
   INTEGRATION: 'INTEGRATION' as const
}

export const enumOverviewConnectionStatus = {
   CLOSED: 'CLOSED' as const,
   CONNECTED: 'CONNECTED' as const,
   DISCONNECTED: 'DISCONNECTED' as const,
   IMPORT_STOPPED: 'IMPORT_STOPPED' as const,
   MANUAL: 'MANUAL' as const
}

export const enumPaidStatus = {
   PAID: 'PAID' as const,
   PARTIALLY_PAID: 'PARTIALLY_PAID' as const,
   UNPAID: 'UNPAID' as const
}

export const enumPairedEntityType = {
   BANK_AFFECTING_INTEGRATION_EVENT: 'BANK_AFFECTING_INTEGRATION_EVENT' as const,
   BANK_TRANSACTION: 'BANK_TRANSACTION' as const,
   BILL: 'BILL' as const,
   INVOICE: 'INVOICE' as const,
   ORDER_GROUP: 'ORDER_GROUP' as const,
   COMPANY_AFFILIATE_BALANCE: 'COMPANY_AFFILIATE_BALANCE' as const,
   PAYMENT_CHECK: 'PAYMENT_CHECK' as const,
   PAYROLL: 'PAYROLL' as const,
   PAYMENT_GROUP: 'PAYMENT_GROUP' as const
}

export const enumPairingType = {
   INTERNAL_TRANSFER: 'INTERNAL_TRANSFER' as const,
   MATCH: 'MATCH' as const,
   REFUND: 'REFUND' as const,
   FAILED_TRANSFER: 'FAILED_TRANSFER' as const
}

export const enumParentLineItemType = {
   PRODUCT: 'PRODUCT' as const,
   TAX: 'TAX' as const,
   SHIPPING: 'SHIPPING' as const,
   DISCOUNT: 'DISCOUNT' as const,
   FEE: 'FEE' as const,
   TIP: 'TIP' as const
}

export const enumPaymentFeeBasis = {
   PERCENTAGE: 'PERCENTAGE' as const,
   FIXED: 'FIXED' as const
}

export const enumPaymentFeeType = {
   PROCESSING: 'PROCESSING' as const,
   DISPUTE: 'DISPUTE' as const
}

export const enumPaymentGateway = {
   AFTERPAY: 'AFTERPAY' as const,
   AMAZON_PAY: 'AMAZON_PAY' as const,
   PAYPAL: 'PAYPAL' as const,
   SHOP_PAY: 'SHOP_PAY' as const,
   STRIPE: 'STRIPE' as const,
   GIFT_CARD: 'GIFT_CARD' as const,
   EXCHANGE_CREDIT: 'EXCHANGE_CREDIT' as const,
   STORE_CREDIT: 'STORE_CREDIT' as const,
   MANUAL: 'MANUAL' as const,
   UNKNOWN: 'UNKNOWN' as const,
   NO_GATEWAY: 'NO_GATEWAY' as const,
   AFFIRM: 'AFFIRM' as const,
   ALMA: 'ALMA' as const,
   AUTHORIZE_NET: 'AUTHORIZE_NET' as const,
   BLACKCART: 'BLACKCART' as const,
   BRAINTREE: 'BRAINTREE' as const,
   CLEARCO: 'CLEARCO' as const,
   CLEARPAY: 'CLEARPAY' as const,
   FAIRE: 'FAIRE' as const,
   PARKER: 'PARKER' as const,
   KLARNA: 'KLARNA' as const,
   KLICKLY: 'KLICKLY' as const,
   SETTLE: 'SETTLE' as const,
   SEZZLE: 'SEZZLE' as const,
   QUICKBOOKS_PAYMENTS: 'QUICKBOOKS_PAYMENTS' as const,
   SQUARE: 'SQUARE' as const,
   WOOCOMMERCE: 'WOOCOMMERCE' as const,
   FACEBOOK: 'FACEBOOK' as const,
   ZIP_CO: 'ZIP_CO' as const,
   SPLITIT: 'SPLITIT' as const,
   BREAD_PAY: 'BREAD_PAY' as const,
   GLOBAL_E: 'GLOBAL_E' as const,
   SNACK_MAGIC: 'SNACK_MAGIC' as const,
   POSTAL: 'POSTAL' as const,
   CORPORATE_GIFT: 'CORPORATE_GIFT' as const,
   CAROO: 'CAROO' as const
}

export const enumPaymentGatewayType = {
   AFFIRM: 'AFFIRM' as const,
   AMAZON_PAY: 'AMAZON_PAY' as const,
   BRAINTREE: 'BRAINTREE' as const,
   FAIRE: 'FAIRE' as const,
   KLARNA: 'KLARNA' as const,
   SEZZLE: 'SEZZLE' as const,
   TRUE_MED: 'TRUE_MED' as const
}

export const enumPaymentGroupExpenseType = {
   ADVERTISING: 'ADVERTISING' as const,
   BRICK_AND_MORTAR: 'BRICK_AND_MORTAR' as const,
   DEDUCTION: 'DEDUCTION' as const,
   DISCOUNT: 'DISCOUNT' as const,
   FEE: 'FEE' as const,
   MERCHANT_FEE: 'MERCHANT_FEE' as const,
   SELLING_FEE: 'SELLING_FEE' as const,
   FX_COMMISSION: 'FX_COMMISSION' as const,
   PLATFORM_ADJUSTMENT: 'PLATFORM_ADJUSTMENT' as const,
   ORDERS_CREDIT: 'ORDERS_CREDIT' as const
}

export const enumPaymentGroupsSortDirection = {
   ASC: 'ASC' as const,
   DESC: 'DESC' as const
}

export const enumPaymentGroupsSortType = {
   POSTED_AT: 'POSTED_AT' as const
}

export const enumPaymentGroupType = {
   INVOICE: 'INVOICE' as const,
   ORDER: 'ORDER' as const
}

export const enumPaymentLinkStatus = {
   LIVE: 'LIVE' as const,
   PROCESSING: 'PROCESSING' as const,
   PAID: 'PAID' as const,
   FAILED: 'FAILED' as const,
   EXPIRED: 'EXPIRED' as const,
   CANCELLED: 'CANCELLED' as const
}

export const enumPaymentMethodType = {
   ACH: 'ACH' as const,
   CHECK: 'CHECK' as const,
   CUSTOM: 'CUSTOM' as const,
   INVOICE_PAY: 'INVOICE_PAY' as const
}

export const enumPaymentRecurrence = {
   MONTHLY: 'MONTHLY' as const,
   YEARLY: 'YEARLY' as const
}

export const enumPayrollCategory = {
   DEFAULT: 'DEFAULT' as const,
   INVENTORY: 'INVENTORY' as const,
   RESEARCH_AND_DEVELOPMENT: 'RESEARCH_AND_DEVELOPMENT' as const,
   SHIPPING_AND_FULFILLMENT: 'SHIPPING_AND_FULFILLMENT' as const,
   MARKETING: 'MARKETING' as const,
   GENERAL_AND_ADMINISTRATIVE: 'GENERAL_AND_ADMINISTRATIVE' as const
}

export const enumPayrollCategoryMappingMode = {
   DEPARTMENT: 'DEPARTMENT' as const,
   PERSONNEL: 'PERSONNEL' as const
}

export const enumPayrollEmploymentType = {
   EMPLOYEE: 'EMPLOYEE' as const,
   OFFICER: 'OFFICER' as const,
   PARTNER: 'PARTNER' as const
}

export const enumPayrollIntegrationTransferType = {
   NET_PAY: 'NET_PAY' as const,
   TAX: 'TAX' as const,
   REIMBURSEMENT: 'REIMBURSEMENT' as const,
   GARNISHMENT: 'GARNISHMENT' as const,
   RETIREMENT: 'RETIREMENT' as const,
   GENERAL: 'GENERAL' as const
}

export const enumPayrollMappableType = {
   DEPARTMENT: 'DEPARTMENT' as const,
   EMPLOYEE: 'EMPLOYEE' as const,
   CONTRACTOR: 'CONTRACTOR' as const
}

export const enumPendingProductAdjustmentsDataType = {
   MISSING: 'MISSING' as const,
   PENDING: 'PENDING' as const
}

export const enumPlatform = {
   FACEBOOK_ADS: 'FACEBOOK_ADS' as const,
   GOOGLE_ADS: 'GOOGLE_ADS' as const
}

export const enumProductAppliedCostSource = {
   USER: 'USER' as const,
   SHOPIFY: 'SHOPIFY' as const
}

export const enumProductAppliedCostType = {
   GENERAL: 'GENERAL' as const,
   DROPSHIPPING: 'DROPSHIPPING' as const
}

export const enumProductAttributesTypes = {
   ACTIVE: 'ACTIVE' as const,
   INACTIVE: 'INACTIVE' as const,
   MERGED: 'MERGED' as const,
   NOT_MERGED: 'NOT_MERGED' as const,
   HAS_RECIPE: 'HAS_RECIPE' as const,
   NO_RECIPE: 'NO_RECIPE' as const,
   COMPONENT_OF: 'COMPONENT_OF' as const,
   NOT_COMPONENT_OF: 'NOT_COMPONENT_OF' as const,
   VISIBLE: 'VISIBLE' as const,
   NOT_VISIBLE: 'NOT_VISIBLE' as const,
   FRACTIONAL: 'FRACTIONAL' as const,
   NOT_FRACTIONAL: 'NOT_FRACTIONAL' as const,
   DROPSHIPPING: 'DROPSHIPPING' as const,
   NOT_DROPSHIPPING: 'NOT_DROPSHIPPING' as const
}

export const enumProductBulkAdjustmentStatusState = {
   IN_PROGRESS: 'IN_PROGRESS' as const,
   DONE: 'DONE' as const,
   FAILED: 'FAILED' as const
}

export const enumProductBulkAdjustmentStatusType = {
   SALES: 'SALES' as const,
   DEAD_INVENTORY: 'DEAD_INVENTORY' as const,
   GIVEAWAY: 'GIVEAWAY' as const,
   GIVEAWAY_DROPSHIPPING: 'GIVEAWAY_DROPSHIPPING' as const,
   DONATIONS: 'DONATIONS' as const
}

export const enumProductBulkEditCsvAttachmentType = {
   PHYSICAL_COUNT_UNIT_TRACKING: 'PHYSICAL_COUNT_UNIT_TRACKING' as const,
   PHYSICAL_COUNT_NO_UNIT_TRACKING: 'PHYSICAL_COUNT_NO_UNIT_TRACKING' as const,
   WAREHOUSE_OPENING_BALANCE: 'WAREHOUSE_OPENING_BALANCE' as const,
   SALES_ADJUSTMENTS: 'SALES_ADJUSTMENTS' as const,
   DEAD_INVENTORY_ADJUSTMENTS: 'DEAD_INVENTORY_ADJUSTMENTS' as const,
   DONATIONS_ADJUSTMENTS: 'DONATIONS_ADJUSTMENTS' as const,
   GIVEN_AWAY_ADJUSTMENTS: 'GIVEN_AWAY_ADJUSTMENTS' as const,
   GIVEN_AWAY_DROPSHIPPING_ADJUSTMENTS: 'GIVEN_AWAY_DROPSHIPPING_ADJUSTMENTS' as const
}

export const enumProductBulkEditCsvErrorItemType = {
   INVALID_HEADERS: 'INVALID_HEADERS' as const,
   MISSING_PRODUCT: 'MISSING_PRODUCT' as const,
   MISSING_QUANTITY: 'MISSING_QUANTITY' as const,
   ROW_DUPLICATE: 'ROW_DUPLICATE' as const,
   PRODUCT_AMBIGUOUS: 'PRODUCT_AMBIGUOUS' as const,
   PRODUCT_NOT_FOUND: 'PRODUCT_NOT_FOUND' as const,
   MISSING_WAREHOUSE: 'MISSING_WAREHOUSE' as const,
   MISSING_COST: 'MISSING_COST' as const,
   WAREHOUSE_AMBIGUOUS: 'WAREHOUSE_AMBIGUOUS' as const,
   WAREHOUSE_NOT_FOUND: 'WAREHOUSE_NOT_FOUND' as const,
   INVALID_DATA: 'INVALID_DATA' as const,
   MISSING_DATE: 'MISSING_DATE' as const,
   UNKNOWN_ERROR: 'UNKNOWN_ERROR' as const,
   MISSING_SOLD_AND_RESTOCKED: 'MISSING_SOLD_AND_RESTOCKED' as const,
   DATE_OUT_OF_METHOD_RANGE: 'DATE_OUT_OF_METHOD_RANGE' as const
}

export const enumProductMergeLogSortDirection = {
   ASC: 'ASC' as const,
   DESC: 'DESC' as const
}

export const enumProductMergeLogSortField = {
   DATE: 'DATE' as const,
   DISPLAY_NAME: 'DISPLAY_NAME' as const,
   SKU: 'SKU' as const,
   SOURCE: 'SOURCE' as const,
   TYPE: 'TYPE' as const
}

export const enumProductMergeLogTrigger = {
   MANUAL: 'MANUAL' as const,
   MANUAL_RECOMMENDATION: 'MANUAL_RECOMMENDATION' as const,
   AUTOMATIC: 'AUTOMATIC' as const,
   MULTI: 'MULTI' as const
}

export const enumProductMergeLogTriggerType = {
   MANUAL: 'MANUAL' as const,
   AUTOMATIC_SUGGESTION: 'AUTOMATIC_SUGGESTION' as const,
   MANUAL_SUGGESTION: 'MANUAL_SUGGESTION' as const,
   MULTI: 'MULTI' as const
}

export const enumProductMergeRecommendationsGroupType = {
   PERFECT: 'PERFECT' as const,
   FLEXIBLE: 'FLEXIBLE' as const,
   SMART: 'SMART' as const
}

export const enumProductQuantityFilter = {
   MISSING_DATA: 'MISSING_DATA' as const,
   PENDING_CHANGES: 'PENDING_CHANGES' as const
}

export const enumProductSource = {
   AMAZON: 'AMAZON' as const,
   WALMART: 'WALMART' as const,
   USER_MANUAL: 'USER_MANUAL' as const,
   SHOPIFY: 'SHOPIFY' as const
}

export const enumProductSourceV3 = {
   TRACKSTAR_FBA: 'TRACKSTAR_FBA' as const,
   AMAZON: 'AMAZON' as const,
   WALMART: 'WALMART' as const,
   USER_MANUAL: 'USER_MANUAL' as const,
   SHOPIFY: 'SHOPIFY' as const,
   TIK_TOK: 'TIK_TOK' as const
}

export const enumProductsSortDirection = {
   ASC: 'ASC' as const,
   DESC: 'DESC' as const
}

export const enumPurchaseOrdersSortField = {
   productionStartDate: 'productionStartDate' as const,
   landedCostTotal: 'landedCostTotal' as const,
   createdAt: 'createdAt' as const,
   paidStatus: 'paidStatus' as const,
   poName: 'poName' as const
}

export const enumPurchaseOrderStatus = {
   DRAFT: 'DRAFT' as const,
   PLACED: 'PLACED' as const,
   IN_PROCESS: 'IN_PROCESS' as const,
   PARTIALLY_SHIPPED: 'PARTIALLY_SHIPPED' as const,
   SHIPPED: 'SHIPPED' as const,
   PARTIALLY_RECEIVED: 'PARTIALLY_RECEIVED' as const,
   RECEIVED: 'RECEIVED' as const
}

export const enumRecipeAllocatedCostType = {
   PRODUCTION_COSTS: 'PRODUCTION_COSTS' as const,
   PRODUCTION_LABOR_COSTS: 'PRODUCTION_LABOR_COSTS' as const,
   OTHER: 'OTHER' as const
}

export const enumRecipeManagementMethod = {
   UNITS_TRACKING: 'UNITS_TRACKING' as const,
   NO_UNITS_TRACKING: 'NO_UNITS_TRACKING' as const
}

export const enumRecommendationSource = {
   BANK_TRANSACTION: 'BANK_TRANSACTION' as const,
   LOCAL_MERCHANT: 'LOCAL_MERCHANT' as const,
   GLOBAL_MERCHANT: 'GLOBAL_MERCHANT' as const
}

export const enumRecommendedBy = {
   FINALOOP_SUGGESTIONS: 'FINALOOP_SUGGESTIONS' as const,
   ASK_AI: 'ASK_AI' as const
}

export const enumReconciliationStatus = {
   RECONCILED: 'RECONCILED' as const,
   RECONCILIATION_NEEDED: 'RECONCILIATION_NEEDED' as const,
   PROCESSING: 'PROCESSING' as const,
   UNKNOWN: 'UNKNOWN' as const
}

export const enumReportSyncStatus = {
   PROCESSING: 'PROCESSING' as const,
   SYNCED: 'SYNCED' as const,
   FAILED: 'FAILED' as const
}

export const enumReportType = {
   PROFIT_AND_LOSS: 'PROFIT_AND_LOSS' as const,
   BALANCE_SHEET: 'BALANCE_SHEET' as const,
   CASH_FLOW: 'CASH_FLOW' as const
}

export const enumRestockStatus = {
   PARTIALLY_RESTOCKED: 'PARTIALLY_RESTOCKED' as const,
   RESTOCKED: 'RESTOCKED' as const
}

export const enumRole = {
   ADMIN: 'ADMIN' as const,
   EMPLOYEE: 'EMPLOYEE' as const,
   USER: 'USER' as const,
   GUEST: 'GUEST' as const
}

export const enumRootConditionOperator = {
   OR: 'OR' as const,
   AND: 'AND' as const
}

export const enumSaleActor = {
   INTEGRATION: 'INTEGRATION' as const,
   CUSTOMER: 'CUSTOMER' as const
}

export const enumSaleLineItemType = {
   PRODUCT: 'PRODUCT' as const,
   TAX: 'TAX' as const,
   SHIPPING: 'SHIPPING' as const,
   SELLER_DISCOUNT: 'SELLER_DISCOUNT' as const,
   PLATFORM_DISCOUNT: 'PLATFORM_DISCOUNT' as const,
   FEE: 'FEE' as const,
   SERVICE: 'SERVICE' as const,
   TIP: 'TIP' as const
}

export const enumSaleSource = {
   FINALOOP_INVOICES: 'FINALOOP_INVOICES' as const,
   STRIPE: 'STRIPE' as const,
   PAYPAL: 'PAYPAL' as const,
   QUICKBOOKS: 'QUICKBOOKS' as const,
   QUICKBOOKS_INVOICES: 'QUICKBOOKS_INVOICES' as const,
   NU_ORDER_INVOICES: 'NU_ORDER_INVOICES' as const,
   SPS_COMMERCE: 'SPS_COMMERCE' as const,
   FINALOOP_ORDERS: 'FINALOOP_ORDERS' as const,
   TIK_TOK: 'TIK_TOK' as const
}

export const enumSaleStatus = {
   DRAFT: 'DRAFT' as const,
   FOR_REVIEW: 'FOR_REVIEW' as const,
   VOIDED: 'VOIDED' as const,
   COGS_ONLY: 'COGS_ONLY' as const,
   GIVEAWAY: 'GIVEAWAY' as const,
   OPEN: 'OPEN' as const,
   PAST_DUE: 'PAST_DUE' as const,
   PAID: 'PAID' as const,
   REFUNDED: 'REFUNDED' as const,
   CLOSED: 'CLOSED' as const,
   UNCOLLECTIBLE: 'UNCOLLECTIBLE' as const,
   OVER_COLLECTED: 'OVER_COLLECTED' as const,
   ADJUSTED: 'ADJUSTED' as const,
   PARTIALLY_UNCOLLECTIBLE: 'PARTIALLY_UNCOLLECTIBLE' as const,
   PARTIALLY_ADJUSTED: 'PARTIALLY_ADJUSTED' as const,
   PARTIALLY_REFUNDED: 'PARTIALLY_REFUNDED' as const,
   PARTIALLY_PAID: 'PARTIALLY_PAID' as const
}

export const enumSaleTaxType = {
   SALES_TAX: 'SALES_TAX' as const,
   VAT: 'VAT' as const,
   GST: 'GST' as const
}

export const enumSaleType = {
   ORDER: 'ORDER' as const,
   INVOICE: 'INVOICE' as const
}

export const enumSellingFeeType = {
   SELLING_FEE: 'SELLING_FEE' as const,
   AFFILIATE_COMMISSION: 'AFFILIATE_COMMISSION' as const
}

export const enumSetProductAdjustmentOperation = {
   CREATE: 'CREATE' as const,
   UPDATE: 'UPDATE' as const,
   DELETE: 'DELETE' as const,
   ADD_ON_TOP: 'ADD_ON_TOP' as const,
   UPDATE_GOING_FORWARD: 'UPDATE_GOING_FORWARD' as const,
   REPLACE: 'REPLACE' as const
}

export const enumShareType = {
   COMMON_STOCK: 'COMMON_STOCK' as const,
   PREFERRED: 'PREFERRED' as const
}

export const enumShippingCostType = {
   SHIPPING_OUT_TO_CUSTOMERS: 'SHIPPING_OUT_TO_CUSTOMERS' as const,
   SHIPPING_BACK_FROM_CUSTOMERS: 'SHIPPING_BACK_FROM_CUSTOMERS' as const
}

export const enumShopifyValidationItemType = {
   RESTOCKED: 'RESTOCKED' as const,
   VOIDED: 'VOIDED' as const,
   IN_BOOKS: 'IN_BOOKS' as const,
   ZERO_NET: 'ZERO_NET' as const,
   EXCLUDED: 'EXCLUDED' as const,
   ZERO_PRICE: 'ZERO_PRICE' as const
}

export const enumSimpleMoneyDirection = {
   IN: 'IN' as const,
   OUT: 'OUT' as const
}

export const enumSortByMerchants = {
   TRANSACTIONS_AMOUNT_DESC: 'TRANSACTIONS_AMOUNT_DESC' as const
}

export const enumSortDirection = {
   ASC: 'ASC' as const,
   DESC: 'DESC' as const
}

export const enumSourceTypes = {
   INVOICE: 'INVOICE' as const,
   SHOPIFY: 'SHOPIFY' as const,
   TIK_TOK: 'TIK_TOK' as const
}

export const enumSpreadBasisType = {
   DAILY: 'DAILY' as const,
   MONTHLY: 'MONTHLY' as const
}

export const enumSpreadType = {
   SPECIFIC_DATE: 'SPECIFIC_DATE' as const,
   SPREAD_OVER_TIME: 'SPREAD_OVER_TIME' as const,
   CUSTOM_SPREAD: 'CUSTOM_SPREAD' as const,
   FIXED_ASSETS_DEFAULT: 'FIXED_ASSETS_DEFAULT' as const,
   FIXED_ASSETS_CUSTOM: 'FIXED_ASSETS_CUSTOM' as const
}

export const enumStoreOrderTransactionMatchType = {
   PAYMENT: 'PAYMENT' as const,
   BANK_TRANSACTION: 'BANK_TRANSACTION' as const
}

export const enumSyncCompanyEventName = {
   INSERT: 'INSERT' as const,
   MODIFY: 'MODIFY' as const,
   REMOVE: 'REMOVE' as const
}

export const enumTax1099AffiliatedEntityDisqualifyReason = {
   CORPORATION: 'CORPORATION' as const,
   NON_US_TAXPAYER: 'NON_US_TAXPAYER' as const,
   NOT_A_SERVICE_PROVIDER: 'NOT_A_SERVICE_PROVIDER' as const,
   FREIGHT_OR_STORAGE_SERVICE_PROVIDER: 'FREIGHT_OR_STORAGE_SERVICE_PROVIDER' as const,
   BANK: 'BANK' as const,
   NOT_A_DIVIDEND: 'NOT_A_DIVIDEND' as const
}

export const enumTax1099AffiliatedEntityType = {
   NEC: 'NEC' as const,
   MISC: 'MISC' as const,
   DIV: 'DIV' as const,
   INT: 'INT' as const
}

export const enumTimeBreakdownUnit = {
   DAY: 'DAY' as const,
   WEEK: 'WEEK' as const,
   MONTH: 'MONTH' as const,
   QUARTER: 'QUARTER' as const,
   YEAR: 'YEAR' as const
}

export const enumTransactionKind = {
   PAYMENT: 'PAYMENT' as const,
   REFUND: 'REFUND' as const
}

export const enumTransactionPaymentGatewayType = {
   AAFES: 'AAFES' as const,
   ADYEN: 'ADYEN' as const,
   AFFIRM: 'AFFIRM' as const,
   AFTERPAY: 'AFTERPAY' as const,
   AIRWALLEX: 'AIRWALLEX' as const,
   ALMA: 'ALMA' as const,
   AMAZON: 'AMAZON' as const,
   AMAZON_PAY: 'AMAZON_PAY' as const,
   AUTHORIZE_NET: 'AUTHORIZE_NET' as const,
   BANKFUL: 'BANKFUL' as const,
   BLACKCART: 'BLACKCART' as const,
   BLOOM: 'BLOOM' as const,
   BN: 'BN' as const,
   BRAINTREE: 'BRAINTREE' as const,
   BREAD_PAY: 'BREAD_PAY' as const,
   CAROO: 'CAROO' as const,
   CARRO: 'CARRO' as const,
   CATCH: 'CATCH' as const,
   CHANNEL_ADVISOR: 'CHANNEL_ADVISOR' as const,
   CHECKOUT_COM: 'CHECKOUT_COM' as const,
   CLEARCO: 'CLEARCO' as const,
   CLEARPAY: 'CLEARPAY' as const,
   COINBASE: 'COINBASE' as const,
   COMMENT_SOLD: 'COMMENT_SOLD' as const,
   CORPORATE_GIFT: 'CORPORATE_GIFT' as const,
   CVS: 'CVS' as const,
   EBAY: 'EBAY' as const,
   ETSY: 'ETSY' as const,
   EXCHANGE_CREDIT: 'EXCHANGE_CREDIT' as const,
   FACEBOOK: 'FACEBOOK' as const,
   FAIRE: 'FAIRE' as const,
   FOUR_BNPL: 'FOUR_BNPL' as const,
   GIFT_CARD: 'GIFT_CARD' as const,
   GLOBAL_E: 'GLOBAL_E' as const,
   GLOPAL: 'GLOPAL' as const,
   GUSTO: 'GUSTO' as const,
   KLARNA: 'KLARNA' as const,
   KLICKLY: 'KLICKLY' as const,
   KROGER: 'KROGER' as const,
   LEAP_RETAIL: 'LEAP_RETAIL' as const,
   MANUAL: 'MANUAL' as const,
   MIRAKL: 'MIRAKL' as const,
   NMI: 'NMI' as const,
   NO_GATEWAY: 'NO_GATEWAY' as const,
   OPEN_NODE: 'OPEN_NODE' as const,
   OPEN_PATH: 'OPEN_PATH' as const,
   PARKER: 'PARKER' as const,
   PARTIALLY: 'PARTIALLY' as const,
   PAYONEER: 'PAYONEER' as const,
   PAYPAL: 'PAYPAL' as const,
   POSTAL: 'POSTAL' as const,
   QUICKBOOKS_PAYMENTS: 'QUICKBOOKS_PAYMENTS' as const,
   QVC: 'QVC' as const,
   REACH: 'REACH' as const,
   RECHARGE: 'RECHARGE' as const,
   RETURNLY: 'RETURNLY' as const,
   REVOLUT: 'REVOLUT' as const,
   SETTLE: 'SETTLE' as const,
   SEZZLE: 'SEZZLE' as const,
   SHOP_PAY: 'SHOP_PAY' as const,
   SNACK_MAGIC: 'SNACK_MAGIC' as const,
   SPLITIT: 'SPLITIT' as const,
   SQUARE: 'SQUARE' as const,
   STORE_CREDIT: 'STORE_CREDIT' as const,
   STRIPE: 'STRIPE' as const,
   TARGET: 'TARGET' as const,
   TIK_TOK: 'TIK_TOK' as const,
   TRUE_MED: 'TRUE_MED' as const,
   TWINT: 'TWINT' as const,
   UNKNOWN: 'UNKNOWN' as const,
   WALGREENS: 'WALGREENS' as const,
   WALMART: 'WALMART' as const,
   WALMART_VIA_SHOPIFY: 'WALMART_VIA_SHOPIFY' as const,
   WISE: 'WISE' as const,
   WOOCOMMERCE: 'WOOCOMMERCE' as const,
   ZIP: 'ZIP' as const
}

export const enumTransactionPaymentType = {
   Internal: 'Internal' as const,
   External: 'External' as const
}

export const enumTransactionType = {
   PAYMENT: 'PAYMENT' as const,
   REFUND: 'REFUND' as const
}

export const enumUnidentifiedBankTransactionsGroupType = {
   TRANSFER: 'TRANSFER' as const,
   BANK_TRANSFER: 'BANK_TRANSFER' as const,
   CREDIT_CARD_PAYMENT: 'CREDIT_CARD_PAYMENT' as const
}

export const enumUnidentifiedTransfersGroupAction = {
   ASK_THE_USER_FLOW: 'ASK_THE_USER_FLOW' as const,
   CONNECT_ACCOUNT: 'CONNECT_ACCOUNT' as const,
   UPLOAD_CSV: 'UPLOAD_CSV' as const,
   UPLOAD_STATEMENT: 'UPLOAD_STATEMENT' as const,
   ROLE_GRANT: 'ROLE_GRANT' as const
}

export const enumUnitType = {
   CURRENCY: 'CURRENCY' as const,
   PERCENTAGE: 'PERCENTAGE' as const,
   NUMBER: 'NUMBER' as const
}

export const enumUnpaidAmountsViaProviderType = {
   TAXES: 'TAXES' as const,
   HEALTH_EMPLOYEE: 'HEALTH_EMPLOYEE' as const,
   TRANSPORTATION_EMPLOYEE: 'TRANSPORTATION_EMPLOYEE' as const,
   OTHER_BENEFITS_EMPLOYEE: 'OTHER_BENEFITS_EMPLOYEE' as const,
   OTHER_GARNISHMENTS: 'OTHER_GARNISHMENTS' as const,
   OTHER_DEDUCTIONS: 'OTHER_DEDUCTIONS' as const,
   SAVINGS_AND_RETIREMENT_OTHER_EMPLOYEE: 'SAVINGS_AND_RETIREMENT_OTHER_EMPLOYEE' as const,
   SAVINGS_AND_RETIREMENT_401K_EMPLOYEE: 'SAVINGS_AND_RETIREMENT_401K_EMPLOYEE' as const,
   VACATION_PAY: 'VACATION_PAY' as const,
   CHILD_SUPPORT: 'CHILD_SUPPORT' as const
}

export const enumUpdateCheckDetails = {
   RECORD_NOT_FOUND: 'RECORD_NOT_FOUND' as const,
   INVALID_STATE_CHANGE: 'INVALID_STATE_CHANGE' as const,
   SAME_STATE: 'SAME_STATE' as const,
   YEAR_END_STATE_BLOCKED_FOR_CHANGES: 'YEAR_END_STATE_BLOCKED_FOR_CHANGES' as const
}

export const enumUpdateCheckTypes = {
   VALID: 'VALID' as const,
   INVALID: 'INVALID' as const,
   NOT_AFFECTED: 'NOT_AFFECTED' as const,
   NOT_FOUND: 'NOT_FOUND' as const
}

export const enumUploadableIntegrationType = {
   FINALOOP_INVOICES: 'FINALOOP_INVOICES' as const,
   QUICKBOOKS_INVOICES: 'QUICKBOOKS_INVOICES' as const,
   NU_ORDER_INVOICES: 'NU_ORDER_INVOICES' as const,
   SPS_COMMERCE: 'SPS_COMMERCE' as const
}

export const enumValidationCycleStatus = {
   IN_PROGRESS: 'IN_PROGRESS' as const,
   COMPLETED: 'COMPLETED' as const,
   FAILED: 'FAILED' as const
}

export const enumValidationTemplateEndTime = {
   NOW: 'NOW' as const,
   PREVIOUS_YEAR: 'PREVIOUS_YEAR' as const,
   LOCKED_DATE: 'LOCKED_DATE' as const
}

export const enumValueType = {
   BENCHMARK: 'BENCHMARK' as const,
   CURRENT: 'CURRENT' as const,
   MARGIN: 'MARGIN' as const,
   PREVIOUS: 'PREVIOUS' as const,
   MAIN: 'MAIN' as const
}

export const enumVendorSource = {
   NTROPY: 'NTROPY' as const,
   FINALOOP: 'FINALOOP' as const,
   FINALOOP_BILLS: 'FINALOOP_BILLS' as const,
   FINALOOP_TRANSACTIONS: 'FINALOOP_TRANSACTIONS' as const,
   FINALOOP_TRANSACTIONS_MACHINE: 'FINALOOP_TRANSACTIONS_MACHINE' as const,
   FINALOOP_MACHINE: 'FINALOOP_MACHINE' as const,
   QUICKBOOKS: 'QUICKBOOKS' as const,
   BILL_COM: 'BILL_COM' as const,
   SETTLE: 'SETTLE' as const,
   CUSTOMER: 'CUSTOMER' as const
}

export const enumVendorSubType = {
   AUTOMATED_PAYMENT_PROCESSOR: 'AUTOMATED_PAYMENT_PROCESSOR' as const,
   AUTOMATED_MARKETPLACE: 'AUTOMATED_MARKETPLACE' as const,
   NON_AUTOMATED_MARKETPLACE: 'NON_AUTOMATED_MARKETPLACE' as const,
   NON_AUTOMATED_BRANDED_STORE: 'NON_AUTOMATED_BRANDED_STORE' as const,
   NON_AUTOMATED_PAYMENT_PROCESSOR: 'NON_AUTOMATED_PAYMENT_PROCESSOR' as const,
   NON_AUTOMATED_PAYMENT_GATEWAY: 'NON_AUTOMATED_PAYMENT_GATEWAY' as const,
   NON_AUTOMATED_PAYMENT_PROCESSOR_AUTHORIZE_NET: 'NON_AUTOMATED_PAYMENT_PROCESSOR_AUTHORIZE_NET' as const,
   SHIPPING_CARRIER: 'SHIPPING_CARRIER' as const,
   INVENTORY: 'INVENTORY' as const
}

export const enumVendorType = {
   LOCAL: 'LOCAL' as const,
   GLOBAL: 'GLOBAL' as const
}

export const enumViewTypes = {
   DEFAULT: 'DEFAULT' as const,
   BARS: 'BARS' as const
}

export const enumVoidStatus = {
   VOIDED: 'VOIDED' as const
}

export const enumWarehouseCreateErrorTypeEnum = {
   DUPLICATE: 'DUPLICATE' as const
}

export const enumWarehouseFilterType = {
   ORIGIN: 'ORIGIN' as const,
   DESTINATION: 'DESTINATION' as const,
   ALL: 'ALL' as const
}

export const enumWarehouseOpeningBalanceErrorItemType = {
   INVALID_HEADERS: 'INVALID_HEADERS' as const,
   MISSING_PRODUCT: 'MISSING_PRODUCT' as const,
   MISSING_WAREHOUSE: 'MISSING_WAREHOUSE' as const,
   MISSING_QUANTITY: 'MISSING_QUANTITY' as const,
   MISSING_COST: 'MISSING_COST' as const,
   INVALID_QUANTITY: 'INVALID_QUANTITY' as const,
   ROW_DUPLICATE: 'ROW_DUPLICATE' as const,
   PRODUCT_AMBIGUOUS: 'PRODUCT_AMBIGUOUS' as const,
   WAREHOUSE_AMBIGUOUS: 'WAREHOUSE_AMBIGUOUS' as const,
   PRODUCT_NOT_FOUND: 'PRODUCT_NOT_FOUND' as const,
   WAREHOUSE_NOT_FOUND: 'WAREHOUSE_NOT_FOUND' as const,
   INVALID_DATA: 'INVALID_DATA' as const,
   UNKNOWN_ERROR: 'UNKNOWN_ERROR' as const
}

export const enumWarehouseOpeningBalanceSortField = {
   PRODUCT_DISPLAY_NAME: 'PRODUCT_DISPLAY_NAME' as const,
   PRODUCT_SKU: 'PRODUCT_SKU' as const,
   WAREHOUSE_NAME: 'WAREHOUSE_NAME' as const,
   QUANTITY: 'QUANTITY' as const,
   COST_PER_UNIT: 'COST_PER_UNIT' as const,
   TOTAL_COST: 'TOTAL_COST' as const
}

export const enumWarehouseSource = {
   SHOPIFY: 'SHOPIFY' as const,
   USER_MANUAL: 'USER_MANUAL' as const,
   AMAZON: 'AMAZON' as const,
   TRACKSTAR_FBA: 'TRACKSTAR_FBA' as const,
   TIK_TOK: 'TIK_TOK' as const
}

export const enumWarehousesProductPurchasesBreakdownSortDirection = {
   ASC: 'ASC' as const,
   DESC: 'DESC' as const
}

export const enumWarehousesProductPurchasesBreakdownSortField = {
   DISPLAY_NAME: 'DISPLAY_NAME' as const,
   RECEIVED_ON: 'RECEIVED_ON' as const,
   ASSEMBLED: 'ASSEMBLED' as const,
   PURCHASED: 'PURCHASED' as const,
   FULFILLED: 'FULFILLED' as const,
   WAREHOUSE_TRANSFERS: 'WAREHOUSE_TRANSFERS' as const,
   ADJUSTMENTS: 'ADJUSTMENTS' as const,
   RESTOCKED: 'RESTOCKED' as const,
   ON_HAND: 'ON_HAND' as const,
   LANDED_COST_PER_UNIT: 'LANDED_COST_PER_UNIT' as const,
   ON_HAND_COST: 'ON_HAND_COST' as const,
   UNAVAILABLE: 'UNAVAILABLE' as const,
   NET_DEPLETED: 'NET_DEPLETED' as const
}

export const enumWarehouseTransferCostLineItemType = {
   SHIPPING: 'SHIPPING' as const,
   GENERAL: 'GENERAL' as const,
   VENDOR_FEES: 'VENDOR_FEES' as const,
   SHIPPING_SURCHARGE: 'SHIPPING_SURCHARGE' as const
}

export const enumWarehouseTransfersSortDirection = {
   ASC: 'ASC' as const,
   DESC: 'DESC' as const
}

export const enumWarehouseTransfersSortField = {
   ARRIVAL_DATE: 'ARRIVAL_DATE' as const,
   SHIPPING_DATE: 'SHIPPING_DATE' as const,
   ORIGIN_WAREHOUSE: 'ORIGIN_WAREHOUSE' as const,
   DESTINATION_WAREHOUSE: 'DESTINATION_WAREHOUSE' as const,
   STATUS: 'STATUS' as const,
   ID: 'ID' as const,
   COST: 'COST' as const,
   PAID_STATUS: 'PAID_STATUS' as const
}

export const enumWarehouseTransferStatus = {
   DRAFT: 'DRAFT' as const,
   SCHEDULED: 'SCHEDULED' as const,
   IN_TRANSIT: 'IN_TRANSIT' as const,
   TRANSFERRED: 'TRANSFERRED' as const
}

export const enumYearEndDomainMode = {
   ENABLED: 'ENABLED' as const,
   DISABLED: 'DISABLED' as const
}

export const enumYearEndDomainState = {
   INACTIVE: 'INACTIVE' as const,
   OPEN: 'OPEN' as const,
   IN_PROGRESS: 'IN_PROGRESS' as const,
   CLOSED: 'CLOSED' as const
}

export const enumYearEndDomainStateErrors = {
   COMPANY_YEAR_END_DOMAIN_STATE_NOT_FOUND: 'COMPANY_YEAR_END_DOMAIN_STATE_NOT_FOUND' as const,
   INVALID_YEAR_END_DOMAIN_STATE_CHANGE: 'INVALID_YEAR_END_DOMAIN_STATE_CHANGE' as const,
   INVALID_YEAR_END_DOMAIN_DATA_CHANGE: 'INVALID_YEAR_END_DOMAIN_DATA_CHANGE' as const,
   YEAR_END_STATE_BLOCKED_FOR_CHANGES: 'YEAR_END_STATE_BLOCKED_FOR_CHANGES' as const
}

export const enumYearEndDomainTypes = {
   BANKS: 'BANKS' as const,
   TRANSACTIONS: 'TRANSACTIONS' as const,
   UNCLASSIFIED_TRANSACTIONS: 'UNCLASSIFIED_TRANSACTIONS' as const,
   UNMATCHED_PAYOUTS_AND_TRANSFERS: 'UNMATCHED_PAYOUTS_AND_TRANSFERS' as const,
   PAYMENTS: 'PAYMENTS' as const,
   INVENTORY: 'INVENTORY' as const,
   LOANS: 'LOANS' as const,
   EQUITY: 'EQUITY' as const,
   PAYROLL: 'PAYROLL' as const,
   SALES_TAX: 'SALES_TAX' as const,
   INVESTMENTS: 'INVESTMENTS' as const,
   SECURITY_DEPOSITS: 'SECURITY_DEPOSITS' as const,
   ACCOUNTING_AND_TAX_INFORMATION: 'ACCOUNTING_AND_TAX_INFORMATION' as const,
   ORDERS: 'ORDERS' as const,
   INVOICES: 'INVOICES' as const,
   BILLS: 'BILLS' as const
}

export const enumYearEndState = {
   INACTIVE: 'INACTIVE' as const,
   NA: 'NA' as const,
   OPEN: 'OPEN' as const,
   INITIAL_PROCESSING: 'INITIAL_PROCESSING' as const,
   AWAITING_USER_FEEDBACK: 'AWAITING_USER_FEEDBACK' as const,
   FOLLOW_UP_PROCESSING: 'FOLLOW_UP_PROCESSING' as const,
   CLOSED: 'CLOSED' as const
}

export const enumYearEndStateErrors = {
   COMPANY_NOT_FOUND: 'COMPANY_NOT_FOUND' as const,
   COMPANY_YEAR_END_STATE_NOT_FOUND: 'COMPANY_YEAR_END_STATE_NOT_FOUND' as const,
   INVALID_YEAR_END_STATE_CHANGE: 'INVALID_YEAR_END_STATE_CHANGE' as const,
   COMPANY_HAS_ANOTHER_YEAR_END_UNDER_REVIEW: 'COMPANY_HAS_ANOTHER_YEAR_END_UNDER_REVIEW' as const
}

export const enumYearEndStateUpdaterType = {
   USER: 'USER' as const,
   SYSTEM: 'SYSTEM' as const,
   OPS: 'OPS' as const
}
